// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%2328a745%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%275%27 viewBox=%270 0 4 5%27%3e%3cpath fill=%27%23343a40%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27 viewBox=%270 0 12 12%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%274%27 viewBox=%270 0 4 4%27%3e%3cpath stroke=%27%23fff%27 d=%27M0 2h4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/materialdesignicons-webfont.eot?v=7.4.47", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/materialdesignicons-webfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/materialdesignicons-webfont.woff2?v=7.4.47", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/materialdesignicons-webfont.woff?v=7.4.47", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../fonts/materialdesignicons-webfont.ttf?v=7.4.47", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___, { hash: "?#iefix&v=7.4.47" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@media only screen and (max-width: 1169px) {
  #cd-primary-nav {
    -webkit-transform: translateX(-80vw);
    -moz-transform: translateX(-80vw);
    -ms-transform: translateX(-80vw);
    -o-transform: translateX(-80vw);
    transform: translateX(-80vw);
  }
}
/* Container */
/* Color */
/* Text */
/* Navigation */
/* Textbox */
/* Dropdown */
/*@import 
    '~bootstrap/';*/
/*!
 * Bootstrap v4.6.2 (https://getbootstrap.com/)
 * Copyright 2011-2022 The Bootstrap Authors
 * Copyright 2011-2022 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root {
  --blue: #007bff;
  --indigo: #6610f2;
  --purple: #440099;
  --pink: #e83e8c;
  --red: #dc3545;
  --orange: #fd7e14;
  --yellow: #ffc107;
  --green: #28a745;
  --teal: #20c997;
  --cyan: #17a2b8;
  --white: #fff;
  --gray: #6c757d;
  --gray-dark: #343a40;
  --primary: #440099;
  --secondary: #6c757d;
  --success: #28a745;
  --info: #17a2b8;
  --warning: #ffc107;
  --danger: #dc3545;
  --light: #f8f9fa;
  --dark: #343a40;
  --breakpoint-xs: 0;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --font-family-sans-serif: "Open Sans";
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

article, aside, figcaption, figure, footer, header, hgroup, main, nav, section {
  display: block;
}

body {
  margin: 0;
  font-family: "Open Sans";
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: left;
  background-color: #fff;
}

[tabindex="-1"]:focus:not(:focus-visible) {
  outline: 0 !important;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small {
  font-size: 80%;
}

sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: #440099;
  text-decoration: none;
  background-color: transparent;
}
a:hover {
  color: #22004d;
  text-decoration: underline;
}

a:not([href]):not([class]) {
  color: inherit;
  text-decoration: none;
}
a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 1em;
}

pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  -ms-overflow-style: scrollbar;
}

figure {
  margin: 0 0 1rem;
}

img {
  vertical-align: middle;
  border-style: none;
}

svg {
  overflow: hidden;
  vertical-align: middle;
}

table {
  border-collapse: collapse;
}

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #6c757d;
  text-align: left;
  caption-side: bottom;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

input[type=radio],
input[type=checkbox] {
  box-sizing: border-box;
  padding: 0;
}

textarea {
  overflow: auto;
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal;
}
@media (max-width: 1200px) {
  legend {
    font-size: calc(1.275rem + 0.3vw);
  }
}

progress {
  vertical-align: baseline;
}

[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: none;
}

[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

summary {
  display: list-item;
  cursor: pointer;
}

template {
  display: none;
}

[hidden] {
  display: none !important;
}

h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

h1, .h1 {
  font-size: 2.5rem;
}
@media (max-width: 1200px) {
  h1, .h1 {
    font-size: calc(1.375rem + 1.5vw);
  }
}

h2, .h2 {
  font-size: 2rem;
}
@media (max-width: 1200px) {
  h2, .h2 {
    font-size: calc(1.325rem + 0.9vw);
  }
}

h3, .h3 {
  font-size: 1.5rem;
}
@media (max-width: 1200px) {
  h3, .h3 {
    font-size: calc(1.275rem + 0.3vw);
  }
}

h4, .h4 {
  font-size: 1.5rem;
}
@media (max-width: 1200px) {
  h4, .h4 {
    font-size: calc(1.275rem + 0.3vw);
  }
}

h5, .h5 {
  font-size: 1.25rem;
}

h6, .h6 {
  font-size: 1.125rem;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: 3rem;
  font-weight: 400;
  line-height: 1.2;
}
@media (max-width: 1200px) {
  .display-1 {
    font-size: calc(1.425rem + 2.1vw);
  }
}

.display-2 {
  font-size: 2rem;
  font-weight: 400;
  line-height: 1.2;
}
@media (max-width: 1200px) {
  .display-2 {
    font-size: calc(1.325rem + 0.9vw);
  }
}

.display-3 {
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.2;
}
@media (max-width: 1200px) {
  .display-3 {
    font-size: calc(1.275rem + 0.3vw);
  }
}

.display-4 {
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.2;
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

small,
.small {
  font-size: 80%;
  font-weight: 400;
}

mark,
.mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 90%;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}

.blockquote-footer {
  display: block;
  font-size: 80%;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 90%;
  color: #6c757d;
}

code {
  font-size: 87.5%;
  color: #e83e8c;
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #fff;
  background-color: #212529;
  border-radius: 0.2rem;
}
kbd kbd {
  padding: 0;
  font-size: 100%;
  font-weight: 700;
}

pre {
  display: block;
  font-size: 87.5%;
  color: #212529;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll;
}

.container,
.container-fluid,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1180px;
  }
}
.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
}
.no-gutters > .col,
.no-gutters > [class*=col-] {
  padding-right: 0;
  padding-left: 0;
}

.col-xl,
.col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg,
.col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md,
.col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm,
.col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col,
.col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}

.col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}

.row-cols-1 > * {
  flex: 0 0 100%;
  max-width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 50%;
  max-width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 33.3333333333%;
  max-width: 33.3333333333%;
}

.row-cols-4 > * {
  flex: 0 0 25%;
  max-width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 20%;
  max-width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 16.6666666667%;
  max-width: 16.6666666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}

.col-1 {
  flex: 0 0 8.33333333%;
  max-width: 8.33333333%;
}

.col-2 {
  flex: 0 0 16.66666667%;
  max-width: 16.66666667%;
}

.col-3 {
  flex: 0 0 25%;
  max-width: 25%;
}

.col-4 {
  flex: 0 0 33.33333333%;
  max-width: 33.33333333%;
}

.col-5 {
  flex: 0 0 41.66666667%;
  max-width: 41.66666667%;
}

.col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

.col-7 {
  flex: 0 0 58.33333333%;
  max-width: 58.33333333%;
}

.col-8 {
  flex: 0 0 66.66666667%;
  max-width: 66.66666667%;
}

.col-9 {
  flex: 0 0 75%;
  max-width: 75%;
}

.col-10 {
  flex: 0 0 83.33333333%;
  max-width: 83.33333333%;
}

.col-11 {
  flex: 0 0 91.66666667%;
  max-width: 91.66666667%;
}

.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}

.order-first {
  order: -1;
}

.order-last {
  order: 13;
}

.order-0 {
  order: 0;
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.order-3 {
  order: 3;
}

.order-4 {
  order: 4;
}

.order-5 {
  order: 5;
}

.order-6 {
  order: 6;
}

.order-7 {
  order: 7;
}

.order-8 {
  order: 8;
}

.order-9 {
  order: 9;
}

.order-10 {
  order: 10;
}

.order-11 {
  order: 11;
}

.order-12 {
  order: 12;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

@media (min-width: 576px) {
  .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-sm-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-sm-first {
    order: -1;
  }
  .order-sm-last {
    order: 13;
  }
  .order-sm-0 {
    order: 0;
  }
  .order-sm-1 {
    order: 1;
  }
  .order-sm-2 {
    order: 2;
  }
  .order-sm-3 {
    order: 3;
  }
  .order-sm-4 {
    order: 4;
  }
  .order-sm-5 {
    order: 5;
  }
  .order-sm-6 {
    order: 6;
  }
  .order-sm-7 {
    order: 7;
  }
  .order-sm-8 {
    order: 8;
  }
  .order-sm-9 {
    order: 9;
  }
  .order-sm-10 {
    order: 10;
  }
  .order-sm-11 {
    order: 11;
  }
  .order-sm-12 {
    order: 12;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-md-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-md-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-md-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-md-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-md-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-md-first {
    order: -1;
  }
  .order-md-last {
    order: 13;
  }
  .order-md-0 {
    order: 0;
  }
  .order-md-1 {
    order: 1;
  }
  .order-md-2 {
    order: 2;
  }
  .order-md-3 {
    order: 3;
  }
  .order-md-4 {
    order: 4;
  }
  .order-md-5 {
    order: 5;
  }
  .order-md-6 {
    order: 6;
  }
  .order-md-7 {
    order: 7;
  }
  .order-md-8 {
    order: 8;
  }
  .order-md-9 {
    order: 9;
  }
  .order-md-10 {
    order: 10;
  }
  .order-md-11 {
    order: 11;
  }
  .order-md-12 {
    order: 12;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-lg-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-lg-first {
    order: -1;
  }
  .order-lg-last {
    order: 13;
  }
  .order-lg-0 {
    order: 0;
  }
  .order-lg-1 {
    order: 1;
  }
  .order-lg-2 {
    order: 2;
  }
  .order-lg-3 {
    order: 3;
  }
  .order-lg-4 {
    order: 4;
  }
  .order-lg-5 {
    order: 5;
  }
  .order-lg-6 {
    order: 6;
  }
  .order-lg-7 {
    order: 7;
  }
  .order-lg-8 {
    order: 8;
  }
  .order-lg-9 {
    order: 9;
  }
  .order-lg-10 {
    order: 10;
  }
  .order-lg-11 {
    order: 11;
  }
  .order-lg-12 {
    order: 12;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-xl-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-xl-first {
    order: -1;
  }
  .order-xl-last {
    order: 13;
  }
  .order-xl-0 {
    order: 0;
  }
  .order-xl-1 {
    order: 1;
  }
  .order-xl-2 {
    order: 2;
  }
  .order-xl-3 {
    order: 3;
  }
  .order-xl-4 {
    order: 4;
  }
  .order-xl-5 {
    order: 5;
  }
  .order-xl-6 {
    order: 6;
  }
  .order-xl-7 {
    order: 7;
  }
  .order-xl-8 {
    order: 8;
  }
  .order-xl-9 {
    order: 9;
  }
  .order-xl-10 {
    order: 10;
  }
  .order-xl-11 {
    order: 11;
  }
  .order-xl-12 {
    order: 12;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
}
.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
}
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}
.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
}
.table tbody + tbody {
  border-top: 2px solid #dee2e6;
}

.table-sm th,
.table-sm td {
  padding: 0.3rem;
}

.table-bordered {
  border: 1px solid #dee2e6;
}
.table-bordered th,
.table-bordered td {
  border: 1px solid #dee2e6;
}
.table-bordered thead th,
.table-bordered thead td {
  border-bottom-width: 2px;
}

.table-borderless th,
.table-borderless td,
.table-borderless thead th,
.table-borderless tbody + tbody {
  border: 0;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}

.table-hover tbody tr:hover {
  color: #212529;
  background-color: rgba(0, 0, 0, 0.075);
}

.table-primary,
.table-primary > th,
.table-primary > td {
  background-color: #cbb8e2;
}
.table-primary th,
.table-primary td,
.table-primary thead th,
.table-primary tbody + tbody {
  border-color: #9e7aca;
}

.table-hover .table-primary:hover {
  background-color: #bea6db;
}
.table-hover .table-primary:hover > td,
.table-hover .table-primary:hover > th {
  background-color: #bea6db;
}

.table-secondary,
.table-secondary > th,
.table-secondary > td {
  background-color: #d6d8db;
}
.table-secondary th,
.table-secondary td,
.table-secondary thead th,
.table-secondary tbody + tbody {
  border-color: #b3b7bb;
}

.table-hover .table-secondary:hover {
  background-color: #c8cbcf;
}
.table-hover .table-secondary:hover > td,
.table-hover .table-secondary:hover > th {
  background-color: #c8cbcf;
}

.table-success,
.table-success > th,
.table-success > td {
  background-color: #c3e6cb;
}
.table-success th,
.table-success td,
.table-success thead th,
.table-success tbody + tbody {
  border-color: #8fd19e;
}

.table-hover .table-success:hover {
  background-color: #b1dfbb;
}
.table-hover .table-success:hover > td,
.table-hover .table-success:hover > th {
  background-color: #b1dfbb;
}

.table-info,
.table-info > th,
.table-info > td {
  background-color: #bee5eb;
}
.table-info th,
.table-info td,
.table-info thead th,
.table-info tbody + tbody {
  border-color: #86cfda;
}

.table-hover .table-info:hover {
  background-color: #abdde5;
}
.table-hover .table-info:hover > td,
.table-hover .table-info:hover > th {
  background-color: #abdde5;
}

.table-warning,
.table-warning > th,
.table-warning > td {
  background-color: #ffeeba;
}
.table-warning th,
.table-warning td,
.table-warning thead th,
.table-warning tbody + tbody {
  border-color: #ffdf7e;
}

.table-hover .table-warning:hover {
  background-color: #ffe8a1;
}
.table-hover .table-warning:hover > td,
.table-hover .table-warning:hover > th {
  background-color: #ffe8a1;
}

.table-danger,
.table-danger > th,
.table-danger > td {
  background-color: #f5c6cb;
}
.table-danger th,
.table-danger td,
.table-danger thead th,
.table-danger tbody + tbody {
  border-color: #ed969e;
}

.table-hover .table-danger:hover {
  background-color: #f1b0b7;
}
.table-hover .table-danger:hover > td,
.table-hover .table-danger:hover > th {
  background-color: #f1b0b7;
}

.table-light,
.table-light > th,
.table-light > td {
  background-color: #fdfdfe;
}
.table-light th,
.table-light td,
.table-light thead th,
.table-light tbody + tbody {
  border-color: #fbfcfc;
}

.table-hover .table-light:hover {
  background-color: #ececf6;
}
.table-hover .table-light:hover > td,
.table-hover .table-light:hover > th {
  background-color: #ececf6;
}

.table-dark,
.table-dark > th,
.table-dark > td {
  background-color: #c6c8ca;
}
.table-dark th,
.table-dark td,
.table-dark thead th,
.table-dark tbody + tbody {
  border-color: #95999c;
}

.table-hover .table-dark:hover {
  background-color: #b9bbbe;
}
.table-hover .table-dark:hover > td,
.table-hover .table-dark:hover > th {
  background-color: #b9bbbe;
}

.table-active,
.table-active > th,
.table-active > td {
  background-color: rgba(0, 0, 0, 0.075);
}

.table-hover .table-active:hover {
  background-color: rgba(0, 0, 0, 0.075);
}
.table-hover .table-active:hover > td,
.table-hover .table-active:hover > th {
  background-color: rgba(0, 0, 0, 0.075);
}

.table .thead-dark th {
  color: #fff;
  background-color: #343a40;
  border-color: #454d55;
}
.table .thead-light th {
  color: #495057;
  background-color: #e9ecef;
  border-color: #dee2e6;
}

.table-dark {
  color: #fff;
  background-color: #343a40;
}
.table-dark th,
.table-dark td,
.table-dark thead th {
  border-color: #454d55;
}
.table-dark.table-bordered {
  border: 0;
}
.table-dark.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.05);
}
.table-dark.table-hover tbody tr:hover {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.075);
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-sm > .table-bordered {
    border: 0;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-md > .table-bordered {
    border: 0;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-lg > .table-bordered {
    border: 0;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-xl > .table-bordered {
    border: 0;
  }
}
.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.table-responsive > .table-bordered {
  border: 0;
}

.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 1.25rem + 2px);
  padding: 0.625rem 2.5rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control::-ms-expand {
  background-color: transparent;
  border: 0;
}
.form-control:focus {
  color: #495057;
  background-color: #fff;
  border-color: #801aff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(68, 0, 153, 0.25);
}
.form-control::placeholder {
  color: #6c757d;
  opacity: 1;
}
.form-control:disabled, .form-control[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}

input[type=date].form-control,
input[type=time].form-control,
input[type=datetime-local].form-control,
input[type=month].form-control {
  appearance: none;
}

select.form-control:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #495057;
}
select.form-control:focus::-ms-value {
  color: #495057;
  background-color: #fff;
}

.form-control-file,
.form-control-range {
  display: block;
  width: 100%;
}

.col-form-label {
  padding-top: calc(0.625rem + 1px);
  padding-bottom: calc(0.625rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.75rem + 1px);
  padding-bottom: calc(0.75rem + 1px);
  font-size: 1.25rem;
  line-height: 1.5;
}

.col-form-label-sm {
  padding-top: calc(0.438rem + 1px);
  padding-bottom: calc(0.438rem + 1px);
  font-size: 0.75rem;
  line-height: 1.5;
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.625rem 0;
  margin-bottom: 0;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #212529;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  height: calc(1.5em + 0.876rem + 2px);
  padding: 0.438rem 2rem;
  font-size: 0.75rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.form-control-lg {
  height: calc(1.5em + 1.5rem + 2px);
  padding: 0.75rem 3rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

select.form-control[size], select.form-control[multiple] {
  height: auto;
}

textarea.form-control {
  height: auto;
}

.form-group {
  margin-bottom: 1rem;
}

.form-text {
  display: block;
  margin-top: 0.25rem;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form-row > .col,
.form-row > [class*=col-] {
  padding-right: 5px;
  padding-left: 5px;
}

.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem;
}

.form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  color: #6c757d;
}

.form-check-label {
  margin-bottom: 0;
}

.form-check-inline {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem;
}
.form-check-inline .form-check-input {
  position: static;
  margin-top: 0;
  margin-right: 0.3125rem;
  margin-left: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #28a745;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.75rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(40, 167, 69, 0.9);
  border-radius: 0.25rem;
}
.form-row > .col > .valid-tooltip, .form-row > [class*=col-] > .valid-tooltip {
  left: 5px;
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #28a745;
  padding-right: calc(1.5em + 1.25rem) !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.3125rem) center;
  background-size: calc(0.75em + 0.625rem) calc(0.75em + 0.625rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.was-validated select.form-control:valid, select.form-control.is-valid {
  padding-right: 10rem !important;
  background-position: right 5rem center;
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 1.25rem);
  background-position: top calc(0.375em + 0.3125rem) right calc(0.375em + 0.3125rem);
}

.was-validated .custom-select:valid, .custom-select.is-valid {
  border-color: #28a745;
  padding-right: calc(0.75em + 4.4375rem) !important;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right 2.5rem center/8px 10px no-repeat, #fff url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center right 3.5rem/calc(0.75em + 0.625rem) calc(0.75em + 0.625rem) no-repeat;
}
.was-validated .custom-select:valid:focus, .custom-select.is-valid:focus {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #28a745;
}
.was-validated .form-check-input:valid ~ .valid-feedback,
.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,
.form-check-input.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {
  color: #28a745;
}
.was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {
  border-color: #28a745;
}
.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {
  border-color: #34ce57;
  background-color: #34ce57;
}
.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}
.was-validated .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #28a745;
}

.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {
  border-color: #28a745;
}
.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.75rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(220, 53, 69, 0.9);
  border-radius: 0.25rem;
}
.form-row > .col > .invalid-tooltip, .form-row > [class*=col-] > .invalid-tooltip {
  left: 5px;
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #dc3545;
  padding-right: calc(1.5em + 1.25rem) !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.3125rem) center;
  background-size: calc(0.75em + 0.625rem) calc(0.75em + 0.625rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.was-validated select.form-control:invalid, select.form-control.is-invalid {
  padding-right: 10rem !important;
  background-position: right 5rem center;
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 1.25rem);
  background-position: top calc(0.375em + 0.3125rem) right calc(0.375em + 0.3125rem);
}

.was-validated .custom-select:invalid, .custom-select.is-invalid {
  border-color: #dc3545;
  padding-right: calc(0.75em + 4.4375rem) !important;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right 2.5rem center/8px 10px no-repeat, #fff url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center right 3.5rem/calc(0.75em + 0.625rem) calc(0.75em + 0.625rem) no-repeat;
}
.was-validated .custom-select:invalid:focus, .custom-select.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #dc3545;
}
.was-validated .form-check-input:invalid ~ .invalid-feedback,
.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,
.form-check-input.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {
  color: #dc3545;
}
.was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {
  border-color: #dc3545;
}
.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {
  border-color: #e4606d;
  background-color: #e4606d;
}
.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}
.was-validated .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #dc3545;
}

.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #dc3545;
}
.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}
.form-inline .form-check {
  width: 100%;
}
@media (min-width: 576px) {
  .form-inline label {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
  }
  .form-inline .form-group {
    display: flex;
    flex: 0 0 auto;
    flex-flow: row wrap;
    align-items: center;
    margin-bottom: 0;
  }
  .form-inline .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }
  .form-inline .form-control-plaintext {
    display: inline-block;
  }
  .form-inline .input-group,
  .form-inline .custom-select {
    width: auto;
  }
  .form-inline .form-check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    padding-left: 0;
  }
  .form-inline .form-check-input {
    position: relative;
    flex-shrink: 0;
    margin-top: 0;
    margin-right: 0.25rem;
    margin-left: 0;
  }
  .form-inline .custom-control {
    align-items: center;
    justify-content: center;
  }
  .form-inline .custom-control-label {
    margin-bottom: 0;
  }
}

.btn {
  display: inline-block;
  font-weight: 400;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.625rem 2.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.1666666667rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: #212529;
  text-decoration: none;
}
.btn:focus, .btn.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(68, 0, 153, 0.25);
}
.btn.disabled, .btn:disabled {
  opacity: 0.65;
}
.btn:not(:disabled):not(.disabled) {
  cursor: pointer;
}
a.btn.disabled,
fieldset:disabled a.btn {
  pointer-events: none;
}

.btn-primary {
  color: #fff;
  background-color: #440099;
  border-color: #440099;
}
.btn-primary:hover {
  color: #fff;
  background-color: #330073;
  border-color: #2d0066;
}
.btn-primary:focus, .btn-primary.focus {
  color: #fff;
  background-color: #330073;
  border-color: #2d0066;
  box-shadow: 0 0 0 0.2rem rgba(96, 38, 168, 0.5);
}
.btn-primary.disabled, .btn-primary:disabled {
  color: #fff;
  background-color: #440099;
  border-color: #440099;
}
.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #2d0066;
  border-color: #280059;
}
.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(96, 38, 168, 0.5);
}

.btn-secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-secondary:hover {
  color: #fff;
  background-color: #5a6268;
  border-color: #545b62;
}
.btn-secondary:focus, .btn-secondary.focus {
  color: #fff;
  background-color: #5a6268;
  border-color: #545b62;
  box-shadow: 0 0 0 0.2rem rgba(130, 138, 145, 0.5);
}
.btn-secondary.disabled, .btn-secondary:disabled {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: #545b62;
  border-color: #4e555b;
}
.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(130, 138, 145, 0.5);
}

.btn-success {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}
.btn-success:hover {
  color: #fff;
  background-color: #218838;
  border-color: #1e7e34;
}
.btn-success:focus, .btn-success.focus {
  color: #fff;
  background-color: #218838;
  border-color: #1e7e34;
  box-shadow: 0 0 0 0.2rem rgba(72, 180, 97, 0.5);
}
.btn-success.disabled, .btn-success:disabled {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}
.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active, .show > .btn-success.dropdown-toggle {
  color: #fff;
  background-color: #1e7e34;
  border-color: #1c7430;
}
.btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus, .show > .btn-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(72, 180, 97, 0.5);
}

.btn-info {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}
.btn-info:hover {
  color: #fff;
  background-color: #138496;
  border-color: #117a8b;
}
.btn-info:focus, .btn-info.focus {
  color: #fff;
  background-color: #138496;
  border-color: #117a8b;
  box-shadow: 0 0 0 0.2rem rgba(58, 176, 195, 0.5);
}
.btn-info.disabled, .btn-info:disabled {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}
.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .show > .btn-info.dropdown-toggle {
  color: #fff;
  background-color: #117a8b;
  border-color: #10707f;
}
.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus, .show > .btn-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(58, 176, 195, 0.5);
}

.btn-warning {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}
.btn-warning:hover {
  color: #212529;
  background-color: #e0a800;
  border-color: #d39e00;
}
.btn-warning:focus, .btn-warning.focus {
  color: #212529;
  background-color: #e0a800;
  border-color: #d39e00;
  box-shadow: 0 0 0 0.2rem rgba(222, 170, 12, 0.5);
}
.btn-warning.disabled, .btn-warning:disabled {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}
.btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active, .show > .btn-warning.dropdown-toggle {
  color: #212529;
  background-color: #d39e00;
  border-color: #c69500;
}
.btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(222, 170, 12, 0.5);
}

.btn-danger {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}
.btn-danger:hover {
  color: #fff;
  background-color: #c82333;
  border-color: #bd2130;
}
.btn-danger:focus, .btn-danger.focus {
  color: #fff;
  background-color: #c82333;
  border-color: #bd2130;
  box-shadow: 0 0 0 0.2rem rgba(225, 83, 97, 0.5);
}
.btn-danger.disabled, .btn-danger:disabled {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}
.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active, .show > .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: #bd2130;
  border-color: #b21f2d;
}
.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(225, 83, 97, 0.5);
}

.btn-light {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-light:hover {
  color: #212529;
  background-color: #e2e6ea;
  border-color: #dae0e5;
}
.btn-light:focus, .btn-light.focus {
  color: #212529;
  background-color: #e2e6ea;
  border-color: #dae0e5;
  box-shadow: 0 0 0 0.2rem rgba(216, 217, 219, 0.5);
}
.btn-light.disabled, .btn-light:disabled {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active, .show > .btn-light.dropdown-toggle {
  color: #212529;
  background-color: #dae0e5;
  border-color: #d3d9df;
}
.btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus, .show > .btn-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(216, 217, 219, 0.5);
}

.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-dark:hover {
  color: #fff;
  background-color: #23272b;
  border-color: #1d2124;
}
.btn-dark:focus, .btn-dark.focus {
  color: #fff;
  background-color: #23272b;
  border-color: #1d2124;
  box-shadow: 0 0 0 0.2rem rgba(82, 88, 93, 0.5);
}
.btn-dark.disabled, .btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active, .show > .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: #1d2124;
  border-color: #171a1d;
}
.btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(82, 88, 93, 0.5);
}

.btn-outline-primary {
  color: #440099;
  border-color: #440099;
}
.btn-outline-primary:hover {
  color: #fff;
  background-color: #440099;
  border-color: #440099;
}
.btn-outline-primary:focus, .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(68, 0, 153, 0.5);
}
.btn-outline-primary.disabled, .btn-outline-primary:disabled {
  color: #440099;
  background-color: transparent;
}
.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {
  color: #fff;
  background-color: #440099;
  border-color: #440099;
}
.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(68, 0, 153, 0.5);
}

.btn-outline-secondary {
  color: #6c757d;
  border-color: #6c757d;
}
.btn-outline-secondary:hover {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-outline-secondary:focus, .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
}
.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {
  color: #6c757d;
  background-color: transparent;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
}

.btn-outline-success {
  color: #28a745;
  border-color: #28a745;
}
.btn-outline-success:hover {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}
.btn-outline-success:focus, .btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);
}
.btn-outline-success.disabled, .btn-outline-success:disabled {
  color: #28a745;
  background-color: transparent;
}
.btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active, .show > .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}
.btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);
}

.btn-outline-info {
  color: #17a2b8;
  border-color: #17a2b8;
}
.btn-outline-info:hover {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}
.btn-outline-info:focus, .btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);
}
.btn-outline-info.disabled, .btn-outline-info:disabled {
  color: #17a2b8;
  background-color: transparent;
}
.btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active, .show > .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}
.btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);
}

.btn-outline-warning {
  color: #ffc107;
  border-color: #ffc107;
}
.btn-outline-warning:hover {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}
.btn-outline-warning:focus, .btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
}
.btn-outline-warning.disabled, .btn-outline-warning:disabled {
  color: #ffc107;
  background-color: transparent;
}
.btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .btn-outline-warning.dropdown-toggle {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}
.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
}

.btn-outline-danger {
  color: #dc3545;
  border-color: #dc3545;
}
.btn-outline-danger:hover {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}
.btn-outline-danger:focus, .btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);
}
.btn-outline-danger.disabled, .btn-outline-danger:disabled {
  color: #dc3545;
  background-color: transparent;
}
.btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}
.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);
}

.btn-outline-light {
  color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-outline-light:hover {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-outline-light:focus, .btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
}
.btn-outline-light.disabled, .btn-outline-light:disabled {
  color: #f8f9fa;
  background-color: transparent;
}
.btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active, .show > .btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
}

.btn-outline-dark {
  color: #343a40;
  border-color: #343a40;
}
.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-outline-dark:focus, .btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.btn-outline-dark.disabled, .btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.btn-link {
  font-weight: 400;
  color: #440099;
  text-decoration: none;
}
.btn-link:hover {
  color: #22004d;
  text-decoration: underline;
}
.btn-link:focus, .btn-link.focus {
  text-decoration: underline;
}
.btn-link:disabled, .btn-link.disabled {
  color: #6c757d;
  pointer-events: none;
}

.btn-lg, .btn-group-lg > .btn {
  padding: 0.75rem 3rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

.btn-sm, .btn-group-sm > .btn {
  padding: 0.438rem 2rem;
  font-size: 0.75rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.btn-block {
  display: block;
  width: 100%;
}
.btn-block + .btn-block {
  margin-top: 0.5rem;
}

input[type=submit].btn-block,
input[type=reset].btn-block,
input[type=button].btn-block {
  width: 100%;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.width {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.width {
    transition: none;
  }
}

.dropup,
.dropright,
.dropdown,
.dropleft {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 1rem;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-menu-left {
  right: auto;
  left: 0;
}

.dropdown-menu-right {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-right {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem;
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropright .dropdown-menu {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: 0.125rem;
}
.dropright .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropright .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropright .dropdown-toggle::after {
  vertical-align: 0;
}

.dropleft .dropdown-menu {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: 0.125rem;
}
.dropleft .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropleft .dropdown-toggle::after {
  display: none;
}
.dropleft .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropleft .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-menu[x-placement^=top], .dropdown-menu[x-placement^=right], .dropdown-menu[x-placement^=bottom], .dropdown-menu[x-placement^=left] {
  right: auto;
  bottom: auto;
}

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #e9ecef;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
.dropdown-item:hover, .dropdown-item:focus {
  color: #16181b;
  text-decoration: none;
  background-color: #f8f9fa;
}
.dropdown-item.active, .dropdown-item:active {
  color: #fff;
  text-decoration: none;
  background-color: #440099;
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: #6c757d;
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: 0.5rem 1.5rem;
  margin-bottom: 0;
  font-size: 0.75rem;
  color: #6c757d;
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: 0.25rem 1.5rem;
  color: #212529;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn:hover,
.btn-group-vertical > .btn:hover {
  z-index: 1;
}
.btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1px;
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 1.875rem;
  padding-left: 1.875rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropright .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 1.5rem;
  padding-left: 1.5rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 2.25rem;
  padding-left: 2.25rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: -1px;
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.btn-group-toggle > .btn,
.btn-group-toggle > .btn-group > .btn {
  margin-bottom: 0;
}
.btn-group-toggle > .btn input[type=radio],
.btn-group-toggle > .btn input[type=checkbox],
.btn-group-toggle > .btn-group > .btn input[type=radio],
.btn-group-toggle > .btn-group > .btn input[type=checkbox] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-control-plaintext,
.input-group > .custom-select,
.input-group > .custom-file {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  margin-bottom: 0;
}
.input-group > .form-control + .form-control,
.input-group > .form-control + .custom-select,
.input-group > .form-control + .custom-file,
.input-group > .form-control-plaintext + .form-control,
.input-group > .form-control-plaintext + .custom-select,
.input-group > .form-control-plaintext + .custom-file,
.input-group > .custom-select + .form-control,
.input-group > .custom-select + .custom-select,
.input-group > .custom-select + .custom-file,
.input-group > .custom-file + .form-control,
.input-group > .custom-file + .custom-select,
.input-group > .custom-file + .custom-file {
  margin-left: -1px;
}
.input-group > .form-control:focus,
.input-group > .custom-select:focus,
.input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {
  z-index: 3;
}
.input-group > .custom-file .custom-file-input:focus {
  z-index: 4;
}
.input-group > .form-control:not(:first-child),
.input-group > .custom-select:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .custom-file {
  display: flex;
  align-items: center;
}
.input-group > .custom-file:not(:last-child) .custom-file-label, .input-group > .custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > .custom-file:not(:first-child) .custom-file-label {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group:not(.has-validation) > .form-control:not(:last-child),
.input-group:not(.has-validation) > .custom-select:not(:last-child),
.input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label,
.input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > .form-control:nth-last-child(n+3),
.input-group.has-validation > .custom-select:nth-last-child(n+3),
.input-group.has-validation > .custom-file:nth-last-child(n+3) .custom-file-label,
.input-group.has-validation > .custom-file:nth-last-child(n+3) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group-prepend,
.input-group-append {
  display: flex;
}
.input-group-prepend .btn,
.input-group-append .btn {
  position: relative;
  z-index: 2;
}
.input-group-prepend .btn:focus,
.input-group-append .btn:focus {
  z-index: 3;
}
.input-group-prepend .btn + .btn,
.input-group-prepend .btn + .input-group-text,
.input-group-prepend .input-group-text + .input-group-text,
.input-group-prepend .input-group-text + .btn,
.input-group-append .btn + .btn,
.input-group-append .btn + .input-group-text,
.input-group-append .input-group-text + .input-group-text,
.input-group-append .input-group-text + .btn {
  margin-left: -1px;
}

.input-group-prepend {
  margin-right: -1px;
}

.input-group-append {
  margin-left: -1px;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.625rem 2.5rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.input-group-text input[type=radio],
.input-group-text input[type=checkbox] {
  margin-top: 0;
}

.input-group-lg > .form-control:not(textarea),
.input-group-lg > .custom-select {
  height: calc(1.5em + 1.5rem + 2px);
}

.input-group-lg > .form-control,
.input-group-lg > .custom-select,
.input-group-lg > .input-group-prepend > .input-group-text,
.input-group-lg > .input-group-append > .input-group-text,
.input-group-lg > .input-group-prepend > .btn,
.input-group-lg > .input-group-append > .btn {
  padding: 0.75rem 3rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

.input-group-sm > .form-control:not(textarea),
.input-group-sm > .custom-select {
  height: calc(1.5em + 0.876rem + 2px);
}

.input-group-sm > .form-control,
.input-group-sm > .custom-select,
.input-group-sm > .input-group-prepend > .input-group-text,
.input-group-sm > .input-group-append > .input-group-text,
.input-group-sm > .input-group-prepend > .btn,
.input-group-sm > .input-group-append > .btn {
  padding: 0.438rem 2rem;
  font-size: 0.75rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.input-group-lg > .custom-select,
.input-group-sm > .custom-select {
  padding-right: 3.5rem;
}

.input-group > .input-group-prepend > .btn,
.input-group > .input-group-prepend > .input-group-text,
.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn,
.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text,
.input-group.has-validation > .input-group-append:nth-last-child(n+3) > .btn,
.input-group.has-validation > .input-group-append:nth-last-child(n+3) > .input-group-text,
.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),
.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.custom-control {
  position: relative;
  z-index: 1;
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5rem;
  print-color-adjust: exact;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}

.custom-control-input {
  position: absolute;
  left: 0;
  z-index: -1;
  width: 1rem;
  height: 1.25rem;
  opacity: 0;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #440099;
  background-color: #440099;
}
.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(68, 0, 153, 0.25);
}
.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #801aff;
}
.custom-control-input:not(:disabled):active ~ .custom-control-label::before {
  color: #fff;
  background-color: #9c4dff;
  border-color: #9c4dff;
}
.custom-control-input[disabled] ~ .custom-control-label, .custom-control-input:disabled ~ .custom-control-label {
  color: #6c757d;
}
.custom-control-input[disabled] ~ .custom-control-label::before, .custom-control-input:disabled ~ .custom-control-label::before {
  background-color: #e9ecef;
}

.custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
}
.custom-control-label::before {
  position: absolute;
  top: 0.25rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  pointer-events: none;
  content: "";
  background-color: #fff;
  border: 1px solid #adb5bd;
}
.custom-control-label::after {
  position: absolute;
  top: 0.25rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  content: "";
  background: 50%/50% 50% no-repeat;
}

.custom-checkbox .custom-control-label::before {
  border-radius: 0.25rem;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
  border-color: #440099;
  background-color: #440099;
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(68, 0, 153, 0.5);
}
.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {
  background-color: rgba(68, 0, 153, 0.5);
}

.custom-radio .custom-control-label::before {
  border-radius: 50%;
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(68, 0, 153, 0.5);
}

.custom-switch {
  padding-left: 2.25rem;
}
.custom-switch .custom-control-label::before {
  left: -2.25rem;
  width: 1.75rem;
  pointer-events: all;
  border-radius: 0.5rem;
}
.custom-switch .custom-control-label::after {
  top: calc(0.25rem + 2px);
  left: calc(-2.25rem + 2px);
  width: calc(1rem - 4px);
  height: calc(1rem - 4px);
  background-color: #adb5bd;
  border-radius: 0.5rem;
  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-switch .custom-control-label::after {
    transition: none;
  }
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff;
  transform: translateX(0.75rem);
}
.custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(68, 0, 153, 0.5);
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 1.25rem + 2px);
  padding: 0.625rem 3.5rem 0.625rem 2.5rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right 2.5rem center/8px 10px no-repeat;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  appearance: none;
}
.custom-select:focus {
  border-color: #801aff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(68, 0, 153, 0.25);
}
.custom-select:focus::-ms-value {
  color: #495057;
  background-color: #fff;
}
.custom-select[multiple], .custom-select[size]:not([size="1"]) {
  height: auto;
  padding-right: 2.5rem;
  background-image: none;
}
.custom-select:disabled {
  color: #6c757d;
  background-color: #e9ecef;
}
.custom-select::-ms-expand {
  display: none;
}
.custom-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #495057;
}

.custom-select-sm {
  height: calc(1.5em + 0.876rem + 2px);
  padding-top: 0.438rem;
  padding-bottom: 0.438rem;
  padding-left: 2rem;
  font-size: 0.75rem;
}

.custom-select-lg {
  height: calc(1.5em + 1.5rem + 2px);
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 3rem;
  font-size: 1.25rem;
}

.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 1.25rem + 2px);
  margin-bottom: 0;
}

.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(1.5em + 1.25rem + 2px);
  margin: 0;
  overflow: hidden;
  opacity: 0;
}
.custom-file-input:focus ~ .custom-file-label {
  border-color: #801aff;
  box-shadow: 0 0 0 0.2rem rgba(68, 0, 153, 0.25);
}
.custom-file-input[disabled] ~ .custom-file-label, .custom-file-input:disabled ~ .custom-file-label {
  background-color: #e9ecef;
}
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "Browse";
}
.custom-file-input ~ .custom-file-label[data-browse]::after {
  content: attr(data-browse);
}

.custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: calc(1.5em + 1.25rem + 2px);
  padding: 0.625rem 2.5rem;
  overflow: hidden;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.custom-file-label::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: block;
  height: calc(1.5em + 1.25rem);
  padding: 0.625rem 2.5rem;
  line-height: 1.5;
  color: #495057;
  content: "Browse";
  background-color: #e9ecef;
  border-left: inherit;
  border-radius: 0 0.25rem 0.25rem 0;
}

.custom-range {
  width: 100%;
  height: 1.4rem;
  padding: 0;
  background-color: transparent;
  appearance: none;
}
.custom-range:focus {
  outline: 0;
}
.custom-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(68, 0, 153, 0.25);
}
.custom-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(68, 0, 153, 0.25);
}
.custom-range:focus::-ms-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(68, 0, 153, 0.25);
}
.custom-range::-moz-focus-outer {
  border: 0;
}
.custom-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #440099;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-webkit-slider-thumb {
    transition: none;
  }
}
.custom-range::-webkit-slider-thumb:active {
  background-color: #9c4dff;
}
.custom-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}
.custom-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #440099;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-moz-range-thumb {
    transition: none;
  }
}
.custom-range::-moz-range-thumb:active {
  background-color: #9c4dff;
}
.custom-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}
.custom-range::-ms-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: 0;
  margin-right: 0.2rem;
  margin-left: 0.2rem;
  background-color: #440099;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-ms-thumb {
    transition: none;
  }
}
.custom-range::-ms-thumb:active {
  background-color: #9c4dff;
}
.custom-range::-ms-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: transparent;
  border-color: transparent;
  border-width: 0.5rem;
}
.custom-range::-ms-fill-lower {
  background-color: #dee2e6;
  border-radius: 1rem;
}
.custom-range::-ms-fill-upper {
  margin-right: 15px;
  background-color: #dee2e6;
  border-radius: 1rem;
}
.custom-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
}
.custom-range:disabled::-webkit-slider-runnable-track {
  cursor: default;
}
.custom-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
}
.custom-range:disabled::-moz-range-track {
  cursor: default;
}
.custom-range:disabled::-ms-thumb {
  background-color: #adb5bd;
}

.custom-control-label::before,
.custom-file-label,
.custom-select {
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-control-label::before,
  .custom-file-label,
  .custom-select {
    transition: none;
  }
}

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
}
.nav-link:hover, .nav-link:focus {
  text-decoration: none;
}
.nav-link.disabled {
  color: #6c757d;
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}
.nav-tabs .nav-link {
  margin-bottom: -1px;
  background-color: transparent;
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: #e9ecef #e9ecef #dee2e6;
}
.nav-tabs .nav-link.disabled {
  color: #6c757d;
  background-color: transparent;
  border-color: transparent;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
}
.nav-tabs .dropdown-menu {
  margin-top: -1px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills .nav-link {
  background: none;
  border: 0;
  border-radius: 0.25rem;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #440099;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
}
.navbar .container,
.navbar .container-fluid,
.navbar .container-sm,
.navbar .container-md,
.navbar .container-lg,
.navbar .container-xl {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  display: inline-block;
  padding-top: 0.3125rem;
  padding-bottom: 0.3125rem;
  margin-right: 1rem;
  font-size: 1.25rem;
  line-height: inherit;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  text-decoration: none;
}

.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}
.navbar-nav .dropdown-menu {
  position: static;
  float: none;
}

.navbar-text {
  display: inline-block;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.25rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.1666666667rem;
}
.navbar-toggler:hover, .navbar-toggler:focus {
  text-decoration: none;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: 50%/100% 100% no-repeat;
}

.navbar-nav-scroll {
  max-height: 75vh;
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid,
  .navbar-expand-sm > .container-sm,
  .navbar-expand-sm > .container-md,
  .navbar-expand-sm > .container-lg,
  .navbar-expand-sm > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid,
  .navbar-expand-sm > .container-sm,
  .navbar-expand-sm > .container-md,
  .navbar-expand-sm > .container-lg,
  .navbar-expand-sm > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
}
@media (max-width: 767.98px) {
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid,
  .navbar-expand-md > .container-sm,
  .navbar-expand-md > .container-md,
  .navbar-expand-md > .container-lg,
  .navbar-expand-md > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid,
  .navbar-expand-md > .container-sm,
  .navbar-expand-md > .container-md,
  .navbar-expand-md > .container-lg,
  .navbar-expand-md > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid,
  .navbar-expand-lg > .container-sm,
  .navbar-expand-lg > .container-md,
  .navbar-expand-lg > .container-lg,
  .navbar-expand-lg > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid,
  .navbar-expand-lg > .container-sm,
  .navbar-expand-lg > .container-md,
  .navbar-expand-lg > .container-lg,
  .navbar-expand-lg > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
}
@media (max-width: 1199.98px) {
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid,
  .navbar-expand-xl > .container-sm,
  .navbar-expand-xl > .container-md,
  .navbar-expand-xl > .container-lg,
  .navbar-expand-xl > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid,
  .navbar-expand-xl > .container-sm,
  .navbar-expand-xl > .container-md,
  .navbar-expand-xl > .container-lg,
  .navbar-expand-xl > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
}
.navbar-expand {
  flex-flow: row nowrap;
  justify-content: flex-start;
}
.navbar-expand > .container,
.navbar-expand > .container-fluid,
.navbar-expand > .container-sm,
.navbar-expand > .container-md,
.navbar-expand > .container-lg,
.navbar-expand > .container-xl {
  padding-right: 0;
  padding-left: 0;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}
.navbar-expand > .container,
.navbar-expand > .container-fluid,
.navbar-expand > .container-sm,
.navbar-expand > .container-md,
.navbar-expand > .container-lg,
.navbar-expand > .container-xl {
  flex-wrap: nowrap;
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-light .navbar-brand {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.5);
}
.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
  color: rgba(0, 0, 0, 0.7);
}
.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(0, 0, 0, 0.3);
}
.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.5);
  border-color: rgba(0, 0, 0, 0.1);
}
.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.5);
}
.navbar-light .navbar-text a {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-dark .navbar-brand {
  color: #fff;
}
.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {
  color: #fff;
}
.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.5);
}
.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {
  color: rgba(255, 255, 255, 0.75);
}
.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}
.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .active > .nav-link,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .nav-link.active {
  color: #fff;
}
.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.5);
  border-color: rgba(255, 255, 255, 0.1);
}
.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.5);
}
.navbar-dark .navbar-text a {
  color: #fff;
}
.navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {
  color: #fff;
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.25rem;
}

.card-title {
  margin-bottom: 0.75rem;
}

.card-subtitle {
  margin-top: -0.375rem;
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}
.card-link + .card-link {
  margin-left: 1.25rem;
}

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
.card-header:first-child {
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}

.card-footer {
  padding: 0.75rem 1.25rem;
  background-color: rgba(0, 0, 0, 0.03);
  border-top: 1px solid rgba(0, 0, 0, 0.125);
}
.card-footer:last-child {
  border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);
}

.card-header-tabs {
  margin-right: -0.625rem;
  margin-bottom: -0.75rem;
  margin-left: -0.625rem;
  border-bottom: 0;
}

.card-header-pills {
  margin-right: -0.625rem;
  margin-left: -0.625rem;
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem;
  border-radius: calc(0.25rem - 1px);
}

.card-img,
.card-img-top,
.card-img-bottom {
  flex-shrink: 0;
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}

.card-deck .card {
  margin-bottom: 15px;
}
@media (min-width: 576px) {
  .card-deck {
    display: flex;
    flex-flow: row wrap;
    margin-right: -15px;
    margin-left: -15px;
  }
  .card-deck .card {
    flex: 1 0 0%;
    margin-right: 15px;
    margin-bottom: 0;
    margin-left: 15px;
  }
}

.card-group > .card {
  margin-bottom: 15px;
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0 0%;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.card-columns .card {
  margin-bottom: 0.75rem;
}
@media (min-width: 576px) {
  .card-columns {
    column-count: 3;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1;
  }
  .card-columns .card {
    display: inline-block;
    width: 100%;
  }
}

.accordion {
  overflow-anchor: none;
}
.accordion > .card {
  overflow: hidden;
}
.accordion > .card:not(:last-of-type) {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.accordion > .card:not(:first-of-type) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.accordion > .card > .card-header {
  border-radius: 0;
  margin-bottom: -1px;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  background-color: #e9ecef;
  border-radius: 0.25rem;
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem;
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: 0.5rem;
  color: #6c757d;
  content: "/";
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: underline;
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: none;
}
.breadcrumb-item.active {
  color: #6c757d;
}

.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: 0.25rem;
}

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #440099;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
.page-link:hover {
  z-index: 2;
  color: #22004d;
  text-decoration: none;
  background-color: #e9ecef;
  border-color: #dee2e6;
}
.page-link:focus {
  z-index: 3;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(68, 0, 153, 0.25);
}

.page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.page-item:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #440099;
  border-color: #440099;
}
.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  cursor: auto;
  background-color: #fff;
  border-color: #dee2e6;
}

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.25rem;
  line-height: 1.5;
}
.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
}
.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1.5;
}
.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem;
}
.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
}

.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .badge {
    transition: none;
  }
}
a.badge:hover, a.badge:focus {
  text-decoration: none;
}

.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.badge-pill {
  padding-right: 0.6em;
  padding-left: 0.6em;
  border-radius: 10rem;
}

.badge-primary {
  color: #fff;
  background-color: #440099;
}
a.badge-primary:hover, a.badge-primary:focus {
  color: #fff;
  background-color: #2d0066;
}
a.badge-primary:focus, a.badge-primary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(68, 0, 153, 0.5);
}

.badge-secondary {
  color: #fff;
  background-color: #6c757d;
}
a.badge-secondary:hover, a.badge-secondary:focus {
  color: #fff;
  background-color: #545b62;
}
a.badge-secondary:focus, a.badge-secondary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
}

.badge-success {
  color: #fff;
  background-color: #28a745;
}
a.badge-success:hover, a.badge-success:focus {
  color: #fff;
  background-color: #1e7e34;
}
a.badge-success:focus, a.badge-success.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);
}

.badge-info {
  color: #fff;
  background-color: #17a2b8;
}
a.badge-info:hover, a.badge-info:focus {
  color: #fff;
  background-color: #117a8b;
}
a.badge-info:focus, a.badge-info.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);
}

.badge-warning {
  color: #212529;
  background-color: #ffc107;
}
a.badge-warning:hover, a.badge-warning:focus {
  color: #212529;
  background-color: #d39e00;
}
a.badge-warning:focus, a.badge-warning.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
}

.badge-danger {
  color: #fff;
  background-color: #dc3545;
}
a.badge-danger:hover, a.badge-danger:focus {
  color: #fff;
  background-color: #bd2130;
}
a.badge-danger:focus, a.badge-danger.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);
}

.badge-light {
  color: #212529;
  background-color: #f8f9fa;
}
a.badge-light:hover, a.badge-light:focus {
  color: #212529;
  background-color: #dae0e5;
}
a.badge-light:focus, a.badge-light.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
}

.badge-dark {
  color: #fff;
  background-color: #343a40;
}
a.badge-dark:hover, a.badge-dark:focus {
  color: #fff;
  background-color: #1d2124;
}
a.badge-dark:focus, a.badge-dark.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.jumbotron {
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  background-color: #e9ecef;
  border-radius: 0.3rem;
}
@media (min-width: 576px) {
  .jumbotron {
    padding: 4rem 2rem;
  }
}

.jumbotron-fluid {
  padding-right: 0;
  padding-left: 0;
  border-radius: 0;
}

.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
}

.alert-dismissible {
  padding-right: 4rem;
}
.alert-dismissible .close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 0.75rem 1.25rem;
  color: inherit;
}

.alert-primary {
  color: #230050;
  background-color: #dacceb;
  border-color: #cbb8e2;
}
.alert-primary hr {
  border-top-color: #bea6db;
}
.alert-primary .alert-link {
  color: #0d001d;
}

.alert-secondary {
  color: #383d41;
  background-color: #e2e3e5;
  border-color: #d6d8db;
}
.alert-secondary hr {
  border-top-color: #c8cbcf;
}
.alert-secondary .alert-link {
  color: #202326;
}

.alert-success {
  color: #155724;
  background-color: #d4edda;
  border-color: #c3e6cb;
}
.alert-success hr {
  border-top-color: #b1dfbb;
}
.alert-success .alert-link {
  color: #0b2e13;
}

.alert-info {
  color: #0c5460;
  background-color: #d1ecf1;
  border-color: #bee5eb;
}
.alert-info hr {
  border-top-color: #abdde5;
}
.alert-info .alert-link {
  color: #062c33;
}

.alert-warning {
  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba;
}
.alert-warning hr {
  border-top-color: #ffe8a1;
}
.alert-warning .alert-link {
  color: #533f03;
}

.alert-danger {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
}
.alert-danger hr {
  border-top-color: #f1b0b7;
}
.alert-danger .alert-link {
  color: #491217;
}

.alert-light {
  color: #818182;
  background-color: #fefefe;
  border-color: #fdfdfe;
}
.alert-light hr {
  border-top-color: #ececf6;
}
.alert-light .alert-link {
  color: #686868;
}

.alert-dark {
  color: #1b1e21;
  background-color: #d6d8d9;
  border-color: #c6c8ca;
}
.alert-dark hr {
  border-top-color: #b9bbbe;
}
.alert-dark .alert-link {
  color: #040505;
}

@keyframes progress-bar-stripes {
  from {
    background-position: 1rem 0;
  }
  to {
    background-position: 0 0;
  }
}
.progress {
  display: flex;
  height: 1rem;
  overflow: hidden;
  line-height: 0;
  font-size: 0.75rem;
  background-color: #e9ecef;
  border-radius: 0.25rem;
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #440099;
  transition: width 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 1rem 1rem;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.media {
  display: flex;
  align-items: flex-start;
}

.media-body {
  flex: 1;
}

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 0.25rem;
}

.list-group-item-action {
  width: 100%;
  color: #495057;
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: #495057;
  text-decoration: none;
  background-color: #f8f9fa;
}
.list-group-item-action:active {
  color: #212529;
  background-color: #e9ecef;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
}
.list-group-item.active {
  z-index: 2;
  color: #fff;
  background-color: #440099;
  border-color: #440099;
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: -1px;
  border-top-width: 1px;
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child {
  border-bottom-left-radius: 0.25rem;
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child {
  border-top-right-radius: 0.25rem;
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: 1px;
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: -1px;
  border-left-width: 1px;
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 1px;
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  color: #230050;
  background-color: #cbb8e2;
}
.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
  color: #230050;
  background-color: #bea6db;
}
.list-group-item-primary.list-group-item-action.active {
  color: #fff;
  background-color: #230050;
  border-color: #230050;
}

.list-group-item-secondary {
  color: #383d41;
  background-color: #d6d8db;
}
.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
  color: #383d41;
  background-color: #c8cbcf;
}
.list-group-item-secondary.list-group-item-action.active {
  color: #fff;
  background-color: #383d41;
  border-color: #383d41;
}

.list-group-item-success {
  color: #155724;
  background-color: #c3e6cb;
}
.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
  color: #155724;
  background-color: #b1dfbb;
}
.list-group-item-success.list-group-item-action.active {
  color: #fff;
  background-color: #155724;
  border-color: #155724;
}

.list-group-item-info {
  color: #0c5460;
  background-color: #bee5eb;
}
.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
  color: #0c5460;
  background-color: #abdde5;
}
.list-group-item-info.list-group-item-action.active {
  color: #fff;
  background-color: #0c5460;
  border-color: #0c5460;
}

.list-group-item-warning {
  color: #856404;
  background-color: #ffeeba;
}
.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
  color: #856404;
  background-color: #ffe8a1;
}
.list-group-item-warning.list-group-item-action.active {
  color: #fff;
  background-color: #856404;
  border-color: #856404;
}

.list-group-item-danger {
  color: #721c24;
  background-color: #f5c6cb;
}
.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
  color: #721c24;
  background-color: #f1b0b7;
}
.list-group-item-danger.list-group-item-action.active {
  color: #fff;
  background-color: #721c24;
  border-color: #721c24;
}

.list-group-item-light {
  color: #818182;
  background-color: #fdfdfe;
}
.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
  color: #818182;
  background-color: #ececf6;
}
.list-group-item-light.list-group-item-action.active {
  color: #fff;
  background-color: #818182;
  border-color: #818182;
}

.list-group-item-dark {
  color: #1b1e21;
  background-color: #c6c8ca;
}
.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
  color: #1b1e21;
  background-color: #b9bbbe;
}
.list-group-item-dark.list-group-item-action.active {
  color: #fff;
  background-color: #1b1e21;
  border-color: #1b1e21;
}

.close {
  float: right;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.5;
}
@media (max-width: 1200px) {
  .close {
    font-size: calc(1.275rem + 0.3vw);
  }
}
.close:hover {
  color: #000;
  text-decoration: none;
}
.close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {
  opacity: 0.75;
}

button.close {
  padding: 0;
  background-color: transparent;
  border: 0;
}

a.close.disabled {
  pointer-events: none;
}

.toast {
  flex-basis: 350px;
  max-width: 350px;
  font-size: 0.875rem;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
  opacity: 0;
  border-radius: 0.25rem;
}
.toast:not(:last-child) {
  margin-bottom: 0.75rem;
}
.toast.showing {
  opacity: 1;
}
.toast.show {
  display: block;
  opacity: 1;
}
.toast.hide {
  display: none;
}

.toast-header {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  color: #6c757d;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}

.toast-body {
  padding: 0.75rem;
}

.modal-open {
  overflow: hidden;
}
.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  display: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  display: flex;
  max-height: calc(100% - 1rem);
}
.modal-dialog-scrollable .modal-content {
  max-height: calc(100vh - 1rem);
  overflow: hidden;
}
.modal-dialog-scrollable .modal-header,
.modal-dialog-scrollable .modal-footer {
  flex-shrink: 0;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
}
.modal-dialog-centered::before {
  display: block;
  height: calc(100vh - 1rem);
  height: min-content;
  content: "";
}
.modal-dialog-centered.modal-dialog-scrollable {
  flex-direction: column;
  justify-content: center;
  height: 100%;
}
.modal-dialog-centered.modal-dialog-scrollable .modal-content {
  max-height: none;
}
.modal-dialog-centered.modal-dialog-scrollable::before {
  content: none;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: 0.5;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}
.modal-header .close {
  padding: 1rem 1rem;
  margin: -1rem -1rem -1rem auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
}

.modal-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: 0.75rem;
  border-top: 1px solid #dee2e6;
  border-bottom-right-radius: calc(0.3rem - 1px);
  border-bottom-left-radius: calc(0.3rem - 1px);
}
.modal-footer > * {
  margin: 0.25rem;
}

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
  }
  .modal-dialog-scrollable {
    max-height: calc(100% - 3.5rem);
  }
  .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 3.5rem);
  }
  .modal-dialog-centered {
    min-height: calc(100% - 3.5rem);
  }
  .modal-dialog-centered::before {
    height: calc(100vh - 3.5rem);
    height: min-content;
  }
  .modal-sm {
    max-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    max-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    max-width: 1140px;
  }
}
.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  margin: 0;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: 0.75rem;
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: 0.9;
}
.tooltip .arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
}
.tooltip .arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top, .bs-tooltip-auto[x-placement^=top] {
  padding: 0.4rem 0;
}
.bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^=top] .arrow {
  bottom: 0;
}
.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^=top] .arrow::before {
  top: 0;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #000;
}

.bs-tooltip-right, .bs-tooltip-auto[x-placement^=right] {
  padding: 0 0.4rem;
}
.bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^=right] .arrow {
  left: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^=right] .arrow::before {
  right: 0;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #000;
}

.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^=bottom] {
  padding: 0.4rem 0;
}
.bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^=bottom] .arrow {
  top: 0;
}
.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  bottom: 0;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #000;
}

.bs-tooltip-left, .bs-tooltip-auto[x-placement^=left] {
  padding: 0 0.4rem;
}
.bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^=left] .arrow {
  right: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^=left] .arrow::before {
  left: 0;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #000;
}

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 0.25rem;
}

.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: block;
  max-width: 276px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: 0.75rem;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
}
.popover .arrow {
  position: absolute;
  display: block;
  width: 1rem;
  height: 0.5rem;
  margin: 0 0.3rem;
}
.popover .arrow::before, .popover .arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-popover-top, .bs-popover-auto[x-placement^=top] {
  margin-bottom: 0.5rem;
}
.bs-popover-top > .arrow, .bs-popover-auto[x-placement^=top] > .arrow {
  bottom: calc(-0.5rem - 1px);
}
.bs-popover-top > .arrow::before, .bs-popover-auto[x-placement^=top] > .arrow::before {
  bottom: 0;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^=top] > .arrow::after {
  bottom: 1px;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: #fff;
}

.bs-popover-right, .bs-popover-auto[x-placement^=right] {
  margin-left: 0.5rem;
}
.bs-popover-right > .arrow, .bs-popover-auto[x-placement^=right] > .arrow {
  left: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
  margin: 0.3rem 0;
}
.bs-popover-right > .arrow::before, .bs-popover-auto[x-placement^=right] > .arrow::before {
  left: 0;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-right > .arrow::after, .bs-popover-auto[x-placement^=right] > .arrow::after {
  left: 1px;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: #fff;
}

.bs-popover-bottom, .bs-popover-auto[x-placement^=bottom] {
  margin-top: 0.5rem;
}
.bs-popover-bottom > .arrow, .bs-popover-auto[x-placement^=bottom] > .arrow {
  top: calc(-0.5rem - 1px);
}
.bs-popover-bottom > .arrow::before, .bs-popover-auto[x-placement^=bottom] > .arrow::before {
  top: 0;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-bottom > .arrow::after, .bs-popover-auto[x-placement^=bottom] > .arrow::after {
  top: 1px;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: #fff;
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1rem;
  margin-left: -0.5rem;
  content: "";
  border-bottom: 1px solid #f7f7f7;
}

.bs-popover-left, .bs-popover-auto[x-placement^=left] {
  margin-right: 0.5rem;
}
.bs-popover-left > .arrow, .bs-popover-auto[x-placement^=left] > .arrow {
  right: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
  margin: 0.3rem 0;
}
.bs-popover-left > .arrow::before, .bs-popover-auto[x-placement^=left] > .arrow::before {
  right: 0;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-left > .arrow::after, .bs-popover-auto[x-placement^=left] > .arrow::after {
  right: 1px;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: #fff;
}

.popover-header {
  padding: 0.5rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  background-color: #f7f7f7;
  border-bottom: 1px solid #ebebeb;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: 0.5rem 0.75rem;
  color: #212529;
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-left),
.active.carousel-item-right {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-right),
.active.carousel-item-left {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-left,
  .carousel-fade .active.carousel-item-right {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 75px;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: 50%/100% 100% no-repeat;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 75px;
  margin-left: 75px;
  list-style: none;
}
.carousel-indicators li {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators li {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}
.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  border: 0.25em solid currentcolor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: 0.75s linear infinite spinner-border;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  background-color: currentcolor;
  border-radius: 50%;
  opacity: 0;
  animation: 0.75s linear infinite spinner-grow;
}

.spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    animation-duration: 1.5s;
  }
}
.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.bg-primary {
  background-color: #440099 !important;
}

a.bg-primary:hover, a.bg-primary:focus,
button.bg-primary:hover,
button.bg-primary:focus {
  background-color: #2d0066 !important;
}

.bg-secondary {
  background-color: #6c757d !important;
}

a.bg-secondary:hover, a.bg-secondary:focus,
button.bg-secondary:hover,
button.bg-secondary:focus {
  background-color: #545b62 !important;
}

.bg-success {
  background-color: #28a745 !important;
}

a.bg-success:hover, a.bg-success:focus,
button.bg-success:hover,
button.bg-success:focus {
  background-color: #1e7e34 !important;
}

.bg-info {
  background-color: #17a2b8 !important;
}

a.bg-info:hover, a.bg-info:focus,
button.bg-info:hover,
button.bg-info:focus {
  background-color: #117a8b !important;
}

.bg-warning {
  background-color: #ffc107 !important;
}

a.bg-warning:hover, a.bg-warning:focus,
button.bg-warning:hover,
button.bg-warning:focus {
  background-color: #d39e00 !important;
}

.bg-danger {
  background-color: #dc3545 !important;
}

a.bg-danger:hover, a.bg-danger:focus,
button.bg-danger:hover,
button.bg-danger:focus {
  background-color: #bd2130 !important;
}

.bg-light {
  background-color: #f8f9fa !important;
}

a.bg-light:hover, a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
  background-color: #dae0e5 !important;
}

.bg-dark {
  background-color: #343a40 !important;
}

a.bg-dark:hover, a.bg-dark:focus,
button.bg-dark:hover,
button.bg-dark:focus {
  background-color: #1d2124 !important;
}

.bg-white {
  background-color: #fff !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.border {
  border: 1px solid #dee2e6 !important;
}

.border-top {
  border-top: 1px solid #dee2e6 !important;
}

.border-right {
  border-right: 1px solid #dee2e6 !important;
}

.border-bottom {
  border-bottom: 1px solid #dee2e6 !important;
}

.border-left {
  border-left: 1px solid #dee2e6 !important;
}

.border-0 {
  border: 0 !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-right-0 {
  border-right: 0 !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-left-0 {
  border-left: 0 !important;
}

.border-primary {
  border-color: #440099 !important;
}

.border-secondary {
  border-color: #6c757d !important;
}

.border-success {
  border-color: #28a745 !important;
}

.border-info {
  border-color: #17a2b8 !important;
}

.border-warning {
  border-color: #ffc107 !important;
}

.border-danger {
  border-color: #dc3545 !important;
}

.border-light {
  border-color: #f8f9fa !important;
}

.border-dark {
  border-color: #343a40 !important;
}

.border-white {
  border-color: #fff !important;
}

.rounded-sm {
  border-radius: 0.2rem !important;
}

.rounded {
  border-radius: 0.25rem !important;
}

.rounded-top {
  border-top-left-radius: 0.25rem !important;
  border-top-right-radius: 0.25rem !important;
}

.rounded-right {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}

.rounded-bottom {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.rounded-left {
  border-top-left-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.rounded-lg {
  border-radius: 0.3rem !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.d-none {
  display: none !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

@media (min-width: 576px) {
  .d-sm-none {
    display: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 768px) {
  .d-md-none {
    display: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 992px) {
  .d-lg-none {
    display: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 1200px) {
  .d-xl-none {
    display: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
}
@media print {
  .d-print-none {
    display: none !important;
  }
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
}
.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}
.embed-responsive::before {
  display: block;
  content: "";
}
.embed-responsive .embed-responsive-item,
.embed-responsive iframe,
.embed-responsive embed,
.embed-responsive object,
.embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.embed-responsive-21by9::before {
  padding-top: 42.85714286%;
}

.embed-responsive-16by9::before {
  padding-top: 56.25%;
}

.embed-responsive-4by3::before {
  padding-top: 75%;
}

.embed-responsive-1by1::before {
  padding-top: 100%;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

@media (min-width: 576px) {
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 768px) {
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 992px) {
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 1200px) {
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
}
.float-left {
  float: left !important;
}

.float-right {
  float: right !important;
}

.float-none {
  float: none !important;
}

@media (min-width: 576px) {
  .float-sm-left {
    float: left !important;
  }
  .float-sm-right {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
}
@media (min-width: 768px) {
  .float-md-left {
    float: left !important;
  }
  .float-md-right {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
}
@media (min-width: 992px) {
  .float-lg-left {
    float: left !important;
  }
  .float-lg-right {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-left {
    float: left !important;
  }
  .float-xl-right {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
}
.user-select-all {
  user-select: all !important;
}

.user-select-auto {
  user-select: auto !important;
}

.user-select-none {
  user-select: none !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

@supports (position: sticky) {
  .sticky-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.sr-only-focusable:active, .sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.vw-100 {
  width: 100vw !important;
}

.vh-100 {
  height: 100vh !important;
}

.m-0 {
  margin: 0 !important;
}

.mt-0,
.my-0 {
  margin-top: 0 !important;
}

.mr-0,
.mx-0 {
  margin-right: 0 !important;
}

.mb-0,
.my-0 {
  margin-bottom: 0 !important;
}

.ml-0,
.mx-0 {
  margin-left: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.mt-1,
.my-1 {
  margin-top: 0.25rem !important;
}

.mr-1,
.mx-1 {
  margin-right: 0.25rem !important;
}

.mb-1,
.my-1 {
  margin-bottom: 0.25rem !important;
}

.ml-1,
.mx-1 {
  margin-left: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.mt-2,
.my-2 {
  margin-top: 0.5rem !important;
}

.mr-2,
.mx-2 {
  margin-right: 0.5rem !important;
}

.mb-2,
.my-2 {
  margin-bottom: 0.5rem !important;
}

.ml-2,
.mx-2 {
  margin-left: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.mt-3,
.my-3 {
  margin-top: 1rem !important;
}

.mr-3,
.mx-3 {
  margin-right: 1rem !important;
}

.mb-3,
.my-3 {
  margin-bottom: 1rem !important;
}

.ml-3,
.mx-3 {
  margin-left: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.mt-4,
.my-4 {
  margin-top: 1.5rem !important;
}

.mr-4,
.mx-4 {
  margin-right: 1.5rem !important;
}

.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important;
}

.ml-4,
.mx-4 {
  margin-left: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.mt-5,
.my-5 {
  margin-top: 3rem !important;
}

.mr-5,
.mx-5 {
  margin-right: 3rem !important;
}

.mb-5,
.my-5 {
  margin-bottom: 3rem !important;
}

.ml-5,
.mx-5 {
  margin-left: 3rem !important;
}

.p-0 {
  padding: 0 !important;
}

.pt-0,
.py-0 {
  padding-top: 0 !important;
}

.pr-0,
.px-0 {
  padding-right: 0 !important;
}

.pb-0,
.py-0 {
  padding-bottom: 0 !important;
}

.pl-0,
.px-0 {
  padding-left: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.pt-1,
.py-1 {
  padding-top: 0.25rem !important;
}

.pr-1,
.px-1 {
  padding-right: 0.25rem !important;
}

.pb-1,
.py-1 {
  padding-bottom: 0.25rem !important;
}

.pl-1,
.px-1 {
  padding-left: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.pt-2,
.py-2 {
  padding-top: 0.5rem !important;
}

.pr-2,
.px-2 {
  padding-right: 0.5rem !important;
}

.pb-2,
.py-2 {
  padding-bottom: 0.5rem !important;
}

.pl-2,
.px-2 {
  padding-left: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.pt-3,
.py-3 {
  padding-top: 1rem !important;
}

.pr-3,
.px-3 {
  padding-right: 1rem !important;
}

.pb-3,
.py-3 {
  padding-bottom: 1rem !important;
}

.pl-3,
.px-3 {
  padding-left: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.pt-4,
.py-4 {
  padding-top: 1.5rem !important;
}

.pr-4,
.px-4 {
  padding-right: 1.5rem !important;
}

.pb-4,
.py-4 {
  padding-bottom: 1.5rem !important;
}

.pl-4,
.px-4 {
  padding-left: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.pt-5,
.py-5 {
  padding-top: 3rem !important;
}

.pr-5,
.px-5 {
  padding-right: 3rem !important;
}

.pb-5,
.py-5 {
  padding-bottom: 3rem !important;
}

.pl-5,
.px-5 {
  padding-left: 3rem !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.mt-n1,
.my-n1 {
  margin-top: -0.25rem !important;
}

.mr-n1,
.mx-n1 {
  margin-right: -0.25rem !important;
}

.mb-n1,
.my-n1 {
  margin-bottom: -0.25rem !important;
}

.ml-n1,
.mx-n1 {
  margin-left: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.mt-n2,
.my-n2 {
  margin-top: -0.5rem !important;
}

.mr-n2,
.mx-n2 {
  margin-right: -0.5rem !important;
}

.mb-n2,
.my-n2 {
  margin-bottom: -0.5rem !important;
}

.ml-n2,
.mx-n2 {
  margin-left: -0.5rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.mt-n3,
.my-n3 {
  margin-top: -1rem !important;
}

.mr-n3,
.mx-n3 {
  margin-right: -1rem !important;
}

.mb-n3,
.my-n3 {
  margin-bottom: -1rem !important;
}

.ml-n3,
.mx-n3 {
  margin-left: -1rem !important;
}

.m-n4 {
  margin: -1.5rem !important;
}

.mt-n4,
.my-n4 {
  margin-top: -1.5rem !important;
}

.mr-n4,
.mx-n4 {
  margin-right: -1.5rem !important;
}

.mb-n4,
.my-n4 {
  margin-bottom: -1.5rem !important;
}

.ml-n4,
.mx-n4 {
  margin-left: -1.5rem !important;
}

.m-n5 {
  margin: -3rem !important;
}

.mt-n5,
.my-n5 {
  margin-top: -3rem !important;
}

.mr-n5,
.mx-n5 {
  margin-right: -3rem !important;
}

.mb-n5,
.my-n5 {
  margin-bottom: -3rem !important;
}

.ml-n5,
.mx-n5 {
  margin-left: -3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mt-auto,
.my-auto {
  margin-top: auto !important;
}

.mr-auto,
.mx-auto {
  margin-right: auto !important;
}

.mb-auto,
.my-auto {
  margin-bottom: auto !important;
}

.ml-auto,
.mx-auto {
  margin-left: auto !important;
}

@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0 !important;
  }
  .mt-sm-0,
  .my-sm-0 {
    margin-top: 0 !important;
  }
  .mr-sm-0,
  .mx-sm-0 {
    margin-right: 0 !important;
  }
  .mb-sm-0,
  .my-sm-0 {
    margin-bottom: 0 !important;
  }
  .ml-sm-0,
  .mx-sm-0 {
    margin-left: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .mt-sm-1,
  .my-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mr-sm-1,
  .mx-sm-1 {
    margin-right: 0.25rem !important;
  }
  .mb-sm-1,
  .my-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-sm-1,
  .mx-sm-1 {
    margin-left: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .mt-sm-2,
  .my-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mr-sm-2,
  .mx-sm-2 {
    margin-right: 0.5rem !important;
  }
  .mb-sm-2,
  .my-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-sm-2,
  .mx-sm-2 {
    margin-left: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .mt-sm-3,
  .my-sm-3 {
    margin-top: 1rem !important;
  }
  .mr-sm-3,
  .mx-sm-3 {
    margin-right: 1rem !important;
  }
  .mb-sm-3,
  .my-sm-3 {
    margin-bottom: 1rem !important;
  }
  .ml-sm-3,
  .mx-sm-3 {
    margin-left: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .mt-sm-4,
  .my-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mr-sm-4,
  .mx-sm-4 {
    margin-right: 1.5rem !important;
  }
  .mb-sm-4,
  .my-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-sm-4,
  .mx-sm-4 {
    margin-left: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .mt-sm-5,
  .my-sm-5 {
    margin-top: 3rem !important;
  }
  .mr-sm-5,
  .mx-sm-5 {
    margin-right: 3rem !important;
  }
  .mb-sm-5,
  .my-sm-5 {
    margin-bottom: 3rem !important;
  }
  .ml-sm-5,
  .mx-sm-5 {
    margin-left: 3rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .pt-sm-0,
  .py-sm-0 {
    padding-top: 0 !important;
  }
  .pr-sm-0,
  .px-sm-0 {
    padding-right: 0 !important;
  }
  .pb-sm-0,
  .py-sm-0 {
    padding-bottom: 0 !important;
  }
  .pl-sm-0,
  .px-sm-0 {
    padding-left: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .pt-sm-1,
  .py-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pr-sm-1,
  .px-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pb-sm-1,
  .py-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-sm-1,
  .px-sm-1 {
    padding-left: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .pt-sm-2,
  .py-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pr-sm-2,
  .px-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pb-sm-2,
  .py-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-sm-2,
  .px-sm-2 {
    padding-left: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .pt-sm-3,
  .py-sm-3 {
    padding-top: 1rem !important;
  }
  .pr-sm-3,
  .px-sm-3 {
    padding-right: 1rem !important;
  }
  .pb-sm-3,
  .py-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pl-sm-3,
  .px-sm-3 {
    padding-left: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .pt-sm-4,
  .py-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pr-sm-4,
  .px-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pb-sm-4,
  .py-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-sm-4,
  .px-sm-4 {
    padding-left: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .pt-sm-5,
  .py-sm-5 {
    padding-top: 3rem !important;
  }
  .pr-sm-5,
  .px-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-5,
  .py-sm-5 {
    padding-bottom: 3rem !important;
  }
  .pl-sm-5,
  .px-sm-5 {
    padding-left: 3rem !important;
  }
  .m-sm-n1 {
    margin: -0.25rem !important;
  }
  .mt-sm-n1,
  .my-sm-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-sm-n1,
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-sm-n1,
  .my-sm-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-sm-n1,
  .mx-sm-n1 {
    margin-left: -0.25rem !important;
  }
  .m-sm-n2 {
    margin: -0.5rem !important;
  }
  .mt-sm-n2,
  .my-sm-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-sm-n2,
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-sm-n2,
  .my-sm-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-sm-n2,
  .mx-sm-n2 {
    margin-left: -0.5rem !important;
  }
  .m-sm-n3 {
    margin: -1rem !important;
  }
  .mt-sm-n3,
  .my-sm-n3 {
    margin-top: -1rem !important;
  }
  .mr-sm-n3,
  .mx-sm-n3 {
    margin-right: -1rem !important;
  }
  .mb-sm-n3,
  .my-sm-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-sm-n3,
  .mx-sm-n3 {
    margin-left: -1rem !important;
  }
  .m-sm-n4 {
    margin: -1.5rem !important;
  }
  .mt-sm-n4,
  .my-sm-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-sm-n4,
  .mx-sm-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-sm-n4,
  .my-sm-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-sm-n4,
  .mx-sm-n4 {
    margin-left: -1.5rem !important;
  }
  .m-sm-n5 {
    margin: -3rem !important;
  }
  .mt-sm-n5,
  .my-sm-n5 {
    margin-top: -3rem !important;
  }
  .mr-sm-n5,
  .mx-sm-n5 {
    margin-right: -3rem !important;
  }
  .mb-sm-n5,
  .my-sm-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-sm-n5,
  .mx-sm-n5 {
    margin-left: -3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mt-sm-auto,
  .my-sm-auto {
    margin-top: auto !important;
  }
  .mr-sm-auto,
  .mx-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-auto,
  .my-sm-auto {
    margin-bottom: auto !important;
  }
  .ml-sm-auto,
  .mx-sm-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 768px) {
  .m-md-0 {
    margin: 0 !important;
  }
  .mt-md-0,
  .my-md-0 {
    margin-top: 0 !important;
  }
  .mr-md-0,
  .mx-md-0 {
    margin-right: 0 !important;
  }
  .mb-md-0,
  .my-md-0 {
    margin-bottom: 0 !important;
  }
  .ml-md-0,
  .mx-md-0 {
    margin-left: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .mt-md-1,
  .my-md-1 {
    margin-top: 0.25rem !important;
  }
  .mr-md-1,
  .mx-md-1 {
    margin-right: 0.25rem !important;
  }
  .mb-md-1,
  .my-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-md-1,
  .mx-md-1 {
    margin-left: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .mt-md-2,
  .my-md-2 {
    margin-top: 0.5rem !important;
  }
  .mr-md-2,
  .mx-md-2 {
    margin-right: 0.5rem !important;
  }
  .mb-md-2,
  .my-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-md-2,
  .mx-md-2 {
    margin-left: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .mt-md-3,
  .my-md-3 {
    margin-top: 1rem !important;
  }
  .mr-md-3,
  .mx-md-3 {
    margin-right: 1rem !important;
  }
  .mb-md-3,
  .my-md-3 {
    margin-bottom: 1rem !important;
  }
  .ml-md-3,
  .mx-md-3 {
    margin-left: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .mt-md-4,
  .my-md-4 {
    margin-top: 1.5rem !important;
  }
  .mr-md-4,
  .mx-md-4 {
    margin-right: 1.5rem !important;
  }
  .mb-md-4,
  .my-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-md-4,
  .mx-md-4 {
    margin-left: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .mt-md-5,
  .my-md-5 {
    margin-top: 3rem !important;
  }
  .mr-md-5,
  .mx-md-5 {
    margin-right: 3rem !important;
  }
  .mb-md-5,
  .my-md-5 {
    margin-bottom: 3rem !important;
  }
  .ml-md-5,
  .mx-md-5 {
    margin-left: 3rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .pt-md-0,
  .py-md-0 {
    padding-top: 0 !important;
  }
  .pr-md-0,
  .px-md-0 {
    padding-right: 0 !important;
  }
  .pb-md-0,
  .py-md-0 {
    padding-bottom: 0 !important;
  }
  .pl-md-0,
  .px-md-0 {
    padding-left: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .pt-md-1,
  .py-md-1 {
    padding-top: 0.25rem !important;
  }
  .pr-md-1,
  .px-md-1 {
    padding-right: 0.25rem !important;
  }
  .pb-md-1,
  .py-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-md-1,
  .px-md-1 {
    padding-left: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .pt-md-2,
  .py-md-2 {
    padding-top: 0.5rem !important;
  }
  .pr-md-2,
  .px-md-2 {
    padding-right: 0.5rem !important;
  }
  .pb-md-2,
  .py-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-md-2,
  .px-md-2 {
    padding-left: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .pt-md-3,
  .py-md-3 {
    padding-top: 1rem !important;
  }
  .pr-md-3,
  .px-md-3 {
    padding-right: 1rem !important;
  }
  .pb-md-3,
  .py-md-3 {
    padding-bottom: 1rem !important;
  }
  .pl-md-3,
  .px-md-3 {
    padding-left: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .pt-md-4,
  .py-md-4 {
    padding-top: 1.5rem !important;
  }
  .pr-md-4,
  .px-md-4 {
    padding-right: 1.5rem !important;
  }
  .pb-md-4,
  .py-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-md-4,
  .px-md-4 {
    padding-left: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .pt-md-5,
  .py-md-5 {
    padding-top: 3rem !important;
  }
  .pr-md-5,
  .px-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-5,
  .py-md-5 {
    padding-bottom: 3rem !important;
  }
  .pl-md-5,
  .px-md-5 {
    padding-left: 3rem !important;
  }
  .m-md-n1 {
    margin: -0.25rem !important;
  }
  .mt-md-n1,
  .my-md-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-md-n1,
  .mx-md-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-md-n1,
  .my-md-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-md-n1,
  .mx-md-n1 {
    margin-left: -0.25rem !important;
  }
  .m-md-n2 {
    margin: -0.5rem !important;
  }
  .mt-md-n2,
  .my-md-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-md-n2,
  .mx-md-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-md-n2,
  .my-md-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-md-n2,
  .mx-md-n2 {
    margin-left: -0.5rem !important;
  }
  .m-md-n3 {
    margin: -1rem !important;
  }
  .mt-md-n3,
  .my-md-n3 {
    margin-top: -1rem !important;
  }
  .mr-md-n3,
  .mx-md-n3 {
    margin-right: -1rem !important;
  }
  .mb-md-n3,
  .my-md-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-md-n3,
  .mx-md-n3 {
    margin-left: -1rem !important;
  }
  .m-md-n4 {
    margin: -1.5rem !important;
  }
  .mt-md-n4,
  .my-md-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-md-n4,
  .mx-md-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-md-n4,
  .my-md-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-md-n4,
  .mx-md-n4 {
    margin-left: -1.5rem !important;
  }
  .m-md-n5 {
    margin: -3rem !important;
  }
  .mt-md-n5,
  .my-md-n5 {
    margin-top: -3rem !important;
  }
  .mr-md-n5,
  .mx-md-n5 {
    margin-right: -3rem !important;
  }
  .mb-md-n5,
  .my-md-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-md-n5,
  .mx-md-n5 {
    margin-left: -3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mt-md-auto,
  .my-md-auto {
    margin-top: auto !important;
  }
  .mr-md-auto,
  .mx-md-auto {
    margin-right: auto !important;
  }
  .mb-md-auto,
  .my-md-auto {
    margin-bottom: auto !important;
  }
  .ml-md-auto,
  .mx-md-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0 !important;
  }
  .mt-lg-0,
  .my-lg-0 {
    margin-top: 0 !important;
  }
  .mr-lg-0,
  .mx-lg-0 {
    margin-right: 0 !important;
  }
  .mb-lg-0,
  .my-lg-0 {
    margin-bottom: 0 !important;
  }
  .ml-lg-0,
  .mx-lg-0 {
    margin-left: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .mt-lg-1,
  .my-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mr-lg-1,
  .mx-lg-1 {
    margin-right: 0.25rem !important;
  }
  .mb-lg-1,
  .my-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-lg-1,
  .mx-lg-1 {
    margin-left: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .mt-lg-2,
  .my-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mr-lg-2,
  .mx-lg-2 {
    margin-right: 0.5rem !important;
  }
  .mb-lg-2,
  .my-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-lg-2,
  .mx-lg-2 {
    margin-left: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .mt-lg-3,
  .my-lg-3 {
    margin-top: 1rem !important;
  }
  .mr-lg-3,
  .mx-lg-3 {
    margin-right: 1rem !important;
  }
  .mb-lg-3,
  .my-lg-3 {
    margin-bottom: 1rem !important;
  }
  .ml-lg-3,
  .mx-lg-3 {
    margin-left: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .mt-lg-4,
  .my-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mr-lg-4,
  .mx-lg-4 {
    margin-right: 1.5rem !important;
  }
  .mb-lg-4,
  .my-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-lg-4,
  .mx-lg-4 {
    margin-left: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .mt-lg-5,
  .my-lg-5 {
    margin-top: 3rem !important;
  }
  .mr-lg-5,
  .mx-lg-5 {
    margin-right: 3rem !important;
  }
  .mb-lg-5,
  .my-lg-5 {
    margin-bottom: 3rem !important;
  }
  .ml-lg-5,
  .mx-lg-5 {
    margin-left: 3rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .pt-lg-0,
  .py-lg-0 {
    padding-top: 0 !important;
  }
  .pr-lg-0,
  .px-lg-0 {
    padding-right: 0 !important;
  }
  .pb-lg-0,
  .py-lg-0 {
    padding-bottom: 0 !important;
  }
  .pl-lg-0,
  .px-lg-0 {
    padding-left: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .pt-lg-1,
  .py-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pr-lg-1,
  .px-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pb-lg-1,
  .py-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-lg-1,
  .px-lg-1 {
    padding-left: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .pt-lg-2,
  .py-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pr-lg-2,
  .px-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pb-lg-2,
  .py-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-lg-2,
  .px-lg-2 {
    padding-left: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .pt-lg-3,
  .py-lg-3 {
    padding-top: 1rem !important;
  }
  .pr-lg-3,
  .px-lg-3 {
    padding-right: 1rem !important;
  }
  .pb-lg-3,
  .py-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pl-lg-3,
  .px-lg-3 {
    padding-left: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .pt-lg-4,
  .py-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pr-lg-4,
  .px-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pb-lg-4,
  .py-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-lg-4,
  .px-lg-4 {
    padding-left: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .pt-lg-5,
  .py-lg-5 {
    padding-top: 3rem !important;
  }
  .pr-lg-5,
  .px-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-5,
  .py-lg-5 {
    padding-bottom: 3rem !important;
  }
  .pl-lg-5,
  .px-lg-5 {
    padding-left: 3rem !important;
  }
  .m-lg-n1 {
    margin: -0.25rem !important;
  }
  .mt-lg-n1,
  .my-lg-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-lg-n1,
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-lg-n1,
  .my-lg-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-lg-n1,
  .mx-lg-n1 {
    margin-left: -0.25rem !important;
  }
  .m-lg-n2 {
    margin: -0.5rem !important;
  }
  .mt-lg-n2,
  .my-lg-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-lg-n2,
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-lg-n2,
  .my-lg-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-lg-n2,
  .mx-lg-n2 {
    margin-left: -0.5rem !important;
  }
  .m-lg-n3 {
    margin: -1rem !important;
  }
  .mt-lg-n3,
  .my-lg-n3 {
    margin-top: -1rem !important;
  }
  .mr-lg-n3,
  .mx-lg-n3 {
    margin-right: -1rem !important;
  }
  .mb-lg-n3,
  .my-lg-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-lg-n3,
  .mx-lg-n3 {
    margin-left: -1rem !important;
  }
  .m-lg-n4 {
    margin: -1.5rem !important;
  }
  .mt-lg-n4,
  .my-lg-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-lg-n4,
  .mx-lg-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-lg-n4,
  .my-lg-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-lg-n4,
  .mx-lg-n4 {
    margin-left: -1.5rem !important;
  }
  .m-lg-n5 {
    margin: -3rem !important;
  }
  .mt-lg-n5,
  .my-lg-n5 {
    margin-top: -3rem !important;
  }
  .mr-lg-n5,
  .mx-lg-n5 {
    margin-right: -3rem !important;
  }
  .mb-lg-n5,
  .my-lg-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-lg-n5,
  .mx-lg-n5 {
    margin-left: -3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mt-lg-auto,
  .my-lg-auto {
    margin-top: auto !important;
  }
  .mr-lg-auto,
  .mx-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-auto,
  .my-lg-auto {
    margin-bottom: auto !important;
  }
  .ml-lg-auto,
  .mx-lg-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0 !important;
  }
  .mt-xl-0,
  .my-xl-0 {
    margin-top: 0 !important;
  }
  .mr-xl-0,
  .mx-xl-0 {
    margin-right: 0 !important;
  }
  .mb-xl-0,
  .my-xl-0 {
    margin-bottom: 0 !important;
  }
  .ml-xl-0,
  .mx-xl-0 {
    margin-left: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .mt-xl-1,
  .my-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mr-xl-1,
  .mx-xl-1 {
    margin-right: 0.25rem !important;
  }
  .mb-xl-1,
  .my-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-xl-1,
  .mx-xl-1 {
    margin-left: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .mt-xl-2,
  .my-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mr-xl-2,
  .mx-xl-2 {
    margin-right: 0.5rem !important;
  }
  .mb-xl-2,
  .my-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-xl-2,
  .mx-xl-2 {
    margin-left: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .mt-xl-3,
  .my-xl-3 {
    margin-top: 1rem !important;
  }
  .mr-xl-3,
  .mx-xl-3 {
    margin-right: 1rem !important;
  }
  .mb-xl-3,
  .my-xl-3 {
    margin-bottom: 1rem !important;
  }
  .ml-xl-3,
  .mx-xl-3 {
    margin-left: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .mt-xl-4,
  .my-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mr-xl-4,
  .mx-xl-4 {
    margin-right: 1.5rem !important;
  }
  .mb-xl-4,
  .my-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-xl-4,
  .mx-xl-4 {
    margin-left: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .mt-xl-5,
  .my-xl-5 {
    margin-top: 3rem !important;
  }
  .mr-xl-5,
  .mx-xl-5 {
    margin-right: 3rem !important;
  }
  .mb-xl-5,
  .my-xl-5 {
    margin-bottom: 3rem !important;
  }
  .ml-xl-5,
  .mx-xl-5 {
    margin-left: 3rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .pt-xl-0,
  .py-xl-0 {
    padding-top: 0 !important;
  }
  .pr-xl-0,
  .px-xl-0 {
    padding-right: 0 !important;
  }
  .pb-xl-0,
  .py-xl-0 {
    padding-bottom: 0 !important;
  }
  .pl-xl-0,
  .px-xl-0 {
    padding-left: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .pt-xl-1,
  .py-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pr-xl-1,
  .px-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pb-xl-1,
  .py-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-xl-1,
  .px-xl-1 {
    padding-left: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .pt-xl-2,
  .py-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pr-xl-2,
  .px-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pb-xl-2,
  .py-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-xl-2,
  .px-xl-2 {
    padding-left: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .pt-xl-3,
  .py-xl-3 {
    padding-top: 1rem !important;
  }
  .pr-xl-3,
  .px-xl-3 {
    padding-right: 1rem !important;
  }
  .pb-xl-3,
  .py-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pl-xl-3,
  .px-xl-3 {
    padding-left: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .pt-xl-4,
  .py-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pr-xl-4,
  .px-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pb-xl-4,
  .py-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-xl-4,
  .px-xl-4 {
    padding-left: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .pt-xl-5,
  .py-xl-5 {
    padding-top: 3rem !important;
  }
  .pr-xl-5,
  .px-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-5,
  .py-xl-5 {
    padding-bottom: 3rem !important;
  }
  .pl-xl-5,
  .px-xl-5 {
    padding-left: 3rem !important;
  }
  .m-xl-n1 {
    margin: -0.25rem !important;
  }
  .mt-xl-n1,
  .my-xl-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-xl-n1,
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-xl-n1,
  .my-xl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-xl-n1,
  .mx-xl-n1 {
    margin-left: -0.25rem !important;
  }
  .m-xl-n2 {
    margin: -0.5rem !important;
  }
  .mt-xl-n2,
  .my-xl-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-xl-n2,
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-xl-n2,
  .my-xl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-xl-n2,
  .mx-xl-n2 {
    margin-left: -0.5rem !important;
  }
  .m-xl-n3 {
    margin: -1rem !important;
  }
  .mt-xl-n3,
  .my-xl-n3 {
    margin-top: -1rem !important;
  }
  .mr-xl-n3,
  .mx-xl-n3 {
    margin-right: -1rem !important;
  }
  .mb-xl-n3,
  .my-xl-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-xl-n3,
  .mx-xl-n3 {
    margin-left: -1rem !important;
  }
  .m-xl-n4 {
    margin: -1.5rem !important;
  }
  .mt-xl-n4,
  .my-xl-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-xl-n4,
  .mx-xl-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-xl-n4,
  .my-xl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-xl-n4,
  .mx-xl-n4 {
    margin-left: -1.5rem !important;
  }
  .m-xl-n5 {
    margin: -3rem !important;
  }
  .mt-xl-n5,
  .my-xl-n5 {
    margin-top: -3rem !important;
  }
  .mr-xl-n5,
  .mx-xl-n5 {
    margin-right: -3rem !important;
  }
  .mb-xl-n5,
  .my-xl-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-xl-n5,
  .mx-xl-n5 {
    margin-left: -3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mt-xl-auto,
  .my-xl-auto {
    margin-top: auto !important;
  }
  .mr-xl-auto,
  .mx-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-auto,
  .my-xl-auto {
    margin-bottom: auto !important;
  }
  .ml-xl-auto,
  .mx-xl-auto {
    margin-left: auto !important;
  }
}
.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  pointer-events: auto;
  content: "";
  background-color: rgba(0, 0, 0, 0);
}

.text-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
}

.text-justify {
  text-align: justify !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-left {
  text-align: left !important;
}

.text-right {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

@media (min-width: 576px) {
  .text-sm-left {
    text-align: left !important;
  }
  .text-sm-right {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .text-md-left {
    text-align: left !important;
  }
  .text-md-right {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .text-lg-left {
    text-align: left !important;
  }
  .text-lg-right {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .text-xl-left {
    text-align: left !important;
  }
  .text-xl-right {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.font-weight-light {
  font-weight: 300 !important;
}

.font-weight-lighter {
  font-weight: lighter !important;
}

.font-weight-normal {
  font-weight: 400 !important;
}

.font-weight-bold {
  font-weight: 700 !important;
}

.font-weight-bolder {
  font-weight: bolder !important;
}

.font-italic {
  font-style: italic !important;
}

.text-white {
  color: #fff !important;
}

.text-primary {
  color: #440099 !important;
}

a.text-primary:hover, a.text-primary:focus {
  color: #22004d !important;
}

.text-secondary {
  color: #6c757d !important;
}

a.text-secondary:hover, a.text-secondary:focus {
  color: #494f54 !important;
}

.text-success {
  color: #28a745 !important;
}

a.text-success:hover, a.text-success:focus {
  color: #19692c !important;
}

.text-info {
  color: #17a2b8 !important;
}

a.text-info:hover, a.text-info:focus {
  color: #0f6674 !important;
}

.text-warning {
  color: #ffc107 !important;
}

a.text-warning:hover, a.text-warning:focus {
  color: #ba8b00 !important;
}

.text-danger {
  color: #dc3545 !important;
}

a.text-danger:hover, a.text-danger:focus {
  color: #a71d2a !important;
}

.text-light {
  color: #f8f9fa !important;
}

a.text-light:hover, a.text-light:focus {
  color: #cbd3da !important;
}

.text-dark {
  color: #343a40 !important;
}

a.text-dark:hover, a.text-dark:focus {
  color: #121416 !important;
}

.text-body {
  color: #212529 !important;
}

.text-muted {
  color: #6c757d !important;
}

.text-black-50 {
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-break {
  word-break: break-word !important;
  word-wrap: break-word !important;
}

.text-reset {
  color: inherit !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

@media print {
  *,
  *::before,
  *::after {
    text-shadow: none !important;
    box-shadow: none !important;
  }
  a:not(.btn) {
    text-decoration: underline;
  }
  abbr[title]::after {
    content: " (" attr(title) ")";
  }
  pre {
    white-space: pre-wrap !important;
  }
  pre,
  blockquote {
    border: 1px solid #adb5bd;
    page-break-inside: avoid;
  }
  tr,
  img {
    page-break-inside: avoid;
  }
  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
  }
  h2,
  h3 {
    page-break-after: avoid;
  }
  @page {
    size: a3;
  }
  body {
    min-width: 992px !important;
  }
  .container {
    min-width: 992px !important;
  }
  .navbar {
    display: none;
  }
  .badge {
    border: 1px solid #000;
  }
  .table {
    border-collapse: collapse !important;
  }
  .table td,
  .table th {
    background-color: #fff !important;
  }
  .table-bordered th,
  .table-bordered td {
    border: 1px solid #dee2e6 !important;
  }
  .table-dark {
    color: inherit;
  }
  .table-dark th,
  .table-dark td,
  .table-dark thead th,
  .table-dark tbody + tbody {
    border-color: #dee2e6;
  }
  .table .thead-dark th {
    color: inherit;
    border-color: #dee2e6;
  }
}
/* MaterialDesignIcons.com */
@font-face {
  font-family: "Material Design Icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
.mdi:before,
.mdi-set {
  display: inline-block;
  font: normal normal normal 24px/1 "Material Design Icons";
  font-size: inherit;
  text-rendering: auto;
  line-height: inherit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.mdi-ab-testing::before {
  content: "\\F01C9";
}

.mdi-abacus::before {
  content: "\\F16E0";
}

.mdi-abjad-arabic::before {
  content: "\\F1328";
}

.mdi-abjad-hebrew::before {
  content: "\\F1329";
}

.mdi-abugida-devanagari::before {
  content: "\\F132A";
}

.mdi-abugida-thai::before {
  content: "\\F132B";
}

.mdi-access-point::before {
  content: "\\F0003";
}

.mdi-access-point-check::before {
  content: "\\F1538";
}

.mdi-access-point-minus::before {
  content: "\\F1539";
}

.mdi-access-point-network::before {
  content: "\\F0002";
}

.mdi-access-point-network-off::before {
  content: "\\F0BE1";
}

.mdi-access-point-off::before {
  content: "\\F1511";
}

.mdi-access-point-plus::before {
  content: "\\F153A";
}

.mdi-access-point-remove::before {
  content: "\\F153B";
}

.mdi-account::before {
  content: "\\F0004";
}

.mdi-account-alert::before {
  content: "\\F0005";
}

.mdi-account-alert-outline::before {
  content: "\\F0B50";
}

.mdi-account-arrow-down::before {
  content: "\\F1868";
}

.mdi-account-arrow-down-outline::before {
  content: "\\F1869";
}

.mdi-account-arrow-left::before {
  content: "\\F0B51";
}

.mdi-account-arrow-left-outline::before {
  content: "\\F0B52";
}

.mdi-account-arrow-right::before {
  content: "\\F0B53";
}

.mdi-account-arrow-right-outline::before {
  content: "\\F0B54";
}

.mdi-account-arrow-up::before {
  content: "\\F1867";
}

.mdi-account-arrow-up-outline::before {
  content: "\\F186A";
}

.mdi-account-badge::before {
  content: "\\F1B0A";
}

.mdi-account-badge-outline::before {
  content: "\\F1B0B";
}

.mdi-account-box::before {
  content: "\\F0006";
}

.mdi-account-box-edit-outline::before {
  content: "\\F1CC8";
}

.mdi-account-box-minus-outline::before {
  content: "\\F1CC9";
}

.mdi-account-box-multiple::before {
  content: "\\F0934";
}

.mdi-account-box-multiple-outline::before {
  content: "\\F100A";
}

.mdi-account-box-outline::before {
  content: "\\F0007";
}

.mdi-account-box-plus-outline::before {
  content: "\\F1CCA";
}

.mdi-account-cancel::before {
  content: "\\F12DF";
}

.mdi-account-cancel-outline::before {
  content: "\\F12E0";
}

.mdi-account-card::before {
  content: "\\F1BA4";
}

.mdi-account-card-outline::before {
  content: "\\F1BA5";
}

.mdi-account-cash::before {
  content: "\\F1097";
}

.mdi-account-cash-outline::before {
  content: "\\F1098";
}

.mdi-account-check::before {
  content: "\\F0008";
}

.mdi-account-check-outline::before {
  content: "\\F0BE2";
}

.mdi-account-child::before {
  content: "\\F0A89";
}

.mdi-account-child-circle::before {
  content: "\\F0A8A";
}

.mdi-account-child-outline::before {
  content: "\\F10C8";
}

.mdi-account-circle::before {
  content: "\\F0009";
}

.mdi-account-circle-outline::before {
  content: "\\F0B55";
}

.mdi-account-clock::before {
  content: "\\F0B56";
}

.mdi-account-clock-outline::before {
  content: "\\F0B57";
}

.mdi-account-cog::before {
  content: "\\F1370";
}

.mdi-account-cog-outline::before {
  content: "\\F1371";
}

.mdi-account-convert::before {
  content: "\\F000A";
}

.mdi-account-convert-outline::before {
  content: "\\F1301";
}

.mdi-account-cowboy-hat::before {
  content: "\\F0E9B";
}

.mdi-account-cowboy-hat-outline::before {
  content: "\\F17F3";
}

.mdi-account-credit-card::before {
  content: "\\F1BA6";
}

.mdi-account-credit-card-outline::before {
  content: "\\F1BA7";
}

.mdi-account-details::before {
  content: "\\F0631";
}

.mdi-account-details-outline::before {
  content: "\\F1372";
}

.mdi-account-edit::before {
  content: "\\F06BC";
}

.mdi-account-edit-outline::before {
  content: "\\F0FFB";
}

.mdi-account-eye::before {
  content: "\\F0420";
}

.mdi-account-eye-outline::before {
  content: "\\F127B";
}

.mdi-account-file::before {
  content: "\\F1CA7";
}

.mdi-account-file-outline::before {
  content: "\\F1CA8";
}

.mdi-account-file-text::before {
  content: "\\F1CA9";
}

.mdi-account-file-text-outline::before {
  content: "\\F1CAA";
}

.mdi-account-filter::before {
  content: "\\F0936";
}

.mdi-account-filter-outline::before {
  content: "\\F0F9D";
}

.mdi-account-group::before {
  content: "\\F0849";
}

.mdi-account-group-outline::before {
  content: "\\F0B58";
}

.mdi-account-hard-hat::before {
  content: "\\F05B5";
}

.mdi-account-hard-hat-outline::before {
  content: "\\F1A1F";
}

.mdi-account-heart::before {
  content: "\\F0899";
}

.mdi-account-heart-outline::before {
  content: "\\F0BE3";
}

.mdi-account-injury::before {
  content: "\\F1815";
}

.mdi-account-injury-outline::before {
  content: "\\F1816";
}

.mdi-account-key::before {
  content: "\\F000B";
}

.mdi-account-key-outline::before {
  content: "\\F0BE4";
}

.mdi-account-lock::before {
  content: "\\F115E";
}

.mdi-account-lock-open::before {
  content: "\\F1960";
}

.mdi-account-lock-open-outline::before {
  content: "\\F1961";
}

.mdi-account-lock-outline::before {
  content: "\\F115F";
}

.mdi-account-minus::before {
  content: "\\F000D";
}

.mdi-account-minus-outline::before {
  content: "\\F0AEC";
}

.mdi-account-multiple::before {
  content: "\\F000E";
}

.mdi-account-multiple-check::before {
  content: "\\F08C5";
}

.mdi-account-multiple-check-outline::before {
  content: "\\F11FE";
}

.mdi-account-multiple-minus::before {
  content: "\\F05D3";
}

.mdi-account-multiple-minus-outline::before {
  content: "\\F0BE5";
}

.mdi-account-multiple-outline::before {
  content: "\\F000F";
}

.mdi-account-multiple-plus::before {
  content: "\\F0010";
}

.mdi-account-multiple-plus-outline::before {
  content: "\\F0800";
}

.mdi-account-multiple-remove::before {
  content: "\\F120A";
}

.mdi-account-multiple-remove-outline::before {
  content: "\\F120B";
}

.mdi-account-music::before {
  content: "\\F0803";
}

.mdi-account-music-outline::before {
  content: "\\F0CE9";
}

.mdi-account-network::before {
  content: "\\F0011";
}

.mdi-account-network-off::before {
  content: "\\F1AF1";
}

.mdi-account-network-off-outline::before {
  content: "\\F1AF2";
}

.mdi-account-network-outline::before {
  content: "\\F0BE6";
}

.mdi-account-off::before {
  content: "\\F0012";
}

.mdi-account-off-outline::before {
  content: "\\F0BE7";
}

.mdi-account-outline::before {
  content: "\\F0013";
}

.mdi-account-plus::before {
  content: "\\F0014";
}

.mdi-account-plus-outline::before {
  content: "\\F0801";
}

.mdi-account-question::before {
  content: "\\F0B59";
}

.mdi-account-question-outline::before {
  content: "\\F0B5A";
}

.mdi-account-reactivate::before {
  content: "\\F152B";
}

.mdi-account-reactivate-outline::before {
  content: "\\F152C";
}

.mdi-account-remove::before {
  content: "\\F0015";
}

.mdi-account-remove-outline::before {
  content: "\\F0AED";
}

.mdi-account-school::before {
  content: "\\F1A20";
}

.mdi-account-school-outline::before {
  content: "\\F1A21";
}

.mdi-account-search::before {
  content: "\\F0016";
}

.mdi-account-search-outline::before {
  content: "\\F0935";
}

.mdi-account-settings::before {
  content: "\\F0630";
}

.mdi-account-settings-outline::before {
  content: "\\F10C9";
}

.mdi-account-star::before {
  content: "\\F0017";
}

.mdi-account-star-outline::before {
  content: "\\F0BE8";
}

.mdi-account-supervisor::before {
  content: "\\F0A8B";
}

.mdi-account-supervisor-circle::before {
  content: "\\F0A8C";
}

.mdi-account-supervisor-circle-outline::before {
  content: "\\F14EC";
}

.mdi-account-supervisor-outline::before {
  content: "\\F112D";
}

.mdi-account-switch::before {
  content: "\\F0019";
}

.mdi-account-switch-outline::before {
  content: "\\F04CB";
}

.mdi-account-sync::before {
  content: "\\F191B";
}

.mdi-account-sync-outline::before {
  content: "\\F191C";
}

.mdi-account-tag::before {
  content: "\\F1C1B";
}

.mdi-account-tag-outline::before {
  content: "\\F1C1C";
}

.mdi-account-tie::before {
  content: "\\F0CE3";
}

.mdi-account-tie-hat::before {
  content: "\\F1898";
}

.mdi-account-tie-hat-outline::before {
  content: "\\F1899";
}

.mdi-account-tie-outline::before {
  content: "\\F10CA";
}

.mdi-account-tie-voice::before {
  content: "\\F1308";
}

.mdi-account-tie-voice-off::before {
  content: "\\F130A";
}

.mdi-account-tie-voice-off-outline::before {
  content: "\\F130B";
}

.mdi-account-tie-voice-outline::before {
  content: "\\F1309";
}

.mdi-account-tie-woman::before {
  content: "\\F1A8C";
}

.mdi-account-voice::before {
  content: "\\F05CB";
}

.mdi-account-voice-off::before {
  content: "\\F0ED4";
}

.mdi-account-wrench::before {
  content: "\\F189A";
}

.mdi-account-wrench-outline::before {
  content: "\\F189B";
}

.mdi-adjust::before {
  content: "\\F001A";
}

.mdi-advertisements::before {
  content: "\\F192A";
}

.mdi-advertisements-off::before {
  content: "\\F192B";
}

.mdi-air-conditioner::before {
  content: "\\F001B";
}

.mdi-air-filter::before {
  content: "\\F0D43";
}

.mdi-air-horn::before {
  content: "\\F0DAC";
}

.mdi-air-humidifier::before {
  content: "\\F1099";
}

.mdi-air-humidifier-off::before {
  content: "\\F1466";
}

.mdi-air-purifier::before {
  content: "\\F0D44";
}

.mdi-air-purifier-off::before {
  content: "\\F1B57";
}

.mdi-airbag::before {
  content: "\\F0BE9";
}

.mdi-airballoon::before {
  content: "\\F001C";
}

.mdi-airballoon-outline::before {
  content: "\\F100B";
}

.mdi-airplane::before {
  content: "\\F001D";
}

.mdi-airplane-alert::before {
  content: "\\F187A";
}

.mdi-airplane-check::before {
  content: "\\F187B";
}

.mdi-airplane-clock::before {
  content: "\\F187C";
}

.mdi-airplane-cog::before {
  content: "\\F187D";
}

.mdi-airplane-edit::before {
  content: "\\F187E";
}

.mdi-airplane-landing::before {
  content: "\\F05D4";
}

.mdi-airplane-marker::before {
  content: "\\F187F";
}

.mdi-airplane-minus::before {
  content: "\\F1880";
}

.mdi-airplane-off::before {
  content: "\\F001E";
}

.mdi-airplane-plus::before {
  content: "\\F1881";
}

.mdi-airplane-remove::before {
  content: "\\F1882";
}

.mdi-airplane-search::before {
  content: "\\F1883";
}

.mdi-airplane-settings::before {
  content: "\\F1884";
}

.mdi-airplane-takeoff::before {
  content: "\\F05D5";
}

.mdi-airport::before {
  content: "\\F084B";
}

.mdi-alarm::before {
  content: "\\F0020";
}

.mdi-alarm-bell::before {
  content: "\\F078E";
}

.mdi-alarm-check::before {
  content: "\\F0021";
}

.mdi-alarm-light::before {
  content: "\\F078F";
}

.mdi-alarm-light-off::before {
  content: "\\F171E";
}

.mdi-alarm-light-off-outline::before {
  content: "\\F171F";
}

.mdi-alarm-light-outline::before {
  content: "\\F0BEA";
}

.mdi-alarm-multiple::before {
  content: "\\F0022";
}

.mdi-alarm-note::before {
  content: "\\F0E71";
}

.mdi-alarm-note-off::before {
  content: "\\F0E72";
}

.mdi-alarm-off::before {
  content: "\\F0023";
}

.mdi-alarm-panel::before {
  content: "\\F15C4";
}

.mdi-alarm-panel-outline::before {
  content: "\\F15C5";
}

.mdi-alarm-plus::before {
  content: "\\F0024";
}

.mdi-alarm-snooze::before {
  content: "\\F068E";
}

.mdi-album::before {
  content: "\\F0025";
}

.mdi-alert::before {
  content: "\\F0026";
}

.mdi-alert-box::before {
  content: "\\F0027";
}

.mdi-alert-box-outline::before {
  content: "\\F0CE4";
}

.mdi-alert-circle::before {
  content: "\\F0028";
}

.mdi-alert-circle-check::before {
  content: "\\F11ED";
}

.mdi-alert-circle-check-outline::before {
  content: "\\F11EE";
}

.mdi-alert-circle-outline::before {
  content: "\\F05D6";
}

.mdi-alert-decagram::before {
  content: "\\F06BD";
}

.mdi-alert-decagram-outline::before {
  content: "\\F0CE5";
}

.mdi-alert-minus::before {
  content: "\\F14BB";
}

.mdi-alert-minus-outline::before {
  content: "\\F14BE";
}

.mdi-alert-octagon::before {
  content: "\\F0029";
}

.mdi-alert-octagon-outline::before {
  content: "\\F0CE6";
}

.mdi-alert-octagram::before {
  content: "\\F0767";
}

.mdi-alert-octagram-outline::before {
  content: "\\F0CE7";
}

.mdi-alert-outline::before {
  content: "\\F002A";
}

.mdi-alert-plus::before {
  content: "\\F14BA";
}

.mdi-alert-plus-outline::before {
  content: "\\F14BD";
}

.mdi-alert-remove::before {
  content: "\\F14BC";
}

.mdi-alert-remove-outline::before {
  content: "\\F14BF";
}

.mdi-alert-rhombus::before {
  content: "\\F11CE";
}

.mdi-alert-rhombus-outline::before {
  content: "\\F11CF";
}

.mdi-alien::before {
  content: "\\F089A";
}

.mdi-alien-outline::before {
  content: "\\F10CB";
}

.mdi-align-horizontal-center::before {
  content: "\\F11C3";
}

.mdi-align-horizontal-distribute::before {
  content: "\\F1962";
}

.mdi-align-horizontal-left::before {
  content: "\\F11C2";
}

.mdi-align-horizontal-right::before {
  content: "\\F11C4";
}

.mdi-align-vertical-bottom::before {
  content: "\\F11C5";
}

.mdi-align-vertical-center::before {
  content: "\\F11C6";
}

.mdi-align-vertical-distribute::before {
  content: "\\F1963";
}

.mdi-align-vertical-top::before {
  content: "\\F11C7";
}

.mdi-all-inclusive::before {
  content: "\\F06BE";
}

.mdi-all-inclusive-box::before {
  content: "\\F188D";
}

.mdi-all-inclusive-box-outline::before {
  content: "\\F188E";
}

.mdi-allergy::before {
  content: "\\F1258";
}

.mdi-alpha::before {
  content: "\\F002B";
}

.mdi-alpha-a::before {
  content: "\\F0AEE";
}

.mdi-alpha-a-box::before {
  content: "\\F0B08";
}

.mdi-alpha-a-box-outline::before {
  content: "\\F0BEB";
}

.mdi-alpha-a-circle::before {
  content: "\\F0BEC";
}

.mdi-alpha-a-circle-outline::before {
  content: "\\F0BED";
}

.mdi-alpha-b::before {
  content: "\\F0AEF";
}

.mdi-alpha-b-box::before {
  content: "\\F0B09";
}

.mdi-alpha-b-box-outline::before {
  content: "\\F0BEE";
}

.mdi-alpha-b-circle::before {
  content: "\\F0BEF";
}

.mdi-alpha-b-circle-outline::before {
  content: "\\F0BF0";
}

.mdi-alpha-c::before {
  content: "\\F0AF0";
}

.mdi-alpha-c-box::before {
  content: "\\F0B0A";
}

.mdi-alpha-c-box-outline::before {
  content: "\\F0BF1";
}

.mdi-alpha-c-circle::before {
  content: "\\F0BF2";
}

.mdi-alpha-c-circle-outline::before {
  content: "\\F0BF3";
}

.mdi-alpha-d::before {
  content: "\\F0AF1";
}

.mdi-alpha-d-box::before {
  content: "\\F0B0B";
}

.mdi-alpha-d-box-outline::before {
  content: "\\F0BF4";
}

.mdi-alpha-d-circle::before {
  content: "\\F0BF5";
}

.mdi-alpha-d-circle-outline::before {
  content: "\\F0BF6";
}

.mdi-alpha-e::before {
  content: "\\F0AF2";
}

.mdi-alpha-e-box::before {
  content: "\\F0B0C";
}

.mdi-alpha-e-box-outline::before {
  content: "\\F0BF7";
}

.mdi-alpha-e-circle::before {
  content: "\\F0BF8";
}

.mdi-alpha-e-circle-outline::before {
  content: "\\F0BF9";
}

.mdi-alpha-f::before {
  content: "\\F0AF3";
}

.mdi-alpha-f-box::before {
  content: "\\F0B0D";
}

.mdi-alpha-f-box-outline::before {
  content: "\\F0BFA";
}

.mdi-alpha-f-circle::before {
  content: "\\F0BFB";
}

.mdi-alpha-f-circle-outline::before {
  content: "\\F0BFC";
}

.mdi-alpha-g::before {
  content: "\\F0AF4";
}

.mdi-alpha-g-box::before {
  content: "\\F0B0E";
}

.mdi-alpha-g-box-outline::before {
  content: "\\F0BFD";
}

.mdi-alpha-g-circle::before {
  content: "\\F0BFE";
}

.mdi-alpha-g-circle-outline::before {
  content: "\\F0BFF";
}

.mdi-alpha-h::before {
  content: "\\F0AF5";
}

.mdi-alpha-h-box::before {
  content: "\\F0B0F";
}

.mdi-alpha-h-box-outline::before {
  content: "\\F0C00";
}

.mdi-alpha-h-circle::before {
  content: "\\F0C01";
}

.mdi-alpha-h-circle-outline::before {
  content: "\\F0C02";
}

.mdi-alpha-i::before {
  content: "\\F0AF6";
}

.mdi-alpha-i-box::before {
  content: "\\F0B10";
}

.mdi-alpha-i-box-outline::before {
  content: "\\F0C03";
}

.mdi-alpha-i-circle::before {
  content: "\\F0C04";
}

.mdi-alpha-i-circle-outline::before {
  content: "\\F0C05";
}

.mdi-alpha-j::before {
  content: "\\F0AF7";
}

.mdi-alpha-j-box::before {
  content: "\\F0B11";
}

.mdi-alpha-j-box-outline::before {
  content: "\\F0C06";
}

.mdi-alpha-j-circle::before {
  content: "\\F0C07";
}

.mdi-alpha-j-circle-outline::before {
  content: "\\F0C08";
}

.mdi-alpha-k::before {
  content: "\\F0AF8";
}

.mdi-alpha-k-box::before {
  content: "\\F0B12";
}

.mdi-alpha-k-box-outline::before {
  content: "\\F0C09";
}

.mdi-alpha-k-circle::before {
  content: "\\F0C0A";
}

.mdi-alpha-k-circle-outline::before {
  content: "\\F0C0B";
}

.mdi-alpha-l::before {
  content: "\\F0AF9";
}

.mdi-alpha-l-box::before {
  content: "\\F0B13";
}

.mdi-alpha-l-box-outline::before {
  content: "\\F0C0C";
}

.mdi-alpha-l-circle::before {
  content: "\\F0C0D";
}

.mdi-alpha-l-circle-outline::before {
  content: "\\F0C0E";
}

.mdi-alpha-m::before {
  content: "\\F0AFA";
}

.mdi-alpha-m-box::before {
  content: "\\F0B14";
}

.mdi-alpha-m-box-outline::before {
  content: "\\F0C0F";
}

.mdi-alpha-m-circle::before {
  content: "\\F0C10";
}

.mdi-alpha-m-circle-outline::before {
  content: "\\F0C11";
}

.mdi-alpha-n::before {
  content: "\\F0AFB";
}

.mdi-alpha-n-box::before {
  content: "\\F0B15";
}

.mdi-alpha-n-box-outline::before {
  content: "\\F0C12";
}

.mdi-alpha-n-circle::before {
  content: "\\F0C13";
}

.mdi-alpha-n-circle-outline::before {
  content: "\\F0C14";
}

.mdi-alpha-o::before {
  content: "\\F0AFC";
}

.mdi-alpha-o-box::before {
  content: "\\F0B16";
}

.mdi-alpha-o-box-outline::before {
  content: "\\F0C15";
}

.mdi-alpha-o-circle::before {
  content: "\\F0C16";
}

.mdi-alpha-o-circle-outline::before {
  content: "\\F0C17";
}

.mdi-alpha-p::before {
  content: "\\F0AFD";
}

.mdi-alpha-p-box::before {
  content: "\\F0B17";
}

.mdi-alpha-p-box-outline::before {
  content: "\\F0C18";
}

.mdi-alpha-p-circle::before {
  content: "\\F0C19";
}

.mdi-alpha-p-circle-outline::before {
  content: "\\F0C1A";
}

.mdi-alpha-q::before {
  content: "\\F0AFE";
}

.mdi-alpha-q-box::before {
  content: "\\F0B18";
}

.mdi-alpha-q-box-outline::before {
  content: "\\F0C1B";
}

.mdi-alpha-q-circle::before {
  content: "\\F0C1C";
}

.mdi-alpha-q-circle-outline::before {
  content: "\\F0C1D";
}

.mdi-alpha-r::before {
  content: "\\F0AFF";
}

.mdi-alpha-r-box::before {
  content: "\\F0B19";
}

.mdi-alpha-r-box-outline::before {
  content: "\\F0C1E";
}

.mdi-alpha-r-circle::before {
  content: "\\F0C1F";
}

.mdi-alpha-r-circle-outline::before {
  content: "\\F0C20";
}

.mdi-alpha-s::before {
  content: "\\F0B00";
}

.mdi-alpha-s-box::before {
  content: "\\F0B1A";
}

.mdi-alpha-s-box-outline::before {
  content: "\\F0C21";
}

.mdi-alpha-s-circle::before {
  content: "\\F0C22";
}

.mdi-alpha-s-circle-outline::before {
  content: "\\F0C23";
}

.mdi-alpha-t::before {
  content: "\\F0B01";
}

.mdi-alpha-t-box::before {
  content: "\\F0B1B";
}

.mdi-alpha-t-box-outline::before {
  content: "\\F0C24";
}

.mdi-alpha-t-circle::before {
  content: "\\F0C25";
}

.mdi-alpha-t-circle-outline::before {
  content: "\\F0C26";
}

.mdi-alpha-u::before {
  content: "\\F0B02";
}

.mdi-alpha-u-box::before {
  content: "\\F0B1C";
}

.mdi-alpha-u-box-outline::before {
  content: "\\F0C27";
}

.mdi-alpha-u-circle::before {
  content: "\\F0C28";
}

.mdi-alpha-u-circle-outline::before {
  content: "\\F0C29";
}

.mdi-alpha-v::before {
  content: "\\F0B03";
}

.mdi-alpha-v-box::before {
  content: "\\F0B1D";
}

.mdi-alpha-v-box-outline::before {
  content: "\\F0C2A";
}

.mdi-alpha-v-circle::before {
  content: "\\F0C2B";
}

.mdi-alpha-v-circle-outline::before {
  content: "\\F0C2C";
}

.mdi-alpha-w::before {
  content: "\\F0B04";
}

.mdi-alpha-w-box::before {
  content: "\\F0B1E";
}

.mdi-alpha-w-box-outline::before {
  content: "\\F0C2D";
}

.mdi-alpha-w-circle::before {
  content: "\\F0C2E";
}

.mdi-alpha-w-circle-outline::before {
  content: "\\F0C2F";
}

.mdi-alpha-x::before {
  content: "\\F0B05";
}

.mdi-alpha-x-box::before {
  content: "\\F0B1F";
}

.mdi-alpha-x-box-outline::before {
  content: "\\F0C30";
}

.mdi-alpha-x-circle::before {
  content: "\\F0C31";
}

.mdi-alpha-x-circle-outline::before {
  content: "\\F0C32";
}

.mdi-alpha-y::before {
  content: "\\F0B06";
}

.mdi-alpha-y-box::before {
  content: "\\F0B20";
}

.mdi-alpha-y-box-outline::before {
  content: "\\F0C33";
}

.mdi-alpha-y-circle::before {
  content: "\\F0C34";
}

.mdi-alpha-y-circle-outline::before {
  content: "\\F0C35";
}

.mdi-alpha-z::before {
  content: "\\F0B07";
}

.mdi-alpha-z-box::before {
  content: "\\F0B21";
}

.mdi-alpha-z-box-outline::before {
  content: "\\F0C36";
}

.mdi-alpha-z-circle::before {
  content: "\\F0C37";
}

.mdi-alpha-z-circle-outline::before {
  content: "\\F0C38";
}

.mdi-alphabet-aurebesh::before {
  content: "\\F132C";
}

.mdi-alphabet-cyrillic::before {
  content: "\\F132D";
}

.mdi-alphabet-greek::before {
  content: "\\F132E";
}

.mdi-alphabet-latin::before {
  content: "\\F132F";
}

.mdi-alphabet-piqad::before {
  content: "\\F1330";
}

.mdi-alphabet-tengwar::before {
  content: "\\F1337";
}

.mdi-alphabetical::before {
  content: "\\F002C";
}

.mdi-alphabetical-off::before {
  content: "\\F100C";
}

.mdi-alphabetical-variant::before {
  content: "\\F100D";
}

.mdi-alphabetical-variant-off::before {
  content: "\\F100E";
}

.mdi-altimeter::before {
  content: "\\F05D7";
}

.mdi-ambulance::before {
  content: "\\F002F";
}

.mdi-ammunition::before {
  content: "\\F0CE8";
}

.mdi-ampersand::before {
  content: "\\F0A8D";
}

.mdi-amplifier::before {
  content: "\\F0030";
}

.mdi-amplifier-off::before {
  content: "\\F11B5";
}

.mdi-anchor::before {
  content: "\\F0031";
}

.mdi-android::before {
  content: "\\F0032";
}

.mdi-android-studio::before {
  content: "\\F0034";
}

.mdi-angle-acute::before {
  content: "\\F0937";
}

.mdi-angle-obtuse::before {
  content: "\\F0938";
}

.mdi-angle-right::before {
  content: "\\F0939";
}

.mdi-angular::before {
  content: "\\F06B2";
}

.mdi-angularjs::before {
  content: "\\F06BF";
}

.mdi-animation::before {
  content: "\\F05D8";
}

.mdi-animation-outline::before {
  content: "\\F0A8F";
}

.mdi-animation-play::before {
  content: "\\F093A";
}

.mdi-animation-play-outline::before {
  content: "\\F0A90";
}

.mdi-ansible::before {
  content: "\\F109A";
}

.mdi-antenna::before {
  content: "\\F1119";
}

.mdi-anvil::before {
  content: "\\F089B";
}

.mdi-apache-kafka::before {
  content: "\\F100F";
}

.mdi-api::before {
  content: "\\F109B";
}

.mdi-api-off::before {
  content: "\\F1257";
}

.mdi-apple::before {
  content: "\\F0035";
}

.mdi-apple-finder::before {
  content: "\\F0036";
}

.mdi-apple-icloud::before {
  content: "\\F0038";
}

.mdi-apple-ios::before {
  content: "\\F0037";
}

.mdi-apple-keyboard-caps::before {
  content: "\\F0632";
}

.mdi-apple-keyboard-command::before {
  content: "\\F0633";
}

.mdi-apple-keyboard-control::before {
  content: "\\F0634";
}

.mdi-apple-keyboard-option::before {
  content: "\\F0635";
}

.mdi-apple-keyboard-shift::before {
  content: "\\F0636";
}

.mdi-apple-safari::before {
  content: "\\F0039";
}

.mdi-application::before {
  content: "\\F08C6";
}

.mdi-application-array::before {
  content: "\\F10F5";
}

.mdi-application-array-outline::before {
  content: "\\F10F6";
}

.mdi-application-braces::before {
  content: "\\F10F7";
}

.mdi-application-braces-outline::before {
  content: "\\F10F8";
}

.mdi-application-brackets::before {
  content: "\\F0C8B";
}

.mdi-application-brackets-outline::before {
  content: "\\F0C8C";
}

.mdi-application-cog::before {
  content: "\\F0675";
}

.mdi-application-cog-outline::before {
  content: "\\F1577";
}

.mdi-application-edit::before {
  content: "\\F00AE";
}

.mdi-application-edit-outline::before {
  content: "\\F0619";
}

.mdi-application-export::before {
  content: "\\F0DAD";
}

.mdi-application-import::before {
  content: "\\F0DAE";
}

.mdi-application-outline::before {
  content: "\\F0614";
}

.mdi-application-parentheses::before {
  content: "\\F10F9";
}

.mdi-application-parentheses-outline::before {
  content: "\\F10FA";
}

.mdi-application-settings::before {
  content: "\\F0B60";
}

.mdi-application-settings-outline::before {
  content: "\\F1555";
}

.mdi-application-variable::before {
  content: "\\F10FB";
}

.mdi-application-variable-outline::before {
  content: "\\F10FC";
}

.mdi-approximately-equal::before {
  content: "\\F0F9E";
}

.mdi-approximately-equal-box::before {
  content: "\\F0F9F";
}

.mdi-apps::before {
  content: "\\F003B";
}

.mdi-apps-box::before {
  content: "\\F0D46";
}

.mdi-arch::before {
  content: "\\F08C7";
}

.mdi-archive::before {
  content: "\\F003C";
}

.mdi-archive-alert::before {
  content: "\\F14FD";
}

.mdi-archive-alert-outline::before {
  content: "\\F14FE";
}

.mdi-archive-arrow-down::before {
  content: "\\F1259";
}

.mdi-archive-arrow-down-outline::before {
  content: "\\F125A";
}

.mdi-archive-arrow-up::before {
  content: "\\F125B";
}

.mdi-archive-arrow-up-outline::before {
  content: "\\F125C";
}

.mdi-archive-cancel::before {
  content: "\\F174B";
}

.mdi-archive-cancel-outline::before {
  content: "\\F174C";
}

.mdi-archive-check::before {
  content: "\\F174D";
}

.mdi-archive-check-outline::before {
  content: "\\F174E";
}

.mdi-archive-clock::before {
  content: "\\F174F";
}

.mdi-archive-clock-outline::before {
  content: "\\F1750";
}

.mdi-archive-cog::before {
  content: "\\F1751";
}

.mdi-archive-cog-outline::before {
  content: "\\F1752";
}

.mdi-archive-edit::before {
  content: "\\F1753";
}

.mdi-archive-edit-outline::before {
  content: "\\F1754";
}

.mdi-archive-eye::before {
  content: "\\F1755";
}

.mdi-archive-eye-outline::before {
  content: "\\F1756";
}

.mdi-archive-lock::before {
  content: "\\F1757";
}

.mdi-archive-lock-open::before {
  content: "\\F1758";
}

.mdi-archive-lock-open-outline::before {
  content: "\\F1759";
}

.mdi-archive-lock-outline::before {
  content: "\\F175A";
}

.mdi-archive-marker::before {
  content: "\\F175B";
}

.mdi-archive-marker-outline::before {
  content: "\\F175C";
}

.mdi-archive-minus::before {
  content: "\\F175D";
}

.mdi-archive-minus-outline::before {
  content: "\\F175E";
}

.mdi-archive-music::before {
  content: "\\F175F";
}

.mdi-archive-music-outline::before {
  content: "\\F1760";
}

.mdi-archive-off::before {
  content: "\\F1761";
}

.mdi-archive-off-outline::before {
  content: "\\F1762";
}

.mdi-archive-outline::before {
  content: "\\F120E";
}

.mdi-archive-plus::before {
  content: "\\F1763";
}

.mdi-archive-plus-outline::before {
  content: "\\F1764";
}

.mdi-archive-refresh::before {
  content: "\\F1765";
}

.mdi-archive-refresh-outline::before {
  content: "\\F1766";
}

.mdi-archive-remove::before {
  content: "\\F1767";
}

.mdi-archive-remove-outline::before {
  content: "\\F1768";
}

.mdi-archive-search::before {
  content: "\\F1769";
}

.mdi-archive-search-outline::before {
  content: "\\F176A";
}

.mdi-archive-settings::before {
  content: "\\F176B";
}

.mdi-archive-settings-outline::before {
  content: "\\F176C";
}

.mdi-archive-star::before {
  content: "\\F176D";
}

.mdi-archive-star-outline::before {
  content: "\\F176E";
}

.mdi-archive-sync::before {
  content: "\\F176F";
}

.mdi-archive-sync-outline::before {
  content: "\\F1770";
}

.mdi-arm-flex::before {
  content: "\\F0FD7";
}

.mdi-arm-flex-outline::before {
  content: "\\F0FD6";
}

.mdi-arrange-bring-forward::before {
  content: "\\F003D";
}

.mdi-arrange-bring-to-front::before {
  content: "\\F003E";
}

.mdi-arrange-send-backward::before {
  content: "\\F003F";
}

.mdi-arrange-send-to-back::before {
  content: "\\F0040";
}

.mdi-arrow-all::before {
  content: "\\F0041";
}

.mdi-arrow-bottom-left::before {
  content: "\\F0042";
}

.mdi-arrow-bottom-left-bold-box::before {
  content: "\\F1964";
}

.mdi-arrow-bottom-left-bold-box-outline::before {
  content: "\\F1965";
}

.mdi-arrow-bottom-left-bold-outline::before {
  content: "\\F09B7";
}

.mdi-arrow-bottom-left-thick::before {
  content: "\\F09B8";
}

.mdi-arrow-bottom-left-thin::before {
  content: "\\F19B6";
}

.mdi-arrow-bottom-left-thin-circle-outline::before {
  content: "\\F1596";
}

.mdi-arrow-bottom-right::before {
  content: "\\F0043";
}

.mdi-arrow-bottom-right-bold-box::before {
  content: "\\F1966";
}

.mdi-arrow-bottom-right-bold-box-outline::before {
  content: "\\F1967";
}

.mdi-arrow-bottom-right-bold-outline::before {
  content: "\\F09B9";
}

.mdi-arrow-bottom-right-thick::before {
  content: "\\F09BA";
}

.mdi-arrow-bottom-right-thin::before {
  content: "\\F19B7";
}

.mdi-arrow-bottom-right-thin-circle-outline::before {
  content: "\\F1595";
}

.mdi-arrow-collapse::before {
  content: "\\F0615";
}

.mdi-arrow-collapse-all::before {
  content: "\\F0044";
}

.mdi-arrow-collapse-down::before {
  content: "\\F0792";
}

.mdi-arrow-collapse-horizontal::before {
  content: "\\F084C";
}

.mdi-arrow-collapse-left::before {
  content: "\\F0793";
}

.mdi-arrow-collapse-right::before {
  content: "\\F0794";
}

.mdi-arrow-collapse-up::before {
  content: "\\F0795";
}

.mdi-arrow-collapse-vertical::before {
  content: "\\F084D";
}

.mdi-arrow-decision::before {
  content: "\\F09BB";
}

.mdi-arrow-decision-auto::before {
  content: "\\F09BC";
}

.mdi-arrow-decision-auto-outline::before {
  content: "\\F09BD";
}

.mdi-arrow-decision-outline::before {
  content: "\\F09BE";
}

.mdi-arrow-down::before {
  content: "\\F0045";
}

.mdi-arrow-down-bold::before {
  content: "\\F072E";
}

.mdi-arrow-down-bold-box::before {
  content: "\\F072F";
}

.mdi-arrow-down-bold-box-outline::before {
  content: "\\F0730";
}

.mdi-arrow-down-bold-circle::before {
  content: "\\F0047";
}

.mdi-arrow-down-bold-circle-outline::before {
  content: "\\F0048";
}

.mdi-arrow-down-bold-hexagon-outline::before {
  content: "\\F0049";
}

.mdi-arrow-down-bold-outline::before {
  content: "\\F09BF";
}

.mdi-arrow-down-box::before {
  content: "\\F06C0";
}

.mdi-arrow-down-circle::before {
  content: "\\F0CDB";
}

.mdi-arrow-down-circle-outline::before {
  content: "\\F0CDC";
}

.mdi-arrow-down-drop-circle::before {
  content: "\\F004A";
}

.mdi-arrow-down-drop-circle-outline::before {
  content: "\\F004B";
}

.mdi-arrow-down-left::before {
  content: "\\F17A1";
}

.mdi-arrow-down-left-bold::before {
  content: "\\F17A2";
}

.mdi-arrow-down-right::before {
  content: "\\F17A3";
}

.mdi-arrow-down-right-bold::before {
  content: "\\F17A4";
}

.mdi-arrow-down-thick::before {
  content: "\\F0046";
}

.mdi-arrow-down-thin::before {
  content: "\\F19B3";
}

.mdi-arrow-down-thin-circle-outline::before {
  content: "\\F1599";
}

.mdi-arrow-expand::before {
  content: "\\F0616";
}

.mdi-arrow-expand-all::before {
  content: "\\F004C";
}

.mdi-arrow-expand-down::before {
  content: "\\F0796";
}

.mdi-arrow-expand-horizontal::before {
  content: "\\F084E";
}

.mdi-arrow-expand-left::before {
  content: "\\F0797";
}

.mdi-arrow-expand-right::before {
  content: "\\F0798";
}

.mdi-arrow-expand-up::before {
  content: "\\F0799";
}

.mdi-arrow-expand-vertical::before {
  content: "\\F084F";
}

.mdi-arrow-horizontal-lock::before {
  content: "\\F115B";
}

.mdi-arrow-left::before {
  content: "\\F004D";
}

.mdi-arrow-left-bold::before {
  content: "\\F0731";
}

.mdi-arrow-left-bold-box::before {
  content: "\\F0732";
}

.mdi-arrow-left-bold-box-outline::before {
  content: "\\F0733";
}

.mdi-arrow-left-bold-circle::before {
  content: "\\F004F";
}

.mdi-arrow-left-bold-circle-outline::before {
  content: "\\F0050";
}

.mdi-arrow-left-bold-hexagon-outline::before {
  content: "\\F0051";
}

.mdi-arrow-left-bold-outline::before {
  content: "\\F09C0";
}

.mdi-arrow-left-bottom::before {
  content: "\\F17A5";
}

.mdi-arrow-left-bottom-bold::before {
  content: "\\F17A6";
}

.mdi-arrow-left-box::before {
  content: "\\F06C1";
}

.mdi-arrow-left-circle::before {
  content: "\\F0CDD";
}

.mdi-arrow-left-circle-outline::before {
  content: "\\F0CDE";
}

.mdi-arrow-left-drop-circle::before {
  content: "\\F0052";
}

.mdi-arrow-left-drop-circle-outline::before {
  content: "\\F0053";
}

.mdi-arrow-left-right::before {
  content: "\\F0E73";
}

.mdi-arrow-left-right-bold::before {
  content: "\\F0E74";
}

.mdi-arrow-left-right-bold-outline::before {
  content: "\\F09C1";
}

.mdi-arrow-left-thick::before {
  content: "\\F004E";
}

.mdi-arrow-left-thin::before {
  content: "\\F19B1";
}

.mdi-arrow-left-thin-circle-outline::before {
  content: "\\F159A";
}

.mdi-arrow-left-top::before {
  content: "\\F17A7";
}

.mdi-arrow-left-top-bold::before {
  content: "\\F17A8";
}

.mdi-arrow-oscillating::before {
  content: "\\F1C91";
}

.mdi-arrow-oscillating-off::before {
  content: "\\F1C92";
}

.mdi-arrow-projectile::before {
  content: "\\F1840";
}

.mdi-arrow-projectile-multiple::before {
  content: "\\F183F";
}

.mdi-arrow-right::before {
  content: "\\F0054";
}

.mdi-arrow-right-bold::before {
  content: "\\F0734";
}

.mdi-arrow-right-bold-box::before {
  content: "\\F0735";
}

.mdi-arrow-right-bold-box-outline::before {
  content: "\\F0736";
}

.mdi-arrow-right-bold-circle::before {
  content: "\\F0056";
}

.mdi-arrow-right-bold-circle-outline::before {
  content: "\\F0057";
}

.mdi-arrow-right-bold-hexagon-outline::before {
  content: "\\F0058";
}

.mdi-arrow-right-bold-outline::before {
  content: "\\F09C2";
}

.mdi-arrow-right-bottom::before {
  content: "\\F17A9";
}

.mdi-arrow-right-bottom-bold::before {
  content: "\\F17AA";
}

.mdi-arrow-right-box::before {
  content: "\\F06C2";
}

.mdi-arrow-right-circle::before {
  content: "\\F0CDF";
}

.mdi-arrow-right-circle-outline::before {
  content: "\\F0CE0";
}

.mdi-arrow-right-drop-circle::before {
  content: "\\F0059";
}

.mdi-arrow-right-drop-circle-outline::before {
  content: "\\F005A";
}

.mdi-arrow-right-thick::before {
  content: "\\F0055";
}

.mdi-arrow-right-thin::before {
  content: "\\F19B0";
}

.mdi-arrow-right-thin-circle-outline::before {
  content: "\\F1598";
}

.mdi-arrow-right-top::before {
  content: "\\F17AB";
}

.mdi-arrow-right-top-bold::before {
  content: "\\F17AC";
}

.mdi-arrow-split-horizontal::before {
  content: "\\F093B";
}

.mdi-arrow-split-vertical::before {
  content: "\\F093C";
}

.mdi-arrow-top-left::before {
  content: "\\F005B";
}

.mdi-arrow-top-left-bold-box::before {
  content: "\\F1968";
}

.mdi-arrow-top-left-bold-box-outline::before {
  content: "\\F1969";
}

.mdi-arrow-top-left-bold-outline::before {
  content: "\\F09C3";
}

.mdi-arrow-top-left-bottom-right::before {
  content: "\\F0E75";
}

.mdi-arrow-top-left-bottom-right-bold::before {
  content: "\\F0E76";
}

.mdi-arrow-top-left-thick::before {
  content: "\\F09C4";
}

.mdi-arrow-top-left-thin::before {
  content: "\\F19B5";
}

.mdi-arrow-top-left-thin-circle-outline::before {
  content: "\\F1593";
}

.mdi-arrow-top-right::before {
  content: "\\F005C";
}

.mdi-arrow-top-right-bold-box::before {
  content: "\\F196A";
}

.mdi-arrow-top-right-bold-box-outline::before {
  content: "\\F196B";
}

.mdi-arrow-top-right-bold-outline::before {
  content: "\\F09C5";
}

.mdi-arrow-top-right-bottom-left::before {
  content: "\\F0E77";
}

.mdi-arrow-top-right-bottom-left-bold::before {
  content: "\\F0E78";
}

.mdi-arrow-top-right-thick::before {
  content: "\\F09C6";
}

.mdi-arrow-top-right-thin::before {
  content: "\\F19B4";
}

.mdi-arrow-top-right-thin-circle-outline::before {
  content: "\\F1594";
}

.mdi-arrow-u-down-left::before {
  content: "\\F17AD";
}

.mdi-arrow-u-down-left-bold::before {
  content: "\\F17AE";
}

.mdi-arrow-u-down-right::before {
  content: "\\F17AF";
}

.mdi-arrow-u-down-right-bold::before {
  content: "\\F17B0";
}

.mdi-arrow-u-left-bottom::before {
  content: "\\F17B1";
}

.mdi-arrow-u-left-bottom-bold::before {
  content: "\\F17B2";
}

.mdi-arrow-u-left-top::before {
  content: "\\F17B3";
}

.mdi-arrow-u-left-top-bold::before {
  content: "\\F17B4";
}

.mdi-arrow-u-right-bottom::before {
  content: "\\F17B5";
}

.mdi-arrow-u-right-bottom-bold::before {
  content: "\\F17B6";
}

.mdi-arrow-u-right-top::before {
  content: "\\F17B7";
}

.mdi-arrow-u-right-top-bold::before {
  content: "\\F17B8";
}

.mdi-arrow-u-up-left::before {
  content: "\\F17B9";
}

.mdi-arrow-u-up-left-bold::before {
  content: "\\F17BA";
}

.mdi-arrow-u-up-right::before {
  content: "\\F17BB";
}

.mdi-arrow-u-up-right-bold::before {
  content: "\\F17BC";
}

.mdi-arrow-up::before {
  content: "\\F005D";
}

.mdi-arrow-up-bold::before {
  content: "\\F0737";
}

.mdi-arrow-up-bold-box::before {
  content: "\\F0738";
}

.mdi-arrow-up-bold-box-outline::before {
  content: "\\F0739";
}

.mdi-arrow-up-bold-circle::before {
  content: "\\F005F";
}

.mdi-arrow-up-bold-circle-outline::before {
  content: "\\F0060";
}

.mdi-arrow-up-bold-hexagon-outline::before {
  content: "\\F0061";
}

.mdi-arrow-up-bold-outline::before {
  content: "\\F09C7";
}

.mdi-arrow-up-box::before {
  content: "\\F06C3";
}

.mdi-arrow-up-circle::before {
  content: "\\F0CE1";
}

.mdi-arrow-up-circle-outline::before {
  content: "\\F0CE2";
}

.mdi-arrow-up-down::before {
  content: "\\F0E79";
}

.mdi-arrow-up-down-bold::before {
  content: "\\F0E7A";
}

.mdi-arrow-up-down-bold-outline::before {
  content: "\\F09C8";
}

.mdi-arrow-up-drop-circle::before {
  content: "\\F0062";
}

.mdi-arrow-up-drop-circle-outline::before {
  content: "\\F0063";
}

.mdi-arrow-up-left::before {
  content: "\\F17BD";
}

.mdi-arrow-up-left-bold::before {
  content: "\\F17BE";
}

.mdi-arrow-up-right::before {
  content: "\\F17BF";
}

.mdi-arrow-up-right-bold::before {
  content: "\\F17C0";
}

.mdi-arrow-up-thick::before {
  content: "\\F005E";
}

.mdi-arrow-up-thin::before {
  content: "\\F19B2";
}

.mdi-arrow-up-thin-circle-outline::before {
  content: "\\F1597";
}

.mdi-arrow-vertical-lock::before {
  content: "\\F115C";
}

.mdi-artboard::before {
  content: "\\F1B9A";
}

.mdi-artstation::before {
  content: "\\F0B5B";
}

.mdi-aspect-ratio::before {
  content: "\\F0A24";
}

.mdi-assistant::before {
  content: "\\F0064";
}

.mdi-asterisk::before {
  content: "\\F06C4";
}

.mdi-asterisk-circle-outline::before {
  content: "\\F1A27";
}

.mdi-at::before {
  content: "\\F0065";
}

.mdi-atlassian::before {
  content: "\\F0804";
}

.mdi-atm::before {
  content: "\\F0D47";
}

.mdi-atom::before {
  content: "\\F0768";
}

.mdi-atom-variant::before {
  content: "\\F0E7B";
}

.mdi-attachment::before {
  content: "\\F0066";
}

.mdi-attachment-check::before {
  content: "\\F1AC1";
}

.mdi-attachment-lock::before {
  content: "\\F19C4";
}

.mdi-attachment-minus::before {
  content: "\\F1AC2";
}

.mdi-attachment-off::before {
  content: "\\F1AC3";
}

.mdi-attachment-plus::before {
  content: "\\F1AC4";
}

.mdi-attachment-remove::before {
  content: "\\F1AC5";
}

.mdi-atv::before {
  content: "\\F1B70";
}

.mdi-audio-input-rca::before {
  content: "\\F186B";
}

.mdi-audio-input-stereo-minijack::before {
  content: "\\F186C";
}

.mdi-audio-input-xlr::before {
  content: "\\F186D";
}

.mdi-audio-video::before {
  content: "\\F093D";
}

.mdi-audio-video-off::before {
  content: "\\F11B6";
}

.mdi-augmented-reality::before {
  content: "\\F0850";
}

.mdi-aurora::before {
  content: "\\F1BB9";
}

.mdi-auto-download::before {
  content: "\\F137E";
}

.mdi-auto-fix::before {
  content: "\\F0068";
}

.mdi-auto-mode::before {
  content: "\\F1C20";
}

.mdi-auto-upload::before {
  content: "\\F0069";
}

.mdi-autorenew::before {
  content: "\\F006A";
}

.mdi-autorenew-off::before {
  content: "\\F19E7";
}

.mdi-av-timer::before {
  content: "\\F006B";
}

.mdi-awning::before {
  content: "\\F1B87";
}

.mdi-awning-outline::before {
  content: "\\F1B88";
}

.mdi-aws::before {
  content: "\\F0E0F";
}

.mdi-axe::before {
  content: "\\F08C8";
}

.mdi-axe-battle::before {
  content: "\\F1842";
}

.mdi-axis::before {
  content: "\\F0D48";
}

.mdi-axis-arrow::before {
  content: "\\F0D49";
}

.mdi-axis-arrow-info::before {
  content: "\\F140E";
}

.mdi-axis-arrow-lock::before {
  content: "\\F0D4A";
}

.mdi-axis-lock::before {
  content: "\\F0D4B";
}

.mdi-axis-x-arrow::before {
  content: "\\F0D4C";
}

.mdi-axis-x-arrow-lock::before {
  content: "\\F0D4D";
}

.mdi-axis-x-rotate-clockwise::before {
  content: "\\F0D4E";
}

.mdi-axis-x-rotate-counterclockwise::before {
  content: "\\F0D4F";
}

.mdi-axis-x-y-arrow-lock::before {
  content: "\\F0D50";
}

.mdi-axis-y-arrow::before {
  content: "\\F0D51";
}

.mdi-axis-y-arrow-lock::before {
  content: "\\F0D52";
}

.mdi-axis-y-rotate-clockwise::before {
  content: "\\F0D53";
}

.mdi-axis-y-rotate-counterclockwise::before {
  content: "\\F0D54";
}

.mdi-axis-z-arrow::before {
  content: "\\F0D55";
}

.mdi-axis-z-arrow-lock::before {
  content: "\\F0D56";
}

.mdi-axis-z-rotate-clockwise::before {
  content: "\\F0D57";
}

.mdi-axis-z-rotate-counterclockwise::before {
  content: "\\F0D58";
}

.mdi-babel::before {
  content: "\\F0A25";
}

.mdi-baby::before {
  content: "\\F006C";
}

.mdi-baby-bottle::before {
  content: "\\F0F39";
}

.mdi-baby-bottle-outline::before {
  content: "\\F0F3A";
}

.mdi-baby-buggy::before {
  content: "\\F13E0";
}

.mdi-baby-buggy-off::before {
  content: "\\F1AF3";
}

.mdi-baby-carriage::before {
  content: "\\F068F";
}

.mdi-baby-carriage-off::before {
  content: "\\F0FA0";
}

.mdi-baby-face::before {
  content: "\\F0E7C";
}

.mdi-baby-face-outline::before {
  content: "\\F0E7D";
}

.mdi-backburger::before {
  content: "\\F006D";
}

.mdi-backspace::before {
  content: "\\F006E";
}

.mdi-backspace-outline::before {
  content: "\\F0B5C";
}

.mdi-backspace-reverse::before {
  content: "\\F0E7E";
}

.mdi-backspace-reverse-outline::before {
  content: "\\F0E7F";
}

.mdi-backup-restore::before {
  content: "\\F006F";
}

.mdi-bacteria::before {
  content: "\\F0ED5";
}

.mdi-bacteria-outline::before {
  content: "\\F0ED6";
}

.mdi-badge-account::before {
  content: "\\F0DA7";
}

.mdi-badge-account-alert::before {
  content: "\\F0DA8";
}

.mdi-badge-account-alert-outline::before {
  content: "\\F0DA9";
}

.mdi-badge-account-horizontal::before {
  content: "\\F0E0D";
}

.mdi-badge-account-horizontal-outline::before {
  content: "\\F0E0E";
}

.mdi-badge-account-outline::before {
  content: "\\F0DAA";
}

.mdi-badminton::before {
  content: "\\F0851";
}

.mdi-bag-carry-on::before {
  content: "\\F0F3B";
}

.mdi-bag-carry-on-check::before {
  content: "\\F0D65";
}

.mdi-bag-carry-on-off::before {
  content: "\\F0F3C";
}

.mdi-bag-checked::before {
  content: "\\F0F3D";
}

.mdi-bag-personal::before {
  content: "\\F0E10";
}

.mdi-bag-personal-off::before {
  content: "\\F0E11";
}

.mdi-bag-personal-off-outline::before {
  content: "\\F0E12";
}

.mdi-bag-personal-outline::before {
  content: "\\F0E13";
}

.mdi-bag-personal-plus::before {
  content: "\\F1CA4";
}

.mdi-bag-personal-plus-outline::before {
  content: "\\F1CA5";
}

.mdi-bag-personal-tag::before {
  content: "\\F1B0C";
}

.mdi-bag-personal-tag-outline::before {
  content: "\\F1B0D";
}

.mdi-bag-suitcase::before {
  content: "\\F158B";
}

.mdi-bag-suitcase-off::before {
  content: "\\F158D";
}

.mdi-bag-suitcase-off-outline::before {
  content: "\\F158E";
}

.mdi-bag-suitcase-outline::before {
  content: "\\F158C";
}

.mdi-baguette::before {
  content: "\\F0F3E";
}

.mdi-balcony::before {
  content: "\\F1817";
}

.mdi-balloon::before {
  content: "\\F0A26";
}

.mdi-ballot::before {
  content: "\\F09C9";
}

.mdi-ballot-outline::before {
  content: "\\F09CA";
}

.mdi-ballot-recount::before {
  content: "\\F0C39";
}

.mdi-ballot-recount-outline::before {
  content: "\\F0C3A";
}

.mdi-bandage::before {
  content: "\\F0DAF";
}

.mdi-bank::before {
  content: "\\F0070";
}

.mdi-bank-check::before {
  content: "\\F1655";
}

.mdi-bank-circle::before {
  content: "\\F1C03";
}

.mdi-bank-circle-outline::before {
  content: "\\F1C04";
}

.mdi-bank-minus::before {
  content: "\\F0DB0";
}

.mdi-bank-off::before {
  content: "\\F1656";
}

.mdi-bank-off-outline::before {
  content: "\\F1657";
}

.mdi-bank-outline::before {
  content: "\\F0E80";
}

.mdi-bank-plus::before {
  content: "\\F0DB1";
}

.mdi-bank-remove::before {
  content: "\\F0DB2";
}

.mdi-bank-transfer::before {
  content: "\\F0A27";
}

.mdi-bank-transfer-in::before {
  content: "\\F0A28";
}

.mdi-bank-transfer-out::before {
  content: "\\F0A29";
}

.mdi-barcode::before {
  content: "\\F0071";
}

.mdi-barcode-off::before {
  content: "\\F1236";
}

.mdi-barcode-scan::before {
  content: "\\F0072";
}

.mdi-barley::before {
  content: "\\F0073";
}

.mdi-barley-off::before {
  content: "\\F0B5D";
}

.mdi-barn::before {
  content: "\\F0B5E";
}

.mdi-barrel::before {
  content: "\\F0074";
}

.mdi-barrel-outline::before {
  content: "\\F1A28";
}

.mdi-baseball::before {
  content: "\\F0852";
}

.mdi-baseball-bat::before {
  content: "\\F0853";
}

.mdi-baseball-diamond::before {
  content: "\\F15EC";
}

.mdi-baseball-diamond-outline::before {
  content: "\\F15ED";
}

.mdi-baseball-outline::before {
  content: "\\F1C5A";
}

.mdi-bash::before {
  content: "\\F1183";
}

.mdi-basket::before {
  content: "\\F0076";
}

.mdi-basket-check::before {
  content: "\\F18E5";
}

.mdi-basket-check-outline::before {
  content: "\\F18E6";
}

.mdi-basket-fill::before {
  content: "\\F0077";
}

.mdi-basket-minus::before {
  content: "\\F1523";
}

.mdi-basket-minus-outline::before {
  content: "\\F1524";
}

.mdi-basket-off::before {
  content: "\\F1525";
}

.mdi-basket-off-outline::before {
  content: "\\F1526";
}

.mdi-basket-outline::before {
  content: "\\F1181";
}

.mdi-basket-plus::before {
  content: "\\F1527";
}

.mdi-basket-plus-outline::before {
  content: "\\F1528";
}

.mdi-basket-remove::before {
  content: "\\F1529";
}

.mdi-basket-remove-outline::before {
  content: "\\F152A";
}

.mdi-basket-unfill::before {
  content: "\\F0078";
}

.mdi-basketball::before {
  content: "\\F0806";
}

.mdi-basketball-hoop::before {
  content: "\\F0C3B";
}

.mdi-basketball-hoop-outline::before {
  content: "\\F0C3C";
}

.mdi-bat::before {
  content: "\\F0B5F";
}

.mdi-bathtub::before {
  content: "\\F1818";
}

.mdi-bathtub-outline::before {
  content: "\\F1819";
}

.mdi-battery::before {
  content: "\\F0079";
}

.mdi-battery-10::before {
  content: "\\F007A";
}

.mdi-battery-10-bluetooth::before {
  content: "\\F093E";
}

.mdi-battery-20::before {
  content: "\\F007B";
}

.mdi-battery-20-bluetooth::before {
  content: "\\F093F";
}

.mdi-battery-30::before {
  content: "\\F007C";
}

.mdi-battery-30-bluetooth::before {
  content: "\\F0940";
}

.mdi-battery-40::before {
  content: "\\F007D";
}

.mdi-battery-40-bluetooth::before {
  content: "\\F0941";
}

.mdi-battery-50::before {
  content: "\\F007E";
}

.mdi-battery-50-bluetooth::before {
  content: "\\F0942";
}

.mdi-battery-60::before {
  content: "\\F007F";
}

.mdi-battery-60-bluetooth::before {
  content: "\\F0943";
}

.mdi-battery-70::before {
  content: "\\F0080";
}

.mdi-battery-70-bluetooth::before {
  content: "\\F0944";
}

.mdi-battery-80::before {
  content: "\\F0081";
}

.mdi-battery-80-bluetooth::before {
  content: "\\F0945";
}

.mdi-battery-90::before {
  content: "\\F0082";
}

.mdi-battery-90-bluetooth::before {
  content: "\\F0946";
}

.mdi-battery-alert::before {
  content: "\\F0083";
}

.mdi-battery-alert-bluetooth::before {
  content: "\\F0947";
}

.mdi-battery-alert-variant::before {
  content: "\\F10CC";
}

.mdi-battery-alert-variant-outline::before {
  content: "\\F10CD";
}

.mdi-battery-arrow-down::before {
  content: "\\F17DE";
}

.mdi-battery-arrow-down-outline::before {
  content: "\\F17DF";
}

.mdi-battery-arrow-up::before {
  content: "\\F17E0";
}

.mdi-battery-arrow-up-outline::before {
  content: "\\F17E1";
}

.mdi-battery-bluetooth::before {
  content: "\\F0948";
}

.mdi-battery-bluetooth-variant::before {
  content: "\\F0949";
}

.mdi-battery-charging::before {
  content: "\\F0084";
}

.mdi-battery-charging-10::before {
  content: "\\F089C";
}

.mdi-battery-charging-100::before {
  content: "\\F0085";
}

.mdi-battery-charging-20::before {
  content: "\\F0086";
}

.mdi-battery-charging-30::before {
  content: "\\F0087";
}

.mdi-battery-charging-40::before {
  content: "\\F0088";
}

.mdi-battery-charging-50::before {
  content: "\\F089D";
}

.mdi-battery-charging-60::before {
  content: "\\F0089";
}

.mdi-battery-charging-70::before {
  content: "\\F089E";
}

.mdi-battery-charging-80::before {
  content: "\\F008A";
}

.mdi-battery-charging-90::before {
  content: "\\F008B";
}

.mdi-battery-charging-high::before {
  content: "\\F12A6";
}

.mdi-battery-charging-low::before {
  content: "\\F12A4";
}

.mdi-battery-charging-medium::before {
  content: "\\F12A5";
}

.mdi-battery-charging-outline::before {
  content: "\\F089F";
}

.mdi-battery-charging-wireless::before {
  content: "\\F0807";
}

.mdi-battery-charging-wireless-10::before {
  content: "\\F0808";
}

.mdi-battery-charging-wireless-20::before {
  content: "\\F0809";
}

.mdi-battery-charging-wireless-30::before {
  content: "\\F080A";
}

.mdi-battery-charging-wireless-40::before {
  content: "\\F080B";
}

.mdi-battery-charging-wireless-50::before {
  content: "\\F080C";
}

.mdi-battery-charging-wireless-60::before {
  content: "\\F080D";
}

.mdi-battery-charging-wireless-70::before {
  content: "\\F080E";
}

.mdi-battery-charging-wireless-80::before {
  content: "\\F080F";
}

.mdi-battery-charging-wireless-90::before {
  content: "\\F0810";
}

.mdi-battery-charging-wireless-alert::before {
  content: "\\F0811";
}

.mdi-battery-charging-wireless-outline::before {
  content: "\\F0812";
}

.mdi-battery-check::before {
  content: "\\F17E2";
}

.mdi-battery-check-outline::before {
  content: "\\F17E3";
}

.mdi-battery-clock::before {
  content: "\\F19E5";
}

.mdi-battery-clock-outline::before {
  content: "\\F19E6";
}

.mdi-battery-heart::before {
  content: "\\F120F";
}

.mdi-battery-heart-outline::before {
  content: "\\F1210";
}

.mdi-battery-heart-variant::before {
  content: "\\F1211";
}

.mdi-battery-high::before {
  content: "\\F12A3";
}

.mdi-battery-lock::before {
  content: "\\F179C";
}

.mdi-battery-lock-open::before {
  content: "\\F179D";
}

.mdi-battery-low::before {
  content: "\\F12A1";
}

.mdi-battery-medium::before {
  content: "\\F12A2";
}

.mdi-battery-minus::before {
  content: "\\F17E4";
}

.mdi-battery-minus-outline::before {
  content: "\\F17E5";
}

.mdi-battery-minus-variant::before {
  content: "\\F008C";
}

.mdi-battery-negative::before {
  content: "\\F008D";
}

.mdi-battery-off::before {
  content: "\\F125D";
}

.mdi-battery-off-outline::before {
  content: "\\F125E";
}

.mdi-battery-outline::before {
  content: "\\F008E";
}

.mdi-battery-plus::before {
  content: "\\F17E6";
}

.mdi-battery-plus-outline::before {
  content: "\\F17E7";
}

.mdi-battery-plus-variant::before {
  content: "\\F008F";
}

.mdi-battery-positive::before {
  content: "\\F0090";
}

.mdi-battery-remove::before {
  content: "\\F17E8";
}

.mdi-battery-remove-outline::before {
  content: "\\F17E9";
}

.mdi-battery-sync::before {
  content: "\\F1834";
}

.mdi-battery-sync-outline::before {
  content: "\\F1835";
}

.mdi-battery-unknown::before {
  content: "\\F0091";
}

.mdi-battery-unknown-bluetooth::before {
  content: "\\F094A";
}

.mdi-beach::before {
  content: "\\F0092";
}

.mdi-beaker::before {
  content: "\\F0CEA";
}

.mdi-beaker-alert::before {
  content: "\\F1229";
}

.mdi-beaker-alert-outline::before {
  content: "\\F122A";
}

.mdi-beaker-check::before {
  content: "\\F122B";
}

.mdi-beaker-check-outline::before {
  content: "\\F122C";
}

.mdi-beaker-minus::before {
  content: "\\F122D";
}

.mdi-beaker-minus-outline::before {
  content: "\\F122E";
}

.mdi-beaker-outline::before {
  content: "\\F0690";
}

.mdi-beaker-plus::before {
  content: "\\F122F";
}

.mdi-beaker-plus-outline::before {
  content: "\\F1230";
}

.mdi-beaker-question::before {
  content: "\\F1231";
}

.mdi-beaker-question-outline::before {
  content: "\\F1232";
}

.mdi-beaker-remove::before {
  content: "\\F1233";
}

.mdi-beaker-remove-outline::before {
  content: "\\F1234";
}

.mdi-bed::before {
  content: "\\F02E3";
}

.mdi-bed-clock::before {
  content: "\\F1B94";
}

.mdi-bed-double::before {
  content: "\\F0FD4";
}

.mdi-bed-double-outline::before {
  content: "\\F0FD3";
}

.mdi-bed-empty::before {
  content: "\\F08A0";
}

.mdi-bed-king::before {
  content: "\\F0FD2";
}

.mdi-bed-king-outline::before {
  content: "\\F0FD1";
}

.mdi-bed-outline::before {
  content: "\\F0099";
}

.mdi-bed-queen::before {
  content: "\\F0FD0";
}

.mdi-bed-queen-outline::before {
  content: "\\F0FDB";
}

.mdi-bed-single::before {
  content: "\\F106D";
}

.mdi-bed-single-outline::before {
  content: "\\F106E";
}

.mdi-bee::before {
  content: "\\F0FA1";
}

.mdi-bee-flower::before {
  content: "\\F0FA2";
}

.mdi-beehive-off-outline::before {
  content: "\\F13ED";
}

.mdi-beehive-outline::before {
  content: "\\F10CE";
}

.mdi-beekeeper::before {
  content: "\\F14E2";
}

.mdi-beer::before {
  content: "\\F0098";
}

.mdi-beer-outline::before {
  content: "\\F130C";
}

.mdi-bell::before {
  content: "\\F009A";
}

.mdi-bell-alert::before {
  content: "\\F0D59";
}

.mdi-bell-alert-outline::before {
  content: "\\F0E81";
}

.mdi-bell-badge::before {
  content: "\\F116B";
}

.mdi-bell-badge-outline::before {
  content: "\\F0178";
}

.mdi-bell-cancel::before {
  content: "\\F13E7";
}

.mdi-bell-cancel-outline::before {
  content: "\\F13E8";
}

.mdi-bell-check::before {
  content: "\\F11E5";
}

.mdi-bell-check-outline::before {
  content: "\\F11E6";
}

.mdi-bell-circle::before {
  content: "\\F0D5A";
}

.mdi-bell-circle-outline::before {
  content: "\\F0D5B";
}

.mdi-bell-cog::before {
  content: "\\F1A29";
}

.mdi-bell-cog-outline::before {
  content: "\\F1A2A";
}

.mdi-bell-minus::before {
  content: "\\F13E9";
}

.mdi-bell-minus-outline::before {
  content: "\\F13EA";
}

.mdi-bell-off::before {
  content: "\\F009B";
}

.mdi-bell-off-outline::before {
  content: "\\F0A91";
}

.mdi-bell-outline::before {
  content: "\\F009C";
}

.mdi-bell-plus::before {
  content: "\\F009D";
}

.mdi-bell-plus-outline::before {
  content: "\\F0A92";
}

.mdi-bell-remove::before {
  content: "\\F13EB";
}

.mdi-bell-remove-outline::before {
  content: "\\F13EC";
}

.mdi-bell-ring::before {
  content: "\\F009E";
}

.mdi-bell-ring-outline::before {
  content: "\\F009F";
}

.mdi-bell-sleep::before {
  content: "\\F00A0";
}

.mdi-bell-sleep-outline::before {
  content: "\\F0A93";
}

.mdi-bench::before {
  content: "\\F1C21";
}

.mdi-bench-back::before {
  content: "\\F1C22";
}

.mdi-beta::before {
  content: "\\F00A1";
}

.mdi-betamax::before {
  content: "\\F09CB";
}

.mdi-biathlon::before {
  content: "\\F0E14";
}

.mdi-bicycle::before {
  content: "\\F109C";
}

.mdi-bicycle-basket::before {
  content: "\\F1235";
}

.mdi-bicycle-cargo::before {
  content: "\\F189C";
}

.mdi-bicycle-electric::before {
  content: "\\F15B4";
}

.mdi-bicycle-penny-farthing::before {
  content: "\\F15E9";
}

.mdi-bike::before {
  content: "\\F00A3";
}

.mdi-bike-fast::before {
  content: "\\F111F";
}

.mdi-bike-pedal::before {
  content: "\\F1C23";
}

.mdi-bike-pedal-clipless::before {
  content: "\\F1C24";
}

.mdi-bike-pedal-mountain::before {
  content: "\\F1C25";
}

.mdi-billboard::before {
  content: "\\F1010";
}

.mdi-billiards::before {
  content: "\\F0B61";
}

.mdi-billiards-rack::before {
  content: "\\F0B62";
}

.mdi-binoculars::before {
  content: "\\F00A5";
}

.mdi-bio::before {
  content: "\\F00A6";
}

.mdi-biohazard::before {
  content: "\\F00A7";
}

.mdi-bird::before {
  content: "\\F15C6";
}

.mdi-bitbucket::before {
  content: "\\F00A8";
}

.mdi-bitcoin::before {
  content: "\\F0813";
}

.mdi-black-mesa::before {
  content: "\\F00A9";
}

.mdi-blender::before {
  content: "\\F0CEB";
}

.mdi-blender-outline::before {
  content: "\\F181A";
}

.mdi-blender-software::before {
  content: "\\F00AB";
}

.mdi-blinds::before {
  content: "\\F00AC";
}

.mdi-blinds-horizontal::before {
  content: "\\F1A2B";
}

.mdi-blinds-horizontal-closed::before {
  content: "\\F1A2C";
}

.mdi-blinds-open::before {
  content: "\\F1011";
}

.mdi-blinds-vertical::before {
  content: "\\F1A2D";
}

.mdi-blinds-vertical-closed::before {
  content: "\\F1A2E";
}

.mdi-block-helper::before {
  content: "\\F00AD";
}

.mdi-blood-bag::before {
  content: "\\F0CEC";
}

.mdi-bluetooth::before {
  content: "\\F00AF";
}

.mdi-bluetooth-audio::before {
  content: "\\F00B0";
}

.mdi-bluetooth-connect::before {
  content: "\\F00B1";
}

.mdi-bluetooth-off::before {
  content: "\\F00B2";
}

.mdi-bluetooth-settings::before {
  content: "\\F00B3";
}

.mdi-bluetooth-transfer::before {
  content: "\\F00B4";
}

.mdi-blur::before {
  content: "\\F00B5";
}

.mdi-blur-linear::before {
  content: "\\F00B6";
}

.mdi-blur-off::before {
  content: "\\F00B7";
}

.mdi-blur-radial::before {
  content: "\\F00B8";
}

.mdi-bolt::before {
  content: "\\F0DB3";
}

.mdi-bomb::before {
  content: "\\F0691";
}

.mdi-bomb-off::before {
  content: "\\F06C5";
}

.mdi-bone::before {
  content: "\\F00B9";
}

.mdi-bone-off::before {
  content: "\\F19E0";
}

.mdi-book::before {
  content: "\\F00BA";
}

.mdi-book-account::before {
  content: "\\F13AD";
}

.mdi-book-account-outline::before {
  content: "\\F13AE";
}

.mdi-book-alert::before {
  content: "\\F167C";
}

.mdi-book-alert-outline::before {
  content: "\\F167D";
}

.mdi-book-alphabet::before {
  content: "\\F061D";
}

.mdi-book-arrow-down::before {
  content: "\\F167E";
}

.mdi-book-arrow-down-outline::before {
  content: "\\F167F";
}

.mdi-book-arrow-left::before {
  content: "\\F1680";
}

.mdi-book-arrow-left-outline::before {
  content: "\\F1681";
}

.mdi-book-arrow-right::before {
  content: "\\F1682";
}

.mdi-book-arrow-right-outline::before {
  content: "\\F1683";
}

.mdi-book-arrow-up::before {
  content: "\\F1684";
}

.mdi-book-arrow-up-outline::before {
  content: "\\F1685";
}

.mdi-book-cancel::before {
  content: "\\F1686";
}

.mdi-book-cancel-outline::before {
  content: "\\F1687";
}

.mdi-book-check::before {
  content: "\\F14F3";
}

.mdi-book-check-outline::before {
  content: "\\F14F4";
}

.mdi-book-clock::before {
  content: "\\F1688";
}

.mdi-book-clock-outline::before {
  content: "\\F1689";
}

.mdi-book-cog::before {
  content: "\\F168A";
}

.mdi-book-cog-outline::before {
  content: "\\F168B";
}

.mdi-book-cross::before {
  content: "\\F00A2";
}

.mdi-book-edit::before {
  content: "\\F168C";
}

.mdi-book-edit-outline::before {
  content: "\\F168D";
}

.mdi-book-education::before {
  content: "\\F16C9";
}

.mdi-book-education-outline::before {
  content: "\\F16CA";
}

.mdi-book-heart::before {
  content: "\\F1A1D";
}

.mdi-book-heart-outline::before {
  content: "\\F1A1E";
}

.mdi-book-information-variant::before {
  content: "\\F106F";
}

.mdi-book-lock::before {
  content: "\\F079A";
}

.mdi-book-lock-open::before {
  content: "\\F079B";
}

.mdi-book-lock-open-outline::before {
  content: "\\F168E";
}

.mdi-book-lock-outline::before {
  content: "\\F168F";
}

.mdi-book-marker::before {
  content: "\\F1690";
}

.mdi-book-marker-outline::before {
  content: "\\F1691";
}

.mdi-book-minus::before {
  content: "\\F05D9";
}

.mdi-book-minus-multiple::before {
  content: "\\F0A94";
}

.mdi-book-minus-multiple-outline::before {
  content: "\\F090B";
}

.mdi-book-minus-outline::before {
  content: "\\F1692";
}

.mdi-book-multiple::before {
  content: "\\F00BB";
}

.mdi-book-multiple-outline::before {
  content: "\\F0436";
}

.mdi-book-music::before {
  content: "\\F0067";
}

.mdi-book-music-outline::before {
  content: "\\F1693";
}

.mdi-book-off::before {
  content: "\\F1694";
}

.mdi-book-off-outline::before {
  content: "\\F1695";
}

.mdi-book-open::before {
  content: "\\F00BD";
}

.mdi-book-open-blank-variant::before {
  content: "\\F00BE";
}

.mdi-book-open-blank-variant-outline::before {
  content: "\\F1CCB";
}

.mdi-book-open-outline::before {
  content: "\\F0B63";
}

.mdi-book-open-page-variant::before {
  content: "\\F05DA";
}

.mdi-book-open-page-variant-outline::before {
  content: "\\F15D6";
}

.mdi-book-open-variant::before {
  content: "\\F14F7";
}

.mdi-book-open-variant-outline::before {
  content: "\\F1CCC";
}

.mdi-book-outline::before {
  content: "\\F0B64";
}

.mdi-book-play::before {
  content: "\\F0E82";
}

.mdi-book-play-outline::before {
  content: "\\F0E83";
}

.mdi-book-plus::before {
  content: "\\F05DB";
}

.mdi-book-plus-multiple::before {
  content: "\\F0A95";
}

.mdi-book-plus-multiple-outline::before {
  content: "\\F0ADE";
}

.mdi-book-plus-outline::before {
  content: "\\F1696";
}

.mdi-book-refresh::before {
  content: "\\F1697";
}

.mdi-book-refresh-outline::before {
  content: "\\F1698";
}

.mdi-book-remove::before {
  content: "\\F0A97";
}

.mdi-book-remove-multiple::before {
  content: "\\F0A96";
}

.mdi-book-remove-multiple-outline::before {
  content: "\\F04CA";
}

.mdi-book-remove-outline::before {
  content: "\\F1699";
}

.mdi-book-search::before {
  content: "\\F0E84";
}

.mdi-book-search-outline::before {
  content: "\\F0E85";
}

.mdi-book-settings::before {
  content: "\\F169A";
}

.mdi-book-settings-outline::before {
  content: "\\F169B";
}

.mdi-book-sync::before {
  content: "\\F169C";
}

.mdi-book-sync-outline::before {
  content: "\\F16C8";
}

.mdi-book-variant::before {
  content: "\\F00BF";
}

.mdi-bookmark::before {
  content: "\\F00C0";
}

.mdi-bookmark-box::before {
  content: "\\F1B75";
}

.mdi-bookmark-box-multiple::before {
  content: "\\F196C";
}

.mdi-bookmark-box-multiple-outline::before {
  content: "\\F196D";
}

.mdi-bookmark-box-outline::before {
  content: "\\F1B76";
}

.mdi-bookmark-check::before {
  content: "\\F00C1";
}

.mdi-bookmark-check-outline::before {
  content: "\\F137B";
}

.mdi-bookmark-minus::before {
  content: "\\F09CC";
}

.mdi-bookmark-minus-outline::before {
  content: "\\F09CD";
}

.mdi-bookmark-multiple::before {
  content: "\\F0E15";
}

.mdi-bookmark-multiple-outline::before {
  content: "\\F0E16";
}

.mdi-bookmark-music::before {
  content: "\\F00C2";
}

.mdi-bookmark-music-outline::before {
  content: "\\F1379";
}

.mdi-bookmark-off::before {
  content: "\\F09CE";
}

.mdi-bookmark-off-outline::before {
  content: "\\F09CF";
}

.mdi-bookmark-outline::before {
  content: "\\F00C3";
}

.mdi-bookmark-plus::before {
  content: "\\F00C5";
}

.mdi-bookmark-plus-outline::before {
  content: "\\F00C4";
}

.mdi-bookmark-remove::before {
  content: "\\F00C6";
}

.mdi-bookmark-remove-outline::before {
  content: "\\F137A";
}

.mdi-bookshelf::before {
  content: "\\F125F";
}

.mdi-boom-gate::before {
  content: "\\F0E86";
}

.mdi-boom-gate-alert::before {
  content: "\\F0E87";
}

.mdi-boom-gate-alert-outline::before {
  content: "\\F0E88";
}

.mdi-boom-gate-arrow-down::before {
  content: "\\F0E89";
}

.mdi-boom-gate-arrow-down-outline::before {
  content: "\\F0E8A";
}

.mdi-boom-gate-arrow-up::before {
  content: "\\F0E8C";
}

.mdi-boom-gate-arrow-up-outline::before {
  content: "\\F0E8D";
}

.mdi-boom-gate-outline::before {
  content: "\\F0E8B";
}

.mdi-boom-gate-up::before {
  content: "\\F17F9";
}

.mdi-boom-gate-up-outline::before {
  content: "\\F17FA";
}

.mdi-boombox::before {
  content: "\\F05DC";
}

.mdi-boomerang::before {
  content: "\\F10CF";
}

.mdi-bootstrap::before {
  content: "\\F06C6";
}

.mdi-border-all::before {
  content: "\\F00C7";
}

.mdi-border-all-variant::before {
  content: "\\F08A1";
}

.mdi-border-bottom::before {
  content: "\\F00C8";
}

.mdi-border-bottom-variant::before {
  content: "\\F08A2";
}

.mdi-border-color::before {
  content: "\\F00C9";
}

.mdi-border-horizontal::before {
  content: "\\F00CA";
}

.mdi-border-inside::before {
  content: "\\F00CB";
}

.mdi-border-left::before {
  content: "\\F00CC";
}

.mdi-border-left-variant::before {
  content: "\\F08A3";
}

.mdi-border-none::before {
  content: "\\F00CD";
}

.mdi-border-none-variant::before {
  content: "\\F08A4";
}

.mdi-border-outside::before {
  content: "\\F00CE";
}

.mdi-border-radius::before {
  content: "\\F1AF4";
}

.mdi-border-right::before {
  content: "\\F00CF";
}

.mdi-border-right-variant::before {
  content: "\\F08A5";
}

.mdi-border-style::before {
  content: "\\F00D0";
}

.mdi-border-top::before {
  content: "\\F00D1";
}

.mdi-border-top-variant::before {
  content: "\\F08A6";
}

.mdi-border-vertical::before {
  content: "\\F00D2";
}

.mdi-bottle-soda::before {
  content: "\\F1070";
}

.mdi-bottle-soda-classic::before {
  content: "\\F1071";
}

.mdi-bottle-soda-classic-outline::before {
  content: "\\F1363";
}

.mdi-bottle-soda-outline::before {
  content: "\\F1072";
}

.mdi-bottle-tonic::before {
  content: "\\F112E";
}

.mdi-bottle-tonic-outline::before {
  content: "\\F112F";
}

.mdi-bottle-tonic-plus::before {
  content: "\\F1130";
}

.mdi-bottle-tonic-plus-outline::before {
  content: "\\F1131";
}

.mdi-bottle-tonic-skull::before {
  content: "\\F1132";
}

.mdi-bottle-tonic-skull-outline::before {
  content: "\\F1133";
}

.mdi-bottle-wine::before {
  content: "\\F0854";
}

.mdi-bottle-wine-outline::before {
  content: "\\F1310";
}

.mdi-bow-arrow::before {
  content: "\\F1841";
}

.mdi-bow-tie::before {
  content: "\\F0678";
}

.mdi-bowl::before {
  content: "\\F028E";
}

.mdi-bowl-mix::before {
  content: "\\F0617";
}

.mdi-bowl-mix-outline::before {
  content: "\\F02E4";
}

.mdi-bowl-outline::before {
  content: "\\F02A9";
}

.mdi-bowling::before {
  content: "\\F00D3";
}

.mdi-box::before {
  content: "\\F00D4";
}

.mdi-box-cutter::before {
  content: "\\F00D5";
}

.mdi-box-cutter-off::before {
  content: "\\F0B4A";
}

.mdi-box-shadow::before {
  content: "\\F0637";
}

.mdi-boxing-glove::before {
  content: "\\F0B65";
}

.mdi-braille::before {
  content: "\\F09D0";
}

.mdi-brain::before {
  content: "\\F09D1";
}

.mdi-bread-slice::before {
  content: "\\F0CEE";
}

.mdi-bread-slice-outline::before {
  content: "\\F0CEF";
}

.mdi-bridge::before {
  content: "\\F0618";
}

.mdi-briefcase::before {
  content: "\\F00D6";
}

.mdi-briefcase-account::before {
  content: "\\F0CF0";
}

.mdi-briefcase-account-outline::before {
  content: "\\F0CF1";
}

.mdi-briefcase-arrow-left-right::before {
  content: "\\F1A8D";
}

.mdi-briefcase-arrow-left-right-outline::before {
  content: "\\F1A8E";
}

.mdi-briefcase-arrow-up-down::before {
  content: "\\F1A8F";
}

.mdi-briefcase-arrow-up-down-outline::before {
  content: "\\F1A90";
}

.mdi-briefcase-check::before {
  content: "\\F00D7";
}

.mdi-briefcase-check-outline::before {
  content: "\\F131E";
}

.mdi-briefcase-clock::before {
  content: "\\F10D0";
}

.mdi-briefcase-clock-outline::before {
  content: "\\F10D1";
}

.mdi-briefcase-download::before {
  content: "\\F00D8";
}

.mdi-briefcase-download-outline::before {
  content: "\\F0C3D";
}

.mdi-briefcase-edit::before {
  content: "\\F0A98";
}

.mdi-briefcase-edit-outline::before {
  content: "\\F0C3E";
}

.mdi-briefcase-eye::before {
  content: "\\F17D9";
}

.mdi-briefcase-eye-outline::before {
  content: "\\F17DA";
}

.mdi-briefcase-minus::before {
  content: "\\F0A2A";
}

.mdi-briefcase-minus-outline::before {
  content: "\\F0C3F";
}

.mdi-briefcase-off::before {
  content: "\\F1658";
}

.mdi-briefcase-off-outline::before {
  content: "\\F1659";
}

.mdi-briefcase-outline::before {
  content: "\\F0814";
}

.mdi-briefcase-plus::before {
  content: "\\F0A2B";
}

.mdi-briefcase-plus-outline::before {
  content: "\\F0C40";
}

.mdi-briefcase-remove::before {
  content: "\\F0A2C";
}

.mdi-briefcase-remove-outline::before {
  content: "\\F0C41";
}

.mdi-briefcase-search::before {
  content: "\\F0A2D";
}

.mdi-briefcase-search-outline::before {
  content: "\\F0C42";
}

.mdi-briefcase-upload::before {
  content: "\\F00D9";
}

.mdi-briefcase-upload-outline::before {
  content: "\\F0C43";
}

.mdi-briefcase-variant::before {
  content: "\\F1494";
}

.mdi-briefcase-variant-off::before {
  content: "\\F165A";
}

.mdi-briefcase-variant-off-outline::before {
  content: "\\F165B";
}

.mdi-briefcase-variant-outline::before {
  content: "\\F1495";
}

.mdi-brightness-1::before {
  content: "\\F00DA";
}

.mdi-brightness-2::before {
  content: "\\F00DB";
}

.mdi-brightness-3::before {
  content: "\\F00DC";
}

.mdi-brightness-4::before {
  content: "\\F00DD";
}

.mdi-brightness-5::before {
  content: "\\F00DE";
}

.mdi-brightness-6::before {
  content: "\\F00DF";
}

.mdi-brightness-7::before {
  content: "\\F00E0";
}

.mdi-brightness-auto::before {
  content: "\\F00E1";
}

.mdi-brightness-percent::before {
  content: "\\F0CF2";
}

.mdi-broadcast::before {
  content: "\\F1720";
}

.mdi-broadcast-off::before {
  content: "\\F1721";
}

.mdi-broom::before {
  content: "\\F00E2";
}

.mdi-brush::before {
  content: "\\F00E3";
}

.mdi-brush-off::before {
  content: "\\F1771";
}

.mdi-brush-outline::before {
  content: "\\F1A0D";
}

.mdi-brush-variant::before {
  content: "\\F1813";
}

.mdi-bucket::before {
  content: "\\F1415";
}

.mdi-bucket-outline::before {
  content: "\\F1416";
}

.mdi-buffet::before {
  content: "\\F0578";
}

.mdi-bug::before {
  content: "\\F00E4";
}

.mdi-bug-check::before {
  content: "\\F0A2E";
}

.mdi-bug-check-outline::before {
  content: "\\F0A2F";
}

.mdi-bug-outline::before {
  content: "\\F0A30";
}

.mdi-bug-pause::before {
  content: "\\F1AF5";
}

.mdi-bug-pause-outline::before {
  content: "\\F1AF6";
}

.mdi-bug-play::before {
  content: "\\F1AF7";
}

.mdi-bug-play-outline::before {
  content: "\\F1AF8";
}

.mdi-bug-stop::before {
  content: "\\F1AF9";
}

.mdi-bug-stop-outline::before {
  content: "\\F1AFA";
}

.mdi-bugle::before {
  content: "\\F0DB4";
}

.mdi-bulkhead-light::before {
  content: "\\F1A2F";
}

.mdi-bulldozer::before {
  content: "\\F0B22";
}

.mdi-bullet::before {
  content: "\\F0CF3";
}

.mdi-bulletin-board::before {
  content: "\\F00E5";
}

.mdi-bullhorn::before {
  content: "\\F00E6";
}

.mdi-bullhorn-outline::before {
  content: "\\F0B23";
}

.mdi-bullhorn-variant::before {
  content: "\\F196E";
}

.mdi-bullhorn-variant-outline::before {
  content: "\\F196F";
}

.mdi-bullseye::before {
  content: "\\F05DD";
}

.mdi-bullseye-arrow::before {
  content: "\\F08C9";
}

.mdi-bulma::before {
  content: "\\F12E7";
}

.mdi-bunk-bed::before {
  content: "\\F1302";
}

.mdi-bunk-bed-outline::before {
  content: "\\F0097";
}

.mdi-bus::before {
  content: "\\F00E7";
}

.mdi-bus-alert::before {
  content: "\\F0A99";
}

.mdi-bus-articulated-end::before {
  content: "\\F079C";
}

.mdi-bus-articulated-front::before {
  content: "\\F079D";
}

.mdi-bus-clock::before {
  content: "\\F08CA";
}

.mdi-bus-double-decker::before {
  content: "\\F079E";
}

.mdi-bus-electric::before {
  content: "\\F191D";
}

.mdi-bus-marker::before {
  content: "\\F1212";
}

.mdi-bus-multiple::before {
  content: "\\F0F3F";
}

.mdi-bus-school::before {
  content: "\\F079F";
}

.mdi-bus-side::before {
  content: "\\F07A0";
}

.mdi-bus-sign::before {
  content: "\\F1CC1";
}

.mdi-bus-stop::before {
  content: "\\F1012";
}

.mdi-bus-stop-covered::before {
  content: "\\F1013";
}

.mdi-bus-stop-uncovered::before {
  content: "\\F1014";
}

.mdi-bus-wrench::before {
  content: "\\F1CC2";
}

.mdi-butterfly::before {
  content: "\\F1589";
}

.mdi-butterfly-outline::before {
  content: "\\F158A";
}

.mdi-button-cursor::before {
  content: "\\F1B4F";
}

.mdi-button-pointer::before {
  content: "\\F1B50";
}

.mdi-cabin-a-frame::before {
  content: "\\F188C";
}

.mdi-cable-data::before {
  content: "\\F1394";
}

.mdi-cached::before {
  content: "\\F00E8";
}

.mdi-cactus::before {
  content: "\\F0DB5";
}

.mdi-cake::before {
  content: "\\F00E9";
}

.mdi-cake-layered::before {
  content: "\\F00EA";
}

.mdi-cake-variant::before {
  content: "\\F00EB";
}

.mdi-cake-variant-outline::before {
  content: "\\F17F0";
}

.mdi-calculator::before {
  content: "\\F00EC";
}

.mdi-calculator-variant::before {
  content: "\\F0A9A";
}

.mdi-calculator-variant-outline::before {
  content: "\\F15A6";
}

.mdi-calendar::before {
  content: "\\F00ED";
}

.mdi-calendar-account::before {
  content: "\\F0ED7";
}

.mdi-calendar-account-outline::before {
  content: "\\F0ED8";
}

.mdi-calendar-alert::before {
  content: "\\F0A31";
}

.mdi-calendar-alert-outline::before {
  content: "\\F1B62";
}

.mdi-calendar-arrow-left::before {
  content: "\\F1134";
}

.mdi-calendar-arrow-right::before {
  content: "\\F1135";
}

.mdi-calendar-badge::before {
  content: "\\F1B9D";
}

.mdi-calendar-badge-outline::before {
  content: "\\F1B9E";
}

.mdi-calendar-blank::before {
  content: "\\F00EE";
}

.mdi-calendar-blank-multiple::before {
  content: "\\F1073";
}

.mdi-calendar-blank-outline::before {
  content: "\\F0B66";
}

.mdi-calendar-check::before {
  content: "\\F00EF";
}

.mdi-calendar-check-outline::before {
  content: "\\F0C44";
}

.mdi-calendar-clock::before {
  content: "\\F00F0";
}

.mdi-calendar-clock-outline::before {
  content: "\\F16E1";
}

.mdi-calendar-collapse-horizontal::before {
  content: "\\F189D";
}

.mdi-calendar-collapse-horizontal-outline::before {
  content: "\\F1B63";
}

.mdi-calendar-cursor::before {
  content: "\\F157B";
}

.mdi-calendar-cursor-outline::before {
  content: "\\F1B64";
}

.mdi-calendar-edit::before {
  content: "\\F08A7";
}

.mdi-calendar-edit-outline::before {
  content: "\\F1B65";
}

.mdi-calendar-end::before {
  content: "\\F166C";
}

.mdi-calendar-end-outline::before {
  content: "\\F1B66";
}

.mdi-calendar-expand-horizontal::before {
  content: "\\F189E";
}

.mdi-calendar-expand-horizontal-outline::before {
  content: "\\F1B67";
}

.mdi-calendar-export::before {
  content: "\\F0B24";
}

.mdi-calendar-export-outline::before {
  content: "\\F1B68";
}

.mdi-calendar-filter::before {
  content: "\\F1A32";
}

.mdi-calendar-filter-outline::before {
  content: "\\F1A33";
}

.mdi-calendar-heart::before {
  content: "\\F09D2";
}

.mdi-calendar-heart-outline::before {
  content: "\\F1B69";
}

.mdi-calendar-import::before {
  content: "\\F0B25";
}

.mdi-calendar-import-outline::before {
  content: "\\F1B6A";
}

.mdi-calendar-lock::before {
  content: "\\F1641";
}

.mdi-calendar-lock-open::before {
  content: "\\F1B5B";
}

.mdi-calendar-lock-open-outline::before {
  content: "\\F1B5C";
}

.mdi-calendar-lock-outline::before {
  content: "\\F1642";
}

.mdi-calendar-minus::before {
  content: "\\F0D5C";
}

.mdi-calendar-minus-outline::before {
  content: "\\F1B6B";
}

.mdi-calendar-month::before {
  content: "\\F0E17";
}

.mdi-calendar-month-outline::before {
  content: "\\F0E18";
}

.mdi-calendar-multiple::before {
  content: "\\F00F1";
}

.mdi-calendar-multiple-check::before {
  content: "\\F00F2";
}

.mdi-calendar-multiselect::before {
  content: "\\F0A32";
}

.mdi-calendar-multiselect-outline::before {
  content: "\\F1B55";
}

.mdi-calendar-outline::before {
  content: "\\F0B67";
}

.mdi-calendar-plus::before {
  content: "\\F00F3";
}

.mdi-calendar-plus-outline::before {
  content: "\\F1B6C";
}

.mdi-calendar-question::before {
  content: "\\F0692";
}

.mdi-calendar-question-outline::before {
  content: "\\F1B6D";
}

.mdi-calendar-range::before {
  content: "\\F0679";
}

.mdi-calendar-range-outline::before {
  content: "\\F0B68";
}

.mdi-calendar-refresh::before {
  content: "\\F01E1";
}

.mdi-calendar-refresh-outline::before {
  content: "\\F0203";
}

.mdi-calendar-remove::before {
  content: "\\F00F4";
}

.mdi-calendar-remove-outline::before {
  content: "\\F0C45";
}

.mdi-calendar-search::before {
  content: "\\F094C";
}

.mdi-calendar-search-outline::before {
  content: "\\F1B6E";
}

.mdi-calendar-star::before {
  content: "\\F09D3";
}

.mdi-calendar-star-four-points::before {
  content: "\\F1C1F";
}

.mdi-calendar-star-outline::before {
  content: "\\F1B53";
}

.mdi-calendar-start::before {
  content: "\\F166D";
}

.mdi-calendar-start-outline::before {
  content: "\\F1B6F";
}

.mdi-calendar-sync::before {
  content: "\\F0E8E";
}

.mdi-calendar-sync-outline::before {
  content: "\\F0E8F";
}

.mdi-calendar-text::before {
  content: "\\F00F5";
}

.mdi-calendar-text-outline::before {
  content: "\\F0C46";
}

.mdi-calendar-today::before {
  content: "\\F00F6";
}

.mdi-calendar-today-outline::before {
  content: "\\F1A30";
}

.mdi-calendar-week::before {
  content: "\\F0A33";
}

.mdi-calendar-week-begin::before {
  content: "\\F0A34";
}

.mdi-calendar-week-begin-outline::before {
  content: "\\F1A31";
}

.mdi-calendar-week-outline::before {
  content: "\\F1A34";
}

.mdi-calendar-weekend::before {
  content: "\\F0ED9";
}

.mdi-calendar-weekend-outline::before {
  content: "\\F0EDA";
}

.mdi-call-made::before {
  content: "\\F00F7";
}

.mdi-call-merge::before {
  content: "\\F00F8";
}

.mdi-call-missed::before {
  content: "\\F00F9";
}

.mdi-call-received::before {
  content: "\\F00FA";
}

.mdi-call-split::before {
  content: "\\F00FB";
}

.mdi-camcorder::before {
  content: "\\F00FC";
}

.mdi-camcorder-off::before {
  content: "\\F00FF";
}

.mdi-camera::before {
  content: "\\F0100";
}

.mdi-camera-account::before {
  content: "\\F08CB";
}

.mdi-camera-burst::before {
  content: "\\F0693";
}

.mdi-camera-control::before {
  content: "\\F0B69";
}

.mdi-camera-document::before {
  content: "\\F1871";
}

.mdi-camera-document-off::before {
  content: "\\F1872";
}

.mdi-camera-enhance::before {
  content: "\\F0101";
}

.mdi-camera-enhance-outline::before {
  content: "\\F0B6A";
}

.mdi-camera-flip::before {
  content: "\\F15D9";
}

.mdi-camera-flip-outline::before {
  content: "\\F15DA";
}

.mdi-camera-front::before {
  content: "\\F0102";
}

.mdi-camera-front-variant::before {
  content: "\\F0103";
}

.mdi-camera-gopro::before {
  content: "\\F07A1";
}

.mdi-camera-image::before {
  content: "\\F08CC";
}

.mdi-camera-iris::before {
  content: "\\F0104";
}

.mdi-camera-lock::before {
  content: "\\F1A14";
}

.mdi-camera-lock-open::before {
  content: "\\F1C0D";
}

.mdi-camera-lock-open-outline::before {
  content: "\\F1C0E";
}

.mdi-camera-lock-outline::before {
  content: "\\F1A15";
}

.mdi-camera-marker::before {
  content: "\\F19A7";
}

.mdi-camera-marker-outline::before {
  content: "\\F19A8";
}

.mdi-camera-metering-center::before {
  content: "\\F07A2";
}

.mdi-camera-metering-matrix::before {
  content: "\\F07A3";
}

.mdi-camera-metering-partial::before {
  content: "\\F07A4";
}

.mdi-camera-metering-spot::before {
  content: "\\F07A5";
}

.mdi-camera-off::before {
  content: "\\F05DF";
}

.mdi-camera-off-outline::before {
  content: "\\F19BF";
}

.mdi-camera-outline::before {
  content: "\\F0D5D";
}

.mdi-camera-party-mode::before {
  content: "\\F0105";
}

.mdi-camera-plus::before {
  content: "\\F0EDB";
}

.mdi-camera-plus-outline::before {
  content: "\\F0EDC";
}

.mdi-camera-rear::before {
  content: "\\F0106";
}

.mdi-camera-rear-variant::before {
  content: "\\F0107";
}

.mdi-camera-retake::before {
  content: "\\F0E19";
}

.mdi-camera-retake-outline::before {
  content: "\\F0E1A";
}

.mdi-camera-switch::before {
  content: "\\F0108";
}

.mdi-camera-switch-outline::before {
  content: "\\F084A";
}

.mdi-camera-timer::before {
  content: "\\F0109";
}

.mdi-camera-wireless::before {
  content: "\\F0DB6";
}

.mdi-camera-wireless-outline::before {
  content: "\\F0DB7";
}

.mdi-campfire::before {
  content: "\\F0EDD";
}

.mdi-cancel::before {
  content: "\\F073A";
}

.mdi-candelabra::before {
  content: "\\F17D2";
}

.mdi-candelabra-fire::before {
  content: "\\F17D3";
}

.mdi-candle::before {
  content: "\\F05E2";
}

.mdi-candy::before {
  content: "\\F1970";
}

.mdi-candy-off::before {
  content: "\\F1971";
}

.mdi-candy-off-outline::before {
  content: "\\F1972";
}

.mdi-candy-outline::before {
  content: "\\F1973";
}

.mdi-candycane::before {
  content: "\\F010A";
}

.mdi-cannabis::before {
  content: "\\F07A6";
}

.mdi-cannabis-off::before {
  content: "\\F166E";
}

.mdi-caps-lock::before {
  content: "\\F0A9B";
}

.mdi-car::before {
  content: "\\F010B";
}

.mdi-car-2-plus::before {
  content: "\\F1015";
}

.mdi-car-3-plus::before {
  content: "\\F1016";
}

.mdi-car-arrow-left::before {
  content: "\\F13B2";
}

.mdi-car-arrow-right::before {
  content: "\\F13B3";
}

.mdi-car-back::before {
  content: "\\F0E1B";
}

.mdi-car-battery::before {
  content: "\\F010C";
}

.mdi-car-brake-abs::before {
  content: "\\F0C47";
}

.mdi-car-brake-alert::before {
  content: "\\F0C48";
}

.mdi-car-brake-fluid-level::before {
  content: "\\F1909";
}

.mdi-car-brake-hold::before {
  content: "\\F0D5E";
}

.mdi-car-brake-low-pressure::before {
  content: "\\F190A";
}

.mdi-car-brake-parking::before {
  content: "\\F0D5F";
}

.mdi-car-brake-retarder::before {
  content: "\\F1017";
}

.mdi-car-brake-temperature::before {
  content: "\\F190B";
}

.mdi-car-brake-worn-linings::before {
  content: "\\F190C";
}

.mdi-car-child-seat::before {
  content: "\\F0FA3";
}

.mdi-car-clock::before {
  content: "\\F1974";
}

.mdi-car-clutch::before {
  content: "\\F1018";
}

.mdi-car-cog::before {
  content: "\\F13CC";
}

.mdi-car-connected::before {
  content: "\\F010D";
}

.mdi-car-convertible::before {
  content: "\\F07A7";
}

.mdi-car-coolant-level::before {
  content: "\\F1019";
}

.mdi-car-cruise-control::before {
  content: "\\F0D60";
}

.mdi-car-defrost-front::before {
  content: "\\F0D61";
}

.mdi-car-defrost-rear::before {
  content: "\\F0D62";
}

.mdi-car-door::before {
  content: "\\F0B6B";
}

.mdi-car-door-lock::before {
  content: "\\F109D";
}

.mdi-car-door-lock-open::before {
  content: "\\F1C81";
}

.mdi-car-electric::before {
  content: "\\F0B6C";
}

.mdi-car-electric-outline::before {
  content: "\\F15B5";
}

.mdi-car-emergency::before {
  content: "\\F160F";
}

.mdi-car-esp::before {
  content: "\\F0C49";
}

.mdi-car-estate::before {
  content: "\\F07A8";
}

.mdi-car-hatchback::before {
  content: "\\F07A9";
}

.mdi-car-info::before {
  content: "\\F11BE";
}

.mdi-car-key::before {
  content: "\\F0B6D";
}

.mdi-car-lifted-pickup::before {
  content: "\\F152D";
}

.mdi-car-light-alert::before {
  content: "\\F190D";
}

.mdi-car-light-dimmed::before {
  content: "\\F0C4A";
}

.mdi-car-light-fog::before {
  content: "\\F0C4B";
}

.mdi-car-light-high::before {
  content: "\\F0C4C";
}

.mdi-car-limousine::before {
  content: "\\F08CD";
}

.mdi-car-multiple::before {
  content: "\\F0B6E";
}

.mdi-car-off::before {
  content: "\\F0E1C";
}

.mdi-car-outline::before {
  content: "\\F14ED";
}

.mdi-car-parking-lights::before {
  content: "\\F0D63";
}

.mdi-car-pickup::before {
  content: "\\F07AA";
}

.mdi-car-search::before {
  content: "\\F1B8D";
}

.mdi-car-search-outline::before {
  content: "\\F1B8E";
}

.mdi-car-seat::before {
  content: "\\F0FA4";
}

.mdi-car-seat-cooler::before {
  content: "\\F0FA5";
}

.mdi-car-seat-heater::before {
  content: "\\F0FA6";
}

.mdi-car-select::before {
  content: "\\F1879";
}

.mdi-car-settings::before {
  content: "\\F13CD";
}

.mdi-car-shift-pattern::before {
  content: "\\F0F40";
}

.mdi-car-side::before {
  content: "\\F07AB";
}

.mdi-car-speed-limiter::before {
  content: "\\F190E";
}

.mdi-car-sports::before {
  content: "\\F07AC";
}

.mdi-car-tire-alert::before {
  content: "\\F0C4D";
}

.mdi-car-traction-control::before {
  content: "\\F0D64";
}

.mdi-car-turbocharger::before {
  content: "\\F101A";
}

.mdi-car-wash::before {
  content: "\\F010E";
}

.mdi-car-windshield::before {
  content: "\\F101B";
}

.mdi-car-windshield-outline::before {
  content: "\\F101C";
}

.mdi-car-wireless::before {
  content: "\\F1878";
}

.mdi-car-wrench::before {
  content: "\\F1814";
}

.mdi-carabiner::before {
  content: "\\F14C0";
}

.mdi-caravan::before {
  content: "\\F07AD";
}

.mdi-card::before {
  content: "\\F0B6F";
}

.mdi-card-account-details::before {
  content: "\\F05D2";
}

.mdi-card-account-details-outline::before {
  content: "\\F0DAB";
}

.mdi-card-account-details-star::before {
  content: "\\F02A3";
}

.mdi-card-account-details-star-outline::before {
  content: "\\F06DB";
}

.mdi-card-account-mail::before {
  content: "\\F018E";
}

.mdi-card-account-mail-outline::before {
  content: "\\F0E98";
}

.mdi-card-account-phone::before {
  content: "\\F0E99";
}

.mdi-card-account-phone-outline::before {
  content: "\\F0E9A";
}

.mdi-card-bulleted::before {
  content: "\\F0B70";
}

.mdi-card-bulleted-off::before {
  content: "\\F0B71";
}

.mdi-card-bulleted-off-outline::before {
  content: "\\F0B72";
}

.mdi-card-bulleted-outline::before {
  content: "\\F0B73";
}

.mdi-card-bulleted-settings::before {
  content: "\\F0B74";
}

.mdi-card-bulleted-settings-outline::before {
  content: "\\F0B75";
}

.mdi-card-minus::before {
  content: "\\F1600";
}

.mdi-card-minus-outline::before {
  content: "\\F1601";
}

.mdi-card-multiple::before {
  content: "\\F17F1";
}

.mdi-card-multiple-outline::before {
  content: "\\F17F2";
}

.mdi-card-off::before {
  content: "\\F1602";
}

.mdi-card-off-outline::before {
  content: "\\F1603";
}

.mdi-card-outline::before {
  content: "\\F0B76";
}

.mdi-card-plus::before {
  content: "\\F11FF";
}

.mdi-card-plus-outline::before {
  content: "\\F1200";
}

.mdi-card-remove::before {
  content: "\\F1604";
}

.mdi-card-remove-outline::before {
  content: "\\F1605";
}

.mdi-card-search::before {
  content: "\\F1074";
}

.mdi-card-search-outline::before {
  content: "\\F1075";
}

.mdi-card-text::before {
  content: "\\F0B77";
}

.mdi-card-text-outline::before {
  content: "\\F0B78";
}

.mdi-cards::before {
  content: "\\F0638";
}

.mdi-cards-club::before {
  content: "\\F08CE";
}

.mdi-cards-club-outline::before {
  content: "\\F189F";
}

.mdi-cards-diamond::before {
  content: "\\F08CF";
}

.mdi-cards-diamond-outline::before {
  content: "\\F101D";
}

.mdi-cards-heart::before {
  content: "\\F08D0";
}

.mdi-cards-heart-outline::before {
  content: "\\F18A0";
}

.mdi-cards-outline::before {
  content: "\\F0639";
}

.mdi-cards-playing::before {
  content: "\\F18A1";
}

.mdi-cards-playing-club::before {
  content: "\\F18A2";
}

.mdi-cards-playing-club-multiple::before {
  content: "\\F18A3";
}

.mdi-cards-playing-club-multiple-outline::before {
  content: "\\F18A4";
}

.mdi-cards-playing-club-outline::before {
  content: "\\F18A5";
}

.mdi-cards-playing-diamond::before {
  content: "\\F18A6";
}

.mdi-cards-playing-diamond-multiple::before {
  content: "\\F18A7";
}

.mdi-cards-playing-diamond-multiple-outline::before {
  content: "\\F18A8";
}

.mdi-cards-playing-diamond-outline::before {
  content: "\\F18A9";
}

.mdi-cards-playing-heart::before {
  content: "\\F18AA";
}

.mdi-cards-playing-heart-multiple::before {
  content: "\\F18AB";
}

.mdi-cards-playing-heart-multiple-outline::before {
  content: "\\F18AC";
}

.mdi-cards-playing-heart-outline::before {
  content: "\\F18AD";
}

.mdi-cards-playing-outline::before {
  content: "\\F063A";
}

.mdi-cards-playing-spade::before {
  content: "\\F18AE";
}

.mdi-cards-playing-spade-multiple::before {
  content: "\\F18AF";
}

.mdi-cards-playing-spade-multiple-outline::before {
  content: "\\F18B0";
}

.mdi-cards-playing-spade-outline::before {
  content: "\\F18B1";
}

.mdi-cards-spade::before {
  content: "\\F08D1";
}

.mdi-cards-spade-outline::before {
  content: "\\F18B2";
}

.mdi-cards-variant::before {
  content: "\\F06C7";
}

.mdi-carrot::before {
  content: "\\F010F";
}

.mdi-cart::before {
  content: "\\F0110";
}

.mdi-cart-arrow-down::before {
  content: "\\F0D66";
}

.mdi-cart-arrow-right::before {
  content: "\\F0C4E";
}

.mdi-cart-arrow-up::before {
  content: "\\F0D67";
}

.mdi-cart-check::before {
  content: "\\F15EA";
}

.mdi-cart-heart::before {
  content: "\\F18E0";
}

.mdi-cart-minus::before {
  content: "\\F0D68";
}

.mdi-cart-off::before {
  content: "\\F066B";
}

.mdi-cart-outline::before {
  content: "\\F0111";
}

.mdi-cart-percent::before {
  content: "\\F1BAE";
}

.mdi-cart-plus::before {
  content: "\\F0112";
}

.mdi-cart-remove::before {
  content: "\\F0D69";
}

.mdi-cart-variant::before {
  content: "\\F15EB";
}

.mdi-case-sensitive-alt::before {
  content: "\\F0113";
}

.mdi-cash::before {
  content: "\\F0114";
}

.mdi-cash-100::before {
  content: "\\F0115";
}

.mdi-cash-check::before {
  content: "\\F14EE";
}

.mdi-cash-clock::before {
  content: "\\F1A91";
}

.mdi-cash-edit::before {
  content: "\\F1CAB";
}

.mdi-cash-fast::before {
  content: "\\F185C";
}

.mdi-cash-lock::before {
  content: "\\F14EA";
}

.mdi-cash-lock-open::before {
  content: "\\F14EB";
}

.mdi-cash-marker::before {
  content: "\\F0DB8";
}

.mdi-cash-minus::before {
  content: "\\F1260";
}

.mdi-cash-multiple::before {
  content: "\\F0116";
}

.mdi-cash-off::before {
  content: "\\F1C79";
}

.mdi-cash-plus::before {
  content: "\\F1261";
}

.mdi-cash-refund::before {
  content: "\\F0A9C";
}

.mdi-cash-register::before {
  content: "\\F0CF4";
}

.mdi-cash-remove::before {
  content: "\\F1262";
}

.mdi-cash-sync::before {
  content: "\\F1A92";
}

.mdi-cassette::before {
  content: "\\F09D4";
}

.mdi-cast::before {
  content: "\\F0118";
}

.mdi-cast-audio::before {
  content: "\\F101E";
}

.mdi-cast-audio-variant::before {
  content: "\\F1749";
}

.mdi-cast-connected::before {
  content: "\\F0119";
}

.mdi-cast-education::before {
  content: "\\F0E1D";
}

.mdi-cast-off::before {
  content: "\\F078A";
}

.mdi-cast-variant::before {
  content: "\\F001F";
}

.mdi-castle::before {
  content: "\\F011A";
}

.mdi-cat::before {
  content: "\\F011B";
}

.mdi-cctv::before {
  content: "\\F07AE";
}

.mdi-cctv-off::before {
  content: "\\F185F";
}

.mdi-ceiling-fan::before {
  content: "\\F1797";
}

.mdi-ceiling-fan-light::before {
  content: "\\F1798";
}

.mdi-ceiling-light::before {
  content: "\\F0769";
}

.mdi-ceiling-light-multiple::before {
  content: "\\F18DD";
}

.mdi-ceiling-light-multiple-outline::before {
  content: "\\F18DE";
}

.mdi-ceiling-light-outline::before {
  content: "\\F17C7";
}

.mdi-cellphone::before {
  content: "\\F011C";
}

.mdi-cellphone-arrow-down::before {
  content: "\\F09D5";
}

.mdi-cellphone-arrow-down-variant::before {
  content: "\\F19C5";
}

.mdi-cellphone-basic::before {
  content: "\\F011E";
}

.mdi-cellphone-charging::before {
  content: "\\F1397";
}

.mdi-cellphone-check::before {
  content: "\\F17FD";
}

.mdi-cellphone-cog::before {
  content: "\\F0951";
}

.mdi-cellphone-dock::before {
  content: "\\F011F";
}

.mdi-cellphone-information::before {
  content: "\\F0F41";
}

.mdi-cellphone-key::before {
  content: "\\F094E";
}

.mdi-cellphone-link::before {
  content: "\\F0121";
}

.mdi-cellphone-link-off::before {
  content: "\\F0122";
}

.mdi-cellphone-lock::before {
  content: "\\F094F";
}

.mdi-cellphone-marker::before {
  content: "\\F183A";
}

.mdi-cellphone-message::before {
  content: "\\F08D3";
}

.mdi-cellphone-message-off::before {
  content: "\\F10D2";
}

.mdi-cellphone-nfc::before {
  content: "\\F0E90";
}

.mdi-cellphone-nfc-off::before {
  content: "\\F12D8";
}

.mdi-cellphone-off::before {
  content: "\\F0950";
}

.mdi-cellphone-play::before {
  content: "\\F101F";
}

.mdi-cellphone-remove::before {
  content: "\\F094D";
}

.mdi-cellphone-screenshot::before {
  content: "\\F0A35";
}

.mdi-cellphone-settings::before {
  content: "\\F0123";
}

.mdi-cellphone-sound::before {
  content: "\\F0952";
}

.mdi-cellphone-text::before {
  content: "\\F08D2";
}

.mdi-cellphone-wireless::before {
  content: "\\F0815";
}

.mdi-centos::before {
  content: "\\F111A";
}

.mdi-certificate::before {
  content: "\\F0124";
}

.mdi-certificate-outline::before {
  content: "\\F1188";
}

.mdi-chair-rolling::before {
  content: "\\F0F48";
}

.mdi-chair-school::before {
  content: "\\F0125";
}

.mdi-chandelier::before {
  content: "\\F1793";
}

.mdi-charity::before {
  content: "\\F0C4F";
}

.mdi-charity-search::before {
  content: "\\F1C82";
}

.mdi-chart-arc::before {
  content: "\\F0126";
}

.mdi-chart-areaspline::before {
  content: "\\F0127";
}

.mdi-chart-areaspline-variant::before {
  content: "\\F0E91";
}

.mdi-chart-bar::before {
  content: "\\F0128";
}

.mdi-chart-bar-stacked::before {
  content: "\\F076A";
}

.mdi-chart-bell-curve::before {
  content: "\\F0C50";
}

.mdi-chart-bell-curve-cumulative::before {
  content: "\\F0FA7";
}

.mdi-chart-box::before {
  content: "\\F154D";
}

.mdi-chart-box-multiple::before {
  content: "\\F1CCD";
}

.mdi-chart-box-multiple-outline::before {
  content: "\\F1CCE";
}

.mdi-chart-box-outline::before {
  content: "\\F154E";
}

.mdi-chart-box-plus-outline::before {
  content: "\\F154F";
}

.mdi-chart-bubble::before {
  content: "\\F05E3";
}

.mdi-chart-donut::before {
  content: "\\F07AF";
}

.mdi-chart-donut-variant::before {
  content: "\\F07B0";
}

.mdi-chart-gantt::before {
  content: "\\F066C";
}

.mdi-chart-histogram::before {
  content: "\\F0129";
}

.mdi-chart-line::before {
  content: "\\F012A";
}

.mdi-chart-line-stacked::before {
  content: "\\F076B";
}

.mdi-chart-line-variant::before {
  content: "\\F07B1";
}

.mdi-chart-multiline::before {
  content: "\\F08D4";
}

.mdi-chart-multiple::before {
  content: "\\F1213";
}

.mdi-chart-pie::before {
  content: "\\F012B";
}

.mdi-chart-pie-outline::before {
  content: "\\F1BDF";
}

.mdi-chart-ppf::before {
  content: "\\F1380";
}

.mdi-chart-sankey::before {
  content: "\\F11DF";
}

.mdi-chart-sankey-variant::before {
  content: "\\F11E0";
}

.mdi-chart-scatter-plot::before {
  content: "\\F0E92";
}

.mdi-chart-scatter-plot-hexbin::before {
  content: "\\F066D";
}

.mdi-chart-timeline::before {
  content: "\\F066E";
}

.mdi-chart-timeline-variant::before {
  content: "\\F0E93";
}

.mdi-chart-timeline-variant-shimmer::before {
  content: "\\F15B6";
}

.mdi-chart-tree::before {
  content: "\\F0E94";
}

.mdi-chart-waterfall::before {
  content: "\\F1918";
}

.mdi-chat::before {
  content: "\\F0B79";
}

.mdi-chat-alert::before {
  content: "\\F0B7A";
}

.mdi-chat-alert-outline::before {
  content: "\\F12C9";
}

.mdi-chat-minus::before {
  content: "\\F1410";
}

.mdi-chat-minus-outline::before {
  content: "\\F1413";
}

.mdi-chat-outline::before {
  content: "\\F0EDE";
}

.mdi-chat-plus::before {
  content: "\\F140F";
}

.mdi-chat-plus-outline::before {
  content: "\\F1412";
}

.mdi-chat-processing::before {
  content: "\\F0B7B";
}

.mdi-chat-processing-outline::before {
  content: "\\F12CA";
}

.mdi-chat-question::before {
  content: "\\F1738";
}

.mdi-chat-question-outline::before {
  content: "\\F1739";
}

.mdi-chat-remove::before {
  content: "\\F1411";
}

.mdi-chat-remove-outline::before {
  content: "\\F1414";
}

.mdi-chat-sleep::before {
  content: "\\F12D1";
}

.mdi-chat-sleep-outline::before {
  content: "\\F12D2";
}

.mdi-check::before {
  content: "\\F012C";
}

.mdi-check-all::before {
  content: "\\F012D";
}

.mdi-check-bold::before {
  content: "\\F0E1E";
}

.mdi-check-circle::before {
  content: "\\F05E0";
}

.mdi-check-circle-outline::before {
  content: "\\F05E1";
}

.mdi-check-decagram::before {
  content: "\\F0791";
}

.mdi-check-decagram-outline::before {
  content: "\\F1740";
}

.mdi-check-network::before {
  content: "\\F0C53";
}

.mdi-check-network-outline::before {
  content: "\\F0C54";
}

.mdi-check-outline::before {
  content: "\\F0855";
}

.mdi-check-underline::before {
  content: "\\F0E1F";
}

.mdi-check-underline-circle::before {
  content: "\\F0E20";
}

.mdi-check-underline-circle-outline::before {
  content: "\\F0E21";
}

.mdi-checkbook::before {
  content: "\\F0A9D";
}

.mdi-checkbook-arrow-left::before {
  content: "\\F1C1D";
}

.mdi-checkbook-arrow-right::before {
  content: "\\F1C1E";
}

.mdi-checkbox-blank::before {
  content: "\\F012E";
}

.mdi-checkbox-blank-badge::before {
  content: "\\F1176";
}

.mdi-checkbox-blank-badge-outline::before {
  content: "\\F0117";
}

.mdi-checkbox-blank-circle::before {
  content: "\\F012F";
}

.mdi-checkbox-blank-circle-outline::before {
  content: "\\F0130";
}

.mdi-checkbox-blank-off::before {
  content: "\\F12EC";
}

.mdi-checkbox-blank-off-outline::before {
  content: "\\F12ED";
}

.mdi-checkbox-blank-outline::before {
  content: "\\F0131";
}

.mdi-checkbox-intermediate::before {
  content: "\\F0856";
}

.mdi-checkbox-intermediate-variant::before {
  content: "\\F1B54";
}

.mdi-checkbox-marked::before {
  content: "\\F0132";
}

.mdi-checkbox-marked-circle::before {
  content: "\\F0133";
}

.mdi-checkbox-marked-circle-auto-outline::before {
  content: "\\F1C26";
}

.mdi-checkbox-marked-circle-minus-outline::before {
  content: "\\F1C27";
}

.mdi-checkbox-marked-circle-outline::before {
  content: "\\F0134";
}

.mdi-checkbox-marked-circle-plus-outline::before {
  content: "\\F1927";
}

.mdi-checkbox-marked-outline::before {
  content: "\\F0135";
}

.mdi-checkbox-multiple-blank::before {
  content: "\\F0136";
}

.mdi-checkbox-multiple-blank-circle::before {
  content: "\\F063B";
}

.mdi-checkbox-multiple-blank-circle-outline::before {
  content: "\\F063C";
}

.mdi-checkbox-multiple-blank-outline::before {
  content: "\\F0137";
}

.mdi-checkbox-multiple-marked::before {
  content: "\\F0138";
}

.mdi-checkbox-multiple-marked-circle::before {
  content: "\\F063D";
}

.mdi-checkbox-multiple-marked-circle-outline::before {
  content: "\\F063E";
}

.mdi-checkbox-multiple-marked-outline::before {
  content: "\\F0139";
}

.mdi-checkbox-multiple-outline::before {
  content: "\\F0C51";
}

.mdi-checkbox-outline::before {
  content: "\\F0C52";
}

.mdi-checkerboard::before {
  content: "\\F013A";
}

.mdi-checkerboard-minus::before {
  content: "\\F1202";
}

.mdi-checkerboard-plus::before {
  content: "\\F1201";
}

.mdi-checkerboard-remove::before {
  content: "\\F1203";
}

.mdi-cheese::before {
  content: "\\F12B9";
}

.mdi-cheese-off::before {
  content: "\\F13EE";
}

.mdi-chef-hat::before {
  content: "\\F0B7C";
}

.mdi-chemical-weapon::before {
  content: "\\F013B";
}

.mdi-chess-bishop::before {
  content: "\\F085C";
}

.mdi-chess-king::before {
  content: "\\F0857";
}

.mdi-chess-knight::before {
  content: "\\F0858";
}

.mdi-chess-pawn::before {
  content: "\\F0859";
}

.mdi-chess-queen::before {
  content: "\\F085A";
}

.mdi-chess-rook::before {
  content: "\\F085B";
}

.mdi-chevron-double-down::before {
  content: "\\F013C";
}

.mdi-chevron-double-left::before {
  content: "\\F013D";
}

.mdi-chevron-double-right::before {
  content: "\\F013E";
}

.mdi-chevron-double-up::before {
  content: "\\F013F";
}

.mdi-chevron-down::before {
  content: "\\F0140";
}

.mdi-chevron-down-box::before {
  content: "\\F09D6";
}

.mdi-chevron-down-box-outline::before {
  content: "\\F09D7";
}

.mdi-chevron-down-circle::before {
  content: "\\F0B26";
}

.mdi-chevron-down-circle-outline::before {
  content: "\\F0B27";
}

.mdi-chevron-left::before {
  content: "\\F0141";
}

.mdi-chevron-left-box::before {
  content: "\\F09D8";
}

.mdi-chevron-left-box-outline::before {
  content: "\\F09D9";
}

.mdi-chevron-left-circle::before {
  content: "\\F0B28";
}

.mdi-chevron-left-circle-outline::before {
  content: "\\F0B29";
}

.mdi-chevron-right::before {
  content: "\\F0142";
}

.mdi-chevron-right-box::before {
  content: "\\F09DA";
}

.mdi-chevron-right-box-outline::before {
  content: "\\F09DB";
}

.mdi-chevron-right-circle::before {
  content: "\\F0B2A";
}

.mdi-chevron-right-circle-outline::before {
  content: "\\F0B2B";
}

.mdi-chevron-triple-down::before {
  content: "\\F0DB9";
}

.mdi-chevron-triple-left::before {
  content: "\\F0DBA";
}

.mdi-chevron-triple-right::before {
  content: "\\F0DBB";
}

.mdi-chevron-triple-up::before {
  content: "\\F0DBC";
}

.mdi-chevron-up::before {
  content: "\\F0143";
}

.mdi-chevron-up-box::before {
  content: "\\F09DC";
}

.mdi-chevron-up-box-outline::before {
  content: "\\F09DD";
}

.mdi-chevron-up-circle::before {
  content: "\\F0B2C";
}

.mdi-chevron-up-circle-outline::before {
  content: "\\F0B2D";
}

.mdi-chili-alert::before {
  content: "\\F17EA";
}

.mdi-chili-alert-outline::before {
  content: "\\F17EB";
}

.mdi-chili-hot::before {
  content: "\\F07B2";
}

.mdi-chili-hot-outline::before {
  content: "\\F17EC";
}

.mdi-chili-medium::before {
  content: "\\F07B3";
}

.mdi-chili-medium-outline::before {
  content: "\\F17ED";
}

.mdi-chili-mild::before {
  content: "\\F07B4";
}

.mdi-chili-mild-outline::before {
  content: "\\F17EE";
}

.mdi-chili-off::before {
  content: "\\F1467";
}

.mdi-chili-off-outline::before {
  content: "\\F17EF";
}

.mdi-chip::before {
  content: "\\F061A";
}

.mdi-church::before {
  content: "\\F0144";
}

.mdi-church-outline::before {
  content: "\\F1B02";
}

.mdi-cigar::before {
  content: "\\F1189";
}

.mdi-cigar-off::before {
  content: "\\F141B";
}

.mdi-circle::before {
  content: "\\F0765";
}

.mdi-circle-box::before {
  content: "\\F15DC";
}

.mdi-circle-box-outline::before {
  content: "\\F15DD";
}

.mdi-circle-double::before {
  content: "\\F0E95";
}

.mdi-circle-edit-outline::before {
  content: "\\F08D5";
}

.mdi-circle-expand::before {
  content: "\\F0E96";
}

.mdi-circle-half::before {
  content: "\\F1395";
}

.mdi-circle-half-full::before {
  content: "\\F1396";
}

.mdi-circle-medium::before {
  content: "\\F09DE";
}

.mdi-circle-multiple::before {
  content: "\\F0B38";
}

.mdi-circle-multiple-outline::before {
  content: "\\F0695";
}

.mdi-circle-off-outline::before {
  content: "\\F10D3";
}

.mdi-circle-opacity::before {
  content: "\\F1853";
}

.mdi-circle-outline::before {
  content: "\\F0766";
}

.mdi-circle-slice-1::before {
  content: "\\F0A9E";
}

.mdi-circle-slice-2::before {
  content: "\\F0A9F";
}

.mdi-circle-slice-3::before {
  content: "\\F0AA0";
}

.mdi-circle-slice-4::before {
  content: "\\F0AA1";
}

.mdi-circle-slice-5::before {
  content: "\\F0AA2";
}

.mdi-circle-slice-6::before {
  content: "\\F0AA3";
}

.mdi-circle-slice-7::before {
  content: "\\F0AA4";
}

.mdi-circle-slice-8::before {
  content: "\\F0AA5";
}

.mdi-circle-small::before {
  content: "\\F09DF";
}

.mdi-circular-saw::before {
  content: "\\F0E22";
}

.mdi-city::before {
  content: "\\F0146";
}

.mdi-city-switch::before {
  content: "\\F1C28";
}

.mdi-city-variant::before {
  content: "\\F0A36";
}

.mdi-city-variant-outline::before {
  content: "\\F0A37";
}

.mdi-clipboard::before {
  content: "\\F0147";
}

.mdi-clipboard-account::before {
  content: "\\F0148";
}

.mdi-clipboard-account-outline::before {
  content: "\\F0C55";
}

.mdi-clipboard-alert::before {
  content: "\\F0149";
}

.mdi-clipboard-alert-outline::before {
  content: "\\F0CF7";
}

.mdi-clipboard-arrow-down::before {
  content: "\\F014A";
}

.mdi-clipboard-arrow-down-outline::before {
  content: "\\F0C56";
}

.mdi-clipboard-arrow-left::before {
  content: "\\F014B";
}

.mdi-clipboard-arrow-left-outline::before {
  content: "\\F0CF8";
}

.mdi-clipboard-arrow-right::before {
  content: "\\F0CF9";
}

.mdi-clipboard-arrow-right-outline::before {
  content: "\\F0CFA";
}

.mdi-clipboard-arrow-up::before {
  content: "\\F0C57";
}

.mdi-clipboard-arrow-up-outline::before {
  content: "\\F0C58";
}

.mdi-clipboard-check::before {
  content: "\\F014E";
}

.mdi-clipboard-check-multiple::before {
  content: "\\F1263";
}

.mdi-clipboard-check-multiple-outline::before {
  content: "\\F1264";
}

.mdi-clipboard-check-outline::before {
  content: "\\F08A8";
}

.mdi-clipboard-clock::before {
  content: "\\F16E2";
}

.mdi-clipboard-clock-outline::before {
  content: "\\F16E3";
}

.mdi-clipboard-edit::before {
  content: "\\F14E5";
}

.mdi-clipboard-edit-outline::before {
  content: "\\F14E6";
}

.mdi-clipboard-file::before {
  content: "\\F1265";
}

.mdi-clipboard-file-outline::before {
  content: "\\F1266";
}

.mdi-clipboard-flow::before {
  content: "\\F06C8";
}

.mdi-clipboard-flow-outline::before {
  content: "\\F1117";
}

.mdi-clipboard-list::before {
  content: "\\F10D4";
}

.mdi-clipboard-list-outline::before {
  content: "\\F10D5";
}

.mdi-clipboard-minus::before {
  content: "\\F1618";
}

.mdi-clipboard-minus-outline::before {
  content: "\\F1619";
}

.mdi-clipboard-multiple::before {
  content: "\\F1267";
}

.mdi-clipboard-multiple-outline::before {
  content: "\\F1268";
}

.mdi-clipboard-off::before {
  content: "\\F161A";
}

.mdi-clipboard-off-outline::before {
  content: "\\F161B";
}

.mdi-clipboard-outline::before {
  content: "\\F014C";
}

.mdi-clipboard-play::before {
  content: "\\F0C59";
}

.mdi-clipboard-play-multiple::before {
  content: "\\F1269";
}

.mdi-clipboard-play-multiple-outline::before {
  content: "\\F126A";
}

.mdi-clipboard-play-outline::before {
  content: "\\F0C5A";
}

.mdi-clipboard-plus::before {
  content: "\\F0751";
}

.mdi-clipboard-plus-outline::before {
  content: "\\F131F";
}

.mdi-clipboard-pulse::before {
  content: "\\F085D";
}

.mdi-clipboard-pulse-outline::before {
  content: "\\F085E";
}

.mdi-clipboard-remove::before {
  content: "\\F161C";
}

.mdi-clipboard-remove-outline::before {
  content: "\\F161D";
}

.mdi-clipboard-search::before {
  content: "\\F161E";
}

.mdi-clipboard-search-outline::before {
  content: "\\F161F";
}

.mdi-clipboard-text::before {
  content: "\\F014D";
}

.mdi-clipboard-text-clock::before {
  content: "\\F18F9";
}

.mdi-clipboard-text-clock-outline::before {
  content: "\\F18FA";
}

.mdi-clipboard-text-multiple::before {
  content: "\\F126B";
}

.mdi-clipboard-text-multiple-outline::before {
  content: "\\F126C";
}

.mdi-clipboard-text-off::before {
  content: "\\F1620";
}

.mdi-clipboard-text-off-outline::before {
  content: "\\F1621";
}

.mdi-clipboard-text-outline::before {
  content: "\\F0A38";
}

.mdi-clipboard-text-play::before {
  content: "\\F0C5B";
}

.mdi-clipboard-text-play-outline::before {
  content: "\\F0C5C";
}

.mdi-clipboard-text-search::before {
  content: "\\F1622";
}

.mdi-clipboard-text-search-outline::before {
  content: "\\F1623";
}

.mdi-clippy::before {
  content: "\\F014F";
}

.mdi-clock::before {
  content: "\\F0954";
}

.mdi-clock-alert::before {
  content: "\\F0955";
}

.mdi-clock-alert-outline::before {
  content: "\\F05CE";
}

.mdi-clock-check::before {
  content: "\\F0FA8";
}

.mdi-clock-check-outline::before {
  content: "\\F0FA9";
}

.mdi-clock-digital::before {
  content: "\\F0E97";
}

.mdi-clock-edit::before {
  content: "\\F19BA";
}

.mdi-clock-edit-outline::before {
  content: "\\F19BB";
}

.mdi-clock-end::before {
  content: "\\F0151";
}

.mdi-clock-fast::before {
  content: "\\F0152";
}

.mdi-clock-in::before {
  content: "\\F0153";
}

.mdi-clock-minus::before {
  content: "\\F1863";
}

.mdi-clock-minus-outline::before {
  content: "\\F1864";
}

.mdi-clock-out::before {
  content: "\\F0154";
}

.mdi-clock-outline::before {
  content: "\\F0150";
}

.mdi-clock-plus::before {
  content: "\\F1861";
}

.mdi-clock-plus-outline::before {
  content: "\\F1862";
}

.mdi-clock-remove::before {
  content: "\\F1865";
}

.mdi-clock-remove-outline::before {
  content: "\\F1866";
}

.mdi-clock-star-four-points::before {
  content: "\\F1C29";
}

.mdi-clock-star-four-points-outline::before {
  content: "\\F1C2A";
}

.mdi-clock-start::before {
  content: "\\F0155";
}

.mdi-clock-time-eight::before {
  content: "\\F1446";
}

.mdi-clock-time-eight-outline::before {
  content: "\\F1452";
}

.mdi-clock-time-eleven::before {
  content: "\\F1449";
}

.mdi-clock-time-eleven-outline::before {
  content: "\\F1455";
}

.mdi-clock-time-five::before {
  content: "\\F1443";
}

.mdi-clock-time-five-outline::before {
  content: "\\F144F";
}

.mdi-clock-time-four::before {
  content: "\\F1442";
}

.mdi-clock-time-four-outline::before {
  content: "\\F144E";
}

.mdi-clock-time-nine::before {
  content: "\\F1447";
}

.mdi-clock-time-nine-outline::before {
  content: "\\F1453";
}

.mdi-clock-time-one::before {
  content: "\\F143F";
}

.mdi-clock-time-one-outline::before {
  content: "\\F144B";
}

.mdi-clock-time-seven::before {
  content: "\\F1445";
}

.mdi-clock-time-seven-outline::before {
  content: "\\F1451";
}

.mdi-clock-time-six::before {
  content: "\\F1444";
}

.mdi-clock-time-six-outline::before {
  content: "\\F1450";
}

.mdi-clock-time-ten::before {
  content: "\\F1448";
}

.mdi-clock-time-ten-outline::before {
  content: "\\F1454";
}

.mdi-clock-time-three::before {
  content: "\\F1441";
}

.mdi-clock-time-three-outline::before {
  content: "\\F144D";
}

.mdi-clock-time-twelve::before {
  content: "\\F144A";
}

.mdi-clock-time-twelve-outline::before {
  content: "\\F1456";
}

.mdi-clock-time-two::before {
  content: "\\F1440";
}

.mdi-clock-time-two-outline::before {
  content: "\\F144C";
}

.mdi-close::before {
  content: "\\F0156";
}

.mdi-close-box::before {
  content: "\\F0157";
}

.mdi-close-box-multiple::before {
  content: "\\F0C5D";
}

.mdi-close-box-multiple-outline::before {
  content: "\\F0C5E";
}

.mdi-close-box-outline::before {
  content: "\\F0158";
}

.mdi-close-circle::before {
  content: "\\F0159";
}

.mdi-close-circle-multiple::before {
  content: "\\F062A";
}

.mdi-close-circle-multiple-outline::before {
  content: "\\F0883";
}

.mdi-close-circle-outline::before {
  content: "\\F015A";
}

.mdi-close-network::before {
  content: "\\F015B";
}

.mdi-close-network-outline::before {
  content: "\\F0C5F";
}

.mdi-close-octagon::before {
  content: "\\F015C";
}

.mdi-close-octagon-outline::before {
  content: "\\F015D";
}

.mdi-close-outline::before {
  content: "\\F06C9";
}

.mdi-close-thick::before {
  content: "\\F1398";
}

.mdi-closed-caption::before {
  content: "\\F015E";
}

.mdi-closed-caption-outline::before {
  content: "\\F0DBD";
}

.mdi-cloud::before {
  content: "\\F015F";
}

.mdi-cloud-alert::before {
  content: "\\F09E0";
}

.mdi-cloud-alert-outline::before {
  content: "\\F1BE0";
}

.mdi-cloud-arrow-down::before {
  content: "\\F1BE1";
}

.mdi-cloud-arrow-down-outline::before {
  content: "\\F1BE2";
}

.mdi-cloud-arrow-left::before {
  content: "\\F1BE3";
}

.mdi-cloud-arrow-left-outline::before {
  content: "\\F1BE4";
}

.mdi-cloud-arrow-right::before {
  content: "\\F1BE5";
}

.mdi-cloud-arrow-right-outline::before {
  content: "\\F1BE6";
}

.mdi-cloud-arrow-up::before {
  content: "\\F1BE7";
}

.mdi-cloud-arrow-up-outline::before {
  content: "\\F1BE8";
}

.mdi-cloud-braces::before {
  content: "\\F07B5";
}

.mdi-cloud-cancel::before {
  content: "\\F1BE9";
}

.mdi-cloud-cancel-outline::before {
  content: "\\F1BEA";
}

.mdi-cloud-check::before {
  content: "\\F1BEB";
}

.mdi-cloud-check-outline::before {
  content: "\\F1BEC";
}

.mdi-cloud-check-variant::before {
  content: "\\F0160";
}

.mdi-cloud-check-variant-outline::before {
  content: "\\F12CC";
}

.mdi-cloud-circle::before {
  content: "\\F0161";
}

.mdi-cloud-circle-outline::before {
  content: "\\F1BED";
}

.mdi-cloud-clock::before {
  content: "\\F1BEE";
}

.mdi-cloud-clock-outline::before {
  content: "\\F1BEF";
}

.mdi-cloud-cog::before {
  content: "\\F1BF0";
}

.mdi-cloud-cog-outline::before {
  content: "\\F1BF1";
}

.mdi-cloud-download::before {
  content: "\\F0162";
}

.mdi-cloud-download-outline::before {
  content: "\\F0B7D";
}

.mdi-cloud-key::before {
  content: "\\F1CA1";
}

.mdi-cloud-key-outline::before {
  content: "\\F1CA2";
}

.mdi-cloud-lock::before {
  content: "\\F11F1";
}

.mdi-cloud-lock-open::before {
  content: "\\F1BF2";
}

.mdi-cloud-lock-open-outline::before {
  content: "\\F1BF3";
}

.mdi-cloud-lock-outline::before {
  content: "\\F11F2";
}

.mdi-cloud-minus::before {
  content: "\\F1BF4";
}

.mdi-cloud-minus-outline::before {
  content: "\\F1BF5";
}

.mdi-cloud-off::before {
  content: "\\F1BF6";
}

.mdi-cloud-off-outline::before {
  content: "\\F0164";
}

.mdi-cloud-outline::before {
  content: "\\F0163";
}

.mdi-cloud-percent::before {
  content: "\\F1A35";
}

.mdi-cloud-percent-outline::before {
  content: "\\F1A36";
}

.mdi-cloud-plus::before {
  content: "\\F1BF7";
}

.mdi-cloud-plus-outline::before {
  content: "\\F1BF8";
}

.mdi-cloud-print::before {
  content: "\\F0165";
}

.mdi-cloud-print-outline::before {
  content: "\\F0166";
}

.mdi-cloud-question::before {
  content: "\\F0A39";
}

.mdi-cloud-question-outline::before {
  content: "\\F1BF9";
}

.mdi-cloud-refresh::before {
  content: "\\F1BFA";
}

.mdi-cloud-refresh-outline::before {
  content: "\\F1BFB";
}

.mdi-cloud-refresh-variant::before {
  content: "\\F052A";
}

.mdi-cloud-refresh-variant-outline::before {
  content: "\\F1BFC";
}

.mdi-cloud-remove::before {
  content: "\\F1BFD";
}

.mdi-cloud-remove-outline::before {
  content: "\\F1BFE";
}

.mdi-cloud-search::before {
  content: "\\F0956";
}

.mdi-cloud-search-outline::before {
  content: "\\F0957";
}

.mdi-cloud-sync::before {
  content: "\\F063F";
}

.mdi-cloud-sync-outline::before {
  content: "\\F12D6";
}

.mdi-cloud-tags::before {
  content: "\\F07B6";
}

.mdi-cloud-upload::before {
  content: "\\F0167";
}

.mdi-cloud-upload-outline::before {
  content: "\\F0B7E";
}

.mdi-clouds::before {
  content: "\\F1B95";
}

.mdi-clover::before {
  content: "\\F0816";
}

.mdi-clover-outline::before {
  content: "\\F1C62";
}

.mdi-coach-lamp::before {
  content: "\\F1020";
}

.mdi-coach-lamp-variant::before {
  content: "\\F1A37";
}

.mdi-coat-rack::before {
  content: "\\F109E";
}

.mdi-code-array::before {
  content: "\\F0168";
}

.mdi-code-block-braces::before {
  content: "\\F1C83";
}

.mdi-code-block-brackets::before {
  content: "\\F1C84";
}

.mdi-code-block-parentheses::before {
  content: "\\F1C85";
}

.mdi-code-block-tags::before {
  content: "\\F1C86";
}

.mdi-code-braces::before {
  content: "\\F0169";
}

.mdi-code-braces-box::before {
  content: "\\F10D6";
}

.mdi-code-brackets::before {
  content: "\\F016A";
}

.mdi-code-equal::before {
  content: "\\F016B";
}

.mdi-code-greater-than::before {
  content: "\\F016C";
}

.mdi-code-greater-than-or-equal::before {
  content: "\\F016D";
}

.mdi-code-json::before {
  content: "\\F0626";
}

.mdi-code-less-than::before {
  content: "\\F016E";
}

.mdi-code-less-than-or-equal::before {
  content: "\\F016F";
}

.mdi-code-not-equal::before {
  content: "\\F0170";
}

.mdi-code-not-equal-variant::before {
  content: "\\F0171";
}

.mdi-code-parentheses::before {
  content: "\\F0172";
}

.mdi-code-parentheses-box::before {
  content: "\\F10D7";
}

.mdi-code-string::before {
  content: "\\F0173";
}

.mdi-code-tags::before {
  content: "\\F0174";
}

.mdi-code-tags-check::before {
  content: "\\F0694";
}

.mdi-codepen::before {
  content: "\\F0175";
}

.mdi-coffee::before {
  content: "\\F0176";
}

.mdi-coffee-maker::before {
  content: "\\F109F";
}

.mdi-coffee-maker-check::before {
  content: "\\F1931";
}

.mdi-coffee-maker-check-outline::before {
  content: "\\F1932";
}

.mdi-coffee-maker-outline::before {
  content: "\\F181B";
}

.mdi-coffee-off::before {
  content: "\\F0FAA";
}

.mdi-coffee-off-outline::before {
  content: "\\F0FAB";
}

.mdi-coffee-outline::before {
  content: "\\F06CA";
}

.mdi-coffee-to-go::before {
  content: "\\F0177";
}

.mdi-coffee-to-go-outline::before {
  content: "\\F130E";
}

.mdi-coffin::before {
  content: "\\F0B7F";
}

.mdi-cog::before {
  content: "\\F0493";
}

.mdi-cog-box::before {
  content: "\\F0494";
}

.mdi-cog-clockwise::before {
  content: "\\F11DD";
}

.mdi-cog-counterclockwise::before {
  content: "\\F11DE";
}

.mdi-cog-off::before {
  content: "\\F13CE";
}

.mdi-cog-off-outline::before {
  content: "\\F13CF";
}

.mdi-cog-outline::before {
  content: "\\F08BB";
}

.mdi-cog-pause::before {
  content: "\\F1933";
}

.mdi-cog-pause-outline::before {
  content: "\\F1934";
}

.mdi-cog-play::before {
  content: "\\F1935";
}

.mdi-cog-play-outline::before {
  content: "\\F1936";
}

.mdi-cog-refresh::before {
  content: "\\F145E";
}

.mdi-cog-refresh-outline::before {
  content: "\\F145F";
}

.mdi-cog-stop::before {
  content: "\\F1937";
}

.mdi-cog-stop-outline::before {
  content: "\\F1938";
}

.mdi-cog-sync::before {
  content: "\\F1460";
}

.mdi-cog-sync-outline::before {
  content: "\\F1461";
}

.mdi-cog-transfer::before {
  content: "\\F105B";
}

.mdi-cog-transfer-outline::before {
  content: "\\F105C";
}

.mdi-cogs::before {
  content: "\\F08D6";
}

.mdi-collage::before {
  content: "\\F0640";
}

.mdi-collapse-all::before {
  content: "\\F0AA6";
}

.mdi-collapse-all-outline::before {
  content: "\\F0AA7";
}

.mdi-color-helper::before {
  content: "\\F0179";
}

.mdi-comma::before {
  content: "\\F0E23";
}

.mdi-comma-box::before {
  content: "\\F0E2B";
}

.mdi-comma-box-outline::before {
  content: "\\F0E24";
}

.mdi-comma-circle::before {
  content: "\\F0E25";
}

.mdi-comma-circle-outline::before {
  content: "\\F0E26";
}

.mdi-comment::before {
  content: "\\F017A";
}

.mdi-comment-account::before {
  content: "\\F017B";
}

.mdi-comment-account-outline::before {
  content: "\\F017C";
}

.mdi-comment-alert::before {
  content: "\\F017D";
}

.mdi-comment-alert-outline::before {
  content: "\\F017E";
}

.mdi-comment-arrow-left::before {
  content: "\\F09E1";
}

.mdi-comment-arrow-left-outline::before {
  content: "\\F09E2";
}

.mdi-comment-arrow-right::before {
  content: "\\F09E3";
}

.mdi-comment-arrow-right-outline::before {
  content: "\\F09E4";
}

.mdi-comment-bookmark::before {
  content: "\\F15AE";
}

.mdi-comment-bookmark-outline::before {
  content: "\\F15AF";
}

.mdi-comment-check::before {
  content: "\\F017F";
}

.mdi-comment-check-outline::before {
  content: "\\F0180";
}

.mdi-comment-edit::before {
  content: "\\F11BF";
}

.mdi-comment-edit-outline::before {
  content: "\\F12C4";
}

.mdi-comment-eye::before {
  content: "\\F0A3A";
}

.mdi-comment-eye-outline::before {
  content: "\\F0A3B";
}

.mdi-comment-flash::before {
  content: "\\F15B0";
}

.mdi-comment-flash-outline::before {
  content: "\\F15B1";
}

.mdi-comment-minus::before {
  content: "\\F15DF";
}

.mdi-comment-minus-outline::before {
  content: "\\F15E0";
}

.mdi-comment-multiple::before {
  content: "\\F085F";
}

.mdi-comment-multiple-outline::before {
  content: "\\F0181";
}

.mdi-comment-off::before {
  content: "\\F15E1";
}

.mdi-comment-off-outline::before {
  content: "\\F15E2";
}

.mdi-comment-outline::before {
  content: "\\F0182";
}

.mdi-comment-plus::before {
  content: "\\F09E5";
}

.mdi-comment-plus-outline::before {
  content: "\\F0183";
}

.mdi-comment-processing::before {
  content: "\\F0184";
}

.mdi-comment-processing-outline::before {
  content: "\\F0185";
}

.mdi-comment-question::before {
  content: "\\F0817";
}

.mdi-comment-question-outline::before {
  content: "\\F0186";
}

.mdi-comment-quote::before {
  content: "\\F1021";
}

.mdi-comment-quote-outline::before {
  content: "\\F1022";
}

.mdi-comment-remove::before {
  content: "\\F05DE";
}

.mdi-comment-remove-outline::before {
  content: "\\F0187";
}

.mdi-comment-search::before {
  content: "\\F0A3C";
}

.mdi-comment-search-outline::before {
  content: "\\F0A3D";
}

.mdi-comment-text::before {
  content: "\\F0188";
}

.mdi-comment-text-multiple::before {
  content: "\\F0860";
}

.mdi-comment-text-multiple-outline::before {
  content: "\\F0861";
}

.mdi-comment-text-outline::before {
  content: "\\F0189";
}

.mdi-compare::before {
  content: "\\F018A";
}

.mdi-compare-horizontal::before {
  content: "\\F1492";
}

.mdi-compare-remove::before {
  content: "\\F18B3";
}

.mdi-compare-vertical::before {
  content: "\\F1493";
}

.mdi-compass::before {
  content: "\\F018B";
}

.mdi-compass-off::before {
  content: "\\F0B80";
}

.mdi-compass-off-outline::before {
  content: "\\F0B81";
}

.mdi-compass-outline::before {
  content: "\\F018C";
}

.mdi-compass-rose::before {
  content: "\\F1382";
}

.mdi-compost::before {
  content: "\\F1A38";
}

.mdi-cone::before {
  content: "\\F194C";
}

.mdi-cone-off::before {
  content: "\\F194D";
}

.mdi-connection::before {
  content: "\\F1616";
}

.mdi-console::before {
  content: "\\F018D";
}

.mdi-console-line::before {
  content: "\\F07B7";
}

.mdi-console-network::before {
  content: "\\F08A9";
}

.mdi-console-network-outline::before {
  content: "\\F0C60";
}

.mdi-consolidate::before {
  content: "\\F10D8";
}

.mdi-contactless-payment::before {
  content: "\\F0D6A";
}

.mdi-contactless-payment-circle::before {
  content: "\\F0321";
}

.mdi-contactless-payment-circle-outline::before {
  content: "\\F0408";
}

.mdi-contacts::before {
  content: "\\F06CB";
}

.mdi-contacts-outline::before {
  content: "\\F05B8";
}

.mdi-contain::before {
  content: "\\F0A3E";
}

.mdi-contain-end::before {
  content: "\\F0A3F";
}

.mdi-contain-start::before {
  content: "\\F0A40";
}

.mdi-content-copy::before {
  content: "\\F018F";
}

.mdi-content-cut::before {
  content: "\\F0190";
}

.mdi-content-duplicate::before {
  content: "\\F0191";
}

.mdi-content-paste::before {
  content: "\\F0192";
}

.mdi-content-save::before {
  content: "\\F0193";
}

.mdi-content-save-alert::before {
  content: "\\F0F42";
}

.mdi-content-save-alert-outline::before {
  content: "\\F0F43";
}

.mdi-content-save-all::before {
  content: "\\F0194";
}

.mdi-content-save-all-outline::before {
  content: "\\F0F44";
}

.mdi-content-save-check::before {
  content: "\\F18EA";
}

.mdi-content-save-check-outline::before {
  content: "\\F18EB";
}

.mdi-content-save-cog::before {
  content: "\\F145B";
}

.mdi-content-save-cog-outline::before {
  content: "\\F145C";
}

.mdi-content-save-edit::before {
  content: "\\F0CFB";
}

.mdi-content-save-edit-outline::before {
  content: "\\F0CFC";
}

.mdi-content-save-minus::before {
  content: "\\F1B43";
}

.mdi-content-save-minus-outline::before {
  content: "\\F1B44";
}

.mdi-content-save-move::before {
  content: "\\F0E27";
}

.mdi-content-save-move-outline::before {
  content: "\\F0E28";
}

.mdi-content-save-off::before {
  content: "\\F1643";
}

.mdi-content-save-off-outline::before {
  content: "\\F1644";
}

.mdi-content-save-outline::before {
  content: "\\F0818";
}

.mdi-content-save-plus::before {
  content: "\\F1B41";
}

.mdi-content-save-plus-outline::before {
  content: "\\F1B42";
}

.mdi-content-save-settings::before {
  content: "\\F061B";
}

.mdi-content-save-settings-outline::before {
  content: "\\F0B2E";
}

.mdi-contrast::before {
  content: "\\F0195";
}

.mdi-contrast-box::before {
  content: "\\F0196";
}

.mdi-contrast-circle::before {
  content: "\\F0197";
}

.mdi-controller::before {
  content: "\\F02B4";
}

.mdi-controller-classic::before {
  content: "\\F0B82";
}

.mdi-controller-classic-outline::before {
  content: "\\F0B83";
}

.mdi-controller-off::before {
  content: "\\F02B5";
}

.mdi-cookie::before {
  content: "\\F0198";
}

.mdi-cookie-alert::before {
  content: "\\F16D0";
}

.mdi-cookie-alert-outline::before {
  content: "\\F16D1";
}

.mdi-cookie-check::before {
  content: "\\F16D2";
}

.mdi-cookie-check-outline::before {
  content: "\\F16D3";
}

.mdi-cookie-clock::before {
  content: "\\F16E4";
}

.mdi-cookie-clock-outline::before {
  content: "\\F16E5";
}

.mdi-cookie-cog::before {
  content: "\\F16D4";
}

.mdi-cookie-cog-outline::before {
  content: "\\F16D5";
}

.mdi-cookie-edit::before {
  content: "\\F16E6";
}

.mdi-cookie-edit-outline::before {
  content: "\\F16E7";
}

.mdi-cookie-lock::before {
  content: "\\F16E8";
}

.mdi-cookie-lock-outline::before {
  content: "\\F16E9";
}

.mdi-cookie-minus::before {
  content: "\\F16DA";
}

.mdi-cookie-minus-outline::before {
  content: "\\F16DB";
}

.mdi-cookie-off::before {
  content: "\\F16EA";
}

.mdi-cookie-off-outline::before {
  content: "\\F16EB";
}

.mdi-cookie-outline::before {
  content: "\\F16DE";
}

.mdi-cookie-plus::before {
  content: "\\F16D6";
}

.mdi-cookie-plus-outline::before {
  content: "\\F16D7";
}

.mdi-cookie-refresh::before {
  content: "\\F16EC";
}

.mdi-cookie-refresh-outline::before {
  content: "\\F16ED";
}

.mdi-cookie-remove::before {
  content: "\\F16D8";
}

.mdi-cookie-remove-outline::before {
  content: "\\F16D9";
}

.mdi-cookie-settings::before {
  content: "\\F16DC";
}

.mdi-cookie-settings-outline::before {
  content: "\\F16DD";
}

.mdi-coolant-temperature::before {
  content: "\\F03C8";
}

.mdi-copyleft::before {
  content: "\\F1939";
}

.mdi-copyright::before {
  content: "\\F05E6";
}

.mdi-cordova::before {
  content: "\\F0958";
}

.mdi-corn::before {
  content: "\\F07B8";
}

.mdi-corn-off::before {
  content: "\\F13EF";
}

.mdi-cosine-wave::before {
  content: "\\F1479";
}

.mdi-counter::before {
  content: "\\F0199";
}

.mdi-countertop::before {
  content: "\\F181C";
}

.mdi-countertop-outline::before {
  content: "\\F181D";
}

.mdi-cow::before {
  content: "\\F019A";
}

.mdi-cow-off::before {
  content: "\\F18FC";
}

.mdi-cpu-32-bit::before {
  content: "\\F0EDF";
}

.mdi-cpu-64-bit::before {
  content: "\\F0EE0";
}

.mdi-cradle::before {
  content: "\\F198B";
}

.mdi-cradle-outline::before {
  content: "\\F1991";
}

.mdi-crane::before {
  content: "\\F0862";
}

.mdi-creation::before {
  content: "\\F0674";
}

.mdi-creation-outline::before {
  content: "\\F1C2B";
}

.mdi-creative-commons::before {
  content: "\\F0D6B";
}

.mdi-credit-card::before {
  content: "\\F0FEF";
}

.mdi-credit-card-check::before {
  content: "\\F13D0";
}

.mdi-credit-card-check-outline::before {
  content: "\\F13D1";
}

.mdi-credit-card-chip::before {
  content: "\\F190F";
}

.mdi-credit-card-chip-outline::before {
  content: "\\F1910";
}

.mdi-credit-card-clock::before {
  content: "\\F0EE1";
}

.mdi-credit-card-clock-outline::before {
  content: "\\F0EE2";
}

.mdi-credit-card-edit::before {
  content: "\\F17D7";
}

.mdi-credit-card-edit-outline::before {
  content: "\\F17D8";
}

.mdi-credit-card-fast::before {
  content: "\\F1911";
}

.mdi-credit-card-fast-outline::before {
  content: "\\F1912";
}

.mdi-credit-card-lock::before {
  content: "\\F18E7";
}

.mdi-credit-card-lock-outline::before {
  content: "\\F18E8";
}

.mdi-credit-card-marker::before {
  content: "\\F06A8";
}

.mdi-credit-card-marker-outline::before {
  content: "\\F0DBE";
}

.mdi-credit-card-minus::before {
  content: "\\F0FAC";
}

.mdi-credit-card-minus-outline::before {
  content: "\\F0FAD";
}

.mdi-credit-card-multiple::before {
  content: "\\F0FF0";
}

.mdi-credit-card-multiple-outline::before {
  content: "\\F019C";
}

.mdi-credit-card-off::before {
  content: "\\F0FF1";
}

.mdi-credit-card-off-outline::before {
  content: "\\F05E4";
}

.mdi-credit-card-outline::before {
  content: "\\F019B";
}

.mdi-credit-card-plus::before {
  content: "\\F0FF2";
}

.mdi-credit-card-plus-outline::before {
  content: "\\F0676";
}

.mdi-credit-card-refresh::before {
  content: "\\F1645";
}

.mdi-credit-card-refresh-outline::before {
  content: "\\F1646";
}

.mdi-credit-card-refund::before {
  content: "\\F0FF3";
}

.mdi-credit-card-refund-outline::before {
  content: "\\F0AA8";
}

.mdi-credit-card-remove::before {
  content: "\\F0FAE";
}

.mdi-credit-card-remove-outline::before {
  content: "\\F0FAF";
}

.mdi-credit-card-scan::before {
  content: "\\F0FF4";
}

.mdi-credit-card-scan-outline::before {
  content: "\\F019D";
}

.mdi-credit-card-search::before {
  content: "\\F1647";
}

.mdi-credit-card-search-outline::before {
  content: "\\F1648";
}

.mdi-credit-card-settings::before {
  content: "\\F0FF5";
}

.mdi-credit-card-settings-outline::before {
  content: "\\F08D7";
}

.mdi-credit-card-sync::before {
  content: "\\F1649";
}

.mdi-credit-card-sync-outline::before {
  content: "\\F164A";
}

.mdi-credit-card-wireless::before {
  content: "\\F0802";
}

.mdi-credit-card-wireless-off::before {
  content: "\\F057A";
}

.mdi-credit-card-wireless-off-outline::before {
  content: "\\F057B";
}

.mdi-credit-card-wireless-outline::before {
  content: "\\F0D6C";
}

.mdi-cricket::before {
  content: "\\F0D6D";
}

.mdi-crop::before {
  content: "\\F019E";
}

.mdi-crop-free::before {
  content: "\\F019F";
}

.mdi-crop-landscape::before {
  content: "\\F01A0";
}

.mdi-crop-portrait::before {
  content: "\\F01A1";
}

.mdi-crop-rotate::before {
  content: "\\F0696";
}

.mdi-crop-square::before {
  content: "\\F01A2";
}

.mdi-cross::before {
  content: "\\F0953";
}

.mdi-cross-bolnisi::before {
  content: "\\F0CED";
}

.mdi-cross-celtic::before {
  content: "\\F0CF5";
}

.mdi-cross-outline::before {
  content: "\\F0CF6";
}

.mdi-crosshairs::before {
  content: "\\F01A3";
}

.mdi-crosshairs-gps::before {
  content: "\\F01A4";
}

.mdi-crosshairs-off::before {
  content: "\\F0F45";
}

.mdi-crosshairs-question::before {
  content: "\\F1136";
}

.mdi-crowd::before {
  content: "\\F1975";
}

.mdi-crown::before {
  content: "\\F01A5";
}

.mdi-crown-circle::before {
  content: "\\F17DC";
}

.mdi-crown-circle-outline::before {
  content: "\\F17DD";
}

.mdi-crown-outline::before {
  content: "\\F11D0";
}

.mdi-cryengine::before {
  content: "\\F0959";
}

.mdi-crystal-ball::before {
  content: "\\F0B2F";
}

.mdi-cube::before {
  content: "\\F01A6";
}

.mdi-cube-off::before {
  content: "\\F141C";
}

.mdi-cube-off-outline::before {
  content: "\\F141D";
}

.mdi-cube-outline::before {
  content: "\\F01A7";
}

.mdi-cube-scan::before {
  content: "\\F0B84";
}

.mdi-cube-send::before {
  content: "\\F01A8";
}

.mdi-cube-unfolded::before {
  content: "\\F01A9";
}

.mdi-cup::before {
  content: "\\F01AA";
}

.mdi-cup-off::before {
  content: "\\F05E5";
}

.mdi-cup-off-outline::before {
  content: "\\F137D";
}

.mdi-cup-outline::before {
  content: "\\F130F";
}

.mdi-cup-water::before {
  content: "\\F01AB";
}

.mdi-cupboard::before {
  content: "\\F0F46";
}

.mdi-cupboard-outline::before {
  content: "\\F0F47";
}

.mdi-cupcake::before {
  content: "\\F095A";
}

.mdi-curling::before {
  content: "\\F0863";
}

.mdi-currency-bdt::before {
  content: "\\F0864";
}

.mdi-currency-brl::before {
  content: "\\F0B85";
}

.mdi-currency-btc::before {
  content: "\\F01AC";
}

.mdi-currency-cny::before {
  content: "\\F07BA";
}

.mdi-currency-eth::before {
  content: "\\F07BB";
}

.mdi-currency-eur::before {
  content: "\\F01AD";
}

.mdi-currency-eur-off::before {
  content: "\\F1315";
}

.mdi-currency-fra::before {
  content: "\\F1A39";
}

.mdi-currency-gbp::before {
  content: "\\F01AE";
}

.mdi-currency-ils::before {
  content: "\\F0C61";
}

.mdi-currency-inr::before {
  content: "\\F01AF";
}

.mdi-currency-jpy::before {
  content: "\\F07BC";
}

.mdi-currency-krw::before {
  content: "\\F07BD";
}

.mdi-currency-kzt::before {
  content: "\\F0865";
}

.mdi-currency-mnt::before {
  content: "\\F1512";
}

.mdi-currency-ngn::before {
  content: "\\F01B0";
}

.mdi-currency-php::before {
  content: "\\F09E6";
}

.mdi-currency-rial::before {
  content: "\\F0E9C";
}

.mdi-currency-rub::before {
  content: "\\F01B1";
}

.mdi-currency-rupee::before {
  content: "\\F1976";
}

.mdi-currency-sign::before {
  content: "\\F07BE";
}

.mdi-currency-thb::before {
  content: "\\F1C05";
}

.mdi-currency-try::before {
  content: "\\F01B2";
}

.mdi-currency-twd::before {
  content: "\\F07BF";
}

.mdi-currency-uah::before {
  content: "\\F1B9B";
}

.mdi-currency-usd::before {
  content: "\\F01C1";
}

.mdi-currency-usd-off::before {
  content: "\\F067A";
}

.mdi-current-ac::before {
  content: "\\F1480";
}

.mdi-current-dc::before {
  content: "\\F095C";
}

.mdi-cursor-default::before {
  content: "\\F01C0";
}

.mdi-cursor-default-click::before {
  content: "\\F0CFD";
}

.mdi-cursor-default-click-outline::before {
  content: "\\F0CFE";
}

.mdi-cursor-default-gesture::before {
  content: "\\F1127";
}

.mdi-cursor-default-gesture-outline::before {
  content: "\\F1128";
}

.mdi-cursor-default-outline::before {
  content: "\\F01BF";
}

.mdi-cursor-move::before {
  content: "\\F01BE";
}

.mdi-cursor-pointer::before {
  content: "\\F01BD";
}

.mdi-cursor-text::before {
  content: "\\F05E7";
}

.mdi-curtains::before {
  content: "\\F1846";
}

.mdi-curtains-closed::before {
  content: "\\F1847";
}

.mdi-cylinder::before {
  content: "\\F194E";
}

.mdi-cylinder-off::before {
  content: "\\F194F";
}

.mdi-dance-ballroom::before {
  content: "\\F15FB";
}

.mdi-dance-pole::before {
  content: "\\F1578";
}

.mdi-data-matrix::before {
  content: "\\F153C";
}

.mdi-data-matrix-edit::before {
  content: "\\F153D";
}

.mdi-data-matrix-minus::before {
  content: "\\F153E";
}

.mdi-data-matrix-plus::before {
  content: "\\F153F";
}

.mdi-data-matrix-remove::before {
  content: "\\F1540";
}

.mdi-data-matrix-scan::before {
  content: "\\F1541";
}

.mdi-database::before {
  content: "\\F01BC";
}

.mdi-database-alert::before {
  content: "\\F163A";
}

.mdi-database-alert-outline::before {
  content: "\\F1624";
}

.mdi-database-arrow-down::before {
  content: "\\F163B";
}

.mdi-database-arrow-down-outline::before {
  content: "\\F1625";
}

.mdi-database-arrow-left::before {
  content: "\\F163C";
}

.mdi-database-arrow-left-outline::before {
  content: "\\F1626";
}

.mdi-database-arrow-right::before {
  content: "\\F163D";
}

.mdi-database-arrow-right-outline::before {
  content: "\\F1627";
}

.mdi-database-arrow-up::before {
  content: "\\F163E";
}

.mdi-database-arrow-up-outline::before {
  content: "\\F1628";
}

.mdi-database-check::before {
  content: "\\F0AA9";
}

.mdi-database-check-outline::before {
  content: "\\F1629";
}

.mdi-database-clock::before {
  content: "\\F163F";
}

.mdi-database-clock-outline::before {
  content: "\\F162A";
}

.mdi-database-cog::before {
  content: "\\F164B";
}

.mdi-database-cog-outline::before {
  content: "\\F164C";
}

.mdi-database-edit::before {
  content: "\\F0B86";
}

.mdi-database-edit-outline::before {
  content: "\\F162B";
}

.mdi-database-export::before {
  content: "\\F095E";
}

.mdi-database-export-outline::before {
  content: "\\F162C";
}

.mdi-database-eye::before {
  content: "\\F191F";
}

.mdi-database-eye-off::before {
  content: "\\F1920";
}

.mdi-database-eye-off-outline::before {
  content: "\\F1921";
}

.mdi-database-eye-outline::before {
  content: "\\F1922";
}

.mdi-database-import::before {
  content: "\\F095D";
}

.mdi-database-import-outline::before {
  content: "\\F162D";
}

.mdi-database-lock::before {
  content: "\\F0AAA";
}

.mdi-database-lock-outline::before {
  content: "\\F162E";
}

.mdi-database-marker::before {
  content: "\\F12F6";
}

.mdi-database-marker-outline::before {
  content: "\\F162F";
}

.mdi-database-minus::before {
  content: "\\F01BB";
}

.mdi-database-minus-outline::before {
  content: "\\F1630";
}

.mdi-database-off::before {
  content: "\\F1640";
}

.mdi-database-off-outline::before {
  content: "\\F1631";
}

.mdi-database-outline::before {
  content: "\\F1632";
}

.mdi-database-plus::before {
  content: "\\F01BA";
}

.mdi-database-plus-outline::before {
  content: "\\F1633";
}

.mdi-database-refresh::before {
  content: "\\F05C2";
}

.mdi-database-refresh-outline::before {
  content: "\\F1634";
}

.mdi-database-remove::before {
  content: "\\F0D00";
}

.mdi-database-remove-outline::before {
  content: "\\F1635";
}

.mdi-database-search::before {
  content: "\\F0866";
}

.mdi-database-search-outline::before {
  content: "\\F1636";
}

.mdi-database-settings::before {
  content: "\\F0D01";
}

.mdi-database-settings-outline::before {
  content: "\\F1637";
}

.mdi-database-sync::before {
  content: "\\F0CFF";
}

.mdi-database-sync-outline::before {
  content: "\\F1638";
}

.mdi-death-star::before {
  content: "\\F08D8";
}

.mdi-death-star-variant::before {
  content: "\\F08D9";
}

.mdi-deathly-hallows::before {
  content: "\\F0B87";
}

.mdi-debian::before {
  content: "\\F08DA";
}

.mdi-debug-step-into::before {
  content: "\\F01B9";
}

.mdi-debug-step-out::before {
  content: "\\F01B8";
}

.mdi-debug-step-over::before {
  content: "\\F01B7";
}

.mdi-decagram::before {
  content: "\\F076C";
}

.mdi-decagram-outline::before {
  content: "\\F076D";
}

.mdi-decimal::before {
  content: "\\F10A1";
}

.mdi-decimal-comma::before {
  content: "\\F10A2";
}

.mdi-decimal-comma-decrease::before {
  content: "\\F10A3";
}

.mdi-decimal-comma-increase::before {
  content: "\\F10A4";
}

.mdi-decimal-decrease::before {
  content: "\\F01B6";
}

.mdi-decimal-increase::before {
  content: "\\F01B5";
}

.mdi-delete::before {
  content: "\\F01B4";
}

.mdi-delete-alert::before {
  content: "\\F10A5";
}

.mdi-delete-alert-outline::before {
  content: "\\F10A6";
}

.mdi-delete-circle::before {
  content: "\\F0683";
}

.mdi-delete-circle-outline::before {
  content: "\\F0B88";
}

.mdi-delete-clock::before {
  content: "\\F1556";
}

.mdi-delete-clock-outline::before {
  content: "\\F1557";
}

.mdi-delete-empty::before {
  content: "\\F06CC";
}

.mdi-delete-empty-outline::before {
  content: "\\F0E9D";
}

.mdi-delete-forever::before {
  content: "\\F05E8";
}

.mdi-delete-forever-outline::before {
  content: "\\F0B89";
}

.mdi-delete-off::before {
  content: "\\F10A7";
}

.mdi-delete-off-outline::before {
  content: "\\F10A8";
}

.mdi-delete-outline::before {
  content: "\\F09E7";
}

.mdi-delete-restore::before {
  content: "\\F0819";
}

.mdi-delete-sweep::before {
  content: "\\F05E9";
}

.mdi-delete-sweep-outline::before {
  content: "\\F0C62";
}

.mdi-delete-variant::before {
  content: "\\F01B3";
}

.mdi-delta::before {
  content: "\\F01C2";
}

.mdi-desk::before {
  content: "\\F1239";
}

.mdi-desk-lamp::before {
  content: "\\F095F";
}

.mdi-desk-lamp-off::before {
  content: "\\F1B1F";
}

.mdi-desk-lamp-on::before {
  content: "\\F1B20";
}

.mdi-deskphone::before {
  content: "\\F01C3";
}

.mdi-desktop-classic::before {
  content: "\\F07C0";
}

.mdi-desktop-tower::before {
  content: "\\F01C5";
}

.mdi-desktop-tower-monitor::before {
  content: "\\F0AAB";
}

.mdi-details::before {
  content: "\\F01C6";
}

.mdi-dev-to::before {
  content: "\\F0D6E";
}

.mdi-developer-board::before {
  content: "\\F0697";
}

.mdi-deviantart::before {
  content: "\\F01C7";
}

.mdi-devices::before {
  content: "\\F0FB0";
}

.mdi-dharmachakra::before {
  content: "\\F094B";
}

.mdi-diabetes::before {
  content: "\\F1126";
}

.mdi-dialpad::before {
  content: "\\F061C";
}

.mdi-diameter::before {
  content: "\\F0C63";
}

.mdi-diameter-outline::before {
  content: "\\F0C64";
}

.mdi-diameter-variant::before {
  content: "\\F0C65";
}

.mdi-diamond::before {
  content: "\\F0B8A";
}

.mdi-diamond-outline::before {
  content: "\\F0B8B";
}

.mdi-diamond-stone::before {
  content: "\\F01C8";
}

.mdi-diaper-outline::before {
  content: "\\F1CCF";
}

.mdi-dice-1::before {
  content: "\\F01CA";
}

.mdi-dice-1-outline::before {
  content: "\\F114A";
}

.mdi-dice-2::before {
  content: "\\F01CB";
}

.mdi-dice-2-outline::before {
  content: "\\F114B";
}

.mdi-dice-3::before {
  content: "\\F01CC";
}

.mdi-dice-3-outline::before {
  content: "\\F114C";
}

.mdi-dice-4::before {
  content: "\\F01CD";
}

.mdi-dice-4-outline::before {
  content: "\\F114D";
}

.mdi-dice-5::before {
  content: "\\F01CE";
}

.mdi-dice-5-outline::before {
  content: "\\F114E";
}

.mdi-dice-6::before {
  content: "\\F01CF";
}

.mdi-dice-6-outline::before {
  content: "\\F114F";
}

.mdi-dice-d10::before {
  content: "\\F1153";
}

.mdi-dice-d10-outline::before {
  content: "\\F076F";
}

.mdi-dice-d12::before {
  content: "\\F1154";
}

.mdi-dice-d12-outline::before {
  content: "\\F0867";
}

.mdi-dice-d20::before {
  content: "\\F1155";
}

.mdi-dice-d20-outline::before {
  content: "\\F05EA";
}

.mdi-dice-d4::before {
  content: "\\F1150";
}

.mdi-dice-d4-outline::before {
  content: "\\F05EB";
}

.mdi-dice-d6::before {
  content: "\\F1151";
}

.mdi-dice-d6-outline::before {
  content: "\\F05ED";
}

.mdi-dice-d8::before {
  content: "\\F1152";
}

.mdi-dice-d8-outline::before {
  content: "\\F05EC";
}

.mdi-dice-multiple::before {
  content: "\\F076E";
}

.mdi-dice-multiple-outline::before {
  content: "\\F1156";
}

.mdi-digital-ocean::before {
  content: "\\F1237";
}

.mdi-dip-switch::before {
  content: "\\F07C1";
}

.mdi-directions::before {
  content: "\\F01D0";
}

.mdi-directions-fork::before {
  content: "\\F0641";
}

.mdi-disc::before {
  content: "\\F05EE";
}

.mdi-disc-alert::before {
  content: "\\F01D1";
}

.mdi-disc-player::before {
  content: "\\F0960";
}

.mdi-dishwasher::before {
  content: "\\F0AAC";
}

.mdi-dishwasher-alert::before {
  content: "\\F11B8";
}

.mdi-dishwasher-off::before {
  content: "\\F11B9";
}

.mdi-disqus::before {
  content: "\\F01D2";
}

.mdi-distribute-horizontal-center::before {
  content: "\\F11C9";
}

.mdi-distribute-horizontal-left::before {
  content: "\\F11C8";
}

.mdi-distribute-horizontal-right::before {
  content: "\\F11CA";
}

.mdi-distribute-vertical-bottom::before {
  content: "\\F11CB";
}

.mdi-distribute-vertical-center::before {
  content: "\\F11CC";
}

.mdi-distribute-vertical-top::before {
  content: "\\F11CD";
}

.mdi-diversify::before {
  content: "\\F1877";
}

.mdi-diving::before {
  content: "\\F1977";
}

.mdi-diving-flippers::before {
  content: "\\F0DBF";
}

.mdi-diving-helmet::before {
  content: "\\F0DC0";
}

.mdi-diving-scuba::before {
  content: "\\F1B77";
}

.mdi-diving-scuba-flag::before {
  content: "\\F0DC2";
}

.mdi-diving-scuba-mask::before {
  content: "\\F0DC1";
}

.mdi-diving-scuba-tank::before {
  content: "\\F0DC3";
}

.mdi-diving-scuba-tank-multiple::before {
  content: "\\F0DC4";
}

.mdi-diving-snorkel::before {
  content: "\\F0DC5";
}

.mdi-division::before {
  content: "\\F01D4";
}

.mdi-division-box::before {
  content: "\\F01D5";
}

.mdi-dlna::before {
  content: "\\F0A41";
}

.mdi-dna::before {
  content: "\\F0684";
}

.mdi-dns::before {
  content: "\\F01D6";
}

.mdi-dns-outline::before {
  content: "\\F0B8C";
}

.mdi-dock-bottom::before {
  content: "\\F10A9";
}

.mdi-dock-left::before {
  content: "\\F10AA";
}

.mdi-dock-right::before {
  content: "\\F10AB";
}

.mdi-dock-top::before {
  content: "\\F1513";
}

.mdi-dock-window::before {
  content: "\\F10AC";
}

.mdi-docker::before {
  content: "\\F0868";
}

.mdi-doctor::before {
  content: "\\F0A42";
}

.mdi-dog::before {
  content: "\\F0A43";
}

.mdi-dog-service::before {
  content: "\\F0AAD";
}

.mdi-dog-side::before {
  content: "\\F0A44";
}

.mdi-dog-side-off::before {
  content: "\\F16EE";
}

.mdi-dolby::before {
  content: "\\F06B3";
}

.mdi-dolly::before {
  content: "\\F0E9E";
}

.mdi-dolphin::before {
  content: "\\F18B4";
}

.mdi-domain::before {
  content: "\\F01D7";
}

.mdi-domain-off::before {
  content: "\\F0D6F";
}

.mdi-domain-plus::before {
  content: "\\F10AD";
}

.mdi-domain-remove::before {
  content: "\\F10AE";
}

.mdi-domain-switch::before {
  content: "\\F1C2C";
}

.mdi-dome-light::before {
  content: "\\F141E";
}

.mdi-domino-mask::before {
  content: "\\F1023";
}

.mdi-donkey::before {
  content: "\\F07C2";
}

.mdi-door::before {
  content: "\\F081A";
}

.mdi-door-closed::before {
  content: "\\F081B";
}

.mdi-door-closed-cancel::before {
  content: "\\F1C93";
}

.mdi-door-closed-lock::before {
  content: "\\F10AF";
}

.mdi-door-open::before {
  content: "\\F081C";
}

.mdi-door-sliding::before {
  content: "\\F181E";
}

.mdi-door-sliding-lock::before {
  content: "\\F181F";
}

.mdi-door-sliding-open::before {
  content: "\\F1820";
}

.mdi-doorbell::before {
  content: "\\F12E6";
}

.mdi-doorbell-video::before {
  content: "\\F0869";
}

.mdi-dot-net::before {
  content: "\\F0AAE";
}

.mdi-dots-circle::before {
  content: "\\F1978";
}

.mdi-dots-grid::before {
  content: "\\F15FC";
}

.mdi-dots-hexagon::before {
  content: "\\F15FF";
}

.mdi-dots-horizontal::before {
  content: "\\F01D8";
}

.mdi-dots-horizontal-circle::before {
  content: "\\F07C3";
}

.mdi-dots-horizontal-circle-outline::before {
  content: "\\F0B8D";
}

.mdi-dots-square::before {
  content: "\\F15FD";
}

.mdi-dots-triangle::before {
  content: "\\F15FE";
}

.mdi-dots-vertical::before {
  content: "\\F01D9";
}

.mdi-dots-vertical-circle::before {
  content: "\\F07C4";
}

.mdi-dots-vertical-circle-outline::before {
  content: "\\F0B8E";
}

.mdi-download::before {
  content: "\\F01DA";
}

.mdi-download-box::before {
  content: "\\F1462";
}

.mdi-download-box-outline::before {
  content: "\\F1463";
}

.mdi-download-circle::before {
  content: "\\F1464";
}

.mdi-download-circle-outline::before {
  content: "\\F1465";
}

.mdi-download-lock::before {
  content: "\\F1320";
}

.mdi-download-lock-outline::before {
  content: "\\F1321";
}

.mdi-download-multiple::before {
  content: "\\F09E9";
}

.mdi-download-multiple-outline::before {
  content: "\\F1CD0";
}

.mdi-download-network::before {
  content: "\\F06F4";
}

.mdi-download-network-outline::before {
  content: "\\F0C66";
}

.mdi-download-off::before {
  content: "\\F10B0";
}

.mdi-download-off-outline::before {
  content: "\\F10B1";
}

.mdi-download-outline::before {
  content: "\\F0B8F";
}

.mdi-drag::before {
  content: "\\F01DB";
}

.mdi-drag-horizontal::before {
  content: "\\F01DC";
}

.mdi-drag-horizontal-variant::before {
  content: "\\F12F0";
}

.mdi-drag-variant::before {
  content: "\\F0B90";
}

.mdi-drag-vertical::before {
  content: "\\F01DD";
}

.mdi-drag-vertical-variant::before {
  content: "\\F12F1";
}

.mdi-drama-masks::before {
  content: "\\F0D02";
}

.mdi-draw::before {
  content: "\\F0F49";
}

.mdi-draw-pen::before {
  content: "\\F19B9";
}

.mdi-drawing::before {
  content: "\\F01DE";
}

.mdi-drawing-box::before {
  content: "\\F01DF";
}

.mdi-dresser::before {
  content: "\\F0F4A";
}

.mdi-dresser-outline::before {
  content: "\\F0F4B";
}

.mdi-drone::before {
  content: "\\F01E2";
}

.mdi-dropbox::before {
  content: "\\F01E3";
}

.mdi-drupal::before {
  content: "\\F01E4";
}

.mdi-duck::before {
  content: "\\F01E5";
}

.mdi-dumbbell::before {
  content: "\\F01E6";
}

.mdi-dump-truck::before {
  content: "\\F0C67";
}

.mdi-ear-hearing::before {
  content: "\\F07C5";
}

.mdi-ear-hearing-loop::before {
  content: "\\F1AEE";
}

.mdi-ear-hearing-off::before {
  content: "\\F0A45";
}

.mdi-earbuds::before {
  content: "\\F184F";
}

.mdi-earbuds-off::before {
  content: "\\F1850";
}

.mdi-earbuds-off-outline::before {
  content: "\\F1851";
}

.mdi-earbuds-outline::before {
  content: "\\F1852";
}

.mdi-earth::before {
  content: "\\F01E7";
}

.mdi-earth-arrow-down::before {
  content: "\\F1C87";
}

.mdi-earth-arrow-left::before {
  content: "\\F1C88";
}

.mdi-earth-arrow-right::before {
  content: "\\F1311";
}

.mdi-earth-arrow-up::before {
  content: "\\F1C89";
}

.mdi-earth-box::before {
  content: "\\F06CD";
}

.mdi-earth-box-minus::before {
  content: "\\F1407";
}

.mdi-earth-box-off::before {
  content: "\\F06CE";
}

.mdi-earth-box-plus::before {
  content: "\\F1406";
}

.mdi-earth-box-remove::before {
  content: "\\F1408";
}

.mdi-earth-minus::before {
  content: "\\F1404";
}

.mdi-earth-off::before {
  content: "\\F01E8";
}

.mdi-earth-plus::before {
  content: "\\F1403";
}

.mdi-earth-remove::before {
  content: "\\F1405";
}

.mdi-egg::before {
  content: "\\F0AAF";
}

.mdi-egg-easter::before {
  content: "\\F0AB0";
}

.mdi-egg-fried::before {
  content: "\\F184A";
}

.mdi-egg-off::before {
  content: "\\F13F0";
}

.mdi-egg-off-outline::before {
  content: "\\F13F1";
}

.mdi-egg-outline::before {
  content: "\\F13F2";
}

.mdi-eiffel-tower::before {
  content: "\\F156B";
}

.mdi-eight-track::before {
  content: "\\F09EA";
}

.mdi-eject::before {
  content: "\\F01EA";
}

.mdi-eject-circle::before {
  content: "\\F1B23";
}

.mdi-eject-circle-outline::before {
  content: "\\F1B24";
}

.mdi-eject-outline::before {
  content: "\\F0B91";
}

.mdi-electric-switch::before {
  content: "\\F0E9F";
}

.mdi-electric-switch-closed::before {
  content: "\\F10D9";
}

.mdi-electron-framework::before {
  content: "\\F1024";
}

.mdi-elephant::before {
  content: "\\F07C6";
}

.mdi-elevation-decline::before {
  content: "\\F01EB";
}

.mdi-elevation-rise::before {
  content: "\\F01EC";
}

.mdi-elevator::before {
  content: "\\F01ED";
}

.mdi-elevator-down::before {
  content: "\\F12C2";
}

.mdi-elevator-passenger::before {
  content: "\\F1381";
}

.mdi-elevator-passenger-off::before {
  content: "\\F1979";
}

.mdi-elevator-passenger-off-outline::before {
  content: "\\F197A";
}

.mdi-elevator-passenger-outline::before {
  content: "\\F197B";
}

.mdi-elevator-up::before {
  content: "\\F12C1";
}

.mdi-ellipse::before {
  content: "\\F0EA0";
}

.mdi-ellipse-outline::before {
  content: "\\F0EA1";
}

.mdi-email::before {
  content: "\\F01EE";
}

.mdi-email-alert::before {
  content: "\\F06CF";
}

.mdi-email-alert-outline::before {
  content: "\\F0D42";
}

.mdi-email-arrow-left::before {
  content: "\\F10DA";
}

.mdi-email-arrow-left-outline::before {
  content: "\\F10DB";
}

.mdi-email-arrow-right::before {
  content: "\\F10DC";
}

.mdi-email-arrow-right-outline::before {
  content: "\\F10DD";
}

.mdi-email-box::before {
  content: "\\F0D03";
}

.mdi-email-check::before {
  content: "\\F0AB1";
}

.mdi-email-check-outline::before {
  content: "\\F0AB2";
}

.mdi-email-edit::before {
  content: "\\F0EE3";
}

.mdi-email-edit-outline::before {
  content: "\\F0EE4";
}

.mdi-email-fast::before {
  content: "\\F186F";
}

.mdi-email-fast-outline::before {
  content: "\\F1870";
}

.mdi-email-heart-outline::before {
  content: "\\F1C5B";
}

.mdi-email-lock::before {
  content: "\\F01F1";
}

.mdi-email-lock-outline::before {
  content: "\\F1B61";
}

.mdi-email-mark-as-unread::before {
  content: "\\F0B92";
}

.mdi-email-minus::before {
  content: "\\F0EE5";
}

.mdi-email-minus-outline::before {
  content: "\\F0EE6";
}

.mdi-email-multiple::before {
  content: "\\F0EE7";
}

.mdi-email-multiple-outline::before {
  content: "\\F0EE8";
}

.mdi-email-newsletter::before {
  content: "\\F0FB1";
}

.mdi-email-off::before {
  content: "\\F13E3";
}

.mdi-email-off-outline::before {
  content: "\\F13E4";
}

.mdi-email-open::before {
  content: "\\F01EF";
}

.mdi-email-open-heart-outline::before {
  content: "\\F1C5C";
}

.mdi-email-open-multiple::before {
  content: "\\F0EE9";
}

.mdi-email-open-multiple-outline::before {
  content: "\\F0EEA";
}

.mdi-email-open-outline::before {
  content: "\\F05EF";
}

.mdi-email-outline::before {
  content: "\\F01F0";
}

.mdi-email-plus::before {
  content: "\\F09EB";
}

.mdi-email-plus-outline::before {
  content: "\\F09EC";
}

.mdi-email-remove::before {
  content: "\\F1661";
}

.mdi-email-remove-outline::before {
  content: "\\F1662";
}

.mdi-email-seal::before {
  content: "\\F195B";
}

.mdi-email-seal-outline::before {
  content: "\\F195C";
}

.mdi-email-search::before {
  content: "\\F0961";
}

.mdi-email-search-outline::before {
  content: "\\F0962";
}

.mdi-email-sync::before {
  content: "\\F12C7";
}

.mdi-email-sync-outline::before {
  content: "\\F12C8";
}

.mdi-email-variant::before {
  content: "\\F05F0";
}

.mdi-ember::before {
  content: "\\F0B30";
}

.mdi-emby::before {
  content: "\\F06B4";
}

.mdi-emoticon::before {
  content: "\\F0C68";
}

.mdi-emoticon-angry::before {
  content: "\\F0C69";
}

.mdi-emoticon-angry-outline::before {
  content: "\\F0C6A";
}

.mdi-emoticon-confused::before {
  content: "\\F10DE";
}

.mdi-emoticon-confused-outline::before {
  content: "\\F10DF";
}

.mdi-emoticon-cool::before {
  content: "\\F0C6B";
}

.mdi-emoticon-cool-outline::before {
  content: "\\F01F3";
}

.mdi-emoticon-cry::before {
  content: "\\F0C6C";
}

.mdi-emoticon-cry-outline::before {
  content: "\\F0C6D";
}

.mdi-emoticon-dead::before {
  content: "\\F0C6E";
}

.mdi-emoticon-dead-outline::before {
  content: "\\F069B";
}

.mdi-emoticon-devil::before {
  content: "\\F0C6F";
}

.mdi-emoticon-devil-outline::before {
  content: "\\F01F4";
}

.mdi-emoticon-excited::before {
  content: "\\F0C70";
}

.mdi-emoticon-excited-outline::before {
  content: "\\F069C";
}

.mdi-emoticon-frown::before {
  content: "\\F0F4C";
}

.mdi-emoticon-frown-outline::before {
  content: "\\F0F4D";
}

.mdi-emoticon-happy::before {
  content: "\\F0C71";
}

.mdi-emoticon-happy-outline::before {
  content: "\\F01F5";
}

.mdi-emoticon-kiss::before {
  content: "\\F0C72";
}

.mdi-emoticon-kiss-outline::before {
  content: "\\F0C73";
}

.mdi-emoticon-lol::before {
  content: "\\F1214";
}

.mdi-emoticon-lol-outline::before {
  content: "\\F1215";
}

.mdi-emoticon-minus::before {
  content: "\\F1CB2";
}

.mdi-emoticon-minus-outline::before {
  content: "\\F1CB3";
}

.mdi-emoticon-neutral::before {
  content: "\\F0C74";
}

.mdi-emoticon-neutral-outline::before {
  content: "\\F01F6";
}

.mdi-emoticon-outline::before {
  content: "\\F01F2";
}

.mdi-emoticon-plus::before {
  content: "\\F1CB4";
}

.mdi-emoticon-plus-outline::before {
  content: "\\F1CB5";
}

.mdi-emoticon-poop::before {
  content: "\\F01F7";
}

.mdi-emoticon-poop-outline::before {
  content: "\\F0C75";
}

.mdi-emoticon-remove::before {
  content: "\\F1CB6";
}

.mdi-emoticon-remove-outline::before {
  content: "\\F1CB7";
}

.mdi-emoticon-sad::before {
  content: "\\F0C76";
}

.mdi-emoticon-sad-outline::before {
  content: "\\F01F8";
}

.mdi-emoticon-sick::before {
  content: "\\F157C";
}

.mdi-emoticon-sick-outline::before {
  content: "\\F157D";
}

.mdi-emoticon-tongue::before {
  content: "\\F01F9";
}

.mdi-emoticon-tongue-outline::before {
  content: "\\F0C77";
}

.mdi-emoticon-wink::before {
  content: "\\F0C78";
}

.mdi-emoticon-wink-outline::before {
  content: "\\F0C79";
}

.mdi-engine::before {
  content: "\\F01FA";
}

.mdi-engine-off::before {
  content: "\\F0A46";
}

.mdi-engine-off-outline::before {
  content: "\\F0A47";
}

.mdi-engine-outline::before {
  content: "\\F01FB";
}

.mdi-epsilon::before {
  content: "\\F10E0";
}

.mdi-equal::before {
  content: "\\F01FC";
}

.mdi-equal-box::before {
  content: "\\F01FD";
}

.mdi-equalizer::before {
  content: "\\F0EA2";
}

.mdi-equalizer-outline::before {
  content: "\\F0EA3";
}

.mdi-eraser::before {
  content: "\\F01FE";
}

.mdi-eraser-variant::before {
  content: "\\F0642";
}

.mdi-escalator::before {
  content: "\\F01FF";
}

.mdi-escalator-box::before {
  content: "\\F1399";
}

.mdi-escalator-down::before {
  content: "\\F12C0";
}

.mdi-escalator-up::before {
  content: "\\F12BF";
}

.mdi-eslint::before {
  content: "\\F0C7A";
}

.mdi-et::before {
  content: "\\F0AB3";
}

.mdi-ethereum::before {
  content: "\\F086A";
}

.mdi-ethernet::before {
  content: "\\F0200";
}

.mdi-ethernet-cable::before {
  content: "\\F0201";
}

.mdi-ethernet-cable-off::before {
  content: "\\F0202";
}

.mdi-ethernet-off::before {
  content: "\\F1CD1";
}

.mdi-ev-plug-ccs1::before {
  content: "\\F1519";
}

.mdi-ev-plug-ccs2::before {
  content: "\\F151A";
}

.mdi-ev-plug-chademo::before {
  content: "\\F151B";
}

.mdi-ev-plug-tesla::before {
  content: "\\F151C";
}

.mdi-ev-plug-type1::before {
  content: "\\F151D";
}

.mdi-ev-plug-type2::before {
  content: "\\F151E";
}

.mdi-ev-station::before {
  content: "\\F05F1";
}

.mdi-evernote::before {
  content: "\\F0204";
}

.mdi-excavator::before {
  content: "\\F1025";
}

.mdi-exclamation::before {
  content: "\\F0205";
}

.mdi-exclamation-thick::before {
  content: "\\F1238";
}

.mdi-exit-run::before {
  content: "\\F0A48";
}

.mdi-exit-to-app::before {
  content: "\\F0206";
}

.mdi-expand-all::before {
  content: "\\F0AB4";
}

.mdi-expand-all-outline::before {
  content: "\\F0AB5";
}

.mdi-expansion-card::before {
  content: "\\F08AE";
}

.mdi-expansion-card-variant::before {
  content: "\\F0FB2";
}

.mdi-exponent::before {
  content: "\\F0963";
}

.mdi-exponent-box::before {
  content: "\\F0964";
}

.mdi-export::before {
  content: "\\F0207";
}

.mdi-export-variant::before {
  content: "\\F0B93";
}

.mdi-eye::before {
  content: "\\F0208";
}

.mdi-eye-arrow-left::before {
  content: "\\F18FD";
}

.mdi-eye-arrow-left-outline::before {
  content: "\\F18FE";
}

.mdi-eye-arrow-right::before {
  content: "\\F18FF";
}

.mdi-eye-arrow-right-outline::before {
  content: "\\F1900";
}

.mdi-eye-check::before {
  content: "\\F0D04";
}

.mdi-eye-check-outline::before {
  content: "\\F0D05";
}

.mdi-eye-circle::before {
  content: "\\F0B94";
}

.mdi-eye-circle-outline::before {
  content: "\\F0B95";
}

.mdi-eye-closed::before {
  content: "\\F1CA3";
}

.mdi-eye-lock::before {
  content: "\\F1C06";
}

.mdi-eye-lock-open::before {
  content: "\\F1C07";
}

.mdi-eye-lock-open-outline::before {
  content: "\\F1C08";
}

.mdi-eye-lock-outline::before {
  content: "\\F1C09";
}

.mdi-eye-minus::before {
  content: "\\F1026";
}

.mdi-eye-minus-outline::before {
  content: "\\F1027";
}

.mdi-eye-off::before {
  content: "\\F0209";
}

.mdi-eye-off-outline::before {
  content: "\\F06D1";
}

.mdi-eye-outline::before {
  content: "\\F06D0";
}

.mdi-eye-plus::before {
  content: "\\F086B";
}

.mdi-eye-plus-outline::before {
  content: "\\F086C";
}

.mdi-eye-refresh::before {
  content: "\\F197C";
}

.mdi-eye-refresh-outline::before {
  content: "\\F197D";
}

.mdi-eye-remove::before {
  content: "\\F15E3";
}

.mdi-eye-remove-outline::before {
  content: "\\F15E4";
}

.mdi-eye-settings::before {
  content: "\\F086D";
}

.mdi-eye-settings-outline::before {
  content: "\\F086E";
}

.mdi-eyedropper::before {
  content: "\\F020A";
}

.mdi-eyedropper-minus::before {
  content: "\\F13DD";
}

.mdi-eyedropper-off::before {
  content: "\\F13DF";
}

.mdi-eyedropper-plus::before {
  content: "\\F13DC";
}

.mdi-eyedropper-remove::before {
  content: "\\F13DE";
}

.mdi-eyedropper-variant::before {
  content: "\\F020B";
}

.mdi-face-agent::before {
  content: "\\F0D70";
}

.mdi-face-man::before {
  content: "\\F0643";
}

.mdi-face-man-outline::before {
  content: "\\F0B96";
}

.mdi-face-man-profile::before {
  content: "\\F0644";
}

.mdi-face-man-shimmer::before {
  content: "\\F15CC";
}

.mdi-face-man-shimmer-outline::before {
  content: "\\F15CD";
}

.mdi-face-mask::before {
  content: "\\F1586";
}

.mdi-face-mask-outline::before {
  content: "\\F1587";
}

.mdi-face-recognition::before {
  content: "\\F0C7B";
}

.mdi-face-woman::before {
  content: "\\F1077";
}

.mdi-face-woman-outline::before {
  content: "\\F1078";
}

.mdi-face-woman-profile::before {
  content: "\\F1076";
}

.mdi-face-woman-shimmer::before {
  content: "\\F15CE";
}

.mdi-face-woman-shimmer-outline::before {
  content: "\\F15CF";
}

.mdi-facebook::before {
  content: "\\F020C";
}

.mdi-facebook-gaming::before {
  content: "\\F07DD";
}

.mdi-facebook-messenger::before {
  content: "\\F020E";
}

.mdi-facebook-workplace::before {
  content: "\\F0B31";
}

.mdi-factory::before {
  content: "\\F020F";
}

.mdi-family-tree::before {
  content: "\\F160E";
}

.mdi-fan::before {
  content: "\\F0210";
}

.mdi-fan-alert::before {
  content: "\\F146C";
}

.mdi-fan-auto::before {
  content: "\\F171D";
}

.mdi-fan-chevron-down::before {
  content: "\\F146D";
}

.mdi-fan-chevron-up::before {
  content: "\\F146E";
}

.mdi-fan-clock::before {
  content: "\\F1A3A";
}

.mdi-fan-minus::before {
  content: "\\F1470";
}

.mdi-fan-off::before {
  content: "\\F081D";
}

.mdi-fan-plus::before {
  content: "\\F146F";
}

.mdi-fan-remove::before {
  content: "\\F1471";
}

.mdi-fan-speed-1::before {
  content: "\\F1472";
}

.mdi-fan-speed-2::before {
  content: "\\F1473";
}

.mdi-fan-speed-3::before {
  content: "\\F1474";
}

.mdi-fast-forward::before {
  content: "\\F0211";
}

.mdi-fast-forward-10::before {
  content: "\\F0D71";
}

.mdi-fast-forward-15::before {
  content: "\\F193A";
}

.mdi-fast-forward-30::before {
  content: "\\F0D06";
}

.mdi-fast-forward-45::before {
  content: "\\F1B12";
}

.mdi-fast-forward-5::before {
  content: "\\F11F8";
}

.mdi-fast-forward-60::before {
  content: "\\F160B";
}

.mdi-fast-forward-outline::before {
  content: "\\F06D2";
}

.mdi-faucet::before {
  content: "\\F1B29";
}

.mdi-faucet-variant::before {
  content: "\\F1B2A";
}

.mdi-fax::before {
  content: "\\F0212";
}

.mdi-feather::before {
  content: "\\F06D3";
}

.mdi-feature-search::before {
  content: "\\F0A49";
}

.mdi-feature-search-outline::before {
  content: "\\F0A4A";
}

.mdi-fedora::before {
  content: "\\F08DB";
}

.mdi-fence::before {
  content: "\\F179A";
}

.mdi-fence-electric::before {
  content: "\\F17F6";
}

.mdi-fencing::before {
  content: "\\F14C1";
}

.mdi-ferris-wheel::before {
  content: "\\F0EA4";
}

.mdi-ferry::before {
  content: "\\F0213";
}

.mdi-file::before {
  content: "\\F0214";
}

.mdi-file-account::before {
  content: "\\F073B";
}

.mdi-file-account-outline::before {
  content: "\\F1028";
}

.mdi-file-alert::before {
  content: "\\F0A4B";
}

.mdi-file-alert-outline::before {
  content: "\\F0A4C";
}

.mdi-file-arrow-left-right::before {
  content: "\\F1A93";
}

.mdi-file-arrow-left-right-outline::before {
  content: "\\F1A94";
}

.mdi-file-arrow-up-down::before {
  content: "\\F1A95";
}

.mdi-file-arrow-up-down-outline::before {
  content: "\\F1A96";
}

.mdi-file-cabinet::before {
  content: "\\F0AB6";
}

.mdi-file-cad::before {
  content: "\\F0EEB";
}

.mdi-file-cad-box::before {
  content: "\\F0EEC";
}

.mdi-file-cancel::before {
  content: "\\F0DC6";
}

.mdi-file-cancel-outline::before {
  content: "\\F0DC7";
}

.mdi-file-certificate::before {
  content: "\\F1186";
}

.mdi-file-certificate-outline::before {
  content: "\\F1187";
}

.mdi-file-chart::before {
  content: "\\F0215";
}

.mdi-file-chart-check::before {
  content: "\\F19C6";
}

.mdi-file-chart-check-outline::before {
  content: "\\F19C7";
}

.mdi-file-chart-outline::before {
  content: "\\F1029";
}

.mdi-file-check::before {
  content: "\\F0216";
}

.mdi-file-check-outline::before {
  content: "\\F0E29";
}

.mdi-file-clock::before {
  content: "\\F12E1";
}

.mdi-file-clock-outline::before {
  content: "\\F12E2";
}

.mdi-file-cloud::before {
  content: "\\F0217";
}

.mdi-file-cloud-outline::before {
  content: "\\F102A";
}

.mdi-file-code::before {
  content: "\\F022E";
}

.mdi-file-code-outline::before {
  content: "\\F102B";
}

.mdi-file-cog::before {
  content: "\\F107B";
}

.mdi-file-cog-outline::before {
  content: "\\F107C";
}

.mdi-file-compare::before {
  content: "\\F08AA";
}

.mdi-file-delimited::before {
  content: "\\F0218";
}

.mdi-file-delimited-outline::before {
  content: "\\F0EA5";
}

.mdi-file-document::before {
  content: "\\F0219";
}

.mdi-file-document-alert::before {
  content: "\\F1A97";
}

.mdi-file-document-alert-outline::before {
  content: "\\F1A98";
}

.mdi-file-document-arrow-right::before {
  content: "\\F1C0F";
}

.mdi-file-document-arrow-right-outline::before {
  content: "\\F1C10";
}

.mdi-file-document-check::before {
  content: "\\F1A99";
}

.mdi-file-document-check-outline::before {
  content: "\\F1A9A";
}

.mdi-file-document-edit::before {
  content: "\\F0DC8";
}

.mdi-file-document-edit-outline::before {
  content: "\\F0DC9";
}

.mdi-file-document-minus::before {
  content: "\\F1A9B";
}

.mdi-file-document-minus-outline::before {
  content: "\\F1A9C";
}

.mdi-file-document-multiple::before {
  content: "\\F1517";
}

.mdi-file-document-multiple-outline::before {
  content: "\\F1518";
}

.mdi-file-document-outline::before {
  content: "\\F09EE";
}

.mdi-file-document-plus::before {
  content: "\\F1A9D";
}

.mdi-file-document-plus-outline::before {
  content: "\\F1A9E";
}

.mdi-file-document-refresh::before {
  content: "\\F1C7A";
}

.mdi-file-document-refresh-outline::before {
  content: "\\F1C7B";
}

.mdi-file-document-remove::before {
  content: "\\F1A9F";
}

.mdi-file-document-remove-outline::before {
  content: "\\F1AA0";
}

.mdi-file-download::before {
  content: "\\F0965";
}

.mdi-file-download-outline::before {
  content: "\\F0966";
}

.mdi-file-edit::before {
  content: "\\F11E7";
}

.mdi-file-edit-outline::before {
  content: "\\F11E8";
}

.mdi-file-excel::before {
  content: "\\F021B";
}

.mdi-file-excel-box::before {
  content: "\\F021C";
}

.mdi-file-excel-box-outline::before {
  content: "\\F102C";
}

.mdi-file-excel-outline::before {
  content: "\\F102D";
}

.mdi-file-export::before {
  content: "\\F021D";
}

.mdi-file-export-outline::before {
  content: "\\F102E";
}

.mdi-file-eye::before {
  content: "\\F0DCA";
}

.mdi-file-eye-outline::before {
  content: "\\F0DCB";
}

.mdi-file-find::before {
  content: "\\F021E";
}

.mdi-file-find-outline::before {
  content: "\\F0B97";
}

.mdi-file-gif-box::before {
  content: "\\F0D78";
}

.mdi-file-hidden::before {
  content: "\\F0613";
}

.mdi-file-image::before {
  content: "\\F021F";
}

.mdi-file-image-marker::before {
  content: "\\F1772";
}

.mdi-file-image-marker-outline::before {
  content: "\\F1773";
}

.mdi-file-image-minus::before {
  content: "\\F193B";
}

.mdi-file-image-minus-outline::before {
  content: "\\F193C";
}

.mdi-file-image-outline::before {
  content: "\\F0EB0";
}

.mdi-file-image-plus::before {
  content: "\\F193D";
}

.mdi-file-image-plus-outline::before {
  content: "\\F193E";
}

.mdi-file-image-remove::before {
  content: "\\F193F";
}

.mdi-file-image-remove-outline::before {
  content: "\\F1940";
}

.mdi-file-import::before {
  content: "\\F0220";
}

.mdi-file-import-outline::before {
  content: "\\F102F";
}

.mdi-file-jpg-box::before {
  content: "\\F0225";
}

.mdi-file-key::before {
  content: "\\F1184";
}

.mdi-file-key-outline::before {
  content: "\\F1185";
}

.mdi-file-link::before {
  content: "\\F1177";
}

.mdi-file-link-outline::before {
  content: "\\F1178";
}

.mdi-file-lock::before {
  content: "\\F0221";
}

.mdi-file-lock-open::before {
  content: "\\F19C8";
}

.mdi-file-lock-open-outline::before {
  content: "\\F19C9";
}

.mdi-file-lock-outline::before {
  content: "\\F1030";
}

.mdi-file-marker::before {
  content: "\\F1774";
}

.mdi-file-marker-outline::before {
  content: "\\F1775";
}

.mdi-file-minus::before {
  content: "\\F1AA1";
}

.mdi-file-minus-outline::before {
  content: "\\F1AA2";
}

.mdi-file-move::before {
  content: "\\F0AB9";
}

.mdi-file-move-outline::before {
  content: "\\F1031";
}

.mdi-file-multiple::before {
  content: "\\F0222";
}

.mdi-file-multiple-outline::before {
  content: "\\F1032";
}

.mdi-file-music::before {
  content: "\\F0223";
}

.mdi-file-music-outline::before {
  content: "\\F0E2A";
}

.mdi-file-outline::before {
  content: "\\F0224";
}

.mdi-file-pdf-box::before {
  content: "\\F0226";
}

.mdi-file-percent::before {
  content: "\\F081E";
}

.mdi-file-percent-outline::before {
  content: "\\F1033";
}

.mdi-file-phone::before {
  content: "\\F1179";
}

.mdi-file-phone-outline::before {
  content: "\\F117A";
}

.mdi-file-plus::before {
  content: "\\F0752";
}

.mdi-file-plus-outline::before {
  content: "\\F0EED";
}

.mdi-file-png-box::before {
  content: "\\F0E2D";
}

.mdi-file-powerpoint::before {
  content: "\\F0227";
}

.mdi-file-powerpoint-box::before {
  content: "\\F0228";
}

.mdi-file-powerpoint-box-outline::before {
  content: "\\F1034";
}

.mdi-file-powerpoint-outline::before {
  content: "\\F1035";
}

.mdi-file-presentation-box::before {
  content: "\\F0229";
}

.mdi-file-question::before {
  content: "\\F086F";
}

.mdi-file-question-outline::before {
  content: "\\F1036";
}

.mdi-file-refresh::before {
  content: "\\F0918";
}

.mdi-file-refresh-outline::before {
  content: "\\F0541";
}

.mdi-file-remove::before {
  content: "\\F0B98";
}

.mdi-file-remove-outline::before {
  content: "\\F1037";
}

.mdi-file-replace::before {
  content: "\\F0B32";
}

.mdi-file-replace-outline::before {
  content: "\\F0B33";
}

.mdi-file-restore::before {
  content: "\\F0670";
}

.mdi-file-restore-outline::before {
  content: "\\F1038";
}

.mdi-file-rotate-left::before {
  content: "\\F1A3B";
}

.mdi-file-rotate-left-outline::before {
  content: "\\F1A3C";
}

.mdi-file-rotate-right::before {
  content: "\\F1A3D";
}

.mdi-file-rotate-right-outline::before {
  content: "\\F1A3E";
}

.mdi-file-search::before {
  content: "\\F0C7C";
}

.mdi-file-search-outline::before {
  content: "\\F0C7D";
}

.mdi-file-send::before {
  content: "\\F022A";
}

.mdi-file-send-outline::before {
  content: "\\F1039";
}

.mdi-file-settings::before {
  content: "\\F1079";
}

.mdi-file-settings-outline::before {
  content: "\\F107A";
}

.mdi-file-sign::before {
  content: "\\F19C3";
}

.mdi-file-star::before {
  content: "\\F103A";
}

.mdi-file-star-four-points::before {
  content: "\\F1C2D";
}

.mdi-file-star-four-points-outline::before {
  content: "\\F1C2E";
}

.mdi-file-star-outline::before {
  content: "\\F103B";
}

.mdi-file-swap::before {
  content: "\\F0FB4";
}

.mdi-file-swap-outline::before {
  content: "\\F0FB5";
}

.mdi-file-sync::before {
  content: "\\F1216";
}

.mdi-file-sync-outline::before {
  content: "\\F1217";
}

.mdi-file-table::before {
  content: "\\F0C7E";
}

.mdi-file-table-box::before {
  content: "\\F10E1";
}

.mdi-file-table-box-multiple::before {
  content: "\\F10E2";
}

.mdi-file-table-box-multiple-outline::before {
  content: "\\F10E3";
}

.mdi-file-table-box-outline::before {
  content: "\\F10E4";
}

.mdi-file-table-outline::before {
  content: "\\F0C7F";
}

.mdi-file-tree::before {
  content: "\\F0645";
}

.mdi-file-tree-outline::before {
  content: "\\F13D2";
}

.mdi-file-undo::before {
  content: "\\F08DC";
}

.mdi-file-undo-outline::before {
  content: "\\F103C";
}

.mdi-file-upload::before {
  content: "\\F0A4D";
}

.mdi-file-upload-outline::before {
  content: "\\F0A4E";
}

.mdi-file-video::before {
  content: "\\F022B";
}

.mdi-file-video-outline::before {
  content: "\\F0E2C";
}

.mdi-file-word::before {
  content: "\\F022C";
}

.mdi-file-word-box::before {
  content: "\\F022D";
}

.mdi-file-word-box-outline::before {
  content: "\\F103D";
}

.mdi-file-word-outline::before {
  content: "\\F103E";
}

.mdi-file-xml-box::before {
  content: "\\F1B4B";
}

.mdi-film::before {
  content: "\\F022F";
}

.mdi-filmstrip::before {
  content: "\\F0230";
}

.mdi-filmstrip-box::before {
  content: "\\F0332";
}

.mdi-filmstrip-box-multiple::before {
  content: "\\F0D18";
}

.mdi-filmstrip-off::before {
  content: "\\F0231";
}

.mdi-filter::before {
  content: "\\F0232";
}

.mdi-filter-check::before {
  content: "\\F18EC";
}

.mdi-filter-check-outline::before {
  content: "\\F18ED";
}

.mdi-filter-cog::before {
  content: "\\F1AA3";
}

.mdi-filter-cog-outline::before {
  content: "\\F1AA4";
}

.mdi-filter-menu::before {
  content: "\\F10E5";
}

.mdi-filter-menu-outline::before {
  content: "\\F10E6";
}

.mdi-filter-minus::before {
  content: "\\F0EEE";
}

.mdi-filter-minus-outline::before {
  content: "\\F0EEF";
}

.mdi-filter-multiple::before {
  content: "\\F1A3F";
}

.mdi-filter-multiple-outline::before {
  content: "\\F1A40";
}

.mdi-filter-off::before {
  content: "\\F14EF";
}

.mdi-filter-off-outline::before {
  content: "\\F14F0";
}

.mdi-filter-outline::before {
  content: "\\F0233";
}

.mdi-filter-plus::before {
  content: "\\F0EF0";
}

.mdi-filter-plus-outline::before {
  content: "\\F0EF1";
}

.mdi-filter-remove::before {
  content: "\\F0234";
}

.mdi-filter-remove-outline::before {
  content: "\\F0235";
}

.mdi-filter-settings::before {
  content: "\\F1AA5";
}

.mdi-filter-settings-outline::before {
  content: "\\F1AA6";
}

.mdi-filter-variant::before {
  content: "\\F0236";
}

.mdi-filter-variant-minus::before {
  content: "\\F1112";
}

.mdi-filter-variant-plus::before {
  content: "\\F1113";
}

.mdi-filter-variant-remove::before {
  content: "\\F103F";
}

.mdi-finance::before {
  content: "\\F081F";
}

.mdi-find-replace::before {
  content: "\\F06D4";
}

.mdi-fingerprint::before {
  content: "\\F0237";
}

.mdi-fingerprint-off::before {
  content: "\\F0EB1";
}

.mdi-fire::before {
  content: "\\F0238";
}

.mdi-fire-alert::before {
  content: "\\F15D7";
}

.mdi-fire-circle::before {
  content: "\\F1807";
}

.mdi-fire-extinguisher::before {
  content: "\\F0EF2";
}

.mdi-fire-hydrant::before {
  content: "\\F1137";
}

.mdi-fire-hydrant-alert::before {
  content: "\\F1138";
}

.mdi-fire-hydrant-off::before {
  content: "\\F1139";
}

.mdi-fire-off::before {
  content: "\\F1722";
}

.mdi-fire-station::before {
  content: "\\F1CC3";
}

.mdi-fire-truck::before {
  content: "\\F08AB";
}

.mdi-firebase::before {
  content: "\\F0967";
}

.mdi-firefox::before {
  content: "\\F0239";
}

.mdi-fireplace::before {
  content: "\\F0E2E";
}

.mdi-fireplace-off::before {
  content: "\\F0E2F";
}

.mdi-firewire::before {
  content: "\\F05BE";
}

.mdi-firework::before {
  content: "\\F0E30";
}

.mdi-firework-off::before {
  content: "\\F1723";
}

.mdi-fish::before {
  content: "\\F023A";
}

.mdi-fish-off::before {
  content: "\\F13F3";
}

.mdi-fishbowl::before {
  content: "\\F0EF3";
}

.mdi-fishbowl-outline::before {
  content: "\\F0EF4";
}

.mdi-fit-to-page::before {
  content: "\\F0EF5";
}

.mdi-fit-to-page-outline::before {
  content: "\\F0EF6";
}

.mdi-fit-to-screen::before {
  content: "\\F18F4";
}

.mdi-fit-to-screen-outline::before {
  content: "\\F18F5";
}

.mdi-flag::before {
  content: "\\F023B";
}

.mdi-flag-checkered::before {
  content: "\\F023C";
}

.mdi-flag-minus::before {
  content: "\\F0B99";
}

.mdi-flag-minus-outline::before {
  content: "\\F10B2";
}

.mdi-flag-off::before {
  content: "\\F18EE";
}

.mdi-flag-off-outline::before {
  content: "\\F18EF";
}

.mdi-flag-outline::before {
  content: "\\F023D";
}

.mdi-flag-plus::before {
  content: "\\F0B9A";
}

.mdi-flag-plus-outline::before {
  content: "\\F10B3";
}

.mdi-flag-remove::before {
  content: "\\F0B9B";
}

.mdi-flag-remove-outline::before {
  content: "\\F10B4";
}

.mdi-flag-triangle::before {
  content: "\\F023F";
}

.mdi-flag-variant::before {
  content: "\\F0240";
}

.mdi-flag-variant-minus::before {
  content: "\\F1BB4";
}

.mdi-flag-variant-minus-outline::before {
  content: "\\F1BB5";
}

.mdi-flag-variant-off::before {
  content: "\\F1BB0";
}

.mdi-flag-variant-off-outline::before {
  content: "\\F1BB1";
}

.mdi-flag-variant-outline::before {
  content: "\\F023E";
}

.mdi-flag-variant-plus::before {
  content: "\\F1BB2";
}

.mdi-flag-variant-plus-outline::before {
  content: "\\F1BB3";
}

.mdi-flag-variant-remove::before {
  content: "\\F1BB6";
}

.mdi-flag-variant-remove-outline::before {
  content: "\\F1BB7";
}

.mdi-flare::before {
  content: "\\F0D72";
}

.mdi-flash::before {
  content: "\\F0241";
}

.mdi-flash-alert::before {
  content: "\\F0EF7";
}

.mdi-flash-alert-outline::before {
  content: "\\F0EF8";
}

.mdi-flash-auto::before {
  content: "\\F0242";
}

.mdi-flash-off::before {
  content: "\\F0243";
}

.mdi-flash-off-outline::before {
  content: "\\F1B45";
}

.mdi-flash-outline::before {
  content: "\\F06D5";
}

.mdi-flash-red-eye::before {
  content: "\\F067B";
}

.mdi-flash-triangle::before {
  content: "\\F1B1D";
}

.mdi-flash-triangle-outline::before {
  content: "\\F1B1E";
}

.mdi-flashlight::before {
  content: "\\F0244";
}

.mdi-flashlight-off::before {
  content: "\\F0245";
}

.mdi-flask::before {
  content: "\\F0093";
}

.mdi-flask-empty::before {
  content: "\\F0094";
}

.mdi-flask-empty-minus::before {
  content: "\\F123A";
}

.mdi-flask-empty-minus-outline::before {
  content: "\\F123B";
}

.mdi-flask-empty-off::before {
  content: "\\F13F4";
}

.mdi-flask-empty-off-outline::before {
  content: "\\F13F5";
}

.mdi-flask-empty-outline::before {
  content: "\\F0095";
}

.mdi-flask-empty-plus::before {
  content: "\\F123C";
}

.mdi-flask-empty-plus-outline::before {
  content: "\\F123D";
}

.mdi-flask-empty-remove::before {
  content: "\\F123E";
}

.mdi-flask-empty-remove-outline::before {
  content: "\\F123F";
}

.mdi-flask-minus::before {
  content: "\\F1240";
}

.mdi-flask-minus-outline::before {
  content: "\\F1241";
}

.mdi-flask-off::before {
  content: "\\F13F6";
}

.mdi-flask-off-outline::before {
  content: "\\F13F7";
}

.mdi-flask-outline::before {
  content: "\\F0096";
}

.mdi-flask-plus::before {
  content: "\\F1242";
}

.mdi-flask-plus-outline::before {
  content: "\\F1243";
}

.mdi-flask-remove::before {
  content: "\\F1244";
}

.mdi-flask-remove-outline::before {
  content: "\\F1245";
}

.mdi-flask-round-bottom::before {
  content: "\\F124B";
}

.mdi-flask-round-bottom-empty::before {
  content: "\\F124C";
}

.mdi-flask-round-bottom-empty-outline::before {
  content: "\\F124D";
}

.mdi-flask-round-bottom-outline::before {
  content: "\\F124E";
}

.mdi-fleur-de-lis::before {
  content: "\\F1303";
}

.mdi-flip-horizontal::before {
  content: "\\F10E7";
}

.mdi-flip-to-back::before {
  content: "\\F0247";
}

.mdi-flip-to-front::before {
  content: "\\F0248";
}

.mdi-flip-vertical::before {
  content: "\\F10E8";
}

.mdi-floor-lamp::before {
  content: "\\F08DD";
}

.mdi-floor-lamp-dual::before {
  content: "\\F1040";
}

.mdi-floor-lamp-dual-outline::before {
  content: "\\F17CE";
}

.mdi-floor-lamp-outline::before {
  content: "\\F17C8";
}

.mdi-floor-lamp-torchiere::before {
  content: "\\F1747";
}

.mdi-floor-lamp-torchiere-outline::before {
  content: "\\F17D6";
}

.mdi-floor-lamp-torchiere-variant::before {
  content: "\\F1041";
}

.mdi-floor-lamp-torchiere-variant-outline::before {
  content: "\\F17CF";
}

.mdi-floor-plan::before {
  content: "\\F0821";
}

.mdi-floppy::before {
  content: "\\F0249";
}

.mdi-floppy-variant::before {
  content: "\\F09EF";
}

.mdi-flower::before {
  content: "\\F024A";
}

.mdi-flower-outline::before {
  content: "\\F09F0";
}

.mdi-flower-pollen::before {
  content: "\\F1885";
}

.mdi-flower-pollen-outline::before {
  content: "\\F1886";
}

.mdi-flower-poppy::before {
  content: "\\F0D08";
}

.mdi-flower-tulip::before {
  content: "\\F09F1";
}

.mdi-flower-tulip-outline::before {
  content: "\\F09F2";
}

.mdi-focus-auto::before {
  content: "\\F0F4E";
}

.mdi-focus-field::before {
  content: "\\F0F4F";
}

.mdi-focus-field-horizontal::before {
  content: "\\F0F50";
}

.mdi-focus-field-vertical::before {
  content: "\\F0F51";
}

.mdi-folder::before {
  content: "\\F024B";
}

.mdi-folder-account::before {
  content: "\\F024C";
}

.mdi-folder-account-outline::before {
  content: "\\F0B9C";
}

.mdi-folder-alert::before {
  content: "\\F0DCC";
}

.mdi-folder-alert-outline::before {
  content: "\\F0DCD";
}

.mdi-folder-arrow-down::before {
  content: "\\F19E8";
}

.mdi-folder-arrow-down-outline::before {
  content: "\\F19E9";
}

.mdi-folder-arrow-left::before {
  content: "\\F19EA";
}

.mdi-folder-arrow-left-outline::before {
  content: "\\F19EB";
}

.mdi-folder-arrow-left-right::before {
  content: "\\F19EC";
}

.mdi-folder-arrow-left-right-outline::before {
  content: "\\F19ED";
}

.mdi-folder-arrow-right::before {
  content: "\\F19EE";
}

.mdi-folder-arrow-right-outline::before {
  content: "\\F19EF";
}

.mdi-folder-arrow-up::before {
  content: "\\F19F0";
}

.mdi-folder-arrow-up-down::before {
  content: "\\F19F1";
}

.mdi-folder-arrow-up-down-outline::before {
  content: "\\F19F2";
}

.mdi-folder-arrow-up-outline::before {
  content: "\\F19F3";
}

.mdi-folder-cancel::before {
  content: "\\F19F4";
}

.mdi-folder-cancel-outline::before {
  content: "\\F19F5";
}

.mdi-folder-check::before {
  content: "\\F197E";
}

.mdi-folder-check-outline::before {
  content: "\\F197F";
}

.mdi-folder-clock::before {
  content: "\\F0ABA";
}

.mdi-folder-clock-outline::before {
  content: "\\F0ABB";
}

.mdi-folder-cog::before {
  content: "\\F107F";
}

.mdi-folder-cog-outline::before {
  content: "\\F1080";
}

.mdi-folder-download::before {
  content: "\\F024D";
}

.mdi-folder-download-outline::before {
  content: "\\F10E9";
}

.mdi-folder-edit::before {
  content: "\\F08DE";
}

.mdi-folder-edit-outline::before {
  content: "\\F0DCE";
}

.mdi-folder-eye::before {
  content: "\\F178A";
}

.mdi-folder-eye-outline::before {
  content: "\\F178B";
}

.mdi-folder-file::before {
  content: "\\F19F6";
}

.mdi-folder-file-outline::before {
  content: "\\F19F7";
}

.mdi-folder-google-drive::before {
  content: "\\F024E";
}

.mdi-folder-heart::before {
  content: "\\F10EA";
}

.mdi-folder-heart-outline::before {
  content: "\\F10EB";
}

.mdi-folder-hidden::before {
  content: "\\F179E";
}

.mdi-folder-home::before {
  content: "\\F10B5";
}

.mdi-folder-home-outline::before {
  content: "\\F10B6";
}

.mdi-folder-image::before {
  content: "\\F024F";
}

.mdi-folder-information::before {
  content: "\\F10B7";
}

.mdi-folder-information-outline::before {
  content: "\\F10B8";
}

.mdi-folder-key::before {
  content: "\\F08AC";
}

.mdi-folder-key-network::before {
  content: "\\F08AD";
}

.mdi-folder-key-network-outline::before {
  content: "\\F0C80";
}

.mdi-folder-key-outline::before {
  content: "\\F10EC";
}

.mdi-folder-lock::before {
  content: "\\F0250";
}

.mdi-folder-lock-open::before {
  content: "\\F0251";
}

.mdi-folder-lock-open-outline::before {
  content: "\\F1AA7";
}

.mdi-folder-lock-outline::before {
  content: "\\F1AA8";
}

.mdi-folder-marker::before {
  content: "\\F126D";
}

.mdi-folder-marker-outline::before {
  content: "\\F126E";
}

.mdi-folder-minus::before {
  content: "\\F1B49";
}

.mdi-folder-minus-outline::before {
  content: "\\F1B4A";
}

.mdi-folder-move::before {
  content: "\\F0252";
}

.mdi-folder-move-outline::before {
  content: "\\F1246";
}

.mdi-folder-multiple::before {
  content: "\\F0253";
}

.mdi-folder-multiple-image::before {
  content: "\\F0254";
}

.mdi-folder-multiple-outline::before {
  content: "\\F0255";
}

.mdi-folder-multiple-plus::before {
  content: "\\F147E";
}

.mdi-folder-multiple-plus-outline::before {
  content: "\\F147F";
}

.mdi-folder-music::before {
  content: "\\F1359";
}

.mdi-folder-music-outline::before {
  content: "\\F135A";
}

.mdi-folder-network::before {
  content: "\\F0870";
}

.mdi-folder-network-outline::before {
  content: "\\F0C81";
}

.mdi-folder-off::before {
  content: "\\F19F8";
}

.mdi-folder-off-outline::before {
  content: "\\F19F9";
}

.mdi-folder-open::before {
  content: "\\F0770";
}

.mdi-folder-open-outline::before {
  content: "\\F0DCF";
}

.mdi-folder-outline::before {
  content: "\\F0256";
}

.mdi-folder-play::before {
  content: "\\F19FA";
}

.mdi-folder-play-outline::before {
  content: "\\F19FB";
}

.mdi-folder-plus::before {
  content: "\\F0257";
}

.mdi-folder-plus-outline::before {
  content: "\\F0B9D";
}

.mdi-folder-pound::before {
  content: "\\F0D09";
}

.mdi-folder-pound-outline::before {
  content: "\\F0D0A";
}

.mdi-folder-question::before {
  content: "\\F19CA";
}

.mdi-folder-question-outline::before {
  content: "\\F19CB";
}

.mdi-folder-refresh::before {
  content: "\\F0749";
}

.mdi-folder-refresh-outline::before {
  content: "\\F0542";
}

.mdi-folder-remove::before {
  content: "\\F0258";
}

.mdi-folder-remove-outline::before {
  content: "\\F0B9E";
}

.mdi-folder-search::before {
  content: "\\F0968";
}

.mdi-folder-search-outline::before {
  content: "\\F0969";
}

.mdi-folder-settings::before {
  content: "\\F107D";
}

.mdi-folder-settings-outline::before {
  content: "\\F107E";
}

.mdi-folder-star::before {
  content: "\\F069D";
}

.mdi-folder-star-multiple::before {
  content: "\\F13D3";
}

.mdi-folder-star-multiple-outline::before {
  content: "\\F13D4";
}

.mdi-folder-star-outline::before {
  content: "\\F0B9F";
}

.mdi-folder-swap::before {
  content: "\\F0FB6";
}

.mdi-folder-swap-outline::before {
  content: "\\F0FB7";
}

.mdi-folder-sync::before {
  content: "\\F0D0B";
}

.mdi-folder-sync-outline::before {
  content: "\\F0D0C";
}

.mdi-folder-table::before {
  content: "\\F12E3";
}

.mdi-folder-table-outline::before {
  content: "\\F12E4";
}

.mdi-folder-text::before {
  content: "\\F0C82";
}

.mdi-folder-text-outline::before {
  content: "\\F0C83";
}

.mdi-folder-upload::before {
  content: "\\F0259";
}

.mdi-folder-upload-outline::before {
  content: "\\F10ED";
}

.mdi-folder-wrench::before {
  content: "\\F19FC";
}

.mdi-folder-wrench-outline::before {
  content: "\\F19FD";
}

.mdi-folder-zip::before {
  content: "\\F06EB";
}

.mdi-folder-zip-outline::before {
  content: "\\F07B9";
}

.mdi-font-awesome::before {
  content: "\\F003A";
}

.mdi-food::before {
  content: "\\F025A";
}

.mdi-food-apple::before {
  content: "\\F025B";
}

.mdi-food-apple-outline::before {
  content: "\\F0C84";
}

.mdi-food-croissant::before {
  content: "\\F07C8";
}

.mdi-food-drumstick::before {
  content: "\\F141F";
}

.mdi-food-drumstick-off::before {
  content: "\\F1468";
}

.mdi-food-drumstick-off-outline::before {
  content: "\\F1469";
}

.mdi-food-drumstick-outline::before {
  content: "\\F1420";
}

.mdi-food-fork-drink::before {
  content: "\\F05F2";
}

.mdi-food-halal::before {
  content: "\\F1572";
}

.mdi-food-hot-dog::before {
  content: "\\F184B";
}

.mdi-food-kosher::before {
  content: "\\F1573";
}

.mdi-food-off::before {
  content: "\\F05F3";
}

.mdi-food-off-outline::before {
  content: "\\F1915";
}

.mdi-food-outline::before {
  content: "\\F1916";
}

.mdi-food-steak::before {
  content: "\\F146A";
}

.mdi-food-steak-off::before {
  content: "\\F146B";
}

.mdi-food-takeout-box::before {
  content: "\\F1836";
}

.mdi-food-takeout-box-outline::before {
  content: "\\F1837";
}

.mdi-food-turkey::before {
  content: "\\F171C";
}

.mdi-food-variant::before {
  content: "\\F025C";
}

.mdi-food-variant-off::before {
  content: "\\F13E5";
}

.mdi-foot-print::before {
  content: "\\F0F52";
}

.mdi-football::before {
  content: "\\F025D";
}

.mdi-football-australian::before {
  content: "\\F025E";
}

.mdi-football-helmet::before {
  content: "\\F025F";
}

.mdi-forest::before {
  content: "\\F1897";
}

.mdi-forest-outline::before {
  content: "\\F1C63";
}

.mdi-forklift::before {
  content: "\\F07C9";
}

.mdi-form-dropdown::before {
  content: "\\F1400";
}

.mdi-form-select::before {
  content: "\\F1401";
}

.mdi-form-textarea::before {
  content: "\\F1095";
}

.mdi-form-textbox::before {
  content: "\\F060E";
}

.mdi-form-textbox-lock::before {
  content: "\\F135D";
}

.mdi-form-textbox-password::before {
  content: "\\F07F5";
}

.mdi-format-align-bottom::before {
  content: "\\F0753";
}

.mdi-format-align-center::before {
  content: "\\F0260";
}

.mdi-format-align-justify::before {
  content: "\\F0261";
}

.mdi-format-align-left::before {
  content: "\\F0262";
}

.mdi-format-align-middle::before {
  content: "\\F0754";
}

.mdi-format-align-right::before {
  content: "\\F0263";
}

.mdi-format-align-top::before {
  content: "\\F0755";
}

.mdi-format-annotation-minus::before {
  content: "\\F0ABC";
}

.mdi-format-annotation-plus::before {
  content: "\\F0646";
}

.mdi-format-bold::before {
  content: "\\F0264";
}

.mdi-format-clear::before {
  content: "\\F0265";
}

.mdi-format-color-fill::before {
  content: "\\F0266";
}

.mdi-format-color-highlight::before {
  content: "\\F0E31";
}

.mdi-format-color-marker-cancel::before {
  content: "\\F1313";
}

.mdi-format-color-text::before {
  content: "\\F069E";
}

.mdi-format-columns::before {
  content: "\\F08DF";
}

.mdi-format-float-center::before {
  content: "\\F0267";
}

.mdi-format-float-left::before {
  content: "\\F0268";
}

.mdi-format-float-none::before {
  content: "\\F0269";
}

.mdi-format-float-right::before {
  content: "\\F026A";
}

.mdi-format-font::before {
  content: "\\F06D6";
}

.mdi-format-font-size-decrease::before {
  content: "\\F09F3";
}

.mdi-format-font-size-increase::before {
  content: "\\F09F4";
}

.mdi-format-header-1::before {
  content: "\\F026B";
}

.mdi-format-header-2::before {
  content: "\\F026C";
}

.mdi-format-header-3::before {
  content: "\\F026D";
}

.mdi-format-header-4::before {
  content: "\\F026E";
}

.mdi-format-header-5::before {
  content: "\\F026F";
}

.mdi-format-header-6::before {
  content: "\\F0270";
}

.mdi-format-header-decrease::before {
  content: "\\F0271";
}

.mdi-format-header-equal::before {
  content: "\\F0272";
}

.mdi-format-header-increase::before {
  content: "\\F0273";
}

.mdi-format-header-pound::before {
  content: "\\F0274";
}

.mdi-format-horizontal-align-center::before {
  content: "\\F061E";
}

.mdi-format-horizontal-align-left::before {
  content: "\\F061F";
}

.mdi-format-horizontal-align-right::before {
  content: "\\F0620";
}

.mdi-format-indent-decrease::before {
  content: "\\F0275";
}

.mdi-format-indent-increase::before {
  content: "\\F0276";
}

.mdi-format-italic::before {
  content: "\\F0277";
}

.mdi-format-letter-case::before {
  content: "\\F0B34";
}

.mdi-format-letter-case-lower::before {
  content: "\\F0B35";
}

.mdi-format-letter-case-upper::before {
  content: "\\F0B36";
}

.mdi-format-letter-ends-with::before {
  content: "\\F0FB8";
}

.mdi-format-letter-matches::before {
  content: "\\F0FB9";
}

.mdi-format-letter-spacing::before {
  content: "\\F1956";
}

.mdi-format-letter-spacing-variant::before {
  content: "\\F1AFB";
}

.mdi-format-letter-starts-with::before {
  content: "\\F0FBA";
}

.mdi-format-line-height::before {
  content: "\\F1AFC";
}

.mdi-format-line-spacing::before {
  content: "\\F0278";
}

.mdi-format-line-style::before {
  content: "\\F05C8";
}

.mdi-format-line-weight::before {
  content: "\\F05C9";
}

.mdi-format-list-bulleted::before {
  content: "\\F0279";
}

.mdi-format-list-bulleted-square::before {
  content: "\\F0DD0";
}

.mdi-format-list-bulleted-triangle::before {
  content: "\\F0EB2";
}

.mdi-format-list-bulleted-type::before {
  content: "\\F027A";
}

.mdi-format-list-checkbox::before {
  content: "\\F096A";
}

.mdi-format-list-checks::before {
  content: "\\F0756";
}

.mdi-format-list-group::before {
  content: "\\F1860";
}

.mdi-format-list-group-plus::before {
  content: "\\F1B56";
}

.mdi-format-list-numbered::before {
  content: "\\F027B";
}

.mdi-format-list-numbered-rtl::before {
  content: "\\F0D0D";
}

.mdi-format-list-text::before {
  content: "\\F126F";
}

.mdi-format-overline::before {
  content: "\\F0EB3";
}

.mdi-format-page-break::before {
  content: "\\F06D7";
}

.mdi-format-page-split::before {
  content: "\\F1917";
}

.mdi-format-paint::before {
  content: "\\F027C";
}

.mdi-format-paragraph::before {
  content: "\\F027D";
}

.mdi-format-paragraph-spacing::before {
  content: "\\F1AFD";
}

.mdi-format-pilcrow::before {
  content: "\\F06D8";
}

.mdi-format-pilcrow-arrow-left::before {
  content: "\\F0286";
}

.mdi-format-pilcrow-arrow-right::before {
  content: "\\F0285";
}

.mdi-format-quote-close::before {
  content: "\\F027E";
}

.mdi-format-quote-close-outline::before {
  content: "\\F11A8";
}

.mdi-format-quote-open::before {
  content: "\\F0757";
}

.mdi-format-quote-open-outline::before {
  content: "\\F11A7";
}

.mdi-format-rotate-90::before {
  content: "\\F06AA";
}

.mdi-format-section::before {
  content: "\\F069F";
}

.mdi-format-size::before {
  content: "\\F027F";
}

.mdi-format-strikethrough::before {
  content: "\\F0280";
}

.mdi-format-strikethrough-variant::before {
  content: "\\F0281";
}

.mdi-format-subscript::before {
  content: "\\F0282";
}

.mdi-format-superscript::before {
  content: "\\F0283";
}

.mdi-format-text::before {
  content: "\\F0284";
}

.mdi-format-text-rotation-angle-down::before {
  content: "\\F0FBB";
}

.mdi-format-text-rotation-angle-up::before {
  content: "\\F0FBC";
}

.mdi-format-text-rotation-down::before {
  content: "\\F0D73";
}

.mdi-format-text-rotation-down-vertical::before {
  content: "\\F0FBD";
}

.mdi-format-text-rotation-none::before {
  content: "\\F0D74";
}

.mdi-format-text-rotation-up::before {
  content: "\\F0FBE";
}

.mdi-format-text-rotation-vertical::before {
  content: "\\F0FBF";
}

.mdi-format-text-variant::before {
  content: "\\F0E32";
}

.mdi-format-text-variant-outline::before {
  content: "\\F150F";
}

.mdi-format-text-wrapping-clip::before {
  content: "\\F0D0E";
}

.mdi-format-text-wrapping-overflow::before {
  content: "\\F0D0F";
}

.mdi-format-text-wrapping-wrap::before {
  content: "\\F0D10";
}

.mdi-format-textbox::before {
  content: "\\F0D11";
}

.mdi-format-title::before {
  content: "\\F05F4";
}

.mdi-format-underline::before {
  content: "\\F0287";
}

.mdi-format-underline-wavy::before {
  content: "\\F18E9";
}

.mdi-format-vertical-align-bottom::before {
  content: "\\F0621";
}

.mdi-format-vertical-align-center::before {
  content: "\\F0622";
}

.mdi-format-vertical-align-top::before {
  content: "\\F0623";
}

.mdi-format-wrap-inline::before {
  content: "\\F0288";
}

.mdi-format-wrap-square::before {
  content: "\\F0289";
}

.mdi-format-wrap-tight::before {
  content: "\\F028A";
}

.mdi-format-wrap-top-bottom::before {
  content: "\\F028B";
}

.mdi-forum::before {
  content: "\\F028C";
}

.mdi-forum-minus::before {
  content: "\\F1AA9";
}

.mdi-forum-minus-outline::before {
  content: "\\F1AAA";
}

.mdi-forum-outline::before {
  content: "\\F0822";
}

.mdi-forum-plus::before {
  content: "\\F1AAB";
}

.mdi-forum-plus-outline::before {
  content: "\\F1AAC";
}

.mdi-forum-remove::before {
  content: "\\F1AAD";
}

.mdi-forum-remove-outline::before {
  content: "\\F1AAE";
}

.mdi-forward::before {
  content: "\\F028D";
}

.mdi-forwardburger::before {
  content: "\\F0D75";
}

.mdi-fountain::before {
  content: "\\F096B";
}

.mdi-fountain-pen::before {
  content: "\\F0D12";
}

.mdi-fountain-pen-tip::before {
  content: "\\F0D13";
}

.mdi-fraction-one-half::before {
  content: "\\F1992";
}

.mdi-freebsd::before {
  content: "\\F08E0";
}

.mdi-french-fries::before {
  content: "\\F1957";
}

.mdi-frequently-asked-questions::before {
  content: "\\F0EB4";
}

.mdi-fridge::before {
  content: "\\F0290";
}

.mdi-fridge-alert::before {
  content: "\\F11B1";
}

.mdi-fridge-alert-outline::before {
  content: "\\F11B2";
}

.mdi-fridge-bottom::before {
  content: "\\F0292";
}

.mdi-fridge-industrial::before {
  content: "\\F15EE";
}

.mdi-fridge-industrial-alert::before {
  content: "\\F15EF";
}

.mdi-fridge-industrial-alert-outline::before {
  content: "\\F15F0";
}

.mdi-fridge-industrial-off::before {
  content: "\\F15F1";
}

.mdi-fridge-industrial-off-outline::before {
  content: "\\F15F2";
}

.mdi-fridge-industrial-outline::before {
  content: "\\F15F3";
}

.mdi-fridge-off::before {
  content: "\\F11AF";
}

.mdi-fridge-off-outline::before {
  content: "\\F11B0";
}

.mdi-fridge-outline::before {
  content: "\\F028F";
}

.mdi-fridge-top::before {
  content: "\\F0291";
}

.mdi-fridge-variant::before {
  content: "\\F15F4";
}

.mdi-fridge-variant-alert::before {
  content: "\\F15F5";
}

.mdi-fridge-variant-alert-outline::before {
  content: "\\F15F6";
}

.mdi-fridge-variant-off::before {
  content: "\\F15F7";
}

.mdi-fridge-variant-off-outline::before {
  content: "\\F15F8";
}

.mdi-fridge-variant-outline::before {
  content: "\\F15F9";
}

.mdi-fruit-cherries::before {
  content: "\\F1042";
}

.mdi-fruit-cherries-off::before {
  content: "\\F13F8";
}

.mdi-fruit-citrus::before {
  content: "\\F1043";
}

.mdi-fruit-citrus-off::before {
  content: "\\F13F9";
}

.mdi-fruit-grapes::before {
  content: "\\F1044";
}

.mdi-fruit-grapes-outline::before {
  content: "\\F1045";
}

.mdi-fruit-pear::before {
  content: "\\F1A0E";
}

.mdi-fruit-pineapple::before {
  content: "\\F1046";
}

.mdi-fruit-watermelon::before {
  content: "\\F1047";
}

.mdi-fuel::before {
  content: "\\F07CA";
}

.mdi-fuel-cell::before {
  content: "\\F18B5";
}

.mdi-fullscreen::before {
  content: "\\F0293";
}

.mdi-fullscreen-exit::before {
  content: "\\F0294";
}

.mdi-function::before {
  content: "\\F0295";
}

.mdi-function-variant::before {
  content: "\\F0871";
}

.mdi-furigana-horizontal::before {
  content: "\\F1081";
}

.mdi-furigana-vertical::before {
  content: "\\F1082";
}

.mdi-fuse::before {
  content: "\\F0C85";
}

.mdi-fuse-alert::before {
  content: "\\F142D";
}

.mdi-fuse-blade::before {
  content: "\\F0C86";
}

.mdi-fuse-off::before {
  content: "\\F142C";
}

.mdi-gamepad::before {
  content: "\\F0296";
}

.mdi-gamepad-circle::before {
  content: "\\F0E33";
}

.mdi-gamepad-circle-down::before {
  content: "\\F0E34";
}

.mdi-gamepad-circle-left::before {
  content: "\\F0E35";
}

.mdi-gamepad-circle-outline::before {
  content: "\\F0E36";
}

.mdi-gamepad-circle-right::before {
  content: "\\F0E37";
}

.mdi-gamepad-circle-up::before {
  content: "\\F0E38";
}

.mdi-gamepad-down::before {
  content: "\\F0E39";
}

.mdi-gamepad-left::before {
  content: "\\F0E3A";
}

.mdi-gamepad-outline::before {
  content: "\\F1919";
}

.mdi-gamepad-right::before {
  content: "\\F0E3B";
}

.mdi-gamepad-round::before {
  content: "\\F0E3C";
}

.mdi-gamepad-round-down::before {
  content: "\\F0E3D";
}

.mdi-gamepad-round-left::before {
  content: "\\F0E3E";
}

.mdi-gamepad-round-outline::before {
  content: "\\F0E3F";
}

.mdi-gamepad-round-right::before {
  content: "\\F0E40";
}

.mdi-gamepad-round-up::before {
  content: "\\F0E41";
}

.mdi-gamepad-square::before {
  content: "\\F0EB5";
}

.mdi-gamepad-square-outline::before {
  content: "\\F0EB6";
}

.mdi-gamepad-up::before {
  content: "\\F0E42";
}

.mdi-gamepad-variant::before {
  content: "\\F0297";
}

.mdi-gamepad-variant-outline::before {
  content: "\\F0EB7";
}

.mdi-gamma::before {
  content: "\\F10EE";
}

.mdi-gantry-crane::before {
  content: "\\F0DD1";
}

.mdi-garage::before {
  content: "\\F06D9";
}

.mdi-garage-alert::before {
  content: "\\F0872";
}

.mdi-garage-alert-variant::before {
  content: "\\F12D5";
}

.mdi-garage-lock::before {
  content: "\\F17FB";
}

.mdi-garage-open::before {
  content: "\\F06DA";
}

.mdi-garage-open-variant::before {
  content: "\\F12D4";
}

.mdi-garage-variant::before {
  content: "\\F12D3";
}

.mdi-garage-variant-lock::before {
  content: "\\F17FC";
}

.mdi-gas-burner::before {
  content: "\\F1A1B";
}

.mdi-gas-cylinder::before {
  content: "\\F0647";
}

.mdi-gas-station::before {
  content: "\\F0298";
}

.mdi-gas-station-in-use::before {
  content: "\\F1CC4";
}

.mdi-gas-station-in-use-outline::before {
  content: "\\F1CC5";
}

.mdi-gas-station-off::before {
  content: "\\F1409";
}

.mdi-gas-station-off-outline::before {
  content: "\\F140A";
}

.mdi-gas-station-outline::before {
  content: "\\F0EB8";
}

.mdi-gate::before {
  content: "\\F0299";
}

.mdi-gate-alert::before {
  content: "\\F17F8";
}

.mdi-gate-and::before {
  content: "\\F08E1";
}

.mdi-gate-arrow-left::before {
  content: "\\F17F7";
}

.mdi-gate-arrow-right::before {
  content: "\\F1169";
}

.mdi-gate-buffer::before {
  content: "\\F1AFE";
}

.mdi-gate-nand::before {
  content: "\\F08E2";
}

.mdi-gate-nor::before {
  content: "\\F08E3";
}

.mdi-gate-not::before {
  content: "\\F08E4";
}

.mdi-gate-open::before {
  content: "\\F116A";
}

.mdi-gate-or::before {
  content: "\\F08E5";
}

.mdi-gate-xnor::before {
  content: "\\F08E6";
}

.mdi-gate-xor::before {
  content: "\\F08E7";
}

.mdi-gatsby::before {
  content: "\\F0E43";
}

.mdi-gauge::before {
  content: "\\F029A";
}

.mdi-gauge-empty::before {
  content: "\\F0873";
}

.mdi-gauge-full::before {
  content: "\\F0874";
}

.mdi-gauge-low::before {
  content: "\\F0875";
}

.mdi-gavel::before {
  content: "\\F029B";
}

.mdi-gender-female::before {
  content: "\\F029C";
}

.mdi-gender-male::before {
  content: "\\F029D";
}

.mdi-gender-male-female::before {
  content: "\\F029E";
}

.mdi-gender-male-female-variant::before {
  content: "\\F113F";
}

.mdi-gender-non-binary::before {
  content: "\\F1140";
}

.mdi-gender-transgender::before {
  content: "\\F029F";
}

.mdi-generator-mobile::before {
  content: "\\F1C8A";
}

.mdi-generator-portable::before {
  content: "\\F1C8B";
}

.mdi-generator-stationary::before {
  content: "\\F1C8C";
}

.mdi-gentoo::before {
  content: "\\F08E8";
}

.mdi-gesture::before {
  content: "\\F07CB";
}

.mdi-gesture-double-tap::before {
  content: "\\F073C";
}

.mdi-gesture-pinch::before {
  content: "\\F0ABD";
}

.mdi-gesture-spread::before {
  content: "\\F0ABE";
}

.mdi-gesture-swipe::before {
  content: "\\F0D76";
}

.mdi-gesture-swipe-down::before {
  content: "\\F073D";
}

.mdi-gesture-swipe-horizontal::before {
  content: "\\F0ABF";
}

.mdi-gesture-swipe-left::before {
  content: "\\F073E";
}

.mdi-gesture-swipe-right::before {
  content: "\\F073F";
}

.mdi-gesture-swipe-up::before {
  content: "\\F0740";
}

.mdi-gesture-swipe-vertical::before {
  content: "\\F0AC0";
}

.mdi-gesture-tap::before {
  content: "\\F0741";
}

.mdi-gesture-tap-box::before {
  content: "\\F12A9";
}

.mdi-gesture-tap-button::before {
  content: "\\F12A8";
}

.mdi-gesture-tap-hold::before {
  content: "\\F0D77";
}

.mdi-gesture-two-double-tap::before {
  content: "\\F0742";
}

.mdi-gesture-two-tap::before {
  content: "\\F0743";
}

.mdi-ghost::before {
  content: "\\F02A0";
}

.mdi-ghost-off::before {
  content: "\\F09F5";
}

.mdi-ghost-off-outline::before {
  content: "\\F165C";
}

.mdi-ghost-outline::before {
  content: "\\F165D";
}

.mdi-gift::before {
  content: "\\F0E44";
}

.mdi-gift-off::before {
  content: "\\F16EF";
}

.mdi-gift-off-outline::before {
  content: "\\F16F0";
}

.mdi-gift-open::before {
  content: "\\F16F1";
}

.mdi-gift-open-outline::before {
  content: "\\F16F2";
}

.mdi-gift-outline::before {
  content: "\\F02A1";
}

.mdi-git::before {
  content: "\\F02A2";
}

.mdi-github::before {
  content: "\\F02A4";
}

.mdi-gitlab::before {
  content: "\\F0BA0";
}

.mdi-glass-cocktail::before {
  content: "\\F0356";
}

.mdi-glass-cocktail-off::before {
  content: "\\F15E6";
}

.mdi-glass-flute::before {
  content: "\\F02A5";
}

.mdi-glass-fragile::before {
  content: "\\F1873";
}

.mdi-glass-mug::before {
  content: "\\F02A6";
}

.mdi-glass-mug-off::before {
  content: "\\F15E7";
}

.mdi-glass-mug-variant::before {
  content: "\\F1116";
}

.mdi-glass-mug-variant-off::before {
  content: "\\F15E8";
}

.mdi-glass-pint-outline::before {
  content: "\\F130D";
}

.mdi-glass-stange::before {
  content: "\\F02A7";
}

.mdi-glass-tulip::before {
  content: "\\F02A8";
}

.mdi-glass-wine::before {
  content: "\\F0876";
}

.mdi-glasses::before {
  content: "\\F02AA";
}

.mdi-globe-light::before {
  content: "\\F066F";
}

.mdi-globe-light-outline::before {
  content: "\\F12D7";
}

.mdi-globe-model::before {
  content: "\\F08E9";
}

.mdi-gmail::before {
  content: "\\F02AB";
}

.mdi-gnome::before {
  content: "\\F02AC";
}

.mdi-go-kart::before {
  content: "\\F0D79";
}

.mdi-go-kart-track::before {
  content: "\\F0D7A";
}

.mdi-gog::before {
  content: "\\F0BA1";
}

.mdi-gold::before {
  content: "\\F124F";
}

.mdi-golf::before {
  content: "\\F0823";
}

.mdi-golf-cart::before {
  content: "\\F11A4";
}

.mdi-golf-tee::before {
  content: "\\F1083";
}

.mdi-gondola::before {
  content: "\\F0686";
}

.mdi-goodreads::before {
  content: "\\F0D7B";
}

.mdi-google::before {
  content: "\\F02AD";
}

.mdi-google-ads::before {
  content: "\\F0C87";
}

.mdi-google-analytics::before {
  content: "\\F07CC";
}

.mdi-google-assistant::before {
  content: "\\F07CD";
}

.mdi-google-cardboard::before {
  content: "\\F02AE";
}

.mdi-google-chrome::before {
  content: "\\F02AF";
}

.mdi-google-circles::before {
  content: "\\F02B0";
}

.mdi-google-circles-communities::before {
  content: "\\F02B1";
}

.mdi-google-circles-extended::before {
  content: "\\F02B2";
}

.mdi-google-circles-group::before {
  content: "\\F02B3";
}

.mdi-google-classroom::before {
  content: "\\F02C0";
}

.mdi-google-cloud::before {
  content: "\\F11F6";
}

.mdi-google-downasaur::before {
  content: "\\F1362";
}

.mdi-google-drive::before {
  content: "\\F02B6";
}

.mdi-google-earth::before {
  content: "\\F02B7";
}

.mdi-google-fit::before {
  content: "\\F096C";
}

.mdi-google-glass::before {
  content: "\\F02B8";
}

.mdi-google-hangouts::before {
  content: "\\F02C9";
}

.mdi-google-keep::before {
  content: "\\F06DC";
}

.mdi-google-lens::before {
  content: "\\F09F6";
}

.mdi-google-maps::before {
  content: "\\F05F5";
}

.mdi-google-my-business::before {
  content: "\\F1048";
}

.mdi-google-nearby::before {
  content: "\\F02B9";
}

.mdi-google-play::before {
  content: "\\F02BC";
}

.mdi-google-plus::before {
  content: "\\F02BD";
}

.mdi-google-podcast::before {
  content: "\\F0EB9";
}

.mdi-google-spreadsheet::before {
  content: "\\F09F7";
}

.mdi-google-street-view::before {
  content: "\\F0C88";
}

.mdi-google-translate::before {
  content: "\\F02BF";
}

.mdi-gradient-horizontal::before {
  content: "\\F174A";
}

.mdi-gradient-vertical::before {
  content: "\\F06A0";
}

.mdi-grain::before {
  content: "\\F0D7C";
}

.mdi-graph::before {
  content: "\\F1049";
}

.mdi-graph-outline::before {
  content: "\\F104A";
}

.mdi-graphql::before {
  content: "\\F0877";
}

.mdi-grass::before {
  content: "\\F1510";
}

.mdi-grave-stone::before {
  content: "\\F0BA2";
}

.mdi-grease-pencil::before {
  content: "\\F0648";
}

.mdi-greater-than::before {
  content: "\\F096D";
}

.mdi-greater-than-or-equal::before {
  content: "\\F096E";
}

.mdi-greenhouse::before {
  content: "\\F002D";
}

.mdi-grid::before {
  content: "\\F02C1";
}

.mdi-grid-large::before {
  content: "\\F0758";
}

.mdi-grid-off::before {
  content: "\\F02C2";
}

.mdi-grill::before {
  content: "\\F0E45";
}

.mdi-grill-outline::before {
  content: "\\F118A";
}

.mdi-group::before {
  content: "\\F02C3";
}

.mdi-guitar-acoustic::before {
  content: "\\F0771";
}

.mdi-guitar-electric::before {
  content: "\\F02C4";
}

.mdi-guitar-pick::before {
  content: "\\F02C5";
}

.mdi-guitar-pick-outline::before {
  content: "\\F02C6";
}

.mdi-guy-fawkes-mask::before {
  content: "\\F0825";
}

.mdi-gymnastics::before {
  content: "\\F1A41";
}

.mdi-hail::before {
  content: "\\F0AC1";
}

.mdi-hair-dryer::before {
  content: "\\F10EF";
}

.mdi-hair-dryer-outline::before {
  content: "\\F10F0";
}

.mdi-halloween::before {
  content: "\\F0BA3";
}

.mdi-hamburger::before {
  content: "\\F0685";
}

.mdi-hamburger-check::before {
  content: "\\F1776";
}

.mdi-hamburger-minus::before {
  content: "\\F1777";
}

.mdi-hamburger-off::before {
  content: "\\F1778";
}

.mdi-hamburger-plus::before {
  content: "\\F1779";
}

.mdi-hamburger-remove::before {
  content: "\\F177A";
}

.mdi-hammer::before {
  content: "\\F08EA";
}

.mdi-hammer-screwdriver::before {
  content: "\\F1322";
}

.mdi-hammer-sickle::before {
  content: "\\F1887";
}

.mdi-hammer-wrench::before {
  content: "\\F1323";
}

.mdi-hand-back-left::before {
  content: "\\F0E46";
}

.mdi-hand-back-left-off::before {
  content: "\\F1830";
}

.mdi-hand-back-left-off-outline::before {
  content: "\\F1832";
}

.mdi-hand-back-left-outline::before {
  content: "\\F182C";
}

.mdi-hand-back-right::before {
  content: "\\F0E47";
}

.mdi-hand-back-right-off::before {
  content: "\\F1831";
}

.mdi-hand-back-right-off-outline::before {
  content: "\\F1833";
}

.mdi-hand-back-right-outline::before {
  content: "\\F182D";
}

.mdi-hand-clap::before {
  content: "\\F194B";
}

.mdi-hand-clap-off::before {
  content: "\\F1A42";
}

.mdi-hand-coin::before {
  content: "\\F188F";
}

.mdi-hand-coin-outline::before {
  content: "\\F1890";
}

.mdi-hand-cycle::before {
  content: "\\F1B9C";
}

.mdi-hand-extended::before {
  content: "\\F18B6";
}

.mdi-hand-extended-outline::before {
  content: "\\F18B7";
}

.mdi-hand-front-left::before {
  content: "\\F182B";
}

.mdi-hand-front-left-outline::before {
  content: "\\F182E";
}

.mdi-hand-front-right::before {
  content: "\\F0A4F";
}

.mdi-hand-front-right-outline::before {
  content: "\\F182F";
}

.mdi-hand-heart::before {
  content: "\\F10F1";
}

.mdi-hand-heart-outline::before {
  content: "\\F157E";
}

.mdi-hand-okay::before {
  content: "\\F0A50";
}

.mdi-hand-peace::before {
  content: "\\F0A51";
}

.mdi-hand-peace-variant::before {
  content: "\\F0A52";
}

.mdi-hand-pointing-down::before {
  content: "\\F0A53";
}

.mdi-hand-pointing-left::before {
  content: "\\F0A54";
}

.mdi-hand-pointing-right::before {
  content: "\\F02C7";
}

.mdi-hand-pointing-up::before {
  content: "\\F0A55";
}

.mdi-hand-saw::before {
  content: "\\F0E48";
}

.mdi-hand-wash::before {
  content: "\\F157F";
}

.mdi-hand-wash-outline::before {
  content: "\\F1580";
}

.mdi-hand-water::before {
  content: "\\F139F";
}

.mdi-hand-wave::before {
  content: "\\F1821";
}

.mdi-hand-wave-outline::before {
  content: "\\F1822";
}

.mdi-handball::before {
  content: "\\F0F53";
}

.mdi-handcuffs::before {
  content: "\\F113E";
}

.mdi-hands-pray::before {
  content: "\\F0579";
}

.mdi-handshake::before {
  content: "\\F1218";
}

.mdi-handshake-outline::before {
  content: "\\F15A1";
}

.mdi-hanger::before {
  content: "\\F02C8";
}

.mdi-hard-hat::before {
  content: "\\F096F";
}

.mdi-harddisk::before {
  content: "\\F02CA";
}

.mdi-harddisk-plus::before {
  content: "\\F104B";
}

.mdi-harddisk-remove::before {
  content: "\\F104C";
}

.mdi-hat-fedora::before {
  content: "\\F0BA4";
}

.mdi-hazard-lights::before {
  content: "\\F0C89";
}

.mdi-hdmi-port::before {
  content: "\\F1BB8";
}

.mdi-hdr::before {
  content: "\\F0D7D";
}

.mdi-hdr-off::before {
  content: "\\F0D7E";
}

.mdi-head::before {
  content: "\\F135E";
}

.mdi-head-alert::before {
  content: "\\F1338";
}

.mdi-head-alert-outline::before {
  content: "\\F1339";
}

.mdi-head-check::before {
  content: "\\F133A";
}

.mdi-head-check-outline::before {
  content: "\\F133B";
}

.mdi-head-cog::before {
  content: "\\F133C";
}

.mdi-head-cog-outline::before {
  content: "\\F133D";
}

.mdi-head-dots-horizontal::before {
  content: "\\F133E";
}

.mdi-head-dots-horizontal-outline::before {
  content: "\\F133F";
}

.mdi-head-flash::before {
  content: "\\F1340";
}

.mdi-head-flash-outline::before {
  content: "\\F1341";
}

.mdi-head-heart::before {
  content: "\\F1342";
}

.mdi-head-heart-outline::before {
  content: "\\F1343";
}

.mdi-head-lightbulb::before {
  content: "\\F1344";
}

.mdi-head-lightbulb-outline::before {
  content: "\\F1345";
}

.mdi-head-minus::before {
  content: "\\F1346";
}

.mdi-head-minus-outline::before {
  content: "\\F1347";
}

.mdi-head-outline::before {
  content: "\\F135F";
}

.mdi-head-plus::before {
  content: "\\F1348";
}

.mdi-head-plus-outline::before {
  content: "\\F1349";
}

.mdi-head-question::before {
  content: "\\F134A";
}

.mdi-head-question-outline::before {
  content: "\\F134B";
}

.mdi-head-remove::before {
  content: "\\F134C";
}

.mdi-head-remove-outline::before {
  content: "\\F134D";
}

.mdi-head-snowflake::before {
  content: "\\F134E";
}

.mdi-head-snowflake-outline::before {
  content: "\\F134F";
}

.mdi-head-sync::before {
  content: "\\F1350";
}

.mdi-head-sync-outline::before {
  content: "\\F1351";
}

.mdi-headphones::before {
  content: "\\F02CB";
}

.mdi-headphones-bluetooth::before {
  content: "\\F0970";
}

.mdi-headphones-box::before {
  content: "\\F02CC";
}

.mdi-headphones-off::before {
  content: "\\F07CE";
}

.mdi-headphones-settings::before {
  content: "\\F02CD";
}

.mdi-headset::before {
  content: "\\F02CE";
}

.mdi-headset-dock::before {
  content: "\\F02CF";
}

.mdi-headset-off::before {
  content: "\\F02D0";
}

.mdi-heart::before {
  content: "\\F02D1";
}

.mdi-heart-box::before {
  content: "\\F02D2";
}

.mdi-heart-box-outline::before {
  content: "\\F02D3";
}

.mdi-heart-broken::before {
  content: "\\F02D4";
}

.mdi-heart-broken-outline::before {
  content: "\\F0D14";
}

.mdi-heart-circle::before {
  content: "\\F0971";
}

.mdi-heart-circle-outline::before {
  content: "\\F0972";
}

.mdi-heart-cog::before {
  content: "\\F1663";
}

.mdi-heart-cog-outline::before {
  content: "\\F1664";
}

.mdi-heart-flash::before {
  content: "\\F0EF9";
}

.mdi-heart-half::before {
  content: "\\F06DF";
}

.mdi-heart-half-full::before {
  content: "\\F06DE";
}

.mdi-heart-half-outline::before {
  content: "\\F06E0";
}

.mdi-heart-minus::before {
  content: "\\F142F";
}

.mdi-heart-minus-outline::before {
  content: "\\F1432";
}

.mdi-heart-multiple::before {
  content: "\\F0A56";
}

.mdi-heart-multiple-outline::before {
  content: "\\F0A57";
}

.mdi-heart-off::before {
  content: "\\F0759";
}

.mdi-heart-off-outline::before {
  content: "\\F1434";
}

.mdi-heart-outline::before {
  content: "\\F02D5";
}

.mdi-heart-plus::before {
  content: "\\F142E";
}

.mdi-heart-plus-outline::before {
  content: "\\F1431";
}

.mdi-heart-pulse::before {
  content: "\\F05F6";
}

.mdi-heart-remove::before {
  content: "\\F1430";
}

.mdi-heart-remove-outline::before {
  content: "\\F1433";
}

.mdi-heart-search::before {
  content: "\\F1C8D";
}

.mdi-heart-settings::before {
  content: "\\F1665";
}

.mdi-heart-settings-outline::before {
  content: "\\F1666";
}

.mdi-heat-pump::before {
  content: "\\F1A43";
}

.mdi-heat-pump-outline::before {
  content: "\\F1A44";
}

.mdi-heat-wave::before {
  content: "\\F1A45";
}

.mdi-heating-coil::before {
  content: "\\F1AAF";
}

.mdi-helicopter::before {
  content: "\\F0AC2";
}

.mdi-help::before {
  content: "\\F02D6";
}

.mdi-help-box::before {
  content: "\\F078B";
}

.mdi-help-box-multiple::before {
  content: "\\F1C0A";
}

.mdi-help-box-multiple-outline::before {
  content: "\\F1C0B";
}

.mdi-help-box-outline::before {
  content: "\\F1C0C";
}

.mdi-help-circle::before {
  content: "\\F02D7";
}

.mdi-help-circle-outline::before {
  content: "\\F0625";
}

.mdi-help-network::before {
  content: "\\F06F5";
}

.mdi-help-network-outline::before {
  content: "\\F0C8A";
}

.mdi-help-rhombus::before {
  content: "\\F0BA5";
}

.mdi-help-rhombus-outline::before {
  content: "\\F0BA6";
}

.mdi-hexadecimal::before {
  content: "\\F12A7";
}

.mdi-hexagon::before {
  content: "\\F02D8";
}

.mdi-hexagon-multiple::before {
  content: "\\F06E1";
}

.mdi-hexagon-multiple-outline::before {
  content: "\\F10F2";
}

.mdi-hexagon-outline::before {
  content: "\\F02D9";
}

.mdi-hexagon-slice-1::before {
  content: "\\F0AC3";
}

.mdi-hexagon-slice-2::before {
  content: "\\F0AC4";
}

.mdi-hexagon-slice-3::before {
  content: "\\F0AC5";
}

.mdi-hexagon-slice-4::before {
  content: "\\F0AC6";
}

.mdi-hexagon-slice-5::before {
  content: "\\F0AC7";
}

.mdi-hexagon-slice-6::before {
  content: "\\F0AC8";
}

.mdi-hexagram::before {
  content: "\\F0AC9";
}

.mdi-hexagram-outline::before {
  content: "\\F0ACA";
}

.mdi-high-definition::before {
  content: "\\F07CF";
}

.mdi-high-definition-box::before {
  content: "\\F0878";
}

.mdi-highway::before {
  content: "\\F05F7";
}

.mdi-hiking::before {
  content: "\\F0D7F";
}

.mdi-history::before {
  content: "\\F02DA";
}

.mdi-hockey-puck::before {
  content: "\\F0879";
}

.mdi-hockey-sticks::before {
  content: "\\F087A";
}

.mdi-hololens::before {
  content: "\\F02DB";
}

.mdi-home::before {
  content: "\\F02DC";
}

.mdi-home-account::before {
  content: "\\F0826";
}

.mdi-home-alert::before {
  content: "\\F087B";
}

.mdi-home-alert-outline::before {
  content: "\\F15D0";
}

.mdi-home-analytics::before {
  content: "\\F0EBA";
}

.mdi-home-assistant::before {
  content: "\\F07D0";
}

.mdi-home-automation::before {
  content: "\\F07D1";
}

.mdi-home-battery::before {
  content: "\\F1901";
}

.mdi-home-battery-outline::before {
  content: "\\F1902";
}

.mdi-home-circle::before {
  content: "\\F07D2";
}

.mdi-home-circle-outline::before {
  content: "\\F104D";
}

.mdi-home-city::before {
  content: "\\F0D15";
}

.mdi-home-city-outline::before {
  content: "\\F0D16";
}

.mdi-home-clock::before {
  content: "\\F1A12";
}

.mdi-home-clock-outline::before {
  content: "\\F1A13";
}

.mdi-home-edit::before {
  content: "\\F1159";
}

.mdi-home-edit-outline::before {
  content: "\\F115A";
}

.mdi-home-export-outline::before {
  content: "\\F0F9B";
}

.mdi-home-flood::before {
  content: "\\F0EFA";
}

.mdi-home-floor-0::before {
  content: "\\F0DD2";
}

.mdi-home-floor-1::before {
  content: "\\F0D80";
}

.mdi-home-floor-2::before {
  content: "\\F0D81";
}

.mdi-home-floor-3::before {
  content: "\\F0D82";
}

.mdi-home-floor-a::before {
  content: "\\F0D83";
}

.mdi-home-floor-b::before {
  content: "\\F0D84";
}

.mdi-home-floor-g::before {
  content: "\\F0D85";
}

.mdi-home-floor-l::before {
  content: "\\F0D86";
}

.mdi-home-floor-negative-1::before {
  content: "\\F0DD3";
}

.mdi-home-group::before {
  content: "\\F0DD4";
}

.mdi-home-group-minus::before {
  content: "\\F19C1";
}

.mdi-home-group-plus::before {
  content: "\\F19C0";
}

.mdi-home-group-remove::before {
  content: "\\F19C2";
}

.mdi-home-heart::before {
  content: "\\F0827";
}

.mdi-home-import-outline::before {
  content: "\\F0F9C";
}

.mdi-home-lightbulb::before {
  content: "\\F1251";
}

.mdi-home-lightbulb-outline::before {
  content: "\\F1252";
}

.mdi-home-lightning-bolt::before {
  content: "\\F1903";
}

.mdi-home-lightning-bolt-outline::before {
  content: "\\F1904";
}

.mdi-home-lock::before {
  content: "\\F08EB";
}

.mdi-home-lock-open::before {
  content: "\\F08EC";
}

.mdi-home-map-marker::before {
  content: "\\F05F8";
}

.mdi-home-minus::before {
  content: "\\F0974";
}

.mdi-home-minus-outline::before {
  content: "\\F13D5";
}

.mdi-home-modern::before {
  content: "\\F02DD";
}

.mdi-home-off::before {
  content: "\\F1A46";
}

.mdi-home-off-outline::before {
  content: "\\F1A47";
}

.mdi-home-outline::before {
  content: "\\F06A1";
}

.mdi-home-percent::before {
  content: "\\F1C7C";
}

.mdi-home-percent-outline::before {
  content: "\\F1C7D";
}

.mdi-home-plus::before {
  content: "\\F0975";
}

.mdi-home-plus-outline::before {
  content: "\\F13D6";
}

.mdi-home-remove::before {
  content: "\\F1247";
}

.mdi-home-remove-outline::before {
  content: "\\F13D7";
}

.mdi-home-roof::before {
  content: "\\F112B";
}

.mdi-home-search::before {
  content: "\\F13B0";
}

.mdi-home-search-outline::before {
  content: "\\F13B1";
}

.mdi-home-silo::before {
  content: "\\F1BA0";
}

.mdi-home-silo-outline::before {
  content: "\\F1BA1";
}

.mdi-home-sound-in::before {
  content: "\\F1C2F";
}

.mdi-home-sound-in-outline::before {
  content: "\\F1C30";
}

.mdi-home-sound-out::before {
  content: "\\F1C31";
}

.mdi-home-sound-out-outline::before {
  content: "\\F1C32";
}

.mdi-home-switch::before {
  content: "\\F1794";
}

.mdi-home-switch-outline::before {
  content: "\\F1795";
}

.mdi-home-thermometer::before {
  content: "\\F0F54";
}

.mdi-home-thermometer-outline::before {
  content: "\\F0F55";
}

.mdi-home-variant::before {
  content: "\\F02DE";
}

.mdi-home-variant-outline::before {
  content: "\\F0BA7";
}

.mdi-hook::before {
  content: "\\F06E2";
}

.mdi-hook-off::before {
  content: "\\F06E3";
}

.mdi-hoop-house::before {
  content: "\\F0E56";
}

.mdi-hops::before {
  content: "\\F02DF";
}

.mdi-horizontal-rotate-clockwise::before {
  content: "\\F10F3";
}

.mdi-horizontal-rotate-counterclockwise::before {
  content: "\\F10F4";
}

.mdi-horse::before {
  content: "\\F15BF";
}

.mdi-horse-human::before {
  content: "\\F15C0";
}

.mdi-horse-variant::before {
  content: "\\F15C1";
}

.mdi-horse-variant-fast::before {
  content: "\\F186E";
}

.mdi-horseshoe::before {
  content: "\\F0A58";
}

.mdi-hospital::before {
  content: "\\F0FF6";
}

.mdi-hospital-box::before {
  content: "\\F02E0";
}

.mdi-hospital-box-outline::before {
  content: "\\F0FF7";
}

.mdi-hospital-building::before {
  content: "\\F02E1";
}

.mdi-hospital-marker::before {
  content: "\\F02E2";
}

.mdi-hot-tub::before {
  content: "\\F0828";
}

.mdi-hours-12::before {
  content: "\\F1C94";
}

.mdi-hours-24::before {
  content: "\\F1478";
}

.mdi-hub::before {
  content: "\\F1C95";
}

.mdi-hub-outline::before {
  content: "\\F1C96";
}

.mdi-hubspot::before {
  content: "\\F0D17";
}

.mdi-hulu::before {
  content: "\\F0829";
}

.mdi-human::before {
  content: "\\F02E6";
}

.mdi-human-baby-changing-table::before {
  content: "\\F138B";
}

.mdi-human-cane::before {
  content: "\\F1581";
}

.mdi-human-capacity-decrease::before {
  content: "\\F159B";
}

.mdi-human-capacity-increase::before {
  content: "\\F159C";
}

.mdi-human-child::before {
  content: "\\F02E7";
}

.mdi-human-dolly::before {
  content: "\\F1980";
}

.mdi-human-edit::before {
  content: "\\F14E8";
}

.mdi-human-female::before {
  content: "\\F0649";
}

.mdi-human-female-boy::before {
  content: "\\F0A59";
}

.mdi-human-female-dance::before {
  content: "\\F15C9";
}

.mdi-human-female-female::before {
  content: "\\F0A5A";
}

.mdi-human-female-female-child::before {
  content: "\\F1C8E";
}

.mdi-human-female-girl::before {
  content: "\\F0A5B";
}

.mdi-human-greeting::before {
  content: "\\F17C4";
}

.mdi-human-greeting-proximity::before {
  content: "\\F159D";
}

.mdi-human-greeting-variant::before {
  content: "\\F064A";
}

.mdi-human-handsdown::before {
  content: "\\F064B";
}

.mdi-human-handsup::before {
  content: "\\F064C";
}

.mdi-human-male::before {
  content: "\\F064D";
}

.mdi-human-male-board::before {
  content: "\\F0890";
}

.mdi-human-male-board-poll::before {
  content: "\\F0846";
}

.mdi-human-male-boy::before {
  content: "\\F0A5C";
}

.mdi-human-male-child::before {
  content: "\\F138C";
}

.mdi-human-male-female::before {
  content: "\\F02E8";
}

.mdi-human-male-female-child::before {
  content: "\\F1823";
}

.mdi-human-male-girl::before {
  content: "\\F0A5D";
}

.mdi-human-male-height::before {
  content: "\\F0EFB";
}

.mdi-human-male-height-variant::before {
  content: "\\F0EFC";
}

.mdi-human-male-male::before {
  content: "\\F0A5E";
}

.mdi-human-male-male-child::before {
  content: "\\F1C8F";
}

.mdi-human-non-binary::before {
  content: "\\F1848";
}

.mdi-human-pregnant::before {
  content: "\\F05CF";
}

.mdi-human-queue::before {
  content: "\\F1571";
}

.mdi-human-scooter::before {
  content: "\\F11E9";
}

.mdi-human-walker::before {
  content: "\\F1B71";
}

.mdi-human-wheelchair::before {
  content: "\\F138D";
}

.mdi-human-white-cane::before {
  content: "\\F1981";
}

.mdi-humble-bundle::before {
  content: "\\F0744";
}

.mdi-hvac::before {
  content: "\\F1352";
}

.mdi-hvac-off::before {
  content: "\\F159E";
}

.mdi-hydraulic-oil-level::before {
  content: "\\F1324";
}

.mdi-hydraulic-oil-temperature::before {
  content: "\\F1325";
}

.mdi-hydro-power::before {
  content: "\\F12E5";
}

.mdi-hydrogen-station::before {
  content: "\\F1894";
}

.mdi-ice-cream::before {
  content: "\\F082A";
}

.mdi-ice-cream-off::before {
  content: "\\F0E52";
}

.mdi-ice-pop::before {
  content: "\\F0EFD";
}

.mdi-id-card::before {
  content: "\\F0FC0";
}

.mdi-identifier::before {
  content: "\\F0EFE";
}

.mdi-ideogram-cjk::before {
  content: "\\F1331";
}

.mdi-ideogram-cjk-variant::before {
  content: "\\F1332";
}

.mdi-image::before {
  content: "\\F02E9";
}

.mdi-image-album::before {
  content: "\\F02EA";
}

.mdi-image-area::before {
  content: "\\F02EB";
}

.mdi-image-area-close::before {
  content: "\\F02EC";
}

.mdi-image-auto-adjust::before {
  content: "\\F0FC1";
}

.mdi-image-broken::before {
  content: "\\F02ED";
}

.mdi-image-broken-variant::before {
  content: "\\F02EE";
}

.mdi-image-check::before {
  content: "\\F1B25";
}

.mdi-image-check-outline::before {
  content: "\\F1B26";
}

.mdi-image-edit::before {
  content: "\\F11E3";
}

.mdi-image-edit-outline::before {
  content: "\\F11E4";
}

.mdi-image-filter-black-white::before {
  content: "\\F02F0";
}

.mdi-image-filter-center-focus::before {
  content: "\\F02F1";
}

.mdi-image-filter-center-focus-strong::before {
  content: "\\F0EFF";
}

.mdi-image-filter-center-focus-strong-outline::before {
  content: "\\F0F00";
}

.mdi-image-filter-center-focus-weak::before {
  content: "\\F02F2";
}

.mdi-image-filter-drama::before {
  content: "\\F02F3";
}

.mdi-image-filter-drama-outline::before {
  content: "\\F1BFF";
}

.mdi-image-filter-frames::before {
  content: "\\F02F4";
}

.mdi-image-filter-hdr::before {
  content: "\\F02F5";
}

.mdi-image-filter-hdr-outline::before {
  content: "\\F1C64";
}

.mdi-image-filter-none::before {
  content: "\\F02F6";
}

.mdi-image-filter-tilt-shift::before {
  content: "\\F02F7";
}

.mdi-image-filter-vintage::before {
  content: "\\F02F8";
}

.mdi-image-frame::before {
  content: "\\F0E49";
}

.mdi-image-lock::before {
  content: "\\F1AB0";
}

.mdi-image-lock-outline::before {
  content: "\\F1AB1";
}

.mdi-image-marker::before {
  content: "\\F177B";
}

.mdi-image-marker-outline::before {
  content: "\\F177C";
}

.mdi-image-minus::before {
  content: "\\F1419";
}

.mdi-image-minus-outline::before {
  content: "\\F1B47";
}

.mdi-image-move::before {
  content: "\\F09F8";
}

.mdi-image-multiple::before {
  content: "\\F02F9";
}

.mdi-image-multiple-outline::before {
  content: "\\F02EF";
}

.mdi-image-off::before {
  content: "\\F082B";
}

.mdi-image-off-outline::before {
  content: "\\F11D1";
}

.mdi-image-outline::before {
  content: "\\F0976";
}

.mdi-image-plus::before {
  content: "\\F087C";
}

.mdi-image-plus-outline::before {
  content: "\\F1B46";
}

.mdi-image-refresh::before {
  content: "\\F19FE";
}

.mdi-image-refresh-outline::before {
  content: "\\F19FF";
}

.mdi-image-remove::before {
  content: "\\F1418";
}

.mdi-image-remove-outline::before {
  content: "\\F1B48";
}

.mdi-image-search::before {
  content: "\\F0977";
}

.mdi-image-search-outline::before {
  content: "\\F0978";
}

.mdi-image-size-select-actual::before {
  content: "\\F0C8D";
}

.mdi-image-size-select-large::before {
  content: "\\F0C8E";
}

.mdi-image-size-select-small::before {
  content: "\\F0C8F";
}

.mdi-image-sync::before {
  content: "\\F1A00";
}

.mdi-image-sync-outline::before {
  content: "\\F1A01";
}

.mdi-image-text::before {
  content: "\\F160D";
}

.mdi-import::before {
  content: "\\F02FA";
}

.mdi-inbox::before {
  content: "\\F0687";
}

.mdi-inbox-arrow-down::before {
  content: "\\F02FB";
}

.mdi-inbox-arrow-down-outline::before {
  content: "\\F1270";
}

.mdi-inbox-arrow-up::before {
  content: "\\F03D1";
}

.mdi-inbox-arrow-up-outline::before {
  content: "\\F1271";
}

.mdi-inbox-full::before {
  content: "\\F1272";
}

.mdi-inbox-full-outline::before {
  content: "\\F1273";
}

.mdi-inbox-multiple::before {
  content: "\\F08B0";
}

.mdi-inbox-multiple-outline::before {
  content: "\\F0BA8";
}

.mdi-inbox-outline::before {
  content: "\\F1274";
}

.mdi-inbox-remove::before {
  content: "\\F159F";
}

.mdi-inbox-remove-outline::before {
  content: "\\F15A0";
}

.mdi-incognito::before {
  content: "\\F05F9";
}

.mdi-incognito-circle::before {
  content: "\\F1421";
}

.mdi-incognito-circle-off::before {
  content: "\\F1422";
}

.mdi-incognito-off::before {
  content: "\\F0075";
}

.mdi-induction::before {
  content: "\\F184C";
}

.mdi-infinity::before {
  content: "\\F06E4";
}

.mdi-information::before {
  content: "\\F02FC";
}

.mdi-information-box::before {
  content: "\\F1C65";
}

.mdi-information-box-outline::before {
  content: "\\F1C66";
}

.mdi-information-off::before {
  content: "\\F178C";
}

.mdi-information-off-outline::before {
  content: "\\F178D";
}

.mdi-information-outline::before {
  content: "\\F02FD";
}

.mdi-information-slab-box::before {
  content: "\\F1C67";
}

.mdi-information-slab-box-outline::before {
  content: "\\F1C68";
}

.mdi-information-slab-circle::before {
  content: "\\F1C69";
}

.mdi-information-slab-circle-outline::before {
  content: "\\F1C6A";
}

.mdi-information-slab-symbol::before {
  content: "\\F1C6B";
}

.mdi-information-symbol::before {
  content: "\\F1C6C";
}

.mdi-information-variant::before {
  content: "\\F064E";
}

.mdi-information-variant-box::before {
  content: "\\F1C6D";
}

.mdi-information-variant-box-outline::before {
  content: "\\F1C6E";
}

.mdi-information-variant-circle::before {
  content: "\\F1C6F";
}

.mdi-information-variant-circle-outline::before {
  content: "\\F1C70";
}

.mdi-instagram::before {
  content: "\\F02FE";
}

.mdi-instrument-triangle::before {
  content: "\\F104E";
}

.mdi-integrated-circuit-chip::before {
  content: "\\F1913";
}

.mdi-invert-colors::before {
  content: "\\F0301";
}

.mdi-invert-colors-off::before {
  content: "\\F0E4A";
}

.mdi-invoice::before {
  content: "\\F1CD2";
}

.mdi-invoice-arrow-left::before {
  content: "\\F1CD3";
}

.mdi-invoice-arrow-left-outline::before {
  content: "\\F1CD4";
}

.mdi-invoice-arrow-right::before {
  content: "\\F1CD5";
}

.mdi-invoice-arrow-right-outline::before {
  content: "\\F1CD6";
}

.mdi-invoice-check::before {
  content: "\\F1CD7";
}

.mdi-invoice-check-outline::before {
  content: "\\F1CD8";
}

.mdi-invoice-clock::before {
  content: "\\F1CD9";
}

.mdi-invoice-clock-outline::before {
  content: "\\F1CDA";
}

.mdi-invoice-edit::before {
  content: "\\F1CDB";
}

.mdi-invoice-edit-outline::before {
  content: "\\F1CDC";
}

.mdi-invoice-export-outline::before {
  content: "\\F1CDD";
}

.mdi-invoice-fast::before {
  content: "\\F1CDE";
}

.mdi-invoice-fast-outline::before {
  content: "\\F1CDF";
}

.mdi-invoice-import::before {
  content: "\\F1CE0";
}

.mdi-invoice-import-outline::before {
  content: "\\F1CE1";
}

.mdi-invoice-list::before {
  content: "\\F1CE2";
}

.mdi-invoice-list-outline::before {
  content: "\\F1CE3";
}

.mdi-invoice-minus::before {
  content: "\\F1CE4";
}

.mdi-invoice-minus-outline::before {
  content: "\\F1CE5";
}

.mdi-invoice-multiple::before {
  content: "\\F1CE6";
}

.mdi-invoice-multiple-outline::before {
  content: "\\F1CE7";
}

.mdi-invoice-outline::before {
  content: "\\F1CE8";
}

.mdi-invoice-plus::before {
  content: "\\F1CE9";
}

.mdi-invoice-plus-outline::before {
  content: "\\F1CEA";
}

.mdi-invoice-remove::before {
  content: "\\F1CEB";
}

.mdi-invoice-remove-outline::before {
  content: "\\F1CEC";
}

.mdi-invoice-send::before {
  content: "\\F1CED";
}

.mdi-invoice-send-outline::before {
  content: "\\F1CEE";
}

.mdi-invoice-text::before {
  content: "\\F1CEF";
}

.mdi-invoice-text-arrow-left::before {
  content: "\\F1CF0";
}

.mdi-invoice-text-arrow-left-outline::before {
  content: "\\F1CF1";
}

.mdi-invoice-text-arrow-right::before {
  content: "\\F1CF2";
}

.mdi-invoice-text-arrow-right-outline::before {
  content: "\\F1CF3";
}

.mdi-invoice-text-check::before {
  content: "\\F1CF4";
}

.mdi-invoice-text-check-outline::before {
  content: "\\F1CF5";
}

.mdi-invoice-text-clock::before {
  content: "\\F1CF6";
}

.mdi-invoice-text-clock-outline::before {
  content: "\\F1CF7";
}

.mdi-invoice-text-edit::before {
  content: "\\F1CF8";
}

.mdi-invoice-text-edit-outline::before {
  content: "\\F1CF9";
}

.mdi-invoice-text-fast::before {
  content: "\\F1CFA";
}

.mdi-invoice-text-fast-outline::before {
  content: "\\F1CFB";
}

.mdi-invoice-text-minus::before {
  content: "\\F1CFC";
}

.mdi-invoice-text-minus-outline::before {
  content: "\\F1CFD";
}

.mdi-invoice-text-multiple::before {
  content: "\\F1CFE";
}

.mdi-invoice-text-multiple-outline::before {
  content: "\\F1CFF";
}

.mdi-invoice-text-outline::before {
  content: "\\F1D00";
}

.mdi-invoice-text-plus::before {
  content: "\\F1D01";
}

.mdi-invoice-text-plus-outline::before {
  content: "\\F1D02";
}

.mdi-invoice-text-remove::before {
  content: "\\F1D03";
}

.mdi-invoice-text-remove-outline::before {
  content: "\\F1D04";
}

.mdi-invoice-text-send::before {
  content: "\\F1D05";
}

.mdi-invoice-text-send-outline::before {
  content: "\\F1D06";
}

.mdi-iobroker::before {
  content: "\\F12E8";
}

.mdi-ip::before {
  content: "\\F0A5F";
}

.mdi-ip-network::before {
  content: "\\F0A60";
}

.mdi-ip-network-outline::before {
  content: "\\F0C90";
}

.mdi-ip-outline::before {
  content: "\\F1982";
}

.mdi-ipod::before {
  content: "\\F0C91";
}

.mdi-iron::before {
  content: "\\F1824";
}

.mdi-iron-board::before {
  content: "\\F1838";
}

.mdi-iron-outline::before {
  content: "\\F1825";
}

.mdi-island::before {
  content: "\\F104F";
}

.mdi-island-variant::before {
  content: "\\F1CC6";
}

.mdi-iv-bag::before {
  content: "\\F10B9";
}

.mdi-jabber::before {
  content: "\\F0DD5";
}

.mdi-jeepney::before {
  content: "\\F0302";
}

.mdi-jellyfish::before {
  content: "\\F0F01";
}

.mdi-jellyfish-outline::before {
  content: "\\F0F02";
}

.mdi-jira::before {
  content: "\\F0303";
}

.mdi-jquery::before {
  content: "\\F087D";
}

.mdi-jsfiddle::before {
  content: "\\F0304";
}

.mdi-jump-rope::before {
  content: "\\F12FF";
}

.mdi-kabaddi::before {
  content: "\\F0D87";
}

.mdi-kangaroo::before {
  content: "\\F1558";
}

.mdi-karate::before {
  content: "\\F082C";
}

.mdi-kayaking::before {
  content: "\\F08AF";
}

.mdi-keg::before {
  content: "\\F0305";
}

.mdi-kettle::before {
  content: "\\F05FA";
}

.mdi-kettle-alert::before {
  content: "\\F1317";
}

.mdi-kettle-alert-outline::before {
  content: "\\F1318";
}

.mdi-kettle-off::before {
  content: "\\F131B";
}

.mdi-kettle-off-outline::before {
  content: "\\F131C";
}

.mdi-kettle-outline::before {
  content: "\\F0F56";
}

.mdi-kettle-pour-over::before {
  content: "\\F173C";
}

.mdi-kettle-steam::before {
  content: "\\F1319";
}

.mdi-kettle-steam-outline::before {
  content: "\\F131A";
}

.mdi-kettlebell::before {
  content: "\\F1300";
}

.mdi-key::before {
  content: "\\F0306";
}

.mdi-key-alert::before {
  content: "\\F1983";
}

.mdi-key-alert-outline::before {
  content: "\\F1984";
}

.mdi-key-arrow-right::before {
  content: "\\F1312";
}

.mdi-key-chain::before {
  content: "\\F1574";
}

.mdi-key-chain-variant::before {
  content: "\\F1575";
}

.mdi-key-change::before {
  content: "\\F0307";
}

.mdi-key-link::before {
  content: "\\F119F";
}

.mdi-key-minus::before {
  content: "\\F0308";
}

.mdi-key-outline::before {
  content: "\\F0DD6";
}

.mdi-key-plus::before {
  content: "\\F0309";
}

.mdi-key-remove::before {
  content: "\\F030A";
}

.mdi-key-star::before {
  content: "\\F119E";
}

.mdi-key-variant::before {
  content: "\\F030B";
}

.mdi-key-wireless::before {
  content: "\\F0FC2";
}

.mdi-keyboard::before {
  content: "\\F030C";
}

.mdi-keyboard-backspace::before {
  content: "\\F030D";
}

.mdi-keyboard-caps::before {
  content: "\\F030E";
}

.mdi-keyboard-close::before {
  content: "\\F030F";
}

.mdi-keyboard-close-outline::before {
  content: "\\F1C00";
}

.mdi-keyboard-esc::before {
  content: "\\F12B7";
}

.mdi-keyboard-f1::before {
  content: "\\F12AB";
}

.mdi-keyboard-f10::before {
  content: "\\F12B4";
}

.mdi-keyboard-f11::before {
  content: "\\F12B5";
}

.mdi-keyboard-f12::before {
  content: "\\F12B6";
}

.mdi-keyboard-f2::before {
  content: "\\F12AC";
}

.mdi-keyboard-f3::before {
  content: "\\F12AD";
}

.mdi-keyboard-f4::before {
  content: "\\F12AE";
}

.mdi-keyboard-f5::before {
  content: "\\F12AF";
}

.mdi-keyboard-f6::before {
  content: "\\F12B0";
}

.mdi-keyboard-f7::before {
  content: "\\F12B1";
}

.mdi-keyboard-f8::before {
  content: "\\F12B2";
}

.mdi-keyboard-f9::before {
  content: "\\F12B3";
}

.mdi-keyboard-off::before {
  content: "\\F0310";
}

.mdi-keyboard-off-outline::before {
  content: "\\F0E4B";
}

.mdi-keyboard-outline::before {
  content: "\\F097B";
}

.mdi-keyboard-return::before {
  content: "\\F0311";
}

.mdi-keyboard-settings::before {
  content: "\\F09F9";
}

.mdi-keyboard-settings-outline::before {
  content: "\\F09FA";
}

.mdi-keyboard-space::before {
  content: "\\F1050";
}

.mdi-keyboard-tab::before {
  content: "\\F0312";
}

.mdi-keyboard-tab-reverse::before {
  content: "\\F0325";
}

.mdi-keyboard-variant::before {
  content: "\\F0313";
}

.mdi-khanda::before {
  content: "\\F10FD";
}

.mdi-kickstarter::before {
  content: "\\F0745";
}

.mdi-kite::before {
  content: "\\F1985";
}

.mdi-kite-outline::before {
  content: "\\F1986";
}

.mdi-kitesurfing::before {
  content: "\\F1744";
}

.mdi-klingon::before {
  content: "\\F135B";
}

.mdi-knife::before {
  content: "\\F09FB";
}

.mdi-knife-military::before {
  content: "\\F09FC";
}

.mdi-knob::before {
  content: "\\F1B96";
}

.mdi-koala::before {
  content: "\\F173F";
}

.mdi-kodi::before {
  content: "\\F0314";
}

.mdi-kubernetes::before {
  content: "\\F10FE";
}

.mdi-label::before {
  content: "\\F0315";
}

.mdi-label-multiple::before {
  content: "\\F1375";
}

.mdi-label-multiple-outline::before {
  content: "\\F1376";
}

.mdi-label-off::before {
  content: "\\F0ACB";
}

.mdi-label-off-outline::before {
  content: "\\F0ACC";
}

.mdi-label-outline::before {
  content: "\\F0316";
}

.mdi-label-percent::before {
  content: "\\F12EA";
}

.mdi-label-percent-outline::before {
  content: "\\F12EB";
}

.mdi-label-variant::before {
  content: "\\F0ACD";
}

.mdi-label-variant-outline::before {
  content: "\\F0ACE";
}

.mdi-ladder::before {
  content: "\\F15A2";
}

.mdi-ladybug::before {
  content: "\\F082D";
}

.mdi-lambda::before {
  content: "\\F0627";
}

.mdi-lamp::before {
  content: "\\F06B5";
}

.mdi-lamp-outline::before {
  content: "\\F17D0";
}

.mdi-lamps::before {
  content: "\\F1576";
}

.mdi-lamps-outline::before {
  content: "\\F17D1";
}

.mdi-lan::before {
  content: "\\F0317";
}

.mdi-lan-check::before {
  content: "\\F12AA";
}

.mdi-lan-connect::before {
  content: "\\F0318";
}

.mdi-lan-disconnect::before {
  content: "\\F0319";
}

.mdi-lan-pending::before {
  content: "\\F031A";
}

.mdi-land-fields::before {
  content: "\\F1AB2";
}

.mdi-land-plots::before {
  content: "\\F1AB3";
}

.mdi-land-plots-circle::before {
  content: "\\F1AB4";
}

.mdi-land-plots-circle-variant::before {
  content: "\\F1AB5";
}

.mdi-land-plots-marker::before {
  content: "\\F1C5D";
}

.mdi-land-rows-horizontal::before {
  content: "\\F1AB6";
}

.mdi-land-rows-vertical::before {
  content: "\\F1AB7";
}

.mdi-landslide::before {
  content: "\\F1A48";
}

.mdi-landslide-outline::before {
  content: "\\F1A49";
}

.mdi-language-c::before {
  content: "\\F0671";
}

.mdi-language-cpp::before {
  content: "\\F0672";
}

.mdi-language-csharp::before {
  content: "\\F031B";
}

.mdi-language-css3::before {
  content: "\\F031C";
}

.mdi-language-fortran::before {
  content: "\\F121A";
}

.mdi-language-go::before {
  content: "\\F07D3";
}

.mdi-language-haskell::before {
  content: "\\F0C92";
}

.mdi-language-html5::before {
  content: "\\F031D";
}

.mdi-language-java::before {
  content: "\\F0B37";
}

.mdi-language-javascript::before {
  content: "\\F031E";
}

.mdi-language-kotlin::before {
  content: "\\F1219";
}

.mdi-language-lua::before {
  content: "\\F08B1";
}

.mdi-language-markdown::before {
  content: "\\F0354";
}

.mdi-language-markdown-outline::before {
  content: "\\F0F5B";
}

.mdi-language-php::before {
  content: "\\F031F";
}

.mdi-language-python::before {
  content: "\\F0320";
}

.mdi-language-r::before {
  content: "\\F07D4";
}

.mdi-language-ruby::before {
  content: "\\F0D2D";
}

.mdi-language-ruby-on-rails::before {
  content: "\\F0ACF";
}

.mdi-language-rust::before {
  content: "\\F1617";
}

.mdi-language-swift::before {
  content: "\\F06E5";
}

.mdi-language-typescript::before {
  content: "\\F06E6";
}

.mdi-language-xaml::before {
  content: "\\F0673";
}

.mdi-laptop::before {
  content: "\\F0322";
}

.mdi-laptop-account::before {
  content: "\\F1A4A";
}

.mdi-laptop-off::before {
  content: "\\F06E7";
}

.mdi-laravel::before {
  content: "\\F0AD0";
}

.mdi-laser-pointer::before {
  content: "\\F1484";
}

.mdi-lasso::before {
  content: "\\F0F03";
}

.mdi-lastpass::before {
  content: "\\F0446";
}

.mdi-latitude::before {
  content: "\\F0F57";
}

.mdi-launch::before {
  content: "\\F0327";
}

.mdi-lava-lamp::before {
  content: "\\F07D5";
}

.mdi-layers::before {
  content: "\\F0328";
}

.mdi-layers-edit::before {
  content: "\\F1892";
}

.mdi-layers-minus::before {
  content: "\\F0E4C";
}

.mdi-layers-off::before {
  content: "\\F0329";
}

.mdi-layers-off-outline::before {
  content: "\\F09FD";
}

.mdi-layers-outline::before {
  content: "\\F09FE";
}

.mdi-layers-plus::before {
  content: "\\F0E4D";
}

.mdi-layers-remove::before {
  content: "\\F0E4E";
}

.mdi-layers-search::before {
  content: "\\F1206";
}

.mdi-layers-search-outline::before {
  content: "\\F1207";
}

.mdi-layers-triple::before {
  content: "\\F0F58";
}

.mdi-layers-triple-outline::before {
  content: "\\F0F59";
}

.mdi-lead-pencil::before {
  content: "\\F064F";
}

.mdi-leaf::before {
  content: "\\F032A";
}

.mdi-leaf-circle::before {
  content: "\\F1905";
}

.mdi-leaf-circle-outline::before {
  content: "\\F1906";
}

.mdi-leaf-maple::before {
  content: "\\F0C93";
}

.mdi-leaf-maple-off::before {
  content: "\\F12DA";
}

.mdi-leaf-off::before {
  content: "\\F12D9";
}

.mdi-leak::before {
  content: "\\F0DD7";
}

.mdi-leak-off::before {
  content: "\\F0DD8";
}

.mdi-lectern::before {
  content: "\\F1AF0";
}

.mdi-led-off::before {
  content: "\\F032B";
}

.mdi-led-on::before {
  content: "\\F032C";
}

.mdi-led-outline::before {
  content: "\\F032D";
}

.mdi-led-strip::before {
  content: "\\F07D6";
}

.mdi-led-strip-variant::before {
  content: "\\F1051";
}

.mdi-led-strip-variant-off::before {
  content: "\\F1A4B";
}

.mdi-led-variant-off::before {
  content: "\\F032E";
}

.mdi-led-variant-on::before {
  content: "\\F032F";
}

.mdi-led-variant-outline::before {
  content: "\\F0330";
}

.mdi-leek::before {
  content: "\\F117D";
}

.mdi-less-than::before {
  content: "\\F097C";
}

.mdi-less-than-or-equal::before {
  content: "\\F097D";
}

.mdi-library::before {
  content: "\\F0331";
}

.mdi-library-outline::before {
  content: "\\F1A22";
}

.mdi-library-shelves::before {
  content: "\\F0BA9";
}

.mdi-license::before {
  content: "\\F0FC3";
}

.mdi-lifebuoy::before {
  content: "\\F087E";
}

.mdi-light-flood-down::before {
  content: "\\F1987";
}

.mdi-light-flood-up::before {
  content: "\\F1988";
}

.mdi-light-recessed::before {
  content: "\\F179B";
}

.mdi-light-switch::before {
  content: "\\F097E";
}

.mdi-light-switch-off::before {
  content: "\\F1A24";
}

.mdi-lightbulb::before {
  content: "\\F0335";
}

.mdi-lightbulb-alert::before {
  content: "\\F19E1";
}

.mdi-lightbulb-alert-outline::before {
  content: "\\F19E2";
}

.mdi-lightbulb-auto::before {
  content: "\\F1800";
}

.mdi-lightbulb-auto-outline::before {
  content: "\\F1801";
}

.mdi-lightbulb-cfl::before {
  content: "\\F1208";
}

.mdi-lightbulb-cfl-off::before {
  content: "\\F1209";
}

.mdi-lightbulb-cfl-spiral::before {
  content: "\\F1275";
}

.mdi-lightbulb-cfl-spiral-off::before {
  content: "\\F12C3";
}

.mdi-lightbulb-fluorescent-tube::before {
  content: "\\F1804";
}

.mdi-lightbulb-fluorescent-tube-outline::before {
  content: "\\F1805";
}

.mdi-lightbulb-group::before {
  content: "\\F1253";
}

.mdi-lightbulb-group-off::before {
  content: "\\F12CD";
}

.mdi-lightbulb-group-off-outline::before {
  content: "\\F12CE";
}

.mdi-lightbulb-group-outline::before {
  content: "\\F1254";
}

.mdi-lightbulb-multiple::before {
  content: "\\F1255";
}

.mdi-lightbulb-multiple-off::before {
  content: "\\F12CF";
}

.mdi-lightbulb-multiple-off-outline::before {
  content: "\\F12D0";
}

.mdi-lightbulb-multiple-outline::before {
  content: "\\F1256";
}

.mdi-lightbulb-night::before {
  content: "\\F1A4C";
}

.mdi-lightbulb-night-outline::before {
  content: "\\F1A4D";
}

.mdi-lightbulb-off::before {
  content: "\\F0E4F";
}

.mdi-lightbulb-off-outline::before {
  content: "\\F0E50";
}

.mdi-lightbulb-on::before {
  content: "\\F06E8";
}

.mdi-lightbulb-on-10::before {
  content: "\\F1A4E";
}

.mdi-lightbulb-on-20::before {
  content: "\\F1A4F";
}

.mdi-lightbulb-on-30::before {
  content: "\\F1A50";
}

.mdi-lightbulb-on-40::before {
  content: "\\F1A51";
}

.mdi-lightbulb-on-50::before {
  content: "\\F1A52";
}

.mdi-lightbulb-on-60::before {
  content: "\\F1A53";
}

.mdi-lightbulb-on-70::before {
  content: "\\F1A54";
}

.mdi-lightbulb-on-80::before {
  content: "\\F1A55";
}

.mdi-lightbulb-on-90::before {
  content: "\\F1A56";
}

.mdi-lightbulb-on-outline::before {
  content: "\\F06E9";
}

.mdi-lightbulb-outline::before {
  content: "\\F0336";
}

.mdi-lightbulb-question::before {
  content: "\\F19E3";
}

.mdi-lightbulb-question-outline::before {
  content: "\\F19E4";
}

.mdi-lightbulb-spot::before {
  content: "\\F17F4";
}

.mdi-lightbulb-spot-off::before {
  content: "\\F17F5";
}

.mdi-lightbulb-variant::before {
  content: "\\F1802";
}

.mdi-lightbulb-variant-outline::before {
  content: "\\F1803";
}

.mdi-lighthouse::before {
  content: "\\F09FF";
}

.mdi-lighthouse-on::before {
  content: "\\F0A00";
}

.mdi-lightning-bolt::before {
  content: "\\F140B";
}

.mdi-lightning-bolt-circle::before {
  content: "\\F0820";
}

.mdi-lightning-bolt-outline::before {
  content: "\\F140C";
}

.mdi-line-scan::before {
  content: "\\F0624";
}

.mdi-lingerie::before {
  content: "\\F1476";
}

.mdi-link::before {
  content: "\\F0337";
}

.mdi-link-box::before {
  content: "\\F0D1A";
}

.mdi-link-box-outline::before {
  content: "\\F0D1B";
}

.mdi-link-box-variant::before {
  content: "\\F0D1C";
}

.mdi-link-box-variant-outline::before {
  content: "\\F0D1D";
}

.mdi-link-circle::before {
  content: "\\F1CAC";
}

.mdi-link-circle-outline::before {
  content: "\\F1CAD";
}

.mdi-link-edit::before {
  content: "\\F1CAE";
}

.mdi-link-lock::before {
  content: "\\F10BA";
}

.mdi-link-off::before {
  content: "\\F0338";
}

.mdi-link-plus::before {
  content: "\\F0C94";
}

.mdi-link-variant::before {
  content: "\\F0339";
}

.mdi-link-variant-minus::before {
  content: "\\F10FF";
}

.mdi-link-variant-off::before {
  content: "\\F033A";
}

.mdi-link-variant-plus::before {
  content: "\\F1100";
}

.mdi-link-variant-remove::before {
  content: "\\F1101";
}

.mdi-linkedin::before {
  content: "\\F033B";
}

.mdi-linux::before {
  content: "\\F033D";
}

.mdi-linux-mint::before {
  content: "\\F08ED";
}

.mdi-lipstick::before {
  content: "\\F13B5";
}

.mdi-liquid-spot::before {
  content: "\\F1826";
}

.mdi-liquor::before {
  content: "\\F191E";
}

.mdi-list-box::before {
  content: "\\F1B7B";
}

.mdi-list-box-outline::before {
  content: "\\F1B7C";
}

.mdi-list-status::before {
  content: "\\F15AB";
}

.mdi-litecoin::before {
  content: "\\F0A61";
}

.mdi-loading::before {
  content: "\\F0772";
}

.mdi-location-enter::before {
  content: "\\F0FC4";
}

.mdi-location-exit::before {
  content: "\\F0FC5";
}

.mdi-lock::before {
  content: "\\F033E";
}

.mdi-lock-alert::before {
  content: "\\F08EE";
}

.mdi-lock-alert-outline::before {
  content: "\\F15D1";
}

.mdi-lock-check::before {
  content: "\\F139A";
}

.mdi-lock-check-outline::before {
  content: "\\F16A8";
}

.mdi-lock-clock::before {
  content: "\\F097F";
}

.mdi-lock-minus::before {
  content: "\\F16A9";
}

.mdi-lock-minus-outline::before {
  content: "\\F16AA";
}

.mdi-lock-off::before {
  content: "\\F1671";
}

.mdi-lock-off-outline::before {
  content: "\\F1672";
}

.mdi-lock-open::before {
  content: "\\F033F";
}

.mdi-lock-open-alert::before {
  content: "\\F139B";
}

.mdi-lock-open-alert-outline::before {
  content: "\\F15D2";
}

.mdi-lock-open-check::before {
  content: "\\F139C";
}

.mdi-lock-open-check-outline::before {
  content: "\\F16AB";
}

.mdi-lock-open-minus::before {
  content: "\\F16AC";
}

.mdi-lock-open-minus-outline::before {
  content: "\\F16AD";
}

.mdi-lock-open-outline::before {
  content: "\\F0340";
}

.mdi-lock-open-plus::before {
  content: "\\F16AE";
}

.mdi-lock-open-plus-outline::before {
  content: "\\F16AF";
}

.mdi-lock-open-remove::before {
  content: "\\F16B0";
}

.mdi-lock-open-remove-outline::before {
  content: "\\F16B1";
}

.mdi-lock-open-variant::before {
  content: "\\F0FC6";
}

.mdi-lock-open-variant-outline::before {
  content: "\\F0FC7";
}

.mdi-lock-outline::before {
  content: "\\F0341";
}

.mdi-lock-pattern::before {
  content: "\\F06EA";
}

.mdi-lock-percent::before {
  content: "\\F1C12";
}

.mdi-lock-percent-open::before {
  content: "\\F1C13";
}

.mdi-lock-percent-open-outline::before {
  content: "\\F1C14";
}

.mdi-lock-percent-open-variant::before {
  content: "\\F1C15";
}

.mdi-lock-percent-open-variant-outline::before {
  content: "\\F1C16";
}

.mdi-lock-percent-outline::before {
  content: "\\F1C17";
}

.mdi-lock-plus::before {
  content: "\\F05FB";
}

.mdi-lock-plus-outline::before {
  content: "\\F16B2";
}

.mdi-lock-question::before {
  content: "\\F08EF";
}

.mdi-lock-remove::before {
  content: "\\F16B3";
}

.mdi-lock-remove-outline::before {
  content: "\\F16B4";
}

.mdi-lock-reset::before {
  content: "\\F0773";
}

.mdi-lock-smart::before {
  content: "\\F08B2";
}

.mdi-locker::before {
  content: "\\F07D7";
}

.mdi-locker-multiple::before {
  content: "\\F07D8";
}

.mdi-login::before {
  content: "\\F0342";
}

.mdi-login-variant::before {
  content: "\\F05FC";
}

.mdi-logout::before {
  content: "\\F0343";
}

.mdi-logout-variant::before {
  content: "\\F05FD";
}

.mdi-longitude::before {
  content: "\\F0F5A";
}

.mdi-looks::before {
  content: "\\F0344";
}

.mdi-lotion::before {
  content: "\\F1582";
}

.mdi-lotion-outline::before {
  content: "\\F1583";
}

.mdi-lotion-plus::before {
  content: "\\F1584";
}

.mdi-lotion-plus-outline::before {
  content: "\\F1585";
}

.mdi-loupe::before {
  content: "\\F0345";
}

.mdi-lumx::before {
  content: "\\F0346";
}

.mdi-lungs::before {
  content: "\\F1084";
}

.mdi-mace::before {
  content: "\\F1843";
}

.mdi-magazine-pistol::before {
  content: "\\F0324";
}

.mdi-magazine-rifle::before {
  content: "\\F0323";
}

.mdi-magic-staff::before {
  content: "\\F1844";
}

.mdi-magnet::before {
  content: "\\F0347";
}

.mdi-magnet-on::before {
  content: "\\F0348";
}

.mdi-magnify::before {
  content: "\\F0349";
}

.mdi-magnify-close::before {
  content: "\\F0980";
}

.mdi-magnify-expand::before {
  content: "\\F1874";
}

.mdi-magnify-minus::before {
  content: "\\F034A";
}

.mdi-magnify-minus-cursor::before {
  content: "\\F0A62";
}

.mdi-magnify-minus-outline::before {
  content: "\\F06EC";
}

.mdi-magnify-plus::before {
  content: "\\F034B";
}

.mdi-magnify-plus-cursor::before {
  content: "\\F0A63";
}

.mdi-magnify-plus-outline::before {
  content: "\\F06ED";
}

.mdi-magnify-remove-cursor::before {
  content: "\\F120C";
}

.mdi-magnify-remove-outline::before {
  content: "\\F120D";
}

.mdi-magnify-scan::before {
  content: "\\F1276";
}

.mdi-mail::before {
  content: "\\F0EBB";
}

.mdi-mailbox::before {
  content: "\\F06EE";
}

.mdi-mailbox-open::before {
  content: "\\F0D88";
}

.mdi-mailbox-open-outline::before {
  content: "\\F0D89";
}

.mdi-mailbox-open-up::before {
  content: "\\F0D8A";
}

.mdi-mailbox-open-up-outline::before {
  content: "\\F0D8B";
}

.mdi-mailbox-outline::before {
  content: "\\F0D8C";
}

.mdi-mailbox-up::before {
  content: "\\F0D8D";
}

.mdi-mailbox-up-outline::before {
  content: "\\F0D8E";
}

.mdi-manjaro::before {
  content: "\\F160A";
}

.mdi-map::before {
  content: "\\F034D";
}

.mdi-map-check::before {
  content: "\\F0EBC";
}

.mdi-map-check-outline::before {
  content: "\\F0EBD";
}

.mdi-map-clock::before {
  content: "\\F0D1E";
}

.mdi-map-clock-outline::before {
  content: "\\F0D1F";
}

.mdi-map-legend::before {
  content: "\\F0A01";
}

.mdi-map-marker::before {
  content: "\\F034E";
}

.mdi-map-marker-account::before {
  content: "\\F18E3";
}

.mdi-map-marker-account-outline::before {
  content: "\\F18E4";
}

.mdi-map-marker-alert::before {
  content: "\\F0F05";
}

.mdi-map-marker-alert-outline::before {
  content: "\\F0F06";
}

.mdi-map-marker-check::before {
  content: "\\F0C95";
}

.mdi-map-marker-check-outline::before {
  content: "\\F12FB";
}

.mdi-map-marker-circle::before {
  content: "\\F034F";
}

.mdi-map-marker-distance::before {
  content: "\\F08F0";
}

.mdi-map-marker-down::before {
  content: "\\F1102";
}

.mdi-map-marker-left::before {
  content: "\\F12DB";
}

.mdi-map-marker-left-outline::before {
  content: "\\F12DD";
}

.mdi-map-marker-minus::before {
  content: "\\F0650";
}

.mdi-map-marker-minus-outline::before {
  content: "\\F12F9";
}

.mdi-map-marker-multiple::before {
  content: "\\F0350";
}

.mdi-map-marker-multiple-outline::before {
  content: "\\F1277";
}

.mdi-map-marker-off::before {
  content: "\\F0351";
}

.mdi-map-marker-off-outline::before {
  content: "\\F12FD";
}

.mdi-map-marker-outline::before {
  content: "\\F07D9";
}

.mdi-map-marker-path::before {
  content: "\\F0D20";
}

.mdi-map-marker-plus::before {
  content: "\\F0651";
}

.mdi-map-marker-plus-outline::before {
  content: "\\F12F8";
}

.mdi-map-marker-question::before {
  content: "\\F0F07";
}

.mdi-map-marker-question-outline::before {
  content: "\\F0F08";
}

.mdi-map-marker-radius::before {
  content: "\\F0352";
}

.mdi-map-marker-radius-outline::before {
  content: "\\F12FC";
}

.mdi-map-marker-remove::before {
  content: "\\F0F09";
}

.mdi-map-marker-remove-outline::before {
  content: "\\F12FA";
}

.mdi-map-marker-remove-variant::before {
  content: "\\F0F0A";
}

.mdi-map-marker-right::before {
  content: "\\F12DC";
}

.mdi-map-marker-right-outline::before {
  content: "\\F12DE";
}

.mdi-map-marker-star::before {
  content: "\\F1608";
}

.mdi-map-marker-star-outline::before {
  content: "\\F1609";
}

.mdi-map-marker-up::before {
  content: "\\F1103";
}

.mdi-map-minus::before {
  content: "\\F0981";
}

.mdi-map-outline::before {
  content: "\\F0982";
}

.mdi-map-plus::before {
  content: "\\F0983";
}

.mdi-map-search::before {
  content: "\\F0984";
}

.mdi-map-search-outline::before {
  content: "\\F0985";
}

.mdi-mapbox::before {
  content: "\\F0BAA";
}

.mdi-margin::before {
  content: "\\F0353";
}

.mdi-marker::before {
  content: "\\F0652";
}

.mdi-marker-cancel::before {
  content: "\\F0DD9";
}

.mdi-marker-check::before {
  content: "\\F0355";
}

.mdi-mastodon::before {
  content: "\\F0AD1";
}

.mdi-material-design::before {
  content: "\\F0986";
}

.mdi-material-ui::before {
  content: "\\F0357";
}

.mdi-math-compass::before {
  content: "\\F0358";
}

.mdi-math-cos::before {
  content: "\\F0C96";
}

.mdi-math-integral::before {
  content: "\\F0FC8";
}

.mdi-math-integral-box::before {
  content: "\\F0FC9";
}

.mdi-math-log::before {
  content: "\\F1085";
}

.mdi-math-norm::before {
  content: "\\F0FCA";
}

.mdi-math-norm-box::before {
  content: "\\F0FCB";
}

.mdi-math-sin::before {
  content: "\\F0C97";
}

.mdi-math-tan::before {
  content: "\\F0C98";
}

.mdi-matrix::before {
  content: "\\F0628";
}

.mdi-medal::before {
  content: "\\F0987";
}

.mdi-medal-outline::before {
  content: "\\F1326";
}

.mdi-medical-bag::before {
  content: "\\F06EF";
}

.mdi-medical-cotton-swab::before {
  content: "\\F1AB8";
}

.mdi-medication::before {
  content: "\\F1B14";
}

.mdi-medication-outline::before {
  content: "\\F1B15";
}

.mdi-meditation::before {
  content: "\\F117B";
}

.mdi-memory::before {
  content: "\\F035B";
}

.mdi-memory-arrow-down::before {
  content: "\\F1CA6";
}

.mdi-menorah::before {
  content: "\\F17D4";
}

.mdi-menorah-fire::before {
  content: "\\F17D5";
}

.mdi-menu::before {
  content: "\\F035C";
}

.mdi-menu-close::before {
  content: "\\F1C90";
}

.mdi-menu-down::before {
  content: "\\F035D";
}

.mdi-menu-down-outline::before {
  content: "\\F06B6";
}

.mdi-menu-left::before {
  content: "\\F035E";
}

.mdi-menu-left-outline::before {
  content: "\\F0A02";
}

.mdi-menu-open::before {
  content: "\\F0BAB";
}

.mdi-menu-right::before {
  content: "\\F035F";
}

.mdi-menu-right-outline::before {
  content: "\\F0A03";
}

.mdi-menu-swap::before {
  content: "\\F0A64";
}

.mdi-menu-swap-outline::before {
  content: "\\F0A65";
}

.mdi-menu-up::before {
  content: "\\F0360";
}

.mdi-menu-up-outline::before {
  content: "\\F06B7";
}

.mdi-merge::before {
  content: "\\F0F5C";
}

.mdi-message::before {
  content: "\\F0361";
}

.mdi-message-alert::before {
  content: "\\F0362";
}

.mdi-message-alert-outline::before {
  content: "\\F0A04";
}

.mdi-message-arrow-left::before {
  content: "\\F12F2";
}

.mdi-message-arrow-left-outline::before {
  content: "\\F12F3";
}

.mdi-message-arrow-right::before {
  content: "\\F12F4";
}

.mdi-message-arrow-right-outline::before {
  content: "\\F12F5";
}

.mdi-message-badge::before {
  content: "\\F1941";
}

.mdi-message-badge-outline::before {
  content: "\\F1942";
}

.mdi-message-bookmark::before {
  content: "\\F15AC";
}

.mdi-message-bookmark-outline::before {
  content: "\\F15AD";
}

.mdi-message-bulleted::before {
  content: "\\F06A2";
}

.mdi-message-bulleted-off::before {
  content: "\\F06A3";
}

.mdi-message-check::before {
  content: "\\F1B8A";
}

.mdi-message-check-outline::before {
  content: "\\F1B8B";
}

.mdi-message-cog::before {
  content: "\\F06F1";
}

.mdi-message-cog-outline::before {
  content: "\\F1172";
}

.mdi-message-draw::before {
  content: "\\F0363";
}

.mdi-message-fast::before {
  content: "\\F19CC";
}

.mdi-message-fast-outline::before {
  content: "\\F19CD";
}

.mdi-message-flash::before {
  content: "\\F15A9";
}

.mdi-message-flash-outline::before {
  content: "\\F15AA";
}

.mdi-message-image::before {
  content: "\\F0364";
}

.mdi-message-image-outline::before {
  content: "\\F116C";
}

.mdi-message-lock::before {
  content: "\\F0FCC";
}

.mdi-message-lock-outline::before {
  content: "\\F116D";
}

.mdi-message-minus::before {
  content: "\\F116E";
}

.mdi-message-minus-outline::before {
  content: "\\F116F";
}

.mdi-message-off::before {
  content: "\\F164D";
}

.mdi-message-off-outline::before {
  content: "\\F164E";
}

.mdi-message-outline::before {
  content: "\\F0365";
}

.mdi-message-plus::before {
  content: "\\F0653";
}

.mdi-message-plus-outline::before {
  content: "\\F10BB";
}

.mdi-message-processing::before {
  content: "\\F0366";
}

.mdi-message-processing-outline::before {
  content: "\\F1170";
}

.mdi-message-question::before {
  content: "\\F173A";
}

.mdi-message-question-outline::before {
  content: "\\F173B";
}

.mdi-message-reply::before {
  content: "\\F0367";
}

.mdi-message-reply-outline::before {
  content: "\\F173D";
}

.mdi-message-reply-text::before {
  content: "\\F0368";
}

.mdi-message-reply-text-outline::before {
  content: "\\F173E";
}

.mdi-message-settings::before {
  content: "\\F06F0";
}

.mdi-message-settings-outline::before {
  content: "\\F1171";
}

.mdi-message-star::before {
  content: "\\F069A";
}

.mdi-message-star-outline::before {
  content: "\\F1250";
}

.mdi-message-text::before {
  content: "\\F0369";
}

.mdi-message-text-clock::before {
  content: "\\F1173";
}

.mdi-message-text-clock-outline::before {
  content: "\\F1174";
}

.mdi-message-text-fast::before {
  content: "\\F19CE";
}

.mdi-message-text-fast-outline::before {
  content: "\\F19CF";
}

.mdi-message-text-lock::before {
  content: "\\F0FCD";
}

.mdi-message-text-lock-outline::before {
  content: "\\F1175";
}

.mdi-message-text-outline::before {
  content: "\\F036A";
}

.mdi-message-video::before {
  content: "\\F036B";
}

.mdi-meteor::before {
  content: "\\F0629";
}

.mdi-meter-electric::before {
  content: "\\F1A57";
}

.mdi-meter-electric-outline::before {
  content: "\\F1A58";
}

.mdi-meter-gas::before {
  content: "\\F1A59";
}

.mdi-meter-gas-outline::before {
  content: "\\F1A5A";
}

.mdi-metronome::before {
  content: "\\F07DA";
}

.mdi-metronome-tick::before {
  content: "\\F07DB";
}

.mdi-micro-sd::before {
  content: "\\F07DC";
}

.mdi-microphone::before {
  content: "\\F036C";
}

.mdi-microphone-message::before {
  content: "\\F050A";
}

.mdi-microphone-message-off::before {
  content: "\\F050B";
}

.mdi-microphone-minus::before {
  content: "\\F08B3";
}

.mdi-microphone-off::before {
  content: "\\F036D";
}

.mdi-microphone-outline::before {
  content: "\\F036E";
}

.mdi-microphone-plus::before {
  content: "\\F08B4";
}

.mdi-microphone-question::before {
  content: "\\F1989";
}

.mdi-microphone-question-outline::before {
  content: "\\F198A";
}

.mdi-microphone-settings::before {
  content: "\\F036F";
}

.mdi-microphone-variant::before {
  content: "\\F0370";
}

.mdi-microphone-variant-off::before {
  content: "\\F0371";
}

.mdi-microscope::before {
  content: "\\F0654";
}

.mdi-microsoft::before {
  content: "\\F0372";
}

.mdi-microsoft-access::before {
  content: "\\F138E";
}

.mdi-microsoft-azure::before {
  content: "\\F0805";
}

.mdi-microsoft-azure-devops::before {
  content: "\\F0FD5";
}

.mdi-microsoft-bing::before {
  content: "\\F00A4";
}

.mdi-microsoft-dynamics-365::before {
  content: "\\F0988";
}

.mdi-microsoft-edge::before {
  content: "\\F01E9";
}

.mdi-microsoft-excel::before {
  content: "\\F138F";
}

.mdi-microsoft-internet-explorer::before {
  content: "\\F0300";
}

.mdi-microsoft-office::before {
  content: "\\F03C6";
}

.mdi-microsoft-onedrive::before {
  content: "\\F03CA";
}

.mdi-microsoft-onenote::before {
  content: "\\F0747";
}

.mdi-microsoft-outlook::before {
  content: "\\F0D22";
}

.mdi-microsoft-powerpoint::before {
  content: "\\F1390";
}

.mdi-microsoft-sharepoint::before {
  content: "\\F1391";
}

.mdi-microsoft-teams::before {
  content: "\\F02BB";
}

.mdi-microsoft-visual-studio::before {
  content: "\\F0610";
}

.mdi-microsoft-visual-studio-code::before {
  content: "\\F0A1E";
}

.mdi-microsoft-windows::before {
  content: "\\F05B3";
}

.mdi-microsoft-windows-classic::before {
  content: "\\F0A21";
}

.mdi-microsoft-word::before {
  content: "\\F1392";
}

.mdi-microsoft-xbox::before {
  content: "\\F05B9";
}

.mdi-microsoft-xbox-controller::before {
  content: "\\F05BA";
}

.mdi-microsoft-xbox-controller-battery-alert::before {
  content: "\\F074B";
}

.mdi-microsoft-xbox-controller-battery-charging::before {
  content: "\\F0A22";
}

.mdi-microsoft-xbox-controller-battery-empty::before {
  content: "\\F074C";
}

.mdi-microsoft-xbox-controller-battery-full::before {
  content: "\\F074D";
}

.mdi-microsoft-xbox-controller-battery-low::before {
  content: "\\F074E";
}

.mdi-microsoft-xbox-controller-battery-medium::before {
  content: "\\F074F";
}

.mdi-microsoft-xbox-controller-battery-unknown::before {
  content: "\\F0750";
}

.mdi-microsoft-xbox-controller-menu::before {
  content: "\\F0E6F";
}

.mdi-microsoft-xbox-controller-off::before {
  content: "\\F05BB";
}

.mdi-microsoft-xbox-controller-view::before {
  content: "\\F0E70";
}

.mdi-microwave::before {
  content: "\\F0C99";
}

.mdi-microwave-off::before {
  content: "\\F1423";
}

.mdi-middleware::before {
  content: "\\F0F5D";
}

.mdi-middleware-outline::before {
  content: "\\F0F5E";
}

.mdi-midi::before {
  content: "\\F08F1";
}

.mdi-midi-port::before {
  content: "\\F08F2";
}

.mdi-mine::before {
  content: "\\F0DDA";
}

.mdi-minecraft::before {
  content: "\\F0373";
}

.mdi-mini-sd::before {
  content: "\\F0A05";
}

.mdi-minidisc::before {
  content: "\\F0A06";
}

.mdi-minus::before {
  content: "\\F0374";
}

.mdi-minus-box::before {
  content: "\\F0375";
}

.mdi-minus-box-multiple::before {
  content: "\\F1141";
}

.mdi-minus-box-multiple-outline::before {
  content: "\\F1142";
}

.mdi-minus-box-outline::before {
  content: "\\F06F2";
}

.mdi-minus-circle::before {
  content: "\\F0376";
}

.mdi-minus-circle-multiple::before {
  content: "\\F035A";
}

.mdi-minus-circle-multiple-outline::before {
  content: "\\F0AD3";
}

.mdi-minus-circle-off::before {
  content: "\\F1459";
}

.mdi-minus-circle-off-outline::before {
  content: "\\F145A";
}

.mdi-minus-circle-outline::before {
  content: "\\F0377";
}

.mdi-minus-network::before {
  content: "\\F0378";
}

.mdi-minus-network-outline::before {
  content: "\\F0C9A";
}

.mdi-minus-thick::before {
  content: "\\F1639";
}

.mdi-mirror::before {
  content: "\\F11FD";
}

.mdi-mirror-rectangle::before {
  content: "\\F179F";
}

.mdi-mirror-variant::before {
  content: "\\F17A0";
}

.mdi-mixed-martial-arts::before {
  content: "\\F0D8F";
}

.mdi-mixed-reality::before {
  content: "\\F087F";
}

.mdi-molecule::before {
  content: "\\F0BAC";
}

.mdi-molecule-co::before {
  content: "\\F12FE";
}

.mdi-molecule-co2::before {
  content: "\\F07E4";
}

.mdi-monitor::before {
  content: "\\F0379";
}

.mdi-monitor-account::before {
  content: "\\F1A5B";
}

.mdi-monitor-arrow-down::before {
  content: "\\F19D0";
}

.mdi-monitor-arrow-down-variant::before {
  content: "\\F19D1";
}

.mdi-monitor-cellphone::before {
  content: "\\F0989";
}

.mdi-monitor-cellphone-star::before {
  content: "\\F098A";
}

.mdi-monitor-dashboard::before {
  content: "\\F0A07";
}

.mdi-monitor-edit::before {
  content: "\\F12C6";
}

.mdi-monitor-eye::before {
  content: "\\F13B4";
}

.mdi-monitor-lock::before {
  content: "\\F0DDB";
}

.mdi-monitor-multiple::before {
  content: "\\F037A";
}

.mdi-monitor-off::before {
  content: "\\F0D90";
}

.mdi-monitor-screenshot::before {
  content: "\\F0E51";
}

.mdi-monitor-share::before {
  content: "\\F1483";
}

.mdi-monitor-shimmer::before {
  content: "\\F1104";
}

.mdi-monitor-small::before {
  content: "\\F1876";
}

.mdi-monitor-speaker::before {
  content: "\\F0F5F";
}

.mdi-monitor-speaker-off::before {
  content: "\\F0F60";
}

.mdi-monitor-star::before {
  content: "\\F0DDC";
}

.mdi-monitor-vertical::before {
  content: "\\F1C33";
}

.mdi-moon-first-quarter::before {
  content: "\\F0F61";
}

.mdi-moon-full::before {
  content: "\\F0F62";
}

.mdi-moon-last-quarter::before {
  content: "\\F0F63";
}

.mdi-moon-new::before {
  content: "\\F0F64";
}

.mdi-moon-waning-crescent::before {
  content: "\\F0F65";
}

.mdi-moon-waning-gibbous::before {
  content: "\\F0F66";
}

.mdi-moon-waxing-crescent::before {
  content: "\\F0F67";
}

.mdi-moon-waxing-gibbous::before {
  content: "\\F0F68";
}

.mdi-moped::before {
  content: "\\F1086";
}

.mdi-moped-electric::before {
  content: "\\F15B7";
}

.mdi-moped-electric-outline::before {
  content: "\\F15B8";
}

.mdi-moped-outline::before {
  content: "\\F15B9";
}

.mdi-more::before {
  content: "\\F037B";
}

.mdi-mortar-pestle::before {
  content: "\\F1748";
}

.mdi-mortar-pestle-plus::before {
  content: "\\F03F1";
}

.mdi-mosque::before {
  content: "\\F0D45";
}

.mdi-mosque-outline::before {
  content: "\\F1827";
}

.mdi-mother-heart::before {
  content: "\\F1314";
}

.mdi-mother-nurse::before {
  content: "\\F0D21";
}

.mdi-motion::before {
  content: "\\F15B2";
}

.mdi-motion-outline::before {
  content: "\\F15B3";
}

.mdi-motion-pause::before {
  content: "\\F1590";
}

.mdi-motion-pause-outline::before {
  content: "\\F1592";
}

.mdi-motion-play::before {
  content: "\\F158F";
}

.mdi-motion-play-outline::before {
  content: "\\F1591";
}

.mdi-motion-sensor::before {
  content: "\\F0D91";
}

.mdi-motion-sensor-off::before {
  content: "\\F1435";
}

.mdi-motorbike::before {
  content: "\\F037C";
}

.mdi-motorbike-electric::before {
  content: "\\F15BA";
}

.mdi-motorbike-off::before {
  content: "\\F1B16";
}

.mdi-mouse::before {
  content: "\\F037D";
}

.mdi-mouse-bluetooth::before {
  content: "\\F098B";
}

.mdi-mouse-left-click::before {
  content: "\\F1D07";
}

.mdi-mouse-left-click-outline::before {
  content: "\\F1D08";
}

.mdi-mouse-move-down::before {
  content: "\\F1550";
}

.mdi-mouse-move-up::before {
  content: "\\F1551";
}

.mdi-mouse-move-vertical::before {
  content: "\\F1552";
}

.mdi-mouse-off::before {
  content: "\\F037E";
}

.mdi-mouse-outline::before {
  content: "\\F1D09";
}

.mdi-mouse-right-click::before {
  content: "\\F1D0A";
}

.mdi-mouse-right-click-outline::before {
  content: "\\F1D0B";
}

.mdi-mouse-scroll-wheel::before {
  content: "\\F1D0C";
}

.mdi-mouse-variant::before {
  content: "\\F037F";
}

.mdi-mouse-variant-off::before {
  content: "\\F0380";
}

.mdi-move-resize::before {
  content: "\\F0655";
}

.mdi-move-resize-variant::before {
  content: "\\F0656";
}

.mdi-movie::before {
  content: "\\F0381";
}

.mdi-movie-check::before {
  content: "\\F16F3";
}

.mdi-movie-check-outline::before {
  content: "\\F16F4";
}

.mdi-movie-cog::before {
  content: "\\F16F5";
}

.mdi-movie-cog-outline::before {
  content: "\\F16F6";
}

.mdi-movie-edit::before {
  content: "\\F1122";
}

.mdi-movie-edit-outline::before {
  content: "\\F1123";
}

.mdi-movie-filter::before {
  content: "\\F1124";
}

.mdi-movie-filter-outline::before {
  content: "\\F1125";
}

.mdi-movie-minus::before {
  content: "\\F16F7";
}

.mdi-movie-minus-outline::before {
  content: "\\F16F8";
}

.mdi-movie-off::before {
  content: "\\F16F9";
}

.mdi-movie-off-outline::before {
  content: "\\F16FA";
}

.mdi-movie-open::before {
  content: "\\F0FCE";
}

.mdi-movie-open-check::before {
  content: "\\F16FB";
}

.mdi-movie-open-check-outline::before {
  content: "\\F16FC";
}

.mdi-movie-open-cog::before {
  content: "\\F16FD";
}

.mdi-movie-open-cog-outline::before {
  content: "\\F16FE";
}

.mdi-movie-open-edit::before {
  content: "\\F16FF";
}

.mdi-movie-open-edit-outline::before {
  content: "\\F1700";
}

.mdi-movie-open-minus::before {
  content: "\\F1701";
}

.mdi-movie-open-minus-outline::before {
  content: "\\F1702";
}

.mdi-movie-open-off::before {
  content: "\\F1703";
}

.mdi-movie-open-off-outline::before {
  content: "\\F1704";
}

.mdi-movie-open-outline::before {
  content: "\\F0FCF";
}

.mdi-movie-open-play::before {
  content: "\\F1705";
}

.mdi-movie-open-play-outline::before {
  content: "\\F1706";
}

.mdi-movie-open-plus::before {
  content: "\\F1707";
}

.mdi-movie-open-plus-outline::before {
  content: "\\F1708";
}

.mdi-movie-open-remove::before {
  content: "\\F1709";
}

.mdi-movie-open-remove-outline::before {
  content: "\\F170A";
}

.mdi-movie-open-settings::before {
  content: "\\F170B";
}

.mdi-movie-open-settings-outline::before {
  content: "\\F170C";
}

.mdi-movie-open-star::before {
  content: "\\F170D";
}

.mdi-movie-open-star-outline::before {
  content: "\\F170E";
}

.mdi-movie-outline::before {
  content: "\\F0DDD";
}

.mdi-movie-play::before {
  content: "\\F170F";
}

.mdi-movie-play-outline::before {
  content: "\\F1710";
}

.mdi-movie-plus::before {
  content: "\\F1711";
}

.mdi-movie-plus-outline::before {
  content: "\\F1712";
}

.mdi-movie-remove::before {
  content: "\\F1713";
}

.mdi-movie-remove-outline::before {
  content: "\\F1714";
}

.mdi-movie-roll::before {
  content: "\\F07DE";
}

.mdi-movie-search::before {
  content: "\\F11D2";
}

.mdi-movie-search-outline::before {
  content: "\\F11D3";
}

.mdi-movie-settings::before {
  content: "\\F1715";
}

.mdi-movie-settings-outline::before {
  content: "\\F1716";
}

.mdi-movie-star::before {
  content: "\\F1717";
}

.mdi-movie-star-outline::before {
  content: "\\F1718";
}

.mdi-mower::before {
  content: "\\F166F";
}

.mdi-mower-bag::before {
  content: "\\F1670";
}

.mdi-mower-bag-on::before {
  content: "\\F1B60";
}

.mdi-mower-on::before {
  content: "\\F1B5F";
}

.mdi-muffin::before {
  content: "\\F098C";
}

.mdi-multicast::before {
  content: "\\F1893";
}

.mdi-multimedia::before {
  content: "\\F1B97";
}

.mdi-multiplication::before {
  content: "\\F0382";
}

.mdi-multiplication-box::before {
  content: "\\F0383";
}

.mdi-mushroom::before {
  content: "\\F07DF";
}

.mdi-mushroom-off::before {
  content: "\\F13FA";
}

.mdi-mushroom-off-outline::before {
  content: "\\F13FB";
}

.mdi-mushroom-outline::before {
  content: "\\F07E0";
}

.mdi-music::before {
  content: "\\F075A";
}

.mdi-music-accidental-double-flat::before {
  content: "\\F0F69";
}

.mdi-music-accidental-double-sharp::before {
  content: "\\F0F6A";
}

.mdi-music-accidental-flat::before {
  content: "\\F0F6B";
}

.mdi-music-accidental-natural::before {
  content: "\\F0F6C";
}

.mdi-music-accidental-sharp::before {
  content: "\\F0F6D";
}

.mdi-music-box::before {
  content: "\\F0384";
}

.mdi-music-box-multiple::before {
  content: "\\F0333";
}

.mdi-music-box-multiple-outline::before {
  content: "\\F0F04";
}

.mdi-music-box-outline::before {
  content: "\\F0385";
}

.mdi-music-circle::before {
  content: "\\F0386";
}

.mdi-music-circle-outline::before {
  content: "\\F0AD4";
}

.mdi-music-clef-alto::before {
  content: "\\F0F6E";
}

.mdi-music-clef-bass::before {
  content: "\\F0F6F";
}

.mdi-music-clef-treble::before {
  content: "\\F0F70";
}

.mdi-music-note::before {
  content: "\\F0387";
}

.mdi-music-note-bluetooth::before {
  content: "\\F05FE";
}

.mdi-music-note-bluetooth-off::before {
  content: "\\F05FF";
}

.mdi-music-note-eighth::before {
  content: "\\F0388";
}

.mdi-music-note-eighth-dotted::before {
  content: "\\F0F71";
}

.mdi-music-note-half::before {
  content: "\\F0389";
}

.mdi-music-note-half-dotted::before {
  content: "\\F0F72";
}

.mdi-music-note-minus::before {
  content: "\\F1B89";
}

.mdi-music-note-off::before {
  content: "\\F038A";
}

.mdi-music-note-off-outline::before {
  content: "\\F0F73";
}

.mdi-music-note-outline::before {
  content: "\\F0F74";
}

.mdi-music-note-plus::before {
  content: "\\F0DDE";
}

.mdi-music-note-quarter::before {
  content: "\\F038B";
}

.mdi-music-note-quarter-dotted::before {
  content: "\\F0F75";
}

.mdi-music-note-sixteenth::before {
  content: "\\F038C";
}

.mdi-music-note-sixteenth-dotted::before {
  content: "\\F0F76";
}

.mdi-music-note-whole::before {
  content: "\\F038D";
}

.mdi-music-note-whole-dotted::before {
  content: "\\F0F77";
}

.mdi-music-off::before {
  content: "\\F075B";
}

.mdi-music-rest-eighth::before {
  content: "\\F0F78";
}

.mdi-music-rest-half::before {
  content: "\\F0F79";
}

.mdi-music-rest-quarter::before {
  content: "\\F0F7A";
}

.mdi-music-rest-sixteenth::before {
  content: "\\F0F7B";
}

.mdi-music-rest-whole::before {
  content: "\\F0F7C";
}

.mdi-mustache::before {
  content: "\\F15DE";
}

.mdi-nail::before {
  content: "\\F0DDF";
}

.mdi-nas::before {
  content: "\\F08F3";
}

.mdi-nativescript::before {
  content: "\\F0880";
}

.mdi-nature::before {
  content: "\\F038E";
}

.mdi-nature-outline::before {
  content: "\\F1C71";
}

.mdi-nature-people::before {
  content: "\\F038F";
}

.mdi-nature-people-outline::before {
  content: "\\F1C72";
}

.mdi-navigation::before {
  content: "\\F0390";
}

.mdi-navigation-outline::before {
  content: "\\F1607";
}

.mdi-navigation-variant::before {
  content: "\\F18F0";
}

.mdi-navigation-variant-outline::before {
  content: "\\F18F1";
}

.mdi-near-me::before {
  content: "\\F05CD";
}

.mdi-necklace::before {
  content: "\\F0F0B";
}

.mdi-needle::before {
  content: "\\F0391";
}

.mdi-needle-off::before {
  content: "\\F19D2";
}

.mdi-netflix::before {
  content: "\\F0746";
}

.mdi-network::before {
  content: "\\F06F3";
}

.mdi-network-off::before {
  content: "\\F0C9B";
}

.mdi-network-off-outline::before {
  content: "\\F0C9C";
}

.mdi-network-outline::before {
  content: "\\F0C9D";
}

.mdi-network-pos::before {
  content: "\\F1ACB";
}

.mdi-network-strength-1::before {
  content: "\\F08F4";
}

.mdi-network-strength-1-alert::before {
  content: "\\F08F5";
}

.mdi-network-strength-2::before {
  content: "\\F08F6";
}

.mdi-network-strength-2-alert::before {
  content: "\\F08F7";
}

.mdi-network-strength-3::before {
  content: "\\F08F8";
}

.mdi-network-strength-3-alert::before {
  content: "\\F08F9";
}

.mdi-network-strength-4::before {
  content: "\\F08FA";
}

.mdi-network-strength-4-alert::before {
  content: "\\F08FB";
}

.mdi-network-strength-4-cog::before {
  content: "\\F191A";
}

.mdi-network-strength-off::before {
  content: "\\F08FC";
}

.mdi-network-strength-off-outline::before {
  content: "\\F08FD";
}

.mdi-network-strength-outline::before {
  content: "\\F08FE";
}

.mdi-new-box::before {
  content: "\\F0394";
}

.mdi-newspaper::before {
  content: "\\F0395";
}

.mdi-newspaper-check::before {
  content: "\\F1943";
}

.mdi-newspaper-minus::before {
  content: "\\F0F0C";
}

.mdi-newspaper-plus::before {
  content: "\\F0F0D";
}

.mdi-newspaper-remove::before {
  content: "\\F1944";
}

.mdi-newspaper-variant::before {
  content: "\\F1001";
}

.mdi-newspaper-variant-multiple::before {
  content: "\\F1002";
}

.mdi-newspaper-variant-multiple-outline::before {
  content: "\\F1003";
}

.mdi-newspaper-variant-outline::before {
  content: "\\F1004";
}

.mdi-nfc::before {
  content: "\\F0396";
}

.mdi-nfc-search-variant::before {
  content: "\\F0E53";
}

.mdi-nfc-tap::before {
  content: "\\F0397";
}

.mdi-nfc-variant::before {
  content: "\\F0398";
}

.mdi-nfc-variant-off::before {
  content: "\\F0E54";
}

.mdi-ninja::before {
  content: "\\F0774";
}

.mdi-nintendo-game-boy::before {
  content: "\\F1393";
}

.mdi-nintendo-switch::before {
  content: "\\F07E1";
}

.mdi-nintendo-wii::before {
  content: "\\F05AB";
}

.mdi-nintendo-wiiu::before {
  content: "\\F072D";
}

.mdi-nix::before {
  content: "\\F1105";
}

.mdi-nodejs::before {
  content: "\\F0399";
}

.mdi-noodles::before {
  content: "\\F117E";
}

.mdi-not-equal::before {
  content: "\\F098D";
}

.mdi-not-equal-variant::before {
  content: "\\F098E";
}

.mdi-note::before {
  content: "\\F039A";
}

.mdi-note-alert::before {
  content: "\\F177D";
}

.mdi-note-alert-outline::before {
  content: "\\F177E";
}

.mdi-note-check::before {
  content: "\\F177F";
}

.mdi-note-check-outline::before {
  content: "\\F1780";
}

.mdi-note-edit::before {
  content: "\\F1781";
}

.mdi-note-edit-outline::before {
  content: "\\F1782";
}

.mdi-note-minus::before {
  content: "\\F164F";
}

.mdi-note-minus-outline::before {
  content: "\\F1650";
}

.mdi-note-multiple::before {
  content: "\\F06B8";
}

.mdi-note-multiple-outline::before {
  content: "\\F06B9";
}

.mdi-note-off::before {
  content: "\\F1783";
}

.mdi-note-off-outline::before {
  content: "\\F1784";
}

.mdi-note-outline::before {
  content: "\\F039B";
}

.mdi-note-plus::before {
  content: "\\F039C";
}

.mdi-note-plus-outline::before {
  content: "\\F039D";
}

.mdi-note-remove::before {
  content: "\\F1651";
}

.mdi-note-remove-outline::before {
  content: "\\F1652";
}

.mdi-note-search::before {
  content: "\\F1653";
}

.mdi-note-search-outline::before {
  content: "\\F1654";
}

.mdi-note-text::before {
  content: "\\F039E";
}

.mdi-note-text-outline::before {
  content: "\\F11D7";
}

.mdi-notebook::before {
  content: "\\F082E";
}

.mdi-notebook-check::before {
  content: "\\F14F5";
}

.mdi-notebook-check-outline::before {
  content: "\\F14F6";
}

.mdi-notebook-edit::before {
  content: "\\F14E7";
}

.mdi-notebook-edit-outline::before {
  content: "\\F14E9";
}

.mdi-notebook-heart::before {
  content: "\\F1A0B";
}

.mdi-notebook-heart-outline::before {
  content: "\\F1A0C";
}

.mdi-notebook-minus::before {
  content: "\\F1610";
}

.mdi-notebook-minus-outline::before {
  content: "\\F1611";
}

.mdi-notebook-multiple::before {
  content: "\\F0E55";
}

.mdi-notebook-outline::before {
  content: "\\F0EBF";
}

.mdi-notebook-plus::before {
  content: "\\F1612";
}

.mdi-notebook-plus-outline::before {
  content: "\\F1613";
}

.mdi-notebook-remove::before {
  content: "\\F1614";
}

.mdi-notebook-remove-outline::before {
  content: "\\F1615";
}

.mdi-notification-clear-all::before {
  content: "\\F039F";
}

.mdi-npm::before {
  content: "\\F06F7";
}

.mdi-nuke::before {
  content: "\\F06A4";
}

.mdi-null::before {
  content: "\\F07E2";
}

.mdi-numeric::before {
  content: "\\F03A0";
}

.mdi-numeric-0::before {
  content: "\\F0B39";
}

.mdi-numeric-0-box::before {
  content: "\\F03A1";
}

.mdi-numeric-0-box-multiple::before {
  content: "\\F0F0E";
}

.mdi-numeric-0-box-multiple-outline::before {
  content: "\\F03A2";
}

.mdi-numeric-0-box-outline::before {
  content: "\\F03A3";
}

.mdi-numeric-0-circle::before {
  content: "\\F0C9E";
}

.mdi-numeric-0-circle-outline::before {
  content: "\\F0C9F";
}

.mdi-numeric-1::before {
  content: "\\F0B3A";
}

.mdi-numeric-1-box::before {
  content: "\\F03A4";
}

.mdi-numeric-1-box-multiple::before {
  content: "\\F0F0F";
}

.mdi-numeric-1-box-multiple-outline::before {
  content: "\\F03A5";
}

.mdi-numeric-1-box-outline::before {
  content: "\\F03A6";
}

.mdi-numeric-1-circle::before {
  content: "\\F0CA0";
}

.mdi-numeric-1-circle-outline::before {
  content: "\\F0CA1";
}

.mdi-numeric-10::before {
  content: "\\F0FE9";
}

.mdi-numeric-10-box::before {
  content: "\\F0F7D";
}

.mdi-numeric-10-box-multiple::before {
  content: "\\F0FEA";
}

.mdi-numeric-10-box-multiple-outline::before {
  content: "\\F0FEB";
}

.mdi-numeric-10-box-outline::before {
  content: "\\F0F7E";
}

.mdi-numeric-10-circle::before {
  content: "\\F0FEC";
}

.mdi-numeric-10-circle-outline::before {
  content: "\\F0FED";
}

.mdi-numeric-2::before {
  content: "\\F0B3B";
}

.mdi-numeric-2-box::before {
  content: "\\F03A7";
}

.mdi-numeric-2-box-multiple::before {
  content: "\\F0F10";
}

.mdi-numeric-2-box-multiple-outline::before {
  content: "\\F03A8";
}

.mdi-numeric-2-box-outline::before {
  content: "\\F03A9";
}

.mdi-numeric-2-circle::before {
  content: "\\F0CA2";
}

.mdi-numeric-2-circle-outline::before {
  content: "\\F0CA3";
}

.mdi-numeric-3::before {
  content: "\\F0B3C";
}

.mdi-numeric-3-box::before {
  content: "\\F03AA";
}

.mdi-numeric-3-box-multiple::before {
  content: "\\F0F11";
}

.mdi-numeric-3-box-multiple-outline::before {
  content: "\\F03AB";
}

.mdi-numeric-3-box-outline::before {
  content: "\\F03AC";
}

.mdi-numeric-3-circle::before {
  content: "\\F0CA4";
}

.mdi-numeric-3-circle-outline::before {
  content: "\\F0CA5";
}

.mdi-numeric-4::before {
  content: "\\F0B3D";
}

.mdi-numeric-4-box::before {
  content: "\\F03AD";
}

.mdi-numeric-4-box-multiple::before {
  content: "\\F0F12";
}

.mdi-numeric-4-box-multiple-outline::before {
  content: "\\F03B2";
}

.mdi-numeric-4-box-outline::before {
  content: "\\F03AE";
}

.mdi-numeric-4-circle::before {
  content: "\\F0CA6";
}

.mdi-numeric-4-circle-outline::before {
  content: "\\F0CA7";
}

.mdi-numeric-5::before {
  content: "\\F0B3E";
}

.mdi-numeric-5-box::before {
  content: "\\F03B1";
}

.mdi-numeric-5-box-multiple::before {
  content: "\\F0F13";
}

.mdi-numeric-5-box-multiple-outline::before {
  content: "\\F03AF";
}

.mdi-numeric-5-box-outline::before {
  content: "\\F03B0";
}

.mdi-numeric-5-circle::before {
  content: "\\F0CA8";
}

.mdi-numeric-5-circle-outline::before {
  content: "\\F0CA9";
}

.mdi-numeric-6::before {
  content: "\\F0B3F";
}

.mdi-numeric-6-box::before {
  content: "\\F03B3";
}

.mdi-numeric-6-box-multiple::before {
  content: "\\F0F14";
}

.mdi-numeric-6-box-multiple-outline::before {
  content: "\\F03B4";
}

.mdi-numeric-6-box-outline::before {
  content: "\\F03B5";
}

.mdi-numeric-6-circle::before {
  content: "\\F0CAA";
}

.mdi-numeric-6-circle-outline::before {
  content: "\\F0CAB";
}

.mdi-numeric-7::before {
  content: "\\F0B40";
}

.mdi-numeric-7-box::before {
  content: "\\F03B6";
}

.mdi-numeric-7-box-multiple::before {
  content: "\\F0F15";
}

.mdi-numeric-7-box-multiple-outline::before {
  content: "\\F03B7";
}

.mdi-numeric-7-box-outline::before {
  content: "\\F03B8";
}

.mdi-numeric-7-circle::before {
  content: "\\F0CAC";
}

.mdi-numeric-7-circle-outline::before {
  content: "\\F0CAD";
}

.mdi-numeric-8::before {
  content: "\\F0B41";
}

.mdi-numeric-8-box::before {
  content: "\\F03B9";
}

.mdi-numeric-8-box-multiple::before {
  content: "\\F0F16";
}

.mdi-numeric-8-box-multiple-outline::before {
  content: "\\F03BA";
}

.mdi-numeric-8-box-outline::before {
  content: "\\F03BB";
}

.mdi-numeric-8-circle::before {
  content: "\\F0CAE";
}

.mdi-numeric-8-circle-outline::before {
  content: "\\F0CAF";
}

.mdi-numeric-9::before {
  content: "\\F0B42";
}

.mdi-numeric-9-box::before {
  content: "\\F03BC";
}

.mdi-numeric-9-box-multiple::before {
  content: "\\F0F17";
}

.mdi-numeric-9-box-multiple-outline::before {
  content: "\\F03BD";
}

.mdi-numeric-9-box-outline::before {
  content: "\\F03BE";
}

.mdi-numeric-9-circle::before {
  content: "\\F0CB0";
}

.mdi-numeric-9-circle-outline::before {
  content: "\\F0CB1";
}

.mdi-numeric-9-plus::before {
  content: "\\F0FEE";
}

.mdi-numeric-9-plus-box::before {
  content: "\\F03BF";
}

.mdi-numeric-9-plus-box-multiple::before {
  content: "\\F0F18";
}

.mdi-numeric-9-plus-box-multiple-outline::before {
  content: "\\F03C0";
}

.mdi-numeric-9-plus-box-outline::before {
  content: "\\F03C1";
}

.mdi-numeric-9-plus-circle::before {
  content: "\\F0CB2";
}

.mdi-numeric-9-plus-circle-outline::before {
  content: "\\F0CB3";
}

.mdi-numeric-negative-1::before {
  content: "\\F1052";
}

.mdi-numeric-off::before {
  content: "\\F19D3";
}

.mdi-numeric-positive-1::before {
  content: "\\F15CB";
}

.mdi-nut::before {
  content: "\\F06F8";
}

.mdi-nutrition::before {
  content: "\\F03C2";
}

.mdi-nuxt::before {
  content: "\\F1106";
}

.mdi-oar::before {
  content: "\\F067C";
}

.mdi-ocarina::before {
  content: "\\F0DE0";
}

.mdi-oci::before {
  content: "\\F12E9";
}

.mdi-ocr::before {
  content: "\\F113A";
}

.mdi-octagon::before {
  content: "\\F03C3";
}

.mdi-octagon-outline::before {
  content: "\\F03C4";
}

.mdi-octagram::before {
  content: "\\F06F9";
}

.mdi-octagram-edit::before {
  content: "\\F1C34";
}

.mdi-octagram-edit-outline::before {
  content: "\\F1C35";
}

.mdi-octagram-minus::before {
  content: "\\F1C36";
}

.mdi-octagram-minus-outline::before {
  content: "\\F1C37";
}

.mdi-octagram-outline::before {
  content: "\\F0775";
}

.mdi-octagram-plus::before {
  content: "\\F1C38";
}

.mdi-octagram-plus-outline::before {
  content: "\\F1C39";
}

.mdi-octahedron::before {
  content: "\\F1950";
}

.mdi-octahedron-off::before {
  content: "\\F1951";
}

.mdi-odnoklassniki::before {
  content: "\\F03C5";
}

.mdi-offer::before {
  content: "\\F121B";
}

.mdi-office-building::before {
  content: "\\F0991";
}

.mdi-office-building-cog::before {
  content: "\\F1949";
}

.mdi-office-building-cog-outline::before {
  content: "\\F194A";
}

.mdi-office-building-marker::before {
  content: "\\F1520";
}

.mdi-office-building-marker-outline::before {
  content: "\\F1521";
}

.mdi-office-building-minus::before {
  content: "\\F1BAA";
}

.mdi-office-building-minus-outline::before {
  content: "\\F1BAB";
}

.mdi-office-building-outline::before {
  content: "\\F151F";
}

.mdi-office-building-plus::before {
  content: "\\F1BA8";
}

.mdi-office-building-plus-outline::before {
  content: "\\F1BA9";
}

.mdi-office-building-remove::before {
  content: "\\F1BAC";
}

.mdi-office-building-remove-outline::before {
  content: "\\F1BAD";
}

.mdi-oil::before {
  content: "\\F03C7";
}

.mdi-oil-lamp::before {
  content: "\\F0F19";
}

.mdi-oil-level::before {
  content: "\\F1053";
}

.mdi-oil-temperature::before {
  content: "\\F0FF8";
}

.mdi-om::before {
  content: "\\F0973";
}

.mdi-omega::before {
  content: "\\F03C9";
}

.mdi-one-up::before {
  content: "\\F0BAD";
}

.mdi-onepassword::before {
  content: "\\F0881";
}

.mdi-opacity::before {
  content: "\\F05CC";
}

.mdi-open-in-app::before {
  content: "\\F03CB";
}

.mdi-open-in-new::before {
  content: "\\F03CC";
}

.mdi-open-source-initiative::before {
  content: "\\F0BAE";
}

.mdi-openid::before {
  content: "\\F03CD";
}

.mdi-opera::before {
  content: "\\F03CE";
}

.mdi-orbit::before {
  content: "\\F0018";
}

.mdi-orbit-variant::before {
  content: "\\F15DB";
}

.mdi-order-alphabetical-ascending::before {
  content: "\\F020D";
}

.mdi-order-alphabetical-descending::before {
  content: "\\F0D07";
}

.mdi-order-bool-ascending::before {
  content: "\\F02BE";
}

.mdi-order-bool-ascending-variant::before {
  content: "\\F098F";
}

.mdi-order-bool-descending::before {
  content: "\\F1384";
}

.mdi-order-bool-descending-variant::before {
  content: "\\F0990";
}

.mdi-order-numeric-ascending::before {
  content: "\\F0545";
}

.mdi-order-numeric-descending::before {
  content: "\\F0546";
}

.mdi-origin::before {
  content: "\\F0B43";
}

.mdi-ornament::before {
  content: "\\F03CF";
}

.mdi-ornament-variant::before {
  content: "\\F03D0";
}

.mdi-outdoor-lamp::before {
  content: "\\F1054";
}

.mdi-overscan::before {
  content: "\\F1005";
}

.mdi-owl::before {
  content: "\\F03D2";
}

.mdi-pac-man::before {
  content: "\\F0BAF";
}

.mdi-package::before {
  content: "\\F03D3";
}

.mdi-package-check::before {
  content: "\\F1B51";
}

.mdi-package-down::before {
  content: "\\F03D4";
}

.mdi-package-up::before {
  content: "\\F03D5";
}

.mdi-package-variant::before {
  content: "\\F03D6";
}

.mdi-package-variant-closed::before {
  content: "\\F03D7";
}

.mdi-package-variant-closed-check::before {
  content: "\\F1B52";
}

.mdi-package-variant-closed-minus::before {
  content: "\\F19D4";
}

.mdi-package-variant-closed-plus::before {
  content: "\\F19D5";
}

.mdi-package-variant-closed-remove::before {
  content: "\\F19D6";
}

.mdi-package-variant-minus::before {
  content: "\\F19D7";
}

.mdi-package-variant-plus::before {
  content: "\\F19D8";
}

.mdi-package-variant-remove::before {
  content: "\\F19D9";
}

.mdi-page-first::before {
  content: "\\F0600";
}

.mdi-page-last::before {
  content: "\\F0601";
}

.mdi-page-layout-body::before {
  content: "\\F06FA";
}

.mdi-page-layout-footer::before {
  content: "\\F06FB";
}

.mdi-page-layout-header::before {
  content: "\\F06FC";
}

.mdi-page-layout-header-footer::before {
  content: "\\F0F7F";
}

.mdi-page-layout-sidebar-left::before {
  content: "\\F06FD";
}

.mdi-page-layout-sidebar-right::before {
  content: "\\F06FE";
}

.mdi-page-next::before {
  content: "\\F0BB0";
}

.mdi-page-next-outline::before {
  content: "\\F0BB1";
}

.mdi-page-previous::before {
  content: "\\F0BB2";
}

.mdi-page-previous-outline::before {
  content: "\\F0BB3";
}

.mdi-pail::before {
  content: "\\F1417";
}

.mdi-pail-minus::before {
  content: "\\F1437";
}

.mdi-pail-minus-outline::before {
  content: "\\F143C";
}

.mdi-pail-off::before {
  content: "\\F1439";
}

.mdi-pail-off-outline::before {
  content: "\\F143E";
}

.mdi-pail-outline::before {
  content: "\\F143A";
}

.mdi-pail-plus::before {
  content: "\\F1436";
}

.mdi-pail-plus-outline::before {
  content: "\\F143B";
}

.mdi-pail-remove::before {
  content: "\\F1438";
}

.mdi-pail-remove-outline::before {
  content: "\\F143D";
}

.mdi-palette::before {
  content: "\\F03D8";
}

.mdi-palette-advanced::before {
  content: "\\F03D9";
}

.mdi-palette-outline::before {
  content: "\\F0E0C";
}

.mdi-palette-swatch::before {
  content: "\\F08B5";
}

.mdi-palette-swatch-outline::before {
  content: "\\F135C";
}

.mdi-palette-swatch-variant::before {
  content: "\\F195A";
}

.mdi-palm-tree::before {
  content: "\\F1055";
}

.mdi-pan::before {
  content: "\\F0BB4";
}

.mdi-pan-bottom-left::before {
  content: "\\F0BB5";
}

.mdi-pan-bottom-right::before {
  content: "\\F0BB6";
}

.mdi-pan-down::before {
  content: "\\F0BB7";
}

.mdi-pan-horizontal::before {
  content: "\\F0BB8";
}

.mdi-pan-left::before {
  content: "\\F0BB9";
}

.mdi-pan-right::before {
  content: "\\F0BBA";
}

.mdi-pan-top-left::before {
  content: "\\F0BBB";
}

.mdi-pan-top-right::before {
  content: "\\F0BBC";
}

.mdi-pan-up::before {
  content: "\\F0BBD";
}

.mdi-pan-vertical::before {
  content: "\\F0BBE";
}

.mdi-panda::before {
  content: "\\F03DA";
}

.mdi-pandora::before {
  content: "\\F03DB";
}

.mdi-panorama::before {
  content: "\\F03DC";
}

.mdi-panorama-fisheye::before {
  content: "\\F03DD";
}

.mdi-panorama-horizontal::before {
  content: "\\F1928";
}

.mdi-panorama-horizontal-outline::before {
  content: "\\F03DE";
}

.mdi-panorama-outline::before {
  content: "\\F198C";
}

.mdi-panorama-sphere::before {
  content: "\\F198D";
}

.mdi-panorama-sphere-outline::before {
  content: "\\F198E";
}

.mdi-panorama-variant::before {
  content: "\\F198F";
}

.mdi-panorama-variant-outline::before {
  content: "\\F1990";
}

.mdi-panorama-vertical::before {
  content: "\\F1929";
}

.mdi-panorama-vertical-outline::before {
  content: "\\F03DF";
}

.mdi-panorama-wide-angle::before {
  content: "\\F195F";
}

.mdi-panorama-wide-angle-outline::before {
  content: "\\F03E0";
}

.mdi-paper-cut-vertical::before {
  content: "\\F03E1";
}

.mdi-paper-roll::before {
  content: "\\F1157";
}

.mdi-paper-roll-outline::before {
  content: "\\F1158";
}

.mdi-paperclip::before {
  content: "\\F03E2";
}

.mdi-paperclip-check::before {
  content: "\\F1AC6";
}

.mdi-paperclip-lock::before {
  content: "\\F19DA";
}

.mdi-paperclip-minus::before {
  content: "\\F1AC7";
}

.mdi-paperclip-off::before {
  content: "\\F1AC8";
}

.mdi-paperclip-plus::before {
  content: "\\F1AC9";
}

.mdi-paperclip-remove::before {
  content: "\\F1ACA";
}

.mdi-parachute::before {
  content: "\\F0CB4";
}

.mdi-parachute-outline::before {
  content: "\\F0CB5";
}

.mdi-paragliding::before {
  content: "\\F1745";
}

.mdi-parking::before {
  content: "\\F03E3";
}

.mdi-party-popper::before {
  content: "\\F1056";
}

.mdi-passport::before {
  content: "\\F07E3";
}

.mdi-passport-alert::before {
  content: "\\F1CB8";
}

.mdi-passport-biometric::before {
  content: "\\F0DE1";
}

.mdi-passport-cancel::before {
  content: "\\F1CB9";
}

.mdi-passport-check::before {
  content: "\\F1CBA";
}

.mdi-passport-minus::before {
  content: "\\F1CBB";
}

.mdi-passport-plus::before {
  content: "\\F1CBC";
}

.mdi-passport-remove::before {
  content: "\\F1CBD";
}

.mdi-pasta::before {
  content: "\\F1160";
}

.mdi-patio-heater::before {
  content: "\\F0F80";
}

.mdi-patreon::before {
  content: "\\F0882";
}

.mdi-pause::before {
  content: "\\F03E4";
}

.mdi-pause-box::before {
  content: "\\F00BC";
}

.mdi-pause-box-outline::before {
  content: "\\F1B7A";
}

.mdi-pause-circle::before {
  content: "\\F03E5";
}

.mdi-pause-circle-outline::before {
  content: "\\F03E6";
}

.mdi-pause-octagon::before {
  content: "\\F03E7";
}

.mdi-pause-octagon-outline::before {
  content: "\\F03E8";
}

.mdi-paw::before {
  content: "\\F03E9";
}

.mdi-paw-off::before {
  content: "\\F0657";
}

.mdi-paw-off-outline::before {
  content: "\\F1676";
}

.mdi-paw-outline::before {
  content: "\\F1675";
}

.mdi-peace::before {
  content: "\\F0884";
}

.mdi-peanut::before {
  content: "\\F0FFC";
}

.mdi-peanut-off::before {
  content: "\\F0FFD";
}

.mdi-peanut-off-outline::before {
  content: "\\F0FFF";
}

.mdi-peanut-outline::before {
  content: "\\F0FFE";
}

.mdi-pen::before {
  content: "\\F03EA";
}

.mdi-pen-lock::before {
  content: "\\F0DE2";
}

.mdi-pen-minus::before {
  content: "\\F0DE3";
}

.mdi-pen-off::before {
  content: "\\F0DE4";
}

.mdi-pen-plus::before {
  content: "\\F0DE5";
}

.mdi-pen-remove::before {
  content: "\\F0DE6";
}

.mdi-pencil::before {
  content: "\\F03EB";
}

.mdi-pencil-box::before {
  content: "\\F03EC";
}

.mdi-pencil-box-multiple::before {
  content: "\\F1144";
}

.mdi-pencil-box-multiple-outline::before {
  content: "\\F1145";
}

.mdi-pencil-box-outline::before {
  content: "\\F03ED";
}

.mdi-pencil-circle::before {
  content: "\\F06FF";
}

.mdi-pencil-circle-outline::before {
  content: "\\F0776";
}

.mdi-pencil-lock::before {
  content: "\\F03EE";
}

.mdi-pencil-lock-outline::before {
  content: "\\F0DE7";
}

.mdi-pencil-minus::before {
  content: "\\F0DE8";
}

.mdi-pencil-minus-outline::before {
  content: "\\F0DE9";
}

.mdi-pencil-off::before {
  content: "\\F03EF";
}

.mdi-pencil-off-outline::before {
  content: "\\F0DEA";
}

.mdi-pencil-outline::before {
  content: "\\F0CB6";
}

.mdi-pencil-plus::before {
  content: "\\F0DEB";
}

.mdi-pencil-plus-outline::before {
  content: "\\F0DEC";
}

.mdi-pencil-remove::before {
  content: "\\F0DED";
}

.mdi-pencil-remove-outline::before {
  content: "\\F0DEE";
}

.mdi-pencil-ruler::before {
  content: "\\F1353";
}

.mdi-pencil-ruler-outline::before {
  content: "\\F1C11";
}

.mdi-penguin::before {
  content: "\\F0EC0";
}

.mdi-pentagon::before {
  content: "\\F0701";
}

.mdi-pentagon-outline::before {
  content: "\\F0700";
}

.mdi-pentagram::before {
  content: "\\F1667";
}

.mdi-percent::before {
  content: "\\F03F0";
}

.mdi-percent-box::before {
  content: "\\F1A02";
}

.mdi-percent-box-outline::before {
  content: "\\F1A03";
}

.mdi-percent-circle::before {
  content: "\\F1A04";
}

.mdi-percent-circle-outline::before {
  content: "\\F1A05";
}

.mdi-percent-outline::before {
  content: "\\F1278";
}

.mdi-periodic-table::before {
  content: "\\F08B6";
}

.mdi-perspective-less::before {
  content: "\\F0D23";
}

.mdi-perspective-more::before {
  content: "\\F0D24";
}

.mdi-ph::before {
  content: "\\F17C5";
}

.mdi-phone::before {
  content: "\\F03F2";
}

.mdi-phone-alert::before {
  content: "\\F0F1A";
}

.mdi-phone-alert-outline::before {
  content: "\\F118E";
}

.mdi-phone-bluetooth::before {
  content: "\\F03F3";
}

.mdi-phone-bluetooth-outline::before {
  content: "\\F118F";
}

.mdi-phone-cancel::before {
  content: "\\F10BC";
}

.mdi-phone-cancel-outline::before {
  content: "\\F1190";
}

.mdi-phone-check::before {
  content: "\\F11A9";
}

.mdi-phone-check-outline::before {
  content: "\\F11AA";
}

.mdi-phone-classic::before {
  content: "\\F0602";
}

.mdi-phone-classic-off::before {
  content: "\\F1279";
}

.mdi-phone-clock::before {
  content: "\\F19DB";
}

.mdi-phone-dial::before {
  content: "\\F1559";
}

.mdi-phone-dial-outline::before {
  content: "\\F155A";
}

.mdi-phone-forward::before {
  content: "\\F03F4";
}

.mdi-phone-forward-outline::before {
  content: "\\F1191";
}

.mdi-phone-hangup::before {
  content: "\\F03F5";
}

.mdi-phone-hangup-outline::before {
  content: "\\F1192";
}

.mdi-phone-in-talk::before {
  content: "\\F03F6";
}

.mdi-phone-in-talk-outline::before {
  content: "\\F1182";
}

.mdi-phone-incoming::before {
  content: "\\F03F7";
}

.mdi-phone-incoming-outgoing::before {
  content: "\\F1B3F";
}

.mdi-phone-incoming-outgoing-outline::before {
  content: "\\F1B40";
}

.mdi-phone-incoming-outline::before {
  content: "\\F1193";
}

.mdi-phone-lock::before {
  content: "\\F03F8";
}

.mdi-phone-lock-outline::before {
  content: "\\F1194";
}

.mdi-phone-log::before {
  content: "\\F03F9";
}

.mdi-phone-log-outline::before {
  content: "\\F1195";
}

.mdi-phone-message::before {
  content: "\\F1196";
}

.mdi-phone-message-outline::before {
  content: "\\F1197";
}

.mdi-phone-minus::before {
  content: "\\F0658";
}

.mdi-phone-minus-outline::before {
  content: "\\F1198";
}

.mdi-phone-missed::before {
  content: "\\F03FA";
}

.mdi-phone-missed-outline::before {
  content: "\\F11A5";
}

.mdi-phone-off::before {
  content: "\\F0DEF";
}

.mdi-phone-off-outline::before {
  content: "\\F11A6";
}

.mdi-phone-outgoing::before {
  content: "\\F03FB";
}

.mdi-phone-outgoing-outline::before {
  content: "\\F1199";
}

.mdi-phone-outline::before {
  content: "\\F0DF0";
}

.mdi-phone-paused::before {
  content: "\\F03FC";
}

.mdi-phone-paused-outline::before {
  content: "\\F119A";
}

.mdi-phone-plus::before {
  content: "\\F0659";
}

.mdi-phone-plus-outline::before {
  content: "\\F119B";
}

.mdi-phone-refresh::before {
  content: "\\F1993";
}

.mdi-phone-refresh-outline::before {
  content: "\\F1994";
}

.mdi-phone-remove::before {
  content: "\\F152F";
}

.mdi-phone-remove-outline::before {
  content: "\\F1530";
}

.mdi-phone-return::before {
  content: "\\F082F";
}

.mdi-phone-return-outline::before {
  content: "\\F119C";
}

.mdi-phone-ring::before {
  content: "\\F11AB";
}

.mdi-phone-ring-outline::before {
  content: "\\F11AC";
}

.mdi-phone-rotate-landscape::before {
  content: "\\F0885";
}

.mdi-phone-rotate-portrait::before {
  content: "\\F0886";
}

.mdi-phone-settings::before {
  content: "\\F03FD";
}

.mdi-phone-settings-outline::before {
  content: "\\F119D";
}

.mdi-phone-sync::before {
  content: "\\F1995";
}

.mdi-phone-sync-outline::before {
  content: "\\F1996";
}

.mdi-phone-voip::before {
  content: "\\F03FE";
}

.mdi-pi::before {
  content: "\\F03FF";
}

.mdi-pi-box::before {
  content: "\\F0400";
}

.mdi-pi-hole::before {
  content: "\\F0DF1";
}

.mdi-piano::before {
  content: "\\F067D";
}

.mdi-piano-off::before {
  content: "\\F0698";
}

.mdi-pickaxe::before {
  content: "\\F08B7";
}

.mdi-picture-in-picture-bottom-right::before {
  content: "\\F0E57";
}

.mdi-picture-in-picture-bottom-right-outline::before {
  content: "\\F0E58";
}

.mdi-picture-in-picture-top-right::before {
  content: "\\F0E59";
}

.mdi-picture-in-picture-top-right-outline::before {
  content: "\\F0E5A";
}

.mdi-pier::before {
  content: "\\F0887";
}

.mdi-pier-crane::before {
  content: "\\F0888";
}

.mdi-pig::before {
  content: "\\F0401";
}

.mdi-pig-variant::before {
  content: "\\F1006";
}

.mdi-pig-variant-outline::before {
  content: "\\F1678";
}

.mdi-piggy-bank::before {
  content: "\\F1007";
}

.mdi-piggy-bank-outline::before {
  content: "\\F1679";
}

.mdi-pill::before {
  content: "\\F0402";
}

.mdi-pill-multiple::before {
  content: "\\F1B4C";
}

.mdi-pill-off::before {
  content: "\\F1A5C";
}

.mdi-pillar::before {
  content: "\\F0702";
}

.mdi-pin::before {
  content: "\\F0403";
}

.mdi-pin-off::before {
  content: "\\F0404";
}

.mdi-pin-off-outline::before {
  content: "\\F0930";
}

.mdi-pin-outline::before {
  content: "\\F0931";
}

.mdi-pine-tree::before {
  content: "\\F0405";
}

.mdi-pine-tree-box::before {
  content: "\\F0406";
}

.mdi-pine-tree-fire::before {
  content: "\\F141A";
}

.mdi-pine-tree-variant::before {
  content: "\\F1C73";
}

.mdi-pine-tree-variant-outline::before {
  content: "\\F1C74";
}

.mdi-pinterest::before {
  content: "\\F0407";
}

.mdi-pinwheel::before {
  content: "\\F0AD5";
}

.mdi-pinwheel-outline::before {
  content: "\\F0AD6";
}

.mdi-pipe::before {
  content: "\\F07E5";
}

.mdi-pipe-disconnected::before {
  content: "\\F07E6";
}

.mdi-pipe-leak::before {
  content: "\\F0889";
}

.mdi-pipe-valve::before {
  content: "\\F184D";
}

.mdi-pipe-wrench::before {
  content: "\\F1354";
}

.mdi-pirate::before {
  content: "\\F0A08";
}

.mdi-pistol::before {
  content: "\\F0703";
}

.mdi-piston::before {
  content: "\\F088A";
}

.mdi-pitchfork::before {
  content: "\\F1553";
}

.mdi-pizza::before {
  content: "\\F0409";
}

.mdi-plane-car::before {
  content: "\\F1AFF";
}

.mdi-plane-train::before {
  content: "\\F1B00";
}

.mdi-play::before {
  content: "\\F040A";
}

.mdi-play-box::before {
  content: "\\F127A";
}

.mdi-play-box-edit-outline::before {
  content: "\\F1C3A";
}

.mdi-play-box-lock::before {
  content: "\\F1A16";
}

.mdi-play-box-lock-open::before {
  content: "\\F1A17";
}

.mdi-play-box-lock-open-outline::before {
  content: "\\F1A18";
}

.mdi-play-box-lock-outline::before {
  content: "\\F1A19";
}

.mdi-play-box-multiple::before {
  content: "\\F0D19";
}

.mdi-play-box-multiple-outline::before {
  content: "\\F13E6";
}

.mdi-play-box-outline::before {
  content: "\\F040B";
}

.mdi-play-circle::before {
  content: "\\F040C";
}

.mdi-play-circle-outline::before {
  content: "\\F040D";
}

.mdi-play-network::before {
  content: "\\F088B";
}

.mdi-play-network-outline::before {
  content: "\\F0CB7";
}

.mdi-play-outline::before {
  content: "\\F0F1B";
}

.mdi-play-pause::before {
  content: "\\F040E";
}

.mdi-play-protected-content::before {
  content: "\\F040F";
}

.mdi-play-speed::before {
  content: "\\F08FF";
}

.mdi-playlist-check::before {
  content: "\\F05C7";
}

.mdi-playlist-edit::before {
  content: "\\F0900";
}

.mdi-playlist-minus::before {
  content: "\\F0410";
}

.mdi-playlist-music::before {
  content: "\\F0CB8";
}

.mdi-playlist-music-outline::before {
  content: "\\F0CB9";
}

.mdi-playlist-play::before {
  content: "\\F0411";
}

.mdi-playlist-plus::before {
  content: "\\F0412";
}

.mdi-playlist-remove::before {
  content: "\\F0413";
}

.mdi-playlist-star::before {
  content: "\\F0DF2";
}

.mdi-plex::before {
  content: "\\F06BA";
}

.mdi-pliers::before {
  content: "\\F19A4";
}

.mdi-plus::before {
  content: "\\F0415";
}

.mdi-plus-box::before {
  content: "\\F0416";
}

.mdi-plus-box-multiple::before {
  content: "\\F0334";
}

.mdi-plus-box-multiple-outline::before {
  content: "\\F1143";
}

.mdi-plus-box-outline::before {
  content: "\\F0704";
}

.mdi-plus-circle::before {
  content: "\\F0417";
}

.mdi-plus-circle-multiple::before {
  content: "\\F034C";
}

.mdi-plus-circle-multiple-outline::before {
  content: "\\F0418";
}

.mdi-plus-circle-outline::before {
  content: "\\F0419";
}

.mdi-plus-lock::before {
  content: "\\F1A5D";
}

.mdi-plus-lock-open::before {
  content: "\\F1A5E";
}

.mdi-plus-minus::before {
  content: "\\F0992";
}

.mdi-plus-minus-box::before {
  content: "\\F0993";
}

.mdi-plus-minus-variant::before {
  content: "\\F14C9";
}

.mdi-plus-network::before {
  content: "\\F041A";
}

.mdi-plus-network-outline::before {
  content: "\\F0CBA";
}

.mdi-plus-outline::before {
  content: "\\F0705";
}

.mdi-plus-thick::before {
  content: "\\F11EC";
}

.mdi-pocket::before {
  content: "\\F1CBE";
}

.mdi-podcast::before {
  content: "\\F0994";
}

.mdi-podium::before {
  content: "\\F0D25";
}

.mdi-podium-bronze::before {
  content: "\\F0D26";
}

.mdi-podium-gold::before {
  content: "\\F0D27";
}

.mdi-podium-silver::before {
  content: "\\F0D28";
}

.mdi-point-of-sale::before {
  content: "\\F0D92";
}

.mdi-pokeball::before {
  content: "\\F041D";
}

.mdi-pokemon-go::before {
  content: "\\F0A09";
}

.mdi-poker-chip::before {
  content: "\\F0830";
}

.mdi-polaroid::before {
  content: "\\F041E";
}

.mdi-police-badge::before {
  content: "\\F1167";
}

.mdi-police-badge-outline::before {
  content: "\\F1168";
}

.mdi-police-station::before {
  content: "\\F1839";
}

.mdi-poll::before {
  content: "\\F041F";
}

.mdi-polo::before {
  content: "\\F14C3";
}

.mdi-polymer::before {
  content: "\\F0421";
}

.mdi-pool::before {
  content: "\\F0606";
}

.mdi-pool-thermometer::before {
  content: "\\F1A5F";
}

.mdi-popcorn::before {
  content: "\\F0422";
}

.mdi-post::before {
  content: "\\F1008";
}

.mdi-post-lamp::before {
  content: "\\F1A60";
}

.mdi-post-outline::before {
  content: "\\F1009";
}

.mdi-postage-stamp::before {
  content: "\\F0CBB";
}

.mdi-pot::before {
  content: "\\F02E5";
}

.mdi-pot-mix::before {
  content: "\\F065B";
}

.mdi-pot-mix-outline::before {
  content: "\\F0677";
}

.mdi-pot-outline::before {
  content: "\\F02FF";
}

.mdi-pot-steam::before {
  content: "\\F065A";
}

.mdi-pot-steam-outline::before {
  content: "\\F0326";
}

.mdi-pound::before {
  content: "\\F0423";
}

.mdi-pound-box::before {
  content: "\\F0424";
}

.mdi-pound-box-outline::before {
  content: "\\F117F";
}

.mdi-power::before {
  content: "\\F0425";
}

.mdi-power-cycle::before {
  content: "\\F0901";
}

.mdi-power-off::before {
  content: "\\F0902";
}

.mdi-power-on::before {
  content: "\\F0903";
}

.mdi-power-plug::before {
  content: "\\F06A5";
}

.mdi-power-plug-battery::before {
  content: "\\F1C3B";
}

.mdi-power-plug-battery-outline::before {
  content: "\\F1C3C";
}

.mdi-power-plug-off::before {
  content: "\\F06A6";
}

.mdi-power-plug-off-outline::before {
  content: "\\F1424";
}

.mdi-power-plug-outline::before {
  content: "\\F1425";
}

.mdi-power-settings::before {
  content: "\\F0426";
}

.mdi-power-sleep::before {
  content: "\\F0904";
}

.mdi-power-socket::before {
  content: "\\F0427";
}

.mdi-power-socket-au::before {
  content: "\\F0905";
}

.mdi-power-socket-ch::before {
  content: "\\F0FB3";
}

.mdi-power-socket-de::before {
  content: "\\F1107";
}

.mdi-power-socket-eu::before {
  content: "\\F07E7";
}

.mdi-power-socket-fr::before {
  content: "\\F1108";
}

.mdi-power-socket-it::before {
  content: "\\F14FF";
}

.mdi-power-socket-jp::before {
  content: "\\F1109";
}

.mdi-power-socket-uk::before {
  content: "\\F07E8";
}

.mdi-power-socket-us::before {
  content: "\\F07E9";
}

.mdi-power-standby::before {
  content: "\\F0906";
}

.mdi-powershell::before {
  content: "\\F0A0A";
}

.mdi-prescription::before {
  content: "\\F0706";
}

.mdi-presentation::before {
  content: "\\F0428";
}

.mdi-presentation-play::before {
  content: "\\F0429";
}

.mdi-pretzel::before {
  content: "\\F1562";
}

.mdi-printer::before {
  content: "\\F042A";
}

.mdi-printer-3d::before {
  content: "\\F042B";
}

.mdi-printer-3d-nozzle::before {
  content: "\\F0E5B";
}

.mdi-printer-3d-nozzle-alert::before {
  content: "\\F11C0";
}

.mdi-printer-3d-nozzle-alert-outline::before {
  content: "\\F11C1";
}

.mdi-printer-3d-nozzle-heat::before {
  content: "\\F18B8";
}

.mdi-printer-3d-nozzle-heat-outline::before {
  content: "\\F18B9";
}

.mdi-printer-3d-nozzle-off::before {
  content: "\\F1B19";
}

.mdi-printer-3d-nozzle-off-outline::before {
  content: "\\F1B1A";
}

.mdi-printer-3d-nozzle-outline::before {
  content: "\\F0E5C";
}

.mdi-printer-3d-off::before {
  content: "\\F1B0E";
}

.mdi-printer-alert::before {
  content: "\\F042C";
}

.mdi-printer-check::before {
  content: "\\F1146";
}

.mdi-printer-eye::before {
  content: "\\F1458";
}

.mdi-printer-off::before {
  content: "\\F0E5D";
}

.mdi-printer-off-outline::before {
  content: "\\F1785";
}

.mdi-printer-outline::before {
  content: "\\F1786";
}

.mdi-printer-pos::before {
  content: "\\F1057";
}

.mdi-printer-pos-alert::before {
  content: "\\F1BBC";
}

.mdi-printer-pos-alert-outline::before {
  content: "\\F1BBD";
}

.mdi-printer-pos-cancel::before {
  content: "\\F1BBE";
}

.mdi-printer-pos-cancel-outline::before {
  content: "\\F1BBF";
}

.mdi-printer-pos-check::before {
  content: "\\F1BC0";
}

.mdi-printer-pos-check-outline::before {
  content: "\\F1BC1";
}

.mdi-printer-pos-cog::before {
  content: "\\F1BC2";
}

.mdi-printer-pos-cog-outline::before {
  content: "\\F1BC3";
}

.mdi-printer-pos-edit::before {
  content: "\\F1BC4";
}

.mdi-printer-pos-edit-outline::before {
  content: "\\F1BC5";
}

.mdi-printer-pos-minus::before {
  content: "\\F1BC6";
}

.mdi-printer-pos-minus-outline::before {
  content: "\\F1BC7";
}

.mdi-printer-pos-network::before {
  content: "\\F1BC8";
}

.mdi-printer-pos-network-outline::before {
  content: "\\F1BC9";
}

.mdi-printer-pos-off::before {
  content: "\\F1BCA";
}

.mdi-printer-pos-off-outline::before {
  content: "\\F1BCB";
}

.mdi-printer-pos-outline::before {
  content: "\\F1BCC";
}

.mdi-printer-pos-pause::before {
  content: "\\F1BCD";
}

.mdi-printer-pos-pause-outline::before {
  content: "\\F1BCE";
}

.mdi-printer-pos-play::before {
  content: "\\F1BCF";
}

.mdi-printer-pos-play-outline::before {
  content: "\\F1BD0";
}

.mdi-printer-pos-plus::before {
  content: "\\F1BD1";
}

.mdi-printer-pos-plus-outline::before {
  content: "\\F1BD2";
}

.mdi-printer-pos-refresh::before {
  content: "\\F1BD3";
}

.mdi-printer-pos-refresh-outline::before {
  content: "\\F1BD4";
}

.mdi-printer-pos-remove::before {
  content: "\\F1BD5";
}

.mdi-printer-pos-remove-outline::before {
  content: "\\F1BD6";
}

.mdi-printer-pos-star::before {
  content: "\\F1BD7";
}

.mdi-printer-pos-star-outline::before {
  content: "\\F1BD8";
}

.mdi-printer-pos-stop::before {
  content: "\\F1BD9";
}

.mdi-printer-pos-stop-outline::before {
  content: "\\F1BDA";
}

.mdi-printer-pos-sync::before {
  content: "\\F1BDB";
}

.mdi-printer-pos-sync-outline::before {
  content: "\\F1BDC";
}

.mdi-printer-pos-wrench::before {
  content: "\\F1BDD";
}

.mdi-printer-pos-wrench-outline::before {
  content: "\\F1BDE";
}

.mdi-printer-search::before {
  content: "\\F1457";
}

.mdi-printer-settings::before {
  content: "\\F0707";
}

.mdi-printer-wireless::before {
  content: "\\F0A0B";
}

.mdi-priority-high::before {
  content: "\\F0603";
}

.mdi-priority-low::before {
  content: "\\F0604";
}

.mdi-professional-hexagon::before {
  content: "\\F042D";
}

.mdi-progress-alert::before {
  content: "\\F0CBC";
}

.mdi-progress-check::before {
  content: "\\F0995";
}

.mdi-progress-clock::before {
  content: "\\F0996";
}

.mdi-progress-close::before {
  content: "\\F110A";
}

.mdi-progress-download::before {
  content: "\\F0997";
}

.mdi-progress-helper::before {
  content: "\\F1BA2";
}

.mdi-progress-pencil::before {
  content: "\\F1787";
}

.mdi-progress-question::before {
  content: "\\F1522";
}

.mdi-progress-star::before {
  content: "\\F1788";
}

.mdi-progress-star-four-points::before {
  content: "\\F1C3D";
}

.mdi-progress-tag::before {
  content: "\\F1D0D";
}

.mdi-progress-upload::before {
  content: "\\F0998";
}

.mdi-progress-wrench::before {
  content: "\\F0CBD";
}

.mdi-projector::before {
  content: "\\F042E";
}

.mdi-projector-off::before {
  content: "\\F1A23";
}

.mdi-projector-screen::before {
  content: "\\F042F";
}

.mdi-projector-screen-off::before {
  content: "\\F180D";
}

.mdi-projector-screen-off-outline::before {
  content: "\\F180E";
}

.mdi-projector-screen-outline::before {
  content: "\\F1724";
}

.mdi-projector-screen-variant::before {
  content: "\\F180F";
}

.mdi-projector-screen-variant-off::before {
  content: "\\F1810";
}

.mdi-projector-screen-variant-off-outline::before {
  content: "\\F1811";
}

.mdi-projector-screen-variant-outline::before {
  content: "\\F1812";
}

.mdi-propane-tank::before {
  content: "\\F1357";
}

.mdi-propane-tank-outline::before {
  content: "\\F1358";
}

.mdi-protocol::before {
  content: "\\F0FD8";
}

.mdi-publish::before {
  content: "\\F06A7";
}

.mdi-publish-off::before {
  content: "\\F1945";
}

.mdi-pulse::before {
  content: "\\F0430";
}

.mdi-pump::before {
  content: "\\F1402";
}

.mdi-pump-off::before {
  content: "\\F1B22";
}

.mdi-pumpkin::before {
  content: "\\F0BBF";
}

.mdi-purse::before {
  content: "\\F0F1C";
}

.mdi-purse-outline::before {
  content: "\\F0F1D";
}

.mdi-puzzle::before {
  content: "\\F0431";
}

.mdi-puzzle-check::before {
  content: "\\F1426";
}

.mdi-puzzle-check-outline::before {
  content: "\\F1427";
}

.mdi-puzzle-edit::before {
  content: "\\F14D3";
}

.mdi-puzzle-edit-outline::before {
  content: "\\F14D9";
}

.mdi-puzzle-heart::before {
  content: "\\F14D4";
}

.mdi-puzzle-heart-outline::before {
  content: "\\F14DA";
}

.mdi-puzzle-minus::before {
  content: "\\F14D1";
}

.mdi-puzzle-minus-outline::before {
  content: "\\F14D7";
}

.mdi-puzzle-outline::before {
  content: "\\F0A66";
}

.mdi-puzzle-plus::before {
  content: "\\F14D0";
}

.mdi-puzzle-plus-outline::before {
  content: "\\F14D6";
}

.mdi-puzzle-remove::before {
  content: "\\F14D2";
}

.mdi-puzzle-remove-outline::before {
  content: "\\F14D8";
}

.mdi-puzzle-star::before {
  content: "\\F14D5";
}

.mdi-puzzle-star-outline::before {
  content: "\\F14DB";
}

.mdi-pyramid::before {
  content: "\\F1952";
}

.mdi-pyramid-off::before {
  content: "\\F1953";
}

.mdi-qi::before {
  content: "\\F0999";
}

.mdi-qqchat::before {
  content: "\\F0605";
}

.mdi-qrcode::before {
  content: "\\F0432";
}

.mdi-qrcode-edit::before {
  content: "\\F08B8";
}

.mdi-qrcode-minus::before {
  content: "\\F118C";
}

.mdi-qrcode-plus::before {
  content: "\\F118B";
}

.mdi-qrcode-remove::before {
  content: "\\F118D";
}

.mdi-qrcode-scan::before {
  content: "\\F0433";
}

.mdi-quadcopter::before {
  content: "\\F0434";
}

.mdi-quality-high::before {
  content: "\\F0435";
}

.mdi-quality-low::before {
  content: "\\F0A0C";
}

.mdi-quality-medium::before {
  content: "\\F0A0D";
}

.mdi-queue-first-in-last-out::before {
  content: "\\F1CAF";
}

.mdi-quora::before {
  content: "\\F0D29";
}

.mdi-rabbit::before {
  content: "\\F0907";
}

.mdi-rabbit-variant::before {
  content: "\\F1A61";
}

.mdi-rabbit-variant-outline::before {
  content: "\\F1A62";
}

.mdi-racing-helmet::before {
  content: "\\F0D93";
}

.mdi-racquetball::before {
  content: "\\F0D94";
}

.mdi-radar::before {
  content: "\\F0437";
}

.mdi-radiator::before {
  content: "\\F0438";
}

.mdi-radiator-disabled::before {
  content: "\\F0AD7";
}

.mdi-radiator-off::before {
  content: "\\F0AD8";
}

.mdi-radio::before {
  content: "\\F0439";
}

.mdi-radio-am::before {
  content: "\\F0CBE";
}

.mdi-radio-fm::before {
  content: "\\F0CBF";
}

.mdi-radio-handheld::before {
  content: "\\F043A";
}

.mdi-radio-off::before {
  content: "\\F121C";
}

.mdi-radio-tower::before {
  content: "\\F043B";
}

.mdi-radioactive::before {
  content: "\\F043C";
}

.mdi-radioactive-circle::before {
  content: "\\F185D";
}

.mdi-radioactive-circle-outline::before {
  content: "\\F185E";
}

.mdi-radioactive-off::before {
  content: "\\F0EC1";
}

.mdi-radiobox-blank::before {
  content: "\\F043D";
}

.mdi-radiobox-indeterminate-variant::before {
  content: "\\F1C5E";
}

.mdi-radiobox-marked::before {
  content: "\\F043E";
}

.mdi-radiology-box::before {
  content: "\\F14C5";
}

.mdi-radiology-box-outline::before {
  content: "\\F14C6";
}

.mdi-radius::before {
  content: "\\F0CC0";
}

.mdi-radius-outline::before {
  content: "\\F0CC1";
}

.mdi-railroad-light::before {
  content: "\\F0F1E";
}

.mdi-rake::before {
  content: "\\F1544";
}

.mdi-raspberry-pi::before {
  content: "\\F043F";
}

.mdi-raw::before {
  content: "\\F1A0F";
}

.mdi-raw-off::before {
  content: "\\F1A10";
}

.mdi-ray-end::before {
  content: "\\F0440";
}

.mdi-ray-end-arrow::before {
  content: "\\F0441";
}

.mdi-ray-start::before {
  content: "\\F0442";
}

.mdi-ray-start-arrow::before {
  content: "\\F0443";
}

.mdi-ray-start-end::before {
  content: "\\F0444";
}

.mdi-ray-start-vertex-end::before {
  content: "\\F15D8";
}

.mdi-ray-vertex::before {
  content: "\\F0445";
}

.mdi-razor-double-edge::before {
  content: "\\F1997";
}

.mdi-razor-single-edge::before {
  content: "\\F1998";
}

.mdi-react::before {
  content: "\\F0708";
}

.mdi-read::before {
  content: "\\F0447";
}

.mdi-receipt::before {
  content: "\\F0824";
}

.mdi-receipt-clock::before {
  content: "\\F1C3E";
}

.mdi-receipt-clock-outline::before {
  content: "\\F1C3F";
}

.mdi-receipt-outline::before {
  content: "\\F04F7";
}

.mdi-receipt-send::before {
  content: "\\F1C40";
}

.mdi-receipt-send-outline::before {
  content: "\\F1C41";
}

.mdi-receipt-text::before {
  content: "\\F0449";
}

.mdi-receipt-text-arrow-left::before {
  content: "\\F1C42";
}

.mdi-receipt-text-arrow-left-outline::before {
  content: "\\F1C43";
}

.mdi-receipt-text-arrow-right::before {
  content: "\\F1C44";
}

.mdi-receipt-text-arrow-right-outline::before {
  content: "\\F1C45";
}

.mdi-receipt-text-check::before {
  content: "\\F1A63";
}

.mdi-receipt-text-check-outline::before {
  content: "\\F1A64";
}

.mdi-receipt-text-clock::before {
  content: "\\F1C46";
}

.mdi-receipt-text-clock-outline::before {
  content: "\\F1C47";
}

.mdi-receipt-text-edit::before {
  content: "\\F1C48";
}

.mdi-receipt-text-edit-outline::before {
  content: "\\F1C49";
}

.mdi-receipt-text-minus::before {
  content: "\\F1A65";
}

.mdi-receipt-text-minus-outline::before {
  content: "\\F1A66";
}

.mdi-receipt-text-outline::before {
  content: "\\F19DC";
}

.mdi-receipt-text-plus::before {
  content: "\\F1A67";
}

.mdi-receipt-text-plus-outline::before {
  content: "\\F1A68";
}

.mdi-receipt-text-remove::before {
  content: "\\F1A69";
}

.mdi-receipt-text-remove-outline::before {
  content: "\\F1A6A";
}

.mdi-receipt-text-send::before {
  content: "\\F1C4A";
}

.mdi-receipt-text-send-outline::before {
  content: "\\F1C4B";
}

.mdi-record::before {
  content: "\\F044A";
}

.mdi-record-circle::before {
  content: "\\F0EC2";
}

.mdi-record-circle-outline::before {
  content: "\\F0EC3";
}

.mdi-record-player::before {
  content: "\\F099A";
}

.mdi-record-rec::before {
  content: "\\F044B";
}

.mdi-rectangle::before {
  content: "\\F0E5E";
}

.mdi-rectangle-outline::before {
  content: "\\F0E5F";
}

.mdi-recycle::before {
  content: "\\F044C";
}

.mdi-recycle-variant::before {
  content: "\\F139D";
}

.mdi-reddit::before {
  content: "\\F044D";
}

.mdi-redhat::before {
  content: "\\F111B";
}

.mdi-redo::before {
  content: "\\F044E";
}

.mdi-redo-variant::before {
  content: "\\F044F";
}

.mdi-reflect-horizontal::before {
  content: "\\F0A0E";
}

.mdi-reflect-vertical::before {
  content: "\\F0A0F";
}

.mdi-refresh::before {
  content: "\\F0450";
}

.mdi-refresh-auto::before {
  content: "\\F18F2";
}

.mdi-refresh-circle::before {
  content: "\\F1377";
}

.mdi-regex::before {
  content: "\\F0451";
}

.mdi-registered-trademark::before {
  content: "\\F0A67";
}

.mdi-reiterate::before {
  content: "\\F1588";
}

.mdi-relation-many-to-many::before {
  content: "\\F1496";
}

.mdi-relation-many-to-one::before {
  content: "\\F1497";
}

.mdi-relation-many-to-one-or-many::before {
  content: "\\F1498";
}

.mdi-relation-many-to-only-one::before {
  content: "\\F1499";
}

.mdi-relation-many-to-zero-or-many::before {
  content: "\\F149A";
}

.mdi-relation-many-to-zero-or-one::before {
  content: "\\F149B";
}

.mdi-relation-one-or-many-to-many::before {
  content: "\\F149C";
}

.mdi-relation-one-or-many-to-one::before {
  content: "\\F149D";
}

.mdi-relation-one-or-many-to-one-or-many::before {
  content: "\\F149E";
}

.mdi-relation-one-or-many-to-only-one::before {
  content: "\\F149F";
}

.mdi-relation-one-or-many-to-zero-or-many::before {
  content: "\\F14A0";
}

.mdi-relation-one-or-many-to-zero-or-one::before {
  content: "\\F14A1";
}

.mdi-relation-one-to-many::before {
  content: "\\F14A2";
}

.mdi-relation-one-to-one::before {
  content: "\\F14A3";
}

.mdi-relation-one-to-one-or-many::before {
  content: "\\F14A4";
}

.mdi-relation-one-to-only-one::before {
  content: "\\F14A5";
}

.mdi-relation-one-to-zero-or-many::before {
  content: "\\F14A6";
}

.mdi-relation-one-to-zero-or-one::before {
  content: "\\F14A7";
}

.mdi-relation-only-one-to-many::before {
  content: "\\F14A8";
}

.mdi-relation-only-one-to-one::before {
  content: "\\F14A9";
}

.mdi-relation-only-one-to-one-or-many::before {
  content: "\\F14AA";
}

.mdi-relation-only-one-to-only-one::before {
  content: "\\F14AB";
}

.mdi-relation-only-one-to-zero-or-many::before {
  content: "\\F14AC";
}

.mdi-relation-only-one-to-zero-or-one::before {
  content: "\\F14AD";
}

.mdi-relation-zero-or-many-to-many::before {
  content: "\\F14AE";
}

.mdi-relation-zero-or-many-to-one::before {
  content: "\\F14AF";
}

.mdi-relation-zero-or-many-to-one-or-many::before {
  content: "\\F14B0";
}

.mdi-relation-zero-or-many-to-only-one::before {
  content: "\\F14B1";
}

.mdi-relation-zero-or-many-to-zero-or-many::before {
  content: "\\F14B2";
}

.mdi-relation-zero-or-many-to-zero-or-one::before {
  content: "\\F14B3";
}

.mdi-relation-zero-or-one-to-many::before {
  content: "\\F14B4";
}

.mdi-relation-zero-or-one-to-one::before {
  content: "\\F14B5";
}

.mdi-relation-zero-or-one-to-one-or-many::before {
  content: "\\F14B6";
}

.mdi-relation-zero-or-one-to-only-one::before {
  content: "\\F14B7";
}

.mdi-relation-zero-or-one-to-zero-or-many::before {
  content: "\\F14B8";
}

.mdi-relation-zero-or-one-to-zero-or-one::before {
  content: "\\F14B9";
}

.mdi-relative-scale::before {
  content: "\\F0452";
}

.mdi-reload::before {
  content: "\\F0453";
}

.mdi-reload-alert::before {
  content: "\\F110B";
}

.mdi-reminder::before {
  content: "\\F088C";
}

.mdi-remote::before {
  content: "\\F0454";
}

.mdi-remote-desktop::before {
  content: "\\F08B9";
}

.mdi-remote-off::before {
  content: "\\F0EC4";
}

.mdi-remote-tv::before {
  content: "\\F0EC5";
}

.mdi-remote-tv-off::before {
  content: "\\F0EC6";
}

.mdi-rename::before {
  content: "\\F1C18";
}

.mdi-rename-box::before {
  content: "\\F0455";
}

.mdi-rename-box-outline::before {
  content: "\\F1C19";
}

.mdi-rename-outline::before {
  content: "\\F1C1A";
}

.mdi-reorder-horizontal::before {
  content: "\\F0688";
}

.mdi-reorder-vertical::before {
  content: "\\F0689";
}

.mdi-repeat::before {
  content: "\\F0456";
}

.mdi-repeat-off::before {
  content: "\\F0457";
}

.mdi-repeat-once::before {
  content: "\\F0458";
}

.mdi-repeat-variant::before {
  content: "\\F0547";
}

.mdi-replay::before {
  content: "\\F0459";
}

.mdi-reply::before {
  content: "\\F045A";
}

.mdi-reply-all::before {
  content: "\\F045B";
}

.mdi-reply-all-outline::before {
  content: "\\F0F1F";
}

.mdi-reply-circle::before {
  content: "\\F11AE";
}

.mdi-reply-outline::before {
  content: "\\F0F20";
}

.mdi-reproduction::before {
  content: "\\F045C";
}

.mdi-resistor::before {
  content: "\\F0B44";
}

.mdi-resistor-nodes::before {
  content: "\\F0B45";
}

.mdi-resize::before {
  content: "\\F0A68";
}

.mdi-resize-bottom-right::before {
  content: "\\F045D";
}

.mdi-responsive::before {
  content: "\\F045E";
}

.mdi-restart::before {
  content: "\\F0709";
}

.mdi-restart-alert::before {
  content: "\\F110C";
}

.mdi-restart-off::before {
  content: "\\F0D95";
}

.mdi-restore::before {
  content: "\\F099B";
}

.mdi-restore-alert::before {
  content: "\\F110D";
}

.mdi-rewind::before {
  content: "\\F045F";
}

.mdi-rewind-10::before {
  content: "\\F0D2A";
}

.mdi-rewind-15::before {
  content: "\\F1946";
}

.mdi-rewind-30::before {
  content: "\\F0D96";
}

.mdi-rewind-45::before {
  content: "\\F1B13";
}

.mdi-rewind-5::before {
  content: "\\F11F9";
}

.mdi-rewind-60::before {
  content: "\\F160C";
}

.mdi-rewind-outline::before {
  content: "\\F070A";
}

.mdi-rhombus::before {
  content: "\\F070B";
}

.mdi-rhombus-medium::before {
  content: "\\F0A10";
}

.mdi-rhombus-medium-outline::before {
  content: "\\F14DC";
}

.mdi-rhombus-outline::before {
  content: "\\F070C";
}

.mdi-rhombus-split::before {
  content: "\\F0A11";
}

.mdi-rhombus-split-outline::before {
  content: "\\F14DD";
}

.mdi-ribbon::before {
  content: "\\F0460";
}

.mdi-rice::before {
  content: "\\F07EA";
}

.mdi-rickshaw::before {
  content: "\\F15BB";
}

.mdi-rickshaw-electric::before {
  content: "\\F15BC";
}

.mdi-ring::before {
  content: "\\F07EB";
}

.mdi-rivet::before {
  content: "\\F0E60";
}

.mdi-road::before {
  content: "\\F0461";
}

.mdi-road-variant::before {
  content: "\\F0462";
}

.mdi-robber::before {
  content: "\\F1058";
}

.mdi-robot::before {
  content: "\\F06A9";
}

.mdi-robot-angry::before {
  content: "\\F169D";
}

.mdi-robot-angry-outline::before {
  content: "\\F169E";
}

.mdi-robot-confused::before {
  content: "\\F169F";
}

.mdi-robot-confused-outline::before {
  content: "\\F16A0";
}

.mdi-robot-dead::before {
  content: "\\F16A1";
}

.mdi-robot-dead-outline::before {
  content: "\\F16A2";
}

.mdi-robot-excited::before {
  content: "\\F16A3";
}

.mdi-robot-excited-outline::before {
  content: "\\F16A4";
}

.mdi-robot-happy::before {
  content: "\\F1719";
}

.mdi-robot-happy-outline::before {
  content: "\\F171A";
}

.mdi-robot-industrial::before {
  content: "\\F0B46";
}

.mdi-robot-industrial-outline::before {
  content: "\\F1A1A";
}

.mdi-robot-love::before {
  content: "\\F16A5";
}

.mdi-robot-love-outline::before {
  content: "\\F16A6";
}

.mdi-robot-mower::before {
  content: "\\F11F7";
}

.mdi-robot-mower-outline::before {
  content: "\\F11F3";
}

.mdi-robot-off::before {
  content: "\\F16A7";
}

.mdi-robot-off-outline::before {
  content: "\\F167B";
}

.mdi-robot-outline::before {
  content: "\\F167A";
}

.mdi-robot-vacuum::before {
  content: "\\F070D";
}

.mdi-robot-vacuum-alert::before {
  content: "\\F1B5D";
}

.mdi-robot-vacuum-off::before {
  content: "\\F1C01";
}

.mdi-robot-vacuum-variant::before {
  content: "\\F0908";
}

.mdi-robot-vacuum-variant-alert::before {
  content: "\\F1B5E";
}

.mdi-robot-vacuum-variant-off::before {
  content: "\\F1C02";
}

.mdi-rocket::before {
  content: "\\F0463";
}

.mdi-rocket-launch::before {
  content: "\\F14DE";
}

.mdi-rocket-launch-outline::before {
  content: "\\F14DF";
}

.mdi-rocket-outline::before {
  content: "\\F13AF";
}

.mdi-rodent::before {
  content: "\\F1327";
}

.mdi-roller-shade::before {
  content: "\\F1A6B";
}

.mdi-roller-shade-closed::before {
  content: "\\F1A6C";
}

.mdi-roller-skate::before {
  content: "\\F0D2B";
}

.mdi-roller-skate-off::before {
  content: "\\F0145";
}

.mdi-rollerblade::before {
  content: "\\F0D2C";
}

.mdi-rollerblade-off::before {
  content: "\\F002E";
}

.mdi-rollupjs::before {
  content: "\\F0BC0";
}

.mdi-rolodex::before {
  content: "\\F1AB9";
}

.mdi-rolodex-outline::before {
  content: "\\F1ABA";
}

.mdi-roman-numeral-1::before {
  content: "\\F1088";
}

.mdi-roman-numeral-10::before {
  content: "\\F1091";
}

.mdi-roman-numeral-2::before {
  content: "\\F1089";
}

.mdi-roman-numeral-3::before {
  content: "\\F108A";
}

.mdi-roman-numeral-4::before {
  content: "\\F108B";
}

.mdi-roman-numeral-5::before {
  content: "\\F108C";
}

.mdi-roman-numeral-6::before {
  content: "\\F108D";
}

.mdi-roman-numeral-7::before {
  content: "\\F108E";
}

.mdi-roman-numeral-8::before {
  content: "\\F108F";
}

.mdi-roman-numeral-9::before {
  content: "\\F1090";
}

.mdi-room-service::before {
  content: "\\F088D";
}

.mdi-room-service-outline::before {
  content: "\\F0D97";
}

.mdi-rotate-360::before {
  content: "\\F1999";
}

.mdi-rotate-3d::before {
  content: "\\F0EC7";
}

.mdi-rotate-3d-variant::before {
  content: "\\F0464";
}

.mdi-rotate-left::before {
  content: "\\F0465";
}

.mdi-rotate-left-variant::before {
  content: "\\F0466";
}

.mdi-rotate-orbit::before {
  content: "\\F0D98";
}

.mdi-rotate-right::before {
  content: "\\F0467";
}

.mdi-rotate-right-variant::before {
  content: "\\F0468";
}

.mdi-rounded-corner::before {
  content: "\\F0607";
}

.mdi-router::before {
  content: "\\F11E2";
}

.mdi-router-network::before {
  content: "\\F1087";
}

.mdi-router-network-wireless::before {
  content: "\\F1C97";
}

.mdi-router-wireless::before {
  content: "\\F0469";
}

.mdi-router-wireless-off::before {
  content: "\\F15A3";
}

.mdi-router-wireless-settings::before {
  content: "\\F0A69";
}

.mdi-routes::before {
  content: "\\F046A";
}

.mdi-routes-clock::before {
  content: "\\F1059";
}

.mdi-rowing::before {
  content: "\\F0608";
}

.mdi-rss::before {
  content: "\\F046B";
}

.mdi-rss-box::before {
  content: "\\F046C";
}

.mdi-rss-off::before {
  content: "\\F0F21";
}

.mdi-rug::before {
  content: "\\F1475";
}

.mdi-rugby::before {
  content: "\\F0D99";
}

.mdi-ruler::before {
  content: "\\F046D";
}

.mdi-ruler-square::before {
  content: "\\F0CC2";
}

.mdi-ruler-square-compass::before {
  content: "\\F0EBE";
}

.mdi-run::before {
  content: "\\F070E";
}

.mdi-run-fast::before {
  content: "\\F046E";
}

.mdi-rv-truck::before {
  content: "\\F11D4";
}

.mdi-sack::before {
  content: "\\F0D2E";
}

.mdi-sack-outline::before {
  content: "\\F1C4C";
}

.mdi-sack-percent::before {
  content: "\\F0D2F";
}

.mdi-safe::before {
  content: "\\F0A6A";
}

.mdi-safe-square::before {
  content: "\\F127C";
}

.mdi-safe-square-outline::before {
  content: "\\F127D";
}

.mdi-safety-goggles::before {
  content: "\\F0D30";
}

.mdi-sail-boat::before {
  content: "\\F0EC8";
}

.mdi-sail-boat-sink::before {
  content: "\\F1AEF";
}

.mdi-sale::before {
  content: "\\F046F";
}

.mdi-sale-outline::before {
  content: "\\F1A06";
}

.mdi-salesforce::before {
  content: "\\F088E";
}

.mdi-sass::before {
  content: "\\F07EC";
}

.mdi-satellite::before {
  content: "\\F0470";
}

.mdi-satellite-uplink::before {
  content: "\\F0909";
}

.mdi-satellite-variant::before {
  content: "\\F0471";
}

.mdi-sausage::before {
  content: "\\F08BA";
}

.mdi-sausage-off::before {
  content: "\\F1789";
}

.mdi-saw-blade::before {
  content: "\\F0E61";
}

.mdi-sawtooth-wave::before {
  content: "\\F147A";
}

.mdi-saxophone::before {
  content: "\\F0609";
}

.mdi-scale::before {
  content: "\\F0472";
}

.mdi-scale-balance::before {
  content: "\\F05D1";
}

.mdi-scale-bathroom::before {
  content: "\\F0473";
}

.mdi-scale-off::before {
  content: "\\F105A";
}

.mdi-scale-unbalanced::before {
  content: "\\F19B8";
}

.mdi-scan-helper::before {
  content: "\\F13D8";
}

.mdi-scanner::before {
  content: "\\F06AB";
}

.mdi-scanner-off::before {
  content: "\\F090A";
}

.mdi-scatter-plot::before {
  content: "\\F0EC9";
}

.mdi-scatter-plot-outline::before {
  content: "\\F0ECA";
}

.mdi-scent::before {
  content: "\\F1958";
}

.mdi-scent-off::before {
  content: "\\F1959";
}

.mdi-school::before {
  content: "\\F0474";
}

.mdi-school-outline::before {
  content: "\\F1180";
}

.mdi-scissors-cutting::before {
  content: "\\F0A6B";
}

.mdi-scooter::before {
  content: "\\F15BD";
}

.mdi-scooter-electric::before {
  content: "\\F15BE";
}

.mdi-scoreboard::before {
  content: "\\F127E";
}

.mdi-scoreboard-outline::before {
  content: "\\F127F";
}

.mdi-screen-rotation::before {
  content: "\\F0475";
}

.mdi-screen-rotation-lock::before {
  content: "\\F0478";
}

.mdi-screw-flat-top::before {
  content: "\\F0DF3";
}

.mdi-screw-lag::before {
  content: "\\F0DF4";
}

.mdi-screw-machine-flat-top::before {
  content: "\\F0DF5";
}

.mdi-screw-machine-round-top::before {
  content: "\\F0DF6";
}

.mdi-screw-round-top::before {
  content: "\\F0DF7";
}

.mdi-screwdriver::before {
  content: "\\F0476";
}

.mdi-script::before {
  content: "\\F0BC1";
}

.mdi-script-outline::before {
  content: "\\F0477";
}

.mdi-script-text::before {
  content: "\\F0BC2";
}

.mdi-script-text-key::before {
  content: "\\F1725";
}

.mdi-script-text-key-outline::before {
  content: "\\F1726";
}

.mdi-script-text-outline::before {
  content: "\\F0BC3";
}

.mdi-script-text-play::before {
  content: "\\F1727";
}

.mdi-script-text-play-outline::before {
  content: "\\F1728";
}

.mdi-sd::before {
  content: "\\F0479";
}

.mdi-seal::before {
  content: "\\F047A";
}

.mdi-seal-variant::before {
  content: "\\F0FD9";
}

.mdi-search-web::before {
  content: "\\F070F";
}

.mdi-seat::before {
  content: "\\F0CC3";
}

.mdi-seat-flat::before {
  content: "\\F047B";
}

.mdi-seat-flat-angled::before {
  content: "\\F047C";
}

.mdi-seat-individual-suite::before {
  content: "\\F047D";
}

.mdi-seat-legroom-extra::before {
  content: "\\F047E";
}

.mdi-seat-legroom-normal::before {
  content: "\\F047F";
}

.mdi-seat-legroom-reduced::before {
  content: "\\F0480";
}

.mdi-seat-outline::before {
  content: "\\F0CC4";
}

.mdi-seat-passenger::before {
  content: "\\F1249";
}

.mdi-seat-recline-extra::before {
  content: "\\F0481";
}

.mdi-seat-recline-normal::before {
  content: "\\F0482";
}

.mdi-seatbelt::before {
  content: "\\F0CC5";
}

.mdi-security::before {
  content: "\\F0483";
}

.mdi-security-network::before {
  content: "\\F0484";
}

.mdi-seed::before {
  content: "\\F0E62";
}

.mdi-seed-off::before {
  content: "\\F13FD";
}

.mdi-seed-off-outline::before {
  content: "\\F13FE";
}

.mdi-seed-outline::before {
  content: "\\F0E63";
}

.mdi-seed-plus::before {
  content: "\\F1A6D";
}

.mdi-seed-plus-outline::before {
  content: "\\F1A6E";
}

.mdi-seesaw::before {
  content: "\\F15A4";
}

.mdi-segment::before {
  content: "\\F0ECB";
}

.mdi-select::before {
  content: "\\F0485";
}

.mdi-select-all::before {
  content: "\\F0486";
}

.mdi-select-arrow-down::before {
  content: "\\F1B59";
}

.mdi-select-arrow-up::before {
  content: "\\F1B58";
}

.mdi-select-color::before {
  content: "\\F0D31";
}

.mdi-select-compare::before {
  content: "\\F0AD9";
}

.mdi-select-drag::before {
  content: "\\F0A6C";
}

.mdi-select-group::before {
  content: "\\F0F82";
}

.mdi-select-inverse::before {
  content: "\\F0487";
}

.mdi-select-marker::before {
  content: "\\F1280";
}

.mdi-select-multiple::before {
  content: "\\F1281";
}

.mdi-select-multiple-marker::before {
  content: "\\F1282";
}

.mdi-select-off::before {
  content: "\\F0488";
}

.mdi-select-place::before {
  content: "\\F0FDA";
}

.mdi-select-remove::before {
  content: "\\F17C1";
}

.mdi-select-search::before {
  content: "\\F1204";
}

.mdi-selection::before {
  content: "\\F0489";
}

.mdi-selection-drag::before {
  content: "\\F0A6D";
}

.mdi-selection-ellipse::before {
  content: "\\F0D32";
}

.mdi-selection-ellipse-arrow-inside::before {
  content: "\\F0F22";
}

.mdi-selection-ellipse-remove::before {
  content: "\\F17C2";
}

.mdi-selection-marker::before {
  content: "\\F1283";
}

.mdi-selection-multiple::before {
  content: "\\F1285";
}

.mdi-selection-multiple-marker::before {
  content: "\\F1284";
}

.mdi-selection-off::before {
  content: "\\F0777";
}

.mdi-selection-remove::before {
  content: "\\F17C3";
}

.mdi-selection-search::before {
  content: "\\F1205";
}

.mdi-semantic-web::before {
  content: "\\F1316";
}

.mdi-send::before {
  content: "\\F048A";
}

.mdi-send-check::before {
  content: "\\F1161";
}

.mdi-send-check-outline::before {
  content: "\\F1162";
}

.mdi-send-circle::before {
  content: "\\F0DF8";
}

.mdi-send-circle-outline::before {
  content: "\\F0DF9";
}

.mdi-send-clock::before {
  content: "\\F1163";
}

.mdi-send-clock-outline::before {
  content: "\\F1164";
}

.mdi-send-lock::before {
  content: "\\F07ED";
}

.mdi-send-lock-outline::before {
  content: "\\F1166";
}

.mdi-send-outline::before {
  content: "\\F1165";
}

.mdi-send-variant::before {
  content: "\\F1C4D";
}

.mdi-send-variant-clock::before {
  content: "\\F1C7E";
}

.mdi-send-variant-clock-outline::before {
  content: "\\F1C7F";
}

.mdi-send-variant-outline::before {
  content: "\\F1C4E";
}

.mdi-serial-port::before {
  content: "\\F065C";
}

.mdi-server::before {
  content: "\\F048B";
}

.mdi-server-minus::before {
  content: "\\F048C";
}

.mdi-server-minus-outline::before {
  content: "\\F1C98";
}

.mdi-server-network::before {
  content: "\\F048D";
}

.mdi-server-network-off::before {
  content: "\\F048E";
}

.mdi-server-network-outline::before {
  content: "\\F1C99";
}

.mdi-server-off::before {
  content: "\\F048F";
}

.mdi-server-outline::before {
  content: "\\F1C9A";
}

.mdi-server-plus::before {
  content: "\\F0490";
}

.mdi-server-plus-outline::before {
  content: "\\F1C9B";
}

.mdi-server-remove::before {
  content: "\\F0491";
}

.mdi-server-security::before {
  content: "\\F0492";
}

.mdi-set-all::before {
  content: "\\F0778";
}

.mdi-set-center::before {
  content: "\\F0779";
}

.mdi-set-center-right::before {
  content: "\\F077A";
}

.mdi-set-left::before {
  content: "\\F077B";
}

.mdi-set-left-center::before {
  content: "\\F077C";
}

.mdi-set-left-right::before {
  content: "\\F077D";
}

.mdi-set-merge::before {
  content: "\\F14E0";
}

.mdi-set-none::before {
  content: "\\F077E";
}

.mdi-set-right::before {
  content: "\\F077F";
}

.mdi-set-split::before {
  content: "\\F14E1";
}

.mdi-set-square::before {
  content: "\\F145D";
}

.mdi-set-top-box::before {
  content: "\\F099F";
}

.mdi-settings-helper::before {
  content: "\\F0A6E";
}

.mdi-shaker::before {
  content: "\\F110E";
}

.mdi-shaker-outline::before {
  content: "\\F110F";
}

.mdi-shape::before {
  content: "\\F0831";
}

.mdi-shape-circle-plus::before {
  content: "\\F065D";
}

.mdi-shape-outline::before {
  content: "\\F0832";
}

.mdi-shape-oval-plus::before {
  content: "\\F11FA";
}

.mdi-shape-plus::before {
  content: "\\F0495";
}

.mdi-shape-plus-outline::before {
  content: "\\F1C4F";
}

.mdi-shape-polygon-plus::before {
  content: "\\F065E";
}

.mdi-shape-rectangle-plus::before {
  content: "\\F065F";
}

.mdi-shape-square-plus::before {
  content: "\\F0660";
}

.mdi-shape-square-rounded-plus::before {
  content: "\\F14FA";
}

.mdi-share::before {
  content: "\\F0496";
}

.mdi-share-all::before {
  content: "\\F11F4";
}

.mdi-share-all-outline::before {
  content: "\\F11F5";
}

.mdi-share-circle::before {
  content: "\\F11AD";
}

.mdi-share-off::before {
  content: "\\F0F23";
}

.mdi-share-off-outline::before {
  content: "\\F0F24";
}

.mdi-share-outline::before {
  content: "\\F0932";
}

.mdi-share-variant::before {
  content: "\\F0497";
}

.mdi-share-variant-outline::before {
  content: "\\F1514";
}

.mdi-shark::before {
  content: "\\F18BA";
}

.mdi-shark-fin::before {
  content: "\\F1673";
}

.mdi-shark-fin-outline::before {
  content: "\\F1674";
}

.mdi-shark-off::before {
  content: "\\F18BB";
}

.mdi-sheep::before {
  content: "\\F0CC6";
}

.mdi-shield::before {
  content: "\\F0498";
}

.mdi-shield-account::before {
  content: "\\F088F";
}

.mdi-shield-account-outline::before {
  content: "\\F0A12";
}

.mdi-shield-account-variant::before {
  content: "\\F15A7";
}

.mdi-shield-account-variant-outline::before {
  content: "\\F15A8";
}

.mdi-shield-airplane::before {
  content: "\\F06BB";
}

.mdi-shield-airplane-outline::before {
  content: "\\F0CC7";
}

.mdi-shield-alert::before {
  content: "\\F0ECC";
}

.mdi-shield-alert-outline::before {
  content: "\\F0ECD";
}

.mdi-shield-bug::before {
  content: "\\F13DA";
}

.mdi-shield-bug-outline::before {
  content: "\\F13DB";
}

.mdi-shield-car::before {
  content: "\\F0F83";
}

.mdi-shield-check::before {
  content: "\\F0565";
}

.mdi-shield-check-outline::before {
  content: "\\F0CC8";
}

.mdi-shield-cross::before {
  content: "\\F0CC9";
}

.mdi-shield-cross-outline::before {
  content: "\\F0CCA";
}

.mdi-shield-crown::before {
  content: "\\F18BC";
}

.mdi-shield-crown-outline::before {
  content: "\\F18BD";
}

.mdi-shield-edit::before {
  content: "\\F11A0";
}

.mdi-shield-edit-outline::before {
  content: "\\F11A1";
}

.mdi-shield-half::before {
  content: "\\F1360";
}

.mdi-shield-half-full::before {
  content: "\\F0780";
}

.mdi-shield-home::before {
  content: "\\F068A";
}

.mdi-shield-home-outline::before {
  content: "\\F0CCB";
}

.mdi-shield-key::before {
  content: "\\F0BC4";
}

.mdi-shield-key-outline::before {
  content: "\\F0BC5";
}

.mdi-shield-link-variant::before {
  content: "\\F0D33";
}

.mdi-shield-link-variant-outline::before {
  content: "\\F0D34";
}

.mdi-shield-lock::before {
  content: "\\F099D";
}

.mdi-shield-lock-open::before {
  content: "\\F199A";
}

.mdi-shield-lock-open-outline::before {
  content: "\\F199B";
}

.mdi-shield-lock-outline::before {
  content: "\\F0CCC";
}

.mdi-shield-moon::before {
  content: "\\F1828";
}

.mdi-shield-moon-outline::before {
  content: "\\F1829";
}

.mdi-shield-off::before {
  content: "\\F099E";
}

.mdi-shield-off-outline::before {
  content: "\\F099C";
}

.mdi-shield-outline::before {
  content: "\\F0499";
}

.mdi-shield-plus::before {
  content: "\\F0ADA";
}

.mdi-shield-plus-outline::before {
  content: "\\F0ADB";
}

.mdi-shield-refresh::before {
  content: "\\F00AA";
}

.mdi-shield-refresh-outline::before {
  content: "\\F01E0";
}

.mdi-shield-remove::before {
  content: "\\F0ADC";
}

.mdi-shield-remove-outline::before {
  content: "\\F0ADD";
}

.mdi-shield-search::before {
  content: "\\F0D9A";
}

.mdi-shield-star::before {
  content: "\\F113B";
}

.mdi-shield-star-outline::before {
  content: "\\F113C";
}

.mdi-shield-sun::before {
  content: "\\F105D";
}

.mdi-shield-sun-outline::before {
  content: "\\F105E";
}

.mdi-shield-sword::before {
  content: "\\F18BE";
}

.mdi-shield-sword-outline::before {
  content: "\\F18BF";
}

.mdi-shield-sync::before {
  content: "\\F11A2";
}

.mdi-shield-sync-outline::before {
  content: "\\F11A3";
}

.mdi-shimmer::before {
  content: "\\F1545";
}

.mdi-ship-wheel::before {
  content: "\\F0833";
}

.mdi-shipping-pallet::before {
  content: "\\F184E";
}

.mdi-shoe-ballet::before {
  content: "\\F15CA";
}

.mdi-shoe-cleat::before {
  content: "\\F15C7";
}

.mdi-shoe-formal::before {
  content: "\\F0B47";
}

.mdi-shoe-heel::before {
  content: "\\F0B48";
}

.mdi-shoe-print::before {
  content: "\\F0DFA";
}

.mdi-shoe-sneaker::before {
  content: "\\F15C8";
}

.mdi-shopping::before {
  content: "\\F049A";
}

.mdi-shopping-music::before {
  content: "\\F049B";
}

.mdi-shopping-outline::before {
  content: "\\F11D5";
}

.mdi-shopping-search::before {
  content: "\\F0F84";
}

.mdi-shopping-search-outline::before {
  content: "\\F1A6F";
}

.mdi-shore::before {
  content: "\\F14F9";
}

.mdi-shovel::before {
  content: "\\F0710";
}

.mdi-shovel-off::before {
  content: "\\F0711";
}

.mdi-shower::before {
  content: "\\F09A0";
}

.mdi-shower-head::before {
  content: "\\F09A1";
}

.mdi-shredder::before {
  content: "\\F049C";
}

.mdi-shuffle::before {
  content: "\\F049D";
}

.mdi-shuffle-disabled::before {
  content: "\\F049E";
}

.mdi-shuffle-variant::before {
  content: "\\F049F";
}

.mdi-shuriken::before {
  content: "\\F137F";
}

.mdi-sickle::before {
  content: "\\F18C0";
}

.mdi-sigma::before {
  content: "\\F04A0";
}

.mdi-sigma-lower::before {
  content: "\\F062B";
}

.mdi-sign-caution::before {
  content: "\\F04A1";
}

.mdi-sign-direction::before {
  content: "\\F0781";
}

.mdi-sign-direction-minus::before {
  content: "\\F1000";
}

.mdi-sign-direction-plus::before {
  content: "\\F0FDC";
}

.mdi-sign-direction-remove::before {
  content: "\\F0FDD";
}

.mdi-sign-language::before {
  content: "\\F1B4D";
}

.mdi-sign-language-outline::before {
  content: "\\F1B4E";
}

.mdi-sign-pole::before {
  content: "\\F14F8";
}

.mdi-sign-real-estate::before {
  content: "\\F1118";
}

.mdi-sign-text::before {
  content: "\\F0782";
}

.mdi-sign-yield::before {
  content: "\\F1BAF";
}

.mdi-signal::before {
  content: "\\F04A2";
}

.mdi-signal-2g::before {
  content: "\\F0712";
}

.mdi-signal-3g::before {
  content: "\\F0713";
}

.mdi-signal-4g::before {
  content: "\\F0714";
}

.mdi-signal-5g::before {
  content: "\\F0A6F";
}

.mdi-signal-cellular-1::before {
  content: "\\F08BC";
}

.mdi-signal-cellular-2::before {
  content: "\\F08BD";
}

.mdi-signal-cellular-3::before {
  content: "\\F08BE";
}

.mdi-signal-cellular-outline::before {
  content: "\\F08BF";
}

.mdi-signal-distance-variant::before {
  content: "\\F0E64";
}

.mdi-signal-hspa::before {
  content: "\\F0715";
}

.mdi-signal-hspa-plus::before {
  content: "\\F0716";
}

.mdi-signal-off::before {
  content: "\\F0783";
}

.mdi-signal-variant::before {
  content: "\\F060A";
}

.mdi-signature::before {
  content: "\\F0DFB";
}

.mdi-signature-freehand::before {
  content: "\\F0DFC";
}

.mdi-signature-image::before {
  content: "\\F0DFD";
}

.mdi-signature-text::before {
  content: "\\F0DFE";
}

.mdi-silo::before {
  content: "\\F1B9F";
}

.mdi-silo-outline::before {
  content: "\\F0B49";
}

.mdi-silverware::before {
  content: "\\F04A3";
}

.mdi-silverware-clean::before {
  content: "\\F0FDE";
}

.mdi-silverware-fork::before {
  content: "\\F04A4";
}

.mdi-silverware-fork-knife::before {
  content: "\\F0A70";
}

.mdi-silverware-spoon::before {
  content: "\\F04A5";
}

.mdi-silverware-variant::before {
  content: "\\F04A6";
}

.mdi-sim::before {
  content: "\\F04A7";
}

.mdi-sim-alert::before {
  content: "\\F04A8";
}

.mdi-sim-alert-outline::before {
  content: "\\F15D3";
}

.mdi-sim-off::before {
  content: "\\F04A9";
}

.mdi-sim-off-outline::before {
  content: "\\F15D4";
}

.mdi-sim-outline::before {
  content: "\\F15D5";
}

.mdi-simple-icons::before {
  content: "\\F131D";
}

.mdi-sina-weibo::before {
  content: "\\F0ADF";
}

.mdi-sine-wave::before {
  content: "\\F095B";
}

.mdi-sitemap::before {
  content: "\\F04AA";
}

.mdi-sitemap-outline::before {
  content: "\\F199C";
}

.mdi-size-l::before {
  content: "\\F13A6";
}

.mdi-size-m::before {
  content: "\\F13A5";
}

.mdi-size-s::before {
  content: "\\F13A4";
}

.mdi-size-xl::before {
  content: "\\F13A7";
}

.mdi-size-xs::before {
  content: "\\F13A3";
}

.mdi-size-xxl::before {
  content: "\\F13A8";
}

.mdi-size-xxs::before {
  content: "\\F13A2";
}

.mdi-size-xxxl::before {
  content: "\\F13A9";
}

.mdi-skate::before {
  content: "\\F0D35";
}

.mdi-skate-off::before {
  content: "\\F0699";
}

.mdi-skateboard::before {
  content: "\\F14C2";
}

.mdi-skateboarding::before {
  content: "\\F0501";
}

.mdi-skew-less::before {
  content: "\\F0D36";
}

.mdi-skew-more::before {
  content: "\\F0D37";
}

.mdi-ski::before {
  content: "\\F1304";
}

.mdi-ski-cross-country::before {
  content: "\\F1305";
}

.mdi-ski-water::before {
  content: "\\F1306";
}

.mdi-skip-backward::before {
  content: "\\F04AB";
}

.mdi-skip-backward-outline::before {
  content: "\\F0F25";
}

.mdi-skip-forward::before {
  content: "\\F04AC";
}

.mdi-skip-forward-outline::before {
  content: "\\F0F26";
}

.mdi-skip-next::before {
  content: "\\F04AD";
}

.mdi-skip-next-circle::before {
  content: "\\F0661";
}

.mdi-skip-next-circle-outline::before {
  content: "\\F0662";
}

.mdi-skip-next-outline::before {
  content: "\\F0F27";
}

.mdi-skip-previous::before {
  content: "\\F04AE";
}

.mdi-skip-previous-circle::before {
  content: "\\F0663";
}

.mdi-skip-previous-circle-outline::before {
  content: "\\F0664";
}

.mdi-skip-previous-outline::before {
  content: "\\F0F28";
}

.mdi-skull::before {
  content: "\\F068C";
}

.mdi-skull-crossbones::before {
  content: "\\F0BC6";
}

.mdi-skull-crossbones-outline::before {
  content: "\\F0BC7";
}

.mdi-skull-outline::before {
  content: "\\F0BC8";
}

.mdi-skull-scan::before {
  content: "\\F14C7";
}

.mdi-skull-scan-outline::before {
  content: "\\F14C8";
}

.mdi-skype::before {
  content: "\\F04AF";
}

.mdi-skype-business::before {
  content: "\\F04B0";
}

.mdi-slack::before {
  content: "\\F04B1";
}

.mdi-slash-forward::before {
  content: "\\F0FDF";
}

.mdi-slash-forward-box::before {
  content: "\\F0FE0";
}

.mdi-sledding::before {
  content: "\\F041B";
}

.mdi-sleep::before {
  content: "\\F04B2";
}

.mdi-sleep-off::before {
  content: "\\F04B3";
}

.mdi-slide::before {
  content: "\\F15A5";
}

.mdi-slope-downhill::before {
  content: "\\F0DFF";
}

.mdi-slope-uphill::before {
  content: "\\F0E00";
}

.mdi-slot-machine::before {
  content: "\\F1114";
}

.mdi-slot-machine-outline::before {
  content: "\\F1115";
}

.mdi-smart-card::before {
  content: "\\F10BD";
}

.mdi-smart-card-off::before {
  content: "\\F18F7";
}

.mdi-smart-card-off-outline::before {
  content: "\\F18F8";
}

.mdi-smart-card-outline::before {
  content: "\\F10BE";
}

.mdi-smart-card-reader::before {
  content: "\\F10BF";
}

.mdi-smart-card-reader-outline::before {
  content: "\\F10C0";
}

.mdi-smog::before {
  content: "\\F0A71";
}

.mdi-smoke::before {
  content: "\\F1799";
}

.mdi-smoke-detector::before {
  content: "\\F0392";
}

.mdi-smoke-detector-alert::before {
  content: "\\F192E";
}

.mdi-smoke-detector-alert-outline::before {
  content: "\\F192F";
}

.mdi-smoke-detector-off::before {
  content: "\\F1809";
}

.mdi-smoke-detector-off-outline::before {
  content: "\\F180A";
}

.mdi-smoke-detector-outline::before {
  content: "\\F1808";
}

.mdi-smoke-detector-variant::before {
  content: "\\F180B";
}

.mdi-smoke-detector-variant-alert::before {
  content: "\\F1930";
}

.mdi-smoke-detector-variant-off::before {
  content: "\\F180C";
}

.mdi-smoking::before {
  content: "\\F04B4";
}

.mdi-smoking-off::before {
  content: "\\F04B5";
}

.mdi-smoking-pipe::before {
  content: "\\F140D";
}

.mdi-smoking-pipe-off::before {
  content: "\\F1428";
}

.mdi-snail::before {
  content: "\\F1677";
}

.mdi-snake::before {
  content: "\\F150E";
}

.mdi-snapchat::before {
  content: "\\F04B6";
}

.mdi-snowboard::before {
  content: "\\F1307";
}

.mdi-snowflake::before {
  content: "\\F0717";
}

.mdi-snowflake-alert::before {
  content: "\\F0F29";
}

.mdi-snowflake-check::before {
  content: "\\F1A70";
}

.mdi-snowflake-melt::before {
  content: "\\F12CB";
}

.mdi-snowflake-off::before {
  content: "\\F14E3";
}

.mdi-snowflake-thermometer::before {
  content: "\\F1A71";
}

.mdi-snowflake-variant::before {
  content: "\\F0F2A";
}

.mdi-snowman::before {
  content: "\\F04B7";
}

.mdi-snowmobile::before {
  content: "\\F06DD";
}

.mdi-snowshoeing::before {
  content: "\\F1A72";
}

.mdi-soccer::before {
  content: "\\F04B8";
}

.mdi-soccer-field::before {
  content: "\\F0834";
}

.mdi-social-distance-2-meters::before {
  content: "\\F1579";
}

.mdi-social-distance-6-feet::before {
  content: "\\F157A";
}

.mdi-sofa::before {
  content: "\\F04B9";
}

.mdi-sofa-outline::before {
  content: "\\F156D";
}

.mdi-sofa-single::before {
  content: "\\F156E";
}

.mdi-sofa-single-outline::before {
  content: "\\F156F";
}

.mdi-solar-panel::before {
  content: "\\F0D9B";
}

.mdi-solar-panel-large::before {
  content: "\\F0D9C";
}

.mdi-solar-power::before {
  content: "\\F0A72";
}

.mdi-solar-power-variant::before {
  content: "\\F1A73";
}

.mdi-solar-power-variant-outline::before {
  content: "\\F1A74";
}

.mdi-soldering-iron::before {
  content: "\\F1092";
}

.mdi-solid::before {
  content: "\\F068D";
}

.mdi-sony-playstation::before {
  content: "\\F0414";
}

.mdi-sort::before {
  content: "\\F04BA";
}

.mdi-sort-alphabetical-ascending::before {
  content: "\\F05BD";
}

.mdi-sort-alphabetical-ascending-variant::before {
  content: "\\F1148";
}

.mdi-sort-alphabetical-descending::before {
  content: "\\F05BF";
}

.mdi-sort-alphabetical-descending-variant::before {
  content: "\\F1149";
}

.mdi-sort-alphabetical-variant::before {
  content: "\\F04BB";
}

.mdi-sort-ascending::before {
  content: "\\F04BC";
}

.mdi-sort-bool-ascending::before {
  content: "\\F1385";
}

.mdi-sort-bool-ascending-variant::before {
  content: "\\F1386";
}

.mdi-sort-bool-descending::before {
  content: "\\F1387";
}

.mdi-sort-bool-descending-variant::before {
  content: "\\F1388";
}

.mdi-sort-calendar-ascending::before {
  content: "\\F1547";
}

.mdi-sort-calendar-descending::before {
  content: "\\F1548";
}

.mdi-sort-clock-ascending::before {
  content: "\\F1549";
}

.mdi-sort-clock-ascending-outline::before {
  content: "\\F154A";
}

.mdi-sort-clock-descending::before {
  content: "\\F154B";
}

.mdi-sort-clock-descending-outline::before {
  content: "\\F154C";
}

.mdi-sort-descending::before {
  content: "\\F04BD";
}

.mdi-sort-numeric-ascending::before {
  content: "\\F1389";
}

.mdi-sort-numeric-ascending-variant::before {
  content: "\\F090D";
}

.mdi-sort-numeric-descending::before {
  content: "\\F138A";
}

.mdi-sort-numeric-descending-variant::before {
  content: "\\F0AD2";
}

.mdi-sort-numeric-variant::before {
  content: "\\F04BE";
}

.mdi-sort-reverse-variant::before {
  content: "\\F033C";
}

.mdi-sort-variant::before {
  content: "\\F04BF";
}

.mdi-sort-variant-lock::before {
  content: "\\F0CCD";
}

.mdi-sort-variant-lock-open::before {
  content: "\\F0CCE";
}

.mdi-sort-variant-off::before {
  content: "\\F1ABB";
}

.mdi-sort-variant-remove::before {
  content: "\\F1147";
}

.mdi-soundbar::before {
  content: "\\F17DB";
}

.mdi-soundcloud::before {
  content: "\\F04C0";
}

.mdi-source-branch::before {
  content: "\\F062C";
}

.mdi-source-branch-check::before {
  content: "\\F14CF";
}

.mdi-source-branch-minus::before {
  content: "\\F14CB";
}

.mdi-source-branch-plus::before {
  content: "\\F14CA";
}

.mdi-source-branch-refresh::before {
  content: "\\F14CD";
}

.mdi-source-branch-remove::before {
  content: "\\F14CC";
}

.mdi-source-branch-sync::before {
  content: "\\F14CE";
}

.mdi-source-commit::before {
  content: "\\F0718";
}

.mdi-source-commit-end::before {
  content: "\\F0719";
}

.mdi-source-commit-end-local::before {
  content: "\\F071A";
}

.mdi-source-commit-local::before {
  content: "\\F071B";
}

.mdi-source-commit-next-local::before {
  content: "\\F071C";
}

.mdi-source-commit-start::before {
  content: "\\F071D";
}

.mdi-source-commit-start-next-local::before {
  content: "\\F071E";
}

.mdi-source-fork::before {
  content: "\\F04C1";
}

.mdi-source-merge::before {
  content: "\\F062D";
}

.mdi-source-pull::before {
  content: "\\F04C2";
}

.mdi-source-repository::before {
  content: "\\F0CCF";
}

.mdi-source-repository-multiple::before {
  content: "\\F0CD0";
}

.mdi-soy-sauce::before {
  content: "\\F07EE";
}

.mdi-soy-sauce-off::before {
  content: "\\F13FC";
}

.mdi-spa::before {
  content: "\\F0CD1";
}

.mdi-spa-outline::before {
  content: "\\F0CD2";
}

.mdi-space-invaders::before {
  content: "\\F0BC9";
}

.mdi-space-station::before {
  content: "\\F1383";
}

.mdi-spade::before {
  content: "\\F0E65";
}

.mdi-speaker::before {
  content: "\\F04C3";
}

.mdi-speaker-bluetooth::before {
  content: "\\F09A2";
}

.mdi-speaker-message::before {
  content: "\\F1B11";
}

.mdi-speaker-multiple::before {
  content: "\\F0D38";
}

.mdi-speaker-off::before {
  content: "\\F04C4";
}

.mdi-speaker-pause::before {
  content: "\\F1B73";
}

.mdi-speaker-play::before {
  content: "\\F1B72";
}

.mdi-speaker-stop::before {
  content: "\\F1B74";
}

.mdi-speaker-wireless::before {
  content: "\\F071F";
}

.mdi-spear::before {
  content: "\\F1845";
}

.mdi-speedometer::before {
  content: "\\F04C5";
}

.mdi-speedometer-medium::before {
  content: "\\F0F85";
}

.mdi-speedometer-slow::before {
  content: "\\F0F86";
}

.mdi-spellcheck::before {
  content: "\\F04C6";
}

.mdi-sphere::before {
  content: "\\F1954";
}

.mdi-sphere-off::before {
  content: "\\F1955";
}

.mdi-spider::before {
  content: "\\F11EA";
}

.mdi-spider-outline::before {
  content: "\\F1C75";
}

.mdi-spider-thread::before {
  content: "\\F11EB";
}

.mdi-spider-web::before {
  content: "\\F0BCA";
}

.mdi-spirit-level::before {
  content: "\\F14F1";
}

.mdi-spoon-sugar::before {
  content: "\\F1429";
}

.mdi-spotify::before {
  content: "\\F04C7";
}

.mdi-spotlight::before {
  content: "\\F04C8";
}

.mdi-spotlight-beam::before {
  content: "\\F04C9";
}

.mdi-spray::before {
  content: "\\F0665";
}

.mdi-spray-bottle::before {
  content: "\\F0AE0";
}

.mdi-sprinkler::before {
  content: "\\F105F";
}

.mdi-sprinkler-fire::before {
  content: "\\F199D";
}

.mdi-sprinkler-variant::before {
  content: "\\F1060";
}

.mdi-sprout::before {
  content: "\\F0E66";
}

.mdi-sprout-outline::before {
  content: "\\F0E67";
}

.mdi-square::before {
  content: "\\F0764";
}

.mdi-square-circle::before {
  content: "\\F1500";
}

.mdi-square-circle-outline::before {
  content: "\\F1C50";
}

.mdi-square-edit-outline::before {
  content: "\\F090C";
}

.mdi-square-medium::before {
  content: "\\F0A13";
}

.mdi-square-medium-outline::before {
  content: "\\F0A14";
}

.mdi-square-off::before {
  content: "\\F12EE";
}

.mdi-square-off-outline::before {
  content: "\\F12EF";
}

.mdi-square-opacity::before {
  content: "\\F1854";
}

.mdi-square-outline::before {
  content: "\\F0763";
}

.mdi-square-root::before {
  content: "\\F0784";
}

.mdi-square-root-box::before {
  content: "\\F09A3";
}

.mdi-square-rounded::before {
  content: "\\F14FB";
}

.mdi-square-rounded-badge::before {
  content: "\\F1A07";
}

.mdi-square-rounded-badge-outline::before {
  content: "\\F1A08";
}

.mdi-square-rounded-outline::before {
  content: "\\F14FC";
}

.mdi-square-small::before {
  content: "\\F0A15";
}

.mdi-square-wave::before {
  content: "\\F147B";
}

.mdi-squeegee::before {
  content: "\\F0AE1";
}

.mdi-ssh::before {
  content: "\\F08C0";
}

.mdi-stack-exchange::before {
  content: "\\F060B";
}

.mdi-stack-overflow::before {
  content: "\\F04CC";
}

.mdi-stackpath::before {
  content: "\\F0359";
}

.mdi-stadium::before {
  content: "\\F0FF9";
}

.mdi-stadium-outline::before {
  content: "\\F1B03";
}

.mdi-stadium-variant::before {
  content: "\\F0720";
}

.mdi-stairs::before {
  content: "\\F04CD";
}

.mdi-stairs-box::before {
  content: "\\F139E";
}

.mdi-stairs-down::before {
  content: "\\F12BE";
}

.mdi-stairs-up::before {
  content: "\\F12BD";
}

.mdi-stamper::before {
  content: "\\F0D39";
}

.mdi-standard-definition::before {
  content: "\\F07EF";
}

.mdi-star::before {
  content: "\\F04CE";
}

.mdi-star-box::before {
  content: "\\F0A73";
}

.mdi-star-box-multiple::before {
  content: "\\F1286";
}

.mdi-star-box-multiple-outline::before {
  content: "\\F1287";
}

.mdi-star-box-outline::before {
  content: "\\F0A74";
}

.mdi-star-check::before {
  content: "\\F1566";
}

.mdi-star-check-outline::before {
  content: "\\F156A";
}

.mdi-star-circle::before {
  content: "\\F04CF";
}

.mdi-star-circle-outline::before {
  content: "\\F09A4";
}

.mdi-star-cog::before {
  content: "\\F1668";
}

.mdi-star-cog-outline::before {
  content: "\\F1669";
}

.mdi-star-crescent::before {
  content: "\\F0979";
}

.mdi-star-david::before {
  content: "\\F097A";
}

.mdi-star-face::before {
  content: "\\F09A5";
}

.mdi-star-four-points::before {
  content: "\\F0AE2";
}

.mdi-star-four-points-box::before {
  content: "\\F1C51";
}

.mdi-star-four-points-box-outline::before {
  content: "\\F1C52";
}

.mdi-star-four-points-circle::before {
  content: "\\F1C53";
}

.mdi-star-four-points-circle-outline::before {
  content: "\\F1C54";
}

.mdi-star-four-points-outline::before {
  content: "\\F0AE3";
}

.mdi-star-four-points-small::before {
  content: "\\F1C55";
}

.mdi-star-half::before {
  content: "\\F0246";
}

.mdi-star-half-full::before {
  content: "\\F04D0";
}

.mdi-star-minus::before {
  content: "\\F1564";
}

.mdi-star-minus-outline::before {
  content: "\\F1568";
}

.mdi-star-off::before {
  content: "\\F04D1";
}

.mdi-star-off-outline::before {
  content: "\\F155B";
}

.mdi-star-outline::before {
  content: "\\F04D2";
}

.mdi-star-plus::before {
  content: "\\F1563";
}

.mdi-star-plus-outline::before {
  content: "\\F1567";
}

.mdi-star-remove::before {
  content: "\\F1565";
}

.mdi-star-remove-outline::before {
  content: "\\F1569";
}

.mdi-star-settings::before {
  content: "\\F166A";
}

.mdi-star-settings-outline::before {
  content: "\\F166B";
}

.mdi-star-shooting::before {
  content: "\\F1741";
}

.mdi-star-shooting-outline::before {
  content: "\\F1742";
}

.mdi-star-three-points::before {
  content: "\\F0AE4";
}

.mdi-star-three-points-outline::before {
  content: "\\F0AE5";
}

.mdi-state-machine::before {
  content: "\\F11EF";
}

.mdi-steam::before {
  content: "\\F04D3";
}

.mdi-steering::before {
  content: "\\F04D4";
}

.mdi-steering-off::before {
  content: "\\F090E";
}

.mdi-step-backward::before {
  content: "\\F04D5";
}

.mdi-step-backward-2::before {
  content: "\\F04D6";
}

.mdi-step-forward::before {
  content: "\\F04D7";
}

.mdi-step-forward-2::before {
  content: "\\F04D8";
}

.mdi-stethoscope::before {
  content: "\\F04D9";
}

.mdi-sticker::before {
  content: "\\F1364";
}

.mdi-sticker-alert::before {
  content: "\\F1365";
}

.mdi-sticker-alert-outline::before {
  content: "\\F1366";
}

.mdi-sticker-check::before {
  content: "\\F1367";
}

.mdi-sticker-check-outline::before {
  content: "\\F1368";
}

.mdi-sticker-circle-outline::before {
  content: "\\F05D0";
}

.mdi-sticker-emoji::before {
  content: "\\F0785";
}

.mdi-sticker-minus::before {
  content: "\\F1369";
}

.mdi-sticker-minus-outline::before {
  content: "\\F136A";
}

.mdi-sticker-outline::before {
  content: "\\F136B";
}

.mdi-sticker-plus::before {
  content: "\\F136C";
}

.mdi-sticker-plus-outline::before {
  content: "\\F136D";
}

.mdi-sticker-remove::before {
  content: "\\F136E";
}

.mdi-sticker-remove-outline::before {
  content: "\\F136F";
}

.mdi-sticker-text::before {
  content: "\\F178E";
}

.mdi-sticker-text-outline::before {
  content: "\\F178F";
}

.mdi-stocking::before {
  content: "\\F04DA";
}

.mdi-stomach::before {
  content: "\\F1093";
}

.mdi-stool::before {
  content: "\\F195D";
}

.mdi-stool-outline::before {
  content: "\\F195E";
}

.mdi-stop::before {
  content: "\\F04DB";
}

.mdi-stop-circle::before {
  content: "\\F0666";
}

.mdi-stop-circle-outline::before {
  content: "\\F0667";
}

.mdi-storage-tank::before {
  content: "\\F1A75";
}

.mdi-storage-tank-outline::before {
  content: "\\F1A76";
}

.mdi-store::before {
  content: "\\F04DC";
}

.mdi-store-24-hour::before {
  content: "\\F04DD";
}

.mdi-store-alert::before {
  content: "\\F18C1";
}

.mdi-store-alert-outline::before {
  content: "\\F18C2";
}

.mdi-store-check::before {
  content: "\\F18C3";
}

.mdi-store-check-outline::before {
  content: "\\F18C4";
}

.mdi-store-clock::before {
  content: "\\F18C5";
}

.mdi-store-clock-outline::before {
  content: "\\F18C6";
}

.mdi-store-cog::before {
  content: "\\F18C7";
}

.mdi-store-cog-outline::before {
  content: "\\F18C8";
}

.mdi-store-edit::before {
  content: "\\F18C9";
}

.mdi-store-edit-outline::before {
  content: "\\F18CA";
}

.mdi-store-marker::before {
  content: "\\F18CB";
}

.mdi-store-marker-outline::before {
  content: "\\F18CC";
}

.mdi-store-minus::before {
  content: "\\F165E";
}

.mdi-store-minus-outline::before {
  content: "\\F18CD";
}

.mdi-store-off::before {
  content: "\\F18CE";
}

.mdi-store-off-outline::before {
  content: "\\F18CF";
}

.mdi-store-outline::before {
  content: "\\F1361";
}

.mdi-store-plus::before {
  content: "\\F165F";
}

.mdi-store-plus-outline::before {
  content: "\\F18D0";
}

.mdi-store-remove::before {
  content: "\\F1660";
}

.mdi-store-remove-outline::before {
  content: "\\F18D1";
}

.mdi-store-search::before {
  content: "\\F18D2";
}

.mdi-store-search-outline::before {
  content: "\\F18D3";
}

.mdi-store-settings::before {
  content: "\\F18D4";
}

.mdi-store-settings-outline::before {
  content: "\\F18D5";
}

.mdi-storefront::before {
  content: "\\F07C7";
}

.mdi-storefront-check::before {
  content: "\\F1B7D";
}

.mdi-storefront-check-outline::before {
  content: "\\F1B7E";
}

.mdi-storefront-edit::before {
  content: "\\F1B7F";
}

.mdi-storefront-edit-outline::before {
  content: "\\F1B80";
}

.mdi-storefront-minus::before {
  content: "\\F1B83";
}

.mdi-storefront-minus-outline::before {
  content: "\\F1B84";
}

.mdi-storefront-outline::before {
  content: "\\F10C1";
}

.mdi-storefront-plus::before {
  content: "\\F1B81";
}

.mdi-storefront-plus-outline::before {
  content: "\\F1B82";
}

.mdi-storefront-remove::before {
  content: "\\F1B85";
}

.mdi-storefront-remove-outline::before {
  content: "\\F1B86";
}

.mdi-stove::before {
  content: "\\F04DE";
}

.mdi-strategy::before {
  content: "\\F11D6";
}

.mdi-stretch-to-page::before {
  content: "\\F0F2B";
}

.mdi-stretch-to-page-outline::before {
  content: "\\F0F2C";
}

.mdi-string-lights::before {
  content: "\\F12BA";
}

.mdi-string-lights-off::before {
  content: "\\F12BB";
}

.mdi-subdirectory-arrow-left::before {
  content: "\\F060C";
}

.mdi-subdirectory-arrow-right::before {
  content: "\\F060D";
}

.mdi-submarine::before {
  content: "\\F156C";
}

.mdi-subtitles::before {
  content: "\\F0A16";
}

.mdi-subtitles-outline::before {
  content: "\\F0A17";
}

.mdi-subway::before {
  content: "\\F06AC";
}

.mdi-subway-alert-variant::before {
  content: "\\F0D9D";
}

.mdi-subway-variant::before {
  content: "\\F04DF";
}

.mdi-summit::before {
  content: "\\F0786";
}

.mdi-sun-angle::before {
  content: "\\F1B27";
}

.mdi-sun-angle-outline::before {
  content: "\\F1B28";
}

.mdi-sun-clock::before {
  content: "\\F1A77";
}

.mdi-sun-clock-outline::before {
  content: "\\F1A78";
}

.mdi-sun-compass::before {
  content: "\\F19A5";
}

.mdi-sun-snowflake::before {
  content: "\\F1796";
}

.mdi-sun-snowflake-variant::before {
  content: "\\F1A79";
}

.mdi-sun-thermometer::before {
  content: "\\F18D6";
}

.mdi-sun-thermometer-outline::before {
  content: "\\F18D7";
}

.mdi-sun-wireless::before {
  content: "\\F17FE";
}

.mdi-sun-wireless-outline::before {
  content: "\\F17FF";
}

.mdi-sunglasses::before {
  content: "\\F04E0";
}

.mdi-surfing::before {
  content: "\\F1746";
}

.mdi-surround-sound::before {
  content: "\\F05C5";
}

.mdi-surround-sound-2-0::before {
  content: "\\F07F0";
}

.mdi-surround-sound-2-1::before {
  content: "\\F1729";
}

.mdi-surround-sound-3-1::before {
  content: "\\F07F1";
}

.mdi-surround-sound-5-1::before {
  content: "\\F07F2";
}

.mdi-surround-sound-5-1-2::before {
  content: "\\F172A";
}

.mdi-surround-sound-7-1::before {
  content: "\\F07F3";
}

.mdi-svg::before {
  content: "\\F0721";
}

.mdi-swap-horizontal::before {
  content: "\\F04E1";
}

.mdi-swap-horizontal-bold::before {
  content: "\\F0BCD";
}

.mdi-swap-horizontal-circle::before {
  content: "\\F0FE1";
}

.mdi-swap-horizontal-circle-outline::before {
  content: "\\F0FE2";
}

.mdi-swap-horizontal-hidden::before {
  content: "\\F1D0E";
}

.mdi-swap-horizontal-variant::before {
  content: "\\F08C1";
}

.mdi-swap-vertical::before {
  content: "\\F04E2";
}

.mdi-swap-vertical-bold::before {
  content: "\\F0BCE";
}

.mdi-swap-vertical-circle::before {
  content: "\\F0FE3";
}

.mdi-swap-vertical-circle-outline::before {
  content: "\\F0FE4";
}

.mdi-swap-vertical-variant::before {
  content: "\\F08C2";
}

.mdi-swim::before {
  content: "\\F04E3";
}

.mdi-switch::before {
  content: "\\F04E4";
}

.mdi-sword::before {
  content: "\\F04E5";
}

.mdi-sword-cross::before {
  content: "\\F0787";
}

.mdi-syllabary-hangul::before {
  content: "\\F1333";
}

.mdi-syllabary-hiragana::before {
  content: "\\F1334";
}

.mdi-syllabary-katakana::before {
  content: "\\F1335";
}

.mdi-syllabary-katakana-halfwidth::before {
  content: "\\F1336";
}

.mdi-symbol::before {
  content: "\\F1501";
}

.mdi-symfony::before {
  content: "\\F0AE6";
}

.mdi-synagogue::before {
  content: "\\F1B04";
}

.mdi-synagogue-outline::before {
  content: "\\F1B05";
}

.mdi-sync::before {
  content: "\\F04E6";
}

.mdi-sync-alert::before {
  content: "\\F04E7";
}

.mdi-sync-circle::before {
  content: "\\F1378";
}

.mdi-sync-off::before {
  content: "\\F04E8";
}

.mdi-tab::before {
  content: "\\F04E9";
}

.mdi-tab-minus::before {
  content: "\\F0B4B";
}

.mdi-tab-plus::before {
  content: "\\F075C";
}

.mdi-tab-remove::before {
  content: "\\F0B4C";
}

.mdi-tab-search::before {
  content: "\\F199E";
}

.mdi-tab-unselected::before {
  content: "\\F04EA";
}

.mdi-table::before {
  content: "\\F04EB";
}

.mdi-table-account::before {
  content: "\\F13B9";
}

.mdi-table-alert::before {
  content: "\\F13BA";
}

.mdi-table-arrow-down::before {
  content: "\\F13BB";
}

.mdi-table-arrow-left::before {
  content: "\\F13BC";
}

.mdi-table-arrow-right::before {
  content: "\\F13BD";
}

.mdi-table-arrow-up::before {
  content: "\\F13BE";
}

.mdi-table-border::before {
  content: "\\F0A18";
}

.mdi-table-cancel::before {
  content: "\\F13BF";
}

.mdi-table-chair::before {
  content: "\\F1061";
}

.mdi-table-check::before {
  content: "\\F13C0";
}

.mdi-table-clock::before {
  content: "\\F13C1";
}

.mdi-table-cog::before {
  content: "\\F13C2";
}

.mdi-table-column::before {
  content: "\\F0835";
}

.mdi-table-column-plus-after::before {
  content: "\\F04EC";
}

.mdi-table-column-plus-before::before {
  content: "\\F04ED";
}

.mdi-table-column-remove::before {
  content: "\\F04EE";
}

.mdi-table-column-width::before {
  content: "\\F04EF";
}

.mdi-table-edit::before {
  content: "\\F04F0";
}

.mdi-table-eye::before {
  content: "\\F1094";
}

.mdi-table-eye-off::before {
  content: "\\F13C3";
}

.mdi-table-filter::before {
  content: "\\F1B8C";
}

.mdi-table-furniture::before {
  content: "\\F05BC";
}

.mdi-table-headers-eye::before {
  content: "\\F121D";
}

.mdi-table-headers-eye-off::before {
  content: "\\F121E";
}

.mdi-table-heart::before {
  content: "\\F13C4";
}

.mdi-table-key::before {
  content: "\\F13C5";
}

.mdi-table-large::before {
  content: "\\F04F1";
}

.mdi-table-large-plus::before {
  content: "\\F0F87";
}

.mdi-table-large-remove::before {
  content: "\\F0F88";
}

.mdi-table-lock::before {
  content: "\\F13C6";
}

.mdi-table-merge-cells::before {
  content: "\\F09A6";
}

.mdi-table-minus::before {
  content: "\\F13C7";
}

.mdi-table-multiple::before {
  content: "\\F13C8";
}

.mdi-table-network::before {
  content: "\\F13C9";
}

.mdi-table-of-contents::before {
  content: "\\F0836";
}

.mdi-table-off::before {
  content: "\\F13CA";
}

.mdi-table-picnic::before {
  content: "\\F1743";
}

.mdi-table-pivot::before {
  content: "\\F183C";
}

.mdi-table-plus::before {
  content: "\\F0A75";
}

.mdi-table-question::before {
  content: "\\F1B21";
}

.mdi-table-refresh::before {
  content: "\\F13A0";
}

.mdi-table-remove::before {
  content: "\\F0A76";
}

.mdi-table-row::before {
  content: "\\F0837";
}

.mdi-table-row-height::before {
  content: "\\F04F2";
}

.mdi-table-row-plus-after::before {
  content: "\\F04F3";
}

.mdi-table-row-plus-before::before {
  content: "\\F04F4";
}

.mdi-table-row-remove::before {
  content: "\\F04F5";
}

.mdi-table-search::before {
  content: "\\F090F";
}

.mdi-table-settings::before {
  content: "\\F0838";
}

.mdi-table-split-cell::before {
  content: "\\F142A";
}

.mdi-table-star::before {
  content: "\\F13CB";
}

.mdi-table-sync::before {
  content: "\\F13A1";
}

.mdi-table-tennis::before {
  content: "\\F0E68";
}

.mdi-tablet::before {
  content: "\\F04F6";
}

.mdi-tablet-cellphone::before {
  content: "\\F09A7";
}

.mdi-tablet-dashboard::before {
  content: "\\F0ECE";
}

.mdi-taco::before {
  content: "\\F0762";
}

.mdi-tag::before {
  content: "\\F04F9";
}

.mdi-tag-arrow-down::before {
  content: "\\F172B";
}

.mdi-tag-arrow-down-outline::before {
  content: "\\F172C";
}

.mdi-tag-arrow-left::before {
  content: "\\F172D";
}

.mdi-tag-arrow-left-outline::before {
  content: "\\F172E";
}

.mdi-tag-arrow-right::before {
  content: "\\F172F";
}

.mdi-tag-arrow-right-outline::before {
  content: "\\F1730";
}

.mdi-tag-arrow-up::before {
  content: "\\F1731";
}

.mdi-tag-arrow-up-outline::before {
  content: "\\F1732";
}

.mdi-tag-check::before {
  content: "\\F1A7A";
}

.mdi-tag-check-outline::before {
  content: "\\F1A7B";
}

.mdi-tag-edit::before {
  content: "\\F1C9C";
}

.mdi-tag-edit-outline::before {
  content: "\\F1C9D";
}

.mdi-tag-faces::before {
  content: "\\F04FA";
}

.mdi-tag-heart::before {
  content: "\\F068B";
}

.mdi-tag-heart-outline::before {
  content: "\\F0BCF";
}

.mdi-tag-hidden::before {
  content: "\\F1C76";
}

.mdi-tag-minus::before {
  content: "\\F0910";
}

.mdi-tag-minus-outline::before {
  content: "\\F121F";
}

.mdi-tag-multiple::before {
  content: "\\F04FB";
}

.mdi-tag-multiple-outline::before {
  content: "\\F12F7";
}

.mdi-tag-off::before {
  content: "\\F1220";
}

.mdi-tag-off-outline::before {
  content: "\\F1221";
}

.mdi-tag-outline::before {
  content: "\\F04FC";
}

.mdi-tag-plus::before {
  content: "\\F0722";
}

.mdi-tag-plus-outline::before {
  content: "\\F1222";
}

.mdi-tag-remove::before {
  content: "\\F0723";
}

.mdi-tag-remove-outline::before {
  content: "\\F1223";
}

.mdi-tag-search::before {
  content: "\\F1907";
}

.mdi-tag-search-outline::before {
  content: "\\F1908";
}

.mdi-tag-text::before {
  content: "\\F1224";
}

.mdi-tag-text-outline::before {
  content: "\\F04FD";
}

.mdi-tailwind::before {
  content: "\\F13FF";
}

.mdi-tally-mark-1::before {
  content: "\\F1ABC";
}

.mdi-tally-mark-2::before {
  content: "\\F1ABD";
}

.mdi-tally-mark-3::before {
  content: "\\F1ABE";
}

.mdi-tally-mark-4::before {
  content: "\\F1ABF";
}

.mdi-tally-mark-5::before {
  content: "\\F1AC0";
}

.mdi-tangram::before {
  content: "\\F04F8";
}

.mdi-tank::before {
  content: "\\F0D3A";
}

.mdi-tanker-truck::before {
  content: "\\F0FE5";
}

.mdi-tape-drive::before {
  content: "\\F16DF";
}

.mdi-tape-measure::before {
  content: "\\F0B4D";
}

.mdi-target::before {
  content: "\\F04FE";
}

.mdi-target-account::before {
  content: "\\F0BD0";
}

.mdi-target-variant::before {
  content: "\\F0A77";
}

.mdi-taxi::before {
  content: "\\F04FF";
}

.mdi-tea::before {
  content: "\\F0D9E";
}

.mdi-tea-outline::before {
  content: "\\F0D9F";
}

.mdi-teamviewer::before {
  content: "\\F0500";
}

.mdi-teddy-bear::before {
  content: "\\F18FB";
}

.mdi-telescope::before {
  content: "\\F0B4E";
}

.mdi-television::before {
  content: "\\F0502";
}

.mdi-television-ambient-light::before {
  content: "\\F1356";
}

.mdi-television-box::before {
  content: "\\F0839";
}

.mdi-television-classic::before {
  content: "\\F07F4";
}

.mdi-television-classic-off::before {
  content: "\\F083A";
}

.mdi-television-guide::before {
  content: "\\F0503";
}

.mdi-television-off::before {
  content: "\\F083B";
}

.mdi-television-pause::before {
  content: "\\F0F89";
}

.mdi-television-play::before {
  content: "\\F0ECF";
}

.mdi-television-shimmer::before {
  content: "\\F1110";
}

.mdi-television-speaker::before {
  content: "\\F1B1B";
}

.mdi-television-speaker-off::before {
  content: "\\F1B1C";
}

.mdi-television-stop::before {
  content: "\\F0F8A";
}

.mdi-temperature-celsius::before {
  content: "\\F0504";
}

.mdi-temperature-fahrenheit::before {
  content: "\\F0505";
}

.mdi-temperature-kelvin::before {
  content: "\\F0506";
}

.mdi-temple-buddhist::before {
  content: "\\F1B06";
}

.mdi-temple-buddhist-outline::before {
  content: "\\F1B07";
}

.mdi-temple-hindu::before {
  content: "\\F1B08";
}

.mdi-temple-hindu-outline::before {
  content: "\\F1B09";
}

.mdi-tennis::before {
  content: "\\F0DA0";
}

.mdi-tennis-ball::before {
  content: "\\F0507";
}

.mdi-tennis-ball-outline::before {
  content: "\\F1C5F";
}

.mdi-tent::before {
  content: "\\F0508";
}

.mdi-terraform::before {
  content: "\\F1062";
}

.mdi-terrain::before {
  content: "\\F0509";
}

.mdi-test-tube::before {
  content: "\\F0668";
}

.mdi-test-tube-empty::before {
  content: "\\F0911";
}

.mdi-test-tube-off::before {
  content: "\\F0912";
}

.mdi-text::before {
  content: "\\F09A8";
}

.mdi-text-account::before {
  content: "\\F1570";
}

.mdi-text-box::before {
  content: "\\F021A";
}

.mdi-text-box-check::before {
  content: "\\F0EA6";
}

.mdi-text-box-check-outline::before {
  content: "\\F0EA7";
}

.mdi-text-box-edit::before {
  content: "\\F1A7C";
}

.mdi-text-box-edit-outline::before {
  content: "\\F1A7D";
}

.mdi-text-box-minus::before {
  content: "\\F0EA8";
}

.mdi-text-box-minus-outline::before {
  content: "\\F0EA9";
}

.mdi-text-box-multiple::before {
  content: "\\F0AB7";
}

.mdi-text-box-multiple-outline::before {
  content: "\\F0AB8";
}

.mdi-text-box-outline::before {
  content: "\\F09ED";
}

.mdi-text-box-plus::before {
  content: "\\F0EAA";
}

.mdi-text-box-plus-outline::before {
  content: "\\F0EAB";
}

.mdi-text-box-remove::before {
  content: "\\F0EAC";
}

.mdi-text-box-remove-outline::before {
  content: "\\F0EAD";
}

.mdi-text-box-search::before {
  content: "\\F0EAE";
}

.mdi-text-box-search-outline::before {
  content: "\\F0EAF";
}

.mdi-text-long::before {
  content: "\\F09AA";
}

.mdi-text-recognition::before {
  content: "\\F113D";
}

.mdi-text-search::before {
  content: "\\F13B8";
}

.mdi-text-search-variant::before {
  content: "\\F1A7E";
}

.mdi-text-shadow::before {
  content: "\\F0669";
}

.mdi-text-short::before {
  content: "\\F09A9";
}

.mdi-texture::before {
  content: "\\F050C";
}

.mdi-texture-box::before {
  content: "\\F0FE6";
}

.mdi-theater::before {
  content: "\\F050D";
}

.mdi-theme-light-dark::before {
  content: "\\F050E";
}

.mdi-thermometer::before {
  content: "\\F050F";
}

.mdi-thermometer-alert::before {
  content: "\\F0E01";
}

.mdi-thermometer-auto::before {
  content: "\\F1B0F";
}

.mdi-thermometer-bluetooth::before {
  content: "\\F1895";
}

.mdi-thermometer-check::before {
  content: "\\F1A7F";
}

.mdi-thermometer-chevron-down::before {
  content: "\\F0E02";
}

.mdi-thermometer-chevron-up::before {
  content: "\\F0E03";
}

.mdi-thermometer-high::before {
  content: "\\F10C2";
}

.mdi-thermometer-lines::before {
  content: "\\F0510";
}

.mdi-thermometer-low::before {
  content: "\\F10C3";
}

.mdi-thermometer-minus::before {
  content: "\\F0E04";
}

.mdi-thermometer-off::before {
  content: "\\F1531";
}

.mdi-thermometer-plus::before {
  content: "\\F0E05";
}

.mdi-thermometer-probe::before {
  content: "\\F1B2B";
}

.mdi-thermometer-probe-off::before {
  content: "\\F1B2C";
}

.mdi-thermometer-water::before {
  content: "\\F1A80";
}

.mdi-thermostat::before {
  content: "\\F0393";
}

.mdi-thermostat-auto::before {
  content: "\\F1B17";
}

.mdi-thermostat-box::before {
  content: "\\F0891";
}

.mdi-thermostat-box-auto::before {
  content: "\\F1B18";
}

.mdi-thermostat-cog::before {
  content: "\\F1C80";
}

.mdi-thought-bubble::before {
  content: "\\F07F6";
}

.mdi-thought-bubble-outline::before {
  content: "\\F07F7";
}

.mdi-thumb-down::before {
  content: "\\F0511";
}

.mdi-thumb-down-outline::before {
  content: "\\F0512";
}

.mdi-thumb-up::before {
  content: "\\F0513";
}

.mdi-thumb-up-outline::before {
  content: "\\F0514";
}

.mdi-thumbs-up-down::before {
  content: "\\F0515";
}

.mdi-thumbs-up-down-outline::before {
  content: "\\F1914";
}

.mdi-ticket::before {
  content: "\\F0516";
}

.mdi-ticket-account::before {
  content: "\\F0517";
}

.mdi-ticket-confirmation::before {
  content: "\\F0518";
}

.mdi-ticket-confirmation-outline::before {
  content: "\\F13AA";
}

.mdi-ticket-outline::before {
  content: "\\F0913";
}

.mdi-ticket-percent::before {
  content: "\\F0724";
}

.mdi-ticket-percent-outline::before {
  content: "\\F142B";
}

.mdi-tie::before {
  content: "\\F0519";
}

.mdi-tilde::before {
  content: "\\F0725";
}

.mdi-tilde-off::before {
  content: "\\F18F3";
}

.mdi-timelapse::before {
  content: "\\F051A";
}

.mdi-timeline::before {
  content: "\\F0BD1";
}

.mdi-timeline-alert::before {
  content: "\\F0F95";
}

.mdi-timeline-alert-outline::before {
  content: "\\F0F98";
}

.mdi-timeline-check::before {
  content: "\\F1532";
}

.mdi-timeline-check-outline::before {
  content: "\\F1533";
}

.mdi-timeline-clock::before {
  content: "\\F11FB";
}

.mdi-timeline-clock-outline::before {
  content: "\\F11FC";
}

.mdi-timeline-minus::before {
  content: "\\F1534";
}

.mdi-timeline-minus-outline::before {
  content: "\\F1535";
}

.mdi-timeline-outline::before {
  content: "\\F0BD2";
}

.mdi-timeline-plus::before {
  content: "\\F0F96";
}

.mdi-timeline-plus-outline::before {
  content: "\\F0F97";
}

.mdi-timeline-question::before {
  content: "\\F0F99";
}

.mdi-timeline-question-outline::before {
  content: "\\F0F9A";
}

.mdi-timeline-remove::before {
  content: "\\F1536";
}

.mdi-timeline-remove-outline::before {
  content: "\\F1537";
}

.mdi-timeline-text::before {
  content: "\\F0BD3";
}

.mdi-timeline-text-outline::before {
  content: "\\F0BD4";
}

.mdi-timer::before {
  content: "\\F13AB";
}

.mdi-timer-10::before {
  content: "\\F051C";
}

.mdi-timer-3::before {
  content: "\\F051D";
}

.mdi-timer-alert::before {
  content: "\\F1ACC";
}

.mdi-timer-alert-outline::before {
  content: "\\F1ACD";
}

.mdi-timer-cancel::before {
  content: "\\F1ACE";
}

.mdi-timer-cancel-outline::before {
  content: "\\F1ACF";
}

.mdi-timer-check::before {
  content: "\\F1AD0";
}

.mdi-timer-check-outline::before {
  content: "\\F1AD1";
}

.mdi-timer-cog::before {
  content: "\\F1925";
}

.mdi-timer-cog-outline::before {
  content: "\\F1926";
}

.mdi-timer-edit::before {
  content: "\\F1AD2";
}

.mdi-timer-edit-outline::before {
  content: "\\F1AD3";
}

.mdi-timer-lock::before {
  content: "\\F1AD4";
}

.mdi-timer-lock-open::before {
  content: "\\F1AD5";
}

.mdi-timer-lock-open-outline::before {
  content: "\\F1AD6";
}

.mdi-timer-lock-outline::before {
  content: "\\F1AD7";
}

.mdi-timer-marker::before {
  content: "\\F1AD8";
}

.mdi-timer-marker-outline::before {
  content: "\\F1AD9";
}

.mdi-timer-minus::before {
  content: "\\F1ADA";
}

.mdi-timer-minus-outline::before {
  content: "\\F1ADB";
}

.mdi-timer-music::before {
  content: "\\F1ADC";
}

.mdi-timer-music-outline::before {
  content: "\\F1ADD";
}

.mdi-timer-off::before {
  content: "\\F13AC";
}

.mdi-timer-off-outline::before {
  content: "\\F051E";
}

.mdi-timer-outline::before {
  content: "\\F051B";
}

.mdi-timer-pause::before {
  content: "\\F1ADE";
}

.mdi-timer-pause-outline::before {
  content: "\\F1ADF";
}

.mdi-timer-play::before {
  content: "\\F1AE0";
}

.mdi-timer-play-outline::before {
  content: "\\F1AE1";
}

.mdi-timer-plus::before {
  content: "\\F1AE2";
}

.mdi-timer-plus-outline::before {
  content: "\\F1AE3";
}

.mdi-timer-refresh::before {
  content: "\\F1AE4";
}

.mdi-timer-refresh-outline::before {
  content: "\\F1AE5";
}

.mdi-timer-remove::before {
  content: "\\F1AE6";
}

.mdi-timer-remove-outline::before {
  content: "\\F1AE7";
}

.mdi-timer-sand::before {
  content: "\\F051F";
}

.mdi-timer-sand-complete::before {
  content: "\\F199F";
}

.mdi-timer-sand-empty::before {
  content: "\\F06AD";
}

.mdi-timer-sand-full::before {
  content: "\\F078C";
}

.mdi-timer-sand-paused::before {
  content: "\\F19A0";
}

.mdi-timer-settings::before {
  content: "\\F1923";
}

.mdi-timer-settings-outline::before {
  content: "\\F1924";
}

.mdi-timer-star::before {
  content: "\\F1AE8";
}

.mdi-timer-star-outline::before {
  content: "\\F1AE9";
}

.mdi-timer-stop::before {
  content: "\\F1AEA";
}

.mdi-timer-stop-outline::before {
  content: "\\F1AEB";
}

.mdi-timer-sync::before {
  content: "\\F1AEC";
}

.mdi-timer-sync-outline::before {
  content: "\\F1AED";
}

.mdi-timetable::before {
  content: "\\F0520";
}

.mdi-tire::before {
  content: "\\F1896";
}

.mdi-toaster::before {
  content: "\\F1063";
}

.mdi-toaster-off::before {
  content: "\\F11B7";
}

.mdi-toaster-oven::before {
  content: "\\F0CD3";
}

.mdi-toggle-switch::before {
  content: "\\F0521";
}

.mdi-toggle-switch-off::before {
  content: "\\F0522";
}

.mdi-toggle-switch-off-outline::before {
  content: "\\F0A19";
}

.mdi-toggle-switch-outline::before {
  content: "\\F0A1A";
}

.mdi-toggle-switch-variant::before {
  content: "\\F1A25";
}

.mdi-toggle-switch-variant-off::before {
  content: "\\F1A26";
}

.mdi-toilet::before {
  content: "\\F09AB";
}

.mdi-toolbox::before {
  content: "\\F09AC";
}

.mdi-toolbox-outline::before {
  content: "\\F09AD";
}

.mdi-tools::before {
  content: "\\F1064";
}

.mdi-tooltip::before {
  content: "\\F0523";
}

.mdi-tooltip-account::before {
  content: "\\F000C";
}

.mdi-tooltip-cellphone::before {
  content: "\\F183B";
}

.mdi-tooltip-check::before {
  content: "\\F155C";
}

.mdi-tooltip-check-outline::before {
  content: "\\F155D";
}

.mdi-tooltip-edit::before {
  content: "\\F0524";
}

.mdi-tooltip-edit-outline::before {
  content: "\\F12C5";
}

.mdi-tooltip-image::before {
  content: "\\F0525";
}

.mdi-tooltip-image-outline::before {
  content: "\\F0BD5";
}

.mdi-tooltip-minus::before {
  content: "\\F155E";
}

.mdi-tooltip-minus-outline::before {
  content: "\\F155F";
}

.mdi-tooltip-outline::before {
  content: "\\F0526";
}

.mdi-tooltip-plus::before {
  content: "\\F0BD6";
}

.mdi-tooltip-plus-outline::before {
  content: "\\F0527";
}

.mdi-tooltip-question::before {
  content: "\\F1BBA";
}

.mdi-tooltip-question-outline::before {
  content: "\\F1BBB";
}

.mdi-tooltip-remove::before {
  content: "\\F1560";
}

.mdi-tooltip-remove-outline::before {
  content: "\\F1561";
}

.mdi-tooltip-text::before {
  content: "\\F0528";
}

.mdi-tooltip-text-outline::before {
  content: "\\F0BD7";
}

.mdi-tooth::before {
  content: "\\F08C3";
}

.mdi-tooth-outline::before {
  content: "\\F0529";
}

.mdi-toothbrush::before {
  content: "\\F1129";
}

.mdi-toothbrush-electric::before {
  content: "\\F112C";
}

.mdi-toothbrush-paste::before {
  content: "\\F112A";
}

.mdi-torch::before {
  content: "\\F1606";
}

.mdi-tortoise::before {
  content: "\\F0D3B";
}

.mdi-toslink::before {
  content: "\\F12B8";
}

.mdi-touch-text-outline::before {
  content: "\\F1C60";
}

.mdi-tournament::before {
  content: "\\F09AE";
}

.mdi-tow-truck::before {
  content: "\\F083C";
}

.mdi-tower-beach::before {
  content: "\\F0681";
}

.mdi-tower-fire::before {
  content: "\\F0682";
}

.mdi-town-hall::before {
  content: "\\F1875";
}

.mdi-toy-brick::before {
  content: "\\F1288";
}

.mdi-toy-brick-marker::before {
  content: "\\F1289";
}

.mdi-toy-brick-marker-outline::before {
  content: "\\F128A";
}

.mdi-toy-brick-minus::before {
  content: "\\F128B";
}

.mdi-toy-brick-minus-outline::before {
  content: "\\F128C";
}

.mdi-toy-brick-outline::before {
  content: "\\F128D";
}

.mdi-toy-brick-plus::before {
  content: "\\F128E";
}

.mdi-toy-brick-plus-outline::before {
  content: "\\F128F";
}

.mdi-toy-brick-remove::before {
  content: "\\F1290";
}

.mdi-toy-brick-remove-outline::before {
  content: "\\F1291";
}

.mdi-toy-brick-search::before {
  content: "\\F1292";
}

.mdi-toy-brick-search-outline::before {
  content: "\\F1293";
}

.mdi-track-light::before {
  content: "\\F0914";
}

.mdi-track-light-off::before {
  content: "\\F1B01";
}

.mdi-trackpad::before {
  content: "\\F07F8";
}

.mdi-trackpad-lock::before {
  content: "\\F0933";
}

.mdi-tractor::before {
  content: "\\F0892";
}

.mdi-tractor-variant::before {
  content: "\\F14C4";
}

.mdi-trademark::before {
  content: "\\F0A78";
}

.mdi-traffic-cone::before {
  content: "\\F137C";
}

.mdi-traffic-light::before {
  content: "\\F052B";
}

.mdi-traffic-light-outline::before {
  content: "\\F182A";
}

.mdi-train::before {
  content: "\\F052C";
}

.mdi-train-bus::before {
  content: "\\F1CC7";
}

.mdi-train-car::before {
  content: "\\F0BD8";
}

.mdi-train-car-autorack::before {
  content: "\\F1B2D";
}

.mdi-train-car-box::before {
  content: "\\F1B2E";
}

.mdi-train-car-box-full::before {
  content: "\\F1B2F";
}

.mdi-train-car-box-open::before {
  content: "\\F1B30";
}

.mdi-train-car-caboose::before {
  content: "\\F1B31";
}

.mdi-train-car-centerbeam::before {
  content: "\\F1B32";
}

.mdi-train-car-centerbeam-full::before {
  content: "\\F1B33";
}

.mdi-train-car-container::before {
  content: "\\F1B34";
}

.mdi-train-car-flatbed::before {
  content: "\\F1B35";
}

.mdi-train-car-flatbed-car::before {
  content: "\\F1B36";
}

.mdi-train-car-flatbed-tank::before {
  content: "\\F1B37";
}

.mdi-train-car-gondola::before {
  content: "\\F1B38";
}

.mdi-train-car-gondola-full::before {
  content: "\\F1B39";
}

.mdi-train-car-hopper::before {
  content: "\\F1B3A";
}

.mdi-train-car-hopper-covered::before {
  content: "\\F1B3B";
}

.mdi-train-car-hopper-full::before {
  content: "\\F1B3C";
}

.mdi-train-car-intermodal::before {
  content: "\\F1B3D";
}

.mdi-train-car-passenger::before {
  content: "\\F1733";
}

.mdi-train-car-passenger-door::before {
  content: "\\F1734";
}

.mdi-train-car-passenger-door-open::before {
  content: "\\F1735";
}

.mdi-train-car-passenger-variant::before {
  content: "\\F1736";
}

.mdi-train-car-tank::before {
  content: "\\F1B3E";
}

.mdi-train-variant::before {
  content: "\\F08C4";
}

.mdi-tram::before {
  content: "\\F052D";
}

.mdi-tram-side::before {
  content: "\\F0FE7";
}

.mdi-transcribe::before {
  content: "\\F052E";
}

.mdi-transcribe-close::before {
  content: "\\F052F";
}

.mdi-transfer::before {
  content: "\\F1065";
}

.mdi-transfer-down::before {
  content: "\\F0DA1";
}

.mdi-transfer-left::before {
  content: "\\F0DA2";
}

.mdi-transfer-right::before {
  content: "\\F0530";
}

.mdi-transfer-up::before {
  content: "\\F0DA3";
}

.mdi-transit-connection::before {
  content: "\\F0D3C";
}

.mdi-transit-connection-horizontal::before {
  content: "\\F1546";
}

.mdi-transit-connection-variant::before {
  content: "\\F0D3D";
}

.mdi-transit-detour::before {
  content: "\\F0F8B";
}

.mdi-transit-skip::before {
  content: "\\F1515";
}

.mdi-transit-transfer::before {
  content: "\\F06AE";
}

.mdi-transition::before {
  content: "\\F0915";
}

.mdi-transition-masked::before {
  content: "\\F0916";
}

.mdi-translate::before {
  content: "\\F05CA";
}

.mdi-translate-off::before {
  content: "\\F0E06";
}

.mdi-translate-variant::before {
  content: "\\F1B99";
}

.mdi-transmission-tower::before {
  content: "\\F0D3E";
}

.mdi-transmission-tower-export::before {
  content: "\\F192C";
}

.mdi-transmission-tower-import::before {
  content: "\\F192D";
}

.mdi-transmission-tower-off::before {
  content: "\\F19DD";
}

.mdi-trash-can::before {
  content: "\\F0A79";
}

.mdi-trash-can-outline::before {
  content: "\\F0A7A";
}

.mdi-tray::before {
  content: "\\F1294";
}

.mdi-tray-alert::before {
  content: "\\F1295";
}

.mdi-tray-arrow-down::before {
  content: "\\F0120";
}

.mdi-tray-arrow-up::before {
  content: "\\F011D";
}

.mdi-tray-full::before {
  content: "\\F1296";
}

.mdi-tray-minus::before {
  content: "\\F1297";
}

.mdi-tray-plus::before {
  content: "\\F1298";
}

.mdi-tray-remove::before {
  content: "\\F1299";
}

.mdi-treasure-chest::before {
  content: "\\F0726";
}

.mdi-treasure-chest-outline::before {
  content: "\\F1C77";
}

.mdi-tree::before {
  content: "\\F0531";
}

.mdi-tree-outline::before {
  content: "\\F0E69";
}

.mdi-trello::before {
  content: "\\F0532";
}

.mdi-trending-down::before {
  content: "\\F0533";
}

.mdi-trending-neutral::before {
  content: "\\F0534";
}

.mdi-trending-up::before {
  content: "\\F0535";
}

.mdi-triangle::before {
  content: "\\F0536";
}

.mdi-triangle-down::before {
  content: "\\F1C56";
}

.mdi-triangle-down-outline::before {
  content: "\\F1C57";
}

.mdi-triangle-outline::before {
  content: "\\F0537";
}

.mdi-triangle-small-down::before {
  content: "\\F1A09";
}

.mdi-triangle-small-up::before {
  content: "\\F1A0A";
}

.mdi-triangle-wave::before {
  content: "\\F147C";
}

.mdi-triforce::before {
  content: "\\F0BD9";
}

.mdi-trophy::before {
  content: "\\F0538";
}

.mdi-trophy-award::before {
  content: "\\F0539";
}

.mdi-trophy-broken::before {
  content: "\\F0DA4";
}

.mdi-trophy-outline::before {
  content: "\\F053A";
}

.mdi-trophy-variant::before {
  content: "\\F053B";
}

.mdi-trophy-variant-outline::before {
  content: "\\F053C";
}

.mdi-truck::before {
  content: "\\F053D";
}

.mdi-truck-alert::before {
  content: "\\F19DE";
}

.mdi-truck-alert-outline::before {
  content: "\\F19DF";
}

.mdi-truck-cargo-container::before {
  content: "\\F18D8";
}

.mdi-truck-check::before {
  content: "\\F0CD4";
}

.mdi-truck-check-outline::before {
  content: "\\F129A";
}

.mdi-truck-delivery::before {
  content: "\\F053E";
}

.mdi-truck-delivery-outline::before {
  content: "\\F129B";
}

.mdi-truck-fast::before {
  content: "\\F0788";
}

.mdi-truck-fast-outline::before {
  content: "\\F129C";
}

.mdi-truck-flatbed::before {
  content: "\\F1891";
}

.mdi-truck-minus::before {
  content: "\\F19AE";
}

.mdi-truck-minus-outline::before {
  content: "\\F19BD";
}

.mdi-truck-off-road::before {
  content: "\\F1C9E";
}

.mdi-truck-off-road-off::before {
  content: "\\F1C9F";
}

.mdi-truck-outline::before {
  content: "\\F129D";
}

.mdi-truck-plus::before {
  content: "\\F19AD";
}

.mdi-truck-plus-outline::before {
  content: "\\F19BC";
}

.mdi-truck-remove::before {
  content: "\\F19AF";
}

.mdi-truck-remove-outline::before {
  content: "\\F19BE";
}

.mdi-truck-snowflake::before {
  content: "\\F19A6";
}

.mdi-truck-trailer::before {
  content: "\\F0727";
}

.mdi-trumpet::before {
  content: "\\F1096";
}

.mdi-tshirt-crew::before {
  content: "\\F0A7B";
}

.mdi-tshirt-crew-outline::before {
  content: "\\F053F";
}

.mdi-tshirt-v::before {
  content: "\\F0A7C";
}

.mdi-tshirt-v-outline::before {
  content: "\\F0540";
}

.mdi-tsunami::before {
  content: "\\F1A81";
}

.mdi-tumble-dryer::before {
  content: "\\F0917";
}

.mdi-tumble-dryer-alert::before {
  content: "\\F11BA";
}

.mdi-tumble-dryer-off::before {
  content: "\\F11BB";
}

.mdi-tune::before {
  content: "\\F062E";
}

.mdi-tune-variant::before {
  content: "\\F1542";
}

.mdi-tune-vertical::before {
  content: "\\F066A";
}

.mdi-tune-vertical-variant::before {
  content: "\\F1543";
}

.mdi-tunnel::before {
  content: "\\F183D";
}

.mdi-tunnel-outline::before {
  content: "\\F183E";
}

.mdi-turbine::before {
  content: "\\F1A82";
}

.mdi-turkey::before {
  content: "\\F171B";
}

.mdi-turnstile::before {
  content: "\\F0CD5";
}

.mdi-turnstile-outline::before {
  content: "\\F0CD6";
}

.mdi-turtle::before {
  content: "\\F0CD7";
}

.mdi-twitch::before {
  content: "\\F0543";
}

.mdi-twitter::before {
  content: "\\F0544";
}

.mdi-two-factor-authentication::before {
  content: "\\F09AF";
}

.mdi-typewriter::before {
  content: "\\F0F2D";
}

.mdi-ubisoft::before {
  content: "\\F0BDA";
}

.mdi-ubuntu::before {
  content: "\\F0548";
}

.mdi-ufo::before {
  content: "\\F10C4";
}

.mdi-ufo-outline::before {
  content: "\\F10C5";
}

.mdi-ultra-high-definition::before {
  content: "\\F07F9";
}

.mdi-umbraco::before {
  content: "\\F0549";
}

.mdi-umbrella::before {
  content: "\\F054A";
}

.mdi-umbrella-beach::before {
  content: "\\F188A";
}

.mdi-umbrella-beach-outline::before {
  content: "\\F188B";
}

.mdi-umbrella-closed::before {
  content: "\\F09B0";
}

.mdi-umbrella-closed-outline::before {
  content: "\\F13E2";
}

.mdi-umbrella-closed-variant::before {
  content: "\\F13E1";
}

.mdi-umbrella-outline::before {
  content: "\\F054B";
}

.mdi-underwear-outline::before {
  content: "\\F1D0F";
}

.mdi-undo::before {
  content: "\\F054C";
}

.mdi-undo-variant::before {
  content: "\\F054D";
}

.mdi-unfold-less-horizontal::before {
  content: "\\F054E";
}

.mdi-unfold-less-vertical::before {
  content: "\\F0760";
}

.mdi-unfold-more-horizontal::before {
  content: "\\F054F";
}

.mdi-unfold-more-vertical::before {
  content: "\\F0761";
}

.mdi-ungroup::before {
  content: "\\F0550";
}

.mdi-unicode::before {
  content: "\\F0ED0";
}

.mdi-unicorn::before {
  content: "\\F15C2";
}

.mdi-unicorn-variant::before {
  content: "\\F15C3";
}

.mdi-unicycle::before {
  content: "\\F15E5";
}

.mdi-unity::before {
  content: "\\F06AF";
}

.mdi-unreal::before {
  content: "\\F09B1";
}

.mdi-update::before {
  content: "\\F06B0";
}

.mdi-upload::before {
  content: "\\F0552";
}

.mdi-upload-box::before {
  content: "\\F1D10";
}

.mdi-upload-box-outline::before {
  content: "\\F1D11";
}

.mdi-upload-circle::before {
  content: "\\F1D12";
}

.mdi-upload-circle-outline::before {
  content: "\\F1D13";
}

.mdi-upload-lock::before {
  content: "\\F1373";
}

.mdi-upload-lock-outline::before {
  content: "\\F1374";
}

.mdi-upload-multiple::before {
  content: "\\F083D";
}

.mdi-upload-multiple-outline::before {
  content: "\\F1D14";
}

.mdi-upload-network::before {
  content: "\\F06F6";
}

.mdi-upload-network-outline::before {
  content: "\\F0CD8";
}

.mdi-upload-off::before {
  content: "\\F10C6";
}

.mdi-upload-off-outline::before {
  content: "\\F10C7";
}

.mdi-upload-outline::before {
  content: "\\F0E07";
}

.mdi-usb::before {
  content: "\\F0553";
}

.mdi-usb-c-port::before {
  content: "\\F1CBF";
}

.mdi-usb-flash-drive::before {
  content: "\\F129E";
}

.mdi-usb-flash-drive-outline::before {
  content: "\\F129F";
}

.mdi-usb-port::before {
  content: "\\F11F0";
}

.mdi-vacuum::before {
  content: "\\F19A1";
}

.mdi-vacuum-outline::before {
  content: "\\F19A2";
}

.mdi-valve::before {
  content: "\\F1066";
}

.mdi-valve-closed::before {
  content: "\\F1067";
}

.mdi-valve-open::before {
  content: "\\F1068";
}

.mdi-van-passenger::before {
  content: "\\F07FA";
}

.mdi-van-utility::before {
  content: "\\F07FB";
}

.mdi-vanish::before {
  content: "\\F07FC";
}

.mdi-vanish-quarter::before {
  content: "\\F1554";
}

.mdi-vanity-light::before {
  content: "\\F11E1";
}

.mdi-variable::before {
  content: "\\F0AE7";
}

.mdi-variable-box::before {
  content: "\\F1111";
}

.mdi-vector-arrange-above::before {
  content: "\\F0554";
}

.mdi-vector-arrange-below::before {
  content: "\\F0555";
}

.mdi-vector-bezier::before {
  content: "\\F0AE8";
}

.mdi-vector-circle::before {
  content: "\\F0556";
}

.mdi-vector-circle-variant::before {
  content: "\\F0557";
}

.mdi-vector-combine::before {
  content: "\\F0558";
}

.mdi-vector-curve::before {
  content: "\\F0559";
}

.mdi-vector-difference::before {
  content: "\\F055A";
}

.mdi-vector-difference-ab::before {
  content: "\\F055B";
}

.mdi-vector-difference-ba::before {
  content: "\\F055C";
}

.mdi-vector-ellipse::before {
  content: "\\F0893";
}

.mdi-vector-intersection::before {
  content: "\\F055D";
}

.mdi-vector-line::before {
  content: "\\F055E";
}

.mdi-vector-link::before {
  content: "\\F0FE8";
}

.mdi-vector-point::before {
  content: "\\F01C4";
}

.mdi-vector-point-edit::before {
  content: "\\F09E8";
}

.mdi-vector-point-minus::before {
  content: "\\F1B78";
}

.mdi-vector-point-plus::before {
  content: "\\F1B79";
}

.mdi-vector-point-select::before {
  content: "\\F055F";
}

.mdi-vector-polygon::before {
  content: "\\F0560";
}

.mdi-vector-polygon-variant::before {
  content: "\\F1856";
}

.mdi-vector-polyline::before {
  content: "\\F0561";
}

.mdi-vector-polyline-edit::before {
  content: "\\F1225";
}

.mdi-vector-polyline-minus::before {
  content: "\\F1226";
}

.mdi-vector-polyline-plus::before {
  content: "\\F1227";
}

.mdi-vector-polyline-remove::before {
  content: "\\F1228";
}

.mdi-vector-radius::before {
  content: "\\F074A";
}

.mdi-vector-rectangle::before {
  content: "\\F05C6";
}

.mdi-vector-selection::before {
  content: "\\F0562";
}

.mdi-vector-square::before {
  content: "\\F0001";
}

.mdi-vector-square-close::before {
  content: "\\F1857";
}

.mdi-vector-square-edit::before {
  content: "\\F18D9";
}

.mdi-vector-square-minus::before {
  content: "\\F18DA";
}

.mdi-vector-square-open::before {
  content: "\\F1858";
}

.mdi-vector-square-plus::before {
  content: "\\F18DB";
}

.mdi-vector-square-remove::before {
  content: "\\F18DC";
}

.mdi-vector-triangle::before {
  content: "\\F0563";
}

.mdi-vector-union::before {
  content: "\\F0564";
}

.mdi-vhs::before {
  content: "\\F0A1B";
}

.mdi-vibrate::before {
  content: "\\F0566";
}

.mdi-vibrate-off::before {
  content: "\\F0CD9";
}

.mdi-video::before {
  content: "\\F0567";
}

.mdi-video-2d::before {
  content: "\\F1A1C";
}

.mdi-video-3d::before {
  content: "\\F07FD";
}

.mdi-video-3d-off::before {
  content: "\\F13D9";
}

.mdi-video-3d-variant::before {
  content: "\\F0ED1";
}

.mdi-video-4k-box::before {
  content: "\\F083E";
}

.mdi-video-account::before {
  content: "\\F0919";
}

.mdi-video-box::before {
  content: "\\F00FD";
}

.mdi-video-box-off::before {
  content: "\\F00FE";
}

.mdi-video-check::before {
  content: "\\F1069";
}

.mdi-video-check-outline::before {
  content: "\\F106A";
}

.mdi-video-high-definition::before {
  content: "\\F152E";
}

.mdi-video-image::before {
  content: "\\F091A";
}

.mdi-video-input-antenna::before {
  content: "\\F083F";
}

.mdi-video-input-component::before {
  content: "\\F0840";
}

.mdi-video-input-hdmi::before {
  content: "\\F0841";
}

.mdi-video-input-scart::before {
  content: "\\F0F8C";
}

.mdi-video-input-svideo::before {
  content: "\\F0842";
}

.mdi-video-marker::before {
  content: "\\F19A9";
}

.mdi-video-marker-outline::before {
  content: "\\F19AA";
}

.mdi-video-minus::before {
  content: "\\F09B2";
}

.mdi-video-minus-outline::before {
  content: "\\F02BA";
}

.mdi-video-off::before {
  content: "\\F0568";
}

.mdi-video-off-outline::before {
  content: "\\F0BDB";
}

.mdi-video-outline::before {
  content: "\\F0BDC";
}

.mdi-video-plus::before {
  content: "\\F09B3";
}

.mdi-video-plus-outline::before {
  content: "\\F01D3";
}

.mdi-video-stabilization::before {
  content: "\\F091B";
}

.mdi-video-standard-definition::before {
  content: "\\F1CA0";
}

.mdi-video-switch::before {
  content: "\\F0569";
}

.mdi-video-switch-outline::before {
  content: "\\F0790";
}

.mdi-video-vintage::before {
  content: "\\F0A1C";
}

.mdi-video-wireless::before {
  content: "\\F0ED2";
}

.mdi-video-wireless-outline::before {
  content: "\\F0ED3";
}

.mdi-view-agenda::before {
  content: "\\F056A";
}

.mdi-view-agenda-outline::before {
  content: "\\F11D8";
}

.mdi-view-array::before {
  content: "\\F056B";
}

.mdi-view-array-outline::before {
  content: "\\F1485";
}

.mdi-view-carousel::before {
  content: "\\F056C";
}

.mdi-view-carousel-outline::before {
  content: "\\F1486";
}

.mdi-view-column::before {
  content: "\\F056D";
}

.mdi-view-column-outline::before {
  content: "\\F1487";
}

.mdi-view-comfy::before {
  content: "\\F0E6A";
}

.mdi-view-comfy-outline::before {
  content: "\\F1488";
}

.mdi-view-compact::before {
  content: "\\F0E6B";
}

.mdi-view-compact-outline::before {
  content: "\\F0E6C";
}

.mdi-view-dashboard::before {
  content: "\\F056E";
}

.mdi-view-dashboard-edit::before {
  content: "\\F1947";
}

.mdi-view-dashboard-edit-outline::before {
  content: "\\F1948";
}

.mdi-view-dashboard-outline::before {
  content: "\\F0A1D";
}

.mdi-view-dashboard-variant::before {
  content: "\\F0843";
}

.mdi-view-dashboard-variant-outline::before {
  content: "\\F1489";
}

.mdi-view-day::before {
  content: "\\F056F";
}

.mdi-view-day-outline::before {
  content: "\\F148A";
}

.mdi-view-gallery::before {
  content: "\\F1888";
}

.mdi-view-gallery-outline::before {
  content: "\\F1889";
}

.mdi-view-grid::before {
  content: "\\F0570";
}

.mdi-view-grid-compact::before {
  content: "\\F1C61";
}

.mdi-view-grid-outline::before {
  content: "\\F11D9";
}

.mdi-view-grid-plus::before {
  content: "\\F0F8D";
}

.mdi-view-grid-plus-outline::before {
  content: "\\F11DA";
}

.mdi-view-headline::before {
  content: "\\F0571";
}

.mdi-view-list::before {
  content: "\\F0572";
}

.mdi-view-list-outline::before {
  content: "\\F148B";
}

.mdi-view-module::before {
  content: "\\F0573";
}

.mdi-view-module-outline::before {
  content: "\\F148C";
}

.mdi-view-parallel::before {
  content: "\\F0728";
}

.mdi-view-parallel-outline::before {
  content: "\\F148D";
}

.mdi-view-quilt::before {
  content: "\\F0574";
}

.mdi-view-quilt-outline::before {
  content: "\\F148E";
}

.mdi-view-sequential::before {
  content: "\\F0729";
}

.mdi-view-sequential-outline::before {
  content: "\\F148F";
}

.mdi-view-split-horizontal::before {
  content: "\\F0BCB";
}

.mdi-view-split-vertical::before {
  content: "\\F0BCC";
}

.mdi-view-stream::before {
  content: "\\F0575";
}

.mdi-view-stream-outline::before {
  content: "\\F1490";
}

.mdi-view-week::before {
  content: "\\F0576";
}

.mdi-view-week-outline::before {
  content: "\\F1491";
}

.mdi-vimeo::before {
  content: "\\F0577";
}

.mdi-violin::before {
  content: "\\F060F";
}

.mdi-virtual-reality::before {
  content: "\\F0894";
}

.mdi-virus::before {
  content: "\\F13B6";
}

.mdi-virus-off::before {
  content: "\\F18E1";
}

.mdi-virus-off-outline::before {
  content: "\\F18E2";
}

.mdi-virus-outline::before {
  content: "\\F13B7";
}

.mdi-vlc::before {
  content: "\\F057C";
}

.mdi-voicemail::before {
  content: "\\F057D";
}

.mdi-volcano::before {
  content: "\\F1A83";
}

.mdi-volcano-outline::before {
  content: "\\F1A84";
}

.mdi-volleyball::before {
  content: "\\F09B4";
}

.mdi-volume-equal::before {
  content: "\\F1B10";
}

.mdi-volume-high::before {
  content: "\\F057E";
}

.mdi-volume-low::before {
  content: "\\F057F";
}

.mdi-volume-medium::before {
  content: "\\F0580";
}

.mdi-volume-minus::before {
  content: "\\F075E";
}

.mdi-volume-mute::before {
  content: "\\F075F";
}

.mdi-volume-off::before {
  content: "\\F0581";
}

.mdi-volume-plus::before {
  content: "\\F075D";
}

.mdi-volume-source::before {
  content: "\\F1120";
}

.mdi-volume-variant-off::before {
  content: "\\F0E08";
}

.mdi-volume-vibrate::before {
  content: "\\F1121";
}

.mdi-vote::before {
  content: "\\F0A1F";
}

.mdi-vote-outline::before {
  content: "\\F0A20";
}

.mdi-vpn::before {
  content: "\\F0582";
}

.mdi-vuejs::before {
  content: "\\F0844";
}

.mdi-vuetify::before {
  content: "\\F0E6D";
}

.mdi-walk::before {
  content: "\\F0583";
}

.mdi-wall::before {
  content: "\\F07FE";
}

.mdi-wall-fire::before {
  content: "\\F1A11";
}

.mdi-wall-sconce::before {
  content: "\\F091C";
}

.mdi-wall-sconce-flat::before {
  content: "\\F091D";
}

.mdi-wall-sconce-flat-outline::before {
  content: "\\F17C9";
}

.mdi-wall-sconce-flat-variant::before {
  content: "\\F041C";
}

.mdi-wall-sconce-flat-variant-outline::before {
  content: "\\F17CA";
}

.mdi-wall-sconce-outline::before {
  content: "\\F17CB";
}

.mdi-wall-sconce-round::before {
  content: "\\F0748";
}

.mdi-wall-sconce-round-outline::before {
  content: "\\F17CC";
}

.mdi-wall-sconce-round-variant::before {
  content: "\\F091E";
}

.mdi-wall-sconce-round-variant-outline::before {
  content: "\\F17CD";
}

.mdi-wallet::before {
  content: "\\F0584";
}

.mdi-wallet-bifold::before {
  content: "\\F1C58";
}

.mdi-wallet-bifold-outline::before {
  content: "\\F1C59";
}

.mdi-wallet-giftcard::before {
  content: "\\F0585";
}

.mdi-wallet-membership::before {
  content: "\\F0586";
}

.mdi-wallet-outline::before {
  content: "\\F0BDD";
}

.mdi-wallet-plus::before {
  content: "\\F0F8E";
}

.mdi-wallet-plus-outline::before {
  content: "\\F0F8F";
}

.mdi-wallet-travel::before {
  content: "\\F0587";
}

.mdi-wallpaper::before {
  content: "\\F0E09";
}

.mdi-wan::before {
  content: "\\F0588";
}

.mdi-wardrobe::before {
  content: "\\F0F90";
}

.mdi-wardrobe-outline::before {
  content: "\\F0F91";
}

.mdi-warehouse::before {
  content: "\\F0F81";
}

.mdi-washing-machine::before {
  content: "\\F072A";
}

.mdi-washing-machine-alert::before {
  content: "\\F11BC";
}

.mdi-washing-machine-off::before {
  content: "\\F11BD";
}

.mdi-watch::before {
  content: "\\F0589";
}

.mdi-watch-export::before {
  content: "\\F058A";
}

.mdi-watch-export-variant::before {
  content: "\\F0895";
}

.mdi-watch-import::before {
  content: "\\F058B";
}

.mdi-watch-import-variant::before {
  content: "\\F0896";
}

.mdi-watch-variant::before {
  content: "\\F0897";
}

.mdi-watch-vibrate::before {
  content: "\\F06B1";
}

.mdi-watch-vibrate-off::before {
  content: "\\F0CDA";
}

.mdi-water::before {
  content: "\\F058C";
}

.mdi-water-alert::before {
  content: "\\F1502";
}

.mdi-water-alert-outline::before {
  content: "\\F1503";
}

.mdi-water-boiler::before {
  content: "\\F0F92";
}

.mdi-water-boiler-alert::before {
  content: "\\F11B3";
}

.mdi-water-boiler-auto::before {
  content: "\\F1B98";
}

.mdi-water-boiler-off::before {
  content: "\\F11B4";
}

.mdi-water-check::before {
  content: "\\F1504";
}

.mdi-water-check-outline::before {
  content: "\\F1505";
}

.mdi-water-circle::before {
  content: "\\F1806";
}

.mdi-water-minus::before {
  content: "\\F1506";
}

.mdi-water-minus-outline::before {
  content: "\\F1507";
}

.mdi-water-off::before {
  content: "\\F058D";
}

.mdi-water-off-outline::before {
  content: "\\F1508";
}

.mdi-water-opacity::before {
  content: "\\F1855";
}

.mdi-water-outline::before {
  content: "\\F0E0A";
}

.mdi-water-percent::before {
  content: "\\F058E";
}

.mdi-water-percent-alert::before {
  content: "\\F1509";
}

.mdi-water-plus::before {
  content: "\\F150A";
}

.mdi-water-plus-outline::before {
  content: "\\F150B";
}

.mdi-water-polo::before {
  content: "\\F12A0";
}

.mdi-water-pump::before {
  content: "\\F058F";
}

.mdi-water-pump-off::before {
  content: "\\F0F93";
}

.mdi-water-remove::before {
  content: "\\F150C";
}

.mdi-water-remove-outline::before {
  content: "\\F150D";
}

.mdi-water-sync::before {
  content: "\\F17C6";
}

.mdi-water-thermometer::before {
  content: "\\F1A85";
}

.mdi-water-thermometer-outline::before {
  content: "\\F1A86";
}

.mdi-water-well::before {
  content: "\\F106B";
}

.mdi-water-well-outline::before {
  content: "\\F106C";
}

.mdi-waterfall::before {
  content: "\\F1849";
}

.mdi-watering-can::before {
  content: "\\F1481";
}

.mdi-watering-can-outline::before {
  content: "\\F1482";
}

.mdi-watermark::before {
  content: "\\F0612";
}

.mdi-wave::before {
  content: "\\F0F2E";
}

.mdi-wave-arrow-down::before {
  content: "\\F1CB0";
}

.mdi-wave-arrow-up::before {
  content: "\\F1CB1";
}

.mdi-wave-undercurrent::before {
  content: "\\F1CC0";
}

.mdi-waveform::before {
  content: "\\F147D";
}

.mdi-waves::before {
  content: "\\F078D";
}

.mdi-waves-arrow-left::before {
  content: "\\F1859";
}

.mdi-waves-arrow-right::before {
  content: "\\F185A";
}

.mdi-waves-arrow-up::before {
  content: "\\F185B";
}

.mdi-waze::before {
  content: "\\F0BDE";
}

.mdi-weather-cloudy::before {
  content: "\\F0590";
}

.mdi-weather-cloudy-alert::before {
  content: "\\F0F2F";
}

.mdi-weather-cloudy-arrow-right::before {
  content: "\\F0E6E";
}

.mdi-weather-cloudy-clock::before {
  content: "\\F18F6";
}

.mdi-weather-dust::before {
  content: "\\F1B5A";
}

.mdi-weather-fog::before {
  content: "\\F0591";
}

.mdi-weather-hail::before {
  content: "\\F0592";
}

.mdi-weather-hazy::before {
  content: "\\F0F30";
}

.mdi-weather-hurricane::before {
  content: "\\F0898";
}

.mdi-weather-hurricane-outline::before {
  content: "\\F1C78";
}

.mdi-weather-lightning::before {
  content: "\\F0593";
}

.mdi-weather-lightning-rainy::before {
  content: "\\F067E";
}

.mdi-weather-moonset::before {
  content: "\\F1D15";
}

.mdi-weather-moonset-down::before {
  content: "\\F1D16";
}

.mdi-weather-moonset-up::before {
  content: "\\F1D17";
}

.mdi-weather-night::before {
  content: "\\F0594";
}

.mdi-weather-night-partly-cloudy::before {
  content: "\\F0F31";
}

.mdi-weather-partly-cloudy::before {
  content: "\\F0595";
}

.mdi-weather-partly-lightning::before {
  content: "\\F0F32";
}

.mdi-weather-partly-rainy::before {
  content: "\\F0F33";
}

.mdi-weather-partly-snowy::before {
  content: "\\F0F34";
}

.mdi-weather-partly-snowy-rainy::before {
  content: "\\F0F35";
}

.mdi-weather-pouring::before {
  content: "\\F0596";
}

.mdi-weather-rainy::before {
  content: "\\F0597";
}

.mdi-weather-snowy::before {
  content: "\\F0598";
}

.mdi-weather-snowy-heavy::before {
  content: "\\F0F36";
}

.mdi-weather-snowy-rainy::before {
  content: "\\F067F";
}

.mdi-weather-sunny::before {
  content: "\\F0599";
}

.mdi-weather-sunny-alert::before {
  content: "\\F0F37";
}

.mdi-weather-sunny-off::before {
  content: "\\F14E4";
}

.mdi-weather-sunset::before {
  content: "\\F059A";
}

.mdi-weather-sunset-down::before {
  content: "\\F059B";
}

.mdi-weather-sunset-up::before {
  content: "\\F059C";
}

.mdi-weather-tornado::before {
  content: "\\F0F38";
}

.mdi-weather-windy::before {
  content: "\\F059D";
}

.mdi-weather-windy-variant::before {
  content: "\\F059E";
}

.mdi-web::before {
  content: "\\F059F";
}

.mdi-web-box::before {
  content: "\\F0F94";
}

.mdi-web-cancel::before {
  content: "\\F1790";
}

.mdi-web-check::before {
  content: "\\F0789";
}

.mdi-web-clock::before {
  content: "\\F124A";
}

.mdi-web-minus::before {
  content: "\\F10A0";
}

.mdi-web-off::before {
  content: "\\F0A8E";
}

.mdi-web-plus::before {
  content: "\\F0033";
}

.mdi-web-refresh::before {
  content: "\\F1791";
}

.mdi-web-remove::before {
  content: "\\F0551";
}

.mdi-web-sync::before {
  content: "\\F1792";
}

.mdi-webcam::before {
  content: "\\F05A0";
}

.mdi-webcam-off::before {
  content: "\\F1737";
}

.mdi-webhook::before {
  content: "\\F062F";
}

.mdi-webpack::before {
  content: "\\F072B";
}

.mdi-webrtc::before {
  content: "\\F1248";
}

.mdi-wechat::before {
  content: "\\F0611";
}

.mdi-weight::before {
  content: "\\F05A1";
}

.mdi-weight-gram::before {
  content: "\\F0D3F";
}

.mdi-weight-kilogram::before {
  content: "\\F05A2";
}

.mdi-weight-lifter::before {
  content: "\\F115D";
}

.mdi-weight-pound::before {
  content: "\\F09B5";
}

.mdi-whatsapp::before {
  content: "\\F05A3";
}

.mdi-wheel-barrow::before {
  content: "\\F14F2";
}

.mdi-wheelchair::before {
  content: "\\F1A87";
}

.mdi-wheelchair-accessibility::before {
  content: "\\F05A4";
}

.mdi-whistle::before {
  content: "\\F09B6";
}

.mdi-whistle-outline::before {
  content: "\\F12BC";
}

.mdi-white-balance-auto::before {
  content: "\\F05A5";
}

.mdi-white-balance-incandescent::before {
  content: "\\F05A6";
}

.mdi-white-balance-iridescent::before {
  content: "\\F05A7";
}

.mdi-white-balance-sunny::before {
  content: "\\F05A8";
}

.mdi-widgets::before {
  content: "\\F072C";
}

.mdi-widgets-outline::before {
  content: "\\F1355";
}

.mdi-wifi::before {
  content: "\\F05A9";
}

.mdi-wifi-alert::before {
  content: "\\F16B5";
}

.mdi-wifi-arrow-down::before {
  content: "\\F16B6";
}

.mdi-wifi-arrow-left::before {
  content: "\\F16B7";
}

.mdi-wifi-arrow-left-right::before {
  content: "\\F16B8";
}

.mdi-wifi-arrow-right::before {
  content: "\\F16B9";
}

.mdi-wifi-arrow-up::before {
  content: "\\F16BA";
}

.mdi-wifi-arrow-up-down::before {
  content: "\\F16BB";
}

.mdi-wifi-cancel::before {
  content: "\\F16BC";
}

.mdi-wifi-check::before {
  content: "\\F16BD";
}

.mdi-wifi-cog::before {
  content: "\\F16BE";
}

.mdi-wifi-lock::before {
  content: "\\F16BF";
}

.mdi-wifi-lock-open::before {
  content: "\\F16C0";
}

.mdi-wifi-marker::before {
  content: "\\F16C1";
}

.mdi-wifi-minus::before {
  content: "\\F16C2";
}

.mdi-wifi-off::before {
  content: "\\F05AA";
}

.mdi-wifi-plus::before {
  content: "\\F16C3";
}

.mdi-wifi-refresh::before {
  content: "\\F16C4";
}

.mdi-wifi-remove::before {
  content: "\\F16C5";
}

.mdi-wifi-settings::before {
  content: "\\F16C6";
}

.mdi-wifi-star::before {
  content: "\\F0E0B";
}

.mdi-wifi-strength-1::before {
  content: "\\F091F";
}

.mdi-wifi-strength-1-alert::before {
  content: "\\F0920";
}

.mdi-wifi-strength-1-lock::before {
  content: "\\F0921";
}

.mdi-wifi-strength-1-lock-open::before {
  content: "\\F16CB";
}

.mdi-wifi-strength-2::before {
  content: "\\F0922";
}

.mdi-wifi-strength-2-alert::before {
  content: "\\F0923";
}

.mdi-wifi-strength-2-lock::before {
  content: "\\F0924";
}

.mdi-wifi-strength-2-lock-open::before {
  content: "\\F16CC";
}

.mdi-wifi-strength-3::before {
  content: "\\F0925";
}

.mdi-wifi-strength-3-alert::before {
  content: "\\F0926";
}

.mdi-wifi-strength-3-lock::before {
  content: "\\F0927";
}

.mdi-wifi-strength-3-lock-open::before {
  content: "\\F16CD";
}

.mdi-wifi-strength-4::before {
  content: "\\F0928";
}

.mdi-wifi-strength-4-alert::before {
  content: "\\F0929";
}

.mdi-wifi-strength-4-lock::before {
  content: "\\F092A";
}

.mdi-wifi-strength-4-lock-open::before {
  content: "\\F16CE";
}

.mdi-wifi-strength-alert-outline::before {
  content: "\\F092B";
}

.mdi-wifi-strength-lock-open-outline::before {
  content: "\\F16CF";
}

.mdi-wifi-strength-lock-outline::before {
  content: "\\F092C";
}

.mdi-wifi-strength-off::before {
  content: "\\F092D";
}

.mdi-wifi-strength-off-outline::before {
  content: "\\F092E";
}

.mdi-wifi-strength-outline::before {
  content: "\\F092F";
}

.mdi-wifi-sync::before {
  content: "\\F16C7";
}

.mdi-wikipedia::before {
  content: "\\F05AC";
}

.mdi-wind-power::before {
  content: "\\F1A88";
}

.mdi-wind-power-outline::before {
  content: "\\F1A89";
}

.mdi-wind-turbine::before {
  content: "\\F0DA5";
}

.mdi-wind-turbine-alert::before {
  content: "\\F19AB";
}

.mdi-wind-turbine-check::before {
  content: "\\F19AC";
}

.mdi-window-close::before {
  content: "\\F05AD";
}

.mdi-window-closed::before {
  content: "\\F05AE";
}

.mdi-window-closed-variant::before {
  content: "\\F11DB";
}

.mdi-window-maximize::before {
  content: "\\F05AF";
}

.mdi-window-minimize::before {
  content: "\\F05B0";
}

.mdi-window-open::before {
  content: "\\F05B1";
}

.mdi-window-open-variant::before {
  content: "\\F11DC";
}

.mdi-window-restore::before {
  content: "\\F05B2";
}

.mdi-window-shutter::before {
  content: "\\F111C";
}

.mdi-window-shutter-alert::before {
  content: "\\F111D";
}

.mdi-window-shutter-auto::before {
  content: "\\F1BA3";
}

.mdi-window-shutter-cog::before {
  content: "\\F1A8A";
}

.mdi-window-shutter-open::before {
  content: "\\F111E";
}

.mdi-window-shutter-settings::before {
  content: "\\F1A8B";
}

.mdi-windsock::before {
  content: "\\F15FA";
}

.mdi-wiper::before {
  content: "\\F0AE9";
}

.mdi-wiper-wash::before {
  content: "\\F0DA6";
}

.mdi-wiper-wash-alert::before {
  content: "\\F18DF";
}

.mdi-wizard-hat::before {
  content: "\\F1477";
}

.mdi-wordpress::before {
  content: "\\F05B4";
}

.mdi-wrap::before {
  content: "\\F05B6";
}

.mdi-wrap-disabled::before {
  content: "\\F0BDF";
}

.mdi-wrench::before {
  content: "\\F05B7";
}

.mdi-wrench-check::before {
  content: "\\F1B8F";
}

.mdi-wrench-check-outline::before {
  content: "\\F1B90";
}

.mdi-wrench-clock::before {
  content: "\\F19A3";
}

.mdi-wrench-clock-outline::before {
  content: "\\F1B93";
}

.mdi-wrench-cog::before {
  content: "\\F1B91";
}

.mdi-wrench-cog-outline::before {
  content: "\\F1B92";
}

.mdi-wrench-outline::before {
  content: "\\F0BE0";
}

.mdi-xamarin::before {
  content: "\\F0845";
}

.mdi-xml::before {
  content: "\\F05C0";
}

.mdi-xmpp::before {
  content: "\\F07FF";
}

.mdi-yahoo::before {
  content: "\\F0B4F";
}

.mdi-yeast::before {
  content: "\\F05C1";
}

.mdi-yin-yang::before {
  content: "\\F0680";
}

.mdi-yoga::before {
  content: "\\F117C";
}

.mdi-youtube::before {
  content: "\\F05C3";
}

.mdi-youtube-gaming::before {
  content: "\\F0848";
}

.mdi-youtube-studio::before {
  content: "\\F0847";
}

.mdi-youtube-subscription::before {
  content: "\\F0D40";
}

.mdi-youtube-tv::before {
  content: "\\F0448";
}

.mdi-yurt::before {
  content: "\\F1516";
}

.mdi-z-wave::before {
  content: "\\F0AEA";
}

.mdi-zend::before {
  content: "\\F0AEB";
}

.mdi-zigbee::before {
  content: "\\F0D41";
}

.mdi-zip-box::before {
  content: "\\F05C4";
}

.mdi-zip-box-outline::before {
  content: "\\F0FFA";
}

.mdi-zip-disk::before {
  content: "\\F0A23";
}

.mdi-zodiac-aquarius::before {
  content: "\\F0A7D";
}

.mdi-zodiac-aries::before {
  content: "\\F0A7E";
}

.mdi-zodiac-cancer::before {
  content: "\\F0A7F";
}

.mdi-zodiac-capricorn::before {
  content: "\\F0A80";
}

.mdi-zodiac-gemini::before {
  content: "\\F0A81";
}

.mdi-zodiac-leo::before {
  content: "\\F0A82";
}

.mdi-zodiac-libra::before {
  content: "\\F0A83";
}

.mdi-zodiac-pisces::before {
  content: "\\F0A84";
}

.mdi-zodiac-sagittarius::before {
  content: "\\F0A85";
}

.mdi-zodiac-scorpio::before {
  content: "\\F0A86";
}

.mdi-zodiac-taurus::before {
  content: "\\F0A87";
}

.mdi-zodiac-virgo::before {
  content: "\\F0A88";
}

.mdi-blank::before {
  content: "\\f68c";
  visibility: hidden;
}

.mdi-18px.mdi-set, .mdi-18px.mdi:before {
  font-size: 18px;
}

.mdi-24px.mdi-set, .mdi-24px.mdi:before {
  font-size: 24px;
}

.mdi-36px.mdi-set, .mdi-36px.mdi:before {
  font-size: 36px;
}

.mdi-48px.mdi-set, .mdi-48px.mdi:before {
  font-size: 48px;
}

.mdi-dark:before {
  color: rgba(0, 0, 0, 0.54);
}
.mdi-dark.mdi-inactive:before {
  color: rgba(0, 0, 0, 0.26);
}

.mdi-light:before {
  color: rgb(255, 255, 255);
}
.mdi-light.mdi-inactive:before {
  color: rgba(255, 255, 255, 0.3);
}

.mdi-rotate-45 {
  /*
  // Not included in production
  &.mdi-flip-h:before {
      -webkit-transform: scaleX(-1) rotate(45deg);
      transform: scaleX(-1) rotate(45deg);
      filter: FlipH;
      -ms-filter: "FlipH";
  }
  &.mdi-flip-v:before {
      -webkit-transform: scaleY(-1) rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: scaleY(-1) rotate(45deg);
      filter: FlipV;
      -ms-filter: "FlipV";
  }
  */
}
.mdi-rotate-45:before {
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.mdi-rotate-90 {
  /*
  // Not included in production
  &.mdi-flip-h:before {
      -webkit-transform: scaleX(-1) rotate(90deg);
      transform: scaleX(-1) rotate(90deg);
      filter: FlipH;
      -ms-filter: "FlipH";
  }
  &.mdi-flip-v:before {
      -webkit-transform: scaleY(-1) rotate(90deg);
      -ms-transform: rotate(90deg);
      transform: scaleY(-1) rotate(90deg);
      filter: FlipV;
      -ms-filter: "FlipV";
  }
  */
}
.mdi-rotate-90:before {
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
}

.mdi-rotate-135 {
  /*
  // Not included in production
  &.mdi-flip-h:before {
      -webkit-transform: scaleX(-1) rotate(135deg);
      transform: scaleX(-1) rotate(135deg);
      filter: FlipH;
      -ms-filter: "FlipH";
  }
  &.mdi-flip-v:before {
      -webkit-transform: scaleY(-1) rotate(135deg);
      -ms-transform: rotate(135deg);
      transform: scaleY(-1) rotate(135deg);
      filter: FlipV;
      -ms-filter: "FlipV";
  }
  */
}
.mdi-rotate-135:before {
  -webkit-transform: rotate(135deg);
  -ms-transform: rotate(135deg);
  transform: rotate(135deg);
}

.mdi-rotate-180 {
  /*
  // Not included in production
  &.mdi-flip-h:before {
      -webkit-transform: scaleX(-1) rotate(180deg);
      transform: scaleX(-1) rotate(180deg);
      filter: FlipH;
      -ms-filter: "FlipH";
  }
  &.mdi-flip-v:before {
      -webkit-transform: scaleY(-1) rotate(180deg);
      -ms-transform: rotate(180deg);
      transform: scaleY(-1) rotate(180deg);
      filter: FlipV;
      -ms-filter: "FlipV";
  }
  */
}
.mdi-rotate-180:before {
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}

.mdi-rotate-225 {
  /*
  // Not included in production
  &.mdi-flip-h:before {
      -webkit-transform: scaleX(-1) rotate(225deg);
      transform: scaleX(-1) rotate(225deg);
      filter: FlipH;
      -ms-filter: "FlipH";
  }
  &.mdi-flip-v:before {
      -webkit-transform: scaleY(-1) rotate(225deg);
      -ms-transform: rotate(225deg);
      transform: scaleY(-1) rotate(225deg);
      filter: FlipV;
      -ms-filter: "FlipV";
  }
  */
}
.mdi-rotate-225:before {
  -webkit-transform: rotate(225deg);
  -ms-transform: rotate(225deg);
  transform: rotate(225deg);
}

.mdi-rotate-270 {
  /*
  // Not included in production
  &.mdi-flip-h:before {
      -webkit-transform: scaleX(-1) rotate(270deg);
      transform: scaleX(-1) rotate(270deg);
      filter: FlipH;
      -ms-filter: "FlipH";
  }
  &.mdi-flip-v:before {
      -webkit-transform: scaleY(-1) rotate(270deg);
      -ms-transform: rotate(270deg);
      transform: scaleY(-1) rotate(270deg);
      filter: FlipV;
      -ms-filter: "FlipV";
  }
  */
}
.mdi-rotate-270:before {
  -webkit-transform: rotate(270deg);
  -ms-transform: rotate(270deg);
  transform: rotate(270deg);
}

.mdi-rotate-315 {
  /*
  // Not included in production
  &.mdi-flip-h:before {
      -webkit-transform: scaleX(-1) rotate(315deg);
      transform: scaleX(-1) rotate(315deg);
      filter: FlipH;
      -ms-filter: "FlipH";
  }
  &.mdi-flip-v:before {
      -webkit-transform: scaleY(-1) rotate(315deg);
      -ms-transform: rotate(315deg);
      transform: scaleY(-1) rotate(315deg);
      filter: FlipV;
      -ms-filter: "FlipV";
  }
  */
}
.mdi-rotate-315:before {
  -webkit-transform: rotate(315deg);
  -ms-transform: rotate(315deg);
  transform: rotate(315deg);
}

.mdi-flip-h:before {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
  filter: FlipH;
  -ms-filter: "FlipH";
}

.mdi-flip-v:before {
  -webkit-transform: scaleY(-1);
  transform: scaleY(-1);
  filter: FlipV;
  -ms-filter: "FlipV";
}

.mdi-spin:before {
  -webkit-animation: mdi-spin 2s infinite linear;
  animation: mdi-spin 2s infinite linear;
}

@-webkit-keyframes mdi-spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
@keyframes mdi-spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
/* Clear inner floats */
.clearfix::after {
  clear: both;
  content: "";
  display: table;
}

body {
  overflow-x: hidden;
}

video {
  width: 100%;
  height: auto;
}

/*Override bootstrap container for 1200px and up */
@media (min-width: 1460px) {
  .container {
    max-width: 1420px;
  }
}

.container-fluid, .container-sm, .container-md, .container-lg, .container-xl {
  max-width: 2560px;
}

/* Make all blocks float to the left and clear duplicate paddings caused by nested Bootstrap's column */
div.block {
  display: inline-block;
  vertical-align: top;
}

div.displaymode-screen, div.faqitemblock, div.shortinfoitemblock, div.shortinfolinkblock {
  padding-left: 0;
  padding-right: 0;
}

hr {
  color: #C4C4C4;
}

.filters-tag {
  position: relative;
  border-radius: 3px;
  background-color: #ddd;
  color: black;
  font-size: 12px;
  padding: 5px 20px 5px 10px;
  margin-bottom: 0;
}
.filters-tag__remove {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  text-align: right;
  padding-right: 5px;
  padding-top: 2px;
}

.content-filters-tag {
  position: relative;
  border-radius: 3px;
  background-color: #ddd;
  color: black;
  font-size: 16px;
  padding: 5px 10px 5px 10px;
  margin-bottom: 0;
}

.hidden {
  display: none;
}

.style-list-none {
  list-style: none;
  padding: 0;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.flex-between {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.flex-start {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.flex-end {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.pull-right {
  float: right;
}

.border {
  border: 1px solid #eeeeee;
}

.border-radius-none {
  border-radius: 0;
}

.link {
  text-decoration: none;
  color: #61A0A8;
  padding-right: 15px;
}
.link:hover {
  text-decoration: none;
  color: #004564;
  opacity: 0.7;
}

.square-box {
  border-radius: 0;
}

.cursor-pointer {
  cursor: pointer;
}

.full-width {
  width: 100%;
}

.align-center {
  text-align: center;
}

.success {
  padding: 15px;
  background-color: #DFF0D8;
  color: #468847;
}

.error {
  padding: 15px;
  background-color: #F2DEDE;
  color: #B94A48;
}

ul.none-style-type {
  list-style-type: none;
}

.disabled {
  pointer-events: none;
  cursor: default;
  background-color: grey;
  border: 0;
}

.modal-open {
  overflow-y: auto;
  padding-right: 0 !important;
}

.cssload-container {
  width: 100%;
  height: 50px;
  text-align: center;
}

.cssload-double-torus {
  width: 50px;
  height: 50px;
  margin: 0 auto;
  border: 4px double;
  border-radius: 50%;
  border-color: transparent #440099 #440099;
  animation: cssload-spin 1500ms infinite linear;
  -o-animation: cssload-spin 1500ms infinite linear;
  -ms-animation: cssload-spin 1500ms infinite linear;
  -webkit-animation: cssload-spin 1500ms infinite linear;
  -moz-animation: cssload-spin 1500ms infinite linear;
}

@keyframes cssload-spin {
  100% {
    transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-o-keyframes cssload-spin {
  100% {
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-ms-keyframes cssload-spin {
  100% {
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-webkit-keyframes cssload-spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-moz-keyframes cssload-spin {
  100% {
    -moz-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
body {
  color: #242829;
  font-size: 16px;
  font-family: "Open Sans", sans-serif;
  line-height: 26px;
}

.title {
  color: #242829;
}

.sub-title {
  color: #242829;
  font-size: 80%;
}

.light-text {
  color: grey;
}

.content {
  color: #666666;
}

.color-light {
  color: #E6F3EF;
}

.color-dark {
  color: #242829;
}

.color-ltGreen {
  color: #61A0A8;
}

.font-italic {
  font-style: italic;
}

.cursor-pointer {
  cursor: pointer;
}

.light-svg {
  fill: grey;
  color: white;
}

.light-border-svg {
  fill: white;
  color: grey;
}

.required {
  color: red;
  font-weight: bold;
}

.error {
  margin-bottom: 15px;
}

li.current {
  font-weight: bold;
  background-color: #f5f5f5;
}

.word-break {
  word-break: break-word;
}

.download-file {
  color: steelblue;
}
.download-file:hover {
  color: steelblue;
}

h2, h4, h5, h6 {
  font-weight: 600;
}

.body-1 {
  font-size: 1.125rem;
  line-height: 2rem;
}

.image-caption {
  font-size: 0.875rem;
  line-height: 1.375rem;
  font-weight: 600;
}

@media (max-width: 767.98px) {
  body {
    font-size: 14px;
    line-height: 24px;
  }
  .body-1 {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.font-weight-semi-bold {
  font-weight: 600;
}

.smaller-body-text {
  line-height: 175%;
  font-size: 80%;
}

.navigation-bar {
  width: 100%;
  height: 70px;
}

.cd-nav {
  display: none;
}

.showMenuOnMobile {
  display: none !important;
}

.navigation__logo {
  display: flex;
  align-items: center;
  width: 20%;
}

.cd-nav ol, .cd-nav ul {
  list-style: none;
}

.cd-nav dl, .cd-nav dt, .cd-nav dd, .cd-nav ol, .cd-nav ul, .cd-nav li {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 15px;
  vertical-align: baseline;
}

@media only screen and (min-width: 1170px) {
  .cd-primary-nav > li {
    float: left;
    /*margin-left: 1.6em;*/
  }
}
@media only screen and (max-width: 1169px) {
  body.nav-on-left.overflow-cart-hidden {
    overflow: hidden;
  }
  .hideMenuOnMobile {
    display: none !important;
  }
  .showMenuOnMobile {
    display: block !important;
  }
}
@media only screen and (max-width: 1169px) {
  #cd-primary-nav {
    -webkit-transform: translateX(-80vw);
    -moz-transform: translateX(-80vw);
    -ms-transform: translateX(-80vw);
    -o-transform: translateX(-80vw);
    transform: translateX(-80vw);
  }
  #cd-primary-nav.nav-is-visible {
    -webkit-transform: translateX(0vw);
    -moz-transform: translateX(0vw);
    -ms-transform: translateX(0vw);
    -o-transform: translateX(0vw);
    transform: translateX(0vw);
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.6);
  }
  .cd-nav {
    width: 0;
  }
}
@media only screen and (max-width: 767px) {
  .nav-on-left .cd-main-content.nav-is-visible, .nav-on-left .cd-main-header.nav-is-visible {
    -webkit-transform: translateX(0vw);
    -moz-transform: translateX(0vw);
    -ms-transform: translateX(0vw);
    -o-transform: translateX(0vw);
    transform: translateX(0vw);
  }
}
.cd-primary-nav, .cd-primary-nav ul {
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: 80vw;
  background: #ffffff;
  overflow: auto;
  z-index: 10;
  -webkit-overflow-scrolling: touch;
  /* Force Hardware Acceleration in WebKit */
  -webkit-transform: translateX(0);
  -moz-transform: translateX(0);
  -ms-transform: translateX(0);
  -o-transform: translateX(0);
  transform: translateX(0);
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-transition: -webkit-transform 0.3s;
  -moz-transition: -moz-transform 0.3s;
  transition: transform 0.3s;
}

@media only screen and (min-width: 768px) {
  .cd-primary-nav, .cd-primary-nav ul {
    width: 50vw;
  }
}
.cd-primary-nav a, .cd-primary-nav ul a {
  display: block;
  height: 67px;
  line-height: 67px;
  padding: 0 32px;
  color: #494949;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-bottom: 1px solid rgba(238, 236, 237, 0.5);
  will-change: transform, opacity;
  -webkit-transition: -webkit-transform 0.3s, opacity 0.3s;
  -moz-transition: -moz-transform 0.3s, opacity 0.3s;
  transition: transform 0.3s, opacity 0.3s;
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);
}

.cd-primary-nav.is-hidden, .cd-primary-nav ul.is-hidden {
  -webkit-transform: translateX(100%);
  -moz-transform: translateX(100%);
  -ms-transform: translateX(100%);
  -o-transform: translateX(100%);
  transform: translateX(100%);
}

.cd-primary-nav.moves-out > li > a, .cd-primary-nav ul.moves-out > li > a {
  -webkit-transform: translateX(-100%);
  -moz-transform: translateX(-100%);
  -ms-transform: translateX(-100%);
  -o-transform: translateX(-100%);
  transform: translateX(-100%);
  opacity: 0;
}

@media only screen and (max-width: 1169px) {
  .nav-on-left .cd-primary-nav, .nav-on-left .cd-primary-nav ul {
    right: auto;
    left: 0;
  }
  .cd-overlay {
    z-index: 11;
  }
}
.cd-primary-nav .see-all a {
  color: #69aa6f;
}

@media only screen and (max-width: 1169px) {
  .cd-primary-nav.nav-is-hidden {
    visibility: hidden;
    -webkit-transition: -webkit-transform 0.3s;
    -moz-transition: -moz-transform 0.3s;
    transition: transform 0.3s;
  }
  .cd-primary-nav.nav-is-visible {
    visibility: visible;
    -webkit-transition: -webkit-transform 0.3s;
    -moz-transition: -moz-transform 0.3s;
    transition: transform 0.3s;
  }
}
.zzMainHeader {
  height: 60px !important;
}

@media only screen and (min-width: 1170px) {
  .cd-primary-nav {
    position: static !important;
    padding: 0 150px 0 0 !important;
    height: auto !important;
    min-height: 70px !important;
    width: 100% !important;
    float: right !important;
    overflow: visible !important;
    background: transparent !important;
  }
  .zzMainHeader {
    height: 70px !important;
  }
  .cd-primary-nav::after {
    clear: both;
    content: "";
    display: table;
  }
  .cd-primary-nav.moves-out > li > a {
    -webkit-transform: translateX(0);
    -moz-transform: translateX(0);
    -ms-transform: translateX(0);
    -o-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
  .cd-primary-nav ul {
    position: static;
    height: auto;
    width: auto;
    background: transparent;
    overflow: visible;
    z-index: 3;
  }
  .cd-primary-nav ul.is-hidden {
    -webkit-transform: translateX(0);
    -moz-transform: translateX(0);
    -ms-transform: translateX(0);
    -o-transform: translateX(0);
    transform: translateX(0);
  }
  .cd-primary-nav ul.moves-out > li > a {
    -webkit-transform: translateX(0);
    -moz-transform: translateX(0);
    -ms-transform: translateX(0);
    -o-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
  .cd-primary-nav > li {
    float: left;
  }
  .cd-primary-nav > li > a {
    position: relative;
    display: inline-block;
    height: 70px;
    line-height: 70px;
    padding: 0 10px;
    color: #494949;
    overflow: visible;
    border-bottom: none;
    -webkit-transition: color 0.3s, box-shadow 0.3s;
    -moz-transition: color 0.3s, box-shadow 0.3s;
    transition: color 0.3s, box-shadow 0.3s;
  }
  .cd-primary-nav > li > a:hover {
    color: #440099;
  }
  .cd-primary-nav > li > a.selected, .cd-primary-nav > li > a:hover {
    color: #440099;
    box-shadow: inset 0 -2px 0 #440099;
  }
  .cd-primary-nav .go-back, .cd-primary-nav .see-all, .mobileSubMenuHeader {
    display: none;
  }
  .cd-primary-nav .cd-secondary-nav {
    /* dropdown menu style */
    position: absolute;
    top: 70px;
    width: 100vw;
    height: 530px;
    background: #ffffff;
    padding: 60px calc((100vw - 1440px) / 2);
    box-shadow: inset 0 1px 0 #e2e3df, 0 3px 6px rgba(0, 0, 0, 0.05);
    -webkit-transition: opacity 0.3s 0s, visibility 0s 0s;
    -moz-transition: opacity 0.3s 0s, visibility 0s 0s;
    transition: opacity 0.3s 0s, visibility 0s 0s;
    -webkit-transform: translateX(0);
    -moz-transform: translateX(0);
    -ms-transform: translateX(0);
    -o-transform: translateX(0);
    transform: translateX(0);
  }
  .cd-primary-nav .cd-secondary-nav::after {
    clear: both;
    content: "";
    display: table;
  }
  .cd-primary-nav .cd-secondary-nav.is-hidden {
    opacity: 0;
    visibility: hidden;
    -webkit-transition: opacity 0.3s 0s, visibility 0s 0.3s;
    -moz-transition: opacity 0.3s 0s, visibility 0s 0.3s;
    transition: opacity 0.3s 0s, visibility 0s 0.3s;
  }
  .cd-primary-nav .cd-secondary-nav > .see-all {
    /* this is the BIG See all button at the bottom of the dropdown menu */
    display: block;
    position: absolute;
    left: 0;
    bottom: 0;
    height: 65px;
    width: 100%;
    overflow: hidden;
    /* reset some inherited style */
    margin: 0;
    padding: 0;
  }
  .cd-primary-nav .cd-secondary-nav > .see-all a {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    font-size: 15px;
    font-weight: bold;
    text-align: center;
    line-height: 65px;
    /* reset some inherited style */
    border-bottom: none;
    margin: 0;
    padding: 0;
    background: #440099;
    -webkit-transition: color 0.2s, background 0.2s, border 0.2s;
    -moz-transition: color 0.2s, background 0.2s, border 0.2s;
    transition: color 0.2s, background 0.2s, border 0.2s;
    color: #ffffff;
  }
  .cd-primary-nav .cd-secondary-nav > .see-all a:hover {
    background: #440099;
    border-color: #2e3233;
    color: #ffffff;
  }
  .cd-primary-nav .cd-secondary-nav > li {
    height: auto;
    width: 260px;
    float: left;
    overflow: hidden;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
  }
  .cd-primary-nav .cd-secondary-nav > li:nth-child(4n+2) {
    margin-right: 0;
    border-right: none;
  }
  .cd-primary-nav .cd-secondary-nav > li > a {
    color: #494949;
    font-weight: 600;
    font-size: 15px;
  }
  .see-all a {
    color: #fff;
  }
  .cd-primary-nav .cd-secondary-nav a {
    height: 27px;
    line-height: 27px;
    padding: 0 18% 0 0;
    color: #2e3233;
    border-bottom: none;
    font-size: 15px;
    font-weight: normal;
    -webkit-transition: all 0.3s, -webkit-transform 0.3s;
    -moz-transition: all 0.3s, -moz-transform 0.3s;
    transition: all 0.3s, transform 0.3s;
  }
  .cd-primary-nav .cd-secondary-nav a:hover {
    color: #440099;
    text-shadow: 2px 4px 2px rgba(0, 0, 0, 0.09);
  }
  .cd-primary-nav .cd-secondary-nav ul {
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    -ms-transform: translateZ(0);
    -o-transform: translateZ(0);
    transform: translateZ(0);
  }
  .cd-primary-nav .cd-secondary-nav ul ul {
    /* tertiary navigation */
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }
  .cd-primary-nav .cd-secondary-nav ul ul.is-hidden {
    -webkit-transform: translateX(100%);
    -moz-transform: translateX(100%);
    -ms-transform: translateX(100%);
    -o-transform: translateX(100%);
    transform: translateX(100%);
  }
  .cd-primary-nav .cd-secondary-nav ul ul .go-back {
    display: block;
  }
  .cd-primary-nav .cd-secondary-nav ul ul .see-all {
    display: block;
  }
  .cd-primary-nav .cd-secondary-nav .moves-out > li > a {
    /* push the navigation items to the left - and lower down opacity - when tertiary nav slides in */
    -webkit-transform: translateX(-100%);
    -moz-transform: translateX(-100%);
    -ms-transform: translateX(-100%);
    -o-transform: translateX(-100%);
    transform: translateX(-100%);
  }
}
.has-children > a, .go-back a {
  position: relative;
}

@media only screen and (max-width: 1169px) {
  ul.cd-primary-nav ul, ul.cd-primary-nav ul ul {
    z-index: 1;
    display: none;
  }
  ul.nav-is-visible ul, ul.nav-is-visible ul ul {
    z-index: 10;
    display: block;
  }
  .has-children > a::before, .has-children > a::after, .go-back a::before, .go-back a::after {
    content: "";
    position: absolute;
    top: 50%;
    margin-top: -1px;
    display: inline-block;
    height: 2px;
    width: 10px;
    background: #22004d;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
  }
  .has-children > a::before, .go-back a::before {
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  .has-children > a::after, .go-back a::after {
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
  .has-children > a {
    padding-right: 40px;
    font-weight: 600;
  }
  .has-children > a::before, .has-children > a::after {
    right: 20px;
    -webkit-transform-origin: 9px 50%;
    -moz-transform-origin: 9px 50%;
    -ms-transform-origin: 9px 50%;
    -o-transform-origin: 9px 50%;
    transform-origin: 9px 50%;
  }
  .cd-primary-nav .go-back a {
    padding-left: 40px;
    font-weight: 600;
  }
  .cd-primary-nav .go-back a::before, .cd-primary-nav .go-back a::after {
    left: 20px;
    -webkit-transform-origin: 1px 50%;
    -moz-transform-origin: 1px 50%;
    -ms-transform-origin: 1px 50%;
    -o-transform-origin: 1px 50%;
    transform-origin: 1px 50%;
  }
}
@media only screen and (min-width: 1170px) {
  .is-third-level {
    cursor: pointer;
  }
  .has-children.is-third-level > a::before, .has-children.is-third-level > a::after, .go-back a::before, .go-back a::after {
    background: #a2a6a7;
    right: 15%;
    -webkit-transform-origin: 8px 50%;
    -moz-transform-origin: 8px 50%;
    -ms-transform-origin: 8px 50%;
    -o-transform-origin: 8px 50%;
    transform-origin: 8px 50%;
  }
  .has-children.is-third-level > a:hover::before, .has-children.is-third-level > a:hover::after, .go-back a:hover::before, .go-back a:hover::after {
    background: #440099;
  }
  .has-children.is-third-level > a::before, .go-back a::before {
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  .has-children.is-third-level > a::after, .go-back a::after {
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
  .has-children.is-third-level > a::before, .has-children.is-third-level > a::after, .go-back a::before, .go-back a::after {
    content: "";
    position: absolute;
    top: 50%;
    margin-top: -1px;
    display: inline-block;
    height: 1px;
    width: 8px;
    background: #a2a6a7;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
  }
  .cd-primary-nav .go-back a::before, .cd-primary-nav .go-back a::after {
    left: 1px;
  }
  .cd-primary-nav .go-back.bg-light {
    background-color: transparent !important;
  }
  .cd-primary-nav .go-back a span {
    display: none;
  }
  .cd-primary-nav .go-back a::before, .cd-primary-nav .go-back a::after {
    -webkit-transform-origin: 1px 50%;
    -moz-transform-origin: 1px 50%;
    -ms-transform-origin: 1px 50%;
    -o-transform-origin: 1px 50%;
    transform-origin: 1px 50%;
  }
}
.cd-overlay {
  /* shadow layer visible when navigation is active */
  position: fixed;
  z-index: 2;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.5);
  visibility: hidden;
  opacity: 0;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transition: opacity 0.3s 0s, visibility 0s 0.3s, -webkit-transform 0.3s 0s;
  -moz-transition: opacity 0.3s 0s, visibility 0s 0.3s, -moz-transform 0.3s 0s;
  transition: opacity 0.3s 0s, visibility 0s 0.3s, transform 0.3s 0s;
}

.cd-overlay.is-visible {
  opacity: 1;
  visibility: visible;
  -webkit-transition: opacity 0.3s 0s, visibility 0s 0s, -webkit-transform 0.3s 0s;
  -moz-transition: opacity 0.3s 0s, visibility 0s 0s, -moz-transform 0.3s 0s;
  transition: opacity 0.3s 0s, visibility 0s 0s, transform 0.3s 0s;
}

@media only screen and (max-width: 1169px) {
  .cd-overlay {
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 11;
  }
}
@media only screen and (max-width: 1169px) {
  .nav-on-left .cd-overlay.is-visible {
    -webkit-transform: translateX(50vw);
    -moz-transform: translateX(50vw);
    -ms-transform: translateX(50vw);
    -o-transform: translateX(50vw);
    transform: translateX(50vw);
  }
}
@media only screen and (max-width: 767px) {
  .nav-on-left .cd-overlay.is-visible {
    -webkit-transform: translateX(80vw);
    -moz-transform: translateX(80vw);
    -ms-transform: translateX(80vw);
    -o-transform: translateX(80vw);
    transform: translateX(80vw);
  }
}
.uspContainer {
  width: 500px;
  height: 529px;
  position: absolute;
  padding: 30px;
  top: 1px;
  background-color: #FBF8F5;
}
.uspContainer h3.uspHeader {
  font-weight: 600;
  font-size: 21px;
  line-height: 29px;
  letter-spacing: 0.3px;
  color: #E5A934;
  margin-bottom: 13px;
}
.uspContainer .uspPayoff {
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  color: #000000;
  margin-bottom: 8px;
}
.uspContainer .usp-list {
  margin-left: 26px;
  padding-left: 22px;
  margin-top: 20px;
  margin-bottom: 20px;
}
.uspContainer .usp-list li {
  font-size: 15px;
  line-height: 20px;
  letter-spacing: 0.3px;
  font-weight: normal;
  font-style: normal;
  color: #000;
  display: block;
  margin-top: 4px;
}
.uspContainer .usp-list li a {
  display: inline;
  color: #440099;
  text-decoration: underline;
}
.uspContainer .usp-list li:before {
  content: "\\f0e1e";
  font-family: "Material Design Icons";
  font-size: 14px;
  margin-left: -26px;
  float: left;
  margin-top: 2px;
  color: #000;
  font-style: normal;
}

@media (max-width: 1299px) {
  .uspContainer, .menuImageSprite {
    width: 450px;
  }
}
/* -------------------------------- 
support for no js 
-------------------------------- */
.no-js .cd-primary-nav {
  position: relative;
  height: auto;
  width: 100%;
  overflow: visible;
  visibility: visible;
  z-index: 2;
}

@media only screen and (min-width: 1170px) {
  .no-js .cd-primary-nav {
    position: absolute;
    z-index: 3;
    display: inline-block;
    width: auto;
    top: 0;
    right: 150px;
    padding: 0;
  }
  .no-js .nav-is-fixed .cd-primary-nav {
    position: fixed;
  }
}
.menuImageSprite {
  display: none;
}

@media only screen and (min-width: 1170px) {
  .firstMainMenuItem {
    margin-left: 17em !important;
  }
  .menuImageSprite {
    width: 450px !important;
    height: 450px !important;
    margin-top: -50px !important;
    -webkit-transition: opacity 0.25s ease-in;
    -moz-transition: opacity 0.25s ease-in;
    -ms-transition: opacity 0.25s ease-in;
    -o-transition: opacity 0.25s ease-in;
    transition: opacity 0.25s ease-in;
    background-size: cover;
    background-repeat: no-repeat;
    display: block;
  }
}
@media only screen and (max-width: 1280px) {
  .menuImageSprite {
    width: 450px !important;
  }
}
@media only screen and (min-width: 1700px) {
  .firstMainMenuItem {
    margin-left: calc((100vw - 1700px) / 2 + 17em) !important;
  }
}
.menuPosition {
  position: absolute;
}

@media only screen and (max-width: 1169px) {
  .menuPosition {
    height: auto !important;
    top: auto !important;
    left: auto !important;
    position: relative !important;
  }
}
.mobileMetaMenu, .mobileMenuHeader {
  display: none;
}

@media (max-width: 1169px) {
  .mobileMetaMenu {
    display: block;
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 19px;
    letter-spacing: 0.2px;
    vertical-align: baseline;
  }
  .mobileMetaMenu .mdi {
    line-height: 54px;
  }
  .mobileMetaMenu .mdi::before {
    padding-left: 0;
  }
  .mobileMetaMenu a {
    display: block;
    height: 67px;
    line-height: 67px;
    padding: 0 32px;
    color: #0095DB;
    font-weight: 500;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    will-change: transform, opacity;
    -webkit-transition: -webkit-transform 0.3s, opacity 0.3s;
    -moz-transition: -moz-transform 0.3s, opacity 0.3s;
    transition: transform 0.3s, opacity 0.3s;
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    -ms-transform: translateZ(0);
    -o-transform: translateZ(0);
    transform: translateZ(0);
  }
  .mobileMetaMenu .mdi:before {
    font-size: 18px;
    position: relative;
    top: 1px;
    margin-right: 3px;
  }
  .mobileMenuHeader {
    display: block;
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 19px;
    letter-spacing: 0.2px;
    vertical-align: baseline;
  }
  .mobileMenuHeader div {
    padding: 21px 32px;
    line-height: 25px;
    height: 67px;
    border-bottom: 1px solid rgba(238, 236, 237, 0.5);
    font-weight: 600;
  }
  .mobileMenuHeader div a {
    height: auto;
    line-height: normal;
    padding: 3px;
    border: 0;
    color: #440099;
  }
}
@media (min-width: 1170px) {
  .mobileMetaMenu.viewAllTopLevel {
    display: block;
    top: 470px;
    left: 50vw;
    position: absolute;
  }
}
@media (min-width: 1170px) and (max-width: 1340px) {
  .firstMainMenuItem {
    margin-left: 18em !important;
  }
  .cd-primary-nav > li > a {
    padding: 0 5px !important;
  }
  .cd-nav li {
    font-size: 13px !important;
  }
}
a.jump-to-main-content {
  position: absolute;
  left: -1500px;
  width: 1px;
  height: 1px;
}
a.jump-to-main-content:focus, a.jump-to-main-content:active {
  color: #fff;
  background-color: #000;
  left: auto;
  top: auto;
  width: 30%;
  height: auto;
  overflow: auto;
  margin: 10px 35%;
  padding: 5px;
  border-radius: 15px;
  border: 4px solid yellow;
  text-align: center;
  font-size: 1.2em;
  z-index: 999;
}

.footer {
  position: relative;
  padding: 39px 0 0;
  margin: 0 auto;
  min-height: 120px;
  display: block;
  width: 100%;
  bottom: 0;
  font-family: "Open Sans", sans-serif;
  color: #242829;
}
.footer.solid-bg {
  background-color: #ECE9F2;
}
.footer .footer-heading {
  padding-bottom: 7px;
  display: inline-block;
  font-size: 1rem;
  font-weight: 600;
}
.footer .leftlinks {
  margin-right: 20px;
  color: !important;
}
.footer .slogan-bubble {
  line-height: 1.4rem;
  color: #242829;
  padding-bottom: 10px;
  font-size: 0.85rem;
}
.footer .slogan-bubble .social-media-header {
  font-size: 16px;
  font-weight: 600;
}
.footer .allmanavillkor a, .footer .allmanavillkor a:hover {
  color: #440099 !important;
}
.footer .logo-space {
  max-width: 250px;
}
.footer .logo-space a {
  color: #242829 !important;
}
.footer .logo-space a:hover {
  color: #000 !important;
}
.footer .footer-link {
  color: #242829;
  display: block;
}
.footer .footer-link:hover {
  color: #000;
}
.footer .logo-space .mdi {
  font-size: 1.875rem;
  margin-right: 1.1rem;
  display: inline-block;
}
.footer .payment-delivery-space {
  padding: 12px;
}
.footer .payment-delivery-space img {
  height: 25px;
}
.footer .footer-zinzino-test {
  background-color: #FFFFFF;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
  border-radius: 15px;
  width: 267px;
  height: 70px;
  cursor: pointer;
}
.footer .footer-zinzino-test:hover {
  background-color: #C4B1CF;
}
.footer .footer-zinzino-test .footer-zinzino-test-image {
  float: left;
  width: 73px;
  height: 100%;
  background-image: url(https://zinzinowebstorage.blob.core.windows.net/images/footer-zinzino-test.png);
  background-size: cover;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
}
.footer .footer-zinzino-test .footer-zinzino-test-text {
  width: 194px;
  float: right;
  padding: 12px 10px 10px 15px;
  font-size: 12px;
  position: relative;
}
.footer .footer-zinzino-test .footer-zinzino-test-text p {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}
.footer .footer-zinzino-test .footer-zinzino-test-text::after {
  content: "\\f03cc";
  font: normal normal normal 24px/1 "Material Design Icons";
  position: absolute;
  top: 9px;
  right: 13px;
  font-size: 15px;
}
.footer .hide-on-mobile {
  line-height: 2rem;
}
.footer .zinzino-header-logo {
  width: 214px;
  height: 34px;
}
.footer .mainmenu-link {
  height: 100% !important;
}
@media (min-width: 768px) {
  .footer .hide-on-mobile {
    line-height: 2rem;
    display: block !important;
  }
}
@media (max-width: 767.98px) {
  .footer .footer-container {
    max-width: 540px !important;
  }
  .footer .hide-on-mobile {
    display: none;
  }
  .footer .hide-on-mobile .footer a {
    line-height: 1rem !important;
    font-size: 1rem;
    text-decoration: none;
  }
  .footer .slogan-bubble {
    display: block;
    margin: auto;
    word-break: break-word;
    font-size: 0.75rem;
    line-height: 1.2rem;
  }
  .footer .leftlinks {
    margin-right: unset !important;
  }
  .footer .allmanavillkor {
    padding-top: 15px;
  }
  .footer .mobile-footleft {
    padding: 0px !important;
    clear: both;
    margin-bottom: 0 !important;
    width: 100%;
    margin: 0;
    cursor: pointer;
  }
  .footer .mobile-footleft br {
    display: none;
  }
  .footer .mobile-footleft .footer-heading {
    line-height: 40px;
    margin: 0 !important;
    padding: 0 0 0 1rem !important;
  }
  .footer .footer-link {
    padding-left: 1rem;
    width: 100%;
  }
  .footer .footer-heading {
    width: 100%;
    cursor: pointer;
  }
  .footer .footer-arrowLinkWrapper {
    width: 22px;
    height: 22px;
    position: absolute;
    right: 12px;
  }
  .footer .footer-link-showHide {
    border: solid #242829;
    border-width: 0 2px 2px 0;
    display: inline-block;
    position: absolute;
    padding: 4px;
    top: 10px;
    left: 5px;
    line-height: 17px;
    -webkit-transition: -webkit-transform linear 0.7s;
    -moz-transition: -moz-transform 0.7s;
    transition: transform 0.7s;
  }
  .footer .footer-link-up {
    transform: rotate(-135deg);
    -moz-transform: rotate(-135deg);
    -webkit-transform: rotate(-135deg);
    top: 14px;
  }
  .footer .footer-link-down {
    transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    top: 14px;
  }
}
.footer .footer-bottom {
  min-height: 43px;
  background-color: #440099;
  text-align: center;
  margin-top: 34px;
  padding: 11px;
}
.footer .footer-bottom ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}
.footer .footer-bottom ul li {
  display: inline;
}
.footer .footer-bottom ul li a {
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  padding: 0 10px;
  letter-spacing: 0.02em;
}
.footer .footer-bottom ul li a:hover {
  text-decoration: underline;
}
.footer .disclaimer-area {
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.4);
  font-size: 12px;
  font-weight: 400;
  line-height: 22px;
  max-width: 940px;
  margin: 20px auto 0;
  text-align: center;
  padding: 14px;
  color: #242829;
}

.login-button {
  position: absolute;
  z-index: 700;
  top: 0;
  right: 15px;
  user-select: none;
  cursor: pointer;
  outline: 0;
  display: block;
}

a.login-url {
  color: #fff;
  padding: 0 25px;
}
a.login-url:hover, a.login-url:focus, a.login-url:visited {
  color: #fff;
  color: #fff;
}

.cd-main-content, .cd-main-header {
  -webkit-transition: -webkit-transform 0.3s;
  -moz-transition: -moz-transform 0.3s;
  transition: transform 0.3s;
}

.cd-main-content {
  background: #fff;
  min-height: calc(100vh - 250px);
  z-index: 2;
  padding-top: 100px;
}
.cd-main-content:has(.news-sticky-nav-tabs), .cd-main-content:has(.news-search-container) {
  background: #f2f2f2;
}
.cd-main-content:has(.visiting-info-centered) {
  padding-top: 126px;
}

@media only screen and (max-width: 1169px) {
  .cd-main-content {
    padding-top: 90px;
  }
  .cd-main-content:has(.visiting-info-centered) {
    padding-top: 116px;
  }
}
.visiting-info-centered {
  width: 100%;
  text-align: center;
  font-size: 11px;
  z-index: 2000;
  background-color: #fff;
  border-radius: 0px;
  z-index: 9;
  color: #494949;
  font-size: 11px;
  line-height: 16px;
  height: auto;
}
.visiting-info-centered div {
  padding: 5px 0;
}

.visiting-info-centered.isEnrolling {
  background-color: #fff;
  color: #494949;
}

.cd-main-header {
  height: auto;
  background: #ffffff;
  z-index: 3;
  -webkit-box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
  -moz-box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
  position: fixed;
  width: 100vw;
}

.nav-is-fixed .cd-main-header {
  /* add .nav-is-fixed class to body if you want a fixed navigation on > 1170px */
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
}

@media only screen and (min-width: 1170px) {
  .cd-main-header {
    height: auto;
  }
  .cd-main-header::after {
    clear: both;
    content: "";
    display: table;
  }
}
.zz-logo-link {
  z-index: 10;
}

.cd-logo {
  position: absolute;
  bottom: 10px;
  left: 5%;
  z-index: 12;
  height: 31px;
}

.cd-logo img {
  display: block;
}

@media only screen and (max-width: 1169px) {
  .nav-on-left .cd-logo {
    left: auto;
    right: calc(50% - 95px);
  }
}
@media only screen and (max-width: 767px) {
  .nav-on-left .cd-logo {
    left: auto;
    right: calc(50% - 75px);
  }
  .zz-logo-link, .zzSvgLogo {
    width: 150px;
  }
}
@media only screen and (min-width: 1170px) {
  .cd-logo {
    bottom: 19px;
    left: 2%;
  }
}
.cd-header-buttons {
  position: absolute;
  display: inline-block;
  bottom: 0;
  right: 5%;
  margin-bottom: 8px;
}

.cd-header-buttons li {
  display: inline-block;
  list-style-position: inside;
  margin-left: 0;
}

@media only screen and (max-width: 1169px) {
  .nav-on-left .cd-header-buttons {
    right: auto;
    left: 3%;
    padding-left: 0;
  }
  .nav-on-left .cd-header-buttons li {
    float: right;
  }
}
@media only screen and (min-width: 1170px) {
  .cd-header-buttons {
    bottom: 0;
    right: 4em;
  }
}
.cd-nav-trigger {
  position: relative;
  display: block;
  width: 44px;
  height: 44px;
  overflow: hidden;
  white-space: nowrap;
  /* hide text */
  color: transparent;
  z-index: 3;
}

.cd-nav-trigger span, .cd-nav-trigger span::before, .cd-nav-trigger span::after {
  /* hamburger icon in CSS */
  position: absolute;
  display: inline-block;
  height: 3px;
  width: 24px;
  background: #2e3233;
}

.cd-nav-trigger span {
  /* line in the center */
  position: absolute;
  top: 50%;
  right: 10px;
  margin-top: -2px;
  -webkit-transition: background 0.3s 0.3s;
  -moz-transition: background 0.3s 0.3s;
  transition: background 0.3s 0.3s;
}

.cd-nav-trigger span::before, .cd-nav-trigger span::after {
  /* other 2 lines */
  content: "";
  right: 0;
  /* Force Hardware Acceleration in WebKit */
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transition: -webkit-transform 0.3s 0.3s;
  -moz-transition: -moz-transform 0.3s 0.3s;
  transition: transform 0.3s 0.3s;
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
}

.cd-nav-trigger span::before {
  /* menu icon top line */
  top: -6px;
}

.cd-nav-trigger span::after {
  /* menu icon bottom line */
  top: 6px;
}

.cd-nav-trigger.nav-is-visible span {
  /* hide line in the center */
  background: rgba(46, 50, 51, 0);
}

.cd-nav-trigger.nav-is-visible span::before, .cd-nav-trigger.nav-is-visible span::after {
  /* keep visible other 2 lines */
  background: #2e3233;
}

.cd-nav-trigger.nav-is-visible span::before {
  -webkit-transform: translateX(4px) translateY(-3px) rotate(45deg);
  -moz-transform: translateX(4px) translateY(-3px) rotate(45deg);
  -ms-transform: translateX(4px) translateY(-3px) rotate(45deg);
  -o-transform: translateX(4px) translateY(-3px) rotate(45deg);
  transform: translateX(4px) translateY(-3px) rotate(45deg);
}

.cd-nav-trigger.nav-is-visible span::after {
  -webkit-transform: translateX(4px) translateY(2px) rotate(-45deg);
  -moz-transform: translateX(4px) translateY(2px) rotate(-45deg);
  -ms-transform: translateX(4px) translateY(2px) rotate(-45deg);
  -o-transform: translateX(4px) translateY(2px) rotate(-45deg);
  transform: translateX(4px) translateY(2px) rotate(-45deg);
}

@media only screen and (min-width: 1170px) {
  .cd-nav-trigger {
    display: none;
  }
}
@media only screen and (min-width: 1700px) {
  .cd-logo {
    left: calc((100vw - 1700px) / 2 + 30px);
  }
  .zzPreHeaderCountry {
    margin-left: calc((100vw - 1700px) / 2 + 10px);
  }
  .zzPreHeaderRight {
    margin-right: calc((100vw - 1700px) / 2 + 10px) !important;
  }
  .zzPreHeaderCart {
    right: calc((100vw - 1700px) / 2 + 25px) !important;
  }
}
@media only screen and (max-width: 1169px) {
  .zzPreHeaderCountry {
    display: none;
  }
}
.zzPreHeader {
  width: 100%;
  height: 30px;
  background-color: #440099;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  padding: 2px 20px;
  vertical-align: middle;
}
.zzPreHeader a, .zzPreHeader a:focus, .zzPreHeader a:active {
  color: #fff;
  line-height: 26px;
}
.zzPreHeader a:hover {
  color: #f5f7fa;
}
.zzPreHeader .mdi:before {
  font-size: 16px;
  position: relative;
  top: 2px;
  margin-right: 3px;
}

.zzPreHeaderCountry {
  float: left;
  line-height: 26px;
}

.zzPreHeaderRight {
  float: right;
  padding-right: 10px;
  margin-right: calc(2% + 10px);
  margin-top: -2px;
}

@media (max-width: 767px) {
  .zzPreHeaderRight {
    margin-right: 7px;
    margin-top: 0;
  }
}
.zzPreHeaderCalendar {
  float: left;
  padding-left: 30px;
  line-height: 26px;
}

.zzPreHeaderSupport {
  float: left;
  padding-left: 30px;
  line-height: 26px;
}

.zzPreHeaderBlog {
  float: left;
  padding-left: 30px;
  line-height: 26px;
}

.zzPreHeaderLogin {
  float: left;
  padding-left: 30px;
  line-height: 26px;
}

.zzPreHeaderCart {
  float: left;
  padding-left: 20px;
  line-height: 26px;
  z-index: 13;
  position: absolute;
  bottom: 20px;
  right: 5%;
  font-size: 24px;
  cursor: pointer;
}
.zzPreHeaderCart span {
  display: none;
}
.zzPreHeaderCart span a.zzPreHeaderCart i.mdi-cart::before {
  color: #242829;
}

.zzPreHeaderSwitchWeb {
  float: left;
  padding-left: 30px;
  line-height: 26px;
}

.zzSignOut {
  float: left;
  padding-right: 30px;
}

@media (max-width: 1169px) {
  .zzPreHeaderSwitchWeb {
    padding-left: 10px;
  }
  .zzPreHeader {
    padding: 0 10px;
  }
  .zzPreHeaderCalendar, .zzPreHeaderSupport, .zzPreHeaderBlog {
    display: none;
  }
  .zzPreHeaderLogin {
    padding-left: 2%;
  }
  .cd-logo {
    position: absolute;
    bottom: 14px;
    left: 25%;
  }
}
.panel-heading span .mdi {
  line-height: 10px;
}

.content-header {
  padding-right: 30px !important;
  padding-left: 30px !important;
}
.content-header .row .col-12 h2 {
  font-size: 30px;
  font-weight: bold;
  text-transform: uppercase;
}
@media (max-width: 767px) {
  .content-header .row .col-12 h2 {
    font-size: 20px;
  }
}

.replicated-site-info {
  position: fixed;
  bottom: 0;
  left: 0;
  display: none;
  z-index: 15;
  -webkit-box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.25);
  -moz-box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.25);
  box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.25);
  text-align: center;
}
@media (max-width: 767px) {
  .replicated-site-info {
    width: 100%;
  }
}
@media (min-width: 768px) {
  .replicated-site-info {
    bottom: 30px;
    left: 45px;
  }
}
@media (max-height: 500px) {
  .replicated-site-info {
    width: 100%;
    bottom: 0;
    left: 0;
    height: 100%;
  }
  .replicated-site-info .replicated-scroll-wrapper {
    height: 100%;
  }
}
.replicated-site-info .replicated-info-main {
  padding: 55px 30px 30px;
  width: 440px;
  overflow: auto;
  min-height: 330px;
  background-color: #F5F8F8;
}
@media (max-width: 767px) {
  .replicated-site-info .replicated-info-main {
    width: auto;
  }
}
@media (max-height: 500px) {
  .replicated-site-info .replicated-info-main {
    min-height: unset;
    width: 100%;
    max-height: 100%;
  }
}
.replicated-site-info .replicated-info-main .close {
  position: absolute;
  top: 10px;
  right: 30px;
}
@media (min-width: 768px) and (min-height: 499px) {
  .replicated-site-info .replicated-info-main .close {
    right: 15px;
  }
}
.replicated-site-info .replicated-info-main .replicated-partner-name {
  font-weight: 400;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 0.01em;
  margin-bottom: 0.2rem;
}
.replicated-site-info .replicated-info-main .replicated-title {
  font-size: 14px;
  font-weight: 600;
}
.replicated-site-info .replicated-info-main .replicated-presentation {
  max-width: 440px;
  margin: 16px auto;
  font-size: 16px;
  line-height: 24px;
}
.replicated-site-info .replicated-info-main .replicated-divider {
  margin: 0 auto;
  width: 47px;
  height: 0px;
  border-top: 3px solid #8859C5;
}
.replicated-site-info .replicated-contact {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  background-color: #440099;
  color: #fff;
  display: inline-flex;
  margin: 0 10px;
  transition: transform 0.2s;
  cursor: pointer;
}
.replicated-site-info .replicated-contact::before {
  font-size: 25px;
  padding-top: 14px;
  padding-left: 14px;
}
.replicated-site-info .replicated-contact:hover {
  transform: scale(1.25);
}
.replicated-site-info .replicated-contact-small {
  width: 28px;
  height: 28px;
}
.replicated-site-info .replicated-contact-small::before {
  font-size: 18px;
  padding-top: 7px;
  padding-left: 7px;
}
.replicated-site-info .replicated-telephone-show-more {
  display: none;
  width: calc(100% - 20px);
  background-color: #fff;
  border-radius: 17px;
  height: 120px;
  position: absolute;
  top: -40px;
  left: 10px;
  -webkit-box-shadow: 0 -2px 20px 0 rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0 -2px 20px 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 -2px 20px 0 rgba(0, 0, 0, 0.15);
  padding: 23px 10px;
}
.replicated-site-info .replicated-telephone-show-more .replicated-contact-text {
  font-size: 28px;
  font-weight: 400;
  letter-spacing: 0.02em;
  display: block;
  margin-bottom: 15px;
  color: #000;
}
.replicated-site-info .replicated-telephone-show-more a.replicated-contact-small {
  font-size: 24px;
  padding: 0 15px;
  font-weight: 300;
  cursor: pointer;
}
.replicated-site-info .replicated-email-show-more {
  display: none;
  width: calc(100% - 20px);
  background-color: #fff;
  border-radius: 17px;
  height: 120px;
  position: absolute;
  top: -40px;
  left: 10px;
  -webkit-box-shadow: 0 -2px 20px 0 rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0 -2px 20px 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 -2px 20px 0 rgba(0, 0, 0, 0.15);
  padding: 23px 10px;
}
.replicated-site-info .replicated-email-show-more .replicated-contact-text {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0.02em;
  display: block;
  margin-bottom: 15px;
  color: #000;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 26px;
  overflow-wrap: anywhere;
}
.replicated-site-info .replicated-email-show-more a.replicated-contact-small {
  font-size: 24px;
  padding: 0 15px;
  font-weight: 300;
  cursor: pointer;
}
.replicated-site-info .replicated-email-show-more a.replicated-contact-small::before {
  font-size: 30px;
}
.replicated-site-info .replicated-image {
  position: absolute;
  top: -47px;
  left: calc(50% - 47px);
  background-color: #fff;
  width: 94px;
  height: 94px;
  border-radius: 50%;
  background-size: cover;
  z-index: 3;
  border: 3px solid #fff;
  background-position: center center;
}
@media (max-height: 500px) {
  .replicated-site-info .replicated-image {
    top: 15px;
    left: 15px;
    width: 50px;
    height: 50px;
    position: relative;
  }
}

#replicated-shadow-layer {
  position: fixed;
  z-index: 14;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.3);
  visibility: hidden;
  opacity: 0;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transition: opacity 0.3s 0s, visibility 0s 0.3s, -webkit-transform 0.3s 0s;
  -moz-transition: opacity 0.3s 0s, visibility 0s 0.3s, -moz-transform 0.3s 0s;
  transition: opacity 0.3s 0s, visibility 0s 0.3s, transform 0.3s 0s;
}

#replicated-shadow-layer.is-visible {
  opacity: 1;
  visibility: visible;
  -webkit-transition: opacity 0.3s 0s, visibility 0s 0s, -webkit-transform 0.3s 0s;
  -moz-transition: opacity 0.3s 0s, visibility 0s 0s, -moz-transform 0.3s 0s;
  transition: opacity 0.3s 0s, visibility 0s 0s, transform 0.3s 0s;
}

.replicated-image-small {
  display: none;
  position: fixed;
  bottom: 16px;
  left: 16px;
  background-color: #fff;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background-size: cover;
  z-index: 3;
  border: 3px solid #fff;
  -webkit-box-shadow: rgba(0, 0, 0, 0.5) 0 2px 4px;
  box-shadow: rgba(0, 0, 0, 0.5) 0 2px 4px;
  opacity: 1;
  cursor: pointer;
  transition: transform 0.2s;
  background-position: center center;
}
.replicated-image-small:hover {
  transform: scale(1.25);
}

.logged-in-trigger {
  display: block;
  height: 30px;
  background-color: #ece9f2;
  padding: 0 12px;
  -webkit-transition: background-color 0.3s 0s, -webkit-transform 0.3s 0s;
  -moz-transition: background-color 0.3s 0s, -moz-transform 0.3s 0s;
  transition: background-color 0.3s 0s, transform 0.3s 0s;
  color: #409 !important;
  font-weight: 600;
  position: relative;
  z-index: 15;
  max-width: calc(100vw - 155px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.logged-in-trigger .mdi-account-multiple-plus {
  color: #f96ca9;
}
@media (max-width: 767px) {
  .logged-in-trigger {
    background-color: transparent;
    color: #fff !important;
  }
  .logged-in-trigger .mdi-account-multiple-plus {
    color: #ff78b3;
  }
}
@media (min-width: 768px) {
  .logged-in-trigger:hover {
    background-color: #fff;
    color: #409 !important;
  }
}
.logged-in-trigger.logged-in-trigger-active {
  background-color: #fff;
  color: #409 !important;
}
.logged-in-trigger.logged-in-trigger-active .mdi-account-multiple-plus {
  color: #f96ca9;
}
.logged-in-trigger.csr-login-info {
  background-color: #ff0000 !important;
  color: #fff !important;
}

.logged-in-info-wrapper {
  position: relative;
  width: inherit;
  height: 0;
  margin-top: 0;
  color: #494949;
  justify-content: start;
}
@media (min-width: 1170px) {
  .logged-in-info-wrapper {
    display: flex;
    justify-content: end;
  }
}

#close-logged-in:focus {
  outline: none;
}

@media (max-width: 767px) {
  .zzPreHeader {
    padding: 0;
  }
  .zzPreHeaderLogin {
    padding-left: 0;
  }
  .sign-in-link {
    padding-left: 15px;
  }
}
.logged-in-info {
  position: absolute;
  display: none;
  font-size: 14px;
  z-index: 15;
  -webkit-box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.15);
}
.logged-in-info a {
  color: #494949;
  display: inline-block;
  text-transform: lowercase;
}
.logged-in-info a:hover, .logged-in-info a:active, .logged-in-info a:focus {
  color: #440099;
}
.logged-in-info a:first-letter {
  text-transform: uppercase !important;
}
@media (max-width: 767px) {
  .logged-in-info {
    top: 0;
    left: 0;
    width: 330px;
    max-width: calc(100vw - 48px);
  }
}
@media (max-width: 378px) {
  .logged-in-info {
    top: 0;
    left: 0;
    width: 100vw;
    max-width: calc(100vw - 2px);
  }
}
.logged-in-info .logged-in-info-main {
  padding: 0;
  width: 330px;
  overflow: auto;
  background-color: #fff;
}
@media (max-width: 767px) {
  .logged-in-info .logged-in-info-main {
    width: auto;
  }
}
.logged-in-info .logged-in-info-main .close {
  position: absolute;
  top: 10px;
  right: 30px;
}
@media (min-width: 768px) and (min-height: 499px) {
  .logged-in-info .logged-in-info-main .close {
    right: 15px;
  }
}
.logged-in-info .logged-in-info-main .guest-mode-text {
  padding: 15px 30px;
  border-top: 1px solid #eee;
  position: relative;
}
@media (max-width: 378px) {
  .logged-in-info .logged-in-info-main .guest-mode-text {
    padding: 15px 15px;
  }
}
.logged-in-info .logged-in-info-main .logged-in-link {
  height: 57px;
  padding: 15px 30px;
  border-top: 1px solid #eee;
  position: relative;
  -webkit-transition: background 0.3s 0s;
  -moz-transition: background 0.3s 0s;
  transition: background 0.3s 0s;
  overflow: hidden;
  text-wrap: nowrap;
}
@media (max-width: 378px) {
  .logged-in-info .logged-in-info-main .logged-in-link {
    padding: 15px 15px;
  }
}
.logged-in-info .logged-in-info-main .logged-in-link:hover {
  background-color: #f7f7f7;
}
.logged-in-info .logged-in-info-main .logged-in-link:hover .mdi {
  color: #440099;
}

#logged-in-shadow-layer {
  position: fixed;
  z-index: 14;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.2);
  visibility: hidden;
  opacity: 0;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transition: opacity 0.3s 0s, visibility 0s 0.3s, -webkit-transform 0.3s 0s;
  -moz-transition: opacity 0.3s 0s, visibility 0s 0.3s, -moz-transform 0.3s 0s;
  transition: opacity 0.3s 0s, visibility 0s 0.3s, transform 0.3s 0s;
}
#logged-in-shadow-layer.is-visible {
  opacity: 1;
  visibility: visible;
  -webkit-transition: opacity 0.3s 0s, visibility 0s 0s, -webkit-transform 0.3s 0s;
  -moz-transition: opacity 0.3s 0s, visibility 0s 0s, -moz-transform 0.3s 0s;
  transition: opacity 0.3s 0s, visibility 0s 0s, transform 0.3s 0s;
}

.bootstrap-col-slider-right, .bootstrap-col-slider-left {
  display: none;
}

.bootstrap-col-slider-content::-webkit-scrollbar {
  display: none;
}

.bootstrap-col-slider-right, .bootstrap-col-slider-left {
  position: absolute;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  z-index: 2;
  top: 45%;
  background-color: rgba(255, 255, 255, 0.65);
}
.bootstrap-col-slider-right span, .bootstrap-col-slider-left span {
  font-size: 30px;
  margin-left: 6px;
  line-height: 42px;
  cursor: pointer;
}

.bootstrap-col-slider-right:hover, .bootstrap-col-slider-left:hover {
  opacity: 0.85;
}
.bootstrap-col-slider-right:hover span, .bootstrap-col-slider-left:hover span {
  opacity: 1;
}

.bootstrap-col-slider-right {
  right: 0;
}

.bootstrap-col-slider-left {
  left: 0;
}

@media (min-width: 577px) {
  .bootstrap-col-slider-xs .bootstrap-col-slider-left, .bootstrap-col-slider-xs .bootstrap-col-slider-right, .bootstrap-col-slider-xs .carousel-indicators {
    display: none !important;
  }
}
@media (max-width: 576px) {
  .bootstrap-col-slider-xs.bootstrap-col-slider {
    position: relative;
    height: auto;
    margin-bottom: 0px;
    -webkit-transition: all 0.25s ease-in;
    -moz-transition: all 0.25s ease-in;
    -ms-transition: all 0.25s ease-in;
    -o-transition: all 0.25s ease-in;
    transition: all 0.25s ease-in;
  }
  .bootstrap-col-slider-xs .bootstrap-col-slider-content {
    overflow: auto;
    flex-wrap: unset;
    scrollbar-width: none;
    scrollbar-height: none;
    -ms-overflow-style: none;
    justify-content: normal !important;
  }
  .bootstrap-col-slider-xs .bootstrap-col-slider-content .bootstrap-col-slider-scroll-content {
    touch-action: pan-y;
  }
  .bootstrap-col-slider-xs .bootstrap-col-slider-content.scroll-1-items {
    justify-content: center !important;
  }
}
@media (max-width: 576px) and (min-width: 768px) {
  .bootstrap-col-slider-xs .bootstrap-col-slider-content.scroll-2-items {
    justify-content: center !important;
  }
}
@media (max-width: 576px) and (min-width: 992px) {
  .bootstrap-col-slider-xs .bootstrap-col-slider-content.scroll-3-items {
    justify-content: center !important;
  }
}
@media (max-width: 576px) {
  .bootstrap-col-slider-xs .carousel-indicators li {
    border-radius: 6px;
    width: 12px;
    height: 12px;
    background-color: #404040;
    background-clip: unset;
    border-top: none;
    border-bottom: none;
  }
}

@media (min-width: 769px) {
  .bootstrap-col-slider-sm .bootstrap-col-slider-left, .bootstrap-col-slider-sm .bootstrap-col-slider-right, .bootstrap-col-slider-sm .carousel-indicators {
    display: none !important;
  }
}
@media (max-width: 768px) {
  .bootstrap-col-slider-sm.bootstrap-col-slider {
    position: relative;
    height: auto;
    margin-bottom: 0px;
    -webkit-transition: all 0.25s ease-in;
    -moz-transition: all 0.25s ease-in;
    -ms-transition: all 0.25s ease-in;
    -o-transition: all 0.25s ease-in;
    transition: all 0.25s ease-in;
  }
  .bootstrap-col-slider-sm .bootstrap-col-slider-content {
    overflow: auto;
    flex-wrap: unset;
    scrollbar-width: none;
    scrollbar-height: none;
    -ms-overflow-style: none;
    justify-content: normal !important;
  }
  .bootstrap-col-slider-sm .bootstrap-col-slider-content .bootstrap-col-slider-scroll-content {
    touch-action: pan-y;
  }
  .bootstrap-col-slider-sm .bootstrap-col-slider-content.scroll-1-items {
    justify-content: center !important;
  }
}
@media (max-width: 768px) and (min-width: 768px) {
  .bootstrap-col-slider-sm .bootstrap-col-slider-content.scroll-2-items {
    justify-content: center !important;
  }
}
@media (max-width: 768px) and (min-width: 992px) {
  .bootstrap-col-slider-sm .bootstrap-col-slider-content.scroll-3-items {
    justify-content: center !important;
  }
}
@media (max-width: 768px) {
  .bootstrap-col-slider-sm .carousel-indicators li {
    border-radius: 6px;
    width: 12px;
    height: 12px;
    background-color: #404040;
    background-clip: unset;
    border-top: none;
    border-bottom: none;
  }
}

@media (min-width: 993px) {
  .bootstrap-col-slider-md .bootstrap-col-slider-left, .bootstrap-col-slider-md .bootstrap-col-slider-right, .bootstrap-col-slider-md .carousel-indicators {
    display: none !important;
  }
}
@media (max-width: 992px) {
  .bootstrap-col-slider-md.bootstrap-col-slider {
    position: relative;
    height: auto;
    margin-bottom: 0px;
    -webkit-transition: all 0.25s ease-in;
    -moz-transition: all 0.25s ease-in;
    -ms-transition: all 0.25s ease-in;
    -o-transition: all 0.25s ease-in;
    transition: all 0.25s ease-in;
  }
  .bootstrap-col-slider-md .bootstrap-col-slider-content {
    overflow: auto;
    flex-wrap: unset;
    scrollbar-width: none;
    scrollbar-height: none;
    -ms-overflow-style: none;
    justify-content: normal !important;
  }
  .bootstrap-col-slider-md .bootstrap-col-slider-content .bootstrap-col-slider-scroll-content {
    touch-action: pan-y;
  }
  .bootstrap-col-slider-md .bootstrap-col-slider-content.scroll-1-items {
    justify-content: center !important;
  }
}
@media (max-width: 992px) and (min-width: 768px) {
  .bootstrap-col-slider-md .bootstrap-col-slider-content.scroll-2-items {
    justify-content: center !important;
  }
}
@media (max-width: 992px) and (min-width: 992px) {
  .bootstrap-col-slider-md .bootstrap-col-slider-content.scroll-3-items {
    justify-content: center !important;
  }
}
@media (max-width: 992px) {
  .bootstrap-col-slider-md .carousel-indicators li {
    border-radius: 6px;
    width: 12px;
    height: 12px;
    background-color: #404040;
    background-clip: unset;
    border-top: none;
    border-bottom: none;
  }
}

@media (min-width: 1201px) {
  .bootstrap-col-slider-lg .bootstrap-col-slider-left, .bootstrap-col-slider-lg .bootstrap-col-slider-right, .bootstrap-col-slider-lg .carousel-indicators {
    display: none !important;
  }
}
@media (max-width: 1200px) {
  .bootstrap-col-slider-lg.bootstrap-col-slider {
    position: relative;
    height: auto;
    margin-bottom: 0px;
    -webkit-transition: all 0.25s ease-in;
    -moz-transition: all 0.25s ease-in;
    -ms-transition: all 0.25s ease-in;
    -o-transition: all 0.25s ease-in;
    transition: all 0.25s ease-in;
  }
  .bootstrap-col-slider-lg .bootstrap-col-slider-content {
    overflow: auto;
    flex-wrap: unset;
    scrollbar-width: none;
    scrollbar-height: none;
    -ms-overflow-style: none;
    justify-content: normal !important;
  }
  .bootstrap-col-slider-lg .bootstrap-col-slider-content .bootstrap-col-slider-scroll-content {
    touch-action: pan-y;
  }
  .bootstrap-col-slider-lg .bootstrap-col-slider-content.scroll-1-items {
    justify-content: center !important;
  }
}
@media (max-width: 1200px) and (min-width: 768px) {
  .bootstrap-col-slider-lg .bootstrap-col-slider-content.scroll-2-items {
    justify-content: center !important;
  }
}
@media (max-width: 1200px) and (min-width: 992px) {
  .bootstrap-col-slider-lg .bootstrap-col-slider-content.scroll-3-items {
    justify-content: center !important;
  }
}
@media (max-width: 1200px) {
  .bootstrap-col-slider-lg .carousel-indicators li {
    border-radius: 6px;
    width: 12px;
    height: 12px;
    background-color: #404040;
    background-clip: unset;
    border-top: none;
    border-bottom: none;
  }
}

.bootstrap-col-slider:not(.bootstrap-col-slider-xs):not(.bootstrap-col-slider-sm):not(.bootstrap-col-slider-md):not(.bootstrap-col-slider-lg).bootstrap-col-slider {
  position: relative;
  height: auto;
  margin-bottom: 0px;
  -webkit-transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -ms-transition: all 0.25s ease-in;
  -o-transition: all 0.25s ease-in;
  transition: all 0.25s ease-in;
}
.bootstrap-col-slider:not(.bootstrap-col-slider-xs):not(.bootstrap-col-slider-sm):not(.bootstrap-col-slider-md):not(.bootstrap-col-slider-lg) .bootstrap-col-slider-content {
  overflow: auto;
  flex-wrap: unset;
  scrollbar-width: none;
  scrollbar-height: none;
  -ms-overflow-style: none;
  justify-content: normal !important;
}
.bootstrap-col-slider:not(.bootstrap-col-slider-xs):not(.bootstrap-col-slider-sm):not(.bootstrap-col-slider-md):not(.bootstrap-col-slider-lg) .bootstrap-col-slider-content .bootstrap-col-slider-scroll-content {
  touch-action: pan-y;
}
.bootstrap-col-slider:not(.bootstrap-col-slider-xs):not(.bootstrap-col-slider-sm):not(.bootstrap-col-slider-md):not(.bootstrap-col-slider-lg) .bootstrap-col-slider-content.scroll-1-items {
  justify-content: center !important;
}
@media (min-width: 768px) {
  .bootstrap-col-slider:not(.bootstrap-col-slider-xs):not(.bootstrap-col-slider-sm):not(.bootstrap-col-slider-md):not(.bootstrap-col-slider-lg) .bootstrap-col-slider-content.scroll-2-items {
    justify-content: center !important;
  }
}
@media (min-width: 992px) {
  .bootstrap-col-slider:not(.bootstrap-col-slider-xs):not(.bootstrap-col-slider-sm):not(.bootstrap-col-slider-md):not(.bootstrap-col-slider-lg) .bootstrap-col-slider-content.scroll-3-items {
    justify-content: center !important;
  }
}
.bootstrap-col-slider:not(.bootstrap-col-slider-xs):not(.bootstrap-col-slider-sm):not(.bootstrap-col-slider-md):not(.bootstrap-col-slider-lg) .carousel-indicators li {
  border-radius: 6px;
  width: 12px;
  height: 12px;
  background-color: #404040;
  background-clip: unset;
  border-top: none;
  border-bottom: none;
}

.hero-block {
  position: relative;
  overflow: hidden;
}
.hero-block__image {
  position: absolute;
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  height: 100%;
  background-position: center center;
}
.hero-block__video {
  position: absolute;
  width: 100%;
  height: 100%;
}
.hero-block__video > video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.hero-block__overlay {
  position: absolute;
  width: 100%;
  height: 100%;
}
.hero-block__callout {
  position: absolute;
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.hero-block__callout > .hero-block-link {
  position: absolute;
  height: 100%;
  width: 100%;
  cursor: pointer;
}
.hero-block__callout > .callout {
  position: relative;
}
.hero-block__callout > .callout:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.hero-block__callout-content {
  position: relative;
  z-index: 1;
}

.heroblock .hero-settings {
  height: 400px;
}
@media (min-width: 576px) {
  .heroblock .hero-settings {
    height: 400px;
  }
}
@media (min-width: 768px) {
  .heroblock .hero-settings {
    height: 500px;
  }
}
@media (min-width: 992px) {
  .heroblock .hero-settings {
    height: 600px;
  }
}
@media (min-width: 1200px) {
  .heroblock .hero-settings {
    height: 700px;
  }
}
.heroblock .hero-settings .container, .heroblock .hero-settings .row {
  height: 100%;
}

.button-yellow-white, .button-yellow-black, .button-white, .button-black, .button-black--icon, .button-transparent-white, .button-transparent-black, .button-transparent-black--icon, .button-origin {
  display: inline-block;
  border-radius: 2px;
  font-size: 0.875rem;
  line-height: 1em;
  font-weight: 600;
  text-transform: uppercase;
  text-align: center;
  vertical-align: middle;
  padding: 12px 20px;
  user-select: none;
  background-color: transparent;
  transition: color 0.15s;
  text-decoration: none;
  min-height: 40px;
  min-width: 100px;
}
.button-yellow-white:active, .button-yellow-black:active, .button-white:active, .button-black:active, .button-black--icon:active, .button-transparent-white:active, .button-transparent-black:active, .button-transparent-black--icon:active, .button-origin:active {
  border-color: none;
}
.button-yellow-white:focus, .button-yellow-black:focus, .button-white:focus, .button-black:focus, .button-black--icon:focus, .button-transparent-white:focus, .button-transparent-black:focus, .button-transparent-black--icon:focus, .button-origin:focus {
  box-shadow: none;
}
.button-yellow-white:hover, .button-yellow-black:hover, .button-white:hover, .button-black:hover, .button-black--icon:hover, .button-transparent-white:hover, .button-transparent-black:hover, .button-transparent-black--icon:hover, .button-origin:hover {
  color: #fff;
  background: #61A0A8;
  text-decoration: none;
}
.button-yellow-white:disabled, .button-yellow-black:disabled, .button-white:disabled, .button-black:disabled, .button-black--icon:disabled, .button-transparent-white:disabled, .button-transparent-black:disabled, .button-transparent-black--icon:disabled, .button-origin:disabled {
  color: #fff;
  background-color: #7f7f7f;
  border-color: #7f7f7f;
}
.button-black--icon, .button-transparent-black--icon {
  height: 40px;
  padding-top: 8px;
  text-transform: none;
}

.button-transparent-black, .button-transparent-black--icon {
  background: transparent;
  color: black;
}
.button-transparent-white {
  background: transparent;
  color: white;
  border-color: white;
}
.button-transparent-white:hover {
  border-color: white !important;
  color: black !important;
  background-color: white !important;
}

.button-black, .button-black--icon {
  background-color: black;
  color: white;
}
.button-white {
  background: white;
  color: black;
}
.button-white:hover {
  border-color: white !important;
}

.button-yellow-black {
  background: #fec84d;
  border: 1px solid #fec84d;
  color: #fff;
}
.button-yellow-black:hover {
  background: #242829 !important;
  border: 1px solid #242829 !important;
  color: #fff !important;
}

.button-yellow-white {
  background: #fec84d;
  border: 1px solid #fec84d;
  color: #fff;
}
.button-yellow-white:hover {
  background: #fff !important;
  border: 1px solid #fff !important;
  color: #242829 !important;
}

a[class^=button-], a[class*=button-] {
  padding-top: 12px;
}

.btn-icon {
  background-color: black;
  color: white;
  padding: 8px 10px 8px 10px;
  border-radius: 0;
  display: inline-block;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
}
.btn-icon:hover {
  color: white;
  text-decoration: none;
  opacity: 0.8;
}

.btn-notification {
  border-radius: 10px;
  padding: 2px 10px 2px 10px;
  border: 1px #468847 solid;
  text-decoration: none;
  color: #468847;
  background-color: white;
  font-weight: normal;
}
.btn-notification:hover {
  text-decoration: none;
  background-color: whitesmoke;
  color: #468847;
}

.btn {
  font-weight: 600;
  letter-spacing: 0.04em;
}

.imagetextblock .image-text-block-button {
  max-width: 800px;
}
.imagetextblock .image-text-block-button .buttonblock {
  padding: 0;
}

.checkbox {
  user-select: none;
  position: relative;
  cursor: pointer;
  padding-left: 35px;
  text-align: center;
}
.checkbox input[type=checkbox], .checkbox input[type=radio] {
  display: none;
}

/* Create a custom checkbox */
.radio,
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  border: 1px solid black;
}

/* When the checkbox is checked, add a black background */
.checkbox input:checked ~ .radio,
.checkbox input:checked ~ .checkmark {
  background-color: black;
}

.checkbox input[type=radio] ~ .radio,
.checkbox input[type=radio] ~ .checkmark {
  border-radius: 50%;
}

/* Create the checkmark/indicator (hidden when not checked) */
.radio:after,
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkbox input:checked ~ .radio:after,
.checkbox input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox .radio:after {
  left: 7.35px;
  top: 7.7px;
  width: 8px;
  height: 8px;
  background: white;
  border-radius: 50%;
  /*border: 1px solid black;*/
}

.checkbox .checkmark:after {
  left: 10px;
  top: 6px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.dropdown {
  outline: 1px solid #eee;
  outline-offset: -1px;
  user-select: none;
}
.dropdown__group {
  display: none;
  width: 100%;
  position: absolute;
  border-left: 1px solid #eeeeee;
  border-right: 1px solid #eeeeee;
  border-top: 1px solid #eeeeee;
  background-color: white;
  z-index: 1;
  max-height: 300px;
  overflow-y: auto;
  list-style: none;
  padding: 0;
}
.dropdown__item {
  width: 100%;
  padding: 15px;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.dropdown__item:hover {
  background-color: #f5f5f5;
}
.dropdown__item--none-padding {
  padding: 0;
}
.dropdown__item-label {
  width: 100%;
  height: 100%;
  text-align: start;
  padding: 15px;
  margin: 0;
  padding-left: 50px;
}
.dropdown__item-label .checkmark {
  top: 15px;
  left: 15px;
}
.dropdown__selected {
  width: 100%;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.icon-button {
  display: inline-block;
  background-color: transparent;
  border: 1px solid transparent;
  border-color: #000;
  padding: 3px;
  color: #555;
  border: 0;
}
.icon-button:hover {
  background-color: transparent;
  color: #555;
  opacity: 0.7;
}
.icon-button:disabled {
  color: #fff;
  background-color: #7f7f7f;
  border-color: #7f7f7f;
}

.icon-menu-description, .icon-menu {
  position: relative;
  width: 80px;
  height: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
}

.icon-menu:active {
  background-color: #eee;
}
.icon-menu--has-badge .icon-menu__badge {
  position: absolute;
  top: 20px;
  right: 16px;
  display: block;
}
.icon-menu-description {
  font-size: 14px;
}
.icon-menu-description--has-badge .icon-menu__badge {
  position: absolute;
  top: 10px;
  right: 16px;
  display: block;
}
.icon-menu__badge {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: black;
  font-size: 10px;
  font-weight: 700;
  color: white;
  box-sizing: border-box;
  text-align: center;
  vertical-align: middle;
  line-height: 18px;
  display: none;
}

.list-group--header {
  width: 100%;
}
.list-group--header .list-group--header__item {
  margin: 0;
  border-bottom: 1px solid #ddd;
  padding: 15px;
  display: block;
  color: black;
  text-decoration: none;
}
.list-group--header .list-group--header__item:hover {
  background-color: #eee;
  transition: 0.2s;
}
.list-group--header .list-group--header__item p {
  margin-bottom: 0;
}

.list-event {
  padding-top: 15px;
}

.content-search-results .list-group--header__item {
  padding: 15px 0px;
  border: none;
}
.content-search-results .list-group--header__item:hover {
  background-color: white;
}
.content-search-results .list-group--header__item:hover .title {
  text-decoration: underline;
}
.content-search-results .content__item {
  padding-left: 0px;
  padding-right: 0px;
}
.content-search-results .content__item .title {
  font-size: 1.5rem;
  color: #28747E;
}
.content-search-results .content__item .sub-title {
  font-size: 0.875rem;
}
.content-search-results .content__betbest {
  width: 22px;
  height: 22px;
}

ul.pagination {
  margin-bottom: 0;
}
ul.pagination li {
  display: inline-block;
  background-color: #eee;
  color: black;
  margin-left: 5px;
  margin-right: 5px;
  padding: 10px;
  cursor: pointer;
}
ul.pagination li a:hover {
  text-decoration: none;
}
ul.pagination li:hover {
  background-color: black;
  color: white;
}
ul.pagination li:hover a {
  color: white;
}
ul.pagination li.active {
  background-color: black;
  color: white;
}
ul.pagination li.active a {
  color: white;
}
ul.pagination li a {
  color: black;
}

.sidebar--container {
  width: 100%;
}
.sidebar--group {
  width: 100%;
  margin: 15px 0 15px 0;
  border-top: 1px solid black;
}
.sidebar__item {
  width: 100%;
  padding: 15px;
  color: black;
  border-bottom: 1px solid #eeeeee;
}
.sidebar__item a {
  color: black;
}
.sidebar__item a:hover {
  text-decoration: none;
  opacity: 0.7;
}
.sidebar__item:hover {
  background-color: #f5f5f5;
}

ul.list-group--info {
  width: 100%;
  margin-top: 15px;
  list-style: none;
  padding: 0;
}
ul.list-group--info li {
  width: 100%;
  padding: 15px;
  border-top: 1px solid #eeeeee;
}

ul.loyalty-statistics li {
  padding: 15px 0px;
}

ul.checkout__status-bar {
  margin-top: 30px;
  margin-bottom: 30px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
ul.checkout__status-bar li {
  flex: 1 0 0;
  display: flex;
  border-top: 3px solid #eeeeee;
  padding-top: 15px;
  padding-bottom: 15px;
  align-items: center;
  justify-content: center;
  position: relative;
}
ul.checkout__status-bar li.active {
  border-color: black;
}
ul.checkout__status-bar li.active > .triangle {
  position: absolute;
  top: 0;
  left: calc(50% - 5px);
  width: 0px;
  height: 0px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid black;
}

@media screen and (max-width: 767px) {
  ul.checkout__status-bar {
    display: block;
  }
  ul.checkout__status-bar li {
    flex: 0 0 100%;
    /*display: block;*/
    margin: 0 0 auto;
    flex-wrap: wrap;
  }
}
ul.loyal--group {
  width: 100%;
  margin-top: 15px;
  padding-left: 0px;
}
ul.loyal--group li {
  width: 100%;
  padding: 8px;
}

.searchFilter {
  background: #E6F3EF;
  padding: 1em;
  margin-bottom: 30px;
}

@media screen and (max-width: 991px) {
  .searchFilter {
    margin-top: 0px;
  }
}
@media screen and (min-width: 992px) {
  .searchFilter {
    margin-top: 80px;
  }
}
.loading-box {
  background-color: rgba(0, 0, 0, 0.2);
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loading-box.loading-in-modal {
  position: absolute;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-cart {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.3);
}

.loader {
  width: 80px;
  height: 80px;
  /*margin: -75px 0 0 -75px;*/
  border: 16px solid white;
  border-radius: 50%;
  border-top: 16px solid black;
  animation: spin 2s linear infinite;
}

.select-menu-small, .select-menu option, .select-menu {
  width: 100%;
  border: 1px solid #ddd;
  transition: all 0.5s ease;
  padding-left: 10px;
}
.select-menu-small:focus, .select-menu option:focus, .select-menu:focus, .select-menu-small :active, .select-menu :active {
  outline: 0;
}

.select-menu {
  height: 40px;
}
.select-menu option {
  height: 40px;
}

.select-menu-small {
  height: 30px;
  font-size: 12px;
}

.selection {
  position: relative;
  background-color: #eee;
  color: black;
  cursor: pointer;
  margin-left: 10px;
  margin-right: 10px;
  margin: 0 10px 0 10px;
  list-style: none;
  padding: 0;
}
.selection li {
  padding: 10px;
  border-bottom: 1px solid #eee;
  width: 100%;
}
.selection li a {
  display: flex;
  justify-content: space-between;
}
.selection li a:hover {
  text-decoration: none;
}
.selection li a svg {
  width: 14px;
}
.selection li:last-child {
  border-bottom: 0;
}
.selection a {
  color: black;
}
.selection .selection__dropdown {
  width: 100%;
  position: absolute;
  top: 40px;
  left: 0;
  z-index: 100;
  visibility: hidden;
  background-color: #E6F3EF;
  color: black;
  list-style: none;
  padding: 0;
}
.selection .selection__dropdown li {
  border-bottom: 1px #eee solid;
  border-left: 1px #eee solid;
  border-right: 1px #eee solid;
}
.selection .selection__dropdown li:hover {
  background-color: white;
}
.selection:hover .selection__dropdown {
  visibility: visible;
}

.selection--cm {
  border-bottom: 1px solid #eee;
  list-style: none;
  padding: 0;
  margin: 1rem 0 0 0;
}
.selection--cm__label {
  font-size: 1.2em;
  font-weight: bold;
  padding-bottom: 10px;
  border-bottom: 1px solid black;
}
.selection--cm__sub-label {
  font-weight: bold;
  padding-bottom: 10px;
}
.selection--cm__link {
  cursor: pointer;
  display: flex;
  align-items: center;
  line-height: 26px;
}
.selection--cm .pull-right {
  float: right;
}
.selection--cm__expand, .selection--cm__collapse {
  opacity: 0.8;
  cursor: pointer;
}
.selection--cm__expand:hover, .selection--cm__collapse:hover {
  opacity: 1;
}
.selection--cm a {
  color: black;
}
.selection--cm a:hover {
  text-decoration: none;
}
.selection--cm li {
  padding: 10px;
}
.selection--cm__inline-item {
  display: inline-block;
}
.selection--cm .active {
  font-weight: bold;
}
.selection--cm .selection--cm__dropdown {
  margin-left: 15px;
  list-style: none;
  padding: 0;
}

.table .thead-dark th {
  background-color: black;
  border-color: black;
  text-transform: uppercase;
}
.table td {
  vertical-align: middle;
}

.textbox {
  padding: 0 10px;
  height: 2.5rem;
  font-size: 16px;
  font-weight: 400;
  border: 1px solid #ddd;
  width: 100%;
}
.textbox:focus, .textbox:active {
  outline: 0;
}
.textbox-big {
  font-size: 16px;
}
.textbox-small {
  padding: 0 10px;
  height: 1.875rem;
  font-size: 0.75rem;
  font-weight: 400;
  border: 1px solid #ddd;
  width: 100%;
}

.formcontainerblock .EPiServerForms {
  max-width: 800px;
  margin: 0 auto;
}
.formcontainerblock .EPiServerForms .hide {
  display: none !important;
}
.formcontainerblock .EPiServerForms .FormCaptcha__Image {
  margin-top: 0.5rem;
  width: 100%;
}
.formcontainerblock .EPiServerForms .FormCaptcha__Refresh, .formcontainerblock .EPiServerForms .FormResetButton {
  display: inline-block;
  border-radius: 0;
  min-width: 100px;
  font-size: 16px;
  line-height: 16px;
  font-weight: 400;
  text-transform: uppercase;
  text-align: center;
  vertical-align: middle;
  padding: 12px 20px;
  border: 1px solid black;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: transparent;
  -webkit-transition: color 0.15s;
  -o-transition: color 0.15s;
  transition: color 0.15s;
  text-decoration: none;
  min-height: 40px;
  min-width: 100px;
}
.formcontainerblock .EPiServerForms .Form__NavigationBar__Action {
  width: auto !important;
  height: auto !important;
  display: inline-block !important;
  border-radius: 0 !important;
  min-width: 100px !important;
  font-size: 16px !important;
  line-height: 16px;
  font-weight: 400;
  text-transform: uppercase;
  text-align: center !important;
  vertical-align: middle !important;
  padding: 12px 20px !important;
  border: 1px solid black !important;
  -webkit-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;
  background-color: transparent !important;
  -webkit-transition: color 0.15s !important;
  -o-transition: color 0.15s !important;
  transition: color 0.15s !important;
  text-decoration: none !important;
  min-height: 40px !important;
  min-width: 100px !important;
  background-image: none !important;
}
.formcontainerblock .EPiServerForms .form-control-file {
  display: inline-block;
  border-radius: 5px;
  min-width: 100px;
  font-size: 16px;
  line-height: 16px;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  padding: 12px 20px;
  border: 1px solid #ddd;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: transparent;
  -webkit-transition: color 0.15s;
  -o-transition: color 0.15s;
  transition: color 0.15s;
  text-decoration: none;
  min-height: 40px;
  width: 100%;
}
.formcontainerblock .EPiServerForms .form-control {
  padding: 0.5rem 1rem;
}
.formcontainerblock .EPiServerForms .labeltext {
  font-size: 12px;
  font-weight: 600;
  color: #440099;
  text-transform: uppercase;
  margin-bottom: 0.4rem;
}
.formcontainerblock .EPiServerForms .labeltext.label-underline {
  border-bottom: 1px solid #440099;
  padding-bottom: 5px;
}
.formcontainerblock .EPiServerForms .image-choice {
  display: inline-block;
  text-align: center;
}
.formcontainerblock .EPiServerForms .Form__Status {
  position: relative;
}
.formcontainerblock .EPiServerForms .Form__Status .Form__Status__Message {
  padding-left: 3.5rem;
  padding-top: 0;
  margin-top: 2rem;
}
.formcontainerblock .EPiServerForms .Form__Status .Form__Status__Message:before {
  display: inline-block;
  font-family: "Material Design Icons";
  font-size: 36px;
  text-rendering: auto;
  line-height: inherit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  top: 10px;
  left: -3px;
}
.formcontainerblock .EPiServerForms .Form__Status .Form__Status__Message.Form__Success__Message {
  background-color: transparent;
  color: unset;
}
.formcontainerblock .EPiServerForms .Form__Status .Form__Status__Message.Form__Success__Message:before {
  content: "\\f0134";
  color: #008000;
}
.formcontainerblock .EPiServerForms .Form__Status .Form__Status__Message.Form__Warning__Message {
  background-color: transparent;
  color: unset;
}
.formcontainerblock .EPiServerForms .Form__Status .Form__Status__Message.Form__Warning__Message:before {
  content: "\\f05d6";
  color: #f71d1d;
}

.brandambassadorblock .shop-link-wrapper {
  height: 306px;
  border-radius: 10px;
  margin: 0;
}
.brandambassadorblock .shop-link-wrapper h4 {
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
}
.brandambassadorblock .shop-link-wrapper img {
  margin-top: 10px;
  max-height: 198px;
  max-width: 100%;
}
.brandambassadorblock h2 {
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
}
.brandambassadorblock h3 {
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
}
.brandambassadorblock .brand-ambassador-image img {
  width: 100%;
}
.brandambassadorblock .brand-ambassador-recommended-products {
  padding: 0 60px;
}
@media (max-width: 767.98px) {
  .brandambassadorblock .brand-ambassador-recommended-products {
    padding: 0 15px;
  }
  .brandambassadorblock h2 {
    font-size: 20px;
    line-height: 28px;
  }
  .brandambassadorblock h3 {
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
  }
}
.brandambassadorblock .MultiCarousel {
  float: left;
  overflow: hidden;
  width: 100%;
  position: relative;
  Height: 306px;
}
.brandambassadorblock .MultiCarousel .MultiCarousel-inner {
  transition: 1s ease all;
  float: left;
}
.brandambassadorblock .MultiCarousel .MultiCarousel-inner .item {
  float: left;
}
.brandambassadorblock .carousel-control-prev,
.brandambassadorblock .carousel-control-next {
  opacity: 1;
  background: rgba(255, 255, 255, 0);
  height: 250px;
}
.brandambassadorblock .carousel-control-prev div.carousel-prev-arrow::before, .brandambassadorblock .carousel-control-next div.carousel-next-arrow::before {
  border-color: #440099;
  border-style: solid;
  content: "";
  display: inline-block;
  position: relative;
  vertical-align: top;
  border-width: 2px 2px 0 0;
  height: 10px;
  width: 10px;
  top: 15px;
}
.brandambassadorblock .carousel-control-prev.over,
.brandambassadorblock .carousel-control-next.over {
  pointer-events: none;
}
.brandambassadorblock .carousel-control-prev.over div::before,
.brandambassadorblock .carousel-control-next.over div::before {
  border-color: #ddd;
}
.brandambassadorblock .carousel-control-prev {
  left: 0;
}
.brandambassadorblock .carousel-control-prev div.carousel-prev-arrow {
  position: absolute;
  width: 30px;
  height: 30px;
  right: 60px;
}
.brandambassadorblock .carousel-control-prev div.carousel-prev-arrow:before {
  transform: rotate(-135deg);
  left: 1px;
}
.brandambassadorblock .carousel-control-next {
  right: 0;
}
.brandambassadorblock .carousel-control-next div.carousel-next-arrow {
  position: absolute;
  width: 30px;
  height: 30px;
  left: 60px;
}
.brandambassadorblock .carousel-control-next div.carousel-next-arrow:before {
  transform: rotate(45deg);
  left: -1px;
}
@media (min-width: 768px) {
  .brandambassadorblock .two-shop-links {
    display: none;
  }
  .brandambassadorblock .carousel-control-prev div.carousel-prev-arrow::before, .brandambassadorblock .carousel-control-next div.carousel-next-arrow::before {
    border-width: 2px 2px 0 0;
    height: 10px;
    width: 10px;
    top: 15px;
  }
  .brandambassadorblock .carousel-control-prev {
    left: 0;
  }
  .brandambassadorblock .carousel-control-prev div.carousel-prev-arrow {
    width: 30px;
    height: 30px;
    right: 60px;
  }
  .brandambassadorblock .carousel-control-prev div.carousel-prev-arrow:before {
    left: 1px;
  }
  .brandambassadorblock .carousel-control-next {
    right: 0;
  }
  .brandambassadorblock .carousel-control-next div.carousel-next-arrow {
    width: 30px;
    height: 30px;
    left: 60px;
  }
  .brandambassadorblock .carousel-control-next div.carousel-next-arrow:before {
    left: -1px;
  }
}
@media (min-width: 992px) {
  .brandambassadorblock .carousel-inner .shop-link-wrapper {
    height: 210px;
    border-radius: 7px;
  }
  .brandambassadorblock .carousel-inner .shop-link-wrapper h4 {
    font-size: 12px;
    line-height: 18px;
  }
  .brandambassadorblock .carousel-inner .shop-link-wrapper img {
    margin-top: 7px;
    max-height: 120px;
  }
  .brandambassadorblock .carousel-control-prev div.carousel-prev-arrow::before, .brandambassadorblock .carousel-control-next div.carousel-next-arrow::before {
    border-width: 2px 2px 0 0;
    height: 10px;
    width: 10px;
    top: 5px;
  }
  .brandambassadorblock .carousel-control-prev {
    left: 0;
    height: 210px;
  }
  .brandambassadorblock .carousel-control-prev div.carousel-prev-arrow {
    width: 30px;
    height: 30px;
    right: 25px;
  }
  .brandambassadorblock .carousel-control-prev div.carousel-prev-arrow:before {
    left: 1px;
  }
  .brandambassadorblock .carousel-control-next {
    right: 0;
    height: 210px;
  }
  .brandambassadorblock .carousel-control-next div.carousel-next-arrow {
    width: 30px;
    height: 30px;
    left: 25px;
  }
  .brandambassadorblock .carousel-control-next div.carousel-next-arrow:before {
    left: -1px;
  }
}
@media (min-width: 992px) and (max-width: 1199.98px) {
  .brandambassadorblock .carousel-inner .shop-link-wrapper .btn {
    font-size: 12px;
    padding: 0.2rem;
    width: calc(100% - 16px);
  }
}
@media (max-width: 767.98px) {
  .brandambassadorblock .carousel-inner {
    max-width: 250px;
    margin: 0 auto;
  }
  .brandambassadorblock .carousel-inner .shop-link-wrapper .btn {
    font-size: 12px;
    padding: 0.2rem;
    width: calc(100% - 16px);
    max-width: 180px;
  }
  .brandambassadorblock .carousel-control-prev {
    width: calc((100% - 250px) / 2);
    left: 0;
  }
  .brandambassadorblock .carousel-control-prev div.carousel-prev-arrow {
    right: 40%;
  }
  .brandambassadorblock .carousel-control-next {
    width: calc((100% - 250px) / 2);
    right: 0;
  }
  .brandambassadorblock .carousel-control-next div.carousel-next-arrow {
    left: 40%;
  }
}
@media (min-width: 1200px) {
  .brandambassadorblock .carousel-inner .shop-link-wrapper {
    height: 306px;
    border-radius: 10px;
  }
  .brandambassadorblock .carousel-inner .shop-link-wrapper h4 {
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
  }
  .brandambassadorblock .carousel-inner .shop-link-wrapper img {
    margin-top: 10px;
    max-height: 198px;
    max-width: 100%;
  }
  .brandambassadorblock .carousel-control-prev div.carousel-prev-arrow::before, .brandambassadorblock .carousel-control-next div.carousel-next-arrow::before {
    border-width: 3px 3px 0 0;
    height: 16px;
    width: 16px;
    top: 10px;
  }
  .brandambassadorblock .carousel-control-prev {
    left: 0px;
    height: 250px;
  }
  .brandambassadorblock .carousel-control-prev div.carousel-prev-arrow {
    width: 50px;
    height: 50px;
    right: 25px;
  }
  .brandambassadorblock .carousel-control-prev div.carousel-prev-arrow:before {
    left: 3px;
  }
  .brandambassadorblock .carousel-control-next {
    right: 0;
    height: 250px;
  }
  .brandambassadorblock .carousel-control-next div.carousel-next-arrow {
    width: 50px;
    height: 50px;
    left: 25px;
  }
  .brandambassadorblock .carousel-control-next div.carousel-next-arrow:before {
    left: -3px;
  }
}

.breadcrumb__group {
  padding: 0;
  list-style-type: none;
}
.breadcrumb__group li {
  border-bottom: 4px solid transparent;
}
.breadcrumb__item {
  padding: 4px 12px;
  text-transform: uppercase;
  border-bottom: 4px solid transparent;
  line-height: 1.5;
  letter-spacing: 0.1em;
  font-weight: 400;
}
.breadcrumb__item:first-child {
  padding-left: 0;
}
.breadcrumb__item:last-child {
  padding-right: 0;
}
.breadcrumb__item.is-active {
  border-bottom: 4px solid #a7c5c3;
}
.breadcrumb__item a:hover {
  text-decoration: none;
  color: #a7c5c3;
}
.breadcrumb__item:hover {
  color: #a7c5c3;
}
.breadcrumb__slash {
  padding: 4px 8px;
  pointer-events: none;
}

.bubble-info-bubble {
  background-color: #fff;
  box-shadow: 0px 16px 24px -10px rgba(0, 0, 0, 0.2);
  border-radius: 40px;
  cursor: pointer;
  font-weight: 400;
  font-size: 24px;
  line-height: 36px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.02em;
  -webkit-transition: background-color 0.3s;
  -moz-transition: background-color 0.3s;
  transition: background-color 0.3s;
  min-height: 375px;
  overflow: hidden;
}
.bubble-info-bubble .bubble-info-bg-image {
  background-size: cover;
  background-position: center center;
  height: 200px;
}
.bubble-info-bubble .bubble-info-text {
  color: #000;
  -webkit-transition: color 0.3s;
  -moz-transition: color 0.3s;
  transition: color 0.3s;
  min-height: 175px;
}
.bubble-info-bubble .bubble-info-text .row {
  align-content: space-between;
}
.bubble-info-bubble .bubble-info-text .bubble-open-close {
  transition: transform 0.2s;
  display: inline-block;
  width: 14px;
  height: 14px;
  line-height: 14px;
  font-size: 30px;
}
.bubble-info-bubble .bubble-info-text p {
  margin: 0;
}
.bubble-info-bubble .bubble-info-text .bubble-text-padding {
  padding-top: 21px;
  padding-right: 36px;
  padding-left: 36px;
}
.bubble-info-bubble:hover, .bubble-info-bubble.chosen-bubble {
  background-color: #8859c5;
}
.bubble-info-bubble:hover .bubble-info-text, .bubble-info-bubble.chosen-bubble .bubble-info-text {
  color: #fff;
}
.bubble-info-bubble.chosen-bubble .bubble-open-close {
  transform: rotate(-45deg);
}
.bubble-info-bubble.chosen-bubble::after {
  content: "";
  clip-path: polygon(0 0, 50% 100%, 100% 0);
  position: absolute;
  width: 30px;
  height: 20px;
  bottom: -18px;
  left: calc(50% - 15px);
  background-color: #8859c5;
}

.bubble-top-padding {
  padding-top: 30px;
}
@media (max-width: 575px) {
  .bubble-top-padding {
    padding-right: 30px;
    padding-left: 30px;
  }
}

.itemRowBreak {
  max-height: 10px;
  clear: both;
  padding: 8px 0;
  -webkit-transition: max-height 0.75s ease-in;
  -moz-transition: max-height 0.75s ease-in;
  -ms-transition: max-height 0.75s ease-in;
  -o-transition: max-height 0.75s ease-in;
  transition: max-height 0.75s ease-in;
  width: 100%;
}
.itemRowBreak .bubbleInfo {
  padding-left: 30px;
  padding-right: 30px;
  text-align: left;
}

.button-block {
  text-decoration: none;
  color: #000;
}
.button-block:hover {
  color: #000;
}
.button-block--blue {
  color: #007BFF;
}
.button-block--blue:hover {
  color: #007BFF;
}
.button-block--orange {
  color: #F7542B;
}
.button-block--orange:hover {
  color: #F7542B;
}
.button-block--italic {
  font-style: italic;
}
.button-block--big {
  font-size: 35px;
}
.button-block--bordered {
  border: 1px solid black;
}

.buttonblock:is(.displaymode-none) {
  padding-left: 15px;
}
.buttonblock:is(.displaymode-none) div {
  margin-right: 0 !important;
}

.arrow-button {
  text-align: left;
  background-color: #fff;
  border-color: #fff;
  color: #000;
  font-size: 18px;
  letter-spacing: 0.02em !important;
}
.arrow-button:after {
  color: #8859C5;
  display: inline-block;
  font: normal normal normal 24px/1 "Material Design Icons";
  content: "\\f0142";
  font-size: 28px;
  top: 14px;
  right: 38px;
  position: absolute;
  text-rendering: auto;
  line-height: inherit;
  -webkit-font-smoothing: antialiased;
}
.arrow-button:hover {
  background-color: #8859C5;
  border-color: #8859C5;
  color: #fff;
}
.arrow-button:hover:after {
  color: #fff;
}
.arrow-button.mdi:before {
  top: 2px !important;
  left: -30px;
  margin-right: -15px;
}

.carousel.slide .carousel-item .item__third:first-child .carousel-item-text-area,
.carousel.slide .carousel-item .item__third:last-child .carousel-item-text-area {
  display: none;
}

.carousel-item-text-area .carousel-item-button-area {
  max-width: 800px;
  margin-right: auto;
  margin-left: auto;
}

.show-neighbors {
  overflow: hidden;
}
.show-neighbors .item__third:first-child,
.show-neighbors .item__third:last-child {
  display: none;
}
.show-neighbors .carousel-control-prev:hover, .show-neighbors .carousel-control-prev:focus, .show-neighbors .carousel-control-next:hover, .show-neighbors .carousel-control-next:focus {
  opacity: 1;
  background: rgba(255, 255, 255, 0.2);
}
.show-neighbors .carousel-control-prev,
.show-neighbors .carousel-control-next {
  opacity: 1;
  background: rgba(255, 255, 255, 0);
}
.show-neighbors .carousel-control-prev div.carousel-prev-arrow::before, .show-neighbors .carousel-control-next div.carousel-next-arrow::before {
  border-color: #440099;
  border-style: solid;
  content: "";
  display: inline-block;
  position: relative;
  vertical-align: top;
}
.show-neighbors .carousel-control-prev div.carousel-prev-arrow {
  background-color: #fff;
  position: absolute;
}
.show-neighbors .carousel-control-prev div.carousel-prev-arrow:before {
  transform: rotate(-135deg);
}
.show-neighbors .carousel-control-next div.carousel-next-arrow {
  background-color: #fff;
  position: absolute;
}
.show-neighbors .carousel-control-next div.carousel-next-arrow:before {
  transform: rotate(45deg);
}
.show-neighbors .carousel-item .carousel-item-image-area .container, .show-neighbors .carousel-item .carousel-item-image-area .row, .show-neighbors .carousel-item .hero-settings .container, .show-neighbors .carousel-item .hero-settings .row {
  height: 100%;
}
.show-neighbors .carousel-item .carousel-item-image-area, .show-neighbors .carousel-item .hero-settings {
  height: 65vw;
  max-height: 450px;
}
.show-neighbors .carousel-indicators {
  margin-right: 10.1%;
  margin-left: 10.1%;
}
.show-neighbors .carousel-control-prev,
.show-neighbors .carousel-control-next {
  height: 65vw;
  max-height: 450px;
  width: 10.1%;
}
.show-neighbors .carousel-control-prev div.carousel-prev-arrow::before, .show-neighbors .carousel-control-next div.carousel-next-arrow::before {
  border-width: 2px 2px 0 0;
  height: 10px;
  width: 10px;
  top: 15px;
}
.show-neighbors .carousel-control-prev {
  border-right: 8px solid #fff;
}
.show-neighbors .carousel-control-prev div.carousel-prev-arrow {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  right: -23px;
}
.show-neighbors .carousel-control-prev div.carousel-prev-arrow:before {
  left: 1px;
}
.show-neighbors .carousel-control-next {
  border-left: 6px solid #fff;
}
.show-neighbors .carousel-control-next div.carousel-next-arrow {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  left: -23px;
}
.show-neighbors .carousel-control-next div.carousel-next-arrow:before {
  left: -1px;
}
.show-neighbors .carousel-inner {
  width: 239.4%;
  left: -69.7%;
}
@media (min-width: 1200px) {
  .show-neighbors .carousel-item .carousel-item-image-area, .show-neighbors .carousel-item .hero-settings {
    height: 33vw;
    max-height: 620px;
  }
  .show-neighbors .carousel-indicators {
    margin-right: 25.1%;
    margin-left: 25.1%;
  }
  .show-neighbors .carousel-control-prev,
  .show-neighbors .carousel-control-next {
    height: 33vw;
    max-height: 620px;
    width: 25.1%;
  }
  .show-neighbors .carousel-control-prev div.carousel-prev-arrow::before, .show-neighbors .carousel-control-next div.carousel-next-arrow::before {
    border-width: 3px 3px 0 0;
    height: 16px;
    width: 16px;
    top: 30px;
  }
  .show-neighbors .carousel-control-prev {
    border-right: 8px solid #fff;
  }
  .show-neighbors .carousel-control-prev div.carousel-prev-arrow {
    width: 72px;
    height: 72px;
    border-radius: 36px;
    right: -40px;
  }
  .show-neighbors .carousel-control-prev div.carousel-prev-arrow:before {
    left: 3px;
  }
  .show-neighbors .carousel-control-next {
    border-left: 8px solid #fff;
  }
  .show-neighbors .carousel-control-next div.carousel-next-arrow {
    width: 72px;
    height: 72px;
    border-radius: 36px;
    left: -40px;
  }
  .show-neighbors .carousel-control-next div.carousel-next-arrow:before {
    left: -3px;
  }
  .show-neighbors .carousel-inner {
    width: 149.4%;
    left: -24.7%;
  }
}
.show-neighbors .carousel-item-next:not(.carousel-item-left),
.show-neighbors .carousel-item-right.active {
  -webkit-transform: translate3d(33%, 0, 0);
  transform: translate3d(33%, 0, 0);
}
.show-neighbors .carousel-item-prev:not(.carousel-item-right),
.show-neighbors .carousel-item-left.active {
  -webkit-transform: translate3d(-33%, 0, 0);
  transform: translate3d(-33%, 0, 0);
}
.show-neighbors .item__third {
  display: block !important;
  float: left;
  position: relative; /* captions can now be added */
  width: 33.33333333%;
}

.block.eventblock .tab-content {
  background-color: #fff;
  margin-top: 54px;
}
@media (max-width: 767.98px) {
  .block.eventblock .tab-content {
    margin-top: 33px;
  }
}
.block.eventblock .tab-content .round-border {
  border-radius: 10px;
  border: 1px solid #dee2e6;
  margin-top: 22px;
  min-height: 235px;
}
@media (min-width: 992px) {
  .block.eventblock .tab-content .round-border {
    min-height: 260px;
  }
}
@media (min-width: 1200px) {
  .block.eventblock .tab-content .round-border {
    min-height: 325px;
  }
}
@media (max-width: 575.98px) {
  .block.eventblock .tab-content .round-border {
    margin-right: 0;
    margin-left: 0;
  }
}
.block.eventblock .tab-content .round-border .round-border-image {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  background-position: center center;
  background-size: cover;
}
@media (max-width: 991.98px) {
  .block.eventblock .tab-content .round-border .round-border-image {
    height: 50vw;
    border-bottom-left-radius: 0;
    border-top-right-radius: 10px;
  }
}
@media (max-width: 991.98px) {
  .block.eventblock .tab-content .round-border {
    border: none;
  }
  .block.eventblock .tab-content .round-border .event-time:before {
    color: #8859c5;
  }
  .block.eventblock .tab-content .round-border .mobile-zero-padding {
    padding: 0 !important;
  }
  .block.eventblock .tab-content .round-border .mobile-zero-padding p {
    margin-bottom: 0.6rem;
  }
}
.block.eventblock .tab-content .session-description {
  max-width: 800px;
  margin: 0 auto;
}
.block.eventblock .tab-content .session-description .event-time {
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 0.5rem;
  margin-top: 0;
  line-height: 2rem;
  letter-spacing: 0.02em;
}
@media (max-width: 767.98px) {
  .block.eventblock .tab-content .session-description .event-time {
    font-size: 16px;
    margin-bottom: 0.27rem;
  }
}
.block.eventblock .tab-content .session-description .event-time:before {
  margin-right: 7px;
}
.block.eventblock .tab-content .session-description h4 {
  font-weight: 400;
  font-size: 24px;
}
@media (max-width: 767.98px) {
  .block.eventblock .tab-content .session-description h4 {
    font-size: 20px;
  }
}
.block.eventblock .event-header {
  padding: 50px 0;
}
.block.eventblock .event-header p, .block.eventblock .event-header h1, .block.eventblock .event-header h2, .block.eventblock .event-header h3, .block.eventblock .event-header h4, .block.eventblock .event-header h5, .block.eventblock .event-header h6, .block.eventblock .event-header ol, .block.eventblock .event-header ul {
  max-width: unset;
}
.block.eventblock .event-nav-tabs {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  padding: 0 2em;
}
.block.eventblock .event-nav-tabs .screen-width-block {
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
}
@media (max-width: 767.98px) {
  .block.eventblock .event-nav-tabs .screen-width-block {
    width: 100vw;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
  }
}
.block.eventblock .event-nav-mobile-header {
  height: 54px;
  background-color: #8859C5;
  color: #fff;
  font-size: 20px;
  line-height: 32px;
  display: block;
  padding: 11px 0;
  cursor: pointer;
}
.block.eventblock .event-nav-mobile-header:hover {
  color: #fff;
}
.block.eventblock .event-arrowLinkWrapper {
  width: 28px;
  height: 28px;
  position: absolute;
  right: 12px;
  top: 20px;
  background-color: rgba(136, 89, 197, 0.5);
  border-radius: 50%;
}
.block.eventblock .event-link-showHide {
  border: solid #fff;
  border-width: 0 2px 2px 0;
  display: inline-block;
  position: absolute;
  padding: 4px;
  top: 11px !important;
  left: 9px;
  line-height: 17px;
  -webkit-transition: -webkit-transform linear 0.7s;
  -moz-transition: -moz-transform 0.7s;
  transition: transform 0.7s;
  transform: rotate(-135deg);
  -moz-transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
  top: 14px;
}
.block.eventblock .event-link-down {
  transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}
.block.eventblock .event-nav-tabs h1, .block.eventblock .event-slide h1 {
  font-size: 48px;
  margin: 0;
  letter-spacing: 0.02em;
}
.block.eventblock .event-nav-tabs h3, .block.eventblock .event-slide h3 {
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  letter-spacing: 0.02em;
  color: #242829;
}
.block.eventblock .event-nav-tabs h3.color-light, .block.eventblock .event-slide h3.color-light {
  color: #fff;
}
.block.eventblock .event-nav-tabs-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 54px;
  background: #ECE9F2;
  z-index: 2;
  -webkit-transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);
  transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);
  padding: 0;
}
.block.eventblock .inside-event {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  height: 84px;
  padding: 0;
}
.block.eventblock .event-nav-tabs-container--top-first {
  position: fixed;
  top: 100px;
  left: 0;
  -webkit-transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);
  transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);
}
.block.eventblock .event-nav-tabs-container--top-second {
  position: fixed;
  top: 100px;
  left: 0;
}
.block.eventblock .event-nav-tabs-container-wrap {
  height: 84px;
}
@media (min-width: 992px) {
  .block.eventblock .event-nav-tabs-container-wrap {
    background-color: #ECE9F2;
  }
}
@media (max-width: 575.98px) {
  .block.eventblock .event-nav-tabs-container-wrap {
    padding: 0;
  }
}
@media (max-width: 991.98px) {
  .block.eventblock .event-nav-tabs-container-wrap {
    height: auto;
  }
  .block.eventblock .event-nav-tabs-container {
    background-color: #8859C5;
  }
  .block.eventblock .inside-event {
    display: block;
    height: auto;
    background-color: #ECE9F2;
    padding: 0;
  }
  .block.eventblock .inside-event .event-nav-tab, .block.eventblock .inside-event .event-nav-link, .block.eventblock .inside-event .event-nav-external-quick-link {
    height: 79px;
    justify-content: left;
    padding: 0 15px;
  }
}
@media (max-width: 991.98px) and (max-width: 1199.98px) {
  .block.eventblock .inside-event .event-nav-tab, .block.eventblock .inside-event .event-nav-link, .block.eventblock .inside-event .event-nav-external-quick-link {
    padding: 0 30px;
  }
}
@media (max-width: 1169px) {
  .block.eventblock .event-nav-tabs-container--top-first {
    top: 90px;
  }
  .block.eventblock .event-nav-tabs-container--top-second {
    top: 90px;
  }
}
.block.eventblock .event-nav-tab, .block.eventblock .event-nav-link, .block.eventblock .event-nav-external-quick-link {
  display: -webkit-box;
  display: -ms-flexbox;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  align-items: center;
  -webkit-box-flex: 1;
  -ms-flex: auto;
  flex: auto;
  color: #242829;
  font-size: 24px;
  font-weight: 300;
}
@media (min-width: 992px) {
  .block.eventblock .event-nav-tab, .block.eventblock .event-nav-link, .block.eventblock .event-nav-external-quick-link {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    -webkit-transition: all 0.5s ease;
    transition: all 0.5s ease;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
  }
}
@media (max-width: 1199.98px) {
  .block.eventblock .event-nav-tab, .block.eventblock .event-nav-link, .block.eventblock .event-nav-external-quick-link {
    font-size: 20px;
    line-height: 22px;
  }
}
.block.eventblock .event-nav-tab span.event-day, .block.eventblock .event-nav-link span.event-day, .block.eventblock .event-nav-external-quick-link span.event-day {
  font-size: 16px;
  font-weight: 400;
  width: 100%;
}
@media (max-width: 1200px) {
  .block.eventblock .event-nav-tab span.event-day, .block.eventblock .event-nav-link span.event-day, .block.eventblock .event-nav-external-quick-link span.event-day {
    font-size: 14px;
  }
}
.block.eventblock .event-nav-tab:hover, .block.eventblock .event-nav-tab.active, .block.eventblock .event-nav-external-quick-link:hover, .block.eventblock .event-nav-external-quick-link.active, .block.eventblock .event-nav-link.active, .block.eventblock .event-nav-link:hover {
  color: white;
  background-color: #8859C5;
  text-decoration: none;
}
.block.eventblock .event-nav-tab.chosen-day {
  display: -webkit-box !important;
  display: -ms-flexbox !important;
}
.block.eventblock .event-nav-link {
  background-color: #C4B1CF;
}
.block.eventblock .event-nav-link:after {
  content: "\\f0142";
  font-family: "Material Design Icons";
  margin-left: 0.5rem;
  font-size: 20px;
  margin-top: 3px;
}

.faqcontainerblock {
  font-size: 18px;
  line-height: 32px;
  letter-spacing: 0.02em;
  color: #000;
}
@media (max-width: 991.98px) {
  .faqcontainerblock {
    font-size: 16px;
    line-height: 28px;
  }
}
.faqcontainerblock h2 {
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  letter-spacing: 0.02em;
}
@media (max-width: 991.98px) {
  .faqcontainerblock h2 {
    font-size: 24px;
    line-height: 36px;
  }
}
.faqcontainerblock p, .faqcontainerblock h1, .faqcontainerblock h2, .faqcontainerblock h3, .faqcontainerblock h4, .faqcontainerblock h5, .faqcontainerblock h6 {
  max-width: 1000px;
  margin-right: 0;
  margin-left: 0;
}

.faqitemblock .col-12 {
  max-width: 1000px;
}
.faqitemblock h5 {
  font-weight: 600;
  font-size: 18px;
  line-height: 32px;
  letter-spacing: 0.02em;
  cursor: pointer;
}
@media (max-width: 991.98px) {
  .faqitemblock h5 {
    font-size: 16px;
    line-height: 28px;
  }
}
@media (min-width: 992px) {
  .faqitemblock h5 {
    padding-right: 120px !important;
  }
}
.faqitemblock .faq-item-content {
  line-height: 1.6rem;
  font-size: 1rem;
}
@media (min-width: 992px) {
  .faqitemblock .faq-item-content {
    padding-right: 120px !important;
  }
}
.faqitemblock a {
  font-weight: 600;
  text-decoration: underline;
  color: #000;
}
.faqitemblock .faq-arrowLinkWrapper {
  width: 22px;
  height: 22px;
  position: absolute;
  right: 12px;
  top: -5px;
}
.faqitemblock .faq-link-showHide {
  border: solid #440099;
  border-width: 0 2px 2px 0;
  display: inline-block;
  position: absolute;
  padding: 4px;
  top: 10px;
  left: 5px;
  line-height: 17px;
  -webkit-transition: -webkit-transform linear 0.7s;
  -moz-transition: -moz-transform 0.7s;
  transition: transform 0.7s;
}
.faqitemblock .faq-link-showHide {
  transform: rotate(-135deg);
  -moz-transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}
.faqitemblock .collapsed .faq-link-showHide {
  transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}

.grid-special {
  height: 615px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 32px;
  width: calc(100% - 32px);
}

.grid-special-wrapper {
  overflow: hidden;
  border-radius: 10px;
}

.grid-special-wrapper {
  font-size: 20px;
}
.grid-special-wrapper h3 {
  font-size: 48px;
  font-weight: 600;
  margin-bottom: 30px;
}
.grid-special-wrapper p {
  margin-bottom: 0;
  letter-spacing: 0.4px;
}

.normal-font-size .grid-special-wrapper {
  font-size: 16px;
}
.normal-font-size .grid-special-wrapper h3 {
  font-size: 24px;
  font-weight: 400;
  margin-bottom: 15px;
}

.grid-special-bg-image {
  background-size: cover;
  background-position: center center;
}

.grid-special-50 {
  flex-grow: 1;
  width: 58%;
  height: calc(50% - 16px);
}
.grid-special-50.grid-special-even-numbers {
  width: 50%;
}
.grid-special-50 .grid-special-50-text {
  padding-top: 45px !important;
  padding-bottom: 45px !important;
  flex-direction: column;
}
.grid-special-50 .grid-special-text {
  height: 100%;
  padding-left: 36px !important;
  padding-right: 36px !important;
}

.grid-special-100 {
  flex-grow: 1;
  width: 42%;
  flex-basis: 100%;
}
.grid-special-100.grid-special-even-numbers {
  width: 50%;
}
.grid-special-100 .grid-special-100-text {
  flex-direction: column;
}
.grid-special-100 .grid-special-bg-image {
  height: 62%;
}
.grid-special-100 .grid-special-text {
  height: 38%;
  padding-left: 36px !important;
  padding-right: 36px !important;
}

@media (min-width: 1200px) {
  .normal-font-size .grid-special-wrapper.grid-special-50 .grid-special-text {
    padding-left: 60px !important;
    padding-right: 60px !important;
  }
}
@media (min-width: 992px) {
  .normal-font-size .grid-special-wrapper.grid-special-100 .grid-special-text {
    padding-left: 75px !important;
    padding-right: 75px !important;
  }
}
@media (max-width: 1199px) {
  .normal-font-size {
    height: auto !important;
    gap: 20px;
    width: 100%;
  }
  .normal-font-size .grid-special-50 {
    flex-grow: 1;
    width: 100%;
    min-height: 245px;
  }
  .normal-font-size .grid-special-50.grid-special-even-numbers {
    width: 100%;
  }
  .normal-font-size .grid-special-50 .grid-special-bg-image {
    min-height: 245px;
  }
  .normal-font-size .grid-special-100 {
    flex-grow: 1;
    width: 100%;
    flex-basis: unset;
    min-height: 430px;
  }
  .normal-font-size .grid-special-100.grid-special-even-numbers {
    width: 100%;
  }
  .normal-font-size .grid-special-100 .grid-special-bg-image {
    min-height: 340px;
  }
}
@media (max-width: 991px) {
  .grid-special {
    height: 400px !important;
  }
  .grid-special.normal-font-size {
    height: auto !important;
    gap: 20px;
    width: 100%;
  }
  .grid-special.normal-font-size .grid-special-50 {
    flex-grow: 1;
    width: 100%;
    min-height: 245px;
  }
  .grid-special.normal-font-size .grid-special-50.grid-special-even-numbers {
    width: 100%;
  }
  .grid-special.normal-font-size .grid-special-100 {
    flex-grow: 1;
    width: 100%;
    flex-basis: unset;
    min-height: 430px;
  }
  .grid-special.normal-font-size .grid-special-100.grid-special-even-numbers {
    width: 100%;
  }
  .grid-special-wrapper {
    font-size: 14px;
  }
  .grid-special-wrapper h3 {
    font-size: 36px;
    font-weight: 600;
    margin-bottom: 14px;
  }
  .normal-font-size .grid-special-wrapper h3 {
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 10px;
  }
  .grid-special-100 .grid-special-100-text {
    padding-top: 23px !important;
  }
  .grid-special-50 .grid-special-50-text {
    padding-top: 23px !important;
    padding-bottom: 23px !important;
  }
}
@media (max-width: 767px) {
  .grid-special {
    height: auto !important;
    gap: 20px;
    width: 100%;
  }
  .grid-special-wrapper {
    font-size: 14px;
  }
  .grid-special-wrapper h3 {
    font-size: 32px;
    font-weight: 600;
    margin-bottom: 12px;
  }
  .normal-font-size .grid-special-wrapper h3 {
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 8px;
  }
  .normal-font-size .grid-special-50 .grid-special-bg-image {
    min-height: 340px;
  }
  .grid-special-50 {
    flex-grow: 1;
    width: 100%;
    height: 245px;
  }
  .grid-special-50.grid-special-even-numbers {
    width: 100%;
  }
  .grid-special-50 .grid-special-50-text {
    padding-top: 16px !important;
    padding-bottom: 16px !important;
  }
  .grid-special-100 {
    flex-grow: 1;
    width: 100%;
    flex-basis: unset;
    height: 430px;
  }
  .grid-special-100.grid-special-even-numbers {
    width: 100%;
  }
  .grid-special-100 .grid-special-100-text {
    padding-top: 16px !important;
    padding-bottom: 16px !important;
  }
  .no-mobile-padding {
    padding: 0;
  }
}
@media (max-width: 615px) {
  .grid-special-50 {
    height: 40vw;
  }
  .grid-special-100 {
    height: 70vw;
  }
}
@media (max-width: 350px) {
  .griduspblock .container {
    padding: 0;
  }
  .grid-special-wrapper {
    font-size: 14px;
    line-height: 20px;
  }
  .grid-special-wrapper h3 {
    font-size: 26px;
    line-height: 1.6rem;
    font-weight: 600;
    margin-bottom: 4px;
  }
  .normal-font-size .grid-special-wrapper h3 {
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 1.4rem;
    margin-bottom: 3px;
  }
}
@media (max-width: 1199px) {
  .normal-font-size .grid-special-50 {
    height: auto;
  }
  .normal-font-size .grid-special-100 {
    height: auto;
  }
}
.instagramblock .instagram-col {
  margin-bottom: 30px;
  cursor: pointer;
}
.instagramblock .instagram-col .responsive-instagram-object {
  -webkit-transition: all 0.4s ease;
}
.instagramblock .instagram-col:hover .responsive-instagram-object {
  -webkit-filter: contrast(125%) brightness(105%);
  filter: contrast(125%) brightness(105%);
  -webkit-box-shadow: 0px 24px 20px -16px rgba(29, 35, 26, 0.24);
  box-shadow: 0px 24px 20px -16px rgba(29, 35, 26, 0.24);
}
.instagramblock .instagram-col .responsive-instagram-object {
  background-color: #000;
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 100%;
}
.instagramblock .instagram-col .responsive-instagram-object video, .instagramblock .instagram-col .responsive-instagram-object img {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.instagramblock .instagram-col .responsive-instagram-object img {
  object-fit: cover;
}
.instagramblock .instagram-col .instagram-carousel-album-icon, .instagramblock .instagram-col .instagram-video-icon {
  width: 47px;
  height: 45px;
  position: absolute;
  top: 5px;
  right: 0;
  z-index: 2;
}
.instagramblock .instagram-col .instagram-carousel-album-icon .mdi, .instagramblock .instagram-col .instagram-video-icon .mdi {
  font-size: 25px;
  color: #aaa;
}
.instagramblock .modal {
  opacity: 0.95;
  position: fixed;
  padding-right: 0 !important;
  text-align: left;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
  overflow: -moz-scrollbars-none;
}
.instagramblock .modal::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}
.instagramblock .modal .modal-dialog {
  max-width: 100vw;
  margin: 0;
}
.instagramblock .modal .modal-dialog .modal-content {
  min-height: 100vh;
  border-radius: 0;
}
@media (max-width: 575px) {
  .instagramblock .modal .modal-dialog .modal-content .modal-header {
    position: fixed;
    top: 0;
    left: 0;
    padding: 7px;
    z-index: 1025;
  }
}
.instagramblock .modal .modal-dialog .modal-content .btn-close::after {
  content: "\\f0156";
  font-family: "Material Design Icons";
  font-size: 35px;
  color: #440099;
  cursor: pointer;
  line-height: 1;
}
.instagramblock .modal .modal-header {
  border-bottom: none;
  justify-content: end;
}
.instagramblock .modal .modal-body {
  padding: 45px;
  height: calc(100% - 69px);
}
.instagramblock .modal .modal-body .scrollable-content {
  overflow-y: auto;
  height: 100%;
}
.instagramblock .modal .modal-body .responsive-instagram-object video {
  max-height: 100%;
  background-color: #000;
}
@media (min-width: 992px) {
  .instagramblock .modal .modal-dialog {
    width: 1240px;
    max-width: 100%;
    margin: calc(50vh - 820px / 2) auto;
  }
  .instagramblock .modal .modal-dialog .modal-content {
    height: 820px;
    min-height: 820px;
    max-height: 100vh;
    border-radius: 10px;
  }
  .instagramblock .modal .modal-body {
    padding: 0px 60px 60px;
  }
}

.investors-hero-block {
  position: relative;
  overflow: hidden;
}
.investors-hero-block__image {
  position: absolute;
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  height: 100%;
  background-position: top center;
}
.investors-hero-block__overlay {
  position: absolute;
  width: 100%;
  height: 100%;
}

.investorsheroblock {
  height: 500px;
}
.investorsheroblock .investors-hero-iframe {
  width: 100%;
  max-width: 220px;
  height: 140px;
  border: 0;
  float: left;
}
@media (min-width: 992px) {
  .investorsheroblock {
    height: 546px;
  }
  .investorsheroblock .investors-hero-iframe {
    width: 248px;
    max-width: 248px;
    height: 190px;
  }
}
.investorsheroblock .investors-hero-block-content {
  position: relative;
  margin: 0 auto;
  width: 1004px;
  max-width: 100%;
  padding-top: 160px;
}
.investorsheroblock .investors-hero-block-content h1 {
  color: #fff;
  margin-bottom: 29px;
  line-height: 58px;
  max-width: unset;
}
@media (min-width: 992px) {
  .investorsheroblock .investors-hero-block-content h1 {
    text-align: center;
  }
}
.investorsheroblock .investors-hero-block-content .investors-hero-block-info {
  background-color: #fff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  height: 300px;
  width: 1004px;
  max-width: 90%;
  margin: 0 auto;
  font-size: 16px;
}
.investorsheroblock .investors-hero-block-content .investors-hero-block-info h3 {
  font-weight: normal;
  font-size: 26px;
  line-height: 26px;
  text-transform: uppercase;
  padding-top: 35px;
  margin-bottom: 20px;
}
.investorsheroblock .investors-hero-block-content .investors-hero-block-info h4.display-4 {
  margin-top: 20px;
  font-size: 38px;
  font-weight: normal;
}
.investorsheroblock .investors-hero-block-content .investors-hero-block-info .investors-hero-report-link {
  display: flex;
  align-items: center;
}
.investorsheroblock .investors-hero-block-content .investors-hero-block-info .investors-hero-report-link ul {
  list-style: none;
  position: relative;
  margin: 0 auto;
  top: -15px;
  padding-inline-start: 0;
}
@media (max-width: 991.98px) {
  .investorsheroblock .investors-hero-block-content .investors-hero-block-info .investors-hero-report-link ul {
    top: 0;
  }
  .investorsheroblock .investors-hero-block-content .investors-hero-block-info .investors-hero-report-link ul li {
    margin-left: 0;
  }
}
.investorsheroblock .investors-hero-block-content .investors-hero-block-info .investors-hero-report-link ul li {
  float: left;
}
.investorsheroblock .investors-hero-block-content .investors-hero-block-info .investors-hero-report-link ul li a {
  font-weight: 600;
  font-size: 16px;
}
.investorsheroblock .investors-hero-block-content .investors-hero-block-info .investors-hero-report-link ul li a::before {
  color: #242829;
  content: "\\f01da";
  font-family: "Material Design Icons";
  margin-right: 0.5rem;
}
.investorsheroblock .investors-hero-block-content .investors-hero-block-info .investors-hero-report-link ul li a:hover::after, .investorsheroblock .investors-hero-block-content .investors-hero-block-info .investors-hero-report-link ul li a:hover::before {
  color: #8859C5;
}
@media (max-width: 991.98px) {
  .investorsheroblock .investors-hero-block-content {
    position: absolute;
    width: 1004px;
    padding-top: 0;
    bottom: 54px;
  }
  .investorsheroblock .investors-hero-block-content h1 {
    font-size: 32px;
    line-height: 40px;
    font-weight: 400;
    text-align: left;
    padding: 0 3rem;
  }
  .investorsheroblock .investors-hero-block-content .investors-hero-block-info {
    background-color: #fff;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    height: 330px;
    width: 1004px;
    max-width: 90%;
    margin: 0 auto;
    font-size: 16px;
  }
  .investorsheroblock .investors-hero-block-content .investors-hero-block-info h3 {
    font-size: 14px;
    line-height: 22px;
    padding-top: 16px;
    margin-bottom: 5px;
  }
  .investorsheroblock .investors-hero-block-content .investors-hero-block-info h4.display-4 {
    margin-top: 20px;
    font-size: 24px;
  }
  .investorsheroblock .investors-hero-block-content .investors-hero-block-info .investors-hero-stats-header {
    font-size: 12px;
    line-height: 18px;
  }
}
@media (max-width: 767.98px) {
  .investorsheroblock .investors-hero-block-content .investors-hero-block-info h4.display-4 {
    margin-top: 20px;
    font-size: 20px;
    font-weight: 600;
  }
}

#sib_embed_signup #sib-container {
  padding: 0;
  background: none;
}
#sib_embed_signup #sib-container .row.mandatory-email {
  max-width: 1000px;
  margin: 0 auto;
}
@media (max-width: 991px) {
  #sib_embed_signup #sib-container .row.mandatory-email {
    margin-right: -15px;
    margin-left: -15px;
  }
}
#sib_embed_signup .sib-form-message-panel {
  border-radius: 3px;
}
#sib_embed_signup .sib-form-message-panel#error-message {
  color: #661d1d;
  background-color: #ffeded;
  border-color: #ff4949;
}
#sib_embed_signup .sib-form-message-panel#success-message {
  color: #085229;
  background-color: #e7faf0;
  border-color: #13ce66;
}
#sib_embed_signup .entry__error.entry__error--primary {
  color: #661d1d;
  background-color: #ffeded;
  border-radius: 3px;
  border-color: #ff4949;
}
#sib_embed_signup .sib-message-wrapper {
  margin: 0 auto;
  padding: 0 32px;
  max-width: 540px;
}
#sib_embed_signup .sib-message-wrapper .sib-form-message-panel--active {
  margin-top: 60px;
  position: relative;
  display: block;
  width: 100%;
}
#sib_embed_signup #sib-container input:-ms-input-placeholder {
  text-align: left;
  color: #b0ccda;
}
#sib_embed_signup #sib-container input::placeholder {
  text-align: left;
  color: #b0ccda;
}
#sib_embed_signup .input-group .form-control:not(:first-child), #sib_embed_signup .input-group .custom-select:not(:first-child) {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
@media (max-width: 768px) {
  #sib_embed_signup .input-group.full-width-mobile .form-control, #sib_embed_signup .input-group.full-width-mobile button {
    width: 100%;
    margin-top: 5px;
  }
  #sib_embed_signup .input-group .form-control:not(:last-child), #sib_embed_signup .input-group .custom-select:not(:last-child) {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
  }
}
@media (min-width: 769px) {
  #sib_embed_signup .input-group button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
#sib_embed_signup .input-group input.form-control {
  padding: 0.625rem 1.2rem;
}
#sib_embed_signup .input-group.full-width-mobile label {
  margin: 0.25rem 0;
}
#sib_embed_signup .input-group.full-width-mobile .btn {
  min-width: 180px;
}
#sib_embed_signup .message_area {
  max-width: 1000px;
  margin: 20px auto;
  padding: 8px;
  border-radius: 5px;
}

.imagetextblock .image-text-block-button .partnerjoinblock {
  padding: 0;
}

.modal.partner-join-modal {
  color: #242829;
}
.modal.partner-join-modal .modal-content {
  border-radius: 4px;
  border: 1px solid #D9D8D6;
}
.modal.partner-join-modal .modal-body {
  padding: 24px 24px 40px 24px;
}
.modal.partner-join-modal .modal-body label {
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  margin-bottom: 32px;
}
.modal.partner-join-modal .modal-body select {
  margin-bottom: 32px;
  padding: 14px 24px;
  height: auto;
  color: #242829;
}
.modal.partner-join-modal .modal-body .btn-primary {
  width: 100%;
}

@media (max-width: 575px) {
  .open-partner-join-button {
    width: 100%;
  }
  .modal.partner-join-modal {
    z-index: 10001;
  }
  .modal.partner-join-modal .modal-content {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  .modal.partner-join-modal .modal-dialog {
    position: fixed;
    top: auto;
    right: auto;
    left: auto;
    bottom: 0;
    width: 100%;
    margin: 0;
  }
  .animate-from-bottom {
    position: relative;
    animation: animateFromBottom 0.4s;
  }
}
@keyframes animateFromBottom {
  from {
    bottom: -200px;
    opacity: 0;
  }
  to {
    bottom: 0;
    opacity: 1;
  }
}
.responsive-iframe-video {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
}

.responsive-iframe-video iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}

.short-info-item-image img {
  max-width: 100%;
}

.staff-card.card {
  border: none;
}
.staff-card.card .card-header {
  background-color: transparent;
  border: none;
  padding-bottom: 0;
}
.staff-card.card .card-header span {
  color: #0C6175;
}
.staff-card.card .card-body {
  padding-top: 10px;
}
.staff-card.card .card-body img {
  max-width: 100%;
  border-radius: 4px;
  margin-bottom: 10px;
}

.supportcontactblock .modal {
  opacity: 0.95;
  position: fixed;
  padding-right: 0 !important;
  text-align: left;
}
.supportcontactblock .modal .modal-dialog {
  max-width: 100vw;
  margin: 0;
}
.supportcontactblock .modal .modal-dialog .modal-content {
  min-height: 100vh;
  border-radius: 0;
}
@media (max-width: 575px) {
  .supportcontactblock .modal .modal-dialog .modal-content .modal-header {
    position: fixed;
    top: 0;
    left: 0;
    padding: 7px;
    z-index: 1025;
  }
}
.supportcontactblock .modal .modal-dialog .modal-content .btn-close::after {
  content: "\\f0156";
  font-family: "Material Design Icons";
  font-size: 35px;
  color: #440099;
  cursor: pointer;
  line-height: 1;
}
.supportcontactblock .modal .modal-header {
  border-bottom: none;
  justify-content: end;
}
.supportcontactblock .modal .modal-body {
  padding: 45px;
}
.supportcontactblock .modal .modal-body #contact-grid {
  display: grid;
  gap: 20px;
  grid-auto-columns: 100%;
}
@media (min-width: 576px) {
  .supportcontactblock .modal .modal-dialog {
    max-width: calc(650px + 40px);
    margin: 10vh auto 0;
  }
  .supportcontactblock .modal .modal-dialog .modal-content {
    min-height: calc(300px + 40px);
    border-radius: 10px;
  }
  .supportcontactblock .modal .modal-body {
    padding: 0px 60px 60px;
  }
  .supportcontactblock .modal .modal-body #contact-grid {
    grid-template-areas: "a a";
    grid-auto-columns: calc(50% - 10px);
  }
}

.testimonialslistblock .testimonial-arrows {
  position: relative;
}
.testimonialslistblock .show-neighbors {
  overflow: hidden;
}
.testimonialslistblock .show-neighbors .item__third:first-child,
.testimonialslistblock .show-neighbors .item__third:last-child {
  display: none;
}
.testimonialslistblock .show-neighbors .item__third {
  display: block !important;
  float: left;
  position: relative; /* captions can now be added */
  width: 33.33333333%;
}
.testimonialslistblock .show-neighbors .carousel-control-prev:hover, .testimonialslistblock .show-neighbors .carousel-control-prev:focus, .testimonialslistblock .show-neighbors .carousel-control-next:hover, .testimonialslistblock .show-neighbors .carousel-control-next:focus {
  opacity: 1;
  background: none;
}
.testimonialslistblock .show-neighbors .carousel-control-prev,
.testimonialslistblock .show-neighbors .carousel-control-next {
  opacity: 0.7;
  background: rgba(255, 255, 255, 0);
}
.testimonialslistblock .show-neighbors .carousel-control-prev div.carousel-prev-arrow::before, .testimonialslistblock .show-neighbors .carousel-control-next div.carousel-next-arrow::before {
  border-color: #440099;
  border-style: solid;
  content: "";
  display: inline-block;
  position: relative;
  vertical-align: top;
}
.testimonialslistblock .show-neighbors .carousel-control-prev div.carousel-prev-arrow {
  background-color: #fff;
  position: absolute;
}
.testimonialslistblock .show-neighbors .carousel-control-prev div.carousel-prev-arrow:before {
  transform: rotate(-135deg);
}
.testimonialslistblock .show-neighbors .carousel-control-next div.carousel-next-arrow {
  background-color: #fff;
  position: absolute;
}
.testimonialslistblock .show-neighbors .carousel-control-next div.carousel-next-arrow:before {
  transform: rotate(45deg);
}
.testimonialslistblock .show-neighbors .carousel-item .carousel-item-image-area .container, .testimonialslistblock .show-neighbors .carousel-item .carousel-item-image-area .row, .testimonialslistblock .show-neighbors .carousel-item .hero-settings .container, .testimonialslistblock .show-neighbors .carousel-item .hero-settings .row {
  height: 100%;
}
.testimonialslistblock .show-neighbors .carousel-item .carousel-item-image-area, .testimonialslistblock .show-neighbors .carousel-item .hero-settings {
  height: 65vw;
  max-height: 450px;
}
.testimonialslistblock .show-neighbors .carousel-control-prev,
.testimonialslistblock .show-neighbors .carousel-control-next {
  height: 58px;
  max-height: 450px;
  width: 58px;
}
.testimonialslistblock .show-neighbors .carousel-control-prev div.carousel-prev-arrow::before, .testimonialslistblock .show-neighbors .carousel-control-next div.carousel-next-arrow::before {
  border-width: 2px 2px 0 0;
  height: 12px;
  width: 12px;
  top: 23px;
}
.testimonialslistblock .show-neighbors .carousel-control-prev {
  border-right: none;
  left: 3rem;
  top: -100px;
}
.testimonialslistblock .show-neighbors .carousel-control-prev div.carousel-prev-arrow {
  width: 58px;
  height: 58px;
  border-radius: 50%;
  right: 0;
}
.testimonialslistblock .show-neighbors .carousel-control-prev div.carousel-prev-arrow:before {
  left: 3px;
}
.testimonialslistblock .show-neighbors .carousel-control-next {
  border-left: none;
  left: calc(3rem + 120px);
  top: -100px;
}
.testimonialslistblock .show-neighbors .carousel-control-next div.carousel-next-arrow {
  width: 58px;
  height: 58px;
  border-radius: 50%;
  left: 0;
}
.testimonialslistblock .show-neighbors .carousel-control-next div.carousel-next-arrow:before {
  left: -3px;
}
.testimonialslistblock .show-neighbors .item__third .testimonial-row {
  height: 600px;
}
.testimonialslistblock .show-neighbors .item__third .testimonial-row .testimonial-image {
  height: 100%;
}
.testimonialslistblock .show-neighbors .item__third .testimonial-row .testimonial-image .testimonial-image-round {
  position: absolute;
  width: 170px;
  height: 170px;
  border-radius: 50%;
  right: 0;
  top: 60px;
}
.testimonialslistblock .show-neighbors .item__third .testimonial-row .testimonial-text-wrap {
  max-height: 480px;
}
.testimonialslistblock .show-neighbors .item__third .testimonial-row .testimonial-text-wrap.testimonial-round-image-padding .testimonial-text {
  padding-top: 60px;
}
.testimonialslistblock .show-neighbors .item__third .testimonial-row .testimonial-text-wrap .testimonial-text {
  max-width: 550px;
}
.testimonialslistblock .show-neighbors .carousel-inner {
  width: 310%;
  left: -103%;
}
.testimonialslistblock .show-neighbors .testimonial-arrows {
  width: 103%;
  left: 15px;
}
@media (min-width: 1200px) {
  .testimonialslistblock .show-neighbors .carousel-item .carousel-item-image-area, .testimonialslistblock .show-neighbors .carousel-item .hero-settings {
    height: 33vw;
    max-height: 620px;
  }
  .testimonialslistblock .show-neighbors .carousel-control-prev,
  .testimonialslistblock .show-neighbors .carousel-control-next {
    height: 58px;
    max-height: 620px;
    width: 58px;
  }
  .testimonialslistblock .show-neighbors .carousel-control-prev div.carousel-prev-arrow::before, .testimonialslistblock .show-neighbors .carousel-control-next div.carousel-next-arrow::before {
    border-width: 2px 2px 0 0;
    height: 12px;
    width: 12px;
    top: 23px;
  }
  .testimonialslistblock .show-neighbors .carousel-control-prev {
    border-right: none;
    left: 3rem;
    top: -100px;
  }
  .testimonialslistblock .show-neighbors .carousel-control-prev div.carousel-prev-arrow {
    width: 58px;
    height: 58px;
    border-radius: 50%;
    right: 0;
  }
  .testimonialslistblock .show-neighbors .carousel-control-prev div.carousel-prev-arrow:before {
    left: 3px;
  }
  .testimonialslistblock .show-neighbors .carousel-control-next {
    border-left: none;
    left: calc(3rem + 120px);
    top: -100px;
  }
  .testimonialslistblock .show-neighbors .carousel-control-next div.carousel-next-arrow {
    width: 58px;
    height: 58px;
    border-radius: 50%;
    left: 0;
  }
  .testimonialslistblock .show-neighbors .carousel-control-next div.carousel-next-arrow:before {
    left: -3px;
  }
  .testimonialslistblock .show-neighbors .carousel-inner {
    width: 270%;
    left: -90%;
  }
  .testimonialslistblock .show-neighbors .carousel-inner.testimonial-round-images {
    width: 300%;
    left: -100%;
  }
  .testimonialslistblock .show-neighbors .testimonial-arrows {
    width: 90%;
    left: 15px;
  }
  .testimonialslistblock .show-neighbors .testimonial-arrows.testimonial-arrows-round-images {
    width: 100%;
    left: 15px;
  }
  .testimonialslistblock .show-neighbors .item__third .testimonial-row {
    height: 600px;
  }
  .testimonialslistblock .show-neighbors .item__third .testimonial-row .testimonial-image {
    height: 100%;
  }
  .testimonialslistblock .show-neighbors .item__third .testimonial-row .testimonial-text-wrap {
    max-height: 480px;
  }
  .testimonialslistblock .show-neighbors .item__third .testimonial-row .testimonial-text-wrap .testimonial-text {
    max-width: 600px;
  }
}
@media (max-width: 991.98px) {
  .testimonialslistblock .show-neighbors .carousel-item .carousel-item-image-area, .testimonialslistblock .show-neighbors .carousel-item .hero-settings {
    height: 65vw;
    max-height: 450px;
  }
  .testimonialslistblock .show-neighbors .carousel-control-prev,
  .testimonialslistblock .show-neighbors .carousel-control-next {
    height: 58px;
    width: 58px;
  }
  .testimonialslistblock .show-neighbors .carousel-control-prev div.carousel-prev-arrow::before, .testimonialslistblock .show-neighbors .carousel-control-next div.carousel-next-arrow::before {
    border-width: 2px 2px 0 0;
    height: 14px;
    width: 14px;
    top: 22px;
  }
  .testimonialslistblock .show-neighbors .carousel-control-prev {
    border-right: none;
    left: 87px;
    top: -100px;
  }
  .testimonialslistblock .show-neighbors .carousel-control-prev div.carousel-prev-arrow {
    width: 58px;
    height: 58px;
    border-radius: 50%;
    right: -23px;
  }
  .testimonialslistblock .show-neighbors .carousel-control-prev div.carousel-prev-arrow:before {
    left: 1px;
  }
  .testimonialslistblock .show-neighbors .carousel-control-next {
    border-left: none;
    left: 237px;
    top: -100px;
  }
  .testimonialslistblock .show-neighbors .carousel-control-next div.carousel-next-arrow {
    width: 58px;
    height: 58px;
    border-radius: 50%;
    left: -23px;
  }
  .testimonialslistblock .show-neighbors .carousel-control-next div.carousel-next-arrow:before {
    left: -1px;
  }
  .testimonialslistblock .show-neighbors .item__third .testimonial-row {
    height: auto;
    padding-bottom: 130px;
  }
  .testimonialslistblock .show-neighbors .item__third .testimonial-row .testimonial-image {
    height: 52vw;
  }
  .testimonialslistblock .show-neighbors .item__third .testimonial-row .testimonial-image.testimonial-image-empty {
    height: 0;
  }
  .testimonialslistblock .show-neighbors .item__third .testimonial-row .testimonial-text-wrap {
    max-height: unset;
    padding-top: 45px;
    padding-left: 0 !important;
    max-width: calc(100vw - 184px);
    margin: 0 auto;
  }
  .testimonialslistblock .show-neighbors .item__third .testimonial-row .testimonial-text-wrap .testimonial-text {
    max-width: unset;
  }
  .testimonialslistblock .show-neighbors .carousel-inner {
    width: 310%;
    left: -103%;
  }
  .testimonialslistblock .show-neighbors .carousel-inner.testimonial-round-images .testimonial-image {
    height: 170px;
  }
  .testimonialslistblock .show-neighbors .carousel-inner.testimonial-round-images .testimonial-image .testimonial-image-round {
    right: unset;
    left: 114px;
  }
  .testimonialslistblock .show-neighbors .carousel-inner.testimonial-round-images .testimonial-image.testimonial-image-empty {
    height: 0;
  }
  .testimonialslistblock .show-neighbors .testimonial-arrows {
    width: 103%;
    left: 0;
  }
}
@media (max-width: 767.98px) {
  .testimonialslistblock .show-neighbors .carousel-control-prev {
    left: 41px;
    top: -100px;
  }
  .testimonialslistblock .show-neighbors .carousel-control-next {
    left: 191px;
    top: -100px;
  }
  .testimonialslistblock .show-neighbors .item__third .testimonial-row {
    height: auto;
  }
  .testimonialslistblock .show-neighbors .item__third .testimonial-row .testimonial-image {
    height: 68vw;
  }
  .testimonialslistblock .show-neighbors .item__third .testimonial-row .testimonial-text-wrap {
    max-height: unset;
    padding-top: 45px;
    padding-left: 0 !important;
    max-width: calc(100vw - 100px);
    margin: 0 auto;
  }
  .testimonialslistblock .show-neighbors .item__third .testimonial-row .testimonial-text-wrap .testimonial-text {
    max-width: unset;
  }
  .testimonialslistblock .show-neighbors .carousel-inner.testimonial-round-images .testimonial-image {
    height: 160px;
  }
  .testimonialslistblock .show-neighbors .carousel-inner.testimonial-round-images .testimonial-image .testimonial-image-round {
    right: unset;
    left: 68px;
  }
  .testimonialslistblock .show-neighbors .carousel-inner.testimonial-round-images .testimonial-image.testimonial-image-empty {
    height: 0;
  }
}
.testimonialslistblock .show-neighbors .carousel-item-next:not(.carousel-item-left),
.testimonialslistblock .show-neighbors .carousel-item-right.active {
  -webkit-transform: translate3d(33%, 0, 0);
  transform: translate3d(33%, 0, 0);
}
.testimonialslistblock .show-neighbors .carousel-item-prev:not(.carousel-item-right),
.testimonialslistblock .show-neighbors .carousel-item-left.active {
  -webkit-transform: translate3d(-33%, 0, 0);
  transform: translate3d(-33%, 0, 0);
}

.testimonial-results {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  border-top: 1px solid #000;
  padding-top: 12px;
  margin-top: 10px;
  height: 90px;
  width: fit-content;
}
.testimonial-results .testimonial-results-content {
  width: fit-content;
  padding-right: 10px;
  line-height: 30px;
}
.testimonial-results .testimonial-results-content span {
  line-height: 30px;
}

.flex-break {
  flex-basis: 100%;
  width: 0;
}

.textblock p {
  margin-top: 1em;
  margin-bottom: 1em;
  font-size: 1rem;
}

.textblock-readmore {
  position: relative;
  overflow: hidden;
}

.textblock-readmore .textblock-readmore-fade {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 60px 0 13px;
  /* "transparent" only works here because == rgba(0,0,0,0) */
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgb(0, 0, 0));
}

.textblock-readmore-button {
  margin: 0;
  text-transform: uppercase;
}

.textblock-readmore-button-white a.animated-link {
  color: #fff;
}
.textblock-readmore-button-white a.animated-link:before {
  background: #fff;
}
.textblock-readmore-button-white a.animated-link:after {
  background: #caaeff;
}

.fixed-background-card-properties, .fixed-background-container .fixed-background-card {
  max-width: 650px;
  min-height: 710px;
  border-radius: 10px;
  padding: 1.5rem 1.5rem;
}
@media (min-width: 768px) {
  .fixed-background-card-properties, .fixed-background-container .fixed-background-card {
    padding: 2rem 3rem;
  }
}
@media (min-width: 992px) {
  .fixed-background-card-properties, .fixed-background-container .fixed-background-card {
    padding: 3rem 3rem;
  }
}
@media (max-width: 575px) {
  .fixed-background-card-properties, .fixed-background-container .fixed-background-card {
    max-width: calc(100vw - 20px);
    min-height: calc(100vh - 110px);
  }
}

.fixed-background-card .modal {
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
  overflow: -moz-scrollbars-none;
}

.fixed-background-card .modal::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}

.e-with-fixed-bg {
  width: 100%;
  min-height: calc(100vh - 100px);
  /* Important */
  position: relative;
}

.bg-wrap {
  clip: rect(0, auto, auto, 0);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.bgb {
  position: fixed;
  display: block;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-size: cover;
  background-position: center center;
  transform: translateZ(0);
  will-change: transform;
}

.e-container {
  z-index: 1;
}

.fixed-background-container {
  min-height: calc(100vh - 100px);
  text-align: center;
}
.fixed-background-container h2 {
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
}
@media (min-width: 768px) {
  .fixed-background-container h2 {
    font-size: 28px;
    line-height: 42px;
  }
}
@media (min-width: 992px) {
  .fixed-background-container h2 {
    font-size: 32px;
    line-height: 48px;
  }
}
.fixed-background-container .fixed-background-card {
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  background-color: #fff;
  margin: 50px auto;
  position: relative;
}
.fixed-background-container .fixed-background-card-no-bg-image {
  padding: 0;
  min-height: initial;
}
.fixed-background-container .fixed-background-card-no-bg-image .order-1 {
  padding-top: 1.5rem;
}
.fixed-background-container .fixed-background-card-no-bg-image .order-2 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}
.fixed-background-container .fixed-background-card-no-bg-image .order-3 {
  padding-bottom: 1.5rem;
}
@media (min-width: 768px) {
  .fixed-background-container .fixed-background-card-no-bg-image .order-1 {
    padding-top: 2rem;
  }
  .fixed-background-container .fixed-background-card-no-bg-image .order-2 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .fixed-background-container .fixed-background-card-no-bg-image .order-3 {
    padding-bottom: 2rem;
  }
}
@media (min-width: 992px) {
  .fixed-background-container .fixed-background-card-no-bg-image .order-1 {
    padding-top: 3rem;
  }
  .fixed-background-container .fixed-background-card-no-bg-image .order-2 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }
  .fixed-background-container .fixed-background-card-no-bg-image .order-3 {
    padding-bottom: 3rem;
  }
}
.fixed-background-container .fixed-background-card-no-bg-image .fixed-background-card-image.order-1.p-0 img {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.fixed-background-container .fixed-background-card-no-bg-image .fixed-background-card-image.order-3.p-0 img {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.fixed-background-container .fixed-background-card button::before {
  content: "\\f0415";
  font-family: "Material Design Icons";
  margin-right: 0.5rem;
  font-size: 1.5rem;
  line-height: 0.1;
  position: relative;
  top: 4px;
  font-weight: 400;
}
.fixed-background-container .fixed-background-card .modal {
  opacity: 0.95;
  position: fixed;
  padding-right: 0 !important;
  text-align: left;
}
.fixed-background-container .fixed-background-card .modal .modal-dialog {
  max-width: 100vw;
  margin: 0;
}
.fixed-background-container .fixed-background-card .modal .modal-dialog .modal-content {
  min-height: 100vh;
  border-radius: 0;
}
@media (max-width: 575px) {
  .fixed-background-container .fixed-background-card .modal .modal-dialog .modal-content .modal-header {
    position: fixed;
    top: 0;
    left: 0;
    padding: 7px;
    z-index: 1025;
  }
}
.fixed-background-container .fixed-background-card .modal .modal-dialog .modal-content .btn-close::after {
  content: "\\f0156";
  font-family: "Material Design Icons";
  font-size: 35px;
  color: #440099;
  cursor: pointer;
  line-height: 1;
}
.fixed-background-container .fixed-background-card .modal .modal-header {
  border-bottom: none;
  justify-content: end;
}
.fixed-background-container .fixed-background-card .modal .modal-body {
  padding: 45px;
}
@media (min-width: 576px) {
  .fixed-background-container .fixed-background-card .modal .modal-dialog {
    max-width: calc(650px + 40px);
    margin: calc(50vh - calc(710px + 40px) / 2) auto;
  }
  .fixed-background-container .fixed-background-card .modal .modal-dialog .modal-content {
    min-height: calc(710px + 40px);
    border-radius: 10px;
  }
  .fixed-background-container .fixed-background-card .modal .modal-body {
    padding: 0px 60px 60px;
  }
}

.category__figure {
  flex: 0 0 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.category__img {
  max-height: 180px;
  width: auto;
}

.category {
  display: flex;
  flex-direction: column;
  margin-right: 50px;
}

.category-heading {
  font-size: 18px;
}

.category__children {
  flex: 1;
  list-style: none;
  padding: 0;
  line-height: 1.7;
}

.category__name {
  font-weight: 500;
}

h1.errorpage {
  margin: 100px auto 0 auto;
  color: var(--stroke-color);
  font-family: "Encode Sans Semi Condensed", Verdana, sans-serif;
  font-size: 10rem;
  line-height: 10rem;
  font-weight: 200;
  text-align: center;
}

h2.errorpage {
  margin: 20px auto 30px auto;
  font-family: "Encode Sans Semi Condensed", Verdana, sans-serif;
  font-size: 1.5rem;
  font-weight: 200;
  text-align: center;
}

h1.errorpage, h2.errorpage {
  -webkit-transition: opacity 0.5s linear, margin-top 0.5s linear; /* Safari */
  transition: opacity 0.5s linear, margin-top 0.5s linear;
}

.error-header {
  background-color: rgb(236, 233, 242);
}
.error-header .container {
  padding: 32px 0;
}
.error-header .container .error-header-logo {
  margin: 0 auto;
  display: block;
}

.cd-main-content:has(.error-header) {
  padding-top: 0;
}

.video-file {
  width: 100%;
  height: 100%;
  position: relative;
}
.video-file__frame {
  width: 100%;
  height: auto;
  object-fit: cover;
}
.video-file__copyright {
  position: absolute;
  z-index: 10;
  right: 1%;
  top: 1%;
  color: white;
  font-style: italic;
  font-size: 1.5vw;
  user-select: none;
  margin: 0;
}

.person-filter-block {
  margin: 40px 0px 100px 0px;
}
.person-filter-block .button-transparent-black, .person-filter-block .button-transparent-black--icon {
  padding: 8px 30px;
  width: 100%;
}
.person-filter-block div {
  padding-left: 0px;
}
.person-filter-block button-transparent-black {
  padding: 8px 10px;
}
.person-filter-block .easy-autocomplete-container ul {
  display: none;
}

.person_image {
  max-height: 200px;
}

.person_heading {
  margin-top: 2rem;
  text-align: center;
  font-size: 3.85714rem;
  margin: 28px 0 14px 0;
  text-align: left;
}

.person-list-block {
  margin-bottom: 40px;
}
.person-list-block .category-page__facets {
  margin-top: 60px;
}
.person-list-block .product-tile-grid {
  padding-bottom: 0px;
  height: 50%;
}
.person-list-block .detail-info {
  padding: 20px 0px 0px 10px;
}
.person-list-block .detail-info a {
  overflow-wrap: break-word;
  color: black;
}
.person-list-block .h-50 {
  margin-bottom: 40px;
}

.contact {
  margin-top: 40px;
}
.contact .detail-contact {
  padding: 25px;
}
.contact .detail-contact h2, .contact .detail-contact p {
  margin-bottom: 25px;
}
.contact .detail-contact a {
  color: black;
}
.contact .product-tile-grid {
  margin-bottom: 0px;
}
.contact .product-tile-grid img {
  height: auto;
  width: 100%;
}

.staff-block {
  line-height: 22px;
}
.staff-block h4 {
  font-weight: normal;
  font-size: 24px;
  line-height: 36px;
  margin-bottom: 0;
}
.staff-block .staff-title {
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 35px;
}

.sticky-nav-tabs {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  padding: 0 2em;
}
.sticky-nav-tabs .screen-width-block {
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
}
@media (max-width: 767.98px) {
  .sticky-nav-tabs .screen-width-block {
    width: 100vw;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
  }
}

.sticky-nav-mobile-header {
  height: 54px;
  background-color: #8859C5;
  color: #fff;
  font-size: 20px;
  line-height: 32px;
  display: block;
  padding: 11px 0;
  cursor: pointer;
}

.sticky-nav-mobile-header:hover {
  color: #fff;
}

.investors-arrowLinkWrapper {
  width: 22px;
  height: 22px;
  position: absolute;
  right: 12px;
  top: 5px;
}

.investors-link-showHide {
  border: solid #fff;
  border-width: 0 2px 2px 0;
  display: inline-block;
  position: absolute;
  padding: 4px;
  top: 10px;
  left: 5px;
  line-height: 17px;
  -webkit-transition: -webkit-transform linear 0.7s;
  -moz-transition: -moz-transform 0.7s;
  transition: transform 0.7s;
  transform: rotate(-135deg);
  -moz-transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
  top: 14px;
}

.investors-link-down {
  transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}

.sticky-nav-tabs h1, .investors-slide h1 {
  font-size: 48px;
  margin: 0;
  letter-spacing: 0.02em;
}

.sticky-nav-tabs h3, .investors-slide h3 {
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  letter-spacing: 0.02em;
  color: #242829;
}
.sticky-nav-tabs h3.color-light, .investors-slide h3.color-light {
  color: #fff;
}

.sticky-nav-tabs-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 54px;
  background: #ECE9F2;
  z-index: 2;
  -webkit-transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);
  transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);
  padding: 0;
}

.inside-sticky {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  height: 54px;
}

.sticky-nav-tabs-container--top-first {
  position: fixed;
  top: 100px;
  left: 0;
  -webkit-transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);
  transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);
}

.sticky-nav-tabs-container--top-second {
  position: fixed;
  top: 100px;
  left: 0;
}

.sticky-nav-tabs-container-wrap {
  height: 54px;
}

@media (max-width: 991.98px) {
  .sticky-nav-tabs-container-wrap {
    height: auto;
  }
  .sticky-nav-tabs-container, .sticky-nav-tabs-container-wrap {
    background-color: #8859C5;
  }
  .inside-sticky {
    display: block;
    height: auto;
    background-color: #ECE9F2;
    padding: 0;
  }
  .inside-sticky .sticky-nav-tab, .inside-sticky .sticky-nav-link, .inside-sticky .sticky-nav-external-quick-link {
    height: 63px;
    justify-content: left;
    padding: 0 15px;
  }
}
@media (max-width: 1169px) {
  .sticky-nav-tabs-container--top-first {
    top: 90px;
  }
  .sticky-nav-tabs-container--top-second {
    top: 90px;
  }
}
.sticky-nav-tab, .sticky-nav-link, .sticky-nav-external-quick-link {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-flex: 1;
  -ms-flex: auto;
  flex: auto;
  color: #242829;
  -webkit-transition: all 0.5s ease;
  transition: all 0.5s ease;
  font-size: 16px;
}
@media (max-width: 1199.98px) {
  .sticky-nav-tab, .sticky-nav-link, .sticky-nav-external-quick-link {
    font-size: 14px;
  }
}

.sticky-nav-tab:hover, .sticky-nav-tab.active, .sticky-nav-external-quick-link:hover, .sticky-nav-external-quick-link.active, .sticky-nav-link.active, .sticky-nav-link:hover {
  color: white;
  background-color: #8859C5;
  -webkit-transition: all 0.5s ease;
  transition: all 0.5s ease;
  text-decoration: none;
}

.sticky-nav-link {
  background-color: #C4B1CF;
}
.sticky-nav-link:after {
  content: "\\f0142";
  font-family: "Material Design Icons";
  margin-left: 0.5rem;
  font-size: 20px;
  margin-top: 3px;
}

.person-filter-block {
  margin: 40px 0px 100px 0px;
}
.person-filter-block .button-transparent-black, .person-filter-block .button-transparent-black--icon {
  padding: 8px 30px;
  width: 100%;
}
.person-filter-block div {
  padding-left: 0px;
}
.person-filter-block button-transparent-black {
  padding: 8px 10px;
}
.person-filter-block .easy-autocomplete-container ul {
  display: none;
}

.person_image {
  max-height: 200px;
}

.person_heading {
  margin-top: 2rem;
  text-align: center;
  font-size: 3.85714rem;
  margin: 28px 0 14px 0;
  text-align: left;
}

.person-list-block {
  margin-bottom: 40px;
}
.person-list-block .category-page__facets {
  margin-top: 60px;
}
.person-list-block .product-tile-grid {
  padding-bottom: 0px;
  height: 50%;
}
.person-list-block .detail-info {
  padding: 20px 0px 0px 10px;
}
.person-list-block .detail-info a {
  overflow-wrap: break-word;
  color: black;
}
.person-list-block .h-50 {
  margin-bottom: 40px;
}

.contact {
  margin-top: 40px;
}
.contact .detail-contact {
  padding: 25px;
}
.contact .detail-contact h2, .contact .detail-contact p {
  margin-bottom: 25px;
}
.contact .detail-contact a {
  color: black;
}
.contact .product-tile-grid {
  margin-bottom: 0px;
}
.contact .product-tile-grid img {
  height: auto;
  width: 100%;
}

.reports-row .collapse {
  -webkit-transition: all 0.5s ease;
  transition: all 0.5s ease;
  opacity: 0;
}

.reports-row .collapsing.show, .reports-row .collapse.show {
  opacity: 1;
}

@media (min-width: 768px) {
  .reports-row .col-md-6:nth-child(odd) {
    border-right: 1px solid #9EA699;
    padding-right: 115px;
  }
  .reports-row .col-md-6:nth-child(even) {
    padding-left: 115px;
  }
}
@media (max-width: 767.98px) {
  .reports-row {
    max-width: 310px;
    margin: 0 auto;
  }
}
.financial-calendar {
  background-color: #0C6175;
  color: #fff;
}
.financial-calendar .detail-info {
  border-bottom: 1px solid #09AFAB;
  padding-top: 30px;
}
.financial-calendar .detail-info p {
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
}
.financial-calendar h3 {
  color: #fff;
}

.financial-reports {
  background-color: #EEEFEE;
}
.financial-reports .detail-info h4 {
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
}
.financial-reports .detail-info a {
  color: #242829;
  font-weight: 600;
  font-size: 16px;
}
.financial-reports .detail-info a:hover::after, .financial-reports .detail-info a:hover::before {
  color: #8859C5;
}

.press-releases {
  background-color: #E5E5E5;
}
.press-releases .detail-info h4 {
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
}
.press-releases .detail-info a {
  color: #242829;
  font-weight: 600;
  font-size: 16px;
}
.press-releases .detail-info a:hover::after, .press-releases .detail-info a:hover::before {
  color: #8859C5;
}

.staff-round-image {
  background-size: cover;
  width: 180px;
  height: 180px;
  border-radius: 50%;
}

.graph-ticker {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 550px;
}

.share-info-toggle {
  font-weight: 600;
  text-decoration: underline;
}

@media (min-width: 992px) {
  .graph-ticker {
    padding-bottom: 270px;
  }
}
.press-release-keyword {
  display: inline-block;
  padding: 7px 15px;
  border-radius: 18px;
  background-color: #f0f3f5;
  white-space: nowrap;
  margin-bottom: 5px;
}

.breadcrumbs {
  color: #242829;
  font-size: 12px;
  line-height: 25px;
  display: flex;
  padding: 10px 0;
  position: fixed;
  z-index: 2;
  background-color: #fff;
}
.breadcrumbs a {
  padding: 0 4px;
  line-height: 25px;
  font-weight: 600;
  letter-spacing: 0.2px;
  text-decoration-line: underline;
  color: #242829;
}
.breadcrumbs a:hover {
  color: #000;
}
.breadcrumbs div.breadcrubms-current-page {
  padding: 0 4px;
  display: inline-block;
  max-width: 100px;
  font-style: italic;
  white-space: nowrap;
}

.news-sticky-nav-tabs {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  padding: 0 2em;
}
.news-sticky-nav-tabs .screen-width-block {
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
}
@media (max-width: 767.98px) {
  .news-sticky-nav-tabs .screen-width-block {
    width: 100vw;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
  }
}
.news-sticky-nav-tabs .news-sticky-nav-mobile-header {
  height: 54px;
  background-color: #8859C5;
  color: #fff;
  font-size: 20px;
  line-height: 32px;
  display: block;
  padding: 11px 0;
  cursor: pointer;
}
.news-sticky-nav-tabs .news-sticky-nav-mobile-header:hover {
  color: #fff;
}
.news-sticky-nav-tabs .news-room-arrowLinkWrapper {
  width: 22px;
  height: 22px;
  position: absolute;
  right: 12px;
  top: 5px;
}
.news-sticky-nav-tabs .news-room-link-showHide {
  border: solid #fff;
  border-width: 0 2px 2px 0;
  display: inline-block;
  position: absolute;
  padding: 4px;
  top: 10px;
  left: 5px;
  line-height: 17px;
  -webkit-transition: -webkit-transform linear 0.7s;
  -moz-transition: -moz-transform 0.7s;
  transition: transform 0.7s;
  transform: rotate(-135deg);
  -moz-transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
  top: 14px;
}
.news-sticky-nav-tabs .news-room-link-down {
  transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}
.news-sticky-nav-tabs h1 {
  font-size: 48px;
  margin: 0;
  letter-spacing: 0.02em;
}
.news-sticky-nav-tabs h3 {
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  letter-spacing: 0.02em;
  color: #242829;
}
.news-sticky-nav-tabs h3.color-light {
  color: #fff;
}
.news-sticky-nav-tabs .news-sticky-nav-tabs-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 54px;
  background: #ECE9F2;
  z-index: 2;
  -webkit-transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);
  transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);
  padding: 0;
}
.news-sticky-nav-tabs .news-inside-sticky {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  height: 54px;
}
.news-sticky-nav-tabs .news-sticky-nav-tabs-container--top-first {
  position: fixed;
  top: 100px;
  left: 0;
  -webkit-transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);
  transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);
}
.news-sticky-nav-tabs .news-sticky-nav-tabs-container--top-second {
  position: fixed;
  top: 100px;
  left: 0;
}
.news-sticky-nav-tabs .news-sticky-nav-tabs-container-wrap {
  height: 54px;
}
@media (max-width: 991.98px) {
  .news-sticky-nav-tabs .news-sticky-nav-tabs-container-wrap {
    height: auto;
  }
  .news-sticky-nav-tabs .news-sticky-nav-tabs-container, .news-sticky-nav-tabs .news-sticky-nav-tabs-container-wrap {
    background-color: #8859C5;
  }
  .news-sticky-nav-tabs .news-inside-sticky {
    display: block;
    height: auto;
    background-color: #ECE9F2;
    padding: 0;
  }
  .news-sticky-nav-tabs .news-inside-sticky .news-sticky-nav-tab, .news-sticky-nav-tabs .news-inside-sticky .news-sticky-nav-link, .news-sticky-nav-tabs .news-inside-sticky .news-sticky-nav-external-quick-link {
    height: 63px;
    justify-content: left;
    padding: 0 15px;
  }
}
@media (max-width: 1169px) {
  .news-sticky-nav-tabs .news-sticky-nav-tabs-container--top-first {
    top: 90px;
  }
  .news-sticky-nav-tabs .news-sticky-nav-tabs-container--top-second {
    top: 90px;
  }
}
.news-sticky-nav-tabs .news-sticky-nav-tab, .news-sticky-nav-tabs .news-sticky-nav-link, .news-sticky-nav-tabs .news-sticky-nav-external-quick-link {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-flex: 1;
  -ms-flex: auto;
  flex: auto;
  color: #242829;
  -webkit-transition: all 0.5s ease;
  transition: all 0.5s ease;
  font-size: 16px;
}
@media (max-width: 1199.98px) {
  .news-sticky-nav-tabs .news-sticky-nav-tab, .news-sticky-nav-tabs .news-sticky-nav-link, .news-sticky-nav-tabs .news-sticky-nav-external-quick-link {
    font-size: 14px;
  }
}
.news-sticky-nav-tabs .news-sticky-nav-tab:hover, .news-sticky-nav-tabs .news-sticky-nav-tab.active, .news-sticky-nav-tabs .news-sticky-nav-external-quick-link:hover, .news-sticky-nav-tabs .news-sticky-nav-external-quick-link.active, .news-sticky-nav-tabs .news-sticky-nav-link.active, .news-sticky-nav-tabs .news-sticky-nav-link:hover {
  color: white;
  background-color: #8859C5;
  -webkit-transition: all 0.5s ease;
  transition: all 0.5s ease;
  text-decoration: none;
}
.news-sticky-nav-tabs .news-sticky-nav-link {
  background-color: #C4B1CF;
}
.news-sticky-nav-tabs .news-sticky-nav-link:after {
  content: "\\f0142";
  font-family: "Material Design Icons";
  margin-left: 0.5rem;
  font-size: 20px;
  margin-top: 3px;
}

.news-room-list-wrapper {
  padding-top: 20px;
}

.news-list-wrapper {
  border-radius: 8px;
  height: 100%;
  cursor: pointer;
  background-color: #fff;
  -webkit-transition: all 0.25s ease;
  transition: all 0.25s ease;
}
.news-list-wrapper:hover {
  -webkit-box-shadow: 0px 24px 40px -16px rgba(29, 35, 36, 0.24);
  box-shadow: 0px 24px 40px -16px rgba(29, 35, 36, 0.24);
}

.news-list-item-image {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  height: 300px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
}

.news-list-item {
  padding: 20px 30px 30px;
  transition: all 0.2s;
  height: calc(100% - 300px);
}
.news-list-item .row.align-content-between {
  height: 100%;
}
.news-list-item .news-category-date {
  color: #555;
  font-size: 14px;
}

@media (max-width: 575px) {
  .more-news.row {
    margin-left: -30px;
    margin-right: -30px;
  }
  .more-news.row .news-list-wrapper {
    padding: 15px;
    border-radius: 0;
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
  }
  .more-news.row .news-list-item-image {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    height: 120px;
    border-radius: 8px;
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
    position: relative;
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
  }
  .more-news.row .news-list-item {
    height: 100%;
    transition: all 0.2s;
    flex: 0 0 66.66667%;
    max-width: 66.66667%;
    position: relative;
    width: 100%;
    padding: 0 0 0 15px;
  }
  .more-news.row .news-list-item h6 {
    font-size: 14px;
    line-height: 24px;
    font-weight: 400;
  }
  .more-news.row .news-list-item .row.align-content-between {
    height: calc(100% - 300px);
  }
}
@media (min-width: 576px) {
  .more-news.row {
    font-size: 15px;
    color: #404748;
  }
  .more-news.row .news-list-wrapper h6 {
    font-size: 15px;
    line-height: 1.3rem;
    font-weight: 400;
    letter-spacing: 0.025em;
    color: #000;
  }
}
@media (min-width: 992px) {
  .news-list-main-item {
    background-image: none !important;
    min-height: 500px;
    padding: 25px 40px 25px 60%;
    height: 100%;
  }
  .news-list-main-item .row.align-content-between {
    height: 100%;
  }
  .news-list-main-item .news-list-main-item-image {
    background-size: cover;
    background-position: center center;
    border-bottom-left-radius: 8px;
    border-top-left-radius: 8px;
    width: calc(60% - 55px);
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    margin-left: 15px;
  }
}
.news-category-header {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #595F56;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.news-detail h1 {
  font-weight: 400;
  font-size: 48px;
  line-height: 64px;
  letter-spacing: 0.02em;
  color: #242829;
}
@media (max-width: 991.98px) {
  .news-detail h1 {
    font-size: 2.25em;
    line-height: 1.2;
  }
}
.news-detail h2 {
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 36px;
  letter-spacing: 0.02em;
  color: #242829;
}
@media (max-width: 991.98px) {
  .news-detail h2 {
    font-size: calc(1.275rem + 0.3vw);
    line-height: 1.4;
  }
}
.news-detail h3 {
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 32px;
  letter-spacing: 0.02em;
  color: #242829;
}
@media (max-width: 991.98px) {
  .news-detail h3 {
    font-size: 1.2em;
    line-height: 1.4;
  }
}
.news-detail h4 {
  font-weight: 600;
  font-size: 1.125rem;
  line-height: 36px;
  letter-spacing: 0.02em;
  color: #242829;
}
@media (max-width: 991.98px) {
  .news-detail h4 {
    font-size: 1.2em;
    line-height: 1.4;
  }
}
.news-detail p {
  margin-bottom: 1.8rem;
}
.news-detail img {
  height: auto;
}
.news-detail sup {
  cursor: pointer;
}
.news-detail sup:after {
  content: "";
  padding: 10px;
  position: absolute;
  left: -7px;
  top: -5px;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
}
.news-detail sup:hover::after {
  padding: 14px;
  left: -9px;
  top: -7px;
  border-radius: 14px;
  background-color: rgba(136, 172, 39, 0.4);
}
.news-detail .blog-article-preheader {
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.02em;
  color: #595F56;
  margin: 20px 0 10px;
}
.news-detail .blog-article-writer {
  margin-top: 20px;
  font-weight: 400;
  font-size: 16px;
  line-height: 25px;
  letter-spacing: 0.2px;
  color: #242829;
}
.news-detail .shop-link-wrapper h6 {
  font-weight: 400;
  font-size: 20px;
  line-height: 27px;
  color: #000000;
}
.news-detail .related-products h2 {
  font-weight: 600;
  font-size: 32px;
  line-height: 44px;
  letter-spacing: 0.02em;
  color: #242829;
}

#searchterm {
  width: 100%;
  border: none;
  border-radius: 0;
  border-bottom: 1px solid #777;
  background-color: transparent;
  max-width: 355px;
}
#searchterm:focus {
  box-shadow: none;
}
#searchterm::blur #auto-complete-results {
  display: none;
}

#search-area {
  max-width: 355px;
}

.search-term-button {
  background: transparent;
  border: none;
  cursor: pointer;
  display: inline-block;
  font-size: 20px;
  position: absolute;
  top: 0;
  left: 0;
  padding: 10px 15px 8px 15px;
}
.search-term-button:focus {
  outline: none;
}

.news-search-header {
  background-color: #8859C5;
  height: 146px;
  margin-right: -15px;
  margin-left: -15px;
}
@media (min-width: 992px) {
  .news-search-header {
    height: 81px;
  }
}
.news-search-header .news-back-button a {
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.01em;
  color: #fff;
}
.news-search-header .news-search-headline {
  text-align: center;
}
.news-search-header .news-search-headline h1 {
  font-weight: 300;
  font-size: 32px;
  line-height: 48px;
  text-align: center;
  letter-spacing: 0.02em;
  color: #FFFFFF;
}

#auto-complete-results {
  -webkit-box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.14);
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.14);
  width: calc(100% - 30px);
  background-color: rgba(255, 255, 255, 0.95);
  position: absolute;
  z-index: 3;
}

.autocomplete-search-result {
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 3px;
}
.autocomplete-search-result .search-result-row {
  height: 55px;
  cursor: pointer;
  margin: 0;
  transition: background-color linear 0.2s;
  overflow: hidden;
}
.autocomplete-search-result .search-result-row a.mdi-chevron-right {
  color: #8859C5;
}
.autocomplete-search-result .search-result-row a.mdi-chevron-right::before {
  margin-top: 15px;
  font-size: 22px;
}
.autocomplete-search-result .search-result-row:hover {
  background-color: #eee;
}
.autocomplete-search-result .search-result-row:hover .news-list-button a {
  background-color: #440099;
}
.autocomplete-search-result .search-result-row .search-result-small-image {
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  width: 100%;
  height: 37px;
  margin: 9px 0;
}
.autocomplete-search-result .search-result-row .search-result-headline {
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  display: flex;
  align-items: center;
  color: #242829;
}
.autocomplete-search-result .news-list-button {
  height: 60px;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  top: 10px;
  padding: 10px 35px 20px;
}
.autocomplete-search-result .news-list-button a {
  float: right;
  background-color: #000;
  color: #fff;
  width: 26px;
  height: 26px;
  border-radius: 13px;
}
.autocomplete-search-result .news-list-button a:hover {
  background-color: #440099;
}
.autocomplete-search-result .news-list-button a::before {
  position: relative;
  vertical-align: top;
  font-size: 15px;
  top: 1px;
  left: 6px;
}

.newsroom-hero-block {
  position: relative;
  overflow: hidden;
  background-size: cover;
  background-position: center center;
}

.newsroomheroblock {
  height: 420px;
}
@media (min-width: 992px) {
  .newsroomheroblock {
    height: 374px;
  }
}
.newsroomheroblock .newsroom-hero-block-content {
  position: relative;
  margin: 0 auto;
  width: 1004px;
  max-width: 100%;
  padding-top: 116px;
}
.newsroomheroblock .newsroom-hero-block-content h1 {
  color: #242829;
  margin-bottom: 10px;
  line-height: 58px;
  max-width: unset;
}
.newsroomheroblock .newsroom-hero-block-content .newsroom-hero-block-info {
  background-color: #fff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  height: 260px;
  width: 1004px;
  max-width: 90%;
  margin: 0 auto;
  font-size: 16px;
  padding-bottom: 30px;
}
@media (max-width: 991.98px) {
  .newsroomheroblock .newsroom-hero-block-content {
    position: absolute;
    width: 1004px;
    padding-top: 0;
    bottom: 54px;
  }
  .newsroomheroblock .newsroom-hero-block-content h1 {
    font-size: 32px;
    line-height: 40px;
    font-weight: 400;
    text-align: left;
  }
  .newsroomheroblock .newsroom-hero-block-content .newsroom-hero-block-info {
    background-color: #fff;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    height: auto;
    width: 1004px;
    max-width: 90%;
    margin: 0 auto;
    font-size: 16px;
  }
}

@media (max-width: 767.98px) {
  .footnotes-container {
    padding: 0;
  }
}

.footnotes {
  max-width: 800px;
  margin: 0 auto 125px;
}
@media (max-width: 575.98px) {
  .footnotes {
    margin: 0 auto 75px;
  }
}
.footnotes #footnoteHeader {
  background-color: #F3EEEB;
  border-radius: 5px;
}
.footnotes #footnoteHeader .footnote-arrowLinkWrapper {
  width: 22px;
  height: 22px;
  position: absolute;
  right: 25px;
}
.footnotes #footnoteHeader .footnote-link-showHide {
  border: solid #242829;
  border-width: 0 2px 2px 0;
  display: inline-block;
  position: absolute;
  padding: 4px;
  top: 10px;
  left: 5px;
  line-height: 17px;
  -webkit-transition: -webkit-transform linear 0.7s;
  -moz-transition: -moz-transform 0.7s;
  transition: transform 0.7s;
}
.footnotes #footnoteHeader .footnote-link-showHide {
  transform: rotate(-135deg);
  -moz-transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}
.footnotes #footnoteHeader .collapsed .footnote-link-showHide {
  transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}
.footnotes #footnotes-expander {
  padding: 0.625rem 0;
  font-weight: 600;
  font-size: 18px;
  line-height: 32px;
}
.footnotes #footnotes-expander:focus {
  box-shadow: none;
}

.preview {
  margin-bottom: 20px;
}

.preview_supported {
  margin-bottom: 25px;
}

.heroblock .support-hero-settings {
  height: 70vw;
}
@media (min-width: 576px) {
  .heroblock .support-hero-settings {
    height: 300px;
  }
}
@media (min-width: 768px) {
  .heroblock .support-hero-settings {
    height: 425px;
  }
}
@media (min-width: 992px) {
  .heroblock .support-hero-settings {
    height: 475px;
  }
}
.heroblock .support-hero-settings .container, .heroblock .support-hero-settings .row {
  height: 100%;
}
.heroblock .support-callout {
  background-color: #EDF6F6;
  padding: 50px;
}
.heroblock .support-callout p {
  font-size: 18px;
  line-height: 32px;
}
.heroblock .support-callout img {
  max-width: 70px;
  height: auto;
}
.heroblock .support-callout h2 {
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
}
.heroblock .support-callout-mobile {
  background-color: #EDF6F6;
  padding: 25px;
}
.heroblock .support-callout-mobile p {
  font-size: 16px;
  line-height: 26px;
}
.heroblock .support-callout-mobile img {
  max-width: 45px;
  height: auto;
}
.heroblock .support-callout-mobile h2 {
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
}

.home-page.no-gutters {
  max-width: 2560px;
  margin: 0 auto;
}

header {
  height: auto;
}

.nav-pills .nav-link {
  color: #440099;
  background-color: #fff;
}

.nav-pills .nav-link.active, .nav-pills .nav-link:hover {
  color: #fff;
  background-color: #440099;
}

.field-validation-error {
  position: relative;
  padding: 0.25rem 1rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  color: #891519;
  background-color: #f9cdd0;
  border-color: #f7b9bd;
}

.btn.mdi:before {
  font-size: 1.5rem;
  line-height: 0.1;
  position: relative;
  top: 4px;
}

img {
  max-width: 100%;
}

@media (min-width: 576px) {
  .screen-width-block.footer-bottom {
    width: 100vw;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
  }
  .screen-width-block .screen-width-wrapper {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
}
@media (min-width: 576px) and (min-width: 1200px) {
  .screen-width-block .screen-width-wrapper {
    max-width: 1440px;
  }
}
@media (min-width: 576px) {
  .screen-width-block .screen-width-container {
    width: 100%;
    margin-right: auto;
    margin-left: auto;
  }
}
@media (min-width: 576px) and (min-width: 1200px) {
  .screen-width-block .screen-width-container {
    max-width: 1440px;
  }
}
.standard-block-padding {
  padding: 40px 0;
}
@media (min-width: 768px) {
  .standard-block-padding {
    padding: 55px 0;
  }
}
@media (min-width: 992px) {
  .standard-block-padding {
    padding: 65px 0;
  }
}
@media (min-width: 1200px) {
  .standard-block-padding {
    padding: 75px 0;
  }
}

.btn-primary, #CartPreview .btn-primary {
  background-color: #242829 !important;
  border-color: #242829 !important;
  color: #fff !important;
}
.btn-primary:hover, #CartPreview .btn-primary:hover {
  background-color: #8859C5;
  border-color: #8859C5;
}
.btn-primary:active, .btn-primary.active, #CartPreview .btn-primary:active, #CartPreview .btn-primary.active {
  background-color: #440099;
  border-color: #440099;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2);
}
.btn-primary.disabled, .btn-primary:disabled, #CartPreview .btn-primary.disabled, #CartPreview .btn-primary:disabled {
  background-color: #B0B4B3;
  border-color: #B0B4B3;
}
.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active,
.btn-primary .show > .btn-primary.dropdown-toggle, #CartPreview .btn-primary:not(:disabled):not(.disabled):active, #CartPreview .btn-primary:not(:disabled):not(.disabled).active,
#CartPreview .btn-primary .show > .btn-primary.dropdown-toggle {
  background-color: #242829;
  border-color: #242829;
}
.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-primary.dropdown-toggle:focus, #CartPreview .btn-primary:not(:disabled):not(.disabled):active:focus, #CartPreview .btn-primary:not(:disabled):not(.disabled).active:focus, .show > #CartPreview .btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2);
}

.btn-outline-primary {
  color: #242829;
  border-color: #242829;
}
.btn-outline-primary:hover {
  color: #fff;
  background-color: #242829;
  border-color: #242829;
}
.btn-outline-primary:active, .btn-outline-primary.active {
  color: #fff;
  background-color: #242829;
  border-color: #242829;
}
.btn-outline-primary.disabled, .btn-outline-primary:disabled {
  color: #fff;
  background-color: #B0B4B3;
  border-color: #B0B4B3;
}
.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {
  background-color: #242829;
  border-color: #242829;
}
.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5);
}

.block p, .block h1, .block h2, .block h3, .block h4, .block h5, .block h6, .block .imagetextblock .buttonblock, .block .shortinfoitemblock .buttonblock, .block ol, .block ul, .news-detail p, .news-detail h1, .news-detail h2, .news-detail h3, .news-detail h4, .news-detail h5, .news-detail h6, .news-detail .imagetextblock .buttonblock, .news-detail .shortinfoitemblock .buttonblock, .news-detail ol, .news-detail ul {
  max-width: 800px;
  margin-right: auto;
  margin-left: auto;
  padding: 0;
}
.block p li, .block h1 li, .block h2 li, .block h3 li, .block h4 li, .block h5 li, .block h6 li, .block .imagetextblock .buttonblock li, .block .shortinfoitemblock .buttonblock li, .block ol li, .block ul li, .news-detail p li, .news-detail h1 li, .news-detail h2 li, .news-detail h3 li, .news-detail h4 li, .news-detail h5 li, .news-detail h6 li, .news-detail .imagetextblock .buttonblock li, .news-detail .shortinfoitemblock .buttonblock li, .news-detail ol li, .news-detail ul li {
  margin-left: 34px;
}

a.zzPreHeaderCart i.mdi-cart::before {
  color: #242829;
}

.hero-block__callout-content p, .hero-block__callout-content h1, .hero-block__callout-content h2, .hero-block__callout-content h3, .hero-block__callout-content h4, .hero-block__callout-content h5, .hero-block__callout-content h6, .hero-block__callout-content .imagetextblock .buttonblock, .hero-block__callout-content .shortinfoitemblock .buttonblock, .allow-full-width p, .allow-full-width h1, .allow-full-width h2, .allow-full-width h3, .allow-full-width h4, .allow-full-width h5, .allow-full-width h6, .allow-full-width .imagetextblock .buttonblock, .allow-full-width .shortinfoitemblock .buttonblock, .faqcontainerblock p, .faqcontainerblock h1, .faqcontainerblock h2, .faqcontainerblock h3, .faqcontainerblock h4, .faqcontainerblock h5, .faqcontainerblock h6, .faqcontainerblock .imagetextblock .buttonblock, .faqcontainerblock .shortinfoitemblock .buttonblock {
  max-width: initial;
  margin-right: initial;
  margin-left: initial;
}

.fade-scale {
  transform: scale(0.8);
  opacity: 0;
  -webkit-transition: all 0.25s linear;
  -o-transition: all 0.25s linear;
  transition: all 0.26s linear;
}

.fade-scale.show {
  opacity: 1;
  transform: scale(1);
}

a:hover {
  text-decoration: none;
}

.block a[target=_blank]:not(.mdi-book-open-outline):not(.social-share-link):not(.footer-bottom a):not(a.animated-link), .zzPreHeader a[target=_blank]:not(.mdi-book-open-outline):not(.social-share-link):not(.footer-bottom a):not(a.animated-link) {
  color: #242829;
  letter-spacing: 0.08em;
}
.block a[target=_blank]:not(.mdi-book-open-outline):not(.social-share-link):not(.footer-bottom a):not(a.animated-link)::before, .zzPreHeader a[target=_blank]:not(.mdi-book-open-outline):not(.social-share-link):not(.footer-bottom a):not(a.animated-link)::before {
  position: relative;
  content: "\\f03cc";
  font-family: "Material Design Icons";
  margin-right: 0.5rem;
  color: #8859C5;
  top: 0.05em;
}
.block a[target=_blank]:not(.mdi-book-open-outline):not(.social-share-link):not(.footer-bottom a):not(a.animated-link):hover::before, .zzPreHeader a[target=_blank]:not(.mdi-book-open-outline):not(.social-share-link):not(.footer-bottom a):not(a.animated-link):hover::before {
  color: #242829;
}
.block a[href\$=".pdf"]:not(.btn):not(.footer-bottom a):not(a.animated-link), .zzPreHeader a[href\$=".pdf"]:not(.btn):not(.footer-bottom a):not(a.animated-link) {
  color: #242829;
}
.block a[href\$=".pdf"]:not(.btn):not(.footer-bottom a):not(a.animated-link)::before, .zzPreHeader a[href\$=".pdf"]:not(.btn):not(.footer-bottom a):not(a.animated-link)::before {
  color: #440099;
  content: "\\f01da";
  font-family: "Material Design Icons";
  margin-right: 0.5rem;
  color: #8859C5;
}
.block a[href\$=".pdf"]:not(.btn):not(.footer-bottom a):not(a.animated-link):hover::before, .zzPreHeader a[href\$=".pdf"]:not(.btn):not(.footer-bottom a):not(a.animated-link):hover::before {
  color: #242829;
}
.block a[href\$=".pdf"]:not(.btn):not(.footer-bottom a):not(a.animated-link)::after, .zzPreHeader a[href\$=".pdf"]:not(.btn):not(.footer-bottom a):not(a.animated-link)::after {
  content: "";
}

h1, .h1 {
  line-height: 3.5rem;
  letter-spacing: 0.02em;
}

h2, .h2 {
  line-height: 3rem;
  letter-spacing: 0.02em;
}

h3, .h3 {
  line-height: 2.25rem;
  letter-spacing: 0.02em;
}

h4, .h4 {
  line-height: 2.25rem;
  letter-spacing: 0.01em;
}

h5, .h5 {
  line-height: 2rem;
}

h6, .h6 {
  line-height: 2rem;
  letter-spacing: 0.02em;
}

.display-1 {
  line-height: 4rem;
  letter-spacing: 0.02em;
}

.display-2 {
  line-height: 3rem;
  letter-spacing: 0.02em;
}

.display-3 {
  line-height: 2.25rem;
  letter-spacing: 0.02em;
}

@media (max-width: 767.98px) {
  h1, .h1 {
    line-height: 2.5rem;
  }
  h2, .h2 {
    line-height: 2.25rem;
  }
  h3, .h3 {
    line-height: 2rem;
  }
  h4, .h4 {
    line-height: 2rem;
  }
  h5, .h5 {
    line-height: 1.75rem;
  }
  h6, .h6 {
    line-height: 1.375rem;
  }
  .display-1 {
    line-height: 1.4;
  }
  .display-2 {
    line-height: 1.4;
  }
  .display-3 {
    line-height: 1.4;
  }
}
.social-sharing {
  position: fixed;
  right: 20px;
  top: 120px;
  z-index: 10;
  background-color: rgba(251, 250, 252, 0.7);
  width: 46px;
  height: 46px;
  border-radius: 23px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transform: scale(1);
  transition: right 300ms ease-out, transform 200ms linear, box-shadow 100ms linear;
}
.social-sharing::after {
  position: absolute;
  content: "\\f0497";
  font-family: "Material Design Icons";
  text-decoration: none;
  color: #6200FF;
  top: 0.42em;
  left: 0.4em;
  font-size: 24px;
}
.social-sharing:hover {
  transform: scale(1.1) translateY(-3px);
  box-shadow: 0px 4px 25px rgba(0, 0, 0, 0.25);
}
.social-sharing:hover::after {
  color: #000;
}
.social-sharing.active {
  top: 120px;
  right: 170px;
  height: 46px;
  background-color: rgb(251, 250, 252);
}
.social-sharing.active::after {
  content: "\\f1398";
  left: 0.62em;
  top: 0.5em;
  font-size: 21px;
  color: #6200FF;
}
.social-sharing svg {
  max-width: 45%;
  height: auto;
  margin: 24%;
}

@media (max-width: 991.98px) {
  .social-sharing {
    position: fixed;
    right: 150px;
    top: 1px;
    z-index: 10;
    background-color: transparent;
    width: 46px;
    height: 17px;
    box-shadow: none;
    cursor: pointer;
    transform: scale(1);
    transition: right 300ms ease-out, transform 200ms linear, box-shadow 100ms linear;
  }
  .social-sharing::after {
    position: absolute;
    content: "\\f0497";
    font-family: "Material Design Icons";
    text-decoration: none;
    color: #ffffff;
    top: 2px;
    left: 0.4em;
    font-size: 16px;
  }
  .social-sharing:hover {
    transform: scale(1) translateY(0);
    box-shadow: none;
  }
  .social-sharing:hover::after {
    color: #fff;
  }
  .social-sharing.active:hover::after {
    color: #000;
  }
}
.social-media-share-panel {
  background-color: inherit;
  padding: 10px 0;
}
.social-media-share-panel #social-share-button {
  padding: 0;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #8859C5;
  color: #fff;
  text-align: center;
  font-size: 14px;
  letter-spacing: 0.04em;
  line-height: 22px;
  text-transform: uppercase;
  font-weight: normal;
  margin: 20px auto 0;
  display: block;
  position: relative;
  margin-bottom: -30px;
  z-index: 1;
}
.social-media-share-panel #social-share-button.overflow-text {
  font-size: 11px;
  letter-spacing: 0;
  line-height: 18px;
}
.social-media-share-panel #social-share-button:hover {
  border-color: #545b62;
  box-shadow: 0 0 0 0.2rem rgba(136, 89, 255, 0.5);
}
.social-media-share-panel #social-share-button span {
  font-size: 18px;
}

#social-share-modal .modal-dialog, .social-share-video-modal .modal-dialog {
  max-width: 475px;
}
#social-share-modal .modal-content, .social-share-video-modal .modal-content {
  background-color: #fbfafc;
}
#social-share-modal .modal-content h4, .social-share-video-modal .modal-content h4 {
  font-weight: normal;
  font-size: 25px;
  line-height: 34px;
}
#social-share-modal .modal-content h6, .social-share-video-modal .modal-content h6 {
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  color: #242E4C;
}
#social-share-modal .modal-body, .social-share-video-modal .modal-body {
  padding: 30px;
}
#social-share-modal .modal-body .url-textarea textarea, #social-share-modal .modal-body #url-textarea textarea, .social-share-video-modal .modal-body .url-textarea textarea, .social-share-video-modal .modal-body #url-textarea textarea {
  height: 48px;
  width: 100%;
  border: 1px solid #EBEBF2;
  background-color: #fff;
  font-size: 14px;
  line-height: 18px;
  color: #242E4C;
  overflow: hidden;
  resize: none;
}
#social-share-modal .social-icon-wrapper, .social-share-video-modal .social-icon-wrapper {
  margin-top: 11px;
  float: left;
  width: 50px;
  height: 50px;
  margin-right: 11px;
  border-radius: 50%;
  background-color: #fff;
  border: 1px solid #EBEBF2;
  padding: 12px;
  cursor: pointer;
  transition: all 150ms ease-out;
  transform: scale(1);
}
#social-share-modal .social-icon-wrapper:hover, .social-share-video-modal .social-icon-wrapper:hover {
  transform: scale(1.3);
}
#social-share-modal .mdi:not(.mdi-check), .social-share-video-modal .mdi:not(.mdi-check) {
  font-size: 24px;
}
#social-share-modal #copy-share-link, .social-share-video-modal #copy-share-link {
  text-transform: uppercase;
  margin-top: 10px;
  padding: 0.625rem 2.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.04em;
}
#social-share-modal .social-share-link .mdi, .social-share-video-modal .social-share-link .mdi {
  line-height: 26px;
  color: #440099;
}

.shortinfolinkblock .hover-bg {
  transition: all 350ms ease-out;
}
.shortinfolinkblock .short-info-link-text {
  position: relative;
  text-decoration: none;
  display: inline-block;
  color: #242829;
  letter-spacing: 0.08em;
  font-weight: 600;
}
.shortinfolinkblock .short-info-link-text:before {
  width: 0;
  background: #000;
  transition: width 250ms ease-in;
  z-index: 2;
  content: "";
  height: 2px;
  display: block;
  position: absolute;
  left: 0;
  bottom: -3px;
}
.shortinfolinkblock .short-info-link-text:after {
  width: 100%;
  background: #8859C5;
  content: "";
  height: 2px;
  display: block;
  position: absolute;
  left: 0;
  bottom: -3px;
}
.shortinfolinkblock:hover .short-info-link-text:before {
  width: 100%;
}
.shortinfolinkblock .hover-bg:hover {
  background-color: #ededed;
}

a.animated-link {
  position: relative;
  text-decoration: none;
  display: inline-block;
  color: #242829;
  letter-spacing: 0.08em;
  font-weight: 600;
}
a.animated-link:before {
  width: 0;
  background: #000;
  transition: width 250ms ease-in;
  z-index: 2;
  content: "";
  height: 2px;
  display: block;
  position: absolute;
  left: 0;
  bottom: -3px;
}
a.animated-link:after {
  width: 100%;
  background: #8859C5;
  content: "";
  height: 2px;
  display: block;
  position: absolute;
  left: 0;
  bottom: -3px;
}
a.animated-link:hover:before {
  width: 100%;
}

.block a:not(.btn):not(.btn-close):not(.carousel-control-prev):not(.carousel-control-next):not([target=_blank]):not([href\$=".pdf"]):not(.short-info-link-block):not(.animated-link):not(.nav-link):not(.event-nav-tab) {
  text-decoration: underline;
  color: inherit;
  font-weight: bold;
}
.block a:not(.btn):not(.btn-close):not(.carousel-control-prev):not(.carousel-control-next):not([target=_blank]):not([href\$=".pdf"]):not(.short-info-link-block):not(.animated-link):not(.nav-link):not(.event-nav-tab):hover {
  color: #8859C5;
}
.block .light-color-text:hover a:not(.btn):not(.btn-close):not(.carousel-control-prev):not(.carousel-control-next):not([target=_blank]):not([href\$=".pdf"]):not(.short-info-link-block):not(.animated-link):not(.nav-link):not(.event-nav-tab):hover {
  opacity: 0.9;
  color: inherit;
}

ul {
  margin-left: 0;
  padding-left: 20px;
}

div.animation-test {
  width: 500px;
  height: 580px;
  background: url(https://zinzinowebstorage.blob.core.windows.net/images/png-animation-test5.png) left top;
  transition: background 0.26s steps(7, end);
}

div.animation-test:hover {
  background-position: -3500px top;
}

.trustpilot-widget iframe .tp-widget-wrapper {
  margin: 0;
}

.form-control-lg {
  padding: 0.5rem 1rem;
}

.selectdiv {
  position: relative;
}

.selectdiv select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.selectdiv:after {
  right: 25px;
  content: " ";
  font-size: 10px;
  border: solid #440099;
  border-width: 0 1px 1px 0;
  display: inline-block;
  width: 8px;
  height: 8px;
  -webkit-transform: scale(0.9, 0.9) rotate(45deg);
  -moz-transform: scale(0.9, 0.9) rotate(45deg);
  -ms-transform: scale(0.9, 0.9) rotate(45deg);
  transform: scale(0.9, 0.9) rotate(45deg);
  top: calc(50% - 5px);
  position: absolute;
  pointer-events: none;
}

.cd-main-header .csr-class {
  background-color: red;
  color: #fff;
}

html, body {
  overflow-x: hidden;
}

body {
  max-width: 100% !important;
}

.pt-serif {
  font-family: "PT Serif", serif;
}

@media print {
  .cd-primary-nav {
    display: none !important;
  }
  #onetrust-banner-sdk {
    display: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./Assets/scss/main.scss","webpack://./Assets/scss/abstracts/_variables.scss","webpack://./node_modules/bootstrap/scss/bootstrap.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./Assets/scss/abstracts/_zinzino-bootstrap-variables.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_hover.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_code.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid-framework.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-row.scss","webpack://./node_modules/bootstrap/scss/_forms.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/mixins/_nav-divider.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_input-group.scss","webpack://./node_modules/bootstrap/scss/_custom-forms.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/mixins/_badge.scss","webpack://./node_modules/bootstrap/scss/_jumbotron.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/mixins/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_media.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/utilities/_align.scss","webpack://./node_modules/bootstrap/scss/mixins/_background-variant.scss","webpack://./node_modules/bootstrap/scss/utilities/_background.scss","webpack://./node_modules/bootstrap/scss/utilities/_borders.scss","webpack://./node_modules/bootstrap/scss/utilities/_display.scss","webpack://./node_modules/bootstrap/scss/utilities/_embed.scss","webpack://./node_modules/bootstrap/scss/utilities/_flex.scss","webpack://./node_modules/bootstrap/scss/utilities/_float.scss","webpack://./node_modules/bootstrap/scss/utilities/_interactions.scss","webpack://./node_modules/bootstrap/scss/utilities/_overflow.scss","webpack://./node_modules/bootstrap/scss/utilities/_position.scss","webpack://./node_modules/bootstrap/scss/utilities/_screenreaders.scss","webpack://./node_modules/bootstrap/scss/mixins/_screen-reader.scss","webpack://./node_modules/bootstrap/scss/utilities/_shadows.scss","webpack://./node_modules/bootstrap/scss/utilities/_sizing.scss","webpack://./node_modules/bootstrap/scss/utilities/_spacing.scss","webpack://./node_modules/bootstrap/scss/utilities/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/utilities/_text.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-emphasis.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-hide.scss","webpack://./node_modules/bootstrap/scss/utilities/_visibility.scss","webpack://./node_modules/bootstrap/scss/_print.scss","webpack://./node_modules/@mdi/font/scss/materialdesignicons.scss","webpack://./node_modules/@mdi/font/scss/_path.scss","webpack://./node_modules/@mdi/font/scss/_core.scss","webpack://./node_modules/@mdi/font/scss/_icons.scss","webpack://./node_modules/@mdi/font/scss/_extras.scss","webpack://./node_modules/@mdi/font/scss/_animated.scss","webpack://./Assets/scss/base/_helpers.scss","webpack://./Assets/scss/base/_typography.scss","webpack://./Assets/scss/base/_mixins.scss","webpack://./Assets/scss/layout/_navigation-bar.scss","webpack://./Assets/scss/layout/_navigation.scss","webpack://./Assets/scss/layout/_footer.scss","webpack://./Assets/scss/layout/_header.scss","webpack://./Assets/scss/layout/_header-logged-in-info.scss","webpack://./Assets/scss/layout/_bootstrap-col-slider.scss","webpack://./Features/Blocks/HeroBlock/_hero-block.scss","webpack://./Assets/scss/components/elements/_buttons.scss","webpack://./Assets/scss/components/elements/_checkbox.scss","webpack://./Assets/scss/components/elements/_dropdown.scss","webpack://./Assets/scss/components/elements/_icon-buttons.scss","webpack://./Assets/scss/components/elements/_icon-menu.scss","webpack://./Assets/scss/components/elements/_list-group.scss","webpack://./Assets/scss/components/elements/_loading-box.scss","webpack://./Assets/scss/components/elements/_select-menu.scss","webpack://./Assets/scss/components/elements/_table.scss","webpack://./Assets/scss/components/elements/_textbox.scss","webpack://./Assets/scss/components/widgets/_form.scss","webpack://./Features/Blocks/BrandAmbassadorBlock/_brand-ambassador-block.scss","webpack://./Features/Blocks/BreadcrumbBlock/_breadcrumb-block.scss","webpack://./Features/Blocks/BubbleInfoBlock/_bubble-info-block.scss","webpack://./Features/Blocks/ButtonBlock/_button-block.scss","webpack://./Features/Blocks/CarouselBlock/_carousel-block.scss","webpack://./Features/Blocks/EventBlock/_event-block.scss","webpack://./Features/Blocks/FAQContainerBlock/_faq-container-block.scss","webpack://./Features/Blocks/GridUspBlock/_grid-usp-block.scss","webpack://./Features/Blocks/InstagramBlock/_instagram-block.scss","webpack://./Features/Blocks/InvestorsHeroBlock/_investors-hero-block.scss","webpack://./Features/Blocks/NewsletterBlock/_newsletter-block.scss","webpack://./Features/Blocks/PartnerJoinBlock/_partner-join-block.scss","webpack://./Features/Blocks/ResponsiveVideoBlock/_responsive-video-block.scss","webpack://./Features/Blocks/ShortInfoBlock/_short-info-block.scss","webpack://./Features/Blocks/StaffBlock/_staff-block.scss","webpack://./Features/Blocks/SupportContactBlock/_support-contact-block.scss","webpack://./Features/Blocks/TestimonialsListBlock/_testimonials-list-block.scss","webpack://./Features/Blocks/TextBlock/_text-block.scss","webpack://./Features/Blocks/FixedBackgroundCointainerBlock/_fixed-background-container-block.scss","webpack://./Features/Category/_category-block.scss","webpack://./Features/ErrorPage/_error.scss","webpack://./Features/Media/_video-file.scss","webpack://./Features/People/_people.scss","webpack://./Features/Investors/_investors.scss","webpack://./Features/NewsRoom/_news-room.scss","webpack://./Features/Preview/_preview.scss","webpack://./Features/Support/_support-page.scss","webpack://./Assets/scss/themes/_default.scss","webpack://./Assets/scss/layout/_print.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAGhB;EACI;IACI,oCAAA;IACA,iCAAA;IACA,gCAAA;IACA,+BAAA;IACA,4BAAA;EADN;AACF;ACTC,cAAA;AAGD,UAAA;AAmBA,SAAA;AAUA,eAAA;AAGA,YAAA;AAIA,aAAA;ADrBA;mBAAA;AElBA;;;;;EAAA;ACAA;EAGI,eAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,eAAA;EAAA,cAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,eAAA;EAAA,oBAAA;EAIA,kBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,eAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAIA,kBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,uBAAA;EAKF,qCAAA;EACA,6GAAA;AHoCF;;AInCA;;;EAGE,sBAAA;AJsCF;;AInCA;EACE,uBAAA;EACA,iBAAA;EACA,8BAAA;EACA,6CAAA;AJsCF;;AIhCA;EACE,cAAA;AJmCF;;AIzBA;EACE,SAAA;EACA,wBCoIuB;ECCnB,eAAA;EFnIJ,gBC6ImB;ED5InB,gBCiJiB;EDhJjB,cCnCS;EDoCT,gBAAA;EACA,sBC9CM;AL0ER;;AIhBA;EACE,qBAAA;AJmBF;;AIVA;EACE,uBAAA;EACA,SAAA;EACA,iBAAA;AJaF;;AIAA;EACE,aAAA;EACA,qBC+GuB;AL5GzB;;AIIA;EACE,aAAA;EACA,mBCiBwB;ALlB1B;;AIYA;;EAEE,0BAAA;EACA,iCAAA;EACA,YAAA;EACA,gBAAA;EACA,8BAAA;AJTF;;AIYA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AJTF;;AIYA;;;EAGE,aAAA;EACA,mBAAA;AJTF;;AIYA;;;;EAIE,gBAAA;AJTF;;AIYA;EACE,gBCgDiB;ALzDnB;;AIYA;EACE,qBAAA;EACA,cAAA;AJTF;;AIYA;EACE,gBAAA;AJTF;;AIYA;;EAEE,mBCmCmB;AL5CrB;;AIYA;EEII,cAAA;ANZJ;;AIiBA;;EAEE,kBAAA;EEPE,cAAA;EFSF,cAAA;EACA,wBAAA;AJdF;;AIiBA;EAAM,eAAA;AJbN;;AIcA;EAAM,WAAA;AJVN;;AIiBA;EACE,cGXwC;EHYxC,qBC9EgB;ED+EhB,6BAAA;AJdF;AQlKE;EJmLE,cGdsC;EHetC,0BClFoB;ALoExB;;AIuBA;EACE,cAAA;EACA,qBAAA;AJpBF;AQ3KE;EJkME,cAAA;EACA,qBAAA;AJpBJ;;AI6BA;;;;EAIE,iGCxCsB;EChBpB,cAAA;AN+BJ;;AI6BA;EAEE,aAAA;EAEA,mBAAA;EAEA,cAAA;EAGA,6BAAA;AJ/BF;;AIuCA;EAEE,gBAAA;AJrCF;;AI6CA;EACE,sBAAA;EACA,kBAAA;AJ1CF;;AI6CA;EAGE,gBAAA;EACA,sBAAA;AJ5CF;;AIoDA;EACE,yBAAA;AJjDF;;AIoDA;EACE,oBCpBmB;EDqBnB,uBCrBmB;EDsBnB,cCtQS;EDuQT,gBAAA;EACA,oBAAA;AJjDF;;AIwDA;EAEE,mBAAA;EACA,gCAAA;AJtDF;;AI8DA;EAEE,qBAAA;EACA,qBCoDoB;ALhHtB;;AIkEA;EAEE,gBAAA;AJhEF;;AIwEA;EACE,UAAA;AJrEF;;AIwEA;;;;;EAKE,SAAA;EACA,oBAAA;EEhKE,kBAAA;EFkKF,oBAAA;AJrEF;;AIwEA;;EAEE,iBAAA;AJrEF;;AIwEA;;EAEE,oBAAA;AJrEF;;AI2EA;EACE,eAAA;AJxEF;;AI8EA;EACE,iBAAA;AJ3EF;;AIkFA;;;;EAIE,0BAAA;AJ/EF;;AIwFI;;;;EACE,eAAA;AJlFN;;AIwFA;;;;EAIE,UAAA;EACA,kBAAA;AJrFF;;AIwFA;;EAEE,sBAAA;EACA,UAAA;AJrFF;;AIyFA;EACE,cAAA;EAEA,gBAAA;AJvFF;;AI0FA;EAME,YAAA;EAEA,UAAA;EACA,SAAA;EACA,SAAA;AJ7FF;;AIkGA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EErNM,iBAAA;EFuNN,oBAAA;EACA,cAAA;EACA,mBAAA;AJ/FF;AMnLI;EFyQJ;IE3MU,iCAXQ;ENoIhB;AACF;;AI6FA;EACE,wBAAA;AJ1FF;;AI8FA;;EAEE,YAAA;AJ3FF;;AI8FA;EAKE,oBAAA;EACA,wBAAA;AJ/FF;;AIsGA;EACE,wBAAA;AJnGF;;AI2GA;EACE,aAAA;EACA,0BAAA;AJxGF;;AI+GA;EACE,qBAAA;AJ5GF;;AI+GA;EACE,kBAAA;EACA,eAAA;AJ5GF;;AI+GA;EACE,aAAA;AJ5GF;;AIiHA;EACE,wBAAA;AJ9GF;;AS9WA;;EAEE,qBJoMuB;EIlMvB,gBJoMqB;EInMrB,gBJoMqB;AL4KvB;;AS5WA;EH8LQ,iBAAA;ANkLR;AM3OI;EGrIJ;IHmMU,iCAXQ;EN4LhB;AACF;;ASpXA;EH6LQ,eAAA;AN2LR;AMpPI;EGpIJ;IHkMU,iCAXQ;ENqMhB;AACF;;AS5XA;EH4LQ,iBAAA;ANoMR;AM7PI;EGnIJ;IHiMU,iCAXQ;EN8MhB;AACF;;ASpYA;EH2LQ,iBAAA;AN6MR;AMtQI;EGlIJ;IHgMU,iCAXQ;ENuNhB;AACF;;AS5YA;EHiKM,kBAAA;AN+ON;;AS/YA;EHgKM,mBAAA;ANmPN;;ASjZA;EH8JM,kBAAA;EG5JJ,gBJsMiB;AL8MnB;;AShZA;EHiLQ,eAAA;EG/KN,gBJyLgB;EIxLhB,gBJgLqB;ALmOvB;AM9RI;EGxHJ;IHsLU,iCAXQ;EN+OhB;AACF;;AStZA;EH4KQ,eAAA;EG1KN,gBJqLgB;EIpLhB,gBJ2KqB;AL8OvB;AMzSI;EGnHJ;IHiLU,iCAXQ;EN0PhB;AACF;;AS5ZA;EHuKQ,iBAAA;EGrKN,gBJiLgB;EIhLhB,gBJsKqB;ALyPvB;AMpTI;EG9GJ;IH4KU,iCAXQ;ENqQhB;AACF;;ASlaA;EHyIM,iBAAA;EGvIJ,gBJ6KgB;EI5KhB,gBJiKqB;ALoQvB;;AS7ZA;EACE,gBJiCO;EIhCP,mBJgCO;EI/BP,SAAA;EACA,wCAAA;ATgaF;;ASxZA;;EHkGI,cAAA;EG/FF,gBJyHmB;ALkSrB;;ASxZA;;EAEE,cJiKa;EIhKb,yBJyKQ;ALkPV;;ASnZA;EC/EE,eAAA;EACA,gBAAA;AVseF;;ASnZA;ECpFE,eAAA;EACA,gBAAA;AV2eF;;ASrZA;EACE,qBAAA;ATwZF;AStZE;EACE,oBJmJkB;ALqQtB;;AS9YA;EH2DI,cAAA;EGzDF,yBAAA;ATiZF;;AS7YA;EACE,mBJxBO;EC4FH,kBAAA;AN6UN;;AS7YA;EACE,cAAA;EH+CE,cAAA;EG7CF,cJ1GS;AL0fX;AS9YE;EACE,aAAA;ATgZJ;;AWngBA;ECIE,eAAA;EAGA,YAAA;AZigBF;;AWlgBA;EACE,gBNiyBkB;EMhyBlB,sBNRM;EMSN,yBAAA;EEEE,sBAAA;EDPF,eAAA;EAGA,YAAA;AZ0gBF;;AW5fA;EAEE,qBAAA;AX8fF;;AW3fA;EACE,qBAAA;EACA,cAAA;AX8fF;;AW3fA;EL8HI,cAAA;EK5HF,cN3BS;ALyhBX;;AcriBA;ERmKI,gBAAA;EQjKF,cTuBK;EStBL,qBAAA;AdwiBF;AcriBE;EACE,cAAA;AduiBJ;;AcliBA;EACE,sBAAA;ERsJE,gBAAA;EQpJF,WTTM;ESUN,yBTDS;EQEP,qBAAA;AbqiBJ;AcliBE;EACE,UAAA;ER8IA,eAAA;EQ5IA,gBTuKe;AL6XnB;;Ac9hBA;EACE,cAAA;ERqIE,gBAAA;EQnIF,cTjBS;ALkjBX;Ac9hBE;ERgIE,kBAAA;EQ9HA,cAAA;EACA,kBAAA;AdgiBJ;;Ac3hBA;EACE,iBPikCkC;EOhkClC,kBAAA;Ad8hBF;;AetkBE;;;;;;ECDA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AhBglBF;;AiB7hBI;EFzCE;IACE,gBViHe;ELydrB;AACF;AiBniBI;EFzCE;IACE,gBViHe;EL8drB;AACF;AiBxiBI;EFzCE;IACE,gBViHe;ELmerB;AACF;AiB7iBI;EFzCE;IACE,iBViHe;ELwerB;AACF;Ae9jBE;ECnCA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AhBomBF;;Ae9jBE;EACE,eAAA;EACA,cAAA;AfikBJ;Ae/jBI;;EAEE,gBAAA;EACA,eAAA;AfikBN;;AkBvnBE;;;;;;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AlB+nBJ;;AkBzmBM;EACE,aAAA;EACA,YAAA;EACA,eAAA;AlB4mBR;;AgBhlBE;EACE,cAAA;EACA,eAAA;AhBmlBJ;;AgBrlBE;EACE,aAAA;EACA,cAAA;AhBwlBJ;;AgB1lBE;EACE,wBAAA;EACA,yBAAA;AhB6lBJ;;AgB/lBE;EACE,aAAA;EACA,cAAA;AhBkmBJ;;AgBpmBE;EACE,aAAA;EACA,cAAA;AhBumBJ;;AgBzmBE;EACE,wBAAA;EACA,yBAAA;AhB4mBJ;;AkB/nBM;EFCJ,cAAA;EACA,WAAA;EACA,eAAA;AhBkoBF;;AkB/nBU;EFbR,qBAAA;EAIA,sBAAA;AhB6oBF;;AkBpoBU;EFbR,sBAAA;EAIA,uBAAA;AhBkpBF;;AkBzoBU;EFbR,aAAA;EAIA,cAAA;AhBupBF;;AkB9oBU;EFbR,sBAAA;EAIA,uBAAA;AhB4pBF;;AkBnpBU;EFbR,sBAAA;EAIA,uBAAA;AhBiqBF;;AkBxpBU;EFbR,aAAA;EAIA,cAAA;AhBsqBF;;AkB7pBU;EFbR,sBAAA;EAIA,uBAAA;AhB2qBF;;AkBlqBU;EFbR,sBAAA;EAIA,uBAAA;AhBgrBF;;AkBvqBU;EFbR,aAAA;EAIA,cAAA;AhBqrBF;;AkB5qBU;EFbR,sBAAA;EAIA,uBAAA;AhB0rBF;;AkBjrBU;EFbR,sBAAA;EAIA,uBAAA;AhB+rBF;;AkBtrBU;EFbR,cAAA;EAIA,eAAA;AhBosBF;;AkBrrBM;EAAwB,SAAA;AlByrB9B;;AkBvrBM;EAAuB,SAAA;AlB2rB7B;;AkBxrBQ;EAAwB,QADb;AlB6rBnB;;AkB5rBQ;EAAwB,QADb;AlBisBnB;;AkBhsBQ;EAAwB,QADb;AlBqsBnB;;AkBpsBQ;EAAwB,QADb;AlBysBnB;;AkBxsBQ;EAAwB,QADb;AlB6sBnB;;AkB5sBQ;EAAwB,QADb;AlBitBnB;;AkBhtBQ;EAAwB,QADb;AlBqtBnB;;AkBptBQ;EAAwB,QADb;AlBytBnB;;AkBxtBQ;EAAwB,QADb;AlB6tBnB;;AkB5tBQ;EAAwB,QADb;AlBiuBnB;;AkBhuBQ;EAAwB,SADb;AlBquBnB;;AkBpuBQ;EAAwB,SADb;AlByuBnB;;AkBxuBQ;EAAwB,SADb;AlB6uBnB;;AkBruBY;EFhBV,wBAAA;AhByvBF;;AkBzuBY;EFhBV,yBAAA;AhB6vBF;;AkB7uBY;EFhBV,gBAAA;AhBiwBF;;AkBjvBY;EFhBV,yBAAA;AhBqwBF;;AkBrvBY;EFhBV,yBAAA;AhBywBF;;AkBzvBY;EFhBV,gBAAA;AhB6wBF;;AkB7vBY;EFhBV,yBAAA;AhBixBF;;AkBjwBY;EFhBV,yBAAA;AhBqxBF;;AkBrwBY;EFhBV,gBAAA;AhByxBF;;AkBzwBY;EFhBV,yBAAA;AhB6xBF;;AkB7wBY;EFhBV,yBAAA;AhBiyBF;;AiB5xBI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;ElB2zBN;EgB/xBA;IACE,cAAA;IACA,eAAA;EhBiyBF;EgBnyBA;IACE,aAAA;IACA,cAAA;EhBqyBF;EgBvyBA;IACE,wBAAA;IACA,yBAAA;EhByyBF;EgB3yBA;IACE,aAAA;IACA,cAAA;EhB6yBF;EgB/yBA;IACE,aAAA;IACA,cAAA;EhBizBF;EgBnzBA;IACE,wBAAA;IACA,yBAAA;EhBqzBF;EkBx0BI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EhB00BA;EkBv0BQ;IFbR,qBAAA;IAIA,sBAAA;EhBo1BA;EkB30BQ;IFbR,sBAAA;IAIA,uBAAA;EhBw1BA;EkB/0BQ;IFbR,aAAA;IAIA,cAAA;EhB41BA;EkBn1BQ;IFbR,sBAAA;IAIA,uBAAA;EhBg2BA;EkBv1BQ;IFbR,sBAAA;IAIA,uBAAA;EhBo2BA;EkB31BQ;IFbR,aAAA;IAIA,cAAA;EhBw2BA;EkB/1BQ;IFbR,sBAAA;IAIA,uBAAA;EhB42BA;EkBn2BQ;IFbR,sBAAA;IAIA,uBAAA;EhBg3BA;EkBv2BQ;IFbR,aAAA;IAIA,cAAA;EhBo3BA;EkB32BQ;IFbR,sBAAA;IAIA,uBAAA;EhBw3BA;EkB/2BQ;IFbR,sBAAA;IAIA,uBAAA;EhB43BA;EkBn3BQ;IFbR,cAAA;IAIA,eAAA;EhBg4BA;EkBj3BI;IAAwB,SAAA;ElBo3B5B;EkBl3BI;IAAuB,SAAA;ElBq3B3B;EkBl3BM;IAAwB,QADb;ElBs3BjB;EkBr3BM;IAAwB,QADb;ElBy3BjB;EkBx3BM;IAAwB,QADb;ElB43BjB;EkB33BM;IAAwB,QADb;ElB+3BjB;EkB93BM;IAAwB,QADb;ElBk4BjB;EkBj4BM;IAAwB,QADb;ElBq4BjB;EkBp4BM;IAAwB,QADb;ElBw4BjB;EkBv4BM;IAAwB,QADb;ElB24BjB;EkB14BM;IAAwB,QADb;ElB84BjB;EkB74BM;IAAwB,QADb;ElBi5BjB;EkBh5BM;IAAwB,SADb;ElBo5BjB;EkBn5BM;IAAwB,SADb;ElBu5BjB;EkBt5BM;IAAwB,SADb;ElB05BjB;EkBl5BU;IFhBV,cAAA;EhBq6BA;EkBr5BU;IFhBV,wBAAA;EhBw6BA;EkBx5BU;IFhBV,yBAAA;EhB26BA;EkB35BU;IFhBV,gBAAA;EhB86BA;EkB95BU;IFhBV,yBAAA;EhBi7BA;EkBj6BU;IFhBV,yBAAA;EhBo7BA;EkBp6BU;IFhBV,gBAAA;EhBu7BA;EkBv6BU;IFhBV,yBAAA;EhB07BA;EkB16BU;IFhBV,yBAAA;EhB67BA;EkB76BU;IFhBV,gBAAA;EhBg8BA;EkBh7BU;IFhBV,yBAAA;EhBm8BA;EkBn7BU;IFhBV,yBAAA;EhBs8BA;AACF;AiBl8BI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;ElBg+BN;EgBp8BA;IACE,cAAA;IACA,eAAA;EhBs8BF;EgBx8BA;IACE,aAAA;IACA,cAAA;EhB08BF;EgB58BA;IACE,wBAAA;IACA,yBAAA;EhB88BF;EgBh9BA;IACE,aAAA;IACA,cAAA;EhBk9BF;EgBp9BA;IACE,aAAA;IACA,cAAA;EhBs9BF;EgBx9BA;IACE,wBAAA;IACA,yBAAA;EhB09BF;EkB7+BI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EhB++BA;EkB5+BQ;IFbR,qBAAA;IAIA,sBAAA;EhBy/BA;EkBh/BQ;IFbR,sBAAA;IAIA,uBAAA;EhB6/BA;EkBp/BQ;IFbR,aAAA;IAIA,cAAA;EhBigCA;EkBx/BQ;IFbR,sBAAA;IAIA,uBAAA;EhBqgCA;EkB5/BQ;IFbR,sBAAA;IAIA,uBAAA;EhBygCA;EkBhgCQ;IFbR,aAAA;IAIA,cAAA;EhB6gCA;EkBpgCQ;IFbR,sBAAA;IAIA,uBAAA;EhBihCA;EkBxgCQ;IFbR,sBAAA;IAIA,uBAAA;EhBqhCA;EkB5gCQ;IFbR,aAAA;IAIA,cAAA;EhByhCA;EkBhhCQ;IFbR,sBAAA;IAIA,uBAAA;EhB6hCA;EkBphCQ;IFbR,sBAAA;IAIA,uBAAA;EhBiiCA;EkBxhCQ;IFbR,cAAA;IAIA,eAAA;EhBqiCA;EkBthCI;IAAwB,SAAA;ElByhC5B;EkBvhCI;IAAuB,SAAA;ElB0hC3B;EkBvhCM;IAAwB,QADb;ElB2hCjB;EkB1hCM;IAAwB,QADb;ElB8hCjB;EkB7hCM;IAAwB,QADb;ElBiiCjB;EkBhiCM;IAAwB,QADb;ElBoiCjB;EkBniCM;IAAwB,QADb;ElBuiCjB;EkBtiCM;IAAwB,QADb;ElB0iCjB;EkBziCM;IAAwB,QADb;ElB6iCjB;EkB5iCM;IAAwB,QADb;ElBgjCjB;EkB/iCM;IAAwB,QADb;ElBmjCjB;EkBljCM;IAAwB,QADb;ElBsjCjB;EkBrjCM;IAAwB,SADb;ElByjCjB;EkBxjCM;IAAwB,SADb;ElB4jCjB;EkB3jCM;IAAwB,SADb;ElB+jCjB;EkBvjCU;IFhBV,cAAA;EhB0kCA;EkB1jCU;IFhBV,wBAAA;EhB6kCA;EkB7jCU;IFhBV,yBAAA;EhBglCA;EkBhkCU;IFhBV,gBAAA;EhBmlCA;EkBnkCU;IFhBV,yBAAA;EhBslCA;EkBtkCU;IFhBV,yBAAA;EhBylCA;EkBzkCU;IFhBV,gBAAA;EhB4lCA;EkB5kCU;IFhBV,yBAAA;EhB+lCA;EkB/kCU;IFhBV,yBAAA;EhBkmCA;EkBllCU;IFhBV,gBAAA;EhBqmCA;EkBrlCU;IFhBV,yBAAA;EhBwmCA;EkBxlCU;IFhBV,yBAAA;EhB2mCA;AACF;AiBvmCI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;ElBqoCN;EgBzmCA;IACE,cAAA;IACA,eAAA;EhB2mCF;EgB7mCA;IACE,aAAA;IACA,cAAA;EhB+mCF;EgBjnCA;IACE,wBAAA;IACA,yBAAA;EhBmnCF;EgBrnCA;IACE,aAAA;IACA,cAAA;EhBunCF;EgBznCA;IACE,aAAA;IACA,cAAA;EhB2nCF;EgB7nCA;IACE,wBAAA;IACA,yBAAA;EhB+nCF;EkBlpCI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EhBopCA;EkBjpCQ;IFbR,qBAAA;IAIA,sBAAA;EhB8pCA;EkBrpCQ;IFbR,sBAAA;IAIA,uBAAA;EhBkqCA;EkBzpCQ;IFbR,aAAA;IAIA,cAAA;EhBsqCA;EkB7pCQ;IFbR,sBAAA;IAIA,uBAAA;EhB0qCA;EkBjqCQ;IFbR,sBAAA;IAIA,uBAAA;EhB8qCA;EkBrqCQ;IFbR,aAAA;IAIA,cAAA;EhBkrCA;EkBzqCQ;IFbR,sBAAA;IAIA,uBAAA;EhBsrCA;EkB7qCQ;IFbR,sBAAA;IAIA,uBAAA;EhB0rCA;EkBjrCQ;IFbR,aAAA;IAIA,cAAA;EhB8rCA;EkBrrCQ;IFbR,sBAAA;IAIA,uBAAA;EhBksCA;EkBzrCQ;IFbR,sBAAA;IAIA,uBAAA;EhBssCA;EkB7rCQ;IFbR,cAAA;IAIA,eAAA;EhB0sCA;EkB3rCI;IAAwB,SAAA;ElB8rC5B;EkB5rCI;IAAuB,SAAA;ElB+rC3B;EkB5rCM;IAAwB,QADb;ElBgsCjB;EkB/rCM;IAAwB,QADb;ElBmsCjB;EkBlsCM;IAAwB,QADb;ElBssCjB;EkBrsCM;IAAwB,QADb;ElBysCjB;EkBxsCM;IAAwB,QADb;ElB4sCjB;EkB3sCM;IAAwB,QADb;ElB+sCjB;EkB9sCM;IAAwB,QADb;ElBktCjB;EkBjtCM;IAAwB,QADb;ElBqtCjB;EkBptCM;IAAwB,QADb;ElBwtCjB;EkBvtCM;IAAwB,QADb;ElB2tCjB;EkB1tCM;IAAwB,SADb;ElB8tCjB;EkB7tCM;IAAwB,SADb;ElBiuCjB;EkBhuCM;IAAwB,SADb;ElBouCjB;EkB5tCU;IFhBV,cAAA;EhB+uCA;EkB/tCU;IFhBV,wBAAA;EhBkvCA;EkBluCU;IFhBV,yBAAA;EhBqvCA;EkBruCU;IFhBV,gBAAA;EhBwvCA;EkBxuCU;IFhBV,yBAAA;EhB2vCA;EkB3uCU;IFhBV,yBAAA;EhB8vCA;EkB9uCU;IFhBV,gBAAA;EhBiwCA;EkBjvCU;IFhBV,yBAAA;EhBowCA;EkBpvCU;IFhBV,yBAAA;EhBuwCA;EkBvvCU;IFhBV,gBAAA;EhB0wCA;EkB1vCU;IFhBV,yBAAA;EhB6wCA;EkB7vCU;IFhBV,yBAAA;EhBgxCA;AACF;AiB5wCI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;ElB0yCN;EgB9wCA;IACE,cAAA;IACA,eAAA;EhBgxCF;EgBlxCA;IACE,aAAA;IACA,cAAA;EhBoxCF;EgBtxCA;IACE,wBAAA;IACA,yBAAA;EhBwxCF;EgB1xCA;IACE,aAAA;IACA,cAAA;EhB4xCF;EgB9xCA;IACE,aAAA;IACA,cAAA;EhBgyCF;EgBlyCA;IACE,wBAAA;IACA,yBAAA;EhBoyCF;EkBvzCI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EhByzCA;EkBtzCQ;IFbR,qBAAA;IAIA,sBAAA;EhBm0CA;EkB1zCQ;IFbR,sBAAA;IAIA,uBAAA;EhBu0CA;EkB9zCQ;IFbR,aAAA;IAIA,cAAA;EhB20CA;EkBl0CQ;IFbR,sBAAA;IAIA,uBAAA;EhB+0CA;EkBt0CQ;IFbR,sBAAA;IAIA,uBAAA;EhBm1CA;EkB10CQ;IFbR,aAAA;IAIA,cAAA;EhBu1CA;EkB90CQ;IFbR,sBAAA;IAIA,uBAAA;EhB21CA;EkBl1CQ;IFbR,sBAAA;IAIA,uBAAA;EhB+1CA;EkBt1CQ;IFbR,aAAA;IAIA,cAAA;EhBm2CA;EkB11CQ;IFbR,sBAAA;IAIA,uBAAA;EhBu2CA;EkB91CQ;IFbR,sBAAA;IAIA,uBAAA;EhB22CA;EkBl2CQ;IFbR,cAAA;IAIA,eAAA;EhB+2CA;EkBh2CI;IAAwB,SAAA;ElBm2C5B;EkBj2CI;IAAuB,SAAA;ElBo2C3B;EkBj2CM;IAAwB,QADb;ElBq2CjB;EkBp2CM;IAAwB,QADb;ElBw2CjB;EkBv2CM;IAAwB,QADb;ElB22CjB;EkB12CM;IAAwB,QADb;ElB82CjB;EkB72CM;IAAwB,QADb;ElBi3CjB;EkBh3CM;IAAwB,QADb;ElBo3CjB;EkBn3CM;IAAwB,QADb;ElBu3CjB;EkBt3CM;IAAwB,QADb;ElB03CjB;EkBz3CM;IAAwB,QADb;ElB63CjB;EkB53CM;IAAwB,QADb;ElBg4CjB;EkB/3CM;IAAwB,SADb;ElBm4CjB;EkBl4CM;IAAwB,SADb;ElBs4CjB;EkBr4CM;IAAwB,SADb;ElBy4CjB;EkBj4CU;IFhBV,cAAA;EhBo5CA;EkBp4CU;IFhBV,wBAAA;EhBu5CA;EkBv4CU;IFhBV,yBAAA;EhB05CA;EkB14CU;IFhBV,gBAAA;EhB65CA;EkB74CU;IFhBV,yBAAA;EhBg6CA;EkBh5CU;IFhBV,yBAAA;EhBm6CA;EkBn5CU;IFhBV,gBAAA;EhBs6CA;EkBt5CU;IFhBV,yBAAA;EhBy6CA;EkBz5CU;IFhBV,yBAAA;EhB46CA;EkB55CU;IFhBV,gBAAA;EhB+6CA;EkB/5CU;IFhBV,yBAAA;EhBk7CA;EkBl6CU;IFhBV,yBAAA;EhBq7CA;AACF;AmBz+CA;EACE,WAAA;EACA,mBdkFO;EcjFP,cdSS;ALk+CX;AmBx+CE;;EAEE,gBdiPiB;EchPjB,mBAAA;EACA,6BAAA;AnB0+CJ;AmBv+CE;EACE,sBAAA;EACA,gCAAA;AnBy+CJ;AmBt+CE;EACE,6BAAA;AnBw+CJ;;AmB99CE;;EAEE,ed2NoB;ALswCxB;;AmBx9CA;EACE,yBAAA;AnB29CF;AmBz9CE;;EAEE,yBAAA;AnB29CJ;AmBv9CI;;EAEE,wBAAA;AnBy9CN;;AmBn9CE;;;;EAIE,SAAA;AnBs9CJ;;AmB78CE;EACE,qCduLc;ALyxClB;;AQ/gDE;EW2EI,cdvEK;EcwEL,sCd4KW;AL4xCjB;;AoB1hDI;;;EAGE,yBD2F+B;AnBk8CrC;AoBzhDM;;;;EAIE,qBDmFyE;AnBw8CjF;;AQhiDE;EYiBM,yBAJe;ApBuhDvB;AoBjhDQ;;EAEE,yBARa;ApB2hDvB;;AoB9iDI;;;EAGE,yBD2F+B;AnBs9CrC;AoB7iDM;;;;EAIE,qBDmFyE;AnB49CjF;;AQpjDE;EYiBM,yBAJe;ApB2iDvB;AoBriDQ;;EAEE,yBARa;ApB+iDvB;;AoBlkDI;;;EAGE,yBD2F+B;AnB0+CrC;AoBjkDM;;;;EAIE,qBDmFyE;AnBg/CjF;;AQxkDE;EYiBM,yBAJe;ApB+jDvB;AoBzjDQ;;EAEE,yBARa;ApBmkDvB;;AoBtlDI;;;EAGE,yBD2F+B;AnB8/CrC;AoBrlDM;;;;EAIE,qBDmFyE;AnBogDjF;;AQ5lDE;EYiBM,yBAJe;ApBmlDvB;AoB7kDQ;;EAEE,yBARa;ApBulDvB;;AoB1mDI;;;EAGE,yBD2F+B;AnBkhDrC;AoBzmDM;;;;EAIE,qBDmFyE;AnBwhDjF;;AQhnDE;EYiBM,yBAJe;ApBumDvB;AoBjmDQ;;EAEE,yBARa;ApB2mDvB;;AoB9nDI;;;EAGE,yBD2F+B;AnBsiDrC;AoB7nDM;;;;EAIE,qBDmFyE;AnB4iDjF;;AQpoDE;EYiBM,yBAJe;ApB2nDvB;AoBrnDQ;;EAEE,yBARa;ApB+nDvB;;AoBlpDI;;;EAGE,yBD2F+B;AnB0jDrC;AoBjpDM;;;;EAIE,qBDmFyE;AnBgkDjF;;AQxpDE;EYiBM,yBAJe;ApB+oDvB;AoBzoDQ;;EAEE,yBARa;ApBmpDvB;;AoBtqDI;;;EAGE,yBD2F+B;AnB8kDrC;AoBrqDM;;;;EAIE,qBDmFyE;AnBolDjF;;AQ5qDE;EYiBM,yBAJe;ApBmqDvB;AoB7pDQ;;EAEE,yBARa;ApBuqDvB;;AoB1rDI;;;EAGE,sCf2PW;ALk8CjB;;AQ1rDE;EYiBM,sCAJe;ApBirDvB;AoB3qDQ;;EAEE,sCARa;ApBqrDvB;;AmB7lDI;EACE,Wd3GE;Ec4GF,yBdpGK;EcqGL,qBd8JoB;ALk8C1B;AmB3lDI;EACE,cd5GK;Ec6GL,yBdlHK;EcmHL,qBdlHK;AL+sDX;;AmBxlDA;EACE,Wd3HM;Ec4HN,yBdpHS;AL+sDX;AmBzlDE;;;EAGE,qBd0IsB;ALi9C1B;AmBxlDE;EACE,SAAA;AnB0lDJ;AmBtlDI;EACE,2Cd8HiB;AL09CvB;AQ7tDE;EW4IM,WdjJA;EckJA,4CdwHc;AL49CtB;;AiBpqDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EnBskDN;EmBnkDM;IACE,SAAA;EnBqkDR;AACF;AiBhrDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EnBilDN;EmB9kDM;IACE,SAAA;EnBglDR;AACF;AiB3rDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EnB4lDN;EmBzlDM;IACE,SAAA;EnB2lDR;AACF;AiBtsDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EnBumDN;EmBpmDM;IACE,SAAA;EnBsmDR;AACF;AmBhnDI;EAEI,cAAA;EACA,WAAA;EACA,gBAAA;EACA,iCAAA;AnBinDR;AmB9mDQ;EACE,SAAA;AnBgnDV;;AqB7xDA;EACE,cAAA;EACA,WAAA;EACA,mCd2esC;Ec1etC,wBAAA;Ef0KI,mBAAA;EevKJ,gBhBiLmB;EgBhLnB,gBhBqLiB;EgBpLjB,chBDS;EgBET,sBhBTM;EgBUN,4BAAA;EACA,yBAAA;ERAE,sBAAA;ESFE,wEDQJ;ArB2xDF;AsB/xDM;EDdN;ICeQ,gBAAA;EtBkyDN;AACF;AqB7xDE;EACE,6BAAA;EACA,SAAA;ArB+xDJ;AuB/yDE;EACE,cAAA;EACA,sBlBRI;EkBSJ,qBhBsdoC;EgBrdpC,UAAA;EAKE,+ChBqXwB;APw7C9B;AqB/xDE;EACE,chBxBO;EgB0BP,UAAA;ArBgyDJ;AqBxxDE;EAEE,yBhBxCO;EgB0CP,UAAA;ArBwxDJ;;AqBhxDE;;;;EACE,gBAAA;ArBsxDJ;;AqBhxDE;EACE,kBAAA;EACA,0BAAA;ArBmxDJ;AqBhxDE;EAME,chB/DO;EgBgEP,sBhBvEI;ALo1DR;;AqBxwDA;;EAEE,cAAA;EACA,WAAA;ArB2wDF;;AqBjwDA;EACE,iCAAA;EACA,oCAAA;EACA,gBAAA;EfiEE,kBAAA;Ee/DF,gBhB8FiB;ALsqDnB;;AqBjwDA;EACE,gCAAA;EACA,mCAAA;Ef0EI,kBAAA;EexEJ,gBhBwCe;AL4tDjB;;AqBjwDA;EACE,iCAAA;EACA,oCAAA;EfmEI,kBAAA;EejEJ,gBhBkCe;ALkuDjB;;AqB3vDA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EfoDI,mBAAA;EelDJ,gBhBiEiB;EgBhEjB,chBnHS;EgBoHT,6BAAA;EACA,yBAAA;EACA,mBAAA;ArB8vDF;AqB5vDE;EAEE,gBAAA;EACA,eAAA;ArB6vDJ;;AqBjvDA;EACE,oCd6VsC;Ec5VtC,sBAAA;Ef2BI,kBAAA;EezBJ,gBhBNe;EQnIb,qBAAA;Ab83DJ;;AqBjvDA;EACE,kCdsVsC;EcrVtC,qBAAA;EfmBI,kBAAA;EejBJ,gBhBfe;EQlIb,qBAAA;Abs4DJ;;AqB/uDE;EAEE,YAAA;ArBivDJ;;AqB7uDA;EACE,YAAA;ArBgvDF;;AqBxuDA;EACE,mBhByNyB;ALkhD3B;;AqBxuDA;EACE,cAAA;EACA,mBhB0MqB;ALiiDvB;;AqBnuDA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;ArBsuDF;AqBpuDE;;EAEE,kBAAA;EACA,iBAAA;ArBsuDJ;;AqB7tDA;EACE,kBAAA;EACA,cAAA;EACA,qBhB+KwB;ALijD1B;;AqB7tDA;EACE,kBAAA;EACA,kBhB2K0B;EgB1K1B,qBAAA;ArBguDF;AqB7tDE;EAEE,chBzNO;ALu7DX;;AqB1tDA;EACE,gBAAA;ArB6tDF;;AqB1tDA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBhB4J2B;ALikD7B;AqB1tDE;EACE,gBAAA;EACA,aAAA;EACA,uBhBuJ+B;EgBtJ/B,cAAA;ArB4tDJ;;AuBz6DE;EACE,aAAA;EACA,WAAA;EACA,mBlByVmB;ECpOnB,cAAA;EiBnHA,cFqNqC;ArButDzC;;AuBz6DE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EjBwHE,kBAAA;EiBtHF,gBlBqIe;EkBpIf,WAAA;EACA,wCAAA;EV9CA,sBAAA;Ab29DJ;AuBx6DI;EAEE,SAAA;AvBy6DN;;AuBp6DI;;;;EAEE,cAAA;AvBy6DN;;AuBv9DI;EAoDE,qBFkLmC;EE/KjC,+CAAA;EACA,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;AvBq6DR;AuBl6DM;EACE,qBFuKiC;EEtKjC,gDAAA;AvBo6DR;;AuBp+DI;EAyEI,+BAAA;EACA,sCAAA;AvB+5DR;;AuBz+DI;EAmFI,oChB6XgC;EgB5XhC,kFAAA;AvB05DR;;AuB9+DI;EA2FE,qBF2ImC;EExIjC,kDAAA;EACA,sNAAA;AvBq5DR;AuBl5DM;EACE,qBFmIiC;EElIjC,gDAAA;AvBo5DR;;AuB74DM;EACE,cF0HiC;ArBsxDzC;AuB74DM;;;EAEE,cAAA;AvBg5DR;;AuBz4DM;EACE,cF6GiC;ArB+xDzC;AuB14DQ;EACE,qBF0G+B;ArBkyDzC;AuBv4DQ;EACE,qBAAA;EC5JN,yBD6J2B;AvBy4D/B;AuBp4DQ;EACE,gDAAA;AvBs4DV;AuBn4DQ;EACE,qBFyF+B;ArB4yDzC;;AuB53DM;EACE,qBF+EiC;ArBgzDzC;AuB33DQ;EACE,qBF0E+B;EEzE/B,gDAAA;AvB63DV;;AuB9gEE;EACE,aAAA;EACA,WAAA;EACA,mBlByVmB;ECpOnB,cAAA;EiBnHA,cFqNqC;ArB4zDzC;;AuB9gEE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EjBwHE,kBAAA;EiBtHF,gBlBqIe;EkBpIf,WAAA;EACA,wCAAA;EV9CA,sBAAA;AbgkEJ;AuB7gEI;EAEE,SAAA;AvB8gEN;;AuBzgEI;;;;EAEE,cAAA;AvB8gEN;;AuB5jEI;EAoDE,qBFkLmC;EE/KjC,+CAAA;EACA,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;AvB0gER;AuBvgEM;EACE,qBFuKiC;EEtKjC,gDAAA;AvBygER;;AuBzkEI;EAyEI,+BAAA;EACA,sCAAA;AvBogER;;AuB9kEI;EAmFI,oChB6XgC;EgB5XhC,kFAAA;AvB+/DR;;AuBnlEI;EA2FE,qBF2ImC;EExIjC,kDAAA;EACA,sNAAA;AvB0/DR;AuBv/DM;EACE,qBFmIiC;EElIjC,gDAAA;AvBy/DR;;AuBl/DM;EACE,cF0HiC;ArB23DzC;AuBl/DM;;;EAEE,cAAA;AvBq/DR;;AuB9+DM;EACE,cF6GiC;ArBo4DzC;AuB/+DQ;EACE,qBF0G+B;ArBu4DzC;AuB5+DQ;EACE,qBAAA;EC5JN,yBD6J2B;AvB8+D/B;AuBz+DQ;EACE,gDAAA;AvB2+DV;AuBx+DQ;EACE,qBFyF+B;ArBi5DzC;;AuBj+DM;EACE,qBF+EiC;ArBq5DzC;AuBh+DQ;EACE,qBF0E+B;EEzE/B,gDAAA;AvBk+DV;;AqB74DA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;ArBg5DF;AqB34DE;EACE,WAAA;ArB64DJ;AiB5mEI;EIoOA;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,gBAAA;ErB24DJ;EqBv4DE;IACE,aAAA;IACA,cAAA;IACA,mBAAA;IACA,mBAAA;IACA,gBAAA;ErBy4DJ;EqBr4DE;IACE,qBAAA;IACA,WAAA;IACA,sBAAA;ErBu4DJ;EqBn4DE;IACE,qBAAA;ErBq4DJ;EqBl4DE;;IAEE,WAAA;ErBo4DJ;EqB/3DE;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,eAAA;ErBi4DJ;EqB/3DE;IACE,kBAAA;IACA,cAAA;IACA,aAAA;IACA,qBhB8DsB;IgB7DtB,cAAA;ErBi4DJ;EqB93DE;IACE,mBAAA;IACA,uBAAA;ErBg4DJ;EqB93DE;IACE,gBAAA;ErBg4DJ;AACF;;AyBltEA;EACE,qBAAA;EAEA,gBpBqLmB;EoBpLnB,cpBMS;EoBLT,kBAAA;EAGA,sBAAA;EACA,iBAAA;EACA,6BAAA;EACA,6BAAA;ECuFA,wBAAA;EpB4EI,mBAAA;EoB1EJ,gBrByFiB;EQjLf,8BAAA;ESFE,qIGGJ;AzBqtEF;AsBptEM;EGdN;IHeQ,gBAAA;EtButEN;AACF;AQjuEE;EiBUE,cpBNO;EoBOP,qBAAA;AzB0tEJ;AyBvtEE;EAEE,UAAA;EACA,+ClB8W0B;AP02D9B;AyBptEE;EAEE,apB4SmB;ALy6DvB;AyBjtEE;EACE,eAAA;AzBmtEJ;AyBrsEA;;EAEE,oBAAA;AzBusEF;;AyB9rEE;EC3DA,WAAA;EFAE,yBjBsEW;EmBpEb,qBnBoEa;APyrEf;AQzvEE;EkBAE,WAAA;EFNA,yBED2D;EAS3D,qBATqG;A1BqwEzG;A0BzvEE;EAEE,WAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,+CAAA;A1BsvEN;A0BjvEE;EAEE,WAAA;EACA,yBnB0CW;EmBzCX,qBnByCW;APysEf;A0B3uEE;EAGE,WAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A1BqxE7L;A0BtuEI;EAKI,+CAAA;A1BouER;;AyB5tEE;EC3DA,WAAA;EFAE,yBjBsEW;EmBpEb,qBnBoEa;APutEf;AQvxEE;EkBAE,WAAA;EFNA,yBED2D;EAS3D,qBATqG;A1BmyEzG;A0BvxEE;EAEE,WAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,iDAAA;A1BoxEN;A0B/wEE;EAEE,WAAA;EACA,yBnB0CW;EmBzCX,qBnByCW;APuuEf;A0BzwEE;EAGE,WAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A1BmzE7L;A0BpwEI;EAKI,iDAAA;A1BkwER;;AyB1vEE;EC3DA,WAAA;EFAE,yBjBsEW;EmBpEb,qBnBoEa;APqvEf;AQrzEE;EkBAE,WAAA;EFNA,yBED2D;EAS3D,qBATqG;A1Bi0EzG;A0BrzEE;EAEE,WAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,+CAAA;A1BkzEN;A0B7yEE;EAEE,WAAA;EACA,yBnB0CW;EmBzCX,qBnByCW;APqwEf;A0BvyEE;EAGE,WAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A1Bi1E7L;A0BlyEI;EAKI,+CAAA;A1BgyER;;AyBxxEE;EC3DA,WAAA;EFAE,yBjBsEW;EmBpEb,qBnBoEa;APmxEf;AQn1EE;EkBAE,WAAA;EFNA,yBED2D;EAS3D,qBATqG;A1B+1EzG;A0Bn1EE;EAEE,WAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,gDAAA;A1Bg1EN;A0B30EE;EAEE,WAAA;EACA,yBnB0CW;EmBzCX,qBnByCW;APmyEf;A0Br0EE;EAGE,WAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A1B+2E7L;A0Bh0EI;EAKI,gDAAA;A1B8zER;;AyBtzEE;EC3DA,cAAA;EFAE,yBjBsEW;EmBpEb,qBnBoEa;APizEf;AQj3EE;EkBAE,cAAA;EFNA,yBED2D;EAS3D,qBATqG;A1B63EzG;A0Bj3EE;EAEE,cAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,gDAAA;A1B82EN;A0Bz2EE;EAEE,cAAA;EACA,yBnB0CW;EmBzCX,qBnByCW;APi0Ef;A0Bn2EE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A1B64E7L;A0B91EI;EAKI,gDAAA;A1B41ER;;AyBp1EE;EC3DA,WAAA;EFAE,yBjBsEW;EmBpEb,qBnBoEa;AP+0Ef;AQ/4EE;EkBAE,WAAA;EFNA,yBED2D;EAS3D,qBATqG;A1B25EzG;A0B/4EE;EAEE,WAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,+CAAA;A1B44EN;A0Bv4EE;EAEE,WAAA;EACA,yBnB0CW;EmBzCX,qBnByCW;AP+1Ef;A0Bj4EE;EAGE,WAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A1B26E7L;A0B53EI;EAKI,+CAAA;A1B03ER;;AyBl3EE;EC3DA,cAAA;EFAE,yBjBsEW;EmBpEb,qBnBoEa;AP62Ef;AQ76EE;EkBAE,cAAA;EFNA,yBED2D;EAS3D,qBATqG;A1By7EzG;A0B76EE;EAEE,cAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,iDAAA;A1B06EN;A0Br6EE;EAEE,cAAA;EACA,yBnB0CW;EmBzCX,qBnByCW;AP63Ef;A0B/5EE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A1By8E7L;A0B15EI;EAKI,iDAAA;A1Bw5ER;;AyBh5EE;EC3DA,WAAA;EFAE,yBjBsEW;EmBpEb,qBnBoEa;AP24Ef;AQ38EE;EkBAE,WAAA;EFNA,yBED2D;EAS3D,qBATqG;A1Bu9EzG;A0B38EE;EAEE,WAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,8CAAA;A1Bw8EN;A0Bn8EE;EAEE,WAAA;EACA,yBnB0CW;EmBzCX,qBnByCW;AP25Ef;A0B77EE;EAGE,WAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A1Bu+E7L;A0Bx7EI;EAKI,8CAAA;A1Bs7ER;;AyBx6EE;ECPA,cnBYa;EmBXb,qBnBWa;APw6Ef;AQx+EE;EkBwDE,WALgD;EAMhD,yBnBOW;EmBNX,qBnBMW;AP66Ef;A0Bh7EE;EAEE,8CAAA;A1Bi7EJ;A0B96EE;EAEE,cnBJW;EmBKX,6BAAA;A1B+6EJ;A0B56EE;EAGE,WAAA;EACA,yBnBZW;EmBaX,qBnBbW;APy7Ef;A0B16EI;EAKI,8CAAA;A1Bw6ER;;AyBj8EE;ECPA,cnBYa;EmBXb,qBnBWa;APi8Ef;AQjgFE;EkBwDE,WALgD;EAMhD,yBnBOW;EmBNX,qBnBMW;APs8Ef;A0Bz8EE;EAEE,iDAAA;A1B08EJ;A0Bv8EE;EAEE,cnBJW;EmBKX,6BAAA;A1Bw8EJ;A0Br8EE;EAGE,WAAA;EACA,yBnBZW;EmBaX,qBnBbW;APk9Ef;A0Bn8EI;EAKI,iDAAA;A1Bi8ER;;AyB19EE;ECPA,cnBYa;EmBXb,qBnBWa;AP09Ef;AQ1hFE;EkBwDE,WALgD;EAMhD,yBnBOW;EmBNX,qBnBMW;AP+9Ef;A0Bl+EE;EAEE,+CAAA;A1Bm+EJ;A0Bh+EE;EAEE,cnBJW;EmBKX,6BAAA;A1Bi+EJ;A0B99EE;EAGE,WAAA;EACA,yBnBZW;EmBaX,qBnBbW;AP2+Ef;A0B59EI;EAKI,+CAAA;A1B09ER;;AyBn/EE;ECPA,cnBYa;EmBXb,qBnBWa;APm/Ef;AQnjFE;EkBwDE,WALgD;EAMhD,yBnBOW;EmBNX,qBnBMW;APw/Ef;A0B3/EE;EAEE,gDAAA;A1B4/EJ;A0Bz/EE;EAEE,cnBJW;EmBKX,6BAAA;A1B0/EJ;A0Bv/EE;EAGE,WAAA;EACA,yBnBZW;EmBaX,qBnBbW;APogFf;A0Br/EI;EAKI,gDAAA;A1Bm/ER;;AyB5gFE;ECPA,cnBYa;EmBXb,qBnBWa;AP4gFf;AQ5kFE;EkBwDE,cALgD;EAMhD,yBnBOW;EmBNX,qBnBMW;APihFf;A0BphFE;EAEE,+CAAA;A1BqhFJ;A0BlhFE;EAEE,cnBJW;EmBKX,6BAAA;A1BmhFJ;A0BhhFE;EAGE,cAAA;EACA,yBnBZW;EmBaX,qBnBbW;AP6hFf;A0B9gFI;EAKI,+CAAA;A1B4gFR;;AyBriFE;ECPA,cnBYa;EmBXb,qBnBWa;APqiFf;AQrmFE;EkBwDE,WALgD;EAMhD,yBnBOW;EmBNX,qBnBMW;AP0iFf;A0B7iFE;EAEE,+CAAA;A1B8iFJ;A0B3iFE;EAEE,cnBJW;EmBKX,6BAAA;A1B4iFJ;A0BziFE;EAGE,WAAA;EACA,yBnBZW;EmBaX,qBnBbW;APsjFf;A0BviFI;EAKI,+CAAA;A1BqiFR;;AyB9jFE;ECPA,cnBYa;EmBXb,qBnBWa;AP8jFf;AQ9nFE;EkBwDE,cALgD;EAMhD,yBnBOW;EmBNX,qBnBMW;APmkFf;A0BtkFE;EAEE,iDAAA;A1BukFJ;A0BpkFE;EAEE,cnBJW;EmBKX,6BAAA;A1BqkFJ;A0BlkFE;EAGE,cAAA;EACA,yBnBZW;EmBaX,qBnBbW;AP+kFf;A0BhkFI;EAKI,iDAAA;A1B8jFR;;AyBvlFE;ECPA,cnBYa;EmBXb,qBnBWa;APulFf;AQvpFE;EkBwDE,WALgD;EAMhD,yBnBOW;EmBNX,qBnBMW;AP4lFf;A0B/lFE;EAEE,8CAAA;A1BgmFJ;A0B7lFE;EAEE,cnBJW;EmBKX,6BAAA;A1B8lFJ;A0B3lFE;EAGE,WAAA;EACA,yBnBZW;EmBaX,qBnBbW;APwmFf;A0BzlFI;EAKI,8CAAA;A1BulFR;;AyBrmFA;EACE,gBpB2GmB;EoB1GnB,clB2FwC;EkB1FxC,qBpBwBgB;ALglFlB;AQjrFE;EiB4EE,clByFsC;EkBxFtC,0BpBqBoB;ALmlFxB;AyBrmFE;EAEE,0BpBgBoB;ALslFxB;AyBnmFE;EAEE,cpBtFO;EoBuFP,oBAAA;AzBomFJ;;AyBzlFA;ECPE,qBAAA;EpB4EI,kBAAA;EoB1EJ,gBrB0Ce;EQlIb,qBAAA;Ab6rFJ;;AyB5lFA;ECXE,sBAAA;EpB4EI,kBAAA;EoB1EJ,gBrB2Ce;EQnIb,qBAAA;AbosFJ;;AyB1lFA;EACE,cAAA;EACA,WAAA;AzB6lFF;AyB1lFE;EACE,kBpBkNkB;AL04EtB;;AyBplFE;;;EACE,WAAA;AzBylFJ;;A2BpuFA;ELgBM,gCKfJ;A3BuuFF;AsBptFM;EKpBN;ILqBQ,gBAAA;EtButFN;AACF;A2B1uFE;EACE,UAAA;A3B4uFJ;;A2BvuFE;EACE,aAAA;A3B0uFJ;;A2BtuFA;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;ELDI,6BKEJ;A3ByuFF;AsBvuFM;EKNN;ILOQ,gBAAA;EtB0uFN;AACF;A2B5uFE;EACE,QAAA;EACA,YAAA;ELNE,4BKOF;A3B8uFJ;AsBjvFM;EKAJ;ILCM,gBAAA;EtBovFN;AACF;;A4BzwFA;;;;EAIE,kBAAA;A5B4wFF;;A4BzwFA;EACE,mBAAA;A5B4wFF;A6BxvFI;EACE,qBAAA;EACA,oBxByIU;EwBxIV,uBxBuIiB;EwBtIjB,WAAA;EAhCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;A7B2xFF;A6BtuFI;EACE,cAAA;A7BwuFN;;A4BlxFA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,avB+egB;EuB9ehB,aAAA;EACA,WAAA;EACA,gBvB4iBmB;EuB3iBnB,iBAAA;EACA,oBAAA;EtB2JI,eAAA;EsBzJJ,cvBXS;EuBYT,gBAAA;EACA,gBAAA;EACA,sBvBvBM;EuBwBN,4BAAA;EACA,qCAAA;EfdE,sBAAA;AboyFJ;;A4B7wFI;EACE,WAAA;EACA,OAAA;A5BgxFN;;A4B7wFI;EACE,QAAA;EACA,UAAA;A5BgxFN;;AiBpwFI;EWnBA;IACE,WAAA;IACA,OAAA;E5B2xFJ;E4BxxFE;IACE,QAAA;IACA,UAAA;E5B0xFJ;AACF;AiB/wFI;EWnBA;IACE,WAAA;IACA,OAAA;E5BqyFJ;E4BlyFE;IACE,QAAA;IACA,UAAA;E5BoyFJ;AACF;AiBzxFI;EWnBA;IACE,WAAA;IACA,OAAA;E5B+yFJ;E4B5yFE;IACE,QAAA;IACA,UAAA;E5B8yFJ;AACF;AiBnyFI;EWnBA;IACE,WAAA;IACA,OAAA;E5ByzFJ;E4BtzFE;IACE,QAAA;IACA,UAAA;E5BwzFJ;AACF;A4BjzFE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,uBvBygBc;AL0yElB;A6Bl1FI;EACE,qBAAA;EACA,oBxByIU;EwBxIV,uBxBuIiB;EwBtIjB,WAAA;EAzBJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;A7B82FF;A6Bh0FI;EACE,cAAA;A7Bk0FN;;A4BvzFE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,qBvB2fc;AL+zElB;A6Bv2FI;EACE,qBAAA;EACA,oBxByIU;EwBxIV,uBxBuIiB;EwBtIjB,WAAA;EAlBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;A7B43FF;A6Br1FI;EACE,cAAA;A7Bu1FN;A4Bl0FI;EACE,iBAAA;A5Bo0FN;;A4B9zFE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sBvB0ec;ALu1ElB;A6B/3FI;EACE,qBAAA;EACA,oBxByIU;EwBxIV,uBxBuIiB;EwBtIjB,WAAA;A7Bi4FN;A6Bt3FM;EACE,aAAA;A7Bw3FR;A6Br3FM;EACE,qBAAA;EACA,qBxBsHQ;EwBrHR,uBxBoHe;EwBnHf,WAAA;EA9BN,mCAAA;EACA,yBAAA;EACA,sCAAA;A7Bs5FF;A6Br3FI;EACE,cAAA;A7Bu3FN;A4Bj1FI;EACE,iBAAA;A5Bm1FN;;A4B30FE;EAIE,WAAA;EACA,YAAA;A5B20FJ;;A4Bt0FA;EE9GE,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;A9Bw7FF;;A4Bt0FA;EACE,cAAA;EACA,WAAA;EACA,uBAAA;EACA,WAAA;EACA,gBvB+DmB;EuB9DnB,cvBhHS;EuBiHT,mBAAA;EAEA,mBAAA;EACA,6BAAA;EACA,SAAA;A5Bw0FF;AQ77FE;EoBoIE,cvB6bwB;EuB5bxB,qBAAA;EJ/IA,yBnBEO;AL08FX;A4BzzFE;EAEE,WvBpJI;EuBqJJ,qBAAA;EJtJA,yBjBoP0B;AP6tF9B;A4BvzFE;EAEE,cvBrJO;EuBsJP,oBAAA;EACA,6BAAA;A5BwzFJ;;A4BhzFA;EACE,cAAA;A5BmzFF;;A4B/yFA;EACE,cAAA;EACA,sBvBuawB;EuBtaxB,gBAAA;EtBAI,kBAAA;EsBEJ,cvBzKS;EuB0KT,mBAAA;A5BkzFF;;A4B9yFA;EACE,cAAA;EACA,uBAAA;EACA,cvB9KS;AL+9FX;;A+B5+FA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;A/B++FF;A+B7+FE;;EACE,kBAAA;EACA,cAAA;A/Bg/FJ;AQ/+FE;;EuBII,UAAA;A/B++FN;A+B7+FI;;;;EAGE,UAAA;A/Bg/FN;;A+B1+FA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;A/B6+FF;A+B3+FE;EACE,WAAA;A/B6+FJ;;A+Bv+FE;;EAEE,iBAAA;A/B0+FJ;A+Bt+FE;;ElBXE,0BAAA;EACA,6BAAA;Abq/FJ;A+Bt+FE;;ElBFE,yBAAA;EACA,4BAAA;Ab4+FJ;;A+Bz9FA;EACE,uBAAA;EACA,sBAAA;A/B49FF;A+B19FE;EAGE,cAAA;A/B09FJ;A+Bv9FE;EACE,eAAA;A/By9FJ;;A+Br9FA;EACE,qBAAA;EACA,oBAAA;A/Bw9FF;;A+Br9FA;EACE,sBAAA;EACA,qBAAA;A/Bw9FF;;A+Bp8FA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;A/Bu8FF;A+Br8FE;;EAEE,WAAA;A/Bu8FJ;A+Bp8FE;;EAEE,gBAAA;A/Bs8FJ;A+Bl8FE;;ElBrFE,6BAAA;EACA,4BAAA;Ab2hGJ;A+Bl8FE;;ElBxGE,yBAAA;EACA,0BAAA;Ab8iGJ;;A+Bn7FE;;EAEE,gBAAA;A/Bs7FJ;A+Bp7FI;;;;EAEE,kBAAA;EACA,sBAAA;EACA,oBAAA;A/Bw7FN;;AgCjlGA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;AhColGF;AgCllGE;;;;EAIE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;AhColGJ;AgCllGI;;;;;;;;;;;;EAGE,iBAAA;AhC6lGN;AgCxlGE;;;EAGE,UAAA;AhC0lGJ;AgCtlGE;EACE,UAAA;AhCwlGJ;AgCnlGI;;EnBIA,yBAAA;EACA,4BAAA;AbmlGJ;AgCnlGE;EACE,aAAA;EACA,mBAAA;AhCqlGJ;AgCnlGI;EnBnBA,0BAAA;EACA,6BAAA;AbymGJ;AgCrlGI;EnBPA,yBAAA;EACA,4BAAA;Ab+lGJ;AgCrlGI;;;;EnBzBA,0BAAA;EACA,6BAAA;AbonGJ;AgCnlGI;;;;EnBlCA,0BAAA;EACA,6BAAA;Ab2nGJ;;AgC1kGA;;EAEE,aAAA;AhC6kGF;AgCxkGE;;EACE,kBAAA;EACA,UAAA;AhC2kGJ;AgCzkGI;;EACE,UAAA;AhC4kGN;AgCxkGE;;;;;;;;EAIE,iBAAA;AhC8kGJ;;AgC1kGA;EAAuB,kBAAA;AhC8kGvB;;AgC7kGA;EAAsB,iBAAA;AhCilGtB;;AgCzkGA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,gBAAA;E1B2DI,mBAAA;E0BzDJ,gB3BmEmB;E2BlEnB,gB3BuEiB;E2BtEjB,c3B/GS;E2BgHT,kBAAA;EACA,mBAAA;EACA,yB3BvHS;E2BwHT,yBAAA;EnB/GE,sBAAA;Ab4rGJ;AgCzkGE;;EAEE,aAAA;AhC2kGJ;;AgCjkGA;;EAEE,kCzBmWsC;APiuFxC;;AgCjkGA;;;;;;EAME,qBAAA;E1BwBI,kBAAA;E0BtBJ,gB3BVe;EQlIb,qBAAA;AbitGJ;;AgCjkGA;;EAEE,oCzBiVsC;APmvFxC;;AgCjkGA;;;;;;EAME,sBAAA;E1BOI,kBAAA;E0BLJ,gB3B1Be;EQnIb,qBAAA;AbkuGJ;;AgCjkGA;;EAEE,qBAAA;AhCokGF;;AgCzjGA;;;;;;;;EnB9JI,0BAAA;EACA,6BAAA;AbkuGJ;;AgC1jGA;;;;;;EnB3JI,yBAAA;EACA,4BAAA;Ab8tGJ;;AiCtwGA;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,yBAAA;AjCywGF;;AiCtwGA;EACE,oBAAA;EACA,kB5BuYwB;ALk4F1B;;AiCtwGA;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,W5BmY8B;E4BlY9B,eAAA;EACA,UAAA;AjCywGF;AiCvwGE;EACE,W5BzBI;E4B0BJ,qB1ByN0B;EiBpP1B,yBjBoP0B;APijG9B;AiCrwGE;EAKI,+C1BgWwB;APm6F9B;AiC/vGE;EACE,qB1BsboC;AP20FxC;AiC9vGE;EACE,W5B7CI;E4B8CJ,yB1Bkf4C;E0Bjf5C,qB1Bif4C;AP+wFhD;AiCzvGI;EACE,c5BjDK;AL4yGX;AiCzvGM;EACE,yB5BxDG;ALmzGX;;AiCjvGA;EACE,kBAAA;EACA,gBAAA;EAEA,mBAAA;AjCmvGF;AiC/uGE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,W5BsU4B;E4BrU5B,Y5BqU4B;E4BpU5B,oBAAA;EACA,WAAA;EACA,sB5BrFI;E4BsFJ,yBAAA;AjCivGJ;AiC5uGE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,W5BuT4B;E4BtT5B,Y5BsT4B;E4BrT5B,WAAA;EACA,iCAAA;AjC8uGJ;;AiCpuGE;EpBlGE,sBAAA;Ab00GJ;AiCnuGI;EACE,yDAAA;AjCquGN;AiChuGI;EACE,qB1B0HwB;EiBpP1B,yBjBoP0B;APymG9B;AiC/tGI;EACE,yDAAA;AjCiuGN;AiC5tGI;ETpIA,uCjByhB4C;AP00FhD;AiC5tGI;ETvIA,uCjByhB4C;AP60FhD;;AiCptGE;EAEE,kB5B8RmC;ALw7FvC;AiCltGI;EACE,yDAAA;AjCotGN;AiC/sGI;ET9JA,uCjByhB4C;APu1FhD;;AiCvsGA;EACE,qBAAA;AjC0sGF;AiCvsGI;EACE,cAAA;EACA,c5BsQgB;E4BrQhB,mBAAA;EAEA,qB5BoQkC;ALo8FxC;AiCrsGI;EACE,wBAAA;EACA,0BAAA;EACA,uB1B2X0C;E0B1X1C,wB1B0X0C;E0BzX1C,yB5BpLK;E4BsLL,qB5B0PkC;EiB5alC,yIWmLA;AjCssGN;AsBr3GM;EWuKF;IXtKI,gBAAA;EtBw3GN;AACF;AiCtsGI;EACE,sB5BlME;E4BmMF,8BAAA;AjCwsGN;AiCnsGI;ETzMA,uCjByhB4C;APs3FhD;;AiCzrGA;EACE,qBAAA;EACA,WAAA;EACA,mC1BqRsC;E0BpRtC,wCAAA;E3B5CI,mBAAA;E2B+CJ,gB5BrCmB;E4BsCnB,gB5BjCiB;E4BkCjB,c5BvNS;E4BwNT,sBAAA;EACA,+FAAA;EACA,yBAAA;EpBtNE,sBAAA;EoByNF,gBAAA;AjC0rGF;AiCxrGE;EACE,qB1BwPoC;E0BvPpC,UAAA;EAKE,+C1BmW8B;APm1FpC;AiCnrGI;EAME,c5B/OK;E4BgPL,sB5BvPE;ALu6GR;AiC5qGE;EAEE,YAAA;EACA,qB5B4BkB;E4B3BlB,sBAAA;AjC6qGJ;AiC1qGE;EACE,c5B7PO;E4B8PP,yB5BlQO;AL86GX;AiCxqGE;EACE,aAAA;AjC0qGJ;AiCtqGE;EACE,kBAAA;EACA,0BAAA;AjCwqGJ;;AiCpqGA;EACE,oC1B0NsC;E0BzNtC,qB5BYuB;E4BXvB,wB5BWuB;E4BVvB,kB5BWuB;ECrHnB,kBAAA;ANkxGN;;AiCpqGA;EACE,kC1BmNsC;E0BlNtC,oB5BSuB;E4BRvB,uB5BQuB;E4BPvB,kB5BQuB;EC1HnB,kBAAA;AN0xGN;;AiC/pGA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,mC1BiMsC;E0BhMtC,gBAAA;AjCkqGF;;AiC/pGA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,mC1ByLsC;E0BxLtC,SAAA;EACA,gBAAA;EACA,UAAA;AjCkqGF;AiChqGE;EACE,qB1BqKoC;E0BpKpC,+C1ByE0B;APylG9B;AiC9pGE;EAEE,yB5B/TO;AL89GX;AiC3pGI;EACE,iB5B+Ka;AL8+FnB;AiCzpGE;EACE,0BAAA;AjC2pGJ;;AiCvpGA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,mC1BwJsC;E0BvJtC,wBAAA;EACA,gBAAA;EAEA,gB5BlKmB;E4BmKnB,gB5B9JiB;E4B+JjB,c5BpVS;E4BqVT,sB5B5VM;E4B6VN,yBAAA;EpBlVE,sBAAA;Ab4+GJ;AiCtpGE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,6B1BiIoC;E0BhIpC,wBAAA;EACA,gB5B9Ke;E4B+Kf,c5BpWO;E4BqWP,iBAAA;ET7WA,yBnBGO;E4B4WP,oBAAA;EpBnWA,kCAAA;Ab4/GJ;;AiC9oGA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,6BAAA;EACA,gBAAA;AjCipGF;AiC/oGE;EACE,UAAA;AjCipGJ;AiC7oGI;EAA0B,+D1BoOe;AP46F7C;AiC/oGI;EAA0B,+D1BmOe;AP+6F7C;AiCjpGI;EAA0B,+D1BkOe;APk7F7C;AiCjpGE;EACE,SAAA;AjCmpGJ;AiChpGE;EACE,W5B+EuB;E4B9EvB,Y5B8EuB;E4B7EvB,oBAAA;ETlZA,yBjBoP0B;E0BgK1B,S5B6EwB;EQrdxB,mBAAA;ESFE,4GW6YF;EACA,gBAAA;AjCipGJ;AsB3hHM;EWiYJ;IXhYM,gBAAA;EtB8hHN;AACF;AiCppGI;ET1ZA,yBjB4mByC;APq8F7C;AiClpGE;EACE,W5BwDuB;E4BvDvB,c5BwDwB;E4BvDxB,kBAAA;EACA,e5BuDwB;E4BtDxB,yB5BhaO;E4BiaP,yBAAA;EpBzZA,mBAAA;Ab8iHJ;AiChpGE;EACE,W5BoDuB;E4BnDvB,Y5BmDuB;EmB/dvB,yBjBoP0B;E0B0L1B,S5BmDwB;EQrdxB,mBAAA;ESFE,4GWuaF;EACA,gBAAA;AjCipGJ;AsBrjHM;EW4ZJ;IX3ZM,gBAAA;EtBwjHN;AACF;AiCppGI;ETpbA,yBjB4mByC;AP+9F7C;AiClpGE;EACE,W5B8BuB;E4B7BvB,c5B8BwB;E4B7BxB,kBAAA;EACA,e5B6BwB;E4B5BxB,yB5B1bO;E4B2bP,yBAAA;EpBnbA,mBAAA;AbwkHJ;AiChpGE;EACE,W5B0BuB;E4BzBvB,Y5ByBuB;E4BxBvB,aAAA;EACA,oB5BxKoB;E4ByKpB,mB5BzKoB;EmBhSpB,yBjBoP0B;E0BuN1B,S5BsBwB;EQrdxB,mBAAA;ESFE,4GWocF;EACA,gBAAA;AjCipGJ;AsBllHM;EWsbJ;IXrbM,gBAAA;EtBqlHN;AACF;AiCppGI;ETjdA,yBjB4mByC;AP4/F7C;AiClpGE;EACE,W5BCuB;E4BAvB,c5BCwB;E4BAxB,kBAAA;EACA,eAAA;EACA,6BAAA;EACA,yBAAA;EACA,oBAAA;AjCopGJ;AiChpGE;EACE,yB5B9dO;EQQP,mBAAA;AbymHJ;AiC/oGE;EACE,kBAAA;EACA,yB5BpeO;EQQP,mBAAA;Ab8mHJ;AiC7oGI;EACE,yB5BxeK;ALunHX;AiC5oGI;EACE,eAAA;AjC8oGN;AiC3oGI;EACE,yB5BhfK;AL6nHX;AiC1oGI;EACE,eAAA;AjC4oGN;AiCzoGI;EACE,yB5BxfK;ALmoHX;;AiCtoGA;;;EXzfM,4GW4fJ;AjCyoGF;AsBjoHM;EWqfN;;;IXpfQ,gBAAA;EtBsoHN;AACF;;AkCvpHA;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AlC0pHF;;AkCvpHA;EACE,cAAA;EACA,oBAAA;AlC0pHF;AQzpHE;E0BGE,qBAAA;AlCypHJ;AkCrpHE;EACE,c7BXO;E6BYP,oBAAA;EACA,eAAA;AlCupHJ;;AkC/oHA;EACE,gCAAA;AlCkpHF;AkChpHE;EACE,mBAAA;EACA,6BAAA;EACA,6BAAA;ErBbA,+BAAA;EACA,gCAAA;AbgqHJ;AQ5qHE;E0B6BI,kBAAA;EACA,qC7Boe6B;AL8qGnC;AkC/oHI;EACE,c7BrCK;E6BsCL,6BAAA;EACA,yBAAA;AlCipHN;AkC7oHE;;EAEE,c7B5CO;E6B6CP,sB7BpDI;E6BqDJ,kC7BydgC;ALsrGpC;AkC5oHE;EAEE,gBAAA;ErBtCA,yBAAA;EACA,0BAAA;AborHJ;;AkCnoHE;EACE,gBAAA;EACA,SAAA;ErB7DA,sBAAA;AbosHJ;AkCnoHE;;EAEE,W7B9EI;E6B+EJ,yB3BoK0B;APi+G9B;;AkC3nHE;;EAEE,cAAA;EACA,kBAAA;AlC8nHJ;;AkCznHE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;AlC4nHJ;;AkClnHE;EACE,aAAA;AlCqnHJ;AkCnnHE;EACE,cAAA;AlCqnHJ;;AmC9tHA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;AnCiuHF;AmC7tHE;;;;;;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;AnCouHJ;AmChtHA;EACE,qBAAA;EACA,sB9B+euB;E8B9evB,yB9B8euB;E8B7evB,kB9BiCO;EC4FH,kBAAA;E6B3HJ,oBAAA;EACA,mBAAA;AnCktHF;AQ5vHE;E2B6CE,qBAAA;AnCktHJ;;AmCzsHA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AnC4sHF;AmC1sHE;EACE,gBAAA;EACA,eAAA;AnC4sHJ;AmCzsHE;EACE,gBAAA;EACA,WAAA;AnC2sHJ;;AmClsHA;EACE,qBAAA;EACA,mB9B6amB;E8B5anB,sB9B4amB;ALyxGrB;;AmCzrHA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AnC0rHF;;AmCtrHA;EACE,wBAAA;E7B8DI,kBAAA;E6B5DJ,cAAA;EACA,6BAAA;EACA,6BAAA;EtBxGE,8BAAA;AbkyHJ;AQpyHE;E2B8GE,qBAAA;AnCyrHJ;;AmCnrHA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mCAAA;AnCsrHF;;AmCnrHA;EACE,gB5BglBkC;E4B/kBlC,gBAAA;AnCsrHF;;AiB5vHI;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;EnCmrHR;AACF;AiBrxHI;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;EnCwqHN;EmCtqHM;IACE,mBAAA;EnCwqHR;EmCtqHQ;IACE,kBAAA;EnCwqHV;EmCrqHQ;IACE,qB9BuWgB;I8BtWhB,oB9BsWgB;ELi0G1B;EmClqHM;;;;;;IACE,iBAAA;EnCyqHR;EmC3pHM;IACE,iBAAA;EnC6pHR;EmC1pHM;IACE,wBAAA;IAGA,gBAAA;EnC0pHR;EmCvpHM;IACE,aAAA;EnCypHR;AACF;AiB1yHI;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;EnCguHR;AACF;AiBl0HI;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;EnCqtHN;EmCntHM;IACE,mBAAA;EnCqtHR;EmCntHQ;IACE,kBAAA;EnCqtHV;EmCltHQ;IACE,qB9BuWgB;I8BtWhB,oB9BsWgB;EL82G1B;EmC/sHM;;;;;;IACE,iBAAA;EnCstHR;EmCxsHM;IACE,iBAAA;EnC0sHR;EmCvsHM;IACE,wBAAA;IAGA,gBAAA;EnCusHR;EmCpsHM;IACE,aAAA;EnCssHR;AACF;AiBv1HI;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;EnC6wHR;AACF;AiB/2HI;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;EnCkwHN;EmChwHM;IACE,mBAAA;EnCkwHR;EmChwHQ;IACE,kBAAA;EnCkwHV;EmC/vHQ;IACE,qB9BuWgB;I8BtWhB,oB9BsWgB;EL25G1B;EmC5vHM;;;;;;IACE,iBAAA;EnCmwHR;EmCrvHM;IACE,iBAAA;EnCuvHR;EmCpvHM;IACE,wBAAA;IAGA,gBAAA;EnCovHR;EmCjvHM;IACE,aAAA;EnCmvHR;AACF;AiBp4HI;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;EnC0zHR;AACF;AiB55HI;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;EnC+yHN;EmC7yHM;IACE,mBAAA;EnC+yHR;EmC7yHQ;IACE,kBAAA;EnC+yHV;EmC5yHQ;IACE,qB9BuWgB;I8BtWhB,oB9BsWgB;ELw8G1B;EmCzyHM;;;;;;IACE,iBAAA;EnCgzHR;EmClyHM;IACE,iBAAA;EnCoyHR;EmCjyHM;IACE,wBAAA;IAGA,gBAAA;EnCiyHR;EmC9xHM;IACE,aAAA;EnCgyHR;AACF;AmCj2HI;EAoBI,qBAAA;EACA,2BAAA;AnCg1HR;AmCn2HQ;;;;;;EACE,gBAAA;EACA,eAAA;AnC02HV;AmCv1HQ;EACE,mBAAA;AnCy1HV;AmCv1HU;EACE,kBAAA;AnCy1HZ;AmCt1HU;EACE,qB9BuWgB;E8BtWhB,oB9BsWgB;ALk/G5B;AmCn1HQ;;;;;;EACE,iBAAA;AnC01HV;AmC50HQ;EACE,iBAAA;AnC80HV;AmC30HQ;EACE,wBAAA;EAGA,gBAAA;AnC20HV;AmCx0HQ;EACE,aAAA;AnC00HV;;AmC5zHE;EACE,yB9B4UwB;ALm/G5B;AQvhIE;E2B2NI,yB9ByUsB;ALs/G5B;AmC1zHI;EACE,yB9BiUe;AL2/GrB;AQ7hIE;E2BoOM,yB9B+TmB;AL6/G3B;AmCzzHM;EACE,yB9B6TsB;AL8/G9B;AmCvzHI;;;;EAIE,yB9BoTsB;ALqgH5B;AmCrzHE;EACE,yB9B6SiB;E8B5SjB,gC9BiTgC;ALsgHpC;AmCpzHE;EACE,yDAAA;AnCszHJ;AmCnzHE;EACE,yB9BoSiB;ALihHrB;AmCpzHI;EACE,yB9BoSsB;ALkhH5B;AQtjIE;E2BmQM,yB9BiSoB;ALqhH5B;;AmC9yHE;EACE,W9BrRI;ALskIR;AQ7jIE;E2B+QI,W9BxRE;ALykIR;AmC5yHI;EACE,+B9BsQc;ALwiHpB;AQnkIE;E2BwRM,gC9BoQkB;AL0iH1B;AmC3yHM;EACE,gC9BkQqB;AL2iH7B;AmCzyHI;;;;EAIE,W9B7SE;ALwlIR;AmCvyHE;EACE,+B9BkPgB;E8BjPhB,sC9BsP+B;ALmjHnC;AmCtyHE;EACE,yDAAA;AnCwyHJ;AmCryHE;EACE,+B9ByOgB;AL8jHpB;AmCtyHI;EACE,W9B7TE;ALqmIR;AQ5lIE;E2BuTM,W9BhUA;ALwmIR;;AoC3mIA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EAEA,qBAAA;EACA,sB/BJM;E+BKN,2BAAA;EACA,sCAAA;EvBKE,sBAAA;AbymIJ;AoC3mIE;EACE,eAAA;EACA,cAAA;ApC6mIJ;AoC1mIE;EACE,mBAAA;EACA,sBAAA;ApC4mIJ;AoC1mII;EACE,mBAAA;EvBCF,2CAAA;EACA,4CAAA;Ab4mIJ;AoC1mII;EACE,sBAAA;EvBUF,+CAAA;EACA,8CAAA;AbmmIJ;AoCvmIE;;EAEE,aAAA;ApCymIJ;;AoCrmIA;EAGE,cAAA;EAGA,eAAA;EACA,gB/BmjBc;ALijHhB;;AoChmIA;EACE,sB/B6iBc;ALsjHhB;;AoChmIA;EACE,qBAAA;EACA,gBAAA;ApCmmIF;;AoChmIA;EACE,gBAAA;ApCmmIF;;AQxpIE;E4B0DE,qBAAA;ApCkmIJ;AoC/lIE;EACE,oB/B4hBY;ALqkHhB;;AoCzlIA;EACE,wBAAA;EACA,gBAAA;EAEA,qC/BmhBY;E+BlhBZ,6CAAA;ApC2lIF;AoCzlIE;EvBvEE,0DAAA;AbmqIJ;;AoCvlIA;EACE,wBAAA;EAEA,qC/BwgBY;E+BvgBZ,0CAAA;ApCylIF;AoCvlIE;EvBlFE,0DAAA;Ab4qIJ;;AoChlIA;EACE,uBAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;ApCmlIF;;AoChlIA;EACE,uBAAA;EACA,sBAAA;ApCmlIF;;AoC/kIA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,gB/B8eyB;EQ7lBvB,kCAAA;AbksIJ;;AoC/kIA;;;EAGE,cAAA;EACA,WAAA;ApCklIF;;AoC/kIA;;EvBjHI,2CAAA;EACA,4CAAA;AbqsIJ;;AoChlIA;;EvBxGI,+CAAA;EACA,8CAAA;Ab6rIJ;;AoC7kIE;EACE,mB/BsdgB;AL0nHpB;AiB/qII;EmB6FJ;IAMI,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,kBAAA;EpCglIF;EoC9kIE;IAEE,YAAA;IACA,kB/B0cc;I+Bzcd,gBAAA;IACA,iB/Bwcc;ELuoHlB;AACF;;AoCnkIE;EACE,mB/B0bgB;AL4oHpB;AiBjsII;EmBuHJ;IAQI,aAAA;IACA,mBAAA;EpCskIF;EoCnkIE;IAEE,YAAA;IACA,gBAAA;EpCokIJ;EoClkII;IACE,cAAA;IACA,cAAA;EpCokIN;EoC/jIM;IvBzKJ,0BAAA;IACA,6BAAA;Eb2uIF;EoChkIQ;;IAGE,0BAAA;EpCikIV;EoC/jIQ;;IAGE,6BAAA;EpCgkIV;EoC5jIM;IvB1KJ,yBAAA;IACA,4BAAA;EbyuIF;EoC7jIQ;;IAGE,yBAAA;EpC8jIV;EoC5jIQ;;IAGE,4BAAA;EpC6jIV;AACF;;AoChjIE;EACE,sB/BiXY;ALksHhB;AiB3uII;EmBsLJ;IAMI,e/B4XiB;I+B3XjB,mB/B4Xe;I+B3Xf,UAAA;IACA,SAAA;EpCmjIF;EoCjjIE;IACE,qBAAA;IACA,WAAA;EpCmjIJ;AACF;;AoC1iIA;EACE,qBAAA;ApC6iIF;AoC3iIE;EACE,gBAAA;ApC6iIJ;AoC3iII;EACE,gBAAA;EvBvOF,6BAAA;EACA,4BAAA;AbqxIJ;AoC3iII;EvBzPA,yBAAA;EACA,0BAAA;AbuyIJ;AoC3iII;EvBtQA,gBAAA;EuBwQE,mBAAA;ApC6iIN;;AqCv0IA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,mBhCi0ByB;EgC/zBzB,gBAAA;EACA,yBhCES;EQSP,sBAAA;Ab+zIJ;;AqCp0IE;EACE,oBhCqzBsB;ALkhH1B;AqCr0II;EACE,WAAA;EACA,qBhCizBoB;EgChzBpB,chCNK;EgCOL,YAAA;ArCu0IN;AqC7zIE;EACE,0BAAA;ArC+zIJ;AqC5zIE;EACE,qBAAA;ArC8zIJ;AqC3zIE;EACE,chC1BO;ALu1IX;;AsCp2IA;EACE,aAAA;E5BGA,eAAA;EACA,gBAAA;EGaE,sBAAA;Aby1IJ;;AsCr2IA;EACE,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;EACA,iB/BoxBkC;E+BnxBlC,c/BmKwC;E+BjKxC,sBjCPM;EiCQN,yBAAA;AtCu2IF;AsCr2IE;EACE,UAAA;EACA,c/B8JsC;E+B7JtC,qBAAA;EACA,yBjCZO;EiCaP,qBjCZO;ALm3IX;AsCp2IE;EACE,UAAA;EACA,U/B4wBgC;E+B3wBhC,+C/B+W0B;APu/H9B;;AsCh2II;EACE,cAAA;EzBaF,+BAAA;EACA,kCAAA;Abu1IJ;AsCh2II;EzBNA,gCAAA;EACA,mCAAA;Aby2IJ;AsC/1IE;EACE,UAAA;EACA,WjCxCI;EiCyCJ,yB/B0M0B;E+BzM1B,qB/ByM0B;APwpI9B;AsC91IE;EACE,cjCxCO;EiCyCP,oBAAA;EAEA,YAAA;EACA,sBjClDI;EiCmDJ,qBjChDO;AL+4IX;;AuCt5IE;EACE,uBAAA;EjCgLE,kBAAA;EiC9KF,gBlC8Ia;AL2wIjB;AuCp5IM;E1BqCF,8BAAA;EACA,iCAAA;Abk3IJ;AuCn5IM;E1BkBF,+BAAA;EACA,kCAAA;Abo4IJ;;AuCp6IE;EACE,uBAAA;EjCgLE,kBAAA;EiC9KF,gBlC+Ia;ALwxIjB;AuCl6IM;E1BqCF,8BAAA;EACA,iCAAA;Abg4IJ;AuCj6IM;E1BkBF,+BAAA;EACA,kCAAA;Abk5IJ;;AwCh7IA;EACE,qBAAA;EACA,qBAAA;ElC6JE,cAAA;EkC3JF,gBnCsLiB;EmCrLjB,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;E3BKE,sBAAA;ESFE,qIkBDJ;AxCm7IF;AsB96IM;EkBfN;IlBgBQ,gBAAA;EtBi7IN;AACF;AQv7IE;EgCGI,qBAAA;AxCu7IN;;AwCl7IE;EACE,aAAA;AxCq7IJ;;AwCh7IA;EACE,kBAAA;EACA,SAAA;AxCm7IF;;AwC56IA;EACE,oBnCiqBqB;EmChqBrB,mBnCgqBqB;EQvrBnB,oBAAA;Abu8IJ;;AwCv6IE;ECjDA,WAAA;EACA,yBlC0Ea;APk5If;AQ98IE;EiCVI,WAAA;EACA,yBAAA;AzC29IN;AyCx9II;EAEE,UAAA;EACA,8CAAA;AzCy9IN;;AwCp7IE;ECjDA,WAAA;EACA,yBlC0Ea;AP+5If;AQ39IE;EiCVI,WAAA;EACA,yBAAA;AzCw+IN;AyCr+II;EAEE,UAAA;EACA,iDAAA;AzCs+IN;;AwCj8IE;ECjDA,WAAA;EACA,yBlC0Ea;AP46If;AQx+IE;EiCVI,WAAA;EACA,yBAAA;AzCq/IN;AyCl/II;EAEE,UAAA;EACA,+CAAA;AzCm/IN;;AwC98IE;ECjDA,WAAA;EACA,yBlC0Ea;APy7If;AQr/IE;EiCVI,WAAA;EACA,yBAAA;AzCkgJN;AyC//II;EAEE,UAAA;EACA,gDAAA;AzCggJN;;AwC39IE;ECjDA,cAAA;EACA,yBlC0Ea;APs8If;AQlgJE;EiCVI,cAAA;EACA,yBAAA;AzC+gJN;AyC5gJI;EAEE,UAAA;EACA,+CAAA;AzC6gJN;;AwCx+IE;ECjDA,WAAA;EACA,yBlC0Ea;APm9If;AQ/gJE;EiCVI,WAAA;EACA,yBAAA;AzC4hJN;AyCzhJI;EAEE,UAAA;EACA,+CAAA;AzC0hJN;;AwCr/IE;ECjDA,cAAA;EACA,yBlC0Ea;APg+If;AQ5hJE;EiCVI,cAAA;EACA,yBAAA;AzCyiJN;AyCtiJI;EAEE,UAAA;EACA,iDAAA;AzCuiJN;;AwClgJE;ECjDA,WAAA;EACA,yBlC0Ea;AP6+If;AQziJE;EiCVI,WAAA;EACA,yBAAA;AzCsjJN;AyCnjJI;EAEE,UAAA;EACA,8CAAA;AzCojJN;;A0CjkJA;EACE,kBAAA;EACA,mBrC6lBkB;EqC3lBlB,yBrCKS;EQSP,qBAAA;AbsjJJ;AiB5gJI;EyB5DJ;IAQI,kBAAA;E1CokJF;AACF;;A0CjkJA;EACE,gBAAA;EACA,eAAA;E7BIE,gBAAA;AbikJJ;;A2C/kJA;EACE,kBAAA;EACA,wBAAA;EACA,mBtCwvBoB;EsCvvBpB,6BAAA;E9BUE,sBAAA;AbykJJ;;A2C9kJA;EAEE,cAAA;A3CglJF;;A2C5kJA;EACE,gBtC2KiB;ALo6InB;;A2CvkJA;EACE,mBAAA;A3C0kJF;A2CvkJE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,wBAAA;EACA,cAAA;A3CykJJ;;A2C/jJE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A3CokJvE;A4ChnJE;EACE,yBAAA;A5CknJJ;A4C/mJE;EACE,cAAA;A5CinJJ;;A2C3kJE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A3CglJvE;A4C5nJE;EACE,yBAAA;A5C8nJJ;A4C3nJE;EACE,cAAA;A5C6nJJ;;A2CvlJE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A3C4lJvE;A4CxoJE;EACE,yBAAA;A5C0oJJ;A4CvoJE;EACE,cAAA;A5CyoJJ;;A2CnmJE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A3CwmJvE;A4CppJE;EACE,yBAAA;A5CspJJ;A4CnpJE;EACE,cAAA;A5CqpJJ;;A2C/mJE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A3ConJvE;A4ChqJE;EACE,yBAAA;A5CkqJJ;A4C/pJE;EACE,cAAA;A5CiqJJ;;A2C3nJE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A3CgoJvE;A4C5qJE;EACE,yBAAA;A5C8qJJ;A4C3qJE;EACE,cAAA;A5C6qJJ;;A2CvoJE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A3C4oJvE;A4CxrJE;EACE,yBAAA;A5C0rJJ;A4CvrJE;EACE,cAAA;A5CyrJJ;;A2CnpJE;EC/CA,cDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;A3CwpJvE;A4CpsJE;EACE,yBAAA;A5CssJJ;A4CnsJE;EACE,cAAA;A5CqsJJ;;A6C7sJE;EACE;IAAO,2BAAA;E7CitJT;E6ChtJE;IAAK,wBAAA;E7CmtJP;AACF;A6ChtJA;EACE,aAAA;EACA,YxCiwBgB;EwChwBhB,gBAAA;EACA,cAAA;EvCwKI,kBAAA;EuCtKJ,yBxCLS;EQSP,sBAAA;Ab+sJJ;;A6C9sJA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WxCjBM;EwCkBN,kBAAA;EACA,mBAAA;EACA,yBtCu9BkC;Eel+B9B,2BuBYJ;A7CitJF;AsBztJM;EuBDN;IvBEQ,gBAAA;EtB4tJN;AACF;;A6CntJA;ErBYE,qMAAA;EqBVA,0BAAA;A7CstJF;;A6CltJE;EACE,kDAAA;A7CqtJJ;A6CltJM;EAJJ;IAKM,eAAA;E7CqtJN;AACF;;A8ChwJA;EACE,aAAA;EACA,uBAAA;A9CmwJF;;A8ChwJA;EACE,OAAA;A9CmwJF;;A+CrwJA;EACE,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;ElCQE,sBAAA;Ab+vJJ;;A+C7vJA;EACE,WAAA;EACA,c1CRS;E0CST,mBAAA;A/CgwJF;AQvwJE;EuCWE,UAAA;EACA,c1CdO;E0CeP,qBAAA;EACA,yB1CtBO;ALqxJX;A+C5vJE;EACE,c1ClBO;E0CmBP,yB1C1BO;ALwxJX;;A+CrvJA;EACE,kBAAA;EACA,cAAA;EACA,wBAAA;EAGA,sB1C3CM;E0C4CN,sCAAA;A/CsvJF;A+CpvJE;ElC1BE,+BAAA;EACA,gCAAA;AbixJJ;A+CpvJE;ElChBE,mCAAA;EACA,kCAAA;AbuwJJ;A+CpvJE;EAEE,c1ClDO;E0CmDP,oBAAA;EACA,sB1C1DI;AL+yJR;A+CjvJE;EACE,UAAA;EACA,W1ChEI;E0CiEJ,yBxCkL0B;EwCjL1B,qBxCiL0B;APkkJ9B;A+ChvJE;EACE,mBAAA;A/CkvJJ;A+ChvJI;EACE,gBAAA;EACA,qB1CsES;AL4qJf;;A+CpuJI;EACE,mBAAA;A/CuuJN;A+CpuJQ;ElC1BJ,kCAAA;EAZA,0BAAA;Ab8wJJ;A+CnuJQ;ElC3CJ,gCAAA;EAYA,4BAAA;AbswJJ;A+CluJQ;EACE,aAAA;A/CouJV;A+CjuJQ;EACE,qB1CqCK;E0CpCL,oBAAA;A/CmuJV;A+CjuJU;EACE,iBAAA;EACA,sB1CgCG;ALmsJf;;AiB9xJI;E8BmCA;IACE,mBAAA;E/C+vJJ;E+C5vJM;IlC1BJ,kCAAA;IAZA,0BAAA;EbsyJF;E+C3vJM;IlC3CJ,gCAAA;IAYA,4BAAA;Eb8xJF;E+C1vJM;IACE,aAAA;E/C4vJR;E+CzvJM;IACE,qB1CqCK;I0CpCL,oBAAA;E/C2vJR;E+CzvJQ;IACE,iBAAA;IACA,sB1CgCG;EL2tJb;AACF;AiBvzJI;E8BmCA;IACE,mBAAA;E/CuxJJ;E+CpxJM;IlC1BJ,kCAAA;IAZA,0BAAA;Eb8zJF;E+CnxJM;IlC3CJ,gCAAA;IAYA,4BAAA;EbszJF;E+ClxJM;IACE,aAAA;E/CoxJR;E+CjxJM;IACE,qB1CqCK;I0CpCL,oBAAA;E/CmxJR;E+CjxJQ;IACE,iBAAA;IACA,sB1CgCG;ELmvJb;AACF;AiB/0JI;E8BmCA;IACE,mBAAA;E/C+yJJ;E+C5yJM;IlC1BJ,kCAAA;IAZA,0BAAA;Ebs1JF;E+C3yJM;IlC3CJ,gCAAA;IAYA,4BAAA;Eb80JF;E+C1yJM;IACE,aAAA;E/C4yJR;E+CzyJM;IACE,qB1CqCK;I0CpCL,oBAAA;E/C2yJR;E+CzyJQ;IACE,iBAAA;IACA,sB1CgCG;EL2wJb;AACF;AiBv2JI;E8BmCA;IACE,mBAAA;E/Cu0JJ;E+Cp0JM;IlC1BJ,kCAAA;IAZA,0BAAA;Eb82JF;E+Cn0JM;IlC3CJ,gCAAA;IAYA,4BAAA;Ebs2JF;E+Cl0JM;IACE,aAAA;E/Co0JR;E+Cj0JM;IACE,qB1CqCK;I0CpCL,oBAAA;E/Cm0JR;E+Cj0JQ;IACE,iBAAA;IACA,sB1CgCG;ELmyJb;AACF;A+CtzJA;ElCnHI,gBAAA;Ab46JJ;A+CtzJE;EACE,qBAAA;A/CwzJJ;A+CtzJI;EACE,sBAAA;A/CwzJN;;AgDj8JE;EACE,cDoJsE;ECnJtE,yBDmJuC;A/CizJ3C;AQz7JE;EwCPM,cD+IkE;EC9IlE,yBAAA;AhDm8JR;AgDh8JM;EACE,W3CPA;E2CQA,yBDyIkE;ECxIlE,qBDwIkE;A/C0zJ1E;;AgD/8JE;EACE,cDoJsE;ECnJtE,yBDmJuC;A/C+zJ3C;AQv8JE;EwCPM,cD+IkE;EC9IlE,yBAAA;AhDi9JR;AgD98JM;EACE,W3CPA;E2CQA,yBDyIkE;ECxIlE,qBDwIkE;A/Cw0J1E;;AgD79JE;EACE,cDoJsE;ECnJtE,yBDmJuC;A/C60J3C;AQr9JE;EwCPM,cD+IkE;EC9IlE,yBAAA;AhD+9JR;AgD59JM;EACE,W3CPA;E2CQA,yBDyIkE;ECxIlE,qBDwIkE;A/Cs1J1E;;AgD3+JE;EACE,cDoJsE;ECnJtE,yBDmJuC;A/C21J3C;AQn+JE;EwCPM,cD+IkE;EC9IlE,yBAAA;AhD6+JR;AgD1+JM;EACE,W3CPA;E2CQA,yBDyIkE;ECxIlE,qBDwIkE;A/Co2J1E;;AgDz/JE;EACE,cDoJsE;ECnJtE,yBDmJuC;A/Cy2J3C;AQj/JE;EwCPM,cD+IkE;EC9IlE,yBAAA;AhD2/JR;AgDx/JM;EACE,W3CPA;E2CQA,yBDyIkE;ECxIlE,qBDwIkE;A/Ck3J1E;;AgDvgKE;EACE,cDoJsE;ECnJtE,yBDmJuC;A/Cu3J3C;AQ//JE;EwCPM,cD+IkE;EC9IlE,yBAAA;AhDygKR;AgDtgKM;EACE,W3CPA;E2CQA,yBDyIkE;ECxIlE,qBDwIkE;A/Cg4J1E;;AgDrhKE;EACE,cDoJsE;ECnJtE,yBDmJuC;A/Cq4J3C;AQ7gKE;EwCPM,cD+IkE;EC9IlE,yBAAA;AhDuhKR;AgDphKM;EACE,W3CPA;E2CQA,yBDyIkE;ECxIlE,qBDwIkE;A/C84J1E;;AgDniKE;EACE,cDoJsE;ECnJtE,yBDmJuC;A/Cm5J3C;AQ3hKE;EwCPM,cD+IkE;EC9IlE,yBAAA;AhDqiKR;AgDliKM;EACE,W3CPA;E2CQA,yBDyIkE;ECxIlE,qBDwIkE;A/C45J1E;;AiDpjKA;EACE,YAAA;E3C4MM,iBAAA;E2C1MN,gB5C4LiB;E4C3LjB,cAAA;EACA,W5CYM;E4CXN,yB5Co3BkB;E4Cn3BlB,YAAA;AjDujKF;AM16JI;E2CpJJ;I3CkNU,iCAXQ;EN23JhB;AACF;AQvjKE;EyCDE,W5CMI;E4CLJ,qBAAA;AjD2jKJ;AQvjKE;EyCCI,aAAA;AjDyjKN;;AiD9iKA;EACE,UAAA;EACA,6BAAA;EACA,SAAA;AjDijKF;;AiD3iKA;EACE,oBAAA;AjD8iKF;;AkDplKA;EAGE,iB7C2qBgB;E6C1qBhB,gB7C0qBgB;EC1fZ,mBAAA;E4C7KJ,2C7C4qBuB;E6C3qBvB,4BAAA;EACA,oCAAA;EACA,gD7C6qBiB;E6C5qBjB,UAAA;ErCOE,sBAAA;Ab8kKJ;AkDllKE;EACE,sB7CgqBc;ALo7IlB;AkDjlKE;EACE,UAAA;AlDmlKJ;AkDhlKE;EACE,cAAA;EACA,UAAA;AlDklKJ;AkD/kKE;EACE,aAAA;AlDilKJ;;AkD7kKA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,c7CvBS;E6CwBT,2C7CqpB8B;E6CppB9B,4BAAA;EACA,4CAAA;ErCZE,2CAAA;EACA,4CAAA;Ab6lKJ;;AkD9kKA;EACE,gB7CmoBgB;AL88IlB;;AmDvnKA;EAEE,gBAAA;AnDynKF;AmDvnKE;EACE,kBAAA;EACA,gBAAA;AnDynKJ;;AmDpnKA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a9Ckfa;E8Cjfb,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EAGA,UAAA;AnDqnKF;;AmD9mKA;EACE,kBAAA;EACA,WAAA;EACA,c9CirBoB;E8C/qBpB,oBAAA;AnDgnKF;AmD7mKE;E7B3BI,mC6B4BF;EACA,8B9CssBmB;ALy6IvB;AsBxoKM;E6BuBJ;I7BtBM,gBAAA;EtB2oKN;AACF;AmDlnKE;EACE,e9CosBmB;ALg7IvB;AmDhnKE;EACE,sB9CisBoB;ALi7IxB;;AmD9mKA;EACE,aAAA;EACA,6BAAA;AnDinKF;AmD/mKE;EACE,8BAAA;EACA,gBAAA;AnDinKJ;AmD9mKE;;EAEE,cAAA;AnDgnKJ;AmD7mKE;EACE,gBAAA;AnD+mKJ;;AmD3mKA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AnD8mKF;AmD3mKE;EACE,cAAA;EACA,0BAAA;EACA,mBAAA;EACA,WAAA;AnD6mKJ;AmDzmKE;EACE,sBAAA;EACA,uBAAA;EACA,YAAA;AnD2mKJ;AmDzmKI;EACE,gBAAA;AnD2mKN;AmDxmKI;EACE,aAAA;AnD0mKN;;AmDpmKA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAGA,oBAAA;EACA,sB9C3GM;E8C4GN,4BAAA;EACA,oCAAA;EtClGE,qBAAA;EsCsGF,UAAA;AnDmmKF;;AmD/lKA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a9CsYsB;E8CrYtB,YAAA;EACA,aAAA;EACA,sB9ClHM;ALotKR;AmD/lKE;EAAS,UAAA;AnDkmKX;AmDjmKE;EAAS,Y9C8lBc;ALsgJzB;;AmD/lKA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,kB9C4lBqB;E8C3lBrB,gCAAA;EtCtHE,0CAAA;EACA,2CAAA;AbytKJ;AmDjmKE;EACE,kB9CulBmB;E8CrlBnB,8BAAA;AnDkmKJ;;AmD7lKA;EACE,gBAAA;EACA,gB9CqCiB;AL2jKnB;;AmD3lKA;EACE,kBAAA;EAGA,cAAA;EACA,a9C0iBoB;ALkjJtB;;AmDxlKA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,6BAAA;EtCzIE,8CAAA;EACA,6CAAA;AbquKJ;AmDvlKE;EACE,eAAA;AnDylKJ;;AmDplKA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AnDulKF;;AiB9tKI;EkC6IF;IACE,gB9CsiBO;I8CriBP,oBAAA;EnDqlKF;EmDllKA;IACE,+BAAA;EnDolKF;EmDllKE;IACE,gCAAA;EnDolKJ;EmDhlKA;IACE,+BAAA;EnDklKF;EmDhlKE;IACE,4BAAA;IACA,mBAAA;EnDklKJ;EmD1kKA;IAAY,gB9C8gBH;EL+jJT;AACF;AiBrvKI;EkC2KF;;IAEE,gB9CsgBO;ELukJT;AACF;AiB3vKI;EkCkLF;IAAY,iB9CggBH;EL6kJT;AACF;AoD3zKA;EACE,kBAAA;EACA,a/CsgBe;E+CrgBf,cAAA;EACA,S/C8nBe;EgDloBf,wBhDkLuB;EgDhLvB,kBAAA;EACA,gBhD0LmB;EgDzLnB,gBhD8LiB;EgD7LjB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;E/CqKI,kBAAA;E8CzKJ,qBAAA;EACA,UAAA;ApDu0KF;AoDr0KE;EAAS,Y/CknBO;ALstJlB;AoDt0KE;EACE,kBAAA;EACA,cAAA;EACA,a/CknBkB;E+CjnBlB,c/CknBmB;ALstJvB;AoDt0KI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ApDw0KN;;AoDn0KA;EACE,iBAAA;ApDs0KF;AoDp0KE;EACE,SAAA;ApDs0KJ;AoDp0KI;EACE,MAAA;EACA,6BAAA;EACA,sB/CvBE;AL61KR;;AoDj0KA;EACE,iBAAA;ApDo0KF;AoDl0KE;EACE,OAAA;EACA,a/ColBmB;E+CnlBnB,c/CklBkB;ALkvJtB;AoDl0KI;EACE,QAAA;EACA,oCAAA;EACA,wB/CvCE;AL22KR;;AoD/zKA;EACE,iBAAA;ApDk0KF;AoDh0KE;EACE,MAAA;ApDk0KJ;AoDh0KI;EACE,SAAA;EACA,6BAAA;EACA,yB/CrDE;ALu3KR;;AoD7zKA;EACE,iBAAA;ApDg0KF;AoD9zKE;EACE,QAAA;EACA,a/CsjBmB;E+CrjBnB,c/CojBkB;AL4wJtB;AoD9zKI;EACE,OAAA;EACA,oCAAA;EACA,uB/CrEE;ALq4KR;;AoD3yKA;EACE,gB/CghBkB;E+C/gBlB,uBAAA;EACA,W/CvGM;E+CwGN,kBAAA;EACA,sB/C/FM;EQCJ,sBAAA;Ab64KJ;;AsD/5KA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,ajDogBe;EiDngBf,cAAA;EACA,gBjDgpBkB;EgDrpBlB,wBhDkLuB;EgDhLvB,kBAAA;EACA,gBhD0LmB;EgDzLnB,gBhD8LiB;EgD7LjB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;E/CqKI,kBAAA;EgDxKJ,qBAAA;EACA,sBjDNM;EiDON,4BAAA;EACA,oCAAA;EzCGE,qBAAA;Ab06KJ;AsDz6KE;EACE,kBAAA;EACA,cAAA;EACA,WjD+oBkB;EiD9oBlB,cjD+oBmB;EiD9oBnB,gBAAA;AtD26KJ;AsDz6KI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AtD06KN;;AsDr6KA;EACE,qBjDgoBqB;ALwyJvB;AsDt6KE;EACE,2BAAA;AtDw6KJ;AsDt6KI;EACE,SAAA;EACA,6BAAA;EACA,qCjD2nBsB;AL6yJ5B;AsDr6KI;EACE,WjDqGS;EiDpGT,6BAAA;EACA,sBjD7CE;ALo9KR;;AsDl6KA;EACE,mBjD4mBqB;ALyzJvB;AsDn6KE;EACE,yBAAA;EACA,ajDwmBmB;EiDvmBnB,YjDsmBkB;EiDrmBlB,gBAAA;AtDq6KJ;AsDn6KI;EACE,OAAA;EACA,oCAAA;EACA,uCjDomBsB;ALi0J5B;AsDl6KI;EACE,SjD8ES;EiD7ET,oCAAA;EACA,wBjDpEE;ALw+KR;;AsD/5KA;EACE,kBjDqlBqB;AL60JvB;AsDh6KE;EACE,wBAAA;AtDk6KJ;AsDh6KI;EACE,MAAA;EACA,oCAAA;EACA,wCjDglBsB;ALk1J5B;AsD/5KI;EACE,QjD0DS;EiDzDT,oCAAA;EACA,yBjDxFE;ALy/KR;AsD55KE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,WjD4jBkB;EiD3jBlB,oBAAA;EACA,WAAA;EACA,gCAAA;AtD85KJ;;AsD15KA;EACE,oBjDqjBqB;ALw2JvB;AsD35KE;EACE,0BAAA;EACA,ajDijBmB;EiDhjBnB,YjD+iBkB;EiD9iBlB,gBAAA;AtD65KJ;AsD35KI;EACE,QAAA;EACA,oCAAA;EACA,sCjD6iBsB;ALg3J5B;AsD15KI;EACE,UjDuBS;EiDtBT,oCAAA;EACA,uBjD3HE;ALuhLR;;AsDt4KA;EACE,uBAAA;EACA,gBAAA;EhD0BI,eAAA;EgDvBJ,yBjD+fkB;EiD9flB,gCAAA;EzCnIE,0CAAA;EACA,2CAAA;Ab4gLJ;AsDv4KE;EACE,aAAA;AtDy4KJ;;AsDr4KA;EACE,uBAAA;EACA,cjDxJS;ALgiLX;;AuDniLA;EACE,kBAAA;AvDsiLF;;AuDniLA;EACE,mBAAA;AvDsiLF;;AuDniLA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AvDsiLF;AwD7jLE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AxD+jLJ;;AuDviLA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EjClBI,sCiCmBJ;AvD0iLF;AsBzjLM;EiCQN;IjCPQ,gBAAA;EtB4jLN;AACF;;AuD5iLA;;;EAGE,cAAA;AvD+iLF;;AuD5iLA;;EAEE,2BAAA;AvD+iLF;;AuD5iLA;;EAEE,4BAAA;AvD+iLF;;AuDtiLE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AvDyiLJ;AuDtiLE;;;EAGE,UAAA;EACA,UAAA;AvDwiLJ;AuDriLE;;EAEE,UAAA;EACA,UAAA;EjC5DE,2BiC6DF;AvDuiLJ;AsBhmLM;EiCqDJ;;IjCpDM,gBAAA;EtBomLN;AACF;;AuDpiLA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WlDkvBuB;EkDjvBvB,UAAA;EACA,WlD3FM;EkD4FN,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YlD6uByB;EiBn0BrB,8BiCuFJ;AvDsiLF;AsBznLM;EiCkEN;;IjCjEQ,gBAAA;EtB6nLN;AACF;AQnoLE;;;E+C2FE,WlDpGI;EkDqGJ,qBAAA;EACA,UAAA;EACA,YlDsuB6B;ALu0JjC;;AuD1iLA;EACE,OAAA;AvD6iLF;;AuDxiLA;EACE,QAAA;AvD2iLF;;AuDpiLA;;EAEE,qBAAA;EACA,WlD+tB4B;EkD9tB5B,YlD8tB4B;EkD7tB5B,mCAAA;AvDuiLF;;AuDriLA;EACE,yDAAA;AvDwiLF;;AuDtiLA;EACE,yDAAA;AvDyiLF;;AuDhiLA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EAEA,kBlDqrBuB;EkDprBvB,iBlDorBuB;EkDnrBvB,gBAAA;AvDkiLF;AuDhiLE;EACE,uBAAA;EACA,cAAA;EACA,WlDmrBuB;EkDlrBvB,WlDmrBwB;EkDlrBxB,iBlDorBwB;EkDnrBxB,gBlDmrBwB;EkDlrBxB,mBAAA;EACA,eAAA;EACA,sBlDnKI;EkDoKJ,4BAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YAAA;EjC/JE,6BiCgKF;AvDiiLJ;AsB7rLM;EiC6IJ;IjC5IM,gBAAA;EtBgsLN;AACF;AuDniLE;EACE,UAAA;AvDqiLJ;;AuD5hLA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,WlD9LM;EkD+LN,kBAAA;AvD+hLF;;AyDjuLA;EACE;IAAK,yBAAA;EzDquLL;AACF;AyDnuLA;EACE,qBAAA;EACA,WpDk2Bc;EoDj2Bd,YpDi2Bc;EoDh2Bd,wBlDskCwB;EkDrkCxB,iCAAA;EACA,+BAAA;EAEA,kBAAA;EACA,+CAAA;AzDouLF;;AyDjuLA;EACE,WpD21BiB;EoD11BjB,YpD01BiB;EoDz1BjB,mBpD21BwB;ALy4J1B;;AyD7tLA;EACE;IACE,mBAAA;EzDguLF;EyD9tLA;IACE,UAAA;IACA,eAAA;EzDguLF;AACF;AyD7tLA;EACE,qBAAA;EACA,WpDk0Bc;EoDj0Bd,YpDi0Bc;EoDh0Bd,wBlDsiCwB;EkDriCxB,8BAAA;EAEA,kBAAA;EACA,UAAA;EACA,6CAAA;AzD8tLF;;AyD3tLA;EACE,WpD2zBiB;EoD1zBjB,YpD0zBiB;ALo6JnB;;AyD1tLE;EACE;;IAEE,wBAAA;EzD6tLJ;AACF;A0DzxLA;EAAqB,mCAAA;A1D4xLrB;;A0D3xLA;EAAqB,8BAAA;A1D+xLrB;;A0D9xLA;EAAqB,iCAAA;A1DkyLrB;;A0DjyLA;EAAqB,iCAAA;A1DqyLrB;;A0DpyLA;EAAqB,sCAAA;A1DwyLrB;;A0DvyLA;EAAqB,mCAAA;A1D2yLrB;;A2D7yLE;EACE,oCAAA;A3DgzLJ;;AQtyLE;;;EmDLI,oCAAA;A3DizLN;;A2DvzLE;EACE,oCAAA;A3D0zLJ;;AQhzLE;;;EmDLI,oCAAA;A3D2zLN;;A2Dj0LE;EACE,oCAAA;A3Do0LJ;;AQ1zLE;;;EmDLI,oCAAA;A3Dq0LN;;A2D30LE;EACE,oCAAA;A3D80LJ;;AQp0LE;;;EmDLI,oCAAA;A3D+0LN;;A2Dr1LE;EACE,oCAAA;A3Dw1LJ;;AQ90LE;;;EmDLI,oCAAA;A3Dy1LN;;A2D/1LE;EACE,oCAAA;A3Dk2LJ;;AQx1LE;;;EmDLI,oCAAA;A3Dm2LN;;A2Dz2LE;EACE,oCAAA;A3D42LJ;;AQl2LE;;;EmDLI,oCAAA;A3D62LN;;A2Dn3LE;EACE,oCAAA;A3Ds3LJ;;AQ52LE;;;EmDLI,oCAAA;A3Du3LN;;A4Dt3LA;EACE,iCAAA;A5Dy3LF;;A4Dt3LA;EACE,wCAAA;A5Dy3LF;;A6Dp4LA;EAAkB,oCAAA;A7Dw4LlB;;A6Dv4LA;EAAkB,wCAAA;A7D24LlB;;A6D14LA;EAAkB,0CAAA;A7D84LlB;;A6D74LA;EAAkB,2CAAA;A7Di5LlB;;A6Dh5LA;EAAkB,yCAAA;A7Do5LlB;;A6Dl5LA;EAAmB,oBAAA;A7Ds5LnB;;A6Dr5LA;EAAmB,wBAAA;A7Dy5LnB;;A6Dx5LA;EAAmB,0BAAA;A7D45LnB;;A6D35LA;EAAmB,2BAAA;A7D+5LnB;;A6D95LA;EAAmB,yBAAA;A7Dk6LnB;;A6D/5LE;EACE,gCAAA;A7Dk6LJ;;A6Dn6LE;EACE,gCAAA;A7Ds6LJ;;A6Dv6LE;EACE,gCAAA;A7D06LJ;;A6D36LE;EACE,gCAAA;A7D86LJ;;A6D/6LE;EACE,gCAAA;A7Dk7LJ;;A6Dn7LE;EACE,gCAAA;A7Ds7LJ;;A6Dv7LE;EACE,gCAAA;A7D07LJ;;A6D37LE;EACE,gCAAA;A7D87LJ;;A6D17LA;EACE,6BAAA;A7D67LF;;A6Dt7LA;EACE,gCAAA;A7Dy7LF;;A6Dt7LA;EACE,iCAAA;A7Dy7LF;;A6Dt7LA;EACE,0CAAA;EACA,2CAAA;A7Dy7LF;;A6Dt7LA;EACE,2CAAA;EACA,8CAAA;A7Dy7LF;;A6Dt7LA;EACE,8CAAA;EACA,6CAAA;A7Dy7LF;;A6Dt7LA;EACE,0CAAA;EACA,6CAAA;A7Dy7LF;;A6Dt7LA;EACE,gCAAA;A7Dy7LF;;A6Dt7LA;EACE,6BAAA;A7Dy7LF;;A6Dt7LA;EACE,+BAAA;A7Dy7LF;;A6Dt7LA;EACE,2BAAA;A7Dy7LF;;AwDjgME;EACE,cAAA;EACA,WAAA;EACA,WAAA;AxDogMJ;;A8D7/LM;EAAwB,wBAAA;A9DigM9B;;A8DjgMM;EAAwB,0BAAA;A9DqgM9B;;A8DrgMM;EAAwB,gCAAA;A9DygM9B;;A8DzgMM;EAAwB,yBAAA;A9D6gM9B;;A8D7gMM;EAAwB,yBAAA;A9DihM9B;;A8DjhMM;EAAwB,6BAAA;A9DqhM9B;;A8DrhMM;EAAwB,8BAAA;A9DyhM9B;;A8DzhMM;EAAwB,wBAAA;A9D6hM9B;;A8D7hMM;EAAwB,+BAAA;A9DiiM9B;;AiBh/LI;E6CjDE;IAAwB,wBAAA;E9DsiM5B;E8DtiMI;IAAwB,0BAAA;E9DyiM5B;E8DziMI;IAAwB,gCAAA;E9D4iM5B;E8D5iMI;IAAwB,yBAAA;E9D+iM5B;E8D/iMI;IAAwB,yBAAA;E9DkjM5B;E8DljMI;IAAwB,6BAAA;E9DqjM5B;E8DrjMI;IAAwB,8BAAA;E9DwjM5B;E8DxjMI;IAAwB,wBAAA;E9D2jM5B;E8D3jMI;IAAwB,+BAAA;E9D8jM5B;AACF;AiB9gMI;E6CjDE;IAAwB,wBAAA;E9DmkM5B;E8DnkMI;IAAwB,0BAAA;E9DskM5B;E8DtkMI;IAAwB,gCAAA;E9DykM5B;E8DzkMI;IAAwB,yBAAA;E9D4kM5B;E8D5kMI;IAAwB,yBAAA;E9D+kM5B;E8D/kMI;IAAwB,6BAAA;E9DklM5B;E8DllMI;IAAwB,8BAAA;E9DqlM5B;E8DrlMI;IAAwB,wBAAA;E9DwlM5B;E8DxlMI;IAAwB,+BAAA;E9D2lM5B;AACF;AiB3iMI;E6CjDE;IAAwB,wBAAA;E9DgmM5B;E8DhmMI;IAAwB,0BAAA;E9DmmM5B;E8DnmMI;IAAwB,gCAAA;E9DsmM5B;E8DtmMI;IAAwB,yBAAA;E9DymM5B;E8DzmMI;IAAwB,yBAAA;E9D4mM5B;E8D5mMI;IAAwB,6BAAA;E9D+mM5B;E8D/mMI;IAAwB,8BAAA;E9DknM5B;E8DlnMI;IAAwB,wBAAA;E9DqnM5B;E8DrnMI;IAAwB,+BAAA;E9DwnM5B;AACF;AiBxkMI;E6CjDE;IAAwB,wBAAA;E9D6nM5B;E8D7nMI;IAAwB,0BAAA;E9DgoM5B;E8DhoMI;IAAwB,gCAAA;E9DmoM5B;E8DnoMI;IAAwB,yBAAA;E9DsoM5B;E8DtoMI;IAAwB,yBAAA;E9DyoM5B;E8DzoMI;IAAwB,6BAAA;E9D4oM5B;E8D5oMI;IAAwB,8BAAA;E9D+oM5B;E8D/oMI;IAAwB,wBAAA;E9DkpM5B;E8DlpMI;IAAwB,+BAAA;E9DqpM5B;AACF;A8D5oMA;EAEI;IAAqB,wBAAA;E9D8oMvB;E8D9oME;IAAqB,0BAAA;E9DipMvB;E8DjpME;IAAqB,gCAAA;E9DopMvB;E8DppME;IAAqB,yBAAA;E9DupMvB;E8DvpME;IAAqB,yBAAA;E9D0pMvB;E8D1pME;IAAqB,6BAAA;E9D6pMvB;E8D7pME;IAAqB,8BAAA;E9DgqMvB;E8DhqME;IAAqB,wBAAA;E9DmqMvB;E8DnqME;IAAqB,+BAAA;E9DsqMvB;AACF;A+D5rMA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;A/D8rMF;A+D5rME;EACE,cAAA;EACA,WAAA;A/D8rMJ;A+D3rME;;;;;EAKE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;A/D6rMJ;;A+DprMI;EACE,yBAAA;A/DurMN;;A+DxrMI;EACE,mBAAA;A/D2rMN;;A+D5rMI;EACE,gBAAA;A/D+rMN;;A+DhsMI;EACE,iBAAA;A/DmsMN;;AgE5tMI;EAAgC,8BAAA;AhEguMpC;;AgE/tMI;EAAgC,iCAAA;AhEmuMpC;;AgEluMI;EAAgC,sCAAA;AhEsuMpC;;AgEruMI;EAAgC,yCAAA;AhEyuMpC;;AgEvuMI;EAA8B,0BAAA;AhE2uMlC;;AgE1uMI;EAA8B,4BAAA;AhE8uMlC;;AgE7uMI;EAA8B,kCAAA;AhEivMlC;;AgEhvMI;EAA8B,yBAAA;AhEovMlC;;AgEnvMI;EAA8B,uBAAA;AhEuvMlC;;AgEtvMI;EAA8B,uBAAA;AhE0vMlC;;AgEzvMI;EAA8B,yBAAA;AhE6vMlC;;AgE5vMI;EAA8B,yBAAA;AhEgwMlC;;AgE9vMI;EAAoC,sCAAA;AhEkwMxC;;AgEjwMI;EAAoC,oCAAA;AhEqwMxC;;AgEpwMI;EAAoC,kCAAA;AhEwwMxC;;AgEvwMI;EAAoC,yCAAA;AhE2wMxC;;AgE1wMI;EAAoC,wCAAA;AhE8wMxC;;AgE5wMI;EAAiC,kCAAA;AhEgxMrC;;AgE/wMI;EAAiC,gCAAA;AhEmxMrC;;AgElxMI;EAAiC,8BAAA;AhEsxMrC;;AgErxMI;EAAiC,gCAAA;AhEyxMrC;;AgExxMI;EAAiC,+BAAA;AhE4xMrC;;AgE1xMI;EAAkC,oCAAA;AhE8xMtC;;AgE7xMI;EAAkC,kCAAA;AhEiyMtC;;AgEhyMI;EAAkC,gCAAA;AhEoyMtC;;AgEnyMI;EAAkC,uCAAA;AhEuyMtC;;AgEtyMI;EAAkC,sCAAA;AhE0yMtC;;AgEzyMI;EAAkC,iCAAA;AhE6yMtC;;AgE3yMI;EAAgC,2BAAA;AhE+yMpC;;AgE9yMI;EAAgC,iCAAA;AhEkzMpC;;AgEjzMI;EAAgC,+BAAA;AhEqzMpC;;AgEpzMI;EAAgC,6BAAA;AhEwzMpC;;AgEvzMI;EAAgC,+BAAA;AhE2zMpC;;AgE1zMI;EAAgC,8BAAA;AhE8zMpC;;AiBlzMI;E+ClDA;IAAgC,8BAAA;EhEy2MlC;EgEx2ME;IAAgC,iCAAA;EhE22MlC;EgE12ME;IAAgC,sCAAA;EhE62MlC;EgE52ME;IAAgC,yCAAA;EhE+2MlC;EgE72ME;IAA8B,0BAAA;EhEg3MhC;EgE/2ME;IAA8B,4BAAA;EhEk3MhC;EgEj3ME;IAA8B,kCAAA;EhEo3MhC;EgEn3ME;IAA8B,yBAAA;EhEs3MhC;EgEr3ME;IAA8B,uBAAA;EhEw3MhC;EgEv3ME;IAA8B,uBAAA;EhE03MhC;EgEz3ME;IAA8B,yBAAA;EhE43MhC;EgE33ME;IAA8B,yBAAA;EhE83MhC;EgE53ME;IAAoC,sCAAA;EhE+3MtC;EgE93ME;IAAoC,oCAAA;EhEi4MtC;EgEh4ME;IAAoC,kCAAA;EhEm4MtC;EgEl4ME;IAAoC,yCAAA;EhEq4MtC;EgEp4ME;IAAoC,wCAAA;EhEu4MtC;EgEr4ME;IAAiC,kCAAA;EhEw4MnC;EgEv4ME;IAAiC,gCAAA;EhE04MnC;EgEz4ME;IAAiC,8BAAA;EhE44MnC;EgE34ME;IAAiC,gCAAA;EhE84MnC;EgE74ME;IAAiC,+BAAA;EhEg5MnC;EgE94ME;IAAkC,oCAAA;EhEi5MpC;EgEh5ME;IAAkC,kCAAA;EhEm5MpC;EgEl5ME;IAAkC,gCAAA;EhEq5MpC;EgEp5ME;IAAkC,uCAAA;EhEu5MpC;EgEt5ME;IAAkC,sCAAA;EhEy5MpC;EgEx5ME;IAAkC,iCAAA;EhE25MpC;EgEz5ME;IAAgC,2BAAA;EhE45MlC;EgE35ME;IAAgC,iCAAA;EhE85MlC;EgE75ME;IAAgC,+BAAA;EhEg6MlC;EgE/5ME;IAAgC,6BAAA;EhEk6MlC;EgEj6ME;IAAgC,+BAAA;EhEo6MlC;EgEn6ME;IAAgC,8BAAA;EhEs6MlC;AACF;AiB35MI;E+ClDA;IAAgC,8BAAA;EhEi9MlC;EgEh9ME;IAAgC,iCAAA;EhEm9MlC;EgEl9ME;IAAgC,sCAAA;EhEq9MlC;EgEp9ME;IAAgC,yCAAA;EhEu9MlC;EgEr9ME;IAA8B,0BAAA;EhEw9MhC;EgEv9ME;IAA8B,4BAAA;EhE09MhC;EgEz9ME;IAA8B,kCAAA;EhE49MhC;EgE39ME;IAA8B,yBAAA;EhE89MhC;EgE79ME;IAA8B,uBAAA;EhEg+MhC;EgE/9ME;IAA8B,uBAAA;EhEk+MhC;EgEj+ME;IAA8B,yBAAA;EhEo+MhC;EgEn+ME;IAA8B,yBAAA;EhEs+MhC;EgEp+ME;IAAoC,sCAAA;EhEu+MtC;EgEt+ME;IAAoC,oCAAA;EhEy+MtC;EgEx+ME;IAAoC,kCAAA;EhE2+MtC;EgE1+ME;IAAoC,yCAAA;EhE6+MtC;EgE5+ME;IAAoC,wCAAA;EhE++MtC;EgE7+ME;IAAiC,kCAAA;EhEg/MnC;EgE/+ME;IAAiC,gCAAA;EhEk/MnC;EgEj/ME;IAAiC,8BAAA;EhEo/MnC;EgEn/ME;IAAiC,gCAAA;EhEs/MnC;EgEr/ME;IAAiC,+BAAA;EhEw/MnC;EgEt/ME;IAAkC,oCAAA;EhEy/MpC;EgEx/ME;IAAkC,kCAAA;EhE2/MpC;EgE1/ME;IAAkC,gCAAA;EhE6/MpC;EgE5/ME;IAAkC,uCAAA;EhE+/MpC;EgE9/ME;IAAkC,sCAAA;EhEigNpC;EgEhgNE;IAAkC,iCAAA;EhEmgNpC;EgEjgNE;IAAgC,2BAAA;EhEogNlC;EgEngNE;IAAgC,iCAAA;EhEsgNlC;EgErgNE;IAAgC,+BAAA;EhEwgNlC;EgEvgNE;IAAgC,6BAAA;EhE0gNlC;EgEzgNE;IAAgC,+BAAA;EhE4gNlC;EgE3gNE;IAAgC,8BAAA;EhE8gNlC;AACF;AiBngNI;E+ClDA;IAAgC,8BAAA;EhEyjNlC;EgExjNE;IAAgC,iCAAA;EhE2jNlC;EgE1jNE;IAAgC,sCAAA;EhE6jNlC;EgE5jNE;IAAgC,yCAAA;EhE+jNlC;EgE7jNE;IAA8B,0BAAA;EhEgkNhC;EgE/jNE;IAA8B,4BAAA;EhEkkNhC;EgEjkNE;IAA8B,kCAAA;EhEokNhC;EgEnkNE;IAA8B,yBAAA;EhEskNhC;EgErkNE;IAA8B,uBAAA;EhEwkNhC;EgEvkNE;IAA8B,uBAAA;EhE0kNhC;EgEzkNE;IAA8B,yBAAA;EhE4kNhC;EgE3kNE;IAA8B,yBAAA;EhE8kNhC;EgE5kNE;IAAoC,sCAAA;EhE+kNtC;EgE9kNE;IAAoC,oCAAA;EhEilNtC;EgEhlNE;IAAoC,kCAAA;EhEmlNtC;EgEllNE;IAAoC,yCAAA;EhEqlNtC;EgEplNE;IAAoC,wCAAA;EhEulNtC;EgErlNE;IAAiC,kCAAA;EhEwlNnC;EgEvlNE;IAAiC,gCAAA;EhE0lNnC;EgEzlNE;IAAiC,8BAAA;EhE4lNnC;EgE3lNE;IAAiC,gCAAA;EhE8lNnC;EgE7lNE;IAAiC,+BAAA;EhEgmNnC;EgE9lNE;IAAkC,oCAAA;EhEimNpC;EgEhmNE;IAAkC,kCAAA;EhEmmNpC;EgElmNE;IAAkC,gCAAA;EhEqmNpC;EgEpmNE;IAAkC,uCAAA;EhEumNpC;EgEtmNE;IAAkC,sCAAA;EhEymNpC;EgExmNE;IAAkC,iCAAA;EhE2mNpC;EgEzmNE;IAAgC,2BAAA;EhE4mNlC;EgE3mNE;IAAgC,iCAAA;EhE8mNlC;EgE7mNE;IAAgC,+BAAA;EhEgnNlC;EgE/mNE;IAAgC,6BAAA;EhEknNlC;EgEjnNE;IAAgC,+BAAA;EhEonNlC;EgEnnNE;IAAgC,8BAAA;EhEsnNlC;AACF;AiB3mNI;E+ClDA;IAAgC,8BAAA;EhEiqNlC;EgEhqNE;IAAgC,iCAAA;EhEmqNlC;EgElqNE;IAAgC,sCAAA;EhEqqNlC;EgEpqNE;IAAgC,yCAAA;EhEuqNlC;EgErqNE;IAA8B,0BAAA;EhEwqNhC;EgEvqNE;IAA8B,4BAAA;EhE0qNhC;EgEzqNE;IAA8B,kCAAA;EhE4qNhC;EgE3qNE;IAA8B,yBAAA;EhE8qNhC;EgE7qNE;IAA8B,uBAAA;EhEgrNhC;EgE/qNE;IAA8B,uBAAA;EhEkrNhC;EgEjrNE;IAA8B,yBAAA;EhEorNhC;EgEnrNE;IAA8B,yBAAA;EhEsrNhC;EgEprNE;IAAoC,sCAAA;EhEurNtC;EgEtrNE;IAAoC,oCAAA;EhEyrNtC;EgExrNE;IAAoC,kCAAA;EhE2rNtC;EgE1rNE;IAAoC,yCAAA;EhE6rNtC;EgE5rNE;IAAoC,wCAAA;EhE+rNtC;EgE7rNE;IAAiC,kCAAA;EhEgsNnC;EgE/rNE;IAAiC,gCAAA;EhEksNnC;EgEjsNE;IAAiC,8BAAA;EhEosNnC;EgEnsNE;IAAiC,gCAAA;EhEssNnC;EgErsNE;IAAiC,+BAAA;EhEwsNnC;EgEtsNE;IAAkC,oCAAA;EhEysNpC;EgExsNE;IAAkC,kCAAA;EhE2sNpC;EgE1sNE;IAAkC,gCAAA;EhE6sNpC;EgE5sNE;IAAkC,uCAAA;EhE+sNpC;EgE9sNE;IAAkC,sCAAA;EhEitNpC;EgEhtNE;IAAkC,iCAAA;EhEmtNpC;EgEjtNE;IAAgC,2BAAA;EhEotNlC;EgEntNE;IAAgC,iCAAA;EhEstNlC;EgErtNE;IAAgC,+BAAA;EhEwtNlC;EgEvtNE;IAAgC,6BAAA;EhE0tNlC;EgEztNE;IAAgC,+BAAA;EhE4tNlC;EgE3tNE;IAAgC,8BAAA;EhE8tNlC;AACF;AiEzwNI;EAAwB,sBAAA;AjE4wN5B;;AiE3wNI;EAAwB,uBAAA;AjE+wN5B;;AiE9wNI;EAAwB,sBAAA;AjEkxN5B;;AiB9tNI;EgDtDA;IAAwB,sBAAA;EjEyxN1B;EiExxNE;IAAwB,uBAAA;EjE2xN1B;EiE1xNE;IAAwB,sBAAA;EjE6xN1B;AACF;AiB1uNI;EgDtDA;IAAwB,sBAAA;EjEoyN1B;EiEnyNE;IAAwB,uBAAA;EjEsyN1B;EiEryNE;IAAwB,sBAAA;EjEwyN1B;AACF;AiBrvNI;EgDtDA;IAAwB,sBAAA;EjE+yN1B;EiE9yNE;IAAwB,uBAAA;EjEizN1B;EiEhzNE;IAAwB,sBAAA;EjEmzN1B;AACF;AiBhwNI;EgDtDA;IAAwB,sBAAA;EjE0zN1B;EiEzzNE;IAAwB,uBAAA;EjE4zN1B;EiE3zNE;IAAwB,sBAAA;EjE8zN1B;AACF;AkEp0NE;EAAyB,2BAAA;AlEu0N3B;;AkEv0NE;EAAyB,4BAAA;AlE20N3B;;AkE30NE;EAAyB,4BAAA;AlE+0N3B;;AmE/0NE;EAAsB,yBAAA;AnEm1NxB;;AmEn1NE;EAAsB,2BAAA;AnEu1NxB;;AoEt1NE;EAAyB,2BAAA;ApE01N3B;;AoE11NE;EAAyB,6BAAA;ApE81N3B;;AoE91NE;EAAyB,6BAAA;ApEk2N3B;;AoEl2NE;EAAyB,0BAAA;ApEs2N3B;;AoEt2NE;EAAyB,2BAAA;ApE02N3B;;AoEr2NA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a/Dufa;ALi3Mf;;AoEr2NA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a/D+ea;ALy3Mf;;AoEp2NE;EADF;IAEI,gBAAA;IACA,MAAA;IACA,a/DueY;ELi4Md;AACF;;AqEl4NA;ECEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AtEo4NF;;AsE13NE;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;AtE43NJ;;AuEz5NA;EAAa,8DAAA;AvE65Nb;;AuE55NA;EAAU,wDAAA;AvEg6NV;;AuE/5NA;EAAa,uDAAA;AvEm6Nb;;AuEl6NA;EAAe,2BAAA;AvEs6Nf;;AwEr6NI;EAAuB,qBAAA;AxEy6N3B;;AwEz6NI;EAAuB,qBAAA;AxE66N3B;;AwE76NI;EAAuB,qBAAA;AxEi7N3B;;AwEj7NI;EAAuB,sBAAA;AxEq7N3B;;AwEr7NI;EAAuB,sBAAA;AxEy7N3B;;AwEz7NI;EAAuB,sBAAA;AxE67N3B;;AwE77NI;EAAuB,sBAAA;AxEi8N3B;;AwEj8NI;EAAuB,sBAAA;AxEq8N3B;;AwEr8NI;EAAuB,uBAAA;AxEy8N3B;;AwEz8NI;EAAuB,uBAAA;AxE68N3B;;AwEz8NA;EAAU,0BAAA;AxE68NV;;AwE58NA;EAAU,2BAAA;AxEg9NV;;AwE58NA;EAAc,2BAAA;AxEg9Nd;;AwE/8NA;EAAc,4BAAA;AxEm9Nd;;AwEj9NA;EAAU,uBAAA;AxEq9NV;;AwEp9NA;EAAU,wBAAA;AxEw9NV;;AyEj+NQ;EAAgC,oBAAA;AzEq+NxC;;AyEp+NQ;;EAEE,wBAAA;AzEu+NV;;AyEr+NQ;;EAEE,0BAAA;AzEw+NV;;AyEt+NQ;;EAEE,2BAAA;AzEy+NV;;AyEv+NQ;;EAEE,yBAAA;AzE0+NV;;AyEz/NQ;EAAgC,0BAAA;AzE6/NxC;;AyE5/NQ;;EAEE,8BAAA;AzE+/NV;;AyE7/NQ;;EAEE,gCAAA;AzEggOV;;AyE9/NQ;;EAEE,iCAAA;AzEigOV;;AyE//NQ;;EAEE,+BAAA;AzEkgOV;;AyEjhOQ;EAAgC,yBAAA;AzEqhOxC;;AyEphOQ;;EAEE,6BAAA;AzEuhOV;;AyErhOQ;;EAEE,+BAAA;AzEwhOV;;AyEthOQ;;EAEE,gCAAA;AzEyhOV;;AyEvhOQ;;EAEE,8BAAA;AzE0hOV;;AyEziOQ;EAAgC,uBAAA;AzE6iOxC;;AyE5iOQ;;EAEE,2BAAA;AzE+iOV;;AyE7iOQ;;EAEE,6BAAA;AzEgjOV;;AyE9iOQ;;EAEE,8BAAA;AzEijOV;;AyE/iOQ;;EAEE,4BAAA;AzEkjOV;;AyEjkOQ;EAAgC,yBAAA;AzEqkOxC;;AyEpkOQ;;EAEE,6BAAA;AzEukOV;;AyErkOQ;;EAEE,+BAAA;AzEwkOV;;AyEtkOQ;;EAEE,gCAAA;AzEykOV;;AyEvkOQ;;EAEE,8BAAA;AzE0kOV;;AyEzlOQ;EAAgC,uBAAA;AzE6lOxC;;AyE5lOQ;;EAEE,2BAAA;AzE+lOV;;AyE7lOQ;;EAEE,6BAAA;AzEgmOV;;AyE9lOQ;;EAEE,8BAAA;AzEimOV;;AyE/lOQ;;EAEE,4BAAA;AzEkmOV;;AyEjnOQ;EAAgC,qBAAA;AzEqnOxC;;AyEpnOQ;;EAEE,yBAAA;AzEunOV;;AyErnOQ;;EAEE,2BAAA;AzEwnOV;;AyEtnOQ;;EAEE,4BAAA;AzEynOV;;AyEvnOQ;;EAEE,0BAAA;AzE0nOV;;AyEzoOQ;EAAgC,2BAAA;AzE6oOxC;;AyE5oOQ;;EAEE,+BAAA;AzE+oOV;;AyE7oOQ;;EAEE,iCAAA;AzEgpOV;;AyE9oOQ;;EAEE,kCAAA;AzEipOV;;AyE/oOQ;;EAEE,gCAAA;AzEkpOV;;AyEjqOQ;EAAgC,0BAAA;AzEqqOxC;;AyEpqOQ;;EAEE,8BAAA;AzEuqOV;;AyErqOQ;;EAEE,gCAAA;AzEwqOV;;AyEtqOQ;;EAEE,iCAAA;AzEyqOV;;AyEvqOQ;;EAEE,+BAAA;AzE0qOV;;AyEzrOQ;EAAgC,wBAAA;AzE6rOxC;;AyE5rOQ;;EAEE,4BAAA;AzE+rOV;;AyE7rOQ;;EAEE,8BAAA;AzEgsOV;;AyE9rOQ;;EAEE,+BAAA;AzEisOV;;AyE/rOQ;;EAEE,6BAAA;AzEksOV;;AyEjtOQ;EAAgC,0BAAA;AzEqtOxC;;AyEptOQ;;EAEE,8BAAA;AzEutOV;;AyErtOQ;;EAEE,gCAAA;AzEwtOV;;AyEttOQ;;EAEE,iCAAA;AzEytOV;;AyEvtOQ;;EAEE,+BAAA;AzE0tOV;;AyEzuOQ;EAAgC,wBAAA;AzE6uOxC;;AyE5uOQ;;EAEE,4BAAA;AzE+uOV;;AyE7uOQ;;EAEE,8BAAA;AzEgvOV;;AyE9uOQ;;EAEE,+BAAA;AzEivOV;;AyE/uOQ;;EAEE,6BAAA;AzEkvOV;;AyE1uOQ;EAAwB,2BAAA;AzE8uOhC;;AyE7uOQ;;EAEE,+BAAA;AzEgvOV;;AyE9uOQ;;EAEE,iCAAA;AzEivOV;;AyE/uOQ;;EAEE,kCAAA;AzEkvOV;;AyEhvOQ;;EAEE,gCAAA;AzEmvOV;;AyElwOQ;EAAwB,0BAAA;AzEswOhC;;AyErwOQ;;EAEE,8BAAA;AzEwwOV;;AyEtwOQ;;EAEE,gCAAA;AzEywOV;;AyEvwOQ;;EAEE,iCAAA;AzE0wOV;;AyExwOQ;;EAEE,+BAAA;AzE2wOV;;AyE1xOQ;EAAwB,wBAAA;AzE8xOhC;;AyE7xOQ;;EAEE,4BAAA;AzEgyOV;;AyE9xOQ;;EAEE,8BAAA;AzEiyOV;;AyE/xOQ;;EAEE,+BAAA;AzEkyOV;;AyEhyOQ;;EAEE,6BAAA;AzEmyOV;;AyElzOQ;EAAwB,0BAAA;AzEszOhC;;AyErzOQ;;EAEE,8BAAA;AzEwzOV;;AyEtzOQ;;EAEE,gCAAA;AzEyzOV;;AyEvzOQ;;EAEE,iCAAA;AzE0zOV;;AyExzOQ;;EAEE,+BAAA;AzE2zOV;;AyE10OQ;EAAwB,wBAAA;AzE80OhC;;AyE70OQ;;EAEE,4BAAA;AzEg1OV;;AyE90OQ;;EAEE,8BAAA;AzEi1OV;;AyE/0OQ;;EAEE,+BAAA;AzEk1OV;;AyEh1OQ;;EAEE,6BAAA;AzEm1OV;;AyE70OI;EAAmB,uBAAA;AzEi1OvB;;AyEh1OI;;EAEE,2BAAA;AzEm1ON;;AyEj1OI;;EAEE,6BAAA;AzEo1ON;;AyEl1OI;;EAEE,8BAAA;AzEq1ON;;AyEn1OI;;EAEE,4BAAA;AzEs1ON;;AiB/1OI;EwDlDI;IAAgC,oBAAA;EzEs5OtC;EyEr5OM;;IAEE,wBAAA;EzEu5OR;EyEr5OM;;IAEE,0BAAA;EzEu5OR;EyEr5OM;;IAEE,2BAAA;EzEu5OR;EyEr5OM;;IAEE,yBAAA;EzEu5OR;EyEt6OM;IAAgC,0BAAA;EzEy6OtC;EyEx6OM;;IAEE,8BAAA;EzE06OR;EyEx6OM;;IAEE,gCAAA;EzE06OR;EyEx6OM;;IAEE,iCAAA;EzE06OR;EyEx6OM;;IAEE,+BAAA;EzE06OR;EyEz7OM;IAAgC,yBAAA;EzE47OtC;EyE37OM;;IAEE,6BAAA;EzE67OR;EyE37OM;;IAEE,+BAAA;EzE67OR;EyE37OM;;IAEE,gCAAA;EzE67OR;EyE37OM;;IAEE,8BAAA;EzE67OR;EyE58OM;IAAgC,uBAAA;EzE+8OtC;EyE98OM;;IAEE,2BAAA;EzEg9OR;EyE98OM;;IAEE,6BAAA;EzEg9OR;EyE98OM;;IAEE,8BAAA;EzEg9OR;EyE98OM;;IAEE,4BAAA;EzEg9OR;EyE/9OM;IAAgC,yBAAA;EzEk+OtC;EyEj+OM;;IAEE,6BAAA;EzEm+OR;EyEj+OM;;IAEE,+BAAA;EzEm+OR;EyEj+OM;;IAEE,gCAAA;EzEm+OR;EyEj+OM;;IAEE,8BAAA;EzEm+OR;EyEl/OM;IAAgC,uBAAA;EzEq/OtC;EyEp/OM;;IAEE,2BAAA;EzEs/OR;EyEp/OM;;IAEE,6BAAA;EzEs/OR;EyEp/OM;;IAEE,8BAAA;EzEs/OR;EyEp/OM;;IAEE,4BAAA;EzEs/OR;EyErgPM;IAAgC,qBAAA;EzEwgPtC;EyEvgPM;;IAEE,yBAAA;EzEygPR;EyEvgPM;;IAEE,2BAAA;EzEygPR;EyEvgPM;;IAEE,4BAAA;EzEygPR;EyEvgPM;;IAEE,0BAAA;EzEygPR;EyExhPM;IAAgC,2BAAA;EzE2hPtC;EyE1hPM;;IAEE,+BAAA;EzE4hPR;EyE1hPM;;IAEE,iCAAA;EzE4hPR;EyE1hPM;;IAEE,kCAAA;EzE4hPR;EyE1hPM;;IAEE,gCAAA;EzE4hPR;EyE3iPM;IAAgC,0BAAA;EzE8iPtC;EyE7iPM;;IAEE,8BAAA;EzE+iPR;EyE7iPM;;IAEE,gCAAA;EzE+iPR;EyE7iPM;;IAEE,iCAAA;EzE+iPR;EyE7iPM;;IAEE,+BAAA;EzE+iPR;EyE9jPM;IAAgC,wBAAA;EzEikPtC;EyEhkPM;;IAEE,4BAAA;EzEkkPR;EyEhkPM;;IAEE,8BAAA;EzEkkPR;EyEhkPM;;IAEE,+BAAA;EzEkkPR;EyEhkPM;;IAEE,6BAAA;EzEkkPR;EyEjlPM;IAAgC,0BAAA;EzEolPtC;EyEnlPM;;IAEE,8BAAA;EzEqlPR;EyEnlPM;;IAEE,gCAAA;EzEqlPR;EyEnlPM;;IAEE,iCAAA;EzEqlPR;EyEnlPM;;IAEE,+BAAA;EzEqlPR;EyEpmPM;IAAgC,wBAAA;EzEumPtC;EyEtmPM;;IAEE,4BAAA;EzEwmPR;EyEtmPM;;IAEE,8BAAA;EzEwmPR;EyEtmPM;;IAEE,+BAAA;EzEwmPR;EyEtmPM;;IAEE,6BAAA;EzEwmPR;EyEhmPM;IAAwB,2BAAA;EzEmmP9B;EyElmPM;;IAEE,+BAAA;EzEomPR;EyElmPM;;IAEE,iCAAA;EzEomPR;EyElmPM;;IAEE,kCAAA;EzEomPR;EyElmPM;;IAEE,gCAAA;EzEomPR;EyEnnPM;IAAwB,0BAAA;EzEsnP9B;EyErnPM;;IAEE,8BAAA;EzEunPR;EyErnPM;;IAEE,gCAAA;EzEunPR;EyErnPM;;IAEE,iCAAA;EzEunPR;EyErnPM;;IAEE,+BAAA;EzEunPR;EyEtoPM;IAAwB,wBAAA;EzEyoP9B;EyExoPM;;IAEE,4BAAA;EzE0oPR;EyExoPM;;IAEE,8BAAA;EzE0oPR;EyExoPM;;IAEE,+BAAA;EzE0oPR;EyExoPM;;IAEE,6BAAA;EzE0oPR;EyEzpPM;IAAwB,0BAAA;EzE4pP9B;EyE3pPM;;IAEE,8BAAA;EzE6pPR;EyE3pPM;;IAEE,gCAAA;EzE6pPR;EyE3pPM;;IAEE,iCAAA;EzE6pPR;EyE3pPM;;IAEE,+BAAA;EzE6pPR;EyE5qPM;IAAwB,wBAAA;EzE+qP9B;EyE9qPM;;IAEE,4BAAA;EzEgrPR;EyE9qPM;;IAEE,8BAAA;EzEgrPR;EyE9qPM;;IAEE,+BAAA;EzEgrPR;EyE9qPM;;IAEE,6BAAA;EzEgrPR;EyE1qPE;IAAmB,uBAAA;EzE6qPrB;EyE5qPE;;IAEE,2BAAA;EzE8qPJ;EyE5qPE;;IAEE,6BAAA;EzE8qPJ;EyE5qPE;;IAEE,8BAAA;EzE8qPJ;EyE5qPE;;IAEE,4BAAA;EzE8qPJ;AACF;AiBxrPI;EwDlDI;IAAgC,oBAAA;EzE8uPtC;EyE7uPM;;IAEE,wBAAA;EzE+uPR;EyE7uPM;;IAEE,0BAAA;EzE+uPR;EyE7uPM;;IAEE,2BAAA;EzE+uPR;EyE7uPM;;IAEE,yBAAA;EzE+uPR;EyE9vPM;IAAgC,0BAAA;EzEiwPtC;EyEhwPM;;IAEE,8BAAA;EzEkwPR;EyEhwPM;;IAEE,gCAAA;EzEkwPR;EyEhwPM;;IAEE,iCAAA;EzEkwPR;EyEhwPM;;IAEE,+BAAA;EzEkwPR;EyEjxPM;IAAgC,yBAAA;EzEoxPtC;EyEnxPM;;IAEE,6BAAA;EzEqxPR;EyEnxPM;;IAEE,+BAAA;EzEqxPR;EyEnxPM;;IAEE,gCAAA;EzEqxPR;EyEnxPM;;IAEE,8BAAA;EzEqxPR;EyEpyPM;IAAgC,uBAAA;EzEuyPtC;EyEtyPM;;IAEE,2BAAA;EzEwyPR;EyEtyPM;;IAEE,6BAAA;EzEwyPR;EyEtyPM;;IAEE,8BAAA;EzEwyPR;EyEtyPM;;IAEE,4BAAA;EzEwyPR;EyEvzPM;IAAgC,yBAAA;EzE0zPtC;EyEzzPM;;IAEE,6BAAA;EzE2zPR;EyEzzPM;;IAEE,+BAAA;EzE2zPR;EyEzzPM;;IAEE,gCAAA;EzE2zPR;EyEzzPM;;IAEE,8BAAA;EzE2zPR;EyE10PM;IAAgC,uBAAA;EzE60PtC;EyE50PM;;IAEE,2BAAA;EzE80PR;EyE50PM;;IAEE,6BAAA;EzE80PR;EyE50PM;;IAEE,8BAAA;EzE80PR;EyE50PM;;IAEE,4BAAA;EzE80PR;EyE71PM;IAAgC,qBAAA;EzEg2PtC;EyE/1PM;;IAEE,yBAAA;EzEi2PR;EyE/1PM;;IAEE,2BAAA;EzEi2PR;EyE/1PM;;IAEE,4BAAA;EzEi2PR;EyE/1PM;;IAEE,0BAAA;EzEi2PR;EyEh3PM;IAAgC,2BAAA;EzEm3PtC;EyEl3PM;;IAEE,+BAAA;EzEo3PR;EyEl3PM;;IAEE,iCAAA;EzEo3PR;EyEl3PM;;IAEE,kCAAA;EzEo3PR;EyEl3PM;;IAEE,gCAAA;EzEo3PR;EyEn4PM;IAAgC,0BAAA;EzEs4PtC;EyEr4PM;;IAEE,8BAAA;EzEu4PR;EyEr4PM;;IAEE,gCAAA;EzEu4PR;EyEr4PM;;IAEE,iCAAA;EzEu4PR;EyEr4PM;;IAEE,+BAAA;EzEu4PR;EyEt5PM;IAAgC,wBAAA;EzEy5PtC;EyEx5PM;;IAEE,4BAAA;EzE05PR;EyEx5PM;;IAEE,8BAAA;EzE05PR;EyEx5PM;;IAEE,+BAAA;EzE05PR;EyEx5PM;;IAEE,6BAAA;EzE05PR;EyEz6PM;IAAgC,0BAAA;EzE46PtC;EyE36PM;;IAEE,8BAAA;EzE66PR;EyE36PM;;IAEE,gCAAA;EzE66PR;EyE36PM;;IAEE,iCAAA;EzE66PR;EyE36PM;;IAEE,+BAAA;EzE66PR;EyE57PM;IAAgC,wBAAA;EzE+7PtC;EyE97PM;;IAEE,4BAAA;EzEg8PR;EyE97PM;;IAEE,8BAAA;EzEg8PR;EyE97PM;;IAEE,+BAAA;EzEg8PR;EyE97PM;;IAEE,6BAAA;EzEg8PR;EyEx7PM;IAAwB,2BAAA;EzE27P9B;EyE17PM;;IAEE,+BAAA;EzE47PR;EyE17PM;;IAEE,iCAAA;EzE47PR;EyE17PM;;IAEE,kCAAA;EzE47PR;EyE17PM;;IAEE,gCAAA;EzE47PR;EyE38PM;IAAwB,0BAAA;EzE88P9B;EyE78PM;;IAEE,8BAAA;EzE+8PR;EyE78PM;;IAEE,gCAAA;EzE+8PR;EyE78PM;;IAEE,iCAAA;EzE+8PR;EyE78PM;;IAEE,+BAAA;EzE+8PR;EyE99PM;IAAwB,wBAAA;EzEi+P9B;EyEh+PM;;IAEE,4BAAA;EzEk+PR;EyEh+PM;;IAEE,8BAAA;EzEk+PR;EyEh+PM;;IAEE,+BAAA;EzEk+PR;EyEh+PM;;IAEE,6BAAA;EzEk+PR;EyEj/PM;IAAwB,0BAAA;EzEo/P9B;EyEn/PM;;IAEE,8BAAA;EzEq/PR;EyEn/PM;;IAEE,gCAAA;EzEq/PR;EyEn/PM;;IAEE,iCAAA;EzEq/PR;EyEn/PM;;IAEE,+BAAA;EzEq/PR;EyEpgQM;IAAwB,wBAAA;EzEugQ9B;EyEtgQM;;IAEE,4BAAA;EzEwgQR;EyEtgQM;;IAEE,8BAAA;EzEwgQR;EyEtgQM;;IAEE,+BAAA;EzEwgQR;EyEtgQM;;IAEE,6BAAA;EzEwgQR;EyElgQE;IAAmB,uBAAA;EzEqgQrB;EyEpgQE;;IAEE,2BAAA;EzEsgQJ;EyEpgQE;;IAEE,6BAAA;EzEsgQJ;EyEpgQE;;IAEE,8BAAA;EzEsgQJ;EyEpgQE;;IAEE,4BAAA;EzEsgQJ;AACF;AiBhhQI;EwDlDI;IAAgC,oBAAA;EzEskQtC;EyErkQM;;IAEE,wBAAA;EzEukQR;EyErkQM;;IAEE,0BAAA;EzEukQR;EyErkQM;;IAEE,2BAAA;EzEukQR;EyErkQM;;IAEE,yBAAA;EzEukQR;EyEtlQM;IAAgC,0BAAA;EzEylQtC;EyExlQM;;IAEE,8BAAA;EzE0lQR;EyExlQM;;IAEE,gCAAA;EzE0lQR;EyExlQM;;IAEE,iCAAA;EzE0lQR;EyExlQM;;IAEE,+BAAA;EzE0lQR;EyEzmQM;IAAgC,yBAAA;EzE4mQtC;EyE3mQM;;IAEE,6BAAA;EzE6mQR;EyE3mQM;;IAEE,+BAAA;EzE6mQR;EyE3mQM;;IAEE,gCAAA;EzE6mQR;EyE3mQM;;IAEE,8BAAA;EzE6mQR;EyE5nQM;IAAgC,uBAAA;EzE+nQtC;EyE9nQM;;IAEE,2BAAA;EzEgoQR;EyE9nQM;;IAEE,6BAAA;EzEgoQR;EyE9nQM;;IAEE,8BAAA;EzEgoQR;EyE9nQM;;IAEE,4BAAA;EzEgoQR;EyE/oQM;IAAgC,yBAAA;EzEkpQtC;EyEjpQM;;IAEE,6BAAA;EzEmpQR;EyEjpQM;;IAEE,+BAAA;EzEmpQR;EyEjpQM;;IAEE,gCAAA;EzEmpQR;EyEjpQM;;IAEE,8BAAA;EzEmpQR;EyElqQM;IAAgC,uBAAA;EzEqqQtC;EyEpqQM;;IAEE,2BAAA;EzEsqQR;EyEpqQM;;IAEE,6BAAA;EzEsqQR;EyEpqQM;;IAEE,8BAAA;EzEsqQR;EyEpqQM;;IAEE,4BAAA;EzEsqQR;EyErrQM;IAAgC,qBAAA;EzEwrQtC;EyEvrQM;;IAEE,yBAAA;EzEyrQR;EyEvrQM;;IAEE,2BAAA;EzEyrQR;EyEvrQM;;IAEE,4BAAA;EzEyrQR;EyEvrQM;;IAEE,0BAAA;EzEyrQR;EyExsQM;IAAgC,2BAAA;EzE2sQtC;EyE1sQM;;IAEE,+BAAA;EzE4sQR;EyE1sQM;;IAEE,iCAAA;EzE4sQR;EyE1sQM;;IAEE,kCAAA;EzE4sQR;EyE1sQM;;IAEE,gCAAA;EzE4sQR;EyE3tQM;IAAgC,0BAAA;EzE8tQtC;EyE7tQM;;IAEE,8BAAA;EzE+tQR;EyE7tQM;;IAEE,gCAAA;EzE+tQR;EyE7tQM;;IAEE,iCAAA;EzE+tQR;EyE7tQM;;IAEE,+BAAA;EzE+tQR;EyE9uQM;IAAgC,wBAAA;EzEivQtC;EyEhvQM;;IAEE,4BAAA;EzEkvQR;EyEhvQM;;IAEE,8BAAA;EzEkvQR;EyEhvQM;;IAEE,+BAAA;EzEkvQR;EyEhvQM;;IAEE,6BAAA;EzEkvQR;EyEjwQM;IAAgC,0BAAA;EzEowQtC;EyEnwQM;;IAEE,8BAAA;EzEqwQR;EyEnwQM;;IAEE,gCAAA;EzEqwQR;EyEnwQM;;IAEE,iCAAA;EzEqwQR;EyEnwQM;;IAEE,+BAAA;EzEqwQR;EyEpxQM;IAAgC,wBAAA;EzEuxQtC;EyEtxQM;;IAEE,4BAAA;EzEwxQR;EyEtxQM;;IAEE,8BAAA;EzEwxQR;EyEtxQM;;IAEE,+BAAA;EzEwxQR;EyEtxQM;;IAEE,6BAAA;EzEwxQR;EyEhxQM;IAAwB,2BAAA;EzEmxQ9B;EyElxQM;;IAEE,+BAAA;EzEoxQR;EyElxQM;;IAEE,iCAAA;EzEoxQR;EyElxQM;;IAEE,kCAAA;EzEoxQR;EyElxQM;;IAEE,gCAAA;EzEoxQR;EyEnyQM;IAAwB,0BAAA;EzEsyQ9B;EyEryQM;;IAEE,8BAAA;EzEuyQR;EyEryQM;;IAEE,gCAAA;EzEuyQR;EyEryQM;;IAEE,iCAAA;EzEuyQR;EyEryQM;;IAEE,+BAAA;EzEuyQR;EyEtzQM;IAAwB,wBAAA;EzEyzQ9B;EyExzQM;;IAEE,4BAAA;EzE0zQR;EyExzQM;;IAEE,8BAAA;EzE0zQR;EyExzQM;;IAEE,+BAAA;EzE0zQR;EyExzQM;;IAEE,6BAAA;EzE0zQR;EyEz0QM;IAAwB,0BAAA;EzE40Q9B;EyE30QM;;IAEE,8BAAA;EzE60QR;EyE30QM;;IAEE,gCAAA;EzE60QR;EyE30QM;;IAEE,iCAAA;EzE60QR;EyE30QM;;IAEE,+BAAA;EzE60QR;EyE51QM;IAAwB,wBAAA;EzE+1Q9B;EyE91QM;;IAEE,4BAAA;EzEg2QR;EyE91QM;;IAEE,8BAAA;EzEg2QR;EyE91QM;;IAEE,+BAAA;EzEg2QR;EyE91QM;;IAEE,6BAAA;EzEg2QR;EyE11QE;IAAmB,uBAAA;EzE61QrB;EyE51QE;;IAEE,2BAAA;EzE81QJ;EyE51QE;;IAEE,6BAAA;EzE81QJ;EyE51QE;;IAEE,8BAAA;EzE81QJ;EyE51QE;;IAEE,4BAAA;EzE81QJ;AACF;AiBx2QI;EwDlDI;IAAgC,oBAAA;EzE85QtC;EyE75QM;;IAEE,wBAAA;EzE+5QR;EyE75QM;;IAEE,0BAAA;EzE+5QR;EyE75QM;;IAEE,2BAAA;EzE+5QR;EyE75QM;;IAEE,yBAAA;EzE+5QR;EyE96QM;IAAgC,0BAAA;EzEi7QtC;EyEh7QM;;IAEE,8BAAA;EzEk7QR;EyEh7QM;;IAEE,gCAAA;EzEk7QR;EyEh7QM;;IAEE,iCAAA;EzEk7QR;EyEh7QM;;IAEE,+BAAA;EzEk7QR;EyEj8QM;IAAgC,yBAAA;EzEo8QtC;EyEn8QM;;IAEE,6BAAA;EzEq8QR;EyEn8QM;;IAEE,+BAAA;EzEq8QR;EyEn8QM;;IAEE,gCAAA;EzEq8QR;EyEn8QM;;IAEE,8BAAA;EzEq8QR;EyEp9QM;IAAgC,uBAAA;EzEu9QtC;EyEt9QM;;IAEE,2BAAA;EzEw9QR;EyEt9QM;;IAEE,6BAAA;EzEw9QR;EyEt9QM;;IAEE,8BAAA;EzEw9QR;EyEt9QM;;IAEE,4BAAA;EzEw9QR;EyEv+QM;IAAgC,yBAAA;EzE0+QtC;EyEz+QM;;IAEE,6BAAA;EzE2+QR;EyEz+QM;;IAEE,+BAAA;EzE2+QR;EyEz+QM;;IAEE,gCAAA;EzE2+QR;EyEz+QM;;IAEE,8BAAA;EzE2+QR;EyE1/QM;IAAgC,uBAAA;EzE6/QtC;EyE5/QM;;IAEE,2BAAA;EzE8/QR;EyE5/QM;;IAEE,6BAAA;EzE8/QR;EyE5/QM;;IAEE,8BAAA;EzE8/QR;EyE5/QM;;IAEE,4BAAA;EzE8/QR;EyE7gRM;IAAgC,qBAAA;EzEghRtC;EyE/gRM;;IAEE,yBAAA;EzEihRR;EyE/gRM;;IAEE,2BAAA;EzEihRR;EyE/gRM;;IAEE,4BAAA;EzEihRR;EyE/gRM;;IAEE,0BAAA;EzEihRR;EyEhiRM;IAAgC,2BAAA;EzEmiRtC;EyEliRM;;IAEE,+BAAA;EzEoiRR;EyEliRM;;IAEE,iCAAA;EzEoiRR;EyEliRM;;IAEE,kCAAA;EzEoiRR;EyEliRM;;IAEE,gCAAA;EzEoiRR;EyEnjRM;IAAgC,0BAAA;EzEsjRtC;EyErjRM;;IAEE,8BAAA;EzEujRR;EyErjRM;;IAEE,gCAAA;EzEujRR;EyErjRM;;IAEE,iCAAA;EzEujRR;EyErjRM;;IAEE,+BAAA;EzEujRR;EyEtkRM;IAAgC,wBAAA;EzEykRtC;EyExkRM;;IAEE,4BAAA;EzE0kRR;EyExkRM;;IAEE,8BAAA;EzE0kRR;EyExkRM;;IAEE,+BAAA;EzE0kRR;EyExkRM;;IAEE,6BAAA;EzE0kRR;EyEzlRM;IAAgC,0BAAA;EzE4lRtC;EyE3lRM;;IAEE,8BAAA;EzE6lRR;EyE3lRM;;IAEE,gCAAA;EzE6lRR;EyE3lRM;;IAEE,iCAAA;EzE6lRR;EyE3lRM;;IAEE,+BAAA;EzE6lRR;EyE5mRM;IAAgC,wBAAA;EzE+mRtC;EyE9mRM;;IAEE,4BAAA;EzEgnRR;EyE9mRM;;IAEE,8BAAA;EzEgnRR;EyE9mRM;;IAEE,+BAAA;EzEgnRR;EyE9mRM;;IAEE,6BAAA;EzEgnRR;EyExmRM;IAAwB,2BAAA;EzE2mR9B;EyE1mRM;;IAEE,+BAAA;EzE4mRR;EyE1mRM;;IAEE,iCAAA;EzE4mRR;EyE1mRM;;IAEE,kCAAA;EzE4mRR;EyE1mRM;;IAEE,gCAAA;EzE4mRR;EyE3nRM;IAAwB,0BAAA;EzE8nR9B;EyE7nRM;;IAEE,8BAAA;EzE+nRR;EyE7nRM;;IAEE,gCAAA;EzE+nRR;EyE7nRM;;IAEE,iCAAA;EzE+nRR;EyE7nRM;;IAEE,+BAAA;EzE+nRR;EyE9oRM;IAAwB,wBAAA;EzEipR9B;EyEhpRM;;IAEE,4BAAA;EzEkpRR;EyEhpRM;;IAEE,8BAAA;EzEkpRR;EyEhpRM;;IAEE,+BAAA;EzEkpRR;EyEhpRM;;IAEE,6BAAA;EzEkpRR;EyEjqRM;IAAwB,0BAAA;EzEoqR9B;EyEnqRM;;IAEE,8BAAA;EzEqqRR;EyEnqRM;;IAEE,gCAAA;EzEqqRR;EyEnqRM;;IAEE,iCAAA;EzEqqRR;EyEnqRM;;IAEE,+BAAA;EzEqqRR;EyEprRM;IAAwB,wBAAA;EzEurR9B;EyEtrRM;;IAEE,4BAAA;EzEwrRR;EyEtrRM;;IAEE,8BAAA;EzEwrRR;EyEtrRM;;IAEE,+BAAA;EzEwrRR;EyEtrRM;;IAEE,6BAAA;EzEwrRR;EyElrRE;IAAmB,uBAAA;EzEqrRrB;EyEprRE;;IAEE,2BAAA;EzEsrRJ;EyEprRE;;IAEE,6BAAA;EzEsrRJ;EyEprRE;;IAEE,8BAAA;EzEsrRJ;EyEprRE;;IAEE,4BAAA;EzEsrRJ;AACF;A0EvvRE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EAEA,oBAAA;EACA,WAAA;EAEA,kCAAA;A1EuvRJ;;A2EjwRA;EAAkB,4GAAA;A3EqwRlB;;A2EjwRA;EAAiB,8BAAA;A3EqwRjB;;A2EpwRA;EAAiB,8BAAA;A3EwwRjB;;A2EvwRA;EAAiB,8BAAA;A3E2wRjB;;A2E1wRA;ECTE,gBAAA;EACA,uBAAA;EACA,mBAAA;A5EuxRF;;A2ExwRI;EAAwB,2BAAA;A3E4wR5B;;A2E3wRI;EAAwB,4BAAA;A3E+wR5B;;A2E9wRI;EAAwB,6BAAA;A3EkxR5B;;AiB7uRI;E0DvCA;IAAwB,2BAAA;E3EyxR1B;E2ExxRE;IAAwB,4BAAA;E3E2xR1B;E2E1xRE;IAAwB,6BAAA;E3E6xR1B;AACF;AiBzvRI;E0DvCA;IAAwB,2BAAA;E3EoyR1B;E2EnyRE;IAAwB,4BAAA;E3EsyR1B;E2EryRE;IAAwB,6BAAA;E3EwyR1B;AACF;AiBpwRI;E0DvCA;IAAwB,2BAAA;E3E+yR1B;E2E9yRE;IAAwB,4BAAA;E3EizR1B;E2EhzRE;IAAwB,6BAAA;E3EmzR1B;AACF;AiB/wRI;E0DvCA;IAAwB,2BAAA;E3E0zR1B;E2EzzRE;IAAwB,4BAAA;E3E4zR1B;E2E3zRE;IAAwB,6BAAA;E3E8zR1B;AACF;A2EzzRA;EAAmB,oCAAA;A3E4zRnB;;A2E3zRA;EAAmB,oCAAA;A3E+zRnB;;A2E9zRA;EAAmB,qCAAA;A3Ek0RnB;;A2E9zRA;EAAuB,2BAAA;A3Ek0RvB;;A2Ej0RA;EAAuB,+BAAA;A3Eq0RvB;;A2Ep0RA;EAAuB,2BAAA;A3Ew0RvB;;A2Ev0RA;EAAuB,2BAAA;A3E20RvB;;A2E10RA;EAAuB,8BAAA;A3E80RvB;;A2E70RA;EAAuB,6BAAA;A3Ei1RvB;;A2E70RA;EAAc,sBAAA;A3Ei1Rd;;A6Ex3RE;EACE,yBAAA;A7E23RJ;;AQj3RE;EqELM,yBAAA;A7E03RR;;A6Eh4RE;EACE,yBAAA;A7Em4RJ;;AQz3RE;EqELM,yBAAA;A7Ek4RR;;A6Ex4RE;EACE,yBAAA;A7E24RJ;;AQj4RE;EqELM,yBAAA;A7E04RR;;A6Eh5RE;EACE,yBAAA;A7Em5RJ;;AQz4RE;EqELM,yBAAA;A7Ek5RR;;A6Ex5RE;EACE,yBAAA;A7E25RJ;;AQj5RE;EqELM,yBAAA;A7E05RR;;A6Eh6RE;EACE,yBAAA;A7Em6RJ;;AQz5RE;EqELM,yBAAA;A7Ek6RR;;A6Ex6RE;EACE,yBAAA;A7E26RJ;;AQj6RE;EqELM,yBAAA;A7E06RR;;A6Eh7RE;EACE,yBAAA;A7Em7RJ;;AQz6RE;EqELM,yBAAA;A7Ek7RR;;A2E34RA;EAAa,yBAAA;A3E+4Rb;;A2E94RA;EAAc,yBAAA;A3Ek5Rd;;A2Eh5RA;EAAiB,oCAAA;A3Eo5RjB;;A2En5RA;EAAiB,0CAAA;A3Eu5RjB;;A2En5RA;EGvDE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,SAAA;A9E88RF;;A2Ev5RA;EAAwB,gCAAA;A3E25RxB;;A2Ez5RA;EACE,iCAAA;EACA,gCAAA;A3E45RF;;A2Ev5RA;EAAc,yBAAA;A3E25Rd;;A+E59RA;EACE,8BAAA;A/E+9RF;;A+E59RA;EACE,6BAAA;A/E+9RF;;AgF/9RE;EACE;;;IAKE,4BAAA;IAEA,2BAAA;EhF+9RJ;EgF39RI;IACE,0BAAA;EhF69RN;EgFp9RE;IACE,6BAAA;EhFs9RJ;EgFx8RE;IACE,gCAAA;EhF08RJ;EgFx8RE;;IAEE,yBAAA;IACA,wBAAA;EhF08RJ;EgFv8RE;;IAEE,wBAAA;EhFy8RJ;EgFt8RE;;;IAGE,UAAA;IACA,SAAA;EhFw8RJ;EgFr8RE;;IAEE,uBAAA;EhFu8RJ;EgF/7RE;IACE,QzE2iC8B;EPs5PlC;EgF/7RE;IACE,2BAAA;EhFi8RJ;EgF/7RE;IACE,2BAAA;EhFi8RJ;EgF77RE;IACE,aAAA;EhF+7RJ;EgF77RE;IACE,sBAAA;EhF+7RJ;EgF57RE;IACE,oCAAA;EhF87RJ;EgF57RI;;IAEE,iCAAA;EhF87RN;EgFz7RI;;IAEE,oCAAA;EhF27RN;EgFv7RE;IACE,cAAA;EhFy7RJ;EgFv7RI;;;;IAIE,qB3E9GG;ELuiST;EgFr7RE;IACE,cAAA;IACA,qB3EpHK;EL2iST;AACF;AiFtjSA,4BAAA;ACAA;EACE,oCAAA;EACA,6CAAA;EACA,yPAAA;EAIA,mBAAA;EACA,kBAAA;AlFsjSF;AmF9jSA;;EAEE,qBAAA;EACA,yDAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mCAAA;EACA,kCAAA;AnFgkSF;;AoFvkSI;EACI,iBAAA;ApF0kSR;;AoF3kSI;EACI,iBAAA;ApF8kSR;;AoF/kSI;EACI,iBAAA;ApFklSR;;AoFnlSI;EACI,iBAAA;ApFslSR;;AoFvlSI;EACI,iBAAA;ApF0lSR;;AoF3lSI;EACI,iBAAA;ApF8lSR;;AoF/lSI;EACI,iBAAA;ApFkmSR;;AoFnmSI;EACI,iBAAA;ApFsmSR;;AoFvmSI;EACI,iBAAA;ApF0mSR;;AoF3mSI;EACI,iBAAA;ApF8mSR;;AoF/mSI;EACI,iBAAA;ApFknSR;;AoFnnSI;EACI,iBAAA;ApFsnSR;;AoFvnSI;EACI,iBAAA;ApF0nSR;;AoF3nSI;EACI,iBAAA;ApF8nSR;;AoF/nSI;EACI,iBAAA;ApFkoSR;;AoFnoSI;EACI,iBAAA;ApFsoSR;;AoFvoSI;EACI,iBAAA;ApF0oSR;;AoF3oSI;EACI,iBAAA;ApF8oSR;;AoF/oSI;EACI,iBAAA;ApFkpSR;;AoFnpSI;EACI,iBAAA;ApFspSR;;AoFvpSI;EACI,iBAAA;ApF0pSR;;AoF3pSI;EACI,iBAAA;ApF8pSR;;AoF/pSI;EACI,iBAAA;ApFkqSR;;AoFnqSI;EACI,iBAAA;ApFsqSR;;AoFvqSI;EACI,iBAAA;ApF0qSR;;AoF3qSI;EACI,iBAAA;ApF8qSR;;AoF/qSI;EACI,iBAAA;ApFkrSR;;AoFnrSI;EACI,iBAAA;ApFsrSR;;AoFvrSI;EACI,iBAAA;ApF0rSR;;AoF3rSI;EACI,iBAAA;ApF8rSR;;AoF/rSI;EACI,iBAAA;ApFksSR;;AoFnsSI;EACI,iBAAA;ApFssSR;;AoFvsSI;EACI,iBAAA;ApF0sSR;;AoF3sSI;EACI,iBAAA;ApF8sSR;;AoF/sSI;EACI,iBAAA;ApFktSR;;AoFntSI;EACI,iBAAA;ApFstSR;;AoFvtSI;EACI,iBAAA;ApF0tSR;;AoF3tSI;EACI,iBAAA;ApF8tSR;;AoF/tSI;EACI,iBAAA;ApFkuSR;;AoFnuSI;EACI,iBAAA;ApFsuSR;;AoFvuSI;EACI,iBAAA;ApF0uSR;;AoF3uSI;EACI,iBAAA;ApF8uSR;;AoF/uSI;EACI,iBAAA;ApFkvSR;;AoFnvSI;EACI,iBAAA;ApFsvSR;;AoFvvSI;EACI,iBAAA;ApF0vSR;;AoF3vSI;EACI,iBAAA;ApF8vSR;;AoF/vSI;EACI,iBAAA;ApFkwSR;;AoFnwSI;EACI,iBAAA;ApFswSR;;AoFvwSI;EACI,iBAAA;ApF0wSR;;AoF3wSI;EACI,iBAAA;ApF8wSR;;AoF/wSI;EACI,iBAAA;ApFkxSR;;AoFnxSI;EACI,iBAAA;ApFsxSR;;AoFvxSI;EACI,iBAAA;ApF0xSR;;AoF3xSI;EACI,iBAAA;ApF8xSR;;AoF/xSI;EACI,iBAAA;ApFkySR;;AoFnySI;EACI,iBAAA;ApFsySR;;AoFvySI;EACI,iBAAA;ApF0ySR;;AoF3ySI;EACI,iBAAA;ApF8ySR;;AoF/ySI;EACI,iBAAA;ApFkzSR;;AoFnzSI;EACI,iBAAA;ApFszSR;;AoFvzSI;EACI,iBAAA;ApF0zSR;;AoF3zSI;EACI,iBAAA;ApF8zSR;;AoF/zSI;EACI,iBAAA;ApFk0SR;;AoFn0SI;EACI,iBAAA;ApFs0SR;;AoFv0SI;EACI,iBAAA;ApF00SR;;AoF30SI;EACI,iBAAA;ApF80SR;;AoF/0SI;EACI,iBAAA;ApFk1SR;;AoFn1SI;EACI,iBAAA;ApFs1SR;;AoFv1SI;EACI,iBAAA;ApF01SR;;AoF31SI;EACI,iBAAA;ApF81SR;;AoF/1SI;EACI,iBAAA;ApFk2SR;;AoFn2SI;EACI,iBAAA;ApFs2SR;;AoFv2SI;EACI,iBAAA;ApF02SR;;AoF32SI;EACI,iBAAA;ApF82SR;;AoF/2SI;EACI,iBAAA;ApFk3SR;;AoFn3SI;EACI,iBAAA;ApFs3SR;;AoFv3SI;EACI,iBAAA;ApF03SR;;AoF33SI;EACI,iBAAA;ApF83SR;;AoF/3SI;EACI,iBAAA;ApFk4SR;;AoFn4SI;EACI,iBAAA;ApFs4SR;;AoFv4SI;EACI,iBAAA;ApF04SR;;AoF34SI;EACI,iBAAA;ApF84SR;;AoF/4SI;EACI,iBAAA;ApFk5SR;;AoFn5SI;EACI,iBAAA;ApFs5SR;;AoFv5SI;EACI,iBAAA;ApF05SR;;AoF35SI;EACI,iBAAA;ApF85SR;;AoF/5SI;EACI,iBAAA;ApFk6SR;;AoFn6SI;EACI,iBAAA;ApFs6SR;;AoFv6SI;EACI,iBAAA;ApF06SR;;AoF36SI;EACI,iBAAA;ApF86SR;;AoF/6SI;EACI,iBAAA;ApFk7SR;;AoFn7SI;EACI,iBAAA;ApFs7SR;;AoFv7SI;EACI,iBAAA;ApF07SR;;AoF37SI;EACI,iBAAA;ApF87SR;;AoF/7SI;EACI,iBAAA;ApFk8SR;;AoFn8SI;EACI,iBAAA;ApFs8SR;;AoFv8SI;EACI,iBAAA;ApF08SR;;AoF38SI;EACI,iBAAA;ApF88SR;;AoF/8SI;EACI,iBAAA;ApFk9SR;;AoFn9SI;EACI,iBAAA;ApFs9SR;;AoFv9SI;EACI,iBAAA;ApF09SR;;AoF39SI;EACI,iBAAA;ApF89SR;;AoF/9SI;EACI,iBAAA;ApFk+SR;;AoFn+SI;EACI,iBAAA;ApFs+SR;;AoFv+SI;EACI,iBAAA;ApF0+SR;;AoF3+SI;EACI,iBAAA;ApF8+SR;;AoF/+SI;EACI,iBAAA;ApFk/SR;;AoFn/SI;EACI,iBAAA;ApFs/SR;;AoFv/SI;EACI,iBAAA;ApF0/SR;;AoF3/SI;EACI,iBAAA;ApF8/SR;;AoF//SI;EACI,iBAAA;ApFkgTR;;AoFngTI;EACI,iBAAA;ApFsgTR;;AoFvgTI;EACI,iBAAA;ApF0gTR;;AoF3gTI;EACI,iBAAA;ApF8gTR;;AoF/gTI;EACI,iBAAA;ApFkhTR;;AoFnhTI;EACI,iBAAA;ApFshTR;;AoFvhTI;EACI,iBAAA;ApF0hTR;;AoF3hTI;EACI,iBAAA;ApF8hTR;;AoF/hTI;EACI,iBAAA;ApFkiTR;;AoFniTI;EACI,iBAAA;ApFsiTR;;AoFviTI;EACI,iBAAA;ApF0iTR;;AoF3iTI;EACI,iBAAA;ApF8iTR;;AoF/iTI;EACI,iBAAA;ApFkjTR;;AoFnjTI;EACI,iBAAA;ApFsjTR;;AoFvjTI;EACI,iBAAA;ApF0jTR;;AoF3jTI;EACI,iBAAA;ApF8jTR;;AoF/jTI;EACI,iBAAA;ApFkkTR;;AoFnkTI;EACI,iBAAA;ApFskTR;;AoFvkTI;EACI,iBAAA;ApF0kTR;;AoF3kTI;EACI,iBAAA;ApF8kTR;;AoF/kTI;EACI,iBAAA;ApFklTR;;AoFnlTI;EACI,iBAAA;ApFslTR;;AoFvlTI;EACI,iBAAA;ApF0lTR;;AoF3lTI;EACI,iBAAA;ApF8lTR;;AoF/lTI;EACI,iBAAA;ApFkmTR;;AoFnmTI;EACI,iBAAA;ApFsmTR;;AoFvmTI;EACI,iBAAA;ApF0mTR;;AoF3mTI;EACI,iBAAA;ApF8mTR;;AoF/mTI;EACI,iBAAA;ApFknTR;;AoFnnTI;EACI,iBAAA;ApFsnTR;;AoFvnTI;EACI,iBAAA;ApF0nTR;;AoF3nTI;EACI,iBAAA;ApF8nTR;;AoF/nTI;EACI,iBAAA;ApFkoTR;;AoFnoTI;EACI,iBAAA;ApFsoTR;;AoFvoTI;EACI,iBAAA;ApF0oTR;;AoF3oTI;EACI,iBAAA;ApF8oTR;;AoF/oTI;EACI,iBAAA;ApFkpTR;;AoFnpTI;EACI,iBAAA;ApFspTR;;AoFvpTI;EACI,iBAAA;ApF0pTR;;AoF3pTI;EACI,iBAAA;ApF8pTR;;AoF/pTI;EACI,iBAAA;ApFkqTR;;AoFnqTI;EACI,iBAAA;ApFsqTR;;AoFvqTI;EACI,iBAAA;ApF0qTR;;AoF3qTI;EACI,iBAAA;ApF8qTR;;AoF/qTI;EACI,iBAAA;ApFkrTR;;AoFnrTI;EACI,iBAAA;ApFsrTR;;AoFvrTI;EACI,iBAAA;ApF0rTR;;AoF3rTI;EACI,iBAAA;ApF8rTR;;AoF/rTI;EACI,iBAAA;ApFksTR;;AoFnsTI;EACI,iBAAA;ApFssTR;;AoFvsTI;EACI,iBAAA;ApF0sTR;;AoF3sTI;EACI,iBAAA;ApF8sTR;;AoF/sTI;EACI,iBAAA;ApFktTR;;AoFntTI;EACI,iBAAA;ApFstTR;;AoFvtTI;EACI,iBAAA;ApF0tTR;;AoF3tTI;EACI,iBAAA;ApF8tTR;;AoF/tTI;EACI,iBAAA;ApFkuTR;;AoFnuTI;EACI,iBAAA;ApFsuTR;;AoFvuTI;EACI,iBAAA;ApF0uTR;;AoF3uTI;EACI,iBAAA;ApF8uTR;;AoF/uTI;EACI,iBAAA;ApFkvTR;;AoFnvTI;EACI,iBAAA;ApFsvTR;;AoFvvTI;EACI,iBAAA;ApF0vTR;;AoF3vTI;EACI,iBAAA;ApF8vTR;;AoF/vTI;EACI,iBAAA;ApFkwTR;;AoFnwTI;EACI,iBAAA;ApFswTR;;AoFvwTI;EACI,iBAAA;ApF0wTR;;AoF3wTI;EACI,iBAAA;ApF8wTR;;AoF/wTI;EACI,iBAAA;ApFkxTR;;AoFnxTI;EACI,iBAAA;ApFsxTR;;AoFvxTI;EACI,iBAAA;ApF0xTR;;AoF3xTI;EACI,iBAAA;ApF8xTR;;AoF/xTI;EACI,iBAAA;ApFkyTR;;AoFnyTI;EACI,iBAAA;ApFsyTR;;AoFvyTI;EACI,iBAAA;ApF0yTR;;AoF3yTI;EACI,iBAAA;ApF8yTR;;AoF/yTI;EACI,iBAAA;ApFkzTR;;AoFnzTI;EACI,iBAAA;ApFszTR;;AoFvzTI;EACI,iBAAA;ApF0zTR;;AoF3zTI;EACI,iBAAA;ApF8zTR;;AoF/zTI;EACI,iBAAA;ApFk0TR;;AoFn0TI;EACI,iBAAA;ApFs0TR;;AoFv0TI;EACI,iBAAA;ApF00TR;;AoF30TI;EACI,iBAAA;ApF80TR;;AoF/0TI;EACI,iBAAA;ApFk1TR;;AoFn1TI;EACI,iBAAA;ApFs1TR;;AoFv1TI;EACI,iBAAA;ApF01TR;;AoF31TI;EACI,iBAAA;ApF81TR;;AoF/1TI;EACI,iBAAA;ApFk2TR;;AoFn2TI;EACI,iBAAA;ApFs2TR;;AoFv2TI;EACI,iBAAA;ApF02TR;;AoF32TI;EACI,iBAAA;ApF82TR;;AoF/2TI;EACI,iBAAA;ApFk3TR;;AoFn3TI;EACI,iBAAA;ApFs3TR;;AoFv3TI;EACI,iBAAA;ApF03TR;;AoF33TI;EACI,iBAAA;ApF83TR;;AoF/3TI;EACI,iBAAA;ApFk4TR;;AoFn4TI;EACI,iBAAA;ApFs4TR;;AoFv4TI;EACI,iBAAA;ApF04TR;;AoF34TI;EACI,iBAAA;ApF84TR;;AoF/4TI;EACI,iBAAA;ApFk5TR;;AoFn5TI;EACI,iBAAA;ApFs5TR;;AoFv5TI;EACI,iBAAA;ApF05TR;;AoF35TI;EACI,iBAAA;ApF85TR;;AoF/5TI;EACI,iBAAA;ApFk6TR;;AoFn6TI;EACI,iBAAA;ApFs6TR;;AoFv6TI;EACI,iBAAA;ApF06TR;;AoF36TI;EACI,iBAAA;ApF86TR;;AoF/6TI;EACI,iBAAA;ApFk7TR;;AoFn7TI;EACI,iBAAA;ApFs7TR;;AoFv7TI;EACI,iBAAA;ApF07TR;;AoF37TI;EACI,iBAAA;ApF87TR;;AoF/7TI;EACI,iBAAA;ApFk8TR;;AoFn8TI;EACI,iBAAA;ApFs8TR;;AoFv8TI;EACI,iBAAA;ApF08TR;;AoF38TI;EACI,iBAAA;ApF88TR;;AoF/8TI;EACI,iBAAA;ApFk9TR;;AoFn9TI;EACI,iBAAA;ApFs9TR;;AoFv9TI;EACI,iBAAA;ApF09TR;;AoF39TI;EACI,iBAAA;ApF89TR;;AoF/9TI;EACI,iBAAA;ApFk+TR;;AoFn+TI;EACI,iBAAA;ApFs+TR;;AoFv+TI;EACI,iBAAA;ApF0+TR;;AoF3+TI;EACI,iBAAA;ApF8+TR;;AoF/+TI;EACI,iBAAA;ApFk/TR;;AoFn/TI;EACI,iBAAA;ApFs/TR;;AoFv/TI;EACI,iBAAA;ApF0/TR;;AoF3/TI;EACI,iBAAA;ApF8/TR;;AoF//TI;EACI,iBAAA;ApFkgUR;;AoFngUI;EACI,iBAAA;ApFsgUR;;AoFvgUI;EACI,iBAAA;ApF0gUR;;AoF3gUI;EACI,iBAAA;ApF8gUR;;AoF/gUI;EACI,iBAAA;ApFkhUR;;AoFnhUI;EACI,iBAAA;ApFshUR;;AoFvhUI;EACI,iBAAA;ApF0hUR;;AoF3hUI;EACI,iBAAA;ApF8hUR;;AoF/hUI;EACI,iBAAA;ApFkiUR;;AoFniUI;EACI,iBAAA;ApFsiUR;;AoFviUI;EACI,iBAAA;ApF0iUR;;AoF3iUI;EACI,iBAAA;ApF8iUR;;AoF/iUI;EACI,iBAAA;ApFkjUR;;AoFnjUI;EACI,iBAAA;ApFsjUR;;AoFvjUI;EACI,iBAAA;ApF0jUR;;AoF3jUI;EACI,iBAAA;ApF8jUR;;AoF/jUI;EACI,iBAAA;ApFkkUR;;AoFnkUI;EACI,iBAAA;ApFskUR;;AoFvkUI;EACI,iBAAA;ApF0kUR;;AoF3kUI;EACI,iBAAA;ApF8kUR;;AoF/kUI;EACI,iBAAA;ApFklUR;;AoFnlUI;EACI,iBAAA;ApFslUR;;AoFvlUI;EACI,iBAAA;ApF0lUR;;AoF3lUI;EACI,iBAAA;ApF8lUR;;AoF/lUI;EACI,iBAAA;ApFkmUR;;AoFnmUI;EACI,iBAAA;ApFsmUR;;AoFvmUI;EACI,iBAAA;ApF0mUR;;AoF3mUI;EACI,iBAAA;ApF8mUR;;AoF/mUI;EACI,iBAAA;ApFknUR;;AoFnnUI;EACI,iBAAA;ApFsnUR;;AoFvnUI;EACI,iBAAA;ApF0nUR;;AoF3nUI;EACI,iBAAA;ApF8nUR;;AoF/nUI;EACI,iBAAA;ApFkoUR;;AoFnoUI;EACI,iBAAA;ApFsoUR;;AoFvoUI;EACI,iBAAA;ApF0oUR;;AoF3oUI;EACI,iBAAA;ApF8oUR;;AoF/oUI;EACI,iBAAA;ApFkpUR;;AoFnpUI;EACI,iBAAA;ApFspUR;;AoFvpUI;EACI,iBAAA;ApF0pUR;;AoF3pUI;EACI,iBAAA;ApF8pUR;;AoF/pUI;EACI,iBAAA;ApFkqUR;;AoFnqUI;EACI,iBAAA;ApFsqUR;;AoFvqUI;EACI,iBAAA;ApF0qUR;;AoF3qUI;EACI,iBAAA;ApF8qUR;;AoF/qUI;EACI,iBAAA;ApFkrUR;;AoFnrUI;EACI,iBAAA;ApFsrUR;;AoFvrUI;EACI,iBAAA;ApF0rUR;;AoF3rUI;EACI,iBAAA;ApF8rUR;;AoF/rUI;EACI,iBAAA;ApFksUR;;AoFnsUI;EACI,iBAAA;ApFssUR;;AoFvsUI;EACI,iBAAA;ApF0sUR;;AoF3sUI;EACI,iBAAA;ApF8sUR;;AoF/sUI;EACI,iBAAA;ApFktUR;;AoFntUI;EACI,iBAAA;ApFstUR;;AoFvtUI;EACI,iBAAA;ApF0tUR;;AoF3tUI;EACI,iBAAA;ApF8tUR;;AoF/tUI;EACI,iBAAA;ApFkuUR;;AoFnuUI;EACI,iBAAA;ApFsuUR;;AoFvuUI;EACI,iBAAA;ApF0uUR;;AoF3uUI;EACI,iBAAA;ApF8uUR;;AoF/uUI;EACI,iBAAA;ApFkvUR;;AoFnvUI;EACI,iBAAA;ApFsvUR;;AoFvvUI;EACI,iBAAA;ApF0vUR;;AoF3vUI;EACI,iBAAA;ApF8vUR;;AoF/vUI;EACI,iBAAA;ApFkwUR;;AoFnwUI;EACI,iBAAA;ApFswUR;;AoFvwUI;EACI,iBAAA;ApF0wUR;;AoF3wUI;EACI,iBAAA;ApF8wUR;;AoF/wUI;EACI,iBAAA;ApFkxUR;;AoFnxUI;EACI,iBAAA;ApFsxUR;;AoFvxUI;EACI,iBAAA;ApF0xUR;;AoF3xUI;EACI,iBAAA;ApF8xUR;;AoF/xUI;EACI,iBAAA;ApFkyUR;;AoFnyUI;EACI,iBAAA;ApFsyUR;;AoFvyUI;EACI,iBAAA;ApF0yUR;;AoF3yUI;EACI,iBAAA;ApF8yUR;;AoF/yUI;EACI,iBAAA;ApFkzUR;;AoFnzUI;EACI,iBAAA;ApFszUR;;AoFvzUI;EACI,iBAAA;ApF0zUR;;AoF3zUI;EACI,iBAAA;ApF8zUR;;AoF/zUI;EACI,iBAAA;ApFk0UR;;AoFn0UI;EACI,iBAAA;ApFs0UR;;AoFv0UI;EACI,iBAAA;ApF00UR;;AoF30UI;EACI,iBAAA;ApF80UR;;AoF/0UI;EACI,iBAAA;ApFk1UR;;AoFn1UI;EACI,iBAAA;ApFs1UR;;AoFv1UI;EACI,iBAAA;ApF01UR;;AoF31UI;EACI,iBAAA;ApF81UR;;AoF/1UI;EACI,iBAAA;ApFk2UR;;AoFn2UI;EACI,iBAAA;ApFs2UR;;AoFv2UI;EACI,iBAAA;ApF02UR;;AoF32UI;EACI,iBAAA;ApF82UR;;AoF/2UI;EACI,iBAAA;ApFk3UR;;AoFn3UI;EACI,iBAAA;ApFs3UR;;AoFv3UI;EACI,iBAAA;ApF03UR;;AoF33UI;EACI,iBAAA;ApF83UR;;AoF/3UI;EACI,iBAAA;ApFk4UR;;AoFn4UI;EACI,iBAAA;ApFs4UR;;AoFv4UI;EACI,iBAAA;ApF04UR;;AoF34UI;EACI,iBAAA;ApF84UR;;AoF/4UI;EACI,iBAAA;ApFk5UR;;AoFn5UI;EACI,iBAAA;ApFs5UR;;AoFv5UI;EACI,iBAAA;ApF05UR;;AoF35UI;EACI,iBAAA;ApF85UR;;AoF/5UI;EACI,iBAAA;ApFk6UR;;AoFn6UI;EACI,iBAAA;ApFs6UR;;AoFv6UI;EACI,iBAAA;ApF06UR;;AoF36UI;EACI,iBAAA;ApF86UR;;AoF/6UI;EACI,iBAAA;ApFk7UR;;AoFn7UI;EACI,iBAAA;ApFs7UR;;AoFv7UI;EACI,iBAAA;ApF07UR;;AoF37UI;EACI,iBAAA;ApF87UR;;AoF/7UI;EACI,iBAAA;ApFk8UR;;AoFn8UI;EACI,iBAAA;ApFs8UR;;AoFv8UI;EACI,iBAAA;ApF08UR;;AoF38UI;EACI,iBAAA;ApF88UR;;AoF/8UI;EACI,iBAAA;ApFk9UR;;AoFn9UI;EACI,iBAAA;ApFs9UR;;AoFv9UI;EACI,iBAAA;ApF09UR;;AoF39UI;EACI,iBAAA;ApF89UR;;AoF/9UI;EACI,iBAAA;ApFk+UR;;AoFn+UI;EACI,iBAAA;ApFs+UR;;AoFv+UI;EACI,iBAAA;ApF0+UR;;AoF3+UI;EACI,iBAAA;ApF8+UR;;AoF/+UI;EACI,iBAAA;ApFk/UR;;AoFn/UI;EACI,iBAAA;ApFs/UR;;AoFv/UI;EACI,iBAAA;ApF0/UR;;AoF3/UI;EACI,iBAAA;ApF8/UR;;AoF//UI;EACI,iBAAA;ApFkgVR;;AoFngVI;EACI,iBAAA;ApFsgVR;;AoFvgVI;EACI,iBAAA;ApF0gVR;;AoF3gVI;EACI,iBAAA;ApF8gVR;;AoF/gVI;EACI,iBAAA;ApFkhVR;;AoFnhVI;EACI,iBAAA;ApFshVR;;AoFvhVI;EACI,iBAAA;ApF0hVR;;AoF3hVI;EACI,iBAAA;ApF8hVR;;AoF/hVI;EACI,iBAAA;ApFkiVR;;AoFniVI;EACI,iBAAA;ApFsiVR;;AoFviVI;EACI,iBAAA;ApF0iVR;;AoF3iVI;EACI,iBAAA;ApF8iVR;;AoF/iVI;EACI,iBAAA;ApFkjVR;;AoFnjVI;EACI,iBAAA;ApFsjVR;;AoFvjVI;EACI,iBAAA;ApF0jVR;;AoF3jVI;EACI,iBAAA;ApF8jVR;;AoF/jVI;EACI,iBAAA;ApFkkVR;;AoFnkVI;EACI,iBAAA;ApFskVR;;AoFvkVI;EACI,iBAAA;ApF0kVR;;AoF3kVI;EACI,iBAAA;ApF8kVR;;AoF/kVI;EACI,iBAAA;ApFklVR;;AoFnlVI;EACI,iBAAA;ApFslVR;;AoFvlVI;EACI,iBAAA;ApF0lVR;;AoF3lVI;EACI,iBAAA;ApF8lVR;;AoF/lVI;EACI,iBAAA;ApFkmVR;;AoFnmVI;EACI,iBAAA;ApFsmVR;;AoFvmVI;EACI,iBAAA;ApF0mVR;;AoF3mVI;EACI,iBAAA;ApF8mVR;;AoF/mVI;EACI,iBAAA;ApFknVR;;AoFnnVI;EACI,iBAAA;ApFsnVR;;AoFvnVI;EACI,iBAAA;ApF0nVR;;AoF3nVI;EACI,iBAAA;ApF8nVR;;AoF/nVI;EACI,iBAAA;ApFkoVR;;AoFnoVI;EACI,iBAAA;ApFsoVR;;AoFvoVI;EACI,iBAAA;ApF0oVR;;AoF3oVI;EACI,iBAAA;ApF8oVR;;AoF/oVI;EACI,iBAAA;ApFkpVR;;AoFnpVI;EACI,iBAAA;ApFspVR;;AoFvpVI;EACI,iBAAA;ApF0pVR;;AoF3pVI;EACI,iBAAA;ApF8pVR;;AoF/pVI;EACI,iBAAA;ApFkqVR;;AoFnqVI;EACI,iBAAA;ApFsqVR;;AoFvqVI;EACI,iBAAA;ApF0qVR;;AoF3qVI;EACI,iBAAA;ApF8qVR;;AoF/qVI;EACI,iBAAA;ApFkrVR;;AoFnrVI;EACI,iBAAA;ApFsrVR;;AoFvrVI;EACI,iBAAA;ApF0rVR;;AoF3rVI;EACI,iBAAA;ApF8rVR;;AoF/rVI;EACI,iBAAA;ApFksVR;;AoFnsVI;EACI,iBAAA;ApFssVR;;AoFvsVI;EACI,iBAAA;ApF0sVR;;AoF3sVI;EACI,iBAAA;ApF8sVR;;AoF/sVI;EACI,iBAAA;ApFktVR;;AoFntVI;EACI,iBAAA;ApFstVR;;AoFvtVI;EACI,iBAAA;ApF0tVR;;AoF3tVI;EACI,iBAAA;ApF8tVR;;AoF/tVI;EACI,iBAAA;ApFkuVR;;AoFnuVI;EACI,iBAAA;ApFsuVR;;AoFvuVI;EACI,iBAAA;ApF0uVR;;AoF3uVI;EACI,iBAAA;ApF8uVR;;AoF/uVI;EACI,iBAAA;ApFkvVR;;AoFnvVI;EACI,iBAAA;ApFsvVR;;AoFvvVI;EACI,iBAAA;ApF0vVR;;AoF3vVI;EACI,iBAAA;ApF8vVR;;AoF/vVI;EACI,iBAAA;ApFkwVR;;AoFnwVI;EACI,iBAAA;ApFswVR;;AoFvwVI;EACI,iBAAA;ApF0wVR;;AoF3wVI;EACI,iBAAA;ApF8wVR;;AoF/wVI;EACI,iBAAA;ApFkxVR;;AoFnxVI;EACI,iBAAA;ApFsxVR;;AoFvxVI;EACI,iBAAA;ApF0xVR;;AoF3xVI;EACI,iBAAA;ApF8xVR;;AoF/xVI;EACI,iBAAA;ApFkyVR;;AoFnyVI;EACI,iBAAA;ApFsyVR;;AoFvyVI;EACI,iBAAA;ApF0yVR;;AoF3yVI;EACI,iBAAA;ApF8yVR;;AoF/yVI;EACI,iBAAA;ApFkzVR;;AoFnzVI;EACI,iBAAA;ApFszVR;;AoFvzVI;EACI,iBAAA;ApF0zVR;;AoF3zVI;EACI,iBAAA;ApF8zVR;;AoF/zVI;EACI,iBAAA;ApFk0VR;;AoFn0VI;EACI,iBAAA;ApFs0VR;;AoFv0VI;EACI,iBAAA;ApF00VR;;AoF30VI;EACI,iBAAA;ApF80VR;;AoF/0VI;EACI,iBAAA;ApFk1VR;;AoFn1VI;EACI,iBAAA;ApFs1VR;;AoFv1VI;EACI,iBAAA;ApF01VR;;AoF31VI;EACI,iBAAA;ApF81VR;;AoF/1VI;EACI,iBAAA;ApFk2VR;;AoFn2VI;EACI,iBAAA;ApFs2VR;;AoFv2VI;EACI,iBAAA;ApF02VR;;AoF32VI;EACI,iBAAA;ApF82VR;;AoF/2VI;EACI,iBAAA;ApFk3VR;;AoFn3VI;EACI,iBAAA;ApFs3VR;;AoFv3VI;EACI,iBAAA;ApF03VR;;AoF33VI;EACI,iBAAA;ApF83VR;;AoF/3VI;EACI,iBAAA;ApFk4VR;;AoFn4VI;EACI,iBAAA;ApFs4VR;;AoFv4VI;EACI,iBAAA;ApF04VR;;AoF34VI;EACI,iBAAA;ApF84VR;;AoF/4VI;EACI,iBAAA;ApFk5VR;;AoFn5VI;EACI,iBAAA;ApFs5VR;;AoFv5VI;EACI,iBAAA;ApF05VR;;AoF35VI;EACI,iBAAA;ApF85VR;;AoF/5VI;EACI,iBAAA;ApFk6VR;;AoFn6VI;EACI,iBAAA;ApFs6VR;;AoFv6VI;EACI,iBAAA;ApF06VR;;AoF36VI;EACI,iBAAA;ApF86VR;;AoF/6VI;EACI,iBAAA;ApFk7VR;;AoFn7VI;EACI,iBAAA;ApFs7VR;;AoFv7VI;EACI,iBAAA;ApF07VR;;AoF37VI;EACI,iBAAA;ApF87VR;;AoF/7VI;EACI,iBAAA;ApFk8VR;;AoFn8VI;EACI,iBAAA;ApFs8VR;;AoFv8VI;EACI,iBAAA;ApF08VR;;AoF38VI;EACI,iBAAA;ApF88VR;;AoF/8VI;EACI,iBAAA;ApFk9VR;;AoFn9VI;EACI,iBAAA;ApFs9VR;;AoFv9VI;EACI,iBAAA;ApF09VR;;AoF39VI;EACI,iBAAA;ApF89VR;;AoF/9VI;EACI,iBAAA;ApFk+VR;;AoFn+VI;EACI,iBAAA;ApFs+VR;;AoFv+VI;EACI,iBAAA;ApF0+VR;;AoF3+VI;EACI,iBAAA;ApF8+VR;;AoF/+VI;EACI,iBAAA;ApFk/VR;;AoFn/VI;EACI,iBAAA;ApFs/VR;;AoFv/VI;EACI,iBAAA;ApF0/VR;;AoF3/VI;EACI,iBAAA;ApF8/VR;;AoF//VI;EACI,iBAAA;ApFkgWR;;AoFngWI;EACI,iBAAA;ApFsgWR;;AoFvgWI;EACI,iBAAA;ApF0gWR;;AoF3gWI;EACI,iBAAA;ApF8gWR;;AoF/gWI;EACI,iBAAA;ApFkhWR;;AoFnhWI;EACI,iBAAA;ApFshWR;;AoFvhWI;EACI,iBAAA;ApF0hWR;;AoF3hWI;EACI,iBAAA;ApF8hWR;;AoF/hWI;EACI,iBAAA;ApFkiWR;;AoFniWI;EACI,iBAAA;ApFsiWR;;AoFviWI;EACI,iBAAA;ApF0iWR;;AoF3iWI;EACI,iBAAA;ApF8iWR;;AoF/iWI;EACI,iBAAA;ApFkjWR;;AoFnjWI;EACI,iBAAA;ApFsjWR;;AoFvjWI;EACI,iBAAA;ApF0jWR;;AoF3jWI;EACI,iBAAA;ApF8jWR;;AoF/jWI;EACI,iBAAA;ApFkkWR;;AoFnkWI;EACI,iBAAA;ApFskWR;;AoFvkWI;EACI,iBAAA;ApF0kWR;;AoF3kWI;EACI,iBAAA;ApF8kWR;;AoF/kWI;EACI,iBAAA;ApFklWR;;AoFnlWI;EACI,iBAAA;ApFslWR;;AoFvlWI;EACI,iBAAA;ApF0lWR;;AoF3lWI;EACI,iBAAA;ApF8lWR;;AoF/lWI;EACI,iBAAA;ApFkmWR;;AoFnmWI;EACI,iBAAA;ApFsmWR;;AoFvmWI;EACI,iBAAA;ApF0mWR;;AoF3mWI;EACI,iBAAA;ApF8mWR;;AoF/mWI;EACI,iBAAA;ApFknWR;;AoFnnWI;EACI,iBAAA;ApFsnWR;;AoFvnWI;EACI,iBAAA;ApF0nWR;;AoF3nWI;EACI,iBAAA;ApF8nWR;;AoF/nWI;EACI,iBAAA;ApFkoWR;;AoFnoWI;EACI,iBAAA;ApFsoWR;;AoFvoWI;EACI,iBAAA;ApF0oWR;;AoF3oWI;EACI,iBAAA;ApF8oWR;;AoF/oWI;EACI,iBAAA;ApFkpWR;;AoFnpWI;EACI,iBAAA;ApFspWR;;AoFvpWI;EACI,iBAAA;ApF0pWR;;AoF3pWI;EACI,iBAAA;ApF8pWR;;AoF/pWI;EACI,iBAAA;ApFkqWR;;AoFnqWI;EACI,iBAAA;ApFsqWR;;AoFvqWI;EACI,iBAAA;ApF0qWR;;AoF3qWI;EACI,iBAAA;ApF8qWR;;AoF/qWI;EACI,iBAAA;ApFkrWR;;AoFnrWI;EACI,iBAAA;ApFsrWR;;AoFvrWI;EACI,iBAAA;ApF0rWR;;AoF3rWI;EACI,iBAAA;ApF8rWR;;AoF/rWI;EACI,iBAAA;ApFksWR;;AoFnsWI;EACI,iBAAA;ApFssWR;;AoFvsWI;EACI,iBAAA;ApF0sWR;;AoF3sWI;EACI,iBAAA;ApF8sWR;;AoF/sWI;EACI,iBAAA;ApFktWR;;AoFntWI;EACI,iBAAA;ApFstWR;;AoFvtWI;EACI,iBAAA;ApF0tWR;;AoF3tWI;EACI,iBAAA;ApF8tWR;;AoF/tWI;EACI,iBAAA;ApFkuWR;;AoFnuWI;EACI,iBAAA;ApFsuWR;;AoFvuWI;EACI,iBAAA;ApF0uWR;;AoF3uWI;EACI,iBAAA;ApF8uWR;;AoF/uWI;EACI,iBAAA;ApFkvWR;;AoFnvWI;EACI,iBAAA;ApFsvWR;;AoFvvWI;EACI,iBAAA;ApF0vWR;;AoF3vWI;EACI,iBAAA;ApF8vWR;;AoF/vWI;EACI,iBAAA;ApFkwWR;;AoFnwWI;EACI,iBAAA;ApFswWR;;AoFvwWI;EACI,iBAAA;ApF0wWR;;AoF3wWI;EACI,iBAAA;ApF8wWR;;AoF/wWI;EACI,iBAAA;ApFkxWR;;AoFnxWI;EACI,iBAAA;ApFsxWR;;AoFvxWI;EACI,iBAAA;ApF0xWR;;AoF3xWI;EACI,iBAAA;ApF8xWR;;AoF/xWI;EACI,iBAAA;ApFkyWR;;AoFnyWI;EACI,iBAAA;ApFsyWR;;AoFvyWI;EACI,iBAAA;ApF0yWR;;AoF3yWI;EACI,iBAAA;ApF8yWR;;AoF/yWI;EACI,iBAAA;ApFkzWR;;AoFnzWI;EACI,iBAAA;ApFszWR;;AoFvzWI;EACI,iBAAA;ApF0zWR;;AoF3zWI;EACI,iBAAA;ApF8zWR;;AoF/zWI;EACI,iBAAA;ApFk0WR;;AoFn0WI;EACI,iBAAA;ApFs0WR;;AoFv0WI;EACI,iBAAA;ApF00WR;;AoF30WI;EACI,iBAAA;ApF80WR;;AoF/0WI;EACI,iBAAA;ApFk1WR;;AoFn1WI;EACI,iBAAA;ApFs1WR;;AoFv1WI;EACI,iBAAA;ApF01WR;;AoF31WI;EACI,iBAAA;ApF81WR;;AoF/1WI;EACI,iBAAA;ApFk2WR;;AoFn2WI;EACI,iBAAA;ApFs2WR;;AoFv2WI;EACI,iBAAA;ApF02WR;;AoF32WI;EACI,iBAAA;ApF82WR;;AoF/2WI;EACI,iBAAA;ApFk3WR;;AoFn3WI;EACI,iBAAA;ApFs3WR;;AoFv3WI;EACI,iBAAA;ApF03WR;;AoF33WI;EACI,iBAAA;ApF83WR;;AoF/3WI;EACI,iBAAA;ApFk4WR;;AoFn4WI;EACI,iBAAA;ApFs4WR;;AoFv4WI;EACI,iBAAA;ApF04WR;;AoF34WI;EACI,iBAAA;ApF84WR;;AoF/4WI;EACI,iBAAA;ApFk5WR;;AoFn5WI;EACI,iBAAA;ApFs5WR;;AoFv5WI;EACI,iBAAA;ApF05WR;;AoF35WI;EACI,iBAAA;ApF85WR;;AoF/5WI;EACI,iBAAA;ApFk6WR;;AoFn6WI;EACI,iBAAA;ApFs6WR;;AoFv6WI;EACI,iBAAA;ApF06WR;;AoF36WI;EACI,iBAAA;ApF86WR;;AoF/6WI;EACI,iBAAA;ApFk7WR;;AoFn7WI;EACI,iBAAA;ApFs7WR;;AoFv7WI;EACI,iBAAA;ApF07WR;;AoF37WI;EACI,iBAAA;ApF87WR;;AoF/7WI;EACI,iBAAA;ApFk8WR;;AoFn8WI;EACI,iBAAA;ApFs8WR;;AoFv8WI;EACI,iBAAA;ApF08WR;;AoF38WI;EACI,iBAAA;ApF88WR;;AoF/8WI;EACI,iBAAA;ApFk9WR;;AoFn9WI;EACI,iBAAA;ApFs9WR;;AoFv9WI;EACI,iBAAA;ApF09WR;;AoF39WI;EACI,iBAAA;ApF89WR;;AoF/9WI;EACI,iBAAA;ApFk+WR;;AoFn+WI;EACI,iBAAA;ApFs+WR;;AoFv+WI;EACI,iBAAA;ApF0+WR;;AoF3+WI;EACI,iBAAA;ApF8+WR;;AoF/+WI;EACI,iBAAA;ApFk/WR;;AoFn/WI;EACI,iBAAA;ApFs/WR;;AoFv/WI;EACI,iBAAA;ApF0/WR;;AoF3/WI;EACI,iBAAA;ApF8/WR;;AoF//WI;EACI,iBAAA;ApFkgXR;;AoFngXI;EACI,iBAAA;ApFsgXR;;AoFvgXI;EACI,iBAAA;ApF0gXR;;AoF3gXI;EACI,iBAAA;ApF8gXR;;AoF/gXI;EACI,iBAAA;ApFkhXR;;AoFnhXI;EACI,iBAAA;ApFshXR;;AoFvhXI;EACI,iBAAA;ApF0hXR;;AoF3hXI;EACI,iBAAA;ApF8hXR;;AoF/hXI;EACI,iBAAA;ApFkiXR;;AoFniXI;EACI,iBAAA;ApFsiXR;;AoFviXI;EACI,iBAAA;ApF0iXR;;AoF3iXI;EACI,iBAAA;ApF8iXR;;AoF/iXI;EACI,iBAAA;ApFkjXR;;AoFnjXI;EACI,iBAAA;ApFsjXR;;AoFvjXI;EACI,iBAAA;ApF0jXR;;AoF3jXI;EACI,iBAAA;ApF8jXR;;AoF/jXI;EACI,iBAAA;ApFkkXR;;AoFnkXI;EACI,iBAAA;ApFskXR;;AoFvkXI;EACI,iBAAA;ApF0kXR;;AoF3kXI;EACI,iBAAA;ApF8kXR;;AoF/kXI;EACI,iBAAA;ApFklXR;;AoFnlXI;EACI,iBAAA;ApFslXR;;AoFvlXI;EACI,iBAAA;ApF0lXR;;AoF3lXI;EACI,iBAAA;ApF8lXR;;AoF/lXI;EACI,iBAAA;ApFkmXR;;AoFnmXI;EACI,iBAAA;ApFsmXR;;AoFvmXI;EACI,iBAAA;ApF0mXR;;AoF3mXI;EACI,iBAAA;ApF8mXR;;AoF/mXI;EACI,iBAAA;ApFknXR;;AoFnnXI;EACI,iBAAA;ApFsnXR;;AoFvnXI;EACI,iBAAA;ApF0nXR;;AoF3nXI;EACI,iBAAA;ApF8nXR;;AoF/nXI;EACI,iBAAA;ApFkoXR;;AoFnoXI;EACI,iBAAA;ApFsoXR;;AoFvoXI;EACI,iBAAA;ApF0oXR;;AoF3oXI;EACI,iBAAA;ApF8oXR;;AoF/oXI;EACI,iBAAA;ApFkpXR;;AoFnpXI;EACI,iBAAA;ApFspXR;;AoFvpXI;EACI,iBAAA;ApF0pXR;;AoF3pXI;EACI,iBAAA;ApF8pXR;;AoF/pXI;EACI,iBAAA;ApFkqXR;;AoFnqXI;EACI,iBAAA;ApFsqXR;;AoFvqXI;EACI,iBAAA;ApF0qXR;;AoF3qXI;EACI,iBAAA;ApF8qXR;;AoF/qXI;EACI,iBAAA;ApFkrXR;;AoFnrXI;EACI,iBAAA;ApFsrXR;;AoFvrXI;EACI,iBAAA;ApF0rXR;;AoF3rXI;EACI,iBAAA;ApF8rXR;;AoF/rXI;EACI,iBAAA;ApFksXR;;AoFnsXI;EACI,iBAAA;ApFssXR;;AoFvsXI;EACI,iBAAA;ApF0sXR;;AoF3sXI;EACI,iBAAA;ApF8sXR;;AoF/sXI;EACI,iBAAA;ApFktXR;;AoFntXI;EACI,iBAAA;ApFstXR;;AoFvtXI;EACI,iBAAA;ApF0tXR;;AoF3tXI;EACI,iBAAA;ApF8tXR;;AoF/tXI;EACI,iBAAA;ApFkuXR;;AoFnuXI;EACI,iBAAA;ApFsuXR;;AoFvuXI;EACI,iBAAA;ApF0uXR;;AoF3uXI;EACI,iBAAA;ApF8uXR;;AoF/uXI;EACI,iBAAA;ApFkvXR;;AoFnvXI;EACI,iBAAA;ApFsvXR;;AoFvvXI;EACI,iBAAA;ApF0vXR;;AoF3vXI;EACI,iBAAA;ApF8vXR;;AoF/vXI;EACI,iBAAA;ApFkwXR;;AoFnwXI;EACI,iBAAA;ApFswXR;;AoFvwXI;EACI,iBAAA;ApF0wXR;;AoF3wXI;EACI,iBAAA;ApF8wXR;;AoF/wXI;EACI,iBAAA;ApFkxXR;;AoFnxXI;EACI,iBAAA;ApFsxXR;;AoFvxXI;EACI,iBAAA;ApF0xXR;;AoF3xXI;EACI,iBAAA;ApF8xXR;;AoF/xXI;EACI,iBAAA;ApFkyXR;;AoFnyXI;EACI,iBAAA;ApFsyXR;;AoFvyXI;EACI,iBAAA;ApF0yXR;;AoF3yXI;EACI,iBAAA;ApF8yXR;;AoF/yXI;EACI,iBAAA;ApFkzXR;;AoFnzXI;EACI,iBAAA;ApFszXR;;AoFvzXI;EACI,iBAAA;ApF0zXR;;AoF3zXI;EACI,iBAAA;ApF8zXR;;AoF/zXI;EACI,iBAAA;ApFk0XR;;AoFn0XI;EACI,iBAAA;ApFs0XR;;AoFv0XI;EACI,iBAAA;ApF00XR;;AoF30XI;EACI,iBAAA;ApF80XR;;AoF/0XI;EACI,iBAAA;ApFk1XR;;AoFn1XI;EACI,iBAAA;ApFs1XR;;AoFv1XI;EACI,iBAAA;ApF01XR;;AoF31XI;EACI,iBAAA;ApF81XR;;AoF/1XI;EACI,iBAAA;ApFk2XR;;AoFn2XI;EACI,iBAAA;ApFs2XR;;AoFv2XI;EACI,iBAAA;ApF02XR;;AoF32XI;EACI,iBAAA;ApF82XR;;AoF/2XI;EACI,iBAAA;ApFk3XR;;AoFn3XI;EACI,iBAAA;ApFs3XR;;AoFv3XI;EACI,iBAAA;ApF03XR;;AoF33XI;EACI,iBAAA;ApF83XR;;AoF/3XI;EACI,iBAAA;ApFk4XR;;AoFn4XI;EACI,iBAAA;ApFs4XR;;AoFv4XI;EACI,iBAAA;ApF04XR;;AoF34XI;EACI,iBAAA;ApF84XR;;AoF/4XI;EACI,iBAAA;ApFk5XR;;AoFn5XI;EACI,iBAAA;ApFs5XR;;AoFv5XI;EACI,iBAAA;ApF05XR;;AoF35XI;EACI,iBAAA;ApF85XR;;AoF/5XI;EACI,iBAAA;ApFk6XR;;AoFn6XI;EACI,iBAAA;ApFs6XR;;AoFv6XI;EACI,iBAAA;ApF06XR;;AoF36XI;EACI,iBAAA;ApF86XR;;AoF/6XI;EACI,iBAAA;ApFk7XR;;AoFn7XI;EACI,iBAAA;ApFs7XR;;AoFv7XI;EACI,iBAAA;ApF07XR;;AoF37XI;EACI,iBAAA;ApF87XR;;AoF/7XI;EACI,iBAAA;ApFk8XR;;AoFn8XI;EACI,iBAAA;ApFs8XR;;AoFv8XI;EACI,iBAAA;ApF08XR;;AoF38XI;EACI,iBAAA;ApF88XR;;AoF/8XI;EACI,iBAAA;ApFk9XR;;AoFn9XI;EACI,iBAAA;ApFs9XR;;AoFv9XI;EACI,iBAAA;ApF09XR;;AoF39XI;EACI,iBAAA;ApF89XR;;AoF/9XI;EACI,iBAAA;ApFk+XR;;AoFn+XI;EACI,iBAAA;ApFs+XR;;AoFv+XI;EACI,iBAAA;ApF0+XR;;AoF3+XI;EACI,iBAAA;ApF8+XR;;AoF/+XI;EACI,iBAAA;ApFk/XR;;AoFn/XI;EACI,iBAAA;ApFs/XR;;AoFv/XI;EACI,iBAAA;ApF0/XR;;AoF3/XI;EACI,iBAAA;ApF8/XR;;AoF//XI;EACI,iBAAA;ApFkgYR;;AoFngYI;EACI,iBAAA;ApFsgYR;;AoFvgYI;EACI,iBAAA;ApF0gYR;;AoF3gYI;EACI,iBAAA;ApF8gYR;;AoF/gYI;EACI,iBAAA;ApFkhYR;;AoFnhYI;EACI,iBAAA;ApFshYR;;AoFvhYI;EACI,iBAAA;ApF0hYR;;AoF3hYI;EACI,iBAAA;ApF8hYR;;AoF/hYI;EACI,iBAAA;ApFkiYR;;AoFniYI;EACI,iBAAA;ApFsiYR;;AoFviYI;EACI,iBAAA;ApF0iYR;;AoF3iYI;EACI,iBAAA;ApF8iYR;;AoF/iYI;EACI,iBAAA;ApFkjYR;;AoFnjYI;EACI,iBAAA;ApFsjYR;;AoFvjYI;EACI,iBAAA;ApF0jYR;;AoF3jYI;EACI,iBAAA;ApF8jYR;;AoF/jYI;EACI,iBAAA;ApFkkYR;;AoFnkYI;EACI,iBAAA;ApFskYR;;AoFvkYI;EACI,iBAAA;ApF0kYR;;AoF3kYI;EACI,iBAAA;ApF8kYR;;AoF/kYI;EACI,iBAAA;ApFklYR;;AoFnlYI;EACI,iBAAA;ApFslYR;;AoFvlYI;EACI,iBAAA;ApF0lYR;;AoF3lYI;EACI,iBAAA;ApF8lYR;;AoF/lYI;EACI,iBAAA;ApFkmYR;;AoFnmYI;EACI,iBAAA;ApFsmYR;;AoFvmYI;EACI,iBAAA;ApF0mYR;;AoF3mYI;EACI,iBAAA;ApF8mYR;;AoF/mYI;EACI,iBAAA;ApFknYR;;AoFnnYI;EACI,iBAAA;ApFsnYR;;AoFvnYI;EACI,iBAAA;ApF0nYR;;AoF3nYI;EACI,iBAAA;ApF8nYR;;AoF/nYI;EACI,iBAAA;ApFkoYR;;AoFnoYI;EACI,iBAAA;ApFsoYR;;AoFvoYI;EACI,iBAAA;ApF0oYR;;AoF3oYI;EACI,iBAAA;ApF8oYR;;AoF/oYI;EACI,iBAAA;ApFkpYR;;AoFnpYI;EACI,iBAAA;ApFspYR;;AoFvpYI;EACI,iBAAA;ApF0pYR;;AoF3pYI;EACI,iBAAA;ApF8pYR;;AoF/pYI;EACI,iBAAA;ApFkqYR;;AoFnqYI;EACI,iBAAA;ApFsqYR;;AoFvqYI;EACI,iBAAA;ApF0qYR;;AoF3qYI;EACI,iBAAA;ApF8qYR;;AoF/qYI;EACI,iBAAA;ApFkrYR;;AoFnrYI;EACI,iBAAA;ApFsrYR;;AoFvrYI;EACI,iBAAA;ApF0rYR;;AoF3rYI;EACI,iBAAA;ApF8rYR;;AoF/rYI;EACI,iBAAA;ApFksYR;;AoFnsYI;EACI,iBAAA;ApFssYR;;AoFvsYI;EACI,iBAAA;ApF0sYR;;AoF3sYI;EACI,iBAAA;ApF8sYR;;AoF/sYI;EACI,iBAAA;ApFktYR;;AoFntYI;EACI,iBAAA;ApFstYR;;AoFvtYI;EACI,iBAAA;ApF0tYR;;AoF3tYI;EACI,iBAAA;ApF8tYR;;AoF/tYI;EACI,iBAAA;ApFkuYR;;AoFnuYI;EACI,iBAAA;ApFsuYR;;AoFvuYI;EACI,iBAAA;ApF0uYR;;AoF3uYI;EACI,iBAAA;ApF8uYR;;AoF/uYI;EACI,iBAAA;ApFkvYR;;AoFnvYI;EACI,iBAAA;ApFsvYR;;AoFvvYI;EACI,iBAAA;ApF0vYR;;AoF3vYI;EACI,iBAAA;ApF8vYR;;AoF/vYI;EACI,iBAAA;ApFkwYR;;AoFnwYI;EACI,iBAAA;ApFswYR;;AoFvwYI;EACI,iBAAA;ApF0wYR;;AoF3wYI;EACI,iBAAA;ApF8wYR;;AoF/wYI;EACI,iBAAA;ApFkxYR;;AoFnxYI;EACI,iBAAA;ApFsxYR;;AoFvxYI;EACI,iBAAA;ApF0xYR;;AoF3xYI;EACI,iBAAA;ApF8xYR;;AoF/xYI;EACI,iBAAA;ApFkyYR;;AoFnyYI;EACI,iBAAA;ApFsyYR;;AoFvyYI;EACI,iBAAA;ApF0yYR;;AoF3yYI;EACI,iBAAA;ApF8yYR;;AoF/yYI;EACI,iBAAA;ApFkzYR;;AoFnzYI;EACI,iBAAA;ApFszYR;;AoFvzYI;EACI,iBAAA;ApF0zYR;;AoF3zYI;EACI,iBAAA;ApF8zYR;;AoF/zYI;EACI,iBAAA;ApFk0YR;;AoFn0YI;EACI,iBAAA;ApFs0YR;;AoFv0YI;EACI,iBAAA;ApF00YR;;AoF30YI;EACI,iBAAA;ApF80YR;;AoF/0YI;EACI,iBAAA;ApFk1YR;;AoFn1YI;EACI,iBAAA;ApFs1YR;;AoFv1YI;EACI,iBAAA;ApF01YR;;AoF31YI;EACI,iBAAA;ApF81YR;;AoF/1YI;EACI,iBAAA;ApFk2YR;;AoFn2YI;EACI,iBAAA;ApFs2YR;;AoFv2YI;EACI,iBAAA;ApF02YR;;AoF32YI;EACI,iBAAA;ApF82YR;;AoF/2YI;EACI,iBAAA;ApFk3YR;;AoFn3YI;EACI,iBAAA;ApFs3YR;;AoFv3YI;EACI,iBAAA;ApF03YR;;AoF33YI;EACI,iBAAA;ApF83YR;;AoF/3YI;EACI,iBAAA;ApFk4YR;;AoFn4YI;EACI,iBAAA;ApFs4YR;;AoFv4YI;EACI,iBAAA;ApF04YR;;AoF34YI;EACI,iBAAA;ApF84YR;;AoF/4YI;EACI,iBAAA;ApFk5YR;;AoFn5YI;EACI,iBAAA;ApFs5YR;;AoFv5YI;EACI,iBAAA;ApF05YR;;AoF35YI;EACI,iBAAA;ApF85YR;;AoF/5YI;EACI,iBAAA;ApFk6YR;;AoFn6YI;EACI,iBAAA;ApFs6YR;;AoFv6YI;EACI,iBAAA;ApF06YR;;AoF36YI;EACI,iBAAA;ApF86YR;;AoF/6YI;EACI,iBAAA;ApFk7YR;;AoFn7YI;EACI,iBAAA;ApFs7YR;;AoFv7YI;EACI,iBAAA;ApF07YR;;AoF37YI;EACI,iBAAA;ApF87YR;;AoF/7YI;EACI,iBAAA;ApFk8YR;;AoFn8YI;EACI,iBAAA;ApFs8YR;;AoFv8YI;EACI,iBAAA;ApF08YR;;AoF38YI;EACI,iBAAA;ApF88YR;;AoF/8YI;EACI,iBAAA;ApFk9YR;;AoFn9YI;EACI,iBAAA;ApFs9YR;;AoFv9YI;EACI,iBAAA;ApF09YR;;AoF39YI;EACI,iBAAA;ApF89YR;;AoF/9YI;EACI,iBAAA;ApFk+YR;;AoFn+YI;EACI,iBAAA;ApFs+YR;;AoFv+YI;EACI,iBAAA;ApF0+YR;;AoF3+YI;EACI,iBAAA;ApF8+YR;;AoF/+YI;EACI,iBAAA;ApFk/YR;;AoFn/YI;EACI,iBAAA;ApFs/YR;;AoFv/YI;EACI,iBAAA;ApF0/YR;;AoF3/YI;EACI,iBAAA;ApF8/YR;;AoF//YI;EACI,iBAAA;ApFkgZR;;AoFngZI;EACI,iBAAA;ApFsgZR;;AoFvgZI;EACI,iBAAA;ApF0gZR;;AoF3gZI;EACI,iBAAA;ApF8gZR;;AoF/gZI;EACI,iBAAA;ApFkhZR;;AoFnhZI;EACI,iBAAA;ApFshZR;;AoFvhZI;EACI,iBAAA;ApF0hZR;;AoF3hZI;EACI,iBAAA;ApF8hZR;;AoF/hZI;EACI,iBAAA;ApFkiZR;;AoFniZI;EACI,iBAAA;ApFsiZR;;AoFviZI;EACI,iBAAA;ApF0iZR;;AoF3iZI;EACI,iBAAA;ApF8iZR;;AoF/iZI;EACI,iBAAA;ApFkjZR;;AoFnjZI;EACI,iBAAA;ApFsjZR;;AoFvjZI;EACI,iBAAA;ApF0jZR;;AoF3jZI;EACI,iBAAA;ApF8jZR;;AoF/jZI;EACI,iBAAA;ApFkkZR;;AoFnkZI;EACI,iBAAA;ApFskZR;;AoFvkZI;EACI,iBAAA;ApF0kZR;;AoF3kZI;EACI,iBAAA;ApF8kZR;;AoF/kZI;EACI,iBAAA;ApFklZR;;AoFnlZI;EACI,iBAAA;ApFslZR;;AoFvlZI;EACI,iBAAA;ApF0lZR;;AoF3lZI;EACI,iBAAA;ApF8lZR;;AoF/lZI;EACI,iBAAA;ApFkmZR;;AoFnmZI;EACI,iBAAA;ApFsmZR;;AoFvmZI;EACI,iBAAA;ApF0mZR;;AoF3mZI;EACI,iBAAA;ApF8mZR;;AoF/mZI;EACI,iBAAA;ApFknZR;;AoFnnZI;EACI,iBAAA;ApFsnZR;;AoFvnZI;EACI,iBAAA;ApF0nZR;;AoF3nZI;EACI,iBAAA;ApF8nZR;;AoF/nZI;EACI,iBAAA;ApFkoZR;;AoFnoZI;EACI,iBAAA;ApFsoZR;;AoFvoZI;EACI,iBAAA;ApF0oZR;;AoF3oZI;EACI,iBAAA;ApF8oZR;;AoF/oZI;EACI,iBAAA;ApFkpZR;;AoFnpZI;EACI,iBAAA;ApFspZR;;AoFvpZI;EACI,iBAAA;ApF0pZR;;AoF3pZI;EACI,iBAAA;ApF8pZR;;AoF/pZI;EACI,iBAAA;ApFkqZR;;AoFnqZI;EACI,iBAAA;ApFsqZR;;AoFvqZI;EACI,iBAAA;ApF0qZR;;AoF3qZI;EACI,iBAAA;ApF8qZR;;AoF/qZI;EACI,iBAAA;ApFkrZR;;AoFnrZI;EACI,iBAAA;ApFsrZR;;AoFvrZI;EACI,iBAAA;ApF0rZR;;AoF3rZI;EACI,iBAAA;ApF8rZR;;AoF/rZI;EACI,iBAAA;ApFksZR;;AoFnsZI;EACI,iBAAA;ApFssZR;;AoFvsZI;EACI,iBAAA;ApF0sZR;;AoF3sZI;EACI,iBAAA;ApF8sZR;;AoF/sZI;EACI,iBAAA;ApFktZR;;AoFntZI;EACI,iBAAA;ApFstZR;;AoFvtZI;EACI,iBAAA;ApF0tZR;;AoF3tZI;EACI,iBAAA;ApF8tZR;;AoF/tZI;EACI,iBAAA;ApFkuZR;;AoFnuZI;EACI,iBAAA;ApFsuZR;;AoFvuZI;EACI,iBAAA;ApF0uZR;;AoF3uZI;EACI,iBAAA;ApF8uZR;;AoF/uZI;EACI,iBAAA;ApFkvZR;;AoFnvZI;EACI,iBAAA;ApFsvZR;;AoFvvZI;EACI,iBAAA;ApF0vZR;;AoF3vZI;EACI,iBAAA;ApF8vZR;;AoF/vZI;EACI,iBAAA;ApFkwZR;;AoFnwZI;EACI,iBAAA;ApFswZR;;AoFvwZI;EACI,iBAAA;ApF0wZR;;AoF3wZI;EACI,iBAAA;ApF8wZR;;AoF/wZI;EACI,iBAAA;ApFkxZR;;AoFnxZI;EACI,iBAAA;ApFsxZR;;AoFvxZI;EACI,iBAAA;ApF0xZR;;AoF3xZI;EACI,iBAAA;ApF8xZR;;AoF/xZI;EACI,iBAAA;ApFkyZR;;AoFnyZI;EACI,iBAAA;ApFsyZR;;AoFvyZI;EACI,iBAAA;ApF0yZR;;AoF3yZI;EACI,iBAAA;ApF8yZR;;AoF/yZI;EACI,iBAAA;ApFkzZR;;AoFnzZI;EACI,iBAAA;ApFszZR;;AoFvzZI;EACI,iBAAA;ApF0zZR;;AoF3zZI;EACI,iBAAA;ApF8zZR;;AoF/zZI;EACI,iBAAA;ApFk0ZR;;AoFn0ZI;EACI,iBAAA;ApFs0ZR;;AoFv0ZI;EACI,iBAAA;ApF00ZR;;AoF30ZI;EACI,iBAAA;ApF80ZR;;AoF/0ZI;EACI,iBAAA;ApFk1ZR;;AoFn1ZI;EACI,iBAAA;ApFs1ZR;;AoFv1ZI;EACI,iBAAA;ApF01ZR;;AoF31ZI;EACI,iBAAA;ApF81ZR;;AoF/1ZI;EACI,iBAAA;ApFk2ZR;;AoFn2ZI;EACI,iBAAA;ApFs2ZR;;AoFv2ZI;EACI,iBAAA;ApF02ZR;;AoF32ZI;EACI,iBAAA;ApF82ZR;;AoF/2ZI;EACI,iBAAA;ApFk3ZR;;AoFn3ZI;EACI,iBAAA;ApFs3ZR;;AoFv3ZI;EACI,iBAAA;ApF03ZR;;AoF33ZI;EACI,iBAAA;ApF83ZR;;AoF/3ZI;EACI,iBAAA;ApFk4ZR;;AoFn4ZI;EACI,iBAAA;ApFs4ZR;;AoFv4ZI;EACI,iBAAA;ApF04ZR;;AoF34ZI;EACI,iBAAA;ApF84ZR;;AoF/4ZI;EACI,iBAAA;ApFk5ZR;;AoFn5ZI;EACI,iBAAA;ApFs5ZR;;AoFv5ZI;EACI,iBAAA;ApF05ZR;;AoF35ZI;EACI,iBAAA;ApF85ZR;;AoF/5ZI;EACI,iBAAA;ApFk6ZR;;AoFn6ZI;EACI,iBAAA;ApFs6ZR;;AoFv6ZI;EACI,iBAAA;ApF06ZR;;AoF36ZI;EACI,iBAAA;ApF86ZR;;AoF/6ZI;EACI,iBAAA;ApFk7ZR;;AoFn7ZI;EACI,iBAAA;ApFs7ZR;;AoFv7ZI;EACI,iBAAA;ApF07ZR;;AoF37ZI;EACI,iBAAA;ApF87ZR;;AoF/7ZI;EACI,iBAAA;ApFk8ZR;;AoFn8ZI;EACI,iBAAA;ApFs8ZR;;AoFv8ZI;EACI,iBAAA;ApF08ZR;;AoF38ZI;EACI,iBAAA;ApF88ZR;;AoF/8ZI;EACI,iBAAA;ApFk9ZR;;AoFn9ZI;EACI,iBAAA;ApFs9ZR;;AoFv9ZI;EACI,iBAAA;ApF09ZR;;AoF39ZI;EACI,iBAAA;ApF89ZR;;AoF/9ZI;EACI,iBAAA;ApFk+ZR;;AoFn+ZI;EACI,iBAAA;ApFs+ZR;;AoFv+ZI;EACI,iBAAA;ApF0+ZR;;AoF3+ZI;EACI,iBAAA;ApF8+ZR;;AoF/+ZI;EACI,iBAAA;ApFk/ZR;;AoFn/ZI;EACI,iBAAA;ApFs/ZR;;AoFv/ZI;EACI,iBAAA;ApF0/ZR;;AoF3/ZI;EACI,iBAAA;ApF8/ZR;;AoF//ZI;EACI,iBAAA;ApFkgaR;;AoFngaI;EACI,iBAAA;ApFsgaR;;AoFvgaI;EACI,iBAAA;ApF0gaR;;AoF3gaI;EACI,iBAAA;ApF8gaR;;AoF/gaI;EACI,iBAAA;ApFkhaR;;AoFnhaI;EACI,iBAAA;ApFshaR;;AoFvhaI;EACI,iBAAA;ApF0haR;;AoF3haI;EACI,iBAAA;ApF8haR;;AoF/haI;EACI,iBAAA;ApFkiaR;;AoFniaI;EACI,iBAAA;ApFsiaR;;AoFviaI;EACI,iBAAA;ApF0iaR;;AoF3iaI;EACI,iBAAA;ApF8iaR;;AoF/iaI;EACI,iBAAA;ApFkjaR;;AoFnjaI;EACI,iBAAA;ApFsjaR;;AoFvjaI;EACI,iBAAA;ApF0jaR;;AoF3jaI;EACI,iBAAA;ApF8jaR;;AoF/jaI;EACI,iBAAA;ApFkkaR;;AoFnkaI;EACI,iBAAA;ApFskaR;;AoFvkaI;EACI,iBAAA;ApF0kaR;;AoF3kaI;EACI,iBAAA;ApF8kaR;;AoF/kaI;EACI,iBAAA;ApFklaR;;AoFnlaI;EACI,iBAAA;ApFslaR;;AoFvlaI;EACI,iBAAA;ApF0laR;;AoF3laI;EACI,iBAAA;ApF8laR;;AoF/laI;EACI,iBAAA;ApFkmaR;;AoFnmaI;EACI,iBAAA;ApFsmaR;;AoFvmaI;EACI,iBAAA;ApF0maR;;AoF3maI;EACI,iBAAA;ApF8maR;;AoF/maI;EACI,iBAAA;ApFknaR;;AoFnnaI;EACI,iBAAA;ApFsnaR;;AoFvnaI;EACI,iBAAA;ApF0naR;;AoF3naI;EACI,iBAAA;ApF8naR;;AoF/naI;EACI,iBAAA;ApFkoaR;;AoFnoaI;EACI,iBAAA;ApFsoaR;;AoFvoaI;EACI,iBAAA;ApF0oaR;;AoF3oaI;EACI,iBAAA;ApF8oaR;;AoF/oaI;EACI,iBAAA;ApFkpaR;;AoFnpaI;EACI,iBAAA;ApFspaR;;AoFvpaI;EACI,iBAAA;ApF0paR;;AoF3paI;EACI,iBAAA;ApF8paR;;AoF/paI;EACI,iBAAA;ApFkqaR;;AoFnqaI;EACI,iBAAA;ApFsqaR;;AoFvqaI;EACI,iBAAA;ApF0qaR;;AoF3qaI;EACI,iBAAA;ApF8qaR;;AoF/qaI;EACI,iBAAA;ApFkraR;;AoFnraI;EACI,iBAAA;ApFsraR;;AoFvraI;EACI,iBAAA;ApF0raR;;AoF3raI;EACI,iBAAA;ApF8raR;;AoF/raI;EACI,iBAAA;ApFksaR;;AoFnsaI;EACI,iBAAA;ApFssaR;;AoFvsaI;EACI,iBAAA;ApF0saR;;AoF3saI;EACI,iBAAA;ApF8saR;;AoF/saI;EACI,iBAAA;ApFktaR;;AoFntaI;EACI,iBAAA;ApFstaR;;AoFvtaI;EACI,iBAAA;ApF0taR;;AoF3taI;EACI,iBAAA;ApF8taR;;AoF/taI;EACI,iBAAA;ApFkuaR;;AoFnuaI;EACI,iBAAA;ApFsuaR;;AoFvuaI;EACI,iBAAA;ApF0uaR;;AoF3uaI;EACI,iBAAA;ApF8uaR;;AoF/uaI;EACI,iBAAA;ApFkvaR;;AoFnvaI;EACI,iBAAA;ApFsvaR;;AoFvvaI;EACI,iBAAA;ApF0vaR;;AoF3vaI;EACI,iBAAA;ApF8vaR;;AoF/vaI;EACI,iBAAA;ApFkwaR;;AoFnwaI;EACI,iBAAA;ApFswaR;;AoFvwaI;EACI,iBAAA;ApF0waR;;AoF3waI;EACI,iBAAA;ApF8waR;;AoF/waI;EACI,iBAAA;ApFkxaR;;AoFnxaI;EACI,iBAAA;ApFsxaR;;AoFvxaI;EACI,iBAAA;ApF0xaR;;AoF3xaI;EACI,iBAAA;ApF8xaR;;AoF/xaI;EACI,iBAAA;ApFkyaR;;AoFnyaI;EACI,iBAAA;ApFsyaR;;AoFvyaI;EACI,iBAAA;ApF0yaR;;AoF3yaI;EACI,iBAAA;ApF8yaR;;AoF/yaI;EACI,iBAAA;ApFkzaR;;AoFnzaI;EACI,iBAAA;ApFszaR;;AoFvzaI;EACI,iBAAA;ApF0zaR;;AoF3zaI;EACI,iBAAA;ApF8zaR;;AoF/zaI;EACI,iBAAA;ApFk0aR;;AoFn0aI;EACI,iBAAA;ApFs0aR;;AoFv0aI;EACI,iBAAA;ApF00aR;;AoF30aI;EACI,iBAAA;ApF80aR;;AoF/0aI;EACI,iBAAA;ApFk1aR;;AoFn1aI;EACI,iBAAA;ApFs1aR;;AoFv1aI;EACI,iBAAA;ApF01aR;;AoF31aI;EACI,iBAAA;ApF81aR;;AoF/1aI;EACI,iBAAA;ApFk2aR;;AoFn2aI;EACI,iBAAA;ApFs2aR;;AoFv2aI;EACI,iBAAA;ApF02aR;;AoF32aI;EACI,iBAAA;ApF82aR;;AoF/2aI;EACI,iBAAA;ApFk3aR;;AoFn3aI;EACI,iBAAA;ApFs3aR;;AoFv3aI;EACI,iBAAA;ApF03aR;;AoF33aI;EACI,iBAAA;ApF83aR;;AoF/3aI;EACI,iBAAA;ApFk4aR;;AoFn4aI;EACI,iBAAA;ApFs4aR;;AoFv4aI;EACI,iBAAA;ApF04aR;;AoF34aI;EACI,iBAAA;ApF84aR;;AoF/4aI;EACI,iBAAA;ApFk5aR;;AoFn5aI;EACI,iBAAA;ApFs5aR;;AoFv5aI;EACI,iBAAA;ApF05aR;;AoF35aI;EACI,iBAAA;ApF85aR;;AoF/5aI;EACI,iBAAA;ApFk6aR;;AoFn6aI;EACI,iBAAA;ApFs6aR;;AoFv6aI;EACI,iBAAA;ApF06aR;;AoF36aI;EACI,iBAAA;ApF86aR;;AoF/6aI;EACI,iBAAA;ApFk7aR;;AoFn7aI;EACI,iBAAA;ApFs7aR;;AoFv7aI;EACI,iBAAA;ApF07aR;;AoF37aI;EACI,iBAAA;ApF87aR;;AoF/7aI;EACI,iBAAA;ApFk8aR;;AoFn8aI;EACI,iBAAA;ApFs8aR;;AoFv8aI;EACI,iBAAA;ApF08aR;;AoF38aI;EACI,iBAAA;ApF88aR;;AoF/8aI;EACI,iBAAA;ApFk9aR;;AoFn9aI;EACI,iBAAA;ApFs9aR;;AoFv9aI;EACI,iBAAA;ApF09aR;;AoF39aI;EACI,iBAAA;ApF89aR;;AoF/9aI;EACI,iBAAA;ApFk+aR;;AoFn+aI;EACI,iBAAA;ApFs+aR;;AoFv+aI;EACI,iBAAA;ApF0+aR;;AoF3+aI;EACI,iBAAA;ApF8+aR;;AoF/+aI;EACI,iBAAA;ApFk/aR;;AoFn/aI;EACI,iBAAA;ApFs/aR;;AoFv/aI;EACI,iBAAA;ApF0/aR;;AoF3/aI;EACI,iBAAA;ApF8/aR;;AoF//aI;EACI,iBAAA;ApFkgbR;;AoFngbI;EACI,iBAAA;ApFsgbR;;AoFvgbI;EACI,iBAAA;ApF0gbR;;AoF3gbI;EACI,iBAAA;ApF8gbR;;AoF/gbI;EACI,iBAAA;ApFkhbR;;AoFnhbI;EACI,iBAAA;ApFshbR;;AoFvhbI;EACI,iBAAA;ApF0hbR;;AoF3hbI;EACI,iBAAA;ApF8hbR;;AoF/hbI;EACI,iBAAA;ApFkibR;;AoFnibI;EACI,iBAAA;ApFsibR;;AoFvibI;EACI,iBAAA;ApF0ibR;;AoF3ibI;EACI,iBAAA;ApF8ibR;;AoF/ibI;EACI,iBAAA;ApFkjbR;;AoFnjbI;EACI,iBAAA;ApFsjbR;;AoFvjbI;EACI,iBAAA;ApF0jbR;;AoF3jbI;EACI,iBAAA;ApF8jbR;;AoF/jbI;EACI,iBAAA;ApFkkbR;;AoFnkbI;EACI,iBAAA;ApFskbR;;AoFvkbI;EACI,iBAAA;ApF0kbR;;AoF3kbI;EACI,iBAAA;ApF8kbR;;AoF/kbI;EACI,iBAAA;ApFklbR;;AoFnlbI;EACI,iBAAA;ApFslbR;;AoFvlbI;EACI,iBAAA;ApF0lbR;;AoF3lbI;EACI,iBAAA;ApF8lbR;;AoF/lbI;EACI,iBAAA;ApFkmbR;;AoFnmbI;EACI,iBAAA;ApFsmbR;;AoFvmbI;EACI,iBAAA;ApF0mbR;;AoF3mbI;EACI,iBAAA;ApF8mbR;;AoF/mbI;EACI,iBAAA;ApFknbR;;AoFnnbI;EACI,iBAAA;ApFsnbR;;AoFvnbI;EACI,iBAAA;ApF0nbR;;AoF3nbI;EACI,iBAAA;ApF8nbR;;AoF/nbI;EACI,iBAAA;ApFkobR;;AoFnobI;EACI,iBAAA;ApFsobR;;AoFvobI;EACI,iBAAA;ApF0obR;;AoF3obI;EACI,iBAAA;ApF8obR;;AoF/obI;EACI,iBAAA;ApFkpbR;;AoFnpbI;EACI,iBAAA;ApFspbR;;AoFvpbI;EACI,iBAAA;ApF0pbR;;AoF3pbI;EACI,iBAAA;ApF8pbR;;AoF/pbI;EACI,iBAAA;ApFkqbR;;AoFnqbI;EACI,iBAAA;ApFsqbR;;AoFvqbI;EACI,iBAAA;ApF0qbR;;AoF3qbI;EACI,iBAAA;ApF8qbR;;AoF/qbI;EACI,iBAAA;ApFkrbR;;AoFnrbI;EACI,iBAAA;ApFsrbR;;AoFvrbI;EACI,iBAAA;ApF0rbR;;AoF3rbI;EACI,iBAAA;ApF8rbR;;AoF/rbI;EACI,iBAAA;ApFksbR;;AoFnsbI;EACI,iBAAA;ApFssbR;;AoFvsbI;EACI,iBAAA;ApF0sbR;;AoF3sbI;EACI,iBAAA;ApF8sbR;;AoF/sbI;EACI,iBAAA;ApFktbR;;AoFntbI;EACI,iBAAA;ApFstbR;;AoFvtbI;EACI,iBAAA;ApF0tbR;;AoF3tbI;EACI,iBAAA;ApF8tbR;;AoF/tbI;EACI,iBAAA;ApFkubR;;AoFnubI;EACI,iBAAA;ApFsubR;;AoFvubI;EACI,iBAAA;ApF0ubR;;AoF3ubI;EACI,iBAAA;ApF8ubR;;AoF/ubI;EACI,iBAAA;ApFkvbR;;AoFnvbI;EACI,iBAAA;ApFsvbR;;AoFvvbI;EACI,iBAAA;ApF0vbR;;AoF3vbI;EACI,iBAAA;ApF8vbR;;AoF/vbI;EACI,iBAAA;ApFkwbR;;AoFnwbI;EACI,iBAAA;ApFswbR;;AoFvwbI;EACI,iBAAA;ApF0wbR;;AoF3wbI;EACI,iBAAA;ApF8wbR;;AoF/wbI;EACI,iBAAA;ApFkxbR;;AoFnxbI;EACI,iBAAA;ApFsxbR;;AoFvxbI;EACI,iBAAA;ApF0xbR;;AoF3xbI;EACI,iBAAA;ApF8xbR;;AoF/xbI;EACI,iBAAA;ApFkybR;;AoFnybI;EACI,iBAAA;ApFsybR;;AoFvybI;EACI,iBAAA;ApF0ybR;;AoF3ybI;EACI,iBAAA;ApF8ybR;;AoF/ybI;EACI,iBAAA;ApFkzbR;;AoFnzbI;EACI,iBAAA;ApFszbR;;AoFvzbI;EACI,iBAAA;ApF0zbR;;AoF3zbI;EACI,iBAAA;ApF8zbR;;AoF/zbI;EACI,iBAAA;ApFk0bR;;AoFn0bI;EACI,iBAAA;ApFs0bR;;AoFv0bI;EACI,iBAAA;ApF00bR;;AoF30bI;EACI,iBAAA;ApF80bR;;AoF/0bI;EACI,iBAAA;ApFk1bR;;AoFn1bI;EACI,iBAAA;ApFs1bR;;AoFv1bI;EACI,iBAAA;ApF01bR;;AoF31bI;EACI,iBAAA;ApF81bR;;AoF/1bI;EACI,iBAAA;ApFk2bR;;AoFn2bI;EACI,iBAAA;ApFs2bR;;AoFv2bI;EACI,iBAAA;ApF02bR;;AoF32bI;EACI,iBAAA;ApF82bR;;AoF/2bI;EACI,iBAAA;ApFk3bR;;AoFn3bI;EACI,iBAAA;ApFs3bR;;AoFv3bI;EACI,iBAAA;ApF03bR;;AoF33bI;EACI,iBAAA;ApF83bR;;AoF/3bI;EACI,iBAAA;ApFk4bR;;AoFn4bI;EACI,iBAAA;ApFs4bR;;AoFv4bI;EACI,iBAAA;ApF04bR;;AoF34bI;EACI,iBAAA;ApF84bR;;AoF/4bI;EACI,iBAAA;ApFk5bR;;AoFn5bI;EACI,iBAAA;ApFs5bR;;AoFv5bI;EACI,iBAAA;ApF05bR;;AoF35bI;EACI,iBAAA;ApF85bR;;AoF/5bI;EACI,iBAAA;ApFk6bR;;AoFn6bI;EACI,iBAAA;ApFs6bR;;AoFv6bI;EACI,iBAAA;ApF06bR;;AoF36bI;EACI,iBAAA;ApF86bR;;AoF/6bI;EACI,iBAAA;ApFk7bR;;AoFn7bI;EACI,iBAAA;ApFs7bR;;AoFv7bI;EACI,iBAAA;ApF07bR;;AoF37bI;EACI,iBAAA;ApF87bR;;AoF/7bI;EACI,iBAAA;ApFk8bR;;AoFn8bI;EACI,iBAAA;ApFs8bR;;AoFv8bI;EACI,iBAAA;ApF08bR;;AoF38bI;EACI,iBAAA;ApF88bR;;AoF/8bI;EACI,iBAAA;ApFk9bR;;AoFn9bI;EACI,iBAAA;ApFs9bR;;AoFv9bI;EACI,iBAAA;ApF09bR;;AoF39bI;EACI,iBAAA;ApF89bR;;AoF/9bI;EACI,iBAAA;ApFk+bR;;AoFn+bI;EACI,iBAAA;ApFs+bR;;AoFv+bI;EACI,iBAAA;ApF0+bR;;AoF3+bI;EACI,iBAAA;ApF8+bR;;AoF/+bI;EACI,iBAAA;ApFk/bR;;AoFn/bI;EACI,iBAAA;ApFs/bR;;AoFv/bI;EACI,iBAAA;ApF0/bR;;AoF3/bI;EACI,iBAAA;ApF8/bR;;AoF//bI;EACI,iBAAA;ApFkgcR;;AoFngcI;EACI,iBAAA;ApFsgcR;;AoFvgcI;EACI,iBAAA;ApF0gcR;;AoF3gcI;EACI,iBAAA;ApF8gcR;;AoF/gcI;EACI,iBAAA;ApFkhcR;;AoFnhcI;EACI,iBAAA;ApFshcR;;AoFvhcI;EACI,iBAAA;ApF0hcR;;AoF3hcI;EACI,iBAAA;ApF8hcR;;AoF/hcI;EACI,iBAAA;ApFkicR;;AoFnicI;EACI,iBAAA;ApFsicR;;AoFvicI;EACI,iBAAA;ApF0icR;;AoF3icI;EACI,iBAAA;ApF8icR;;AoF/icI;EACI,iBAAA;ApFkjcR;;AoFnjcI;EACI,iBAAA;ApFsjcR;;AoFvjcI;EACI,iBAAA;ApF0jcR;;AoF3jcI;EACI,iBAAA;ApF8jcR;;AoF/jcI;EACI,iBAAA;ApFkkcR;;AoFnkcI;EACI,iBAAA;ApFskcR;;AoFvkcI;EACI,iBAAA;ApF0kcR;;AoF3kcI;EACI,iBAAA;ApF8kcR;;AoF/kcI;EACI,iBAAA;ApFklcR;;AoFnlcI;EACI,iBAAA;ApFslcR;;AoFvlcI;EACI,iBAAA;ApF0lcR;;AoF3lcI;EACI,iBAAA;ApF8lcR;;AoF/lcI;EACI,iBAAA;ApFkmcR;;AoFnmcI;EACI,iBAAA;ApFsmcR;;AoFvmcI;EACI,iBAAA;ApF0mcR;;AoF3mcI;EACI,iBAAA;ApF8mcR;;AoF/mcI;EACI,iBAAA;ApFkncR;;AoFnncI;EACI,iBAAA;ApFsncR;;AoFvncI;EACI,iBAAA;ApF0ncR;;AoF3ncI;EACI,iBAAA;ApF8ncR;;AoF/ncI;EACI,iBAAA;ApFkocR;;AoFnocI;EACI,iBAAA;ApFsocR;;AoFvocI;EACI,iBAAA;ApF0ocR;;AoF3ocI;EACI,iBAAA;ApF8ocR;;AoF/ocI;EACI,iBAAA;ApFkpcR;;AoFnpcI;EACI,iBAAA;ApFspcR;;AoFvpcI;EACI,iBAAA;ApF0pcR;;AoF3pcI;EACI,iBAAA;ApF8pcR;;AoF/pcI;EACI,iBAAA;ApFkqcR;;AoFnqcI;EACI,iBAAA;ApFsqcR;;AoFvqcI;EACI,iBAAA;ApF0qcR;;AoF3qcI;EACI,iBAAA;ApF8qcR;;AoF/qcI;EACI,iBAAA;ApFkrcR;;AoFnrcI;EACI,iBAAA;ApFsrcR;;AoFvrcI;EACI,iBAAA;ApF0rcR;;AoF3rcI;EACI,iBAAA;ApF8rcR;;AoF/rcI;EACI,iBAAA;ApFkscR;;AoFnscI;EACI,iBAAA;ApFsscR;;AoFvscI;EACI,iBAAA;ApF0scR;;AoF3scI;EACI,iBAAA;ApF8scR;;AoF/scI;EACI,iBAAA;ApFktcR;;AoFntcI;EACI,iBAAA;ApFstcR;;AoFvtcI;EACI,iBAAA;ApF0tcR;;AoF3tcI;EACI,iBAAA;ApF8tcR;;AoF/tcI;EACI,iBAAA;ApFkucR;;AoFnucI;EACI,iBAAA;ApFsucR;;AoFvucI;EACI,iBAAA;ApF0ucR;;AoF3ucI;EACI,iBAAA;ApF8ucR;;AoF/ucI;EACI,iBAAA;ApFkvcR;;AoFnvcI;EACI,iBAAA;ApFsvcR;;AoFvvcI;EACI,iBAAA;ApF0vcR;;AoF3vcI;EACI,iBAAA;ApF8vcR;;AoF/vcI;EACI,iBAAA;ApFkwcR;;AoFnwcI;EACI,iBAAA;ApFswcR;;AoFvwcI;EACI,iBAAA;ApF0wcR;;AoF3wcI;EACI,iBAAA;ApF8wcR;;AoF/wcI;EACI,iBAAA;ApFkxcR;;AoFnxcI;EACI,iBAAA;ApFsxcR;;AoFvxcI;EACI,iBAAA;ApF0xcR;;AoF3xcI;EACI,iBAAA;ApF8xcR;;AoF/xcI;EACI,iBAAA;ApFkycR;;AoFnycI;EACI,iBAAA;ApFsycR;;AoFvycI;EACI,iBAAA;ApF0ycR;;AoF3ycI;EACI,iBAAA;ApF8ycR;;AoF/ycI;EACI,iBAAA;ApFkzcR;;AoFnzcI;EACI,iBAAA;ApFszcR;;AoFvzcI;EACI,iBAAA;ApF0zcR;;AoF3zcI;EACI,iBAAA;ApF8zcR;;AoF/zcI;EACI,iBAAA;ApFk0cR;;AoFn0cI;EACI,iBAAA;ApFs0cR;;AoFv0cI;EACI,iBAAA;ApF00cR;;AoF30cI;EACI,iBAAA;ApF80cR;;AoF/0cI;EACI,iBAAA;ApFk1cR;;AoFn1cI;EACI,iBAAA;ApFs1cR;;AoFv1cI;EACI,iBAAA;ApF01cR;;AoF31cI;EACI,iBAAA;ApF81cR;;AoF/1cI;EACI,iBAAA;ApFk2cR;;AoFn2cI;EACI,iBAAA;ApFs2cR;;AoFv2cI;EACI,iBAAA;ApF02cR;;AoF32cI;EACI,iBAAA;ApF82cR;;AoF/2cI;EACI,iBAAA;ApFk3cR;;AoFn3cI;EACI,iBAAA;ApFs3cR;;AoFv3cI;EACI,iBAAA;ApF03cR;;AoF33cI;EACI,iBAAA;ApF83cR;;AoF/3cI;EACI,iBAAA;ApFk4cR;;AoFn4cI;EACI,iBAAA;ApFs4cR;;AoFv4cI;EACI,iBAAA;ApF04cR;;AoF34cI;EACI,iBAAA;ApF84cR;;AoF/4cI;EACI,iBAAA;ApFk5cR;;AoFn5cI;EACI,iBAAA;ApFs5cR;;AoFv5cI;EACI,iBAAA;ApF05cR;;AoF35cI;EACI,iBAAA;ApF85cR;;AoF/5cI;EACI,iBAAA;ApFk6cR;;AoFn6cI;EACI,iBAAA;ApFs6cR;;AoFv6cI;EACI,iBAAA;ApF06cR;;AoF36cI;EACI,iBAAA;ApF86cR;;AoF/6cI;EACI,iBAAA;ApFk7cR;;AoFn7cI;EACI,iBAAA;ApFs7cR;;AoFv7cI;EACI,iBAAA;ApF07cR;;AoF37cI;EACI,iBAAA;ApF87cR;;AoF/7cI;EACI,iBAAA;ApFk8cR;;AoFn8cI;EACI,iBAAA;ApFs8cR;;AoFv8cI;EACI,iBAAA;ApF08cR;;AoF38cI;EACI,iBAAA;ApF88cR;;AoF/8cI;EACI,iBAAA;ApFk9cR;;AoFn9cI;EACI,iBAAA;ApFs9cR;;AoFv9cI;EACI,iBAAA;ApF09cR;;AoF39cI;EACI,iBAAA;ApF89cR;;AoF/9cI;EACI,iBAAA;ApFk+cR;;AoFn+cI;EACI,iBAAA;ApFs+cR;;AoFv+cI;EACI,iBAAA;ApF0+cR;;AoF3+cI;EACI,iBAAA;ApF8+cR;;AoF/+cI;EACI,iBAAA;ApFk/cR;;AoFn/cI;EACI,iBAAA;ApFs/cR;;AoFv/cI;EACI,iBAAA;ApF0/cR;;AoF3/cI;EACI,iBAAA;ApF8/cR;;AoF//cI;EACI,iBAAA;ApFkgdR;;AoFngdI;EACI,iBAAA;ApFsgdR;;AoFvgdI;EACI,iBAAA;ApF0gdR;;AoF3gdI;EACI,iBAAA;ApF8gdR;;AoF/gdI;EACI,iBAAA;ApFkhdR;;AoFnhdI;EACI,iBAAA;ApFshdR;;AoFvhdI;EACI,iBAAA;ApF0hdR;;AoF3hdI;EACI,iBAAA;ApF8hdR;;AoF/hdI;EACI,iBAAA;ApFkidR;;AoFnidI;EACI,iBAAA;ApFsidR;;AoFvidI;EACI,iBAAA;ApF0idR;;AoF3idI;EACI,iBAAA;ApF8idR;;AoF/idI;EACI,iBAAA;ApFkjdR;;AoFnjdI;EACI,iBAAA;ApFsjdR;;AoFvjdI;EACI,iBAAA;ApF0jdR;;AoF3jdI;EACI,iBAAA;ApF8jdR;;AoF/jdI;EACI,iBAAA;ApFkkdR;;AoFnkdI;EACI,iBAAA;ApFskdR;;AoFvkdI;EACI,iBAAA;ApF0kdR;;AoF3kdI;EACI,iBAAA;ApF8kdR;;AoF/kdI;EACI,iBAAA;ApFkldR;;AoFnldI;EACI,iBAAA;ApFsldR;;AoFvldI;EACI,iBAAA;ApF0ldR;;AoF3ldI;EACI,iBAAA;ApF8ldR;;AoF/ldI;EACI,iBAAA;ApFkmdR;;AoFnmdI;EACI,iBAAA;ApFsmdR;;AoFvmdI;EACI,iBAAA;ApF0mdR;;AoF3mdI;EACI,iBAAA;ApF8mdR;;AoF/mdI;EACI,iBAAA;ApFkndR;;AoFnndI;EACI,iBAAA;ApFsndR;;AoFvndI;EACI,iBAAA;ApF0ndR;;AoF3ndI;EACI,iBAAA;ApF8ndR;;AoF/ndI;EACI,iBAAA;ApFkodR;;AoFnodI;EACI,iBAAA;ApFsodR;;AoFvodI;EACI,iBAAA;ApF0odR;;AoF3odI;EACI,iBAAA;ApF8odR;;AoF/odI;EACI,iBAAA;ApFkpdR;;AoFnpdI;EACI,iBAAA;ApFspdR;;AoFvpdI;EACI,iBAAA;ApF0pdR;;AoF3pdI;EACI,iBAAA;ApF8pdR;;AoF/pdI;EACI,iBAAA;ApFkqdR;;AoFnqdI;EACI,iBAAA;ApFsqdR;;AoFvqdI;EACI,iBAAA;ApF0qdR;;AoF3qdI;EACI,iBAAA;ApF8qdR;;AoF/qdI;EACI,iBAAA;ApFkrdR;;AoFnrdI;EACI,iBAAA;ApFsrdR;;AoFvrdI;EACI,iBAAA;ApF0rdR;;AoF3rdI;EACI,iBAAA;ApF8rdR;;AoF/rdI;EACI,iBAAA;ApFksdR;;AoFnsdI;EACI,iBAAA;ApFssdR;;AoFvsdI;EACI,iBAAA;ApF0sdR;;AoF3sdI;EACI,iBAAA;ApF8sdR;;AoF/sdI;EACI,iBAAA;ApFktdR;;AoFntdI;EACI,iBAAA;ApFstdR;;AoFvtdI;EACI,iBAAA;ApF0tdR;;AoF3tdI;EACI,iBAAA;ApF8tdR;;AoF/tdI;EACI,iBAAA;ApFkudR;;AoFnudI;EACI,iBAAA;ApFsudR;;AoFvudI;EACI,iBAAA;ApF0udR;;AoF3udI;EACI,iBAAA;ApF8udR;;AoF/udI;EACI,iBAAA;ApFkvdR;;AoFnvdI;EACI,iBAAA;ApFsvdR;;AoFvvdI;EACI,iBAAA;ApF0vdR;;AoF3vdI;EACI,iBAAA;ApF8vdR;;AoF/vdI;EACI,iBAAA;ApFkwdR;;AoFnwdI;EACI,iBAAA;ApFswdR;;AoFvwdI;EACI,iBAAA;ApF0wdR;;AoF3wdI;EACI,iBAAA;ApF8wdR;;AoF/wdI;EACI,iBAAA;ApFkxdR;;AoFnxdI;EACI,iBAAA;ApFsxdR;;AoFvxdI;EACI,iBAAA;ApF0xdR;;AoF3xdI;EACI,iBAAA;ApF8xdR;;AoF/xdI;EACI,iBAAA;ApFkydR;;AoFnydI;EACI,iBAAA;ApFsydR;;AoFvydI;EACI,iBAAA;ApF0ydR;;AoF3ydI;EACI,iBAAA;ApF8ydR;;AoF/ydI;EACI,iBAAA;ApFkzdR;;AoFnzdI;EACI,iBAAA;ApFszdR;;AoFvzdI;EACI,iBAAA;ApF0zdR;;AoF3zdI;EACI,iBAAA;ApF8zdR;;AoF/zdI;EACI,iBAAA;ApFk0dR;;AoFn0dI;EACI,iBAAA;ApFs0dR;;AoFv0dI;EACI,iBAAA;ApF00dR;;AoF30dI;EACI,iBAAA;ApF80dR;;AoF/0dI;EACI,iBAAA;ApFk1dR;;AoFn1dI;EACI,iBAAA;ApFs1dR;;AoFv1dI;EACI,iBAAA;ApF01dR;;AoF31dI;EACI,iBAAA;ApF81dR;;AoF/1dI;EACI,iBAAA;ApFk2dR;;AoFn2dI;EACI,iBAAA;ApFs2dR;;AoFv2dI;EACI,iBAAA;ApF02dR;;AoF32dI;EACI,iBAAA;ApF82dR;;AoF/2dI;EACI,iBAAA;ApFk3dR;;AoFn3dI;EACI,iBAAA;ApFs3dR;;AoFv3dI;EACI,iBAAA;ApF03dR;;AoF33dI;EACI,iBAAA;ApF83dR;;AoF/3dI;EACI,iBAAA;ApFk4dR;;AoFn4dI;EACI,iBAAA;ApFs4dR;;AoFv4dI;EACI,iBAAA;ApF04dR;;AoF34dI;EACI,iBAAA;ApF84dR;;AoF/4dI;EACI,iBAAA;ApFk5dR;;AoFn5dI;EACI,iBAAA;ApFs5dR;;AoFv5dI;EACI,iBAAA;ApF05dR;;AoF35dI;EACI,iBAAA;ApF85dR;;AoF/5dI;EACI,iBAAA;ApFk6dR;;AoFn6dI;EACI,iBAAA;ApFs6dR;;AoFv6dI;EACI,iBAAA;ApF06dR;;AoF36dI;EACI,iBAAA;ApF86dR;;AoF/6dI;EACI,iBAAA;ApFk7dR;;AoFn7dI;EACI,iBAAA;ApFs7dR;;AoFv7dI;EACI,iBAAA;ApF07dR;;AoF37dI;EACI,iBAAA;ApF87dR;;AoF/7dI;EACI,iBAAA;ApFk8dR;;AoFn8dI;EACI,iBAAA;ApFs8dR;;AoFv8dI;EACI,iBAAA;ApF08dR;;AoF38dI;EACI,iBAAA;ApF88dR;;AoF/8dI;EACI,iBAAA;ApFk9dR;;AoFn9dI;EACI,iBAAA;ApFs9dR;;AoFv9dI;EACI,iBAAA;ApF09dR;;AoF39dI;EACI,iBAAA;ApF89dR;;AoF/9dI;EACI,iBAAA;ApFk+dR;;AoFn+dI;EACI,iBAAA;ApFs+dR;;AoFv+dI;EACI,iBAAA;ApF0+dR;;AoF3+dI;EACI,iBAAA;ApF8+dR;;AoF/+dI;EACI,iBAAA;ApFk/dR;;AoFn/dI;EACI,iBAAA;ApFs/dR;;AoFv/dI;EACI,iBAAA;ApF0/dR;;AoF3/dI;EACI,iBAAA;ApF8/dR;;AoF//dI;EACI,iBAAA;ApFkgeR;;AoFngeI;EACI,iBAAA;ApFsgeR;;AoFvgeI;EACI,iBAAA;ApF0geR;;AoF3geI;EACI,iBAAA;ApF8geR;;AoF/geI;EACI,iBAAA;ApFkheR;;AoFnheI;EACI,iBAAA;ApFsheR;;AoFvheI;EACI,iBAAA;ApF0heR;;AoF3heI;EACI,iBAAA;ApF8heR;;AoF/heI;EACI,iBAAA;ApFkieR;;AoFnieI;EACI,iBAAA;ApFsieR;;AoFvieI;EACI,iBAAA;ApF0ieR;;AoF3ieI;EACI,iBAAA;ApF8ieR;;AoF/ieI;EACI,iBAAA;ApFkjeR;;AoFnjeI;EACI,iBAAA;ApFsjeR;;AoFvjeI;EACI,iBAAA;ApF0jeR;;AoF3jeI;EACI,iBAAA;ApF8jeR;;AoF/jeI;EACI,iBAAA;ApFkkeR;;AoFnkeI;EACI,iBAAA;ApFskeR;;AoFvkeI;EACI,iBAAA;ApF0keR;;AoF3keI;EACI,iBAAA;ApF8keR;;AoF/keI;EACI,iBAAA;ApFkleR;;AoFnleI;EACI,iBAAA;ApFsleR;;AoFvleI;EACI,iBAAA;ApF0leR;;AoF3leI;EACI,iBAAA;ApF8leR;;AoF/leI;EACI,iBAAA;ApFkmeR;;AoFnmeI;EACI,iBAAA;ApFsmeR;;AoFvmeI;EACI,iBAAA;ApF0meR;;AoF3meI;EACI,iBAAA;ApF8meR;;AoF/meI;EACI,iBAAA;ApFkneR;;AoFnneI;EACI,iBAAA;ApFsneR;;AoFvneI;EACI,iBAAA;ApF0neR;;AoF3neI;EACI,iBAAA;ApF8neR;;AoF/neI;EACI,iBAAA;ApFkoeR;;AoFnoeI;EACI,iBAAA;ApFsoeR;;AoFvoeI;EACI,iBAAA;ApF0oeR;;AoF3oeI;EACI,iBAAA;ApF8oeR;;AoF/oeI;EACI,iBAAA;ApFkpeR;;AoFnpeI;EACI,iBAAA;ApFspeR;;AoFvpeI;EACI,iBAAA;ApF0peR;;AoF3peI;EACI,iBAAA;ApF8peR;;AoF/peI;EACI,iBAAA;ApFkqeR;;AoFnqeI;EACI,iBAAA;ApFsqeR;;AoFvqeI;EACI,iBAAA;ApF0qeR;;AoF3qeI;EACI,iBAAA;ApF8qeR;;AoF/qeI;EACI,iBAAA;ApFkreR;;AoFnreI;EACI,iBAAA;ApFsreR;;AoFvreI;EACI,iBAAA;ApF0reR;;AoF3reI;EACI,iBAAA;ApF8reR;;AoF/reI;EACI,iBAAA;ApFkseR;;AoFnseI;EACI,iBAAA;ApFsseR;;AoFvseI;EACI,iBAAA;ApF0seR;;AoF3seI;EACI,iBAAA;ApF8seR;;AoF/seI;EACI,iBAAA;ApFkteR;;AoFnteI;EACI,iBAAA;ApFsteR;;AoFvteI;EACI,iBAAA;ApF0teR;;AoF3teI;EACI,iBAAA;ApF8teR;;AoF/teI;EACI,iBAAA;ApFkueR;;AoFnueI;EACI,iBAAA;ApFsueR;;AoFvueI;EACI,iBAAA;ApF0ueR;;AoF3ueI;EACI,iBAAA;ApF8ueR;;AoF/ueI;EACI,iBAAA;ApFkveR;;AoFnveI;EACI,iBAAA;ApFsveR;;AoFvveI;EACI,iBAAA;ApF0veR;;AoF3veI;EACI,iBAAA;ApF8veR;;AoF/veI;EACI,iBAAA;ApFkweR;;AoFnweI;EACI,iBAAA;ApFsweR;;AoFvweI;EACI,iBAAA;ApF0weR;;AoF3weI;EACI,iBAAA;ApF8weR;;AoF/weI;EACI,iBAAA;ApFkxeR;;AoFnxeI;EACI,iBAAA;ApFsxeR;;AoFvxeI;EACI,iBAAA;ApF0xeR;;AoF3xeI;EACI,iBAAA;ApF8xeR;;AoF/xeI;EACI,iBAAA;ApFkyeR;;AoFnyeI;EACI,iBAAA;ApFsyeR;;AoFvyeI;EACI,iBAAA;ApF0yeR;;AoF3yeI;EACI,iBAAA;ApF8yeR;;AoF/yeI;EACI,iBAAA;ApFkzeR;;AoFnzeI;EACI,iBAAA;ApFszeR;;AoFvzeI;EACI,iBAAA;ApF0zeR;;AoF3zeI;EACI,iBAAA;ApF8zeR;;AoF/zeI;EACI,iBAAA;ApFk0eR;;AoFn0eI;EACI,iBAAA;ApFs0eR;;AoFv0eI;EACI,iBAAA;ApF00eR;;AoF30eI;EACI,iBAAA;ApF80eR;;AoF/0eI;EACI,iBAAA;ApFk1eR;;AoFn1eI;EACI,iBAAA;ApFs1eR;;AoFv1eI;EACI,iBAAA;ApF01eR;;AoF31eI;EACI,iBAAA;ApF81eR;;AoF/1eI;EACI,iBAAA;ApFk2eR;;AoFn2eI;EACI,iBAAA;ApFs2eR;;AoFv2eI;EACI,iBAAA;ApF02eR;;AoF32eI;EACI,iBAAA;ApF82eR;;AoF/2eI;EACI,iBAAA;ApFk3eR;;AoFn3eI;EACI,iBAAA;ApFs3eR;;AoFv3eI;EACI,iBAAA;ApF03eR;;AoF33eI;EACI,iBAAA;ApF83eR;;AoF/3eI;EACI,iBAAA;ApFk4eR;;AoFn4eI;EACI,iBAAA;ApFs4eR;;AoFv4eI;EACI,iBAAA;ApF04eR;;AoF34eI;EACI,iBAAA;ApF84eR;;AoF/4eI;EACI,iBAAA;ApFk5eR;;AoFn5eI;EACI,iBAAA;ApFs5eR;;AoFv5eI;EACI,iBAAA;ApF05eR;;AoF35eI;EACI,iBAAA;ApF85eR;;AoF/5eI;EACI,iBAAA;ApFk6eR;;AoFn6eI;EACI,iBAAA;ApFs6eR;;AoFv6eI;EACI,iBAAA;ApF06eR;;AoF36eI;EACI,iBAAA;ApF86eR;;AoF/6eI;EACI,iBAAA;ApFk7eR;;AoFn7eI;EACI,iBAAA;ApFs7eR;;AoFv7eI;EACI,iBAAA;ApF07eR;;AoF37eI;EACI,iBAAA;ApF87eR;;AoF/7eI;EACI,iBAAA;ApFk8eR;;AoFn8eI;EACI,iBAAA;ApFs8eR;;AoFv8eI;EACI,iBAAA;ApF08eR;;AoF38eI;EACI,iBAAA;ApF88eR;;AoF/8eI;EACI,iBAAA;ApFk9eR;;AoFn9eI;EACI,iBAAA;ApFs9eR;;AoFv9eI;EACI,iBAAA;ApF09eR;;AoF39eI;EACI,iBAAA;ApF89eR;;AoF/9eI;EACI,iBAAA;ApFk+eR;;AoFn+eI;EACI,iBAAA;ApFs+eR;;AoFv+eI;EACI,iBAAA;ApF0+eR;;AoF3+eI;EACI,iBAAA;ApF8+eR;;AoF/+eI;EACI,iBAAA;ApFk/eR;;AoFn/eI;EACI,iBAAA;ApFs/eR;;AoFv/eI;EACI,iBAAA;ApF0/eR;;AoF3/eI;EACI,iBAAA;ApF8/eR;;AoF//eI;EACI,iBAAA;ApFkgfR;;AoFngfI;EACI,iBAAA;ApFsgfR;;AoFvgfI;EACI,iBAAA;ApF0gfR;;AoF3gfI;EACI,iBAAA;ApF8gfR;;AoF/gfI;EACI,iBAAA;ApFkhfR;;AoFnhfI;EACI,iBAAA;ApFshfR;;AoFvhfI;EACI,iBAAA;ApF0hfR;;AoF3hfI;EACI,iBAAA;ApF8hfR;;AoF/hfI;EACI,iBAAA;ApFkifR;;AoFnifI;EACI,iBAAA;ApFsifR;;AoFvifI;EACI,iBAAA;ApF0ifR;;AoF3ifI;EACI,iBAAA;ApF8ifR;;AoF/ifI;EACI,iBAAA;ApFkjfR;;AoFnjfI;EACI,iBAAA;ApFsjfR;;AoFvjfI;EACI,iBAAA;ApF0jfR;;AoF3jfI;EACI,iBAAA;ApF8jfR;;AoF/jfI;EACI,iBAAA;ApFkkfR;;AoFnkfI;EACI,iBAAA;ApFskfR;;AoFvkfI;EACI,iBAAA;ApF0kfR;;AoF3kfI;EACI,iBAAA;ApF8kfR;;AoF/kfI;EACI,iBAAA;ApFklfR;;AoFnlfI;EACI,iBAAA;ApFslfR;;AoFvlfI;EACI,iBAAA;ApF0lfR;;AoF3lfI;EACI,iBAAA;ApF8lfR;;AoF/lfI;EACI,iBAAA;ApFkmfR;;AoFnmfI;EACI,iBAAA;ApFsmfR;;AoFvmfI;EACI,iBAAA;ApF0mfR;;AoF3mfI;EACI,iBAAA;ApF8mfR;;AoF/mfI;EACI,iBAAA;ApFknfR;;AoFnnfI;EACI,iBAAA;ApFsnfR;;AoFvnfI;EACI,iBAAA;ApF0nfR;;AoF3nfI;EACI,iBAAA;ApF8nfR;;AoF/nfI;EACI,iBAAA;ApFkofR;;AoFnofI;EACI,iBAAA;ApFsofR;;AoFvofI;EACI,iBAAA;ApF0ofR;;AoF3ofI;EACI,iBAAA;ApF8ofR;;AoF/ofI;EACI,iBAAA;ApFkpfR;;AoFnpfI;EACI,iBAAA;ApFspfR;;AoFvpfI;EACI,iBAAA;ApF0pfR;;AoF3pfI;EACI,iBAAA;ApF8pfR;;AoF/pfI;EACI,iBAAA;ApFkqfR;;AoFnqfI;EACI,iBAAA;ApFsqfR;;AoFvqfI;EACI,iBAAA;ApF0qfR;;AoF3qfI;EACI,iBAAA;ApF8qfR;;AoF/qfI;EACI,iBAAA;ApFkrfR;;AoFnrfI;EACI,iBAAA;ApFsrfR;;AoFvrfI;EACI,iBAAA;ApF0rfR;;AoF3rfI;EACI,iBAAA;ApF8rfR;;AoF/rfI;EACI,iBAAA;ApFksfR;;AoFnsfI;EACI,iBAAA;ApFssfR;;AoFvsfI;EACI,iBAAA;ApF0sfR;;AoF3sfI;EACI,iBAAA;ApF8sfR;;AoF/sfI;EACI,iBAAA;ApFktfR;;AoFntfI;EACI,iBAAA;ApFstfR;;AoFvtfI;EACI,iBAAA;ApF0tfR;;AoF3tfI;EACI,iBAAA;ApF8tfR;;AoF/tfI;EACI,iBAAA;ApFkufR;;AoFnufI;EACI,iBAAA;ApFsufR;;AoFvufI;EACI,iBAAA;ApF0ufR;;AoF3ufI;EACI,iBAAA;ApF8ufR;;AoF/ufI;EACI,iBAAA;ApFkvfR;;AoFnvfI;EACI,iBAAA;ApFsvfR;;AoFvvfI;EACI,iBAAA;ApF0vfR;;AoF3vfI;EACI,iBAAA;ApF8vfR;;AoF/vfI;EACI,iBAAA;ApFkwfR;;AoFnwfI;EACI,iBAAA;ApFswfR;;AoFvwfI;EACI,iBAAA;ApF0wfR;;AoF3wfI;EACI,iBAAA;ApF8wfR;;AoF/wfI;EACI,iBAAA;ApFkxfR;;AoFnxfI;EACI,iBAAA;ApFsxfR;;AoFvxfI;EACI,iBAAA;ApF0xfR;;AoF3xfI;EACI,iBAAA;ApF8xfR;;AoF/xfI;EACI,iBAAA;ApFkyfR;;AoFnyfI;EACI,iBAAA;ApFsyfR;;AoFvyfI;EACI,iBAAA;ApF0yfR;;AoF3yfI;EACI,iBAAA;ApF8yfR;;AoF/yfI;EACI,iBAAA;ApFkzfR;;AoFnzfI;EACI,iBAAA;ApFszfR;;AoFvzfI;EACI,iBAAA;ApF0zfR;;AoF3zfI;EACI,iBAAA;ApF8zfR;;AoF/zfI;EACI,iBAAA;ApFk0fR;;AoFn0fI;EACI,iBAAA;ApFs0fR;;AoFv0fI;EACI,iBAAA;ApF00fR;;AoF30fI;EACI,iBAAA;ApF80fR;;AoF/0fI;EACI,iBAAA;ApFk1fR;;AoFn1fI;EACI,iBAAA;ApFs1fR;;AoFv1fI;EACI,iBAAA;ApF01fR;;AoF31fI;EACI,iBAAA;ApF81fR;;AoF/1fI;EACI,iBAAA;ApFk2fR;;AoFn2fI;EACI,iBAAA;ApFs2fR;;AoFv2fI;EACI,iBAAA;ApF02fR;;AoF32fI;EACI,iBAAA;ApF82fR;;AoF/2fI;EACI,iBAAA;ApFk3fR;;AoFn3fI;EACI,iBAAA;ApFs3fR;;AoFv3fI;EACI,iBAAA;ApF03fR;;AoF33fI;EACI,iBAAA;ApF83fR;;AoF/3fI;EACI,iBAAA;ApFk4fR;;AoFn4fI;EACI,iBAAA;ApFs4fR;;AoFv4fI;EACI,iBAAA;ApF04fR;;AoF34fI;EACI,iBAAA;ApF84fR;;AoF/4fI;EACI,iBAAA;ApFk5fR;;AoFn5fI;EACI,iBAAA;ApFs5fR;;AoFv5fI;EACI,iBAAA;ApF05fR;;AoF35fI;EACI,iBAAA;ApF85fR;;AoF/5fI;EACI,iBAAA;ApFk6fR;;AoFn6fI;EACI,iBAAA;ApFs6fR;;AoFv6fI;EACI,iBAAA;ApF06fR;;AoF36fI;EACI,iBAAA;ApF86fR;;AoF/6fI;EACI,iBAAA;ApFk7fR;;AoFn7fI;EACI,iBAAA;ApFs7fR;;AoFv7fI;EACI,iBAAA;ApF07fR;;AoF37fI;EACI,iBAAA;ApF87fR;;AoF/7fI;EACI,iBAAA;ApFk8fR;;AoFn8fI;EACI,iBAAA;ApFs8fR;;AoFv8fI;EACI,iBAAA;ApF08fR;;AoF38fI;EACI,iBAAA;ApF88fR;;AoF/8fI;EACI,iBAAA;ApFk9fR;;AoFn9fI;EACI,iBAAA;ApFs9fR;;AoFv9fI;EACI,iBAAA;ApF09fR;;AoF39fI;EACI,iBAAA;ApF89fR;;AoF/9fI;EACI,iBAAA;ApFk+fR;;AoFn+fI;EACI,iBAAA;ApFs+fR;;AoFv+fI;EACI,iBAAA;ApF0+fR;;AoF3+fI;EACI,iBAAA;ApF8+fR;;AoF/+fI;EACI,iBAAA;ApFk/fR;;AoFn/fI;EACI,iBAAA;ApFs/fR;;AoFv/fI;EACI,iBAAA;ApF0/fR;;AoF3/fI;EACI,iBAAA;ApF8/fR;;AoF//fI;EACI,iBAAA;ApFkggBR;;AoFnggBI;EACI,iBAAA;ApFsggBR;;AoFvggBI;EACI,iBAAA;ApF0ggBR;;AoF3ggBI;EACI,iBAAA;ApF8ggBR;;AoF/ggBI;EACI,iBAAA;ApFkhgBR;;AoFnhgBI;EACI,iBAAA;ApFshgBR;;AoFvhgBI;EACI,iBAAA;ApF0hgBR;;AoF3hgBI;EACI,iBAAA;ApF8hgBR;;AoF/hgBI;EACI,iBAAA;ApFkigBR;;AoFnigBI;EACI,iBAAA;ApFsigBR;;AoFvigBI;EACI,iBAAA;ApF0igBR;;AoF3igBI;EACI,iBAAA;ApF8igBR;;AoF/igBI;EACI,iBAAA;ApFkjgBR;;AoFnjgBI;EACI,iBAAA;ApFsjgBR;;AoFvjgBI;EACI,iBAAA;ApF0jgBR;;AoF3jgBI;EACI,iBAAA;ApF8jgBR;;AoF/jgBI;EACI,iBAAA;ApFkkgBR;;AoFnkgBI;EACI,iBAAA;ApFskgBR;;AoFvkgBI;EACI,iBAAA;ApF0kgBR;;AoF3kgBI;EACI,iBAAA;ApF8kgBR;;AoF/kgBI;EACI,iBAAA;ApFklgBR;;AoFnlgBI;EACI,iBAAA;ApFslgBR;;AoFvlgBI;EACI,iBAAA;ApF0lgBR;;AoF3lgBI;EACI,iBAAA;ApF8lgBR;;AoF/lgBI;EACI,iBAAA;ApFkmgBR;;AoFnmgBI;EACI,iBAAA;ApFsmgBR;;AoFvmgBI;EACI,iBAAA;ApF0mgBR;;AoF3mgBI;EACI,iBAAA;ApF8mgBR;;AoF/mgBI;EACI,iBAAA;ApFkngBR;;AoFnngBI;EACI,iBAAA;ApFsngBR;;AoFvngBI;EACI,iBAAA;ApF0ngBR;;AoF3ngBI;EACI,iBAAA;ApF8ngBR;;AoF/ngBI;EACI,iBAAA;ApFkogBR;;AoFnogBI;EACI,iBAAA;ApFsogBR;;AoFvogBI;EACI,iBAAA;ApF0ogBR;;AoF3ogBI;EACI,iBAAA;ApF8ogBR;;AoF/ogBI;EACI,iBAAA;ApFkpgBR;;AoFnpgBI;EACI,iBAAA;ApFspgBR;;AoFvpgBI;EACI,iBAAA;ApF0pgBR;;AoF3pgBI;EACI,iBAAA;ApF8pgBR;;AoF/pgBI;EACI,iBAAA;ApFkqgBR;;AoFnqgBI;EACI,iBAAA;ApFsqgBR;;AoFvqgBI;EACI,iBAAA;ApF0qgBR;;AoF3qgBI;EACI,iBAAA;ApF8qgBR;;AoF/qgBI;EACI,iBAAA;ApFkrgBR;;AoFnrgBI;EACI,iBAAA;ApFsrgBR;;AoFvrgBI;EACI,iBAAA;ApF0rgBR;;AoF3rgBI;EACI,iBAAA;ApF8rgBR;;AoF/rgBI;EACI,iBAAA;ApFksgBR;;AoFnsgBI;EACI,iBAAA;ApFssgBR;;AoFvsgBI;EACI,iBAAA;ApF0sgBR;;AoF3sgBI;EACI,iBAAA;ApF8sgBR;;AoF/sgBI;EACI,iBAAA;ApFktgBR;;AoFntgBI;EACI,iBAAA;ApFstgBR;;AoFvtgBI;EACI,iBAAA;ApF0tgBR;;AoF3tgBI;EACI,iBAAA;ApF8tgBR;;AoF/tgBI;EACI,iBAAA;ApFkugBR;;AoFnugBI;EACI,iBAAA;ApFsugBR;;AoFvugBI;EACI,iBAAA;ApF0ugBR;;AoF3ugBI;EACI,iBAAA;ApF8ugBR;;AoF/ugBI;EACI,iBAAA;ApFkvgBR;;AoFnvgBI;EACI,iBAAA;ApFsvgBR;;AoFvvgBI;EACI,iBAAA;ApF0vgBR;;AoF3vgBI;EACI,iBAAA;ApF8vgBR;;AoF/vgBI;EACI,iBAAA;ApFkwgBR;;AoFnwgBI;EACI,iBAAA;ApFswgBR;;AoFvwgBI;EACI,iBAAA;ApF0wgBR;;AoF3wgBI;EACI,iBAAA;ApF8wgBR;;AoF/wgBI;EACI,iBAAA;ApFkxgBR;;AoFnxgBI;EACI,iBAAA;ApFsxgBR;;AoFvxgBI;EACI,iBAAA;ApF0xgBR;;AoF3xgBI;EACI,iBAAA;ApF8xgBR;;AoF/xgBI;EACI,iBAAA;ApFkygBR;;AoFnygBI;EACI,iBAAA;ApFsygBR;;AoFvygBI;EACI,iBAAA;ApF0ygBR;;AoF3ygBI;EACI,iBAAA;ApF8ygBR;;AoF/ygBI;EACI,iBAAA;ApFkzgBR;;AoFnzgBI;EACI,iBAAA;ApFszgBR;;AoFvzgBI;EACI,iBAAA;ApF0zgBR;;AoF3zgBI;EACI,iBAAA;ApF8zgBR;;AoF/zgBI;EACI,iBAAA;ApFk0gBR;;AoFn0gBI;EACI,iBAAA;ApFs0gBR;;AoFv0gBI;EACI,iBAAA;ApF00gBR;;AoF30gBI;EACI,iBAAA;ApF80gBR;;AoF/0gBI;EACI,iBAAA;ApFk1gBR;;AoFn1gBI;EACI,iBAAA;ApFs1gBR;;AoFv1gBI;EACI,iBAAA;ApF01gBR;;AoF31gBI;EACI,iBAAA;ApF81gBR;;AoF/1gBI;EACI,iBAAA;ApFk2gBR;;AoFn2gBI;EACI,iBAAA;ApFs2gBR;;AoFv2gBI;EACI,iBAAA;ApF02gBR;;AoF32gBI;EACI,iBAAA;ApF82gBR;;AoF/2gBI;EACI,iBAAA;ApFk3gBR;;AoFn3gBI;EACI,iBAAA;ApFs3gBR;;AoFv3gBI;EACI,iBAAA;ApF03gBR;;AoF33gBI;EACI,iBAAA;ApF83gBR;;AoF/3gBI;EACI,iBAAA;ApFk4gBR;;AoFn4gBI;EACI,iBAAA;ApFs4gBR;;AoFv4gBI;EACI,iBAAA;ApF04gBR;;AoF34gBI;EACI,iBAAA;ApF84gBR;;AoF/4gBI;EACI,iBAAA;ApFk5gBR;;AoFn5gBI;EACI,iBAAA;ApFs5gBR;;AoFv5gBI;EACI,iBAAA;ApF05gBR;;AoF35gBI;EACI,iBAAA;ApF85gBR;;AoF/5gBI;EACI,iBAAA;ApFk6gBR;;AoFn6gBI;EACI,iBAAA;ApFs6gBR;;AoFv6gBI;EACI,iBAAA;ApF06gBR;;AoF36gBI;EACI,iBAAA;ApF86gBR;;AoF/6gBI;EACI,iBAAA;ApFk7gBR;;AoFn7gBI;EACI,iBAAA;ApFs7gBR;;AoFv7gBI;EACI,iBAAA;ApF07gBR;;AoF37gBI;EACI,iBAAA;ApF87gBR;;AoF/7gBI;EACI,iBAAA;ApFk8gBR;;AoFn8gBI;EACI,iBAAA;ApFs8gBR;;AoFv8gBI;EACI,iBAAA;ApF08gBR;;AoF38gBI;EACI,iBAAA;ApF88gBR;;AoF/8gBI;EACI,iBAAA;ApFk9gBR;;AoFn9gBI;EACI,iBAAA;ApFs9gBR;;AoFv9gBI;EACI,iBAAA;ApF09gBR;;AoF39gBI;EACI,iBAAA;ApF89gBR;;AoF/9gBI;EACI,iBAAA;ApFk+gBR;;AoFn+gBI;EACI,iBAAA;ApFs+gBR;;AoFv+gBI;EACI,iBAAA;ApF0+gBR;;AoF3+gBI;EACI,iBAAA;ApF8+gBR;;AoF/+gBI;EACI,iBAAA;ApFk/gBR;;AoFn/gBI;EACI,iBAAA;ApFs/gBR;;AoFv/gBI;EACI,iBAAA;ApF0/gBR;;AoF3/gBI;EACI,iBAAA;ApF8/gBR;;AoF//gBI;EACI,iBAAA;ApFkghBR;;AoFnghBI;EACI,iBAAA;ApFsghBR;;AoFvghBI;EACI,iBAAA;ApF0ghBR;;AoF3ghBI;EACI,iBAAA;ApF8ghBR;;AoF/ghBI;EACI,iBAAA;ApFkhhBR;;AoFnhhBI;EACI,iBAAA;ApFshhBR;;AoFvhhBI;EACI,iBAAA;ApF0hhBR;;AoF3hhBI;EACI,iBAAA;ApF8hhBR;;AoF/hhBI;EACI,iBAAA;ApFkihBR;;AoFnihBI;EACI,iBAAA;ApFsihBR;;AoFvihBI;EACI,iBAAA;ApF0ihBR;;AoF3ihBI;EACI,iBAAA;ApF8ihBR;;AoF/ihBI;EACI,iBAAA;ApFkjhBR;;AoFnjhBI;EACI,iBAAA;ApFsjhBR;;AoFvjhBI;EACI,iBAAA;ApF0jhBR;;AoF3jhBI;EACI,iBAAA;ApF8jhBR;;AoF/jhBI;EACI,iBAAA;ApFkkhBR;;AoFnkhBI;EACI,iBAAA;ApFskhBR;;AoFvkhBI;EACI,iBAAA;ApF0khBR;;AoF3khBI;EACI,iBAAA;ApF8khBR;;AoF/khBI;EACI,iBAAA;ApFklhBR;;AoFnlhBI;EACI,iBAAA;ApFslhBR;;AoFvlhBI;EACI,iBAAA;ApF0lhBR;;AoF3lhBI;EACI,iBAAA;ApF8lhBR;;AoF/lhBI;EACI,iBAAA;ApFkmhBR;;AoFnmhBI;EACI,iBAAA;ApFsmhBR;;AoFvmhBI;EACI,iBAAA;ApF0mhBR;;AoF3mhBI;EACI,iBAAA;ApF8mhBR;;AoF/mhBI;EACI,iBAAA;ApFknhBR;;AoFnnhBI;EACI,iBAAA;ApFsnhBR;;AoFvnhBI;EACI,iBAAA;ApF0nhBR;;AoF3nhBI;EACI,iBAAA;ApF8nhBR;;AoF/nhBI;EACI,iBAAA;ApFkohBR;;AoFnohBI;EACI,iBAAA;ApFsohBR;;AoFvohBI;EACI,iBAAA;ApF0ohBR;;AoF3ohBI;EACI,iBAAA;ApF8ohBR;;AoF/ohBI;EACI,iBAAA;ApFkphBR;;AoFnphBI;EACI,iBAAA;ApFsphBR;;AoFvphBI;EACI,iBAAA;ApF0phBR;;AoF3phBI;EACI,iBAAA;ApF8phBR;;AoF/phBI;EACI,iBAAA;ApFkqhBR;;AoFnqhBI;EACI,iBAAA;ApFsqhBR;;AoFvqhBI;EACI,iBAAA;ApF0qhBR;;AoF3qhBI;EACI,iBAAA;ApF8qhBR;;AoF/qhBI;EACI,iBAAA;ApFkrhBR;;AoFnrhBI;EACI,iBAAA;ApFsrhBR;;AoFvrhBI;EACI,iBAAA;ApF0rhBR;;AoF3rhBI;EACI,iBAAA;ApF8rhBR;;AoF/rhBI;EACI,iBAAA;ApFkshBR;;AoFnshBI;EACI,iBAAA;ApFsshBR;;AoFvshBI;EACI,iBAAA;ApF0shBR;;AoF3shBI;EACI,iBAAA;ApF8shBR;;AoF/shBI;EACI,iBAAA;ApFkthBR;;AoFnthBI;EACI,iBAAA;ApFsthBR;;AoFvthBI;EACI,iBAAA;ApF0thBR;;AoF3thBI;EACI,iBAAA;ApF8thBR;;AoF/thBI;EACI,iBAAA;ApFkuhBR;;AoFnuhBI;EACI,iBAAA;ApFsuhBR;;AoFvuhBI;EACI,iBAAA;ApF0uhBR;;AoF3uhBI;EACI,iBAAA;ApF8uhBR;;AoF/uhBI;EACI,iBAAA;ApFkvhBR;;AoFnvhBI;EACI,iBAAA;ApFsvhBR;;AoFvvhBI;EACI,iBAAA;ApF0vhBR;;AoF3vhBI;EACI,iBAAA;ApF8vhBR;;AoF/vhBI;EACI,iBAAA;ApFkwhBR;;AoFnwhBI;EACI,iBAAA;ApFswhBR;;AoFvwhBI;EACI,iBAAA;ApF0whBR;;AoF3whBI;EACI,iBAAA;ApF8whBR;;AoF/whBI;EACI,iBAAA;ApFkxhBR;;AoFnxhBI;EACI,iBAAA;ApFsxhBR;;AoFvxhBI;EACI,iBAAA;ApF0xhBR;;AoF3xhBI;EACI,iBAAA;ApF8xhBR;;AoF/xhBI;EACI,iBAAA;ApFkyhBR;;AoFnyhBI;EACI,iBAAA;ApFsyhBR;;AoFvyhBI;EACI,iBAAA;ApF0yhBR;;AoF3yhBI;EACI,iBAAA;ApF8yhBR;;AoF/yhBI;EACI,iBAAA;ApFkzhBR;;AoFnzhBI;EACI,iBAAA;ApFszhBR;;AoFvzhBI;EACI,iBAAA;ApF0zhBR;;AoF3zhBI;EACI,iBAAA;ApF8zhBR;;AoF/zhBI;EACI,iBAAA;ApFk0hBR;;AoFn0hBI;EACI,iBAAA;ApFs0hBR;;AoFv0hBI;EACI,iBAAA;ApF00hBR;;AoF30hBI;EACI,iBAAA;ApF80hBR;;AoF/0hBI;EACI,iBAAA;ApFk1hBR;;AoFn1hBI;EACI,iBAAA;ApFs1hBR;;AoFv1hBI;EACI,iBAAA;ApF01hBR;;AoF31hBI;EACI,iBAAA;ApF81hBR;;AoF/1hBI;EACI,iBAAA;ApFk2hBR;;AoFn2hBI;EACI,iBAAA;ApFs2hBR;;AoFv2hBI;EACI,iBAAA;ApF02hBR;;AoF32hBI;EACI,iBAAA;ApF82hBR;;AoF/2hBI;EACI,iBAAA;ApFk3hBR;;AoFn3hBI;EACI,iBAAA;ApFs3hBR;;AoFv3hBI;EACI,iBAAA;ApF03hBR;;AoF33hBI;EACI,iBAAA;ApF83hBR;;AoF/3hBI;EACI,iBAAA;ApFk4hBR;;AoFn4hBI;EACI,iBAAA;ApFs4hBR;;AoFv4hBI;EACI,iBAAA;ApF04hBR;;AoF34hBI;EACI,iBAAA;ApF84hBR;;AoF/4hBI;EACI,iBAAA;ApFk5hBR;;AoFn5hBI;EACI,iBAAA;ApFs5hBR;;AoFv5hBI;EACI,iBAAA;ApF05hBR;;AoF35hBI;EACI,iBAAA;ApF85hBR;;AoF/5hBI;EACI,iBAAA;ApFk6hBR;;AoFn6hBI;EACI,iBAAA;ApFs6hBR;;AoFv6hBI;EACI,iBAAA;ApF06hBR;;AoF36hBI;EACI,iBAAA;ApF86hBR;;AoF/6hBI;EACI,iBAAA;ApFk7hBR;;AoFn7hBI;EACI,iBAAA;ApFs7hBR;;AoFv7hBI;EACI,iBAAA;ApF07hBR;;AoF37hBI;EACI,iBAAA;ApF87hBR;;AoF/7hBI;EACI,iBAAA;ApFk8hBR;;AoFn8hBI;EACI,iBAAA;ApFs8hBR;;AoFv8hBI;EACI,iBAAA;ApF08hBR;;AoF38hBI;EACI,iBAAA;ApF88hBR;;AoF/8hBI;EACI,iBAAA;ApFk9hBR;;AoFn9hBI;EACI,iBAAA;ApFs9hBR;;AoFv9hBI;EACI,iBAAA;ApF09hBR;;AoF39hBI;EACI,iBAAA;ApF89hBR;;AoF/9hBI;EACI,iBAAA;ApFk+hBR;;AoFn+hBI;EACI,iBAAA;ApFs+hBR;;AoFv+hBI;EACI,iBAAA;ApF0+hBR;;AoF3+hBI;EACI,iBAAA;ApF8+hBR;;AoF/+hBI;EACI,iBAAA;ApFk/hBR;;AoFn/hBI;EACI,iBAAA;ApFs/hBR;;AoFv/hBI;EACI,iBAAA;ApF0/hBR;;AoF3/hBI;EACI,iBAAA;ApF8/hBR;;AoF//hBI;EACI,iBAAA;ApFkgiBR;;AoFngiBI;EACI,iBAAA;ApFsgiBR;;AoFvgiBI;EACI,iBAAA;ApF0giBR;;AoF3giBI;EACI,iBAAA;ApF8giBR;;AoF/giBI;EACI,iBAAA;ApFkhiBR;;AoFnhiBI;EACI,iBAAA;ApFshiBR;;AoFvhiBI;EACI,iBAAA;ApF0hiBR;;AoF3hiBI;EACI,iBAAA;ApF8hiBR;;AoF/hiBI;EACI,iBAAA;ApFkiiBR;;AoFniiBI;EACI,iBAAA;ApFsiiBR;;AoFviiBI;EACI,iBAAA;ApF0iiBR;;AoF3iiBI;EACI,iBAAA;ApF8iiBR;;AoF/iiBI;EACI,iBAAA;ApFkjiBR;;AoFnjiBI;EACI,iBAAA;ApFsjiBR;;AoFvjiBI;EACI,iBAAA;ApF0jiBR;;AoF3jiBI;EACI,iBAAA;ApF8jiBR;;AoF/jiBI;EACI,iBAAA;ApFkkiBR;;AoFnkiBI;EACI,iBAAA;ApFskiBR;;AoFvkiBI;EACI,iBAAA;ApF0kiBR;;AoF3kiBI;EACI,iBAAA;ApF8kiBR;;AoF/kiBI;EACI,iBAAA;ApFkliBR;;AoFnliBI;EACI,iBAAA;ApFsliBR;;AoFvliBI;EACI,iBAAA;ApF0liBR;;AoF3liBI;EACI,iBAAA;ApF8liBR;;AoF/liBI;EACI,iBAAA;ApFkmiBR;;AoFnmiBI;EACI,iBAAA;ApFsmiBR;;AoFvmiBI;EACI,iBAAA;ApF0miBR;;AoF3miBI;EACI,iBAAA;ApF8miBR;;AoF/miBI;EACI,iBAAA;ApFkniBR;;AoFnniBI;EACI,iBAAA;ApFsniBR;;AoFvniBI;EACI,iBAAA;ApF0niBR;;AoF3niBI;EACI,iBAAA;ApF8niBR;;AoF/niBI;EACI,iBAAA;ApFkoiBR;;AoFnoiBI;EACI,iBAAA;ApFsoiBR;;AoFvoiBI;EACI,iBAAA;ApF0oiBR;;AoF3oiBI;EACI,iBAAA;ApF8oiBR;;AoF/oiBI;EACI,iBAAA;ApFkpiBR;;AoFnpiBI;EACI,iBAAA;ApFspiBR;;AoFvpiBI;EACI,iBAAA;ApF0piBR;;AoF3piBI;EACI,iBAAA;ApF8piBR;;AoF/piBI;EACI,iBAAA;ApFkqiBR;;AoFnqiBI;EACI,iBAAA;ApFsqiBR;;AoFvqiBI;EACI,iBAAA;ApF0qiBR;;AoF3qiBI;EACI,iBAAA;ApF8qiBR;;AoF/qiBI;EACI,iBAAA;ApFkriBR;;AoFnriBI;EACI,iBAAA;ApFsriBR;;AoFvriBI;EACI,iBAAA;ApF0riBR;;AoF3riBI;EACI,iBAAA;ApF8riBR;;AoF/riBI;EACI,iBAAA;ApFksiBR;;AoFnsiBI;EACI,iBAAA;ApFssiBR;;AoFvsiBI;EACI,iBAAA;ApF0siBR;;AoF3siBI;EACI,iBAAA;ApF8siBR;;AoF/siBI;EACI,iBAAA;ApFktiBR;;AoFntiBI;EACI,iBAAA;ApFstiBR;;AoFvtiBI;EACI,iBAAA;ApF0tiBR;;AoF3tiBI;EACI,iBAAA;ApF8tiBR;;AoF/tiBI;EACI,iBAAA;ApFkuiBR;;AoFnuiBI;EACI,iBAAA;ApFsuiBR;;AoFvuiBI;EACI,iBAAA;ApF0uiBR;;AoF3uiBI;EACI,iBAAA;ApF8uiBR;;AoF/uiBI;EACI,iBAAA;ApFkviBR;;AoFnviBI;EACI,iBAAA;ApFsviBR;;AoFvviBI;EACI,iBAAA;ApF0viBR;;AoF3viBI;EACI,iBAAA;ApF8viBR;;AoF/viBI;EACI,iBAAA;ApFkwiBR;;AoFnwiBI;EACI,iBAAA;ApFswiBR;;AoFvwiBI;EACI,iBAAA;ApF0wiBR;;AoF3wiBI;EACI,iBAAA;ApF8wiBR;;AoF/wiBI;EACI,iBAAA;ApFkxiBR;;AoFnxiBI;EACI,iBAAA;ApFsxiBR;;AoFvxiBI;EACI,iBAAA;ApF0xiBR;;AoF3xiBI;EACI,iBAAA;ApF8xiBR;;AoF/xiBI;EACI,iBAAA;ApFkyiBR;;AoFnyiBI;EACI,iBAAA;ApFsyiBR;;AoFvyiBI;EACI,iBAAA;ApF0yiBR;;AoF3yiBI;EACI,iBAAA;ApF8yiBR;;AoF/yiBI;EACI,iBAAA;ApFkziBR;;AoFnziBI;EACI,iBAAA;ApFsziBR;;AoFvziBI;EACI,iBAAA;ApF0ziBR;;AoF3ziBI;EACI,iBAAA;ApF8ziBR;;AoF/ziBI;EACI,iBAAA;ApFk0iBR;;AoFn0iBI;EACI,iBAAA;ApFs0iBR;;AoFv0iBI;EACI,iBAAA;ApF00iBR;;AoF30iBI;EACI,iBAAA;ApF80iBR;;AoF/0iBI;EACI,iBAAA;ApFk1iBR;;AoFn1iBI;EACI,iBAAA;ApFs1iBR;;AoFv1iBI;EACI,iBAAA;ApF01iBR;;AoF31iBI;EACI,iBAAA;ApF81iBR;;AoF/1iBI;EACI,iBAAA;ApFk2iBR;;AoFn2iBI;EACI,iBAAA;ApFs2iBR;;AoFv2iBI;EACI,iBAAA;ApF02iBR;;AoF32iBI;EACI,iBAAA;ApF82iBR;;AoF/2iBI;EACI,iBAAA;ApFk3iBR;;AoFn3iBI;EACI,iBAAA;ApFs3iBR;;AoFv3iBI;EACI,iBAAA;ApF03iBR;;AoF33iBI;EACI,iBAAA;ApF83iBR;;AoF/3iBI;EACI,iBAAA;ApFk4iBR;;AoFn4iBI;EACI,iBAAA;ApFs4iBR;;AoFv4iBI;EACI,iBAAA;ApF04iBR;;AoF34iBI;EACI,iBAAA;ApF84iBR;;AoF/4iBI;EACI,iBAAA;ApFk5iBR;;AoFn5iBI;EACI,iBAAA;ApFs5iBR;;AoFv5iBI;EACI,iBAAA;ApF05iBR;;AoF35iBI;EACI,iBAAA;ApF85iBR;;AoF/5iBI;EACI,iBAAA;ApFk6iBR;;AoFn6iBI;EACI,iBAAA;ApFs6iBR;;AoFv6iBI;EACI,iBAAA;ApF06iBR;;AoF36iBI;EACI,iBAAA;ApF86iBR;;AoF/6iBI;EACI,iBAAA;ApFk7iBR;;AoFn7iBI;EACI,iBAAA;ApFs7iBR;;AoFv7iBI;EACI,iBAAA;ApF07iBR;;AoF37iBI;EACI,iBAAA;ApF87iBR;;AoF/7iBI;EACI,iBAAA;ApFk8iBR;;AoFn8iBI;EACI,iBAAA;ApFs8iBR;;AoFv8iBI;EACI,iBAAA;ApF08iBR;;AoF38iBI;EACI,iBAAA;ApF88iBR;;AoF/8iBI;EACI,iBAAA;ApFk9iBR;;AoFn9iBI;EACI,iBAAA;ApFs9iBR;;AoFv9iBI;EACI,iBAAA;ApF09iBR;;AoF39iBI;EACI,iBAAA;ApF89iBR;;AoF/9iBI;EACI,iBAAA;ApFk+iBR;;AoFn+iBI;EACI,iBAAA;ApFs+iBR;;AoFv+iBI;EACI,iBAAA;ApF0+iBR;;AoF3+iBI;EACI,iBAAA;ApF8+iBR;;AoF/+iBI;EACI,iBAAA;ApFk/iBR;;AoFn/iBI;EACI,iBAAA;ApFs/iBR;;AoFv/iBI;EACI,iBAAA;ApF0/iBR;;AoF3/iBI;EACI,iBAAA;ApF8/iBR;;AoF//iBI;EACI,iBAAA;ApFkgjBR;;AoFngjBI;EACI,iBAAA;ApFsgjBR;;AoFvgjBI;EACI,iBAAA;ApF0gjBR;;AoF3gjBI;EACI,iBAAA;ApF8gjBR;;AoF/gjBI;EACI,iBAAA;ApFkhjBR;;AoFnhjBI;EACI,iBAAA;ApFshjBR;;AoFvhjBI;EACI,iBAAA;ApF0hjBR;;AoF3hjBI;EACI,iBAAA;ApF8hjBR;;AoF/hjBI;EACI,iBAAA;ApFkijBR;;AoFnijBI;EACI,iBAAA;ApFsijBR;;AoFvijBI;EACI,iBAAA;ApF0ijBR;;AoF3ijBI;EACI,iBAAA;ApF8ijBR;;AoF/ijBI;EACI,iBAAA;ApFkjjBR;;AoFnjjBI;EACI,iBAAA;ApFsjjBR;;AoFvjjBI;EACI,iBAAA;ApF0jjBR;;AoF3jjBI;EACI,iBAAA;ApF8jjBR;;AoF/jjBI;EACI,iBAAA;ApFkkjBR;;AoFnkjBI;EACI,iBAAA;ApFskjBR;;AoFvkjBI;EACI,iBAAA;ApF0kjBR;;AoF3kjBI;EACI,iBAAA;ApF8kjBR;;AoF/kjBI;EACI,iBAAA;ApFkljBR;;AoFnljBI;EACI,iBAAA;ApFsljBR;;AoFvljBI;EACI,iBAAA;ApF0ljBR;;AoF3ljBI;EACI,iBAAA;ApF8ljBR;;AoF/ljBI;EACI,iBAAA;ApFkmjBR;;AoFnmjBI;EACI,iBAAA;ApFsmjBR;;AoFvmjBI;EACI,iBAAA;ApF0mjBR;;AoF3mjBI;EACI,iBAAA;ApF8mjBR;;AoF/mjBI;EACI,iBAAA;ApFknjBR;;AoFnnjBI;EACI,iBAAA;ApFsnjBR;;AoFvnjBI;EACI,iBAAA;ApF0njBR;;AoF3njBI;EACI,iBAAA;ApF8njBR;;AoF/njBI;EACI,iBAAA;ApFkojBR;;AoFnojBI;EACI,iBAAA;ApFsojBR;;AoFvojBI;EACI,iBAAA;ApF0ojBR;;AoF3ojBI;EACI,iBAAA;ApF8ojBR;;AoF/ojBI;EACI,iBAAA;ApFkpjBR;;AoFnpjBI;EACI,iBAAA;ApFspjBR;;AoFvpjBI;EACI,iBAAA;ApF0pjBR;;AoF3pjBI;EACI,iBAAA;ApF8pjBR;;AoF/pjBI;EACI,iBAAA;ApFkqjBR;;AoFnqjBI;EACI,iBAAA;ApFsqjBR;;AoFvqjBI;EACI,iBAAA;ApF0qjBR;;AoF3qjBI;EACI,iBAAA;ApF8qjBR;;AoF/qjBI;EACI,iBAAA;ApFkrjBR;;AoFnrjBI;EACI,iBAAA;ApFsrjBR;;AoFvrjBI;EACI,iBAAA;ApF0rjBR;;AoF3rjBI;EACI,iBAAA;ApF8rjBR;;AoF/rjBI;EACI,iBAAA;ApFksjBR;;AoFnsjBI;EACI,iBAAA;ApFssjBR;;AoFvsjBI;EACI,iBAAA;ApF0sjBR;;AoF3sjBI;EACI,iBAAA;ApF8sjBR;;AoF/sjBI;EACI,iBAAA;ApFktjBR;;AoFntjBI;EACI,iBAAA;ApFstjBR;;AoFvtjBI;EACI,iBAAA;ApF0tjBR;;AoF3tjBI;EACI,iBAAA;ApF8tjBR;;AoF/tjBI;EACI,iBAAA;ApFkujBR;;AoFnujBI;EACI,iBAAA;ApFsujBR;;AoFvujBI;EACI,iBAAA;ApF0ujBR;;AoF3ujBI;EACI,iBAAA;ApF8ujBR;;AoF/ujBI;EACI,iBAAA;ApFkvjBR;;AoFnvjBI;EACI,iBAAA;ApFsvjBR;;AoFvvjBI;EACI,iBAAA;ApF0vjBR;;AoF3vjBI;EACI,iBAAA;ApF8vjBR;;AoF/vjBI;EACI,iBAAA;ApFkwjBR;;AoFnwjBI;EACI,iBAAA;ApFswjBR;;AoFvwjBI;EACI,iBAAA;ApF0wjBR;;AoF3wjBI;EACI,iBAAA;ApF8wjBR;;AoF/wjBI;EACI,iBAAA;ApFkxjBR;;AoFnxjBI;EACI,iBAAA;ApFsxjBR;;AoFvxjBI;EACI,iBAAA;ApF0xjBR;;AoF3xjBI;EACI,iBAAA;ApF8xjBR;;AoF/xjBI;EACI,iBAAA;ApFkyjBR;;AoFnyjBI;EACI,iBAAA;ApFsyjBR;;AoFvyjBI;EACI,iBAAA;ApF0yjBR;;AoF3yjBI;EACI,iBAAA;ApF8yjBR;;AoF/yjBI;EACI,iBAAA;ApFkzjBR;;AoFnzjBI;EACI,iBAAA;ApFszjBR;;AoFvzjBI;EACI,iBAAA;ApF0zjBR;;AoF3zjBI;EACI,iBAAA;ApF8zjBR;;AoF/zjBI;EACI,iBAAA;ApFk0jBR;;AoFn0jBI;EACI,iBAAA;ApFs0jBR;;AoFv0jBI;EACI,iBAAA;ApF00jBR;;AoF30jBI;EACI,iBAAA;ApF80jBR;;AoF/0jBI;EACI,iBAAA;ApFk1jBR;;AoFn1jBI;EACI,iBAAA;ApFs1jBR;;AoFv1jBI;EACI,iBAAA;ApF01jBR;;AoF31jBI;EACI,iBAAA;ApF81jBR;;AoF/1jBI;EACI,iBAAA;ApFk2jBR;;AoFn2jBI;EACI,iBAAA;ApFs2jBR;;AoFv2jBI;EACI,iBAAA;ApF02jBR;;AoF32jBI;EACI,iBAAA;ApF82jBR;;AoF/2jBI;EACI,iBAAA;ApFk3jBR;;AoFn3jBI;EACI,iBAAA;ApFs3jBR;;AoFv3jBI;EACI,iBAAA;ApF03jBR;;AoF33jBI;EACI,iBAAA;ApF83jBR;;AoF/3jBI;EACI,iBAAA;ApFk4jBR;;AoFn4jBI;EACI,iBAAA;ApFs4jBR;;AoFv4jBI;EACI,iBAAA;ApF04jBR;;AoF34jBI;EACI,iBAAA;ApF84jBR;;AoF/4jBI;EACI,iBAAA;ApFk5jBR;;AoFn5jBI;EACI,iBAAA;ApFs5jBR;;AoFv5jBI;EACI,iBAAA;ApF05jBR;;AoF35jBI;EACI,iBAAA;ApF85jBR;;AoF/5jBI;EACI,iBAAA;ApFk6jBR;;AoFn6jBI;EACI,iBAAA;ApFs6jBR;;AoFv6jBI;EACI,iBAAA;ApF06jBR;;AoF36jBI;EACI,iBAAA;ApF86jBR;;AoF/6jBI;EACI,iBAAA;ApFk7jBR;;AoFn7jBI;EACI,iBAAA;ApFs7jBR;;AoFv7jBI;EACI,iBAAA;ApF07jBR;;AoF37jBI;EACI,iBAAA;ApF87jBR;;AoF/7jBI;EACI,iBAAA;ApFk8jBR;;AoFn8jBI;EACI,iBAAA;ApFs8jBR;;AoFv8jBI;EACI,iBAAA;ApF08jBR;;AoF38jBI;EACI,iBAAA;ApF88jBR;;AoF/8jBI;EACI,iBAAA;ApFk9jBR;;AoFn9jBI;EACI,iBAAA;ApFs9jBR;;AoFv9jBI;EACI,iBAAA;ApF09jBR;;AoF39jBI;EACI,iBAAA;ApF89jBR;;AoF/9jBI;EACI,iBAAA;ApFk+jBR;;AoFn+jBI;EACI,iBAAA;ApFs+jBR;;AoFv+jBI;EACI,iBAAA;ApF0+jBR;;AoF3+jBI;EACI,iBAAA;ApF8+jBR;;AoF/+jBI;EACI,iBAAA;ApFk/jBR;;AoFn/jBI;EACI,iBAAA;ApFs/jBR;;AoFv/jBI;EACI,iBAAA;ApF0/jBR;;AoF3/jBI;EACI,iBAAA;ApF8/jBR;;AoF//jBI;EACI,iBAAA;ApFkgkBR;;AoFngkBI;EACI,iBAAA;ApFsgkBR;;AoFvgkBI;EACI,iBAAA;ApF0gkBR;;AoF3gkBI;EACI,iBAAA;ApF8gkBR;;AoF/gkBI;EACI,iBAAA;ApFkhkBR;;AoFnhkBI;EACI,iBAAA;ApFshkBR;;AoFvhkBI;EACI,iBAAA;ApF0hkBR;;AoF3hkBI;EACI,iBAAA;ApF8hkBR;;AoF/hkBI;EACI,iBAAA;ApFkikBR;;AoFnikBI;EACI,iBAAA;ApFsikBR;;AoFvikBI;EACI,iBAAA;ApF0ikBR;;AoF3ikBI;EACI,iBAAA;ApF8ikBR;;AoF/ikBI;EACI,iBAAA;ApFkjkBR;;AoFnjkBI;EACI,iBAAA;ApFsjkBR;;AoFvjkBI;EACI,iBAAA;ApF0jkBR;;AoF3jkBI;EACI,iBAAA;ApF8jkBR;;AoF/jkBI;EACI,iBAAA;ApFkkkBR;;AoFnkkBI;EACI,iBAAA;ApFskkBR;;AoFvkkBI;EACI,iBAAA;ApF0kkBR;;AoF3kkBI;EACI,iBAAA;ApF8kkBR;;AoF/kkBI;EACI,iBAAA;ApFklkBR;;AoFnlkBI;EACI,iBAAA;ApFslkBR;;AoFvlkBI;EACI,iBAAA;ApF0lkBR;;AoF3lkBI;EACI,iBAAA;ApF8lkBR;;AoF/lkBI;EACI,iBAAA;ApFkmkBR;;AoFnmkBI;EACI,iBAAA;ApFsmkBR;;AoFvmkBI;EACI,iBAAA;ApF0mkBR;;AoF3mkBI;EACI,iBAAA;ApF8mkBR;;AoF/mkBI;EACI,iBAAA;ApFknkBR;;AoFnnkBI;EACI,iBAAA;ApFsnkBR;;AoFvnkBI;EACI,iBAAA;ApF0nkBR;;AoF3nkBI;EACI,iBAAA;ApF8nkBR;;AoF/nkBI;EACI,iBAAA;ApFkokBR;;AoFnokBI;EACI,iBAAA;ApFsokBR;;AoFvokBI;EACI,iBAAA;ApF0okBR;;AoF3okBI;EACI,iBAAA;ApF8okBR;;AoF/okBI;EACI,iBAAA;ApFkpkBR;;AoFnpkBI;EACI,iBAAA;ApFspkBR;;AoFvpkBI;EACI,iBAAA;ApF0pkBR;;AoF3pkBI;EACI,iBAAA;ApF8pkBR;;AoF/pkBI;EACI,iBAAA;ApFkqkBR;;AoFnqkBI;EACI,iBAAA;ApFsqkBR;;AoFvqkBI;EACI,iBAAA;ApF0qkBR;;AoF3qkBI;EACI,iBAAA;ApF8qkBR;;AoF/qkBI;EACI,iBAAA;ApFkrkBR;;AoFnrkBI;EACI,iBAAA;ApFsrkBR;;AoFvrkBI;EACI,iBAAA;ApF0rkBR;;AoF3rkBI;EACI,iBAAA;ApF8rkBR;;AoF/rkBI;EACI,iBAAA;ApFkskBR;;AoFnskBI;EACI,iBAAA;ApFsskBR;;AoFvskBI;EACI,iBAAA;ApF0skBR;;AoF3skBI;EACI,iBAAA;ApF8skBR;;AoF/skBI;EACI,iBAAA;ApFktkBR;;AoFntkBI;EACI,iBAAA;ApFstkBR;;AoFvtkBI;EACI,iBAAA;ApF0tkBR;;AoF3tkBI;EACI,iBAAA;ApF8tkBR;;AoF/tkBI;EACI,iBAAA;ApFkukBR;;AoFnukBI;EACI,iBAAA;ApFsukBR;;AoFvukBI;EACI,iBAAA;ApF0ukBR;;AoF3ukBI;EACI,iBAAA;ApF8ukBR;;AoF/ukBI;EACI,iBAAA;ApFkvkBR;;AoFnvkBI;EACI,iBAAA;ApFsvkBR;;AoFvvkBI;EACI,iBAAA;ApF0vkBR;;AoF3vkBI;EACI,iBAAA;ApF8vkBR;;AoF/vkBI;EACI,iBAAA;ApFkwkBR;;AoFnwkBI;EACI,iBAAA;ApFswkBR;;AoFvwkBI;EACI,iBAAA;ApF0wkBR;;AoF3wkBI;EACI,iBAAA;ApF8wkBR;;AoF/wkBI;EACI,iBAAA;ApFkxkBR;;AoFnxkBI;EACI,iBAAA;ApFsxkBR;;AoFvxkBI;EACI,iBAAA;ApF0xkBR;;AoF3xkBI;EACI,iBAAA;ApF8xkBR;;AoF/xkBI;EACI,iBAAA;ApFkykBR;;AoFnykBI;EACI,iBAAA;ApFsykBR;;AoFvykBI;EACI,iBAAA;ApF0ykBR;;AoF3ykBI;EACI,iBAAA;ApF8ykBR;;AoF/ykBI;EACI,iBAAA;ApFkzkBR;;AoFnzkBI;EACI,iBAAA;ApFszkBR;;AoFvzkBI;EACI,iBAAA;ApF0zkBR;;AoF3zkBI;EACI,iBAAA;ApF8zkBR;;AoF/zkBI;EACI,iBAAA;ApFk0kBR;;AoFn0kBI;EACI,iBAAA;ApFs0kBR;;AoFv0kBI;EACI,iBAAA;ApF00kBR;;AoF30kBI;EACI,iBAAA;ApF80kBR;;AoF/0kBI;EACI,iBAAA;ApFk1kBR;;AoFn1kBI;EACI,iBAAA;ApFs1kBR;;AoFv1kBI;EACI,iBAAA;ApF01kBR;;AoF31kBI;EACI,iBAAA;ApF81kBR;;AoF/1kBI;EACI,iBAAA;ApFk2kBR;;AoFn2kBI;EACI,iBAAA;ApFs2kBR;;AoFv2kBI;EACI,iBAAA;ApF02kBR;;AoF32kBI;EACI,iBAAA;ApF82kBR;;AoF/2kBI;EACI,iBAAA;ApFk3kBR;;AoFn3kBI;EACI,iBAAA;ApFs3kBR;;AoFv3kBI;EACI,iBAAA;ApF03kBR;;AoF33kBI;EACI,iBAAA;ApF83kBR;;AoF/3kBI;EACI,iBAAA;ApFk4kBR;;AoFn4kBI;EACI,iBAAA;ApFs4kBR;;AoFv4kBI;EACI,iBAAA;ApF04kBR;;AoF34kBI;EACI,iBAAA;ApF84kBR;;AoF/4kBI;EACI,iBAAA;ApFk5kBR;;AoFn5kBI;EACI,iBAAA;ApFs5kBR;;AoFv5kBI;EACI,iBAAA;ApF05kBR;;AoF35kBI;EACI,iBAAA;ApF85kBR;;AoF/5kBI;EACI,iBAAA;ApFk6kBR;;AoFn6kBI;EACI,iBAAA;ApFs6kBR;;AoFv6kBI;EACI,iBAAA;ApF06kBR;;AoF36kBI;EACI,iBAAA;ApF86kBR;;AoF/6kBI;EACI,iBAAA;ApFk7kBR;;AoFn7kBI;EACI,iBAAA;ApFs7kBR;;AoFv7kBI;EACI,iBAAA;ApF07kBR;;AoF37kBI;EACI,iBAAA;ApF87kBR;;AoF/7kBI;EACI,iBAAA;ApFk8kBR;;AoFn8kBI;EACI,iBAAA;ApFs8kBR;;AoFv8kBI;EACI,iBAAA;ApF08kBR;;AoF38kBI;EACI,iBAAA;ApF88kBR;;AoF/8kBI;EACI,iBAAA;ApFk9kBR;;AoFn9kBI;EACI,iBAAA;ApFs9kBR;;AoFv9kBI;EACI,iBAAA;ApF09kBR;;AoF39kBI;EACI,iBAAA;ApF89kBR;;AoF/9kBI;EACI,iBAAA;ApFk+kBR;;AoFn+kBI;EACI,iBAAA;ApFs+kBR;;AoFv+kBI;EACI,iBAAA;ApF0+kBR;;AoF3+kBI;EACI,iBAAA;ApF8+kBR;;AoF/+kBI;EACI,iBAAA;ApFk/kBR;;AoFn/kBI;EACI,iBAAA;ApFs/kBR;;AoFv/kBI;EACI,iBAAA;ApF0/kBR;;AoF3/kBI;EACI,iBAAA;ApF8/kBR;;AoF//kBI;EACI,iBAAA;ApFkglBR;;AoFnglBI;EACI,iBAAA;ApFsglBR;;AoFvglBI;EACI,iBAAA;ApF0glBR;;AoF3glBI;EACI,iBAAA;ApF8glBR;;AoF/glBI;EACI,iBAAA;ApFkhlBR;;AoFnhlBI;EACI,iBAAA;ApFshlBR;;AoFvhlBI;EACI,iBAAA;ApF0hlBR;;AoF3hlBI;EACI,iBAAA;ApF8hlBR;;AoF/hlBI;EACI,iBAAA;ApFkilBR;;AoFnilBI;EACI,iBAAA;ApFsilBR;;AoFvilBI;EACI,iBAAA;ApF0ilBR;;AoF3ilBI;EACI,iBAAA;ApF8ilBR;;AoF/ilBI;EACI,iBAAA;ApFkjlBR;;AoFnjlBI;EACI,iBAAA;ApFsjlBR;;AoFvjlBI;EACI,iBAAA;ApF0jlBR;;AoF3jlBI;EACI,iBAAA;ApF8jlBR;;AoF/jlBI;EACI,iBAAA;ApFkklBR;;AoFnklBI;EACI,iBAAA;ApFsklBR;;AoFvklBI;EACI,iBAAA;ApF0klBR;;AoF3klBI;EACI,iBAAA;ApF8klBR;;AoF/klBI;EACI,iBAAA;ApFkllBR;;AoFnllBI;EACI,iBAAA;ApFsllBR;;AoFvllBI;EACI,iBAAA;ApF0llBR;;AoF3llBI;EACI,iBAAA;ApF8llBR;;AoF/llBI;EACI,iBAAA;ApFkmlBR;;AoFnmlBI;EACI,iBAAA;ApFsmlBR;;AoFvmlBI;EACI,iBAAA;ApF0mlBR;;AoF3mlBI;EACI,iBAAA;ApF8mlBR;;AoF/mlBI;EACI,iBAAA;ApFknlBR;;AoFnnlBI;EACI,iBAAA;ApFsnlBR;;AoFvnlBI;EACI,iBAAA;ApF0nlBR;;AoF3nlBI;EACI,iBAAA;ApF8nlBR;;AoF/nlBI;EACI,iBAAA;ApFkolBR;;AoFnolBI;EACI,iBAAA;ApFsolBR;;AoFvolBI;EACI,iBAAA;ApF0olBR;;AoF3olBI;EACI,iBAAA;ApF8olBR;;AoF/olBI;EACI,iBAAA;ApFkplBR;;AoFnplBI;EACI,iBAAA;ApFsplBR;;AoFvplBI;EACI,iBAAA;ApF0plBR;;AoF3plBI;EACI,iBAAA;ApF8plBR;;AoF/plBI;EACI,iBAAA;ApFkqlBR;;AoFnqlBI;EACI,iBAAA;ApFsqlBR;;AoFvqlBI;EACI,iBAAA;ApF0qlBR;;AoF3qlBI;EACI,iBAAA;ApF8qlBR;;AoF/qlBI;EACI,iBAAA;ApFkrlBR;;AoFnrlBI;EACI,iBAAA;ApFsrlBR;;AoFvrlBI;EACI,iBAAA;ApF0rlBR;;AoF3rlBI;EACI,iBAAA;ApF8rlBR;;AoF/rlBI;EACI,iBAAA;ApFkslBR;;AoFnslBI;EACI,iBAAA;ApFsslBR;;AoFvslBI;EACI,iBAAA;ApF0slBR;;AoF3slBI;EACI,iBAAA;ApF8slBR;;AoF/slBI;EACI,iBAAA;ApFktlBR;;AoFntlBI;EACI,iBAAA;ApFstlBR;;AoFvtlBI;EACI,iBAAA;ApF0tlBR;;AoF3tlBI;EACI,iBAAA;ApF8tlBR;;AoF/tlBI;EACI,iBAAA;ApFkulBR;;AoFnulBI;EACI,iBAAA;ApFsulBR;;AoFvulBI;EACI,iBAAA;ApF0ulBR;;AoF3ulBI;EACI,iBAAA;ApF8ulBR;;AoF/ulBI;EACI,iBAAA;ApFkvlBR;;AoFnvlBI;EACI,iBAAA;ApFsvlBR;;AoFvvlBI;EACI,iBAAA;ApF0vlBR;;AoF3vlBI;EACI,iBAAA;ApF8vlBR;;AoF/vlBI;EACI,iBAAA;ApFkwlBR;;AoFnwlBI;EACI,iBAAA;ApFswlBR;;AoFvwlBI;EACI,iBAAA;ApF0wlBR;;AoF3wlBI;EACI,iBAAA;ApF8wlBR;;AoF/wlBI;EACI,iBAAA;ApFkxlBR;;AoFnxlBI;EACI,iBAAA;ApFsxlBR;;AoFvxlBI;EACI,iBAAA;ApF0xlBR;;AoF3xlBI;EACI,iBAAA;ApF8xlBR;;AoF/xlBI;EACI,iBAAA;ApFkylBR;;AoFnylBI;EACI,iBAAA;ApFsylBR;;AoFvylBI;EACI,iBAAA;ApF0ylBR;;AoF3ylBI;EACI,iBAAA;ApF8ylBR;;AoF/ylBI;EACI,iBAAA;ApFkzlBR;;AoFnzlBI;EACI,iBAAA;ApFszlBR;;AoFvzlBI;EACI,iBAAA;ApF0zlBR;;AoF3zlBI;EACI,iBAAA;ApF8zlBR;;AoF/zlBI;EACI,iBAAA;ApFk0lBR;;AoFn0lBI;EACI,iBAAA;ApFs0lBR;;AoFv0lBI;EACI,iBAAA;ApF00lBR;;AoF30lBI;EACI,iBAAA;ApF80lBR;;AoF/0lBI;EACI,iBAAA;ApFk1lBR;;AoFn1lBI;EACI,iBAAA;ApFs1lBR;;AoFv1lBI;EACI,iBAAA;ApF01lBR;;AoF31lBI;EACI,iBAAA;ApF81lBR;;AoF/1lBI;EACI,iBAAA;ApFk2lBR;;AoFn2lBI;EACI,iBAAA;ApFs2lBR;;AoFv2lBI;EACI,iBAAA;ApF02lBR;;AoF32lBI;EACI,iBAAA;ApF82lBR;;AoF/2lBI;EACI,iBAAA;ApFk3lBR;;AoFn3lBI;EACI,iBAAA;ApFs3lBR;;AoFv3lBI;EACI,iBAAA;ApF03lBR;;AoF33lBI;EACI,iBAAA;ApF83lBR;;AoF/3lBI;EACI,iBAAA;ApFk4lBR;;AoFn4lBI;EACI,iBAAA;ApFs4lBR;;AoFv4lBI;EACI,iBAAA;ApF04lBR;;AoF34lBI;EACI,iBAAA;ApF84lBR;;AoF/4lBI;EACI,iBAAA;ApFk5lBR;;AoFn5lBI;EACI,iBAAA;ApFs5lBR;;AoFv5lBI;EACI,iBAAA;ApF05lBR;;AoF35lBI;EACI,iBAAA;ApF85lBR;;AoF/5lBI;EACI,iBAAA;ApFk6lBR;;AoFn6lBI;EACI,iBAAA;ApFs6lBR;;AoFv6lBI;EACI,iBAAA;ApF06lBR;;AoF36lBI;EACI,iBAAA;ApF86lBR;;AoF/6lBI;EACI,iBAAA;ApFk7lBR;;AoFn7lBI;EACI,iBAAA;ApFs7lBR;;AoFv7lBI;EACI,iBAAA;ApF07lBR;;AoF37lBI;EACI,iBAAA;ApF87lBR;;AoF/7lBI;EACI,iBAAA;ApFk8lBR;;AoFn8lBI;EACI,iBAAA;ApFs8lBR;;AoFv8lBI;EACI,iBAAA;ApF08lBR;;AoF38lBI;EACI,iBAAA;ApF88lBR;;AoF/8lBI;EACI,iBAAA;ApFk9lBR;;AoFn9lBI;EACI,iBAAA;ApFs9lBR;;AoFv9lBI;EACI,iBAAA;ApF09lBR;;AoF39lBI;EACI,iBAAA;ApF89lBR;;AoF/9lBI;EACI,iBAAA;ApFk+lBR;;AoFn+lBI;EACI,iBAAA;ApFs+lBR;;AoFv+lBI;EACI,iBAAA;ApF0+lBR;;AoF3+lBI;EACI,iBAAA;ApF8+lBR;;AoF/+lBI;EACI,iBAAA;ApFk/lBR;;AoFn/lBI;EACI,iBAAA;ApFs/lBR;;AoFv/lBI;EACI,iBAAA;ApF0/lBR;;AoF3/lBI;EACI,iBAAA;ApF8/lBR;;AoF//lBI;EACI,iBAAA;ApFkgmBR;;AoFngmBI;EACI,iBAAA;ApFsgmBR;;AoFvgmBI;EACI,iBAAA;ApF0gmBR;;AoF3gmBI;EACI,iBAAA;ApF8gmBR;;AoF/gmBI;EACI,iBAAA;ApFkhmBR;;AoFnhmBI;EACI,iBAAA;ApFshmBR;;AoFvhmBI;EACI,iBAAA;ApF0hmBR;;AoF3hmBI;EACI,iBAAA;ApF8hmBR;;AoF/hmBI;EACI,iBAAA;ApFkimBR;;AoFnimBI;EACI,iBAAA;ApFsimBR;;AoFvimBI;EACI,iBAAA;ApF0imBR;;AoF3imBI;EACI,iBAAA;ApF8imBR;;AoF/imBI;EACI,iBAAA;ApFkjmBR;;AoFnjmBI;EACI,iBAAA;ApFsjmBR;;AoFvjmBI;EACI,iBAAA;ApF0jmBR;;AoF3jmBI;EACI,iBAAA;ApF8jmBR;;AoF/jmBI;EACI,iBAAA;ApFkkmBR;;AoFnkmBI;EACI,iBAAA;ApFskmBR;;AoFvkmBI;EACI,iBAAA;ApF0kmBR;;AoF3kmBI;EACI,iBAAA;ApF8kmBR;;AoF/kmBI;EACI,iBAAA;ApFklmBR;;AoFnlmBI;EACI,iBAAA;ApFslmBR;;AoFvlmBI;EACI,iBAAA;ApF0lmBR;;AoF3lmBI;EACI,iBAAA;ApF8lmBR;;AoF/lmBI;EACI,iBAAA;ApFkmmBR;;AoFnmmBI;EACI,iBAAA;ApFsmmBR;;AoFvmmBI;EACI,iBAAA;ApF0mmBR;;AoF3mmBI;EACI,iBAAA;ApF8mmBR;;AoF/mmBI;EACI,iBAAA;ApFknmBR;;AoFnnmBI;EACI,iBAAA;ApFsnmBR;;AoFvnmBI;EACI,iBAAA;ApF0nmBR;;AoF3nmBI;EACI,iBAAA;ApF8nmBR;;AoF/nmBI;EACI,iBAAA;ApFkomBR;;AoFnomBI;EACI,iBAAA;ApFsomBR;;AoFvomBI;EACI,iBAAA;ApF0omBR;;AoF3omBI;EACI,iBAAA;ApF8omBR;;AoF/omBI;EACI,iBAAA;ApFkpmBR;;AoFnpmBI;EACI,iBAAA;ApFspmBR;;AoFvpmBI;EACI,iBAAA;ApF0pmBR;;AoF3pmBI;EACI,iBAAA;ApF8pmBR;;AoF/pmBI;EACI,iBAAA;ApFkqmBR;;AoFnqmBI;EACI,iBAAA;ApFsqmBR;;AoFvqmBI;EACI,iBAAA;ApF0qmBR;;AoF3qmBI;EACI,iBAAA;ApF8qmBR;;AoF/qmBI;EACI,iBAAA;ApFkrmBR;;AoFnrmBI;EACI,iBAAA;ApFsrmBR;;AoFvrmBI;EACI,iBAAA;ApF0rmBR;;AoF3rmBI;EACI,iBAAA;ApF8rmBR;;AoF/rmBI;EACI,iBAAA;ApFksmBR;;AoFnsmBI;EACI,iBAAA;ApFssmBR;;AoFvsmBI;EACI,iBAAA;ApF0smBR;;AoF3smBI;EACI,iBAAA;ApF8smBR;;AoF/smBI;EACI,iBAAA;ApFktmBR;;AoFntmBI;EACI,iBAAA;ApFstmBR;;AoFvtmBI;EACI,iBAAA;ApF0tmBR;;AoF3tmBI;EACI,iBAAA;ApF8tmBR;;AoF/tmBI;EACI,iBAAA;ApFkumBR;;AoFnumBI;EACI,iBAAA;ApFsumBR;;AoFvumBI;EACI,iBAAA;ApF0umBR;;AoF3umBI;EACI,iBAAA;ApF8umBR;;AoF/umBI;EACI,iBAAA;ApFkvmBR;;AoFnvmBI;EACI,iBAAA;ApFsvmBR;;AoFvvmBI;EACI,iBAAA;ApF0vmBR;;AoF3vmBI;EACI,iBAAA;ApF8vmBR;;AoF/vmBI;EACI,iBAAA;ApFkwmBR;;AoFnwmBI;EACI,iBAAA;ApFswmBR;;AoFvwmBI;EACI,iBAAA;ApF0wmBR;;AoF3wmBI;EACI,iBAAA;ApF8wmBR;;AoF/wmBI;EACI,iBAAA;ApFkxmBR;;AoFnxmBI;EACI,iBAAA;ApFsxmBR;;AoFvxmBI;EACI,iBAAA;ApF0xmBR;;AoF3xmBI;EACI,iBAAA;ApF8xmBR;;AoF/xmBI;EACI,iBAAA;ApFkymBR;;AoFnymBI;EACI,iBAAA;ApFsymBR;;AoFvymBI;EACI,iBAAA;ApF0ymBR;;AoF3ymBI;EACI,iBAAA;ApF8ymBR;;AoF/ymBI;EACI,iBAAA;ApFkzmBR;;AoFnzmBI;EACI,iBAAA;ApFszmBR;;AoFvzmBI;EACI,iBAAA;ApF0zmBR;;AoF3zmBI;EACI,iBAAA;ApF8zmBR;;AoF/zmBI;EACI,iBAAA;ApFk0mBR;;AoFn0mBI;EACI,iBAAA;ApFs0mBR;;AoFv0mBI;EACI,iBAAA;ApF00mBR;;AoF30mBI;EACI,iBAAA;ApF80mBR;;AoF/0mBI;EACI,iBAAA;ApFk1mBR;;AoFn1mBI;EACI,iBAAA;ApFs1mBR;;AoFv1mBI;EACI,iBAAA;ApF01mBR;;AoF31mBI;EACI,iBAAA;ApF81mBR;;AoF/1mBI;EACI,iBAAA;ApFk2mBR;;AoFn2mBI;EACI,iBAAA;ApFs2mBR;;AoFv2mBI;EACI,iBAAA;ApF02mBR;;AoF32mBI;EACI,iBAAA;ApF82mBR;;AoF/2mBI;EACI,iBAAA;ApFk3mBR;;AoFn3mBI;EACI,iBAAA;ApFs3mBR;;AoFv3mBI;EACI,iBAAA;ApF03mBR;;AoF33mBI;EACI,iBAAA;ApF83mBR;;AoF/3mBI;EACI,iBAAA;ApFk4mBR;;AoFn4mBI;EACI,iBAAA;ApFs4mBR;;AoFv4mBI;EACI,iBAAA;ApF04mBR;;AoF34mBI;EACI,iBAAA;ApF84mBR;;AoF/4mBI;EACI,iBAAA;ApFk5mBR;;AoFn5mBI;EACI,iBAAA;ApFs5mBR;;AoFv5mBI;EACI,iBAAA;ApF05mBR;;AoF35mBI;EACI,iBAAA;ApF85mBR;;AoF/5mBI;EACI,iBAAA;ApFk6mBR;;AoFn6mBI;EACI,iBAAA;ApFs6mBR;;AoFv6mBI;EACI,iBAAA;ApF06mBR;;AoF36mBI;EACI,iBAAA;ApF86mBR;;AoF/6mBI;EACI,iBAAA;ApFk7mBR;;AoFn7mBI;EACI,iBAAA;ApFs7mBR;;AoFv7mBI;EACI,iBAAA;ApF07mBR;;AoF37mBI;EACI,iBAAA;ApF87mBR;;AoF/7mBI;EACI,iBAAA;ApFk8mBR;;AoFn8mBI;EACI,iBAAA;ApFs8mBR;;AoFv8mBI;EACI,iBAAA;ApF08mBR;;AoF38mBI;EACI,iBAAA;ApF88mBR;;AoF/8mBI;EACI,iBAAA;ApFk9mBR;;AoFn9mBI;EACI,iBAAA;ApFs9mBR;;AoFv9mBI;EACI,iBAAA;ApF09mBR;;AoF39mBI;EACI,iBAAA;ApF89mBR;;AoF/9mBI;EACI,iBAAA;ApFk+mBR;;AoFn+mBI;EACI,iBAAA;ApFs+mBR;;AoFv+mBI;EACI,iBAAA;ApF0+mBR;;AoF3+mBI;EACI,iBAAA;ApF8+mBR;;AoF/+mBI;EACI,iBAAA;ApFk/mBR;;AoFn/mBI;EACI,iBAAA;ApFs/mBR;;AoFv/mBI;EACI,iBAAA;ApF0/mBR;;AoF3/mBI;EACI,iBAAA;ApF8/mBR;;AoF//mBI;EACI,iBAAA;ApFkgnBR;;AoFngnBI;EACI,iBAAA;ApFsgnBR;;AoFvgnBI;EACI,iBAAA;ApF0gnBR;;AoF3gnBI;EACI,iBAAA;ApF8gnBR;;AoF/gnBI;EACI,iBAAA;ApFkhnBR;;AoFnhnBI;EACI,iBAAA;ApFshnBR;;AoFvhnBI;EACI,iBAAA;ApF0hnBR;;AoF3hnBI;EACI,iBAAA;ApF8hnBR;;AoF/hnBI;EACI,iBAAA;ApFkinBR;;AoFninBI;EACI,iBAAA;ApFsinBR;;AoFvinBI;EACI,iBAAA;ApF0inBR;;AoF3inBI;EACI,iBAAA;ApF8inBR;;AoF/inBI;EACI,iBAAA;ApFkjnBR;;AoFnjnBI;EACI,iBAAA;ApFsjnBR;;AoFvjnBI;EACI,iBAAA;ApF0jnBR;;AoF3jnBI;EACI,iBAAA;ApF8jnBR;;AoF/jnBI;EACI,iBAAA;ApFkknBR;;AoFnknBI;EACI,iBAAA;ApFsknBR;;AoFvknBI;EACI,iBAAA;ApF0knBR;;AoF3knBI;EACI,iBAAA;ApF8knBR;;AoF/knBI;EACI,iBAAA;ApFklnBR;;AoFnlnBI;EACI,iBAAA;ApFslnBR;;AoFvlnBI;EACI,iBAAA;ApF0lnBR;;AoF3lnBI;EACI,iBAAA;ApF8lnBR;;AoF/lnBI;EACI,iBAAA;ApFkmnBR;;AoFnmnBI;EACI,iBAAA;ApFsmnBR;;AoFvmnBI;EACI,iBAAA;ApF0mnBR;;AoF3mnBI;EACI,iBAAA;ApF8mnBR;;AoF/mnBI;EACI,iBAAA;ApFknnBR;;AoFnnnBI;EACI,iBAAA;ApFsnnBR;;AoFvnnBI;EACI,iBAAA;ApF0nnBR;;AoF3nnBI;EACI,iBAAA;ApF8nnBR;;AoF/nnBI;EACI,iBAAA;ApFkonBR;;AoFnonBI;EACI,iBAAA;ApFsonBR;;AoFvonBI;EACI,iBAAA;ApF0onBR;;AoF3onBI;EACI,iBAAA;ApF8onBR;;AoF/onBI;EACI,iBAAA;ApFkpnBR;;AoFnpnBI;EACI,iBAAA;ApFspnBR;;AoFvpnBI;EACI,iBAAA;ApF0pnBR;;AoF3pnBI;EACI,iBAAA;ApF8pnBR;;AoF/pnBI;EACI,iBAAA;ApFkqnBR;;AoFnqnBI;EACI,iBAAA;ApFsqnBR;;AoFvqnBI;EACI,iBAAA;ApF0qnBR;;AoF3qnBI;EACI,iBAAA;ApF8qnBR;;AoF/qnBI;EACI,iBAAA;ApFkrnBR;;AoFnrnBI;EACI,iBAAA;ApFsrnBR;;AoFvrnBI;EACI,iBAAA;ApF0rnBR;;AoF3rnBI;EACI,iBAAA;ApF8rnBR;;AoF/rnBI;EACI,iBAAA;ApFksnBR;;AoFnsnBI;EACI,iBAAA;ApFssnBR;;AoFvsnBI;EACI,iBAAA;ApF0snBR;;AoF3snBI;EACI,iBAAA;ApF8snBR;;AoF/snBI;EACI,iBAAA;ApFktnBR;;AoFntnBI;EACI,iBAAA;ApFstnBR;;AoFvtnBI;EACI,iBAAA;ApF0tnBR;;AoF3tnBI;EACI,iBAAA;ApF8tnBR;;AoF/tnBI;EACI,iBAAA;ApFkunBR;;AoFnunBI;EACI,iBAAA;ApFsunBR;;AoFvunBI;EACI,iBAAA;ApF0unBR;;AoF3unBI;EACI,iBAAA;ApF8unBR;;AoF/unBI;EACI,iBAAA;ApFkvnBR;;AoFnvnBI;EACI,iBAAA;ApFsvnBR;;AoFvvnBI;EACI,iBAAA;ApF0vnBR;;AoF3vnBI;EACI,iBAAA;ApF8vnBR;;AoF/vnBI;EACI,iBAAA;ApFkwnBR;;AoFnwnBI;EACI,iBAAA;ApFswnBR;;AoFvwnBI;EACI,iBAAA;ApF0wnBR;;AoF3wnBI;EACI,iBAAA;ApF8wnBR;;AoF/wnBI;EACI,iBAAA;ApFkxnBR;;AoFnxnBI;EACI,iBAAA;ApFsxnBR;;AoFvxnBI;EACI,iBAAA;ApF0xnBR;;AoF3xnBI;EACI,iBAAA;ApF8xnBR;;AoF/xnBI;EACI,iBAAA;ApFkynBR;;AoFnynBI;EACI,iBAAA;ApFsynBR;;AoFvynBI;EACI,iBAAA;ApF0ynBR;;AoF3ynBI;EACI,iBAAA;ApF8ynBR;;AoF/ynBI;EACI,iBAAA;ApFkznBR;;AoFnznBI;EACI,iBAAA;ApFsznBR;;AoFvznBI;EACI,iBAAA;ApF0znBR;;AoF3znBI;EACI,iBAAA;ApF8znBR;;AoF/znBI;EACI,iBAAA;ApFk0nBR;;AoFn0nBI;EACI,iBAAA;ApFs0nBR;;AoFv0nBI;EACI,iBAAA;ApF00nBR;;AoF30nBI;EACI,iBAAA;ApF80nBR;;AoF/0nBI;EACI,iBAAA;ApFk1nBR;;AoFn1nBI;EACI,iBAAA;ApFs1nBR;;AoFv1nBI;EACI,iBAAA;ApF01nBR;;AoF31nBI;EACI,iBAAA;ApF81nBR;;AoF/1nBI;EACI,iBAAA;ApFk2nBR;;AoFn2nBI;EACI,iBAAA;ApFs2nBR;;AoFv2nBI;EACI,iBAAA;ApF02nBR;;AoF32nBI;EACI,iBAAA;ApF82nBR;;AoF/2nBI;EACI,iBAAA;ApFk3nBR;;AoFn3nBI;EACI,iBAAA;ApFs3nBR;;AoFv3nBI;EACI,iBAAA;ApF03nBR;;AoF33nBI;EACI,iBAAA;ApF83nBR;;AoF/3nBI;EACI,iBAAA;ApFk4nBR;;AoFn4nBI;EACI,iBAAA;ApFs4nBR;;AoFv4nBI;EACI,iBAAA;ApF04nBR;;AoF34nBI;EACI,iBAAA;ApF84nBR;;AoF/4nBI;EACI,iBAAA;ApFk5nBR;;AoFn5nBI;EACI,iBAAA;ApFs5nBR;;AoFv5nBI;EACI,iBAAA;ApF05nBR;;AoF35nBI;EACI,iBAAA;ApF85nBR;;AoF/5nBI;EACI,iBAAA;ApFk6nBR;;AoFn6nBI;EACI,iBAAA;ApFs6nBR;;AoFv6nBI;EACI,iBAAA;ApF06nBR;;AoF36nBI;EACI,iBAAA;ApF86nBR;;AoF/6nBI;EACI,iBAAA;ApFk7nBR;;AoFn7nBI;EACI,iBAAA;ApFs7nBR;;AoFv7nBI;EACI,iBAAA;ApF07nBR;;AoF37nBI;EACI,iBAAA;ApF87nBR;;AoF/7nBI;EACI,iBAAA;ApFk8nBR;;AoFn8nBI;EACI,iBAAA;ApFs8nBR;;AoFv8nBI;EACI,iBAAA;ApF08nBR;;AoF38nBI;EACI,iBAAA;ApF88nBR;;AoF/8nBI;EACI,iBAAA;ApFk9nBR;;AoFn9nBI;EACI,iBAAA;ApFs9nBR;;AoFv9nBI;EACI,iBAAA;ApF09nBR;;AoF39nBI;EACI,iBAAA;ApF89nBR;;AoF/9nBI;EACI,iBAAA;ApFk+nBR;;AoFn+nBI;EACI,iBAAA;ApFs+nBR;;AoFv+nBI;EACI,iBAAA;ApF0+nBR;;AoF3+nBI;EACI,iBAAA;ApF8+nBR;;AoF/+nBI;EACI,iBAAA;ApFk/nBR;;AoFn/nBI;EACI,iBAAA;ApFs/nBR;;AoFv/nBI;EACI,iBAAA;ApF0/nBR;;AoF3/nBI;EACI,iBAAA;ApF8/nBR;;AoF//nBI;EACI,iBAAA;ApFkgoBR;;AoFngoBI;EACI,iBAAA;ApFsgoBR;;AoFvgoBI;EACI,iBAAA;ApF0goBR;;AoF3goBI;EACI,iBAAA;ApF8goBR;;AoF/goBI;EACI,iBAAA;ApFkhoBR;;AoFnhoBI;EACI,iBAAA;ApFshoBR;;AoFvhoBI;EACI,iBAAA;ApF0hoBR;;AoF3hoBI;EACI,iBAAA;ApF8hoBR;;AoF/hoBI;EACI,iBAAA;ApFkioBR;;AoFnioBI;EACI,iBAAA;ApFsioBR;;AoFvioBI;EACI,iBAAA;ApF0ioBR;;AoF3ioBI;EACI,iBAAA;ApF8ioBR;;AoF/ioBI;EACI,iBAAA;ApFkjoBR;;AoFnjoBI;EACI,iBAAA;ApFsjoBR;;AoFvjoBI;EACI,iBAAA;ApF0joBR;;AoF3joBI;EACI,iBAAA;ApF8joBR;;AoF/joBI;EACI,iBAAA;ApFkkoBR;;AoFnkoBI;EACI,iBAAA;ApFskoBR;;AoFvkoBI;EACI,iBAAA;ApF0koBR;;AoF3koBI;EACI,iBAAA;ApF8koBR;;AoF/koBI;EACI,iBAAA;ApFkloBR;;AoFnloBI;EACI,iBAAA;ApFsloBR;;AoFvloBI;EACI,iBAAA;ApF0loBR;;AoF3loBI;EACI,iBAAA;ApF8loBR;;AoF/loBI;EACI,iBAAA;ApFkmoBR;;AoFnmoBI;EACI,iBAAA;ApFsmoBR;;AoFvmoBI;EACI,iBAAA;ApF0moBR;;AoF3moBI;EACI,iBAAA;ApF8moBR;;AoF/moBI;EACI,iBAAA;ApFknoBR;;AoFnnoBI;EACI,iBAAA;ApFsnoBR;;AoFvnoBI;EACI,iBAAA;ApF0noBR;;AoF3noBI;EACI,iBAAA;ApF8noBR;;AoF/noBI;EACI,iBAAA;ApFkooBR;;AoFnooBI;EACI,iBAAA;ApFsooBR;;AoFvooBI;EACI,iBAAA;ApF0ooBR;;AoF3ooBI;EACI,iBAAA;ApF8ooBR;;AoF/ooBI;EACI,iBAAA;ApFkpoBR;;AoFnpoBI;EACI,iBAAA;ApFspoBR;;AoFvpoBI;EACI,iBAAA;ApF0poBR;;AoF3poBI;EACI,iBAAA;ApF8poBR;;AoF/poBI;EACI,iBAAA;ApFkqoBR;;AoFnqoBI;EACI,iBAAA;ApFsqoBR;;AoFvqoBI;EACI,iBAAA;ApF0qoBR;;AoF3qoBI;EACI,iBAAA;ApF8qoBR;;AoF/qoBI;EACI,iBAAA;ApFkroBR;;AoFnroBI;EACI,iBAAA;ApFsroBR;;AoFvroBI;EACI,iBAAA;ApF0roBR;;AoF3roBI;EACI,iBAAA;ApF8roBR;;AoF/roBI;EACI,iBAAA;ApFksoBR;;AoFnsoBI;EACI,iBAAA;ApFssoBR;;AoFvsoBI;EACI,iBAAA;ApF0soBR;;AoF3soBI;EACI,iBAAA;ApF8soBR;;AoF/soBI;EACI,iBAAA;ApFktoBR;;AoFntoBI;EACI,iBAAA;ApFstoBR;;AoFvtoBI;EACI,iBAAA;ApF0toBR;;AoF3toBI;EACI,iBAAA;ApF8toBR;;AoF/toBI;EACI,iBAAA;ApFkuoBR;;AoFnuoBI;EACI,iBAAA;ApFsuoBR;;AoFvuoBI;EACI,iBAAA;ApF0uoBR;;AoF3uoBI;EACI,iBAAA;ApF8uoBR;;AoF/uoBI;EACI,iBAAA;ApFkvoBR;;AoFnvoBI;EACI,iBAAA;ApFsvoBR;;AoFvvoBI;EACI,iBAAA;ApF0voBR;;AoF3voBI;EACI,iBAAA;ApF8voBR;;AoF/voBI;EACI,iBAAA;ApFkwoBR;;AoFnwoBI;EACI,iBAAA;ApFswoBR;;AoFvwoBI;EACI,iBAAA;ApF0woBR;;AoF3woBI;EACI,iBAAA;ApF8woBR;;AoF/woBI;EACI,iBAAA;ApFkxoBR;;AoFnxoBI;EACI,iBAAA;ApFsxoBR;;AoFvxoBI;EACI,iBAAA;ApF0xoBR;;AoF3xoBI;EACI,iBAAA;ApF8xoBR;;AoF/xoBI;EACI,iBAAA;ApFkyoBR;;AoFnyoBI;EACI,iBAAA;ApFsyoBR;;AoFvyoBI;EACI,iBAAA;ApF0yoBR;;AoF3yoBI;EACI,iBAAA;ApF8yoBR;;AoF/yoBI;EACI,iBAAA;ApFkzoBR;;AoFnzoBI;EACI,iBAAA;ApFszoBR;;AoFvzoBI;EACI,iBAAA;ApF0zoBR;;AoF3zoBI;EACI,iBAAA;ApF8zoBR;;AoF/zoBI;EACI,iBAAA;ApFk0oBR;;AoFn0oBI;EACI,iBAAA;ApFs0oBR;;AoFv0oBI;EACI,iBAAA;ApF00oBR;;AoF30oBI;EACI,iBAAA;ApF80oBR;;AoF/0oBI;EACI,iBAAA;ApFk1oBR;;AoFn1oBI;EACI,iBAAA;ApFs1oBR;;AoFv1oBI;EACI,iBAAA;ApF01oBR;;AoF31oBI;EACI,iBAAA;ApF81oBR;;AoF/1oBI;EACI,iBAAA;ApFk2oBR;;AoFn2oBI;EACI,iBAAA;ApFs2oBR;;AoFv2oBI;EACI,iBAAA;ApF02oBR;;AoF32oBI;EACI,iBAAA;ApF82oBR;;AoF/2oBI;EACI,iBAAA;ApFk3oBR;;AoFn3oBI;EACI,iBAAA;ApFs3oBR;;AoFv3oBI;EACI,iBAAA;ApF03oBR;;AoF33oBI;EACI,iBAAA;ApF83oBR;;AoF/3oBI;EACI,iBAAA;ApFk4oBR;;AoFn4oBI;EACI,iBAAA;ApFs4oBR;;AoFv4oBI;EACI,iBAAA;ApF04oBR;;AoF34oBI;EACI,iBAAA;ApF84oBR;;AoF/4oBI;EACI,iBAAA;ApFk5oBR;;AoFn5oBI;EACI,iBAAA;ApFs5oBR;;AoFv5oBI;EACI,iBAAA;ApF05oBR;;AoF35oBI;EACI,iBAAA;ApF85oBR;;AoF/5oBI;EACI,iBAAA;ApFk6oBR;;AoFn6oBI;EACI,iBAAA;ApFs6oBR;;AoFv6oBI;EACI,iBAAA;ApF06oBR;;AoF36oBI;EACI,iBAAA;ApF86oBR;;AoF/6oBI;EACI,iBAAA;ApFk7oBR;;AoFn7oBI;EACI,iBAAA;ApFs7oBR;;AoFv7oBI;EACI,iBAAA;ApF07oBR;;AoF37oBI;EACI,iBAAA;ApF87oBR;;AoF/7oBI;EACI,iBAAA;ApFk8oBR;;AoFn8oBI;EACI,iBAAA;ApFs8oBR;;AoFv8oBI;EACI,iBAAA;ApF08oBR;;AoF38oBI;EACI,iBAAA;ApF88oBR;;AoF/8oBI;EACI,iBAAA;ApFk9oBR;;AoFn9oBI;EACI,iBAAA;ApFs9oBR;;AoFv9oBI;EACI,iBAAA;ApF09oBR;;AoF39oBI;EACI,iBAAA;ApF89oBR;;AoF/9oBI;EACI,iBAAA;ApFk+oBR;;AoFn+oBI;EACI,iBAAA;ApFs+oBR;;AoFv+oBI;EACI,iBAAA;ApF0+oBR;;AoF3+oBI;EACI,iBAAA;ApF8+oBR;;AoF/+oBI;EACI,iBAAA;ApFk/oBR;;AoFn/oBI;EACI,iBAAA;ApFs/oBR;;AoFv/oBI;EACI,iBAAA;ApF0/oBR;;AoF3/oBI;EACI,iBAAA;ApF8/oBR;;AoF//oBI;EACI,iBAAA;ApFkgpBR;;AoFngpBI;EACI,iBAAA;ApFsgpBR;;AoFvgpBI;EACI,iBAAA;ApF0gpBR;;AoF3gpBI;EACI,iBAAA;ApF8gpBR;;AoF/gpBI;EACI,iBAAA;ApFkhpBR;;AoFnhpBI;EACI,iBAAA;ApFshpBR;;AoFvhpBI;EACI,iBAAA;ApF0hpBR;;AoF3hpBI;EACI,iBAAA;ApF8hpBR;;AoF/hpBI;EACI,iBAAA;ApFkipBR;;AoFnipBI;EACI,iBAAA;ApFsipBR;;AoFvipBI;EACI,iBAAA;ApF0ipBR;;AoF3ipBI;EACI,iBAAA;ApF8ipBR;;AoF/ipBI;EACI,iBAAA;ApFkjpBR;;AoFnjpBI;EACI,iBAAA;ApFsjpBR;;AoFvjpBI;EACI,iBAAA;ApF0jpBR;;AoF3jpBI;EACI,iBAAA;ApF8jpBR;;AoF/jpBI;EACI,iBAAA;ApFkkpBR;;AoFnkpBI;EACI,iBAAA;ApFskpBR;;AoFvkpBI;EACI,iBAAA;ApF0kpBR;;AoF3kpBI;EACI,iBAAA;ApF8kpBR;;AoF/kpBI;EACI,iBAAA;ApFklpBR;;AoFnlpBI;EACI,iBAAA;ApFslpBR;;AoFvlpBI;EACI,iBAAA;ApF0lpBR;;AoF3lpBI;EACI,iBAAA;ApF8lpBR;;AoF/lpBI;EACI,iBAAA;ApFkmpBR;;AoFnmpBI;EACI,iBAAA;ApFsmpBR;;AoFvmpBI;EACI,iBAAA;ApF0mpBR;;AoF3mpBI;EACI,iBAAA;ApF8mpBR;;AoF/mpBI;EACI,iBAAA;ApFknpBR;;AoFnnpBI;EACI,iBAAA;ApFsnpBR;;AoFvnpBI;EACI,iBAAA;ApF0npBR;;AoF3npBI;EACI,iBAAA;ApF8npBR;;AoF/npBI;EACI,iBAAA;ApFkopBR;;AoFnopBI;EACI,iBAAA;ApFsopBR;;AoFvopBI;EACI,iBAAA;ApF0opBR;;AoF3opBI;EACI,iBAAA;ApF8opBR;;AoF/opBI;EACI,iBAAA;ApFkppBR;;AoFnppBI;EACI,iBAAA;ApFsppBR;;AoFvppBI;EACI,iBAAA;ApF0ppBR;;AoF3ppBI;EACI,iBAAA;ApF8ppBR;;AoF/ppBI;EACI,iBAAA;ApFkqpBR;;AoFnqpBI;EACI,iBAAA;ApFsqpBR;;AoFvqpBI;EACI,iBAAA;ApF0qpBR;;AoF3qpBI;EACI,iBAAA;ApF8qpBR;;AoF/qpBI;EACI,iBAAA;ApFkrpBR;;AoFnrpBI;EACI,iBAAA;ApFsrpBR;;AoFvrpBI;EACI,iBAAA;ApF0rpBR;;AoF3rpBI;EACI,iBAAA;ApF8rpBR;;AoF/rpBI;EACI,iBAAA;ApFkspBR;;AoFnspBI;EACI,iBAAA;ApFsspBR;;AoFvspBI;EACI,iBAAA;ApF0spBR;;AoF3spBI;EACI,iBAAA;ApF8spBR;;AoF/spBI;EACI,iBAAA;ApFktpBR;;AoFntpBI;EACI,iBAAA;ApFstpBR;;AoFvtpBI;EACI,iBAAA;ApF0tpBR;;AoF3tpBI;EACI,iBAAA;ApF8tpBR;;AoF/tpBI;EACI,iBAAA;ApFkupBR;;AoFnupBI;EACI,iBAAA;ApFsupBR;;AoFvupBI;EACI,iBAAA;ApF0upBR;;AoF3upBI;EACI,iBAAA;ApF8upBR;;AoF/upBI;EACI,iBAAA;ApFkvpBR;;AoFnvpBI;EACI,iBAAA;ApFsvpBR;;AoFvvpBI;EACI,iBAAA;ApF0vpBR;;AoF3vpBI;EACI,iBAAA;ApF8vpBR;;AoF/vpBI;EACI,iBAAA;ApFkwpBR;;AoFnwpBI;EACI,iBAAA;ApFswpBR;;AoFvwpBI;EACI,iBAAA;ApF0wpBR;;AoF3wpBI;EACI,iBAAA;ApF8wpBR;;AoF/wpBI;EACI,iBAAA;ApFkxpBR;;AoFnxpBI;EACI,iBAAA;ApFsxpBR;;AoFvxpBI;EACI,iBAAA;ApF0xpBR;;AoF3xpBI;EACI,iBAAA;ApF8xpBR;;AoF/xpBI;EACI,iBAAA;ApFkypBR;;AoFnypBI;EACI,iBAAA;ApFsypBR;;AoFvypBI;EACI,iBAAA;ApF0ypBR;;AoF3ypBI;EACI,iBAAA;ApF8ypBR;;AoF/ypBI;EACI,iBAAA;ApFkzpBR;;AoFnzpBI;EACI,iBAAA;ApFszpBR;;AoFvzpBI;EACI,iBAAA;ApF0zpBR;;AoF3zpBI;EACI,iBAAA;ApF8zpBR;;AoF/zpBI;EACI,iBAAA;ApFk0pBR;;AoFn0pBI;EACI,iBAAA;ApFs0pBR;;AoFv0pBI;EACI,iBAAA;ApF00pBR;;AoF30pBI;EACI,iBAAA;ApF80pBR;;AoF/0pBI;EACI,iBAAA;ApFk1pBR;;AoFn1pBI;EACI,iBAAA;ApFs1pBR;;AoFv1pBI;EACI,iBAAA;ApF01pBR;;AoF31pBI;EACI,iBAAA;ApF81pBR;;AoF/1pBI;EACI,iBAAA;ApFk2pBR;;AoFn2pBI;EACI,iBAAA;ApFs2pBR;;AoFv2pBI;EACI,iBAAA;ApF02pBR;;AoF32pBI;EACI,iBAAA;ApF82pBR;;AoF/2pBI;EACI,iBAAA;ApFk3pBR;;AoFn3pBI;EACI,iBAAA;ApFs3pBR;;AoFv3pBI;EACI,iBAAA;ApF03pBR;;AoF33pBI;EACI,iBAAA;ApF83pBR;;AoF/3pBI;EACI,iBAAA;ApFk4pBR;;AoFn4pBI;EACI,iBAAA;ApFs4pBR;;AoFv4pBI;EACI,iBAAA;ApF04pBR;;AoF34pBI;EACI,iBAAA;ApF84pBR;;AoF/4pBI;EACI,iBAAA;ApFk5pBR;;AoFn5pBI;EACI,iBAAA;ApFs5pBR;;AoFv5pBI;EACI,iBAAA;ApF05pBR;;AoF35pBI;EACI,iBAAA;ApF85pBR;;AoF/5pBI;EACI,iBAAA;ApFk6pBR;;AoFn6pBI;EACI,iBAAA;ApFs6pBR;;AoFv6pBI;EACI,iBAAA;ApF06pBR;;AoF36pBI;EACI,iBAAA;ApF86pBR;;AoF/6pBI;EACI,iBAAA;ApFk7pBR;;AoFn7pBI;EACI,iBAAA;ApFs7pBR;;AoFv7pBI;EACI,iBAAA;ApF07pBR;;AoF37pBI;EACI,iBAAA;ApF87pBR;;AoF/7pBI;EACI,iBAAA;ApFk8pBR;;AoFn8pBI;EACI,iBAAA;ApFs8pBR;;AoFv8pBI;EACI,iBAAA;ApF08pBR;;AoF38pBI;EACI,iBAAA;ApF88pBR;;AoF/8pBI;EACI,iBAAA;ApFk9pBR;;AoFn9pBI;EACI,iBAAA;ApFs9pBR;;AoFv9pBI;EACI,iBAAA;ApF09pBR;;AoF39pBI;EACI,iBAAA;ApF89pBR;;AoF/9pBI;EACI,iBAAA;ApFk+pBR;;AoFn+pBI;EACI,iBAAA;ApFs+pBR;;AoFv+pBI;EACI,iBAAA;ApF0+pBR;;AoF3+pBI;EACI,iBAAA;ApF8+pBR;;AoF/+pBI;EACI,iBAAA;ApFk/pBR;;AoFn/pBI;EACI,iBAAA;ApFs/pBR;;AoFv/pBI;EACI,iBAAA;ApF0/pBR;;AoF3/pBI;EACI,iBAAA;ApF8/pBR;;AoF//pBI;EACI,iBAAA;ApFkgqBR;;AoFngqBI;EACI,iBAAA;ApFsgqBR;;AoFvgqBI;EACI,iBAAA;ApF0gqBR;;AoF3gqBI;EACI,iBAAA;ApF8gqBR;;AoF/gqBI;EACI,iBAAA;ApFkhqBR;;AoFnhqBI;EACI,iBAAA;ApFshqBR;;AoFvhqBI;EACI,iBAAA;ApF0hqBR;;AoF3hqBI;EACI,iBAAA;ApF8hqBR;;AoF/hqBI;EACI,iBAAA;ApFkiqBR;;AoFniqBI;EACI,iBAAA;ApFsiqBR;;AoFviqBI;EACI,iBAAA;ApF0iqBR;;AoF3iqBI;EACI,iBAAA;ApF8iqBR;;AoF/iqBI;EACI,iBAAA;ApFkjqBR;;AoFnjqBI;EACI,iBAAA;ApFsjqBR;;AoFvjqBI;EACI,iBAAA;ApF0jqBR;;AoF3jqBI;EACI,iBAAA;ApF8jqBR;;AoF/jqBI;EACI,iBAAA;ApFkkqBR;;AoFnkqBI;EACI,iBAAA;ApFskqBR;;AoFvkqBI;EACI,iBAAA;ApF0kqBR;;AoF3kqBI;EACI,iBAAA;ApF8kqBR;;AoF/kqBI;EACI,iBAAA;ApFklqBR;;AoFnlqBI;EACI,iBAAA;ApFslqBR;;AoFvlqBI;EACI,iBAAA;ApF0lqBR;;AoF3lqBI;EACI,iBAAA;ApF8lqBR;;AoF/lqBI;EACI,iBAAA;ApFkmqBR;;AoFnmqBI;EACI,iBAAA;ApFsmqBR;;AoFvmqBI;EACI,iBAAA;ApF0mqBR;;AoF3mqBI;EACI,iBAAA;ApF8mqBR;;AoF/mqBI;EACI,iBAAA;ApFknqBR;;AoFnnqBI;EACI,iBAAA;ApFsnqBR;;AoFvnqBI;EACI,iBAAA;ApF0nqBR;;AoF3nqBI;EACI,iBAAA;ApF8nqBR;;AoF/nqBI;EACI,iBAAA;ApFkoqBR;;AoFnoqBI;EACI,iBAAA;ApFsoqBR;;AoFvoqBI;EACI,iBAAA;ApF0oqBR;;AoF3oqBI;EACI,iBAAA;ApF8oqBR;;AoF/oqBI;EACI,iBAAA;ApFkpqBR;;AoFnpqBI;EACI,iBAAA;ApFspqBR;;AoFvpqBI;EACI,iBAAA;ApF0pqBR;;AoF3pqBI;EACI,iBAAA;ApF8pqBR;;AoF/pqBI;EACI,iBAAA;ApFkqqBR;;AoFnqqBI;EACI,iBAAA;ApFsqqBR;;AoFvqqBI;EACI,iBAAA;ApF0qqBR;;AoF3qqBI;EACI,iBAAA;ApF8qqBR;;AoF/qqBI;EACI,iBAAA;ApFkrqBR;;AoFnrqBI;EACI,iBAAA;ApFsrqBR;;AoFvrqBI;EACI,iBAAA;ApF0rqBR;;AoF3rqBI;EACI,iBAAA;ApF8rqBR;;AoF/rqBI;EACI,iBAAA;ApFksqBR;;AoFnsqBI;EACI,iBAAA;ApFssqBR;;AoFvsqBI;EACI,iBAAA;ApF0sqBR;;AoF3sqBI;EACI,iBAAA;ApF8sqBR;;AoF/sqBI;EACI,iBAAA;ApFktqBR;;AoFntqBI;EACI,iBAAA;ApFstqBR;;AoFvtqBI;EACI,iBAAA;ApF0tqBR;;AoF3tqBI;EACI,iBAAA;ApF8tqBR;;AoF/tqBI;EACI,iBAAA;ApFkuqBR;;AoFnuqBI;EACI,iBAAA;ApFsuqBR;;AoFvuqBI;EACI,iBAAA;ApF0uqBR;;AoF3uqBI;EACI,iBAAA;ApF8uqBR;;AoF/uqBI;EACI,iBAAA;ApFkvqBR;;AoFnvqBI;EACI,iBAAA;ApFsvqBR;;AoFvvqBI;EACI,iBAAA;ApF0vqBR;;AoF3vqBI;EACI,iBAAA;ApF8vqBR;;AoF/vqBI;EACI,iBAAA;ApFkwqBR;;AoFnwqBI;EACI,iBAAA;ApFswqBR;;AoFvwqBI;EACI,iBAAA;ApF0wqBR;;AoF3wqBI;EACI,iBAAA;ApF8wqBR;;AoF/wqBI;EACI,iBAAA;ApFkxqBR;;AoFnxqBI;EACI,iBAAA;ApFsxqBR;;AoFvxqBI;EACI,iBAAA;ApF0xqBR;;AoF3xqBI;EACI,iBAAA;ApF8xqBR;;AoF/xqBI;EACI,iBAAA;ApFkyqBR;;AoFnyqBI;EACI,iBAAA;ApFsyqBR;;AoFvyqBI;EACI,iBAAA;ApF0yqBR;;AoF3yqBI;EACI,iBAAA;ApF8yqBR;;AoF/yqBI;EACI,iBAAA;ApFkzqBR;;AoFnzqBI;EACI,iBAAA;ApFszqBR;;AoFvzqBI;EACI,iBAAA;ApF0zqBR;;AoF3zqBI;EACI,iBAAA;ApF8zqBR;;AoF/zqBI;EACI,iBAAA;ApFk0qBR;;AoFn0qBI;EACI,iBAAA;ApFs0qBR;;AoFv0qBI;EACI,iBAAA;ApF00qBR;;AoF30qBI;EACI,iBAAA;ApF80qBR;;AoF/0qBI;EACI,iBAAA;ApFk1qBR;;AoFn1qBI;EACI,iBAAA;ApFs1qBR;;AoFv1qBI;EACI,iBAAA;ApF01qBR;;AoF31qBI;EACI,iBAAA;ApF81qBR;;AoF/1qBI;EACI,iBAAA;ApFk2qBR;;AoFn2qBI;EACI,iBAAA;ApFs2qBR;;AoFv2qBI;EACI,iBAAA;ApF02qBR;;AoF32qBI;EACI,iBAAA;ApF82qBR;;AoF/2qBI;EACI,iBAAA;ApFk3qBR;;AoFn3qBI;EACI,iBAAA;ApFs3qBR;;AoFv3qBI;EACI,iBAAA;ApF03qBR;;AoF33qBI;EACI,iBAAA;ApF83qBR;;AoF/3qBI;EACI,iBAAA;ApFk4qBR;;AoFn4qBI;EACI,iBAAA;ApFs4qBR;;AoFv4qBI;EACI,iBAAA;ApF04qBR;;AoF34qBI;EACI,iBAAA;ApF84qBR;;AoF/4qBI;EACI,iBAAA;ApFk5qBR;;AoFn5qBI;EACI,iBAAA;ApFs5qBR;;AoFv5qBI;EACI,iBAAA;ApF05qBR;;AoF35qBI;EACI,iBAAA;ApF85qBR;;AoF/5qBI;EACI,iBAAA;ApFk6qBR;;AoFn6qBI;EACI,iBAAA;ApFs6qBR;;AoFv6qBI;EACI,iBAAA;ApF06qBR;;AoF36qBI;EACI,iBAAA;ApF86qBR;;AoF/6qBI;EACI,iBAAA;ApFk7qBR;;AoFn7qBI;EACI,iBAAA;ApFs7qBR;;AoFv7qBI;EACI,iBAAA;ApF07qBR;;AoF37qBI;EACI,iBAAA;ApF87qBR;;AoF/7qBI;EACI,iBAAA;ApFk8qBR;;AoFn8qBI;EACI,iBAAA;ApFs8qBR;;AoFv8qBI;EACI,iBAAA;ApF08qBR;;AoF38qBI;EACI,iBAAA;ApF88qBR;;AoF/8qBI;EACI,iBAAA;ApFk9qBR;;AoFn9qBI;EACI,iBAAA;ApFs9qBR;;AoFv9qBI;EACI,iBAAA;ApF09qBR;;AoF39qBI;EACI,iBAAA;ApF89qBR;;AoF/9qBI;EACI,iBAAA;ApFk+qBR;;AoFn+qBI;EACI,iBAAA;ApFs+qBR;;AoFv+qBI;EACI,iBAAA;ApF0+qBR;;AoF3+qBI;EACI,iBAAA;ApF8+qBR;;AoF/+qBI;EACI,iBAAA;ApFk/qBR;;AoFn/qBI;EACI,iBAAA;ApFs/qBR;;AoFv/qBI;EACI,iBAAA;ApF0/qBR;;AoF3/qBI;EACI,iBAAA;ApF8/qBR;;AoF//qBI;EACI,iBAAA;ApFkgrBR;;AoFngrBI;EACI,iBAAA;ApFsgrBR;;AoFvgrBI;EACI,iBAAA;ApF0grBR;;AoF3grBI;EACI,iBAAA;ApF8grBR;;AoF/grBI;EACI,iBAAA;ApFkhrBR;;AoFnhrBI;EACI,iBAAA;ApFshrBR;;AoFvhrBI;EACI,iBAAA;ApF0hrBR;;AoF3hrBI;EACI,iBAAA;ApF8hrBR;;AoF/hrBI;EACI,iBAAA;ApFkirBR;;AoFnirBI;EACI,iBAAA;ApFsirBR;;AoFvirBI;EACI,iBAAA;ApF0irBR;;AoF3irBI;EACI,iBAAA;ApF8irBR;;AoF/irBI;EACI,iBAAA;ApFkjrBR;;AoFnjrBI;EACI,iBAAA;ApFsjrBR;;AoFvjrBI;EACI,iBAAA;ApF0jrBR;;AoF3jrBI;EACI,iBAAA;ApF8jrBR;;AoF/jrBI;EACI,iBAAA;ApFkkrBR;;AoFnkrBI;EACI,iBAAA;ApFskrBR;;AoFvkrBI;EACI,iBAAA;ApF0krBR;;AoF3krBI;EACI,iBAAA;ApF8krBR;;AoF/krBI;EACI,iBAAA;ApFklrBR;;AoFnlrBI;EACI,iBAAA;ApFslrBR;;AoFvlrBI;EACI,iBAAA;ApF0lrBR;;AoF3lrBI;EACI,iBAAA;ApF8lrBR;;AoF/lrBI;EACI,iBAAA;ApFkmrBR;;AoFnmrBI;EACI,iBAAA;ApFsmrBR;;AoFvmrBI;EACI,iBAAA;ApF0mrBR;;AoF3mrBI;EACI,iBAAA;ApF8mrBR;;AoF/mrBI;EACI,iBAAA;ApFknrBR;;AoFnnrBI;EACI,iBAAA;ApFsnrBR;;AoFvnrBI;EACI,iBAAA;ApF0nrBR;;AoF3nrBI;EACI,iBAAA;ApF8nrBR;;AoF/nrBI;EACI,iBAAA;ApFkorBR;;AoFnorBI;EACI,iBAAA;ApFsorBR;;AoFvorBI;EACI,iBAAA;ApF0orBR;;AoF3orBI;EACI,iBAAA;ApF8orBR;;AoF/orBI;EACI,iBAAA;ApFkprBR;;AoFnprBI;EACI,iBAAA;ApFsprBR;;AoFvprBI;EACI,iBAAA;ApF0prBR;;AoF3prBI;EACI,iBAAA;ApF8prBR;;AoF/prBI;EACI,iBAAA;ApFkqrBR;;AoFnqrBI;EACI,iBAAA;ApFsqrBR;;AoFvqrBI;EACI,iBAAA;ApF0qrBR;;AoF3qrBI;EACI,iBAAA;ApF8qrBR;;AoF/qrBI;EACI,iBAAA;ApFkrrBR;;AoFnrrBI;EACI,iBAAA;ApFsrrBR;;AoFvrrBI;EACI,iBAAA;ApF0rrBR;;AoF3rrBI;EACI,iBAAA;ApF8rrBR;;AoF/rrBI;EACI,iBAAA;ApFksrBR;;AoFnsrBI;EACI,iBAAA;ApFssrBR;;AoFvsrBI;EACI,iBAAA;ApF0srBR;;AoF3srBI;EACI,iBAAA;ApF8srBR;;AoF/srBI;EACI,iBAAA;ApFktrBR;;AoFntrBI;EACI,iBAAA;ApFstrBR;;AoFvtrBI;EACI,iBAAA;ApF0trBR;;AoF3trBI;EACI,iBAAA;ApF8trBR;;AoF/trBI;EACI,iBAAA;ApFkurBR;;AoFnurBI;EACI,iBAAA;ApFsurBR;;AoFvurBI;EACI,iBAAA;ApF0urBR;;AoF3urBI;EACI,iBAAA;ApF8urBR;;AoF/urBI;EACI,iBAAA;ApFkvrBR;;AoFnvrBI;EACI,iBAAA;ApFsvrBR;;AoFvvrBI;EACI,iBAAA;ApF0vrBR;;AoF3vrBI;EACI,iBAAA;ApF8vrBR;;AoF/vrBI;EACI,iBAAA;ApFkwrBR;;AoFnwrBI;EACI,iBAAA;ApFswrBR;;AoFvwrBI;EACI,iBAAA;ApF0wrBR;;AoF3wrBI;EACI,iBAAA;ApF8wrBR;;AoF/wrBI;EACI,iBAAA;ApFkxrBR;;AoFnxrBI;EACI,iBAAA;ApFsxrBR;;AoFvxrBI;EACI,iBAAA;ApF0xrBR;;AoF3xrBI;EACI,iBAAA;ApF8xrBR;;AoF/xrBI;EACI,iBAAA;ApFkyrBR;;AoFnyrBI;EACI,iBAAA;ApFsyrBR;;AoFvyrBI;EACI,iBAAA;ApF0yrBR;;AoF3yrBI;EACI,iBAAA;ApF8yrBR;;AoF/yrBI;EACI,iBAAA;ApFkzrBR;;AoFnzrBI;EACI,iBAAA;ApFszrBR;;AoFvzrBI;EACI,iBAAA;ApF0zrBR;;AoF3zrBI;EACI,iBAAA;ApF8zrBR;;AoF/zrBI;EACI,iBAAA;ApFk0rBR;;AoFn0rBI;EACI,iBAAA;ApFs0rBR;;AoFv0rBI;EACI,iBAAA;ApF00rBR;;AoF30rBI;EACI,iBAAA;ApF80rBR;;AoF/0rBI;EACI,iBAAA;ApFk1rBR;;AoFn1rBI;EACI,iBAAA;ApFs1rBR;;AoFv1rBI;EACI,iBAAA;ApF01rBR;;AoF31rBI;EACI,iBAAA;ApF81rBR;;AoF/1rBI;EACI,iBAAA;ApFk2rBR;;AoFn2rBI;EACI,iBAAA;ApFs2rBR;;AoFv2rBI;EACI,iBAAA;ApF02rBR;;AoF32rBI;EACI,iBAAA;ApF82rBR;;AoF/2rBI;EACI,iBAAA;ApFk3rBR;;AoFn3rBI;EACI,iBAAA;ApFs3rBR;;AoFv3rBI;EACI,iBAAA;ApF03rBR;;AoF33rBI;EACI,iBAAA;ApF83rBR;;AoF/3rBI;EACI,iBAAA;ApFk4rBR;;AoFn4rBI;EACI,iBAAA;ApFs4rBR;;AoFv4rBI;EACI,iBAAA;ApF04rBR;;AoF34rBI;EACI,iBAAA;ApF84rBR;;AoF/4rBI;EACI,iBAAA;ApFk5rBR;;AoFn5rBI;EACI,iBAAA;ApFs5rBR;;AoFv5rBI;EACI,iBAAA;ApF05rBR;;AoF35rBI;EACI,iBAAA;ApF85rBR;;AoF/5rBI;EACI,iBAAA;ApFk6rBR;;AoFn6rBI;EACI,iBAAA;ApFs6rBR;;AoFv6rBI;EACI,iBAAA;ApF06rBR;;AoF36rBI;EACI,iBAAA;ApF86rBR;;AoF/6rBI;EACI,iBAAA;ApFk7rBR;;AoFn7rBI;EACI,iBAAA;ApFs7rBR;;AoFv7rBI;EACI,iBAAA;ApF07rBR;;AoF37rBI;EACI,iBAAA;ApF87rBR;;AoF/7rBI;EACI,iBAAA;ApFk8rBR;;AoFn8rBI;EACI,iBAAA;ApFs8rBR;;AoFv8rBI;EACI,iBAAA;ApF08rBR;;AoF38rBI;EACI,iBAAA;ApF88rBR;;AoF/8rBI;EACI,iBAAA;ApFk9rBR;;AoFn9rBI;EACI,iBAAA;ApFs9rBR;;AoFv9rBI;EACI,iBAAA;ApF09rBR;;AoF39rBI;EACI,iBAAA;ApF89rBR;;AoF/9rBI;EACI,iBAAA;ApFk+rBR;;AoFn+rBI;EACI,iBAAA;ApFs+rBR;;AoFv+rBI;EACI,iBAAA;ApF0+rBR;;AoF3+rBI;EACI,iBAAA;ApF8+rBR;;AoF/+rBI;EACI,iBAAA;ApFk/rBR;;AoFn/rBI;EACI,iBAAA;ApFs/rBR;;AoFv/rBI;EACI,iBAAA;ApF0/rBR;;AoF3/rBI;EACI,iBAAA;ApF8/rBR;;AoF//rBI;EACI,iBAAA;ApFkgsBR;;AoFngsBI;EACI,iBAAA;ApFsgsBR;;AoFvgsBI;EACI,iBAAA;ApF0gsBR;;AoF3gsBI;EACI,iBAAA;ApF8gsBR;;AoF/gsBI;EACI,iBAAA;ApFkhsBR;;AoFnhsBI;EACI,iBAAA;ApFshsBR;;AoFvhsBI;EACI,iBAAA;ApF0hsBR;;AoF3hsBI;EACI,iBAAA;ApF8hsBR;;AoF/hsBI;EACI,iBAAA;ApFkisBR;;AoFnisBI;EACI,iBAAA;ApFsisBR;;AoFvisBI;EACI,iBAAA;ApF0isBR;;AoF3isBI;EACI,iBAAA;ApF8isBR;;AoF/isBI;EACI,iBAAA;ApFkjsBR;;AoFnjsBI;EACI,iBAAA;ApFsjsBR;;AoFvjsBI;EACI,iBAAA;ApF0jsBR;;AoF3jsBI;EACI,iBAAA;ApF8jsBR;;AoF/jsBI;EACI,iBAAA;ApFkksBR;;AoFnksBI;EACI,iBAAA;ApFsksBR;;AoFvksBI;EACI,iBAAA;ApF0ksBR;;AoF3ksBI;EACI,iBAAA;ApF8ksBR;;AoF/ksBI;EACI,iBAAA;ApFklsBR;;AoFnlsBI;EACI,iBAAA;ApFslsBR;;AoFvlsBI;EACI,iBAAA;ApF0lsBR;;AoF3lsBI;EACI,iBAAA;ApF8lsBR;;AoF/lsBI;EACI,iBAAA;ApFkmsBR;;AoFnmsBI;EACI,iBAAA;ApFsmsBR;;AoFvmsBI;EACI,iBAAA;ApF0msBR;;AoF3msBI;EACI,iBAAA;ApF8msBR;;AoF/msBI;EACI,iBAAA;ApFknsBR;;AoFnnsBI;EACI,iBAAA;ApFsnsBR;;AoFvnsBI;EACI,iBAAA;ApF0nsBR;;AoF3nsBI;EACI,iBAAA;ApF8nsBR;;AoF/nsBI;EACI,iBAAA;ApFkosBR;;AoFnosBI;EACI,iBAAA;ApFsosBR;;AoFvosBI;EACI,iBAAA;ApF0osBR;;AoF3osBI;EACI,iBAAA;ApF8osBR;;AoF/osBI;EACI,iBAAA;ApFkpsBR;;AoFnpsBI;EACI,iBAAA;ApFspsBR;;AoFvpsBI;EACI,iBAAA;ApF0psBR;;AoF3psBI;EACI,iBAAA;ApF8psBR;;AoF/psBI;EACI,iBAAA;ApFkqsBR;;AoFnqsBI;EACI,iBAAA;ApFsqsBR;;AoFvqsBI;EACI,iBAAA;ApF0qsBR;;AoF3qsBI;EACI,iBAAA;ApF8qsBR;;AoF/qsBI;EACI,iBAAA;ApFkrsBR;;AoFnrsBI;EACI,iBAAA;ApFsrsBR;;AoFvrsBI;EACI,iBAAA;ApF0rsBR;;AoF3rsBI;EACI,iBAAA;ApF8rsBR;;AoF/rsBI;EACI,iBAAA;ApFkssBR;;AoFnssBI;EACI,iBAAA;ApFsssBR;;AoFvssBI;EACI,iBAAA;ApF0ssBR;;AoF3ssBI;EACI,iBAAA;ApF8ssBR;;AoF/ssBI;EACI,iBAAA;ApFktsBR;;AoFntsBI;EACI,iBAAA;ApFstsBR;;AoFvtsBI;EACI,iBAAA;ApF0tsBR;;AoF3tsBI;EACI,iBAAA;ApF8tsBR;;AoF/tsBI;EACI,iBAAA;ApFkusBR;;AoFnusBI;EACI,iBAAA;ApFsusBR;;AoFvusBI;EACI,iBAAA;ApF0usBR;;AoF3usBI;EACI,iBAAA;ApF8usBR;;AoF/usBI;EACI,iBAAA;ApFkvsBR;;AoFnvsBI;EACI,iBAAA;ApFsvsBR;;AoFvvsBI;EACI,iBAAA;ApF0vsBR;;AoF3vsBI;EACI,iBAAA;ApF8vsBR;;AoF/vsBI;EACI,iBAAA;ApFkwsBR;;AoFnwsBI;EACI,iBAAA;ApFswsBR;;AoFvwsBI;EACI,iBAAA;ApF0wsBR;;AoF3wsBI;EACI,iBAAA;ApF8wsBR;;AoF/wsBI;EACI,iBAAA;ApFkxsBR;;AoFnxsBI;EACI,iBAAA;ApFsxsBR;;AoFvxsBI;EACI,iBAAA;ApF0xsBR;;AoF3xsBI;EACI,iBAAA;ApF8xsBR;;AoF/xsBI;EACI,iBAAA;ApFkysBR;;AoFnysBI;EACI,iBAAA;ApFsysBR;;AoFvysBI;EACI,iBAAA;ApF0ysBR;;AoF3ysBI;EACI,iBAAA;ApF8ysBR;;AoF/ysBI;EACI,iBAAA;ApFkzsBR;;AoFnzsBI;EACI,iBAAA;ApFszsBR;;AoFvzsBI;EACI,iBAAA;ApF0zsBR;;AoF3zsBI;EACI,iBAAA;ApF8zsBR;;AoF/zsBI;EACI,iBAAA;ApFk0sBR;;AoFn0sBI;EACI,iBAAA;ApFs0sBR;;AoFv0sBI;EACI,iBAAA;ApF00sBR;;AoF30sBI;EACI,iBAAA;ApF80sBR;;AoF/0sBI;EACI,iBAAA;ApFk1sBR;;AoFn1sBI;EACI,iBAAA;ApFs1sBR;;AoFv1sBI;EACI,iBAAA;ApF01sBR;;AoF31sBI;EACI,iBAAA;ApF81sBR;;AoF/1sBI;EACI,iBAAA;ApFk2sBR;;AoFn2sBI;EACI,iBAAA;ApFs2sBR;;AoFv2sBI;EACI,iBAAA;ApF02sBR;;AoF32sBI;EACI,iBAAA;ApF82sBR;;AoF/2sBI;EACI,iBAAA;ApFk3sBR;;AoFn3sBI;EACI,iBAAA;ApFs3sBR;;AoFv3sBI;EACI,iBAAA;ApF03sBR;;AoF33sBI;EACI,iBAAA;ApF83sBR;;AoF/3sBI;EACI,iBAAA;ApFk4sBR;;AoFn4sBI;EACI,iBAAA;ApFs4sBR;;AoFv4sBI;EACI,iBAAA;ApF04sBR;;AoF34sBI;EACI,iBAAA;ApF84sBR;;AoF/4sBI;EACI,iBAAA;ApFk5sBR;;AoFn5sBI;EACI,iBAAA;ApFs5sBR;;AoFv5sBI;EACI,iBAAA;ApF05sBR;;AoF35sBI;EACI,iBAAA;ApF85sBR;;AoF/5sBI;EACI,iBAAA;ApFk6sBR;;AoFn6sBI;EACI,iBAAA;ApFs6sBR;;AoFv6sBI;EACI,iBAAA;ApF06sBR;;AoF36sBI;EACI,iBAAA;ApF86sBR;;AoF/6sBI;EACI,iBAAA;ApFk7sBR;;AoFn7sBI;EACI,iBAAA;ApFs7sBR;;AoFv7sBI;EACI,iBAAA;ApF07sBR;;AoF37sBI;EACI,iBAAA;ApF87sBR;;AoF/7sBI;EACI,iBAAA;ApFk8sBR;;AoFn8sBI;EACI,iBAAA;ApFs8sBR;;AoFv8sBI;EACI,iBAAA;ApF08sBR;;AoF38sBI;EACI,iBAAA;ApF88sBR;;AoF/8sBI;EACI,iBAAA;ApFk9sBR;;AoFn9sBI;EACI,iBAAA;ApFs9sBR;;AoFv9sBI;EACI,iBAAA;ApF09sBR;;AoF39sBI;EACI,iBAAA;ApF89sBR;;AoF/9sBI;EACI,iBAAA;ApFk+sBR;;AoFn+sBI;EACI,iBAAA;ApFs+sBR;;AoFv+sBI;EACI,iBAAA;ApF0+sBR;;AoF3+sBI;EACI,iBAAA;ApF8+sBR;;AoF/+sBI;EACI,iBAAA;ApFk/sBR;;AoFn/sBI;EACI,iBAAA;ApFs/sBR;;AoFv/sBI;EACI,iBAAA;ApF0/sBR;;AoF3/sBI;EACI,iBAAA;ApF8/sBR;;AoF//sBI;EACI,iBAAA;ApFkgtBR;;AoFngtBI;EACI,iBAAA;ApFsgtBR;;AoFvgtBI;EACI,iBAAA;ApF0gtBR;;AoF3gtBI;EACI,iBAAA;ApF8gtBR;;AoF/gtBI;EACI,iBAAA;ApFkhtBR;;AoFnhtBI;EACI,iBAAA;ApFshtBR;;AoFvhtBI;EACI,iBAAA;ApF0htBR;;AoF3htBI;EACI,iBAAA;ApF8htBR;;AoF/htBI;EACI,iBAAA;ApFkitBR;;AoFnitBI;EACI,iBAAA;ApFsitBR;;AoFvitBI;EACI,iBAAA;ApF0itBR;;AoF3itBI;EACI,iBAAA;ApF8itBR;;AoF/itBI;EACI,iBAAA;ApFkjtBR;;AoFnjtBI;EACI,iBAAA;ApFsjtBR;;AoFvjtBI;EACI,iBAAA;ApF0jtBR;;AoF3jtBI;EACI,iBAAA;ApF8jtBR;;AoF/jtBI;EACI,iBAAA;ApFkktBR;;AoFnktBI;EACI,iBAAA;ApFsktBR;;AoFvktBI;EACI,iBAAA;ApF0ktBR;;AoF3ktBI;EACI,iBAAA;ApF8ktBR;;AoF/ktBI;EACI,iBAAA;ApFkltBR;;AoFnltBI;EACI,iBAAA;ApFsltBR;;AoFvltBI;EACI,iBAAA;ApF0ltBR;;AoF3ltBI;EACI,iBAAA;ApF8ltBR;;AoF/ltBI;EACI,iBAAA;ApFkmtBR;;AoFnmtBI;EACI,iBAAA;ApFsmtBR;;AoFvmtBI;EACI,iBAAA;ApF0mtBR;;AoF3mtBI;EACI,iBAAA;ApF8mtBR;;AoF/mtBI;EACI,iBAAA;ApFkntBR;;AoFnntBI;EACI,iBAAA;ApFsntBR;;AoFvntBI;EACI,iBAAA;ApF0ntBR;;AoF3ntBI;EACI,iBAAA;ApF8ntBR;;AoF/ntBI;EACI,iBAAA;ApFkotBR;;AoFnotBI;EACI,iBAAA;ApFsotBR;;AoFvotBI;EACI,iBAAA;ApF0otBR;;AoF3otBI;EACI,iBAAA;ApF8otBR;;AoF/otBI;EACI,iBAAA;ApFkptBR;;AoFnptBI;EACI,iBAAA;ApFsptBR;;AoFvptBI;EACI,iBAAA;ApF0ptBR;;AoF3ptBI;EACI,iBAAA;ApF8ptBR;;AoF/ptBI;EACI,iBAAA;ApFkqtBR;;AoFnqtBI;EACI,iBAAA;ApFsqtBR;;AoFvqtBI;EACI,iBAAA;ApF0qtBR;;AoF3qtBI;EACI,iBAAA;ApF8qtBR;;AoF/qtBI;EACI,iBAAA;ApFkrtBR;;AoFnrtBI;EACI,iBAAA;ApFsrtBR;;AoFvrtBI;EACI,iBAAA;ApF0rtBR;;AoF3rtBI;EACI,iBAAA;ApF8rtBR;;AoF/rtBI;EACI,iBAAA;ApFkstBR;;AoFnstBI;EACI,iBAAA;ApFsstBR;;AoFvstBI;EACI,iBAAA;ApF0stBR;;AoF3stBI;EACI,iBAAA;ApF8stBR;;AoF/stBI;EACI,iBAAA;ApFkttBR;;AoFnttBI;EACI,iBAAA;ApFsttBR;;AoFvttBI;EACI,iBAAA;ApF0ttBR;;AoF3ttBI;EACI,iBAAA;ApF8ttBR;;AoF/ttBI;EACI,iBAAA;ApFkutBR;;AoFnutBI;EACI,iBAAA;ApFsutBR;;AoFvutBI;EACI,iBAAA;ApF0utBR;;AoF3utBI;EACI,iBAAA;ApF8utBR;;AoF/utBI;EACI,iBAAA;ApFkvtBR;;AoFnvtBI;EACI,iBAAA;ApFsvtBR;;AoFvvtBI;EACI,iBAAA;ApF0vtBR;;AoF3vtBI;EACI,iBAAA;ApF8vtBR;;AoF/vtBI;EACI,iBAAA;ApFkwtBR;;AoFnwtBI;EACI,iBAAA;ApFswtBR;;AoFvwtBI;EACI,iBAAA;ApF0wtBR;;AoF3wtBI;EACI,iBAAA;ApF8wtBR;;AoF/wtBI;EACI,iBAAA;ApFkxtBR;;AoFnxtBI;EACI,iBAAA;ApFsxtBR;;AoFvxtBI;EACI,iBAAA;ApF0xtBR;;AoF3xtBI;EACI,iBAAA;ApF8xtBR;;AoF/xtBI;EACI,iBAAA;ApFkytBR;;AoFnytBI;EACI,iBAAA;ApFsytBR;;AoFvytBI;EACI,iBAAA;ApF0ytBR;;AoF3ytBI;EACI,iBAAA;ApF8ytBR;;AoF/ytBI;EACI,iBAAA;ApFkztBR;;AoFnztBI;EACI,iBAAA;ApFsztBR;;AoFvztBI;EACI,iBAAA;ApF0ztBR;;AoF3ztBI;EACI,iBAAA;ApF8ztBR;;AoF/ztBI;EACI,iBAAA;ApFk0tBR;;AoFn0tBI;EACI,iBAAA;ApFs0tBR;;AoFv0tBI;EACI,iBAAA;ApF00tBR;;AoF30tBI;EACI,iBAAA;ApF80tBR;;AoF/0tBI;EACI,iBAAA;ApFk1tBR;;AoFn1tBI;EACI,iBAAA;ApFs1tBR;;AoFv1tBI;EACI,iBAAA;ApF01tBR;;AoF31tBI;EACI,iBAAA;ApF81tBR;;AoF/1tBI;EACI,iBAAA;ApFk2tBR;;AoFn2tBI;EACI,iBAAA;ApFs2tBR;;AoFv2tBI;EACI,iBAAA;ApF02tBR;;AoF32tBI;EACI,iBAAA;ApF82tBR;;AoF/2tBI;EACI,iBAAA;ApFk3tBR;;AoFn3tBI;EACI,iBAAA;ApFs3tBR;;AoFv3tBI;EACI,iBAAA;ApF03tBR;;AoF33tBI;EACI,iBAAA;ApF83tBR;;AoF/3tBI;EACI,iBAAA;ApFk4tBR;;AoFn4tBI;EACI,iBAAA;ApFs4tBR;;AoFv4tBI;EACI,iBAAA;ApF04tBR;;AoF34tBI;EACI,iBAAA;ApF84tBR;;AoF/4tBI;EACI,iBAAA;ApFk5tBR;;AoFn5tBI;EACI,iBAAA;ApFs5tBR;;AoFv5tBI;EACI,iBAAA;ApF05tBR;;AoF35tBI;EACI,iBAAA;ApF85tBR;;AoF/5tBI;EACI,iBAAA;ApFk6tBR;;AoFn6tBI;EACI,iBAAA;ApFs6tBR;;AoFv6tBI;EACI,iBAAA;ApF06tBR;;AoF36tBI;EACI,iBAAA;ApF86tBR;;AoF/6tBI;EACI,iBAAA;ApFk7tBR;;AoFn7tBI;EACI,iBAAA;ApFs7tBR;;AoFv7tBI;EACI,iBAAA;ApF07tBR;;AoF37tBI;EACI,iBAAA;ApF87tBR;;AoF/7tBI;EACI,iBAAA;ApFk8tBR;;AoFn8tBI;EACI,iBAAA;ApFs8tBR;;AoFv8tBI;EACI,iBAAA;ApF08tBR;;AoF38tBI;EACI,iBAAA;ApF88tBR;;AoF/8tBI;EACI,iBAAA;ApFk9tBR;;AoFn9tBI;EACI,iBAAA;ApFs9tBR;;AoFv9tBI;EACI,iBAAA;ApF09tBR;;AoF39tBI;EACI,iBAAA;ApF89tBR;;AoF/9tBI;EACI,iBAAA;ApFk+tBR;;AoFn+tBI;EACI,iBAAA;ApFs+tBR;;AoFv+tBI;EACI,iBAAA;ApF0+tBR;;AoF3+tBI;EACI,iBAAA;ApF8+tBR;;AoF/+tBI;EACI,iBAAA;ApFk/tBR;;AoFn/tBI;EACI,iBAAA;ApFs/tBR;;AoFv/tBI;EACI,iBAAA;ApF0/tBR;;AoF3/tBI;EACI,iBAAA;ApF8/tBR;;AoF//tBI;EACI,iBAAA;ApFkguBR;;AoFnguBI;EACI,iBAAA;ApFsguBR;;AoFvguBI;EACI,iBAAA;ApF0guBR;;AoF3guBI;EACI,iBAAA;ApF8guBR;;AoF/guBI;EACI,iBAAA;ApFkhuBR;;AoFnhuBI;EACI,iBAAA;ApFshuBR;;AoFvhuBI;EACI,iBAAA;ApF0huBR;;AoF3huBI;EACI,iBAAA;ApF8huBR;;AoF/huBI;EACI,iBAAA;ApFkiuBR;;AoFniuBI;EACI,iBAAA;ApFsiuBR;;AoFviuBI;EACI,iBAAA;ApF0iuBR;;AoF3iuBI;EACI,iBAAA;ApF8iuBR;;AoF/iuBI;EACI,iBAAA;ApFkjuBR;;AoFnjuBI;EACI,iBAAA;ApFsjuBR;;AoFvjuBI;EACI,iBAAA;ApF0juBR;;AoF3juBI;EACI,iBAAA;ApF8juBR;;AoF/juBI;EACI,iBAAA;ApFkkuBR;;AoFnkuBI;EACI,iBAAA;ApFskuBR;;AoFvkuBI;EACI,iBAAA;ApF0kuBR;;AoF3kuBI;EACI,iBAAA;ApF8kuBR;;AoF/kuBI;EACI,iBAAA;ApFkluBR;;AoFnluBI;EACI,iBAAA;ApFsluBR;;AoFvluBI;EACI,iBAAA;ApF0luBR;;AoF3luBI;EACI,iBAAA;ApF8luBR;;AoF/luBI;EACI,iBAAA;ApFkmuBR;;AoFnmuBI;EACI,iBAAA;ApFsmuBR;;AoFvmuBI;EACI,iBAAA;ApF0muBR;;AoF3muBI;EACI,iBAAA;ApF8muBR;;AoF/muBI;EACI,iBAAA;ApFknuBR;;AoFnnuBI;EACI,iBAAA;ApFsnuBR;;AoFvnuBI;EACI,iBAAA;ApF0nuBR;;AoF3nuBI;EACI,iBAAA;ApF8nuBR;;AoF/nuBI;EACI,iBAAA;ApFkouBR;;AoFnouBI;EACI,iBAAA;ApFsouBR;;AoFvouBI;EACI,iBAAA;ApF0ouBR;;AoF3ouBI;EACI,iBAAA;ApF8ouBR;;AoF/ouBI;EACI,iBAAA;ApFkpuBR;;AoFnpuBI;EACI,iBAAA;ApFspuBR;;AoFvpuBI;EACI,iBAAA;ApF0puBR;;AoF3puBI;EACI,iBAAA;ApF8puBR;;AoF/puBI;EACI,iBAAA;ApFkquBR;;AoFnquBI;EACI,iBAAA;ApFsquBR;;AoFvquBI;EACI,iBAAA;ApF0quBR;;AoF3quBI;EACI,iBAAA;ApF8quBR;;AoF/quBI;EACI,iBAAA;ApFkruBR;;AoFnruBI;EACI,iBAAA;ApFsruBR;;AoFvruBI;EACI,iBAAA;ApF0ruBR;;AoF3ruBI;EACI,iBAAA;ApF8ruBR;;AoF/ruBI;EACI,iBAAA;ApFksuBR;;AoFnsuBI;EACI,iBAAA;ApFssuBR;;AoFvsuBI;EACI,iBAAA;ApF0suBR;;AoF3suBI;EACI,iBAAA;ApF8suBR;;AoF/suBI;EACI,iBAAA;ApFktuBR;;AoFntuBI;EACI,iBAAA;ApFstuBR;;AoFvtuBI;EACI,iBAAA;ApF0tuBR;;AoF3tuBI;EACI,iBAAA;ApF8tuBR;;AoF/tuBI;EACI,iBAAA;ApFkuuBR;;AoFnuuBI;EACI,iBAAA;ApFsuuBR;;AoFvuuBI;EACI,iBAAA;ApF0uuBR;;AoF3uuBI;EACI,iBAAA;ApF8uuBR;;AoF/uuBI;EACI,iBAAA;ApFkvuBR;;AoFnvuBI;EACI,iBAAA;ApFsvuBR;;AoFvvuBI;EACI,iBAAA;ApF0vuBR;;AoF3vuBI;EACI,iBAAA;ApF8vuBR;;AoF/vuBI;EACI,iBAAA;ApFkwuBR;;AoFnwuBI;EACI,iBAAA;ApFswuBR;;AoFvwuBI;EACI,iBAAA;ApF0wuBR;;AoF3wuBI;EACI,iBAAA;ApF8wuBR;;AoF/wuBI;EACI,iBAAA;ApFkxuBR;;AoFnxuBI;EACI,iBAAA;ApFsxuBR;;AoFvxuBI;EACI,iBAAA;ApF0xuBR;;AoF3xuBI;EACI,iBAAA;ApF8xuBR;;AoF/xuBI;EACI,iBAAA;ApFkyuBR;;AoFnyuBI;EACI,iBAAA;ApFsyuBR;;AoFvyuBI;EACI,iBAAA;ApF0yuBR;;AoF3yuBI;EACI,iBAAA;ApF8yuBR;;AoF/yuBI;EACI,iBAAA;ApFkzuBR;;AoFnzuBI;EACI,iBAAA;ApFszuBR;;AoFvzuBI;EACI,iBAAA;ApF0zuBR;;AoF3zuBI;EACI,iBAAA;ApF8zuBR;;AoF/zuBI;EACI,iBAAA;ApFk0uBR;;AoFn0uBI;EACI,iBAAA;ApFs0uBR;;AoFv0uBI;EACI,iBAAA;ApF00uBR;;AoF30uBI;EACI,iBAAA;ApF80uBR;;AoF/0uBI;EACI,iBAAA;ApFk1uBR;;AoFn1uBI;EACI,iBAAA;ApFs1uBR;;AoFv1uBI;EACI,iBAAA;ApF01uBR;;AoF31uBI;EACI,iBAAA;ApF81uBR;;AoF/1uBI;EACI,iBAAA;ApFk2uBR;;AoFn2uBI;EACI,iBAAA;ApFs2uBR;;AoFv2uBI;EACI,iBAAA;ApF02uBR;;AoF32uBI;EACI,iBAAA;ApF82uBR;;AoF/2uBI;EACI,iBAAA;ApFk3uBR;;AoFn3uBI;EACI,iBAAA;ApFs3uBR;;AoFv3uBI;EACI,iBAAA;ApF03uBR;;AoF33uBI;EACI,iBAAA;ApF83uBR;;AoF/3uBI;EACI,iBAAA;ApFk4uBR;;AoFn4uBI;EACI,iBAAA;ApFs4uBR;;AoFv4uBI;EACI,iBAAA;ApF04uBR;;AoF34uBI;EACI,iBAAA;ApF84uBR;;AoF/4uBI;EACI,iBAAA;ApFk5uBR;;AoFn5uBI;EACI,iBAAA;ApFs5uBR;;AoFv5uBI;EACI,iBAAA;ApF05uBR;;AoF35uBI;EACI,iBAAA;ApF85uBR;;AoF/5uBI;EACI,iBAAA;ApFk6uBR;;AoFn6uBI;EACI,iBAAA;ApFs6uBR;;AoFv6uBI;EACI,iBAAA;ApF06uBR;;AoF36uBI;EACI,iBAAA;ApF86uBR;;AoF/6uBI;EACI,iBAAA;ApFk7uBR;;AoFn7uBI;EACI,iBAAA;ApFs7uBR;;AoFv7uBI;EACI,iBAAA;ApF07uBR;;AoF37uBI;EACI,iBAAA;ApF87uBR;;AoF/7uBI;EACI,iBAAA;ApFk8uBR;;AoFn8uBI;EACI,iBAAA;ApFs8uBR;;AoFv8uBI;EACI,iBAAA;ApF08uBR;;AoF38uBI;EACI,iBAAA;ApF88uBR;;AoF/8uBI;EACI,iBAAA;ApFk9uBR;;AoFn9uBI;EACI,iBAAA;ApFs9uBR;;AoFv9uBI;EACI,iBAAA;ApF09uBR;;AoF39uBI;EACI,iBAAA;ApF89uBR;;AoF/9uBI;EACI,iBAAA;ApFk+uBR;;AoFn+uBI;EACI,iBAAA;ApFs+uBR;;AoFv+uBI;EACI,iBAAA;ApF0+uBR;;AoF3+uBI;EACI,iBAAA;ApF8+uBR;;AoF/+uBI;EACI,iBAAA;ApFk/uBR;;AoFn/uBI;EACI,iBAAA;ApFs/uBR;;AoFv/uBI;EACI,iBAAA;ApF0/uBR;;AoF3/uBI;EACI,iBAAA;ApF8/uBR;;AoF//uBI;EACI,iBAAA;ApFkgvBR;;AoFngvBI;EACI,iBAAA;ApFsgvBR;;AoFvgvBI;EACI,iBAAA;ApF0gvBR;;AoF3gvBI;EACI,iBAAA;ApF8gvBR;;AoF/gvBI;EACI,iBAAA;ApFkhvBR;;AoFnhvBI;EACI,iBAAA;ApFshvBR;;AoFvhvBI;EACI,iBAAA;ApF0hvBR;;AoF3hvBI;EACI,iBAAA;ApF8hvBR;;AoF/hvBI;EACI,iBAAA;ApFkivBR;;AoFnivBI;EACI,iBAAA;ApFsivBR;;AoFvivBI;EACI,iBAAA;ApF0ivBR;;AoF3ivBI;EACI,iBAAA;ApF8ivBR;;AoF/ivBI;EACI,iBAAA;ApFkjvBR;;AoFnjvBI;EACI,iBAAA;ApFsjvBR;;AoFvjvBI;EACI,iBAAA;ApF0jvBR;;AoF3jvBI;EACI,iBAAA;ApF8jvBR;;AoF/jvBI;EACI,iBAAA;ApFkkvBR;;AoFnkvBI;EACI,iBAAA;ApFskvBR;;AoFvkvBI;EACI,iBAAA;ApF0kvBR;;AoF3kvBI;EACI,iBAAA;ApF8kvBR;;AoF/kvBI;EACI,iBAAA;ApFklvBR;;AoFnlvBI;EACI,iBAAA;ApFslvBR;;AoFvlvBI;EACI,iBAAA;ApF0lvBR;;AoF3lvBI;EACI,iBAAA;ApF8lvBR;;AoF/lvBI;EACI,iBAAA;ApFkmvBR;;AoFnmvBI;EACI,iBAAA;ApFsmvBR;;AoFvmvBI;EACI,iBAAA;ApF0mvBR;;AoF3mvBI;EACI,iBAAA;ApF8mvBR;;AoF/mvBI;EACI,iBAAA;ApFknvBR;;AoFnnvBI;EACI,iBAAA;ApFsnvBR;;AoFvnvBI;EACI,iBAAA;ApF0nvBR;;AoF3nvBI;EACI,iBAAA;ApF8nvBR;;AoF/nvBI;EACI,iBAAA;ApFkovBR;;AoFnovBI;EACI,iBAAA;ApFsovBR;;AoFvovBI;EACI,iBAAA;ApF0ovBR;;AoF3ovBI;EACI,iBAAA;ApF8ovBR;;AoF/ovBI;EACI,iBAAA;ApFkpvBR;;AoFnpvBI;EACI,iBAAA;ApFspvBR;;AoFvpvBI;EACI,iBAAA;ApF0pvBR;;AoF3pvBI;EACI,iBAAA;ApF8pvBR;;AoF/pvBI;EACI,iBAAA;ApFkqvBR;;AoFnqvBI;EACI,iBAAA;ApFsqvBR;;AoFvqvBI;EACI,iBAAA;ApF0qvBR;;AoF3qvBI;EACI,iBAAA;ApF8qvBR;;AoF/qvBI;EACI,iBAAA;ApFkrvBR;;AoFnrvBI;EACI,iBAAA;ApFsrvBR;;AoFvrvBI;EACI,iBAAA;ApF0rvBR;;AoF3rvBI;EACI,iBAAA;ApF8rvBR;;AoF/rvBI;EACI,iBAAA;ApFksvBR;;AoFnsvBI;EACI,iBAAA;ApFssvBR;;AoFvsvBI;EACI,iBAAA;ApF0svBR;;AoF3svBI;EACI,iBAAA;ApF8svBR;;AoF/svBI;EACI,iBAAA;ApFktvBR;;AoFntvBI;EACI,iBAAA;ApFstvBR;;AoFvtvBI;EACI,iBAAA;ApF0tvBR;;AoF3tvBI;EACI,iBAAA;ApF8tvBR;;AoF/tvBI;EACI,iBAAA;ApFkuvBR;;AoFnuvBI;EACI,iBAAA;ApFsuvBR;;AoFvuvBI;EACI,iBAAA;ApF0uvBR;;AoF3uvBI;EACI,iBAAA;ApF8uvBR;;AoF/uvBI;EACI,iBAAA;ApFkvvBR;;AoFnvvBI;EACI,iBAAA;ApFsvvBR;;AoFvvvBI;EACI,iBAAA;ApF0vvBR;;AoF3vvBI;EACI,iBAAA;ApF8vvBR;;AoF/vvBI;EACI,iBAAA;ApFkwvBR;;AoFnwvBI;EACI,iBAAA;ApFswvBR;;AoFvwvBI;EACI,iBAAA;ApF0wvBR;;AoF3wvBI;EACI,iBAAA;ApF8wvBR;;AoF/wvBI;EACI,iBAAA;ApFkxvBR;;AoFnxvBI;EACI,iBAAA;ApFsxvBR;;AoFvxvBI;EACI,iBAAA;ApF0xvBR;;AoF3xvBI;EACI,iBAAA;ApF8xvBR;;AoF/xvBI;EACI,iBAAA;ApFkyvBR;;AoFnyvBI;EACI,iBAAA;ApFsyvBR;;AoFvyvBI;EACI,iBAAA;ApF0yvBR;;AoF3yvBI;EACI,iBAAA;ApF8yvBR;;AoF/yvBI;EACI,iBAAA;ApFkzvBR;;AoFnzvBI;EACI,iBAAA;ApFszvBR;;AoFvzvBI;EACI,iBAAA;ApF0zvBR;;AoF3zvBI;EACI,iBAAA;ApF8zvBR;;AoF/zvBI;EACI,iBAAA;ApFk0vBR;;AoFn0vBI;EACI,iBAAA;ApFs0vBR;;AoFv0vBI;EACI,iBAAA;ApF00vBR;;AoF30vBI;EACI,iBAAA;ApF80vBR;;AoF/0vBI;EACI,iBAAA;ApFk1vBR;;AoFn1vBI;EACI,iBAAA;ApFs1vBR;;AoFv1vBI;EACI,iBAAA;ApF01vBR;;AoF31vBI;EACI,iBAAA;ApF81vBR;;AoF/1vBI;EACI,iBAAA;ApFk2vBR;;AoFn2vBI;EACI,iBAAA;ApFs2vBR;;AoFv2vBI;EACI,iBAAA;ApF02vBR;;AoF32vBI;EACI,iBAAA;ApF82vBR;;AoF/2vBI;EACI,iBAAA;ApFk3vBR;;AoFn3vBI;EACI,iBAAA;ApFs3vBR;;AoFv3vBI;EACI,iBAAA;ApF03vBR;;AoF33vBI;EACI,iBAAA;ApF83vBR;;AoF/3vBI;EACI,iBAAA;ApFk4vBR;;AoFn4vBI;EACI,iBAAA;ApFs4vBR;;AoFv4vBI;EACI,iBAAA;ApF04vBR;;AoF34vBI;EACI,iBAAA;ApF84vBR;;AoF/4vBI;EACI,iBAAA;ApFk5vBR;;AoFn5vBI;EACI,iBAAA;ApFs5vBR;;AoFv5vBI;EACI,iBAAA;ApF05vBR;;AoF35vBI;EACI,iBAAA;ApF85vBR;;AoF/5vBI;EACI,iBAAA;ApFk6vBR;;AoFn6vBI;EACI,iBAAA;ApFs6vBR;;AoFv6vBI;EACI,iBAAA;ApF06vBR;;AoF36vBI;EACI,iBAAA;ApF86vBR;;AoF/6vBI;EACI,iBAAA;ApFk7vBR;;AoFn7vBI;EACI,iBAAA;ApFs7vBR;;AoFv7vBI;EACI,iBAAA;ApF07vBR;;AoF37vBI;EACI,iBAAA;ApF87vBR;;AoF/7vBI;EACI,iBAAA;ApFk8vBR;;AoFn8vBI;EACI,iBAAA;ApFs8vBR;;AoFv8vBI;EACI,iBAAA;ApF08vBR;;AoF38vBI;EACI,iBAAA;ApF88vBR;;AoF/8vBI;EACI,iBAAA;ApFk9vBR;;AoFn9vBI;EACI,iBAAA;ApFs9vBR;;AoFv9vBI;EACI,iBAAA;ApF09vBR;;AoF39vBI;EACI,iBAAA;ApF89vBR;;AoF/9vBI;EACI,iBAAA;ApFk+vBR;;AoFn+vBI;EACI,iBAAA;ApFs+vBR;;AoFv+vBI;EACI,iBAAA;ApF0+vBR;;AoF3+vBI;EACI,iBAAA;ApF8+vBR;;AoF/+vBI;EACI,iBAAA;ApFk/vBR;;AoFn/vBI;EACI,iBAAA;ApFs/vBR;;AoFv/vBI;EACI,iBAAA;ApF0/vBR;;AoF3/vBI;EACI,iBAAA;ApF8/vBR;;AoF//vBI;EACI,iBAAA;ApFkgwBR;;AoFngwBI;EACI,iBAAA;ApFsgwBR;;AoFvgwBI;EACI,iBAAA;ApF0gwBR;;AoF3gwBI;EACI,iBAAA;ApF8gwBR;;AoF/gwBI;EACI,iBAAA;ApFkhwBR;;AoFnhwBI;EACI,iBAAA;ApFshwBR;;AoFvhwBI;EACI,iBAAA;ApF0hwBR;;AoF3hwBI;EACI,iBAAA;ApF8hwBR;;AoF/hwBI;EACI,iBAAA;ApFkiwBR;;AoFniwBI;EACI,iBAAA;ApFsiwBR;;AoFviwBI;EACI,iBAAA;ApF0iwBR;;AoF3iwBI;EACI,iBAAA;ApF8iwBR;;AoF/iwBI;EACI,iBAAA;ApFkjwBR;;AoFnjwBI;EACI,iBAAA;ApFsjwBR;;AoFvjwBI;EACI,iBAAA;ApF0jwBR;;AoF3jwBI;EACI,iBAAA;ApF8jwBR;;AoF/jwBI;EACI,iBAAA;ApFkkwBR;;AoFnkwBI;EACI,iBAAA;ApFskwBR;;AoFvkwBI;EACI,iBAAA;ApF0kwBR;;AoF3kwBI;EACI,iBAAA;ApF8kwBR;;AoF/kwBI;EACI,iBAAA;ApFklwBR;;AoFnlwBI;EACI,iBAAA;ApFslwBR;;AoFvlwBI;EACI,iBAAA;ApF0lwBR;;AoF3lwBI;EACI,iBAAA;ApF8lwBR;;AoF/lwBI;EACI,iBAAA;ApFkmwBR;;AoFnmwBI;EACI,iBAAA;ApFsmwBR;;AoFvmwBI;EACI,iBAAA;ApF0mwBR;;AoF3mwBI;EACI,iBAAA;ApF8mwBR;;AoF/mwBI;EACI,iBAAA;ApFknwBR;;AoFnnwBI;EACI,iBAAA;ApFsnwBR;;AoFvnwBI;EACI,iBAAA;ApF0nwBR;;AoF3nwBI;EACI,iBAAA;ApF8nwBR;;AoF/nwBI;EACI,iBAAA;ApFkowBR;;AoFnowBI;EACI,iBAAA;ApFsowBR;;AoFvowBI;EACI,iBAAA;ApF0owBR;;AoF3owBI;EACI,iBAAA;ApF8owBR;;AoF/owBI;EACI,iBAAA;ApFkpwBR;;AoFnpwBI;EACI,iBAAA;ApFspwBR;;AoFvpwBI;EACI,iBAAA;ApF0pwBR;;AoF3pwBI;EACI,iBAAA;ApF8pwBR;;AoF/pwBI;EACI,iBAAA;ApFkqwBR;;AoFnqwBI;EACI,iBAAA;ApFsqwBR;;AoFvqwBI;EACI,iBAAA;ApF0qwBR;;AoF3qwBI;EACI,iBAAA;ApF8qwBR;;AoF/qwBI;EACI,iBAAA;ApFkrwBR;;AoFnrwBI;EACI,iBAAA;ApFsrwBR;;AoFvrwBI;EACI,iBAAA;ApF0rwBR;;AoF3rwBI;EACI,iBAAA;ApF8rwBR;;AoF/rwBI;EACI,iBAAA;ApFkswBR;;AoFnswBI;EACI,iBAAA;ApFsswBR;;AoFvswBI;EACI,iBAAA;ApF0swBR;;AoF3swBI;EACI,iBAAA;ApF8swBR;;AoF/swBI;EACI,iBAAA;ApFktwBR;;AoFntwBI;EACI,iBAAA;ApFstwBR;;AoFvtwBI;EACI,iBAAA;ApF0twBR;;AoF3twBI;EACI,iBAAA;ApF8twBR;;AoF/twBI;EACI,iBAAA;ApFkuwBR;;AoFnuwBI;EACI,iBAAA;ApFsuwBR;;AoFvuwBI;EACI,iBAAA;ApF0uwBR;;AoF3uwBI;EACI,iBAAA;ApF8uwBR;;AoF/uwBI;EACI,iBAAA;ApFkvwBR;;AoFnvwBI;EACI,iBAAA;ApFsvwBR;;AoFvvwBI;EACI,iBAAA;ApF0vwBR;;AoF3vwBI;EACI,iBAAA;ApF8vwBR;;AoF/vwBI;EACI,iBAAA;ApFkwwBR;;AoFnwwBI;EACI,iBAAA;ApFswwBR;;AoFvwwBI;EACI,iBAAA;ApF0wwBR;;AoF3wwBI;EACI,iBAAA;ApF8wwBR;;AoF/wwBI;EACI,iBAAA;ApFkxwBR;;AoFnxwBI;EACI,iBAAA;ApFsxwBR;;AoFvxwBI;EACI,iBAAA;ApF0xwBR;;AoF3xwBI;EACI,iBAAA;ApF8xwBR;;AoF/xwBI;EACI,iBAAA;ApFkywBR;;AoFnywBI;EACI,iBAAA;ApFsywBR;;AoFvywBI;EACI,iBAAA;ApF0ywBR;;AoF3ywBI;EACI,iBAAA;ApF8ywBR;;AoF/ywBI;EACI,iBAAA;ApFkzwBR;;AoFnzwBI;EACI,iBAAA;ApFszwBR;;AoFvzwBI;EACI,iBAAA;ApF0zwBR;;AoF3zwBI;EACI,iBAAA;ApF8zwBR;;AoF/zwBI;EACI,iBAAA;ApFk0wBR;;AoFn0wBI;EACI,iBAAA;ApFs0wBR;;AoFv0wBI;EACI,iBAAA;ApF00wBR;;AoF30wBI;EACI,iBAAA;ApF80wBR;;AoF/0wBI;EACI,iBAAA;ApFk1wBR;;AoFn1wBI;EACI,iBAAA;ApFs1wBR;;AoFv1wBI;EACI,iBAAA;ApF01wBR;;AoF31wBI;EACI,iBAAA;ApF81wBR;;AoF/1wBI;EACI,iBAAA;ApFk2wBR;;AoFn2wBI;EACI,iBAAA;ApFs2wBR;;AoFv2wBI;EACI,iBAAA;ApF02wBR;;AoF32wBI;EACI,iBAAA;ApF82wBR;;AoF/2wBI;EACI,iBAAA;ApFk3wBR;;AoFn3wBI;EACI,iBAAA;ApFs3wBR;;AoFv3wBI;EACI,iBAAA;ApF03wBR;;AoF33wBI;EACI,iBAAA;ApF83wBR;;AoF/3wBI;EACI,iBAAA;ApFk4wBR;;AoFn4wBI;EACI,iBAAA;ApFs4wBR;;AoFv4wBI;EACI,iBAAA;ApF04wBR;;AoF34wBI;EACI,iBAAA;ApF84wBR;;AoF/4wBI;EACI,iBAAA;ApFk5wBR;;AoFn5wBI;EACI,iBAAA;ApFs5wBR;;AoFv5wBI;EACI,iBAAA;ApF05wBR;;AoF35wBI;EACI,iBAAA;ApF85wBR;;AoF/5wBI;EACI,iBAAA;ApFk6wBR;;AoFn6wBI;EACI,iBAAA;ApFs6wBR;;AoFv6wBI;EACI,iBAAA;ApF06wBR;;AoF36wBI;EACI,iBAAA;ApF86wBR;;AoF/6wBI;EACI,iBAAA;ApFk7wBR;;AoFn7wBI;EACI,iBAAA;ApFs7wBR;;AoFv7wBI;EACI,iBAAA;ApF07wBR;;AoF37wBI;EACI,iBAAA;ApF87wBR;;AoF/7wBI;EACI,iBAAA;ApFk8wBR;;AoFn8wBI;EACI,iBAAA;ApFs8wBR;;AoFv8wBI;EACI,iBAAA;ApF08wBR;;AoF38wBI;EACI,iBAAA;ApF88wBR;;AoF/8wBI;EACI,iBAAA;ApFk9wBR;;AoFn9wBI;EACI,iBAAA;ApFs9wBR;;AoFv9wBI;EACI,iBAAA;ApF09wBR;;AoF39wBI;EACI,iBAAA;ApF89wBR;;AoF/9wBI;EACI,iBAAA;ApFk+wBR;;AoFn+wBI;EACI,iBAAA;ApFs+wBR;;AoFv+wBI;EACI,iBAAA;ApF0+wBR;;AoF3+wBI;EACI,iBAAA;ApF8+wBR;;AoF/+wBI;EACI,iBAAA;ApFk/wBR;;AoFn/wBI;EACI,iBAAA;ApFs/wBR;;AoFv/wBI;EACI,iBAAA;ApF0/wBR;;AoF3/wBI;EACI,iBAAA;ApF8/wBR;;AoF//wBI;EACI,iBAAA;ApFkgxBR;;AoFngxBI;EACI,iBAAA;ApFsgxBR;;AoFvgxBI;EACI,iBAAA;ApF0gxBR;;AoF3gxBI;EACI,iBAAA;ApF8gxBR;;AoF/gxBI;EACI,iBAAA;ApFkhxBR;;AoFnhxBI;EACI,iBAAA;ApFshxBR;;AoFvhxBI;EACI,iBAAA;ApF0hxBR;;AoF3hxBI;EACI,iBAAA;ApF8hxBR;;AoF/hxBI;EACI,iBAAA;ApFkixBR;;AoFnixBI;EACI,iBAAA;ApFsixBR;;AoFvixBI;EACI,iBAAA;ApF0ixBR;;AoF3ixBI;EACI,iBAAA;ApF8ixBR;;AoF/ixBI;EACI,iBAAA;ApFkjxBR;;AoFnjxBI;EACI,iBAAA;ApFsjxBR;;AoFvjxBI;EACI,iBAAA;ApF0jxBR;;AoF3jxBI;EACI,iBAAA;ApF8jxBR;;AoF/jxBI;EACI,iBAAA;ApFkkxBR;;AoFnkxBI;EACI,iBAAA;ApFskxBR;;AoFvkxBI;EACI,iBAAA;ApF0kxBR;;AoF3kxBI;EACI,iBAAA;ApF8kxBR;;AoF/kxBI;EACI,iBAAA;ApFklxBR;;AoFnlxBI;EACI,iBAAA;ApFslxBR;;AoFvlxBI;EACI,iBAAA;ApF0lxBR;;AoF3lxBI;EACI,iBAAA;ApF8lxBR;;AoF/lxBI;EACI,iBAAA;ApFkmxBR;;AoFnmxBI;EACI,iBAAA;ApFsmxBR;;AoFvmxBI;EACI,iBAAA;ApF0mxBR;;AoF3mxBI;EACI,iBAAA;ApF8mxBR;;AoF/mxBI;EACI,iBAAA;ApFknxBR;;AoFnnxBI;EACI,iBAAA;ApFsnxBR;;AoFvnxBI;EACI,iBAAA;ApF0nxBR;;AoF3nxBI;EACI,iBAAA;ApF8nxBR;;AoF/nxBI;EACI,iBAAA;ApFkoxBR;;AoFnoxBI;EACI,iBAAA;ApFsoxBR;;AoFvoxBI;EACI,iBAAA;ApF0oxBR;;AoF3oxBI;EACI,iBAAA;ApF8oxBR;;AoF/oxBI;EACI,iBAAA;ApFkpxBR;;AoFnpxBI;EACI,iBAAA;ApFspxBR;;AoFvpxBI;EACI,iBAAA;ApF0pxBR;;AoF3pxBI;EACI,iBAAA;ApF8pxBR;;AoF/pxBI;EACI,iBAAA;ApFkqxBR;;AoFnqxBI;EACI,iBAAA;ApFsqxBR;;AoFvqxBI;EACI,iBAAA;ApF0qxBR;;AoF3qxBI;EACI,iBAAA;ApF8qxBR;;AoF/qxBI;EACI,iBAAA;ApFkrxBR;;AoFnrxBI;EACI,iBAAA;ApFsrxBR;;AoFvrxBI;EACI,iBAAA;ApF0rxBR;;AoF3rxBI;EACI,iBAAA;ApF8rxBR;;AoF/rxBI;EACI,iBAAA;ApFksxBR;;AoFnsxBI;EACI,iBAAA;ApFssxBR;;AoFvsxBI;EACI,iBAAA;ApF0sxBR;;AoF3sxBI;EACI,iBAAA;ApF8sxBR;;AoF/sxBI;EACI,iBAAA;ApFktxBR;;AoFntxBI;EACI,iBAAA;ApFstxBR;;AoFvtxBI;EACI,iBAAA;ApF0txBR;;AoF3txBI;EACI,iBAAA;ApF8txBR;;AoF/txBI;EACI,iBAAA;ApFkuxBR;;AoFnuxBI;EACI,iBAAA;ApFsuxBR;;AoFvuxBI;EACI,iBAAA;ApF0uxBR;;AoF3uxBI;EACI,iBAAA;ApF8uxBR;;AoF/uxBI;EACI,iBAAA;ApFkvxBR;;AoFnvxBI;EACI,iBAAA;ApFsvxBR;;AoFvvxBI;EACI,iBAAA;ApF0vxBR;;AoF3vxBI;EACI,iBAAA;ApF8vxBR;;AoF/vxBI;EACI,iBAAA;ApFkwxBR;;AoFnwxBI;EACI,iBAAA;ApFswxBR;;AoFvwxBI;EACI,iBAAA;ApF0wxBR;;AoF3wxBI;EACI,iBAAA;ApF8wxBR;;AoF/wxBI;EACI,iBAAA;ApFkxxBR;;AoFnxxBI;EACI,iBAAA;ApFsxxBR;;AoFvxxBI;EACI,iBAAA;ApF0xxBR;;AoF3xxBI;EACI,iBAAA;ApF8xxBR;;AoF/xxBI;EACI,iBAAA;ApFkyxBR;;AoFnyxBI;EACI,iBAAA;ApFsyxBR;;AoFvyxBI;EACI,iBAAA;ApF0yxBR;;AoF3yxBI;EACI,iBAAA;ApF8yxBR;;AoF/yxBI;EACI,iBAAA;ApFkzxBR;;AoFnzxBI;EACI,iBAAA;ApFszxBR;;AoFvzxBI;EACI,iBAAA;ApF0zxBR;;AoF3zxBI;EACI,iBAAA;ApF8zxBR;;AoF/zxBI;EACI,iBAAA;ApFk0xBR;;AoFn0xBI;EACI,iBAAA;ApFs0xBR;;AoFv0xBI;EACI,iBAAA;ApF00xBR;;AoF30xBI;EACI,iBAAA;ApF80xBR;;AoF/0xBI;EACI,iBAAA;ApFk1xBR;;AoFn1xBI;EACI,iBAAA;ApFs1xBR;;AoFv1xBI;EACI,iBAAA;ApF01xBR;;AoF31xBI;EACI,iBAAA;ApF81xBR;;AoF/1xBI;EACI,iBAAA;ApFk2xBR;;AoFn2xBI;EACI,iBAAA;ApFs2xBR;;AoFv2xBI;EACI,iBAAA;ApF02xBR;;AoF32xBI;EACI,iBAAA;ApF82xBR;;AoF/2xBI;EACI,iBAAA;ApFk3xBR;;AoFn3xBI;EACI,iBAAA;ApFs3xBR;;AoFv3xBI;EACI,iBAAA;ApF03xBR;;AoF33xBI;EACI,iBAAA;ApF83xBR;;AoF/3xBI;EACI,iBAAA;ApFk4xBR;;AoFn4xBI;EACI,iBAAA;ApFs4xBR;;AoFv4xBI;EACI,iBAAA;ApF04xBR;;AoF34xBI;EACI,iBAAA;ApF84xBR;;AoF/4xBI;EACI,iBAAA;ApFk5xBR;;AoFn5xBI;EACI,iBAAA;ApFs5xBR;;AoFv5xBI;EACI,iBAAA;ApF05xBR;;AoF35xBI;EACI,iBAAA;ApF85xBR;;AoF/5xBI;EACI,iBAAA;ApFk6xBR;;AoFn6xBI;EACI,iBAAA;ApFs6xBR;;AoFv6xBI;EACI,iBAAA;ApF06xBR;;AoF36xBI;EACI,iBAAA;ApF86xBR;;AoF/6xBI;EACI,iBAAA;ApFk7xBR;;AoFn7xBI;EACI,iBAAA;ApFs7xBR;;AoFv7xBI;EACI,iBAAA;ApF07xBR;;AoF37xBI;EACI,iBAAA;ApF87xBR;;AoF/7xBI;EACI,iBAAA;ApFk8xBR;;AoFn8xBI;EACI,iBAAA;ApFs8xBR;;AoFv8xBI;EACI,iBAAA;ApF08xBR;;AoF38xBI;EACI,iBAAA;ApF88xBR;;AoF/8xBI;EACI,iBAAA;ApFk9xBR;;AoFn9xBI;EACI,iBAAA;ApFs9xBR;;AoFv9xBI;EACI,iBAAA;ApF09xBR;;AoF39xBI;EACI,iBAAA;ApF89xBR;;AoF/9xBI;EACI,iBAAA;ApFk+xBR;;AoFn+xBI;EACI,iBAAA;ApFs+xBR;;AoFv+xBI;EACI,iBAAA;ApF0+xBR;;AoF3+xBI;EACI,iBAAA;ApF8+xBR;;AoF/+xBI;EACI,iBAAA;ApFk/xBR;;AoFn/xBI;EACI,iBAAA;ApFs/xBR;;AoFv/xBI;EACI,iBAAA;ApF0/xBR;;AoF3/xBI;EACI,iBAAA;ApF8/xBR;;AoF//xBI;EACI,iBAAA;ApFkgyBR;;AoFngyBI;EACI,iBAAA;ApFsgyBR;;AoFvgyBI;EACI,iBAAA;ApF0gyBR;;AoF3gyBI;EACI,iBAAA;ApF8gyBR;;AoF/gyBI;EACI,iBAAA;ApFkhyBR;;AoFnhyBI;EACI,iBAAA;ApFshyBR;;AoFvhyBI;EACI,iBAAA;ApF0hyBR;;AoF3hyBI;EACI,iBAAA;ApF8hyBR;;AoF/hyBI;EACI,iBAAA;ApFkiyBR;;AoFniyBI;EACI,iBAAA;ApFsiyBR;;AoFviyBI;EACI,iBAAA;ApF0iyBR;;AoF3iyBI;EACI,iBAAA;ApF8iyBR;;AoF/iyBI;EACI,iBAAA;ApFkjyBR;;AoFnjyBI;EACI,iBAAA;ApFsjyBR;;AoFvjyBI;EACI,iBAAA;ApF0jyBR;;AoF3jyBI;EACI,iBAAA;ApF8jyBR;;AoF/jyBI;EACI,iBAAA;ApFkkyBR;;AoFnkyBI;EACI,iBAAA;ApFskyBR;;AoFvkyBI;EACI,iBAAA;ApF0kyBR;;AoF3kyBI;EACI,iBAAA;ApF8kyBR;;AoF/kyBI;EACI,iBAAA;ApFklyBR;;AoFnlyBI;EACI,iBAAA;ApFslyBR;;AoFvlyBI;EACI,iBAAA;ApF0lyBR;;AoF3lyBI;EACI,iBAAA;ApF8lyBR;;AoF/lyBI;EACI,iBAAA;ApFkmyBR;;AoFnmyBI;EACI,iBAAA;ApFsmyBR;;AoFvmyBI;EACI,iBAAA;ApF0myBR;;AoF3myBI;EACI,iBAAA;ApF8myBR;;AoF/myBI;EACI,iBAAA;ApFknyBR;;AoFnnyBI;EACI,iBAAA;ApFsnyBR;;AoFvnyBI;EACI,iBAAA;ApF0nyBR;;AoF3nyBI;EACI,iBAAA;ApF8nyBR;;AoF/nyBI;EACI,iBAAA;ApFkoyBR;;AoFnoyBI;EACI,iBAAA;ApFsoyBR;;AoFvoyBI;EACI,iBAAA;ApF0oyBR;;AoF3oyBI;EACI,iBAAA;ApF8oyBR;;AoF/oyBI;EACI,iBAAA;ApFkpyBR;;AoFnpyBI;EACI,iBAAA;ApFspyBR;;AoFvpyBI;EACI,iBAAA;ApF0pyBR;;AoF3pyBI;EACI,iBAAA;ApF8pyBR;;AoF/pyBI;EACI,iBAAA;ApFkqyBR;;AoFnqyBI;EACI,iBAAA;ApFsqyBR;;AoFvqyBI;EACI,iBAAA;ApF0qyBR;;AoF3qyBI;EACI,iBAAA;ApF8qyBR;;AoF/qyBI;EACI,iBAAA;ApFkryBR;;AoFnryBI;EACI,iBAAA;ApFsryBR;;AoFvryBI;EACI,iBAAA;ApF0ryBR;;AoF3ryBI;EACI,iBAAA;ApF8ryBR;;AoF/ryBI;EACI,iBAAA;ApFksyBR;;AoFnsyBI;EACI,iBAAA;ApFssyBR;;AoFvsyBI;EACI,iBAAA;ApF0syBR;;AoF3syBI;EACI,iBAAA;ApF8syBR;;AoF/syBI;EACI,iBAAA;ApFktyBR;;AoFntyBI;EACI,iBAAA;ApFstyBR;;AoFvtyBI;EACI,iBAAA;ApF0tyBR;;AoF3tyBI;EACI,iBAAA;ApF8tyBR;;AoF/tyBI;EACI,iBAAA;ApFkuyBR;;AoFnuyBI;EACI,iBAAA;ApFsuyBR;;AoFvuyBI;EACI,iBAAA;ApF0uyBR;;AoF3uyBI;EACI,iBAAA;ApF8uyBR;;AoF/uyBI;EACI,iBAAA;ApFkvyBR;;AoFnvyBI;EACI,iBAAA;ApFsvyBR;;AoFvvyBI;EACI,iBAAA;ApF0vyBR;;AoF3vyBI;EACI,iBAAA;ApF8vyBR;;AoF/vyBI;EACI,iBAAA;ApFkwyBR;;AoFnwyBI;EACI,iBAAA;ApFswyBR;;AoFvwyBI;EACI,iBAAA;ApF0wyBR;;AoF3wyBI;EACI,iBAAA;ApF8wyBR;;AoF/wyBI;EACI,iBAAA;ApFkxyBR;;AoFnxyBI;EACI,iBAAA;ApFsxyBR;;AoFvxyBI;EACI,iBAAA;ApF0xyBR;;AoF3xyBI;EACI,iBAAA;ApF8xyBR;;AoF/xyBI;EACI,iBAAA;ApFkyyBR;;AoFnyyBI;EACI,iBAAA;ApFsyyBR;;AoFvyyBI;EACI,iBAAA;ApF0yyBR;;AoF3yyBI;EACI,iBAAA;ApF8yyBR;;AoF/yyBI;EACI,iBAAA;ApFkzyBR;;AoFnzyBI;EACI,iBAAA;ApFszyBR;;AoFvzyBI;EACI,iBAAA;ApF0zyBR;;AoF3zyBI;EACI,iBAAA;ApF8zyBR;;AoF/zyBI;EACI,iBAAA;ApFk0yBR;;AoFn0yBI;EACI,iBAAA;ApFs0yBR;;AoFv0yBI;EACI,iBAAA;ApF00yBR;;AoF30yBI;EACI,iBAAA;ApF80yBR;;AoF/0yBI;EACI,iBAAA;ApFk1yBR;;AoFn1yBI;EACI,iBAAA;ApFs1yBR;;AoFv1yBI;EACI,iBAAA;ApF01yBR;;AoF31yBI;EACI,iBAAA;ApF81yBR;;AoF/1yBI;EACI,iBAAA;ApFk2yBR;;AoFn2yBI;EACI,iBAAA;ApFs2yBR;;AoFv2yBI;EACI,iBAAA;ApF02yBR;;AoF32yBI;EACI,iBAAA;ApF82yBR;;AoF/2yBI;EACI,iBAAA;ApFk3yBR;;AoFn3yBI;EACI,iBAAA;ApFs3yBR;;AoFv3yBI;EACI,iBAAA;ApF03yBR;;AoF33yBI;EACI,iBAAA;ApF83yBR;;AoF/3yBI;EACI,iBAAA;ApFk4yBR;;AoFn4yBI;EACI,iBAAA;ApFs4yBR;;AoFv4yBI;EACI,iBAAA;ApF04yBR;;AoF34yBI;EACI,iBAAA;ApF84yBR;;AoF/4yBI;EACI,iBAAA;ApFk5yBR;;AoFn5yBI;EACI,iBAAA;ApFs5yBR;;AoFv5yBI;EACI,iBAAA;ApF05yBR;;AoF35yBI;EACI,iBAAA;ApF85yBR;;AoF/5yBI;EACI,iBAAA;ApFk6yBR;;AoFn6yBI;EACI,iBAAA;ApFs6yBR;;AoFv6yBI;EACI,iBAAA;ApF06yBR;;AoF36yBI;EACI,iBAAA;ApF86yBR;;AoF/6yBI;EACI,iBAAA;ApFk7yBR;;AoFn7yBI;EACI,iBAAA;ApFs7yBR;;AoFv7yBI;EACI,iBAAA;ApF07yBR;;AoF37yBI;EACI,iBAAA;ApF87yBR;;AoF/7yBI;EACI,iBAAA;ApFk8yBR;;AoFn8yBI;EACI,iBAAA;ApFs8yBR;;AoFv8yBI;EACI,iBAAA;ApF08yBR;;AoF38yBI;EACI,iBAAA;ApF88yBR;;AoF/8yBI;EACI,iBAAA;ApFk9yBR;;AoFn9yBI;EACI,iBAAA;ApFs9yBR;;AoFv9yBI;EACI,iBAAA;ApF09yBR;;AoF39yBI;EACI,iBAAA;ApF89yBR;;AoF/9yBI;EACI,iBAAA;ApFk+yBR;;AoFn+yBI;EACI,iBAAA;ApFs+yBR;;AoFv+yBI;EACI,iBAAA;ApF0+yBR;;AoF3+yBI;EACI,iBAAA;ApF8+yBR;;AoF/+yBI;EACI,iBAAA;ApFk/yBR;;AoFn/yBI;EACI,iBAAA;ApFs/yBR;;AoFv/yBI;EACI,iBAAA;ApF0/yBR;;AoF3/yBI;EACI,iBAAA;ApF8/yBR;;AoF//yBI;EACI,iBAAA;ApFkgzBR;;AoFngzBI;EACI,iBAAA;ApFsgzBR;;AoFvgzBI;EACI,iBAAA;ApF0gzBR;;AoF3gzBI;EACI,iBAAA;ApF8gzBR;;AoF/gzBI;EACI,iBAAA;ApFkhzBR;;AoFnhzBI;EACI,iBAAA;ApFshzBR;;AoFvhzBI;EACI,iBAAA;ApF0hzBR;;AoF3hzBI;EACI,iBAAA;ApF8hzBR;;AoF/hzBI;EACI,iBAAA;ApFkizBR;;AoFnizBI;EACI,iBAAA;ApFsizBR;;AoFvizBI;EACI,iBAAA;ApF0izBR;;AoF3izBI;EACI,iBAAA;ApF8izBR;;AoF/izBI;EACI,iBAAA;ApFkjzBR;;AoFnjzBI;EACI,iBAAA;ApFsjzBR;;AoFvjzBI;EACI,iBAAA;ApF0jzBR;;AoF3jzBI;EACI,iBAAA;ApF8jzBR;;AoF/jzBI;EACI,iBAAA;ApFkkzBR;;AoFnkzBI;EACI,iBAAA;ApFskzBR;;AoFvkzBI;EACI,iBAAA;ApF0kzBR;;AoF3kzBI;EACI,iBAAA;ApF8kzBR;;AoF/kzBI;EACI,iBAAA;ApFklzBR;;AoFnlzBI;EACI,iBAAA;ApFslzBR;;AoFvlzBI;EACI,iBAAA;ApF0lzBR;;AoF3lzBI;EACI,iBAAA;ApF8lzBR;;AoF/lzBI;EACI,iBAAA;ApFkmzBR;;AoFnmzBI;EACI,iBAAA;ApFsmzBR;;AoFvmzBI;EACI,iBAAA;ApF0mzBR;;AoF3mzBI;EACI,iBAAA;ApF8mzBR;;AoF/mzBI;EACI,iBAAA;ApFknzBR;;AoFnnzBI;EACI,iBAAA;ApFsnzBR;;AoFvnzBI;EACI,iBAAA;ApF0nzBR;;AoF3nzBI;EACI,iBAAA;ApF8nzBR;;AoF/nzBI;EACI,iBAAA;ApFkozBR;;AoFnozBI;EACI,iBAAA;ApFsozBR;;AoFvozBI;EACI,iBAAA;ApF0ozBR;;AoF3ozBI;EACI,iBAAA;ApF8ozBR;;AoF/ozBI;EACI,iBAAA;ApFkpzBR;;AoFnpzBI;EACI,iBAAA;ApFspzBR;;AoFvpzBI;EACI,iBAAA;ApF0pzBR;;AoF3pzBI;EACI,iBAAA;ApF8pzBR;;AoF/pzBI;EACI,iBAAA;ApFkqzBR;;AoFnqzBI;EACI,iBAAA;ApFsqzBR;;AoFvqzBI;EACI,iBAAA;ApF0qzBR;;AoF3qzBI;EACI,iBAAA;ApF8qzBR;;AoF/qzBI;EACI,iBAAA;ApFkrzBR;;AoFnrzBI;EACI,iBAAA;ApFsrzBR;;AoFvrzBI;EACI,iBAAA;ApF0rzBR;;AoF3rzBI;EACI,iBAAA;ApF8rzBR;;AoF/rzBI;EACI,iBAAA;ApFkszBR;;AoFnszBI;EACI,iBAAA;ApFsszBR;;AoFvszBI;EACI,iBAAA;ApF0szBR;;AoF3szBI;EACI,iBAAA;ApF8szBR;;AoF/szBI;EACI,iBAAA;ApFktzBR;;AoFntzBI;EACI,iBAAA;ApFstzBR;;AoFvtzBI;EACI,iBAAA;ApF0tzBR;;AoF3tzBI;EACI,iBAAA;ApF8tzBR;;AoF/tzBI;EACI,iBAAA;ApFkuzBR;;AoFnuzBI;EACI,iBAAA;ApFsuzBR;;AoFvuzBI;EACI,iBAAA;ApF0uzBR;;AoF3uzBI;EACI,iBAAA;ApF8uzBR;;AoF/uzBI;EACI,iBAAA;ApFkvzBR;;AoFnvzBI;EACI,iBAAA;ApFsvzBR;;AoFvvzBI;EACI,iBAAA;ApF0vzBR;;AoF3vzBI;EACI,iBAAA;ApF8vzBR;;AoF/vzBI;EACI,iBAAA;ApFkwzBR;;AoFnwzBI;EACI,iBAAA;ApFswzBR;;AoFvwzBI;EACI,iBAAA;ApF0wzBR;;AoF3wzBI;EACI,iBAAA;ApF8wzBR;;AoF/wzBI;EACI,iBAAA;ApFkxzBR;;AoFnxzBI;EACI,iBAAA;ApFsxzBR;;AoFvxzBI;EACI,iBAAA;ApF0xzBR;;AoF3xzBI;EACI,iBAAA;ApF8xzBR;;AoF/xzBI;EACI,iBAAA;ApFkyzBR;;AoFnyzBI;EACI,iBAAA;ApFsyzBR;;AoFvyzBI;EACI,iBAAA;ApF0yzBR;;AoF3yzBI;EACI,iBAAA;ApF8yzBR;;AoF/yzBI;EACI,iBAAA;ApFkzzBR;;AoFnzzBI;EACI,iBAAA;ApFszzBR;;AoFvzzBI;EACI,iBAAA;ApF0zzBR;;AoF3zzBI;EACI,iBAAA;ApF8zzBR;;AoF/zzBI;EACI,iBAAA;ApFk0zBR;;AoFn0zBI;EACI,iBAAA;ApFs0zBR;;AoFv0zBI;EACI,iBAAA;ApF00zBR;;AoF30zBI;EACI,iBAAA;ApF80zBR;;AoF/0zBI;EACI,iBAAA;ApFk1zBR;;AoFn1zBI;EACI,iBAAA;ApFs1zBR;;AoFv1zBI;EACI,iBAAA;ApF01zBR;;AoF31zBI;EACI,iBAAA;ApF81zBR;;AoF/1zBI;EACI,iBAAA;ApFk2zBR;;AoFn2zBI;EACI,iBAAA;ApFs2zBR;;AoFv2zBI;EACI,iBAAA;ApF02zBR;;AoF32zBI;EACI,iBAAA;ApF82zBR;;AoF/2zBI;EACI,iBAAA;ApFk3zBR;;AoFn3zBI;EACI,iBAAA;ApFs3zBR;;AoFv3zBI;EACI,iBAAA;ApF03zBR;;AoF33zBI;EACI,iBAAA;ApF83zBR;;AoF/3zBI;EACI,iBAAA;ApFk4zBR;;AoFn4zBI;EACI,iBAAA;ApFs4zBR;;AoFv4zBI;EACI,iBAAA;ApF04zBR;;AoF34zBI;EACI,iBAAA;ApF84zBR;;AoF/4zBI;EACI,iBAAA;ApFk5zBR;;AoFn5zBI;EACI,iBAAA;ApFs5zBR;;AoFv5zBI;EACI,iBAAA;ApF05zBR;;AoF35zBI;EACI,iBAAA;ApF85zBR;;AoF/5zBI;EACI,iBAAA;ApFk6zBR;;AoFn6zBI;EACI,iBAAA;ApFs6zBR;;AoFv6zBI;EACI,iBAAA;ApF06zBR;;AoF36zBI;EACI,iBAAA;ApF86zBR;;AoF/6zBI;EACI,iBAAA;ApFk7zBR;;AoFn7zBI;EACI,iBAAA;ApFs7zBR;;AoFv7zBI;EACI,iBAAA;ApF07zBR;;AoF37zBI;EACI,iBAAA;ApF87zBR;;AoF/7zBI;EACI,iBAAA;ApFk8zBR;;AoFn8zBI;EACI,iBAAA;ApFs8zBR;;AoFv8zBI;EACI,iBAAA;ApF08zBR;;AoF38zBI;EACI,iBAAA;ApF88zBR;;AoF/8zBI;EACI,iBAAA;ApFk9zBR;;AoFn9zBI;EACI,iBAAA;ApFs9zBR;;AoFv9zBI;EACI,iBAAA;ApF09zBR;;AoF39zBI;EACI,iBAAA;ApF89zBR;;AoF/9zBI;EACI,iBAAA;ApFk+zBR;;AoFn+zBI;EACI,iBAAA;ApFs+zBR;;AoFv+zBI;EACI,iBAAA;ApF0+zBR;;AoF3+zBI;EACI,iBAAA;ApF8+zBR;;AoF/+zBI;EACI,iBAAA;ApFk/zBR;;AoFn/zBI;EACI,iBAAA;ApFs/zBR;;AoFv/zBI;EACI,iBAAA;ApF0/zBR;;AoF3/zBI;EACI,iBAAA;ApF8/zBR;;AoF//zBI;EACI,iBAAA;ApFkg0BR;;AoFng0BI;EACI,iBAAA;ApFsg0BR;;AoFvg0BI;EACI,iBAAA;ApF0g0BR;;AoF3g0BI;EACI,iBAAA;ApF8g0BR;;AoF/g0BI;EACI,iBAAA;ApFkh0BR;;AoFnh0BI;EACI,iBAAA;ApFsh0BR;;AoFvh0BI;EACI,iBAAA;ApF0h0BR;;AoF3h0BI;EACI,iBAAA;ApF8h0BR;;AoF/h0BI;EACI,iBAAA;ApFki0BR;;AoFni0BI;EACI,iBAAA;ApFsi0BR;;AoFvi0BI;EACI,iBAAA;ApF0i0BR;;AoF3i0BI;EACI,iBAAA;ApF8i0BR;;AoF/i0BI;EACI,iBAAA;ApFkj0BR;;AoFnj0BI;EACI,iBAAA;ApFsj0BR;;AoFvj0BI;EACI,iBAAA;ApF0j0BR;;AoF3j0BI;EACI,iBAAA;ApF8j0BR;;AoF/j0BI;EACI,iBAAA;ApFkk0BR;;AoFnk0BI;EACI,iBAAA;ApFsk0BR;;AoFvk0BI;EACI,iBAAA;ApF0k0BR;;AoF3k0BI;EACI,iBAAA;ApF8k0BR;;AoF/k0BI;EACI,iBAAA;ApFkl0BR;;AoFnl0BI;EACI,iBAAA;ApFsl0BR;;AoFvl0BI;EACI,iBAAA;ApF0l0BR;;AoF3l0BI;EACI,iBAAA;ApF8l0BR;;AoF/l0BI;EACI,iBAAA;ApFkm0BR;;AoFnm0BI;EACI,iBAAA;ApFsm0BR;;AoFvm0BI;EACI,iBAAA;ApF0m0BR;;AoF3m0BI;EACI,iBAAA;ApF8m0BR;;AoF/m0BI;EACI,iBAAA;ApFkn0BR;;AoFnn0BI;EACI,iBAAA;ApFsn0BR;;AoFvn0BI;EACI,iBAAA;ApF0n0BR;;AoF3n0BI;EACI,iBAAA;ApF8n0BR;;AoF/n0BI;EACI,iBAAA;ApFko0BR;;AoFno0BI;EACI,iBAAA;ApFso0BR;;AoFvo0BI;EACI,iBAAA;ApF0o0BR;;AoF3o0BI;EACI,iBAAA;ApF8o0BR;;AoF/o0BI;EACI,iBAAA;ApFkp0BR;;AoFnp0BI;EACI,iBAAA;ApFsp0BR;;AoFvp0BI;EACI,iBAAA;ApF0p0BR;;AoF3p0BI;EACI,iBAAA;ApF8p0BR;;AoF/p0BI;EACI,iBAAA;ApFkq0BR;;AoFnq0BI;EACI,iBAAA;ApFsq0BR;;AoFvq0BI;EACI,iBAAA;ApF0q0BR;;AoF3q0BI;EACI,iBAAA;ApF8q0BR;;AoF/q0BI;EACI,iBAAA;ApFkr0BR;;AoFnr0BI;EACI,iBAAA;ApFsr0BR;;AoFvr0BI;EACI,iBAAA;ApF0r0BR;;AoF3r0BI;EACI,iBAAA;ApF8r0BR;;AoF/r0BI;EACI,iBAAA;ApFks0BR;;AoFns0BI;EACI,iBAAA;ApFss0BR;;AoFvs0BI;EACI,iBAAA;ApF0s0BR;;AoF3s0BI;EACI,iBAAA;ApF8s0BR;;AoF/s0BI;EACI,iBAAA;ApFkt0BR;;AoFnt0BI;EACI,iBAAA;ApFst0BR;;AoFvt0BI;EACI,iBAAA;ApF0t0BR;;AoF3t0BI;EACI,iBAAA;ApF8t0BR;;AoF/t0BI;EACI,iBAAA;ApFku0BR;;AoFnu0BI;EACI,iBAAA;ApFsu0BR;;AoFvu0BI;EACI,iBAAA;ApF0u0BR;;AoF3u0BI;EACI,iBAAA;ApF8u0BR;;AoF/u0BI;EACI,iBAAA;ApFkv0BR;;AoFnv0BI;EACI,iBAAA;ApFsv0BR;;AoFvv0BI;EACI,iBAAA;ApF0v0BR;;AoF3v0BI;EACI,iBAAA;ApF8v0BR;;AoF/v0BI;EACI,iBAAA;ApFkw0BR;;AoFnw0BI;EACI,iBAAA;ApFsw0BR;;AoFvw0BI;EACI,iBAAA;ApF0w0BR;;AoF3w0BI;EACI,iBAAA;ApF8w0BR;;AoF/w0BI;EACI,iBAAA;ApFkx0BR;;AoFnx0BI;EACI,iBAAA;ApFsx0BR;;AoFvx0BI;EACI,iBAAA;ApF0x0BR;;AoF3x0BI;EACI,iBAAA;ApF8x0BR;;AoF/x0BI;EACI,iBAAA;ApFky0BR;;AoFny0BI;EACI,iBAAA;ApFsy0BR;;AoFvy0BI;EACI,iBAAA;ApF0y0BR;;AoF3y0BI;EACI,iBAAA;ApF8y0BR;;AoF/y0BI;EACI,iBAAA;ApFkz0BR;;AoFnz0BI;EACI,iBAAA;ApFsz0BR;;AoFvz0BI;EACI,iBAAA;ApF0z0BR;;AoF3z0BI;EACI,iBAAA;ApF8z0BR;;AoF/z0BI;EACI,iBAAA;ApFk00BR;;AoFn00BI;EACI,iBAAA;ApFs00BR;;AoFv00BI;EACI,iBAAA;ApF000BR;;AoF300BI;EACI,iBAAA;ApF800BR;;AoF/00BI;EACI,iBAAA;ApFk10BR;;AoFn10BI;EACI,iBAAA;ApFs10BR;;AoFv10BI;EACI,iBAAA;ApF010BR;;AoF310BI;EACI,iBAAA;ApF810BR;;AoF/10BI;EACI,iBAAA;ApFk20BR;;AoFn20BI;EACI,iBAAA;ApFs20BR;;AoFv20BI;EACI,iBAAA;ApF020BR;;AoF320BI;EACI,iBAAA;ApF820BR;;AoF/20BI;EACI,iBAAA;ApFk30BR;;AoFn30BI;EACI,iBAAA;ApFs30BR;;AoFv30BI;EACI,iBAAA;ApF030BR;;AoF330BI;EACI,iBAAA;ApF830BR;;AoF/30BI;EACI,iBAAA;ApFk40BR;;AoFn40BI;EACI,iBAAA;ApFs40BR;;AoFv40BI;EACI,iBAAA;ApF040BR;;AoF340BI;EACI,iBAAA;ApF840BR;;AoF/40BI;EACI,iBAAA;ApFk50BR;;AoFn50BI;EACI,iBAAA;ApFs50BR;;AoFv50BI;EACI,iBAAA;ApF050BR;;AoF350BI;EACI,iBAAA;ApF850BR;;AoF/50BI;EACI,iBAAA;ApFk60BR;;AoFn60BI;EACI,iBAAA;ApFs60BR;;AoFv60BI;EACI,iBAAA;ApF060BR;;AoF360BI;EACI,iBAAA;ApF860BR;;AoF/60BI;EACI,iBAAA;ApFk70BR;;AoFn70BI;EACI,iBAAA;ApFs70BR;;AoFv70BI;EACI,iBAAA;ApF070BR;;AoF370BI;EACI,iBAAA;ApF870BR;;AoF/70BI;EACI,iBAAA;ApFk80BR;;AoFn80BI;EACI,iBAAA;ApFs80BR;;AoFv80BI;EACI,iBAAA;ApF080BR;;AoF380BI;EACI,iBAAA;ApF880BR;;AoF/80BI;EACI,iBAAA;ApFk90BR;;AoFn90BI;EACI,iBAAA;ApFs90BR;;AoFv90BI;EACI,iBAAA;ApF090BR;;AoF390BI;EACI,iBAAA;ApF890BR;;AoF/90BI;EACI,iBAAA;ApFk+0BR;;AoFn+0BI;EACI,iBAAA;ApFs+0BR;;AoFv+0BI;EACI,iBAAA;ApF0+0BR;;AoF3+0BI;EACI,iBAAA;ApF8+0BR;;AoF/+0BI;EACI,iBAAA;ApFk/0BR;;AoFn/0BI;EACI,iBAAA;ApFs/0BR;;AoFv/0BI;EACI,iBAAA;ApF0/0BR;;AoF3/0BI;EACI,iBAAA;ApF8/0BR;;AoF//0BI;EACI,iBAAA;ApFkg1BR;;AoFng1BI;EACI,iBAAA;ApFsg1BR;;AoFvg1BI;EACI,iBAAA;ApF0g1BR;;AoF3g1BI;EACI,iBAAA;ApF8g1BR;;AoF/g1BI;EACI,iBAAA;ApFkh1BR;;AoFnh1BI;EACI,iBAAA;ApFsh1BR;;AoFvh1BI;EACI,iBAAA;ApF0h1BR;;AoF3h1BI;EACI,iBAAA;ApF8h1BR;;AoF/h1BI;EACI,iBAAA;ApFki1BR;;AoFni1BI;EACI,iBAAA;ApFsi1BR;;AoFvi1BI;EACI,iBAAA;ApF0i1BR;;AoF3i1BI;EACI,iBAAA;ApF8i1BR;;AoF/i1BI;EACI,iBAAA;ApFkj1BR;;AoFnj1BI;EACI,iBAAA;ApFsj1BR;;AoFvj1BI;EACI,iBAAA;ApF0j1BR;;AoF3j1BI;EACI,iBAAA;ApF8j1BR;;AoF/j1BI;EACI,iBAAA;ApFkk1BR;;AoFnk1BI;EACI,iBAAA;ApFsk1BR;;AoFvk1BI;EACI,iBAAA;ApF0k1BR;;AoF3k1BI;EACI,iBAAA;ApF8k1BR;;AoF/k1BI;EACI,iBAAA;ApFkl1BR;;AoFnl1BI;EACI,iBAAA;ApFsl1BR;;AoFvl1BI;EACI,iBAAA;ApF0l1BR;;AoF3l1BI;EACI,iBAAA;ApF8l1BR;;AoF/l1BI;EACI,iBAAA;ApFkm1BR;;AoFnm1BI;EACI,iBAAA;ApFsm1BR;;AoFvm1BI;EACI,iBAAA;ApF0m1BR;;AoF3m1BI;EACI,iBAAA;ApF8m1BR;;AoF/m1BI;EACI,iBAAA;ApFkn1BR;;AoFnn1BI;EACI,iBAAA;ApFsn1BR;;AoFvn1BI;EACI,iBAAA;ApF0n1BR;;AoF3n1BI;EACI,iBAAA;ApF8n1BR;;AoF/n1BI;EACI,iBAAA;ApFko1BR;;AoFno1BI;EACI,iBAAA;ApFso1BR;;AoFvo1BI;EACI,iBAAA;ApF0o1BR;;AoF3o1BI;EACI,iBAAA;ApF8o1BR;;AoF/o1BI;EACI,iBAAA;ApFkp1BR;;AoFnp1BI;EACI,iBAAA;ApFsp1BR;;AoFvp1BI;EACI,iBAAA;ApF0p1BR;;AoF3p1BI;EACI,iBAAA;ApF8p1BR;;AoF/p1BI;EACI,iBAAA;ApFkq1BR;;AoFnq1BI;EACI,iBAAA;ApFsq1BR;;AoFvq1BI;EACI,iBAAA;ApF0q1BR;;AoF3q1BI;EACI,iBAAA;ApF8q1BR;;AoF/q1BI;EACI,iBAAA;ApFkr1BR;;AoFnr1BI;EACI,iBAAA;ApFsr1BR;;AoFvr1BI;EACI,iBAAA;ApF0r1BR;;AoF3r1BI;EACI,iBAAA;ApF8r1BR;;AoF/r1BI;EACI,iBAAA;ApFks1BR;;AoFns1BI;EACI,iBAAA;ApFss1BR;;AoFvs1BI;EACI,iBAAA;ApF0s1BR;;AoF3s1BI;EACI,iBAAA;ApF8s1BR;;AoF/s1BI;EACI,iBAAA;ApFkt1BR;;AoFnt1BI;EACI,iBAAA;ApFst1BR;;AoFvt1BI;EACI,iBAAA;ApF0t1BR;;AoF3t1BI;EACI,iBAAA;ApF8t1BR;;AoF/t1BI;EACI,iBAAA;ApFku1BR;;AoFnu1BI;EACI,iBAAA;ApFsu1BR;;AoFvu1BI;EACI,iBAAA;ApF0u1BR;;AoF3u1BI;EACI,iBAAA;ApF8u1BR;;AoF/u1BI;EACI,iBAAA;ApFkv1BR;;AoFnv1BI;EACI,iBAAA;ApFsv1BR;;AoFvv1BI;EACI,iBAAA;ApF0v1BR;;AoF3v1BI;EACI,iBAAA;ApF8v1BR;;AoF/v1BI;EACI,iBAAA;ApFkw1BR;;AoFnw1BI;EACI,iBAAA;ApFsw1BR;;AoFvw1BI;EACI,iBAAA;ApF0w1BR;;AoF3w1BI;EACI,iBAAA;ApF8w1BR;;AoF/w1BI;EACI,iBAAA;ApFkx1BR;;AoFnx1BI;EACI,iBAAA;ApFsx1BR;;AoFvx1BI;EACI,iBAAA;ApF0x1BR;;AoF3x1BI;EACI,iBAAA;ApF8x1BR;;AoF/x1BI;EACI,iBAAA;ApFky1BR;;AoFny1BI;EACI,iBAAA;ApFsy1BR;;AoFvy1BI;EACI,iBAAA;ApF0y1BR;;AoF3y1BI;EACI,iBAAA;ApF8y1BR;;AoF/y1BI;EACI,iBAAA;ApFkz1BR;;AoFnz1BI;EACI,iBAAA;ApFsz1BR;;AoFvz1BI;EACI,iBAAA;ApF0z1BR;;AoF3z1BI;EACI,iBAAA;ApF8z1BR;;AoF/z1BI;EACI,iBAAA;ApFk01BR;;AoFn01BI;EACI,iBAAA;ApFs01BR;;AoFv01BI;EACI,iBAAA;ApF001BR;;AoF301BI;EACI,iBAAA;ApF801BR;;AoF/01BI;EACI,iBAAA;ApFk11BR;;AoFn11BI;EACI,iBAAA;ApFs11BR;;AoFv11BI;EACI,iBAAA;ApF011BR;;AoF311BI;EACI,iBAAA;ApF811BR;;AoF/11BI;EACI,iBAAA;ApFk21BR;;AoFn21BI;EACI,iBAAA;ApFs21BR;;AoFv21BI;EACI,iBAAA;ApF021BR;;AoF321BI;EACI,iBAAA;ApF821BR;;AoF/21BI;EACI,iBAAA;ApFk31BR;;AoFn31BI;EACI,iBAAA;ApFs31BR;;AoFv31BI;EACI,iBAAA;ApF031BR;;AoF331BI;EACI,iBAAA;ApF831BR;;AoF/31BI;EACI,iBAAA;ApFk41BR;;AoFn41BI;EACI,iBAAA;ApFs41BR;;AoFv41BI;EACI,iBAAA;ApF041BR;;AoF341BI;EACI,iBAAA;ApF841BR;;AoF/41BI;EACI,iBAAA;ApFk51BR;;AoFn51BI;EACI,iBAAA;ApFs51BR;;AoFv51BI;EACI,iBAAA;ApF051BR;;AoF351BI;EACI,iBAAA;ApF851BR;;AoF/51BI;EACI,iBAAA;ApFk61BR;;AoFn61BI;EACI,iBAAA;ApFs61BR;;AoFv61BI;EACI,iBAAA;ApF061BR;;AoF361BI;EACI,iBAAA;ApF861BR;;AoF/61BI;EACI,iBAAA;ApFk71BR;;AoFn71BI;EACI,iBAAA;ApFs71BR;;AoFv71BI;EACI,iBAAA;ApF071BR;;AoF371BI;EACI,iBAAA;ApF871BR;;AoF/71BI;EACI,iBAAA;ApFk81BR;;AoFn81BI;EACI,iBAAA;ApFs81BR;;AoFv81BI;EACI,iBAAA;ApF081BR;;AoF381BI;EACI,iBAAA;ApF881BR;;AoF/81BI;EACI,iBAAA;ApFk91BR;;AoFn91BI;EACI,iBAAA;ApFs91BR;;AoFv91BI;EACI,iBAAA;ApF091BR;;AoF391BI;EACI,iBAAA;ApF891BR;;AoF/91BI;EACI,iBAAA;ApFk+1BR;;AoFn+1BI;EACI,iBAAA;ApFs+1BR;;AoFv+1BI;EACI,iBAAA;ApF0+1BR;;AoF3+1BI;EACI,iBAAA;ApF8+1BR;;AoF/+1BI;EACI,iBAAA;ApFk/1BR;;AoFn/1BI;EACI,iBAAA;ApFs/1BR;;AoFv/1BI;EACI,iBAAA;ApF0/1BR;;AoF3/1BI;EACI,iBAAA;ApF8/1BR;;AoF//1BI;EACI,iBAAA;ApFkg2BR;;AoFng2BI;EACI,iBAAA;ApFsg2BR;;AoFvg2BI;EACI,iBAAA;ApF0g2BR;;AoF3g2BI;EACI,iBAAA;ApF8g2BR;;AoF/g2BI;EACI,iBAAA;ApFkh2BR;;AoFnh2BI;EACI,iBAAA;ApFsh2BR;;AoFvh2BI;EACI,iBAAA;ApF0h2BR;;AoF3h2BI;EACI,iBAAA;ApF8h2BR;;AoF/h2BI;EACI,iBAAA;ApFki2BR;;AoFni2BI;EACI,iBAAA;ApFsi2BR;;AoFvi2BI;EACI,iBAAA;ApF0i2BR;;AoF3i2BI;EACI,iBAAA;ApF8i2BR;;AoF/i2BI;EACI,iBAAA;ApFkj2BR;;AoFnj2BI;EACI,iBAAA;ApFsj2BR;;AoFvj2BI;EACI,iBAAA;ApF0j2BR;;AoF3j2BI;EACI,iBAAA;ApF8j2BR;;AoF/j2BI;EACI,iBAAA;ApFkk2BR;;AoFnk2BI;EACI,iBAAA;ApFsk2BR;;AoFvk2BI;EACI,iBAAA;ApF0k2BR;;AoF3k2BI;EACI,iBAAA;ApF8k2BR;;AoF/k2BI;EACI,iBAAA;ApFkl2BR;;AoFnl2BI;EACI,iBAAA;ApFsl2BR;;AoFvl2BI;EACI,iBAAA;ApF0l2BR;;AoF3l2BI;EACI,iBAAA;ApF8l2BR;;AoF/l2BI;EACI,iBAAA;ApFkm2BR;;AoFnm2BI;EACI,iBAAA;ApFsm2BR;;AoFvm2BI;EACI,iBAAA;ApF0m2BR;;AoF3m2BI;EACI,iBAAA;ApF8m2BR;;AoF/m2BI;EACI,iBAAA;ApFkn2BR;;AoFnn2BI;EACI,iBAAA;ApFsn2BR;;AoFvn2BI;EACI,iBAAA;ApF0n2BR;;AoF3n2BI;EACI,iBAAA;ApF8n2BR;;AoF/n2BI;EACI,iBAAA;ApFko2BR;;AoFno2BI;EACI,iBAAA;ApFso2BR;;AoFvo2BI;EACI,iBAAA;ApF0o2BR;;AoF3o2BI;EACI,iBAAA;ApF8o2BR;;AoF/o2BI;EACI,iBAAA;ApFkp2BR;;AoFnp2BI;EACI,iBAAA;ApFsp2BR;;AoFvp2BI;EACI,iBAAA;ApF0p2BR;;AoF3p2BI;EACI,iBAAA;ApF8p2BR;;AoF/p2BI;EACI,iBAAA;ApFkq2BR;;AoFnq2BI;EACI,iBAAA;ApFsq2BR;;AoFvq2BI;EACI,iBAAA;ApF0q2BR;;AoF3q2BI;EACI,iBAAA;ApF8q2BR;;AoF/q2BI;EACI,iBAAA;ApFkr2BR;;AoFnr2BI;EACI,iBAAA;ApFsr2BR;;AoFvr2BI;EACI,iBAAA;ApF0r2BR;;AoF3r2BI;EACI,iBAAA;ApF8r2BR;;AoF/r2BI;EACI,iBAAA;ApFks2BR;;AoFns2BI;EACI,iBAAA;ApFss2BR;;AoFvs2BI;EACI,iBAAA;ApF0s2BR;;AoF3s2BI;EACI,iBAAA;ApF8s2BR;;AoF/s2BI;EACI,iBAAA;ApFkt2BR;;AoFnt2BI;EACI,iBAAA;ApFst2BR;;AoFvt2BI;EACI,iBAAA;ApF0t2BR;;AoF3t2BI;EACI,iBAAA;ApF8t2BR;;AoF/t2BI;EACI,iBAAA;ApFku2BR;;AoFnu2BI;EACI,iBAAA;ApFsu2BR;;AoFvu2BI;EACI,iBAAA;ApF0u2BR;;AoF3u2BI;EACI,iBAAA;ApF8u2BR;;AoF/u2BI;EACI,iBAAA;ApFkv2BR;;AoFnv2BI;EACI,iBAAA;ApFsv2BR;;AoFvv2BI;EACI,iBAAA;ApF0v2BR;;AoF3v2BI;EACI,iBAAA;ApF8v2BR;;AoF/v2BI;EACI,iBAAA;ApFkw2BR;;AoFnw2BI;EACI,iBAAA;ApFsw2BR;;AoFvw2BI;EACI,iBAAA;ApF0w2BR;;AoF3w2BI;EACI,iBAAA;ApF8w2BR;;AoF/w2BI;EACI,iBAAA;ApFkx2BR;;AoFnx2BI;EACI,iBAAA;ApFsx2BR;;AoFvx2BI;EACI,iBAAA;ApF0x2BR;;AoF3x2BI;EACI,iBAAA;ApF8x2BR;;AoF/x2BI;EACI,iBAAA;ApFky2BR;;AoFny2BI;EACI,iBAAA;ApFsy2BR;;AoFvy2BI;EACI,iBAAA;ApF0y2BR;;AoF3y2BI;EACI,iBAAA;ApF8y2BR;;AoF/y2BI;EACI,iBAAA;ApFkz2BR;;AoFnz2BI;EACI,iBAAA;ApFsz2BR;;AoFvz2BI;EACI,iBAAA;ApF0z2BR;;AoF3z2BI;EACI,iBAAA;ApF8z2BR;;AoF/z2BI;EACI,iBAAA;ApFk02BR;;AoFn02BI;EACI,iBAAA;ApFs02BR;;AoFv02BI;EACI,iBAAA;ApF002BR;;AoF302BI;EACI,iBAAA;ApF802BR;;AoF/02BI;EACI,iBAAA;ApFk12BR;;AoFn12BI;EACI,iBAAA;ApFs12BR;;AoFv12BI;EACI,iBAAA;ApF012BR;;AoF312BI;EACI,iBAAA;ApF812BR;;AoF/12BI;EACI,iBAAA;ApFk22BR;;AoFn22BI;EACI,iBAAA;ApFs22BR;;AoFv22BI;EACI,iBAAA;ApF022BR;;AoF322BI;EACI,iBAAA;ApF822BR;;AoF/22BI;EACI,iBAAA;ApFk32BR;;AoFn32BI;EACI,iBAAA;ApFs32BR;;AoFv32BI;EACI,iBAAA;ApF032BR;;AoF332BI;EACI,iBAAA;ApF832BR;;AoF/32BI;EACI,iBAAA;ApFk42BR;;AoFn42BI;EACI,iBAAA;ApFs42BR;;AoFv42BI;EACI,iBAAA;ApF042BR;;AoF342BI;EACI,iBAAA;ApF842BR;;AoF/42BI;EACI,iBAAA;ApFk52BR;;AoFn52BI;EACI,iBAAA;ApFs52BR;;AoFv52BI;EACI,iBAAA;ApF052BR;;AoF352BI;EACI,iBAAA;ApF852BR;;AoF/52BI;EACI,iBAAA;ApFk62BR;;AoFn62BI;EACI,iBAAA;ApFs62BR;;AoFv62BI;EACI,iBAAA;ApF062BR;;AoF362BI;EACI,iBAAA;ApF862BR;;AoF/62BI;EACI,iBAAA;ApFk72BR;;AoFn72BI;EACI,iBAAA;ApFs72BR;;AoFv72BI;EACI,iBAAA;ApF072BR;;AoF372BI;EACI,iBAAA;ApF872BR;;AoF/72BI;EACI,iBAAA;ApFk82BR;;AoFn82BI;EACI,iBAAA;ApFs82BR;;AoFv82BI;EACI,iBAAA;ApF082BR;;AoF382BI;EACI,iBAAA;ApF882BR;;AoF/82BI;EACI,iBAAA;ApFk92BR;;AoFn92BI;EACI,iBAAA;ApFs92BR;;AoFv92BI;EACI,iBAAA;ApF092BR;;AoF392BI;EACI,iBAAA;ApF892BR;;AoF/92BI;EACI,iBAAA;ApFk+2BR;;AoFn+2BI;EACI,iBAAA;ApFs+2BR;;AoFv+2BI;EACI,iBAAA;ApF0+2BR;;AoF3+2BI;EACI,iBAAA;ApF8+2BR;;AoF/+2BI;EACI,iBAAA;ApFk/2BR;;AoFn/2BI;EACI,iBAAA;ApFs/2BR;;AoFv/2BI;EACI,iBAAA;ApF0/2BR;;AoF3/2BI;EACI,iBAAA;ApF8/2BR;;AoF//2BI;EACI,iBAAA;ApFkg3BR;;AoFng3BI;EACI,iBAAA;ApFsg3BR;;AoFvg3BI;EACI,iBAAA;ApF0g3BR;;AoF3g3BI;EACI,iBAAA;ApF8g3BR;;AoF/g3BI;EACI,iBAAA;ApFkh3BR;;AoFnh3BI;EACI,iBAAA;ApFsh3BR;;AoFvh3BI;EACI,iBAAA;ApF0h3BR;;AoF3h3BI;EACI,iBAAA;ApF8h3BR;;AoF/h3BI;EACI,iBAAA;ApFki3BR;;AoFni3BI;EACI,iBAAA;ApFsi3BR;;AoFvi3BI;EACI,iBAAA;ApF0i3BR;;AoF3i3BI;EACI,iBAAA;ApF8i3BR;;AoF/i3BI;EACI,iBAAA;ApFkj3BR;;AoFnj3BI;EACI,iBAAA;ApFsj3BR;;AoFvj3BI;EACI,iBAAA;ApF0j3BR;;AoF3j3BI;EACI,iBAAA;ApF8j3BR;;AoF/j3BI;EACI,iBAAA;ApFkk3BR;;AoFnk3BI;EACI,iBAAA;ApFsk3BR;;AoFvk3BI;EACI,iBAAA;ApF0k3BR;;AoF3k3BI;EACI,iBAAA;ApF8k3BR;;AoF/k3BI;EACI,iBAAA;ApFkl3BR;;AoFnl3BI;EACI,iBAAA;ApFsl3BR;;AoFvl3BI;EACI,iBAAA;ApF0l3BR;;AoF3l3BI;EACI,iBAAA;ApF8l3BR;;AoF/l3BI;EACI,iBAAA;ApFkm3BR;;AoFnm3BI;EACI,iBAAA;ApFsm3BR;;AoFvm3BI;EACI,iBAAA;ApF0m3BR;;AoF3m3BI;EACI,iBAAA;ApF8m3BR;;AoF/m3BI;EACI,iBAAA;ApFkn3BR;;AoFnn3BI;EACI,iBAAA;ApFsn3BR;;AoFvn3BI;EACI,iBAAA;ApF0n3BR;;AoF3n3BI;EACI,iBAAA;ApF8n3BR;;AoF/n3BI;EACI,iBAAA;ApFko3BR;;AoFno3BI;EACI,iBAAA;ApFso3BR;;AoFvo3BI;EACI,iBAAA;ApF0o3BR;;AoF3o3BI;EACI,iBAAA;ApF8o3BR;;AoF/o3BI;EACI,iBAAA;ApFkp3BR;;AoFnp3BI;EACI,iBAAA;ApFsp3BR;;AoFvp3BI;EACI,iBAAA;ApF0p3BR;;AoF3p3BI;EACI,iBAAA;ApF8p3BR;;AoF/p3BI;EACI,iBAAA;ApFkq3BR;;AoFnq3BI;EACI,iBAAA;ApFsq3BR;;AoFvq3BI;EACI,iBAAA;ApF0q3BR;;AoF3q3BI;EACI,iBAAA;ApF8q3BR;;AoF/q3BI;EACI,iBAAA;ApFkr3BR;;AoFnr3BI;EACI,iBAAA;ApFsr3BR;;AoFvr3BI;EACI,iBAAA;ApF0r3BR;;AoF3r3BI;EACI,iBAAA;ApF8r3BR;;AoF/r3BI;EACI,iBAAA;ApFks3BR;;AoFns3BI;EACI,iBAAA;ApFss3BR;;AoFvs3BI;EACI,iBAAA;ApF0s3BR;;AoF3s3BI;EACI,iBAAA;ApF8s3BR;;AoF/s3BI;EACI,iBAAA;ApFkt3BR;;AoFnt3BI;EACI,iBAAA;ApFst3BR;;AoFvt3BI;EACI,iBAAA;ApF0t3BR;;AoF3t3BI;EACI,iBAAA;ApF8t3BR;;AoF/t3BI;EACI,iBAAA;ApFku3BR;;AoFnu3BI;EACI,iBAAA;ApFsu3BR;;AoFvu3BI;EACI,iBAAA;ApF0u3BR;;AoF3u3BI;EACI,iBAAA;ApF8u3BR;;AoF/u3BI;EACI,iBAAA;ApFkv3BR;;AoFnv3BI;EACI,iBAAA;ApFsv3BR;;AoFvv3BI;EACI,iBAAA;ApF0v3BR;;AoF3v3BI;EACI,iBAAA;ApF8v3BR;;AoF/v3BI;EACI,iBAAA;ApFkw3BR;;AoFnw3BI;EACI,iBAAA;ApFsw3BR;;AoFvw3BI;EACI,iBAAA;ApF0w3BR;;AoF3w3BI;EACI,iBAAA;ApF8w3BR;;AoF/w3BI;EACI,iBAAA;ApFkx3BR;;AoFnx3BI;EACI,iBAAA;ApFsx3BR;;AoFvx3BI;EACI,iBAAA;ApF0x3BR;;AoF3x3BI;EACI,iBAAA;ApF8x3BR;;AoF/x3BI;EACI,iBAAA;ApFky3BR;;AoFny3BI;EACI,iBAAA;ApFsy3BR;;AoFvy3BI;EACI,iBAAA;ApF0y3BR;;AoF3y3BI;EACI,iBAAA;ApF8y3BR;;AoF/y3BI;EACI,iBAAA;ApFkz3BR;;AoFnz3BI;EACI,iBAAA;ApFsz3BR;;AoFvz3BI;EACI,iBAAA;ApF0z3BR;;AoF3z3BI;EACI,iBAAA;ApF8z3BR;;AoF/z3BI;EACI,iBAAA;ApFk03BR;;AoFn03BI;EACI,iBAAA;ApFs03BR;;AoFv03BI;EACI,iBAAA;ApF003BR;;AoF303BI;EACI,iBAAA;ApF803BR;;AoF/03BI;EACI,iBAAA;ApFk13BR;;AoFn13BI;EACI,iBAAA;ApFs13BR;;AoFv13BI;EACI,iBAAA;ApF013BR;;AoF313BI;EACI,iBAAA;ApF813BR;;AoF/13BI;EACI,iBAAA;ApFk23BR;;AoFn23BI;EACI,iBAAA;ApFs23BR;;AoFv23BI;EACI,iBAAA;ApF023BR;;AoF323BI;EACI,iBAAA;ApF823BR;;AoF/23BI;EACI,iBAAA;ApFk33BR;;AoFn33BI;EACI,iBAAA;ApFs33BR;;AoFv33BI;EACI,iBAAA;ApF033BR;;AoF333BI;EACI,iBAAA;ApF833BR;;AoF/33BI;EACI,iBAAA;ApFk43BR;;AoFn43BI;EACI,iBAAA;ApFs43BR;;AoFv43BI;EACI,iBAAA;ApF043BR;;AoF343BI;EACI,iBAAA;ApF843BR;;AoF/43BI;EACI,iBAAA;ApFk53BR;;AoFn53BI;EACI,iBAAA;ApFs53BR;;AoFv53BI;EACI,iBAAA;ApF053BR;;AoF353BI;EACI,iBAAA;ApF853BR;;AoF/53BI;EACI,iBAAA;ApFk63BR;;AoFn63BI;EACI,iBAAA;ApFs63BR;;AoFv63BI;EACI,iBAAA;ApF063BR;;AoF363BI;EACI,iBAAA;ApF863BR;;AoF/63BI;EACI,iBAAA;ApFk73BR;;AoFn73BI;EACI,iBAAA;ApFs73BR;;AoFv73BI;EACI,iBAAA;ApF073BR;;AoF373BI;EACI,iBAAA;ApF873BR;;AoF/73BI;EACI,iBAAA;ApFk83BR;;AoFn83BI;EACI,iBAAA;ApFs83BR;;AoFv83BI;EACI,iBAAA;ApF083BR;;AoF383BI;EACI,iBAAA;ApF883BR;;AoF/83BI;EACI,iBAAA;ApFk93BR;;AoFn93BI;EACI,iBAAA;ApFs93BR;;AoFv93BI;EACI,iBAAA;ApF093BR;;AoF393BI;EACI,iBAAA;ApF893BR;;AoF/93BI;EACI,iBAAA;ApFk+3BR;;AoFn+3BI;EACI,iBAAA;ApFs+3BR;;AoFv+3BI;EACI,iBAAA;ApF0+3BR;;AoF3+3BI;EACI,iBAAA;ApF8+3BR;;AoF/+3BI;EACI,iBAAA;ApFk/3BR;;AoFn/3BI;EACI,iBAAA;ApFs/3BR;;AoFv/3BI;EACI,iBAAA;ApF0/3BR;;AoF3/3BI;EACI,iBAAA;ApF8/3BR;;AoF//3BI;EACI,iBAAA;ApFkg4BR;;AoFng4BI;EACI,iBAAA;ApFsg4BR;;AoFvg4BI;EACI,iBAAA;ApF0g4BR;;AoF3g4BI;EACI,iBAAA;ApF8g4BR;;AoF/g4BI;EACI,iBAAA;ApFkh4BR;;AoFnh4BI;EACI,iBAAA;ApFsh4BR;;AoFvh4BI;EACI,iBAAA;ApF0h4BR;;AoF3h4BI;EACI,iBAAA;ApF8h4BR;;AoF/h4BI;EACI,iBAAA;ApFki4BR;;AoFni4BI;EACI,iBAAA;ApFsi4BR;;AoFvi4BI;EACI,iBAAA;ApF0i4BR;;AoF3i4BI;EACI,iBAAA;ApF8i4BR;;AoF/i4BI;EACI,iBAAA;ApFkj4BR;;AoFnj4BI;EACI,iBAAA;ApFsj4BR;;AoFvj4BI;EACI,iBAAA;ApF0j4BR;;AoF3j4BI;EACI,iBAAA;ApF8j4BR;;AoF/j4BI;EACI,iBAAA;ApFkk4BR;;AoFnk4BI;EACI,iBAAA;ApFsk4BR;;AoFvk4BI;EACI,iBAAA;ApF0k4BR;;AoF3k4BI;EACI,iBAAA;ApF8k4BR;;AoF/k4BI;EACI,iBAAA;ApFkl4BR;;AoFnl4BI;EACI,iBAAA;ApFsl4BR;;AoFvl4BI;EACI,iBAAA;ApF0l4BR;;AoF3l4BI;EACI,iBAAA;ApF8l4BR;;AoF/l4BI;EACI,iBAAA;ApFkm4BR;;AoFnm4BI;EACI,iBAAA;ApFsm4BR;;AoFvm4BI;EACI,iBAAA;ApF0m4BR;;AoF3m4BI;EACI,iBAAA;ApF8m4BR;;AoF/m4BI;EACI,iBAAA;ApFkn4BR;;AoFnn4BI;EACI,iBAAA;ApFsn4BR;;AoFvn4BI;EACI,iBAAA;ApF0n4BR;;AoF3n4BI;EACI,iBAAA;ApF8n4BR;;AoF/n4BI;EACI,iBAAA;ApFko4BR;;AoFno4BI;EACI,iBAAA;ApFso4BR;;AoFvo4BI;EACI,iBAAA;ApF0o4BR;;AoF3o4BI;EACI,iBAAA;ApF8o4BR;;AoF/o4BI;EACI,iBAAA;ApFkp4BR;;AoFnp4BI;EACI,iBAAA;ApFsp4BR;;AoFvp4BI;EACI,iBAAA;ApF0p4BR;;AoF3p4BI;EACI,iBAAA;ApF8p4BR;;AoF/p4BI;EACI,iBAAA;ApFkq4BR;;AoFnq4BI;EACI,iBAAA;ApFsq4BR;;AoFvq4BI;EACI,iBAAA;ApF0q4BR;;AoF3q4BI;EACI,iBAAA;ApF8q4BR;;AoF/q4BI;EACI,iBAAA;ApFkr4BR;;AoFnr4BI;EACI,iBAAA;ApFsr4BR;;AoFvr4BI;EACI,iBAAA;ApF0r4BR;;AoF3r4BI;EACI,iBAAA;ApF8r4BR;;AoF/r4BI;EACI,iBAAA;ApFks4BR;;AoFns4BI;EACI,iBAAA;ApFss4BR;;AoFvs4BI;EACI,iBAAA;ApF0s4BR;;AoF3s4BI;EACI,iBAAA;ApF8s4BR;;AoF/s4BI;EACI,iBAAA;ApFkt4BR;;AoFnt4BI;EACI,iBAAA;ApFst4BR;;AoFvt4BI;EACI,iBAAA;ApF0t4BR;;AoF3t4BI;EACI,iBAAA;ApF8t4BR;;AoF/t4BI;EACI,iBAAA;ApFku4BR;;AoFnu4BI;EACI,iBAAA;ApFsu4BR;;AoFvu4BI;EACI,iBAAA;ApF0u4BR;;AoF3u4BI;EACI,iBAAA;ApF8u4BR;;AoF/u4BI;EACI,iBAAA;ApFkv4BR;;AoFnv4BI;EACI,iBAAA;ApFsv4BR;;AoFvv4BI;EACI,iBAAA;ApF0v4BR;;AoF3v4BI;EACI,iBAAA;ApF8v4BR;;AoF/v4BI;EACI,iBAAA;ApFkw4BR;;AoFnw4BI;EACI,iBAAA;ApFsw4BR;;AoFvw4BI;EACI,iBAAA;ApF0w4BR;;AoF3w4BI;EACI,iBAAA;ApF8w4BR;;AoF/w4BI;EACI,iBAAA;ApFkx4BR;;AoFnx4BI;EACI,iBAAA;ApFsx4BR;;AoFvx4BI;EACI,iBAAA;ApF0x4BR;;AoF3x4BI;EACI,iBAAA;ApF8x4BR;;AoF/x4BI;EACI,iBAAA;ApFky4BR;;AoFny4BI;EACI,iBAAA;ApFsy4BR;;AoFvy4BI;EACI,iBAAA;ApF0y4BR;;AoF3y4BI;EACI,iBAAA;ApF8y4BR;;AoF/y4BI;EACI,iBAAA;ApFkz4BR;;AoFnz4BI;EACI,iBAAA;ApFsz4BR;;AoFvz4BI;EACI,iBAAA;ApF0z4BR;;AoF3z4BI;EACI,iBAAA;ApF8z4BR;;AoF/z4BI;EACI,iBAAA;ApFk04BR;;AoFn04BI;EACI,iBAAA;ApFs04BR;;AoFv04BI;EACI,iBAAA;ApF004BR;;AoF304BI;EACI,iBAAA;ApF804BR;;AoF/04BI;EACI,iBAAA;ApFk14BR;;AoFn14BI;EACI,iBAAA;ApFs14BR;;AoFv14BI;EACI,iBAAA;ApF014BR;;AoF314BI;EACI,iBAAA;ApF814BR;;AoF/14BI;EACI,iBAAA;ApFk24BR;;AoFn24BI;EACI,iBAAA;ApFs24BR;;AoFv24BI;EACI,iBAAA;ApF024BR;;AoF324BI;EACI,iBAAA;ApF824BR;;AoF/24BI;EACI,iBAAA;ApFk34BR;;AoFn34BI;EACI,iBAAA;ApFs34BR;;AoFv34BI;EACI,iBAAA;ApF034BR;;AoF334BI;EACI,iBAAA;ApF834BR;;AoF/34BI;EACI,iBAAA;ApFk44BR;;AoFn44BI;EACI,iBAAA;ApFs44BR;;AoFv44BI;EACI,iBAAA;ApF044BR;;AoF344BI;EACI,iBAAA;ApF844BR;;AoF/44BI;EACI,iBAAA;ApFk54BR;;AoFn54BI;EACI,iBAAA;ApFs54BR;;AoFv54BI;EACI,iBAAA;ApF054BR;;AoF354BI;EACI,iBAAA;ApF854BR;;AoF/54BI;EACI,iBAAA;ApFk64BR;;AoFn64BI;EACI,iBAAA;ApFs64BR;;AoFv64BI;EACI,iBAAA;ApF064BR;;AoF364BI;EACI,iBAAA;ApF864BR;;AoF/64BI;EACI,iBAAA;ApFk74BR;;AoFn74BI;EACI,iBAAA;ApFs74BR;;AoFv74BI;EACI,iBAAA;ApF074BR;;AoF374BI;EACI,iBAAA;ApF874BR;;AoF/74BI;EACI,iBAAA;ApFk84BR;;AoFn84BI;EACI,iBAAA;ApFs84BR;;AoFv84BI;EACI,iBAAA;ApF084BR;;AoF384BI;EACI,iBAAA;ApF884BR;;AoF/84BI;EACI,iBAAA;ApFk94BR;;AoFn94BI;EACI,iBAAA;ApFs94BR;;AoFv94BI;EACI,iBAAA;ApF094BR;;AoF394BI;EACI,iBAAA;ApF894BR;;AoF/94BI;EACI,iBAAA;ApFk+4BR;;AoFn+4BI;EACI,iBAAA;ApFs+4BR;;AoFv+4BI;EACI,iBAAA;ApF0+4BR;;AoF3+4BI;EACI,iBAAA;ApF8+4BR;;AoF/+4BI;EACI,iBAAA;ApFk/4BR;;AoFn/4BI;EACI,iBAAA;ApFs/4BR;;AoFv/4BI;EACI,iBAAA;ApF0/4BR;;AoF3/4BI;EACI,iBAAA;ApF8/4BR;;AoF//4BI;EACI,iBAAA;ApFkg5BR;;AoFng5BI;EACI,iBAAA;ApFsg5BR;;AoFvg5BI;EACI,iBAAA;ApF0g5BR;;AoF3g5BI;EACI,iBAAA;ApF8g5BR;;AoF/g5BI;EACI,iBAAA;ApFkh5BR;;AoFnh5BI;EACI,iBAAA;ApFsh5BR;;AoFvh5BI;EACI,iBAAA;ApF0h5BR;;AoF3h5BI;EACI,iBAAA;ApF8h5BR;;AoF/h5BI;EACI,iBAAA;ApFki5BR;;AoFni5BI;EACI,iBAAA;ApFsi5BR;;AoFvi5BI;EACI,iBAAA;ApF0i5BR;;AoF3i5BI;EACI,iBAAA;ApF8i5BR;;AoF/i5BI;EACI,iBAAA;ApFkj5BR;;AoFnj5BI;EACI,iBAAA;ApFsj5BR;;AoFvj5BI;EACI,iBAAA;ApF0j5BR;;AoF3j5BI;EACI,iBAAA;ApF8j5BR;;AoF/j5BI;EACI,iBAAA;ApFkk5BR;;AoFnk5BI;EACI,iBAAA;ApFsk5BR;;AoFvk5BI;EACI,iBAAA;ApF0k5BR;;AoF3k5BI;EACI,iBAAA;ApF8k5BR;;AoF/k5BI;EACI,iBAAA;ApFkl5BR;;AoFnl5BI;EACI,iBAAA;ApFsl5BR;;AoFvl5BI;EACI,iBAAA;ApF0l5BR;;AoF3l5BI;EACI,iBAAA;ApF8l5BR;;AoF/l5BI;EACI,iBAAA;ApFkm5BR;;AoFnm5BI;EACI,iBAAA;ApFsm5BR;;AoFvm5BI;EACI,iBAAA;ApF0m5BR;;AoF3m5BI;EACI,iBAAA;ApF8m5BR;;AoF/m5BI;EACI,iBAAA;ApFkn5BR;;AoFnn5BI;EACI,iBAAA;ApFsn5BR;;AoFvn5BI;EACI,iBAAA;ApF0n5BR;;AoF3n5BI;EACI,iBAAA;ApF8n5BR;;AoF/n5BI;EACI,iBAAA;ApFko5BR;;AoFno5BI;EACI,iBAAA;ApFso5BR;;AoFvo5BI;EACI,iBAAA;ApF0o5BR;;AoF3o5BI;EACI,iBAAA;ApF8o5BR;;AoF/o5BI;EACI,iBAAA;ApFkp5BR;;AoFnp5BI;EACI,iBAAA;ApFsp5BR;;AoFvp5BI;EACI,iBAAA;ApF0p5BR;;AoF3p5BI;EACI,iBAAA;ApF8p5BR;;AoF/p5BI;EACI,iBAAA;ApFkq5BR;;AoFnq5BI;EACI,iBAAA;ApFsq5BR;;AoFvq5BI;EACI,iBAAA;ApF0q5BR;;AoF3q5BI;EACI,iBAAA;ApF8q5BR;;AoF/q5BI;EACI,iBAAA;ApFkr5BR;;AoFnr5BI;EACI,iBAAA;ApFsr5BR;;AoFvr5BI;EACI,iBAAA;ApF0r5BR;;AoF3r5BI;EACI,iBAAA;ApF8r5BR;;AoF/r5BI;EACI,iBAAA;ApFks5BR;;AoFns5BI;EACI,iBAAA;ApFss5BR;;AoFvs5BI;EACI,iBAAA;ApF0s5BR;;AoF3s5BI;EACI,iBAAA;ApF8s5BR;;AoF/s5BI;EACI,iBAAA;ApFkt5BR;;AoFnt5BI;EACI,iBAAA;ApFst5BR;;AoFvt5BI;EACI,iBAAA;ApF0t5BR;;AoF3t5BI;EACI,iBAAA;ApF8t5BR;;AoF/t5BI;EACI,iBAAA;ApFku5BR;;AoFnu5BI;EACI,iBAAA;ApFsu5BR;;AoFvu5BI;EACI,iBAAA;ApF0u5BR;;AoF3u5BI;EACI,iBAAA;ApF8u5BR;;AoF/u5BI;EACI,iBAAA;ApFkv5BR;;AoFnv5BI;EACI,iBAAA;ApFsv5BR;;AoFvv5BI;EACI,iBAAA;ApF0v5BR;;AoF3v5BI;EACI,iBAAA;ApF8v5BR;;AoF/v5BI;EACI,iBAAA;ApFkw5BR;;AoFnw5BI;EACI,iBAAA;ApFsw5BR;;AoFvw5BI;EACI,iBAAA;ApF0w5BR;;AoF3w5BI;EACI,iBAAA;ApF8w5BR;;AoF/w5BI;EACI,iBAAA;ApFkx5BR;;AoFnx5BI;EACI,iBAAA;ApFsx5BR;;AoFvx5BI;EACI,iBAAA;ApF0x5BR;;AoF3x5BI;EACI,iBAAA;ApF8x5BR;;AoF/x5BI;EACI,iBAAA;ApFky5BR;;AoFny5BI;EACI,iBAAA;ApFsy5BR;;AoFvy5BI;EACI,iBAAA;ApF0y5BR;;AoF3y5BI;EACI,iBAAA;ApF8y5BR;;AoF/y5BI;EACI,iBAAA;ApFkz5BR;;AoFnz5BI;EACI,iBAAA;ApFsz5BR;;AoFvz5BI;EACI,iBAAA;ApF0z5BR;;AoF3z5BI;EACI,iBAAA;ApF8z5BR;;AoF/z5BI;EACI,iBAAA;ApFk05BR;;AoFn05BI;EACI,iBAAA;ApFs05BR;;AoFv05BI;EACI,iBAAA;ApF005BR;;AoF305BI;EACI,iBAAA;ApF805BR;;AoF/05BI;EACI,iBAAA;ApFk15BR;;AoFn15BI;EACI,iBAAA;ApFs15BR;;AoFv15BI;EACI,iBAAA;ApF015BR;;AoF315BI;EACI,iBAAA;ApF815BR;;AoF/15BI;EACI,iBAAA;ApFk25BR;;AoFn25BI;EACI,iBAAA;ApFs25BR;;AoFv25BI;EACI,iBAAA;ApF025BR;;AoF325BI;EACI,iBAAA;ApF825BR;;AoF/25BI;EACI,iBAAA;ApFk35BR;;AoFn35BI;EACI,iBAAA;ApFs35BR;;AoFv35BI;EACI,iBAAA;ApF035BR;;AoF335BI;EACI,iBAAA;ApF835BR;;AoF/35BI;EACI,iBAAA;ApFk45BR;;AoFn45BI;EACI,iBAAA;ApFs45BR;;AoFv45BI;EACI,iBAAA;ApF045BR;;AoF345BI;EACI,iBAAA;ApF845BR;;AoF/45BI;EACI,iBAAA;ApFk55BR;;AoFn55BI;EACI,iBAAA;ApFs55BR;;AoFv55BI;EACI,iBAAA;ApF055BR;;AoF355BI;EACI,iBAAA;ApF855BR;;AoF/55BI;EACI,iBAAA;ApFk65BR;;AoFn65BI;EACI,iBAAA;ApFs65BR;;AoFv65BI;EACI,iBAAA;ApF065BR;;AoF365BI;EACI,iBAAA;ApF865BR;;AoF/65BI;EACI,iBAAA;ApFk75BR;;AoFn75BI;EACI,iBAAA;ApFs75BR;;AoFv75BI;EACI,iBAAA;ApF075BR;;AoF375BI;EACI,iBAAA;ApF875BR;;AoF/75BI;EACI,iBAAA;ApFk85BR;;AoFn85BI;EACI,iBAAA;ApFs85BR;;AoFv85BI;EACI,iBAAA;ApF085BR;;AoF385BI;EACI,iBAAA;ApF885BR;;AoF/85BI;EACI,iBAAA;ApFk95BR;;AoFn95BI;EACI,iBAAA;ApFs95BR;;AoFv95BI;EACI,iBAAA;ApF095BR;;AoF395BI;EACI,iBAAA;ApF895BR;;AoF/95BI;EACI,iBAAA;ApFk+5BR;;AoFn+5BI;EACI,iBAAA;ApFs+5BR;;AoFv+5BI;EACI,iBAAA;ApF0+5BR;;AoF3+5BI;EACI,iBAAA;ApF8+5BR;;AoF/+5BI;EACI,iBAAA;ApFk/5BR;;AoFn/5BI;EACI,iBAAA;ApFs/5BR;;AoFv/5BI;EACI,iBAAA;ApF0/5BR;;AoF3/5BI;EACI,iBAAA;ApF8/5BR;;AoF//5BI;EACI,iBAAA;ApFkg6BR;;AoFng6BI;EACI,iBAAA;ApFsg6BR;;AoFvg6BI;EACI,iBAAA;ApF0g6BR;;AoF3g6BI;EACI,iBAAA;ApF8g6BR;;AoF/g6BI;EACI,iBAAA;ApFkh6BR;;AoFnh6BI;EACI,iBAAA;ApFsh6BR;;AoFvh6BI;EACI,iBAAA;ApF0h6BR;;AoF3h6BI;EACI,iBAAA;ApF8h6BR;;AoF/h6BI;EACI,iBAAA;ApFki6BR;;AoFni6BI;EACI,iBAAA;ApFsi6BR;;AoFvi6BI;EACI,iBAAA;ApF0i6BR;;AoF3i6BI;EACI,iBAAA;ApF8i6BR;;AoF/i6BI;EACI,iBAAA;ApFkj6BR;;AoFnj6BI;EACI,iBAAA;ApFsj6BR;;AoFvj6BI;EACI,iBAAA;ApF0j6BR;;AoF3j6BI;EACI,iBAAA;ApF8j6BR;;AoF/j6BI;EACI,iBAAA;ApFkk6BR;;AoFnk6BI;EACI,iBAAA;ApFsk6BR;;AoFvk6BI;EACI,iBAAA;ApF0k6BR;;AoF3k6BI;EACI,iBAAA;ApF8k6BR;;AoF/k6BI;EACI,iBAAA;ApFkl6BR;;AoFnl6BI;EACI,iBAAA;ApFsl6BR;;AoFvl6BI;EACI,iBAAA;ApF0l6BR;;AoF3l6BI;EACI,iBAAA;ApF8l6BR;;AoF/l6BI;EACI,iBAAA;ApFkm6BR;;AoFnm6BI;EACI,iBAAA;ApFsm6BR;;AoFvm6BI;EACI,iBAAA;ApF0m6BR;;AoF3m6BI;EACI,iBAAA;ApF8m6BR;;AoF/m6BI;EACI,iBAAA;ApFkn6BR;;AoFnn6BI;EACI,iBAAA;ApFsn6BR;;AoFvn6BI;EACI,iBAAA;ApF0n6BR;;AoF3n6BI;EACI,iBAAA;ApF8n6BR;;AoF/n6BI;EACI,iBAAA;ApFko6BR;;AoFno6BI;EACI,iBAAA;ApFso6BR;;AoFvo6BI;EACI,iBAAA;ApF0o6BR;;AoF3o6BI;EACI,iBAAA;ApF8o6BR;;AoF/o6BI;EACI,iBAAA;ApFkp6BR;;AoFnp6BI;EACI,iBAAA;ApFsp6BR;;AoFvp6BI;EACI,iBAAA;ApF0p6BR;;AoF3p6BI;EACI,iBAAA;ApF8p6BR;;AoF/p6BI;EACI,iBAAA;ApFkq6BR;;AoFnq6BI;EACI,iBAAA;ApFsq6BR;;AoFvq6BI;EACI,iBAAA;ApF0q6BR;;AoF3q6BI;EACI,iBAAA;ApF8q6BR;;AoF/q6BI;EACI,iBAAA;ApFkr6BR;;AoFnr6BI;EACI,iBAAA;ApFsr6BR;;AoFvr6BI;EACI,iBAAA;ApF0r6BR;;AoF3r6BI;EACI,iBAAA;ApF8r6BR;;AoF/r6BI;EACI,iBAAA;ApFks6BR;;AoFns6BI;EACI,iBAAA;ApFss6BR;;AoFvs6BI;EACI,iBAAA;ApF0s6BR;;AoF3s6BI;EACI,iBAAA;ApF8s6BR;;AoF/s6BI;EACI,iBAAA;ApFkt6BR;;AoFnt6BI;EACI,iBAAA;ApFst6BR;;AoFvt6BI;EACI,iBAAA;ApF0t6BR;;AoF3t6BI;EACI,iBAAA;ApF8t6BR;;AoF/t6BI;EACI,iBAAA;ApFku6BR;;AoFnu6BI;EACI,iBAAA;ApFsu6BR;;AoFvu6BI;EACI,iBAAA;ApF0u6BR;;AoF3u6BI;EACI,iBAAA;ApF8u6BR;;AoF/u6BI;EACI,iBAAA;ApFkv6BR;;AoFnv6BI;EACI,iBAAA;ApFsv6BR;;AoFvv6BI;EACI,iBAAA;ApF0v6BR;;AoF3v6BI;EACI,iBAAA;ApF8v6BR;;AoF/v6BI;EACI,iBAAA;ApFkw6BR;;AoFnw6BI;EACI,iBAAA;ApFsw6BR;;AoFvw6BI;EACI,iBAAA;ApF0w6BR;;AoF3w6BI;EACI,iBAAA;ApF8w6BR;;AoF/w6BI;EACI,iBAAA;ApFkx6BR;;AoFnx6BI;EACI,iBAAA;ApFsx6BR;;AoFvx6BI;EACI,iBAAA;ApF0x6BR;;AoF3x6BI;EACI,iBAAA;ApF8x6BR;;AoF/x6BI;EACI,iBAAA;ApFky6BR;;AoFny6BI;EACI,iBAAA;ApFsy6BR;;AoFvy6BI;EACI,iBAAA;ApF0y6BR;;AoF3y6BI;EACI,iBAAA;ApF8y6BR;;AoF/y6BI;EACI,iBAAA;ApFkz6BR;;AoFnz6BI;EACI,iBAAA;ApFsz6BR;;AoFvz6BI;EACI,iBAAA;ApF0z6BR;;AoF3z6BI;EACI,iBAAA;ApF8z6BR;;AoF/z6BI;EACI,iBAAA;ApFk06BR;;AoFn06BI;EACI,iBAAA;ApFs06BR;;AoFv06BI;EACI,iBAAA;ApF006BR;;AoF306BI;EACI,iBAAA;ApF806BR;;AoF/06BI;EACI,iBAAA;ApFk16BR;;AoFn16BI;EACI,iBAAA;ApFs16BR;;AoFv16BI;EACI,iBAAA;ApF016BR;;AoF316BI;EACI,iBAAA;ApF816BR;;AoF/16BI;EACI,iBAAA;ApFk26BR;;AoFn26BI;EACI,iBAAA;ApFs26BR;;AoFv26BI;EACI,iBAAA;ApF026BR;;AoF326BI;EACI,iBAAA;ApF826BR;;AoF/26BI;EACI,iBAAA;ApFk36BR;;AoFn36BI;EACI,iBAAA;ApFs36BR;;AoFv36BI;EACI,iBAAA;ApF036BR;;AoF336BI;EACI,iBAAA;ApF836BR;;AoF/36BI;EACI,iBAAA;ApFk46BR;;AoFn46BI;EACI,iBAAA;ApFs46BR;;AoFv46BI;EACI,iBAAA;ApF046BR;;AoF346BI;EACI,iBAAA;ApF846BR;;AoF/46BI;EACI,iBAAA;ApFk56BR;;AoFn56BI;EACI,iBAAA;ApFs56BR;;AoFv56BI;EACI,iBAAA;ApF056BR;;AoF356BI;EACI,iBAAA;ApF856BR;;AoF/56BI;EACI,iBAAA;ApFk66BR;;AoFn66BI;EACI,iBAAA;ApFs66BR;;AoFv66BI;EACI,iBAAA;ApF066BR;;AoF366BI;EACI,iBAAA;ApF866BR;;AoF/66BI;EACI,iBAAA;ApFk76BR;;AoFn76BI;EACI,iBAAA;ApFs76BR;;AoFv76BI;EACI,iBAAA;ApF076BR;;AoF376BI;EACI,iBAAA;ApF876BR;;AoF/76BI;EACI,iBAAA;ApFk86BR;;AoFn86BI;EACI,iBAAA;ApFs86BR;;AoFv86BI;EACI,iBAAA;ApF086BR;;AoF386BI;EACI,iBAAA;ApF886BR;;AoF/86BI;EACI,iBAAA;ApFk96BR;;AoFn96BI;EACI,iBAAA;ApFs96BR;;AoFv96BI;EACI,iBAAA;ApF096BR;;AoF396BI;EACI,iBAAA;ApF896BR;;AoF/96BI;EACI,iBAAA;ApFk+6BR;;AoFn+6BI;EACI,iBAAA;ApFs+6BR;;AoFv+6BI;EACI,iBAAA;ApF0+6BR;;AoF3+6BI;EACI,iBAAA;ApF8+6BR;;AoF/+6BI;EACI,iBAAA;ApFk/6BR;;AoFn/6BI;EACI,iBAAA;ApFs/6BR;;AoFv/6BI;EACI,iBAAA;ApF0/6BR;;AoF3/6BI;EACI,iBAAA;ApF8/6BR;;AoF//6BI;EACI,iBAAA;ApFkg7BR;;AoFng7BI;EACI,iBAAA;ApFsg7BR;;AoFvg7BI;EACI,iBAAA;ApF0g7BR;;AoF3g7BI;EACI,iBAAA;ApF8g7BR;;AoF/g7BI;EACI,iBAAA;ApFkh7BR;;AoFnh7BI;EACI,iBAAA;ApFsh7BR;;AoFvh7BI;EACI,iBAAA;ApF0h7BR;;AoF3h7BI;EACI,iBAAA;ApF8h7BR;;AoF/h7BI;EACI,iBAAA;ApFki7BR;;AoFni7BI;EACI,iBAAA;ApFsi7BR;;AoFvi7BI;EACI,iBAAA;ApF0i7BR;;AoF3i7BI;EACI,iBAAA;ApF8i7BR;;AoF/i7BI;EACI,iBAAA;ApFkj7BR;;AoFnj7BI;EACI,iBAAA;ApFsj7BR;;AoFvj7BI;EACI,iBAAA;ApF0j7BR;;AoF3j7BI;EACI,iBAAA;ApF8j7BR;;AoF/j7BI;EACI,iBAAA;ApFkk7BR;;AoFnk7BI;EACI,iBAAA;ApFsk7BR;;AoFvk7BI;EACI,iBAAA;ApF0k7BR;;AoF3k7BI;EACI,iBAAA;ApF8k7BR;;AoF/k7BI;EACI,iBAAA;ApFkl7BR;;AoFnl7BI;EACI,iBAAA;ApFsl7BR;;AoFvl7BI;EACI,iBAAA;ApF0l7BR;;AoF3l7BI;EACI,iBAAA;ApF8l7BR;;AoF/l7BI;EACI,iBAAA;ApFkm7BR;;AoFnm7BI;EACI,iBAAA;ApFsm7BR;;AoFvm7BI;EACI,iBAAA;ApF0m7BR;;AoF3m7BI;EACI,iBAAA;ApF8m7BR;;AoF/m7BI;EACI,iBAAA;ApFkn7BR;;AoFnn7BI;EACI,iBAAA;ApFsn7BR;;AoFvn7BI;EACI,iBAAA;ApF0n7BR;;AoF3n7BI;EACI,iBAAA;ApF8n7BR;;AoF/n7BI;EACI,iBAAA;ApFko7BR;;AoFno7BI;EACI,iBAAA;ApFso7BR;;AoFvo7BI;EACI,iBAAA;ApF0o7BR;;AoF3o7BI;EACI,iBAAA;ApF8o7BR;;AoF/o7BI;EACI,iBAAA;ApFkp7BR;;AoFnp7BI;EACI,iBAAA;ApFsp7BR;;AoFvp7BI;EACI,iBAAA;ApF0p7BR;;AoF3p7BI;EACI,iBAAA;ApF8p7BR;;AoF/p7BI;EACI,iBAAA;ApFkq7BR;;AoFnq7BI;EACI,iBAAA;ApFsq7BR;;AoFvq7BI;EACI,iBAAA;ApF0q7BR;;AoF3q7BI;EACI,iBAAA;ApF8q7BR;;AoF/q7BI;EACI,iBAAA;ApFkr7BR;;AoFnr7BI;EACI,iBAAA;ApFsr7BR;;AoFvr7BI;EACI,iBAAA;ApF0r7BR;;AoF3r7BI;EACI,iBAAA;ApF8r7BR;;AoF/r7BI;EACI,iBAAA;ApFks7BR;;AoFns7BI;EACI,iBAAA;ApFss7BR;;AoFvs7BI;EACI,iBAAA;ApF0s7BR;;AoF3s7BI;EACI,iBAAA;ApF8s7BR;;AoF/s7BI;EACI,iBAAA;ApFkt7BR;;AoFnt7BI;EACI,iBAAA;ApFst7BR;;AoFvt7BI;EACI,iBAAA;ApF0t7BR;;AoF3t7BI;EACI,iBAAA;ApF8t7BR;;AoF/t7BI;EACI,iBAAA;ApFku7BR;;AoFnu7BI;EACI,iBAAA;ApFsu7BR;;AoFvu7BI;EACI,iBAAA;ApF0u7BR;;AoF3u7BI;EACI,iBAAA;ApF8u7BR;;AoF/u7BI;EACI,iBAAA;ApFkv7BR;;AoFnv7BI;EACI,iBAAA;ApFsv7BR;;AoFvv7BI;EACI,iBAAA;ApF0v7BR;;AoF3v7BI;EACI,iBAAA;ApF8v7BR;;AoF/v7BI;EACI,iBAAA;ApFkw7BR;;AoFnw7BI;EACI,iBAAA;ApFsw7BR;;AoFvw7BI;EACI,iBAAA;ApF0w7BR;;AoF3w7BI;EACI,iBAAA;ApF8w7BR;;AoF/w7BI;EACI,iBAAA;ApFkx7BR;;AoFnx7BI;EACI,iBAAA;ApFsx7BR;;AoFvx7BI;EACI,iBAAA;ApF0x7BR;;AoF3x7BI;EACI,iBAAA;ApF8x7BR;;AoF/x7BI;EACI,iBAAA;ApFky7BR;;AoFny7BI;EACI,iBAAA;ApFsy7BR;;AoFvy7BI;EACI,iBAAA;ApF0y7BR;;AoF3y7BI;EACI,iBAAA;ApF8y7BR;;AoF/y7BI;EACI,iBAAA;ApFkz7BR;;AoFnz7BI;EACI,iBAAA;ApFsz7BR;;AoFvz7BI;EACI,iBAAA;ApF0z7BR;;AoF3z7BI;EACI,iBAAA;ApF8z7BR;;AoF/z7BI;EACI,iBAAA;ApFk07BR;;AoFn07BI;EACI,iBAAA;ApFs07BR;;AoFv07BI;EACI,iBAAA;ApF007BR;;AoF307BI;EACI,iBAAA;ApF807BR;;AoF/07BI;EACI,iBAAA;ApFk17BR;;AoFn17BI;EACI,iBAAA;ApFs17BR;;AoFv17BI;EACI,iBAAA;ApF017BR;;AoF317BI;EACI,iBAAA;ApF817BR;;AoF/17BI;EACI,iBAAA;ApFk27BR;;AoFn27BI;EACI,iBAAA;ApFs27BR;;AoFv27BI;EACI,iBAAA;ApF027BR;;AoF327BI;EACI,iBAAA;ApF827BR;;AoF/27BI;EACI,iBAAA;ApFk37BR;;AoFn37BI;EACI,iBAAA;ApFs37BR;;AoFv37BI;EACI,iBAAA;ApF037BR;;AoF337BI;EACI,iBAAA;ApF837BR;;AoF/37BI;EACI,iBAAA;ApFk47BR;;AoFn47BI;EACI,iBAAA;ApFs47BR;;AoFv47BI;EACI,iBAAA;ApF047BR;;AoF347BI;EACI,iBAAA;ApF847BR;;AoF/47BI;EACI,iBAAA;ApFk57BR;;AoFn57BI;EACI,iBAAA;ApFs57BR;;AoFv57BI;EACI,iBAAA;ApF057BR;;AoF357BI;EACI,iBAAA;ApF857BR;;AoF/57BI;EACI,iBAAA;ApFk67BR;;AoFn67BI;EACI,iBAAA;ApFs67BR;;AoFv67BI;EACI,iBAAA;ApF067BR;;AoF367BI;EACI,iBAAA;ApF867BR;;AoF/67BI;EACI,iBAAA;ApFk77BR;;AoFn77BI;EACI,iBAAA;ApFs77BR;;AoFv77BI;EACI,iBAAA;ApF077BR;;AoF377BI;EACI,iBAAA;ApF877BR;;AoF/77BI;EACI,iBAAA;ApFk87BR;;AoFn87BI;EACI,iBAAA;ApFs87BR;;AoFv87BI;EACI,iBAAA;ApF087BR;;AoF387BI;EACI,iBAAA;ApF887BR;;AoF/87BI;EACI,iBAAA;ApFk97BR;;AoFn97BI;EACI,iBAAA;ApFs97BR;;AoFv97BI;EACI,iBAAA;ApF097BR;;AoF397BI;EACI,iBAAA;ApF897BR;;AoF/97BI;EACI,iBAAA;ApFk+7BR;;AoFn+7BI;EACI,iBAAA;ApFs+7BR;;AoFv+7BI;EACI,iBAAA;ApF0+7BR;;AoF3+7BI;EACI,iBAAA;ApF8+7BR;;AoF/+7BI;EACI,iBAAA;ApFk/7BR;;AoFn/7BI;EACI,iBAAA;ApFs/7BR;;AoFv/7BI;EACI,iBAAA;ApF0/7BR;;AoF3/7BI;EACI,iBAAA;ApF8/7BR;;AoF//7BI;EACI,iBAAA;ApFkg8BR;;AoFng8BI;EACI,iBAAA;ApFsg8BR;;AoFvg8BI;EACI,iBAAA;ApF0g8BR;;AoF3g8BI;EACI,iBAAA;ApF8g8BR;;AoF/g8BI;EACI,iBAAA;ApFkh8BR;;AoFnh8BI;EACI,iBAAA;ApFsh8BR;;AoFvh8BI;EACI,iBAAA;ApF0h8BR;;AoF3h8BI;EACI,iBAAA;ApF8h8BR;;AoF/h8BI;EACI,iBAAA;ApFki8BR;;AoFni8BI;EACI,iBAAA;ApFsi8BR;;AoFvi8BI;EACI,iBAAA;ApF0i8BR;;AoF3i8BI;EACI,iBAAA;ApF8i8BR;;AoF/i8BI;EACI,iBAAA;ApFkj8BR;;AoFnj8BI;EACI,iBAAA;ApFsj8BR;;AoFvj8BI;EACI,iBAAA;ApF0j8BR;;AoF3j8BI;EACI,iBAAA;ApF8j8BR;;AoF/j8BI;EACI,iBAAA;ApFkk8BR;;AoFnk8BI;EACI,iBAAA;ApFsk8BR;;AoFvk8BI;EACI,iBAAA;ApF0k8BR;;AoF3k8BI;EACI,iBAAA;ApF8k8BR;;AoF/k8BI;EACI,iBAAA;ApFkl8BR;;AoFnl8BI;EACI,iBAAA;ApFsl8BR;;AoFvl8BI;EACI,iBAAA;ApF0l8BR;;AoF3l8BI;EACI,iBAAA;ApF8l8BR;;AoF/l8BI;EACI,iBAAA;ApFkm8BR;;AoFnm8BI;EACI,iBAAA;ApFsm8BR;;AoFvm8BI;EACI,iBAAA;ApF0m8BR;;AoF3m8BI;EACI,iBAAA;ApF8m8BR;;AoF/m8BI;EACI,iBAAA;ApFkn8BR;;AoFnn8BI;EACI,iBAAA;ApFsn8BR;;AoFvn8BI;EACI,iBAAA;ApF0n8BR;;AoF3n8BI;EACI,iBAAA;ApF8n8BR;;AoF/n8BI;EACI,iBAAA;ApFko8BR;;AoFno8BI;EACI,iBAAA;ApFso8BR;;AoFvo8BI;EACI,iBAAA;ApF0o8BR;;AoF3o8BI;EACI,iBAAA;ApF8o8BR;;AoF/o8BI;EACI,iBAAA;ApFkp8BR;;AoFnp8BI;EACI,iBAAA;ApFsp8BR;;AoFvp8BI;EACI,iBAAA;ApF0p8BR;;AoF3p8BI;EACI,iBAAA;ApF8p8BR;;AoF/p8BI;EACI,iBAAA;ApFkq8BR;;AoFnq8BI;EACI,iBAAA;ApFsq8BR;;AoFvq8BI;EACI,iBAAA;ApF0q8BR;;AoF3q8BI;EACI,iBAAA;ApF8q8BR;;AoF/q8BI;EACI,iBAAA;ApFkr8BR;;AoFnr8BI;EACI,iBAAA;ApFsr8BR;;AoFvr8BI;EACI,iBAAA;ApF0r8BR;;AoF3r8BI;EACI,iBAAA;ApF8r8BR;;AoF/r8BI;EACI,iBAAA;ApFks8BR;;AoFns8BI;EACI,iBAAA;ApFss8BR;;AoFvs8BI;EACI,iBAAA;ApF0s8BR;;AoF3s8BI;EACI,iBAAA;ApF8s8BR;;AoF/s8BI;EACI,iBAAA;ApFkt8BR;;AoFnt8BI;EACI,iBAAA;ApFst8BR;;AoFvt8BI;EACI,iBAAA;ApF0t8BR;;AoF3t8BI;EACI,iBAAA;ApF8t8BR;;AoF/t8BI;EACI,iBAAA;ApFku8BR;;AoFnu8BI;EACI,iBAAA;ApFsu8BR;;AoFvu8BI;EACI,iBAAA;ApF0u8BR;;AoF3u8BI;EACI,iBAAA;ApF8u8BR;;AoF/u8BI;EACI,iBAAA;ApFkv8BR;;AoFnv8BI;EACI,iBAAA;ApFsv8BR;;AoFvv8BI;EACI,iBAAA;ApF0v8BR;;AoF3v8BI;EACI,iBAAA;ApF8v8BR;;AoF/v8BI;EACI,iBAAA;ApFkw8BR;;AoFnw8BI;EACI,iBAAA;ApFsw8BR;;AoFvw8BI;EACI,iBAAA;ApF0w8BR;;AoF3w8BI;EACI,iBAAA;ApF8w8BR;;AoF/w8BI;EACI,iBAAA;ApFkx8BR;;AoFnx8BI;EACI,iBAAA;ApFsx8BR;;AoFvx8BI;EACI,iBAAA;ApF0x8BR;;AoF3x8BI;EACI,iBAAA;ApF8x8BR;;AoF/x8BI;EACI,iBAAA;ApFky8BR;;AoFny8BI;EACI,iBAAA;ApFsy8BR;;AoFvy8BI;EACI,iBAAA;ApF0y8BR;;AoF3y8BI;EACI,iBAAA;ApF8y8BR;;AoF/y8BI;EACI,iBAAA;ApFkz8BR;;AoFnz8BI;EACI,iBAAA;ApFsz8BR;;AoFvz8BI;EACI,iBAAA;ApF0z8BR;;AoF3z8BI;EACI,iBAAA;ApF8z8BR;;AoF/z8BI;EACI,iBAAA;ApFk08BR;;AoFn08BI;EACI,iBAAA;ApFs08BR;;AoFv08BI;EACI,iBAAA;ApF008BR;;AoF308BI;EACI,iBAAA;ApF808BR;;AoF/08BI;EACI,iBAAA;ApFk18BR;;AoFn18BI;EACI,iBAAA;ApFs18BR;;AoFv18BI;EACI,iBAAA;ApF018BR;;AoF318BI;EACI,iBAAA;ApF818BR;;AoF/18BI;EACI,iBAAA;ApFk28BR;;AoFn28BI;EACI,iBAAA;ApFs28BR;;AoFv28BI;EACI,iBAAA;ApF028BR;;AoF328BI;EACI,iBAAA;ApF828BR;;AoF/28BI;EACI,iBAAA;ApFk38BR;;AoFn38BI;EACI,iBAAA;ApFs38BR;;AoFv38BI;EACI,iBAAA;ApF038BR;;AoF338BI;EACI,iBAAA;ApF838BR;;AoF/38BI;EACI,iBAAA;ApFk48BR;;AoFn48BI;EACI,iBAAA;ApFs48BR;;AoFv48BI;EACI,iBAAA;ApF048BR;;AoF348BI;EACI,iBAAA;ApF848BR;;AoF/48BI;EACI,iBAAA;ApFk58BR;;AoFn58BI;EACI,iBAAA;ApFs58BR;;AoFv58BI;EACI,iBAAA;ApF058BR;;AoF358BI;EACI,iBAAA;ApF858BR;;AoF/58BI;EACI,iBAAA;ApFk68BR;;AoFn68BI;EACI,iBAAA;ApFs68BR;;AoFv68BI;EACI,iBAAA;ApF068BR;;AoF368BI;EACI,iBAAA;ApF868BR;;AoF/68BI;EACI,iBAAA;ApFk78BR;;AoFn78BI;EACI,iBAAA;ApFs78BR;;AoFv78BI;EACI,iBAAA;ApF078BR;;AoF378BI;EACI,iBAAA;ApF878BR;;AoF/78BI;EACI,iBAAA;ApFk88BR;;AoFn88BI;EACI,iBAAA;ApFs88BR;;AoFv88BI;EACI,iBAAA;ApF088BR;;AoF388BI;EACI,iBAAA;ApF888BR;;AoF/88BI;EACI,iBAAA;ApFk98BR;;AoFn98BI;EACI,iBAAA;ApFs98BR;;AoFv98BI;EACI,iBAAA;ApF098BR;;AoF398BI;EACI,iBAAA;ApF898BR;;AoF/98BI;EACI,iBAAA;ApFk+8BR;;AoFn+8BI;EACI,iBAAA;ApFs+8BR;;AoFv+8BI;EACI,iBAAA;ApF0+8BR;;AoF3+8BI;EACI,iBAAA;ApF8+8BR;;AoF/+8BI;EACI,iBAAA;ApFk/8BR;;AoFn/8BI;EACI,iBAAA;ApFs/8BR;;AoFv/8BI;EACI,iBAAA;ApF0/8BR;;AoF3/8BI;EACI,iBAAA;ApF8/8BR;;AoF//8BI;EACI,iBAAA;ApFkg9BR;;AoFng9BI;EACI,iBAAA;ApFsg9BR;;AoFvg9BI;EACI,iBAAA;ApF0g9BR;;AoF3g9BI;EACI,iBAAA;ApF8g9BR;;AoF/g9BI;EACI,iBAAA;ApFkh9BR;;AoFnh9BI;EACI,iBAAA;ApFsh9BR;;AoFvh9BI;EACI,iBAAA;ApF0h9BR;;AoF3h9BI;EACI,iBAAA;ApF8h9BR;;AoF/h9BI;EACI,iBAAA;ApFki9BR;;AoFni9BI;EACI,iBAAA;ApFsi9BR;;AoFvi9BI;EACI,iBAAA;ApF0i9BR;;AoF3i9BI;EACI,iBAAA;ApF8i9BR;;AoF/i9BI;EACI,iBAAA;ApFkj9BR;;AoFnj9BI;EACI,iBAAA;ApFsj9BR;;AoFvj9BI;EACI,iBAAA;ApF0j9BR;;AoF3j9BI;EACI,iBAAA;ApF8j9BR;;AoF/j9BI;EACI,iBAAA;ApFkk9BR;;AoFnk9BI;EACI,iBAAA;ApFsk9BR;;AoFvk9BI;EACI,iBAAA;ApF0k9BR;;AoF3k9BI;EACI,iBAAA;ApF8k9BR;;AoF/k9BI;EACI,iBAAA;ApFkl9BR;;AoFnl9BI;EACI,iBAAA;ApFsl9BR;;AoFvl9BI;EACI,iBAAA;ApF0l9BR;;AoF3l9BI;EACI,iBAAA;ApF8l9BR;;AoF/l9BI;EACI,iBAAA;ApFkm9BR;;AoFnm9BI;EACI,iBAAA;ApFsm9BR;;AoFvm9BI;EACI,iBAAA;ApF0m9BR;;AoF3m9BI;EACI,iBAAA;ApF8m9BR;;AoF/m9BI;EACI,iBAAA;ApFkn9BR;;AoFnn9BI;EACI,iBAAA;ApFsn9BR;;AoFvn9BI;EACI,iBAAA;ApF0n9BR;;AoF3n9BI;EACI,iBAAA;ApF8n9BR;;AoF/n9BI;EACI,iBAAA;ApFko9BR;;AoFno9BI;EACI,iBAAA;ApFso9BR;;AoFvo9BI;EACI,iBAAA;ApF0o9BR;;AoF3o9BI;EACI,iBAAA;ApF8o9BR;;AoF/o9BI;EACI,iBAAA;ApFkp9BR;;AoFnp9BI;EACI,iBAAA;ApFsp9BR;;AoFvp9BI;EACI,iBAAA;ApF0p9BR;;AoF3p9BI;EACI,iBAAA;ApF8p9BR;;AoF/p9BI;EACI,iBAAA;ApFkq9BR;;AoFnq9BI;EACI,iBAAA;ApFsq9BR;;AoFvq9BI;EACI,iBAAA;ApF0q9BR;;AoF3q9BI;EACI,iBAAA;ApF8q9BR;;AoF/q9BI;EACI,iBAAA;ApFkr9BR;;AoFnr9BI;EACI,iBAAA;ApFsr9BR;;AoFvr9BI;EACI,iBAAA;ApF0r9BR;;AoF3r9BI;EACI,iBAAA;ApF8r9BR;;AoF/r9BI;EACI,iBAAA;ApFks9BR;;AoFns9BI;EACI,iBAAA;ApFss9BR;;AoFvs9BI;EACI,iBAAA;ApF0s9BR;;AoF3s9BI;EACI,iBAAA;ApF8s9BR;;AoF/s9BI;EACI,iBAAA;ApFkt9BR;;AoFnt9BI;EACI,iBAAA;ApFst9BR;;AoFvt9BI;EACI,iBAAA;ApF0t9BR;;AoF3t9BI;EACI,iBAAA;ApF8t9BR;;AoF/t9BI;EACI,iBAAA;ApFku9BR;;AoFnu9BI;EACI,iBAAA;ApFsu9BR;;AoFvu9BI;EACI,iBAAA;ApF0u9BR;;AoF3u9BI;EACI,iBAAA;ApF8u9BR;;AoF/u9BI;EACI,iBAAA;ApFkv9BR;;AoFnv9BI;EACI,iBAAA;ApFsv9BR;;AoFvv9BI;EACI,iBAAA;ApF0v9BR;;AoF3v9BI;EACI,iBAAA;ApF8v9BR;;AoF/v9BI;EACI,iBAAA;ApFkw9BR;;AoFnw9BI;EACI,iBAAA;ApFsw9BR;;AoFvw9BI;EACI,iBAAA;ApF0w9BR;;AoF3w9BI;EACI,iBAAA;ApF8w9BR;;AoF/w9BI;EACI,iBAAA;ApFkx9BR;;AoFnx9BI;EACI,iBAAA;ApFsx9BR;;AoFvx9BI;EACI,iBAAA;ApF0x9BR;;AoF3x9BI;EACI,iBAAA;ApF8x9BR;;AoF/x9BI;EACI,iBAAA;ApFky9BR;;AoFny9BI;EACI,iBAAA;ApFsy9BR;;AoFvy9BI;EACI,iBAAA;ApF0y9BR;;AoF3y9BI;EACI,iBAAA;ApF8y9BR;;AoF/y9BI;EACI,iBAAA;ApFkz9BR;;AoFnz9BI;EACI,iBAAA;ApFsz9BR;;AoFvz9BI;EACI,iBAAA;ApF0z9BR;;AoF3z9BI;EACI,iBAAA;ApF8z9BR;;AoF/z9BI;EACI,iBAAA;ApFk09BR;;AoFn09BI;EACI,iBAAA;ApFs09BR;;AoFv09BI;EACI,iBAAA;ApF009BR;;AoF309BI;EACI,iBAAA;ApF809BR;;AoF/09BI;EACI,iBAAA;ApFk19BR;;AoFn19BI;EACI,iBAAA;ApFs19BR;;AoFv19BI;EACI,iBAAA;ApF019BR;;AoF319BI;EACI,iBAAA;ApF819BR;;AoF/19BI;EACI,iBAAA;ApFk29BR;;AoFn29BI;EACI,iBAAA;ApFs29BR;;AoFv29BI;EACI,iBAAA;ApF029BR;;AoF329BI;EACI,iBAAA;ApF829BR;;AoF/29BI;EACI,iBAAA;ApFk39BR;;AoFn39BI;EACI,iBAAA;ApFs39BR;;AoFv39BI;EACI,iBAAA;ApF039BR;;AoF339BI;EACI,iBAAA;ApF839BR;;AoF/39BI;EACI,iBAAA;ApFk49BR;;AoFn49BI;EACI,iBAAA;ApFs49BR;;AoFv49BI;EACI,iBAAA;ApF049BR;;AoF349BI;EACI,iBAAA;ApF849BR;;AoF/49BI;EACI,iBAAA;ApFk59BR;;AoFn59BI;EACI,iBAAA;ApFs59BR;;AoFv59BI;EACI,iBAAA;ApF059BR;;AoF359BI;EACI,iBAAA;ApF859BR;;AoF/59BI;EACI,iBAAA;ApFk69BR;;AoFn69BI;EACI,iBAAA;ApFs69BR;;AoFv69BI;EACI,iBAAA;ApF069BR;;AoF369BI;EACI,iBAAA;ApF869BR;;AoF/69BI;EACI,iBAAA;ApFk79BR;;AoFn79BI;EACI,iBAAA;ApFs79BR;;AoFv79BI;EACI,iBAAA;ApF079BR;;AoF379BI;EACI,iBAAA;ApF879BR;;AoF/79BI;EACI,iBAAA;ApFk89BR;;AoFn89BI;EACI,iBAAA;ApFs89BR;;AoFv89BI;EACI,iBAAA;ApF089BR;;AoF389BI;EACI,iBAAA;ApF889BR;;AoF/89BI;EACI,iBAAA;ApFk99BR;;AoFn99BI;EACI,iBAAA;ApFs99BR;;AoFv99BI;EACI,iBAAA;ApF099BR;;AoF399BI;EACI,iBAAA;ApF899BR;;AoF/99BI;EACI,iBAAA;ApFk+9BR;;AoFn+9BI;EACI,iBAAA;ApFs+9BR;;AoFv+9BI;EACI,iBAAA;ApF0+9BR;;AoF3+9BI;EACI,iBAAA;ApF8+9BR;;AoF/+9BI;EACI,iBAAA;ApFk/9BR;;AoFn/9BI;EACI,iBAAA;ApFs/9BR;;AoFv/9BI;EACI,iBAAA;ApF0/9BR;;AoF3/9BI;EACI,iBAAA;ApF8/9BR;;AoF//9BI;EACI,iBAAA;ApFkg+BR;;AoFng+BI;EACI,iBAAA;ApFsg+BR;;AoFvg+BI;EACI,iBAAA;ApF0g+BR;;AoF3g+BI;EACI,iBAAA;ApF8g+BR;;AoF/g+BI;EACI,iBAAA;ApFkh+BR;;AoFnh+BI;EACI,iBAAA;ApFsh+BR;;AoFvh+BI;EACI,iBAAA;ApF0h+BR;;AoF3h+BI;EACI,iBAAA;ApF8h+BR;;AoF/h+BI;EACI,iBAAA;ApFki+BR;;AoFni+BI;EACI,iBAAA;ApFsi+BR;;AoFvi+BI;EACI,iBAAA;ApF0i+BR;;AoF3i+BI;EACI,iBAAA;ApF8i+BR;;AoF/i+BI;EACI,iBAAA;ApFkj+BR;;AoFnj+BI;EACI,iBAAA;ApFsj+BR;;AoFvj+BI;EACI,iBAAA;ApF0j+BR;;AoF3j+BI;EACI,iBAAA;ApF8j+BR;;AoF/j+BI;EACI,iBAAA;ApFkk+BR;;AoFnk+BI;EACI,iBAAA;ApFsk+BR;;AoFvk+BI;EACI,iBAAA;ApF0k+BR;;AoF3k+BI;EACI,iBAAA;ApF8k+BR;;AoF/k+BI;EACI,iBAAA;ApFkl+BR;;AoFnl+BI;EACI,iBAAA;ApFsl+BR;;AoFvl+BI;EACI,iBAAA;ApF0l+BR;;AoF3l+BI;EACI,iBAAA;ApF8l+BR;;AoF/l+BI;EACI,iBAAA;ApFkm+BR;;AoFnm+BI;EACI,iBAAA;ApFsm+BR;;AoFvm+BI;EACI,iBAAA;ApF0m+BR;;AoF3m+BI;EACI,iBAAA;ApF8m+BR;;AoF/m+BI;EACI,iBAAA;ApFkn+BR;;AoFnn+BI;EACI,iBAAA;ApFsn+BR;;AoFvn+BI;EACI,iBAAA;ApF0n+BR;;AoF3n+BI;EACI,iBAAA;ApF8n+BR;;AoF/n+BI;EACI,iBAAA;ApFko+BR;;AoFno+BI;EACI,iBAAA;ApFso+BR;;AoFvo+BI;EACI,iBAAA;ApF0o+BR;;AoF3o+BI;EACI,iBAAA;ApF8o+BR;;AoF/o+BI;EACI,iBAAA;ApFkp+BR;;AoFnp+BI;EACI,iBAAA;ApFsp+BR;;AoFvp+BI;EACI,iBAAA;ApF0p+BR;;AoF3p+BI;EACI,iBAAA;ApF8p+BR;;AoF/p+BI;EACI,iBAAA;ApFkq+BR;;AoFnq+BI;EACI,iBAAA;ApFsq+BR;;AoFvq+BI;EACI,iBAAA;ApF0q+BR;;AoF3q+BI;EACI,iBAAA;ApF8q+BR;;AoF/q+BI;EACI,iBAAA;ApFkr+BR;;AoFnr+BI;EACI,iBAAA;ApFsr+BR;;AoFvr+BI;EACI,iBAAA;ApF0r+BR;;AoF3r+BI;EACI,iBAAA;ApF8r+BR;;AoF/r+BI;EACI,iBAAA;ApFks+BR;;AoFns+BI;EACI,iBAAA;ApFss+BR;;AoFvs+BI;EACI,iBAAA;ApF0s+BR;;AoF3s+BI;EACI,iBAAA;ApF8s+BR;;AoF/s+BI;EACI,iBAAA;ApFkt+BR;;AoFnt+BI;EACI,iBAAA;ApFst+BR;;AoFvt+BI;EACI,iBAAA;ApF0t+BR;;AoF3t+BI;EACI,iBAAA;ApF8t+BR;;AoF/t+BI;EACI,iBAAA;ApFku+BR;;AoFnu+BI;EACI,iBAAA;ApFsu+BR;;AoFvu+BI;EACI,iBAAA;ApF0u+BR;;AoF3u+BI;EACI,iBAAA;ApF8u+BR;;AoF/u+BI;EACI,iBAAA;ApFkv+BR;;AoFnv+BI;EACI,iBAAA;ApFsv+BR;;AoFvv+BI;EACI,iBAAA;ApF0v+BR;;AoF3v+BI;EACI,iBAAA;ApF8v+BR;;AoF/v+BI;EACI,iBAAA;ApFkw+BR;;AoFnw+BI;EACI,iBAAA;ApFsw+BR;;AoFvw+BI;EACI,iBAAA;ApF0w+BR;;AoF3w+BI;EACI,iBAAA;ApF8w+BR;;AoF/w+BI;EACI,iBAAA;ApFkx+BR;;AoFnx+BI;EACI,iBAAA;ApFsx+BR;;AoFvx+BI;EACI,iBAAA;ApF0x+BR;;AoF3x+BI;EACI,iBAAA;ApF8x+BR;;AoF/x+BI;EACI,iBAAA;ApFky+BR;;AoFny+BI;EACI,iBAAA;ApFsy+BR;;AoFvy+BI;EACI,iBAAA;ApF0y+BR;;AoF3y+BI;EACI,iBAAA;ApF8y+BR;;AoF/y+BI;EACI,iBAAA;ApFkz+BR;;AoFnz+BI;EACI,iBAAA;ApFsz+BR;;AoFvz+BI;EACI,iBAAA;ApF0z+BR;;AoF3z+BI;EACI,iBAAA;ApF8z+BR;;AoF/z+BI;EACI,iBAAA;ApFk0+BR;;AoFn0+BI;EACI,iBAAA;ApFs0+BR;;AoFv0+BI;EACI,iBAAA;ApF00+BR;;AoF30+BI;EACI,iBAAA;ApF80+BR;;AoF/0+BI;EACI,iBAAA;ApFk1+BR;;AoFn1+BI;EACI,iBAAA;ApFs1+BR;;AoFv1+BI;EACI,iBAAA;ApF01+BR;;AoF31+BI;EACI,iBAAA;ApF81+BR;;AoF/1+BI;EACI,iBAAA;ApFk2+BR;;AoFn2+BI;EACI,iBAAA;ApFs2+BR;;AoFv2+BI;EACI,iBAAA;ApF02+BR;;AoF32+BI;EACI,iBAAA;ApF82+BR;;AoF/2+BI;EACI,iBAAA;ApFk3+BR;;AoFn3+BI;EACI,iBAAA;ApFs3+BR;;AoFv3+BI;EACI,iBAAA;ApF03+BR;;AoF33+BI;EACI,iBAAA;ApF83+BR;;AoF/3+BI;EACI,iBAAA;ApFk4+BR;;AoFn4+BI;EACI,iBAAA;ApFs4+BR;;AoFv4+BI;EACI,iBAAA;ApF04+BR;;AoF34+BI;EACI,iBAAA;ApF84+BR;;AoF/4+BI;EACI,iBAAA;ApFk5+BR;;AoFn5+BI;EACI,iBAAA;ApFs5+BR;;AoFv5+BI;EACI,iBAAA;ApF05+BR;;AoF35+BI;EACI,iBAAA;ApF85+BR;;AoF/5+BI;EACI,iBAAA;ApFk6+BR;;AoFn6+BI;EACI,iBAAA;ApFs6+BR;;AoFv6+BI;EACI,iBAAA;ApF06+BR;;AoF36+BI;EACI,iBAAA;ApF86+BR;;AoF/6+BI;EACI,iBAAA;ApFk7+BR;;AoFn7+BI;EACI,iBAAA;ApFs7+BR;;AoFv7+BI;EACI,iBAAA;ApF07+BR;;AoF37+BI;EACI,iBAAA;ApF87+BR;;AoF/7+BI;EACI,iBAAA;ApFk8+BR;;AoFn8+BI;EACI,iBAAA;ApFs8+BR;;AoFv8+BI;EACI,iBAAA;ApF08+BR;;AoF38+BI;EACI,iBAAA;ApF88+BR;;AoF/8+BI;EACI,iBAAA;ApFk9+BR;;AoFn9+BI;EACI,iBAAA;ApFs9+BR;;AoFv9+BI;EACI,iBAAA;ApF09+BR;;AoF39+BI;EACI,iBAAA;ApF89+BR;;AoF/9+BI;EACI,iBAAA;ApFk++BR;;AoFn++BI;EACI,iBAAA;ApFs++BR;;AoFv++BI;EACI,iBAAA;ApF0++BR;;AoF3++BI;EACI,iBAAA;ApF8++BR;;AoF/++BI;EACI,iBAAA;ApFk/+BR;;AoFn/+BI;EACI,iBAAA;ApFs/+BR;;AoFv/+BI;EACI,iBAAA;ApF0/+BR;;AoF3/+BI;EACI,iBAAA;ApF8/+BR;;AoF//+BI;EACI,iBAAA;ApFkg/BR;;AoFng/BI;EACI,iBAAA;ApFsg/BR;;AoFvg/BI;EACI,iBAAA;ApF0g/BR;;AoF3g/BI;EACI,iBAAA;ApF8g/BR;;AoF/g/BI;EACI,iBAAA;ApFkh/BR;;AoFnh/BI;EACI,iBAAA;ApFsh/BR;;AoFvh/BI;EACI,iBAAA;ApF0h/BR;;AoF3h/BI;EACI,iBAAA;ApF8h/BR;;AoF/h/BI;EACI,iBAAA;ApFki/BR;;AoFni/BI;EACI,iBAAA;ApFsi/BR;;AoFvi/BI;EACI,iBAAA;ApF0i/BR;;AoF3i/BI;EACI,iBAAA;ApF8i/BR;;AoF/i/BI;EACI,iBAAA;ApFkj/BR;;AoFnj/BI;EACI,iBAAA;ApFsj/BR;;AoFvj/BI;EACI,iBAAA;ApF0j/BR;;AoF3j/BI;EACI,iBAAA;ApF8j/BR;;AoF/j/BI;EACI,iBAAA;ApFkk/BR;;AoFnk/BI;EACI,iBAAA;ApFsk/BR;;AoFvk/BI;EACI,iBAAA;ApF0k/BR;;AoF3k/BI;EACI,iBAAA;ApF8k/BR;;AoF/k/BI;EACI,iBAAA;ApFkl/BR;;AoFnl/BI;EACI,iBAAA;ApFsl/BR;;AoFvl/BI;EACI,iBAAA;ApF0l/BR;;AoF3l/BI;EACI,iBAAA;ApF8l/BR;;AoF/l/BI;EACI,iBAAA;ApFkm/BR;;AoFnm/BI;EACI,iBAAA;ApFsm/BR;;AoFvm/BI;EACI,iBAAA;ApF0m/BR;;AoF3m/BI;EACI,iBAAA;ApF8m/BR;;AoF/m/BI;EACI,iBAAA;ApFkn/BR;;AoFnn/BI;EACI,iBAAA;ApFsn/BR;;AoFvn/BI;EACI,iBAAA;ApF0n/BR;;AoF3n/BI;EACI,iBAAA;ApF8n/BR;;AoF/n/BI;EACI,iBAAA;ApFko/BR;;AoFno/BI;EACI,iBAAA;ApFso/BR;;AoFvo/BI;EACI,iBAAA;ApF0o/BR;;AoF3o/BI;EACI,iBAAA;ApF8o/BR;;AoF/o/BI;EACI,iBAAA;ApFkp/BR;;AoFnp/BI;EACI,iBAAA;ApFsp/BR;;AoFvp/BI;EACI,iBAAA;ApF0p/BR;;AoF3p/BI;EACI,iBAAA;ApF8p/BR;;AoF/p/BI;EACI,iBAAA;ApFkq/BR;;AoFnq/BI;EACI,iBAAA;ApFsq/BR;;AoFvq/BI;EACI,iBAAA;ApF0q/BR;;AoF3q/BI;EACI,iBAAA;ApF8q/BR;;AoF/q/BI;EACI,iBAAA;ApFkr/BR;;AoFnr/BI;EACI,iBAAA;ApFsr/BR;;AoFvr/BI;EACI,iBAAA;ApF0r/BR;;AoF3r/BI;EACI,iBAAA;ApF8r/BR;;AoF/r/BI;EACI,iBAAA;ApFks/BR;;AoFns/BI;EACI,iBAAA;ApFss/BR;;AoFvs/BI;EACI,iBAAA;ApF0s/BR;;AoF3s/BI;EACI,iBAAA;ApF8s/BR;;AoF/s/BI;EACI,iBAAA;ApFkt/BR;;AoFnt/BI;EACI,iBAAA;ApFst/BR;;AoFvt/BI;EACI,iBAAA;ApF0t/BR;;AoF3t/BI;EACI,iBAAA;ApF8t/BR;;AoF/t/BI;EACI,iBAAA;ApFku/BR;;AoFnu/BI;EACI,iBAAA;ApFsu/BR;;AoFvu/BI;EACI,iBAAA;ApF0u/BR;;AoF3u/BI;EACI,iBAAA;ApF8u/BR;;AoF/u/BI;EACI,iBAAA;ApFkv/BR;;AoFnv/BI;EACI,iBAAA;ApFsv/BR;;AoFvv/BI;EACI,iBAAA;ApF0v/BR;;AoF3v/BI;EACI,iBAAA;ApF8v/BR;;AoF/v/BI;EACI,iBAAA;ApFkw/BR;;AoFnw/BI;EACI,iBAAA;ApFsw/BR;;AoFvw/BI;EACI,iBAAA;ApF0w/BR;;AoF3w/BI;EACI,iBAAA;ApF8w/BR;;AoF/w/BI;EACI,iBAAA;ApFkx/BR;;AoFnx/BI;EACI,iBAAA;ApFsx/BR;;AoFvx/BI;EACI,iBAAA;ApF0x/BR;;AoF3x/BI;EACI,iBAAA;ApF8x/BR;;AoF/x/BI;EACI,iBAAA;ApFky/BR;;AoFny/BI;EACI,iBAAA;ApFsy/BR;;AoFvy/BI;EACI,iBAAA;ApF0y/BR;;AoF3y/BI;EACI,iBAAA;ApF8y/BR;;AoF/y/BI;EACI,iBAAA;ApFkz/BR;;AoFnz/BI;EACI,iBAAA;ApFsz/BR;;AoFvz/BI;EACI,iBAAA;ApF0z/BR;;AoF3z/BI;EACI,iBAAA;ApF8z/BR;;AoF/z/BI;EACI,iBAAA;ApFk0/BR;;AoFn0/BI;EACI,iBAAA;ApFs0/BR;;AoFv0/BI;EACI,iBAAA;ApF00/BR;;AoF30/BI;EACI,iBAAA;ApF80/BR;;AoF/0/BI;EACI,iBAAA;ApFk1/BR;;AoFn1/BI;EACI,iBAAA;ApFs1/BR;;AoFv1/BI;EACI,iBAAA;ApF01/BR;;AoF31/BI;EACI,iBAAA;ApF81/BR;;AoF/1/BI;EACI,iBAAA;ApFk2/BR;;AoFn2/BI;EACI,iBAAA;ApFs2/BR;;AoFv2/BI;EACI,iBAAA;ApF02/BR;;AoF32/BI;EACI,iBAAA;ApF82/BR;;AoF/2/BI;EACI,iBAAA;ApFk3/BR;;AoFn3/BI;EACI,iBAAA;ApFs3/BR;;AoFv3/BI;EACI,iBAAA;ApF03/BR;;AoF33/BI;EACI,iBAAA;ApF83/BR;;AoF/3/BI;EACI,iBAAA;ApFk4/BR;;AoFn4/BI;EACI,iBAAA;ApFs4/BR;;AoFv4/BI;EACI,iBAAA;ApF04/BR;;AoF34/BI;EACI,iBAAA;ApF84/BR;;AoF/4/BI;EACI,iBAAA;ApFk5/BR;;AoFn5/BI;EACI,iBAAA;ApFs5/BR;;AoFv5/BI;EACI,iBAAA;ApF05/BR;;AoF35/BI;EACI,iBAAA;ApF85/BR;;AoF/5/BI;EACI,iBAAA;ApFk6/BR;;AoFn6/BI;EACI,iBAAA;ApFs6/BR;;AoFv6/BI;EACI,iBAAA;ApF06/BR;;AoF36/BI;EACI,iBAAA;ApF86/BR;;AoF/6/BI;EACI,iBAAA;ApFk7/BR;;AoFn7/BI;EACI,iBAAA;ApFs7/BR;;AoFv7/BI;EACI,iBAAA;ApF07/BR;;AoF37/BI;EACI,iBAAA;ApF87/BR;;AoF/7/BI;EACI,iBAAA;ApFk8/BR;;AoFn8/BI;EACI,iBAAA;ApFs8/BR;;AoFv8/BI;EACI,iBAAA;ApF08/BR;;AoF38/BI;EACI,iBAAA;ApF88/BR;;AoF/8/BI;EACI,iBAAA;ApFk9/BR;;AoFn9/BI;EACI,iBAAA;ApFs9/BR;;AoFv9/BI;EACI,iBAAA;ApF09/BR;;AoF39/BI;EACI,iBAAA;ApF89/BR;;AoF/9/BI;EACI,iBAAA;ApFk+/BR;;AoFn+/BI;EACI,iBAAA;ApFs+/BR;;AoFv+/BI;EACI,iBAAA;ApF0+/BR;;AoF3+/BI;EACI,iBAAA;ApF8+/BR;;AoF/+/BI;EACI,iBAAA;ApFk//BR;;AoFn//BI;EACI,iBAAA;ApFs//BR;;AoFv//BI;EACI,iBAAA;ApF0//BR;;AoF3//BI;EACI,iBAAA;ApF8//BR;;AoF///BI;EACI,iBAAA;ApFkggCR;;AoFnggCI;EACI,iBAAA;ApFsggCR;;AoFvggCI;EACI,iBAAA;ApF0ggCR;;AoF3ggCI;EACI,iBAAA;ApF8ggCR;;AoF/ggCI;EACI,iBAAA;ApFkhgCR;;AoFnhgCI;EACI,iBAAA;ApFshgCR;;AoFvhgCI;EACI,iBAAA;ApF0hgCR;;AoF3hgCI;EACI,iBAAA;ApF8hgCR;;AoF/hgCI;EACI,iBAAA;ApFkigCR;;AoFnigCI;EACI,iBAAA;ApFsigCR;;AoFvigCI;EACI,iBAAA;ApF0igCR;;AoF3igCI;EACI,iBAAA;ApF8igCR;;AoF/igCI;EACI,iBAAA;ApFkjgCR;;AoFnjgCI;EACI,iBAAA;ApFsjgCR;;AoFvjgCI;EACI,iBAAA;ApF0jgCR;;AoF3jgCI;EACI,iBAAA;ApF8jgCR;;AoF/jgCI;EACI,iBAAA;ApFkkgCR;;AoFnkgCI;EACI,iBAAA;ApFskgCR;;AoFvkgCI;EACI,iBAAA;ApF0kgCR;;AoF3kgCI;EACI,iBAAA;ApF8kgCR;;AoF/kgCI;EACI,iBAAA;ApFklgCR;;AoFnlgCI;EACI,iBAAA;ApFslgCR;;AoFvlgCI;EACI,iBAAA;ApF0lgCR;;AoF3lgCI;EACI,iBAAA;ApF8lgCR;;AoF/lgCI;EACI,iBAAA;ApFkmgCR;;AoFnmgCI;EACI,iBAAA;ApFsmgCR;;AoFvmgCI;EACI,iBAAA;ApF0mgCR;;AoF3mgCI;EACI,iBAAA;ApF8mgCR;;AoF/mgCI;EACI,iBAAA;ApFkngCR;;AoFnngCI;EACI,iBAAA;ApFsngCR;;AoFvngCI;EACI,iBAAA;ApF0ngCR;;AoF3ngCI;EACI,iBAAA;ApF8ngCR;;AoF/ngCI;EACI,iBAAA;ApFkogCR;;AoFnogCI;EACI,iBAAA;ApFsogCR;;AoFvogCI;EACI,iBAAA;ApF0ogCR;;AoF3ogCI;EACI,iBAAA;ApF8ogCR;;AoF/ogCI;EACI,iBAAA;ApFkpgCR;;AoFnpgCI;EACI,iBAAA;ApFspgCR;;AoFvpgCI;EACI,iBAAA;ApF0pgCR;;AoF3pgCI;EACI,iBAAA;ApF8pgCR;;AoF/pgCI;EACI,iBAAA;ApFkqgCR;;AoFnqgCI;EACI,iBAAA;ApFsqgCR;;AoFvqgCI;EACI,iBAAA;ApF0qgCR;;AoF3qgCI;EACI,iBAAA;ApF8qgCR;;AoF/qgCI;EACI,iBAAA;ApFkrgCR;;AoFnrgCI;EACI,iBAAA;ApFsrgCR;;AoFvrgCI;EACI,iBAAA;ApF0rgCR;;AoF3rgCI;EACI,iBAAA;ApF8rgCR;;AoF/rgCI;EACI,iBAAA;ApFksgCR;;AoFnsgCI;EACI,iBAAA;ApFssgCR;;AoFvsgCI;EACI,iBAAA;ApF0sgCR;;AoF3sgCI;EACI,iBAAA;ApF8sgCR;;AoF/sgCI;EACI,iBAAA;ApFktgCR;;AoFntgCI;EACI,iBAAA;ApFstgCR;;AoFvtgCI;EACI,iBAAA;ApF0tgCR;;AoF3tgCI;EACI,iBAAA;ApF8tgCR;;AoF/tgCI;EACI,iBAAA;ApFkugCR;;AoFnugCI;EACI,iBAAA;ApFsugCR;;AoFvugCI;EACI,iBAAA;ApF0ugCR;;AoF3ugCI;EACI,iBAAA;ApF8ugCR;;AoF/ugCI;EACI,iBAAA;ApFkvgCR;;AoFnvgCI;EACI,iBAAA;ApFsvgCR;;AoFvvgCI;EACI,iBAAA;ApF0vgCR;;AoF3vgCI;EACI,iBAAA;ApF8vgCR;;AoF/vgCI;EACI,iBAAA;ApFkwgCR;;AoFnwgCI;EACI,iBAAA;ApFswgCR;;AoFvwgCI;EACI,iBAAA;ApF0wgCR;;AoF3wgCI;EACI,iBAAA;ApF8wgCR;;AoF/wgCI;EACI,iBAAA;ApFkxgCR;;AoFnxgCI;EACI,iBAAA;ApFsxgCR;;AoFvxgCI;EACI,iBAAA;ApF0xgCR;;AoF3xgCI;EACI,iBAAA;ApF8xgCR;;AoF/xgCI;EACI,iBAAA;ApFkygCR;;AoFnygCI;EACI,iBAAA;ApFsygCR;;AoFvygCI;EACI,iBAAA;ApF0ygCR;;AoF3ygCI;EACI,iBAAA;ApF8ygCR;;AoF/ygCI;EACI,iBAAA;ApFkzgCR;;AoFnzgCI;EACI,iBAAA;ApFszgCR;;AoFvzgCI;EACI,iBAAA;ApF0zgCR;;AoF3zgCI;EACI,iBAAA;ApF8zgCR;;AoF/zgCI;EACI,iBAAA;ApFk0gCR;;AoFn0gCI;EACI,iBAAA;ApFs0gCR;;AoFv0gCI;EACI,iBAAA;ApF00gCR;;AoF30gCI;EACI,iBAAA;ApF80gCR;;AoF/0gCI;EACI,iBAAA;ApFk1gCR;;AoFn1gCI;EACI,iBAAA;ApFs1gCR;;AoFv1gCI;EACI,iBAAA;ApF01gCR;;AoF31gCI;EACI,iBAAA;ApF81gCR;;AoF/1gCI;EACI,iBAAA;ApFk2gCR;;AoFn2gCI;EACI,iBAAA;ApFs2gCR;;AoFv2gCI;EACI,iBAAA;ApF02gCR;;AoF32gCI;EACI,iBAAA;ApF82gCR;;AoF/2gCI;EACI,iBAAA;ApFk3gCR;;AoFn3gCI;EACI,iBAAA;ApFs3gCR;;AoFv3gCI;EACI,iBAAA;ApF03gCR;;AoF33gCI;EACI,iBAAA;ApF83gCR;;AoF/3gCI;EACI,iBAAA;ApFk4gCR;;AoFn4gCI;EACI,iBAAA;ApFs4gCR;;AoFv4gCI;EACI,iBAAA;ApF04gCR;;AoF34gCI;EACI,iBAAA;ApF84gCR;;AoF/4gCI;EACI,iBAAA;ApFk5gCR;;AoFn5gCI;EACI,iBAAA;ApFs5gCR;;AoFv5gCI;EACI,iBAAA;ApF05gCR;;AoF35gCI;EACI,iBAAA;ApF85gCR;;AoF/5gCI;EACI,iBAAA;ApFk6gCR;;AoFn6gCI;EACI,iBAAA;ApFs6gCR;;AoFv6gCI;EACI,iBAAA;ApF06gCR;;AoF36gCI;EACI,iBAAA;ApF86gCR;;AoF/6gCI;EACI,iBAAA;ApFk7gCR;;AoFn7gCI;EACI,iBAAA;ApFs7gCR;;AoFv7gCI;EACI,iBAAA;ApF07gCR;;AoF37gCI;EACI,iBAAA;ApF87gCR;;AoF/7gCI;EACI,iBAAA;ApFk8gCR;;AoFn8gCI;EACI,iBAAA;ApFs8gCR;;AoFv8gCI;EACI,iBAAA;ApF08gCR;;AoF38gCI;EACI,iBAAA;ApF88gCR;;AoF/8gCI;EACI,iBAAA;ApFk9gCR;;AoFn9gCI;EACI,iBAAA;ApFs9gCR;;AoFv9gCI;EACI,iBAAA;ApF09gCR;;AoF39gCI;EACI,iBAAA;ApF89gCR;;AoF/9gCI;EACI,iBAAA;ApFk+gCR;;AoFn+gCI;EACI,iBAAA;ApFs+gCR;;AoFv+gCI;EACI,iBAAA;ApF0+gCR;;AoF3+gCI;EACI,iBAAA;ApF8+gCR;;AoF/+gCI;EACI,iBAAA;ApFk/gCR;;AoFn/gCI;EACI,iBAAA;ApFs/gCR;;AoFv/gCI;EACI,iBAAA;ApF0/gCR;;AoF3/gCI;EACI,iBAAA;ApF8/gCR;;AoF//gCI;EACI,iBAAA;ApFkghCR;;AoFnghCI;EACI,iBAAA;ApFsghCR;;AoFvghCI;EACI,iBAAA;ApF0ghCR;;AoF3ghCI;EACI,iBAAA;ApF8ghCR;;AoF/ghCI;EACI,iBAAA;ApFkhhCR;;AoFnhhCI;EACI,iBAAA;ApFshhCR;;AoFvhhCI;EACI,iBAAA;ApF0hhCR;;AoF3hhCI;EACI,iBAAA;ApF8hhCR;;AoF/hhCI;EACI,iBAAA;ApFkihCR;;AoFnihCI;EACI,iBAAA;ApFsihCR;;AoFvihCI;EACI,iBAAA;ApF0ihCR;;AoF3ihCI;EACI,iBAAA;ApF8ihCR;;AoF/ihCI;EACI,iBAAA;ApFkjhCR;;AoFnjhCI;EACI,iBAAA;ApFsjhCR;;AoFvjhCI;EACI,iBAAA;ApF0jhCR;;AoF3jhCI;EACI,iBAAA;ApF8jhCR;;AoF/jhCI;EACI,iBAAA;ApFkkhCR;;AoFnkhCI;EACI,iBAAA;ApFskhCR;;AoFvkhCI;EACI,iBAAA;ApF0khCR;;AoF3khCI;EACI,iBAAA;ApF8khCR;;AoF/khCI;EACI,iBAAA;ApFklhCR;;AoFnlhCI;EACI,iBAAA;ApFslhCR;;AoFvlhCI;EACI,iBAAA;ApF0lhCR;;AoF3lhCI;EACI,iBAAA;ApF8lhCR;;AoF/lhCI;EACI,iBAAA;ApFkmhCR;;AoFnmhCI;EACI,iBAAA;ApFsmhCR;;AoFvmhCI;EACI,iBAAA;ApF0mhCR;;AoF3mhCI;EACI,iBAAA;ApF8mhCR;;AoF/mhCI;EACI,iBAAA;ApFknhCR;;AoFnnhCI;EACI,iBAAA;ApFsnhCR;;AoFvnhCI;EACI,iBAAA;ApF0nhCR;;AoF3nhCI;EACI,iBAAA;ApF8nhCR;;AoF/nhCI;EACI,iBAAA;ApFkohCR;;AoFnohCI;EACI,iBAAA;ApFsohCR;;AoFvohCI;EACI,iBAAA;ApF0ohCR;;AoF3ohCI;EACI,iBAAA;ApF8ohCR;;AoF/ohCI;EACI,iBAAA;ApFkphCR;;AoFnphCI;EACI,iBAAA;ApFsphCR;;AoFvphCI;EACI,iBAAA;ApF0phCR;;AoF3phCI;EACI,iBAAA;ApF8phCR;;AoF/phCI;EACI,iBAAA;ApFkqhCR;;AoFnqhCI;EACI,iBAAA;ApFsqhCR;;AoFvqhCI;EACI,iBAAA;ApF0qhCR;;AoF3qhCI;EACI,iBAAA;ApF8qhCR;;AoF/qhCI;EACI,iBAAA;ApFkrhCR;;AoFnrhCI;EACI,iBAAA;ApFsrhCR;;AoFvrhCI;EACI,iBAAA;ApF0rhCR;;AoF3rhCI;EACI,iBAAA;ApF8rhCR;;AoF/rhCI;EACI,iBAAA;ApFkshCR;;AoFnshCI;EACI,iBAAA;ApFsshCR;;AoFvshCI;EACI,iBAAA;ApF0shCR;;AoF3shCI;EACI,iBAAA;ApF8shCR;;AoF/shCI;EACI,iBAAA;ApFkthCR;;AoFnthCI;EACI,iBAAA;ApFsthCR;;AoFvthCI;EACI,iBAAA;ApF0thCR;;AoF3thCI;EACI,iBAAA;ApF8thCR;;AoF/thCI;EACI,iBAAA;ApFkuhCR;;AoFnuhCI;EACI,iBAAA;ApFsuhCR;;AoFvuhCI;EACI,iBAAA;ApF0uhCR;;AoF3uhCI;EACI,iBAAA;ApF8uhCR;;AoF/uhCI;EACI,iBAAA;ApFkvhCR;;AoFnvhCI;EACI,iBAAA;ApFsvhCR;;AoFvvhCI;EACI,iBAAA;ApF0vhCR;;AoF3vhCI;EACI,iBAAA;ApF8vhCR;;AoF/vhCI;EACI,iBAAA;ApFkwhCR;;AoFnwhCI;EACI,iBAAA;ApFswhCR;;AoFvwhCI;EACI,iBAAA;ApF0whCR;;AoF3whCI;EACI,iBAAA;ApF8whCR;;AoF/whCI;EACI,iBAAA;ApFkxhCR;;AoFnxhCI;EACI,iBAAA;ApFsxhCR;;AoFvxhCI;EACI,iBAAA;ApF0xhCR;;AoF3xhCI;EACI,iBAAA;ApF8xhCR;;AoF/xhCI;EACI,iBAAA;ApFkyhCR;;AoFnyhCI;EACI,iBAAA;ApFsyhCR;;AoFvyhCI;EACI,iBAAA;ApF0yhCR;;AoF3yhCI;EACI,iBAAA;ApF8yhCR;;AoF/yhCI;EACI,iBAAA;ApFkzhCR;;AoFnzhCI;EACI,iBAAA;ApFszhCR;;AoFvzhCI;EACI,iBAAA;ApF0zhCR;;AoF3zhCI;EACI,iBAAA;ApF8zhCR;;AoF/zhCI;EACI,iBAAA;ApFk0hCR;;AoFn0hCI;EACI,iBAAA;ApFs0hCR;;AoFv0hCI;EACI,iBAAA;ApF00hCR;;AoF30hCI;EACI,iBAAA;ApF80hCR;;AoF/0hCI;EACI,iBAAA;ApFk1hCR;;AoFn1hCI;EACI,iBAAA;ApFs1hCR;;AoFv1hCI;EACI,iBAAA;ApF01hCR;;AoF31hCI;EACI,iBAAA;ApF81hCR;;AoF/1hCI;EACI,iBAAA;ApFk2hCR;;AoFn2hCI;EACI,iBAAA;ApFs2hCR;;AoFv2hCI;EACI,iBAAA;ApF02hCR;;AoF32hCI;EACI,iBAAA;ApF82hCR;;AoF/2hCI;EACI,iBAAA;ApFk3hCR;;AoFn3hCI;EACI,iBAAA;ApFs3hCR;;AoFv3hCI;EACI,iBAAA;ApF03hCR;;AoF33hCI;EACI,iBAAA;ApF83hCR;;AoF/3hCI;EACI,iBAAA;ApFk4hCR;;AoFn4hCI;EACI,iBAAA;ApFs4hCR;;AoFv4hCI;EACI,iBAAA;ApF04hCR;;AoF34hCI;EACI,iBAAA;ApF84hCR;;AoF/4hCI;EACI,iBAAA;ApFk5hCR;;AoFn5hCI;EACI,iBAAA;ApFs5hCR;;AoFv5hCI;EACI,iBAAA;ApF05hCR;;AoF35hCI;EACI,iBAAA;ApF85hCR;;AoF/5hCI;EACI,iBAAA;ApFk6hCR;;AoFn6hCI;EACI,iBAAA;ApFs6hCR;;AoFv6hCI;EACI,iBAAA;ApF06hCR;;AoF36hCI;EACI,iBAAA;ApF86hCR;;AoF/6hCI;EACI,iBAAA;ApFk7hCR;;AoFn7hCI;EACI,iBAAA;ApFs7hCR;;AoFv7hCI;EACI,iBAAA;ApF07hCR;;AoF37hCI;EACI,iBAAA;ApF87hCR;;AoF/7hCI;EACI,iBAAA;ApFk8hCR;;AoFn8hCI;EACI,iBAAA;ApFs8hCR;;AoFv8hCI;EACI,iBAAA;ApF08hCR;;AoF38hCI;EACI,iBAAA;ApF88hCR;;AoF/8hCI;EACI,iBAAA;ApFk9hCR;;AoFn9hCI;EACI,iBAAA;ApFs9hCR;;AoFv9hCI;EACI,iBAAA;ApF09hCR;;AoF39hCI;EACI,iBAAA;ApF89hCR;;AoF/9hCI;EACI,iBAAA;ApFk+hCR;;AoFn+hCI;EACI,iBAAA;ApFs+hCR;;AoFv+hCI;EACI,iBAAA;ApF0+hCR;;AoF3+hCI;EACI,iBAAA;ApF8+hCR;;AoF/+hCI;EACI,iBAAA;ApFk/hCR;;AoFn/hCI;EACI,iBAAA;ApFs/hCR;;AoFv/hCI;EACI,iBAAA;ApF0/hCR;;AoF3/hCI;EACI,iBAAA;ApF8/hCR;;AoF//hCI;EACI,iBAAA;ApFkgiCR;;AoFngiCI;EACI,iBAAA;ApFsgiCR;;AoFvgiCI;EACI,iBAAA;ApF0giCR;;AoF3giCI;EACI,iBAAA;ApF8giCR;;AoF/giCI;EACI,iBAAA;ApFkhiCR;;AoFnhiCI;EACI,iBAAA;ApFshiCR;;AoFvhiCI;EACI,iBAAA;ApF0hiCR;;AoF3hiCI;EACI,iBAAA;ApF8hiCR;;AoF/hiCI;EACI,iBAAA;ApFkiiCR;;AoFniiCI;EACI,iBAAA;ApFsiiCR;;AoFviiCI;EACI,iBAAA;ApF0iiCR;;AoF3iiCI;EACI,iBAAA;ApF8iiCR;;AoF/iiCI;EACI,iBAAA;ApFkjiCR;;AoFnjiCI;EACI,iBAAA;ApFsjiCR;;AoFvjiCI;EACI,iBAAA;ApF0jiCR;;AoF3jiCI;EACI,iBAAA;ApF8jiCR;;AoF/jiCI;EACI,iBAAA;ApFkkiCR;;AoFnkiCI;EACI,iBAAA;ApFskiCR;;AoFvkiCI;EACI,iBAAA;ApF0kiCR;;AoF3kiCI;EACI,iBAAA;ApF8kiCR;;AoF/kiCI;EACI,iBAAA;ApFkliCR;;AoFnliCI;EACI,iBAAA;ApFsliCR;;AoFvliCI;EACI,iBAAA;ApF0liCR;;AoF3liCI;EACI,iBAAA;ApF8liCR;;AoF/liCI;EACI,iBAAA;ApFkmiCR;;AoFnmiCI;EACI,iBAAA;ApFsmiCR;;AoFvmiCI;EACI,iBAAA;ApF0miCR;;AoF3miCI;EACI,iBAAA;ApF8miCR;;AoF/miCI;EACI,iBAAA;ApFkniCR;;AoFnniCI;EACI,iBAAA;ApFsniCR;;AoFvniCI;EACI,iBAAA;ApF0niCR;;AoF3niCI;EACI,iBAAA;ApF8niCR;;AoF/niCI;EACI,iBAAA;ApFkoiCR;;AoFnoiCI;EACI,iBAAA;ApFsoiCR;;AoFvoiCI;EACI,iBAAA;ApF0oiCR;;AoF3oiCI;EACI,iBAAA;ApF8oiCR;;AoF/oiCI;EACI,iBAAA;ApFkpiCR;;AoFnpiCI;EACI,iBAAA;ApFspiCR;;AoFvpiCI;EACI,iBAAA;ApF0piCR;;AoF3piCI;EACI,iBAAA;ApF8piCR;;AoF/piCI;EACI,iBAAA;ApFkqiCR;;AoFnqiCI;EACI,iBAAA;ApFsqiCR;;AoFvqiCI;EACI,iBAAA;ApF0qiCR;;AoF3qiCI;EACI,iBAAA;ApF8qiCR;;AoF/qiCI;EACI,iBAAA;ApFkriCR;;AoFnriCI;EACI,iBAAA;ApFsriCR;;AoFvriCI;EACI,iBAAA;ApF0riCR;;AoF3riCI;EACI,iBAAA;ApF8riCR;;AoF/riCI;EACI,iBAAA;ApFksiCR;;AoFnsiCI;EACI,iBAAA;ApFssiCR;;AoFvsiCI;EACI,iBAAA;ApF0siCR;;AoF3siCI;EACI,iBAAA;ApF8siCR;;AoF/siCI;EACI,iBAAA;ApFktiCR;;AoFntiCI;EACI,iBAAA;ApFstiCR;;AoFvtiCI;EACI,iBAAA;ApF0tiCR;;AoF3tiCI;EACI,iBAAA;ApF8tiCR;;AoF/tiCI;EACI,iBAAA;ApFkuiCR;;AoFnuiCI;EACI,iBAAA;ApFsuiCR;;AoFvuiCI;EACI,iBAAA;ApF0uiCR;;AoF3uiCI;EACI,iBAAA;ApF8uiCR;;AoF/uiCI;EACI,iBAAA;ApFkviCR;;AoFnviCI;EACI,iBAAA;ApFsviCR;;AoFvviCI;EACI,iBAAA;ApF0viCR;;AoF3viCI;EACI,iBAAA;ApF8viCR;;AoF/viCI;EACI,iBAAA;ApFkwiCR;;AoFnwiCI;EACI,iBAAA;ApFswiCR;;AoFvwiCI;EACI,iBAAA;ApF0wiCR;;AoF3wiCI;EACI,iBAAA;ApF8wiCR;;AoF/wiCI;EACI,iBAAA;ApFkxiCR;;AoFnxiCI;EACI,iBAAA;ApFsxiCR;;AoFvxiCI;EACI,iBAAA;ApF0xiCR;;AoF3xiCI;EACI,iBAAA;ApF8xiCR;;AoF/xiCI;EACI,iBAAA;ApFkyiCR;;AoFnyiCI;EACI,iBAAA;ApFsyiCR;;AoFvyiCI;EACI,iBAAA;ApF0yiCR;;AoF3yiCI;EACI,iBAAA;ApF8yiCR;;AoF/yiCI;EACI,iBAAA;ApFkziCR;;AoFnziCI;EACI,iBAAA;ApFsziCR;;AoFvziCI;EACI,iBAAA;ApF0ziCR;;AoF3ziCI;EACI,iBAAA;ApF8ziCR;;AoF/ziCI;EACI,iBAAA;ApFk0iCR;;AoFn0iCI;EACI,iBAAA;ApFs0iCR;;AoFv0iCI;EACI,iBAAA;ApF00iCR;;AoF30iCI;EACI,iBAAA;ApF80iCR;;AoF/0iCI;EACI,iBAAA;ApFk1iCR;;AoFn1iCI;EACI,iBAAA;ApFs1iCR;;AoFv1iCI;EACI,iBAAA;ApF01iCR;;AoF31iCI;EACI,iBAAA;ApF81iCR;;AoF/1iCI;EACI,iBAAA;ApFk2iCR;;AoFn2iCI;EACI,iBAAA;ApFs2iCR;;AoFv2iCI;EACI,iBAAA;ApF02iCR;;AoF32iCI;EACI,iBAAA;ApF82iCR;;AoF/2iCI;EACI,iBAAA;ApFk3iCR;;AoFn3iCI;EACI,iBAAA;ApFs3iCR;;AoFv3iCI;EACI,iBAAA;ApF03iCR;;AoF33iCI;EACI,iBAAA;ApF83iCR;;AoF/3iCI;EACI,iBAAA;ApFk4iCR;;AoFn4iCI;EACI,iBAAA;ApFs4iCR;;AoFv4iCI;EACI,iBAAA;ApF04iCR;;AoF34iCI;EACI,iBAAA;ApF84iCR;;AoF/4iCI;EACI,iBAAA;ApFk5iCR;;AoFn5iCI;EACI,iBAAA;ApFs5iCR;;AoFv5iCI;EACI,iBAAA;ApF05iCR;;AoF35iCI;EACI,iBAAA;ApF85iCR;;AoF/5iCI;EACI,iBAAA;ApFk6iCR;;AoFn6iCI;EACI,iBAAA;ApFs6iCR;;AoFv6iCI;EACI,iBAAA;ApF06iCR;;AoF36iCI;EACI,iBAAA;ApF86iCR;;AoF/6iCI;EACI,iBAAA;ApFk7iCR;;AoFn7iCI;EACI,iBAAA;ApFs7iCR;;AoFv7iCI;EACI,iBAAA;ApF07iCR;;AoF37iCI;EACI,iBAAA;ApF87iCR;;AoF/7iCI;EACI,iBAAA;ApFk8iCR;;AoFn8iCI;EACI,iBAAA;ApFs8iCR;;AoFv8iCI;EACI,iBAAA;ApF08iCR;;AoF38iCI;EACI,iBAAA;ApF88iCR;;AoF/8iCI;EACI,iBAAA;ApFk9iCR;;AoFn9iCI;EACI,iBAAA;ApFs9iCR;;AoFv9iCI;EACI,iBAAA;ApF09iCR;;AoF39iCI;EACI,iBAAA;ApF89iCR;;AoF/9iCI;EACI,iBAAA;ApFk+iCR;;AoFn+iCI;EACI,iBAAA;ApFs+iCR;;AoFv+iCI;EACI,iBAAA;ApF0+iCR;;AoF3+iCI;EACI,iBAAA;ApF8+iCR;;AoF/+iCI;EACI,iBAAA;ApFk/iCR;;AoFn/iCI;EACI,iBAAA;ApFs/iCR;;AoFv/iCI;EACI,iBAAA;ApF0/iCR;;AoF3/iCI;EACI,iBAAA;ApF8/iCR;;AoF//iCI;EACI,iBAAA;ApFkgjCR;;AoFngjCI;EACI,iBAAA;ApFsgjCR;;AoFvgjCI;EACI,iBAAA;ApF0gjCR;;AoF3gjCI;EACI,iBAAA;ApF8gjCR;;AoF/gjCI;EACI,iBAAA;ApFkhjCR;;AoFnhjCI;EACI,iBAAA;ApFshjCR;;AoFvhjCI;EACI,iBAAA;ApF0hjCR;;AoF3hjCI;EACI,iBAAA;ApF8hjCR;;AoF/hjCI;EACI,iBAAA;ApFkijCR;;AoFnijCI;EACI,iBAAA;ApFsijCR;;AoFvijCI;EACI,iBAAA;ApF0ijCR;;AoF3ijCI;EACI,iBAAA;ApF8ijCR;;AoF/ijCI;EACI,iBAAA;ApFkjjCR;;AoFnjjCI;EACI,iBAAA;ApFsjjCR;;AoFvjjCI;EACI,iBAAA;ApF0jjCR;;AoF3jjCI;EACI,iBAAA;ApF8jjCR;;AoF/jjCI;EACI,iBAAA;ApFkkjCR;;AoFnkjCI;EACI,iBAAA;ApFskjCR;;AoFvkjCI;EACI,iBAAA;ApF0kjCR;;AoF3kjCI;EACI,iBAAA;ApF8kjCR;;AoF/kjCI;EACI,iBAAA;ApFkljCR;;AoFnljCI;EACI,iBAAA;ApFsljCR;;AoFvljCI;EACI,iBAAA;ApF0ljCR;;AoF3ljCI;EACI,iBAAA;ApF8ljCR;;AoF/ljCI;EACI,iBAAA;ApFkmjCR;;AoFnmjCI;EACI,iBAAA;ApFsmjCR;;AoFvmjCI;EACI,iBAAA;ApF0mjCR;;AoF3mjCI;EACI,iBAAA;ApF8mjCR;;AoF/mjCI;EACI,iBAAA;ApFknjCR;;AoFnnjCI;EACI,iBAAA;ApFsnjCR;;AoFvnjCI;EACI,iBAAA;ApF0njCR;;AoF3njCI;EACI,iBAAA;ApF8njCR;;AoF/njCI;EACI,iBAAA;ApFkojCR;;AoFnojCI;EACI,iBAAA;ApFsojCR;;AoFvojCI;EACI,iBAAA;ApF0ojCR;;AoF3ojCI;EACI,iBAAA;ApF8ojCR;;AoF/ojCI;EACI,iBAAA;ApFkpjCR;;AoFnpjCI;EACI,iBAAA;ApFspjCR;;AoFvpjCI;EACI,iBAAA;ApF0pjCR;;AoF3pjCI;EACI,iBAAA;ApF8pjCR;;AoF/pjCI;EACI,iBAAA;ApFkqjCR;;AoFnqjCI;EACI,iBAAA;ApFsqjCR;;AoFvqjCI;EACI,iBAAA;ApF0qjCR;;AoF3qjCI;EACI,iBAAA;ApF8qjCR;;AoF/qjCI;EACI,iBAAA;ApFkrjCR;;AoFnrjCI;EACI,iBAAA;ApFsrjCR;;AoFvrjCI;EACI,iBAAA;ApF0rjCR;;AoF3rjCI;EACI,iBAAA;ApF8rjCR;;AoF/rjCI;EACI,iBAAA;ApFksjCR;;AoFnsjCI;EACI,iBAAA;ApFssjCR;;AoFvsjCI;EACI,iBAAA;ApF0sjCR;;AoF3sjCI;EACI,iBAAA;ApF8sjCR;;AoF/sjCI;EACI,iBAAA;ApFktjCR;;AoFntjCI;EACI,iBAAA;ApFstjCR;;AoFvtjCI;EACI,iBAAA;ApF0tjCR;;AoF3tjCI;EACI,iBAAA;ApF8tjCR;;AoF/tjCI;EACI,iBAAA;ApFkujCR;;AoFnujCI;EACI,iBAAA;ApFsujCR;;AoFvujCI;EACI,iBAAA;ApF0ujCR;;AoF3ujCI;EACI,iBAAA;ApF8ujCR;;AoF/ujCI;EACI,iBAAA;ApFkvjCR;;AoFnvjCI;EACI,iBAAA;ApFsvjCR;;AoFvvjCI;EACI,iBAAA;ApF0vjCR;;AoF3vjCI;EACI,iBAAA;ApF8vjCR;;AoF/vjCI;EACI,iBAAA;ApFkwjCR;;AoFnwjCI;EACI,iBAAA;ApFswjCR;;AoFvwjCI;EACI,iBAAA;ApF0wjCR;;AoF3wjCI;EACI,iBAAA;ApF8wjCR;;AoF/wjCI;EACI,iBAAA;ApFkxjCR;;AoFnxjCI;EACI,iBAAA;ApFsxjCR;;AoFvxjCI;EACI,iBAAA;ApF0xjCR;;AoF3xjCI;EACI,iBAAA;ApF8xjCR;;AoF/xjCI;EACI,iBAAA;ApFkyjCR;;AoFnyjCI;EACI,iBAAA;ApFsyjCR;;AoFvyjCI;EACI,iBAAA;ApF0yjCR;;AoF3yjCI;EACI,iBAAA;ApF8yjCR;;AoF/yjCI;EACI,iBAAA;ApFkzjCR;;AoFnzjCI;EACI,iBAAA;ApFszjCR;;AoFvzjCI;EACI,iBAAA;ApF0zjCR;;AoF3zjCI;EACI,iBAAA;ApF8zjCR;;AoF/zjCI;EACI,iBAAA;ApFk0jCR;;AoFn0jCI;EACI,iBAAA;ApFs0jCR;;AoFv0jCI;EACI,iBAAA;ApF00jCR;;AoF30jCI;EACI,iBAAA;ApF80jCR;;AoF/0jCI;EACI,iBAAA;ApFk1jCR;;AoFn1jCI;EACI,iBAAA;ApFs1jCR;;AoFv1jCI;EACI,iBAAA;ApF01jCR;;AoF31jCI;EACI,iBAAA;ApF81jCR;;AoF/1jCI;EACI,iBAAA;ApFk2jCR;;AoFn2jCI;EACI,iBAAA;ApFs2jCR;;AoFv2jCI;EACI,iBAAA;ApF02jCR;;AoF32jCI;EACI,iBAAA;ApF82jCR;;AoF/2jCI;EACI,iBAAA;ApFk3jCR;;AoFn3jCI;EACI,iBAAA;ApFs3jCR;;AoFv3jCI;EACI,iBAAA;ApF03jCR;;AoF33jCI;EACI,iBAAA;ApF83jCR;;AoF/3jCI;EACI,iBAAA;ApFk4jCR;;AoFn4jCI;EACI,iBAAA;ApFs4jCR;;AoFv4jCI;EACI,iBAAA;ApF04jCR;;AoF34jCI;EACI,iBAAA;ApF84jCR;;AoF/4jCI;EACI,iBAAA;ApFk5jCR;;AoFn5jCI;EACI,iBAAA;ApFs5jCR;;AoFv5jCI;EACI,iBAAA;ApF05jCR;;AoF35jCI;EACI,iBAAA;ApF85jCR;;AoF/5jCI;EACI,iBAAA;ApFk6jCR;;AoFn6jCI;EACI,iBAAA;ApFs6jCR;;AoFv6jCI;EACI,iBAAA;ApF06jCR;;AoF36jCI;EACI,iBAAA;ApF86jCR;;AoF/6jCI;EACI,iBAAA;ApFk7jCR;;AoFn7jCI;EACI,iBAAA;ApFs7jCR;;AoFv7jCI;EACI,iBAAA;ApF07jCR;;AoF37jCI;EACI,iBAAA;ApF87jCR;;AoF/7jCI;EACI,iBAAA;ApFk8jCR;;AoFn8jCI;EACI,iBAAA;ApFs8jCR;;AoFv8jCI;EACI,iBAAA;ApF08jCR;;AoF38jCI;EACI,iBAAA;ApF88jCR;;AoF/8jCI;EACI,iBAAA;ApFk9jCR;;AoFn9jCI;EACI,iBAAA;ApFs9jCR;;AoFv9jCI;EACI,iBAAA;ApF09jCR;;AoF39jCI;EACI,iBAAA;ApF89jCR;;AoF/9jCI;EACI,iBAAA;ApFk+jCR;;AoFn+jCI;EACI,iBAAA;ApFs+jCR;;AoFv+jCI;EACI,iBAAA;ApF0+jCR;;AoF3+jCI;EACI,iBAAA;ApF8+jCR;;AoF/+jCI;EACI,iBAAA;ApFk/jCR;;AoFn/jCI;EACI,iBAAA;ApFs/jCR;;AoFv/jCI;EACI,iBAAA;ApF0/jCR;;AoF3/jCI;EACI,iBAAA;ApF8/jCR;;AoF//jCI;EACI,iBAAA;ApFkgkCR;;AoFngkCI;EACI,iBAAA;ApFsgkCR;;AoFvgkCI;EACI,iBAAA;ApF0gkCR;;AoF3gkCI;EACI,iBAAA;ApF8gkCR;;AoF/gkCI;EACI,iBAAA;ApFkhkCR;;AoFnhkCI;EACI,iBAAA;ApFshkCR;;AoFvhkCI;EACI,iBAAA;ApF0hkCR;;AoF3hkCI;EACI,iBAAA;ApF8hkCR;;AoF/hkCI;EACI,iBAAA;ApFkikCR;;AoFnikCI;EACI,iBAAA;ApFsikCR;;AoFvikCI;EACI,iBAAA;ApF0ikCR;;AoF3ikCI;EACI,iBAAA;ApF8ikCR;;AoF/ikCI;EACI,iBAAA;ApFkjkCR;;AoFnjkCI;EACI,iBAAA;ApFsjkCR;;AoFvjkCI;EACI,iBAAA;ApF0jkCR;;AoF3jkCI;EACI,iBAAA;ApF8jkCR;;AoF/jkCI;EACI,iBAAA;ApFkkkCR;;AoFnkkCI;EACI,iBAAA;ApFskkCR;;AoFvkkCI;EACI,iBAAA;ApF0kkCR;;AoF3kkCI;EACI,iBAAA;ApF8kkCR;;AoF/kkCI;EACI,iBAAA;ApFklkCR;;AoFnlkCI;EACI,iBAAA;ApFslkCR;;AoFvlkCI;EACI,iBAAA;ApF0lkCR;;AoF3lkCI;EACI,iBAAA;ApF8lkCR;;AoF/lkCI;EACI,iBAAA;ApFkmkCR;;AoFnmkCI;EACI,iBAAA;ApFsmkCR;;AoFvmkCI;EACI,iBAAA;ApF0mkCR;;AoF3mkCI;EACI,iBAAA;ApF8mkCR;;AoF/mkCI;EACI,iBAAA;ApFknkCR;;AoFnnkCI;EACI,iBAAA;ApFsnkCR;;AoFvnkCI;EACI,iBAAA;ApF0nkCR;;AoF3nkCI;EACI,iBAAA;ApF8nkCR;;AoF/nkCI;EACI,iBAAA;ApFkokCR;;AoFnokCI;EACI,iBAAA;ApFsokCR;;AoFvokCI;EACI,iBAAA;ApF0okCR;;AoF3okCI;EACI,iBAAA;ApF8okCR;;AoF/okCI;EACI,iBAAA;ApFkpkCR;;AoFnpkCI;EACI,iBAAA;ApFspkCR;;AoFvpkCI;EACI,iBAAA;ApF0pkCR;;AoF3pkCI;EACI,iBAAA;ApF8pkCR;;AoF/pkCI;EACI,iBAAA;ApFkqkCR;;AoFnqkCI;EACI,iBAAA;ApFsqkCR;;AoFvqkCI;EACI,iBAAA;ApF0qkCR;;AoF3qkCI;EACI,iBAAA;ApF8qkCR;;AoF/qkCI;EACI,iBAAA;ApFkrkCR;;AoFnrkCI;EACI,iBAAA;ApFsrkCR;;AoFvrkCI;EACI,iBAAA;ApF0rkCR;;AoF3rkCI;EACI,iBAAA;ApF8rkCR;;AoF/rkCI;EACI,iBAAA;ApFkskCR;;AoFnskCI;EACI,iBAAA;ApFsskCR;;AoFvskCI;EACI,iBAAA;ApF0skCR;;AoF3skCI;EACI,iBAAA;ApF8skCR;;AoF/skCI;EACI,iBAAA;ApFktkCR;;AoFntkCI;EACI,iBAAA;ApFstkCR;;AoFvtkCI;EACI,iBAAA;ApF0tkCR;;AoF3tkCI;EACI,iBAAA;ApF8tkCR;;AoF/tkCI;EACI,iBAAA;ApFkukCR;;AoFnukCI;EACI,iBAAA;ApFsukCR;;AoFvukCI;EACI,iBAAA;ApF0ukCR;;AoF3ukCI;EACI,iBAAA;ApF8ukCR;;AoF/ukCI;EACI,iBAAA;ApFkvkCR;;AoFnvkCI;EACI,iBAAA;ApFsvkCR;;AoFvvkCI;EACI,iBAAA;ApF0vkCR;;AoF3vkCI;EACI,iBAAA;ApF8vkCR;;AoF/vkCI;EACI,iBAAA;ApFkwkCR;;AoFnwkCI;EACI,iBAAA;ApFswkCR;;AoFvwkCI;EACI,iBAAA;ApF0wkCR;;AoF3wkCI;EACI,iBAAA;ApF8wkCR;;AoF/wkCI;EACI,iBAAA;ApFkxkCR;;AoFnxkCI;EACI,iBAAA;ApFsxkCR;;AoFvxkCI;EACI,iBAAA;ApF0xkCR;;AoF3xkCI;EACI,iBAAA;ApF8xkCR;;AoF/xkCI;EACI,iBAAA;ApFkykCR;;AoFnykCI;EACI,iBAAA;ApFsykCR;;AoFvykCI;EACI,iBAAA;ApF0ykCR;;AoF3ykCI;EACI,iBAAA;ApF8ykCR;;AoF/ykCI;EACI,iBAAA;ApFkzkCR;;AoFnzkCI;EACI,iBAAA;ApFszkCR;;AoFvzkCI;EACI,iBAAA;ApF0zkCR;;AoF3zkCI;EACI,iBAAA;ApF8zkCR;;AoF/zkCI;EACI,iBAAA;ApFk0kCR;;AoFn0kCI;EACI,iBAAA;ApFs0kCR;;AoFv0kCI;EACI,iBAAA;ApF00kCR;;AoF30kCI;EACI,iBAAA;ApF80kCR;;AoF/0kCI;EACI,iBAAA;ApFk1kCR;;AoFn1kCI;EACI,iBAAA;ApFs1kCR;;AoFv1kCI;EACI,iBAAA;ApF01kCR;;AoF31kCI;EACI,iBAAA;ApF81kCR;;AoF/1kCI;EACI,iBAAA;ApFk2kCR;;AoFn2kCI;EACI,iBAAA;ApFs2kCR;;AoFv2kCI;EACI,iBAAA;ApF02kCR;;AoF32kCI;EACI,iBAAA;ApF82kCR;;AoF/2kCI;EACI,iBAAA;ApFk3kCR;;AoFn3kCI;EACI,iBAAA;ApFs3kCR;;AoFv3kCI;EACI,iBAAA;ApF03kCR;;AoF33kCI;EACI,iBAAA;ApF83kCR;;AoF/3kCI;EACI,iBAAA;ApFk4kCR;;AoFn4kCI;EACI,iBAAA;ApFs4kCR;;AoFv4kCI;EACI,iBAAA;ApF04kCR;;AoF34kCI;EACI,iBAAA;ApF84kCR;;AoF/4kCI;EACI,iBAAA;ApFk5kCR;;AoFn5kCI;EACI,iBAAA;ApFs5kCR;;AoFv5kCI;EACI,iBAAA;ApF05kCR;;AoF35kCI;EACI,iBAAA;ApF85kCR;;AoF/5kCI;EACI,iBAAA;ApFk6kCR;;AoFn6kCI;EACI,iBAAA;ApFs6kCR;;AoFv6kCI;EACI,iBAAA;ApF06kCR;;AoF36kCI;EACI,iBAAA;ApF86kCR;;AoF/6kCI;EACI,iBAAA;ApFk7kCR;;AoFn7kCI;EACI,iBAAA;ApFs7kCR;;AoFv7kCI;EACI,iBAAA;ApF07kCR;;AoF37kCI;EACI,iBAAA;ApF87kCR;;AoF/7kCI;EACI,iBAAA;ApFk8kCR;;AoFn8kCI;EACI,iBAAA;ApFs8kCR;;AoFv8kCI;EACI,iBAAA;ApF08kCR;;AoF38kCI;EACI,iBAAA;ApF88kCR;;AoF/8kCI;EACI,iBAAA;ApFk9kCR;;AoFn9kCI;EACI,iBAAA;ApFs9kCR;;AoFv9kCI;EACI,iBAAA;ApF09kCR;;AoF39kCI;EACI,iBAAA;ApF89kCR;;AoF/9kCI;EACI,iBAAA;ApFk+kCR;;AoFn+kCI;EACI,iBAAA;ApFs+kCR;;AoFv+kCI;EACI,iBAAA;ApF0+kCR;;AoF3+kCI;EACI,iBAAA;ApF8+kCR;;AoF/+kCI;EACI,iBAAA;ApFk/kCR;;AoFn/kCI;EACI,iBAAA;ApFs/kCR;;AoFv/kCI;EACI,iBAAA;ApF0/kCR;;AoF3/kCI;EACI,iBAAA;ApF8/kCR;;AoF//kCI;EACI,iBAAA;ApFkglCR;;AoFnglCI;EACI,iBAAA;ApFsglCR;;AoFvglCI;EACI,iBAAA;ApF0glCR;;AoF3glCI;EACI,iBAAA;ApF8glCR;;AoF/glCI;EACI,iBAAA;ApFkhlCR;;AoFnhlCI;EACI,iBAAA;ApFshlCR;;AoFvhlCI;EACI,iBAAA;ApF0hlCR;;AoF3hlCI;EACI,iBAAA;ApF8hlCR;;AoF/hlCI;EACI,iBAAA;ApFkilCR;;AoFnilCI;EACI,iBAAA;ApFsilCR;;AoFvilCI;EACI,iBAAA;ApF0ilCR;;AoF3ilCI;EACI,iBAAA;ApF8ilCR;;AoF/ilCI;EACI,iBAAA;ApFkjlCR;;AoFnjlCI;EACI,iBAAA;ApFsjlCR;;AoFvjlCI;EACI,iBAAA;ApF0jlCR;;AoF3jlCI;EACI,iBAAA;ApF8jlCR;;AoF/jlCI;EACI,iBAAA;ApFkklCR;;AoFnklCI;EACI,iBAAA;ApFsklCR;;AoFvklCI;EACI,iBAAA;ApF0klCR;;AoF3klCI;EACI,iBAAA;ApF8klCR;;AoF/klCI;EACI,iBAAA;ApFkllCR;;AoFnllCI;EACI,iBAAA;ApFsllCR;;AoFvllCI;EACI,iBAAA;ApF0llCR;;AoF3llCI;EACI,iBAAA;ApF8llCR;;AoF/llCI;EACI,iBAAA;ApFkmlCR;;AoFnmlCI;EACI,iBAAA;ApFsmlCR;;AoFvmlCI;EACI,iBAAA;ApF0mlCR;;AoF3mlCI;EACI,iBAAA;ApF8mlCR;;AoF/mlCI;EACI,iBAAA;ApFknlCR;;AoFnnlCI;EACI,iBAAA;ApFsnlCR;;AoFvnlCI;EACI,iBAAA;ApF0nlCR;;AoF3nlCI;EACI,iBAAA;ApF8nlCR;;AoF/nlCI;EACI,iBAAA;ApFkolCR;;AoFnolCI;EACI,iBAAA;ApFsolCR;;AoFvolCI;EACI,iBAAA;ApF0olCR;;AoF3olCI;EACI,iBAAA;ApF8olCR;;AoF/olCI;EACI,iBAAA;ApFkplCR;;AoFnplCI;EACI,iBAAA;ApFsplCR;;AoFvplCI;EACI,iBAAA;ApF0plCR;;AoF3plCI;EACI,iBAAA;ApF8plCR;;AoF/plCI;EACI,iBAAA;ApFkqlCR;;AoFnqlCI;EACI,iBAAA;ApFsqlCR;;AoFvqlCI;EACI,iBAAA;ApF0qlCR;;AoF3qlCI;EACI,iBAAA;ApF8qlCR;;AoF/qlCI;EACI,iBAAA;ApFkrlCR;;AoFnrlCI;EACI,iBAAA;ApFsrlCR;;AoFvrlCI;EACI,iBAAA;ApF0rlCR;;AoF3rlCI;EACI,iBAAA;ApF8rlCR;;AoF/rlCI;EACI,iBAAA;ApFkslCR;;AoFnslCI;EACI,iBAAA;ApFsslCR;;AoFvslCI;EACI,iBAAA;ApF0slCR;;AoF3slCI;EACI,iBAAA;ApF8slCR;;AoF/slCI;EACI,iBAAA;ApFktlCR;;AoFntlCI;EACI,iBAAA;ApFstlCR;;AoFvtlCI;EACI,iBAAA;ApF0tlCR;;AoF3tlCI;EACI,iBAAA;ApF8tlCR;;AoF/tlCI;EACI,iBAAA;ApFkulCR;;AoFnulCI;EACI,iBAAA;ApFsulCR;;AoFvulCI;EACI,iBAAA;ApF0ulCR;;AoF3ulCI;EACI,iBAAA;ApF8ulCR;;AoF/ulCI;EACI,iBAAA;ApFkvlCR;;AoFnvlCI;EACI,iBAAA;ApFsvlCR;;AoFvvlCI;EACI,iBAAA;ApF0vlCR;;AoF3vlCI;EACI,iBAAA;ApF8vlCR;;AoF/vlCI;EACI,iBAAA;ApFkwlCR;;AoFnwlCI;EACI,iBAAA;ApFswlCR;;AoFvwlCI;EACI,iBAAA;ApF0wlCR;;AoF3wlCI;EACI,iBAAA;ApF8wlCR;;AoF/wlCI;EACI,iBAAA;ApFkxlCR;;AoFnxlCI;EACI,iBAAA;ApFsxlCR;;AoFvxlCI;EACI,iBAAA;ApF0xlCR;;AoF3xlCI;EACI,iBAAA;ApF8xlCR;;AoF/xlCI;EACI,iBAAA;ApFkylCR;;AoFnylCI;EACI,iBAAA;ApFsylCR;;AoFvylCI;EACI,iBAAA;ApF0ylCR;;AoF3ylCI;EACI,iBAAA;ApF8ylCR;;AoF/ylCI;EACI,iBAAA;ApFkzlCR;;AoFnzlCI;EACI,iBAAA;ApFszlCR;;AoFvzlCI;EACI,iBAAA;ApF0zlCR;;AoF3zlCI;EACI,iBAAA;ApF8zlCR;;AoF/zlCI;EACI,iBAAA;ApFk0lCR;;AoFn0lCI;EACI,iBAAA;ApFs0lCR;;AoFv0lCI;EACI,iBAAA;ApF00lCR;;AoF30lCI;EACI,iBAAA;ApF80lCR;;AoF/0lCI;EACI,iBAAA;ApFk1lCR;;AoFn1lCI;EACI,iBAAA;ApFs1lCR;;AoFv1lCI;EACI,iBAAA;ApF01lCR;;AoF31lCI;EACI,iBAAA;ApF81lCR;;AoF/1lCI;EACI,iBAAA;ApFk2lCR;;AoFn2lCI;EACI,iBAAA;ApFs2lCR;;AoFv2lCI;EACI,iBAAA;ApF02lCR;;AoF32lCI;EACI,iBAAA;ApF82lCR;;AoF/2lCI;EACI,iBAAA;ApFk3lCR;;AoFn3lCI;EACI,iBAAA;ApFs3lCR;;AoFv3lCI;EACI,iBAAA;ApF03lCR;;AoF33lCI;EACI,iBAAA;ApF83lCR;;AoF/3lCI;EACI,iBAAA;ApFk4lCR;;AoFn4lCI;EACI,iBAAA;ApFs4lCR;;AoFv4lCI;EACI,iBAAA;ApF04lCR;;AoF34lCI;EACI,iBAAA;ApF84lCR;;AoF/4lCI;EACI,iBAAA;ApFk5lCR;;AoFn5lCI;EACI,iBAAA;ApFs5lCR;;AoFv5lCI;EACI,iBAAA;ApF05lCR;;AoF35lCI;EACI,iBAAA;ApF85lCR;;AoF/5lCI;EACI,iBAAA;ApFk6lCR;;AoFn6lCI;EACI,iBAAA;ApFs6lCR;;AoFv6lCI;EACI,iBAAA;ApF06lCR;;AoF36lCI;EACI,iBAAA;ApF86lCR;;AoF/6lCI;EACI,iBAAA;ApFk7lCR;;AoFn7lCI;EACI,iBAAA;ApFs7lCR;;AoFv7lCI;EACI,iBAAA;ApF07lCR;;AoF37lCI;EACI,iBAAA;ApF87lCR;;AoF/7lCI;EACI,iBAAA;ApFk8lCR;;AoFn8lCI;EACI,iBAAA;ApFs8lCR;;AoFv8lCI;EACI,iBAAA;ApF08lCR;;AoF38lCI;EACI,iBAAA;ApF88lCR;;AoF/8lCI;EACI,iBAAA;ApFk9lCR;;AoFn9lCI;EACI,iBAAA;ApFs9lCR;;AoFv9lCI;EACI,iBAAA;ApF09lCR;;AoF39lCI;EACI,iBAAA;ApF89lCR;;AoF/9lCI;EACI,iBAAA;ApFk+lCR;;AoFn+lCI;EACI,iBAAA;ApFs+lCR;;AoFv+lCI;EACI,iBAAA;ApF0+lCR;;AoF3+lCI;EACI,iBAAA;ApF8+lCR;;AoF/+lCI;EACI,iBAAA;ApFk/lCR;;AoFn/lCI;EACI,iBAAA;ApFs/lCR;;AoFv/lCI;EACI,iBAAA;ApF0/lCR;;AoF3/lCI;EACI,iBAAA;ApF8/lCR;;AoF//lCI;EACI,iBAAA;ApFkgmCR;;AoFngmCI;EACI,iBAAA;ApFsgmCR;;AoFvgmCI;EACI,iBAAA;ApF0gmCR;;AoF3gmCI;EACI,iBAAA;ApF8gmCR;;AoF/gmCI;EACI,iBAAA;ApFkhmCR;;AoFnhmCI;EACI,iBAAA;ApFshmCR;;AoFvhmCI;EACI,iBAAA;ApF0hmCR;;AoF3hmCI;EACI,iBAAA;ApF8hmCR;;AoF/hmCI;EACI,iBAAA;ApFkimCR;;AoFnimCI;EACI,iBAAA;ApFsimCR;;AoFvimCI;EACI,iBAAA;ApF0imCR;;AoF3imCI;EACI,iBAAA;ApF8imCR;;AoF/imCI;EACI,iBAAA;ApFkjmCR;;AoFnjmCI;EACI,iBAAA;ApFsjmCR;;AoFvjmCI;EACI,iBAAA;ApF0jmCR;;AoF3jmCI;EACI,iBAAA;ApF8jmCR;;AoF/jmCI;EACI,iBAAA;ApFkkmCR;;AoFnkmCI;EACI,iBAAA;ApFskmCR;;AoFvkmCI;EACI,iBAAA;ApF0kmCR;;AoF3kmCI;EACI,iBAAA;ApF8kmCR;;AoF/kmCI;EACI,iBAAA;ApFklmCR;;AoFnlmCI;EACI,iBAAA;ApFslmCR;;AoFvlmCI;EACI,iBAAA;ApF0lmCR;;AoF3lmCI;EACI,iBAAA;ApF8lmCR;;AoF/lmCI;EACI,iBAAA;ApFkmmCR;;AoFnmmCI;EACI,iBAAA;ApFsmmCR;;AoFvmmCI;EACI,iBAAA;ApF0mmCR;;AoF3mmCI;EACI,iBAAA;ApF8mmCR;;AoF/mmCI;EACI,iBAAA;ApFknmCR;;AoFnnmCI;EACI,iBAAA;ApFsnmCR;;AoFvnmCI;EACI,iBAAA;ApF0nmCR;;AoF3nmCI;EACI,iBAAA;ApF8nmCR;;AoF/nmCI;EACI,iBAAA;ApFkomCR;;AoFnomCI;EACI,iBAAA;ApFsomCR;;AoFvomCI;EACI,iBAAA;ApF0omCR;;AoF3omCI;EACI,iBAAA;ApF8omCR;;AoF/omCI;EACI,iBAAA;ApFkpmCR;;AoFnpmCI;EACI,iBAAA;ApFspmCR;;AoFvpmCI;EACI,iBAAA;ApF0pmCR;;AoF3pmCI;EACI,iBAAA;ApF8pmCR;;AoF/pmCI;EACI,iBAAA;ApFkqmCR;;AoFnqmCI;EACI,iBAAA;ApFsqmCR;;AoFvqmCI;EACI,iBAAA;ApF0qmCR;;AoF3qmCI;EACI,iBAAA;ApF8qmCR;;AoF/qmCI;EACI,iBAAA;ApFkrmCR;;AoFnrmCI;EACI,iBAAA;ApFsrmCR;;AoFvrmCI;EACI,iBAAA;ApF0rmCR;;AoF3rmCI;EACI,iBAAA;ApF8rmCR;;AoF/rmCI;EACI,iBAAA;ApFksmCR;;AoFnsmCI;EACI,iBAAA;ApFssmCR;;AoFvsmCI;EACI,iBAAA;ApF0smCR;;AoF3smCI;EACI,iBAAA;ApF8smCR;;AoF/smCI;EACI,iBAAA;ApFktmCR;;AoFntmCI;EACI,iBAAA;ApFstmCR;;AoFvtmCI;EACI,iBAAA;ApF0tmCR;;AoF3tmCI;EACI,iBAAA;ApF8tmCR;;AoF/tmCI;EACI,iBAAA;ApFkumCR;;AoFnumCI;EACI,iBAAA;ApFsumCR;;AoFvumCI;EACI,iBAAA;ApF0umCR;;AoF3umCI;EACI,iBAAA;ApF8umCR;;AoF/umCI;EACI,iBAAA;ApFkvmCR;;AoFnvmCI;EACI,iBAAA;ApFsvmCR;;AoFvvmCI;EACI,iBAAA;ApF0vmCR;;AoF3vmCI;EACI,iBAAA;ApF8vmCR;;AoF/vmCI;EACI,iBAAA;ApFkwmCR;;AoFnwmCI;EACI,iBAAA;ApFswmCR;;AoFvwmCI;EACI,iBAAA;ApF0wmCR;;AoF3wmCI;EACI,iBAAA;ApF8wmCR;;AoF/wmCI;EACI,iBAAA;ApFkxmCR;;AoFnxmCI;EACI,iBAAA;ApFsxmCR;;AoFvxmCI;EACI,iBAAA;ApF0xmCR;;AoF3xmCI;EACI,iBAAA;ApF8xmCR;;AoF/xmCI;EACI,iBAAA;ApFkymCR;;AoFnymCI;EACI,iBAAA;ApFsymCR;;AoFvymCI;EACI,iBAAA;ApF0ymCR;;AoF3ymCI;EACI,iBAAA;ApF8ymCR;;AoF/ymCI;EACI,iBAAA;ApFkzmCR;;AoFnzmCI;EACI,iBAAA;ApFszmCR;;AoFvzmCI;EACI,iBAAA;ApF0zmCR;;AoF3zmCI;EACI,iBAAA;ApF8zmCR;;AoF/zmCI;EACI,iBAAA;ApFk0mCR;;AoFn0mCI;EACI,iBAAA;ApFs0mCR;;AoFv0mCI;EACI,iBAAA;ApF00mCR;;AoF30mCI;EACI,iBAAA;ApF80mCR;;AoF/0mCI;EACI,iBAAA;ApFk1mCR;;AoFn1mCI;EACI,iBAAA;ApFs1mCR;;AoFv1mCI;EACI,iBAAA;ApF01mCR;;AoF31mCI;EACI,iBAAA;ApF81mCR;;AoF/1mCI;EACI,iBAAA;ApFk2mCR;;AoFn2mCI;EACI,iBAAA;ApFs2mCR;;AoFv2mCI;EACI,iBAAA;ApF02mCR;;AoF32mCI;EACI,iBAAA;ApF82mCR;;AoF/2mCI;EACI,iBAAA;ApFk3mCR;;AoFn3mCI;EACI,iBAAA;ApFs3mCR;;AoFv3mCI;EACI,iBAAA;ApF03mCR;;AoF33mCI;EACI,iBAAA;ApF83mCR;;AoF/3mCI;EACI,iBAAA;ApFk4mCR;;AoFn4mCI;EACI,iBAAA;ApFs4mCR;;AoFv4mCI;EACI,iBAAA;ApF04mCR;;AoF34mCI;EACI,iBAAA;ApF84mCR;;AoF/4mCI;EACI,iBAAA;ApFk5mCR;;AoFn5mCI;EACI,iBAAA;ApFs5mCR;;AoFv5mCI;EACI,iBAAA;ApF05mCR;;AoF35mCI;EACI,iBAAA;ApF85mCR;;AoF/5mCI;EACI,iBAAA;ApFk6mCR;;AoFn6mCI;EACI,iBAAA;ApFs6mCR;;AoFv6mCI;EACI,iBAAA;ApF06mCR;;AoF36mCI;EACI,iBAAA;ApF86mCR;;AoF/6mCI;EACI,iBAAA;ApFk7mCR;;AoFn7mCI;EACI,iBAAA;ApFs7mCR;;AoFv7mCI;EACI,iBAAA;ApF07mCR;;AoF37mCI;EACI,iBAAA;ApF87mCR;;AoF/7mCI;EACI,iBAAA;ApFk8mCR;;AoFn8mCI;EACI,iBAAA;ApFs8mCR;;AoFv8mCI;EACI,iBAAA;ApF08mCR;;AoF38mCI;EACI,iBAAA;ApF88mCR;;AoF/8mCI;EACI,iBAAA;ApFk9mCR;;AoFn9mCI;EACI,iBAAA;ApFs9mCR;;AoFv9mCI;EACI,iBAAA;ApF09mCR;;AoF39mCI;EACI,iBAAA;ApF89mCR;;AoF/9mCI;EACI,iBAAA;ApFk+mCR;;AoFn+mCI;EACI,iBAAA;ApFs+mCR;;AoFv+mCI;EACI,iBAAA;ApF0+mCR;;AoF3+mCI;EACI,iBAAA;ApF8+mCR;;AoF/+mCI;EACI,iBAAA;ApFk/mCR;;AoFn/mCI;EACI,iBAAA;ApFs/mCR;;AoFv/mCI;EACI,iBAAA;ApF0/mCR;;AoF3/mCI;EACI,iBAAA;ApF8/mCR;;AoF//mCI;EACI,iBAAA;ApFkgnCR;;AoFngnCI;EACI,iBAAA;ApFsgnCR;;AoFvgnCI;EACI,iBAAA;ApF0gnCR;;AoF3gnCI;EACI,iBAAA;ApF8gnCR;;AoF/gnCI;EACI,iBAAA;ApFkhnCR;;AoFnhnCI;EACI,iBAAA;ApFshnCR;;AoFvhnCI;EACI,iBAAA;ApF0hnCR;;AoF3hnCI;EACI,iBAAA;ApF8hnCR;;AoF/hnCI;EACI,iBAAA;ApFkinCR;;AoFninCI;EACI,iBAAA;ApFsinCR;;AoFvinCI;EACI,iBAAA;ApF0inCR;;AoF3inCI;EACI,iBAAA;ApF8inCR;;AoF/inCI;EACI,iBAAA;ApFkjnCR;;AoFnjnCI;EACI,iBAAA;ApFsjnCR;;AoFvjnCI;EACI,iBAAA;ApF0jnCR;;AoF3jnCI;EACI,iBAAA;ApF8jnCR;;AoF/jnCI;EACI,iBAAA;ApFkknCR;;AoFnknCI;EACI,iBAAA;ApFsknCR;;AoFvknCI;EACI,iBAAA;ApF0knCR;;AoF3knCI;EACI,iBAAA;ApF8knCR;;AoF/knCI;EACI,iBAAA;ApFklnCR;;AoFnlnCI;EACI,iBAAA;ApFslnCR;;AoFvlnCI;EACI,iBAAA;ApF0lnCR;;AoF3lnCI;EACI,iBAAA;ApF8lnCR;;AoF/lnCI;EACI,iBAAA;ApFkmnCR;;AoFnmnCI;EACI,iBAAA;ApFsmnCR;;AoFvmnCI;EACI,iBAAA;ApF0mnCR;;AoF3mnCI;EACI,iBAAA;ApF8mnCR;;AoF/mnCI;EACI,iBAAA;ApFknnCR;;AoFnnnCI;EACI,iBAAA;ApFsnnCR;;AoFvnnCI;EACI,iBAAA;ApF0nnCR;;AoF3nnCI;EACI,iBAAA;ApF8nnCR;;AoF/nnCI;EACI,iBAAA;ApFkonCR;;AoFnonCI;EACI,iBAAA;ApFsonCR;;AoFvonCI;EACI,iBAAA;ApF0onCR;;AoF3onCI;EACI,iBAAA;ApF8onCR;;AoF/onCI;EACI,iBAAA;ApFkpnCR;;AoFnpnCI;EACI,iBAAA;ApFspnCR;;AoFvpnCI;EACI,iBAAA;ApF0pnCR;;AoF3pnCI;EACI,iBAAA;ApF8pnCR;;AoF/pnCI;EACI,iBAAA;ApFkqnCR;;AoFnqnCI;EACI,iBAAA;ApFsqnCR;;AoFvqnCI;EACI,iBAAA;ApF0qnCR;;AoF3qnCI;EACI,iBAAA;ApF8qnCR;;AoF/qnCI;EACI,iBAAA;ApFkrnCR;;AoFnrnCI;EACI,iBAAA;ApFsrnCR;;AoFvrnCI;EACI,iBAAA;ApF0rnCR;;AoF3rnCI;EACI,iBAAA;ApF8rnCR;;AoF/rnCI;EACI,iBAAA;ApFksnCR;;AoFnsnCI;EACI,iBAAA;ApFssnCR;;AoFvsnCI;EACI,iBAAA;ApF0snCR;;AoF3snCI;EACI,iBAAA;ApF8snCR;;AoF/snCI;EACI,iBAAA;ApFktnCR;;AoFntnCI;EACI,iBAAA;ApFstnCR;;AoFvtnCI;EACI,iBAAA;ApF0tnCR;;AoF3tnCI;EACI,iBAAA;ApF8tnCR;;AoF/tnCI;EACI,iBAAA;ApFkunCR;;AoFnunCI;EACI,iBAAA;ApFsunCR;;AoFvunCI;EACI,iBAAA;ApF0unCR;;AoF3unCI;EACI,iBAAA;ApF8unCR;;AoF/unCI;EACI,iBAAA;ApFkvnCR;;AoFnvnCI;EACI,iBAAA;ApFsvnCR;;AoFvvnCI;EACI,iBAAA;ApF0vnCR;;AoF3vnCI;EACI,iBAAA;ApF8vnCR;;AoF/vnCI;EACI,iBAAA;ApFkwnCR;;AoFnwnCI;EACI,iBAAA;ApFswnCR;;AoFvwnCI;EACI,iBAAA;ApF0wnCR;;AoF3wnCI;EACI,iBAAA;ApF8wnCR;;AoF/wnCI;EACI,iBAAA;ApFkxnCR;;AoFnxnCI;EACI,iBAAA;ApFsxnCR;;AoFvxnCI;EACI,iBAAA;ApF0xnCR;;AoF3xnCI;EACI,iBAAA;ApF8xnCR;;AoF/xnCI;EACI,iBAAA;ApFkynCR;;AoFnynCI;EACI,iBAAA;ApFsynCR;;AoFvynCI;EACI,iBAAA;ApF0ynCR;;AoF3ynCI;EACI,iBAAA;ApF8ynCR;;AoF/ynCI;EACI,iBAAA;ApFkznCR;;AoFnznCI;EACI,iBAAA;ApFsznCR;;AoFvznCI;EACI,iBAAA;ApF0znCR;;AoF3znCI;EACI,iBAAA;ApF8znCR;;AoF/znCI;EACI,iBAAA;ApFk0nCR;;AoFn0nCI;EACI,iBAAA;ApFs0nCR;;AoFv0nCI;EACI,iBAAA;ApF00nCR;;AoF30nCI;EACI,iBAAA;ApF80nCR;;AoF/0nCI;EACI,iBAAA;ApFk1nCR;;AoFn1nCI;EACI,iBAAA;ApFs1nCR;;AoFv1nCI;EACI,iBAAA;ApF01nCR;;AoF31nCI;EACI,iBAAA;ApF81nCR;;AoF/1nCI;EACI,iBAAA;ApFk2nCR;;AoFn2nCI;EACI,iBAAA;ApFs2nCR;;AoFv2nCI;EACI,iBAAA;ApF02nCR;;AoF32nCI;EACI,iBAAA;ApF82nCR;;AoF/2nCI;EACI,iBAAA;ApFk3nCR;;AoFn3nCI;EACI,iBAAA;ApFs3nCR;;AoFv3nCI;EACI,iBAAA;ApF03nCR;;AoF33nCI;EACI,iBAAA;ApF83nCR;;AoF/3nCI;EACI,iBAAA;ApFk4nCR;;AoFn4nCI;EACI,iBAAA;ApFs4nCR;;AoFv4nCI;EACI,iBAAA;ApF04nCR;;AoF34nCI;EACI,iBAAA;ApF84nCR;;AoF/4nCI;EACI,iBAAA;ApFk5nCR;;AoFn5nCI;EACI,iBAAA;ApFs5nCR;;AoFv5nCI;EACI,iBAAA;ApF05nCR;;AoF35nCI;EACI,iBAAA;ApF85nCR;;AoF/5nCI;EACI,iBAAA;ApFk6nCR;;AoFn6nCI;EACI,iBAAA;ApFs6nCR;;AoFv6nCI;EACI,iBAAA;ApF06nCR;;AoF36nCI;EACI,iBAAA;ApF86nCR;;AoF/6nCI;EACI,iBAAA;ApFk7nCR;;AoFn7nCI;EACI,iBAAA;ApFs7nCR;;AoFv7nCI;EACI,iBAAA;ApF07nCR;;AoF37nCI;EACI,iBAAA;ApF87nCR;;AoF/7nCI;EACI,iBAAA;ApFk8nCR;;AoFn8nCI;EACI,iBAAA;ApFs8nCR;;AoFv8nCI;EACI,iBAAA;ApF08nCR;;AoF38nCI;EACI,iBAAA;ApF88nCR;;AoF/8nCI;EACI,iBAAA;ApFk9nCR;;AoFn9nCI;EACI,iBAAA;ApFs9nCR;;AoFv9nCI;EACI,iBAAA;ApF09nCR;;AoF39nCI;EACI,iBAAA;ApF89nCR;;AoF/9nCI;EACI,iBAAA;ApFk+nCR;;AoFn+nCI;EACI,iBAAA;ApFs+nCR;;AoFv+nCI;EACI,iBAAA;ApF0+nCR;;AoF3+nCI;EACI,iBAAA;ApF8+nCR;;AoF/+nCI;EACI,iBAAA;ApFk/nCR;;AoFn/nCI;EACI,iBAAA;ApFs/nCR;;AoFv/nCI;EACI,iBAAA;ApF0/nCR;;AoF3/nCI;EACI,iBAAA;ApF8/nCR;;AoF//nCI;EACI,iBAAA;ApFkgoCR;;AoFngoCI;EACI,iBAAA;ApFsgoCR;;AoFvgoCI;EACI,iBAAA;ApF0goCR;;AoF3goCI;EACI,iBAAA;ApF8goCR;;AoF/goCI;EACI,iBAAA;ApFkhoCR;;AoFnhoCI;EACI,iBAAA;ApFshoCR;;AoFvhoCI;EACI,iBAAA;ApF0hoCR;;AoF3hoCI;EACI,iBAAA;ApF8hoCR;;AoF/hoCI;EACI,iBAAA;ApFkioCR;;AoFnioCI;EACI,iBAAA;ApFsioCR;;AoFvioCI;EACI,iBAAA;ApF0ioCR;;AoF3ioCI;EACI,iBAAA;ApF8ioCR;;AoF/ioCI;EACI,iBAAA;ApFkjoCR;;AoFnjoCI;EACI,iBAAA;ApFsjoCR;;AoFvjoCI;EACI,iBAAA;ApF0joCR;;AoF3joCI;EACI,iBAAA;ApF8joCR;;AoF/joCI;EACI,iBAAA;ApFkkoCR;;AoFnkoCI;EACI,iBAAA;ApFskoCR;;AoFvkoCI;EACI,iBAAA;ApF0koCR;;AoF3koCI;EACI,iBAAA;ApF8koCR;;AoF/koCI;EACI,iBAAA;ApFkloCR;;AoFnloCI;EACI,iBAAA;ApFsloCR;;AoFvloCI;EACI,iBAAA;ApF0loCR;;AoF3loCI;EACI,iBAAA;ApF8loCR;;AoF/loCI;EACI,iBAAA;ApFkmoCR;;AoFnmoCI;EACI,iBAAA;ApFsmoCR;;AoFvmoCI;EACI,iBAAA;ApF0moCR;;AoF3moCI;EACI,iBAAA;ApF8moCR;;AoF/moCI;EACI,iBAAA;ApFknoCR;;AoFnnoCI;EACI,iBAAA;ApFsnoCR;;AoFvnoCI;EACI,iBAAA;ApF0noCR;;AoF3noCI;EACI,iBAAA;ApF8noCR;;AoF/noCI;EACI,iBAAA;ApFkooCR;;AoFnooCI;EACI,iBAAA;ApFsooCR;;AoFvooCI;EACI,iBAAA;ApF0ooCR;;AoF3ooCI;EACI,iBAAA;ApF8ooCR;;AoF/ooCI;EACI,iBAAA;ApFkpoCR;;AoFnpoCI;EACI,iBAAA;ApFspoCR;;AoFvpoCI;EACI,iBAAA;ApF0poCR;;AoF3poCI;EACI,iBAAA;ApF8poCR;;AoF/poCI;EACI,iBAAA;ApFkqoCR;;AoFnqoCI;EACI,iBAAA;ApFsqoCR;;AoFvqoCI;EACI,iBAAA;ApF0qoCR;;AoF3qoCI;EACI,iBAAA;ApF8qoCR;;AoF/qoCI;EACI,iBAAA;ApFkroCR;;AoFnroCI;EACI,iBAAA;ApFsroCR;;AoFvroCI;EACI,iBAAA;ApF0roCR;;AoF3roCI;EACI,iBAAA;ApF8roCR;;AoF/roCI;EACI,iBAAA;ApFksoCR;;AoFnsoCI;EACI,iBAAA;ApFssoCR;;AoFvsoCI;EACI,iBAAA;ApF0soCR;;AoF3soCI;EACI,iBAAA;ApF8soCR;;AoF/soCI;EACI,iBAAA;ApFktoCR;;AoFntoCI;EACI,iBAAA;ApFstoCR;;AoFvtoCI;EACI,iBAAA;ApF0toCR;;AoF3toCI;EACI,iBAAA;ApF8toCR;;AoF/toCI;EACI,iBAAA;ApFkuoCR;;AoFnuoCI;EACI,iBAAA;ApFsuoCR;;AoFvuoCI;EACI,iBAAA;ApF0uoCR;;AoF3uoCI;EACI,iBAAA;ApF8uoCR;;AoF/uoCI;EACI,iBAAA;ApFkvoCR;;AoFnvoCI;EACI,iBAAA;ApFsvoCR;;AoFvvoCI;EACI,iBAAA;ApF0voCR;;AoF3voCI;EACI,iBAAA;ApF8voCR;;AoF/voCI;EACI,iBAAA;ApFkwoCR;;AoFnwoCI;EACI,iBAAA;ApFswoCR;;AoFvwoCI;EACI,iBAAA;ApF0woCR;;AoF3woCI;EACI,iBAAA;ApF8woCR;;AoF/woCI;EACI,iBAAA;ApFkxoCR;;AoFnxoCI;EACI,iBAAA;ApFsxoCR;;AoFvxoCI;EACI,iBAAA;ApF0xoCR;;AoF3xoCI;EACI,iBAAA;ApF8xoCR;;AoF/xoCI;EACI,iBAAA;ApFkyoCR;;AoFnyoCI;EACI,iBAAA;ApFsyoCR;;AoFvyoCI;EACI,iBAAA;ApF0yoCR;;AoF3yoCI;EACI,iBAAA;ApF8yoCR;;AoF/yoCI;EACI,iBAAA;ApFkzoCR;;AoFnzoCI;EACI,iBAAA;ApFszoCR;;AoFvzoCI;EACI,iBAAA;ApF0zoCR;;AoF3zoCI;EACI,iBAAA;ApF8zoCR;;AoF/zoCI;EACI,iBAAA;ApFk0oCR;;AoFn0oCI;EACI,iBAAA;ApFs0oCR;;AoFv0oCI;EACI,iBAAA;ApF00oCR;;AoF30oCI;EACI,iBAAA;ApF80oCR;;AoF/0oCI;EACI,iBAAA;ApFk1oCR;;AoFn1oCI;EACI,iBAAA;ApFs1oCR;;AoFv1oCI;EACI,iBAAA;ApF01oCR;;AoF31oCI;EACI,iBAAA;ApF81oCR;;AoF/1oCI;EACI,iBAAA;ApFk2oCR;;AoFn2oCI;EACI,iBAAA;ApFs2oCR;;AoFv2oCI;EACI,iBAAA;ApF02oCR;;AoF32oCI;EACI,iBAAA;ApF82oCR;;AoF/2oCI;EACI,iBAAA;ApFk3oCR;;AoFn3oCI;EACI,iBAAA;ApFs3oCR;;AoFv3oCI;EACI,iBAAA;ApF03oCR;;AoF33oCI;EACI,iBAAA;ApF83oCR;;AoF/3oCI;EACI,iBAAA;ApFk4oCR;;AoFn4oCI;EACI,iBAAA;ApFs4oCR;;AoFv4oCI;EACI,iBAAA;ApF04oCR;;AoF34oCI;EACI,iBAAA;ApF84oCR;;AoF/4oCI;EACI,iBAAA;ApFk5oCR;;AoFn5oCI;EACI,iBAAA;ApFs5oCR;;AoFv5oCI;EACI,iBAAA;ApF05oCR;;AoF35oCI;EACI,iBAAA;ApF85oCR;;AoF/5oCI;EACI,iBAAA;ApFk6oCR;;AoFn6oCI;EACI,iBAAA;ApFs6oCR;;AoFv6oCI;EACI,iBAAA;ApF06oCR;;AoF36oCI;EACI,iBAAA;ApF86oCR;;AoF/6oCI;EACI,iBAAA;ApFk7oCR;;AoFn7oCI;EACI,iBAAA;ApFs7oCR;;AoFv7oCI;EACI,iBAAA;ApF07oCR;;AoF37oCI;EACI,iBAAA;ApF87oCR;;AoF/7oCI;EACI,iBAAA;ApFk8oCR;;AoFn8oCI;EACI,iBAAA;ApFs8oCR;;AoFv8oCI;EACI,iBAAA;ApF08oCR;;AoF38oCI;EACI,iBAAA;ApF88oCR;;AoF/8oCI;EACI,iBAAA;ApFk9oCR;;AoFn9oCI;EACI,iBAAA;ApFs9oCR;;AoFv9oCI;EACI,iBAAA;ApF09oCR;;AoF39oCI;EACI,iBAAA;ApF89oCR;;AoF/9oCI;EACI,iBAAA;ApFk+oCR;;AoFn+oCI;EACI,iBAAA;ApFs+oCR;;AoFv+oCI;EACI,iBAAA;ApF0+oCR;;AoF3+oCI;EACI,iBAAA;ApF8+oCR;;AoF/+oCI;EACI,iBAAA;ApFk/oCR;;AoFn/oCI;EACI,iBAAA;ApFs/oCR;;AoFv/oCI;EACI,iBAAA;ApF0/oCR;;AoF3/oCI;EACI,iBAAA;ApF8/oCR;;AoF//oCI;EACI,iBAAA;ApFkgpCR;;AoFngpCI;EACI,iBAAA;ApFsgpCR;;AoFvgpCI;EACI,iBAAA;ApF0gpCR;;AoF3gpCI;EACI,iBAAA;ApF8gpCR;;AoF/gpCI;EACI,iBAAA;ApFkhpCR;;AoFnhpCI;EACI,iBAAA;ApFshpCR;;AoFvhpCI;EACI,iBAAA;ApF0hpCR;;AoF3hpCI;EACI,iBAAA;ApF8hpCR;;AoF/hpCI;EACI,iBAAA;ApFkipCR;;AoFnipCI;EACI,iBAAA;ApFsipCR;;AoFvipCI;EACI,iBAAA;ApF0ipCR;;AoF3ipCI;EACI,iBAAA;ApF8ipCR;;AoF/ipCI;EACI,iBAAA;ApFkjpCR;;AoFnjpCI;EACI,iBAAA;ApFsjpCR;;AoFvjpCI;EACI,iBAAA;ApF0jpCR;;AoF3jpCI;EACI,iBAAA;ApF8jpCR;;AoF/jpCI;EACI,iBAAA;ApFkkpCR;;AoFnkpCI;EACI,iBAAA;ApFskpCR;;AoFvkpCI;EACI,iBAAA;ApF0kpCR;;AoF3kpCI;EACI,iBAAA;ApF8kpCR;;AoF/kpCI;EACI,iBAAA;ApFklpCR;;AoFnlpCI;EACI,iBAAA;ApFslpCR;;AoFvlpCI;EACI,iBAAA;ApF0lpCR;;AoF3lpCI;EACI,iBAAA;ApF8lpCR;;AoF/lpCI;EACI,iBAAA;ApFkmpCR;;AoFnmpCI;EACI,iBAAA;ApFsmpCR;;AoFvmpCI;EACI,iBAAA;ApF0mpCR;;AoF3mpCI;EACI,iBAAA;ApF8mpCR;;AoF/mpCI;EACI,iBAAA;ApFknpCR;;AoFnnpCI;EACI,iBAAA;ApFsnpCR;;AoFvnpCI;EACI,iBAAA;ApF0npCR;;AoF3npCI;EACI,iBAAA;ApF8npCR;;AoF/npCI;EACI,iBAAA;ApFkopCR;;AoFnopCI;EACI,iBAAA;ApFsopCR;;AoFvopCI;EACI,iBAAA;ApF0opCR;;AoF3opCI;EACI,iBAAA;ApF8opCR;;AoF/opCI;EACI,iBAAA;ApFkppCR;;AoFnppCI;EACI,iBAAA;ApFsppCR;;AoFvppCI;EACI,iBAAA;ApF0ppCR;;AoF3ppCI;EACI,iBAAA;ApF8ppCR;;AoF/ppCI;EACI,iBAAA;ApFkqpCR;;AoFnqpCI;EACI,iBAAA;ApFsqpCR;;AoFvqpCI;EACI,iBAAA;ApF0qpCR;;AoF3qpCI;EACI,iBAAA;ApF8qpCR;;AoF/qpCI;EACI,iBAAA;ApFkrpCR;;AoFnrpCI;EACI,iBAAA;ApFsrpCR;;AoFvrpCI;EACI,iBAAA;ApF0rpCR;;AoF3rpCI;EACI,iBAAA;ApF8rpCR;;AoF/rpCI;EACI,iBAAA;ApFkspCR;;AoFnspCI;EACI,iBAAA;ApFsspCR;;AoFvspCI;EACI,iBAAA;ApF0spCR;;AoF3spCI;EACI,iBAAA;ApF8spCR;;AoF/spCI;EACI,iBAAA;ApFktpCR;;AoFntpCI;EACI,iBAAA;ApFstpCR;;AoFvtpCI;EACI,iBAAA;ApF0tpCR;;AoF3tpCI;EACI,iBAAA;ApF8tpCR;;AoF/tpCI;EACI,iBAAA;ApFkupCR;;AoFnupCI;EACI,iBAAA;ApFsupCR;;AoFvupCI;EACI,iBAAA;ApF0upCR;;AoF3upCI;EACI,iBAAA;ApF8upCR;;AoF/upCI;EACI,iBAAA;ApFkvpCR;;AoFnvpCI;EACI,iBAAA;ApFsvpCR;;AoFvvpCI;EACI,iBAAA;ApF0vpCR;;AoF3vpCI;EACI,iBAAA;ApF8vpCR;;AoF/vpCI;EACI,iBAAA;ApFkwpCR;;AoFnwpCI;EACI,iBAAA;ApFswpCR;;AoFvwpCI;EACI,iBAAA;ApF0wpCR;;AoF3wpCI;EACI,iBAAA;ApF8wpCR;;AoF/wpCI;EACI,iBAAA;ApFkxpCR;;AoFnxpCI;EACI,iBAAA;ApFsxpCR;;AoFvxpCI;EACI,iBAAA;ApF0xpCR;;AoF3xpCI;EACI,iBAAA;ApF8xpCR;;AoF/xpCI;EACI,iBAAA;ApFkypCR;;AoFnypCI;EACI,iBAAA;ApFsypCR;;AoFvypCI;EACI,iBAAA;ApF0ypCR;;AoF3ypCI;EACI,iBAAA;ApF8ypCR;;AoF/ypCI;EACI,iBAAA;ApFkzpCR;;AoFnzpCI;EACI,iBAAA;ApFszpCR;;AoFvzpCI;EACI,iBAAA;ApF0zpCR;;AoF3zpCI;EACI,iBAAA;ApF8zpCR;;AoF/zpCI;EACI,iBAAA;ApFk0pCR;;AoFn0pCI;EACI,iBAAA;ApFs0pCR;;AoFv0pCI;EACI,iBAAA;ApF00pCR;;AoF30pCI;EACI,iBAAA;ApF80pCR;;AoF/0pCI;EACI,iBAAA;ApFk1pCR;;AoFn1pCI;EACI,iBAAA;ApFs1pCR;;AoFv1pCI;EACI,iBAAA;ApF01pCR;;AoF31pCI;EACI,iBAAA;ApF81pCR;;AoF/1pCI;EACI,iBAAA;ApFk2pCR;;AoFn2pCI;EACI,iBAAA;ApFs2pCR;;AoFv2pCI;EACI,iBAAA;ApF02pCR;;AoF32pCI;EACI,iBAAA;ApF82pCR;;AoF/2pCI;EACI,iBAAA;ApFk3pCR;;AoFn3pCI;EACI,iBAAA;ApFs3pCR;;AoFv3pCI;EACI,iBAAA;ApF03pCR;;AoF33pCI;EACI,iBAAA;ApF83pCR;;AoF/3pCI;EACI,iBAAA;ApFk4pCR;;AoFn4pCI;EACI,iBAAA;ApFs4pCR;;AoFv4pCI;EACI,iBAAA;ApF04pCR;;AoF34pCI;EACI,iBAAA;ApF84pCR;;AoF/4pCI;EACI,iBAAA;ApFk5pCR;;AoFn5pCI;EACI,iBAAA;ApFs5pCR;;AoFv5pCI;EACI,iBAAA;ApF05pCR;;AoF35pCI;EACI,iBAAA;ApF85pCR;;AoF/5pCI;EACI,iBAAA;ApFk6pCR;;AoFn6pCI;EACI,iBAAA;ApFs6pCR;;AoFv6pCI;EACI,iBAAA;ApF06pCR;;AoF36pCI;EACI,iBAAA;ApF86pCR;;AoF/6pCI;EACI,iBAAA;ApFk7pCR;;AoFn7pCI;EACI,iBAAA;ApFs7pCR;;AoFv7pCI;EACI,iBAAA;ApF07pCR;;AoF37pCI;EACI,iBAAA;ApF87pCR;;AoF/7pCI;EACI,iBAAA;ApFk8pCR;;AoFn8pCI;EACI,iBAAA;ApFs8pCR;;AoFv8pCI;EACI,iBAAA;ApF08pCR;;AoF38pCI;EACI,iBAAA;ApF88pCR;;AoF/8pCI;EACI,iBAAA;ApFk9pCR;;AoFn9pCI;EACI,iBAAA;ApFs9pCR;;AoFv9pCI;EACI,iBAAA;ApF09pCR;;AoF39pCI;EACI,iBAAA;ApF89pCR;;AoF/9pCI;EACI,iBAAA;ApFk+pCR;;AoFn+pCI;EACI,iBAAA;ApFs+pCR;;AoFv+pCI;EACI,iBAAA;ApF0+pCR;;AoF3+pCI;EACI,iBAAA;ApF8+pCR;;AoF/+pCI;EACI,iBAAA;ApFk/pCR;;AoFn/pCI;EACI,iBAAA;ApFs/pCR;;AoFv/pCI;EACI,iBAAA;ApF0/pCR;;AoF3/pCI;EACI,iBAAA;ApF8/pCR;;AoF//pCI;EACI,iBAAA;ApFkgqCR;;AoFngqCI;EACI,iBAAA;ApFsgqCR;;AoFvgqCI;EACI,iBAAA;ApF0gqCR;;AoF3gqCI;EACI,iBAAA;ApF8gqCR;;AoF/gqCI;EACI,iBAAA;ApFkhqCR;;AoFnhqCI;EACI,iBAAA;ApFshqCR;;AoFvhqCI;EACI,iBAAA;ApF0hqCR;;AoF3hqCI;EACI,iBAAA;ApF8hqCR;;AoF/hqCI;EACI,iBAAA;ApFkiqCR;;AoFniqCI;EACI,iBAAA;ApFsiqCR;;AoFviqCI;EACI,iBAAA;ApF0iqCR;;AoF3iqCI;EACI,iBAAA;ApF8iqCR;;AoF/iqCI;EACI,iBAAA;ApFkjqCR;;AoFnjqCI;EACI,iBAAA;ApFsjqCR;;AoFvjqCI;EACI,iBAAA;ApF0jqCR;;AoF3jqCI;EACI,iBAAA;ApF8jqCR;;AoF/jqCI;EACI,iBAAA;ApFkkqCR;;AoFnkqCI;EACI,iBAAA;ApFskqCR;;AoFvkqCI;EACI,iBAAA;ApF0kqCR;;AoF3kqCI;EACI,iBAAA;ApF8kqCR;;AoF/kqCI;EACI,iBAAA;ApFklqCR;;AoFnlqCI;EACI,iBAAA;ApFslqCR;;AoFvlqCI;EACI,iBAAA;ApF0lqCR;;AoF3lqCI;EACI,iBAAA;ApF8lqCR;;AoF/lqCI;EACI,iBAAA;ApFkmqCR;;AoFnmqCI;EACI,iBAAA;ApFsmqCR;;AoFvmqCI;EACI,iBAAA;ApF0mqCR;;AoF3mqCI;EACI,iBAAA;ApF8mqCR;;AoF/mqCI;EACI,iBAAA;ApFknqCR;;AoFnnqCI;EACI,iBAAA;ApFsnqCR;;AoFvnqCI;EACI,iBAAA;ApF0nqCR;;AoF3nqCI;EACI,iBAAA;ApF8nqCR;;AoF/nqCI;EACI,iBAAA;ApFkoqCR;;AoFnoqCI;EACI,iBAAA;ApFsoqCR;;AoFvoqCI;EACI,iBAAA;ApF0oqCR;;AoF3oqCI;EACI,iBAAA;ApF8oqCR;;AoF/oqCI;EACI,iBAAA;ApFkpqCR;;AoFnpqCI;EACI,iBAAA;ApFspqCR;;AoFvpqCI;EACI,iBAAA;ApF0pqCR;;AoF3pqCI;EACI,iBAAA;ApF8pqCR;;AoF/pqCI;EACI,iBAAA;ApFkqqCR;;AoFnqqCI;EACI,iBAAA;ApFsqqCR;;AoFvqqCI;EACI,iBAAA;ApF0qqCR;;AoF3qqCI;EACI,iBAAA;ApF8qqCR;;AoF/qqCI;EACI,iBAAA;ApFkrqCR;;AoFnrqCI;EACI,iBAAA;ApFsrqCR;;AoFvrqCI;EACI,iBAAA;ApF0rqCR;;AoF3rqCI;EACI,iBAAA;ApF8rqCR;;AoF/rqCI;EACI,iBAAA;ApFksqCR;;AoFnsqCI;EACI,iBAAA;ApFssqCR;;AoFvsqCI;EACI,iBAAA;ApF0sqCR;;AoF3sqCI;EACI,iBAAA;ApF8sqCR;;AoF/sqCI;EACI,iBAAA;ApFktqCR;;AoFntqCI;EACI,iBAAA;ApFstqCR;;AoFvtqCI;EACI,iBAAA;ApF0tqCR;;AoF3tqCI;EACI,iBAAA;ApF8tqCR;;AoF/tqCI;EACI,iBAAA;ApFkuqCR;;AoFnuqCI;EACI,iBAAA;ApFsuqCR;;AoFvuqCI;EACI,iBAAA;ApF0uqCR;;AoF3uqCI;EACI,iBAAA;ApF8uqCR;;AoF/uqCI;EACI,iBAAA;ApFkvqCR;;AoFnvqCI;EACI,iBAAA;ApFsvqCR;;AoFvvqCI;EACI,iBAAA;ApF0vqCR;;AoF3vqCI;EACI,iBAAA;ApF8vqCR;;AoF/vqCI;EACI,iBAAA;ApFkwqCR;;AoFnwqCI;EACI,iBAAA;ApFswqCR;;AoFvwqCI;EACI,iBAAA;ApF0wqCR;;AoF3wqCI;EACI,iBAAA;ApF8wqCR;;AoF/wqCI;EACI,iBAAA;ApFkxqCR;;AoFnxqCI;EACI,iBAAA;ApFsxqCR;;AoFvxqCI;EACI,iBAAA;ApF0xqCR;;AoF3xqCI;EACI,iBAAA;ApF8xqCR;;AoF/xqCI;EACI,iBAAA;ApFkyqCR;;AoFnyqCI;EACI,iBAAA;ApFsyqCR;;AoFvyqCI;EACI,iBAAA;ApF0yqCR;;AoF3yqCI;EACI,iBAAA;ApF8yqCR;;AoF/yqCI;EACI,iBAAA;ApFkzqCR;;AoFnzqCI;EACI,iBAAA;ApFszqCR;;AoFvzqCI;EACI,iBAAA;ApF0zqCR;;AoF3zqCI;EACI,iBAAA;ApF8zqCR;;AoF/zqCI;EACI,iBAAA;ApFk0qCR;;AoFn0qCI;EACI,iBAAA;ApFs0qCR;;AoFv0qCI;EACI,iBAAA;ApF00qCR;;AoF30qCI;EACI,iBAAA;ApF80qCR;;AoF/0qCI;EACI,iBAAA;ApFk1qCR;;AoFn1qCI;EACI,iBAAA;ApFs1qCR;;AoFv1qCI;EACI,iBAAA;ApF01qCR;;AoF31qCI;EACI,iBAAA;ApF81qCR;;AoF/1qCI;EACI,iBAAA;ApFk2qCR;;AoFn2qCI;EACI,iBAAA;ApFs2qCR;;AoFv2qCI;EACI,iBAAA;ApF02qCR;;AoF32qCI;EACI,iBAAA;ApF82qCR;;AoF/2qCI;EACI,iBAAA;ApFk3qCR;;AoFn3qCI;EACI,iBAAA;ApFs3qCR;;AoFv3qCI;EACI,iBAAA;ApF03qCR;;AoF33qCI;EACI,iBAAA;ApF83qCR;;AoF/3qCI;EACI,iBAAA;ApFk4qCR;;AoFn4qCI;EACI,iBAAA;ApFs4qCR;;AoFv4qCI;EACI,iBAAA;ApF04qCR;;AoF34qCI;EACI,iBAAA;ApF84qCR;;AoF/4qCI;EACI,iBAAA;ApFk5qCR;;AoFn5qCI;EACI,iBAAA;ApFs5qCR;;AoFv5qCI;EACI,iBAAA;ApF05qCR;;AoF35qCI;EACI,iBAAA;ApF85qCR;;AoF/5qCI;EACI,iBAAA;ApFk6qCR;;AoFn6qCI;EACI,iBAAA;ApFs6qCR;;AoFv6qCI;EACI,iBAAA;ApF06qCR;;AoF36qCI;EACI,iBAAA;ApF86qCR;;AoF/6qCI;EACI,iBAAA;ApFk7qCR;;AoFn7qCI;EACI,iBAAA;ApFs7qCR;;AoFv7qCI;EACI,iBAAA;ApF07qCR;;AoF37qCI;EACI,iBAAA;ApF87qCR;;AoF/7qCI;EACI,iBAAA;ApFk8qCR;;AoFn8qCI;EACI,iBAAA;ApFs8qCR;;AoFv8qCI;EACI,iBAAA;ApF08qCR;;AoF38qCI;EACI,iBAAA;ApF88qCR;;AoF/8qCI;EACI,iBAAA;ApFk9qCR;;AoFn9qCI;EACI,iBAAA;ApFs9qCR;;AoFv9qCI;EACI,iBAAA;ApF09qCR;;AoF39qCI;EACI,iBAAA;ApF89qCR;;AoF/9qCI;EACI,iBAAA;ApFk+qCR;;AoFn+qCI;EACI,iBAAA;ApFs+qCR;;AoFv+qCI;EACI,iBAAA;ApF0+qCR;;AoF3+qCI;EACI,iBAAA;ApF8+qCR;;AoF/+qCI;EACI,iBAAA;ApFk/qCR;;AoFn/qCI;EACI,iBAAA;ApFs/qCR;;AoFv/qCI;EACI,iBAAA;ApF0/qCR;;AoF3/qCI;EACI,iBAAA;ApF8/qCR;;AoF//qCI;EACI,iBAAA;ApFkgrCR;;AoFngrCI;EACI,iBAAA;ApFsgrCR;;AoFvgrCI;EACI,iBAAA;ApF0grCR;;AoF3grCI;EACI,iBAAA;ApF8grCR;;AoF/grCI;EACI,iBAAA;ApFkhrCR;;AoFnhrCI;EACI,iBAAA;ApFshrCR;;AoFvhrCI;EACI,iBAAA;ApF0hrCR;;AoF3hrCI;EACI,iBAAA;ApF8hrCR;;AoF/hrCI;EACI,iBAAA;ApFkirCR;;AoFnirCI;EACI,iBAAA;ApFsirCR;;AoFvirCI;EACI,iBAAA;ApF0irCR;;AoF3irCI;EACI,iBAAA;ApF8irCR;;AoF/irCI;EACI,iBAAA;ApFkjrCR;;AoFnjrCI;EACI,iBAAA;ApFsjrCR;;AoFvjrCI;EACI,iBAAA;ApF0jrCR;;AoF3jrCI;EACI,iBAAA;ApF8jrCR;;AoF/jrCI;EACI,iBAAA;ApFkkrCR;;AoFnkrCI;EACI,iBAAA;ApFskrCR;;AoFvkrCI;EACI,iBAAA;ApF0krCR;;AoF3krCI;EACI,iBAAA;ApF8krCR;;AoF/krCI;EACI,iBAAA;ApFklrCR;;AoFnlrCI;EACI,iBAAA;ApFslrCR;;AoFvlrCI;EACI,iBAAA;ApF0lrCR;;AoF3lrCI;EACI,iBAAA;ApF8lrCR;;AoF/lrCI;EACI,iBAAA;ApFkmrCR;;AoFnmrCI;EACI,iBAAA;ApFsmrCR;;AoFvmrCI;EACI,iBAAA;ApF0mrCR;;AoF3mrCI;EACI,iBAAA;ApF8mrCR;;AoF/mrCI;EACI,iBAAA;ApFknrCR;;AoFnnrCI;EACI,iBAAA;ApFsnrCR;;AoFvnrCI;EACI,iBAAA;ApF0nrCR;;AoF3nrCI;EACI,iBAAA;ApF8nrCR;;AoF/nrCI;EACI,iBAAA;ApFkorCR;;AoFnorCI;EACI,iBAAA;ApFsorCR;;AoFvorCI;EACI,iBAAA;ApF0orCR;;AoF3orCI;EACI,iBAAA;ApF8orCR;;AoF/orCI;EACI,iBAAA;ApFkprCR;;AoFnprCI;EACI,iBAAA;ApFsprCR;;AoFvprCI;EACI,iBAAA;ApF0prCR;;AoF3prCI;EACI,iBAAA;ApF8prCR;;AoF/prCI;EACI,iBAAA;ApFkqrCR;;AoFnqrCI;EACI,iBAAA;ApFsqrCR;;AoFvqrCI;EACI,iBAAA;ApF0qrCR;;AoF3qrCI;EACI,iBAAA;ApF8qrCR;;AoF/qrCI;EACI,iBAAA;ApFkrrCR;;AoFnrrCI;EACI,iBAAA;ApFsrrCR;;AoFvrrCI;EACI,iBAAA;ApF0rrCR;;AoF3rrCI;EACI,iBAAA;ApF8rrCR;;AoF/rrCI;EACI,iBAAA;ApFksrCR;;AoFnsrCI;EACI,iBAAA;ApFssrCR;;AoFvsrCI;EACI,iBAAA;ApF0srCR;;AoF3srCI;EACI,iBAAA;ApF8srCR;;AoF/srCI;EACI,iBAAA;ApFktrCR;;AoFntrCI;EACI,iBAAA;ApFstrCR;;AoFvtrCI;EACI,iBAAA;ApF0trCR;;AoF3trCI;EACI,iBAAA;ApF8trCR;;AoF/trCI;EACI,iBAAA;ApFkurCR;;AoFnurCI;EACI,iBAAA;ApFsurCR;;AoFvurCI;EACI,iBAAA;ApF0urCR;;AoF3urCI;EACI,iBAAA;ApF8urCR;;AoF/urCI;EACI,iBAAA;ApFkvrCR;;AoFnvrCI;EACI,iBAAA;ApFsvrCR;;AoFvvrCI;EACI,iBAAA;ApF0vrCR;;AoF3vrCI;EACI,iBAAA;ApF8vrCR;;AoF/vrCI;EACI,iBAAA;ApFkwrCR;;AoFnwrCI;EACI,iBAAA;ApFswrCR;;AoFvwrCI;EACI,iBAAA;ApF0wrCR;;AoF3wrCI;EACI,iBAAA;ApF8wrCR;;AoF/wrCI;EACI,iBAAA;ApFkxrCR;;AoFnxrCI;EACI,iBAAA;ApFsxrCR;;AoFvxrCI;EACI,iBAAA;ApF0xrCR;;AoF3xrCI;EACI,iBAAA;ApF8xrCR;;AoF/xrCI;EACI,iBAAA;ApFkyrCR;;AoFnyrCI;EACI,iBAAA;ApFsyrCR;;AoFvyrCI;EACI,iBAAA;ApF0yrCR;;AoF3yrCI;EACI,iBAAA;ApF8yrCR;;AoF/yrCI;EACI,iBAAA;ApFkzrCR;;AoFnzrCI;EACI,iBAAA;ApFszrCR;;AoFvzrCI;EACI,iBAAA;ApF0zrCR;;AoF3zrCI;EACI,iBAAA;ApF8zrCR;;AoF/zrCI;EACI,iBAAA;ApFk0rCR;;AoFn0rCI;EACI,iBAAA;ApFs0rCR;;AoFv0rCI;EACI,iBAAA;ApF00rCR;;AoF30rCI;EACI,iBAAA;ApF80rCR;;AoF/0rCI;EACI,iBAAA;ApFk1rCR;;AoFn1rCI;EACI,iBAAA;ApFs1rCR;;AoFv1rCI;EACI,iBAAA;ApF01rCR;;AoF31rCI;EACI,iBAAA;ApF81rCR;;AoF/1rCI;EACI,iBAAA;ApFk2rCR;;AoFn2rCI;EACI,iBAAA;ApFs2rCR;;AoFv2rCI;EACI,iBAAA;ApF02rCR;;AoF32rCI;EACI,iBAAA;ApF82rCR;;AoF/2rCI;EACI,iBAAA;ApFk3rCR;;AoFn3rCI;EACI,iBAAA;ApFs3rCR;;AoFv3rCI;EACI,iBAAA;ApF03rCR;;AoF33rCI;EACI,iBAAA;ApF83rCR;;AoF/3rCI;EACI,iBAAA;ApFk4rCR;;AoFn4rCI;EACI,iBAAA;ApFs4rCR;;AoFv4rCI;EACI,iBAAA;ApF04rCR;;AoF34rCI;EACI,iBAAA;ApF84rCR;;AoF/4rCI;EACI,iBAAA;ApFk5rCR;;AoFn5rCI;EACI,iBAAA;ApFs5rCR;;AoFv5rCI;EACI,iBAAA;ApF05rCR;;AoF35rCI;EACI,iBAAA;ApF85rCR;;AoF/5rCI;EACI,iBAAA;ApFk6rCR;;AoFn6rCI;EACI,iBAAA;ApFs6rCR;;AoFv6rCI;EACI,iBAAA;ApF06rCR;;AoF36rCI;EACI,iBAAA;ApF86rCR;;AoF/6rCI;EACI,iBAAA;ApFk7rCR;;AoFn7rCI;EACI,iBAAA;ApFs7rCR;;AoFv7rCI;EACI,iBAAA;ApF07rCR;;AoF37rCI;EACI,iBAAA;ApF87rCR;;AoF/7rCI;EACI,iBAAA;ApFk8rCR;;AoFn8rCI;EACI,iBAAA;ApFs8rCR;;AoFv8rCI;EACI,iBAAA;ApF08rCR;;AoF38rCI;EACI,iBAAA;ApF88rCR;;AoF/8rCI;EACI,iBAAA;ApFk9rCR;;AoFn9rCI;EACI,iBAAA;ApFs9rCR;;AoFv9rCI;EACI,iBAAA;ApF09rCR;;AoF39rCI;EACI,iBAAA;ApF89rCR;;AoF/9rCI;EACI,iBAAA;ApFk+rCR;;AoFn+rCI;EACI,iBAAA;ApFs+rCR;;AoFv+rCI;EACI,iBAAA;ApF0+rCR;;AoF3+rCI;EACI,iBAAA;ApF8+rCR;;AoF/+rCI;EACI,iBAAA;ApFk/rCR;;AoFn/rCI;EACI,iBAAA;ApFs/rCR;;AoFv/rCI;EACI,iBAAA;ApF0/rCR;;AoF3/rCI;EACI,iBAAA;ApF8/rCR;;AoF//rCI;EACI,iBAAA;ApFkgsCR;;AoFngsCI;EACI,iBAAA;ApFsgsCR;;AoFvgsCI;EACI,iBAAA;ApF0gsCR;;AoF3gsCI;EACI,iBAAA;ApF8gsCR;;AoF/gsCI;EACI,iBAAA;ApFkhsCR;;AoFnhsCI;EACI,iBAAA;ApFshsCR;;AoFvhsCI;EACI,iBAAA;ApF0hsCR;;AoF3hsCI;EACI,iBAAA;ApF8hsCR;;AoF/hsCI;EACI,iBAAA;ApFkisCR;;AoFnisCI;EACI,iBAAA;ApFsisCR;;AoFvisCI;EACI,iBAAA;ApF0isCR;;AoF3isCI;EACI,iBAAA;ApF8isCR;;AoF/isCI;EACI,iBAAA;ApFkjsCR;;AoFnjsCI;EACI,iBAAA;ApFsjsCR;;AoFvjsCI;EACI,iBAAA;ApF0jsCR;;AoF3jsCI;EACI,iBAAA;ApF8jsCR;;AoF/jsCI;EACI,iBAAA;ApFkksCR;;AoFnksCI;EACI,iBAAA;ApFsksCR;;AoFvksCI;EACI,iBAAA;ApF0ksCR;;AoF3ksCI;EACI,iBAAA;ApF8ksCR;;AoF/ksCI;EACI,iBAAA;ApFklsCR;;AoFnlsCI;EACI,iBAAA;ApFslsCR;;AoFvlsCI;EACI,iBAAA;ApF0lsCR;;AoF3lsCI;EACI,iBAAA;ApF8lsCR;;AoF/lsCI;EACI,iBAAA;ApFkmsCR;;AoFnmsCI;EACI,iBAAA;ApFsmsCR;;AoFvmsCI;EACI,iBAAA;ApF0msCR;;AoF3msCI;EACI,iBAAA;ApF8msCR;;AoF/msCI;EACI,iBAAA;ApFknsCR;;AoFnnsCI;EACI,iBAAA;ApFsnsCR;;AoFvnsCI;EACI,iBAAA;ApF0nsCR;;AoF3nsCI;EACI,iBAAA;ApF8nsCR;;AoF/nsCI;EACI,iBAAA;ApFkosCR;;AoFnosCI;EACI,iBAAA;ApFsosCR;;AoFvosCI;EACI,iBAAA;ApF0osCR;;AoF3osCI;EACI,iBAAA;ApF8osCR;;AoF/osCI;EACI,iBAAA;ApFkpsCR;;AoFnpsCI;EACI,iBAAA;ApFspsCR;;AoFvpsCI;EACI,iBAAA;ApF0psCR;;AoF3psCI;EACI,iBAAA;ApF8psCR;;AoF/psCI;EACI,iBAAA;ApFkqsCR;;AoF9psCA;EACI,gBAAA;EACA,kBAAA;ApFiqsCJ;;AqFtqsCQ;EAEI,eAAA;ArFwqsCZ;;AqF1qsCQ;EAEI,eAAA;ArF4qsCZ;;AqF9qsCQ;EAEI,eAAA;ArFgrsCZ;;AqFlrsCQ;EAEI,eAAA;ArForsCZ;;AqF9qsCI;EACI,0BAAA;ArFirsCR;AqF/qsCI;EACI,0BAAA;ArFirsCR;;AqF7qsCI;EACI,yBAAA;ArFgrsCR;AqF9qsCI;EACI,+BAAA;ArFgrsCR;;AqF1qsCI;EAMI;;;;;;;;;;;;;;;GAAA;ArFursCR;AqF5rsCQ;EACI,gCAAA;EACA,4BAAA;EACA,wBAAA;ArF8rsCZ;;AqFlssCI;EAMI;;;;;;;;;;;;;;;GAAA;ArF+ssCR;AqFptsCQ;EACI,gCAAA;EACA,4BAAA;EACA,wBAAA;ArFstsCZ;;AqF1tsCI;EAMI;;;;;;;;;;;;;;;GAAA;ArFuusCR;AqF5usCQ;EACI,iCAAA;EACA,6BAAA;EACA,yBAAA;ArF8usCZ;;AqFlvsCI;EAMI;;;;;;;;;;;;;;;GAAA;ArF+vsCR;AqFpwsCQ;EACI,iCAAA;EACA,6BAAA;EACA,yBAAA;ArFswsCZ;;AqF1wsCI;EAMI;;;;;;;;;;;;;;;GAAA;ArFuxsCR;AqF5xsCQ;EACI,iCAAA;EACA,6BAAA;EACA,yBAAA;ArF8xsCZ;;AqFlysCI;EAMI;;;;;;;;;;;;;;;GAAA;ArF+ysCR;AqFpzsCQ;EACI,iCAAA;EACA,6BAAA;EACA,yBAAA;ArFszsCZ;;AqF1zsCI;EAMI;;;;;;;;;;;;;;;GAAA;ArFu0sCR;AqF50sCQ;EACI,iCAAA;EACA,6BAAA;EACA,yBAAA;ArF80sCZ;;AqF1zsCA;EACI,6BAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;ArF6zsCJ;;AqF3zsCA;EACI,6BAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;ArF8zsCJ;;AsF53sCA;EACI,8CAAA;EACQ,sCAAA;AtF+3sCZ;;AsF53sCA;EACI;IACE,+BAAA;IACQ,uBAAA;EtF+3sCZ;EsF73sCE;IACE,iCAAA;IACQ,yBAAA;EtF+3sCZ;AACF;AsF53sCA;EACI;IACE,+BAAA;IACQ,uBAAA;EtF83sCZ;EsF53sCE;IACE,iCAAA;IACQ,yBAAA;EtF83sCZ;AACF;AuFv5sCA,uBAAA;AACA;EACI,WAAA;EACA,WAAA;EACA,cAAA;AvFy5sCJ;;AuFt5sCA;EACI,kBAAA;AvFy5sCJ;;AuFt5sCA;EACI,WAAA;EACA,YAAA;AvFy5sCJ;;AuFr5sCA,kDAAA;AAEI;EADJ;IAEQ,iBAAA;EvFw5sCN;AACF;;AuFr5sCA;EACI,iBAAA;AvFw5sCJ;;AuFr5sCA,uGAAA;AACA;EACI,qBAAA;EACA,mBAAA;AvFw5sCJ;;AuFr5sCA;EACI,eAAA;EACA,gBAAA;AvFw5sCJ;;AuFp5sCA;EACI,cAAA;AvFu5sCJ;;AuFp5sCA;EACI,kBAAA;EACA,kBAAA;EACA,sBtFvCa;EsFwCb,YAAA;EACA,eAAA;EACA,0BAAA;EACA,gBAAA;AvFu5sCJ;AuFr5sCI;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AvFu5sCR;;AuFn5sCA;EACI,kBAAA;EACA,kBAAA;EACA,sBtF7Da;EsF8Db,YAAA;EACA,etF/Ca;EsFgDb,0BAAA;EACA,gBAAA;AvFs5sCJ;;AuFn5sCA;EACI,aAAA;AvFs5sCJ;;AuFn5sCA;EACI,gBAAA;EACA,UAAA;AvFs5sCJ;;AuFn5sCA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AvFs5sCJ;;AuFn5sCA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AvFs5sCJ;;AuFn5sCA;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;AvFs5sCJ;;AuFn5sCA;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;AvFs5sCJ;;AuFn5sCA;EACI,YAAA;AvFs5sCJ;;AuFn5sCA;EACI,yBAAA;AvFs5sCJ;;AuFn5sCA;EACI,gBAAA;AvFs5sCJ;;AuFn5sCA;EACI,qBAAA;EACA,cAAA;EACA,mBAAA;AvFs5sCJ;AuFp5sCI;EACI,qBAAA;EACA,cAAA;EACA,YAAA;AvFs5sCR;;AuFl5sCA;EACI,gBAAA;AvFq5sCJ;;AuFl5sCA;EACI,eAAA;AvFq5sCJ;;AuFl5sCA;EACI,WAAA;AvFq5sCJ;;AuFl5sCA;EACI,kBAAA;AvFq5sCJ;;AuFl5sCA;EACI,aAAA;EACA,yBAAA;EACA,cAAA;AvFq5sCJ;;AuFl5sCA;EACI,aAAA;EACA,yBAAA;EACA,cAAA;AvFq5sCJ;;AuFl5sCA;EACI,qBAAA;AvFq5sCJ;;AuFl5sCA;EACI,oBAAA;EACA,eAAA;EACA,sBAAA;EACA,SAAA;AvFq5sCJ;;AuFj5sCA;EACI,gBAAA;EACA,2BAAA;AvFo5sCJ;;AuFj5sCA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AvFo5sCJ;;AuFj5sCA;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,yCAAA;EACA,8CAAA;EACA,iDAAA;EACA,kDAAA;EACA,sDAAA;EACA,mDAAA;AvFo5sCJ;;AuFl5sCA;EACI;IACI,yBAAA;IACA,yBAAA;EvFq5sCN;AACF;AuFl5sCA;EACI;IACI,4BAAA;IACA,yBAAA;EvFo5sCN;AACF;AuFj5sCA;EACI;IACI,6BAAA;IACA,yBAAA;EvFm5sCN;AACF;AuFh5sCA;EACI;IACI,iCAAA;IACA,yBAAA;EvFk5sCN;AACF;AuF/4sCA;EACI;IACI,8BAAA;IACA,yBAAA;EvFi5sCN;AACF;AwFvntCA;EACI,cvFcU;EuFbV,evFsBa;EuFrBb,oCvFwBc;EuFvBd,iBvFwBe;ADimtCnB;;AwFtntCA;EACI,cvFOU;ADkntCd;;AwFtntCA;EACI,cvFGU;EuFFV,cAAA;AxFyntCJ;;AwFtntCA;EACI,WAAA;AxFyntCJ;;AwFtntCA;EACI,cAAA;AxFyntCJ;;AwFtntCA;EACI,cvFfc;ADwotClB;;AwFtntCA;EACI,cvFdU;ADuotCd;;AwFtntCA;EACI,cAAA;AxFyntCJ;;AwFtntCA;EACI,kBAAA;AxFyntCJ;;AwFtntCA;EACI,eAAA;AxFyntCJ;;AwFtntCA;EACI,UAAA;EACA,YAAA;AxFyntCJ;;AwFtntCA;EACI,WAAA;EACA,WAAA;AxFyntCJ;;AwFtntCA;EACI,UAAA;EACA,iBAAA;AxFyntCJ;;AwFtntCA;EACI,mBAAA;AxFyntCJ;;AwFtntCA;EACI,iBAAA;EACA,yBAAA;AxFyntCJ;;AwFtntCA;EACI,sBAAA;AxFyntCJ;;AwFtntCA;EACI,gBAAA;AxFyntCJ;AwFvntCI;EACI,gBAAA;AxFyntCR;;AwFrntCA;EACI,gBAAA;AxFwntCJ;;AwFrntCA;EACI,mBAAA;EACA,iBAAA;AxFwntCJ;;AwFrntCA;EACI,mBAAA;EACA,qBAAA;EACA,gBAAA;AxFwntCJ;;AyFxntCQ;EDIJ;IACI,evFxEgB;IuFyEhB,iBvFrEkB;ED6rtCxB;EwFrntCE;IACI,eAAA;IACA,mBAAA;ExFuntCN;AACF;AwFpntCA;EACI,gBAAA;AxFsntCJ;;AwFnntCA;EACI,iBAAA;EACA,cAAA;AxFsntCJ;;A0FvutCA;EACE,WAAA;EACA,YzF+BkB;AD2stCpB;;A2F5utCA;EACI,aAAA;A3F+utCJ;;A2F5utCA;EACI,wBAAA;A3F+utCJ;;A2F5utCI;EACI,aAAA;EACA,mBAAA;EACA,UAAA;A3F+utCR;;A2F3utCA;EACI,gBAAA;A3F8utCJ;;A2F3utCA;EACI,SAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,wBAAA;A3F8utCJ;;A2F3utCA;EACI;IACI,WAAA;IACA,sBAAA;E3F8utCN;AACF;A2F3utCA;EACI;IACI,gBAAA;E3F6utCN;E2F1utCE;IACI,wBAAA;E3F4utCN;E2FzutCE;IACI,yBAAA;E3F2utCN;AACF;A2FxutCA;EACI;IFxCA,oCEyCuB;IFxCvB,iCEwCuB;IFvCvB,gCEuCuB;IFtCvB,+BEsCuB;IFrCvB,4BEqCuB;E3F8utCzB;E2F3utCE;IF5CA,kCE6CuB;IF5CvB,+BE4CuB;IF3CvB,8BE2CuB;IF1CvB,6BE0CuB;IFzCvB,0BEyCuB;IACnB,uCAAA;E3FivtCN;E2F9utCE;IACI,QAAA;E3FgvtCN;AACF;A2F7utCA;EACI;IFvDA,kCEwDuB;IFvDvB,+BEuDuB;IFtDvB,8BEsDuB;IFrDvB,6BEqDuB;IFpDvB,0BEoDuB;E3FmvtCzB;AACF;A2FhvtCA;EACI,eAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,iCAAA;EACA,0CAAA;EFtEA,gCEuEmB;EFtEnB,6BEsEmB;EFrEnB,4BEqEmB;EFpEnB,2BEoEmB;EFnEnB,wBEmEmB;EFvEnB,gCEwEmB;EFvEnB,6BEuEmB;EFtEnB,4BEsEmB;EFrEnB,2BEqEmB;EFpEnB,wBEoEmB;EAEnB,0CAAA;EACA,oCAAA;EACA,0BAAA;A3FyvtCJ;;A2FrvtCA;EACI;IACI,WAAA;E3FwvtCN;AACF;A2FrvtCA;EACI,cAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,c1F3FQ;E0F4FR,mCAAA;EACA,kCAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iDAAA;EACA,+BAAA;EACA,wDAAA;EACA,kDAAA;EACA,wCAAA;EFrGA,gCEsGmB;EFrGnB,6BEqGmB;EFpGnB,4BEoGmB;EFnGnB,2BEmGmB;EFlGnB,wBEkGmB;A3F2vtCvB;;A2FxvtCA;EFzGI,mCE0GmB;EFzGnB,gCEyGmB;EFxGnB,+BEwGmB;EFvGnB,8BEuGmB;EFtGnB,2BEsGmB;A3F+vtCvB;;A2F5vtCA;EF7GI,oCE8GmB;EF7GnB,iCE6GmB;EF5GnB,gCE4GmB;EF3GnB,+BE2GmB;EF1GnB,4BE0GmB;EACnB,UAAA;A3FmwtCJ;;A2FhwtCA;EACI;IACI,WAAA;IACA,OAAA;E3FmwtCN;E2FhwtCE;IACI,WAAA;E3FkwtCN;AACF;A2F/vtCA;EACI,cAAA;A3FiwtCJ;;A2F9vtCA;EACI;IACI,kBAAA;IACA,0CAAA;IACA,oCAAA;IACA,0BAAA;E3FiwtCN;E2F9vtCE;IACI,mBAAA;IACA,0CAAA;IACA,oCAAA;IACA,0BAAA;E3FgwtCN;AACF;A2F7vtCA;EACI,uBAAA;A3F+vtCJ;;A2F5vtCA;EACI;IACI,2BAAA;IACA,+BAAA;IACA,uBAAA;IACA,2BAAA;IACA,sBAAA;IACA,uBAAA;IACA,4BAAA;IACA,kCAAA;E3F+vtCN;E2F5vtCE;IACI,uBAAA;E3F8vtCN;E2F3vtCE;IACI,WAAA;IACA,WAAA;IACA,cAAA;E3F6vtCN;E2F1vtCE;IF3KA,gCE4KuB;IF3KvB,6BE2KuB;IF1KvB,4BE0KuB;IFzKvB,2BEyKuB;IFxKvB,wBEwKuB;IACnB,UAAA;E3FgwtCN;E2F7vtCE;IACI,gBAAA;IACA,YAAA;IACA,WAAA;IACA,uBAAA;IACA,iBAAA;IACA,UAAA;E3F+vtCN;E2F5vtCE;IFzLA,gCE0LuB;IFzLvB,6BEyLuB;IFxLvB,4BEwLuB;IFvLvB,2BEuLuB;IFtLvB,wBEsLuB;E3FkwtCzB;E2F/vtCE;IF7LA,gCE8LuB;IF7LvB,6BE6LuB;IF5LvB,4BE4LuB;IF3LvB,2BE2LuB;IF1LvB,wBE0LuB;IACnB,UAAA;E3FqwtCN;E2FlwtCE;IACI,WAAA;E3FowtCN;E2FjwtCE;IACI,kBAAA;IACA,qBAAA;IACA,YAAA;IACA,iBAAA;IACA,eAAA;IACA,c1F5MI;I0F6MJ,iBAAA;IACA,mBAAA;IACA,+CAAA;IACA,4CAAA;IACA,uCAAA;E3FmwtCN;E2FhwtCE;IACI,c1F1NO;ED49tCb;E2F/vtCE;IACI,c1F9NO;I0F+NP,kCAAA;E3FiwtCN;E2F9vtCE;IACI,aAAA;E3FgwtCN;E2F7vtCE;IACI,wBAAA;IACA,kBAAA;IACA,SAAA;IACA,YAAA;IACA,aAAA;IACA,mBAAA;IACA,wCAAA;IACA,gEAAA;IACA,qDAAA;IACA,kDAAA;IACA,6CAAA;IF5OJ,gCE6OuB;IF5OvB,6BE4OuB;IF3OvB,4BE2OuB;IF1OvB,2BE0OuB;IFzOvB,wBEyOuB;E3FmwtCzB;E2FhwtCE;IACI,WAAA;IACA,WAAA;IACA,cAAA;E3FkwtCN;E2F/vtCE;IACI,UAAA;IACA,kBAAA;IACA,uDAAA;IACA,oDAAA;IACA,+CAAA;E3FiwtCN;E2F9vtCE;IACI,sEAAA;IACA,cAAA;IACA,kBAAA;IACA,OAAA;IACA,SAAA;IACA,YAAA;IACA,WAAA;IACA,gBAAA;IACA,+BAAA;IACA,SAAA;IACA,UAAA;E3FgwtCN;E2F7vtCE;IACI,kBAAA;IACA,WAAA;IACA,YAAA;IACA,MAAA;IACA,OAAA;IACA,eAAA;IACA,iBAAA;IACA,kBAAA;IACA,iBAAA;IACA,+BAAA;IACA,mBAAA;IACA,SAAA;IACA,UAAA;IACA,mB1F/RO;I0FgSP,4DAAA;IACA,yDAAA;IACA,oDAAA;IACA,cAAA;E3F+vtCN;E2F5vtCE;IACI,mB1FvSO;I0FwSP,qBAAA;IACA,cAAA;E3F8vtCN;E2F3vtCE;IACI,YAAA;IACA,YAAA;IACA,WAAA;IACA,gBAAA;IACA,kBAAA;IACA,iCAAA;E3F6vtCN;E2F1vtCE;IACI,eAAA;IACA,kBAAA;E3F4vtCN;E2FzvtCE;IACI,c1FtTI;I0FuTJ,gBAAA;IACA,eAAA;E3F2vtCN;E2FxvtCE;IACI,WAAA;E3F0vtCN;E2FvvtCE;IACI,YAAA;IACA,iBAAA;IACA,kBAAA;IACA,cAAA;IACA,mBAAA;IACA,eAAA;IACA,mBAAA;IACA,oDAAA;IACA,8CAAA;IACA,oCAAA;E3FyvtCN;E2FtvtCE;IACI,c1FlVO;I0FmVP,4CAAA;E3FwvtCN;E2FrvtCE;IFjVA,gCEkVuB;IFjVvB,6BEiVuB;IFhVvB,4BEgVuB;IF/UvB,2BE+UuB;IF9UvB,wBE8UuB;E3F2vtCzB;E2FxvtCE;IACI,wBAAA;IACA,kBAAA;IACA,MAAA;IACA,OAAA;IACA,YAAA;IACA,WAAA;E3F0vtCN;E2FvvtCE;IF9VA,mCE+VuB;IF9VvB,gCE8VuB;IF7VvB,+BE6VuB;IF5VvB,8BE4VuB;IF3VvB,2BE2VuB;E3F6vtCzB;E2F1vtCE;IACI,cAAA;E3F4vtCN;E2FzvtCE;IACI,cAAA;E3F2vtCN;E2FxvtCE;IACI,iGAAA;IF3WJ,oCE4WuB;IF3WvB,iCE2WuB;IF1WvB,gCE0WuB;IFzWvB,+BEyWuB;IFxWvB,4BEwWuB;E3F8vtCzB;AACF;A2F3vtCA;EACI,kBAAA;A3F6vtCJ;;A2F1vtCA;EACI;IACI,UAAA;IACA,aAAA;E3F6vtCN;E2F1vtCE;IACI,WAAA;IACA,cAAA;E3F4vtCN;E2FzvtCE;IACI,WAAA;IACA,kBAAA;IACA,QAAA;IACA,gBAAA;IACA,qBAAA;IACA,WAAA;IACA,WAAA;IACA,mBAAA;IACA,mCAAA;IACA,2BAAA;E3F2vtCN;E2FxvtCE;IF5YA,gCE6YuB;IF5YvB,6BE4YuB;IF3YvB,4BE2YuB;IF1YvB,2BE0YuB;IFzYvB,wBEyYuB;E3F8vtCzB;E2F3vtCE;IFhZA,iCEiZuB;IFhZvB,8BEgZuB;IF/YvB,6BE+YuB;IF9YvB,4BE8YuB;IF7YvB,yBE6YuB;E3FiwtCzB;E2F9vtCE;IACI,mBAAA;IACA,gBAAA;E3FgwtCN;E2F7vtCE;IACI,WAAA;IFlaJ,iCEma8B;IFla9B,8BEka8B;IFja9B,6BEia8B;IFha9B,4BEga8B;IF/Z9B,yBE+Z8B;E3FmwtChC;E2FhwtCE;IACI,kBAAA;IACA,gBAAA;E3FkwtCN;E2F/vtCE;IACI,UAAA;IF5aJ,iCE6a8B;IF5a9B,8BE4a8B;IF3a9B,6BE2a8B;IF1a9B,4BE0a8B;IFza9B,yBEya8B;E3FqwtChC;AACF;A2FlwtCA;EACI;IACI,eAAA;E3FowtCN;E2FjwtCE;IACI,mBAAA;IACA,UAAA;IFxbJ,iCEyb8B;IFxb9B,8BEwb8B;IFvb9B,6BEub8B;IFtb9B,4BEsb8B;IFrb9B,yBEqb8B;E3FuwtChC;E2FpwtCE;IACI,mB1F1bO;EDgsuCb;E2FnwtCE;IFxbA,gCEybuB;IFxbvB,6BEwbuB;IFvbvB,4BEubuB;IFtbvB,2BEsbuB;IFrbvB,wBEqbuB;E3FywtCzB;E2FtwtCE;IF5bA,iCE6buB;IF5bvB,8BE4buB;IF3bvB,6BE2buB;IF1bvB,4BE0buB;IFzbvB,yBEybuB;E3F4wtCzB;E2FzwtCE;IACI,WAAA;IACA,kBAAA;IACA,QAAA;IACA,gBAAA;IACA,qBAAA;IACA,WAAA;IACA,UAAA;IACA,mBAAA;IACA,mCAAA;IACA,2BAAA;E3F2wtCN;E2FxwtCE;IACI,SAAA;E3F0wtCN;E2FvwtCE;IACI,wCAAA;E3FywtCN;E2FrwtCM;IACI,aAAA;E3FuwtCV;E2FnwtCE;IFneA,iCEoe8B;IFne9B,8BEme8B;IFle9B,6BEke8B;IFje9B,4BEie8B;IFhe9B,yBEge8B;E3FywtChC;AACF;A2FtwtCA;EACI,mDAAA;EACA,eAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,eAAA;EACA,oCAAA;EACA,kBAAA;EACA,UAAA;EACA,mCAAA;EACA,2BAAA;EACA,kFAAA;EACA,4EAAA;EACA,kEAAA;A3FwwtCJ;;A2FrwtCA;EACI,UAAA;EACA,mBAAA;EACA,gFAAA;EACA,0EAAA;EACA,gEAAA;A3FwwtCJ;;A2FrwtCA;EACI;IACI,oCAAA;IACA,WAAA;E3FwwtCN;AACF;A2FrwtCA;EACI;IFngBA,mCEogBuB;IFngBvB,gCEmgBuB;IFlgBvB,+BEkgBuB;IFjgBvB,8BEigBuB;IFhgBvB,2BEggBuB;E3F2wtCzB;AACF;A2FxwtCA;EACI;IFzgBA,mCE0gBuB;IFzgBvB,gCEygBuB;IFxgBvB,+BEwgBuB;IFvgBvB,8BEugBuB;IFtgBvB,2BEsgBuB;E3F8wtCzB;AACF;A2F1wtCA;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,QAAA;EACA,yBAAA;A3F4wtCJ;A2F1wtCI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;A3F4wtCR;A2FzwtCI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;A3F2wtCR;A2FxwtCI;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;A3F0wtCR;A2FvwtCI;EACI,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;A3FywtCR;A2FvwtCQ;EACI,eAAA;EACA,cAAA;EACA,0BAAA;A3FywtCZ;A2FtwtCQ;EACI,iBAAA;EACA,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;A3FwwtCZ;;A2FnwtCA;EACI;IACI,YAAA;E3FswtCN;AACF;A2FnwtCA;;kCAAA;AAGA;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,UAAA;A3FqwtCJ;;A2FlwtCA;EACI;IACI,kBAAA;IACA,UAAA;IACA,qBAAA;IACA,WAAA;IACA,MAAA;IACA,YAAA;IACA,UAAA;E3FqwtCN;E2FlwtCE;IACI,eAAA;E3FowtCN;AACF;A2FjwtCA;EACI,aAAA;A3FmwtCJ;;A2FhwtCA;EACI;IACI,4BAAA;E3FmwtCN;E2FhwtCE;IACI,uBAAA;IACA,wBAAA;IACA,4BAAA;IACA,yCAAA;IACA,sCAAA;IACA,qCAAA;IACA,oCAAA;IACA,iCAAA;IACA,sBAAA;IACA,4BAAA;IACA,cAAA;E3FkwtCN;AACF;A2F/vtCA;EACI;IACI,uBAAA;E3FiwtCN;AACF;A2F9vtCA;EACI;IACI,yDAAA;E3FgwtCN;AACF;A2F7vtCA;EACI,kBAAA;A3F+vtCJ;;A2F5vtCA;EACI;IACI,uBAAA;IACA,oBAAA;IACA,qBAAA;IACA,6BAAA;E3F+vtCN;AACF;A2F5vtCA;EACI,aAAA;A3F8vtCJ;;A2F3vtCA;EAEI;IACI,cAAA;IACA,SAAA;IACA,UAAA;IACA,SAAA;IACA,eAAA;IACA,qBAAA;IACA,wBAAA;E3F6vtCN;E2F3vtCM;IACI,iBAAA;E3F6vtCV;E2F1vtCM;IACI,eAAA;E3F4vtCV;E2FzvtCM;IACI,cAAA;IACA,YAAA;IACA,iBAAA;IACA,eAAA;IACA,cAAA;IACA,gBAAA;IACA,mCAAA;IACA,kCAAA;IACA,gBAAA;IACA,uBAAA;IACA,mBAAA;IACA,+BAAA;IACA,wDAAA;IACA,kDAAA;IACA,wCAAA;IFrsBR,gCEssB2B;IFrsB3B,6BEqsB2B;IFpsB3B,4BEosB2B;IFnsB3B,2BEmsB2B;IFlsB3B,wBEksB2B;E3F+vtC7B;E2F5vtCM;IACI,eAAA;IACA,kBAAA;IACA,QAAA;IACA,iBAAA;E3F8vtCV;E2F1vtCE;IACI,cAAA;IACA,SAAA;IACA,UAAA;IACA,SAAA;IACA,eAAA;IACA,qBAAA;IACA,wBAAA;E3F4vtCN;E2F1vtCM;IASI,kBAAA;IACA,iBAAA;IACA,YAAA;IACA,iDAAA;IACA,gBAAA;E3FovtCV;E2FhwtCU;IACI,YAAA;IACA,mBAAA;IACA,YAAA;IACA,SAAA;IACA,c1FruBD;EDu+uCb;AACF;A2FvvtCA;EACI;IACI,cAAA;IACA,UAAA;IACA,UAAA;IACA,kBAAA;E3FyvtCN;AACF;A2FrvtCA;EACI;IACI,4BAAA;E3FuvtCN;E2FpvtCE;IACI,yBAAA;E3FsvtCN;E2FnvtCE;IACI,0BAAA;E3FqvtCN;AACF;A2FlvtCA;EACI,kBAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;A3FovtCJ;A2FlvtCI;EACI,WAAA;EACA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;A3FovtCR;;A4FrhvCA;EACI,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,SAAA;EACA,oCAAA;EACA,c3FMU;ADkhvCd;A4FthvCI;EACI,yB3FIe;ADohvCvB;A4FrhvCI;EACI,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;A5FuhvCR;A4FphvCI;EACI,kBAAA;EACA,iBAAA;A5FshvCR;A4FnhvCI;EACI,mBAAA;EACA,c3FdM;E2FeN,oBAAA;EACA,kBAAA;A5FqhvCR;A4FnhvCQ;EACI,eAAA;EACA,gBAAA;A5FqhvCZ;A4FjhvCI;EACI,yBAAA;A5FmhvCR;A4FhhvCI;EACI,gBAAA;A5FkhvCR;A4F/gvCI;EAKI,yBAAA;A5F6gvCR;A4FjhvCQ;EACI,sBAAA;A5FmhvCZ;A4F7gvCI;EACI,c3FzCM;E2F0CN,cAAA;A5F+gvCR;A4F7gvCQ;EACI,WAAA;A5F+gvCZ;A4F3gvCI;EACI,mBAAA;EACA,oBAAA;EACA,qBAAA;A5F6gvCR;A4F1gvCI;EACI,aAAA;A5F4gvCR;A4F3gvCQ;EACI,YAAA;A5F6gvCZ;A4FzgvCI;EACI,yBAAA;EACA,0CAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;A5F2gvCR;A4FzgvCQ;EACI,yBAAA;A5F2gvCZ;A4FxgvCQ;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,qGAAA;EACA,sBAAA;EACA,4BAAA;EACA,+BAAA;A5F0gvCZ;A4FvgvCQ;EACI,YAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;A5FygvCZ;A4FvgvCY;EACI,eAAA;EACA,gBAAA;EACA,SAAA;A5FygvChB;A4FtgvCY;EACI,iBAAA;EACA,yDAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;A5FwgvChB;A4FngvCI;EACI,iBAAA;A5FqgvCR;A4FlgvCI;EACI,YAAA;EACA,YAAA;A5FogvCR;A4FjgvCI;EACI,uBAAA;A5FmgvCR;AyF3jvCQ;EG4DA;IACI,iBAAA;IACA,yBAAA;E5FkgvCV;AACF;AyFljvCQ;EGsDA;IACI,2BAAA;E5F+/uCV;E4F5/uCM;IACI,aAAA;E5F8/uCV;E4F5/uCU;IACI,4BAAA;IACA,eAAA;IACA,qBAAA;E5F8/uCd;E4F1/uCM;IACI,cAAA;IACA,YAAA;IACA,sBAAA;IACA,kBAAA;IACA,mBAAA;E5F4/uCV;E4Fz/uCM;IACI,8BAAA;E5F2/uCV;E4Fx/uCM;IACI,iBAAA;E5F0/uCV;E4Fv/uCM;IACI,uBAAA;IACA,WAAA;IACA,2BAAA;IACA,WAAA;IACA,SAAA;IACA,eAAA;E5Fy/uCV;E4Fv/uCU;IACI,aAAA;E5Fy/uCd;E4Ft/uCU;IACI,iBAAA;IACA,oBAAA;IACA,8BAAA;E5Fw/uCd;E4Fp/uCM;IACI,kBAAA;IACA,WAAA;E5Fs/uCV;E4Fn/uCM;IACI,WAAA;IACA,eAAA;E5Fq/uCV;E4Fl/uCM;IACI,WAAA;IACA,YAAA;IACA,kBAAA;IACA,WAAA;E5Fo/uCV;E4Fj/uCM;IACI,qBAAA;IACA,yBAAA;IACA,qBAAA;IACA,kBAAA;IACA,YAAA;IACA,SAAA;IACA,SAAA;IACA,iBAAA;IACA,iDAAA;IACA,oCAAA;IACA,0BAAA;E5Fm/uCV;E4Fh/uCM;IACI,0BAAA;IACA,+BAAA;IACA,kCAAA;IACA,SAAA;E5Fk/uCV;E4F/+uCM;IACI,wBAAA;IACA,6BAAA;IACA,gCAAA;IACA,SAAA;E5Fi/uCV;AACF;A4F9+uCI;EACI,gBAAA;EACA,yB3F/OO;E2FgPP,kBAAA;EACA,gBAAA;EACA,aAAA;A5Fg/uCR;A4F9+uCQ;EACI,gBAAA;EACA,eAAA;EACA,SAAA;A5Fg/uCZ;A4F9+uCY;EACI,eAAA;A5Fg/uChB;A4F9+uCgB;EACI,WAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,sBAAA;A5Fg/uCpB;A4F9+uCoB;EACI,0BAAA;A5Fg/uCxB;A4Fz+uCI;EACI,mBAAA;EACA,oCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;A5F2+uCR;;A6FpwvCA;EACI,kBAAA;EACA,YAAA;EACA,MAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,UAAA;EACA,cAAA;A7FuwvCJ;;A6FpwvCA;EACI,WAAA;EACA,eAAA;A7FuwvCJ;A6FrwvCI;EACI,WAAA;EACA,WAAA;A7FuwvCR;;A6FlwvCA;EACI,0CAAA;EACA,oCAAA;EACA,0BAAA;A7FqwvCJ;;A6FlwvCA;EACI,gBAAA;EACA,+BAAA;EACA,UAAA;EACA,kBAAA;A7FqwvCJ;A6FnwvCI;EACI,mBAAA;A7FqwvCR;A6FlwvCI;EACI,kBAAA;A7FowvCR;;A6FhwvCA;EACI;IACI,iBAAA;E7FmwvCN;E6FjwvCM;IACI,kBAAA;E7FmwvCV;AACF;A6F/vvCA;EACI,WAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,c5FpDQ;E4FqDR,eAAA;EACA,iBAAA;EACA,YAAA;A7FiwvCJ;A6F/vvCI;EACI,cAAA;A7FiwvCR;;A6F7vvCA;EACI,sBAAA;EACA,c5FhEQ;ADg0vCZ;;A6F7vvCA;EACI,YAAA;EACA,mBAAA;EACA,UAAA;EACA,uDAAA;EACA,oDAAA;EACA,+CAAA;EACA,eAAA;EACA,YAAA;A7FgwvCJ;;A6F7vvCA;EACI,+EAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;A7FgwvCJ;;A6F7vvCA;EACI;IACI,YAAA;E7FgwvCN;E6F7vvCE;IACI,WAAA;IACA,WAAA;IACA,cAAA;E7F+vvCN;AACF;A6F5vvCA;EACI,WAAA;A7F8vvCJ;;A6F3vvCA;EACI,kBAAA;EACA,YAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;A7F8vvCJ;;A6F3vvCA;EACI,cAAA;A7F8vvCJ;;A6F3vvCA;EACI;IACI,UAAA;IACA,uBAAA;E7F8vvCN;AACF;A6F3vvCA;EACI;IACI,UAAA;IACA,uBAAA;E7F6vvCN;E6F1vvCE;IACI,YAAA;E7F4vvCN;AACF;A6FzvvCA;EACI;IACI,YAAA;IACA,QAAA;E7F2vvCN;AACF;A6FxvvCA;EACI,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;A7F0vvCJ;;A6FvvvCA;EACI,qBAAA;EACA,2BAAA;EACA,cAAA;A7F0vvCJ;;A6FvvvCA;EACI;IACI,WAAA;IACA,QAAA;IACA,eAAA;E7F0vvCN;E6FvvvCE;IACI,YAAA;E7FyvvCN;AACF;A6FtvvCA;EACI;IACI,SAAA;IACA,UAAA;E7FwvvCN;AACF;A6FrvvCA;EACI,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;A7FuvvCJ;;A6FpvvCA;EACI,0BAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;A7FuvvCJ;;A6FpvvCA;EACI,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,wCAAA;EACA,qCAAA;EACA,gCAAA;A7FuvvCJ;;A6FpvvCA;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,0CAAA;EACA,mCAAA;EACA,2BAAA;EACA,+CAAA;EACA,yCAAA;EACA,+BAAA;EJrNA,gCIsNmB;EJrNnB,6BIqNmB;EJpNnB,4BIoNmB;EJnNnB,2BImNmB;EJlNnB,wBIkNmB;EJ9NnB,gCI+N0B;EJ9N1B,6BI8N0B;EJ7N1B,4BI6N0B;EJ5N1B,2BI4N0B;EJ3N1B,wBI2N0B;A7F+vvC9B;;A6F5vvCA;EACI,uBAAA;EACA,SAAA;A7F+vvCJ;;A6F5vvCA;EACI,0BAAA;EACA,QAAA;A7F+vvCJ;;A6F5vvCA;EACI,4BAAA;EACA,+BAAA;A7F+vvCJ;;A6F5vvCA;EACI,+BAAA;EACA,mBAAA;A7F+vvCJ;;A6F5vvCA;EJ9OI,iEI+OmB;EJ9OnB,8DI8OmB;EJ7OnB,6DI6OmB;EJ5OnB,4DI4OmB;EJ3OnB,yDI2OmB;A7FmwvCvB;;A6FhwvCA;EJlPI,iEImPmB;EJlPnB,8DIkPmB;EJjPnB,6DIiPmB;EJhPnB,4DIgPmB;EJ/OnB,yDI+OmB;A7FuwvCvB;;A6FpwvCA;EACI;IACI,aAAA;E7FuwvCN;AACF;A6FpwvCA;EACI;IACI,uCAAA;E7FswvCN;E6FnwvCE;IACI,8CAAA;E7FqwvCN;E6FlwvCE;IACI,0DAAA;E7FowvCN;E6FjwvCE;IACI,mDAAA;E7FmwvCN;AACF;A6FhwvCA;EACI;IACI,aAAA;E7FkwvCN;AACF;A6F/vvCA;EACI,WAAA;EACA,YAAA;EACA,yB5F5RW;E4F6RX,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;A7FiwvCJ;A6F/vvCI;EACI,WAAA;EACA,iBAAA;A7FiwvCR;A6F9vvCI;EACI,cAAA;A7FgwvCR;A6F7vvCI;EACI,eAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;A7F+vvCR;;A6F3vvCA;EACI,WAAA;EACA,iBAAA;A7F8vvCJ;;A6F3vvCA;EACI,YAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;A7F8vvCJ;;A6F3vvCA;EACI;IACI,iBAAA;IACA,aAAA;E7F8vvCN;AACF;A6F3vvCA;EACI,WAAA;EACA,kBAAA;EACA,iBAAA;A7F6vvCJ;;A6F1vvCA;EACI,WAAA;EACA,kBAAA;EACA,iBAAA;A7F6vvCJ;;A6F1vvCA;EACI,WAAA;EACA,kBAAA;EACA,iBAAA;A7F6vvCJ;;A6F1vvCA;EACI,WAAA;EACA,kBAAA;EACA,iBAAA;A7F6vvCJ;;A6F1vvCA;EACI,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;A7F6vvCJ;A6F3vvCI;EACI,aAAA;A7F6vvCR;A6F3vvCQ;EACI,cAAA;A7F6vvCZ;;A6FxvvCA;EACI,WAAA;EACA,kBAAA;EACA,iBAAA;A7F2vvCJ;;A6FxvvCA;EACI,WAAA;EACA,mBAAA;A7F2vvCJ;;A6FxvvCA;EACI;IACI,kBAAA;E7F2vvCN;E6FzvvCE;IACI,eAAA;E7F2vvCN;E6FxvvCE;IACI,aAAA;E7F0vvCN;E6FvvvCE;IACI,gBAAA;E7FyvvCN;E6FrvvCE;IACI,kBAAA;IACA,YAAA;IACA,SAAA;E7FuvvCN;AACF;A6FpvvCA;EACI,iBAAA;A7FsvvCJ;;A6FnvvCA;EACI,8BAAA;EACA,6BAAA;A7FsvvCJ;A6FpvvCI;EACI,eAAA;EACA,iBAAA;EACA,yBAAA;A7FsvvCR;A6FnvvCI;EACI;IACI,eAAA;E7FqvvCV;AACF;;A6FjvvCA;EACI,eAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EAsBA,WAAA;EACA,qDAAA;EACA,kDAAA;EACA,6CAAA;EACA,kBAAA;A7F+tvCJ;A6FvvvCI;EANJ;IAOQ,WAAA;E7F0vvCN;AACF;A6FxvvCI;EAVJ;IAWQ,YAAA;IACA,UAAA;E7F2vvCN;AACF;A6FzvvCI;EAfJ;IAgBQ,WAAA;IACA,SAAA;IACA,OAAA;IACA,YAAA;E7F4vvCN;E6F1vvCM;IACI,YAAA;E7F4vvCV;AACF;A6FnvvCI;EACI,uBAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,yBAAA;A7FqvvCR;A6FnvvCQ;EAPJ;IAQQ,WAAA;E7FsvvCV;AACF;A6FpvvCQ;EAXJ;IAYQ,iBAAA;IACA,WAAA;IACA,gBAAA;E7FuvvCV;AACF;A6FrvvCQ;EACI,kBAAA;EACA,SAAA;EACA,WAAA;A7FuvvCZ;A6FrvvCY;EALJ;IAMQ,WAAA;E7FwvvCd;AACF;A6FrvvCQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,qBAAA;A7FuvvCZ;A6FpvvCQ;EACI,eAAA;EACA,gBAAA;A7FsvvCZ;A6FnvvCQ;EACI,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;A7FqvvCZ;A6FlvvCQ;EACI,cAAA;EACA,WAAA;EACA,WAAA;EACA,6BAAA;A7FovvCZ;A6FhvvCI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,oBAAA;EACA,cAAA;EACA,0BAAA;EACA,eAAA;A7FkvvCR;A6FhvvCQ;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;A7FkvvCZ;A6F/uvCQ;EACI,sBAAA;A7FivvCZ;A6F9uvCQ;EACI,WAAA;EACA,YAAA;A7FgvvCZ;A6F9uvCY;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;A7FgvvChB;A6F3uvCI;EACI,aAAA;EACA,wBAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,qDAAA;EACA,kDAAA;EACA,6CAAA;EACA,kBAAA;A7F6uvCR;A6F3uvCQ;EACI,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;A7F6uvCZ;A6F1uvCQ;EACI,eAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;A7F4uvCZ;A6FxuvCI;EACI,aAAA;EACA,wBAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,qDAAA;EACA,kDAAA;EACA,6CAAA;EACA,kBAAA;A7F0uvCR;A6FxuvCQ;EACI,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,uBAAA;A7F0uvCZ;A6FvuvCQ;EAMI,eAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;A7FouvCZ;A6F3uvCY;EACI,eAAA;A7F6uvChB;A6FnuvCI;EACI,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,UAAA;EACA,sBAAA;EACA,kCAAA;A7FquvCR;A6FnuvCQ;EAbJ;IAcQ,SAAA;IACA,UAAA;IACA,WAAA;IACA,YAAA;IACA,kBAAA;E7FsuvCV;AACF;;A6FluvCA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,eAAA;EACA,oCAAA;EACA,kBAAA;EACA,UAAA;EACA,mCAAA;EACA,2BAAA;EACA,kFAAA;EACA,4EAAA;EACA,kEAAA;A7FquvCJ;;A6FluvCA;EACI,UAAA;EACA,mBAAA;EACA,gFAAA;EACA,0EAAA;EACA,gEAAA;A7FquvCJ;;A6FluvCA;EACI,aAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,UAAA;EACA,sBAAA;EACA,gDAAA;EACA,wCAAA;EACA,UAAA;EACA,eAAA;EACA,0BAAA;EACA,kCAAA;A7FquvCJ;A6FnuvCI;EACI,sBAAA;A7FquvCR;;A8F35wCC;EACG,cAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,uEAAA;EACA,iEAAA;EACA,uDAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;A9F85wCJ;A8F55wCI;EACI,cAAA;A9F85wCR;A8F35wCI;EArBH;IAsBO,6BAAA;IACA,sBAAA;E9F85wCN;E8F55wCM;IACI,cAAA;E9F85wCV;AACF;A8F35wCI;EACI;IACI,sBAAA;IACA,sBAAA;E9F65wCV;AACF;A8F15wCI;EACI,sBAAA;EACA,sBAAA;A9F45wCR;A8F15wCQ;EACI,cAAA;A9F45wCZ;A8Fx5wCI;EACI,oCAAA;EACA,sBAAA;A9F05wCR;;A8Ft5wCA;EACI,kBAAA;EACA,cAAA;EACA,SAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;A9Fy5wCJ;A8Fv5wCI;EARJ;IASQ,aAAA;IACA,oBAAA;E9F05wCN;AACF;;A8Fv5wCA;EACI,aAAA;A9F05wCJ;;A8Fv5wCA;EACI;IACI,UAAA;E9F05wCN;E8Fx5wCE;IACI,eAAA;E9F05wCN;E8Fx5wCE;IACI,kBAAA;E9F05wCN;AACF;A8Fv5wCA;EACI,kBAAA;EACA,aAAA;EACA,eAAA;EA+BA,WAAA;EACA,qDAAA;EACA,kDAAA;EACA,6CAAA;A9F23wCJ;A8F35wCI;EACI,cAAA;EACA,qBAAA;EAMA,yBAAA;A9Fw5wCR;A8F55wCQ;EACI,cAAA;A9F85wCZ;A8Fz5wCQ;EACI,oCAAA;A9F25wCZ;A8Fv5wCI;EApBJ;IAqBQ,MAAA;IACA,OAAA;IACA,YAAA;IACA,6BAAA;E9F05wCN;AACF;A8Fx5wCI;EA3BJ;IA4BQ,MAAA;IACA,OAAA;IACA,YAAA;IACA,4BAAA;E9F25wCN;AACF;A8Fp5wCI;EACI,UAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;A9Fs5wCR;A8Fp5wCQ;EANJ;IAOQ,WAAA;E9Fu5wCV;AACF;A8Fr5wCQ;EACI,kBAAA;EACA,SAAA;EACA,WAAA;A9Fu5wCZ;A8Fr5wCY;EALJ;IAMQ,WAAA;E9Fw5wCd;AACF;A8Fr5wCQ;EACI,kBAAA;EAMA,0BAAA;EACA,kBAAA;A9Fk5wCZ;A8Fv5wCY;EAHJ;IAIQ,kBAAA;E9F05wCd;AACF;A8Fp5wCQ;EACI,YAAA;EACA,kBAAA;EAMA,0BAAA;EACA,kBAAA;EACA,sCAAA;EACA,mCAAA;EACA,8BAAA;EACA,gBAAA;EACA,iBAAA;A9Fi5wCZ;A8F35wCY;EAJJ;IAKQ,kBAAA;E9F85wCd;AACF;A8Fp5wCY;EACI,yBAAA;A9Fs5wChB;A8Fp5wCgB;EACI,cAAA;A9Fs5wCpB;;A8F/4wCA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,eAAA;EACA,oCAAA;EACA,kBAAA;EACA,UAAA;EACA,mCAAA;EACA,2BAAA;EACA,kFAAA;EACA,4EAAA;EACA,kEAAA;A9Fk5wCJ;A8Fh5wCI;EACI,UAAA;EACA,mBAAA;EACA,gFAAA;EACA,0EAAA;EACA,gEAAA;A9Fk5wCR;;A+FpixCA;EACI,aAAA;A/FuixCJ;;A+FpixCA;EACI,aAAA;A/FuixCJ;;A+FpixCA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2CAAA;A/FuixCJ;A+FrixCI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;A/FuixCR;;A+FnixCA;EACI,aAAA;A/FsixCJ;A+FpixCI;EACI,UAAA;A/FsixCR;;A+FlixCA;EACI,QAAA;A/FqixCJ;;A+FlixCA;EACI,OAAA;A/FqixCJ;;A+F/hxCI;EACI;IACI,wBAAA;E/FkixCV;AACF;A+F/hxCI;EAxGA;IACI,kBAAA;IACA,YAAA;IACA,kBAAA;IACA,qCAAA;IACA,kCAAA;IACA,iCAAA;IACA,gCAAA;IACA,6BAAA;E/F0oxCN;E+FvoxCE;IACI,cAAA;IACA,gBAAA;IACA,qBAAA;IACA,sBAAA;IACA,wBAAA;IACA,kCAAA;E/FyoxCN;E+FvoxCM;IACI,mBAAA;E/FyoxCV;E+FtoxCM;IACI,kCAAA;E/FwoxCV;AACF;AyFrlxCQ;EMhDI;IACI,kCAAA;E/FwoxCd;AACF;AyF1lxCQ;EM1CI;IACI,kCAAA;E/FuoxCd;AACF;A+FnkxCI;EA9DI;IACI,kBAAA;IACA,WAAA;IACA,YAAA;IACA,yBAAA;IACA,sBAAA;IACA,gBAAA;IACA,mBAAA;E/FooxCV;AACF;;A+FzkxCI;EACI;IACI,wBAAA;E/F4kxCV;AACF;A+FzkxCI;EAnHA;IACI,kBAAA;IACA,YAAA;IACA,kBAAA;IACA,qCAAA;IACA,kCAAA;IACA,iCAAA;IACA,gCAAA;IACA,6BAAA;E/F+rxCN;E+F5rxCE;IACI,cAAA;IACA,gBAAA;IACA,qBAAA;IACA,sBAAA;IACA,wBAAA;IACA,kCAAA;E/F8rxCN;E+F5rxCM;IACI,mBAAA;E/F8rxCV;E+F3rxCM;IACI,kCAAA;E/F6rxCV;AACF;AyF1oxCQ;EMhDI;IACI,kCAAA;E/F6rxCd;AACF;AyF/oxCQ;EM1CI;IACI,kCAAA;E/F4rxCd;AACF;A+F7mxCI;EAzEI;IACI,kBAAA;IACA,WAAA;IACA,YAAA;IACA,yBAAA;IACA,sBAAA;IACA,gBAAA;IACA,mBAAA;E/FyrxCV;AACF;;A+FnnxCI;EACI;IACI,wBAAA;E/FsnxCV;AACF;A+FnnxCI;EA9HA;IACI,kBAAA;IACA,YAAA;IACA,kBAAA;IACA,qCAAA;IACA,kCAAA;IACA,iCAAA;IACA,gCAAA;IACA,6BAAA;E/FovxCN;E+FjvxCE;IACI,cAAA;IACA,gBAAA;IACA,qBAAA;IACA,sBAAA;IACA,wBAAA;IACA,kCAAA;E/FmvxCN;E+FjvxCM;IACI,mBAAA;E/FmvxCV;E+FhvxCM;IACI,kCAAA;E/FkvxCV;AACF;AyF/rxCQ;EMhDI;IACI,kCAAA;E/FkvxCd;AACF;AyFpsxCQ;EM1CI;IACI,kCAAA;E/FivxCd;AACF;A+FvpxCI;EApFI;IACI,kBAAA;IACA,WAAA;IACA,YAAA;IACA,yBAAA;IACA,sBAAA;IACA,gBAAA;IACA,mBAAA;E/F8uxCV;AACF;;A+F7pxCI;EACI;IACI,wBAAA;E/FgqxCV;AACF;A+F7pxCI;EAzIA;IACI,kBAAA;IACA,YAAA;IACA,kBAAA;IACA,qCAAA;IACA,kCAAA;IACA,iCAAA;IACA,gCAAA;IACA,6BAAA;E/FyyxCN;E+FtyxCE;IACI,cAAA;IACA,gBAAA;IACA,qBAAA;IACA,sBAAA;IACA,wBAAA;IACA,kCAAA;E/FwyxCN;E+FtyxCM;IACI,mBAAA;E/FwyxCV;E+FryxCM;IACI,kCAAA;E/FuyxCV;AACF;AyFpvxCQ;EMhDI;IACI,kCAAA;E/FuyxCd;AACF;AyFzvxCQ;EM1CI;IACI,kCAAA;E/FsyxCd;AACF;A+FjsxCI;EA/FI;IACI,kBAAA;IACA,WAAA;IACA,YAAA;IACA,yBAAA;IACA,sBAAA;IACA,gBAAA;IACA,mBAAA;E/FmyxCV;AACF;;A+Fr1xCI;EACI,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,kCAAA;EACA,iCAAA;EACA,gCAAA;EACA,6BAAA;A/Fw1xCR;A+Fr1xCI;EACI,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,wBAAA;EACA,kCAAA;A/Fu1xCR;A+Fr1xCQ;EACI,mBAAA;A/Fu1xCZ;A+Fp1xCQ;EACI,kCAAA;A/Fs1xCZ;AyFlyxCQ;EMhDI;IACI,kCAAA;E/Fq1xCd;AACF;AyFvyxCQ;EM1CI;IACI,kCAAA;E/Fo1xCd;AACF;A+F90xCQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;A/Fg1xCZ;;AgGl4xCC;EACG,kBAAA;EACA,gBAAA;AhGq4xCJ;AgGn4xCI;EACI,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,4BAAA;EACA,YAAA;EACA,kCAAA;AhGq4xCR;AgGl4xCI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AhGo4xCR;AgGl4xCQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AhGo4xCZ;AgGh4xCI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AhGk4xCR;AgG/3xCI;EACI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AhGi4xCR;AgG/3xCQ;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AhGi4xCZ;AgG93xCQ;EACI,kBAAA;AhGg4xCZ;AgG93xCY;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AhGg4xChB;AgG33xCI;EACI,kBAAA;EACA,UAAA;AhG63xCR;;AgGx3xCI;EACI,aAAA;AhG23xCR;AgGz3xCQ;EAHJ;IAIQ,aAAA;EhG43xCV;AACF;AgG13xCQ;EAPJ;IAQQ,aAAA;EhG63xCV;AACF;AgG33xCQ;EAXJ;IAYQ,aAAA;EhG83xCV;AACF;AgG53xCQ;EAfJ;IAgBQ,aAAA;EhG+3xCV;AACF;AgG73xCQ;EACI,YAAA;AhG+3xCZ;;AiGr9xCA;EACI,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;AjGw9xCJ;AiGt9xCI;EACI,kBAAA;AjGw9xCR;AiGr9xCI;EACI,gBAAA;AjGu9xCR;AiGp9xCI;EACI,WAAA;EACA,mBAAA;EACA,qBAAA;AjGs9xCR;AiGn9xCI;EACI,WAAA;EACA,yBAAA;EACA,qBAAA;AjGq9xCR;AiGl9xCI;EACI,YAAA;EACA,gBAAA;EACA,oBAAA;AjGo9xCR;;AiG58xCA;EAEI,uBAAA;EACA,YAAA;AjG88xCJ;AiGt8xCA;EAEI,uBAAA;EACA,YAAA;EACA,mBAAA;AjGu8xCJ;AiGr8xCI;EACI,8BAAA;EACA,uBAAA;EACA,kCAAA;AjGu8xCR;;AiGn8xCA;EAEI,uBAAA;EACA,YAAA;AjGq8xCJ;AiG77xCA;EAEI,iBAAA;EACA,YAAA;AjG87xCJ;AiG57xCI;EACI,8BAAA;AjG87xCR;;AiG17xCA;EAEI,mBhGjFW;EgGkFX,yBAAA;EACA,WhGpFU;ADghyCd;AiG17xCI;EACI,8BAAA;EACA,oCAAA;EACA,sBAAA;AjG47xCR;;AiGx7xCA;EAEI,mBhG9FW;EgG+FX,yBAAA;EACA,WhGjGU;AD2hyCd;AiGx7xCI;EACI,2BAAA;EACA,iCAAA;EACA,yBAAA;AjG07xCR;;AiGt7xCA;EACI,iBAAA;AjGy7xCJ;;AiGt7xCA;EACI,uBAAA;EACA,YAAA;EACA,0BAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;AjGy7xCJ;AiGv7xCI;EACI,YAAA;EACA,qBAAA;EACA,YAAA;AjGy7xCR;;AiGr7xCA;EACI,mBAAA;EACA,0BAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;AjGw7xCJ;AiGt7xCI;EACI,qBAAA;EACA,4BAAA;EACA,cAAA;AjGw7xCR;;AiGp7xCA;EACI,gBAAA;EACA,sBAAA;AjGu7xCJ;;AiGp7xCA;EACI,gBAAA;AjGu7xCJ;AiGr7xCI;EACI,UAAA;AjGu7xCR;;AkG5lyCA;EACI,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AlG+lyCJ;AkG5lyCQ;EACI,aAAA;AlG8lyCZ;;AkGzlyCA,6BAAA;AACA;;EAEI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;AlG4lyCJ;;AkGzlyCA,yDAAA;AACA;;EAEI,uBAAA;AlG4lyCJ;;AkGzlyCA;;EAEI,kBAAA;AlG4lyCJ;;AkGzlyCA,6DAAA;AACA;;EAEI,WAAA;EACA,kBAAA;EACA,aAAA;AlG4lyCJ;;AkGzlyCA,oCAAA;AACA;;EAEI,cAAA;AlG4lyCJ;;AkGzlyCA,kCAAA;AACA;EACI,YAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,2BAAA;AlG4lyCJ;;AkGzlyCA;EACI,UAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,gCAAA;EACA,4BAAA;EACA,wBAAA;AlG4lyCJ;;AmGlqyCC;EACG,uBAAA;EACA,oBAAA;EACA,iBAAA;AnGqqyCJ;AmGnqyCI;EACI,aAAA;EACA,WAAA;EACA,kBAAA;EACA,8BAAA;EACA,+BAAA;EACA,6BAAA;EACA,uBAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;AnGqqyCR;AmGlqyCI;EACI,WAAA;EACA,aAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AnGoqyCR;AmGlqyCQ;EACI,yBAAA;AnGoqyCZ;AmGjqyCQ;EACI,UAAA;AnGmqyCZ;AmGhqyCQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;AnGkqyCZ;AmGhqyCY;EACI,SAAA;EACA,UAAA;AnGkqyChB;AmG7pyCI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AnG+pyCR;;AoGxtyCC;EACG,qBAAA;EACA,6BAAA;EACA,6BAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;ApG2tyCJ;AoGztyCI;EACI,6BAAA;EACA,WAAA;EACA,YAAA;ApG2tyCR;AoGxtyCI;EACI,WAAA;EACA,yBAAA;EACA,qBAAA;ApG0tyCR;;AqG5uyCA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;ArG+uyCJ;;AqGzuyCI;EACI,sBAAA;ArG4uyCR;AqGxuyCQ;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;ArG0uyCZ;AqGtuyCI;EAEI,eAAA;ArGuuyCR;AqGpuyCY;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;ArGsuyChB;AqGjuyCI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,aAAA;ArGmuyCR;;AsGzxyCA;EACI,WAAA;AtG4xyCJ;AsG1xyCI;EACI,SAAA;EACA,6BAAA;EACA,aAAA;EACA,cAAA;EACA,YAAA;EACA,qBAAA;AtG4xyCR;AsG1xyCQ;EACI,sBAAA;EACA,gBAAA;AtG4xyCZ;AsGzxyCQ;EACI,gBAAA;AtG2xyCZ;;AsGtxyCA;EACI,iBAAA;AtGyxyCJ;;AsGrxyCI;EACI,iBAAA;EACA,YAAA;AtGwxyCR;AsGtxyCQ;EACI,uBAAA;AtGwxyCZ;AsGrxyCQ;EACI,0BAAA;AtGuxyCZ;AsGnxyCI;EACI,iBAAA;EACA,kBAAA;AtGqxyCR;AsGnxyCQ;EACI,iBAAA;EACA,cAAA;AtGqxyCZ;AsGlxyCQ;EACI,mBAAA;AtGoxyCZ;AsGhxyCI;EACI,WAAA;EACA,YAAA;AtGkxyCR;;AsG9wyCA;EACI,gBAAA;AtGixyCJ;AsG/wyCI;EACI,qBAAA;EACA,sBrG1DK;EqG2DL,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;AtGixyCR;AsG/wyCQ;EACI,qBAAA;AtGixyCZ;AsG9wyCQ;EACI,uBAAA;EACA,YAAA;AtGgxyCZ;AsG9wyCY;EACI,YAAA;AtGgxyChB;AsG5wyCQ;EACI,uBAAA;EACA,YAAA;AtG8wyCZ;AsG5wyCY;EACI,YAAA;AtG8wyChB;AsG1wyCQ;EACI,YAAA;AtG4wyCZ;;AsGrwyCI;EACI,WAAA;AtGwwyCR;AsGrwyCI;EACI,WAAA;EACA,qBAAA;EACA,2BAAA;AtGuwyCR;AsGpwyCI;EACI,WAAA;EACA,aAAA;EACA,YAAA;EACA,gCAAA;AtGswyCR;AsGpwyCQ;EACI,YAAA;AtGswyCZ;AsGpwyCY;EACI,qBAAA;EACA,YAAA;AtGswyChB;AsGlwyCQ;EACI,yBAAA;AtGowyCZ;;AsG/vyCA;EACI,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;AtGkwyCJ;AsGhwyCI;EACI,WAAA;EACA,aAAA;EACA,6BAAA;AtGkwyCR;;AsG9vyCA;EACI,iBAAA;AtGiwyCJ;;AsG9vyCA;EACI,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;AtGiwyCJ;AsG/vyCI;EACI,WAAA;EACA,aAAA;EACA,6BAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AtGiwyCR;AsG/vyCQ;EACI,mBAAA;AtGiwyCZ;AsG/vyCY;EACI,kBAAA;EACA,MAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;EACA,oCAAA;EACA,4BAAA;AtGiwyChB;;AsG3vyCA;EACI;IACI,cAAA;EtG8vyCN;EsG5vyCM;IACI,cAAA;IACA,kBAAA;IACA,gBAAA;IACA,eAAA;EtG8vyCV;AACF;AsG1vyCA;EACI,WAAA;EACA,gBAAA;EACA,iBAAA;AtG4vyCJ;AsG1vyCI;EACI,WAAA;EACA,YAAA;AtG4vyCR;;AsGxvyCA;EACI,mBAAA;EACA,YAAA;EACA,mBAAA;AtG2vyCJ;;AsGxvyCA;EACI;IACI,eAAA;EtG2vyCN;AACF;AsGxvyCA;EACI;IACI,gBAAA;EtG0vyCN;AACF;AuGz9yCC;EACG,oCAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AvG29yCJ;AuGz9yCI;EACI,kBAAA;AvG29yCR;AuGx9yCI;EACI;IACI,uBAAA;EvG09yCV;EuGv9yCM;IACI,yBAAA;EvGy9yCV;AACF;;AuGr9yCA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;AvGw9yCJ;;AuGr9yCA;EACI,WAAA;EACA,YAAA;EACA,2BAAA;EACA,wBAAA;EACA,kBAAA;EACA,4BAAA;EACA,kCAAA;AvGw9yCJ;;AwGngzCA;EACI,WAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AxGsgzCJ;AwGpgzCI;EACI,UAAA;AxGsgzCR;;AwGlgzCA;EAEI,YAAA;AxGogzCJ;AwGlgzCI;EAEI,YAAA;AxGmgzCR;;AwG//yCA;EAEI,YAAA;EACA,eAAA;AxGigzCJ;;AwG9/yCA;EACI,kBAAA;EACA,sBvGtBS;EuGuBT,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,UAAA;AxGigzCJ;AwG//yCI;EACI,aAAA;EACA,6BAAA;EACA,WAAA;AxGigzCR;AwG//yCQ;EACI,aAAA;EACA,8BAAA;AxGigzCZ;AwG//yCY;EACI,qBAAA;AxGigzChB;AwG9/yCY;EACI,WAAA;AxGggzChB;AwG5/yCQ;EACI,gBAAA;AxG8/yCZ;AwG1/yCI;EACI,YAAA;AxG4/yCR;AwGz/yCI;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,kBAAA;EACA,yBvG9DU;EuG+DV,YAAA;EACA,gBAAA;EACA,UAAA;AxG2/yCR;AwGz/yCQ;EACI,6BAAA;EACA,2BAAA;EACA,4BAAA;AxG2/yCZ;AwGz/yCY;EACI,uBAAA;AxG2/yChB;AwGr/yCQ;EACI,mBAAA;AxGu/yCZ;;AwGl/yCA;EACI,6BAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;AxGq/yCJ;AwGn/yCI;EACI,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,8BAAA;AxGq/yCR;AwGl/yCI;EACI,iBAAA;EACA,oBAAA;AxGo/yCR;AwGj/yCI;EACI,eAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AxGm/yCR;AwGh/yCI;EACI,YAAA;AxGk/yCR;AwG/+yCI;EACI,YAAA;EACA,eAAA;AxGi/yCR;AwG/+yCQ;EACI,UAAA;AxGi/yCZ;AwG7+yCI;EACI,YAAA;AxG++yCR;AwG7+yCQ;EACI,qBAAA;AxG++yCZ;AwG3+yCI;EACI,aAAA;AxG6+yCR;AwG1+yCI;EACI,qBAAA;AxG4+yCR;AwGz+yCI;EACI,iBAAA;AxG2+yCR;AwGx+yCI;EACI,iBAAA;EACA,gBAAA;EACA,UAAA;AxG0+yCR;;AyGpozCQ;EACI,uBAAA;EACA,mBAAA;EACA,yBAAA;AzGuozCZ;AyGnozCI;EACI,sBAAA;AzGqozCR;;A0G/ozCA;EACI,eAAA;EACA,czGkCa;EyGjCb,ezGqBa;EyGpBb,gBAAA;EACA,sBAAA;EACA,WAAA;A1GkpzCJ;A0GhpzCI;EAEI,UAAA;A1GipzCR;A0G9ozCI;EACI,eAAA;A1GgpzCR;A0G7ozCI;EACI,eAAA;EACA,gBzGkBe;EyGjBf,kBzGMe;EyGLf,gBAAA;EACA,sBAAA;EACA,WAAA;A1G+ozCR;;A2GrqzCI;EACI,gBAAA;EACA,cAAA;A3GwqzCR;A2GtqzCQ;EACI,wBAAA;A3GwqzCZ;A2GrqzCQ;EACI,kBAAA;EACA,WAAA;A3GuqzCZ;A2GpqzCQ;EACI,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,e1GMK;E0GLL,iB1GKK;E0GJL,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,6BAAA;EACA,+BAAA;EACA,0BAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;A3GsqzCZ;A2GnqzCQ;EACI,sBAAA;EACA,uBAAA;EACA,gCAAA;EACA,2BAAA;EACA,2BAAA;EACA,0BAAA;EACA,iB1GtBK;E0GuBL,gBAAA;EACA,yBAAA;EACA,6BAAA;EACA,iCAAA;EACA,6BAAA;EACA,kCAAA;EACA,oCAAA;EACA,iCAAA;EACA,gCAAA;EACA,4BAAA;EACA,wCAAA;EACA,0CAAA;EACA,qCAAA;EACA,kCAAA;EACA,gCAAA;EACA,2BAAA;EACA,2BAAA;EACA,iCAAA;A3GqqzCZ;A2GlqzCQ;EACI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,e1G/CK;E0GgDL,iB1GhDK;E0GiDL,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,6BAAA;EACA,+BAAA;EACA,0BAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;A3GoqzCZ;A2GjqzCQ;EACI,oBAAA;A3GmqzCZ;A2GhqzCQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;A3GkqzCZ;A2GhqzCY;EACI,gCAAA;EACA,mBAAA;A3GkqzChB;A2G9pzCQ;EACI,qBAAA;EACA,kBAAA;A3GgqzCZ;A2G7pzCQ;EACI,kBAAA;A3G+pzCZ;A2G7pzCY;EACI,oBAAA;EACA,cAAA;EACA,gBAAA;A3G+pzChB;A2G7pzCgB;EACI,qBAAA;EACA,oCAAA;EACA,eAAA;EACA,oBAAA;EACA,oBAAA;EACA,mCAAA;EACA,kCAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;A3G+pzCpB;A2G5pzCgB;EACI,6BAAA;EACA,YAAA;A3G8pzCpB;A2G5pzCoB;EACI,iBAAA;EACA,cAAA;A3G8pzCxB;A2G1pzCgB;EACI,6BAAA;EACA,YAAA;A3G4pzCpB;A2G1pzCoB;EACI,iBAAA;EACA,cAAA;A3G4pzCxB;;A4GhzzCI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;A5GmzzCR;A4GjzzCQ;EACI,mBAAA;EACA,eAAA;EACA,iBAAA;A5GmzzCZ;A4GhzzCQ;EACI,gBAAA;EACA,iBAAA;EACA,eAAA;A5GkzzCZ;A4G9yzCI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;A5GgzzCR;A4G7yzCI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;A5G+yzCR;A4G5yzCI;EACI,WAAA;A5G8yzCR;A4G3yzCI;EACI,eAAA;A5G6yzCR;AyFtvzCQ;EmBlDA;IACI,eAAA;E5G2yzCV;E4GxyzCM;IACI,eAAA;IACA,iBAAA;E5G0yzCV;E4GvyzCM;IACI,gBAAA;IACA,eAAA;IACA,iBAAA;E5GyyzCV;AACF;A4GtyzCI;EACI,WAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;A5GwyzCR;A4GryzCI;EACI,uBAAA;EACA,WAAA;A5GuyzCR;A4GpyzCI;EACI,WAAA;A5GsyzCR;A4GnyzCI;;EAEI,UAAA;EACA,kCAAA;EACA,aAAA;A5GqyzCR;A4GlyzCI;EACI,qB3G/EO;E2GgFP,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;A5GoyzCR;A4GjyzCI;;EAEI,oBAAA;A5GmyzCR;A4GjyzCQ;;EACI,kBAAA;A5GoyzCZ;A4GhyzCI;EACI,OAAA;A5GkyzCR;A4GhyzCQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;A5GkyzCZ;A4GhyzCY;EACI,0BAAA;EACA,SAAA;A5GkyzChB;A4G7xzCI;EACI,QAAA;A5G+xzCR;A4G7xzCQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;A5G+xzCZ;A4G7xzCY;EACI,wBAAA;EACA,UAAA;A5G+xzChB;AyFr1zCQ;EmB4DA;IACI,aAAA;E5G4xzCV;E4GzxzCM;IACI,yBAAA;IACA,YAAA;IACA,WAAA;IACA,SAAA;E5G2xzCV;E4GxxzCM;IACI,OAAA;E5G0xzCV;E4GxxzCU;IACI,WAAA;IACA,YAAA;IACA,WAAA;E5G0xzCd;E4GxxzCc;IACI,SAAA;E5G0xzClB;E4GrxzCM;IACI,QAAA;E5GuxzCV;E4GrxzCU;IACI,WAAA;IACA,YAAA;IACA,UAAA;E5GuxzCd;E4GrxzCc;IACI,UAAA;E5GuxzClB;AACF;AyFt3zCQ;EmBwGI;IACI,aAAA;IACA,kBAAA;E5GixzCd;E4G/wzCc;IACI,eAAA;IACA,iBAAA;E5GixzClB;E4G9wzCc;IACI,eAAA;IACA,iBAAA;E5GgxzClB;E4G3wzCM;IACI,yBAAA;IACA,YAAA;IACA,WAAA;IACA,QAAA;E5G6wzCV;E4G1wzCM;IACI,OAAA;IACA,aAAA;E5G4wzCV;E4G1wzCU;IACI,WAAA;IACA,YAAA;IACA,WAAA;E5G4wzCd;E4G1wzCc;IACI,SAAA;E5G4wzClB;E4GvwzCM;IACI,QAAA;IACA,aAAA;E5GywzCV;E4GvwzCU;IACI,WAAA;IACA,YAAA;IACA,UAAA;E5GywzCd;E4GvwzCc;IACI,UAAA;E5GywzClB;AACF;AyF32zCQ;EmB0GQ;IACI,eAAA;IACA,eAAA;IACA,wBAAA;E5GowzClB;AACF;AyF15zCQ;EmB4JA;IACI,gBAAA;IACA,cAAA;E5GiwzCV;E4G9vzCc;IACI,eAAA;IACA,eAAA;IACA,wBAAA;IACA,gBAAA;E5GgwzClB;E4G3vzCM;IACI,+BAAA;IACA,OAAA;E5G6vzCV;E4G3vzCU;IACI,UAAA;E5G6vzCd;E4GzvzCM;IACI,+BAAA;IACA,QAAA;E5G2vzCV;E4GzvzCU;IACI,SAAA;E5G2vzCd;AACF;AyFn8zCQ;EmB+MI;IACI,aAAA;IACA,mBAAA;E5GuvzCd;E4GrvzCc;IACI,mBAAA;IACA,eAAA;IACA,iBAAA;E5GuvzClB;E4GpvzCc;IACI,gBAAA;IACA,iBAAA;IACA,eAAA;E5GsvzClB;E4GjvzCM;IACI,yBAAA;IACA,YAAA;IACA,WAAA;IACA,SAAA;E5GmvzCV;E4GhvzCM;IACI,SAAA;IACA,aAAA;E5GkvzCV;E4GhvzCU;IACI,WAAA;IACA,YAAA;IACA,WAAA;E5GkvzCd;E4GhvzCc;IACI,SAAA;E5GkvzClB;E4G7uzCM;IACI,QAAA;IACA,aAAA;E5G+uzCV;E4G7uzCU;IACI,WAAA;IACA,YAAA;IACA,UAAA;E5G+uzCd;E4G7uzCc;IACI,UAAA;E5G+uzClB;AACF;;A6G7j0CI;EACI,UAAA;EACA,qBAAA;A7Ggk0CR;A6G9j0CQ;EACI,oCAAA;A7Ggk0CZ;A6G5j0CI;EACI,iBAAA;EACA,yBAAA;EACA,oCAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;A7G8j0CR;A6G5j0CQ;EACI,eAAA;A7G8j0CZ;A6G3j0CQ;EACI,gBAAA;A7G6j0CZ;A6G1j0CQ;EACI,gCAAA;A7G4j0CZ;A6Gxj0CY;EACI,qBAAA;EACA,cAAA;A7G0j0ChB;A6Gtj0CQ;EACI,cAAA;A7Gwj0CZ;A6Gpj0CI;EACI,gBAAA;EACA,oBAAA;A7Gsj0CR;;A8Gjm0CA;EACI,sBAAA;EACA,kDAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yCAAA;EACA,sCAAA;EACA,iCAAA;EACA,iBAAA;EACA,gBAAA;A9Gom0CJ;A8Glm0CI;EACI,sBAAA;EACA,kCAAA;EACA,aAAA;A9Gom0CR;A8Gjm0CI;EACI,WAAA;EACA,8BAAA;EACA,2BAAA;EACA,sBAAA;EACA,iBAAA;A9Gmm0CR;A8Gjm0CQ;EACI,4BAAA;A9Gmm0CZ;A8Ghm0CQ;EACI,0BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;A9Gkm0CZ;A8G/l0CQ;EACI,SAAA;A9Gim0CZ;A8G9l0CQ;EACI,iBAAA;EACA,mBAAA;EACA,kBAAA;A9Ggm0CZ;A8G5l0CI;EACI,yBAAA;A9G8l0CR;A8G5l0CQ;EACI,WAAA;A9G8l0CZ;A8Gxl0CQ;EACI,yBAAA;A9G0l0CZ;A8Gtl0CI;EACI,WAAA;EACA,yCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;A9Gwl0CR;;A8Gpl0CA;EACI,iBAAA;A9Gul0CJ;A8Gtl0CI;EAFJ;IAGQ,mBAAA;IACA,kBAAA;E9Gyl0CN;AACF;;A8Gtl0CA;EACI,gBAAA;EACA,WAAA;EACA,cAAA;EACA,4CAAA;EACA,yCAAA;EACA,wCAAA;EACA,uCAAA;EACA,oCAAA;EACA,WAAA;A9Gyl0CJ;A8Gvl0CI;EACI,kBAAA;EACA,mBAAA;EACA,gBAAA;A9Gyl0CR;;A+Gls0CC;EACG,qBAAA;EACA,WAAA;A/Gqs0CJ;A+Gns0CI;EACI,WAAA;A/Gqs0CR;A+Gls0CI;EACI,cAAA;A/Gos0CR;A+Gls0CQ;EACI,cAAA;A/Gos0CZ;A+Ghs0CI;EACI,cAAA;A/Gks0CR;A+Ghs0CQ;EACI,cAAA;A/Gks0CZ;A+G9r0CI;EACI,kBAAA;A/Ggs0CR;A+G7r0CI;EACI,eAAA;A/G+r0CR;A+G5r0CI;EACI,uBAAA;A/G8r0CR;;A+G1r0CA;EACI,kBAAA;A/G6r0CJ;A+G3r0CI;EACI,0BAAA;A/G6r0CR;;A+Gzr0CA;EACI,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,iCAAA;A/G4r0CJ;A+G1r0CI;EACI,cAAA;EACA,qBAAA;EACA,yDAAA;EACA,iBAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mCAAA;A/G4r0CR;A+Gzr0CI;EACI,yBAAA;EACA,qBAAA;EACA,WAAA;A/G2r0CR;A+Gzr0CQ;EACI,WAAA;A/G2r0CZ;A+Gvr0CI;EACI,mBAAA;EACA,WAAA;EACA,mBAAA;A/Gyr0CR;;AgHxw0CI;;EAEI,aAAA;AhH2w0CR;;AgHtw0CI;EACI,gBAAA;EACA,kBAAA;EACA,iBAAA;AhHyw0CR;;AgHjw0CA;EACI,gBAAA;AhHow0CJ;AgHlw0CI;;EAEI,aAAA;AhHow0CR;AgHjw0CI;EACI,UAAA;EACA,oCAAA;AhHmw0CR;AgHhw0CI;;EAEI,UAAA;EACA,kCAAA;AhHkw0CR;AgH/v0CI;EACI,qB/GnCO;E+GoCP,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;AhHiw0CR;AgH5v0CQ;EACI,sBAAA;EACA,kBAAA;AhH8v0CZ;AgH5v0CY;EACI,0BAAA;AhH8v0ChB;AgHvv0CQ;EACI,sBAAA;EACA,kBAAA;AhHyv0CZ;AgHvv0CY;EACI,wBAAA;AhHyv0ChB;AgHnv0CQ;EACI,YAAA;AhHqv0CZ;AgHhv0CQ;EACI,YAAA;EACA,iBAAA;AhHkv0CZ;AgH/u0CQ;EACI,mBAnEgB;EAoEhB,kBApEgB;AhHqz0C5B;AgH9u0CQ;;EAEI,YAAA;EACA,iBAAA;EACA,YA3EgB;AhH2z0C5B;AgH7u0CQ;EACI,yBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;AhH+u0CZ;AgH5u0CQ;EACI,4BAAA;AhH8u0CZ;AgH5u0CY;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;AhH8u0ChB;AgH5u0CgB;EACI,SAAA;AhH8u0CpB;AgHzu0CQ;EACI,2BAAA;AhH2u0CZ;AgHzu0CY;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;AhH2u0ChB;AgHzu0CgB;EACI,UAAA;AhH2u0CpB;AgHtu0CQ;EACI,aAAA;EACA,YAAA;AhHwu0CZ;AyFjy0CQ;EuB8DA;IACI,YAAA;IACA,iBAAA;EhHsu0CV;EgHnu0CM;IACI,mBAjIS;IAkIT,kBAlIS;EhHu20CnB;EgHlu0CM;;IAEI,YAAA;IACA,iBAAA;IACA,YAzIS;EhH620CnB;EgHju0CM;IACI,yBAAA;IACA,YAAA;IACA,WAAA;IACA,SAAA;EhHmu0CV;EgHhu0CM;IACI,4BAAA;EhHku0CV;EgHhu0CU;IACI,WAAA;IACA,YAAA;IACA,mBAAA;IACA,YAAA;EhHku0Cd;EgHhu0Cc;IACI,SAAA;EhHku0ClB;EgH7t0CM;IACI,2BAAA;EhH+t0CV;EgH7t0CU;IACI,WAAA;IACA,YAAA;IACA,mBAAA;IACA,WAAA;EhH+t0Cd;EgH7t0Cc;IACI,UAAA;EhH+t0ClB;EgH1t0CM;IACI,aAAA;IACA,YAAA;EhH4t0CV;AACF;AgHzt0CI;;EAEI,yCAAA;EACA,iCAAA;AhH2t0CR;AgHxt0CI;;EAEI,0CAAA;EACA,kCAAA;AhH0t0CR;AgHvt0CI;EACI,yBAAA;EACA,WAAA;EACA,kBAAA,EAAA,8BAAA;EACA,mBAAA;AhHyt0CR;;AiH960CI;EACI,sBAAA;EACA,gBAAA;AjHi70CR;AyFz10CQ;EwB1FJ;IAKQ,gBAAA;EjHk70CV;AACF;AiHh70CQ;EACI,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;AjHk70CZ;AyFn30CQ;EwBnEA;IAOQ,iBAAA;EjHm70Cd;AACF;AyFx30CQ;EwBnEA;IAWQ,iBAAA;EjHo70Cd;AACF;AyF920CQ;EwBlFA;IAeQ,eAAA;IACA,cAAA;EjHq70Cd;AACF;AiHn70CY;EACI,4BAAA;EACA,+BAAA;EACA,kCAAA;EACA,sBAAA;AjHq70ChB;AyF130CQ;EwB/DI;IAOQ,YAAA;IACA,4BAAA;IACA,6BAAA;EjHs70ClB;AACF;AyFj40CQ;EwBlFA;IAiCQ,YAAA;EjHs70Cd;EiHp70Cc;IACI,cAAA;EjHs70ClB;EiHn70Cc;IACI,qBAAA;EjHq70ClB;EiHn70CkB;IACI,qBAAA;EjHq70CtB;AACF;AiHh70CQ;EACI,gBAAA;EACA,cAAA;AjHk70CZ;AiHh70CY;EACI,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,aAAA;EACA,iBAAA;EACA,sBAAA;AjHk70ChB;AyF350CQ;EwB7BI;IASQ,eAAA;IACA,sBAAA;EjHm70ClB;AACF;AiHj70CgB;EACI,iBAAA;AjHm70CpB;AiH/60CY;EACI,gBAAA;EACA,eAAA;AjHi70ChB;AyFx60CQ;EwBXI;IAKQ,eAAA;EjHk70ClB;AACF;AiH760CI;EACI,eAAA;AjH+60CR;AiH760CQ;EACI,gBAAA;AjH+60CZ;AiH360CI;EACI,oBAAA;EACA,oBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;AjH660CR;AiH360CQ;EACI,YAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;AjH660CZ;AyFl80CQ;EwByBI;IACI,YAAA;IACA,kBAAA;IACA,SAAA;IACA,UAAA;IACA,kBAAA;IACA,mBAAA;EjH460Cd;AACF;AiHx60CI;EACI,YAAA;EACA,yB5GzGO;E4G0GP,WAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AjH060CR;AiHv60CI;EACI,WAAA;AjHy60CR;AiHt60CI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,yCAAA;EACA,kBAAA;AjHw60CR;AiHr60CI;EACI,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,oBAAA;EACA,SAAA;EACA,iBAAA;EACA,iDAAA;EACA,oCAAA;EACA,0BAAA;EACA,0BAAA;EACA,+BAAA;EACA,kCAAA;EACA,SAAA;AjHu60CR;AiHp60CI;EACI,wBAAA;EACA,6BAAA;EACA,gCAAA;AjHs60CR;AiHn60CI;EACI,eAAA;EACA,SAAA;EACA,sBAAA;AjHq60CR;AiHl60CI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,chH7KM;ADil1Cd;AiHl60CQ;EACI,WAAA;AjHo60CZ;AiHh60CI;EACI,oBAAA;EACA,oBAAA;EACA,aAAA;EACA,8BAAA;EACA,6BAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,mBhHhMe;EgHiMf,UAAA;EACA,2DAAA;EACA,mDAAA;EACA,UAAA;AjHk60CR;AiH/50CI;EACI,oBAAA;EACA,oBAAA;EACA,aAAA;EACA,8BAAA;EACA,6BAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;AjHi60CR;AiH950CI;EACI,eAAA;EACA,UAAA;EACA,OAAA;EACA,2DAAA;EACA,mDAAA;AjHg60CR;AiH750CI;EACI,eAAA;EACA,UAAA;EACA,OAAA;AjH+50CR;AiH550CI;EACI,YAAA;AjH850CR;AyFnk1CQ;EwBoKJ;IAIQ,yBAAA;EjH+50CV;AACF;AyFzj1CQ;EwB8JA;IACI,UAAA;EjH850CV;AACF;AyF9j1CQ;EwBqKA;IACI,YAAA;EjH450CV;EiHz50CM;IACI,yB5G7OG;ELwo1Cb;EiHx50CM;IACI,cAAA;IACA,YAAA;IACA,yBhH5PW;IgH6PX,UAAA;EjH050CV;EiHx50CU;IACI,YAAA;IACA,qBAAA;IACA,eAAA;EjH050Cd;AACF;AyFjl1CQ;EwBmLI;IAMQ,eAAA;EjH450ClB;AACF;AiHv50CI;EAEI;IACI,SAAA;EjHw50CV;EiHr50CM;IACI,SAAA;EjHu50CV;AACF;AiHp50CI;EACI,oBAAA;EACA,oBAAA;EAWA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,chH3SM;EgH4SN,eAAA;EACA,gBAAA;AjH440CR;AyF3n1CQ;EwByNJ;IAKQ,+BAAA;IACA,+BAAA;IACA,iCAAA;IACA,yBAAA;IACA,wBAAA;IACA,qBAAA;EjHi60CV;AACF;AyFtn1CQ;EwB0MJ;IAyBQ,eAAA;IACA,iBAAA;EjHu50CV;AACF;AiHr50CQ;EACI,eAAA;EACA,gBAAA;EACA,WAAA;AjHu50CZ;AiHr50CY;EALJ;IAMQ,eAAA;EjHw50Cd;AACF;AiHp50CI;EACI,YAAA;EACA,yB5GvTO;E4GwTP,qBAAA;AjHs50CR;AiHn50CI;EACI,+BAAA;EACA,+BAAA;AjHq50CR;AiHl50CI;EACI,yBAAA;AjHo50CR;AiHl50CQ;EACI,iBAAA;EACA,oCAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;AjHo50CZ;;AkHrv1CC;EACG,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,WAAA;AlHwv1CJ;AyFhq1CQ;EyB5FP;IAOO,eAAA;IACA,iBAAA;ElHyv1CN;AACF;AkHvv1CI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AlHyv1CR;AyF5q1CQ;EyBjFJ;IAOQ,eAAA;IACA,iBAAA;ElH0v1CV;AACF;AkHvv1CI;EACI,iBAAA;EACA,eAAA;EACA,cAAA;AlHyv1CR;;AkHnv1CI;EACI,iBAAA;AlHsv1CR;AkHnv1CI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;AlHqv1CR;AyFls1CQ;EyBxDJ;IAQQ,eAAA;IACA,iBAAA;ElHsv1CV;AACF;AyFvt1CQ;EyBzCJ;IAaQ,+BAAA;ElHuv1CV;AACF;AkHpv1CI;EACI,mBAAA;EACA,eAAA;AlHsv1CR;AyFhu1CQ;EyBxBJ;IAKQ,+BAAA;ElHuv1CV;AACF;AkHpv1CI;EACI,gBAAA;EACA,0BAAA;EACA,WAAA;AlHsv1CR;AkHnv1CI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AlHqv1CR;AkHlv1CI;EACI,qBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;EACA,iDAAA;EACA,oCAAA;EACA,0BAAA;AlHov1CR;AkHjv1CI;EACI,0BAAA;EACA,+BAAA;EACA,kCAAA;AlHmv1CR;AkHhv1CI;EACI,wBAAA;EACA,6BAAA;EACA,gCAAA;AlHkv1CR;;AmHr11CC;EACG,aAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,SAAA;EACA,wBAAA;AnHw11CJ;;AmHr11CA;EACI,gBAAA;EACA,mBAAA;AnHw11CJ;;AmHr11CA;EACI,eAAA;AnHw11CJ;AmHt11CI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AnHw11CR;AmHr11CI;EACI,gBAAA;EACA,qBAAA;AnHu11CR;;AmHl11CI;EACI,eAAA;AnHq11CR;AmHn11CQ;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AnHq11CZ;;AmHh11CA;EACI,sBAAA;EACA,kCAAA;AnHm11CJ;;AmHh11CA;EACI,YAAA;EACA,UAAA;EACA,wBAAA;AnHm11CJ;AmHj11CI;EACI,UAAA;AnHm11CR;AmHh11CI;EACI,4BAAA;EACA,+BAAA;EACA,sBAAA;AnHk11CR;AmH/01CI;EACI,YAAA;EACA,6BAAA;EACA,8BAAA;AnHi11CR;;AmH701CA;EACI,YAAA;EACA,UAAA;EACA,gBAAA;AnHg11CJ;AmH901CI;EACI,UAAA;AnHg11CR;AmH701CI;EACI,sBAAA;AnH+01CR;AmH501CI;EACI,WAAA;AnH801CR;AmH301CI;EACI,WAAA;EACA,6BAAA;EACA,8BAAA;AnH601CR;;AmHz01CA;EAKgB;IACI,6BAAA;IACA,8BAAA;EnHw01ClB;AACF;AmHj01CA;EAKgB;IACI,6BAAA;IACA,8BAAA;EnH+z1ClB;AACF;AmHzz1CA;EACI;IACI,uBAAA;IACA,SAAA;IACA,WAAA;EnH2z1CN;EmHzz1CM;IACI,YAAA;IACA,WAAA;IACA,iBAAA;EnH2z1CV;EmHzz1CU;IACI,WAAA;EnH2z1Cd;EmHxz1CU;IACI,iBAAA;EnH0z1Cd;EmHtz1CM;IACI,YAAA;IACA,WAAA;IACA,iBAAA;IACA,iBAAA;EnHwz1CV;EmHtz1CU;IACI,WAAA;EnHwz1Cd;EmHrz1CU;IACI,iBAAA;EnHuz1Cd;AACF;AmHjz1CA;EACI;IACI,wBAAA;EnHmz1CN;EmHjz1CM;IACI,uBAAA;IACA,SAAA;IACA,WAAA;EnHmz1CV;EmHjz1CU;IACI,YAAA;IACA,WAAA;IACA,iBAAA;EnHmz1Cd;EmHjz1Cc;IACI,WAAA;EnHmz1ClB;EmH/y1CU;IACI,YAAA;IACA,WAAA;IACA,iBAAA;IACA,iBAAA;EnHiz1Cd;EmH/y1Cc;IACI,WAAA;EnHiz1ClB;EmH3y1CE;IACI,eAAA;EnH6y1CN;EmH1y1CE;IACI,eAAA;IACA,gBAAA;IACA,mBAAA;EnH4y1CN;EmHvy1CU;IACI,eAAA;IACA,gBAAA;IACA,mBAAA;EnHyy1Cd;EmHpy1CM;IACI,4BAAA;EnHsy1CV;EmHly1CM;IACI,4BAAA;IACA,+BAAA;EnHoy1CV;AACF;AmHhy1CA;EACI;IACI,uBAAA;IACA,SAAA;IACA,WAAA;EnHky1CN;EmHhy1CE;IACI,eAAA;EnHky1CN;EmH/x1CE;IACI,eAAA;IACA,gBAAA;IACA,mBAAA;EnHiy1CN;EmH3x1CU;IACI,eAAA;IACA,gBAAA;IACA,kBAAA;EnH6x1Cd;EmHxx1CU;IACI,iBAAA;EnH0x1Cd;EmHtx1CE;IACI,YAAA;IACA,WAAA;IACA,aAAA;EnHwx1CN;EmHtx1CM;IACI,WAAA;EnHwx1CV;EmHrx1CM;IACI,4BAAA;IACA,+BAAA;EnHux1CV;EmHnx1CE;IACI,YAAA;IACA,WAAA;IACA,iBAAA;IACA,aAAA;EnHqx1CN;EmHnx1CM;IACI,WAAA;EnHqx1CV;EmHlx1CM;IACI,4BAAA;IACA,+BAAA;EnHox1CV;EmH/w1CE;IACI,UAAA;EnHix1CN;AACF;AmH9w1CA;EACI;IACI,YAAA;EnHgx1CN;EmH7w1CE;IACI,YAAA;EnH+w1CN;AACF;AmH5w1CA;EACI;IACI,UAAA;EnH8w1CN;EmH3w1CE;IACI,eAAA;IACA,iBAAA;EnH6w1CN;EmH1w1CE;IACI,eAAA;IACA,mBAAA;IACA,gBAAA;IACA,kBAAA;EnH4w1CN;EmHrw1CU;IACI,eAAA;IACA,gBAAA;IACA,qBAAA;IACA,kBAAA;EnHuw1Cd;AACF;AmHlw1CA;EAEQ;IACI,YAAA;EnHmw1CV;EmHhw1CM;IACI,YAAA;EnHkw1CV;AACF;AoHnl2CI;EACI,mBAAA;EACA,eAAA;ApHql2CR;AoHnl2CQ;EACI,iCAAA;ApHql2CZ;AoHjl2CY;EACI,+CAAA;EACA,uCAAA;EACA,8DAAA;EACA,sDAAA;ApHml2ChB;AoH/k2CQ;EACI,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;ApHil2CZ;AoH7k2CY;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;ApH+k2ChB;AoH5k2CY;EACI,iBAAA;ApH8k2ChB;AoH1k2CQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;ApH4k2CZ;AoH1k2CY;EACI,eAAA;EACA,WAAA;ApH4k2ChB;AoHvk2CI;EACI,aAAA;EACA,eAAA;EACA,2BAAA;EACA,gBAAA;EACA,wBAAA,EAAA,0BAAA;EACA,qBAAA,EAAA,YAAA;EACA,8BAAA;ApHyk2CR;AoHvk2CQ;EACI,aAAA,EAAA,sBAAA;ApHyk2CZ;AoHtk2CQ;EACI,gBAAA;EACA,SAAA;ApHwk2CZ;AoHtk2CY;EACI,iBAAA;EACA,gBAAA;ApHwk2ChB;AoHtk2CgB;EACI;IACI,eAAA;IACA,MAAA;IACA,OAAA;IACA,YAAA;IACA,aAAA;EpHwk2CtB;AACF;AoHrk2CgB;EACI,iBAAA;EACA,oCAAA;EACA,eAAA;EACA,c/GvEX;E+GwEW,eAAA;EACA,cAAA;ApHuk2CpB;AoHlk2CQ;EACI,mBAAA;EACA,oBAAA;ApHok2CZ;AoHjk2CQ;EACI,aAAA;EACA,yBAAA;ApHmk2CZ;AoHjk2CY;EACI,gBAAA;EACA,YAAA;ApHmk2ChB;AoHhk2CY;EACI,gBAAA;EACA,sBAAA;ApHkk2ChB;AoH9j2CQ;EAEI;IACI,aA5HQ;IA6HR,eAAA;IACA,mCAAA;EpH+j2Cd;EoH7j2Cc;IACI,aAlIM;IAmIN,iBAnIM;IAoIN,iBAAA;IACA,mBAAA;EpH+j2ClB;EoH3j2CU;IACI,sBAAA;EpH6j2Cd;AACF;;AqHxs2CC;EACG,kBAAA;EACA,gBAAA;ArH2s2CJ;AqHzs2CI;EACI,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,4BAAA;EACA,YAAA;EACA,+BAAA;ArH2s2CR;AqHxs2CI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;ArH0s2CR;;AqHts2CA;EACI,aAAA;ArHys2CJ;AqHvs2CI;EACI,WAAA;EACA,gBAAA;EACA,aAAA;EACA,SAAA;EACA,WAAA;ArHys2CR;AyFxp2CQ;E4BzDR;IAYQ,aAAA;ErHys2CN;EqHvs2CM;IACI,YAAA;IACA,gBAAA;IACA,aAAA;ErHys2CV;AACF;AqHts2CI;EACI,kBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;ArHws2CR;AqHps2CQ;EACI,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;ArHss2CZ;AyF/q2CQ;E4B3BA;IAOQ,kBAAA;ErHus2Cd;AACF;AqHps2CQ;EACI,sBAAA;EACA,4BAAA;EACA,6BAAA;EACA,aAAA;EACA,aAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;ArHss2CZ;AqHps2CY;EACI,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;ArHss2ChB;AqHns2CY;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;ArHqs2ChB;AqHls2CY;EACI,aAAA;EACA,mBAAA;ArHos2ChB;AqHls2CgB;EACI,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,uBAAA;ArHos2CpB;AyFvs2CQ;E4BFQ;IAQQ,MAAA;ErHqs2CtB;EqHns2CsB;IACI,cAAA;ErHqs2C1B;AACF;AqHls2CoB;EACI,WAAA;ArHos2CxB;AqHls2CwB;EACI,gBAAA;EACA,eAAA;ArHos2C5B;AqHls2C4B;EACI,cpHlGlB;EoHmGkB,iBAAA;EACA,oCAAA;EACA,oBAAA;ArHos2ChC;AqHhs2CgC;EACI,chHhGrB;ALky2Cf;AyF/t2CQ;E4BnDJ;IA0FQ,kBAAA;IACA,aAAA;IACA,cAAA;IACA,YAAA;ErH4r2CV;EqH1r2CU;IACI,eAAA;IACA,iBAAA;IACA,gBAAA;IACA,gBAAA;IACA,eAAA;ErH4r2Cd;EqHzr2CU;IACI,sBAAA;IACA,4BAAA;IACA,6BAAA;IACA,aAAA;IACA,aAAA;IACA,cAAA;IACA,cAAA;IACA,eAAA;ErH2r2Cd;EqHzr2Cc;IACI,eAAA;IACA,iBAAA;IACA,iBAAA;IACA,kBAAA;ErH2r2ClB;EqHxr2Cc;IACI,gBAAA;IACA,eAAA;ErH0r2ClB;EqHvr2Cc;IACI,eAAA;IACA,iBAAA;ErHyr2ClB;AACF;AyFtw2CQ;E4BqFQ;IACI,gBAAA;IACA,eAAA;IACA,gBAAA;ErHor2ClB;AACF;;AsHx22CI;EACI,UAAA;EACA,gBAAA;AtH222CR;AsHz22CQ;EACI,iBAAA;EACA,cAAA;AtH222CZ;AsHz22CY;EAJJ;IAKQ,mBAAA;IACA,kBAAA;EtH422Cd;AACF;AsHx22CI;EACI,kBAAA;AtH022CR;AsHx22CQ;EACI,cAAA;EACA,yBAAA;EACA,qBAAA;AtH022CZ;AsHv22CQ;EACI,cAAA;EACA,yBAAA;EACA,qBAAA;AtHy22CZ;AsHr22CI;EACI,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;AtHu22CR;AsHp22CI;EACI,cAAA;EACA,eAAA;EACA,gBAAA;AtHs22CR;AsHp22CQ;EACI,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;AtHs22CZ;AsHl22CI;EACI,gBAAA;EACA,cAAA;AtHo22CR;AsHj22CI;EACI,gBAAA;EACA,cAAA;AtHm22CR;AsH/12CQ;EACI,+BAAA;EACA,kCAAA;AtHi22CZ;AsH912CQ;EACI;IACI,WAAA;IACA,eAAA;EtHg22Cd;EsH712CU;IACI,gCAAA;IACA,mCAAA;EtH+12Cd;AACF;AsH512CQ;EACI;IACI,yBAAA;IACA,4BAAA;EtH812Cd;AACF;AsH112CQ;EACI,wBAAA;AtH412CZ;AsHx12CY;EACI,iBAAA;AtH012ChB;AsHv12CY;EACI,gBAAA;AtHy12ChB;AsHp12CI;EACI,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;AtHs12CR;;AuHj82CC;EACG,UAAA;AvHo82CJ;;AuHl82CA;EACI,cAAA;AvHq82CJ;AuHn82CI;EACI,kBAAA;EACA,yBAAA;AvHq82CR;AuHl82CI;EACI,4BAAA;AvHo82CR;AuHl82CQ;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AvHo82CZ;AuHj82CQ;EACI,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AvHm82CZ;AuHh82CQ;EACI,WAAA;AvHk82CZ;;AuH972CA;EACI;IACI,WAAA;EvHi82CN;EuH/72CE;IACI,cAAA;EvHi82CN;EuH/72CM;IACI,4BAAA;IACA,6BAAA;EvHi82CV;EuH972CM;IACI,eAAA;IACA,SAAA;IACA,WAAA;IACA,UAAA;IACA,SAAA;IACA,WAAA;IACA,SAAA;EvHg82CV;EuH772CE;IACI,kBAAA;IACA,iCAAA;EvH+72CN;AACF;AuH572CA;EACI;IACI,cAAA;IACA,UAAA;EvH872CN;EuH372CE;IACI,SAAA;IACA,UAAA;EvH672CN;AACF;AwHpg3CC;EACG,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA,EAAA,gDAAA;AxHsg3CJ;;AwHng3CA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;AxHsg3CJ;;AyHph3CC;EACG,eAAA;AzHuh3CJ;;A0Hxh3CC;EACG,YAAA;A1H2h3CJ;A0Hzh3CI;EACI,6BAAA;EACA,YAAA;EACA,iBAAA;A1H2h3CR;A0Hzh3CQ;EACI,cAAA;A1H2h3CZ;A0Hvh3CI;EACI,iBAAA;A1Hyh3CR;A0Hvh3CQ;EACI,eAAA;EACA,kBAAA;EACA,mBAAA;A1Hyh3CZ;;A2Hti3CI;EACI,aAAA;EACA,eAAA;EACA,2BAAA;EACA,gBAAA;A3Hyi3CR;A2Hvi3CQ;EACI,gBAAA;EACA,SAAA;A3Hyi3CZ;A2Hvi3CY;EACI,iBAAA;EACA,gBAAA;A3Hyi3ChB;A2Hvi3CgB;EACI;IACI,eAAA;IACA,MAAA;IACA,OAAA;IACA,YAAA;IACA,aAAA;E3Hyi3CtB;AACF;A2Hti3CgB;EACI,iBAAA;EACA,oCAAA;EACA,eAAA;EACA,ctHVX;EsHWW,eAAA;EACA,cAAA;A3Hwi3CpB;A2Hni3CQ;EACI,mBAAA;EACA,oBAAA;A3Hqi3CZ;A2Hli3CQ;EACI,aAAA;A3Hoi3CZ;A2Hli3CY;EACI,aAAA;EACA,SAAA;EACA,uBAAA;A3Hoi3ChB;A2Hhi3CQ;EAEI;IACI,6BAxDW;IAyDX,mBAAA;E3Hii3Cd;E2H/h3Cc;IACI,8BA7DQ;IA8DR,mBAAA;E3Hii3ClB;E2H7h3CU;IACI,sBAAA;E3H+h3Cd;E2H7h3Cc;IACI,0BAAA;IACA,mCAAA;E3H+h3ClB;AACF;;A4Htm3CI;EACI,kBAAA;A5Hym3CR;A4Htm3CI;EACI,gBAAA;A5Hwm3CR;A4Htm3CQ;;EAEI,aAAA;A5Hwm3CZ;A4Hrm3CQ;EACI,yBAAA;EACA,WAAA;EACA,kBAAA,EAAA,8BAAA;EACA,mBAAA;A5Hum3CZ;A4Hpm3CQ;EACI,UAAA;EACA,gBAAA;A5Hsm3CZ;A4Hnm3CQ;;EAEI,YAAA;EACA,kCAAA;A5Hqm3CZ;A4Hlm3CQ;EACI,qB3H9BG;E2H+BH,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;A5Hom3CZ;A4H/l3CY;EACI,sBAAA;EACA,kBAAA;A5Him3ChB;A4H/l3CgB;EACI,0BAAA;A5Him3CpB;A4H1l3CY;EACI,sBAAA;EACA,kBAAA;A5H4l3ChB;A4H1l3CgB;EACI,wBAAA;A5H4l3CpB;A4Htl3CY;EACI,YAAA;A5Hwl3ChB;A4Hnl3CY;EACI,YAAA;EACA,iBAAA;A5Hql3ChB;A4Hll3CY;;EAEI,YAAA;EACA,iBAAA;EACA,WAAA;A5Hol3ChB;A4Hjl3CY;EACI,yBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;A5Hml3ChB;A4Hhl3CY;EACI,kBAAA;EACA,UAAA;EACA,WAAA;A5Hkl3ChB;A4Hhl3CgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;A5Hkl3CpB;A4Hhl3CoB;EACI,SAAA;A5Hkl3CxB;A4H7k3CY;EACI,iBAAA;EACA,wBAAA;EACA,WAAA;A5H+k3ChB;A4H7k3CgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;A5H+k3CpB;A4H7k3CoB;EACI,UAAA;A5H+k3CxB;A4Hxk3CgB;EACI,aAAA;A5H0k3CpB;A4Hxk3CoB;EACI,YAAA;A5H0k3CxB;A4Hxk3CwB;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;A5H0k3C5B;A4Htk3CoB;EACI,iBAAA;A5Hwk3CxB;A4Hpk3C4B;EACI,iBAAA;A5Hsk3ChC;A4Hlk3CwB;EACI,gBAAA;A5Hok3C5B;A4H9j3CY;EACI,WAAA;EACA,WAAA;A5Hgk3ChB;A4H7j3CY;EACI,WAAA;EACA,UAAA;A5H+j3ChB;AyF1p3CQ;EmCgGI;IACI,YAAA;IACA,iBAAA;E5H6j3Cd;E4H1j3CU;;IAEI,YAAA;IACA,iBAAA;IACA,WAAA;E5H4j3Cd;E4Hzj3CU;IACI,yBAAA;IACA,YAAA;IACA,WAAA;IACA,SAAA;E5H2j3Cd;E4Hxj3CU;IACI,kBAAA;IACA,UAAA;IACA,WAAA;E5H0j3Cd;E4Hxj3Cc;IACI,WAAA;IACA,YAAA;IACA,kBAAA;IACA,QAAA;E5H0j3ClB;E4Hxj3CkB;IACI,SAAA;E5H0j3CtB;E4Hrj3CU;IACI,iBAAA;IACA,wBAAA;IACA,WAAA;E5Huj3Cd;E4Hrj3Cc;IACI,WAAA;IACA,YAAA;IACA,kBAAA;IACA,OAAA;E5Huj3ClB;E4Hrj3CkB;IACI,UAAA;E5Huj3CtB;E4Hlj3CU;IACI,WAAA;IACA,UAAA;E5Hoj3Cd;E4Hlj3Cc;IACI,WAAA;IACA,WAAA;E5Hoj3ClB;E4Hhj3CU;IACI,UAAA;IACA,UAAA;E5Hkj3Cd;E4Hhj3Cc;IACI,WAAA;IACA,UAAA;E5Hkj3ClB;E4H5i3Cc;IACI,aAAA;E5H8i3ClB;E4H5i3CkB;IACI,YAAA;E5H8i3CtB;E4H3i3CkB;IACI,iBAAA;E5H6i3CtB;E4H3i3CsB;IACI,gBAAA;E5H6i3C1B;AACF;AyFrt3CQ;EmCgLI;IACI,YAAA;IACA,iBAAA;E5Hwi3Cd;E4Hri3CU;;IAEI,YAAA;IACA,WAAA;E5Hui3Cd;E4Hpi3CU;IACI,yBAAA;IACA,YAAA;IACA,WAAA;IACA,SAAA;E5Hsi3Cd;E4Hni3CU;IACI,kBAAA;IACA,UAAA;IACA,WAAA;E5Hqi3Cd;E4Hni3Cc;IACI,WAAA;IACA,YAAA;IACA,kBAAA;IACA,YAAA;E5Hqi3ClB;E4Hni3CkB;IACI,SAAA;E5Hqi3CtB;E4Hhi3CU;IACI,iBAAA;IACA,WAAA;IACA,WAAA;E5Hki3Cd;E4Hhi3Cc;IACI,WAAA;IACA,YAAA;IACA,kBAAA;IACA,WAAA;E5Hki3ClB;E4Hhi3CkB;IACI,UAAA;E5Hki3CtB;E4H3h3Cc;IACI,YAAA;IACA,qBAAA;E5H6h3ClB;E4H3h3CkB;IACI,YAAA;E5H6h3CtB;E4H3h3CsB;IACI,SAAA;E5H6h3C1B;E4Hzh3CkB;IACI,iBAAA;IACA,iBAAA;IACA,0BAAA;IACA,8BAAA;IACA,cAAA;E5H2h3CtB;E4Hzh3CsB;IACI,gBAAA;E5H2h3C1B;E4Hrh3CU;IACI,WAAA;IACA,WAAA;E5Huh3Cd;E4Hph3CkB;IACI,aAAA;E5Hsh3CtB;E4Hph3CsB;IACI,YAAA;IACA,WAAA;E5Hsh3C1B;E4Hnh3CsB;IACI,SAAA;E5Hqh3C1B;E4H/g3CU;IACI,WAAA;IACA,OAAA;E5Hih3Cd;AACF;AyFxy3CQ;EmC4RI;IACI,UAAA;IACA,WAAA;E5H+g3Cd;E4H5g3CU;IACI,WAAA;IACA,WAAA;E5H8g3Cd;E4Hzg3Cc;IACI,YAAA;E5H2g3ClB;E4Hzg3CkB;IACI,YAAA;E5H2g3CtB;E4Hxg3CkB;IACI,iBAAA;IACA,iBAAA;IACA,0BAAA;IACA,8BAAA;IACA,cAAA;E5H0g3CtB;E4Hxg3CsB;IACI,gBAAA;E5H0g3C1B;E4Hhg3CkB;IACI,aAAA;E5Hkg3CtB;E4Hhg3CsB;IACI,YAAA;IACA,UAAA;E5Hkg3C1B;E4H//2CsB;IACI,SAAA;E5Hig3C1B;AACF;A4H3/2CQ;;EAEI,yCAAA;EACA,iCAAA;A5H6/2CZ;A4H1/2CQ;;EAEI,0CAAA;EACA,kCAAA;A5H4/2CZ;;A4Hv/2CA;EACI,aAAA;EACA,eAAA;EACA,sBAAA;EACA,0BAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;A5H0/2CJ;A4Hx/2CI;EACI,kBAAA;EACA,mBAAA;EACA,iBAAA;A5H0/2CR;A4Hx/2CQ;EACI,iBAAA;A5H0/2CZ;;A4Hr/2CA;EACI,gBAAA;EACA,QAAA;A5Hw/2CJ;;A6H183CC;EACG,eAAA;EACA,kBAAA;EACA,eAAA;A7H683CJ;;A6H183CA;EACI,kBAAA;EACA,gBAAA;A7H683CJ;;A6H183CA;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;EACA,oBAAA;EACA,2DAAA;EACA,4EAAA;A7H683CJ;;A6H383CA;EACI,SAAA;EACA,yBAAA;A7H883CJ;;A6H383CA;EACI,WAAA;A7H883CJ;A6H583CI;EACI,gBAAA;A7H883CR;A6H383CI;EACI,mBAAA;A7H683CR;;A8H3+3CA;EACI,gBAL0B;EAM1B,iBAP4B;EAQ5B,mBAAA;EACA,sBAAA;A9H8+3CJ;AyF163CQ;EqCxER;IAOQ,kBAAA;E9H++3CN;AACF;AyF/63CQ;EqCxER;IAWQ,kBAAA;E9Hg/3CN;AACF;A8H9+3CI;EAdJ;IAeQ,6BAAA;IACA,+BAAA;E9Hi/3CN;AACF;;A8H/+3CA;EACI,wBAAA,EAAA,0BAAA;EACA,qBAAA,EAAA,YAAA;EACA,8BAAA;A9Hk/3CJ;;A8H/+3CA;EACI,aAAA,EAAA,sBAAA;A9Hk/3CJ;;A8H/+3CA;EACI,WAAA;EACA,+BAAA;EACA,cAAA;EACA,kBAAA;A9Hk/3CJ;;A8H/+3CA;EACI,4BAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;A9Hk/3CJ;;A8H/+3CA;EACI,eAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kCAAA;EACA,wBAAA;EACA,sBAAA;A9Hk/3CJ;;A8H/+3CA;EACI,UAAA;A9Hk/3CJ;;A8H/+3CA;EACI,+BAAA;EACA,kBAAA;A9Hk/3CJ;A8Hh/3CI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;A9Hk/3CR;AyF/+3CQ;EqCCA;IACI,eAAA;IACA,iBAAA;E9Hi/3CV;AACF;AyFr/3CQ;EqCQA;IACI,eAAA;IACA,iBAAA;E9Hg/3CV;AACF;A8H7+3CI;EAEI,4BAAA;EACA,kCAAA;EACA,sBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;A9H8+3CR;A8H7+3CQ;EACI,UAAA;EACA,mBAAA;A9H++3CZ;A8H7+3CY;EACI,mBAAA;A9H++3ChB;A8H5+3CY;EACI,4BAAA;EACA,+BAAA;A9H8+3ChB;A8H3+3CY;EACI,sBAAA;A9H6+3ChB;AyFjh4CQ;EqCwCQ;IACI,iBAAA;E9H4+3ClB;E8Hz+3Cc;IACI,8BAAA;IACA,iCAAA;E9H2+3ClB;E8Hx+3Cc;IACI,oBAAA;E9H0+3ClB;AACF;AyF7h4CQ;EqCuDQ;IACI,iBAAA;E9Hy+3ClB;E8Ht+3Cc;IACI,4BAAA;IACA,+BAAA;E9Hw+3ClB;E8Hr+3Cc;IACI,oBAAA;E9Hu+3ClB;AACF;A8Hp+3CY;EACI,4BAAA;EACA,6BAAA;A9Hs+3ChB;A8Hn+3CY;EACI,+BAAA;EACA,gCAAA;A9Hq+3ChB;A8H/93CY;EACI,iBAAA;EACA,oCAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,gBAAA;A9Hi+3ChB;A8H793CQ;EACI,aAAA;EACA,eAAA;EACA,2BAAA;EACA,gBAAA;A9H+93CZ;A8H793CY;EACI,gBAAA;EACA,SAAA;A9H+93ChB;A8H793CgB;EACI,iBAAA;EACA,gBAAA;A9H+93CpB;A8H793CoB;EACI;IACI,eAAA;IACA,MAAA;IACA,OAAA;IACA,YAAA;IACA,aAAA;E9H+93C1B;AACF;A8H593CoB;EACI,iBAAA;EACA,oCAAA;EACA,eAAA;EACA,czH/Kf;EyHgLe,eAAA;EACA,cAAA;A9H893CxB;A8Hz93CY;EACI,mBAAA;EACA,oBAAA;A9H293ChB;A8Hx93CY;EACI,aAAA;A9H093ChB;A8Hv93CY;EAEI;IACI,6BAvNW;IAwNX,gDAAA;E9Hw93ClB;E8Ht93CkB;IACI,8BA5NQ;IA6NR,mBAAA;E9Hw93CtB;E8Hp93Cc;IACI,sBAAA;E9Hs93ClB;AACF;;A+H3r4CC;EACG,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;A/H8r4CJ;;A+H3r4CA;EACI,iBAAA;EACA,WAAA;A/H8r4CJ;;A+H3r4CA;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;A/H8r4CJ;;A+H3r4CA;EACI,eAAA;A/H8r4CJ;;A+H3r4CA;EACI,OAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;A/H8r4CJ;;A+H3r4CA;EACI,gBAAA;A/H8r4CJ;;AgI5t4CC;EACG,yBAAA;EACA,0BAAA;EACA,8DAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AhI+t4CJ;;AgI5t4CA;EACI,2BAAA;EACA,8DAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AhI+t4CJ;;AgI5t4CA;EACI,+DAAA,EAAA,WAAA;EACA,uDAAA;AhI+t4CJ;;AgI5t4CA;EACI,oCAAA;AhI+t4CJ;AgI7t4CI;EACI,eAAA;AhI+t4CR;AgI7t4CQ;EACI,cAAA;EACA,cAAA;AhI+t4CZ;;AgI1t4CA;EACI,cAAA;AhI6t4CJ;;AiIlw4CC;EACG,WAAA;EACA,YAAA;EACA,kBAAA;AjIqw4CJ;AiInw4CI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AjIqw4CR;AiIlw4CI;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;AjIow4CR;;AkIxx4CC;EACG,0BAAA;AlI2x4CJ;AkIzx4CI;EACI,iBAAA;EACA,WAAA;AlI2x4CR;AkIxx4CI;EACI,iBAAA;AlI0x4CR;AkIvx4CI;EACI,iBAAA;AlIyx4CR;AkItx4CI;EACI,aAAA;AlIwx4CR;;AkIpx4CA;EACI,iBAAA;AlIux4CJ;;AkIpx4CA;EACI,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;AlIux4CJ;;AkIpx4CA;EACI,mBAAA;AlIux4CJ;AkIrx4CI;EACI,gBAAA;AlIux4CR;AkIpx4CI;EACI,mBAAA;EACA,WAAA;AlIsx4CR;AkInx4CI;EACI,0BAAA;AlIqx4CR;AkInx4CQ;EACI,yBAAA;EACA,YAAA;AlIqx4CZ;AkIjx4CI;EACI,mBAAA;AlImx4CR;;AkI/w4CA;EACI,gBAAA;AlIkx4CJ;AkIhx4CI;EACI,aAAA;AlIkx4CR;AkIhx4CQ;EACI,mBAAA;AlIkx4CZ;AkI/w4CQ;EACI,YAAA;AlIix4CZ;AkI7w4CI;EACI,kBAAA;AlI+w4CR;AkI5w4CI;EACI,YAAA;EACA,WAAA;AlI8w4CR;;AkI1w4CA;EACI,iBAAA;AlI6w4CJ;AkI5w4CI;EACI,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AlI8w4CR;AkI3w4CI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AlI6w4CR;;AmI924CA;EACI,oBAAA;EACA,oBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;AnIi34CJ;AmI/24CI;EACI,YAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;AnIi34CR;AyFly4CQ;E0C3EA;IACI,YAAA;IACA,kBAAA;IACA,SAAA;IACA,UAAA;IACA,kBAAA;IACA,mBAAA;EnIg34CV;AACF;;AmI524CA;EACI,YAAA;EACA,yB9HLW;E8HMX,WAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AnI+24CJ;;AmI724CA;EACI,WAAA;AnIg34CJ;;AmI724CA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;AnIg34CJ;;AmI724CA;EACI,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;EACA,iDAAA;EACA,oCAAA;EACA,0BAAA;EACA,0BAAA;EACA,+BAAA;EACA,kCAAA;EACA,SAAA;AnIg34CJ;;AmI724CA;EACI,wBAAA;EACA,6BAAA;EACA,gCAAA;AnIg34CJ;;AmI724CA;EACI,eAAA;EACA,SAAA;EACA,sBAAA;AnIg34CJ;;AmI724CA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,clItEU;ADs74Cd;AmI924CI;EACI,WAAA;AnIg34CR;;AmI524CA;EACI,oBAAA;EACA,oBAAA;EACA,aAAA;EACA,8BAAA;EACA,6BAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,mBlIzFmB;EkI0FnB,UAAA;EACA,2DAAA;EACA,mDAAA;EACA,UAAA;AnI+24CJ;;AmI524CA;EACI,oBAAA;EACA,oBAAA;EACA,aAAA;EACA,8BAAA;EACA,6BAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AnI+24CJ;;AmI524CA;EACI,eAAA;EACA,UAAA;EACA,OAAA;EACA,2DAAA;EACA,mDAAA;AnI+24CJ;;AmI524CA;EACI,eAAA;EACA,UAAA;EACA,OAAA;AnI+24CJ;;AmI524CA;EACI,YAAA;AnI+24CJ;;AyF754CQ;E0CkDJ;IACI,YAAA;EnI+24CN;EmI524CE;IACI,yB9H1HO;ELw+4Cb;EmI324CE;IACI,cAAA;IACA,YAAA;IACA,yBlIzIe;IkI0If,UAAA;EnI624CN;EmI324CM;IACI,YAAA;IACA,qBAAA;IACA,eAAA;EnI624CV;AACF;AmIz24CA;EAEI;IACI,SAAA;EnI024CN;EmIv24CE;IACI,SAAA;EnIy24CN;AACF;AmIt24CA;EACI,oBAAA;EACA,oBAAA;EACA,aAAA;EACA,wBAAA;EACA,qBAAA;EACA,uBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,clI7KU;EkI8KV,iCAAA;EACA,yBAAA;EACA,eAAA;AnIw24CJ;AyF384CQ;E0CmFR;IAmBQ,eAAA;EnIy24CN;AACF;;AmIt24CA;EACI,YAAA;EACA,yB9H/KW;E8HgLX,iCAAA;EACA,yBAAA;EACA,qBAAA;AnIy24CJ;;AmIv24CA;EACI,yBAAA;AnI024CJ;AmIx24CI;EACI,iBAAA;EACA,oCAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;AnI024CR;;AmIt24CA;EACI,0BAAA;AnIy24CJ;AmIv24CI;EACI,iBAAA;EACA,WAAA;AnIy24CR;AmIt24CI;EACI,iBAAA;AnIw24CR;AmIr24CI;EACI,iBAAA;AnIu24CR;AmIp24CI;EACI,aAAA;AnIs24CR;;AmIl24CA;EACI,iBAAA;AnIq24CJ;;AmIl24CA;EACI,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;AnIq24CJ;;AmIl24CA;EACI,mBAAA;AnIq24CJ;AmIn24CI;EACI,gBAAA;AnIq24CR;AmIl24CI;EACI,mBAAA;EACA,WAAA;AnIo24CR;AmIj24CI;EACI,0BAAA;AnIm24CR;AmIj24CQ;EACI,yBAAA;EACA,YAAA;AnIm24CZ;AmI/14CI;EACI,mBAAA;AnIi24CR;;AmI714CA;EACI,gBAAA;AnIg24CJ;AmI914CI;EACI,aAAA;AnIg24CR;AmI914CQ;EACI,mBAAA;AnIg24CZ;AmI714CQ;EACI,YAAA;AnI+14CZ;AmI314CI;EACI,kBAAA;AnI614CR;AmI114CI;EACI,YAAA;EACA,WAAA;AnI414CR;;AmIz14CA;EACI,iCAAA;EACA,yBAAA;EACA,UAAA;AnI414CJ;;AmI114CA;EACI,UAAA;AnI614CJ;;AyFlk5CQ;E0CyOJ;IACI,+BAAA;IACA,oBAAA;EnI614CN;EmI114CE;IACI,mBAAA;EnI414CN;AACF;AyF7j5CQ;E0CoOJ;IACI,gBAAA;IACA,cAAA;EnI414CN;AACF;AmIz14CA;EACI,yBAAA;EACA,WAAA;AnI214CJ;AmIz14CI;EACI,gCAAA;EACA,iBAAA;AnI214CR;AmI114CQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;AnI414CZ;AmIx14CI;EACI,WAAA;AnI014CR;;AmIv14CA;EACI,yBAAA;AnI014CJ;AmIv14CQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;AnIy14CZ;AmIt14CQ;EACI,clIpVE;EkIqVF,gBAAA;EACA,eAAA;AnIw14CZ;AmIr14CgB;EACI,c9HhVL;ALuq5Cf;;AmIj14CA;EACI,yBAAA;AnIo14CJ;AmIj14CQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;AnIm14CZ;AmIh14CQ;EACI,clI3WE;EkI4WF,gBAAA;EACA,eAAA;AnIk14CZ;AmI/04CgB;EACI,c9HvWL;ALwr5Cf;;AmI104CA;EACI,sBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AnI604CJ;;AmI104CA;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,qBAAA;AnI604CJ;;AmI304CA;EACI,gBAAA;EACA,0BAAA;AnI804CJ;;AyFvp5CQ;E0C4UJ;IACI,qBAAA;EnI+04CN;AACF;AmI504CA;EACI,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AnI804CJ;;AoIhv5CA;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,sBAAA;ApImv5CJ;AoIjv5CI;EACI,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,+BAAA;EACA,cAAA;ApImv5CR;AoIjv5CQ;EACI,WAAA;ApImv5CZ;AoI/u5CI;EACI,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;ApIiv5CR;;AoI9u5CA;EACI,oBAAA;EACA,oBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;ApIiv5CJ;AoI/u5CI;EACI,YAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;ApIiv5CR;AyFns5CQ;E2C1CA;IACI,YAAA;IACA,kBAAA;IACA,SAAA;IACA,UAAA;IACA,kBAAA;IACA,mBAAA;EpIgv5CV;AACF;AoI7u5CI;EACI,YAAA;EACA,yB/HrCO;E+HsCP,WAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;ApI+u5CR;AoI5u5CI;EACI,WAAA;ApI8u5CR;AoI3u5CI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;ApI6u5CR;AoI1u5CI;EACI,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;EACA,iDAAA;EACA,oCAAA;EACA,0BAAA;EACA,0BAAA;EACA,+BAAA;EACA,kCAAA;EACA,SAAA;ApI4u5CR;AoIzu5CI;EACI,wBAAA;EACA,6BAAA;EACA,gCAAA;ApI2u5CR;AoIxu5CI;EACI,eAAA;EACA,SAAA;EACA,sBAAA;ApI0u5CR;AoIvu5CI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cnIvGM;ADg15Cd;AoIvu5CQ;EACI,WAAA;ApIyu5CZ;AoIru5CI;EACI,oBAAA;EACA,oBAAA;EACA,aAAA;EACA,8BAAA;EACA,6BAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,mBnI1He;EmI2Hf,UAAA;EACA,2DAAA;EACA,mDAAA;EACA,UAAA;ApIuu5CR;AoIpu5CI;EACI,oBAAA;EACA,oBAAA;EACA,aAAA;EACA,8BAAA;EACA,6BAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;ApIsu5CR;AoInu5CI;EACI,eAAA;EACA,UAAA;EACA,OAAA;EACA,2DAAA;EACA,mDAAA;ApIqu5CR;AoIlu5CI;EACI,eAAA;EACA,UAAA;EACA,OAAA;ApIou5CR;AoIju5CI;EACI,YAAA;ApImu5CR;AyFlz5CQ;E2CoFA;IACI,YAAA;EpIiu5CV;EoI9t5CM;IACI,yB/H5JG;EL435Cb;EoI7t5CM;IACI,cAAA;IACA,YAAA;IACA,yBnI3KW;ImI4KX,UAAA;EpI+t5CV;EoI7t5CU;IACI,YAAA;IACA,qBAAA;IACA,eAAA;EpI+t5Cd;AACF;AoI3t5CI;EAEI;IACI,SAAA;EpI4t5CV;EoIzt5CM;IACI,SAAA;EpI2t5CV;AACF;AoIxt5CI;EACI,oBAAA;EACA,oBAAA;EACA,aAAA;EACA,wBAAA;EACA,qBAAA;EACA,uBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,cnI/MM;EmIgNN,iCAAA;EACA,yBAAA;EACA,eAAA;ApI0t5CR;AyF/15CQ;E2CqHJ;IAmBQ,eAAA;EpI2t5CV;AACF;AoIxt5CI;EACI,YAAA;EACA,yB/HjNO;E+HkNP,iCAAA;EACA,yBAAA;EACA,qBAAA;ApI0t5CR;AoIvt5CI;EACI,yBAAA;ApIyt5CR;AoIvt5CQ;EACI,iBAAA;EACA,oCAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;ApIyt5CZ;;AoIpt5CA;EACI,iBAAA;ApIut5CJ;;AoIpt5CA;EACI,kBAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,kCAAA;EACA,0BAAA;ApIut5CJ;AoIrt5CI;EACI,8DAAA;EACA,sDAAA;ApIut5CR;;AoInt5CA;EACI,sBAAA;EACA,4BAAA;EACA,kCAAA;EACA,aAnRqB;EAoRrB,4BAAA;EACA,2BAAA;ApIst5CJ;;AoInt5CA;EACI,uBAAA;EACA,oBAAA;EACA,0BAAA;ApIst5CJ;AoIpt5CI;EACI,YAAA;ApIst5CR;AoInt5CI;EACI,WAAA;EACA,eAAA;ApIqt5CR;;AoIjt5CA;EACI;IACI,kBAAA;IACA,mBAAA;EpIot5CN;EoIlt5CM;IACI,aAAA;IACA,gBAAA;IACA,aAAA;IACA,eAAA;IACA,mBAAA;IACA,kBAAA;EpIot5CV;EoIjt5CM;IACI,sBAAA;IACA,4BAAA;IACA,kCAAA;IACA,aAAA;IACA,kBAAA;IACA,mBAAA;IACA,oBAAA;IACA,kBAAA;IACA,WAAA;IACA,mBAAA;IACA,kBAAA;EpImt5CV;EoIht5CM;IACI,YAAA;IACA,oBAAA;IACA,mBAAA;IACA,oBAAA;IACA,kBAAA;IACA,WAAA;IACA,mBAAA;EpIkt5CV;EoIht5CU;IACI,eAAA;IACA,iBAAA;IACA,gBAAA;EpIkt5Cd;EoI9s5CU;IACI,0BAAA;EpIgt5Cd;AACF;AoI3s5CA;EACI;IACI,eAAA;IACA,cAAA;EpI6s5CN;EoI1s5CU;IACI,eAAA;IACA,mBAAA;IACA,gBAAA;IACA,uBAAA;IACA,WAAA;EpI4s5Cd;AACF;AoIvs5CA;EACI;IACI,iCAAA;IACA,iBAAA;IACA,2BAAA;IACA,YAAA;EpIys5CN;EoIvs5CM;IACI,YAAA;EpIys5CV;EoIts5CM;IACI,sBAAA;IACA,kCAAA;IACA,8BAAA;IACA,2BAAA;IACA,uBAAA;IACA,YAAA;IACA,kBAAA;IACA,OAAA;IACA,MAAA;IACA,iBAAA;EpIws5CV;AACF;AoIps5CA;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;ApIss5CJ;;AoIjs5CI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;ApIos5CR;AyF9/5CQ;E2CqTJ;IAQQ,iBAAA;IACA,gBAAA;EpIqs5CV;AACF;AoIls5CI;EACI,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;ApIos5CR;AyF3g6CQ;E2CkUJ;IAQQ,iCAAA;IACA,gBAAA;EpIqs5CV;AACF;AoIls5CI;EACI,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;ApIos5CR;AyFxh6CQ;E2C+UJ;IAQQ,gBAAA;IACA,gBAAA;EpIqs5CV;AACF;AoIls5CI;EACI,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;ApIos5CR;AyFri6CQ;E2C4VJ;IAQQ,gBAAA;IACA,gBAAA;EpIqs5CV;AACF;AoIls5CI;EACI,qBAAA;ApIos5CR;AoIjs5CI;EACI,YAAA;ApIms5CR;AoIhs5CI;EACI,eAAA;ApIks5CR;AoIhs5CQ;EACI,WAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;EACA,wCAAA;EACA,qCAAA;EACA,oCAAA;EACA,mCAAA;EACA,gCAAA;ApIks5CZ;AoI/r5CQ;EACI,aAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;EACA,yCAAA;ApIis5CZ;AoI7r5CI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;ApI+r5CR;AoI5r5CI;EACI,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;ApI8r5CR;AoI1r5CQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ApI4r5CZ;AoIvr5CQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;ApIyr5CZ;;AoIpr5CA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,6BAAA;EACA,6BAAA;EACA,gBAAA;ApIur5CJ;AoIrr5CI;EACI,gBAAA;ApIur5CR;AoInr5CQ;EACI,aAAA;ApIqr5CZ;;AoIhr5CA;EACI,gBAAA;ApImr5CJ;;AoIhr5CA;EACI,uBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,2BAAA;ApImr5CJ;AoIjr5CI;EACI,aAAA;ApImr5CR;;AoI/q5CA;EACI,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;ApIkr5CJ;AyF7p6CQ;E2CueR;IAOQ,YAAA;EpImr5CN;AACF;AoIjr5CI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,WAAA;ApImr5CR;AoIhr5CI;EACI,kBAAA;ApIkr5CR;AoIhr5CQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;ApIkr5CZ;;AoI7q5CA;EACI,wDAAA;EACA,gDAAA;EACA,wBAAA;EACA,2CAAA;EACA,kBAAA;EACA,UAAA;ApIgr5CJ;;AoI7q5CA;EACI,WAAA;EACA,sBAAA;EACA,kBAAA;ApIgr5CJ;AoI9q5CI;EACI,YAAA;EACA,eAAA;EACA,SAAA;EACA,wCAAA;EACA,gBAAA;ApIgr5CR;AoI9q5CQ;EACI,cAAA;ApIgr5CZ;AoI/q5CY;EACI,gBAAA;EACA,eAAA;ApIir5ChB;AoI7q5CQ;EACI,sBAAA;ApI+q5CZ;AoI7q5CY;EACI,yBAAA;ApI+q5ChB;AoI3q5CQ;EACI,sBAAA;EACA,kCAAA;EACA,4BAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;ApI6q5CZ;AoI1q5CQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;ApI4q5CZ;AoIxq5CI;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,SAAA;EACA,uBAAA;ApI0q5CR;AoIxq5CQ;EACI,YAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;ApI0q5CZ;AoIxq5CY;EACI,yBAAA;ApI0q5ChB;AoIvq5CY;EACI,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;ApIyq5ChB;;AoInq5CA;EACI,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kCAAA;ApIsq5CJ;;AoInq5CA;EACI,aAAA;ApIsq5CJ;AyF7w6CQ;E2CsmBR;IAIQ,aAAA;EpIuq5CN;AACF;AoIrq5CI;EACI,kBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;ApIuq5CR;AoIrq5CQ;EACI,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;ApIuq5CZ;AoIpq5CQ;EACI,sBAAA;EACA,4BAAA;EACA,6BAAA;EACA,aAAA;EACA,aAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;ApIsq5CZ;AyF3x6CQ;E2C8lBJ;IA2BQ,kBAAA;IACA,aAAA;IACA,cAAA;IACA,YAAA;EpIsq5CV;EoIpq5CU;IACI,eAAA;IACA,iBAAA;IACA,gBAAA;IACA,gBAAA;EpIsq5Cd;EoInq5CU;IACI,sBAAA;IACA,4BAAA;IACA,6BAAA;IACA,YAAA;IACA,aAAA;IACA,cAAA;IACA,cAAA;IACA,eAAA;EpIqq5Cd;AACF;;AyFnz6CQ;E2CmpBR;IAEQ,UAAA;EpImq5CN;AACF;;AoIhq5CA;EACI,gBAAA;EACA,oBAAA;ApImq5CJ;AyF9z6CQ;E2CypBR;IAKQ,mBAAA;EpIoq5CN;AACF;AoIlq5CI;EACI,yBAAA;EACA,kBAAA;ApIoq5CR;AoIlq5CQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;ApIoq5CZ;AoIjq5CQ;EACI,qBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;EACA,iDAAA;EACA,oCAAA;EACA,0BAAA;ApImq5CZ;AoIhq5CQ;EACI,0BAAA;EACA,+BAAA;EACA,kCAAA;ApIkq5CZ;AoI/p5CQ;EACI,wBAAA;EACA,6BAAA;EACA,gCAAA;ApIiq5CZ;AoI7p5CI;EACI,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;ApI+p5CR;AoI7p5CQ;EACI,gBAAA;ApI+p5CZ;;AqIz86CA;EACI,mBAAA;ArI486CJ;;AqIz86CA;EACI,mBAAA;ArI486CJ;;AsI/86CI;EACI,YAAA;AtIk96CR;AsIh96CQ;EAHJ;IAIQ,aAAA;EtIm96CV;AACF;AsIj96CQ;EAPJ;IAQQ,aAAA;EtIo96CV;AACF;AsIl96CQ;EAXJ;IAYQ,aAAA;EtIq96CV;AACF;AsIn96CQ;EACI,YAAA;AtIq96CZ;AsIj96CI;EACI,yBAAA;EACA,aAAA;AtIm96CR;AsIj96CQ;EACI,eAAA;EACA,iBAAA;AtIm96CZ;AsIh96CQ;EACI,eAAA;EACA,YAAA;AtIk96CZ;AsI/86CQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;AtIi96CZ;AsI786CI;EACI,yBAAA;EACA,aAAA;AtI+86CR;AsI786CQ;EACI,eAAA;EACA,iBAAA;AtI+86CZ;AsI586CQ;EACI,eAAA;EACA,YAAA;AtI886CZ;AsI386CQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;AtI686CZ;;AuIpg7CA;EACI,iBAAA;EACA,cAAA;AvIug7CJ;;AuIpg7CA;EACI,YAAA;AvIug7CJ;;AuIpg7CA;EACI,ctIVY;EsIWZ,sBtIHU;AD0g7Cd;;AuIpg7CA;EACI,WtIPU;EsIQV,yBtIhBY;ADuh7ChB;;AuIpg7CA;EACI,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,sBAAA;EACA,ctIbY;EsIcZ,yBtIbS;EsIcT,qBtIba;ADoh7CjB;;AuIpg7CA;EACI,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;AvIug7CJ;;AuIpg7CA;EACI,eAAA;AvIug7CJ;;AyFr+6CQ;E8C7BA;IACI,YAAA;IACA,kBAAA;IACA,SAAA;IACA,UAAA;IACA,kBAAA;IACA,mBAAA;EvIsg7CV;EuIng7CM;IAKI,WAAA;IACA,mBAAA;IACA,kBAAA;IACA,kBAAA;IACA,iBAAA;EvIig7CV;AACF;AyFv/6CQ;E8CpBA;IAEQ,iBAAA;EvI6g7Cd;AACF;AyF5/6CQ;E8CRA;IAKI,WAAA;IACA,kBAAA;IACA,iBAAA;EvImg7CV;AACF;AyFng7CQ;E8CRA;IAEQ,iBAAA;EvI6g7Cd;AACF;AuIpg7CA;EACI,eAAA;AvIsg7CJ;AyF3g7CQ;E8CIR;IAIQ,eAAA;EvIug7CN;AACF;AyFhh7CQ;E8CIR;IAQQ,eAAA;EvIwg7CN;AACF;AyFrh7CQ;E8CIR;IAYQ,eAAA;EvIyg7CN;AACF;;AuItg7CA;EACI,oCAAA;EACA,gCAAA;EACA,sBAAA;AvIyg7CJ;AuIvg7CI;EACI,yBlI9EO;EkI+EP,qBlI/EO;ALwl7Cf;AuItg7CI;EACI,yBAAA;EACA,qBAAA;EACA,sCAAA;AvIwg7CR;AuIrg7CI;EACI,yBAAA;EACA,qBAAA;AvIug7CR;AuIpg7CI;;;EAEI,yBtIzGM;EsI0GN,qBtI1GM;ADin7Cd;AuIpg7CI;EAEI,sCAAA;AvIqg7CR;;AuIjg7CA;EACI,ctIpHU;EsIqHV,qBtIrHU;ADyn7Cd;AuIlg7CI;EACI,WAAA;EACA,yBtIzHM;EsI0HN,qBtI1HM;AD8n7Cd;AuIjg7CI;EACI,WAAA;EACA,yBtI/HM;EsIgIN,qBtIhIM;ADmo7Cd;AuIhg7CI;EACI,WAAA;EACA,yBAAA;EACA,qBAAA;AvIkg7CR;AuI//6CI;EAEI,yBtI3IM;EsI4IN,qBtI5IM;AD4o7Cd;AuI7/6CI;EAEI,sCAAA;AvI8/6CR;;AuIz/6CI;EACI,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;AvI4/6CR;AuI1/6CQ;EACI,iBAAA;AvI4/6CZ;;AuIx/6CA;EACI,cAAA;AvI2/6CJ;;AuIx/6CI;EACI,kBAAA;EACA,qBAAA;EACA,oBAAA;AvI2/6CR;;AuIv/6CA;EACI,qBAAA;EACA,UAAA;EACA,oCAAA;EACA,+BAAA;EACA,4BAAA;AvI0/6CJ;;AuIv/6CA;EACI,UAAA;EACA,mBAAA;AvI0/6CJ;;AuIv/6CA;EACI,qBAAA;AvI0/6CJ;;AuIr/6CQ;EACI,ctIhME;EsIiMF,sBAAA;AvIw/6CZ;AuIt/6CY;EACI,kBAAA;EACA,iBAAA;EACA,oCAAA;EACA,oBAAA;EACA,clI9LD;EkI+LC,WAAA;AvIw/6ChB;AuIr/6CY;EACI,ctI7MF;ADos7Cd;AuIl/6CI;EACI,ctInNM;ADus7Cd;AuIl/6CQ;EACI,cAAA;EACA,iBAAA;EACA,oCAAA;EACA,oBAAA;EACA,clIhNG;ALos7Cf;AuIj/6CQ;EACI,ctI9NE;ADit7Cd;AuIh/6CQ;EACI,WAAA;AvIk/6CZ;;AuI5+6CA;EACI,mBAAA;EACA,sBAAA;AvI++6CJ;;AuI5+6CA;EACI,iBAAA;EACA,sBAAA;AvI++6CJ;;AuI5+6CA;EACI,oBAAA;EACA,sBAAA;AvI++6CJ;;AuI5+6CA;EACI,oBAAA;EACA,sBAAA;AvI++6CJ;;AuI5+6CA;EACI,iBAAA;AvI++6CJ;;AuI5+6CA;EACI,iBAAA;EACA,sBAAA;AvI++6CJ;;AuI5+6CA;EACI,iBAAA;EACA,sBAAA;AvI++6CJ;;AuI5+6CA;EACI,iBAAA;EACA,sBAAA;AvI++6CJ;;AuI5+6CA;EACI,oBAAA;EACA,sBAAA;AvI++6CJ;;AyFnr7CQ;E8CwMJ;IACI,mBAAA;EvI++6CN;EuI5+6CE;IACI,oBAAA;EvI8+6CN;EuI3+6CE;IACI,iBAAA;EvI6+6CN;EuI1+6CE;IACI,iBAAA;EvI4+6CN;EuIz+6CE;IACI,oBAAA;EvI2+6CN;EuIx+6CE;IACI,qBAAA;EvI0+6CN;EuIv+6CE;IACI,gBAAA;EvIy+6CN;EuIt+6CE;IACI,gBAAA;EvIw+6CN;EuIr+6CE;IACI,gBAAA;EvIu+6CN;AACF;AuIp+6CA;EACI,eAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,0CAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yCAAA;EACA,eAAA;EACA,mBAAA;EACA,iFAAA;AvIs+6CJ;AuIp+6CI;EACI,kBAAA;EACA,iBAAA;EACA,oCAAA;EACA,qBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;AvIs+6CR;AuIn+6CI;EACI,sCAAA;EACA,4CAAA;AvIq+6CR;AuIn+6CQ;EACI,WAAA;AvIq+6CZ;AuIj+6CI;EACI,UAAA;EACA,YAAA;EACA,YAAA;EACA,oCAAA;AvIm+6CR;AuIj+6CQ;EACI,iBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;AvIm+6CZ;AuI/96CI;EACI,cAAA;EACA,YAAA;EACA,WAAA;AvIi+6CR;;AyFlw7CQ;E8CsSJ;IACI,eAAA;IACA,YAAA;IACA,QAAA;IACA,WAAA;IACA,6BAAA;IACA,WAAA;IACA,YAAA;IACA,gBAAA;IACA,eAAA;IACA,mBAAA;IACA,iFAAA;EvIg+6CN;EuI996CM;IACI,kBAAA;IACA,iBAAA;IACA,oCAAA;IACA,qBAAA;IACA,cAAA;IACA,QAAA;IACA,WAAA;IACA,eAAA;EvIg+6CV;EuI796CM;IACI,iCAAA;IACA,gBAAA;EvI+96CV;EuI796CU;IACI,WAAA;EvI+96Cd;EuIz96CU;IACI,WAAA;EvI296Cd;AACF;AuIt96CA;EACI,yBAAA;EACA,eAAA;AvIw96CJ;AuIt96CI;EACI,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,UAAA;AvIw96CR;AuIt96CQ;EACI,eAAA;EACA,iBAAA;EACA,iBAAA;AvIw96CZ;AuIr96CQ;EACI,qBAAA;EACA,gDAAA;AvIu96CZ;AuIp96CQ;EACI,eAAA;AvIs96CZ;;AuIh96CI;EACI,gBAAA;AvIm96CR;AuIh96CI;EACI,yBAAA;AvIk96CR;AuIh96CQ;EACI,mBAAA;EACA,eAAA;EACA,iBAAA;AvIk96CZ;AuI/86CQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AvIi96CZ;AuI786CI;EACI,aAAA;AvI+86CR;AuI786CQ;EACI,YAAA;EACA,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;AvI+86CZ;AuI386CI;EACI,gBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;AvI686CR;AuI386CQ;EACI,qBAAA;AvI686CZ;AuIz86CI;EACI,eAAA;AvI286CR;AuIx86CI;EACI,yBAAA;EACA,gBAAA;EACA,wBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;AvI086CR;AuIv86CI;EACI,iBAAA;EACA,cAAA;AvIy86CR;;AuIl86CI;EACI,8BAAA;AvIq86CR;AuIl86CI;EACI,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;AvIo86CR;AuIl86CQ;EACI,QAAA;EACA,gBAAA;EACA,+BAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,OAAA;EACA,YAAA;AvIo86CZ;AuIj86CQ;EACI,WAAA;EACA,mBlIriBG;EkIsiBH,WAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,OAAA;EACA,YAAA;AvIm86CZ;AuI776CY;EACI,WAAA;AvI+76ChB;AuI176CI;EACI,yBAAA;AvI476CR;;AuIv76CA;EACI,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;AvI076CJ;AuIx76CI;EACI,QAAA;EACA,gBAAA;EACA,+BAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,OAAA;EACA,YAAA;AvI076CR;AuIv76CI;EACI,WAAA;EACA,mBlIplBO;EkIqlBP,WAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,OAAA;EACA,YAAA;AvIy76CR;AuIr76CQ;EACI,WAAA;AvIu76CZ;;AuIj76CI;EACI,0BAAA;EACA,cAAA;EACA,iBAAA;AvIo76CR;AuIl76CQ;EACI,clI3mBG;AL+h8Cf;AuI966CY;EACI,YAAA;EACA,cAAA;AvIg76ChB;;AuI166CA;EACI,cAAA;EACA,kBAAA;AvI666CJ;;AuI166CA;EACI,YAAA;EACA,aAAA;EACA,wGAAA;EACA,0CAAA;AvI666CJ;;AuI166CA;EACI,gCAAA;AvI666CJ;;AuIz66CA;EACI,SAAA;AvI466CJ;;AuIz66CA;EACI,oBAAA;AvI466CJ;;AuIz66CA;EACI,kBAAA;AvI466CJ;;AuIz66CA;EACI,wBAAA;EACA,qBAAA;EACA,gBAAA;AvI466CJ;;AuIz66CA;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;EACA,gDAAA;EACA,6CAAA;EACA,4CAAA;EACA,wCAAA;EACA,oBAAA;EACA,kBAAA;EACA,oBAAA;AvI466CJ;;AuIx66CI;EACI,qBAAA;EACA,WAAA;AvI266CR;;AuIv66CA;EACI,kBAAA;AvI066CJ;;AuIv66CA;EACI,0BAAA;AvI066CJ;;AuIv66CA;EACI,8BAAA;AvI066CJ;;AwIjo8CC;EACC;IACE,wBAAA;ExIoo8CF;EwIlo8CA;IACE,wBAAA;ExIoo8CF;AACF","sourcesContent":["@charset 'UTF-8';\r\n\r\n// 0. Hide menu before it's loaded\r\n@media only screen and (max-width: 1169px) {\r\n    #cd-primary-nav {\r\n        -webkit-transform: translateX(-80vw);\r\n        -moz-transform: translateX(-80vw);\r\n        -ms-transform: translateX(-80vw);\r\n        -o-transform: translateX(-80vw);\r\n        transform: translateX(-80vw);\r\n    }\r\n}\r\n\r\n// 1. Configuration and helpers\r\n@import 'abstracts/variables';\r\n@import 'abstracts/zinzino-bootstrap-variables';\r\n\r\n// 2. Vendors\r\n/*@import \r\n    '~bootstrap/';*/\r\n@import \"../../node_modules/bootstrap/scss/bootstrap\";\r\n@import \"../../node_modules/@mdi/font/scss/materialdesignicons\";\r\n\r\n\r\n// 3. Base stuff\r\n@import 'base/helpers';\r\n@import 'base/mixins';\r\n@import 'base/typography';\r\n\r\n// 4. Layout-related sections\r\n@import \"layout/navigation-bar\";\r\n@import \"layout/navigation\";\r\n@import \"layout/footer\";\r\n@import \"layout/header\";\r\n@import \"layout/_header-logged-in-info\";\r\n@import \"layout/bootstrap-col-slider\";\r\n@import \"../../Features/Blocks/HeroBlock/hero-block\";\r\n\r\n\r\n// 5. Components\r\n@import \"components/elements/buttons\";\r\n@import \"components/elements/checkbox\";\r\n@import \"components/elements/dropdown\";\r\n@import \"components/elements/icon-buttons\";\r\n@import \"components/elements/icon-menu\";\r\n@import \"components/elements/list-group\";\r\n@import \"components/elements/loading-box\";\r\n@import \"components/elements/select-menu\";\r\n@import \"components/elements/table\";\r\n@import \"components/elements/textbox\";\r\n\r\n@import \"components/widgets/form\";\r\n\r\n// 6. Page and block specific styles.\r\n\r\n@import \"../../Features/Blocks/BrandAmbassadorBlock/brand-ambassador-block\";\r\n@import \"../../Features/Blocks/BreadcrumbBlock/breadcrumb-block\";\r\n@import \"../../Features/Blocks/BubbleInfoBlock/bubble-info-block\";\r\n@import \"../../Features/Blocks/ButtonBlock/button-block\";\r\n@import \"../../Features/Blocks/CarouselBlock/carousel-block\";\r\n@import \"../../Features/Blocks/EventBlock/event-block\";\r\n@import \"../../Features/Blocks/FAQContainerBlock/faq-container-block\";\r\n@import \"../../Features/Blocks/GridUspBlock/grid-usp-block\";\r\n@import \"../../Features/Blocks/InstagramBlock/instagram-block\";\r\n@import \"../../Features/Blocks/InvestorsHeroBlock/investors-hero-block\";\r\n@import \"../../Features/Blocks/NewsletterBlock/newsletter-block\";\r\n@import \"../../Features/Blocks/PartnerJoinBlock/partner-join-block\";\r\n@import \"../../Features/Blocks/ResponsiveVideoBlock/responsive-video-block\";\r\n@import \"../../Features/Blocks/ShortInfoBlock/short-info-block\";\r\n@import \"../../Features/Blocks/StaffBlock/staff-block\";\r\n@import \"../../Features/Blocks/SupportContactBlock/support-contact-block\";\r\n@import \"../../Features/Blocks/TestimonialsListBlock/testimonials-list-block\";\r\n@import \"../../Features/Blocks/TextBlock/text-block\";\r\n@import \"../../Features/Blocks/FixedBackgroundCointainerBlock/fixed-background-container-block\";\r\n@import \"../../Features/Category/category-block\";\r\n\r\n@import \"../../Features/ErrorPage/error\";\r\n@import \"../../Features/Home/home\";\r\n@import \"../../Features/Media/video-file\";\r\n@import \"../../Features/People/people\";\r\n@import \"../../Features/Investors/investors\";\r\n@import \"../../Features/NewsRoom/news-room\";\r\n@import \"../../Features/Preview/preview\";\r\n@import \"../../Features/Support/support-page\";\r\n\r\n// 7. Themes..\r\n@import \"themes/default\";\r\n\r\n// Print styles\r\n@import \"layout/print\";\r\n\r\n//// 1. Configuration and helpers\r\n//@import 'abstracts/**/*.scss';\r\n\r\n//// 2. Vendors\r\n//@import '~bootstrap/scss/bootstrap';\r\n\r\n//// 3. Base stuff\r\n//@import 'base/**/*.scss';\r\n\r\n//// 4. Layout-related sections\r\n//@import 'layout/**/*.scss';\r\n\r\n//// 5. Components\r\n//@import 'components/**/*.scss';\r\n\r\n//// 6. Page and block specific styles.\r\n\r\n//@import '../../Features/**/*.scss';\r\n\r\n//// 7. Themes..\r\n//@import 'themes/**/*.scss';\r\n\r\n\r\n","﻿/* Container */\r\n$container-max-width: 1440px;\r\n\r\n/* Color */\r\n$accent-color: #440099;\r\n$color-primary: #440099;\r\n$color-dark: #28747E;\r\n$color-grey: #eee;\r\n$color-darkgrey: #ddd;\r\n$dark-grey: #494949;\r\n$color-lightgrey: #E6F3EF;\r\n$color-red: #ff0000;\r\n$color-muted: #ccc;\r\n$color-white: #fff;\r\n$color-yellow: #fec84d;\r\n$color-black: #242829;\r\n$color-lighter-purple: #ECE9F2;\r\n$color-darkred: #891519;\r\n$color-pink: #f9cdd0;\r\n$color-darkpink: #f7b9bd;\r\n\r\n\r\n/* Text */\r\n$text-color: $color-black;\r\n$text-font-size: 16px;\r\n$text-mobile-font-size: 14px;\r\n$text-font-size-small: 0.75rem;\r\n$text-font-stack: \"Open Sans\", sans-serif;\r\n$text-line-height: 26px;\r\n$text-mobile-line-height: 24px;\r\n$text-light-color: $color-lightgrey;\r\n\r\n/* Navigation */\r\n$navigation-height: 70px;\r\n\r\n/* Textbox */\r\n$textbox-height: 2.5rem;\r\n$textbox-height-small: 1.875rem;\r\n\r\n/* Dropdown */\r\n$shadow-dropdown: 0 3px 4px rgba(0, 0, 0, 0.25);","/*!\n * Bootstrap v4.6.2 (https://getbootstrap.com/)\n * Copyright 2011-2022 The Bootstrap Authors\n * Copyright 2011-2022 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n\n@import \"functions\";\n@import \"variables\";\n@import \"mixins\";\n@import \"root\";\n@import \"reboot\";\n@import \"type\";\n@import \"images\";\n@import \"code\";\n@import \"grid\";\n@import \"tables\";\n@import \"forms\";\n@import \"buttons\";\n@import \"transitions\";\n@import \"dropdown\";\n@import \"button-group\";\n@import \"input-group\";\n@import \"custom-forms\";\n@import \"nav\";\n@import \"navbar\";\n@import \"card\";\n@import \"breadcrumb\";\n@import \"pagination\";\n@import \"badge\";\n@import \"jumbotron\";\n@import \"alert\";\n@import \"progress\";\n@import \"media\";\n@import \"list-group\";\n@import \"close\";\n@import \"toasts\";\n@import \"modal\";\n@import \"tooltip\";\n@import \"popover\";\n@import \"carousel\";\n@import \"spinners\";\n@import \"utilities\";\n@import \"print\";\n",":root {\n  // Custom variable values only support SassScript inside `#{}`.\n  @each $color, $value in $colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $bp, $value in $grid-breakpoints {\n    --breakpoint-#{$bp}: #{$value};\n  }\n\n  // Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --font-family-sans-serif: #{inspect($font-family-sans-serif)};\n  --font-family-monospace: #{inspect($font-family-monospace)};\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// 1. Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n// 2. Change the default font family in all browsers.\n// 3. Correct the line height in all browsers.\n// 4. Prevent adjustments of font size after orientation changes in IE on Windows Phone and in iOS.\n// 5. Change the default tap highlight to be completely transparent in iOS.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box; // 1\n}\n\nhtml {\n  font-family: sans-serif; // 2\n  line-height: 1.15; // 3\n  -webkit-text-size-adjust: 100%; // 4\n  -webkit-tap-highlight-color: rgba($black, 0); // 5\n}\n\n// Shim for \"new\" HTML5 structural elements to display correctly (IE10, older browsers)\n// TODO: remove in v5\n// stylelint-disable-next-line selector-list-comma-newline-after\narticle, aside, figcaption, figure, footer, header, hgroup, main, nav, section {\n  display: block;\n}\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Set an explicit initial text-align value so that we can later use\n//    the `inherit` value on things like `<th>` elements.\n\nbody {\n  margin: 0; // 1\n  font-family: $font-family-base;\n  @include font-size($font-size-base);\n  font-weight: $font-weight-base;\n  line-height: $line-height-base;\n  color: $body-color;\n  text-align: left; // 3\n  background-color: $body-bg; // 2\n}\n\n// Future-proof rule: in browsers that support :focus-visible, suppress the focus outline\n// on elements that programmatically receive focus but wouldn't normally show a visible\n// focus outline. In general, this would mean that the outline is only applied if the\n// interaction that led to the element receiving programmatic focus was a keyboard interaction,\n// or the browser has somehow determined that the user is primarily a keyboard user and/or\n// wants focus outlines to always be presented.\n//\n// See https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-visible\n// and https://developer.paciellogroup.com/blog/2018/03/focus-visible-and-backwards-compatibility/\n[tabindex=\"-1\"]:focus:not(:focus-visible) {\n  outline: 0 !important;\n}\n\n\n// Content grouping\n//\n// 1. Add the correct box sizing in Firefox.\n// 2. Show the overflow in Edge and IE.\n\nhr {\n  box-sizing: content-box; // 1\n  height: 0; // 1\n  overflow: visible; // 2\n}\n\n\n//\n// Typography\n//\n\n// Remove top margins from headings\n//\n// By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n// margin for easier control within type scales as it avoids margin collapsing.\n// stylelint-disable-next-line selector-list-comma-newline-after\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: $headings-margin-bottom;\n}\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n// Abbreviations\n//\n// 1. Duplicate behavior to the data-* attribute for our tooltip plugin\n// 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n// 3. Add explicit cursor to indicate changed behavior.\n// 4. Remove the bottom border in Firefox 39-.\n// 5. Prevent the text-decoration to be skipped.\n\nabbr[title],\nabbr[data-original-title] { // 1\n  text-decoration: underline; // 2\n  text-decoration: underline dotted; // 2\n  cursor: help; // 3\n  border-bottom: 0; // 4\n  text-decoration-skip-ink: none; // 5\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // Undo browser default\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: $font-weight-bolder; // Add the correct font weight in Chrome, Edge, and Safari\n}\n\nsmall {\n  @include font-size(80%); // Add the correct font size in all browsers\n}\n\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n//\n\nsub,\nsup {\n  position: relative;\n  @include font-size(75%);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n//\n// Links\n//\n\na {\n  color: $link-color;\n  text-decoration: $link-decoration;\n  background-color: transparent; // Remove the gray background on active links in IE 10.\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  color: inherit;\n  text-decoration: none;\n\n  @include hover() {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n//\n// Code\n//\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-monospace;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\npre {\n  // Remove browser default top margin\n  margin-top: 0;\n  // Reset browser default of `1em` to use `rem`s\n  margin-bottom: 1rem;\n  // Don't allow content to break outside\n  overflow: auto;\n  // Disable auto-hiding scrollbar in IE & legacy Edge to avoid overlap,\n  // making it impossible to interact with the content\n  -ms-overflow-style: scrollbar;\n}\n\n\n//\n// Figures\n//\n\nfigure {\n  // Apply a consistent margin strategy (matches our type styles).\n  margin: 0 0 1rem;\n}\n\n\n//\n// Images and content\n//\n\nimg {\n  vertical-align: middle;\n  border-style: none; // Remove the border on images inside links in IE 10-.\n}\n\nsvg {\n  // Workaround for the SVG overflow bug in IE10/11 is still required.\n  // See https://github.com/twbs/bootstrap/issues/26878\n  overflow: hidden;\n  vertical-align: middle;\n}\n\n\n//\n// Tables\n//\n\ntable {\n  border-collapse: collapse; // Prevent double borders\n}\n\ncaption {\n  padding-top: $table-cell-padding;\n  padding-bottom: $table-cell-padding;\n  color: $table-caption-color;\n  text-align: left;\n  caption-side: bottom;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\n\n//\n// Forms\n//\n\nlabel {\n  // Allow labels to use `margin` for spacing.\n  display: inline-block;\n  margin-bottom: $label-margin-bottom;\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24093\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // Remove the margin in Firefox and Safari\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\nbutton,\ninput {\n  overflow: visible; // Show the overflow in Edge\n}\n\nbutton,\nselect {\n  text-transform: none; // Remove the inheritance of text transform in Firefox\n}\n\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\n// Remove the inheritance of word-wrap in Safari.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24990\nselect {\n  word-wrap: normal;\n}\n\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n}\n\n// Opinionated: add \"hand\" cursor to non-disabled button elements.\n@if $enable-pointer-cursor-for-buttons {\n  button,\n  [type=\"button\"],\n  [type=\"reset\"],\n  [type=\"submit\"] {\n    &:not(:disabled) {\n      cursor: pointer;\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  box-sizing: border-box; // 1. Add the correct box sizing in IE 10-\n  padding: 0; // 2. Remove the padding in IE 10-\n}\n\n\ntextarea {\n  overflow: auto; // Remove the default vertical scrollbar in IE.\n  // Textareas should really only resize vertically so they don't break their (horizontal) containers.\n  resize: vertical;\n}\n\nfieldset {\n  // Browsers set a default `min-width: min-content;` on fieldsets,\n  // unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n  // So we reset that to ensure fieldsets behave more like a standard block element.\n  // See https://github.com/twbs/bootstrap/issues/12359\n  // and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n  min-width: 0;\n  // Reset the default outline behavior of fieldsets so they don't affect page layout.\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\n// 1. Correct the text wrapping in Edge and IE.\n// 2. Correct the color inheritance from `fieldset` elements in IE.\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%; // 1\n  padding: 0;\n  margin-bottom: .5rem;\n  @include font-size(1.5rem);\n  line-height: inherit;\n  color: inherit; // 2\n  white-space: normal; // 1\n}\n\nprogress {\n  vertical-align: baseline; // Add the correct vertical alignment in Chrome, Firefox, and Opera.\n}\n\n// Correct the cursor style of increment and decrement buttons in Chrome.\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=\"search\"] {\n  // This overrides the extra rounded corners on search inputs in iOS so that our\n  // `.form-control` class can properly style them. Note that this cannot simply\n  // be added to `.form-control` as it's not specific enough. For details, see\n  // https://github.com/twbs/bootstrap/issues/11586.\n  outline-offset: -2px; // 2. Correct the outline style in Safari.\n  -webkit-appearance: none;\n}\n\n//\n// Remove the inner padding in Chrome and Safari on macOS.\n//\n\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n//\n// 1. Correct the inability to style clickable types in iOS and Safari.\n// 2. Change font properties to `inherit` in Safari.\n//\n\n::-webkit-file-upload-button {\n  font: inherit; // 2\n  -webkit-appearance: button; // 1\n}\n\n//\n// Correct element displays\n//\n\noutput {\n  display: inline-block;\n}\n\nsummary {\n  display: list-item; // Add the correct display in all browsers\n  cursor: pointer;\n}\n\ntemplate {\n  display: none; // Add the correct display in IE\n}\n\n// Always hide an element with the `hidden` HTML attribute (from PureCSS).\n// Needed for proper display in IE 10-.\n[hidden] {\n  display: none !important;\n}\n","// Variables\r\n//\r\n// Variables should follow the `$component-state-property-size` formula for\r\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\r\n\r\n// Color system\r\n\r\n$white: #fff;\r\n$gray-100: #f8f9fa;\r\n$gray-200: #e9ecef;\r\n$gray-300: #dee2e6;\r\n$gray-400: #ced4da;\r\n$gray-500: #adb5bd;\r\n$gray-600: #6c757d;\r\n$gray-700: #495057;\r\n$gray-800: #343a40;\r\n$gray-900: #212529;\r\n$black: #000;\r\n\r\n$grays: ();\r\n$grays: map-merge( ( \"100\": $gray-100, \"200\": $gray-200, \"300\": $gray-300, \"400\": $gray-400, \"500\": $gray-500, \"600\": $gray-600, \"700\": $gray-700, \"800\": $gray-800, \"900\": $gray-900 ), $grays );\r\n\r\n$blue: #007bff;\r\n$indigo: #6610f2;\r\n$purple: #440099;\r\n$light-purple: #8859C5; \r\n$pink: #e83e8c;\r\n$red: #dc3545;\r\n$orange: #fd7e14;\r\n$yellow: #ffc107;\r\n$green: #28a745;\r\n$teal: #20c997;\r\n$cyan: #17a2b8;\r\n\r\n$colors: ();\r\n$colors: map-merge( ( \"blue\": $blue, \"indigo\": $indigo, \"purple\": $purple, \"pink\": $pink, \"red\": $red, \"orange\": $orange, \"yellow\": $yellow, \"green\": $green, \"teal\": $teal, \"cyan\": $cyan, \"white\": $white, \"gray\": $gray-600, \"gray-dark\": $gray-800 ), $colors );\r\n\r\n$primary: $purple;\r\n$secondary: $gray-600;\r\n$success: $green;\r\n$info: $cyan;\r\n$warning: $yellow;\r\n$danger: $red;\r\n$light: $gray-100;\r\n$dark: $gray-800;\r\n\r\n$theme-colors: ();\r\n$theme-colors: map-merge( ( \"primary\": $primary, \"secondary\": $secondary, \"success\": $success, \"info\": $info, \"warning\": $warning, \"danger\": $danger, \"light\": $light, \"dark\": $dark ), $theme-colors );\r\n\r\n// Set a specific jump point for requesting color jumps\r\n$theme-color-interval: 8%;\r\n\r\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\r\n$yiq-contrasted-threshold: 150;\r\n\r\n// Customize the light and dark text colors for use in our YIQ color contrast function.\r\n$yiq-text-dark: $gray-900;\r\n$yiq-text-light: $white;\r\n\r\n// Characters which are escaped by the escape-svg function\r\n$escaped-characters: ( (\"<\", \"%3c\"), (\">\", \"%3e\"), (\"#\", \"%23\"), (\"(\", \"%28\"), (\")\", \"%29\"), );\r\n\r\n\r\n// Options\r\n//\r\n// Quickly modify global styling by enabling or disabling optional features.\r\n\r\n$enable-caret: true;\r\n$enable-rounded: true;\r\n$enable-shadows: false;\r\n$enable-gradients: false;\r\n$enable-transitions: true;\r\n$enable-prefers-reduced-motion-media-query: true;\r\n$enable-hover-media-query: false; // Deprecated, no longer affects any compiled CSS\r\n$enable-grid-classes: true;\r\n$enable-pointer-cursor-for-buttons: true;\r\n$enable-print-styles: true;\r\n$enable-responsive-font-sizes: true;\r\n$enable-validation-icons: true;\r\n$enable-deprecation-messages: true;\r\n\r\n\r\n// Spacing\r\n//\r\n// Control the default styling of most Bootstrap elements by modifying these\r\n// variables. Mostly focused on spacing.\r\n// You can add more entries to the $spacers map, should you need more variation.\r\n\r\n$spacer: 1rem;\r\n$spacers: ();\r\n$spacers: map-merge( ( 0: 0, 1: ($spacer * .25), 2: ($spacer * .5), 3: $spacer, 4: ($spacer * 1.5), 5: ($spacer * 3) ), $spacers );\r\n\r\n// This variable affects the `.h-*` and `.w-*` classes.\r\n$sizes: ();\r\n$sizes: map-merge( ( 25: 25%, 50: 50%, 75: 75%, 100: 100%, auto: auto ), $sizes );\r\n\r\n\r\n// Body\r\n//\r\n// Settings for the `<body>` element.\r\n\r\n$body-bg: $white;\r\n$body-color: $gray-900;\r\n\r\n\r\n// Links\r\n//\r\n// Style anchor elements.\r\n\r\n$link-decoration: none;\r\n$link-hover-decoration: underline;\r\n\r\n// Darken percentage for links with `.text-*` class (e.g. `.text-success`)\r\n$emphasized-link-hover-darken-percentage: 15%;\r\n\r\n// Paragraphs\r\n//\r\n// Style p element.\r\n\r\n$paragraph-margin-bottom: 1rem;\r\n\r\n\r\n// Grid breakpoints\r\n//\r\n// Define the minimum dimensions at which your layout will change,\r\n// adapting to different screen sizes, for use in media queries.\r\n\r\n$grid-breakpoints: ( xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px );\r\n\r\n// Grid containers\r\n//\r\n// Define the maximum width of `.container` for different screen sizes.\r\n\r\n$container-max-widths: ( sm: 540px, md: 720px, lg: 960px, xl: 1180px );\r\n\r\n// Grid columns\r\n//\r\n// Set the number of columns and specify the width of the gutters.\r\n\r\n$grid-columns: 12;\r\n$grid-gutter-width: 30px;\r\n$grid-row-columns: 6;\r\n\r\n\r\n// Components\r\n//\r\n// Define common padding and border radius sizes and more.\r\n\r\n$line-height-lg: 1.5;\r\n$line-height-sm: 1.5;\r\n\r\n$border-width: 1px;\r\n$border-color: $gray-300;\r\n\r\n$border-radius: .25rem;\r\n$border-radius-lg: .3rem;\r\n$border-radius-sm: .2rem;\r\n\r\n$rounded-pill: 50rem;\r\n\r\n$box-shadow-sm: 0 .125rem .25rem rgba($black, .075);\r\n$box-shadow: 0 .5rem 1rem rgba($black, .15);\r\n$box-shadow-lg: 0 1rem 3rem rgba($black, .175);\r\n\r\n$component-active-color: $white;\r\n\r\n$caret-width: .3em;\r\n$caret-vertical-align: $caret-width * .85;\r\n$caret-spacing: $caret-width * .85;\r\n\r\n$transition-base: all .2s ease-in-out;\r\n$transition-fade: opacity .15s linear;\r\n$transition-collapse: height .35s ease;\r\n\r\n// Typography\r\n//\r\n// Font, line-height, and color for body text, headings, and more.\r\n\r\n// stylelint-disable value-keyword-case\r\n$font-family-sans-serif: \"Open Sans\";\r\n$font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\r\n$font-family-base: $font-family-sans-serif;\r\n// stylelint-enable value-keyword-case\r\n\r\n$font-size-base: 1rem; // Assumes the browser default, typically `16px`\r\n$font-size-lg: $font-size-base * 1.25;\r\n$font-size-sm: $font-size-base * .75;\r\n\r\n$font-weight-lighter: lighter;\r\n$font-weight-light: 300;\r\n$font-weight-normal: 400;\r\n$font-weight-bold: 700;\r\n$font-weight-bolder: bolder;\r\n\r\n$font-weight-base: $font-weight-normal;\r\n$line-height-base: 1.5;\r\n\r\n$h1-font-size: $font-size-base * 2.5;\r\n$h2-font-size: $font-size-base * 2;\r\n$h3-font-size: $font-size-base * 1.5;\r\n$h4-font-size: $font-size-base * 1.5;\r\n$h5-font-size: $font-size-base * 1.25;\r\n$h6-font-size: $font-size-base * 1.125;\r\n\r\n$headings-margin-bottom: $spacer / 2;\r\n$headings-font-family: null;\r\n$headings-font-weight: 500;\r\n$headings-line-height: 1.2;\r\n$headings-color: null;\r\n\r\n$display1-size: 3rem;\r\n$display2-size: 2rem;\r\n$display3-size: 1.5rem;\r\n$display4-size: 1.2rem;\r\n\r\n$display1-weight: 400;\r\n$display2-weight: 400;\r\n$display3-weight: 400;\r\n$display4-weight: 400;\r\n$display-line-height: $headings-line-height;\r\n\r\n$lead-font-size: $font-size-base * 1.25;\r\n$lead-font-weight: 300;\r\n\r\n$small-font-size: 80%;\r\n\r\n$text-muted: $gray-600;\r\n\r\n$blockquote-small-color: $gray-600;\r\n$blockquote-small-font-size: $small-font-size;\r\n$blockquote-font-size: $font-size-base * 1.25;\r\n\r\n$hr-border-color: rgba($black, .1);\r\n$hr-border-width: $border-width;\r\n\r\n$mark-padding: .2em;\r\n\r\n$dt-font-weight: $font-weight-bold;\r\n\r\n$kbd-box-shadow: inset 0 -.1rem 0 rgba($black, .25);\r\n$nested-kbd-font-weight: $font-weight-bold;\r\n\r\n$list-inline-padding: .5rem;\r\n\r\n$mark-bg: #fcf8e3;\r\n\r\n$hr-margin-y: $spacer;\r\n\r\n\r\n// Tables\r\n//\r\n// Customizes the `.table` component with basic values, each used across all table variations.\r\n\r\n$table-cell-padding: .75rem;\r\n$table-cell-padding-sm: .3rem;\r\n\r\n$table-color: $body-color;\r\n$table-bg: null;\r\n$table-accent-bg: rgba($black, .05);\r\n$table-hover-color: $table-color;\r\n$table-hover-bg: rgba($black, .075);\r\n$table-active-bg: $table-hover-bg;\r\n\r\n$table-border-width: $border-width;\r\n$table-border-color: $border-color;\r\n\r\n$table-head-bg: $gray-200;\r\n$table-head-color: $gray-700;\r\n\r\n$table-dark-color: $white;\r\n$table-dark-bg: $gray-800;\r\n$table-dark-accent-bg: rgba($white, .05);\r\n$table-dark-hover-color: $table-dark-color;\r\n$table-dark-hover-bg: rgba($white, .075);\r\n$table-dark-border-color: lighten($table-dark-bg, 7.5%);\r\n\r\n$table-striped-order: odd;\r\n\r\n$table-caption-color: $text-muted;\r\n\r\n$table-bg-level: -9;\r\n$table-border-level: -6;\r\n\r\n\r\n// Buttons + Forms\r\n//\r\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\r\n\r\n$input-btn-padding-y: .625rem;\r\n$input-btn-padding-x: 2.5rem;\r\n$input-btn-font-family: null;\r\n$input-btn-font-size: $font-size-base * 0.875;\r\n$input-btn-line-height: $line-height-base;\r\n\r\n$input-btn-focus-width: .2rem;\r\n\r\n$input-btn-padding-y-sm: .438rem;\r\n$input-btn-padding-x-sm: 2rem;\r\n$input-btn-font-size-sm: $font-size-sm;\r\n$input-btn-line-height-sm: $line-height-sm;\r\n\r\n$input-btn-padding-y-lg: .75rem;\r\n$input-btn-padding-x-lg: 3rem;\r\n$input-btn-font-size-lg: $font-size-lg;\r\n$input-btn-line-height-lg: $line-height-lg;\r\n\r\n$input-btn-border-width: $border-width;\r\n\r\n\r\n// Buttons\r\n//\r\n// For each of Bootstrap's buttons, define text, background, and border color.\r\n\r\n$btn-padding-y: $input-btn-padding-y;\r\n$btn-padding-x: $input-btn-padding-x;\r\n$btn-font-family: $input-btn-font-family;\r\n$btn-font-size: $input-btn-font-size;\r\n$btn-line-height: $input-btn-line-height;\r\n$btn-white-space: null; // Set to `nowrap` to prevent text wrapping\r\n\r\n$btn-padding-y-sm: $input-btn-padding-y-sm;\r\n$btn-padding-x-sm: $input-btn-padding-x-sm;\r\n$btn-font-size-sm: $input-btn-font-size-sm;\r\n$btn-line-height-sm: $input-btn-line-height-sm;\r\n\r\n$btn-padding-y-lg: $input-btn-padding-y-lg;\r\n$btn-padding-x-lg: $input-btn-padding-x-lg;\r\n$btn-font-size-lg: $input-btn-font-size-lg;\r\n$btn-line-height-lg: $input-btn-line-height-lg;\r\n\r\n$btn-border-width: $input-btn-border-width;\r\n\r\n$btn-font-weight: $font-weight-normal;\r\n$btn-box-shadow: inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075);\r\n$btn-focus-width: $input-btn-focus-width;\r\n$btn-disabled-opacity: .65;\r\n$btn-active-box-shadow: inset 0 3px 5px rgba($black, .125);\r\n\r\n$btn-link-disabled-color: $gray-600;\r\n\r\n$btn-block-spacing-y: .5rem;\r\n\r\n// Allows for customizing button radius independently from global border radius\r\n$btn-border-radius: $border-radius / 1.5;\r\n$btn-border-radius-lg: $border-radius-lg;\r\n$btn-border-radius-sm: $border-radius-sm;\r\n$btn-transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\r\n\r\n// Forms\r\n\r\n$label-margin-bottom: .5rem;\r\n\r\n$input-padding-y: $input-btn-padding-y;\r\n$input-padding-x: $input-btn-padding-x;\r\n$input-font-family: $input-btn-font-family;\r\n$input-font-size: $input-btn-font-size;\r\n$input-font-weight: $font-weight-base;\r\n$input-line-height: $input-btn-line-height;\r\n\r\n$input-padding-y-sm: $input-btn-padding-y-sm;\r\n$input-padding-x-sm: $input-btn-padding-x-sm;\r\n$input-font-size-sm: $input-btn-font-size-sm;\r\n$input-line-height-sm: $input-btn-line-height-sm;\r\n\r\n$input-padding-y-lg: $input-btn-padding-y-lg;\r\n$input-padding-x-lg: $input-btn-padding-x-lg;\r\n$input-font-size-lg: $input-btn-font-size-lg;\r\n$input-line-height-lg: $input-btn-line-height-lg;\r\n\r\n$input-bg: $white;\r\n$input-disabled-bg: $gray-200;\r\n\r\n$input-color: $gray-700;\r\n$input-border-color: $gray-400;\r\n$input-border-width: $input-btn-border-width;\r\n$input-box-shadow: inset 0 1px 1px rgba($black, .075);\r\n\r\n$input-border-radius: $border-radius;\r\n$input-border-radius-lg: $border-radius-lg;\r\n$input-border-radius-sm: $border-radius-sm;\r\n\r\n$input-focus-bg: $input-bg;\r\n$input-focus-color: $input-color;\r\n$input-focus-width: $input-btn-focus-width;\r\n\r\n$input-placeholder-color: $gray-600;\r\n$input-plaintext-color: $body-color;\r\n\r\n$input-height-border: $input-border-width * 2;\r\n\r\n$input-transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;\r\n\r\n$form-text-margin-top: .25rem;\r\n\r\n$form-check-input-gutter: 1.25rem;\r\n$form-check-input-margin-y: .3rem;\r\n$form-check-input-margin-x: .25rem;\r\n\r\n$form-check-inline-margin-x: .75rem;\r\n$form-check-inline-input-margin-x: .3125rem;\r\n\r\n$form-grid-gutter-width: 10px;\r\n$form-group-margin-bottom: 1rem;\r\n\r\n$input-group-addon-color: $input-color;\r\n$input-group-addon-bg: $gray-200;\r\n$input-group-addon-border-color: $input-border-color;\r\n\r\n$custom-forms-transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\r\n\r\n$custom-control-gutter: .5rem;\r\n$custom-control-spacer-x: 1rem;\r\n$custom-control-cursor: null;\r\n\r\n$custom-control-indicator-size: 1rem;\r\n$custom-control-indicator-bg: $input-bg;\r\n\r\n$custom-control-indicator-bg-size: 50% 50%;\r\n$custom-control-indicator-box-shadow: $input-box-shadow;\r\n$custom-control-indicator-border-color: $gray-500;\r\n$custom-control-indicator-border-width: $input-border-width;\r\n\r\n$custom-control-label-color: null;\r\n\r\n$custom-control-indicator-disabled-bg: $input-disabled-bg;\r\n$custom-control-label-disabled-color: $gray-600;\r\n\r\n$custom-control-indicator-checked-color: $component-active-color;\r\n$custom-control-indicator-checked-box-shadow: null;\r\n\r\n$custom-control-indicator-active-color: $component-active-color;\r\n$custom-control-indicator-active-box-shadow: null;\r\n\r\n$custom-checkbox-indicator-border-radius: $border-radius;\r\n$custom-checkbox-indicator-icon-checked: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$custom-control-indicator-checked-color}' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/></svg>\");\r\n\r\n$custom-checkbox-indicator-indeterminate-color: $custom-control-indicator-checked-color;\r\n$custom-checkbox-indicator-icon-indeterminate: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'><path stroke='#{$custom-checkbox-indicator-indeterminate-color}' d='M0 2h4'/></svg>\");\r\n$custom-checkbox-indicator-indeterminate-box-shadow: null;\r\n\r\n$custom-radio-indicator-border-radius: 50%;\r\n$custom-radio-indicator-icon-checked: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'><circle r='3' fill='#{$custom-control-indicator-checked-color}'/></svg>\");\r\n\r\n$custom-switch-width: $custom-control-indicator-size * 1.75;\r\n$custom-switch-indicator-border-radius: $custom-control-indicator-size / 2;\r\n\r\n$custom-select-padding-y: $input-padding-y;\r\n$custom-select-padding-x: $input-padding-x;\r\n$custom-select-font-family: $input-font-family;\r\n$custom-select-font-size: $input-font-size;\r\n$custom-select-indicator-padding: 1rem; // Extra padding to account for the presence of the background-image based indicator\r\n$custom-select-font-weight: $input-font-weight;\r\n$custom-select-line-height: $input-line-height;\r\n$custom-select-color: $input-color;\r\n$custom-select-disabled-color: $gray-600;\r\n$custom-select-bg: $input-bg;\r\n$custom-select-disabled-bg: $gray-200;\r\n$custom-select-bg-size: 8px 10px; // In pixels because image dimensions\r\n$custom-select-indicator-color: $gray-800;\r\n$custom-select-indicator: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'><path fill='#{$custom-select-indicator-color}' d='M2 0L0 2h4zm0 5L0 3h4z'/></svg>\");\r\n\r\n$custom-select-feedback-icon-position: center right ($custom-select-padding-x + $custom-select-indicator-padding);\r\n\r\n$custom-select-border-width: $input-border-width;\r\n$custom-select-border-color: $input-border-color;\r\n$custom-select-border-radius: $border-radius;\r\n$custom-select-box-shadow: inset 0 1px 2px rgba($black, .075);\r\n\r\n$custom-select-focus-width: $input-focus-width;\r\n\r\n$custom-select-padding-y-sm: $input-padding-y-sm;\r\n$custom-select-padding-x-sm: $input-padding-x-sm;\r\n$custom-select-font-size-sm: $input-font-size-sm;\r\n\r\n$custom-select-padding-y-lg: $input-padding-y-lg;\r\n$custom-select-padding-x-lg: $input-padding-x-lg;\r\n$custom-select-font-size-lg: $input-font-size-lg;\r\n\r\n$custom-range-track-width: 100%;\r\n$custom-range-track-height: .5rem;\r\n$custom-range-track-cursor: pointer;\r\n$custom-range-track-bg: $gray-300;\r\n$custom-range-track-border-radius: 1rem;\r\n$custom-range-track-box-shadow: inset 0 .25rem .25rem rgba($black, .1);\r\n\r\n$custom-range-thumb-width: 1rem;\r\n$custom-range-thumb-height: $custom-range-thumb-width;\r\n$custom-range-thumb-border: 0;\r\n$custom-range-thumb-border-radius: 1rem;\r\n$custom-range-thumb-box-shadow: 0 .1rem .25rem rgba($black, .1);\r\n$custom-range-thumb-focus-box-shadow-width: $input-focus-width; // For focus box shadow issue in IE/Edge\r\n$custom-range-thumb-disabled-bg: $gray-500;\r\n\r\n$custom-file-disabled-bg: $input-disabled-bg;\r\n\r\n$custom-file-padding-y: $input-padding-y;\r\n$custom-file-padding-x: $input-padding-x;\r\n$custom-file-line-height: $input-line-height;\r\n$custom-file-font-family: $input-font-family;\r\n$custom-file-font-weight: $input-font-weight;\r\n$custom-file-color: $input-color;\r\n$custom-file-bg: $input-bg;\r\n$custom-file-border-width: $input-border-width;\r\n$custom-file-border-color: $input-border-color;\r\n$custom-file-border-radius: $input-border-radius;\r\n$custom-file-box-shadow: $input-box-shadow;\r\n$custom-file-button-color: $custom-file-color;\r\n$custom-file-button-bg: $input-group-addon-bg;\r\n$custom-file-text: ( en: \"Browse\" );\r\n\r\n// Z-index master list\r\n//\r\n// Warning: Avoid customizing these values. They're used for a bird's eye view\r\n// of components dependent on the z-axis and are designed to all work together.\r\n\r\n$zindex-dropdown: 1000;\r\n$zindex-sticky: 1020;\r\n$zindex-fixed: 1030;\r\n$zindex-modal-backdrop: 1040;\r\n$zindex-modal: 1050;\r\n$zindex-popover: 1060;\r\n$zindex-tooltip: 1070;\r\n\r\n// Navs\r\n$nav-link-padding-y: .5rem;\r\n$nav-link-padding-x: 1rem;\r\n$nav-link-disabled-color: $gray-600;\r\n$nav-tabs-border-color: $gray-300;\r\n$nav-tabs-border-width: $border-width;\r\n$nav-tabs-border-radius: $border-radius;\r\n$nav-tabs-link-hover-border-color: $gray-200 $gray-200 $nav-tabs-border-color;\r\n$nav-tabs-link-active-color: $gray-700;\r\n$nav-tabs-link-active-bg: $body-bg;\r\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg;\r\n$nav-pills-border-radius: $border-radius;\r\n$nav-pills-link-active-color: $component-active-color;\r\n$nav-divider-color: $gray-200;\r\n$nav-divider-margin-y: $spacer / 2;\r\n\r\n\r\n// Navbar\r\n$navbar-padding-y: $spacer / 2;\r\n$navbar-padding-x: $spacer;\r\n$navbar-nav-link-padding-x: .5rem;\r\n$navbar-brand-font-size: $font-size-lg;\r\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\r\n$nav-link-height: $font-size-base * $line-height-base + $nav-link-padding-y * 2;\r\n$navbar-brand-height: $navbar-brand-font-size * $line-height-base;\r\n$navbar-brand-padding-y: ($nav-link-height - $navbar-brand-height) / 2;\r\n\r\n$navbar-toggler-padding-y: .25rem;\r\n$navbar-toggler-padding-x: .75rem;\r\n$navbar-toggler-font-size: $font-size-lg;\r\n$navbar-toggler-border-radius: $btn-border-radius;\r\n\r\n$navbar-dark-color: rgba($white, .5);\r\n$navbar-dark-hover-color: rgba($white, .75);\r\n$navbar-dark-active-color: $white;\r\n$navbar-dark-disabled-color: rgba($white, .25);\r\n$navbar-dark-toggler-icon-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\r\n$navbar-dark-toggler-border-color: rgba($white, .1);\r\n\r\n$navbar-light-color: rgba($black, .5);\r\n$navbar-light-hover-color: rgba($black, .7);\r\n$navbar-light-active-color: rgba($black, .9);\r\n$navbar-light-disabled-color: rgba($black, .3);\r\n$navbar-light-toggler-icon-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\r\n$navbar-light-toggler-border-color: rgba($black, .1);\r\n\r\n$navbar-light-brand-color: $navbar-light-active-color;\r\n$navbar-light-brand-hover-color: $navbar-light-active-color;\r\n$navbar-dark-brand-color: $navbar-dark-active-color;\r\n$navbar-dark-brand-hover-color: $navbar-dark-active-color;\r\n\r\n\r\n// Dropdowns\r\n//\r\n// Dropdown menu container and contents.\r\n\r\n$dropdown-min-width: 10rem;\r\n$dropdown-padding-y: .5rem;\r\n$dropdown-spacer: .125rem;\r\n$dropdown-font-size: $font-size-base;\r\n$dropdown-color: $body-color;\r\n$dropdown-bg: $white;\r\n$dropdown-border-color: rgba($black, .15);\r\n$dropdown-border-radius: $border-radius;\r\n$dropdown-border-width: $border-width;\r\n$dropdown-divider-bg: $gray-200;\r\n$dropdown-divider-margin-y: $nav-divider-margin-y;\r\n$dropdown-box-shadow: 0 .5rem 1rem rgba($black, .175);\r\n\r\n$dropdown-link-color: $gray-900;\r\n$dropdown-link-hover-color: darken($gray-900, 5%);\r\n$dropdown-link-hover-bg: $gray-100;\r\n$dropdown-link-active-color: $component-active-color;\r\n$dropdown-link-disabled-color: $gray-600;\r\n\r\n$dropdown-item-padding-y: .25rem;\r\n$dropdown-item-padding-x: 1.5rem;\r\n\r\n$dropdown-header-color: $gray-600;\r\n$dropdown-header-padding: $dropdown-padding-y $dropdown-item-padding-x;\r\n\r\n\r\n// Jumbotron\r\n\r\n$jumbotron-padding: 2rem;\r\n$jumbotron-color: null;\r\n\r\n\r\n// Cards\r\n\r\n$card-spacer-y: .75rem;\r\n$card-spacer-x: 1.25rem;\r\n$card-border-radius: $border-radius;\r\n$card-border-color: rgba($black, .125);\r\n$card-cap-bg: rgba($black, .03);\r\n$card-cap-color: null;\r\n$card-height: null;\r\n$card-color: null;\r\n$card-bg: $white;\r\n\r\n$card-img-overlay-padding: 1.25rem;\r\n\r\n$card-group-margin: $grid-gutter-width / 2;\r\n$card-deck-margin: $card-group-margin;\r\n\r\n$card-columns-count: 3;\r\n$card-columns-gap: 1.25rem;\r\n$card-columns-margin: $card-spacer-y;\r\n\r\n\r\n// Tooltips\r\n\r\n$tooltip-font-size: $font-size-sm;\r\n$tooltip-max-width: 200px;\r\n$tooltip-color: $white;\r\n$tooltip-bg: $black;\r\n$tooltip-border-radius: $border-radius;\r\n$tooltip-opacity: .9;\r\n$tooltip-padding-y: .25rem;\r\n$tooltip-padding-x: .5rem;\r\n$tooltip-margin: 0;\r\n\r\n$tooltip-arrow-width: .8rem;\r\n$tooltip-arrow-height: .4rem;\r\n$tooltip-arrow-color: $tooltip-bg;\r\n\r\n// Form tooltips must come after regular tooltips\r\n$form-feedback-tooltip-padding-y: $tooltip-padding-y;\r\n$form-feedback-tooltip-padding-x: $tooltip-padding-x;\r\n$form-feedback-tooltip-font-size: $tooltip-font-size;\r\n$form-feedback-tooltip-line-height: $line-height-base;\r\n$form-feedback-tooltip-opacity: $tooltip-opacity;\r\n$form-feedback-tooltip-border-radius: $tooltip-border-radius;\r\n\r\n\r\n// Popovers\r\n\r\n$popover-font-size: $font-size-sm;\r\n$popover-bg: $white;\r\n$popover-max-width: 276px;\r\n$popover-border-width: $border-width;\r\n$popover-border-color: rgba($black, .2);\r\n$popover-border-radius: $border-radius-lg;\r\n$popover-box-shadow: 0 .25rem .5rem rgba($black, .2);\r\n\r\n$popover-header-bg: darken($popover-bg, 3%);\r\n$popover-header-color: $headings-color;\r\n$popover-header-padding-y: .5rem;\r\n$popover-header-padding-x: .75rem;\r\n\r\n$popover-body-color: $body-color;\r\n$popover-body-padding-y: $popover-header-padding-y;\r\n$popover-body-padding-x: $popover-header-padding-x;\r\n\r\n$popover-arrow-width: 1rem;\r\n$popover-arrow-height: .5rem;\r\n$popover-arrow-color: $popover-bg;\r\n\r\n$popover-arrow-outer-color: fade-in($popover-border-color, .05);\r\n\r\n\r\n// Toasts\r\n\r\n$toast-max-width: 350px;\r\n$toast-padding-x: .75rem;\r\n$toast-padding-y: .25rem;\r\n$toast-font-size: .875rem;\r\n$toast-color: null;\r\n$toast-background-color: rgba($white, .85);\r\n$toast-border-width: 1px;\r\n$toast-border-color: rgba(0, 0, 0, .1);\r\n$toast-border-radius: .25rem;\r\n$toast-box-shadow: 0 .25rem .75rem rgba($black, .1);\r\n\r\n$toast-header-color: $gray-600;\r\n$toast-header-background-color: rgba($white, .85);\r\n$toast-header-border-color: rgba(0, 0, 0, .05);\r\n\r\n\r\n// Badges\r\n\r\n$badge-font-size: 75%;\r\n$badge-font-weight: $font-weight-bold;\r\n$badge-padding-y: .25em;\r\n$badge-padding-x: .4em;\r\n$badge-border-radius: $border-radius;\r\n\r\n$badge-transition: $btn-transition;\r\n$badge-focus-width: $input-btn-focus-width;\r\n\r\n$badge-pill-padding-x: .6em;\r\n// Use a higher than normal value to ensure completely rounded edges when\r\n// customizing padding or font-size on labels.\r\n$badge-pill-border-radius: 10rem;\r\n\r\n\r\n// Modals\r\n\r\n// Padding applied to the modal body\r\n$modal-inner-padding: 1rem;\r\n\r\n// Margin between elements in footer, must be lower than or equal to 2 * $modal-inner-padding\r\n$modal-footer-margin-between: .5rem;\r\n\r\n$modal-dialog-margin: .5rem;\r\n$modal-dialog-margin-y-sm-up: 1.75rem;\r\n\r\n$modal-title-line-height: $line-height-base;\r\n\r\n$modal-content-color: null;\r\n$modal-content-bg: $white;\r\n$modal-content-border-color: rgba($black, .2);\r\n$modal-content-border-width: $border-width;\r\n$modal-content-border-radius: $border-radius-lg;\r\n$modal-content-box-shadow-xs: 0 .25rem .5rem rgba($black, .5);\r\n$modal-content-box-shadow-sm-up: 0 .5rem 1rem rgba($black, .5);\r\n\r\n$modal-backdrop-bg: $black;\r\n$modal-backdrop-opacity: .5;\r\n$modal-header-border-color: $border-color;\r\n$modal-footer-border-color: $modal-header-border-color;\r\n$modal-header-border-width: $modal-content-border-width;\r\n$modal-footer-border-width: $modal-header-border-width;\r\n$modal-header-padding-y: 1rem;\r\n$modal-header-padding-x: 1rem;\r\n$modal-header-padding: $modal-header-padding-y $modal-header-padding-x; // Keep this for backwards compatibility\r\n\r\n$modal-xl: 1140px;\r\n$modal-lg: 800px;\r\n$modal-md: 500px;\r\n$modal-sm: 300px;\r\n\r\n$modal-fade-transform: translate(0, -50px);\r\n$modal-show-transform: none;\r\n$modal-transition: transform .3s ease-out;\r\n$modal-scale-transform: scale(1.02);\r\n\r\n\r\n// Alerts\r\n//\r\n// Define alert colors, border radius, and padding.\r\n\r\n$alert-padding-y: .75rem;\r\n$alert-padding-x: 1.25rem;\r\n$alert-margin-bottom: 1rem;\r\n$alert-border-radius: $border-radius;\r\n$alert-link-font-weight: $font-weight-bold;\r\n$alert-border-width: $border-width;\r\n\r\n$alert-bg-level: -10;\r\n$alert-border-level: -9;\r\n$alert-color-level: 6;\r\n\r\n\r\n// Progress bars\r\n\r\n$progress-height: 1rem;\r\n$progress-font-size: $font-size-base * .75;\r\n$progress-bg: $gray-200;\r\n$progress-border-radius: $border-radius;\r\n$progress-box-shadow: inset 0 .1rem .1rem rgba($black, .1);\r\n$progress-bar-color: $white;\r\n$progress-bar-animation-timing: 1s linear infinite;\r\n$progress-bar-transition: width .6s ease;\r\n\r\n\r\n// List group\r\n\r\n$list-group-color: null;\r\n$list-group-bg: $white;\r\n$list-group-border-color: rgba($black, .125);\r\n$list-group-border-width: $border-width;\r\n$list-group-border-radius: $border-radius;\r\n\r\n$list-group-item-padding-y: .75rem;\r\n$list-group-item-padding-x: 1.25rem;\r\n\r\n$list-group-hover-bg: $gray-100;\r\n$list-group-active-color: $component-active-color;\r\n\r\n$list-group-disabled-color: $gray-600;\r\n$list-group-disabled-bg: $list-group-bg;\r\n\r\n$list-group-action-color: $gray-700;\r\n$list-group-action-hover-color: $list-group-action-color;\r\n\r\n$list-group-action-active-color: $body-color;\r\n$list-group-action-active-bg: $gray-200;\r\n\r\n\r\n// Image thumbnails\r\n\r\n$thumbnail-padding: .25rem;\r\n$thumbnail-bg: $body-bg;\r\n$thumbnail-border-width: $border-width;\r\n$thumbnail-border-color: $gray-300;\r\n$thumbnail-border-radius: $border-radius;\r\n$thumbnail-box-shadow: 0 1px 2px rgba($black, .075);\r\n\r\n\r\n// Figures\r\n\r\n$figure-caption-font-size: 90%;\r\n$figure-caption-color: $gray-600;\r\n\r\n\r\n// Breadcrumbs\r\n\r\n$breadcrumb-font-size: null;\r\n\r\n$breadcrumb-padding-y: .75rem;\r\n$breadcrumb-padding-x: 1rem;\r\n$breadcrumb-item-padding: .5rem;\r\n\r\n$breadcrumb-margin-bottom: 1rem;\r\n\r\n$breadcrumb-bg: $gray-200;\r\n$breadcrumb-divider-color: $gray-600;\r\n$breadcrumb-active-color: $gray-600;\r\n$breadcrumb-divider: quote(\"/\");\r\n\r\n$breadcrumb-border-radius: $border-radius;\r\n\r\n\r\n// Carousel\r\n\r\n$carousel-control-color: $white;\r\n$carousel-control-width: 75px;\r\n$carousel-control-opacity: .5;\r\n$carousel-control-hover-opacity: .9;\r\n$carousel-control-transition: opacity .15s ease;\r\n\r\n$carousel-indicator-width: 30px;\r\n$carousel-indicator-height: 3px;\r\n$carousel-indicator-hit-area-height: 10px;\r\n$carousel-indicator-spacer: 3px;\r\n$carousel-indicator-active-bg: $white;\r\n$carousel-indicator-transition: opacity .6s ease;\r\n\r\n$carousel-caption-width: 70%;\r\n$carousel-caption-color: $white;\r\n\r\n$carousel-control-icon-width: 20px;\r\n\r\n$carousel-control-prev-icon-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/></svg>\");\r\n$carousel-control-next-icon-bg: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/></svg>\");\r\n\r\n$carousel-transition-duration: .6s;\r\n$carousel-transition: transform $carousel-transition-duration ease-in-out; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\r\n\r\n\r\n// Spinners\r\n\r\n$spinner-width: 2rem;\r\n$spinner-height: $spinner-width;\r\n$spinner-border-width: .25em;\r\n\r\n$spinner-width-sm: 1rem;\r\n$spinner-height-sm: $spinner-width-sm;\r\n$spinner-border-width-sm: .2em;\r\n\r\n\r\n// Close\r\n\r\n$close-font-size: $font-size-base * 1.5;\r\n$close-font-weight: $font-weight-bold;\r\n$close-color: $black;\r\n$close-text-shadow: 0 1px 0 $white;\r\n","// stylelint-disable property-blacklist, scss/dollar-variable-default\n\n// SCSS RFS mixin\n//\n// Automated responsive font sizes\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/v8.x/LICENSE)\n\n// Configuration\n\n// Base font size\n$rfs-base-font-size: 1.25rem !default;\n$rfs-font-size-unit: rem !default;\n\n@if $rfs-font-size-unit != rem and $rfs-font-size-unit != px {\n  @error \"`#{$rfs-font-size-unit}` is not a valid unit for $rfs-font-size-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where font-size starts decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize font size based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != \"number\" or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-responsive-font-sizes to false\n$enable-responsive-font-sizes: true !default;\n\n// Cache $rfs-base-font-size unit\n$rfs-base-font-size-unit: unit($rfs-base-font-size);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-font-size for calculations\n@if $rfs-base-font-size-unit == \"px\" {\n  $rfs-base-font-size: divide($rfs-base-font-size, $rfs-base-font-size * 0 + 1);\n}\n@else if $rfs-base-font-size-unit == \"rem\" {\n  $rfs-base-font-size: divide($rfs-base-font-size, divide($rfs-base-font-size * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == \"px\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == \"rem\" or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-disable-class {\n  @if $rfs-class == \"disable\" {\n    // Adding an extra class increases specificity, which prevents the media query to override the font size\n    &,\n    .disable-responsive-font-size &,\n    &.disable-responsive-font-size {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-enable-class {\n  @if $rfs-class == \"enable\" {\n    .enable-responsive-font-size &,\n    &.enable-responsive-font-size {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query($mq-value) {\n  @if $rfs-two-dimensional {\n    @media (max-width: #{$mq-value}), (max-height: #{$mq-value}) {\n      @content;\n    }\n  }\n  @else {\n    @media (max-width: #{$mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Responsive font size mixin\n@mixin rfs($fs, $important: false) {\n  // Cache $fs unit\n  $fs-unit: if(type-of($fs) == \"number\", unit($fs), false);\n\n  // Add !important suffix if needed\n  $rfs-suffix: if($important, \" !important\", \"\");\n\n  // If $fs isn't a number (like inherit) or $fs has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n  @if not $fs-unit or $fs-unit != \"\" and $fs-unit != \"px\" and $fs-unit != \"rem\" or $fs == 0 {\n    font-size: #{$fs}#{$rfs-suffix};\n  }\n  @else {\n    // Remove unit from $fs for calculations\n    @if $fs-unit == \"px\" {\n      $fs: divide($fs, $fs * 0 + 1);\n    }\n    @else if $fs-unit == \"rem\" {\n      $fs: divide($fs, divide($fs * 0 + 1, $rfs-rem-value));\n    }\n\n    // Set default font size\n    $rfs-static: if($rfs-font-size-unit == rem, #{divide($fs, $rfs-rem-value)}rem, #{$fs}px);\n\n    // Only add the media query if the font size is bigger than the minimum font size\n    @if $fs <= $rfs-base-font-size or not $enable-responsive-font-sizes {\n      font-size: #{$rfs-static}#{$rfs-suffix};\n    }\n    @else {\n      // Calculate the minimum font size for $fs\n      $fs-min: $rfs-base-font-size + divide($fs - $rfs-base-font-size, $rfs-factor);\n\n      // Calculate difference between $fs and the minimum font size\n      $fs-diff: $fs - $fs-min;\n\n      // Base font-size formatting\n      $min-width: if($rfs-font-size-unit == rem, #{divide($fs-min, $rfs-rem-value)}rem, #{$fs-min}px);\n\n      // Use `vmin` if two-dimensional is enabled\n      $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n      // Calculate the variable width between 0 and $rfs-breakpoint\n      $variable-width: #{divide($fs-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n      // Set the calculated font-size\n      $rfs-fluid: calc(#{$min-width} + #{$variable-width}) #{$rfs-suffix};\n\n      // Breakpoint formatting\n      $mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n\n      @include _rfs-disable-class {\n        font-size: #{$rfs-static}#{$rfs-suffix};\n      }\n\n      @include _rfs-media-query($mq-value) {\n        @include _rfs-enable-class {\n          font-size: $rfs-fluid;\n        }\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n    }\n  }\n}\n\n// The font-size & responsive-font-size mixins use RFS to rescale the font size\n@mixin font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n\n@mixin responsive-font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n\n$grays: () !default;\n$grays: map-merge(\n  (\n    \"100\": $gray-100,\n    \"200\": $gray-200,\n    \"300\": $gray-300,\n    \"400\": $gray-400,\n    \"500\": $gray-500,\n    \"600\": $gray-600,\n    \"700\": $gray-700,\n    \"800\": $gray-800,\n    \"900\": $gray-900\n  ),\n  $grays\n);\n\n$blue:    #007bff !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #e83e8c !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #28a745 !default;\n$teal:    #20c997 !default;\n$cyan:    #17a2b8 !default;\n\n$colors: () !default;\n$colors: map-merge(\n  (\n    \"blue\":       $blue,\n    \"indigo\":     $indigo,\n    \"purple\":     $purple,\n    \"pink\":       $pink,\n    \"red\":        $red,\n    \"orange\":     $orange,\n    \"yellow\":     $yellow,\n    \"green\":      $green,\n    \"teal\":       $teal,\n    \"cyan\":       $cyan,\n    \"white\":      $white,\n    \"gray\":       $gray-600,\n    \"gray-dark\":  $gray-800\n  ),\n  $colors\n);\n\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-800 !default;\n\n$theme-colors: () !default;\n$theme-colors: map-merge(\n  (\n    \"primary\":    $primary,\n    \"secondary\":  $secondary,\n    \"success\":    $success,\n    \"info\":       $info,\n    \"warning\":    $warning,\n    \"danger\":     $danger,\n    \"light\":      $light,\n    \"dark\":       $dark\n  ),\n  $theme-colors\n);\n\n// Set a specific jump point for requesting color jumps\n$theme-color-interval:      8% !default;\n\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\n$yiq-contrasted-threshold:  150 !default;\n\n// Customize the light and dark text colors for use in our YIQ color contrast function.\n$yiq-text-dark:             $gray-900 !default;\n$yiq-text-light:            $white !default;\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                                true !default;\n$enable-rounded:                              true !default;\n$enable-shadows:                              false !default;\n$enable-gradients:                            false !default;\n$enable-transitions:                          true !default;\n$enable-prefers-reduced-motion-media-query:   true !default;\n$enable-hover-media-query:                    false !default; // Deprecated, no longer affects any compiled CSS\n$enable-grid-classes:                         true !default;\n$enable-pointer-cursor-for-buttons:           true !default;\n$enable-print-styles:                         true !default;\n$enable-responsive-font-sizes:                false !default;\n$enable-validation-icons:                     true !default;\n$enable-deprecation-messages:                 true !default;\n\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n$spacer: 1rem !default;\n$spacers: () !default;\n$spacers: map-merge(\n  (\n    0: 0,\n    1: ($spacer * .25),\n    2: ($spacer * .5),\n    3: $spacer,\n    4: ($spacer * 1.5),\n    5: ($spacer * 3)\n  ),\n  $spacers\n);\n\n// This variable affects the `.h-*` and `.w-*` classes.\n$sizes: () !default;\n$sizes: map-merge(\n  (\n    25: 25%,\n    50: 50%,\n    75: 75%,\n    100: 100%,\n    auto: auto\n  ),\n  $sizes\n);\n\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   $white !default;\n$body-color:                $gray-900 !default;\n\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              theme-color(\"primary\") !default;\n$link-decoration:                         none !default;\n$link-hover-color:                        darken($link-color, 15%) !default;\n$link-hover-decoration:                   underline !default;\n// Darken percentage for links with `.text-*` class (e.g. `.text-success`)\n$emphasized-link-hover-darken-percentage: 15% !default;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px\n) !default;\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px\n) !default;\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           30px !default;\n$grid-row-columns:            6 !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n$line-height-lg:              1.5 !default;\n$line-height-sm:              1.5 !default;\n\n$border-width:                1px !default;\n$border-color:                $gray-300 !default;\n\n$border-radius:               .25rem !default;\n$border-radius-lg:            .3rem !default;\n$border-radius-sm:            .2rem !default;\n\n$rounded-pill:                50rem !default;\n\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n\n$component-active-color:      $white !default;\n$component-active-bg:         theme-color(\"primary\") !default;\n\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n\n$embed-responsive-aspect-ratios: () !default;\n$embed-responsive-aspect-ratios: join(\n  (\n    (21 9),\n    (16 9),\n    (4 3),\n    (1 1),\n  ),\n  $embed-responsive-aspect-ratios\n);\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n$font-family-base:            $font-family-sans-serif !default;\n// stylelint-enable value-keyword-case\n\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-lg:                $font-size-base * 1.25 !default;\n$font-size-sm:                $font-size-base * .875 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n$line-height-base:            1.5 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              null !default;\n\n$display1-size:               6rem !default;\n$display2-size:               5.5rem !default;\n$display3-size:               4.5rem !default;\n$display4-size:               3.5rem !default;\n\n$display1-weight:             300 !default;\n$display2-weight:             300 !default;\n$display3-weight:             300 !default;\n$display4-weight:             300 !default;\n$display-line-height:         $headings-line-height !default;\n\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$text-muted:                  $gray-600 !default;\n\n$blockquote-small-color:      $gray-600 !default;\n$blockquote-small-font-size:  $small-font-size !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n\n$hr-border-color:             rgba($black, .1) !default;\n$hr-border-width:             $border-width !default;\n\n$mark-padding:                .2em !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$kbd-box-shadow:              inset 0 -.1rem 0 rgba($black, .25) !default;\n$nested-kbd-font-weight:      $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-bg:                     #fcf8e3 !default;\n\n$hr-margin-y:                 $spacer !default;\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n$table-cell-padding:          .75rem !default;\n$table-cell-padding-sm:       .3rem !default;\n\n$table-color:                 $body-color !default;\n$table-bg:                    null !default;\n$table-accent-bg:             rgba($black, .05) !default;\n$table-hover-color:           $table-color !default;\n$table-hover-bg:              rgba($black, .075) !default;\n$table-active-bg:             $table-hover-bg !default;\n\n$table-border-width:          $border-width !default;\n$table-border-color:          $border-color !default;\n\n$table-head-bg:               $gray-200 !default;\n$table-head-color:            $gray-700 !default;\n$table-th-font-weight:        null !default;\n\n$table-dark-color:            $white !default;\n$table-dark-bg:               $gray-800 !default;\n$table-dark-accent-bg:        rgba($white, .05) !default;\n$table-dark-hover-color:      $table-dark-color !default;\n$table-dark-hover-bg:         rgba($white, .075) !default;\n$table-dark-border-color:     lighten($table-dark-bg, 7.5%) !default;\n\n$table-striped-order:         odd !default;\n\n$table-caption-color:         $text-muted !default;\n\n$table-bg-level:              -9 !default;\n$table-border-level:          -6 !default;\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:       .2rem !default;\n$input-btn-focus-color:       rgba($component-active-bg, .25) !default;\n$input-btn-focus-box-shadow:  0 0 0 $input-btn-focus-width $input-btn-focus-color !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n$input-btn-line-height-sm:    $line-height-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n$input-btn-line-height-lg:    $line-height-lg !default;\n\n$input-btn-border-width:      $border-width !default;\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n$btn-line-height-sm:          $input-btn-line-height-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n$btn-line-height-lg:          $input-btn-line-height-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-disabled-color:     $gray-600 !default;\n\n$btn-block-spacing-y:         .5rem !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius !default;\n$btn-border-radius-lg:        $border-radius-lg !default;\n$btn-border-radius-sm:        $border-radius-sm !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n\n// Forms\n\n$label-margin-bottom:                   .5rem !default;\n\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n$input-line-height-sm:                  $input-btn-line-height-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n$input-line-height-lg:                  $input-btn-line-height-lg !default;\n\n$input-bg:                              $white !default;\n$input-disabled-bg:                     $gray-200 !default;\n\n$input-color:                           $gray-700 !default;\n$input-border-color:                    $gray-400 !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      inset 0 1px 1px rgba($black, .075) !default;\n\n$input-border-radius:                   $border-radius !default;\n$input-border-radius-lg:                $border-radius-lg !default;\n$input-border-radius-sm:                $border-radius-sm !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              lighten($component-active-bg, 25%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               $gray-600 !default;\n$input-plaintext-color:                 $body-color !default;\n\n$input-height-border:                   $input-border-width * 2 !default;\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height-sm * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height-lg * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-text-margin-top:                  .25rem !default;\n\n$form-check-input-gutter:               1.25rem !default;\n$form-check-input-margin-y:             .3rem !default;\n$form-check-input-margin-x:             .25rem !default;\n\n$form-check-inline-margin-x:            .75rem !default;\n$form-check-inline-input-margin-x:      .3125rem !default;\n\n$form-grid-gutter-width:                10px !default;\n$form-group-margin-bottom:              1rem !default;\n\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  $gray-200 !default;\n$input-group-addon-border-color:        $input-border-color !default;\n\n$custom-forms-transition:               background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$custom-control-gutter:                 .5rem !default;\n$custom-control-spacer-x:               1rem !default;\n$custom-control-cursor:                 null !default;\n\n$custom-control-indicator-size:         1rem !default;\n$custom-control-indicator-bg:           $input-bg !default;\n\n$custom-control-indicator-bg-size:      50% 50% !default;\n$custom-control-indicator-box-shadow:   $input-box-shadow !default;\n$custom-control-indicator-border-color: $gray-500 !default;\n$custom-control-indicator-border-width: $input-border-width !default;\n\n$custom-control-label-color:            null !default;\n\n$custom-control-indicator-disabled-bg:          $input-disabled-bg !default;\n$custom-control-label-disabled-color:           $gray-600 !default;\n\n$custom-control-indicator-checked-color:        $component-active-color !default;\n$custom-control-indicator-checked-bg:           $component-active-bg !default;\n$custom-control-indicator-checked-disabled-bg:  rgba(theme-color(\"primary\"), .5) !default;\n$custom-control-indicator-checked-box-shadow:   null !default;\n$custom-control-indicator-checked-border-color: $custom-control-indicator-checked-bg !default;\n\n$custom-control-indicator-focus-box-shadow:     $input-focus-box-shadow !default;\n$custom-control-indicator-focus-border-color:   $input-focus-border-color !default;\n\n$custom-control-indicator-active-color:         $component-active-color !default;\n$custom-control-indicator-active-bg:            lighten($component-active-bg, 35%) !default;\n$custom-control-indicator-active-box-shadow:    null !default;\n$custom-control-indicator-active-border-color:  $custom-control-indicator-active-bg !default;\n\n$custom-checkbox-indicator-border-radius:       $border-radius !default;\n$custom-checkbox-indicator-icon-checked:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$custom-control-indicator-checked-color}' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/></svg>\") !default;\n\n$custom-checkbox-indicator-indeterminate-bg:           $component-active-bg !default;\n$custom-checkbox-indicator-indeterminate-color:        $custom-control-indicator-checked-color !default;\n$custom-checkbox-indicator-icon-indeterminate:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'><path stroke='#{$custom-checkbox-indicator-indeterminate-color}' d='M0 2h4'/></svg>\") !default;\n$custom-checkbox-indicator-indeterminate-box-shadow:   null !default;\n$custom-checkbox-indicator-indeterminate-border-color: $custom-checkbox-indicator-indeterminate-bg !default;\n\n$custom-radio-indicator-border-radius:          50% !default;\n$custom-radio-indicator-icon-checked:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'><circle r='3' fill='#{$custom-control-indicator-checked-color}'/></svg>\") !default;\n\n$custom-switch-width:                           $custom-control-indicator-size * 1.75 !default;\n$custom-switch-indicator-border-radius:         $custom-control-indicator-size * .5 !default;\n$custom-switch-indicator-size:                  subtract($custom-control-indicator-size, $custom-control-indicator-border-width * 4) !default;\n\n$custom-select-padding-y:           $input-padding-y !default;\n$custom-select-padding-x:           $input-padding-x !default;\n$custom-select-font-family:         $input-font-family !default;\n$custom-select-font-size:           $input-font-size !default;\n$custom-select-height:              $input-height !default;\n$custom-select-indicator-padding:   1rem !default; // Extra padding to account for the presence of the background-image based indicator\n$custom-select-font-weight:         $input-font-weight !default;\n$custom-select-line-height:         $input-line-height !default;\n$custom-select-color:               $input-color !default;\n$custom-select-disabled-color:      $gray-600 !default;\n$custom-select-bg:                  $input-bg !default;\n$custom-select-disabled-bg:         $gray-200 !default;\n$custom-select-bg-size:             8px 10px !default; // In pixels because image dimensions\n$custom-select-indicator-color:     $gray-800 !default;\n$custom-select-indicator:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'><path fill='#{$custom-select-indicator-color}' d='M2 0L0 2h4zm0 5L0 3h4z'/></svg>\") !default;\n$custom-select-background:          escape-svg($custom-select-indicator) right $custom-select-padding-x center / $custom-select-bg-size no-repeat !default; // Used so we can have multiple background elements (e.g., arrow and feedback icon)\n\n$custom-select-feedback-icon-padding-right: add(1em * .75, (2 * $custom-select-padding-y * .75) + $custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-position:      center right ($custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-size:          $input-height-inner-half $input-height-inner-half !default;\n\n$custom-select-border-width:        $input-border-width !default;\n$custom-select-border-color:        $input-border-color !default;\n$custom-select-border-radius:       $border-radius !default;\n$custom-select-box-shadow:          inset 0 1px 2px rgba($black, .075) !default;\n\n$custom-select-focus-border-color:  $input-focus-border-color !default;\n$custom-select-focus-width:         $input-focus-width !default;\n$custom-select-focus-box-shadow:    0 0 0 $custom-select-focus-width $input-btn-focus-color !default;\n\n$custom-select-padding-y-sm:        $input-padding-y-sm !default;\n$custom-select-padding-x-sm:        $input-padding-x-sm !default;\n$custom-select-font-size-sm:        $input-font-size-sm !default;\n$custom-select-height-sm:           $input-height-sm !default;\n\n$custom-select-padding-y-lg:        $input-padding-y-lg !default;\n$custom-select-padding-x-lg:        $input-padding-x-lg !default;\n$custom-select-font-size-lg:        $input-font-size-lg !default;\n$custom-select-height-lg:           $input-height-lg !default;\n\n$custom-range-track-width:          100% !default;\n$custom-range-track-height:         .5rem !default;\n$custom-range-track-cursor:         pointer !default;\n$custom-range-track-bg:             $gray-300 !default;\n$custom-range-track-border-radius:  1rem !default;\n$custom-range-track-box-shadow:     inset 0 .25rem .25rem rgba($black, .1) !default;\n\n$custom-range-thumb-width:                   1rem !default;\n$custom-range-thumb-height:                  $custom-range-thumb-width !default;\n$custom-range-thumb-bg:                      $component-active-bg !default;\n$custom-range-thumb-border:                  0 !default;\n$custom-range-thumb-border-radius:           1rem !default;\n$custom-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$custom-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$custom-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in IE/Edge\n$custom-range-thumb-active-bg:               lighten($component-active-bg, 35%) !default;\n$custom-range-thumb-disabled-bg:             $gray-500 !default;\n\n$custom-file-height:                $input-height !default;\n$custom-file-height-inner:          $input-height-inner !default;\n$custom-file-focus-border-color:    $input-focus-border-color !default;\n$custom-file-focus-box-shadow:      $input-focus-box-shadow !default;\n$custom-file-disabled-bg:           $input-disabled-bg !default;\n\n$custom-file-padding-y:             $input-padding-y !default;\n$custom-file-padding-x:             $input-padding-x !default;\n$custom-file-line-height:           $input-line-height !default;\n$custom-file-font-family:           $input-font-family !default;\n$custom-file-font-weight:           $input-font-weight !default;\n$custom-file-color:                 $input-color !default;\n$custom-file-bg:                    $input-bg !default;\n$custom-file-border-width:          $input-border-width !default;\n$custom-file-border-color:          $input-border-color !default;\n$custom-file-border-radius:         $input-border-radius !default;\n$custom-file-box-shadow:            $input-box-shadow !default;\n$custom-file-button-color:          $custom-file-color !default;\n$custom-file-button-bg:             $input-group-addon-bg !default;\n$custom-file-text: (\n  en: \"Browse\"\n) !default;\n\n\n// Form validation\n\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $small-font-size !default;\n$form-feedback-valid-color:         theme-color(\"success\") !default;\n$form-feedback-invalid-color:       theme-color(\"danger\") !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}' viewBox='0 0 12 12'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n\n$form-validation-states: () !default;\n$form-validation-states: map-merge(\n  (\n    \"valid\": (\n      \"color\": $form-feedback-valid-color,\n      \"icon\": $form-feedback-icon-valid\n    ),\n    \"invalid\": (\n      \"color\": $form-feedback-invalid-color,\n      \"icon\": $form-feedback-icon-invalid\n    ),\n  ),\n  $form-validation-states\n);\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-modal-backdrop:             1040 !default;\n$zindex-modal:                      1050 !default;\n$zindex-popover:                    1060 !default;\n$zindex-tooltip:                    1070 !default;\n\n\n// Navs\n\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-disabled-color:           $gray-600 !default;\n\n$nav-tabs-border-color:             $gray-300 !default;\n$nav-tabs-border-width:             $border-width !default;\n$nav-tabs-border-radius:            $border-radius !default;\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        $gray-700 !default;\n$nav-tabs-link-active-bg:           $body-bg !default;\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           $border-radius !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-divider-color:                 $gray-200 !default;\n$nav-divider-margin-y:              $spacer * .5 !default;\n\n\n// Navbar\n\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  $spacer !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n\n$navbar-nav-scroll-max-height:      75vh !default;\n\n$navbar-dark-color:                 rgba($white, .5) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n\n$navbar-light-color:                rgba($black, .5) !default;\n$navbar-light-hover-color:          rgba($black, .7) !default;\n$navbar-light-active-color:         rgba($black, .9) !default;\n$navbar-light-disabled-color:       rgba($black, .3) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\n\n$navbar-light-brand-color:                $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:          $navbar-light-active-color !default;\n$navbar-dark-brand-color:                 $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color !default;\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    $body-color !default;\n$dropdown-bg:                       $white !default;\n$dropdown-border-color:             rgba($black, .15) !default;\n$dropdown-border-radius:            $border-radius !default;\n$dropdown-border-width:             $border-width !default;\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width) !default;\n$dropdown-divider-bg:               $gray-200 !default;\n$dropdown-divider-margin-y:         $nav-divider-margin-y !default;\n$dropdown-box-shadow:               0 .5rem 1rem rgba($black, .175) !default;\n\n$dropdown-link-color:               $gray-900 !default;\n$dropdown-link-hover-color:         darken($gray-900, 5%) !default;\n$dropdown-link-hover-bg:            $gray-200 !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      $gray-500 !default;\n\n$dropdown-item-padding-y:           .25rem !default;\n$dropdown-item-padding-x:           1.5rem !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding:           $dropdown-padding-y $dropdown-item-padding-x !default;\n\n\n// Pagination\n\n$pagination-padding-y:              .5rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n$pagination-line-height:            1.25 !default;\n\n$pagination-color:                  $link-color !default;\n$pagination-bg:                     $white !default;\n$pagination-border-width:           $border-width !default;\n$pagination-border-color:           $gray-300 !default;\n\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            $link-hover-color !default;\n$pagination-hover-bg:               $gray-200 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            $white !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n\n$pagination-border-radius-sm:       $border-radius-sm !default;\n$pagination-border-radius-lg:       $border-radius-lg !default;\n\n\n// Jumbotron\n\n$jumbotron-padding:                 2rem !default;\n$jumbotron-color:                   null !default;\n$jumbotron-bg:                      $gray-200 !default;\n\n\n// Cards\n\n$card-spacer-y:                     .75rem !default;\n$card-spacer-x:                     1.25rem !default;\n$card-border-width:                 $border-width !default;\n$card-border-radius:                $border-radius !default;\n$card-border-color:                 rgba($black, .125) !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-bg:                       rgba($black, .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           $white !default;\n\n$card-img-overlay-padding:          1.25rem !default;\n\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n$card-deck-margin:                  $card-group-margin !default;\n\n$card-columns-count:                3 !default;\n$card-columns-gap:                  1.25rem !default;\n$card-columns-margin:               $card-spacer-y !default;\n\n\n// Tooltips\n\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     $white !default;\n$tooltip-bg:                        $black !default;\n$tooltip-border-radius:             $border-radius !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 .25rem !default;\n$tooltip-padding-x:                 .5rem !default;\n$tooltip-margin:                    0 !default;\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n$tooltip-arrow-color:               $tooltip-bg !default;\n\n// Form tooltips must come after regular tooltips\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   $line-height-base !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n\n\n// Popovers\n\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        $white !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              $border-width !default;\n$popover-border-color:              rgba($black, .2) !default;\n$popover-border-radius:             $border-radius-lg !default;\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width) !default;\n$popover-box-shadow:                0 .25rem .5rem rgba($black, .2) !default;\n\n$popover-header-bg:                 darken($popover-bg, 3%) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          .75rem !default;\n\n$popover-body-color:                $body-color !default;\n$popover-body-padding-y:            $popover-header-padding-y !default;\n$popover-body-padding-x:            $popover-header-padding-x !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n$popover-arrow-color:               $popover-bg !default;\n\n$popover-arrow-outer-color:         fade-in($popover-border-color, .05) !default;\n\n\n// Toasts\n\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .25rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba($white, .85) !default;\n$toast-border-width:                1px !default;\n$toast-border-color:                rgba(0, 0, 0, .1) !default;\n$toast-border-radius:               .25rem !default;\n$toast-box-shadow:                  0 .25rem .75rem rgba($black, .1) !default;\n\n$toast-header-color:                $gray-600 !default;\n$toast-header-background-color:     rgba($white, .85) !default;\n$toast-header-border-color:         rgba(0, 0, 0, .05) !default;\n\n\n// Badges\n\n$badge-font-size:                   75% !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-padding-y:                   .25em !default;\n$badge-padding-x:                   .4em !default;\n$badge-border-radius:               $border-radius !default;\n\n$badge-transition:                  $btn-transition !default;\n$badge-focus-width:                 $input-btn-focus-width !default;\n\n$badge-pill-padding-x:              .6em !default;\n// Use a higher than normal value to ensure completely rounded edges when\n// customizing padding or font-size on labels.\n$badge-pill-border-radius:          10rem !default;\n\n\n// Modals\n\n// Padding applied to the modal body\n$modal-inner-padding:               1rem !default;\n\n// Margin between elements in footer, must be lower than or equal to 2 * $modal-inner-padding\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  $white !default;\n$modal-content-border-color:        rgba($black, .2) !default;\n$modal-content-border-width:        $border-width !default;\n$modal-content-border-radius:       $border-radius-lg !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       0 .25rem .5rem rgba($black, .5) !default;\n$modal-content-box-shadow-sm-up:    0 .5rem 1rem rgba($black, .5) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n$modal-header-border-color:         $border-color !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n$modal-header-padding-y:            1rem !default;\n$modal-header-padding-x:            1rem !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-xl:                          1140px !default;\n$modal-lg:                          800px !default;\n$modal-md:                          500px !default;\n$modal-sm:                          300px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n$alert-padding-y:                   .75rem !default;\n$alert-padding-x:                   1.25rem !default;\n$alert-margin-bottom:               1rem !default;\n$alert-border-radius:               $border-radius !default;\n$alert-link-font-weight:            $font-weight-bold !default;\n$alert-border-width:                $border-width !default;\n\n$alert-bg-level:                    -10 !default;\n$alert-border-level:                -9 !default;\n$alert-color-level:                 6 !default;\n\n\n// Progress bars\n\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       $gray-200 !default;\n$progress-border-radius:            $border-radius !default;\n$progress-box-shadow:               inset 0 .1rem .1rem rgba($black, .1) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   theme-color(\"primary\") !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n\n\n// List group\n\n$list-group-color:                  null !default;\n$list-group-bg:                     $white !default;\n$list-group-border-color:           rgba($black, .125) !default;\n$list-group-border-width:           $border-width !default;\n$list-group-border-radius:          $border-radius !default;\n\n$list-group-item-padding-y:         .75rem !default;\n$list-group-item-padding-x:         1.25rem !default;\n\n$list-group-hover-bg:               $gray-100 !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         $gray-600 !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           $gray-700 !default;\n$list-group-action-hover-color:     $list-group-action-color !default;\n\n$list-group-action-active-color:    $body-color !default;\n$list-group-action-active-bg:       $gray-200 !default;\n\n\n// Image thumbnails\n\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      $body-bg !default;\n$thumbnail-border-width:            $border-width !default;\n$thumbnail-border-color:            $gray-300 !default;\n$thumbnail-border-radius:           $border-radius !default;\n$thumbnail-box-shadow:              0 1px 2px rgba($black, .075) !default;\n\n\n// Figures\n\n$figure-caption-font-size:          90% !default;\n$figure-caption-color:              $gray-600 !default;\n\n\n// Breadcrumbs\n\n$breadcrumb-font-size:              null !default;\n\n$breadcrumb-padding-y:              .75rem !default;\n$breadcrumb-padding-x:              1rem !default;\n$breadcrumb-item-padding:           .5rem !default;\n\n$breadcrumb-margin-bottom:          1rem !default;\n\n$breadcrumb-bg:                     $gray-200 !default;\n$breadcrumb-divider-color:          $gray-600 !default;\n$breadcrumb-active-color:           $gray-600 !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n\n$breadcrumb-border-radius:          $border-radius !default;\n\n\n// Carousel\n\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n\n$carousel-control-icon-width:        20px !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n\n// Spinners\n\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n\n\n// Close\n\n$close-font-size:                   $font-size-base * 1.5 !default;\n$close-font-weight:                 $font-weight-bold !default;\n$close-color:                       $black !default;\n$close-text-shadow:                 0 1px 0 $white !default;\n\n\n// Code\n\n$code-font-size:                    87.5% !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .2rem !default;\n$kbd-padding-x:                     .4rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         $white !default;\n$kbd-bg:                            $gray-900 !default;\n\n$pre-color:                         $gray-900 !default;\n$pre-scrollable-max-height:         340px !default;\n\n\n// Utilities\n\n$displays: none, inline, inline-block, block, table, table-row, table-cell, flex, inline-flex !default;\n$overflows: auto, hidden !default;\n$positions: static, relative, absolute, fixed, sticky !default;\n$user-selects: all, auto, none !default;\n\n\n// Printing\n\n$print-page-size:                   a3 !default;\n$print-body-min-width:              map-get($grid-breakpoints, \"lg\") !default;\n","// Hover mixin and `$enable-hover-media-query` are deprecated.\n//\n// Originally added during our alphas and maintained during betas, this mixin was\n// designed to prevent `:hover` stickiness on iOS-an issue where hover styles\n// would persist after initial touch.\n//\n// For backward compatibility, we've kept these mixins and updated them to\n// always return their regular pseudo-classes instead of a shimmed media query.\n//\n// Issue: https://github.com/twbs/bootstrap/issues/25195\n\n@mixin hover() {\n  &:hover { @content; }\n}\n\n@mixin hover-focus() {\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin plain-hover-focus() {\n  &,\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin hover-focus-active() {\n  &:hover,\n  &:focus,\n  &:active {\n    @content;\n  }\n}\n","// stylelint-disable selector-list-comma-newline-after\n\n//\n// Headings\n//\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: $headings-color;\n}\n\nh1, .h1 { @include font-size($h1-font-size); }\nh2, .h2 { @include font-size($h2-font-size); }\nh3, .h3 { @include font-size($h3-font-size); }\nh4, .h4 { @include font-size($h4-font-size); }\nh5, .h5 { @include font-size($h5-font-size); }\nh6, .h6 { @include font-size($h6-font-size); }\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n.display-1 {\n  @include font-size($display1-size);\n  font-weight: $display1-weight;\n  line-height: $display-line-height;\n}\n.display-2 {\n  @include font-size($display2-size);\n  font-weight: $display2-weight;\n  line-height: $display-line-height;\n}\n.display-3 {\n  @include font-size($display3-size);\n  font-weight: $display3-weight;\n  line-height: $display-line-height;\n}\n.display-4 {\n  @include font-size($display4-size);\n  font-weight: $display4-weight;\n  line-height: $display-line-height;\n}\n\n\n//\n// Horizontal rules\n//\n\nhr {\n  margin-top: $hr-margin-y;\n  margin-bottom: $hr-margin-y;\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n}\n\n\n//\n// Emphasis\n//\n\nsmall,\n.small {\n  @include font-size($small-font-size);\n  font-weight: $font-weight-normal;\n}\n\nmark,\n.mark {\n  padding: $mark-padding;\n  background-color: $mark-bg;\n}\n\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size(90%);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $spacer;\n  @include font-size($blockquote-font-size);\n}\n\n.blockquote-footer {\n  display: block;\n  @include font-size($blockquote-small-font-size);\n  color: $blockquote-small-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled() {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid() {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n\n\n// Retina image\n//\n// Short retina mixin for setting background-image and -size.\n\n@mixin img-retina($file-1x, $file-2x, $width-1x, $height-1x) {\n  background-image: url($file-1x);\n\n  // Autoprefixer takes care of adding -webkit-min-device-pixel-ratio and -o-min-device-pixel-ratio,\n  // but doesn't convert dppx=>dpi.\n  // There's no such thing as unprefixed min-device-pixel-ratio since it's nonstandard.\n  // Compatibility info: https://caniuse.com/css-media-resolution\n  @media only screen and (min-resolution: 192dpi), // IE9-11 don't support dppx\n    only screen and (min-resolution: 2dppx) { // Standardized\n    background-image: url($file-2x);\n    background-size: $width-1x $height-1x;\n  }\n  @include deprecate(\"`img-retina()`\", \"v4.3.0\", \"v5\");\n}\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-right-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-left-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n","// Inline code\ncode {\n  @include font-size($code-font-size);\n  color: $code-color;\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\n// User input typically entered via keyboard\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n  @include box-shadow($kbd-box-shadow);\n\n  kbd {\n    padding: 0;\n    @include font-size(100%);\n    font-weight: $nested-kbd-font-weight;\n    @include box-shadow(none);\n  }\n}\n\n// Blocks of code\npre {\n  display: block;\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\n// Enable scrollable blocks of code\n.pre-scrollable {\n  max-height: $pre-scrollable-max-height;\n  overflow-y: scroll;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-grid-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Row\n//\n// Rows contain your columns.\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n  }\n\n  // Remove the negative margin from default .row, then the horizontal padding\n  // from all immediate children columns (to prevent runaway style inheritance).\n  .no-gutters {\n    margin-right: 0;\n    margin-left: 0;\n\n    > .col,\n    > [class*=\"col-\"] {\n      padding-right: 0;\n      padding-left: 0;\n    }\n  }\n}\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","/// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-container($gutter: $grid-gutter-width) {\n  width: 100%;\n  padding-right: $gutter * .5;\n  padding-left: $gutter * .5;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$gutter * .5;\n  margin-left: -$gutter * .5;\n}\n\n// For each breakpoint, define the maximum width of the container in a media query\n@mixin make-container-max-widths($max-widths: $container-max-widths, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint, $container-max-width in $max-widths {\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      max-width: $container-max-width;\n    }\n  }\n  @include deprecate(\"The `make-container-max-widths` mixin\", \"v4.5.2\", \"v5\");\n}\n\n@mixin make-col-ready($gutter: $grid-gutter-width) {\n  position: relative;\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we use `flex` values\n  // later on to override this initial width.\n  width: 100%;\n  padding-right: $gutter * .5;\n  padding-left: $gutter * .5;\n}\n\n@mixin make-col($size, $columns: $grid-columns) {\n  flex: 0 0 percentage(divide($size, $columns));\n  // Add a `max-width` to ensure content within each column does not blow out\n  // the width of the column. Applies to IE10+ and Firefox. Chrome and Safari\n  // do not appear to require this.\n  max-width: percentage(divide($size, $columns));\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: 100%; // Reset earlier grid tiers\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// numberof columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 divide(100%, $count);\n    max-width: divide(100%, $count);\n  }\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @return if($n != null and $n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width. Null for the largest (last) breakpoint.\n// The maximum value is calculated as the minimum of the next one less 0.02px\n// to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $next: breakpoint-next($name, $breakpoints);\n  @return if($next, breakpoint-min($next, $breakpoints) - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  $max: breakpoint-max($name, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($name, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  // Common properties for all breakpoints\n  %grid-column {\n    position: relative;\n    width: 100%;\n    padding-right: $gutter * .5;\n    padding-left: $gutter * .5;\n  }\n\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @if $columns > 0 {\n      // Allow columns to stretch full width below their breakpoints\n      @for $i from 1 through $columns {\n        .col#{$infix}-#{$i} {\n          @extend %grid-column;\n        }\n      }\n    }\n\n    .col#{$infix},\n    .col#{$infix}-auto {\n      @extend %grid-column;\n    }\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex-basis: 0;\n        flex-grow: 1;\n        max-width: 100%;\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n      }\n\n      .order#{$infix}-first { order: -1; }\n\n      .order#{$infix}-last { order: $columns + 1; }\n\n      @for $i from 0 through $columns {\n        .order#{$infix}-#{$i} { order: $i; }\n      }\n\n      @if $columns > 0 {\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  width: 100%;\n  margin-bottom: $spacer;\n  color: $table-color;\n  background-color: $table-bg; // Reset for nesting within parents with `background-color`.\n\n  th,\n  td {\n    padding: $table-cell-padding;\n    vertical-align: top;\n    border-top: $table-border-width solid $table-border-color;\n  }\n\n  thead th {\n    vertical-align: bottom;\n    border-bottom: (2 * $table-border-width) solid $table-border-color;\n  }\n\n  tbody + tbody {\n    border-top: (2 * $table-border-width) solid $table-border-color;\n  }\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  th,\n  td {\n    padding: $table-cell-padding-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n\n.table-bordered {\n  border: $table-border-width solid $table-border-color;\n\n  th,\n  td {\n    border: $table-border-width solid $table-border-color;\n  }\n\n  thead {\n    th,\n    td {\n      border-bottom-width: 2 * $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  th,\n  td,\n  thead th,\n  tbody + tbody {\n    border: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n.table-striped {\n  tbody tr:nth-of-type(#{$table-striped-order}) {\n    background-color: $table-accent-bg;\n  }\n}\n\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  tbody tr {\n    @include hover() {\n      color: $table-hover-color;\n      background-color: $table-hover-bg;\n    }\n  }\n}\n\n\n// Table backgrounds\n//\n// Exact selectors below required to override `.table-striped` and prevent\n// inheritance to nested tables.\n\n@each $color, $value in $theme-colors {\n  @include table-row-variant($color, theme-color-level($color, $table-bg-level), theme-color-level($color, $table-border-level));\n}\n\n@include table-row-variant(active, $table-active-bg);\n\n\n// Dark styles\n//\n// Same table markup, but inverted color scheme: dark background and light text.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.table {\n  .thead-dark {\n    th {\n      color: $table-dark-color;\n      background-color: $table-dark-bg;\n      border-color: $table-dark-border-color;\n    }\n  }\n\n  .thead-light {\n    th {\n      color: $table-head-color;\n      background-color: $table-head-bg;\n      border-color: $table-border-color;\n    }\n  }\n}\n\n.table-dark {\n  color: $table-dark-color;\n  background-color: $table-dark-bg;\n\n  th,\n  td,\n  thead th {\n    border-color: $table-dark-border-color;\n  }\n\n  &.table-bordered {\n    border: 0;\n  }\n\n  &.table-striped {\n    tbody tr:nth-of-type(#{$table-striped-order}) {\n      background-color: $table-dark-accent-bg;\n    }\n  }\n\n  &.table-hover {\n    tbody tr {\n      @include hover() {\n        color: $table-dark-hover-color;\n        background-color: $table-dark-hover-bg;\n      }\n    }\n  }\n}\n\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n.table-responsive {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n\n        // Prevent double border on horizontal scroll due to use of `display: block;`\n        > .table-bordered {\n          border: 0;\n        }\n      }\n    }\n  }\n}\n","// Tables\n\n@mixin table-row-variant($state, $background, $border: null) {\n  // Exact selectors below required to override `.table-striped` and prevent\n  // inheritance to nested tables.\n  .table-#{$state} {\n    &,\n    > th,\n    > td {\n      background-color: $background;\n    }\n\n    @if $border != null {\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $border;\n      }\n    }\n  }\n\n  // Hover states for `.table-hover`\n  // Note: this is not available for cells or rows within `thead` or `tfoot`.\n  .table-hover {\n    $hover-background: darken($background, 5%);\n\n    .table-#{$state} {\n      @include hover() {\n        background-color: $hover-background;\n\n        > td,\n        > th {\n          background-color: $hover-background;\n        }\n      }\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Textual form controls\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: $input-height;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  // Unstyle the caret on `<select>`s in IE10+.\n  &::-ms-expand {\n    background-color: transparent;\n    border: 0;\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  @include form-control-focus($ignore-warning: true);\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled and read-only inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled,\n  &[readonly] {\n    background-color: $input-disabled-bg;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n}\n\ninput[type=\"date\"],\ninput[type=\"time\"],\ninput[type=\"datetime-local\"],\ninput[type=\"month\"] {\n  &.form-control {\n    appearance: none; // Fix appearance for date inputs in Safari\n  }\n}\n\nselect.form-control {\n  // Remove select outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $input-color;\n  }\n\n  &:focus::-ms-value {\n    // Suppress the nested default white text on blue background highlight given to\n    // the selected option text when the (still closed) <select> receives focus\n    // in IE and (under certain conditions) Edge, as it looks bad and cannot be made to\n    // match the appearance of the native widget.\n    // See https://github.com/twbs/bootstrap/issues/19398.\n    color: $input-color;\n    background-color: $input-bg;\n  }\n}\n\n// Make file inputs better match text inputs by forcing them to new lines.\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%;\n}\n\n\n//\n// Labels\n//\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<label>/<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  line-height: $input-line-height;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n}\n\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  @include font-size($input-font-size);\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.form-control-lg {\n  height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n// stylelint-disable-next-line no-duplicate-selectors\nselect.form-control {\n  &[size],\n  &[multiple] {\n    height: auto;\n  }\n}\n\ntextarea.form-control {\n  height: auto;\n}\n\n// Form groups\n//\n// Designed to help with the organization and spacing of vertical forms. For\n// horizontal forms, use the predefined grid classes.\n\n.form-group {\n  margin-bottom: $form-group-margin-bottom;\n}\n\n.form-text {\n  display: block;\n  margin-top: $form-text-margin-top;\n}\n\n\n// Form grid\n//\n// Special replacement for our grid system's `.row` for tighter form layouts.\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$form-grid-gutter-width * .5;\n  margin-left: -$form-grid-gutter-width * .5;\n\n  > .col,\n  > [class*=\"col-\"] {\n    padding-right: $form-grid-gutter-width * .5;\n    padding-left: $form-grid-gutter-width * .5;\n  }\n}\n\n\n// Checkboxes and radios\n//\n// Indent the labels to position radios/checkboxes as hanging controls.\n\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: $form-check-input-gutter;\n}\n\n.form-check-input {\n  position: absolute;\n  margin-top: $form-check-input-margin-y;\n  margin-left: -$form-check-input-gutter;\n\n  // Use [disabled] and :disabled for workaround https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .form-check-label,\n  &:disabled ~ .form-check-label {\n    color: $text-muted;\n  }\n}\n\n.form-check-label {\n  margin-bottom: 0; // Override default `<label>` bottom margin\n}\n\n.form-check-inline {\n  display: inline-flex;\n  align-items: center;\n  padding-left: 0; // Override base .form-check\n  margin-right: $form-check-inline-margin-x;\n\n  // Undo .form-check-input defaults and add some `margin-right`.\n  .form-check-input {\n    position: static;\n    margin-top: 0;\n    margin-right: $form-check-inline-input-margin-x;\n    margin-left: 0;\n  }\n}\n\n\n// Form validation\n//\n// Provide feedback to users when form field values are valid or invalid. Works\n// primarily for client-side validation via scoped `:invalid` and `:valid`\n// pseudo-classes but also includes `.is-invalid` and `.is-valid` classes for\n// server side validation.\n\n@each $state, $data in $form-validation-states {\n  @include form-validation-state($state, map-get($data, color), map-get($data, icon));\n}\n\n// Inline forms\n//\n// Make forms appear inline(-block) by adding the `.form-inline` class. Inline\n// forms begin stacked on extra small (mobile) devices and then go inline when\n// viewports reach <768px.\n//\n// Requires wrapping inputs and labels with `.form-group` for proper display of\n// default HTML form controls and our custom form controls (e.g., input groups).\n\n.form-inline {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center; // Prevent shorter elements from growing to same height as others (e.g., small buttons growing to normal sized button height)\n\n  // Because we use flex, the initial sizing of checkboxes is collapsed and\n  // doesn't occupy the full-width (which is what we want for xs grid tier),\n  // so we force that here.\n  .form-check {\n    width: 100%;\n  }\n\n  // Kick in the inline\n  @include media-breakpoint-up(sm) {\n    label {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-bottom: 0;\n    }\n\n    // Inline-block all the things for \"inline\"\n    .form-group {\n      display: flex;\n      flex: 0 0 auto;\n      flex-flow: row wrap;\n      align-items: center;\n      margin-bottom: 0;\n    }\n\n    // Allow folks to *not* use `.form-group`\n    .form-control {\n      display: inline-block;\n      width: auto; // Prevent labels from stacking above inputs in `.form-group`\n      vertical-align: middle;\n    }\n\n    // Make static controls behave like regular ones\n    .form-control-plaintext {\n      display: inline-block;\n    }\n\n    .input-group,\n    .custom-select {\n      width: auto;\n    }\n\n    // Remove default margin on radios/checkboxes that were used for stacking, and\n    // then undo the floating of radios and checkboxes to match.\n    .form-check {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: auto;\n      padding-left: 0;\n    }\n    .form-check-input {\n      position: relative;\n      flex-shrink: 0;\n      margin-top: 0;\n      margin-right: $form-check-input-margin-x;\n      margin-left: 0;\n    }\n\n    .custom-control {\n      align-items: center;\n      justify-content: center;\n    }\n    .custom-control-label {\n      margin-bottom: 0;\n    }\n  }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-prefers-reduced-motion-media-query and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Form control focus state\n//\n// Generate a customized focus state and for any input with the specified color,\n// which defaults to the `$input-focus-border-color` variable.\n//\n// We highly encourage you to not customize the default value, but instead use\n// this to tweak colors on an as-needed basis. This aesthetic change is based on\n// WebKit's default styles, but applicable to a wider range of browsers. Its\n// usability and accessibility should be taken into account with any change.\n//\n// Example usage: change the default blue border and shadow to white for better\n// contrast against a dark gray background.\n@mixin form-control-focus($ignore-warning: false) {\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n  @include deprecate(\"The `form-control-focus()` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n\n// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state($state, $color, $icon) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: color-yiq($color);\n    background-color: rgba($color, $form-feedback-tooltip-opacity);\n    @include border-radius($form-feedback-tooltip-border-radius);\n\n    // See https://github.com/twbs/bootstrap/pull/31557\n    // Align tooltip to form elements\n    .form-row > .col > &,\n    .form-row > [class*=\"col-\"] > & {\n      left: $form-grid-gutter-width * .5;\n    }\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner !important; // stylelint-disable-line declaration-no-important\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  select.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-padding-x * 4 !important; // stylelint-disable-line declaration-no-important\n        background-position: right $input-padding-x * 2 center;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .custom-select {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $custom-select-feedback-icon-padding-right !important; // stylelint-disable-line declaration-no-important\n        background: $custom-select-background, $custom-select-bg escape-svg($icon) $custom-select-feedback-icon-position / $custom-select-feedback-icon-size no-repeat;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      ~ .form-check-label {\n        color: $color;\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n    }\n  }\n\n  .custom-control-input {\n    @include form-validation-state-selector($state) {\n      ~ .custom-control-label {\n        color: $color;\n\n        &::before {\n          border-color: $color;\n        }\n      }\n\n      &:checked {\n        ~ .custom-control-label::before {\n          border-color: lighten($color, 10%);\n          @include gradient-bg(lighten($color, 10%));\n        }\n      }\n\n      &:focus {\n        ~ .custom-control-label::before {\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n        }\n\n        &:not(:checked) ~ .custom-control-label::before {\n          border-color: $color;\n        }\n      }\n    }\n  }\n\n  // custom file\n  .custom-file-input {\n    @include form-validation-state-selector($state) {\n      ~ .custom-file-label {\n        border-color: $color;\n      }\n\n      &:focus {\n        ~ .custom-file-label {\n          border-color: $color;\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n        }\n      }\n    }\n  }\n}\n","// Gradients\n\n@mixin gradient-bg($color) {\n  @if $enable-gradients {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x;\n  } @else {\n    background-color: $color;\n  }\n}\n\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n  background-repeat: repeat-x;\n}\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.btn {\n  display: inline-block;\n  font-family: $btn-font-family;\n  font-weight: $btn-font-weight;\n  color: $body-color;\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  user-select: none;\n  background-color: transparent;\n  border: $btn-border-width solid transparent;\n  @include button-size($btn-padding-y, $btn-padding-x, $btn-font-size, $btn-line-height, $btn-border-radius);\n  @include transition($btn-transition);\n\n  @include hover() {\n    color: $body-color;\n    text-decoration: none;\n  }\n\n  &:focus,\n  &.focus {\n    outline: 0;\n    box-shadow: $btn-focus-box-shadow;\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    opacity: $btn-disabled-opacity;\n    @include box-shadow(none);\n  }\n\n  &:not(:disabled):not(.disabled) {\n    cursor: if($enable-pointer-cursor-for-buttons, pointer, null);\n\n    &:active,\n    &.active {\n      @include box-shadow($btn-active-box-shadow);\n\n      &:focus {\n        @include box-shadow($btn-focus-box-shadow, $btn-active-box-shadow);\n      }\n    }\n  }\n}\n\n// Future-proof disabling of clicks on `<a>` elements\na.btn.disabled,\nfieldset:disabled a.btn {\n  pointer-events: none;\n}\n\n\n//\n// Alternate buttons\n//\n\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  font-weight: $font-weight-normal;\n  color: $link-color;\n  text-decoration: $link-decoration;\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus,\n  &.focus {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $btn-link-disabled-color;\n    pointer-events: none;\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-line-height-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-line-height-sm, $btn-border-radius-sm);\n}\n\n\n//\n// Block button\n//\n\n.btn-block {\n  display: block;\n  width: 100%;\n\n  // Vertically space out multiple block buttons\n  + .btn-block {\n    margin-top: $btn-block-spacing-y;\n  }\n}\n\n// Specificity overrides\ninput[type=\"submit\"],\ninput[type=\"reset\"],\ninput[type=\"button\"] {\n  &.btn-block {\n    width: 100%;\n  }\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n@mixin button-variant($background, $border, $hover-background: darken($background, 7.5%), $hover-border: darken($border, 10%), $active-background: darken($background, 10%), $active-border: darken($border, 12.5%)) {\n  color: color-yiq($background);\n  @include gradient-bg($background);\n  border-color: $border;\n  @include box-shadow($btn-box-shadow);\n\n  @include hover() {\n    color: color-yiq($hover-background);\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n  }\n\n  &:focus,\n  &.focus {\n    color: color-yiq($hover-background);\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n    @if $enable-shadows {\n      @include box-shadow($btn-box-shadow, 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5));\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5);\n    }\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    color: color-yiq($background);\n    background-color: $background;\n    border-color: $border;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    @if $enable-gradients {\n      background-image: none; // Remove the gradient for the pressed/active state\n    }\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5);\n      }\n    }\n  }\n}\n\n@mixin button-outline-variant($color, $color-hover: color-yiq($color), $active-background: $color, $active-border: $color) {\n  color: $color;\n  border-color: $color;\n\n  @include hover() {\n    color: $color-hover;\n    background-color: $active-background;\n    border-color: $active-border;\n  }\n\n  &:focus,\n  &.focus {\n    box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $color;\n    background-color: transparent;\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n      }\n    }\n  }\n}\n\n// Button sizes\n@mixin button-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  padding: $padding-y $padding-x;\n  @include font-size($font-size);\n  line-height: $line-height;\n  // Manually declare to provide an override to the browser default\n  @include border-radius($border-radius, 0);\n}\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.width {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropright,\n.dropdown,\n.dropleft {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: $zindex-dropdown;\n  display: none; // none by default, but block on \"open\" of the menu\n  float: left;\n  min-width: $dropdown-min-width;\n  padding: $dropdown-padding-y $dropdown-padding-x;\n  margin: $dropdown-spacer 0 0; // override default ul\n  @include font-size($dropdown-font-size);\n  color: $dropdown-color;\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: $dropdown-bg;\n  background-clip: padding-box;\n  border: $dropdown-border-width solid $dropdown-border-color;\n  @include border-radius($dropdown-border-radius);\n  @include box-shadow($dropdown-box-shadow);\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-left {\n      right: auto;\n      left: 0;\n    }\n\n    .dropdown-menu#{$infix}-right {\n      right: 0;\n      left: auto;\n    }\n  }\n}\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropright {\n  .dropdown-menu {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(right);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropleft {\n  .dropdown-menu {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(left);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n// When Popper is enabled, reset the basic dropdown position\n// stylelint-disable-next-line no-duplicate-selectors\n.dropdown-menu {\n  &[x-placement^=\"top\"],\n  &[x-placement^=\"right\"],\n  &[x-placement^=\"bottom\"],\n  &[x-placement^=\"left\"] {\n    right: auto;\n    bottom: auto;\n  }\n}\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  @include nav-divider($dropdown-divider-bg, $dropdown-divider-margin-y, true);\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: $dropdown-link-color;\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n\n  // Prevent dropdown overflow if there's no padding\n  // See https://github.com/twbs/bootstrap/pull/27703\n  @if $dropdown-padding-y == 0 {\n    &:first-child {\n      @include border-top-radius($dropdown-inner-border-radius);\n    }\n\n    &:last-child {\n      @include border-bottom-radius($dropdown-inner-border-radius);\n    }\n  }\n\n  @include hover-focus() {\n    color: $dropdown-link-hover-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-hover-bg);\n  }\n\n  &.active,\n  &:active {\n    color: $dropdown-link-active-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-active-bg);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $dropdown-link-disabled-color;\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: $dropdown-header-padding;\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: $dropdown-header-color;\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  color: $dropdown-link-color;\n}\n","@mixin caret-down() {\n  border-top: $caret-width solid;\n  border-right: $caret-width solid transparent;\n  border-bottom: 0;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-up() {\n  border-top: 0;\n  border-right: $caret-width solid transparent;\n  border-bottom: $caret-width solid;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-right() {\n  border-top: $caret-width solid transparent;\n  border-right: 0;\n  border-bottom: $caret-width solid transparent;\n  border-left: $caret-width solid;\n}\n\n@mixin caret-left() {\n  border-top: $caret-width solid transparent;\n  border-right: $caret-width solid;\n  border-bottom: $caret-width solid transparent;\n}\n\n@mixin caret($direction: down) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $caret-spacing;\n      vertical-align: $caret-vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down();\n      } @else if $direction == up {\n        @include caret-up();\n      } @else if $direction == right {\n        @include caret-right();\n      }\n    }\n\n    @if $direction == left {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $caret-spacing;\n        vertical-align: $caret-vertical-align;\n        content: \"\";\n        @include caret-left();\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n","// Horizontal dividers\n//\n// Dividers (basically an hr) within dropdowns and nav lists\n\n@mixin nav-divider($color: $nav-divider-color, $margin-y: $nav-divider-margin-y, $ignore-warning: false) {\n  height: 0;\n  margin: $margin-y 0;\n  overflow: hidden;\n  border-top: 1px solid $color;\n  @include deprecate(\"The `nav-divider()` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n\n    // Bring the hover, focused, and \"active\" buttons to the front to overlay\n    // the borders properly\n    @include hover() {\n      z-index: 1;\n    }\n    &:focus,\n    &:active,\n    &.active {\n      z-index: 1;\n    }\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  // Prevent double borders when buttons are next to each other\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-left: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-right-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-left-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropright &::after {\n    margin-left: 0;\n  }\n\n  .dropleft &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n\n\n// Checkbox and radio options\n//\n// In order to support the browser's form validation feedback, powered by the\n// `required` attribute, we have to \"hide\" the inputs via `clip`. We cannot use\n// `display: none;` or `visibility: hidden;` as that also hides the popover.\n// Simply visually hiding the inputs via `opacity` would leave them clickable in\n// certain cases which is prevented by using `clip` and `pointer-events`.\n// This way, we ensure a DOM element is visible to position the popover from.\n//\n// See https://github.com/twbs/bootstrap/pull/12794 and\n// https://github.com/twbs/bootstrap/pull/14559 for more information.\n\n.btn-group-toggle {\n  > .btn,\n  > .btn-group > .btn {\n    margin-bottom: 0; // Override default `<label>` value\n\n    input[type=\"radio\"],\n    input[type=\"checkbox\"] {\n      position: absolute;\n      clip: rect(0, 0, 0, 0);\n      pointer-events: none;\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .custom-select,\n  > .custom-file {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n    margin-bottom: 0;\n\n    + .form-control,\n    + .custom-select,\n    + .custom-file {\n      margin-left: -$input-border-width;\n    }\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .custom-select:focus,\n  > .custom-file .custom-file-input:focus ~ .custom-file-label {\n    z-index: 3;\n  }\n\n  // Bring the custom file input above the label\n  > .custom-file .custom-file-input:focus {\n    z-index: 4;\n  }\n\n  > .form-control,\n  > .custom-select {\n    &:not(:first-child) { @include border-left-radius(0); }\n  }\n\n  // Custom file inputs have more complex markup, thus requiring different\n  // border-radius overrides.\n  > .custom-file {\n    display: flex;\n    align-items: center;\n\n    &:not(:last-child) .custom-file-label,\n    &:not(:last-child) .custom-file-label::after { @include border-right-radius(0); }\n    &:not(:first-child) .custom-file-label { @include border-left-radius(0); }\n  }\n\n  &:not(.has-validation) {\n    > .form-control:not(:last-child),\n    > .custom-select:not(:last-child),\n    > .custom-file:not(:last-child) .custom-file-label,\n    > .custom-file:not(:last-child) .custom-file-label::after {\n      @include border-right-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > .form-control:nth-last-child(n + 3),\n    > .custom-select:nth-last-child(n + 3),\n    > .custom-file:nth-last-child(n + 3) .custom-file-label,\n    > .custom-file:nth-last-child(n + 3) .custom-file-label::after {\n      @include border-right-radius(0);\n    }\n  }\n}\n\n\n// Prepend and append\n//\n// While it requires one extra layer of HTML for each, dedicated prepend and\n// append elements allow us to 1) be less clever, 2) simplify our selectors, and\n// 3) support HTML5 form validation.\n\n.input-group-prepend,\n.input-group-append {\n  display: flex;\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 3;\n    }\n  }\n\n  .btn + .btn,\n  .btn + .input-group-text,\n  .input-group-text + .input-group-text,\n  .input-group-text + .btn {\n    margin-left: -$input-border-width;\n  }\n}\n\n.input-group-prepend { margin-right: -$input-border-width; }\n.input-group-append { margin-left: -$input-border-width; }\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-padding-y $input-padding-x;\n  margin-bottom: 0; // Allow use of <label> elements by overriding our default margin-bottom\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $font-weight-normal;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n\n  // Nuke default margins from checkboxes and radios to vertically center within.\n  input[type=\"radio\"],\n  input[type=\"checkbox\"] {\n    margin-top: 0;\n  }\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control:not(textarea),\n.input-group-lg > .custom-select {\n  height: $input-height-lg;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .custom-select,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control:not(textarea),\n.input-group-sm > .custom-select {\n  height: $input-height-sm;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .custom-select,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .custom-select,\n.input-group-sm > .custom-select {\n  padding-right: $custom-select-padding-x + $custom-select-indicator-padding;\n}\n\n\n// Prepend and append rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text,\n.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .btn,\n.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .input-group-text,\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n  @include border-right-radius(0);\n}\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n  @include border-left-radius(0);\n}\n","// Embedded icons from Open Iconic.\n// Released under MIT and copyright 2014 Waybury.\n// https://useiconic.com/open\n\n\n// Checkboxes and radios\n//\n// Base class takes care of all the key behavioral aspects.\n\n.custom-control {\n  position: relative;\n  z-index: 1;\n  display: block;\n  min-height: $font-size-base * $line-height-base;\n  padding-left: $custom-control-gutter + $custom-control-indicator-size;\n  print-color-adjust: exact; // Keep themed appearance for print\n}\n\n.custom-control-inline {\n  display: inline-flex;\n  margin-right: $custom-control-spacer-x;\n}\n\n.custom-control-input {\n  position: absolute;\n  left: 0;\n  z-index: -1; // Put the input behind the label so it doesn't overlay text\n  width: $custom-control-indicator-size;\n  height: ($font-size-base * $line-height-base + $custom-control-indicator-size) * .5;\n  opacity: 0;\n\n  &:checked ~ .custom-control-label::before {\n    color: $custom-control-indicator-checked-color;\n    border-color: $custom-control-indicator-checked-border-color;\n    @include gradient-bg($custom-control-indicator-checked-bg);\n    @include box-shadow($custom-control-indicator-checked-box-shadow);\n  }\n\n  &:focus ~ .custom-control-label::before {\n    // the mixin is not used here to make sure there is feedback\n    @if $enable-shadows {\n      box-shadow: $input-box-shadow, $custom-control-indicator-focus-box-shadow;\n    } @else {\n      box-shadow: $custom-control-indicator-focus-box-shadow;\n    }\n  }\n\n  &:focus:not(:checked) ~ .custom-control-label::before {\n    border-color: $custom-control-indicator-focus-border-color;\n  }\n\n  &:not(:disabled):active ~ .custom-control-label::before {\n    color: $custom-control-indicator-active-color;\n    background-color: $custom-control-indicator-active-bg;\n    border-color: $custom-control-indicator-active-border-color;\n    @include box-shadow($custom-control-indicator-active-box-shadow);\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .custom-control-label {\n      color: $custom-control-label-disabled-color;\n\n      &::before {\n        background-color: $custom-control-indicator-disabled-bg;\n      }\n    }\n  }\n}\n\n// Custom control indicators\n//\n// Build the custom controls out of pseudo-elements.\n\n.custom-control-label {\n  position: relative;\n  margin-bottom: 0;\n  color: $custom-control-label-color;\n  vertical-align: top;\n  cursor: $custom-control-cursor;\n\n  // Background-color and (when enabled) gradient\n  &::before {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) * .5;\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    pointer-events: none;\n    content: \"\";\n    background-color: $custom-control-indicator-bg;\n    border: $custom-control-indicator-border-width solid $custom-control-indicator-border-color;\n    @include box-shadow($custom-control-indicator-box-shadow);\n  }\n\n  // Foreground (icon)\n  &::after {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) * .5;\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    content: \"\";\n    background: 50% / #{$custom-control-indicator-bg-size} no-repeat;\n  }\n}\n\n\n// Checkboxes\n//\n// Tweak just a few things for checkboxes.\n\n.custom-checkbox {\n  .custom-control-label::before {\n    @include border-radius($custom-checkbox-indicator-border-radius);\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-checked);\n    }\n  }\n\n  .custom-control-input:indeterminate ~ .custom-control-label {\n    &::before {\n      border-color: $custom-checkbox-indicator-indeterminate-border-color;\n      @include gradient-bg($custom-checkbox-indicator-indeterminate-bg);\n      @include box-shadow($custom-checkbox-indicator-indeterminate-box-shadow);\n    }\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-indeterminate);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n    &:indeterminate ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n// Radios\n//\n// Tweak just a few things for radios.\n\n.custom-radio {\n  .custom-control-label::before {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $custom-radio-indicator-border-radius;\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: escape-svg($custom-radio-indicator-icon-checked);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n\n// switches\n//\n// Tweak a few things for switches\n\n.custom-switch {\n  padding-left: $custom-switch-width + $custom-control-gutter;\n\n  .custom-control-label {\n    &::before {\n      left: -($custom-switch-width + $custom-control-gutter);\n      width: $custom-switch-width;\n      pointer-events: all;\n      // stylelint-disable-next-line property-disallowed-list\n      border-radius: $custom-switch-indicator-border-radius;\n    }\n\n    &::after {\n      top: add(($font-size-base * $line-height-base - $custom-control-indicator-size) * .5, $custom-control-indicator-border-width * 2);\n      left: add(-($custom-switch-width + $custom-control-gutter), $custom-control-indicator-border-width * 2);\n      width: $custom-switch-indicator-size;\n      height: $custom-switch-indicator-size;\n      background-color: $custom-control-indicator-border-color;\n      // stylelint-disable-next-line property-disallowed-list\n      border-radius: $custom-switch-indicator-border-radius;\n      @include transition(transform .15s ease-in-out, $custom-forms-transition);\n    }\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-color: $custom-control-indicator-bg;\n      transform: translateX($custom-switch-width - $custom-control-indicator-size);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n\n// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n//\n\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: $custom-select-height;\n  padding: $custom-select-padding-y ($custom-select-padding-x + $custom-select-indicator-padding) $custom-select-padding-y $custom-select-padding-x;\n  font-family: $custom-select-font-family;\n  @include font-size($custom-select-font-size);\n  font-weight: $custom-select-font-weight;\n  line-height: $custom-select-line-height;\n  color: $custom-select-color;\n  vertical-align: middle;\n  background: $custom-select-bg $custom-select-background;\n  border: $custom-select-border-width solid $custom-select-border-color;\n  @include border-radius($custom-select-border-radius, 0);\n  @include box-shadow($custom-select-box-shadow);\n  appearance: none;\n\n  &:focus {\n    border-color: $custom-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($custom-select-box-shadow, $custom-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $custom-select-focus-box-shadow;\n    }\n\n    &::-ms-value {\n      // For visual consistency with other platforms/browsers,\n      // suppress the default white text on blue background highlight given to\n      // the selected option text when the (still closed) <select> receives focus\n      // in IE and (under certain conditions) Edge.\n      // See https://github.com/twbs/bootstrap/issues/19398.\n      color: $input-color;\n      background-color: $input-bg;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    height: auto;\n    padding-right: $custom-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $custom-select-disabled-color;\n    background-color: $custom-select-disabled-bg;\n  }\n\n  // Hides the default caret in IE11\n  &::-ms-expand {\n    display: none;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $custom-select-color;\n  }\n}\n\n.custom-select-sm {\n  height: $custom-select-height-sm;\n  padding-top: $custom-select-padding-y-sm;\n  padding-bottom: $custom-select-padding-y-sm;\n  padding-left: $custom-select-padding-x-sm;\n  @include font-size($custom-select-font-size-sm);\n}\n\n.custom-select-lg {\n  height: $custom-select-height-lg;\n  padding-top: $custom-select-padding-y-lg;\n  padding-bottom: $custom-select-padding-y-lg;\n  padding-left: $custom-select-padding-x-lg;\n  @include font-size($custom-select-font-size-lg);\n}\n\n\n// File\n//\n// Custom file input.\n\n.custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: $custom-file-height;\n  margin-bottom: 0;\n}\n\n.custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: $custom-file-height;\n  margin: 0;\n  overflow: hidden;\n  opacity: 0;\n\n  &:focus ~ .custom-file-label {\n    border-color: $custom-file-focus-border-color;\n    box-shadow: $custom-file-focus-box-shadow;\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .custom-file-label,\n  &:disabled ~ .custom-file-label {\n    background-color: $custom-file-disabled-bg;\n  }\n\n  @each $lang, $value in $custom-file-text {\n    &:lang(#{$lang}) ~ .custom-file-label::after {\n      content: $value;\n    }\n  }\n\n  ~ .custom-file-label[data-browse]::after {\n    content: attr(data-browse);\n  }\n}\n\n.custom-file-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: $custom-file-height;\n  padding: $custom-file-padding-y $custom-file-padding-x;\n  overflow: hidden;\n  font-family: $custom-file-font-family;\n  font-weight: $custom-file-font-weight;\n  line-height: $custom-file-line-height;\n  color: $custom-file-color;\n  background-color: $custom-file-bg;\n  border: $custom-file-border-width solid $custom-file-border-color;\n  @include border-radius($custom-file-border-radius);\n  @include box-shadow($custom-file-box-shadow);\n\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 3;\n    display: block;\n    height: $custom-file-height-inner;\n    padding: $custom-file-padding-y $custom-file-padding-x;\n    line-height: $custom-file-line-height;\n    color: $custom-file-button-color;\n    content: \"Browse\";\n    @include gradient-bg($custom-file-button-bg);\n    border-left: inherit;\n    @include border-radius(0 $custom-file-border-radius $custom-file-border-radius 0);\n  }\n}\n\n// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.custom-range {\n  width: 100%;\n  height: add($custom-range-thumb-height, $custom-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  background-color: transparent;\n  appearance: none;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-ms-thumb            { box-shadow: $custom-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: ($custom-range-track-height - $custom-range-thumb-height) * .5; // Webkit specific\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent; // Why?\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent;\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: 0; // Edge specific\n    margin-right: $custom-range-thumb-focus-box-shadow-width; // Workaround that overflowed box-shadow is hidden.\n    margin-left: $custom-range-thumb-focus-box-shadow-width;  // Workaround that overflowed box-shadow is hidden.\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-ms-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: transparent;\n    border-color: transparent;\n    border-width: $custom-range-thumb-height * .5;\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-fill-lower {\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &::-ms-fill-upper {\n    margin-right: 15px; // arbitrary?\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &:disabled {\n    &::-webkit-slider-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-webkit-slider-runnable-track {\n      cursor: default;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-track {\n      cursor: default;\n    }\n\n    &::-ms-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n  }\n}\n\n.custom-control-label::before,\n.custom-file-label,\n.custom-select {\n  @include transition($custom-forms-transition);\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: $nav-link-padding-y $nav-link-padding-x;\n  text-decoration: if($link-decoration == none, null, none);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n\n  // Disabled state lightens text\n  &.disabled {\n    color: $nav-link-disabled-color;\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  border-bottom: $nav-tabs-border-width solid $nav-tabs-border-color;\n\n  .nav-link {\n    margin-bottom: -$nav-tabs-border-width;\n    background-color: transparent;\n    border: $nav-tabs-border-width solid transparent;\n    @include border-top-radius($nav-tabs-border-radius);\n\n    @include hover-focus() {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: $nav-tabs-link-hover-border-color;\n    }\n\n    &.disabled {\n      color: $nav-link-disabled-color;\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: $nav-tabs-link-active-color;\n    background-color: $nav-tabs-link-active-bg;\n    border-color: $nav-tabs-link-active-border-color;\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: -$nav-tabs-border-width;\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  .nav-link {\n    background: none;\n    border: 0;\n    @include border-radius($nav-pills-border-radius);\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: $nav-pills-link-active-color;\n    background-color: $nav-pills-link-active-bg;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Contents\n//\n// Navbar\n// Navbar brand\n// Navbar nav\n// Navbar text\n// Navbar divider\n// Responsive navbar\n// Navbar position\n// Navbar themes\n\n\n// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: $navbar-padding-y $navbar-padding-x;\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .container,\n  .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  display: inline-block;\n  padding-top: $navbar-brand-padding-y;\n  padding-bottom: $navbar-brand-padding-y;\n  margin-right: $navbar-padding-x;\n  @include font-size($navbar-brand-font-size);\n  line-height: inherit;\n  white-space: nowrap;\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .dropdown-menu {\n    position: static;\n    float: none;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  display: inline-block;\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: $navbar-toggler-padding-y $navbar-toggler-padding-x;\n  @include font-size($navbar-toggler-font-size);\n  line-height: 1;\n  background-color: transparent; // remove default button style\n  border: $border-width solid transparent; // remove default button style\n  @include border-radius($navbar-toggler-border-radius);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: 50% / 100% 100% no-repeat;\n}\n\n.navbar-nav-scroll {\n  max-height: $navbar-nav-scroll-max-height;\n  overflow-y: auto;\n}\n\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        %container-navbar-expand-#{$breakpoint} {\n          padding-right: 0;\n          padding-left: 0;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-navbar-expand-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-navbar-expand-#{$breakpoint};\n          }\n        }\n      }\n\n      @include media-breakpoint-up($next) {\n        flex-flow: row nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: $navbar-nav-link-padding-x;\n            padding-left: $navbar-nav-link-padding-x;\n          }\n        }\n\n        // For nesting containers, have to redeclare for alignment purposes\n        %container-nesting-#{$breakpoint} {\n          flex-wrap: nowrap;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-nesting-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-nesting-#{$breakpoint};\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n\n          // Changes flex-bases to auto because of an IE10 bug\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n// Dark links against a light background\n.navbar-light {\n  .navbar-brand {\n    color: $navbar-light-brand-color;\n\n    @include hover-focus() {\n      color: $navbar-light-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-light-color;\n\n      @include hover-focus() {\n        color: $navbar-light-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-light-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-light-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-light-color;\n    border-color: $navbar-light-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-light-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-light-color;\n    a {\n      color: $navbar-light-active-color;\n\n      @include hover-focus() {\n        color: $navbar-light-active-color;\n      }\n    }\n  }\n}\n\n// White links against a dark background\n.navbar-dark {\n  .navbar-brand {\n    color: $navbar-dark-brand-color;\n\n    @include hover-focus() {\n      color: $navbar-dark-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-dark-color;\n\n      @include hover-focus() {\n        color: $navbar-dark-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-dark-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-dark-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-dark-color;\n    border-color: $navbar-dark-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-dark-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-dark-color;\n    a {\n      color: $navbar-dark-active-color;\n\n      @include hover-focus() {\n        color: $navbar-dark-active-color;\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: $card-height;\n  word-wrap: break-word;\n  background-color: $card-bg;\n  background-clip: border-box;\n  border: $card-border-width solid $card-border-color;\n  @include border-radius($card-border-radius);\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius($card-inner-border-radius);\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius($card-inner-border-radius);\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  // Workaround for the image size bug in IE\n  // See: https://github.com/twbs/bootstrap/pull/28855\n  min-height: 1px;\n  padding: $card-spacer-x;\n  color: $card-color;\n}\n\n.card-title {\n  margin-bottom: $card-spacer-y;\n}\n\n.card-subtitle {\n  margin-top: -$card-spacer-y * .5;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  @include hover() {\n    text-decoration: none;\n  }\n\n  + .card-link {\n    margin-left: $card-spacer-x;\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: $card-spacer-y $card-spacer-x;\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-bottom: $card-border-width solid $card-border-color;\n\n  &:first-child {\n    @include border-radius($card-inner-border-radius $card-inner-border-radius 0 0);\n  }\n}\n\n.card-footer {\n  padding: $card-spacer-y $card-spacer-x;\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-top: $card-border-width solid $card-border-color;\n\n  &:last-child {\n    @include border-radius(0 0 $card-inner-border-radius $card-inner-border-radius);\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: -$card-spacer-x * .5;\n  margin-bottom: -$card-spacer-y;\n  margin-left: -$card-spacer-x * .5;\n  border-bottom: 0;\n}\n\n.card-header-pills {\n  margin-right: -$card-spacer-x * .5;\n  margin-left: -$card-spacer-x * .5;\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: $card-img-overlay-padding;\n  @include border-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  flex-shrink: 0; // For IE: https://github.com/twbs/bootstrap/issues/29396\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius($card-inner-border-radius);\n}\n\n\n// Card deck\n\n.card-deck {\n  .card {\n    margin-bottom: $card-deck-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    margin-right: -$card-deck-margin;\n    margin-left: -$card-deck-margin;\n\n    .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-right: $card-deck-margin;\n      margin-bottom: 0; // Override the default\n      margin-left: $card-deck-margin;\n    }\n  }\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: $card-group-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-right-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-left-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n//\n// Columns\n//\n\n.card-columns {\n  .card {\n    margin-bottom: $card-columns-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    column-count: $card-columns-count;\n    column-gap: $card-columns-gap;\n    orphans: 1;\n    widows: 1;\n\n    .card {\n      display: inline-block; // Don't let them vertically span multiple columns\n      width: 100%; // Don't let their width change\n    }\n  }\n}\n\n\n//\n// Accordion\n//\n\n.accordion {\n  overflow-anchor: none;\n\n  > .card {\n    overflow: hidden;\n\n    &:not(:last-of-type) {\n      border-bottom: 0;\n      @include border-bottom-radius(0);\n    }\n\n    &:not(:first-of-type) {\n      @include border-top-radius(0);\n    }\n\n    > .card-header {\n      @include border-radius(0);\n      margin-bottom: -$card-border-width;\n    }\n  }\n}\n",".breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: $breadcrumb-padding-y $breadcrumb-padding-x;\n  margin-bottom: $breadcrumb-margin-bottom;\n  @include font-size($breadcrumb-font-size);\n  list-style: none;\n  background-color: $breadcrumb-bg;\n  @include border-radius($breadcrumb-border-radius);\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: $breadcrumb-item-padding;\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: $breadcrumb-item-padding;\n      color: $breadcrumb-divider-color;\n      content: escape-svg($breadcrumb-divider);\n    }\n  }\n\n  // IE9-11 hack to properly handle hyperlink underlines for breadcrumbs built\n  // without `<ul>`s. The `::before` pseudo-element generates an element\n  // *within* the .breadcrumb-item and thereby inherits the `text-decoration`.\n  //\n  // To trick IE into suppressing the underline, we give the pseudo-element an\n  // underline and then immediately remove it.\n  + .breadcrumb-item:hover::before {\n    text-decoration: underline;\n  }\n  // stylelint-disable-next-line no-duplicate-selectors\n  + .breadcrumb-item:hover::before {\n    text-decoration: none;\n  }\n\n  &.active {\n    color: $breadcrumb-active-color;\n  }\n}\n",".pagination {\n  display: flex;\n  @include list-unstyled();\n  @include border-radius();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: $pagination-padding-y $pagination-padding-x;\n  margin-left: -$pagination-border-width;\n  line-height: $pagination-line-height;\n  color: $pagination-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $pagination-bg;\n  border: $pagination-border-width solid $pagination-border-color;\n\n  &:hover {\n    z-index: 2;\n    color: $pagination-hover-color;\n    text-decoration: none;\n    background-color: $pagination-hover-bg;\n    border-color: $pagination-hover-border-color;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: $pagination-focus-outline;\n    box-shadow: $pagination-focus-box-shadow;\n  }\n}\n\n.page-item {\n  &:first-child {\n    .page-link {\n      margin-left: 0;\n      @include border-left-radius($border-radius);\n    }\n  }\n  &:last-child {\n    .page-link {\n      @include border-right-radius($border-radius);\n    }\n  }\n\n  &.active .page-link {\n    z-index: 3;\n    color: $pagination-active-color;\n    background-color: $pagination-active-bg;\n    border-color: $pagination-active-border-color;\n  }\n\n  &.disabled .page-link {\n    color: $pagination-disabled-color;\n    pointer-events: none;\n    // Opinionated: remove the \"hand\" cursor set previously for .page-link\n    cursor: auto;\n    background-color: $pagination-disabled-bg;\n    border-color: $pagination-disabled-border-color;\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $line-height-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $line-height-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n@mixin pagination-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  .page-link {\n    padding: $padding-y $padding-x;\n    @include font-size($font-size);\n    line-height: $line-height;\n  }\n\n  .page-item {\n    &:first-child {\n      .page-link {\n        @include border-left-radius($border-radius);\n      }\n    }\n    &:last-child {\n      .page-link {\n        @include border-right-radius($border-radius);\n      }\n    }\n  }\n}\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  display: inline-block;\n  padding: $badge-padding-y $badge-padding-x;\n  @include font-size($badge-font-size);\n  font-weight: $badge-font-weight;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius($badge-border-radius);\n  @include transition($badge-transition);\n\n  @at-root a#{&} {\n    @include hover-focus() {\n      text-decoration: none;\n    }\n  }\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n// Pill badges\n//\n// Make them extra rounded with a modifier to replace v3's badges.\n\n.badge-pill {\n  padding-right: $badge-pill-padding-x;\n  padding-left: $badge-pill-padding-x;\n  @include border-radius($badge-pill-border-radius);\n}\n\n// Colors\n//\n// Contextual variations (linked badges get darker on :hover).\n\n@each $color, $value in $theme-colors {\n  .badge-#{$color} {\n    @include badge-variant($value);\n  }\n}\n","@mixin badge-variant($bg) {\n  color: color-yiq($bg);\n  background-color: $bg;\n\n  @at-root a#{&} {\n    @include hover-focus() {\n      color: color-yiq($bg);\n      background-color: darken($bg, 10%);\n    }\n\n    &:focus,\n    &.focus {\n      outline: 0;\n      box-shadow: 0 0 0 $badge-focus-width rgba($bg, .5);\n    }\n  }\n}\n",".jumbotron {\n  padding: $jumbotron-padding ($jumbotron-padding * .5);\n  margin-bottom: $jumbotron-padding;\n  color: $jumbotron-color;\n  background-color: $jumbotron-bg;\n  @include border-radius($border-radius-lg);\n\n  @include media-breakpoint-up(sm) {\n    padding: ($jumbotron-padding * 2) $jumbotron-padding;\n  }\n}\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  @include border-radius(0);\n}\n","//\n// Base styles\n//\n\n.alert {\n  position: relative;\n  padding: $alert-padding-y $alert-padding-x;\n  margin-bottom: $alert-margin-bottom;\n  border: $alert-border-width solid transparent;\n  @include border-radius($alert-border-radius);\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $close-font-size + $alert-padding-x * 2;\n\n  // Adjust close link position\n  .close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 2;\n    padding: $alert-padding-y $alert-padding-x;\n    color: inherit;\n  }\n}\n\n\n// Alternate styles\n//\n// Generate contextual modifier classes for colorizing the alert.\n\n@each $color, $value in $theme-colors {\n  .alert-#{$color} {\n    @include alert-variant(theme-color-level($color, $alert-bg-level), theme-color-level($color, $alert-border-level), theme-color-level($color, $alert-color-level));\n  }\n}\n","@mixin alert-variant($background, $border, $color) {\n  color: $color;\n  @include gradient-bg($background);\n  border-color: $border;\n\n  hr {\n    border-top-color: darken($border, 5%);\n  }\n\n  .alert-link {\n    color: darken($color, 10%);\n  }\n}\n","// Disable animation if transitions are disabled\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    from { background-position: $progress-height 0; }\n    to { background-position: 0 0; }\n  }\n}\n\n.progress {\n  display: flex;\n  height: $progress-height;\n  overflow: hidden; // force rounded corners by cropping it\n  line-height: 0;\n  @include font-size($progress-font-size);\n  background-color: $progress-bg;\n  @include border-radius($progress-border-radius);\n  @include box-shadow($progress-box-shadow);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: $progress-bar-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $progress-bar-bg;\n  @include transition($progress-bar-transition);\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: $progress-height $progress-height;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-prefers-reduced-motion-media-query {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n",".media {\n  display: flex;\n  align-items: flex-start;\n}\n\n.media-body {\n  flex: 1;\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius($list-group-border-radius);\n}\n\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: $list-group-action-color;\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  @include hover-focus() {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: $list-group-action-hover-color;\n    text-decoration: none;\n    background-color: $list-group-hover-bg;\n  }\n\n  &:active {\n    color: $list-group-action-active-color;\n    background-color: $list-group-action-active-bg;\n  }\n}\n\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: $list-group-item-padding-y $list-group-item-padding-x;\n  color: $list-group-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $list-group-bg;\n  border: $list-group-border-width solid $list-group-border-color;\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $list-group-disabled-color;\n    pointer-events: none;\n    background-color: $list-group-disabled-bg;\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: $list-group-active-color;\n    background-color: $list-group-active-bg;\n    border-color: $list-group-active-border-color;\n  }\n\n  & + & {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: -$list-group-border-width;\n      border-top-width: $list-group-border-width;\n    }\n  }\n}\n\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child {\n          @include border-bottom-left-radius($list-group-border-radius);\n          @include border-top-right-radius(0);\n        }\n\n        &:last-child {\n          @include border-top-right-radius($list-group-border-radius);\n          @include border-bottom-left-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: $list-group-border-width;\n          border-left-width: 0;\n\n          &.active {\n            margin-left: -$list-group-border-width;\n            border-left-width: $list-group-border-width;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 $list-group-border-width;\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// Contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $color, $value in $theme-colors {\n  @include list-group-item-variant($color, theme-color-level($color, -9), theme-color-level($color, 6));\n}\n","// List Groups\n\n@mixin list-group-item-variant($state, $background, $color) {\n  .list-group-item-#{$state} {\n    color: $color;\n    background-color: $background;\n\n    &.list-group-item-action {\n      @include hover-focus() {\n        color: $color;\n        background-color: darken($background, 5%);\n      }\n\n      &.active {\n        color: $white;\n        background-color: $color;\n        border-color: $color;\n      }\n    }\n  }\n}\n",".close {\n  float: right;\n  @include font-size($close-font-size);\n  font-weight: $close-font-weight;\n  line-height: 1;\n  color: $close-color;\n  text-shadow: $close-text-shadow;\n  opacity: .5;\n\n  // Override <a>'s hover style\n  @include hover() {\n    color: $close-color;\n    text-decoration: none;\n  }\n\n  &:not(:disabled):not(.disabled) {\n    @include hover-focus() {\n      opacity: .75;\n    }\n  }\n}\n\n// Additional properties for button version\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n// stylelint-disable-next-line selector-no-qualifying-type\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n}\n\n// Future-proof disabling of clicks on `<a>` elements\n\n// stylelint-disable-next-line selector-no-qualifying-type\na.close.disabled {\n  pointer-events: none;\n}\n",".toast {\n  // Prevents from shrinking in IE11, when in a flex container\n  // See https://github.com/twbs/bootstrap/issues/28341\n  flex-basis: $toast-max-width;\n  max-width: $toast-max-width;\n  @include font-size($toast-font-size);\n  color: $toast-color;\n  background-color: $toast-background-color;\n  background-clip: padding-box;\n  border: $toast-border-width solid $toast-border-color;\n  box-shadow: $toast-box-shadow;\n  opacity: 0;\n  @include border-radius($toast-border-radius);\n\n  &:not(:last-child) {\n    margin-bottom: $toast-padding-x;\n  }\n\n  &.showing {\n    opacity: 1;\n  }\n\n  &.show {\n    display: block;\n    opacity: 1;\n  }\n\n  &.hide {\n    display: none;\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: $toast-padding-y $toast-padding-x;\n  color: $toast-header-color;\n  background-color: $toast-header-background-color;\n  background-clip: padding-box;\n  border-bottom: $toast-border-width solid $toast-header-border-color;\n  @include border-top-radius(subtract($toast-border-radius, $toast-border-width));\n}\n\n.toast-body {\n  padding: $toast-padding-x; // apply to both vertical and horizontal\n}\n","// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n.modal-open {\n  // Kill the scroll on the body\n  overflow: hidden;\n\n  .modal {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n}\n\n// Container that the modal scrolls within\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: $modal-dialog-margin;\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  display: flex; // IE10/11\n  max-height: subtract(100%, $modal-dialog-margin * 2);\n\n  .modal-content {\n    max-height: subtract(100vh, $modal-dialog-margin * 2); // IE10/11\n    overflow: hidden;\n  }\n\n  .modal-header,\n  .modal-footer {\n    flex-shrink: 0;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: subtract(100%, $modal-dialog-margin * 2);\n\n  // Ensure `modal-dialog-centered` extends the full height of the view (IE10/11)\n  &::before {\n    display: block; // IE10\n    height: subtract(100vh, $modal-dialog-margin * 2);\n    height: min-content; // Reset height to 0 except on IE\n    content: \"\";\n  }\n\n  // Ensure `.modal-body` shows scrollbar (IE10/11)\n  &.modal-dialog-scrollable {\n    flex-direction: column;\n    justify-content: center;\n    height: 100%;\n\n    .modal-content {\n      max-height: none;\n    }\n\n    &::before {\n      content: none;\n    }\n  }\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: $modal-content-color;\n  pointer-events: auto;\n  background-color: $modal-content-bg;\n  background-clip: padding-box;\n  border: $modal-content-border-width solid $modal-content-border-color;\n  @include border-radius($modal-content-border-radius);\n  @include box-shadow($modal-content-box-shadow-xs);\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal-backdrop;\n  width: 100vw;\n  height: 100vh;\n  background-color: $modal-backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $modal-backdrop-opacity; }\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  align-items: flex-start; // so the close btn always stays on the upper right corner\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: $modal-header-padding;\n  border-bottom: $modal-header-border-width solid $modal-header-border-color;\n  @include border-top-radius($modal-content-inner-border-radius);\n\n  .close {\n    padding: $modal-header-padding;\n    // auto on the left force icon to the right even when there is no .modal-title\n    margin: (-$modal-header-padding-y) (-$modal-header-padding-x) (-$modal-header-padding-y) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: $modal-title-line-height;\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: $modal-inner-padding;\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: $modal-inner-padding - $modal-footer-margin-between * .5;\n  border-top: $modal-footer-border-width solid $modal-footer-border-color;\n  @include border-bottom-radius($modal-content-inner-border-radius);\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: $modal-footer-margin-between * .5;\n  }\n}\n\n// Measure scrollbar width for padding body during modal show/hide\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: $modal-md;\n    margin: $modal-dialog-margin-y-sm-up auto;\n  }\n\n  .modal-dialog-scrollable {\n    max-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    .modal-content {\n      max-height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n    }\n  }\n\n  .modal-dialog-centered {\n    min-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    &::before {\n      height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n      height: min-content;\n    }\n  }\n\n  .modal-content {\n    @include box-shadow($modal-content-box-shadow-sm-up);\n  }\n\n  .modal-sm { max-width: $modal-sm; }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    max-width: $modal-lg;\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl { max-width: $modal-xl; }\n}\n","// Base class\n.tooltip {\n  position: absolute;\n  z-index: $zindex-tooltip;\n  display: block;\n  margin: $tooltip-margin;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($tooltip-font-size);\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: $tooltip-opacity; }\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $tooltip-arrow-width;\n    height: $tooltip-arrow-height;\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    bottom: 0;\n\n    &::before {\n      top: 0;\n      border-width: $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-top-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-right {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    left: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      right: 0;\n      border-width: ($tooltip-arrow-width * .5) $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-right-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-bottom {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    top: 0;\n\n    &::before {\n      bottom: 0;\n      border-width: 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-bottom-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-left {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    right: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      left: 0;\n      border-width: ($tooltip-arrow-width * .5) 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-left-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-tooltip-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-tooltip-left;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: $tooltip-max-width;\n  padding: $tooltip-padding-y $tooltip-padding-x;\n  color: $tooltip-color;\n  text-align: center;\n  background-color: $tooltip-bg;\n  @include border-radius($tooltip-border-radius);\n}\n","@mixin reset-text() {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: $zindex-popover;\n  display: block;\n  max-width: $popover-max-width;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($popover-font-size);\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: $popover-bg;\n  background-clip: padding-box;\n  border: $popover-border-width solid $popover-border-color;\n  @include border-radius($popover-border-radius);\n  @include box-shadow($popover-box-shadow);\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $popover-arrow-width;\n    height: $popover-arrow-height;\n    margin: 0 $popover-border-radius;\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-popover-top {\n  margin-bottom: $popover-arrow-height;\n\n  > .arrow {\n    bottom: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      bottom: 0;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      bottom: $popover-border-width;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-right {\n  margin-left: $popover-arrow-height;\n\n  > .arrow {\n    left: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      left: 0;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      left: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-bottom {\n  margin-top: $popover-arrow-height;\n\n  > .arrow {\n    top: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      top: 0;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      top: $popover-border-width;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-color;\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: $popover-arrow-width;\n    margin-left: -$popover-arrow-width * .5;\n    content: \"\";\n    border-bottom: $popover-border-width solid $popover-header-bg;\n  }\n}\n\n.bs-popover-left {\n  margin-right: $popover-arrow-height;\n\n  > .arrow {\n    right: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      right: 0;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      right: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-popover-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-popover-left;\n  }\n}\n\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: $popover-header-padding-y $popover-header-padding-x;\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size($font-size-base);\n  color: $popover-header-color;\n  background-color: $popover-header-bg;\n  border-bottom: $popover-border-width solid darken($popover-header-bg, 5%);\n  @include border-top-radius($popover-inner-border-radius);\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: $popover-body-padding-y $popover-body-padding-x;\n  color: $popover-body-color;\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-left and .carousel-item-right is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-left and .active.carousel-item-right is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-left and .carousel-item-prev.carousel-item-right\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-left),\n.active.carousel-item-right {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-right),\n.active.carousel-item-left {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-left,\n  .carousel-item-prev.carousel-item-right {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-left,\n  .active.carousel-item-right {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  @include hover-focus() {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(90deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n.carousel-control-next {\n  right: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(270deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background: 50% / 100% 100% no-repeat;\n}\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n\n// Optional indicator pips\n//\n// Add an ordered list with the following class and add a list item for each\n// slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 15;\n  display: flex;\n  justify-content: center;\n  padding-left: 0; // override <ol> default\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  li {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: .5;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: 1;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: 20px;\n  left: (100% - $carousel-caption-width) * .5;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n","@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n","//\n// Rotating border\n//\n\n@keyframes spinner-border {\n  to { transform: rotate(360deg); }\n}\n\n.spinner-border {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  border: $spinner-border-width solid currentcolor;\n  border-right-color: transparent;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: .75s linear infinite spinner-border;\n}\n\n.spinner-border-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n  border-width: $spinner-border-width-sm;\n}\n\n//\n// Growing circle\n//\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n.spinner-grow {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  background-color: currentcolor;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  opacity: 0;\n  animation: .75s linear infinite spinner-grow;\n}\n\n.spinner-grow-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n}\n\n@if $enable-prefers-reduced-motion-media-query {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      animation-duration: 1.5s;\n    }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.align-baseline    { vertical-align: baseline !important; } // Browser default\n.align-top         { vertical-align: top !important; }\n.align-middle      { vertical-align: middle !important; }\n.align-bottom      { vertical-align: bottom !important; }\n.align-text-bottom { vertical-align: text-bottom !important; }\n.align-text-top    { vertical-align: text-top !important; }\n","// stylelint-disable declaration-no-important\n\n// Contextual backgrounds\n\n@mixin bg-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    background-color: $color !important;\n  }\n  a#{$parent},\n  button#{$parent} {\n    @include hover-focus() {\n      background-color: darken($color, 10%) !important;\n    }\n  }\n  @include deprecate(\"The `bg-variant` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n\n@mixin bg-gradient-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x !important;\n  }\n  @include deprecate(\"The `bg-gradient-variant` mixin\", \"v4.5.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable declaration-no-important\n\n@each $color, $value in $theme-colors {\n  @include bg-variant(\".bg-#{$color}\", $value, true);\n}\n\n@if $enable-gradients {\n  @each $color, $value in $theme-colors {\n    @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value, true);\n  }\n}\n\n.bg-white {\n  background-color: $white !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n","// stylelint-disable property-disallowed-list, declaration-no-important\n\n//\n// Border\n//\n\n.border         { border: $border-width solid $border-color !important; }\n.border-top     { border-top: $border-width solid $border-color !important; }\n.border-right   { border-right: $border-width solid $border-color !important; }\n.border-bottom  { border-bottom: $border-width solid $border-color !important; }\n.border-left    { border-left: $border-width solid $border-color !important; }\n\n.border-0        { border: 0 !important; }\n.border-top-0    { border-top: 0 !important; }\n.border-right-0  { border-right: 0 !important; }\n.border-bottom-0 { border-bottom: 0 !important; }\n.border-left-0   { border-left: 0 !important; }\n\n@each $color, $value in $theme-colors {\n  .border-#{$color} {\n    border-color: $value !important;\n  }\n}\n\n.border-white {\n  border-color: $white !important;\n}\n\n//\n// Border-radius\n//\n\n.rounded-sm {\n  border-radius: $border-radius-sm !important;\n}\n\n.rounded {\n  border-radius: $border-radius !important;\n}\n\n.rounded-top {\n  border-top-left-radius: $border-radius !important;\n  border-top-right-radius: $border-radius !important;\n}\n\n.rounded-right {\n  border-top-right-radius: $border-radius !important;\n  border-bottom-right-radius: $border-radius !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-left {\n  border-top-left-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-lg {\n  border-radius: $border-radius-lg !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: $rounded-pill !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Utilities for common `display` values\n//\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $value in $displays {\n      .d#{$infix}-#{$value} { display: $value !important; }\n    }\n  }\n}\n\n\n//\n// Utilities for toggling `display` in print\n//\n\n@media print {\n  @each $value in $displays {\n    .d-print-#{$value} { display: $value !important; }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n\n  &::before {\n    display: block;\n    content: \"\";\n  }\n\n  .embed-responsive-item,\n  iframe,\n  embed,\n  object,\n  video {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0;\n  }\n}\n\n@each $embed-responsive-aspect-ratio in $embed-responsive-aspect-ratios {\n  $embed-responsive-aspect-ratio-x: nth($embed-responsive-aspect-ratio, 1);\n  $embed-responsive-aspect-ratio-y: nth($embed-responsive-aspect-ratio, 2);\n\n  .embed-responsive-#{$embed-responsive-aspect-ratio-x}by#{$embed-responsive-aspect-ratio-y} {\n    &::before {\n      padding-top: percentage(divide($embed-responsive-aspect-ratio-y, $embed-responsive-aspect-ratio-x));\n    }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n// Flex variation\n//\n// Custom styles for additional flex alignment options.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .flex#{$infix}-row            { flex-direction: row !important; }\n    .flex#{$infix}-column         { flex-direction: column !important; }\n    .flex#{$infix}-row-reverse    { flex-direction: row-reverse !important; }\n    .flex#{$infix}-column-reverse { flex-direction: column-reverse !important; }\n\n    .flex#{$infix}-wrap         { flex-wrap: wrap !important; }\n    .flex#{$infix}-nowrap       { flex-wrap: nowrap !important; }\n    .flex#{$infix}-wrap-reverse { flex-wrap: wrap-reverse !important; }\n    .flex#{$infix}-fill         { flex: 1 1 auto !important; }\n    .flex#{$infix}-grow-0       { flex-grow: 0 !important; }\n    .flex#{$infix}-grow-1       { flex-grow: 1 !important; }\n    .flex#{$infix}-shrink-0     { flex-shrink: 0 !important; }\n    .flex#{$infix}-shrink-1     { flex-shrink: 1 !important; }\n\n    .justify-content#{$infix}-start   { justify-content: flex-start !important; }\n    .justify-content#{$infix}-end     { justify-content: flex-end !important; }\n    .justify-content#{$infix}-center  { justify-content: center !important; }\n    .justify-content#{$infix}-between { justify-content: space-between !important; }\n    .justify-content#{$infix}-around  { justify-content: space-around !important; }\n\n    .align-items#{$infix}-start    { align-items: flex-start !important; }\n    .align-items#{$infix}-end      { align-items: flex-end !important; }\n    .align-items#{$infix}-center   { align-items: center !important; }\n    .align-items#{$infix}-baseline { align-items: baseline !important; }\n    .align-items#{$infix}-stretch  { align-items: stretch !important; }\n\n    .align-content#{$infix}-start   { align-content: flex-start !important; }\n    .align-content#{$infix}-end     { align-content: flex-end !important; }\n    .align-content#{$infix}-center  { align-content: center !important; }\n    .align-content#{$infix}-between { align-content: space-between !important; }\n    .align-content#{$infix}-around  { align-content: space-around !important; }\n    .align-content#{$infix}-stretch { align-content: stretch !important; }\n\n    .align-self#{$infix}-auto     { align-self: auto !important; }\n    .align-self#{$infix}-start    { align-self: flex-start !important; }\n    .align-self#{$infix}-end      { align-self: flex-end !important; }\n    .align-self#{$infix}-center   { align-self: center !important; }\n    .align-self#{$infix}-baseline { align-self: baseline !important; }\n    .align-self#{$infix}-stretch  { align-self: stretch !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .float#{$infix}-left  { float: left !important; }\n    .float#{$infix}-right { float: right !important; }\n    .float#{$infix}-none  { float: none !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $user-selects {\n  .user-select-#{$value} { user-select: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $overflows {\n  .overflow-#{$value} { overflow: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n// Common values\n@each $position in $positions {\n  .position-#{$position} { position: $position !important; }\n}\n\n// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.sticky-top {\n  @supports (position: sticky) {\n    position: sticky;\n    top: 0;\n    z-index: $zindex-sticky;\n  }\n}\n","//\n// Screenreaders\n//\n\n.sr-only {\n  @include sr-only();\n}\n\n.sr-only-focusable {\n  @include sr-only-focusable();\n}\n","// Only display content to screen readers\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin sr-only() {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n// Use in conjunction with .sr-only to only display content when it's focused.\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n//\n// Credit: HTML5 Boilerplate\n\n@mixin sr-only-focusable() {\n  &:active,\n  &:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.shadow-sm { box-shadow: $box-shadow-sm !important; }\n.shadow { box-shadow: $box-shadow !important; }\n.shadow-lg { box-shadow: $box-shadow-lg !important; }\n.shadow-none { box-shadow: none !important; }\n","// stylelint-disable declaration-no-important\n\n// Width and height\n\n@each $prop, $abbrev in (width: w, height: h) {\n  @each $size, $length in $sizes {\n    .#{$abbrev}-#{$size} { #{$prop}: $length !important; }\n  }\n}\n\n.mw-100 { max-width: 100% !important; }\n.mh-100 { max-height: 100% !important; }\n\n// Viewport additional helpers\n\n.min-vw-100 { min-width: 100vw !important; }\n.min-vh-100 { min-height: 100vh !important; }\n\n.vw-100 { width: 100vw !important; }\n.vh-100 { height: 100vh !important; }\n","// stylelint-disable declaration-no-important\n\n// Margin and Padding\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $prop, $abbrev in (margin: m, padding: p) {\n      @each $size, $length in $spacers {\n        .#{$abbrev}#{$infix}-#{$size} { #{$prop}: $length !important; }\n        .#{$abbrev}t#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-top: $length !important;\n        }\n        .#{$abbrev}r#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-right: $length !important;\n        }\n        .#{$abbrev}b#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-bottom: $length !important;\n        }\n        .#{$abbrev}l#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-left: $length !important;\n        }\n      }\n    }\n\n    // Negative margins (e.g., where `.mb-n1` is negative version of `.mb-1`)\n    @each $size, $length in $spacers {\n      @if \"#{$size}\" != \"0\" {\n        .m#{$infix}-n#{$size} { margin: -$length !important; }\n        .mt#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-top: -$length !important;\n        }\n        .mr#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-right: -$length !important;\n        }\n        .mb#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-bottom: -$length !important;\n        }\n        .ml#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-left: -$length !important;\n        }\n      }\n    }\n\n    // Some special margin utils\n    .m#{$infix}-auto { margin: auto !important; }\n    .mt#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-top: auto !important;\n    }\n    .mr#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-right: auto !important;\n    }\n    .mb#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-bottom: auto !important;\n    }\n    .ml#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-left: auto !important;\n    }\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    // Just in case `pointer-events: none` is set on a parent\n    pointer-events: auto;\n    content: \"\";\n    // IE10 bugfix, see https://stackoverflow.com/questions/16947967/ie10-hover-pseudo-class-doesnt-work-without-background-color\n    background-color: rgba(0, 0, 0, 0);\n  }\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Text\n//\n\n.text-monospace { font-family: $font-family-monospace !important; }\n\n// Alignment\n\n.text-justify  { text-align: justify !important; }\n.text-wrap     { white-space: normal !important; }\n.text-nowrap   { white-space: nowrap !important; }\n.text-truncate { @include text-truncate(); }\n\n// Responsive alignment\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .text#{$infix}-left   { text-align: left !important; }\n    .text#{$infix}-right  { text-align: right !important; }\n    .text#{$infix}-center { text-align: center !important; }\n  }\n}\n\n// Transformation\n\n.text-lowercase  { text-transform: lowercase !important; }\n.text-uppercase  { text-transform: uppercase !important; }\n.text-capitalize { text-transform: capitalize !important; }\n\n// Weight and italics\n\n.font-weight-light   { font-weight: $font-weight-light !important; }\n.font-weight-lighter { font-weight: $font-weight-lighter !important; }\n.font-weight-normal  { font-weight: $font-weight-normal !important; }\n.font-weight-bold    { font-weight: $font-weight-bold !important; }\n.font-weight-bolder  { font-weight: $font-weight-bolder !important; }\n.font-italic         { font-style: italic !important; }\n\n// Contextual colors\n\n.text-white { color: $white !important; }\n\n@each $color, $value in $theme-colors {\n  @include text-emphasis-variant(\".text-#{$color}\", $value, true);\n}\n\n.text-body { color: $body-color !important; }\n.text-muted { color: $text-muted !important; }\n\n.text-black-50 { color: rgba($black, .5) !important; }\n.text-white-50 { color: rgba($white, .5) !important; }\n\n// Misc\n\n.text-hide {\n  @include text-hide($ignore-warning: true);\n}\n\n.text-decoration-none { text-decoration: none !important; }\n\n.text-break {\n  word-break: break-word !important; // Deprecated, but avoids issues with flex containers\n  word-wrap: break-word !important; // Used instead of `overflow-wrap` for IE & Edge Legacy\n}\n\n// Reset\n\n.text-reset { color: inherit !important; }\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n","// stylelint-disable declaration-no-important\n\n// Typography\n\n@mixin text-emphasis-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    color: $color !important;\n  }\n  @if $emphasized-link-hover-darken-percentage != 0 {\n    a#{$parent} {\n      @include hover-focus() {\n        color: darken($color, $emphasized-link-hover-darken-percentage) !important;\n      }\n    }\n  }\n  @include deprecate(\"`text-emphasis-variant()`\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// CSS image replacement\n@mixin text-hide($ignore-warning: false) {\n  // stylelint-disable-next-line font-family-no-missing-generic-family-keyword\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n\n  @include deprecate(\"`text-hide()`\", \"v4.1.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Visibility utilities\n//\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type\n\n// Source: https://github.com/h5bp/main.css/blob/master/src/_print.css\n\n// ==========================================================================\n// Print styles.\n// Inlined to avoid the additional HTTP request:\n// https://www.phpied.com/delay-loading-your-print-css/\n// ==========================================================================\n\n@if $enable-print-styles {\n  @media print {\n    *,\n    *::before,\n    *::after {\n      // Bootstrap specific; comment out `color` and `background`\n      //color: $black !important; // Black prints faster\n      text-shadow: none !important;\n      //background: transparent !important;\n      box-shadow: none !important;\n    }\n\n    a {\n      &:not(.btn) {\n        text-decoration: underline;\n      }\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //a[href]::after {\n    //  content: \" (\" attr(href) \")\";\n    //}\n\n    abbr[title]::after {\n      content: \" (\" attr(title) \")\";\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //\n    // Don't show links that are fragment identifiers,\n    // or use the `javascript:` pseudo protocol\n    //\n\n    //a[href^=\"#\"]::after,\n    //a[href^=\"javascript:\"]::after {\n    // content: \"\";\n    //}\n\n    pre {\n      white-space: pre-wrap !important;\n    }\n    pre,\n    blockquote {\n      border: $border-width solid $gray-500; // Bootstrap custom code; using `$border-width` instead of 1px\n      page-break-inside: avoid;\n    }\n\n    tr,\n    img {\n      page-break-inside: avoid;\n    }\n\n    p,\n    h2,\n    h3 {\n      orphans: 3;\n      widows: 3;\n    }\n\n    h2,\n    h3 {\n      page-break-after: avoid;\n    }\n\n    // Bootstrap specific changes start\n\n    // Specify a size and min-width to make printing closer across browsers.\n    // We don't set margin here because it breaks `size` in Chrome. We also\n    // don't use `!important` on `size` as it breaks in Chrome.\n    @page {\n      size: $print-page-size;\n    }\n    body {\n      min-width: $print-body-min-width !important;\n    }\n    .container {\n      min-width: $print-body-min-width !important;\n    }\n\n    // Bootstrap components\n    .navbar {\n      display: none;\n    }\n    .badge {\n      border: $border-width solid $black;\n    }\n\n    .table {\n      border-collapse: collapse !important;\n\n      td,\n      th {\n        background-color: $white !important;\n      }\n    }\n\n    .table-bordered {\n      th,\n      td {\n        border: 1px solid $gray-300 !important;\n      }\n    }\n\n    .table-dark {\n      color: inherit;\n\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $table-border-color;\n      }\n    }\n\n    .table .thead-dark th {\n      color: inherit;\n      border-color: $table-border-color;\n    }\n\n    // Bootstrap specific changes end\n  }\n}\n","/* MaterialDesignIcons.com */\r\n@import \"variables\";\r\n@import \"functions\";\r\n@import \"path\";\r\n@import \"core\";\r\n@import \"icons\";\r\n@import \"extras\";\r\n@import \"animated\";","@font-face {\r\n  font-family: '#{$mdi-font-name}';\r\n  src: url('#{$mdi-font-path}/#{$mdi-filename}-webfont.eot?v=#{$mdi-version}');\r\n  src: url('#{$mdi-font-path}/#{$mdi-filename}-webfont.eot?#iefix&v=#{$mdi-version}') format('embedded-opentype'),\r\n    url('#{$mdi-font-path}/#{$mdi-filename}-webfont.woff2?v=#{$mdi-version}') format('woff2'),\r\n    url('#{$mdi-font-path}/#{$mdi-filename}-webfont.woff?v=#{$mdi-version}') format('woff'),\r\n    url('#{$mdi-font-path}/#{$mdi-filename}-webfont.ttf?v=#{$mdi-version}') format('truetype');\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n",".#{$mdi-css-prefix}:before,\r\n.#{$mdi-css-prefix}-set {\r\n  display: inline-block;\r\n  font: normal normal normal #{$mdi-font-size-base}/1 '#{$mdi-font-name}'; // shortening font declaration\r\n  font-size: inherit; // can't have font-size inherit on line above, so need to override\r\n  text-rendering: auto; // optimizelegibility throws things off #1094\r\n  line-height: inherit;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}","@each $key, $value in $mdi-icons {\r\n    .#{$mdi-css-prefix}-#{$key}::before {\r\n        content: char($value);\r\n    }\r\n}\r\n\r\n.#{$mdi-css-prefix}-blank::before {\r\n    content: \"\\F68C\";\r\n    visibility: hidden;\r\n}","$mdi-sizes: 18 24 36 48 !default;\r\n@each $mdi-size in $mdi-sizes {\r\n    .#{$mdi-css-prefix}-#{$mdi-size}px {\r\n        &.#{$mdi-css-prefix}-set,\r\n        &.#{$mdi-css-prefix}:before {\r\n            font-size: $mdi-size * 1px;\r\n        }\r\n    }\r\n}\r\n\r\n.#{$mdi-css-prefix}-dark {\r\n    &:before {\r\n        color: rgba(0, 0, 0, 0.54);\r\n    }\r\n    &.#{$mdi-css-prefix}-inactive:before {\r\n        color: rgba(0, 0, 0, 0.26);\r\n    }\r\n}\r\n.#{$mdi-css-prefix}-light {\r\n    &:before {\r\n        color: rgba(255, 255, 255, 1);\r\n    }\r\n    &.#{$mdi-css-prefix}-inactive:before {\r\n        color: rgba(255, 255, 255, 0.3);\r\n    }\r\n}\r\n\r\n$mdi-degrees: 45 90 135 180 225 270 315 !default;\r\n@each $mdi-degree in $mdi-degrees {\r\n    .#{$mdi-css-prefix}-rotate-#{$mdi-degree}{\r\n        &:before {\r\n            -webkit-transform: rotate(#{$mdi-degree}deg);\r\n            -ms-transform: rotate(#{$mdi-degree}deg);\r\n            transform: rotate(#{$mdi-degree}deg);\r\n        }\r\n        /*\r\n        // Not included in production\r\n        &.#{$mdi-css-prefix}-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(#{$mdi-degree}deg);\r\n            transform: scaleX(-1) rotate(#{$mdi-degree}deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.#{$mdi-css-prefix}-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(#{$mdi-degree}deg);\r\n            -ms-transform: rotate(#{$mdi-degree}deg);\r\n            transform: scaleY(-1) rotate(#{$mdi-degree}deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\r\n    }\r\n}\r\n.#{$mdi-css-prefix}-flip-h:before {\r\n    -webkit-transform: scaleX(-1);\r\n    transform: scaleX(-1);\r\n    filter: FlipH;\r\n    -ms-filter: \"FlipH\";\r\n}\r\n.#{$mdi-css-prefix}-flip-v:before {\r\n    -webkit-transform: scaleY(-1);\r\n    transform: scaleY(-1);\r\n    filter: FlipV;\r\n    -ms-filter: \"FlipV\";\r\n}","// From Font Awesome\r\n.#{$mdi-css-prefix}-spin:before {\r\n    -webkit-animation: #{$mdi-css-prefix}-spin 2s infinite linear;\r\n            animation: #{$mdi-css-prefix}-spin 2s infinite linear;\r\n}\r\n\r\n@-webkit-keyframes #{$mdi-css-prefix}-spin {\r\n    0% {\r\n      -webkit-transform: rotate(0deg);\r\n              transform: rotate(0deg);\r\n    }\r\n    100% {\r\n      -webkit-transform: rotate(359deg);\r\n              transform: rotate(359deg);\r\n    }\r\n}\r\n\r\n@keyframes #{$mdi-css-prefix}-spin {\r\n    0% {\r\n      -webkit-transform: rotate(0deg);\r\n              transform: rotate(0deg);\r\n    }\r\n    100% {\r\n      -webkit-transform: rotate(359deg);\r\n              transform: rotate(359deg);\r\n    }\r\n}","/* Clear inner floats */\r\n.clearfix::after {\r\n    clear: both;\r\n    content: \"\";\r\n    display: table;\r\n}\r\n\r\nbody {\r\n    overflow-x: hidden;\r\n}\r\n\r\nvideo {\r\n    width: 100%;\r\n    height: auto;\r\n}\r\n\r\n\r\n/*Override bootstrap container for 1200px and up */ \r\n.container {\r\n    @media(min-width: 1460px) {\r\n        max-width: 1420px;\r\n    }\r\n}\r\n\r\n.container-fluid{\r\n    max-width: 2560px;\r\n}\r\n\r\n/* Make all blocks float to the left and clear duplicate paddings caused by nested Bootstrap's column */\r\ndiv.block {\r\n    display: inline-block;\r\n    vertical-align: top;\r\n}\r\n\r\ndiv.displaymode-screen, div.faqitemblock, div.shortinfoitemblock, div.shortinfolinkblock {\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n}\r\n\r\n\r\nhr {\r\n    color: #C4C4C4;\r\n}\r\n\r\n.filters-tag {\r\n    position: relative;\r\n    border-radius: 3px;\r\n    background-color: $color-darkgrey;\r\n    color: black;\r\n    font-size: 12px;\r\n    padding: 5px 20px 5px 10px;\r\n    margin-bottom: 0;\r\n\r\n    &__remove {\r\n        position: absolute;\r\n        top: 0;\r\n        right: 0;\r\n        width: 100%;\r\n        height: 100%;\r\n        cursor: pointer;\r\n        text-align: right;\r\n        padding-right: 5px;\r\n        padding-top: 2px;\r\n    }\r\n}\r\n\r\n.content-filters-tag {\r\n    position: relative;\r\n    border-radius: 3px;\r\n    background-color: $color-darkgrey;\r\n    color: black;\r\n    font-size: $text-font-size;\r\n    padding: 5px 10px 5px 10px;\r\n    margin-bottom: 0;\r\n}\r\n\r\n.hidden {\r\n    display: none;\r\n}\r\n\r\n.style-list-none {\r\n    list-style: none;\r\n    padding: 0;\r\n}\r\n\r\n.flex-center {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.flex-between {\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n\r\n.flex-start {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n}\r\n\r\n.flex-end {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.pull-right {\r\n    float: right;\r\n}\r\n\r\n.border {\r\n    border: 1px solid #eeeeee;\r\n}\r\n\r\n.border-radius-none {\r\n    border-radius: 0;\r\n}\r\n\r\n.link {\r\n    text-decoration: none;\r\n    color: #61A0A8;\r\n    padding-right: 15px;\r\n\r\n    &:hover {\r\n        text-decoration: none;\r\n        color: #004564;\r\n        opacity: 0.7;\r\n    }\r\n}\r\n\r\n.square-box {\r\n    border-radius: 0;\r\n}\r\n\r\n.cursor-pointer {\r\n    cursor: pointer;\r\n}\r\n\r\n.full-width {\r\n    width: 100%;\r\n}\r\n\r\n.align-center {\r\n    text-align: center;\r\n}\r\n\r\n.success {\r\n    padding: 15px;\r\n    background-color: #DFF0D8;\r\n    color: #468847;\r\n}\r\n\r\n.error {\r\n    padding: 15px;\r\n    background-color: #F2DEDE;\r\n    color: #B94A48;\r\n}\r\n\r\nul.none-style-type {\r\n    list-style-type: none;\r\n}\r\n\r\n.disabled {\r\n    pointer-events: none;\r\n    cursor: default;\r\n    background-color: grey;\r\n    border: 0;\r\n}\r\n\r\n// Fix for Bootstrap Modal causing the site to \"jump\" right on modal open.\r\n.modal-open {\r\n    overflow-y: auto;\r\n    padding-right: 0 !important;\r\n}\r\n\r\n.cssload-container {\r\n    width: 100%;\r\n    height: 50px;\r\n    text-align: center;\r\n}\r\n\r\n.cssload-double-torus {\r\n    width: 50px;\r\n    height: 50px;\r\n    margin: 0 auto;\r\n    border: 4px double;\r\n    border-radius: 50%;\r\n    border-color: transparent $accent-color $accent-color;\r\n    animation: cssload-spin 1500ms infinite linear;\r\n    -o-animation: cssload-spin 1500ms infinite linear;\r\n    -ms-animation: cssload-spin 1500ms infinite linear;\r\n    -webkit-animation: cssload-spin 1500ms infinite linear;\r\n    -moz-animation: cssload-spin 1500ms infinite linear;\r\n}\r\n@keyframes cssload-spin {\r\n    100% {\r\n        transform: rotate(360deg);\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n@-o-keyframes cssload-spin {\r\n    100% {\r\n        -o-transform: rotate(360deg);\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n@-ms-keyframes cssload-spin {\r\n    100% {\r\n        -ms-transform: rotate(360deg);\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n@-webkit-keyframes cssload-spin {\r\n    100% {\r\n        -webkit-transform: rotate(360deg);\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n@-moz-keyframes cssload-spin {\r\n    100% {\r\n        -moz-transform: rotate(360deg);\r\n        transform: rotate(360deg);\r\n    }\r\n}","body {\r\n    color: $text-color;\r\n    font-size: $text-font-size;\r\n    font-family: $text-font-stack;\r\n    line-height: $text-line-height;\r\n}\r\n\r\n.title {\r\n    color: $text-color;\r\n}\r\n\r\n.sub-title {\r\n    color: $text-color;\r\n    font-size: 80%;\r\n}\r\n\r\n.light-text {\r\n    color: grey;\r\n}\r\n\r\n.content {\r\n    color: #666666;\r\n}\r\n\r\n.color-light {\r\n    color: $color-lightgrey;\r\n}\r\n\r\n.color-dark {\r\n    color: $text-color;\r\n}\r\n\r\n.color-ltGreen {\r\n    color: #61A0A8;\r\n}\r\n\r\n.font-italic {\r\n    font-style: italic;\r\n}\r\n\r\n.cursor-pointer {\r\n    cursor: pointer;\r\n}\r\n\r\n.light-svg {\r\n    fill: grey;\r\n    color: white;\r\n}\r\n\r\n.light-border-svg {\r\n    fill: white;\r\n    color: grey;\r\n}\r\n\r\n.required {\r\n    color: red;\r\n    font-weight: bold;\r\n}\r\n\r\n.error {\r\n    margin-bottom: 15px;\r\n}\r\n\r\nli.current {\r\n    font-weight: bold;\r\n    background-color: #f5f5f5;\r\n}\r\n\r\n.word-break {\r\n    word-break: break-word;\r\n}\r\n\r\n.download-file {\r\n    color: steelblue;\r\n\r\n    &:hover {\r\n        color: steelblue;\r\n    }\r\n}\r\n\r\nh2, h4, h5, h6 {\r\n    font-weight: 600;\r\n}\r\n\r\n.body-1 {\r\n    font-size: $font-size-base * 1.125;\r\n    line-height: $font-size-base * 2;\r\n}\r\n\r\n.image-caption {\r\n    font-size: $font-size-base * 0.875;\r\n    line-height: $font-size-base * 1.375;\r\n    font-weight: 600;\r\n}\r\n\r\n@include media-breakpoint-down(sm) {\r\n    body {\r\n        font-size: $text-mobile-font-size;\r\n        line-height: $text-mobile-line-height;\r\n    }\r\n\r\n    .body-1 {\r\n        font-size: $font-size-base * 1;\r\n        line-height: $font-size-base * 1.5;\r\n    }\r\n}\r\n\r\n.font-weight-semi-bold{\r\n    font-weight: 600;\r\n}\r\n\r\n.smaller-body-text{\r\n    line-height: 175%;\r\n    font-size: 80%;\r\n}","﻿@mixin transform-origin ($origin) {\r\n    -webkit-transform-origin: $origin;\r\n    -moz-transform-origin: $origin;\r\n    -ms-transform-origin: $origin;\r\n    -o-transform-origin: $origin;\r\n    transform-origin: $origin;\r\n}\r\n\r\n@mixin transform($transforms) {\r\n    -webkit-transform: $transforms;\r\n    -moz-transform: $transforms;\r\n    -ms-transform: $transforms;\r\n    -o-transform: $transforms;\r\n    transform: $transforms;\r\n}\r\n\r\n// Breakpoint viewport sizes and media queries.\r\n//\r\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\r\n//\r\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\r\n//\r\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\r\n\r\n// Name of the next breakpoint, or null for the last breakpoint.\r\n//\r\n//    >> breakpoint-next(sm)\r\n//    md\r\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\r\n//    md\r\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\r\n//    md\r\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\r\n    $n: index($breakpoint-names, $name);\r\n    @return if($n != null and $n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\r\n}\r\n\r\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\r\n//\r\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\r\n//    576px\r\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\r\n    $min: map-get($breakpoints, $name);\r\n    @return if($min != 0, $min, null);\r\n}\r\n\r\n// Maximum breakpoint width. Null for the largest (last) breakpoint.\r\n// The maximum value is calculated as the minimum of the next one less 0.02px\r\n// to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.\r\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\r\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\r\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\r\n//\r\n//    >> breakpoint-max(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\r\n//    767.98px\r\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\r\n    $next: breakpoint-next($name, $breakpoints);\r\n    @return if($next, breakpoint-min($next, $breakpoints) - .02, null);\r\n}\r\n\r\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\r\n// Useful for making responsive utilities.\r\n//\r\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\r\n//    \"\"  (Returns a blank string)\r\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\r\n//    \"-sm\"\r\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\r\n    @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\r\n}\r\n\r\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\r\n// Makes the @content apply to the given breakpoint and wider.\r\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\r\n    $min: breakpoint-min($name, $breakpoints);\r\n\r\n    @if $min {\r\n        @media (min-width: $min) {\r\n            @content;\r\n        }\r\n    }\r\n    @else {\r\n        @content;\r\n    }\r\n}\r\n\r\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\r\n// Makes the @content apply to the given breakpoint and narrower.\r\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\r\n    $max: breakpoint-max($name, $breakpoints);\r\n\r\n    @if $max {\r\n        @media (max-width: $max) {\r\n            @content;\r\n        }\r\n    }\r\n    @else {\r\n        @content;\r\n    }\r\n}\r\n\r\n// Media that spans multiple breakpoint widths.\r\n// Makes the @content apply between the min and max breakpoints\r\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\r\n    $min: breakpoint-min($lower, $breakpoints);\r\n    $max: breakpoint-max($upper, $breakpoints);\r\n\r\n    @if $min != null and $max != null {\r\n        @media (min-width: $min) and (max-width: $max) {\r\n            @content;\r\n        }\r\n    }\r\n    @else if $max == null {\r\n        @include media-breakpoint-up($lower, $breakpoints) {\r\n            @content;\r\n        }\r\n    }\r\n    @else if $min == null {\r\n        @include media-breakpoint-down($upper, $breakpoints) {\r\n            @content;\r\n        }\r\n    }\r\n}\r\n\r\n// Media between the breakpoint's minimum and maximum widths.\r\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\r\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\r\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\r\n    $min: breakpoint-min($name, $breakpoints);\r\n    $max: breakpoint-max($name, $breakpoints);\r\n\r\n    @if $min != null and $max != null {\r\n        @media (min-width: $min) and (max-width: $max) {\r\n            @content;\r\n        }\r\n    }\r\n    @else if $max == null {\r\n        @include media-breakpoint-up($name, $breakpoints) {\r\n            @content;\r\n        }\r\n    }\r\n    @else if $min == null {\r\n        @include media-breakpoint-down($name, $breakpoints) {\r\n            @content;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n",".navigation-bar {\r\n  width: 100%;\r\n  height: $navigation-height;\r\n}",".cd-nav{\r\n    display: none;\r\n}\r\n\r\n.showMenuOnMobile {\r\n    display: none !important;\r\n}\r\n.navigation {\r\n    &__logo {\r\n        display: flex;\r\n        align-items: center;\r\n        width: 20%;\r\n    }\r\n}\r\n\r\n.cd-nav ol, .cd-nav ul {\r\n    list-style: none;\r\n}\r\n\r\n.cd-nav dl, .cd-nav dt, .cd-nav dd, .cd-nav ol, .cd-nav ul, .cd-nav li {\r\n    margin: 0;\r\n    padding: 0;\r\n    border: 0;\r\n    font-size: 15px;\r\n    vertical-align: baseline;\r\n}\r\n\r\n@media only screen and (min-width: 1170px){\r\n    .cd-primary-nav > li {\r\n        float: left;\r\n        /*margin-left: 1.6em;*/\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 1169px) {\r\n    body.nav-on-left.overflow-cart-hidden {\r\n        overflow: hidden;\r\n    }\r\n\r\n    .hideMenuOnMobile {\r\n        display: none !important;\r\n    }\r\n\r\n    .showMenuOnMobile {\r\n        display: block !important;\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 1169px) {\r\n    #cd-primary-nav {\r\n        @include transform(translateX(-80vw));\r\n    }\r\n\r\n    #cd-primary-nav.nav-is-visible {\r\n        @include transform(translateX(0vw));\r\n        box-shadow: 0 0 20px rgba(0, 0, 0, 0.6);\r\n    }\r\n\r\n    .cd-nav {\r\n        width: 0;\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 767px) {\r\n    .nav-on-left .cd-main-content.nav-is-visible, .nav-on-left .cd-main-header.nav-is-visible {\r\n        @include transform(translateX(0vw));\r\n    }\r\n}\r\n\r\n.cd-primary-nav, .cd-primary-nav ul {\r\n    position: fixed;\r\n    top: 0;\r\n    right: 0;\r\n    height: 100%;\r\n    width: 80vw;\r\n    background: #ffffff;\r\n    overflow: auto;\r\n    z-index: 10;\r\n    -webkit-overflow-scrolling: touch;\r\n    /* Force Hardware Acceleration in WebKit */\r\n    @include transform(translateX(0));\r\n    @include transform(translateZ(0));\r\n\r\n    -webkit-transition: -webkit-transform 0.3s;\r\n    -moz-transition: -moz-transform 0.3s;\r\n    transition: transform 0.3s;\r\n}\r\n\r\n\r\n@media only screen and (min-width: 768px) {\r\n    .cd-primary-nav, .cd-primary-nav ul {\r\n        width: 50vw;\r\n    }\r\n}\r\n\r\n.cd-primary-nav a, .cd-primary-nav ul a {\r\n    display: block;\r\n    height: 67px;\r\n    line-height: 67px;\r\n    padding: 0 32px;\r\n    color: $dark-grey;\r\n    -webkit-font-smoothing: antialiased;\r\n    -moz-osx-font-smoothing: grayscale;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    border-bottom: 1px solid rgba(238, 236, 237, 0.5);\r\n    will-change: transform, opacity;\r\n    -webkit-transition: -webkit-transform 0.3s, opacity 0.3s;\r\n    -moz-transition: -moz-transform 0.3s, opacity 0.3s;\r\n    transition: transform 0.3s, opacity 0.3s;\r\n    @include transform(translateZ(0));\r\n}\r\n\r\n.cd-primary-nav.is-hidden, .cd-primary-nav ul.is-hidden {\r\n    @include transform(translateX(100%));\r\n}\r\n\r\n.cd-primary-nav.moves-out > li > a, .cd-primary-nav ul.moves-out > li > a {\r\n    @include transform(translateX(-100%));\r\n    opacity: 0;\r\n}\r\n\r\n@media only screen and (max-width: 1169px) {\r\n    .nav-on-left .cd-primary-nav, .nav-on-left .cd-primary-nav ul {\r\n        right: auto;\r\n        left: 0;\r\n    }\r\n\r\n    .cd-overlay {\r\n        z-index: 11;\r\n    }\r\n}\r\n\r\n.cd-primary-nav .see-all a {\r\n    color: #69aa6f;\r\n}\r\n\r\n@media only screen and (max-width: 1169px) {\r\n    .cd-primary-nav.nav-is-hidden {\r\n        visibility: hidden;\r\n        -webkit-transition: -webkit-transform 0.3s;\r\n        -moz-transition: -moz-transform 0.3s;\r\n        transition: transform 0.3s;\r\n    }\r\n\r\n    .cd-primary-nav.nav-is-visible {\r\n        visibility: visible;\r\n        -webkit-transition: -webkit-transform 0.3s;\r\n        -moz-transition: -moz-transform 0.3s;\r\n        transition: transform 0.3s;\r\n    }\r\n}\r\n\r\n.zzMainHeader {\r\n    height: 60px !important;\r\n}\r\n\r\n@media only screen and (min-width: 1170px) {\r\n    .cd-primary-nav {\r\n        position: static !important;\r\n        padding: 0 150px 0 0 !important;\r\n        height: auto !important;\r\n        min-height: 70px !important;\r\n        width: 100% !important;\r\n        float: right !important;\r\n        overflow: visible !important;\r\n        background: transparent !important;\r\n    }\r\n\r\n    .zzMainHeader {\r\n        height: 70px !important;\r\n    }\r\n\r\n    .cd-primary-nav::after {\r\n        clear: both;\r\n        content: \"\";\r\n        display: table;\r\n    }\r\n\r\n    .cd-primary-nav.moves-out > li > a {\r\n        @include transform(translateX(0));\r\n        opacity: 1;\r\n    }\r\n\r\n    .cd-primary-nav ul {\r\n        position: static;\r\n        height: auto;\r\n        width: auto;\r\n        background: transparent;\r\n        overflow: visible;\r\n        z-index: 3;\r\n    }\r\n\r\n    .cd-primary-nav ul.is-hidden {\r\n        @include transform(translateX(0));\r\n    }\r\n\r\n    .cd-primary-nav ul.moves-out > li > a {\r\n        @include transform(translateX(0));\r\n        opacity: 1;\r\n    }\r\n\r\n    .cd-primary-nav > li {\r\n        float: left;\r\n    }\r\n\r\n    .cd-primary-nav > li > a {\r\n        position: relative;\r\n        display: inline-block;\r\n        height: 70px;\r\n        line-height: 70px;\r\n        padding: 0 10px;\r\n        color: $dark-grey;\r\n        overflow: visible;\r\n        border-bottom: none;\r\n        -webkit-transition: color 0.3s, box-shadow 0.3s;\r\n        -moz-transition: color 0.3s, box-shadow 0.3s;\r\n        transition: color 0.3s, box-shadow 0.3s;\r\n    }\r\n\r\n    .cd-primary-nav > li > a:hover {\r\n        color: $accent-color;\r\n    }\r\n\r\n    .cd-primary-nav > li > a.selected, .cd-primary-nav > li > a:hover {\r\n        color: $accent-color;\r\n        box-shadow: inset 0 -2px 0 $accent-color;\r\n    }\r\n\r\n    .cd-primary-nav .go-back, .cd-primary-nav .see-all, .mobileSubMenuHeader {\r\n        display: none;\r\n    }\r\n\r\n    .cd-primary-nav .cd-secondary-nav {\r\n        /* dropdown menu style */\r\n        position: absolute;\r\n        top: 70px;\r\n        width: 100vw;\r\n        height: 530px;\r\n        background: #ffffff;\r\n        padding: 60px calc((100vw - 1440px) / 2);\r\n        box-shadow: inset 0 1px 0 #e2e3df, 0 3px 6px rgba(0, 0, 0, 0.05);\r\n        -webkit-transition: opacity .3s 0s, visibility 0s 0s;\r\n        -moz-transition: opacity .3s 0s, visibility 0s 0s;\r\n        transition: opacity .3s 0s, visibility 0s 0s;\r\n        @include transform(translateX(0));\r\n    }\r\n\r\n    .cd-primary-nav .cd-secondary-nav::after {\r\n        clear: both;\r\n        content: \"\";\r\n        display: table;\r\n    }\r\n\r\n    .cd-primary-nav .cd-secondary-nav.is-hidden  {\r\n        opacity: 0;\r\n        visibility: hidden;\r\n        -webkit-transition: opacity .3s 0s, visibility 0s .3s;\r\n        -moz-transition: opacity .3s 0s, visibility 0s .3s;\r\n        transition: opacity .3s 0s, visibility 0s .3s;\r\n    }\r\n\r\n    .cd-primary-nav .cd-secondary-nav > .see-all {\r\n        /* this is the BIG See all button at the bottom of the dropdown menu */\r\n        display: block;\r\n        position: absolute;\r\n        left: 0;\r\n        bottom: 0;\r\n        height: 65px;\r\n        width: 100%;\r\n        overflow: hidden;\r\n        /* reset some inherited style */\r\n        margin: 0;\r\n        padding: 0;\r\n    }\r\n\r\n    .cd-primary-nav .cd-secondary-nav > .see-all a {\r\n        position: absolute;\r\n        width: 100%;\r\n        height: 100%;\r\n        top: 0;\r\n        left: 0;\r\n        font-size: 15px;\r\n        font-weight: bold;\r\n        text-align: center;\r\n        line-height: 65px;\r\n        /* reset some inherited style */\r\n        border-bottom: none;\r\n        margin: 0;\r\n        padding: 0;\r\n        background: $accent-color;\r\n        -webkit-transition: color 0.2s, background 0.2s, border 0.2s;\r\n        -moz-transition: color 0.2s, background 0.2s, border 0.2s;\r\n        transition: color 0.2s, background 0.2s, border 0.2s;\r\n        color: #ffffff;\r\n    }\r\n\r\n    .cd-primary-nav .cd-secondary-nav > .see-all a:hover {\r\n        background: $accent-color;\r\n        border-color: #2e3233;\r\n        color: #ffffff;\r\n    }\r\n\r\n    .cd-primary-nav .cd-secondary-nav > li {\r\n        height: auto;\r\n        width: 260px;\r\n        float: left;\r\n        overflow: hidden;\r\n        overflow-x: hidden;\r\n        -webkit-overflow-scrolling: touch;\r\n    }\r\n\r\n    .cd-primary-nav .cd-secondary-nav > li:nth-child(4n+2) {\r\n        margin-right: 0;\r\n        border-right: none;\r\n    }\r\n\r\n    .cd-primary-nav .cd-secondary-nav > li > a {\r\n        color: $dark-grey;\r\n        font-weight: 600;\r\n        font-size: 15px;\r\n    }\r\n\r\n    .see-all a {\r\n        color: #fff;\r\n    }\r\n\r\n    .cd-primary-nav .cd-secondary-nav a {\r\n        height: 27px;\r\n        line-height: 27px;\r\n        padding: 0 18% 0 0;\r\n        color: #2e3233;\r\n        border-bottom: none;\r\n        font-size: 15px;\r\n        font-weight: normal;\r\n        -webkit-transition: all 0.3s, -webkit-transform 0.3s;\r\n        -moz-transition: all 0.3s, -moz-transform 0.3s;\r\n        transition: all 0.3s, transform 0.3s;\r\n    }\r\n\r\n    .cd-primary-nav .cd-secondary-nav a:hover {\r\n        color: $accent-color;\r\n        text-shadow: 2px 4px 2px rgba(0,0,0,0.09);\r\n    }\r\n\r\n    .cd-primary-nav .cd-secondary-nav ul {\r\n        @include transform(translateZ(0));\r\n    }\r\n\r\n    .cd-primary-nav .cd-secondary-nav ul ul {\r\n        /* tertiary navigation */\r\n        position: absolute;\r\n        top: 0;\r\n        left: 0;\r\n        height: 100%;\r\n        width: 100%;\r\n    }\r\n\r\n    .cd-primary-nav .cd-secondary-nav ul ul.is-hidden {\r\n        @include transform(translateX(100%));\r\n    }\r\n\r\n    .cd-primary-nav .cd-secondary-nav ul ul .go-back {\r\n        display: block;\r\n    }\r\n\r\n    .cd-primary-nav .cd-secondary-nav ul ul .see-all {\r\n        display: block;\r\n    }\r\n\r\n    .cd-primary-nav .cd-secondary-nav .moves-out > li > a {\r\n        /* push the navigation items to the left - and lower down opacity - when tertiary nav slides in */\r\n        @include transform(translateX(-100%));\r\n    }\r\n}\r\n\r\n.has-children > a, .go-back a {\r\n    position: relative;\r\n}\r\n\r\n@media only screen and (max-width: 1169px) {\r\n    ul.cd-primary-nav ul, ul.cd-primary-nav ul ul {\r\n        z-index: 1;\r\n        display: none;\r\n    }\r\n\r\n    ul.nav-is-visible ul, ul.nav-is-visible ul ul {\r\n        z-index: 10;\r\n        display: block;\r\n    }\r\n\r\n    .has-children > a::before, .has-children > a::after, .go-back a::before, .go-back a::after {\r\n        content: '';\r\n        position: absolute;\r\n        top: 50%;\r\n        margin-top: -1px;\r\n        display: inline-block;\r\n        height: 2px;\r\n        width: 10px;\r\n        background: #22004d;\r\n        -webkit-backface-visibility: hidden;\r\n        backface-visibility: hidden;\r\n    }\r\n\r\n    .has-children > a::before, .go-back a::before {\r\n        @include transform(rotate(45deg));\r\n    }\r\n\r\n    .has-children > a::after, .go-back a::after {\r\n        @include transform(rotate(-45deg));\r\n    }\r\n\r\n    .has-children > a {\r\n        padding-right: 40px;\r\n        font-weight: 600;\r\n    }\r\n\r\n    .has-children > a::before, .has-children > a::after {\r\n        right: 20px;\r\n        @include transform-origin(9px 50%);\r\n    }\r\n\r\n    .cd-primary-nav .go-back a {\r\n        padding-left: 40px;\r\n        font-weight: 600;\r\n    }\r\n\r\n    .cd-primary-nav .go-back a::before, .cd-primary-nav .go-back a::after {\r\n        left: 20px;\r\n        @include transform-origin(1px 50%);\r\n    }\r\n}\r\n\r\n@media only screen and (min-width: 1170px) {\r\n    .is-third-level {\r\n        cursor: pointer;\r\n    }\r\n\r\n    .has-children.is-third-level > a::before, .has-children.is-third-level > a::after, .go-back a::before, .go-back a::after {\r\n        background: #a2a6a7;\r\n        right: 15%;\r\n        @include transform-origin(8px 50%);\r\n    }\r\n\r\n    .has-children.is-third-level > a:hover::before, .has-children.is-third-level > a:hover::after, .go-back a:hover::before, .go-back a:hover::after {\r\n        background: $accent-color;\r\n    }\r\n\r\n    .has-children.is-third-level > a::before, .go-back a::before {\r\n        @include transform(rotate(45deg));\r\n    }\r\n\r\n    .has-children.is-third-level > a::after, .go-back a::after {\r\n        @include transform(rotate(-45deg));\r\n    }\r\n\r\n    .has-children.is-third-level > a::before, .has-children.is-third-level > a::after, .go-back a::before, .go-back a::after {\r\n        content: '';\r\n        position: absolute;\r\n        top: 50%;\r\n        margin-top: -1px;\r\n        display: inline-block;\r\n        height: 1px;\r\n        width: 8px;\r\n        background: #a2a6a7;\r\n        -webkit-backface-visibility: hidden;\r\n        backface-visibility: hidden;\r\n    }\r\n\r\n    .cd-primary-nav .go-back a::before, .cd-primary-nav .go-back a::after {\r\n        left: 1px;\r\n    }\r\n\r\n    .cd-primary-nav .go-back.bg-light {\r\n        background-color: transparent !important;\r\n    }\r\n\r\n    .cd-primary-nav .go-back {\r\n        a span {\r\n            display: none;\r\n        }\r\n    }\r\n\r\n    .cd-primary-nav .go-back a::before, .cd-primary-nav .go-back a::after {\r\n        @include transform-origin(1px 50%);\r\n    }\r\n}\r\n\r\n.cd-overlay {\r\n    /* shadow layer visible when navigation is active */\r\n    position: fixed;\r\n    z-index: 2;\r\n    height: 100%;\r\n    width: 100%;\r\n    top: 0;\r\n    left: 0;\r\n    cursor: pointer;\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n    visibility: hidden;\r\n    opacity: 0;\r\n    -webkit-backface-visibility: hidden;\r\n    backface-visibility: hidden;\r\n    -webkit-transition: opacity 0.3s 0s, visibility 0s 0.3s, -webkit-transform 0.3s 0s;\r\n    -moz-transition: opacity 0.3s 0s, visibility 0s 0.3s, -moz-transform 0.3s 0s;\r\n    transition: opacity 0.3s 0s, visibility 0s 0.3s, transform 0.3s 0s;\r\n}\r\n\r\n.cd-overlay.is-visible {\r\n    opacity: 1;\r\n    visibility: visible;\r\n    -webkit-transition: opacity 0.3s 0s, visibility 0s 0s, -webkit-transform 0.3s 0s;\r\n    -moz-transition: opacity 0.3s 0s, visibility 0s 0s, -moz-transform 0.3s 0s;\r\n    transition: opacity 0.3s 0s, visibility 0s 0s, transform 0.3s 0s;\r\n}\r\n\r\n@media only screen and (max-width: 1169px) {\r\n    .cd-overlay {\r\n        background-color: rgba(0, 0, 0, 0.3);\r\n        z-index: 11;\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 1169px) {\r\n    .nav-on-left .cd-overlay.is-visible {\r\n        @include transform(translateX(50vw));\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 767px) {\r\n    .nav-on-left .cd-overlay.is-visible {\r\n        @include transform(translateX(80vw));\r\n    }\r\n}\r\n\r\n\r\n.uspContainer {\r\n    width: 500px;\r\n    height: 529px;\r\n    position: absolute;\r\n    padding: 30px;\r\n    top: 1px;\r\n    background-color: #FBF8F5;\r\n\r\n    h3.uspHeader {\r\n        font-weight: 600;\r\n        font-size: 21px;\r\n        line-height: 29px;\r\n        letter-spacing: 0.3px;\r\n        color: #E5A934;\r\n        margin-bottom: 13px;\r\n    }\r\n\r\n    .uspPayoff {\r\n        font-weight: 600;\r\n        font-size: 18px;\r\n        line-height: 25px;\r\n        color: #000000;\r\n        margin-bottom: 8px;\r\n    }\r\n\r\n    .usp-list {\r\n        margin-left: 26px;\r\n        padding-left: 22px;\r\n        margin-top: 20px;\r\n        margin-bottom: 20px;\r\n    }\r\n\r\n    .usp-list li {\r\n        font-size: 15px;\r\n        line-height: 20px;\r\n        letter-spacing: 0.3px;\r\n        font-weight: normal;\r\n        font-style: normal;\r\n        color: #000;\r\n        display: block;\r\n        margin-top: 4px;\r\n\r\n        a {\r\n            display: inline;\r\n            color: #440099;\r\n            text-decoration: underline;\r\n        }\r\n\r\n        &:before {\r\n            content: \"\\F0E1E\";\r\n            font-family: 'Material Design Icons';\r\n            font-size: 14px;\r\n            margin-left: -26px;\r\n            float: left;\r\n            margin-top: 2px;\r\n            color: #000;\r\n            font-style: normal;\r\n        }\r\n    }\r\n}\r\n\r\n@media(max-width: 1299px) {\r\n    .uspContainer, .menuImageSprite {\r\n        width: 450px;\r\n    }\r\n}\r\n\r\n/* -------------------------------- \r\nsupport for no js \r\n-------------------------------- */\r\n.no-js .cd-primary-nav {\r\n    position: relative;\r\n    height: auto;\r\n    width: 100%;\r\n    overflow: visible;\r\n    visibility: visible;\r\n    z-index: 2;\r\n}\r\n\r\n@media only screen and (min-width: 1170px) {\r\n    .no-js .cd-primary-nav {\r\n        position: absolute;\r\n        z-index: 3;\r\n        display: inline-block;\r\n        width: auto;\r\n        top: 0;\r\n        right: 150px;\r\n        padding: 0;\r\n    }\r\n\r\n    .no-js .nav-is-fixed .cd-primary-nav {\r\n        position: fixed;\r\n    }\r\n}\r\n\r\n.menuImageSprite {\r\n    display: none;\r\n}\r\n\r\n@media only screen and (min-width: 1170px) {\r\n    .firstMainMenuItem {\r\n        margin-left: 17em !important;\r\n    }\r\n\r\n    .menuImageSprite {\r\n        width: 450px !important;\r\n        height: 450px !important;\r\n        margin-top: -50px !important;\r\n        -webkit-transition: opacity .25s ease-in;\r\n        -moz-transition: opacity .25s ease-in;\r\n        -ms-transition: opacity .25s ease-in;\r\n        -o-transition: opacity .25s ease-in;\r\n        transition: opacity .25s ease-in;\r\n        background-size: cover;\r\n        background-repeat: no-repeat;\r\n        display: block;\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 1280px) {\r\n    .menuImageSprite {\r\n        width: 450px !important;\r\n    }\r\n}\r\n\r\n@media only screen and (min-width: 1700px) {\r\n    .firstMainMenuItem {\r\n        margin-left: calc((100vw - 1700px)/2 + 17em) !important;\r\n    }\r\n}\r\n\r\n.menuPosition {\r\n    position: absolute;\r\n}\r\n\r\n@media only screen and (max-width: 1169px) {\r\n    .menuPosition {\r\n        height: auto !important;\r\n        top: auto !important;\r\n        left: auto !important;\r\n        position: relative !important;\r\n    }\r\n}\r\n\r\n.mobileMetaMenu, .mobileMenuHeader {\r\n    display: none;\r\n}\r\n\r\n@media(max-width: 1169px) {\r\n\r\n    .mobileMetaMenu {\r\n        display: block;\r\n        margin: 0;\r\n        padding: 0;\r\n        border: 0;\r\n        font-size: 19px;\r\n        letter-spacing: 0.2px;\r\n        vertical-align: baseline;\r\n\r\n        .mdi {\r\n            line-height: 54px;\r\n        }\r\n\r\n        .mdi::before {\r\n            padding-left: 0;\r\n        }\r\n\r\n        a {\r\n            display: block;\r\n            height: 67px;\r\n            line-height: 67px;\r\n            padding: 0 32px;\r\n            color: #0095DB;\r\n            font-weight: 500;\r\n            -webkit-font-smoothing: antialiased;\r\n            -moz-osx-font-smoothing: grayscale;\r\n            overflow: hidden;\r\n            text-overflow: ellipsis;\r\n            white-space: nowrap;\r\n            will-change: transform, opacity;\r\n            -webkit-transition: -webkit-transform 0.3s, opacity 0.3s;\r\n            -moz-transition: -moz-transform 0.3s, opacity 0.3s;\r\n            transition: transform 0.3s, opacity 0.3s;\r\n            @include transform(translateZ(0));\r\n        }\r\n\r\n        .mdi:before {\r\n            font-size: 18px;\r\n            position: relative;\r\n            top: 1px;\r\n            margin-right: 3px;\r\n        }\r\n    }\r\n\r\n    .mobileMenuHeader {\r\n        display: block;\r\n        margin: 0;\r\n        padding: 0;\r\n        border: 0;\r\n        font-size: 19px;\r\n        letter-spacing: 0.2px;\r\n        vertical-align: baseline;\r\n\r\n        div {\r\n            a {\r\n                height: auto;\r\n                line-height: normal;\r\n                padding: 3px;\r\n                border: 0;\r\n                color: $accent-color;\r\n            }\r\n\r\n            padding: 21px 32px;\r\n            line-height: 25px;\r\n            height: 67px;\r\n            border-bottom: 1px solid rgba(238, 236, 237, 0.5);\r\n            font-weight: 600;\r\n        }\r\n    }\r\n}\r\n\r\n@media(min-width: 1170px) {\r\n    .mobileMetaMenu.viewAllTopLevel {\r\n        display: block;\r\n        top: 470px;\r\n        left: calc(100vw / 2);\r\n        position: absolute;\r\n    }\r\n}\r\n\r\n// To account for \"large\" languages before switching to mobile menu\r\n@media(min-width: 1170px) and (max-width: 1340px) {\r\n    .firstMainMenuItem {\r\n        margin-left: 18em !important;\r\n    }\r\n\r\n    .cd-primary-nav > li > a {\r\n        padding: 0 5px !important;\r\n    }\r\n\r\n    .cd-nav li {\r\n        font-size: 13px !important;\r\n    }\r\n}\r\n\r\na.jump-to-main-content {\r\n    position: absolute;\r\n    left: -1500px;\r\n    width: 1px;\r\n    height: 1px;\r\n\r\n    &:focus, &:active {\r\n        color: #fff;\r\n        background-color: #000;\r\n        left: auto;\r\n        top: auto;\r\n        width: 30%;\r\n        height: auto;\r\n        overflow: auto;\r\n        margin: 10px 35%;\r\n        padding: 5px;\r\n        border-radius: 15px;\r\n        border: 4px solid yellow;\r\n        text-align: center;\r\n        font-size: 1.2em;\r\n        z-index: 999;\r\n    }\r\n}\r\n\r\n\r\n",".footer {\r\n    position: relative;\r\n    padding: 39px 0 0;\r\n    margin: 0 auto;\r\n    min-height: 120px;\r\n    display: block;\r\n    width: 100%;\r\n    bottom: 0;\r\n    font-family: 'Open Sans', sans-serif;\r\n    color: $text-color;\r\n\r\n    &.solid-bg {\r\n        background-color: $color-lighter-purple;\r\n    }\r\n\r\n    .footer-heading {\r\n        padding-bottom: 7px;\r\n        display: inline-block;\r\n        font-size: 1rem;\r\n        font-weight: 600;\r\n    }\r\n\r\n    .leftlinks {\r\n        margin-right: 20px;\r\n        color: !important\r\n    }\r\n\r\n    .slogan-bubble {\r\n        line-height: 1.4rem;\r\n        color: $text-color;\r\n        padding-bottom: 10px;\r\n        font-size: 0.85rem;\r\n\r\n        .social-media-header {\r\n            font-size: 16px;\r\n            font-weight: 600;\r\n        }\r\n    }\r\n\r\n    .allmanavillkor a, .allmanavillkor a:hover {\r\n        color: $accent-color !important;\r\n    }\r\n\r\n    .logo-space {\r\n        max-width: 250px;\r\n    }\r\n\r\n    .logo-space a {\r\n        &:hover {\r\n            color: #000 !important;\r\n        }\r\n\r\n        color: $text-color !important;\r\n    }\r\n\r\n    .footer-link {\r\n        color: $text-color;\r\n        display: block;\r\n\r\n        &:hover {\r\n            color: #000;\r\n        }\r\n    }\r\n\r\n    .logo-space .mdi {\r\n        font-size: 1.875rem;\r\n        margin-right: 1.1rem;\r\n        display: inline-block;\r\n    }\r\n\r\n    .payment-delivery-space {\r\n        padding: 12px;\r\n        img {\r\n            height: 25px;\r\n        }\r\n    }\r\n\r\n    .footer-zinzino-test {\r\n        background-color: #FFFFFF;\r\n        box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);\r\n        border-radius: 15px;\r\n        width: 267px;\r\n        height: 70px;\r\n        cursor: pointer;\r\n\r\n        &:hover {\r\n            background-color: #C4B1CF;\r\n        }\r\n\r\n        .footer-zinzino-test-image {\r\n            float: left;\r\n            width: 73px;\r\n            height: 100%;\r\n            background-image: url(https://zinzinowebstorage.blob.core.windows.net/images/footer-zinzino-test.png);\r\n            background-size: cover;\r\n            border-top-left-radius: 15px;\r\n            border-bottom-left-radius: 15px;\r\n        }\r\n\r\n        .footer-zinzino-test-text {\r\n            width: 194px;\r\n            float: right;\r\n            padding: 12px 10px 10px 15px;\r\n            font-size: 12px;\r\n            position: relative;\r\n\r\n            p {\r\n                font-size: 18px;\r\n                font-weight: 600;\r\n                margin: 0;\r\n            }\r\n\r\n            &::after {\r\n                content: \"\\F03CC\";\r\n                font: normal normal normal 24px/1 \"Material Design Icons\";\r\n                position: absolute;\r\n                top: 9px;\r\n                right: 13px;\r\n                font-size: 15px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .hide-on-mobile {\r\n        line-height: 2rem;\r\n    }\r\n\r\n    .zinzino-header-logo {\r\n        width: 214px;\r\n        height: 34px;\r\n    }\r\n\r\n    .mainmenu-link {\r\n        height: 100% !important;\r\n    }\r\n\r\n    @include media-breakpoint-up(md) {\r\n        .hide-on-mobile {\r\n            line-height: 2rem;\r\n            display: block !important;\r\n        }\r\n    }\r\n\r\n\r\n    @include media-breakpoint-down(sm) {\r\n\r\n        .footer-container {\r\n            max-width: 540px !important;\r\n        }\r\n\r\n        .hide-on-mobile {\r\n            display: none;\r\n\r\n            .footer a {\r\n                line-height: 1rem !important;\r\n                font-size: 1rem;\r\n                text-decoration: none;\r\n            }\r\n        }\r\n\r\n        .slogan-bubble {\r\n            display: block;\r\n            margin: auto;\r\n            word-break: break-word;\r\n            font-size: $font-size-base * 0.75;\r\n            line-height: $font-size-base * 1.2;\r\n        }\r\n\r\n        .leftlinks {\r\n            margin-right: unset !important;\r\n        }\r\n\r\n        .allmanavillkor {\r\n            padding-top: 15px;\r\n        }\r\n\r\n        .mobile-footleft {\r\n            padding: 0px !important;\r\n            clear: both;\r\n            margin-bottom: 0 !important;\r\n            width: 100%;\r\n            margin: 0;\r\n            cursor: pointer;\r\n\r\n            br {\r\n                display: none;\r\n            }\r\n\r\n            .footer-heading {\r\n                line-height: 40px;\r\n                margin: 0 !important;\r\n                padding: 0 0 0 1rem !important;\r\n            }\r\n        }\r\n\r\n        .footer-link {\r\n            padding-left: 1rem;\r\n            width: 100%;\r\n        }\r\n\r\n        .footer-heading {\r\n            width: 100%;\r\n            cursor: pointer;\r\n        }\r\n\r\n        .footer-arrowLinkWrapper {\r\n            width: 22px;\r\n            height: 22px;\r\n            position: absolute;\r\n            right: 12px;\r\n        }\r\n\r\n        .footer-link-showHide {\r\n            border: solid $color-black;\r\n            border-width: 0 2px 2px 0;\r\n            display: inline-block;\r\n            position: absolute;\r\n            padding: 4px;\r\n            top: 10px;\r\n            left: 5px;\r\n            line-height: 17px;\r\n            -webkit-transition: -webkit-transform linear 0.7s;\r\n            -moz-transition: -moz-transform 0.7s;\r\n            transition: transform 0.7s;\r\n        }\r\n\r\n        .footer-link-up {\r\n            transform: rotate(-135deg);\r\n            -moz-transform: rotate(-135deg);\r\n            -webkit-transform: rotate(-135deg);\r\n            top: 14px;\r\n        }\r\n\r\n        .footer-link-down {\r\n            transform: rotate(45deg);\r\n            -moz-transform: rotate(45deg);\r\n            -webkit-transform: rotate(45deg);\r\n            top: 14px;\r\n        }\r\n    }\r\n\r\n    .footer-bottom {\r\n        min-height: 43px;\r\n        background-color: $accent-color;\r\n        text-align: center;\r\n        margin-top: 34px;\r\n        padding: 11px;\r\n\r\n        ul {\r\n            list-style: none;\r\n            padding-left: 0;\r\n            margin: 0;\r\n\r\n            li {\r\n                display: inline;\r\n\r\n                a {\r\n                    color: #fff;\r\n                    font-weight: 600;\r\n                    font-size: 14px;\r\n                    padding: 0 10px;\r\n                    letter-spacing: 0.02em;\r\n\r\n                    &:hover {\r\n                        text-decoration: underline;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .disclaimer-area {\r\n        border-radius: 10px;\r\n        background: rgba(255, 255, 255, 0.4);\r\n        font-size: 12px;\r\n        font-weight: 400;\r\n        line-height: 22px;\r\n        max-width: 940px;\r\n        margin: 20px auto 0;\r\n        text-align: center;\r\n        padding: 14px;\r\n        color: #242829;\r\n    }\r\n}\r\n",".login-button {\r\n    position: absolute;\r\n    z-index: 700;\r\n    top: 0;\r\n    right: 15px;\r\n    user-select: none;\r\n    cursor: pointer;\r\n    outline: 0;\r\n    display: block;\r\n}\r\n\r\na.login-url {\r\n    color: #fff;\r\n    padding: 0 25px;\r\n\r\n    &:hover, &:focus, &:visited {\r\n        color: #fff;\r\n        color:#fff;\r\n\r\n    }\r\n}\r\n\r\n.cd-main-content, .cd-main-header {\r\n    -webkit-transition: -webkit-transform 0.3s;\r\n    -moz-transition: -moz-transform 0.3s;\r\n    transition: transform 0.3s;\r\n}\r\n\r\n.cd-main-content {\r\n    background: #fff;\r\n    min-height: calc(100vh - 250px);\r\n    z-index: 2;\r\n    padding-top: 100px;\r\n\r\n    &:has(.news-sticky-nav-tabs), &:has(.news-search-container) {\r\n        background: #f2f2f2;\r\n    }\r\n\r\n    &:has(.visiting-info-centered) {\r\n        padding-top: 126px;\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 1169px) {\r\n    .cd-main-content {\r\n        padding-top: 90px;\r\n\r\n        &:has(.visiting-info-centered) {\r\n            padding-top: 116px;\r\n        }\r\n    }\r\n}\r\n\r\n.visiting-info-centered {\r\n    width: 100%;\r\n    text-align: center;\r\n    font-size: 11px;\r\n    z-index: 2000;\r\n    background-color: #fff;\r\n    border-radius: 0px;\r\n    z-index: 9;\r\n    color: $dark-grey;\r\n    font-size: 11px;\r\n    line-height: 16px;\r\n    height: auto;\r\n\r\n    div {\r\n        padding: 5px 0;\r\n    }\r\n}\r\n\r\n.visiting-info-centered.isEnrolling {\r\n    background-color: #fff;\r\n    color: $dark-grey;\r\n}\r\n\r\n.cd-main-header {\r\n    height: auto;\r\n    background: #ffffff;\r\n    z-index: 3;\r\n    -webkit-box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.25);\r\n    -moz-box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.25);\r\n    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.25);\r\n    position: fixed;\r\n    width: 100vw;\r\n}\r\n\r\n.nav-is-fixed .cd-main-header {\r\n    /* add .nav-is-fixed class to body if you want a fixed navigation on > 1170px */\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100vw;\r\n}\r\n\r\n@media only screen and (min-width: 1170px) {\r\n    .cd-main-header {\r\n        height: auto;\r\n    }\r\n\r\n    .cd-main-header::after {\r\n        clear: both;\r\n        content: \"\";\r\n        display: table;\r\n    }\r\n}\r\n\r\n.zz-logo-link {\r\n    z-index: 10;\r\n}\r\n\r\n.cd-logo {\r\n    position: absolute;\r\n    bottom: 10px;\r\n    left: 5%;\r\n    z-index: 12;\r\n    height: 31px;\r\n}\r\n\r\n.cd-logo img {\r\n    display: block;\r\n}\r\n\r\n@media only screen and (max-width: 1169px) {\r\n    .nav-on-left .cd-logo {\r\n        left: auto;\r\n        right: calc(50% - 95px);\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 767px) {\r\n    .nav-on-left .cd-logo {\r\n        left: auto;\r\n        right: calc(50% - 75px);\r\n    }\r\n\r\n    .zz-logo-link, .zzSvgLogo {\r\n        width: 150px;\r\n    }\r\n}\r\n\r\n@media only screen and (min-width: 1170px) {\r\n    .cd-logo {\r\n        bottom: 19px;\r\n        left: 2%;\r\n    }\r\n}\r\n\r\n.cd-header-buttons {\r\n    position: absolute;\r\n    display: inline-block;\r\n    bottom: 0;\r\n    right: 5%;\r\n    margin-bottom: 8px;\r\n}\r\n\r\n.cd-header-buttons li {\r\n    display: inline-block;\r\n    list-style-position: inside;\r\n    margin-left: 0;\r\n}\r\n\r\n@media only screen and (max-width: 1169px) {\r\n    .nav-on-left .cd-header-buttons {\r\n        right: auto;\r\n        left: 3%;\r\n        padding-left: 0;\r\n    }\r\n\r\n    .nav-on-left .cd-header-buttons li {\r\n        float: right;\r\n    }\r\n}\r\n\r\n@media only screen and (min-width: 1170px) {\r\n    .cd-header-buttons {\r\n        bottom: 0;\r\n        right: 4em;\r\n    }\r\n}\r\n\r\n.cd-nav-trigger {\r\n    position: relative;\r\n    display: block;\r\n    width: 44px;\r\n    height: 44px;\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n    /* hide text */\r\n    color: transparent;\r\n    z-index: 3;\r\n}\r\n\r\n.cd-nav-trigger span, .cd-nav-trigger span::before, .cd-nav-trigger span::after {\r\n    /* hamburger icon in CSS */\r\n    position: absolute;\r\n    display: inline-block;\r\n    height: 3px;\r\n    width: 24px;\r\n    background: #2e3233;\r\n}\r\n\r\n.cd-nav-trigger span {\r\n    /* line in the center */\r\n    position: absolute;\r\n    top: 50%;\r\n    right: 10px;\r\n    margin-top: -2px;\r\n    -webkit-transition: background 0.3s 0.3s;\r\n    -moz-transition: background 0.3s 0.3s;\r\n    transition: background 0.3s 0.3s;\r\n}\r\n\r\n.cd-nav-trigger span::before, .cd-nav-trigger span::after {\r\n    /* other 2 lines */\r\n    content: '';\r\n    right: 0;\r\n    /* Force Hardware Acceleration in WebKit */\r\n    -webkit-backface-visibility: hidden;\r\n    backface-visibility: hidden;\r\n    -webkit-transition: -webkit-transform 0.3s 0.3s;\r\n    -moz-transition: -moz-transform 0.3s 0.3s;\r\n    transition: transform 0.3s 0.3s;\r\n    @include transform(translateZ(0));\r\n    @include transform-origin(0% 50%);\r\n}\r\n\r\n.cd-nav-trigger span::before {\r\n    /* menu icon top line */\r\n    top: -6px;\r\n}\r\n\r\n.cd-nav-trigger span::after {\r\n    /* menu icon bottom line */\r\n    top: 6px;\r\n}\r\n\r\n.cd-nav-trigger.nav-is-visible span {\r\n    /* hide line in the center */\r\n    background: rgba(46, 50, 51, 0);\r\n}\r\n\r\n.cd-nav-trigger.nav-is-visible span::before, .cd-nav-trigger.nav-is-visible span::after {\r\n    /* keep visible other 2 lines */\r\n    background: #2e3233;\r\n}\r\n\r\n.cd-nav-trigger.nav-is-visible span::before {\r\n    @include transform(translateX(4px) translateY(-3px) rotate(45deg));\r\n}\r\n\r\n.cd-nav-trigger.nav-is-visible span::after {\r\n    @include transform(translateX(4px) translateY(2px) rotate(-45deg));\r\n}\r\n\r\n@media only screen and (min-width: 1170px) {\r\n    .cd-nav-trigger {\r\n        display: none;\r\n    }\r\n}\r\n\r\n@media only screen and (min-width: 1700px) {\r\n    .cd-logo {\r\n        left: calc((100vw - 1700px)/2 + 30px);\r\n    }\r\n\r\n    .zzPreHeaderCountry {\r\n        margin-left: calc((100vw - 1700px)/2 + 10px);\r\n    }\r\n\r\n    .zzPreHeaderRight {\r\n        margin-right: calc((100vw - 1700px)/2 + 10px) !important;\r\n    }\r\n\r\n    .zzPreHeaderCart {\r\n        right: calc((100vw - 1700px)/2 + 25px) !important;\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 1169px) {\r\n    .zzPreHeaderCountry {\r\n        display: none;\r\n    }\r\n}\r\n\r\n.zzPreHeader {\r\n    width: 100%;\r\n    height: 30px;\r\n    background-color: $accent-color;\r\n    color: #fff;\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n    padding: 2px 20px;\r\n    vertical-align: middle;\r\n\r\n    a, a:focus, a:active {\r\n        color: #fff;\r\n        line-height: 26px;\r\n    }\r\n\r\n    a:hover {\r\n        color: #f5f7fa;\r\n    }\r\n\r\n    .mdi:before {\r\n        font-size: 16px;\r\n        position: relative;\r\n        top: 2px;\r\n        margin-right: 3px;\r\n    }\r\n}\r\n\r\n.zzPreHeaderCountry {\r\n    float: left;\r\n    line-height: 26px;\r\n}\r\n\r\n.zzPreHeaderRight {\r\n    float: right;\r\n    padding-right: 10px;\r\n    margin-right: calc(2% + 10px);\r\n    margin-top: -2px;\r\n}\r\n\r\n@media(max-width: 767px){\r\n    .zzPreHeaderRight {\r\n        margin-right: 7px;\r\n        margin-top: 0;\r\n    }\r\n}\r\n\r\n.zzPreHeaderCalendar {\r\n    float: left;\r\n    padding-left: 30px;\r\n    line-height: 26px;\r\n}\r\n\r\n.zzPreHeaderSupport {\r\n    float: left;\r\n    padding-left: 30px;\r\n    line-height: 26px;\r\n}\r\n\r\n.zzPreHeaderBlog {\r\n    float: left;\r\n    padding-left: 30px;\r\n    line-height: 26px;\r\n}\r\n\r\n.zzPreHeaderLogin {\r\n    float: left;\r\n    padding-left: 30px;\r\n    line-height: 26px;\r\n}\r\n\r\n.zzPreHeaderCart {\r\n    float: left;\r\n    padding-left: 20px;\r\n    line-height: 26px;\r\n    z-index: 13;\r\n    position: absolute;\r\n    bottom: 20px;\r\n    right: calc(5%);\r\n    font-size: 24px;\r\n    cursor: pointer;\r\n\r\n    span {\r\n        display: none;\r\n\r\n        a.zzPreHeaderCart i.mdi-cart::before {\r\n            color: #242829;\r\n        }\r\n    }\r\n}\r\n\r\n.zzPreHeaderSwitchWeb {\r\n    float: left;\r\n    padding-left: 30px;\r\n    line-height: 26px;\r\n}\r\n\r\n.zzSignOut {\r\n    float: left;\r\n    padding-right: 30px;\r\n}\r\n\r\n@media(max-width: 1169px) {\r\n    .zzPreHeaderSwitchWeb {\r\n        padding-left: 10px;\r\n    }\r\n    .zzPreHeader {\r\n        padding: 0 10px;\r\n    }\r\n\r\n    .zzPreHeaderCalendar, .zzPreHeaderSupport, .zzPreHeaderBlog {\r\n        display: none;\r\n    }\r\n\r\n    .zzPreHeaderLogin {\r\n        padding-left: 2%;\r\n    }\r\n\r\n\r\n    .cd-logo {\r\n        position: absolute;\r\n        bottom: 14px;\r\n        left: 25%;\r\n    }\r\n}\r\n\r\n.panel-heading span .mdi {\r\n    line-height: 10px;\r\n}\r\n\r\n.content-header {\r\n    padding-right: 30px !important;\r\n    padding-left: 30px !important;\r\n\r\n    .row .col-12 h2 {\r\n        font-size: 30px;\r\n        font-weight: bold;\r\n        text-transform: uppercase;\r\n    }\r\n\r\n    @media(max-width: 767px) {\r\n        .row .col-12 h2 {\r\n            font-size: 20px;\r\n        }\r\n    }\r\n}\r\n\r\n.replicated-site-info {\r\n    position: fixed;\r\n    bottom: 0;\r\n    left: 0;\r\n    display: none;\r\n\r\n    @media(max-width: 767px) {\r\n        width: 100%;\r\n    }\r\n\r\n    @media(min-width: 768px) {\r\n        bottom: 30px;\r\n        left: 45px;\r\n    }\r\n\r\n    @media(max-height: 500px) {\r\n        width: 100%;\r\n        bottom: 0;\r\n        left: 0;\r\n        height: 100%;\r\n\r\n        .replicated-scroll-wrapper {\r\n            height: 100%;\r\n        }\r\n    }\r\n\r\n    z-index: 15;\r\n    -webkit-box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, .25);\r\n    -moz-box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, .25);\r\n    box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, .25);\r\n    text-align: center;\r\n\r\n    .replicated-info-main {\r\n        padding: 55px 30px 30px;\r\n        width: 440px;\r\n        overflow: auto;\r\n        min-height: 330px;\r\n        background-color: #F5F8F8;\r\n\r\n        @media(max-width: 767px) {\r\n            width: auto;\r\n        }\r\n\r\n        @media(max-height: 500px) {\r\n            min-height: unset;\r\n            width: 100%;\r\n            max-height: 100%;\r\n        }\r\n\r\n        .close {\r\n            position: absolute;\r\n            top: 10px;\r\n            right: 30px;\r\n\r\n            @media(min-width: 768px) and (min-height: 499px) {\r\n                right: 15px;\r\n            }\r\n        }\r\n\r\n        .replicated-partner-name {\r\n            font-weight: 400;\r\n            font-size: 24px;\r\n            line-height: 32px;\r\n            letter-spacing: 0.01em;\r\n            margin-bottom: .2rem;\r\n        }\r\n\r\n        .replicated-title {\r\n            font-size: 14px;\r\n            font-weight: 600;\r\n        }\r\n\r\n        .replicated-presentation {\r\n            max-width: 440px;\r\n            margin: 16px auto;\r\n            font-size: 16px;\r\n            line-height: 24px;\r\n        }\r\n\r\n        .replicated-divider {\r\n            margin: 0 auto;\r\n            width: 47px;\r\n            height: 0px;\r\n            border-top: 3px solid #8859C5;\r\n        }\r\n    }\r\n\r\n    .replicated-contact {\r\n        width: 54px;\r\n        height: 54px;\r\n        border-radius: 50%;\r\n        background-color: #440099;\r\n        color: #fff;\r\n        display: inline-flex;\r\n        margin: 0 10px;\r\n        transition: transform .2s;\r\n        cursor: pointer;\r\n\r\n        &::before {\r\n            font-size: 25px;\r\n            padding-top: 14px;\r\n            padding-left: 14px;\r\n        }\r\n\r\n        &:hover {\r\n            transform: scale(1.25);\r\n        }\r\n\r\n        &-small {\r\n            width: 28px;\r\n            height: 28px;\r\n\r\n            &::before {\r\n                font-size: 18px;\r\n                padding-top: 7px;\r\n                padding-left: 7px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .replicated-telephone-show-more {\r\n        display: none;\r\n        width: calc(100% - 20px);\r\n        background-color: #fff;\r\n        border-radius: 17px;\r\n        height: 120px;\r\n        position: absolute;\r\n        top: -40px;\r\n        left: 10px;\r\n        -webkit-box-shadow: 0 -2px 20px 0 rgba(0,0,0,.15);\r\n        -moz-box-shadow: 0 -2px 20px 0 rgba(0,0,0,.15);\r\n        box-shadow: 0 -2px 20px 0 rgba(0,0,0,.15);\r\n        padding: 23px 10px;\r\n\r\n        .replicated-contact-text {\r\n            font-size: 28px;\r\n            font-weight: 400;\r\n            letter-spacing: 0.02em;\r\n            display: block;\r\n            margin-bottom: 15px;\r\n            color: #000;\r\n        }\r\n\r\n        a.replicated-contact-small {\r\n            font-size: 24px;\r\n            padding: 0 15px;\r\n            font-weight: 300;\r\n            cursor: pointer;\r\n        }\r\n    }\r\n\r\n    .replicated-email-show-more {\r\n        display: none;\r\n        width: calc(100% - 20px);\r\n        background-color: #fff;\r\n        border-radius: 17px;\r\n        height: 120px;\r\n        position: absolute;\r\n        top: -40px;\r\n        left: 10px;\r\n        -webkit-box-shadow: 0 -2px 20px 0 rgba(0,0,0,.15);\r\n        -moz-box-shadow: 0 -2px 20px 0 rgba(0,0,0,.15);\r\n        box-shadow: 0 -2px 20px 0 rgba(0,0,0,.15);\r\n        padding: 23px 10px;\r\n\r\n        .replicated-contact-text {\r\n            font-size: 20px;\r\n            font-weight: 400;\r\n            letter-spacing: 0.02em;\r\n            display: block;\r\n            margin-bottom: 15px;\r\n            color: #000;\r\n            display: -webkit-box;\r\n            -webkit-line-clamp: 1;\r\n            -webkit-box-orient: vertical;\r\n            overflow: hidden;\r\n            text-overflow: ellipsis;\r\n            line-height: 26px;\r\n            overflow-wrap: anywhere;\r\n        }\r\n\r\n        a.replicated-contact-small {\r\n\r\n            &::before {\r\n                font-size: 30px;\r\n            }\r\n\r\n            font-size: 24px;\r\n            padding: 0 15px;\r\n            font-weight: 300;\r\n            cursor: pointer;\r\n        }\r\n    }\r\n\r\n    .replicated-image {\r\n        position: absolute;\r\n        top: -47px;\r\n        left: calc(50% - 47px);\r\n        background-color: #fff;\r\n        width: 94px;\r\n        height: 94px;\r\n        border-radius: 50%;\r\n        background-size: cover;\r\n        z-index: 3;\r\n        border: 3px solid #fff;\r\n        background-position: center center;\r\n\r\n        @media(max-height: 500px) {\r\n            top: 15px;\r\n            left: 15px;\r\n            width: 50px;\r\n            height: 50px;\r\n            position: relative;\r\n        }\r\n    }\r\n}\r\n\r\n#replicated-shadow-layer {\r\n    position: fixed;\r\n    z-index: 14;\r\n    height: 100%;\r\n    width: 100%;\r\n    top: 0;\r\n    left: 0;\r\n    cursor: pointer;\r\n    background-color: rgba(0,0,0,.3);\r\n    visibility: hidden;\r\n    opacity: 0;\r\n    -webkit-backface-visibility: hidden;\r\n    backface-visibility: hidden;\r\n    -webkit-transition: opacity .3s 0s,visibility 0s .3s,-webkit-transform .3s 0s;\r\n    -moz-transition: opacity .3s 0s,visibility 0s .3s,-moz-transform .3s 0s;\r\n    transition: opacity .3s 0s,visibility 0s .3s,transform .3s 0s;\r\n}\r\n\r\n#replicated-shadow-layer.is-visible {\r\n    opacity: 1;\r\n    visibility: visible;\r\n    -webkit-transition: opacity .3s 0s,visibility 0s 0s,-webkit-transform .3s 0s;\r\n    -moz-transition: opacity .3s 0s,visibility 0s 0s,-moz-transform .3s 0s;\r\n    transition: opacity .3s 0s,visibility 0s 0s,transform .3s 0s;\r\n}\r\n\r\n.replicated-image-small {\r\n    display: none;\r\n    position: fixed;\r\n    bottom: 16px;\r\n    left: 16px;\r\n    background-color: #fff;\r\n    width: 44px;\r\n    height: 44px;\r\n    border-radius: 50%;\r\n    background-size: cover;\r\n    z-index: 3;\r\n    border: 3px solid #fff;\r\n    -webkit-box-shadow: rgba(0,0,0,.5) 0 2px 4px;\r\n    box-shadow: rgba(0,0,0,.5) 0 2px 4px;\r\n    opacity: 1;\r\n    cursor: pointer;\r\n    transition: transform .2s;\r\n    background-position: center center;\r\n\r\n    &:hover {\r\n        transform: scale(1.25);\r\n    }\r\n}","﻿.logged-in-trigger {\r\n    display: block;\r\n    height: 30px;\r\n    background-color: #ece9f2;\r\n    padding: 0 12px;\r\n    -webkit-transition: background-color .3s 0s,-webkit-transform .3s 0s;\r\n    -moz-transition: background-color .3s 0s,-moz-transform .3s 0s;\r\n    transition: background-color .3s 0s,transform .3s 0s;\r\n    color: #409 !important;\r\n    font-weight: 600;\r\n    position: relative;\r\n    z-index: 15;\r\n    max-width: calc(100vw - 155px);\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n\r\n    .mdi-account-multiple-plus {\r\n        color: #f96ca9;\r\n    }\r\n\r\n    @media(max-width: 767px) {\r\n        background-color: transparent;\r\n        color: #fff !important;\r\n\r\n        .mdi-account-multiple-plus {\r\n            color: #ff78b3;\r\n        }\r\n    }\r\n\r\n    @media(min-width: 768px) {\r\n        &:hover {\r\n            background-color: #fff;\r\n            color: #409 !important;\r\n        }\r\n    }\r\n\r\n    &.logged-in-trigger-active {\r\n        background-color: #fff;\r\n        color: #409 !important;\r\n\r\n        .mdi-account-multiple-plus {\r\n            color: #f96ca9;\r\n        }\r\n    }\r\n\r\n    &.csr-login-info {\r\n        background-color: #ff0000 !important;\r\n        color: #fff !important;\r\n    }\r\n}\r\n\r\n.logged-in-info-wrapper {\r\n    position: relative;\r\n    width: inherit;\r\n    height: 0;\r\n    margin-top: 0;\r\n    color: #494949;\r\n    justify-content: start;\r\n\r\n    @media(min-width: 1170px) {\r\n        display: flex;\r\n        justify-content: end;\r\n    }\r\n}\r\n\r\n#close-logged-in:focus {\r\n    outline: none;\r\n}\r\n\r\n@media(max-width: 767px) {\r\n    .zzPreHeader {\r\n        padding: 0;\r\n    }\r\n    .zzPreHeaderLogin {\r\n        padding-left: 0;\r\n    }\r\n    .sign-in-link{\r\n        padding-left: 15px;\r\n    }\r\n}\r\n\r\n.logged-in-info {\r\n    position: absolute;\r\n    display: none;\r\n    font-size: 14px;\r\n\r\n    a {\r\n        color: #494949;\r\n        display: inline-block;\r\n\r\n        &:hover, &:active, &:focus {\r\n            color: #440099;\r\n        }\r\n\r\n        text-transform: lowercase;\r\n\r\n        &:first-letter {\r\n            text-transform: uppercase !important;\r\n        }\r\n    }\r\n\r\n    @media(max-width: 767px) {\r\n        top: 0;\r\n        left: 0;\r\n        width: 330px;\r\n        max-width: calc(100vw - 48px);\r\n    }\r\n\r\n    @media(max-width: 378px) {\r\n        top: 0;\r\n        left: 0;\r\n        width: 100vw;\r\n        max-width: calc(100vw - 2px);\r\n    }          \r\n\r\n    z-index: 15;\r\n    -webkit-box-shadow: 0 10px 10px 0 rgba(0, 0, 0, .15);\r\n    -moz-box-shadow: 0 10px 10px 0 rgba(0, 0, 0, .15);\r\n    box-shadow: 0 10px 10px 0 rgba(0, 0, 0, .15);\r\n\r\n    .logged-in-info-main {\r\n        padding: 0;\r\n        width: 330px;\r\n        overflow: auto;\r\n        background-color: #fff;\r\n\r\n        @media(max-width: 767px) {\r\n            width: auto;\r\n        }\r\n\r\n        .close {\r\n            position: absolute;\r\n            top: 10px;\r\n            right: 30px;\r\n\r\n            @media(min-width: 768px) and (min-height: 499px) {\r\n                right: 15px;\r\n            }\r\n        }\r\n\r\n        .guest-mode-text {\r\n            padding: 15px 30px;\r\n\r\n            @media(max-width: 378px) {\r\n                padding: 15px 15px;\r\n            }\r\n\r\n            border-top: 1px solid #eee;\r\n            position: relative;\r\n        }\r\n\r\n        .logged-in-link {\r\n            height: 57px;\r\n            padding: 15px 30px;\r\n\r\n            @media(max-width: 378px) {\r\n                padding: 15px 15px;\r\n            }\r\n\r\n            border-top: 1px solid #eee;\r\n            position: relative;\r\n            -webkit-transition: background .3s 0s;\r\n            -moz-transition: background .3s 0s;\r\n            transition: background .3s 0s;\r\n            overflow: hidden;\r\n            text-wrap: nowrap;\r\n\r\n            &:hover {\r\n                background-color: #f7f7f7;\r\n\r\n                .mdi {\r\n                    color: #440099;\r\n                }\r\n            }\r\n        }\r\n    }    \r\n}\r\n\r\n#logged-in-shadow-layer {\r\n    position: fixed;\r\n    z-index: 14;\r\n    height: 100%;\r\n    width: 100%;\r\n    top: 0;\r\n    left: 0;\r\n    cursor: pointer;\r\n    background-color: rgba(0,0,0,.2);\r\n    visibility: hidden;\r\n    opacity: 0;\r\n    -webkit-backface-visibility: hidden;\r\n    backface-visibility: hidden;\r\n    -webkit-transition: opacity .3s 0s,visibility 0s .3s,-webkit-transform .3s 0s;\r\n    -moz-transition: opacity .3s 0s,visibility 0s .3s,-moz-transform .3s 0s;\r\n    transition: opacity .3s 0s,visibility 0s .3s,transform .3s 0s;\r\n\r\n    &.is-visible {\r\n        opacity: 1;\r\n        visibility: visible;\r\n        -webkit-transition: opacity .3s 0s,visibility 0s 0s,-webkit-transform .3s 0s;\r\n        -moz-transition: opacity .3s 0s,visibility 0s 0s,-moz-transform .3s 0s;\r\n        transition: opacity .3s 0s,visibility 0s 0s,transform .3s 0s;\r\n    }\r\n}\r\n","@mixin bootstrap-col-slider {\r\n    &.bootstrap-col-slider {\r\n        position: relative;\r\n        height: auto;\r\n        margin-bottom: 0px;\r\n        -webkit-transition: all .25s ease-in;\r\n        -moz-transition: all .25s ease-in;\r\n        -ms-transition: all .25s ease-in;\r\n        -o-transition: all .25s ease-in;\r\n        transition: all .25s ease-in;\r\n    }\r\n\r\n    .bootstrap-col-slider-content {\r\n        overflow: auto;\r\n        flex-wrap: unset;\r\n        scrollbar-width: none;\r\n        scrollbar-height: none;\r\n        -ms-overflow-style: none;\r\n        justify-content: normal !important;\r\n\r\n        .bootstrap-col-slider-scroll-content {\r\n            touch-action: pan-y;\r\n        }\r\n\r\n        &.scroll-1-items {\r\n            justify-content: center !important;\r\n        }\r\n\r\n        @include media-breakpoint-up(md) {\r\n            &.scroll-2-items {\r\n                justify-content: center !important;\r\n            }\r\n        }\r\n\r\n        @include media-breakpoint-up(lg) {\r\n            &.scroll-3-items {\r\n                justify-content: center !important;\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n    .carousel-indicators {\r\n        li {\r\n            border-radius: 6px;\r\n            width: 12px;\r\n            height: 12px;\r\n            background-color: #404040;\r\n            background-clip: unset;\r\n            border-top: none;\r\n            border-bottom: none;\r\n        }\r\n    }\r\n}\r\n\r\n.bootstrap-col-slider-right, .bootstrap-col-slider-left {\r\n    display: none;\r\n}\r\n\r\n.bootstrap-col-slider-content::-webkit-scrollbar {\r\n    display: none;\r\n}\r\n\r\n.bootstrap-col-slider-right, .bootstrap-col-slider-left {\r\n    position: absolute;\r\n    width: 40px;\r\n    height: 40px;\r\n    border-radius: 50%;\r\n    z-index: 2;\r\n    top: 45%;\r\n    background-color: rgba(255,255,255,.65);\r\n\r\n    span {\r\n        font-size: 30px;\r\n        margin-left: 6px;\r\n        line-height: 42px;\r\n        cursor: pointer;\r\n    }\r\n}\r\n\r\n.bootstrap-col-slider-right:hover, .bootstrap-col-slider-left:hover {\r\n    opacity: 0.85;\r\n\r\n    span {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n.bootstrap-col-slider-right {\r\n    right: 0;\r\n}\r\n\r\n.bootstrap-col-slider-left {\r\n    left: 0;\r\n}\r\n\r\n\r\n\r\n.bootstrap-col-slider-xs {\r\n    @media(min-width: 577px) {\r\n        .bootstrap-col-slider-left, .bootstrap-col-slider-right, .carousel-indicators {\r\n            display: none !important;\r\n        }\r\n    }\r\n\r\n    @media(max-width: 576px) {\r\n        @include bootstrap-col-slider;\r\n    }\r\n}\r\n.bootstrap-col-slider-sm {\r\n    @media(min-width: 769px) {\r\n        .bootstrap-col-slider-left, .bootstrap-col-slider-right, .carousel-indicators {\r\n            display: none !important;\r\n        }\r\n    }\r\n\r\n    @media(max-width: 768px) {\r\n        @include bootstrap-col-slider;\r\n    }\r\n}\r\n.bootstrap-col-slider-md {\r\n    @media(min-width: 993px) {\r\n        .bootstrap-col-slider-left, .bootstrap-col-slider-right, .carousel-indicators {\r\n            display: none !important;\r\n        }\r\n    }\r\n\r\n    @media(max-width: 992px) {\r\n        @include bootstrap-col-slider;\r\n    }\r\n}\r\n.bootstrap-col-slider-lg {\r\n    @media(min-width: 1201px) {\r\n        .bootstrap-col-slider-left, .bootstrap-col-slider-right, .carousel-indicators {\r\n            display: none !important;\r\n        }\r\n    }\r\n\r\n    @media(max-width: 1200px) {\r\n        @include bootstrap-col-slider;\r\n    }\r\n}\r\n.bootstrap-col-slider:not(.bootstrap-col-slider-xs):not(.bootstrap-col-slider-sm):not(.bootstrap-col-slider-md):not(.bootstrap-col-slider-lg) {\r\n    @include bootstrap-col-slider;\r\n}\r\n\r\n","﻿.hero-block {\r\n    position: relative;\r\n    overflow: hidden;\r\n\r\n    &__image {\r\n        position: absolute;\r\n        width: 100%;\r\n        background-size: cover;\r\n        background-repeat: no-repeat;\r\n        height: 100%;\r\n        background-position: center center;\r\n    }\r\n\r\n    &__video {\r\n        position: absolute;\r\n        width: 100%;\r\n        height: 100%;\r\n\r\n        > video {\r\n            width: 100%;\r\n            height: 100%;\r\n            object-fit: cover;\r\n        }\r\n    }\r\n\r\n    &__overlay {\r\n        position: absolute;\r\n        width: 100%;\r\n        height: 100%;\r\n    }\r\n\r\n    &__callout {\r\n        position: absolute;\r\n        width: 100%;\r\n        display: flex;\r\n        flex-direction: column;\r\n        height: 100%;\r\n\r\n        > .hero-block-link {\r\n            position: absolute;\r\n            height: 100%;\r\n            width: 100%;\r\n            cursor: pointer;\r\n        }\r\n\r\n        > .callout {\r\n            position: relative;\r\n\r\n            &:after {\r\n                content: '';\r\n                position: absolute;\r\n                top: 0;\r\n                left: 0;\r\n                width: 100%;\r\n                height: 100%;\r\n            }\r\n        }\r\n    }\r\n\r\n    &__callout-content {\r\n        position: relative;\r\n        z-index: 1;\r\n    }\r\n}\r\n\r\n.heroblock {\r\n    .hero-settings {\r\n        height: 400px;\r\n\r\n        @media(min-width: 576px) {\r\n            height: 400px;\r\n        }\r\n\r\n        @media(min-width: 768px) {\r\n            height: 500px;\r\n        }\r\n\r\n        @media(min-width: 992px) {\r\n            height: 600px;\r\n        }\r\n\r\n        @media(min-width: 1200px) {\r\n            height: 700px;\r\n        }\r\n\r\n        .container, .row {\r\n            height: 100%;\r\n        }\r\n    }\r\n}\r\n","%button-base {\r\n    display: inline-block;\r\n    border-radius: 2px;\r\n    font-size: .875rem;\r\n    line-height: 1em;\r\n    font-weight: 600;\r\n    text-transform: uppercase;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    padding: 12px 20px;\r\n    user-select: none;\r\n    background-color: transparent;\r\n    transition: color 0.15s;\r\n    text-decoration: none;\r\n    min-height: 40px;\r\n    min-width: 100px;\r\n\r\n    &:active {\r\n        border-color: none;\r\n    }\r\n\r\n    &:focus {\r\n        box-shadow: none;\r\n    }\r\n\r\n    &:hover {\r\n        color: #fff;\r\n        background: #61A0A8;\r\n        text-decoration: none;\r\n    }\r\n\r\n    &:disabled {\r\n        color: #fff;\r\n        background-color: #7f7f7f;\r\n        border-color: #7f7f7f;\r\n    }\r\n\r\n    &--icon {\r\n        height: 40px;\r\n        padding-top: 8px;\r\n        text-transform: none;\r\n    }\r\n}\r\n\r\n.button-origin {\r\n    @extend %button-base;\r\n}\r\n\r\n.button-transparent-black {\r\n    @extend %button-base;\r\n    background: transparent;\r\n    color: black;\r\n\r\n    &--icon {\r\n        @extend .button-transparent-black;\r\n        @extend %button-base--icon;\r\n    }\r\n}\r\n\r\n.button-transparent-white {\r\n    @extend %button-base;\r\n    background: transparent;\r\n    color: white;\r\n    border-color: white;\r\n\r\n    &:hover {\r\n        border-color: white !important;\r\n        color: black !important;\r\n        background-color: white !important;\r\n    }\r\n}\r\n\r\n.button-black {\r\n    @extend %button-base;\r\n    background-color: black;\r\n    color: white;\r\n\r\n    &--icon {\r\n        @extend .button-black;\r\n        @extend %button-base--icon;\r\n    }\r\n}\r\n\r\n.button-white {\r\n    @extend %button-base;\r\n    background: white;\r\n    color: black;\r\n\r\n    &:hover {\r\n        border-color: white !important;\r\n    }\r\n}\r\n\r\n.button-yellow-black {\r\n    @extend %button-base;\r\n    background: $color-yellow;\r\n    border: 1px solid $color-yellow;\r\n    color: $color-white;\r\n\r\n    &:hover {\r\n        background: $color-black !important;\r\n        border: 1px solid $color-black !important;\r\n        color: $color-white !important;\r\n    }\r\n}\r\n\r\n.button-yellow-white {\r\n    @extend %button-base;\r\n    background: $color-yellow;\r\n    border: 1px solid $color-yellow;\r\n    color: $color-white;\r\n\r\n    &:hover {\r\n        background: $color-white !important;\r\n        border: 1px solid $color-white !important;\r\n        color: $color-black !important;\r\n    }\r\n}\r\n\r\na[class^=\"button-\"], a[class*=\"button-\"] {\r\n    padding-top: 12px;\r\n}\r\n\r\n.btn-icon {\r\n    background-color: black;\r\n    color: white;\r\n    padding: 8px 10px 8px 10px;\r\n    border-radius: 0;\r\n    display: inline-block;\r\n    font-weight: 400;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n\r\n    &:hover {\r\n        color: white;\r\n        text-decoration: none;\r\n        opacity: 0.8;\r\n    }\r\n}\r\n\r\n.btn-notification {\r\n    border-radius: 10px;\r\n    padding: 2px 10px 2px 10px;\r\n    border: 1px #468847 solid;\r\n    text-decoration: none;\r\n    color: #468847;\r\n    background-color: white;\r\n    font-weight: normal;\r\n\r\n    &:hover {\r\n        text-decoration: none;\r\n        background-color: whitesmoke;\r\n        color: #468847;\r\n    }\r\n}\r\n\r\n.btn {\r\n    font-weight: 600;\r\n    letter-spacing: 0.04em;\r\n}\r\n\r\n.imagetextblock  .image-text-block-button {\r\n    max-width: 800px;\r\n\r\n    .buttonblock {\r\n        padding: 0;\r\n    }\r\n}\r\n",".checkbox {\r\n    user-select: none;\r\n    position: relative;\r\n    cursor: pointer;\r\n    padding-left: 35px;\r\n    text-align: center;\r\n\r\n    & {\r\n        input[type=\"checkbox\"], input[type=\"radio\"] {\r\n            display: none;\r\n        }\r\n    }\r\n}\r\n\r\n/* Create a custom checkbox */\r\n.radio,\r\n.checkmark {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    height: 25px;\r\n    width: 25px;\r\n    border: 1px solid black;\r\n}\r\n\r\n/* When the checkbox is checked, add a black background */\r\n.checkbox input:checked ~ .radio,\r\n.checkbox input:checked ~ .checkmark {\r\n    background-color: black;\r\n}\r\n\r\n.checkbox input[type=\"radio\"] ~ .radio,\r\n.checkbox input[type=\"radio\"] ~ .checkmark {\r\n    border-radius: 50%;\r\n}\r\n\r\n/* Create the checkmark/indicator (hidden when not checked) */\r\n.radio:after,\r\n.checkmark:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    display: none;\r\n}\r\n\r\n/* Show the checkmark when checked */\r\n.checkbox input:checked ~ .radio:after,\r\n.checkbox input:checked ~ .checkmark:after {\r\n    display: block;\r\n}\r\n\r\n/* Style the checkmark/indicator */\r\n.checkbox .radio:after {\r\n    left: 7.35px;\r\n    top: 7.7px;\r\n    width: 8px;\r\n    height: 8px;\r\n    background: white;\r\n    border-radius: 50%;\r\n    /*border: 1px solid black;*/\r\n}\r\n\r\n.checkbox .checkmark:after {\r\n    left: 10px;\r\n    top: 6px;\r\n    width: 5px;\r\n    height: 10px;\r\n    border: solid white;\r\n    border-width: 0 3px 3px 0;\r\n    -webkit-transform: rotate(45deg);\r\n    -ms-transform: rotate(45deg);\r\n    transform: rotate(45deg);\r\n}\r\n","﻿.dropdown {\r\n    outline: 1px solid #eee;\r\n    outline-offset: -1px;\r\n    user-select: none;\r\n\r\n    &__group {\r\n        display: none;\r\n        width: 100%;\r\n        position: absolute;\r\n        border-left: 1px solid #eeeeee;\r\n        border-right: 1px solid #eeeeee;\r\n        border-top: 1px solid #eeeeee;\r\n        background-color: white;\r\n        z-index: 1;\r\n        max-height: 300px;\r\n        overflow-y: auto;\r\n        list-style: none;\r\n        padding: 0;\r\n    }\r\n\r\n    &__item {\r\n        width: 100%;\r\n        padding: 15px;\r\n        border-bottom: 1px solid #eeeeee;\r\n        display: flex;\r\n        align-items: center;\r\n        cursor: pointer;\r\n\r\n        &:hover {\r\n            background-color: #f5f5f5;\r\n        }\r\n\r\n        &--none-padding {\r\n            padding: 0;\r\n        }\r\n\r\n        &-label {\r\n            width: 100%;\r\n            height: 100%;\r\n            text-align: start;\r\n            padding: 15px;\r\n            margin: 0;\r\n            padding-left: 50px;\r\n\r\n            .checkmark {\r\n                top: 15px;\r\n                left: 15px;\r\n            }\r\n        }\r\n    }\r\n\r\n    &__selected {\r\n        width: 100%;\r\n        padding: 8px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n        cursor: pointer;\r\n    }\r\n}\r\n","﻿.icon-button {\r\n    display: inline-block;\r\n    background-color: transparent;\r\n    border: 1px solid transparent;\r\n    border-color: #000;\r\n    padding: 3px;\r\n    color: #555;\r\n    border: 0;\r\n\r\n    &:hover {\r\n        background-color: transparent;\r\n        color: #555;\r\n        opacity: 0.7;\r\n    }\r\n\r\n    &:disabled {\r\n        color: #fff;\r\n        background-color: #7f7f7f;\r\n        border-color: #7f7f7f;\r\n    }\r\n}\r\n","%icon-menu-style {\r\n    position: relative;\r\n    width: 80px;\r\n    height: 80px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    user-select: none;\r\n}\r\n\r\n.icon-menu {\r\n    @extend %icon-menu-style;\r\n\r\n    &:active {\r\n        background-color: #eee;\r\n    }\r\n\r\n    &--has-badge {\r\n        .icon-menu__badge {\r\n            position: absolute;\r\n            top: 20px;\r\n            right: 16px;\r\n            display: block;\r\n        }\r\n    }\r\n\r\n    &-description {\r\n        @extend %icon-menu-style;\r\n        font-size: 14px;\r\n\r\n        &--has-badge {\r\n            .icon-menu__badge {\r\n                position: absolute;\r\n                top: 10px;\r\n                right: 16px;\r\n                display: block;\r\n            }\r\n        }\r\n    }\r\n\r\n    &__badge {\r\n        width: 18px;\r\n        height: 18px;\r\n        border-radius: 50%;\r\n        background-color: black;\r\n        font-size: 10px;\r\n        font-weight: 700;\r\n        color: white;\r\n        box-sizing: border-box;\r\n        text-align: center;\r\n        vertical-align: middle;\r\n        line-height: 18px;\r\n        display: none;\r\n    }\r\n}\r\n",".list-group--header {\r\n    width: 100%;\r\n\r\n    .list-group--header__item {\r\n        margin: 0;\r\n        border-bottom: 1px solid $color-darkgrey;\r\n        padding: 15px;\r\n        display: block;\r\n        color: black;\r\n        text-decoration: none;\r\n\r\n        &:hover {\r\n            background-color: #eee;\r\n            transition: 0.2s;\r\n        }\r\n\r\n        p {\r\n            margin-bottom: 0;\r\n        }\r\n    }\r\n}\r\n\r\n.list-event {\r\n    padding-top: 15px;\r\n}\r\n\r\n.content-search-results {\r\n    .list-group--header__item {\r\n        padding: 15px 0px;\r\n        border: none;\r\n\r\n        &:hover {\r\n            background-color: white;\r\n        }\r\n\r\n        &:hover .title {\r\n            text-decoration: underline;\r\n        }\r\n    }\r\n\r\n    .content__item {\r\n        padding-left: 0px;\r\n        padding-right: 0px;\r\n\r\n        .title {\r\n            font-size: 1.5rem;\r\n            color: #28747E;\r\n        }\r\n\r\n        .sub-title {\r\n            font-size: .875rem;\r\n        }\r\n    }\r\n\r\n    .content__betbest {\r\n        width: 22px;\r\n        height: 22px;\r\n    }\r\n}\r\n\r\nul.pagination {\r\n    margin-bottom: 0;\r\n\r\n    & li {\r\n        display: inline-block;\r\n        background-color: $color-grey;\r\n        color: black;\r\n        margin-left: 5px;\r\n        margin-right: 5px;\r\n        padding: 10px;\r\n        cursor: pointer;\r\n\r\n        a:hover {\r\n            text-decoration: none;\r\n        }\r\n\r\n        &:hover {\r\n            background-color: black;\r\n            color: white;\r\n\r\n            & a {\r\n                color: white;\r\n            }\r\n        }\r\n\r\n        &.active {\r\n            background-color: black;\r\n            color: white;\r\n\r\n            & a {\r\n                color: white;\r\n            }\r\n        }\r\n\r\n        & a {\r\n            color: black;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n.sidebar {\r\n    &--container {\r\n        width: 100%;\r\n    }\r\n\r\n    &--group {\r\n        width: 100%;\r\n        margin: 15px 0 15px 0;\r\n        border-top: 1px solid black;\r\n    }\r\n\r\n    &__item {\r\n        width: 100%;\r\n        padding: 15px;\r\n        color: black;\r\n        border-bottom: 1px solid #eeeeee;\r\n\r\n        & a {\r\n            color: black;\r\n\r\n            &:hover {\r\n                text-decoration: none;\r\n                opacity: 0.7;\r\n            }\r\n        }\r\n\r\n        &:hover {\r\n            background-color: #f5f5f5;\r\n        }\r\n    }\r\n}\r\n\r\nul.list-group--info {\r\n    width: 100%;\r\n    margin-top: 15px;\r\n    list-style: none;\r\n    padding: 0;\r\n\r\n    & li {\r\n        width: 100%;\r\n        padding: 15px;\r\n        border-top: 1px solid #eeeeee;\r\n    }\r\n}\r\n\r\nul.loyalty-statistics li {\r\n    padding: 15px 0px;\r\n}\r\n\r\nul.checkout__status-bar {\r\n    margin-top: 30px;\r\n    margin-bottom: 30px;\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: space-between;\r\n\r\n    & li {\r\n        flex: 1 0 0;\r\n        display: flex;\r\n        border-top: 3px solid #eeeeee;\r\n        padding-top: 15px;\r\n        padding-bottom: 15px;\r\n        align-items: center;\r\n        justify-content: center;\r\n        position: relative;\r\n\r\n        &.active {\r\n            border-color: black;\r\n\r\n            & > .triangle {\r\n                position: absolute;\r\n                top: 0;\r\n                left: calc(50% - 5px);\r\n                width: 0px;\r\n                height: 0px;\r\n                border-left: 10px solid transparent;\r\n                border-right: 10px solid transparent;\r\n                border-top: 10px solid black;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n    ul.checkout__status-bar {\r\n        display: block;\r\n\r\n        & li {\r\n            flex: 0 0 100%;\r\n            /*display: block;*/\r\n            margin: 0 0 auto;\r\n            flex-wrap: wrap;\r\n        }\r\n    }\r\n}\r\n\r\nul.loyal--group {\r\n    width: 100%;\r\n    margin-top: 15px;\r\n    padding-left: 0px;\r\n\r\n    & li {\r\n        width: 100%;\r\n        padding: 8px;\r\n    }\r\n}\r\n\r\n.searchFilter {\r\n    background: #E6F3EF;\r\n    padding: 1em;\r\n    margin-bottom: 30px;\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n    .searchFilter {\r\n        margin-top: 0px;\r\n    }\r\n}\r\n\r\n@media screen and (min-width: 992px) {\r\n    .searchFilter {\r\n        margin-top: 80px;\r\n    }\r\n}","﻿.loading-box {\r\n    background-color: rgba(0,0,0,0.2);\r\n    width: 100%;\r\n    height: 100%;\r\n    position: fixed;\r\n    z-index: 9999;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n    &.loading-in-modal {\r\n        position: absolute;\r\n    }\r\n\r\n    @keyframes spin {\r\n        0% {\r\n            transform: rotate(0deg);\r\n        }\r\n\r\n        100% {\r\n            transform: rotate(360deg);\r\n        }\r\n    }\r\n}\r\n\r\n.loading-cart {\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    z-index: 9999;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.loader {\r\n    width: 80px;\r\n    height: 80px;\r\n    /*margin: -75px 0 0 -75px;*/\r\n    border: 16px solid white;\r\n    border-radius: 50%;\r\n    border-top: 16px solid black;\r\n    animation: spin 2s linear infinite;\r\n}","%select-menu-style {\r\n    width: 100%;\r\n    border: 1px solid $color-darkgrey;\r\n    transition: all 0.5s ease;\r\n    padding-left: 10px;\r\n\r\n    &:focus, :active {\r\n        outline: 0;\r\n    }\r\n}\r\n\r\n.select-menu {\r\n    @extend %select-menu-style;\r\n    height: 40px;\r\n\r\n    & option {\r\n        @extend %select-menu-style;\r\n        height: 40px;\r\n    }\r\n}\r\n\r\n.select-menu-small {\r\n    @extend %select-menu-style;\r\n    height: 30px;\r\n    font-size: 12px;\r\n}\r\n\r\n.selection {\r\n    position: relative;\r\n    background-color: $color-grey;\r\n    color: black;\r\n    cursor: pointer;\r\n    margin-left: 10px;\r\n    margin-right: 10px;\r\n    margin: 0 10px 0 10px;\r\n    list-style: none;\r\n    padding: 0;\r\n\r\n    & li {\r\n        padding: 10px;\r\n        border-bottom: 1px solid $color-grey;\r\n        width: 100%;\r\n\r\n        & a {\r\n            display: flex;\r\n            justify-content: space-between;\r\n\r\n            &:hover {\r\n                text-decoration: none;\r\n            }\r\n\r\n            & svg {\r\n                width: 14px;\r\n            }\r\n        }\r\n\r\n        &:last-child {\r\n            border-bottom: 0;\r\n        }\r\n    }\r\n\r\n    & a {\r\n        color: black;\r\n    }\r\n\r\n    & &__dropdown {\r\n        width: 100%;\r\n        position: absolute;\r\n        top: 40px;\r\n        left: 0;\r\n        z-index: 100;\r\n        visibility: hidden;\r\n        background-color: $color-lightgrey;\r\n        color: black;\r\n        list-style: none;\r\n        padding: 0;\r\n\r\n        & li {\r\n            border-bottom: 1px $color-grey solid;\r\n            border-left: 1px $color-grey solid;\r\n            border-right: 1px $color-grey solid;\r\n\r\n            &:hover {\r\n                background-color: white;\r\n            }\r\n        }\r\n    }\r\n\r\n    &:hover {\r\n        .selection__dropdown {\r\n            visibility: visible;\r\n        }\r\n    }\r\n}\r\n\r\n.selection--cm {\r\n    border-bottom: 1px solid $color-grey;\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 1rem 0 0 0;\r\n\r\n    &__label {\r\n        font-size: 1.2em;\r\n        font-weight: bold;\r\n        padding-bottom: 10px;\r\n        border-bottom: 1px solid black;\r\n    }\r\n\r\n    &__sub-label {\r\n        font-weight: bold;\r\n        padding-bottom: 10px;\r\n    }\r\n\r\n    &__link {\r\n        cursor: pointer;\r\n        display: flex;\r\n        align-items: center;\r\n        line-height: 26px;\r\n    }\r\n\r\n    & .pull-right {\r\n        float: right;\r\n    }\r\n\r\n    &__expand, &__collapse {\r\n        opacity: 0.8;\r\n        cursor: pointer;\r\n\r\n        &:hover {\r\n            opacity: 1;\r\n        }\r\n    }\r\n\r\n    & a {\r\n        color: black;\r\n\r\n        &:hover {\r\n            text-decoration: none;\r\n        }\r\n    }\r\n\r\n    & li {\r\n        padding: 10px;\r\n    }\r\n\r\n    &__inline-item {\r\n        display: inline-block;\r\n    }\r\n\r\n    & .active {\r\n        font-weight: bold;\r\n    }\r\n\r\n    & &__dropdown {\r\n        margin-left: 15px;\r\n        list-style: none;\r\n        padding: 0;\r\n    }\r\n}\r\n","﻿.table {\r\n    .thead-dark {\r\n        th {\r\n            background-color: black;\r\n            border-color: black;\r\n            text-transform: uppercase;\r\n        }\r\n    }\r\n\r\n    td {\r\n        vertical-align: middle;\r\n    }\r\n}\r\n",".textbox {\r\n    padding: 0 10px;\r\n    height: $textbox-height;\r\n    font-size: $text-font-size;\r\n    font-weight: 400;\r\n    border: 1px solid $color-darkgrey;\r\n    width: 100%;\r\n\r\n    &:focus,\r\n    &:active {\r\n        outline: 0;\r\n    }\r\n\r\n    &-big {\r\n        font-size: 16px;\r\n    }\r\n\r\n    &-small {\r\n        padding: 0 10px;\r\n        height: $textbox-height-small;\r\n        font-size: $text-font-size-small;\r\n        font-weight: 400;\r\n        border: 1px solid $color-darkgrey;\r\n        width: 100%;\r\n    }\r\n}\r\n","﻿.formcontainerblock {\r\n    .EPiServerForms {\r\n        max-width: 800px;\r\n        margin: 0 auto;\r\n\r\n        .hide {\r\n            display: none !important;\r\n        }\r\n\r\n        .FormCaptcha__Image {\r\n            margin-top: .5rem;\r\n            width: 100%;\r\n        }\r\n\r\n        .FormCaptcha__Refresh, .FormResetButton {\r\n            display: inline-block;\r\n            border-radius: 0;\r\n            min-width: 100px;\r\n            font-size: $text-font-size;\r\n            line-height: $text-font-size;\r\n            font-weight: 400;\r\n            text-transform: uppercase;\r\n            text-align: center;\r\n            vertical-align: middle;\r\n            padding: 12px 20px;\r\n            border: 1px solid black;\r\n            -webkit-user-select: none;\r\n            -moz-user-select: none;\r\n            -ms-user-select: none;\r\n            user-select: none;\r\n            background-color: transparent;\r\n            -webkit-transition: color 0.15s;\r\n            -o-transition: color 0.15s;\r\n            transition: color 0.15s;\r\n            text-decoration: none;\r\n            min-height: 40px;\r\n            min-width: 100px;\r\n        }\r\n\r\n        .Form__NavigationBar__Action {\r\n            width: auto !important;\r\n            height: auto !important;\r\n            display: inline-block !important;\r\n            border-radius: 0 !important;\r\n            min-width: 100px !important;\r\n            font-size: $text-font-size !important;\r\n            line-height: $text-font-size;\r\n            font-weight: 400;\r\n            text-transform: uppercase;\r\n            text-align: center !important;\r\n            vertical-align: middle !important;\r\n            padding: 12px 20px !important;\r\n            border: 1px solid black !important;\r\n            -webkit-user-select: none !important;\r\n            -moz-user-select: none !important;\r\n            -ms-user-select: none !important;\r\n            user-select: none !important;\r\n            background-color: transparent !important;\r\n            -webkit-transition: color 0.15s !important;\r\n            -o-transition: color 0.15s !important;\r\n            transition: color 0.15s !important;\r\n            text-decoration: none !important;\r\n            min-height: 40px !important;\r\n            min-width: 100px !important;\r\n            background-image: none !important;\r\n        }\r\n\r\n        .form-control-file {\r\n            display: inline-block;\r\n            border-radius: 5px;\r\n            min-width: 100px;\r\n            font-size: $text-font-size;\r\n            line-height: $text-font-size;\r\n            font-weight: 400;\r\n            text-align: center;\r\n            vertical-align: middle;\r\n            padding: 12px 20px;\r\n            border: 1px solid #ddd;\r\n            -webkit-user-select: none;\r\n            -moz-user-select: none;\r\n            -ms-user-select: none;\r\n            user-select: none;\r\n            background-color: transparent;\r\n            -webkit-transition: color 0.15s;\r\n            -o-transition: color 0.15s;\r\n            transition: color 0.15s;\r\n            text-decoration: none;\r\n            min-height: 40px;\r\n            width: 100%;\r\n        }\r\n\r\n        .form-control {\r\n            padding: 0.5rem 1rem;\r\n        }\r\n\r\n        .labeltext {\r\n            font-size: 12px;\r\n            font-weight: 600;\r\n            color: #440099;\r\n            text-transform: uppercase;\r\n            margin-bottom: 0.4rem;\r\n\r\n            &.label-underline {\r\n                border-bottom: 1px solid #440099;\r\n                padding-bottom: 5px;\r\n            }\r\n        }\r\n\r\n        .image-choice {\r\n            display: inline-block;\r\n            text-align: center;\r\n        }\r\n\r\n        .Form__Status {\r\n            position: relative;\r\n\r\n            .Form__Status__Message {\r\n                padding-left: 3.5rem;\r\n                padding-top: 0;\r\n                margin-top: 2rem;\r\n\r\n                &:before {\r\n                    display: inline-block;\r\n                    font-family: \"Material Design Icons\";\r\n                    font-size: 36px;\r\n                    text-rendering: auto;\r\n                    line-height: inherit;\r\n                    -webkit-font-smoothing: antialiased;\r\n                    -moz-osx-font-smoothing: grayscale;\r\n                    position: absolute;\r\n                    top: 10px;\r\n                    left: -3px;\r\n                }\r\n\r\n                &.Form__Success__Message {\r\n                    background-color: transparent;\r\n                    color: unset;\r\n\r\n                    &:before {\r\n                        content: \"\\F0134\";\r\n                        color: #008000;\r\n                    }\r\n                }\r\n\r\n                &.Form__Warning__Message {\r\n                    background-color: transparent;\r\n                    color: unset;\r\n\r\n                    &:before {\r\n                        content: \"\\F05D6\";\r\n                        color: #f71d1d;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n","﻿.brandambassadorblock {\r\n\r\n    .shop-link-wrapper {\r\n        height: 306px;\r\n        border-radius: 10px;\r\n        margin: 0;\r\n\r\n        h4 {\r\n            font-weight: normal;\r\n            font-size: 14px;\r\n            line-height: 22px;\r\n        }\r\n\r\n        img {\r\n            margin-top: 10px;\r\n            max-height: 198px;\r\n            max-width: 100%;\r\n        }\r\n    }\r\n\r\n    h2 {\r\n        font-weight: 600;\r\n        font-size: 24px;\r\n        line-height: 32px;\r\n    }\r\n\r\n    h3 {\r\n        font-weight: 600;\r\n        font-size: 18px;\r\n        line-height: 24px;\r\n    }\r\n\r\n    .brand-ambassador-image img {\r\n        width: 100%;\r\n    }\r\n\r\n    .brand-ambassador-recommended-products {\r\n        padding: 0 60px;\r\n    }\r\n\r\n    @include media-breakpoint-down(sm) {\r\n\r\n        .brand-ambassador-recommended-products {\r\n            padding: 0 15px;\r\n        }\r\n\r\n        h2 {\r\n            font-size: 20px;\r\n            line-height: 28px;\r\n        }\r\n\r\n        h3 {\r\n            font-weight: 600;\r\n            font-size: 16px;\r\n            line-height: 22px;\r\n        }\r\n    }\r\n\r\n    .MultiCarousel {\r\n        float: left;\r\n        overflow: hidden;\r\n        width: 100%;\r\n        position: relative;\r\n        Height: 306px;\r\n    }\r\n\r\n    .MultiCarousel .MultiCarousel-inner {\r\n        transition: 1s ease all;\r\n        float: left;\r\n    }\r\n\r\n    .MultiCarousel .MultiCarousel-inner .item {\r\n        float: left;\r\n    }\r\n\r\n    .carousel-control-prev,\r\n    .carousel-control-next {\r\n        opacity: 1;\r\n        background: rgba(255, 255, 255, 0);\r\n        height: 250px;\r\n    }\r\n\r\n    .carousel-control-prev div.carousel-prev-arrow::before, .carousel-control-next div.carousel-next-arrow::before {\r\n        border-color: $accent-color;\r\n        border-style: solid;\r\n        content: '';\r\n        display: inline-block;\r\n        position: relative;\r\n        vertical-align: top;\r\n        border-width: 2px 2px 0 0;\r\n        height: 10px;\r\n        width: 10px;\r\n        top: 15px;\r\n    }\r\n\r\n    .carousel-control-prev.over,\r\n    .carousel-control-next.over {\r\n        pointer-events: none;\r\n\r\n        div::before {\r\n            border-color: #ddd;\r\n        }\r\n    }\r\n\r\n    .carousel-control-prev {\r\n        left: 0;\r\n\r\n        div.carousel-prev-arrow {\r\n            position: absolute;\r\n            width: 30px;\r\n            height: 30px;\r\n            right: 60px;\r\n\r\n            &:before {\r\n                transform: rotate(-135deg);\r\n                left: 1px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .carousel-control-next {\r\n        right: 0;\r\n\r\n        div.carousel-next-arrow {\r\n            position: absolute;\r\n            width: 30px;\r\n            height: 30px;\r\n            left: 60px;\r\n\r\n            &:before {\r\n                transform: rotate(45deg);\r\n                left: -1px;\r\n            }\r\n        }\r\n    }\r\n\r\n    @include media-breakpoint-up(md) {\r\n        .two-shop-links {\r\n            display: none;\r\n        }\r\n\r\n        .carousel-control-prev div.carousel-prev-arrow::before, .carousel-control-next div.carousel-next-arrow::before {\r\n            border-width: 2px 2px 0 0;\r\n            height: 10px;\r\n            width: 10px;\r\n            top: 15px;\r\n        }\r\n\r\n        .carousel-control-prev {\r\n            left: 0;\r\n\r\n            div.carousel-prev-arrow {\r\n                width: 30px;\r\n                height: 30px;\r\n                right: 60px;\r\n\r\n                &:before {\r\n                    left: 1px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .carousel-control-next {\r\n            right: 0;\r\n\r\n            div.carousel-next-arrow {\r\n                width: 30px;\r\n                height: 30px;\r\n                left: 60px;\r\n\r\n                &:before {\r\n                    left: -1px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n    @include media-breakpoint-up(lg) {\r\n\r\n        .carousel-inner {\r\n            .shop-link-wrapper {\r\n                height: 210px;\r\n                border-radius: 7px;\r\n\r\n                h4 {\r\n                    font-size: 12px;\r\n                    line-height: 18px;\r\n                }\r\n\r\n                img {\r\n                    margin-top: 7px;\r\n                    max-height: 120px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .carousel-control-prev div.carousel-prev-arrow::before, .carousel-control-next div.carousel-next-arrow::before {\r\n            border-width: 2px 2px 0 0;\r\n            height: 10px;\r\n            width: 10px;\r\n            top: 5px;\r\n        }\r\n\r\n        .carousel-control-prev {\r\n            left: 0;\r\n            height: 210px;\r\n\r\n            div.carousel-prev-arrow {\r\n                width: 30px;\r\n                height: 30px;\r\n                right: 25px;\r\n\r\n                &:before {\r\n                    left: 1px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .carousel-control-next {\r\n            right: 0;\r\n            height: 210px;\r\n\r\n            div.carousel-next-arrow {\r\n                width: 30px;\r\n                height: 30px;\r\n                left: 25px;\r\n\r\n                &:before {\r\n                    left: -1px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    @include media-breakpoint-only(lg) {\r\n        .carousel-inner {\r\n            .shop-link-wrapper {\r\n                .btn {\r\n                    font-size: 12px;\r\n                    padding: 0.2rem;\r\n                    width: calc(100% - 16px);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    @include media-breakpoint-down(sm) {\r\n        .carousel-inner {\r\n            max-width: 250px;\r\n            margin: 0 auto;\r\n\r\n            .shop-link-wrapper {\r\n                .btn {\r\n                    font-size: 12px;\r\n                    padding: 0.2rem;\r\n                    width: calc(100% - 16px);\r\n                    max-width: 180px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .carousel-control-prev {\r\n            width: calc((100% - 250px) / 2);\r\n            left: 0;\r\n\r\n            div.carousel-prev-arrow {\r\n                right: 40%\r\n            }\r\n        }\r\n\r\n        .carousel-control-next {\r\n            width: calc((100% - 250px) / 2);\r\n            right: 0;\r\n\r\n            div.carousel-next-arrow {\r\n                left: 40%\r\n            }\r\n        }\r\n    }\r\n\r\n    @include media-breakpoint-up(xl) {\r\n\r\n        .carousel-inner {\r\n            .shop-link-wrapper {\r\n                height: 306px;\r\n                border-radius: 10px;\r\n\r\n                h4 {\r\n                    font-weight: normal;\r\n                    font-size: 14px;\r\n                    line-height: 22px;\r\n                }\r\n\r\n                img {\r\n                    margin-top: 10px;\r\n                    max-height: 198px;\r\n                    max-width: 100%;\r\n                }\r\n            }\r\n        }\r\n\r\n        .carousel-control-prev div.carousel-prev-arrow::before, .carousel-control-next div.carousel-next-arrow::before {\r\n            border-width: 3px 3px 0 0;\r\n            height: 16px;\r\n            width: 16px;\r\n            top: 10px;\r\n        }\r\n\r\n        .carousel-control-prev {\r\n            left: 0px;\r\n            height: 250px;\r\n\r\n            div.carousel-prev-arrow {\r\n                width: 50px;\r\n                height: 50px;\r\n                right: 25px;\r\n\r\n                &:before {\r\n                    left: 3px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .carousel-control-next {\r\n            right: 0;\r\n            height: 250px;\r\n\r\n            div.carousel-next-arrow {\r\n                width: 50px;\r\n                height: 50px;\r\n                left: 25px;\r\n\r\n                &:before {\r\n                    left: -3px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n","﻿.breadcrumb {\r\n    &__group {\r\n        padding: 0;\r\n        list-style-type: none;\r\n\r\n        & li {\r\n            border-bottom: 4px solid transparent;\r\n        }\r\n    }\r\n\r\n    &__item {\r\n        padding: 4px 12px;\r\n        text-transform: uppercase;\r\n        border-bottom: 4px solid transparent;\r\n        line-height: 1.5;\r\n        letter-spacing: 0.1em;\r\n        font-weight: 400;\r\n\r\n        &:first-child {\r\n            padding-left: 0;\r\n        }\r\n\r\n        &:last-child {\r\n            padding-right: 0;\r\n        }\r\n\r\n        &.is-active {\r\n            border-bottom: 4px solid #a7c5c3;\r\n        }\r\n\r\n        & a {\r\n            &:hover {\r\n                text-decoration: none;\r\n                color: #a7c5c3;\r\n            }\r\n        }\r\n\r\n        &:hover {\r\n            color: #a7c5c3;\r\n        }\r\n    }\r\n\r\n    &__slash {\r\n        padding: 4px 8px;\r\n        pointer-events: none;\r\n    }\r\n}\r\n","﻿\r\n.bubble-info-bubble {\r\n    background-color: #fff;\r\n    box-shadow: 0px 16px 24px -10px rgba(0, 0, 0, 0.2);\r\n    border-radius: 40px;\r\n    cursor: pointer;\r\n    font-weight: 400;\r\n    font-size: 24px;\r\n    line-height: 36px;\r\n    display: flex;\r\n    align-items: center;\r\n    text-align: center;\r\n    letter-spacing: 0.02em;\r\n    -webkit-transition: background-color .3s;\r\n    -moz-transition: background-color .3s;\r\n    transition: background-color .3s;\r\n    min-height: 375px;\r\n    overflow: hidden;\r\n\r\n    .bubble-info-bg-image {\r\n        background-size: cover;\r\n        background-position: center center;\r\n        height: 200px;\r\n    }\r\n\r\n    .bubble-info-text {\r\n        color: #000;\r\n        -webkit-transition: color .3s;\r\n        -moz-transition: color .3s;\r\n        transition: color .3s;\r\n        min-height: 175px;\r\n\r\n        .row {\r\n            align-content: space-between;\r\n        }\r\n\r\n        .bubble-open-close {\r\n            transition: transform .2s;\r\n            display: inline-block;\r\n            width: 14px;\r\n            height: 14px;\r\n            line-height: 14px;\r\n            font-size: 30px;\r\n        }\r\n\r\n        p {\r\n            margin: 0;\r\n        }\r\n\r\n        .bubble-text-padding{\r\n            padding-top: 21px;\r\n            padding-right: 36px;\r\n            padding-left: 36px;\r\n        }\r\n    }\r\n\r\n    &:hover, &.chosen-bubble {\r\n        background-color: #8859c5;\r\n\r\n        .bubble-info-text {\r\n            color: #fff;\r\n        }\r\n    }\r\n\r\n\r\n    &.chosen-bubble {\r\n        .bubble-open-close {\r\n            transform: rotate(-45deg);\r\n        }\r\n    }\r\n\r\n    &.chosen-bubble::after {\r\n        content: '';\r\n        clip-path: polygon(0 0, 50% 100%, 100% 0);\r\n        position: absolute;\r\n        width: 30px;\r\n        height: 20px;\r\n        bottom: -18px;\r\n        left: calc(50% - 15px);\r\n        background-color: #8859c5;\r\n    }\r\n}\r\n\r\n.bubble-top-padding {\r\n    padding-top: 30px;\r\n    @media(max-width: 575px){\r\n        padding-right: 30px;\r\n        padding-left: 30px;\r\n    }\r\n}\r\n\r\n.itemRowBreak {\r\n    max-height: 10px;\r\n    clear: both;\r\n    padding: 8px 0;\r\n    -webkit-transition: max-height .75s ease-in;\r\n    -moz-transition: max-height .75s ease-in;\r\n    -ms-transition: max-height .75s ease-in;\r\n    -o-transition: max-height .75s ease-in;\r\n    transition: max-height .75s ease-in;\r\n    width: 100%;\r\n\r\n    .bubbleInfo{\r\n        padding-left: 30px;\r\n        padding-right: 30px;\r\n        text-align: left;\r\n    }\r\n}","﻿.button-block {\r\n    text-decoration: none;\r\n    color: #000;\r\n\r\n    &:hover {\r\n        color: #000;\r\n    }\r\n\r\n    &--blue {\r\n        color: #007BFF;\r\n\r\n        &:hover {\r\n            color: #007BFF;\r\n        }\r\n    }\r\n\r\n    &--orange {\r\n        color: #F7542B;\r\n\r\n        &:hover {\r\n            color: #F7542B;\r\n        }\r\n    }\r\n\r\n    &--italic {\r\n        font-style: italic;\r\n    }\r\n\r\n    &--big {\r\n        font-size: 35px;\r\n    }\r\n\r\n    &--bordered {\r\n        border: 1px solid black;\r\n    }\r\n}\r\n\r\n.buttonblock:is(.displaymode-none) {\r\n    padding-left: 15px;\r\n\r\n    div {\r\n        margin-right: 0 !important;\r\n    }\r\n}\r\n\r\n.arrow-button {\r\n    text-align: left;\r\n    background-color: #fff;\r\n    border-color: #fff;\r\n    color: #000;\r\n    font-size: 18px;\r\n    letter-spacing: 0.02em !important;\r\n\r\n    &:after {\r\n        color: #8859C5;\r\n        display: inline-block;\r\n        font: normal normal normal 24px/1 \"Material Design Icons\";\r\n        content: '\\F0142';\r\n        font-size: 28px;\r\n        top: 14px;\r\n        right: 38px;\r\n        position: absolute;\r\n        text-rendering: auto;\r\n        line-height: inherit;\r\n        -webkit-font-smoothing: antialiased;\r\n    }\r\n\r\n    &:hover {\r\n        background-color: #8859C5;\r\n        border-color: #8859C5;\r\n        color: #fff;\r\n\r\n        &:after {\r\n            color: #fff;\r\n        }\r\n    }\r\n\r\n    &.mdi:before {\r\n        top: 2px !important;\r\n        left: -30px;\r\n        margin-right: -15px;\r\n    }\r\n}","﻿.carousel.slide {\r\n    .carousel-item .item__third:first-child .carousel-item-text-area,\r\n    .carousel-item .item__third:last-child .carousel-item-text-area {\r\n        display: none;\r\n    }\r\n}\r\n\r\n.carousel-item-text-area {\r\n    .carousel-item-button-area {\r\n        max-width: 800px;\r\n        margin-right: auto;\r\n        margin-left: auto;\r\n    }\r\n}\r\n\r\n\r\n$slide-margin-width: 25.1%;\r\n$slide-mobile-margin-width: 10.1%;\r\n\r\n.show-neighbors {\r\n    overflow: hidden;\r\n\r\n    .item__third:first-child,\r\n    .item__third:last-child {\r\n        display: none;\r\n    }\r\n\r\n    .carousel-control-prev:hover, .carousel-control-prev:focus, .carousel-control-next:hover, .carousel-control-next:focus {\r\n        opacity: 1;\r\n        background: rgba(255, 255, 255, 0.2);\r\n    }\r\n\r\n    .carousel-control-prev,\r\n    .carousel-control-next {\r\n        opacity: 1;\r\n        background: rgba(255, 255, 255, 0);\r\n    }\r\n\r\n    .carousel-control-prev div.carousel-prev-arrow::before, .carousel-control-next div.carousel-next-arrow::before {\r\n        border-color: $accent-color;\r\n        border-style: solid;\r\n        content: '';\r\n        display: inline-block;\r\n        position: relative;\r\n        vertical-align: top;\r\n    }\r\n\r\n    .carousel-control-prev {\r\n\r\n        div.carousel-prev-arrow {\r\n            background-color: #fff;\r\n            position: absolute;\r\n\r\n            &:before {\r\n                transform: rotate(-135deg);\r\n            }\r\n        }\r\n    }\r\n\r\n    .carousel-control-next {\r\n\r\n        div.carousel-next-arrow {\r\n            background-color: #fff;\r\n            position: absolute;\r\n\r\n            &:before {\r\n                transform: rotate(45deg);\r\n            }\r\n        }\r\n    }\r\n\r\n    .carousel-item .carousel-item-image-area, .carousel-item .hero-settings {\r\n        .container, .row {\r\n            height: 100%;\r\n        }\r\n    }\r\n\r\n    @include media-breakpoint-down(xl) {\r\n        .carousel-item .carousel-item-image-area, .carousel-item .hero-settings {\r\n            height: 65vw;\r\n            max-height: 450px;\r\n        }\r\n\r\n        .carousel-indicators {\r\n            margin-right: $slide-mobile-margin-width;\r\n            margin-left: $slide-mobile-margin-width;\r\n        }\r\n\r\n        .carousel-control-prev,\r\n        .carousel-control-next {\r\n            height: 65vw;\r\n            max-height: 450px;\r\n            width: $slide-mobile-margin-width;\r\n        }\r\n\r\n        .carousel-control-prev div.carousel-prev-arrow::before, .carousel-control-next div.carousel-next-arrow::before {\r\n            border-width: 2px 2px 0 0;\r\n            height: 10px;\r\n            width: 10px;\r\n            top: 15px;\r\n        }\r\n\r\n        .carousel-control-prev {\r\n            border-right: 8px solid #fff;\r\n\r\n            div.carousel-prev-arrow {\r\n                width: 40px;\r\n                height: 40px;\r\n                border-radius: 20px;\r\n                right: -23px;\r\n\r\n                &:before {\r\n                    left: 1px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .carousel-control-next {\r\n            border-left: 6px solid #fff;\r\n\r\n            div.carousel-next-arrow {\r\n                width: 40px;\r\n                height: 40px;\r\n                border-radius: 20px;\r\n                left: -23px;\r\n\r\n                &:before {\r\n                    left: -1px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .carousel-inner {\r\n            width: (100% - 2 * $slide-mobile-margin-width) * 3;\r\n            left: 3 * $slide-mobile-margin-width - 100%;\r\n        }\r\n    }\r\n\r\n    @include media-breakpoint-up(xl) {\r\n        .carousel-item .carousel-item-image-area, .carousel-item .hero-settings {\r\n            height: 33vw;\r\n            max-height: 620px;\r\n        }\r\n\r\n        .carousel-indicators {\r\n            margin-right: $slide-margin-width;\r\n            margin-left: $slide-margin-width;\r\n        }\r\n\r\n        .carousel-control-prev,\r\n        .carousel-control-next {\r\n            height: 33vw;\r\n            max-height: 620px;\r\n            width: $slide-margin-width;\r\n        }\r\n\r\n        .carousel-control-prev div.carousel-prev-arrow::before, .carousel-control-next div.carousel-next-arrow::before {\r\n            border-width: 3px 3px 0 0;\r\n            height: 16px;\r\n            width: 16px;\r\n            top: 30px;\r\n        }\r\n\r\n        .carousel-control-prev {\r\n            border-right: 8px solid #fff;\r\n\r\n            div.carousel-prev-arrow {\r\n                width: 72px;\r\n                height: 72px;\r\n                border-radius: 36px;\r\n                right: -40px;\r\n\r\n                &:before {\r\n                    left: 3px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .carousel-control-next {\r\n            border-left: 8px solid #fff;\r\n\r\n            div.carousel-next-arrow {\r\n                width: 72px;\r\n                height: 72px;\r\n                border-radius: 36px;\r\n                left: -40px;\r\n\r\n                &:before {\r\n                    left: -3px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .carousel-inner {\r\n            width: (100% - 2 * $slide-margin-width) * 3;\r\n            left: 3 * $slide-margin-width - 100%;\r\n        }\r\n    }\r\n\r\n    .carousel-item-next:not(.carousel-item-left),\r\n    .carousel-item-right.active {\r\n        -webkit-transform: translate3d(33%, 0, 0);\r\n        transform: translate3d(33%, 0, 0);\r\n    }\r\n\r\n    .carousel-item-prev:not(.carousel-item-right),\r\n    .carousel-item-left.active {\r\n        -webkit-transform: translate3d(-33%, 0, 0);\r\n        transform: translate3d(-33%, 0, 0);\r\n    }\r\n\r\n    .item__third {\r\n        display: block !important;\r\n        float: left;\r\n        position: relative; /* captions can now be added */\r\n        width: 33.33333333%;\r\n    }\r\n}","﻿.block.eventblock {\r\n\r\n    .tab-content {\r\n        background-color: #fff;\r\n        margin-top: 54px;\r\n\r\n        @include media-breakpoint-down(sm) {\r\n            margin-top: 33px;\r\n        }\r\n\r\n        .round-border {\r\n            border-radius: 10px;\r\n            border: 1px solid #dee2e6;\r\n            margin-top: 22px;\r\n            min-height: 235px;\r\n\r\n            @include media-breakpoint-up(lg) {\r\n                min-height: 260px;\r\n            }\r\n\r\n            @include media-breakpoint-up(xl) {\r\n                min-height: 325px;\r\n            }\r\n\r\n            @include media-breakpoint-down(xs) {\r\n                margin-right: 0;\r\n                margin-left: 0;\r\n            }\r\n\r\n            .round-border-image {\r\n                border-top-left-radius: 10px;\r\n                border-bottom-left-radius: 10px;\r\n                background-position: center center;\r\n                background-size: cover;\r\n\r\n                @include media-breakpoint-down(md) {\r\n                    height: 50vw;\r\n                    border-bottom-left-radius: 0;\r\n                    border-top-right-radius: 10px;\r\n                }\r\n            }\r\n\r\n            @include media-breakpoint-down(md) {\r\n                border: none;\r\n\r\n                .event-time:before {\r\n                    color: #8859c5;\r\n                }\r\n\r\n                .mobile-zero-padding {\r\n                    padding: 0 !important;\r\n\r\n                    p {\r\n                        margin-bottom: 0.6rem;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        .session-description {\r\n            max-width: 800px;\r\n            margin: 0 auto;\r\n\r\n            .event-time {\r\n                font-weight: 600;\r\n                font-size: 18px;\r\n                margin-bottom: 0.5rem;\r\n                margin-top: 0;\r\n                line-height: 2rem;\r\n                letter-spacing: .02em;\r\n\r\n                @include media-breakpoint-down(sm) {\r\n                    font-size: 16px;\r\n                    margin-bottom: 0.27rem;\r\n                }\r\n\r\n                &:before {\r\n                    margin-right: 7px;\r\n                }\r\n            }\r\n\r\n            h4 {\r\n                font-weight: 400;\r\n                font-size: 24px;\r\n\r\n                @include media-breakpoint-down(sm) {\r\n                    font-size: 20px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .event-header {\r\n        padding: 50px 0;\r\n\r\n        p, h1, h2, h3, h4, h5, h6, ol, ul {\r\n            max-width: unset;\r\n        }\r\n    }\r\n\r\n    .event-nav-tabs {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        position: relative;\r\n        padding: 0 2em;\r\n\r\n        .screen-width-block {\r\n            width: 100vw;\r\n            position: relative;\r\n            left: 50%;\r\n            right: 50%;\r\n            margin-left: -50vw;\r\n            margin-right: -50vw;\r\n        }\r\n\r\n        @include media-breakpoint-down(sm) {\r\n            .screen-width-block {\r\n                width: 100vw;\r\n                position: relative;\r\n                left: 50%;\r\n                right: 50%;\r\n                margin-left: -50vw;\r\n                margin-right: -50vw;\r\n            }\r\n        }\r\n    }\r\n\r\n    .event-nav-mobile-header {\r\n        height: 54px;\r\n        background-color: $light-purple;\r\n        color: #fff;\r\n        font-size: 20px;\r\n        line-height: 32px;\r\n        display: block;\r\n        padding: 11px 0;\r\n        cursor: pointer;\r\n    }\r\n\r\n    .event-nav-mobile-header:hover {\r\n        color: #fff;\r\n    }\r\n\r\n    .event-arrowLinkWrapper {\r\n        width: 28px;\r\n        height: 28px;\r\n        position: absolute;\r\n        right: 12px;\r\n        top: 20px;\r\n        background-color: rgba(136,89,197,.5);\r\n        border-radius: 50%;\r\n    }\r\n\r\n    .event-link-showHide {\r\n        border: solid #fff;\r\n        border-width: 0 2px 2px 0;\r\n        display: inline-block;\r\n        position: absolute;\r\n        padding: 4px;\r\n        top: 11px !important;\r\n        left: 9px;\r\n        line-height: 17px;\r\n        -webkit-transition: -webkit-transform linear 0.7s;\r\n        -moz-transition: -moz-transform 0.7s;\r\n        transition: transform 0.7s;\r\n        transform: rotate(-135deg);\r\n        -moz-transform: rotate(-135deg);\r\n        -webkit-transform: rotate(-135deg);\r\n        top: 14px;\r\n    }\r\n\r\n    .event-link-down {\r\n        transform: rotate(45deg);\r\n        -moz-transform: rotate(45deg);\r\n        -webkit-transform: rotate(45deg);\r\n    }\r\n\r\n    .event-nav-tabs h1, .event-slide h1 {\r\n        font-size: 48px;\r\n        margin: 0;\r\n        letter-spacing: 0.02em;\r\n    }\r\n\r\n    .event-nav-tabs h3, .event-slide h3 {\r\n        font-weight: 600;\r\n        font-size: 32px;\r\n        line-height: 48px;\r\n        letter-spacing: 0.02em;\r\n        color: $color-black;\r\n\r\n        &.color-light {\r\n            color: #fff;\r\n        }\r\n    }\r\n\r\n    .event-nav-tabs-container {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        -webkit-box-orient: horizontal;\r\n        -webkit-box-direction: normal;\r\n        -ms-flex-direction: row;\r\n        flex-direction: row;\r\n        position: absolute;\r\n        bottom: 0;\r\n        left: 0;\r\n        width: 100%;\r\n        height: 54px;\r\n        background: $color-lighter-purple;\r\n        z-index: 2;\r\n        -webkit-transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);\r\n        transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);\r\n        padding: 0;\r\n    }\r\n\r\n    .inside-event {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        -webkit-box-orient: horizontal;\r\n        -webkit-box-direction: normal;\r\n        -ms-flex-direction: row;\r\n        flex-direction: row;\r\n        height: 84px;\r\n        padding: 0;\r\n    }\r\n\r\n    .event-nav-tabs-container--top-first {\r\n        position: fixed;\r\n        top: 100px;\r\n        left: 0;\r\n        -webkit-transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);\r\n        transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);\r\n    }\r\n\r\n    .event-nav-tabs-container--top-second {\r\n        position: fixed;\r\n        top: 100px;\r\n        left: 0;\r\n    }\r\n\r\n    .event-nav-tabs-container-wrap {\r\n        height: 84px;\r\n\r\n        @include media-breakpoint-up(lg) {\r\n            background-color: #ECE9F2;\r\n        }\r\n    }\r\n\r\n    @include media-breakpoint-down(xs) {\r\n        .event-nav-tabs-container-wrap {\r\n            padding: 0;\r\n        }\r\n    }\r\n\r\n    @include media-breakpoint-down(md) {\r\n\r\n        .event-nav-tabs-container-wrap {\r\n            height: auto;\r\n        }\r\n\r\n        .event-nav-tabs-container {\r\n            background-color: $light-purple;\r\n        }\r\n\r\n        .inside-event {\r\n            display: block;\r\n            height: auto;\r\n            background-color: $color-lighter-purple;\r\n            padding: 0;\r\n\r\n            .event-nav-tab, .event-nav-link, .event-nav-external-quick-link {\r\n                height: 79px;\r\n                justify-content: left;\r\n                padding: 0 15px;\r\n\r\n                @include media-breakpoint-down(lg) {\r\n                    padding: 0 30px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    @media(max-width: 1169px) {\r\n\r\n        .event-nav-tabs-container--top-first {\r\n            top: 90px;\r\n        }\r\n\r\n        .event-nav-tabs-container--top-second {\r\n            top: 90px;\r\n        }\r\n    }\r\n\r\n    .event-nav-tab, .event-nav-link, .event-nav-external-quick-link {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n\r\n        @include media-breakpoint-up(lg) {\r\n            display: -webkit-box !important;\r\n            display: -ms-flexbox !important;\r\n            -webkit-transition: all 0.5s ease;\r\n            transition: all 0.5s ease;\r\n            -webkit-box-pack: center;\r\n            -ms-flex-pack: center;\r\n        }\r\n\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        justify-content: center;\r\n        align-items: center;\r\n        -webkit-box-flex: 1;\r\n        -ms-flex: auto;\r\n        flex: auto;\r\n        color: $color-black;\r\n        font-size: 24px;\r\n        font-weight: 300;\r\n\r\n        @include media-breakpoint-down(lg) {\r\n            font-size: 20px;\r\n            line-height: 22px;\r\n        }\r\n\r\n        span.event-day {\r\n            font-size: 16px;\r\n            font-weight: 400;\r\n            width: 100%;\r\n\r\n            @media (max-width: 1200px) {\r\n                font-size: 14px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .event-nav-tab:hover, .event-nav-tab.active, .event-nav-external-quick-link:hover, .event-nav-external-quick-link.active, .event-nav-link.active, .event-nav-link:hover {\r\n        color: white;\r\n        background-color: $light-purple;\r\n        text-decoration: none;\r\n    }\r\n\r\n    .event-nav-tab.chosen-day {\r\n        display: -webkit-box !important;\r\n        display: -ms-flexbox !important;\r\n    }\r\n\r\n    .event-nav-link {\r\n        background-color: #C4B1CF;\r\n\r\n        &:after {\r\n            content: \"\\F0142\";\r\n            font-family: 'Material Design Icons';\r\n            margin-left: 0.5rem;\r\n            font-size: 20px;\r\n            margin-top: 3px;\r\n        }\r\n    }\r\n}\r\n","﻿.faqcontainerblock {\r\n    font-size: 18px;\r\n    line-height: 32px;\r\n    letter-spacing: 0.02em;\r\n    color: #000;\r\n\r\n    @include media-breakpoint-down(md) {\r\n        font-size: 16px;\r\n        line-height: 28px;\r\n    }\r\n\r\n    h2 {\r\n        font-weight: 600;\r\n        font-size: 32px;\r\n        line-height: 48px;\r\n        letter-spacing: 0.02em;\r\n\r\n        @include media-breakpoint-down(md) {\r\n            font-size: 24px;\r\n            line-height: 36px;\r\n        }\r\n    }\r\n\r\n    p, h1, h2, h3, h4, h5, h6 {\r\n        max-width: 1000px;\r\n        margin-right: 0;\r\n        margin-left: 0;\r\n    }\r\n}\r\n\r\n.faqitemblock {\r\n\r\n    .col-12 {\r\n        max-width: 1000px;\r\n    }\r\n\r\n    h5 {\r\n        font-weight: 600;\r\n        font-size: 18px;\r\n        line-height: 32px;\r\n        letter-spacing: 0.02em;\r\n        cursor: pointer;\r\n\r\n        @include media-breakpoint-down(md) {\r\n            font-size: 16px;\r\n            line-height: 28px;\r\n        }\r\n\r\n        @include media-breakpoint-up(lg) {\r\n            padding-right: 120px !important;\r\n        }\r\n    }\r\n\r\n    .faq-item-content {\r\n        line-height: 1.6rem;\r\n        font-size: 1rem;\r\n\r\n        @include media-breakpoint-up(lg) {\r\n            padding-right: 120px !important;\r\n        }\r\n    }\r\n\r\n    a {\r\n        font-weight: 600;\r\n        text-decoration: underline;\r\n        color: #000;\r\n    }\r\n\r\n    .faq-arrowLinkWrapper {\r\n        width: 22px;\r\n        height: 22px;\r\n        position: absolute;\r\n        right: 12px;\r\n        top: -5px;\r\n    }\r\n\r\n    .faq-link-showHide {\r\n        border: solid $accent-color;\r\n        border-width: 0 2px 2px 0;\r\n        display: inline-block;\r\n        position: absolute;\r\n        padding: 4px;\r\n        top: 10px;\r\n        left: 5px;\r\n        line-height: 17px;\r\n        -webkit-transition: -webkit-transform linear 0.7s;\r\n        -moz-transition: -moz-transform 0.7s;\r\n        transition: transform 0.7s;\r\n    }\r\n\r\n    .faq-link-showHide {\r\n        transform: rotate(-135deg);\r\n        -moz-transform: rotate(-135deg);\r\n        -webkit-transform: rotate(-135deg);\r\n    }\r\n\r\n    .collapsed .faq-link-showHide {\r\n        transform: rotate(45deg);\r\n        -moz-transform: rotate(45deg);\r\n        -webkit-transform: rotate(45deg);\r\n    }\r\n}\r\n","﻿.grid-special {\r\n    height: 615px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex-wrap: wrap;\r\n    gap: 32px;\r\n    width: calc(100% - 32px);\r\n}\r\n\r\n.grid-special-wrapper {\r\n    overflow: hidden;\r\n    border-radius: 10px;\r\n}\r\n\r\n.grid-special-wrapper {\r\n    font-size: 20px;\r\n\r\n    h3 {\r\n        font-size: 48px;\r\n        font-weight: 600;\r\n        margin-bottom: 30px;\r\n    }\r\n\r\n    p {\r\n        margin-bottom: 0;\r\n        letter-spacing: 0.4px;\r\n    }\r\n}\r\n\r\n.normal-font-size {\r\n    .grid-special-wrapper {\r\n        font-size: 16px;\r\n\r\n        h3 {\r\n            font-size: 24px;\r\n            font-weight: 400;\r\n            margin-bottom: 15px;\r\n        }\r\n    }\r\n}\r\n\r\n.grid-special-bg-image {\r\n    background-size: cover;\r\n    background-position: center center;\r\n}\r\n\r\n.grid-special-50 {\r\n    flex-grow: 1;\r\n    width: 58%;\r\n    height: calc(50% - 16px);\r\n\r\n    &.grid-special-even-numbers {\r\n        width: 50%;\r\n    }\r\n\r\n    .grid-special-50-text {\r\n        padding-top: 45px !important;\r\n        padding-bottom: 45px !important;\r\n        flex-direction: column;\r\n    }\r\n\r\n    .grid-special-text {\r\n        height: 100%;\r\n        padding-left: 36px !important;\r\n        padding-right: 36px !important;\r\n    }\r\n}\r\n\r\n.grid-special-100 {\r\n    flex-grow: 1;\r\n    width: 42%;\r\n    flex-basis: 100%;\r\n\r\n    &.grid-special-even-numbers {\r\n        width: 50%;\r\n    }\r\n\r\n    .grid-special-100-text {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .grid-special-bg-image {\r\n        height: 62%;\r\n    }\r\n\r\n    .grid-special-text {\r\n        height: 38%;\r\n        padding-left: 36px !important;\r\n        padding-right: 36px !important;\r\n    }\r\n}\r\n\r\n@media(min-width: 1200px){\r\n    .normal-font-size {\r\n        .grid-special-wrapper {\r\n\r\n            &.grid-special-50 {\r\n                .grid-special-text {\r\n                    padding-left: 60px !important;\r\n                    padding-right: 60px !important;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n}\r\n\r\n@media(min-width: 992px) {\r\n    .normal-font-size {\r\n        .grid-special-wrapper {\r\n\r\n            &.grid-special-100 {\r\n                .grid-special-text {\r\n                    padding-left: 75px !important;\r\n                    padding-right: 75px !important;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media(max-width: 1199px) {\r\n    .normal-font-size {\r\n        height: auto !important;\r\n        gap: 20px;\r\n        width: 100%;\r\n\r\n        .grid-special-50 {\r\n            flex-grow: 1;\r\n            width: 100%;\r\n            min-height: 245px;\r\n\r\n            &.grid-special-even-numbers {\r\n                width: 100%;\r\n            }\r\n\r\n            .grid-special-bg-image {\r\n                min-height: 245px;\r\n            }\r\n        }\r\n\r\n        .grid-special-100 {\r\n            flex-grow: 1;\r\n            width: 100%;\r\n            flex-basis: unset;\r\n            min-height: 430px;\r\n\r\n            &.grid-special-even-numbers {\r\n                width: 100%;\r\n            }\r\n\r\n            .grid-special-bg-image {\r\n                min-height: 340px;\r\n            }\r\n        }\r\n    }\r\n\r\n    \r\n}\r\n@media(max-width: 991px) {\r\n    .grid-special {\r\n        height: 400px !important;\r\n\r\n        &.normal-font-size {\r\n            height: auto !important;\r\n            gap: 20px;\r\n            width: 100%;\r\n\r\n            .grid-special-50 {\r\n                flex-grow: 1;\r\n                width: 100%;\r\n                min-height: 245px;\r\n\r\n                &.grid-special-even-numbers {\r\n                    width: 100%;\r\n                }\r\n            }\r\n\r\n            .grid-special-100 {\r\n                flex-grow: 1;\r\n                width: 100%;\r\n                flex-basis: unset;\r\n                min-height: 430px;\r\n\r\n                &.grid-special-even-numbers {\r\n                    width: 100%;\r\n                }\r\n            }\r\n        }\r\n    }    \r\n\r\n    .grid-special-wrapper {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .grid-special-wrapper h3 {\r\n        font-size: 36px;\r\n        font-weight: 600;\r\n        margin-bottom: 14px;\r\n    }\r\n    .normal-font-size {\r\n        .grid-special-wrapper {\r\n\r\n            h3 {\r\n                font-size: 20px;\r\n                font-weight: 400;\r\n                margin-bottom: 10px;\r\n            }\r\n        }\r\n    }\r\n    .grid-special-100 {\r\n        .grid-special-100-text {\r\n            padding-top: 23px !important;\r\n        }\r\n    }\r\n    .grid-special-50 {\r\n        .grid-special-50-text {\r\n            padding-top: 23px !important;\r\n            padding-bottom: 23px !important;\r\n        }\r\n    }\r\n}\r\n\r\n@media(max-width: 767px){\r\n    .grid-special {\r\n        height: auto !important;\r\n        gap: 20px;\r\n        width: 100%;\r\n    }\r\n    .grid-special-wrapper {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .grid-special-wrapper h3 {\r\n        font-size: 32px;\r\n        font-weight: 600;\r\n        margin-bottom: 12px;\r\n    }\r\n\r\n    .normal-font-size {\r\n        .grid-special-wrapper {\r\n\r\n            h3 {\r\n                font-size: 20px;\r\n                font-weight: 400;\r\n                margin-bottom: 8px;\r\n            }\r\n        }\r\n\r\n        .grid-special-50 {\r\n            .grid-special-bg-image {\r\n                min-height: 340px;\r\n            }\r\n        }\r\n    }\r\n    .grid-special-50 {\r\n        flex-grow: 1;\r\n        width: 100%;\r\n        height: 245px;\r\n\r\n        &.grid-special-even-numbers {\r\n            width: 100%;\r\n        }\r\n\r\n        .grid-special-50-text {\r\n            padding-top: 16px !important;\r\n            padding-bottom: 16px !important;\r\n        }\r\n    }\r\n\r\n    .grid-special-100 {\r\n        flex-grow: 1;\r\n        width: 100%;\r\n        flex-basis: unset;\r\n        height: 430px;\r\n\r\n        &.grid-special-even-numbers {\r\n            width: 100%;\r\n        }\r\n\r\n        .grid-special-100-text {\r\n            padding-top: 16px !important;\r\n            padding-bottom: 16px !important;\r\n        }\r\n    }\r\n\r\n\r\n    .no-mobile-padding {\r\n        padding: 0;\r\n    }\r\n}\r\n\r\n@media(max-width: 615px) {\r\n    .grid-special-50 {\r\n        height: 40vw;\r\n    }\r\n\r\n    .grid-special-100 {\r\n        height: 70vw;\r\n    }\r\n}\r\n\r\n@media(max-width: 350px) {\r\n    .griduspblock .container{\r\n        padding: 0;\r\n    }\r\n\r\n    .grid-special-wrapper {\r\n        font-size: 14px;\r\n        line-height: 20px;\r\n    }\r\n\r\n    .grid-special-wrapper h3 {\r\n        font-size: 26px;\r\n        line-height: 1.6rem;\r\n        font-weight: 600;\r\n        margin-bottom: 4px;\r\n    }\r\n\r\n\r\n    .normal-font-size {\r\n        .grid-special-wrapper {\r\n\r\n            h3 {\r\n                font-size: 20px;\r\n                font-weight: 400;\r\n                margin-bottom: 1.4rem;\r\n                margin-bottom: 3px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media(max-width: 1199px){\r\n    .normal-font-size {\r\n        .grid-special-50 {\r\n            height: auto;\r\n        }\r\n\r\n        .grid-special-100 {\r\n            height: auto;\r\n        }\r\n    }\r\n}","﻿$instagram-modal-height: 820px;\r\n$instagram-modal-width: 1240px;\r\n\r\n.instagramblock {\r\n    .instagram-col {\r\n        margin-bottom: 30px;\r\n        cursor: pointer;\r\n\r\n        .responsive-instagram-object {\r\n            -webkit-transition: all .4s ease;\r\n        }\r\n\r\n        &:hover {\r\n            .responsive-instagram-object {\r\n                -webkit-filter: contrast(125%) brightness(105%);\r\n                filter: contrast(125%) brightness(105%);\r\n                -webkit-box-shadow: 0px 24px 20px -16px rgba(29, 35, 26, 0.24);\r\n                box-shadow: 0px 24px 20px -16px rgba(29, 35, 26, 0.24);\r\n            }\r\n        }\r\n\r\n        .responsive-instagram-object {\r\n            background-color: #000;\r\n            position: relative;\r\n            overflow: hidden;\r\n            width: 100%;\r\n            padding-top: 100%;\r\n        }\r\n\r\n        .responsive-instagram-object {\r\n            video, img {\r\n                position: absolute;\r\n                top: 0;\r\n                left: 0;\r\n                bottom: 0;\r\n                right: 0;\r\n                width: 100%;\r\n                height: 100%;\r\n            }\r\n\r\n            img {\r\n                object-fit: cover;\r\n            }\r\n        }\r\n\r\n        .instagram-carousel-album-icon, .instagram-video-icon {\r\n            width: 47px;\r\n            height: 45px;\r\n            position: absolute;\r\n            top: 5px;\r\n            right: 0;\r\n            z-index: 2;\r\n\r\n            .mdi {\r\n                font-size: 25px;\r\n                color: #aaa;\r\n            }\r\n        }\r\n    }\r\n\r\n    .modal {\r\n        opacity: 0.95;\r\n        position: fixed;\r\n        padding-right: 0 !important;\r\n        text-align: left;\r\n        -ms-overflow-style: none; /* Internet Explorer 10+ */\r\n        scrollbar-width: none; /* Firefox */\r\n        overflow: -moz-scrollbars-none;\r\n\r\n        &::-webkit-scrollbar {\r\n            display: none; /* Safari and Chrome */\r\n        }\r\n\r\n        .modal-dialog {\r\n            max-width: 100vw;\r\n            margin: 0;\r\n\r\n            .modal-content {\r\n                min-height: 100vh;\r\n                border-radius: 0;\r\n\r\n                @media (max-width: 575px) {\r\n                    .modal-header {\r\n                        position: fixed;\r\n                        top: 0;\r\n                        left: 0;\r\n                        padding: 7px;\r\n                        z-index: 1025;\r\n                    }\r\n                }\r\n\r\n                .btn-close::after {\r\n                    content: \"\\F0156\";\r\n                    font-family: 'Material Design Icons';\r\n                    font-size: 35px;\r\n                    color: $primary;\r\n                    cursor: pointer;\r\n                    line-height: 1;\r\n                }\r\n            }\r\n        }\r\n\r\n        .modal-header {\r\n            border-bottom: none;\r\n            justify-content: end;\r\n        }\r\n\r\n        .modal-body {\r\n            padding: 45px;\r\n            height: calc(100% - 69px);\r\n\r\n            .scrollable-content {\r\n                overflow-y: auto;\r\n                height: 100%;\r\n            }\r\n\r\n            .responsive-instagram-object video {\r\n                max-height: 100%;\r\n                background-color: #000;\r\n            }\r\n        }\r\n\r\n        @media (min-width: 992px) {\r\n\r\n            .modal-dialog {\r\n                width: $instagram-modal-width;\r\n                max-width: 100%;\r\n                margin: calc(50vh - #{$instagram-modal-height} / 2) auto;\r\n\r\n                .modal-content {\r\n                    height: $instagram-modal-height;\r\n                    min-height: $instagram-modal-height;\r\n                    max-height: 100vh;\r\n                    border-radius: 10px;\r\n                }\r\n            }\r\n\r\n            .modal-body {\r\n                padding: 0px 60px 60px;\r\n            }\r\n        }\r\n    }\r\n}\r\n","﻿.investors-hero-block {\r\n    position: relative;\r\n    overflow: hidden;\r\n\r\n    &__image {\r\n        position: absolute;\r\n        width: 100%;\r\n        background-size: cover;\r\n        background-repeat: no-repeat;\r\n        height: 100%;\r\n        background-position: top center;\r\n    }\r\n\r\n    &__overlay {\r\n        position: absolute;\r\n        width: 100%;\r\n        height: 100%;\r\n    }\r\n}\r\n\r\n.investorsheroblock {\r\n    height: 500px;\r\n\r\n    .investors-hero-iframe {\r\n        width: 100%;\r\n        max-width: 220px;\r\n        height: 140px;\r\n        border: 0;\r\n        float: left;\r\n    }\r\n\r\n    @include media-breakpoint-up(lg) {\r\n        height: 546px;\r\n\r\n        .investors-hero-iframe {\r\n            width: 248px;\r\n            max-width: 248px;\r\n            height: 190px;\r\n        }\r\n    }\r\n\r\n    .investors-hero-block-content {\r\n        position: relative;\r\n        margin: 0 auto;\r\n        width: 1004px;\r\n        max-width: 100%;\r\n        padding-top: 160px;\r\n\r\n\r\n\r\n        h1 {\r\n            color: #fff;\r\n            margin-bottom: 29px;\r\n            line-height: 58px;\r\n            max-width: unset;\r\n\r\n            @include media-breakpoint-up(lg) {\r\n                text-align: center;\r\n            }\r\n        }\r\n\r\n        .investors-hero-block-info {\r\n            background-color: #fff;\r\n            border-top-left-radius: 10px;\r\n            border-top-right-radius: 10px;\r\n            height: 300px;\r\n            width: 1004px;\r\n            max-width: 90%;\r\n            margin: 0 auto;\r\n            font-size: 16px;\r\n\r\n            h3 {\r\n                font-weight: normal;\r\n                font-size: 26px;\r\n                line-height: 26px;\r\n                text-transform: uppercase;\r\n                padding-top: 35px;\r\n                margin-bottom: 20px;\r\n            }\r\n\r\n            h4.display-4 {\r\n                margin-top: 20px;\r\n                font-size: 38px;\r\n                font-weight: normal;\r\n            }\r\n\r\n            .investors-hero-report-link {\r\n                display: flex;\r\n                align-items: center;\r\n\r\n                ul {\r\n                    list-style: none;\r\n                    position: relative;\r\n                    margin: 0 auto;\r\n                    top: -15px;\r\n                    padding-inline-start: 0;\r\n\r\n                    @include media-breakpoint-down(md) {\r\n                        top: 0;\r\n\r\n                        li {\r\n                            margin-left: 0;\r\n                        }\r\n                    }\r\n\r\n                    li {\r\n                        float: left;\r\n\r\n                        a {\r\n                            font-weight: 600;\r\n                            font-size: 16px;\r\n\r\n                            &::before {\r\n                                color: $color-black;\r\n                                content: \"\\F01DA\";\r\n                                font-family: 'Material Design Icons';\r\n                                margin-right: 0.5rem;\r\n                            }\r\n\r\n                            &:hover {\r\n                                &::after, &::before {\r\n                                    color: $light-purple;\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        @include media-breakpoint-down(md) {\r\n            position: absolute;\r\n            width: 1004px;\r\n            padding-top: 0;\r\n            bottom: 54px;\r\n\r\n            h1 {\r\n                font-size: 32px;\r\n                line-height: 40px;\r\n                font-weight: 400;\r\n                text-align: left;\r\n                padding: 0 3rem;\r\n            }\r\n\r\n            .investors-hero-block-info {\r\n                background-color: #fff;\r\n                border-top-left-radius: 10px;\r\n                border-top-right-radius: 10px;\r\n                height: 330px;\r\n                width: 1004px;\r\n                max-width: 90%;\r\n                margin: 0 auto;\r\n                font-size: 16px;\r\n\r\n                h3 {\r\n                    font-size: 14px;\r\n                    line-height: 22px;\r\n                    padding-top: 16px;\r\n                    margin-bottom: 5px;\r\n                }\r\n\r\n                h4.display-4 {\r\n                    margin-top: 20px;\r\n                    font-size: 24px;\r\n                }\r\n\r\n                .investors-hero-stats-header {\r\n                    font-size: 12px;\r\n                    line-height: 18px;\r\n                }\r\n            }\r\n        }\r\n\r\n        @include media-breakpoint-down(sm) {\r\n            \r\n            .investors-hero-block-info {\r\n                \r\n                h4.display-4 {\r\n                    margin-top: 20px;\r\n                    font-size: 20px;\r\n                    font-weight: 600;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n","﻿#sib_embed_signup {\r\n    #sib-container {\r\n        padding: 0;\r\n        background: none;\r\n\r\n        .row.mandatory-email {\r\n            max-width: 1000px;\r\n            margin: 0 auto;\r\n\r\n            @media(max-width: 991px) {\r\n                margin-right: -15px;\r\n                margin-left: -15px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .sib-form-message-panel {\r\n        border-radius: 3px;\r\n\r\n        &#error-message {\r\n            color: #661d1d;\r\n            background-color: #ffeded;\r\n            border-color: #ff4949;\r\n        }\r\n\r\n        &#success-message {\r\n            color: #085229;\r\n            background-color: #e7faf0;\r\n            border-color: #13ce66;\r\n        }\r\n    }\r\n\r\n    .entry__error.entry__error--primary {\r\n        color: #661d1d;\r\n        background-color: #ffeded;\r\n        border-radius: 3px;\r\n        border-color: #ff4949;\r\n    }\r\n\r\n    .sib-message-wrapper {\r\n        margin: 0 auto;\r\n        padding: 0 32px;\r\n        max-width: 540px;\r\n\r\n        .sib-form-message-panel--active {\r\n            margin-top: 60px;\r\n            position: relative;\r\n            display: block;\r\n            width: 100%;\r\n        }\r\n    }\r\n\r\n    #sib-container input:-ms-input-placeholder {\r\n        text-align: left;\r\n        color: #b0ccda;\r\n    }\r\n\r\n    #sib-container input::placeholder {\r\n        text-align: left;\r\n        color: #b0ccda;\r\n    }\r\n\r\n    .input-group {\r\n        .form-control:not(:first-child), .custom-select:not(:first-child) {\r\n            border-top-left-radius: 0.25rem;\r\n            border-bottom-left-radius: 0.25rem;\r\n        }\r\n\r\n        @media(max-width: 768px) {\r\n            &.full-width-mobile .form-control, &.full-width-mobile button {\r\n                width: 100%;\r\n                margin-top: 5px;\r\n            }\r\n\r\n            .form-control:not(:last-child), .custom-select:not(:last-child) {\r\n                border-top-right-radius: 0.25rem;\r\n                border-bottom-right-radius: 0.25rem;\r\n            }\r\n        }\r\n\r\n        @media(min-width: 769px) {\r\n            button {\r\n                border-top-left-radius: 0;\r\n                border-bottom-left-radius: 0;\r\n            }\r\n        }\r\n\r\n\r\n        input.form-control {\r\n            padding: 0.625rem 1.2rem;\r\n        }\r\n\r\n        &.full-width-mobile {\r\n            label {\r\n                margin: 0.25rem 0;\r\n            }\r\n\r\n            .btn {\r\n                min-width: 180px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .message_area {\r\n        max-width: 1000px;\r\n        margin: 20px auto;\r\n        padding: 8px;\r\n        border-radius: 5px;\r\n    }\r\n}\r\n","﻿.imagetextblock .image-text-block-button .partnerjoinblock {\r\n    padding: 0;\r\n}\r\n.modal.partner-join-modal {\r\n    color: #242829;\r\n\r\n    .modal-content {\r\n        border-radius: 4px;\r\n        border: 1px solid #D9D8D6;\r\n    }\r\n\r\n    .modal-body {\r\n        padding: 24px 24px 40px 24px;\r\n\r\n        label {\r\n            font-size: 22px;\r\n            font-style: normal;\r\n            font-weight: 400;\r\n            line-height: 28px;\r\n            margin-bottom: 32px;\r\n        }\r\n\r\n        select {\r\n            margin-bottom: 32px;\r\n            padding: 14px 24px;\r\n            height: auto;\r\n            color: #242829;\r\n        }\r\n\r\n        .btn-primary {\r\n            width: 100%;\r\n        }\r\n    }\r\n}\r\n@media(max-width: 575px) {\r\n    .open-partner-join-button{\r\n        width: 100%;\r\n    }\r\n    .modal.partner-join-modal {\r\n        z-index: 10001;\r\n\r\n        .modal-content {\r\n            border-bottom-left-radius: 0;\r\n            border-bottom-right-radius: 0;\r\n        }\r\n\r\n        .modal-dialog {\r\n            position: fixed;\r\n            top: auto;\r\n            right: auto;\r\n            left: auto;\r\n            bottom: 0;\r\n            width: 100%;\r\n            margin: 0;\r\n        }\r\n    }\r\n    .animate-from-bottom {\r\n        position: relative;\r\n        animation: animateFromBottom 0.4s;\r\n    } \r\n}\r\n\r\n@keyframes animateFromBottom {\r\n    from {\r\n        bottom: -200px;\r\n        opacity: 0;\r\n    }\r\n\r\n    to {\r\n        bottom: 0;\r\n        opacity: 1;\r\n    }\r\n}\r\n","﻿.responsive-iframe-video {\r\n    position: relative;\r\n    overflow: hidden;\r\n    width: 100%;\r\n    padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */\r\n}\r\n\r\n.responsive-iframe-video iframe {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    bottom: 0;\r\n    right: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n","﻿.short-info-item-image img{\r\n    max-width: 100%;\r\n}","﻿.staff-card.card {\r\n    border: none;\r\n\r\n    .card-header {\r\n        background-color: transparent;\r\n        border: none;\r\n        padding-bottom: 0;\r\n\r\n        & span {\r\n            color: #0C6175;\r\n        }\r\n    }\r\n\r\n    .card-body {\r\n        padding-top: 10px;\r\n\r\n        & img {\r\n            max-width: 100%;\r\n            border-radius: 4px;\r\n            margin-bottom: 10px;\r\n        }\r\n    }\r\n}\r\n","﻿$contact-info-height: 300px;\r\n$contact-info-width: 650px;\r\n$contact-info-modal-height: calc(#{$contact-info-height} + 40px);\r\n$contact-info-modal-width: calc(#{$contact-info-width} + 40px);\r\n\r\n.supportcontactblock {\r\n    .modal {\r\n        opacity: 0.95;\r\n        position: fixed;\r\n        padding-right: 0 !important;\r\n        text-align: left;\r\n\r\n        .modal-dialog {\r\n            max-width: 100vw;\r\n            margin: 0;\r\n\r\n            .modal-content {\r\n                min-height: 100vh;\r\n                border-radius: 0;\r\n\r\n                @media (max-width: 575px) {\r\n                    .modal-header {\r\n                        position: fixed;\r\n                        top: 0;\r\n                        left: 0;\r\n                        padding: 7px;\r\n                        z-index: 1025;\r\n                    }\r\n                }\r\n\r\n                .btn-close::after {\r\n                    content: \"\\F0156\";\r\n                    font-family: 'Material Design Icons';\r\n                    font-size: 35px;\r\n                    color: $primary;\r\n                    cursor: pointer;\r\n                    line-height: 1;\r\n                }\r\n            }\r\n        }\r\n\r\n        .modal-header {\r\n            border-bottom: none;\r\n            justify-content: end;\r\n        }\r\n\r\n        .modal-body {\r\n            padding: 45px;\r\n\r\n            #contact-grid {\r\n                display: grid;\r\n                gap: 20px;\r\n                grid-auto-columns: 100%;\r\n            }\r\n        }\r\n\r\n        @media (min-width: 576px) {\r\n\r\n            .modal-dialog {\r\n                max-width: $contact-info-modal-width;\r\n                margin: 10vh auto 0;\r\n\r\n                .modal-content {\r\n                    min-height: $contact-info-modal-height;\r\n                    border-radius: 10px;\r\n                }\r\n            }\r\n\r\n            .modal-body {\r\n                padding: 0px 60px 60px;\r\n\r\n                #contact-grid {\r\n                    grid-template-areas: \"a a\";\r\n                    grid-auto-columns: calc(50% - 10px);\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n","﻿\r\n.testimonialslistblock {\r\n\r\n    .testimonial-arrows {\r\n        position: relative;\r\n    }\r\n\r\n    .show-neighbors {\r\n        overflow: hidden;\r\n\r\n        .item__third:first-child,\r\n        .item__third:last-child {\r\n            display: none;\r\n        }\r\n\r\n        .item__third {\r\n            display: block !important;\r\n            float: left;\r\n            position: relative; /* captions can now be added */\r\n            width: 33.33333333%;\r\n        }\r\n\r\n        .carousel-control-prev:hover, .carousel-control-prev:focus, .carousel-control-next:hover, .carousel-control-next:focus {\r\n            opacity: 1;\r\n            background: none;\r\n        }\r\n\r\n        .carousel-control-prev,\r\n        .carousel-control-next {\r\n            opacity: .7;\r\n            background: rgba(255, 255, 255, 0);\r\n        }\r\n\r\n        .carousel-control-prev div.carousel-prev-arrow::before, .carousel-control-next div.carousel-next-arrow::before {\r\n            border-color: $accent-color;\r\n            border-style: solid;\r\n            content: '';\r\n            display: inline-block;\r\n            position: relative;\r\n            vertical-align: top;\r\n        }\r\n\r\n        .carousel-control-prev {\r\n\r\n            div.carousel-prev-arrow {\r\n                background-color: #fff;\r\n                position: absolute;\r\n\r\n                &:before {\r\n                    transform: rotate(-135deg);\r\n                }\r\n            }\r\n        }\r\n\r\n        .carousel-control-next {\r\n\r\n            div.carousel-next-arrow {\r\n                background-color: #fff;\r\n                position: absolute;\r\n\r\n                &:before {\r\n                    transform: rotate(45deg);\r\n                }\r\n            }\r\n        }\r\n\r\n        .carousel-item .carousel-item-image-area, .carousel-item .hero-settings {\r\n            .container, .row {\r\n                height: 100%;\r\n            }\r\n        }\r\n\r\n        @include media-breakpoint-down(xl) {\r\n            .carousel-item .carousel-item-image-area, .carousel-item .hero-settings {\r\n                height: 65vw;\r\n                max-height: 450px;\r\n            }\r\n\r\n            .carousel-control-prev,\r\n            .carousel-control-next {\r\n                height: 58px;\r\n                max-height: 450px;\r\n                width: 58px;\r\n            }\r\n\r\n            .carousel-control-prev div.carousel-prev-arrow::before, .carousel-control-next div.carousel-next-arrow::before {\r\n                border-width: 2px 2px 0 0;\r\n                height: 12px;\r\n                width: 12px;\r\n                top: 23px;\r\n            }\r\n\r\n            .carousel-control-prev {\r\n                border-right: none;\r\n                left: calc(3rem);\r\n                top: -100px;\r\n\r\n                div.carousel-prev-arrow {\r\n                    width: 58px;\r\n                    height: 58px;\r\n                    border-radius: 50%;\r\n                    right: 0;\r\n\r\n                    &:before {\r\n                        left: 3px;\r\n                    }\r\n                }\r\n            }\r\n\r\n            .carousel-control-next {\r\n                border-left: none;\r\n                left: calc(3rem + 120px);\r\n                top: -100px;\r\n\r\n                div.carousel-next-arrow {\r\n                    width: 58px;\r\n                    height: 58px;\r\n                    border-radius: 50%;\r\n                    left: 0;\r\n\r\n                    &:before {\r\n                        left: -3px;\r\n                    }\r\n                }\r\n            }\r\n\r\n            .item__third {\r\n\r\n                .testimonial-row {\r\n                    height: 600px;\r\n\r\n                    .testimonial-image {\r\n                        height: 100%;\r\n\r\n                        .testimonial-image-round {\r\n                            position: absolute;\r\n                            width: 170px;\r\n                            height: 170px;\r\n                            border-radius: 50%;\r\n                            right: 0;\r\n                            top: 60px;\r\n                        }\r\n                    }\r\n\r\n                    .testimonial-text-wrap {\r\n                        max-height: 480px;\r\n\r\n                        &.testimonial-round-image-padding {\r\n\r\n                            .testimonial-text {\r\n                                padding-top: 60px;\r\n                            }\r\n                        }\r\n\r\n                        .testimonial-text {\r\n                            max-width: 550px;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n\r\n            .carousel-inner {\r\n                width: 310%;\r\n                left: -103%;\r\n            }\r\n\r\n            .testimonial-arrows {\r\n                width: 103%;\r\n                left: 15px;\r\n            }\r\n        }\r\n\r\n        @include media-breakpoint-up(xl) {\r\n            .carousel-item .carousel-item-image-area, .carousel-item .hero-settings {\r\n                height: 33vw;\r\n                max-height: 620px;\r\n            }\r\n\r\n            .carousel-control-prev,\r\n            .carousel-control-next {\r\n                height: 58px;\r\n                max-height: 620px;\r\n                width: 58px;\r\n            }\r\n\r\n            .carousel-control-prev div.carousel-prev-arrow::before, .carousel-control-next div.carousel-next-arrow::before {\r\n                border-width: 2px 2px 0 0;\r\n                height: 12px;\r\n                width: 12px;\r\n                top: 23px;\r\n            }\r\n\r\n            .carousel-control-prev {\r\n                border-right: none;\r\n                left: calc(3rem);\r\n                top: -100px;\r\n\r\n                div.carousel-prev-arrow {\r\n                    width: 58px;\r\n                    height: 58px;\r\n                    border-radius: 50%;\r\n                    right: 0;\r\n\r\n                    &:before {\r\n                        left: 3px;\r\n                    }\r\n                }\r\n            }\r\n\r\n            .carousel-control-next {\r\n                border-left: none;\r\n                left: calc(3rem + 120px);\r\n                top: -100px;\r\n\r\n                div.carousel-next-arrow {\r\n                    width: 58px;\r\n                    height: 58px;\r\n                    border-radius: 50%;\r\n                    left: 0;\r\n\r\n                    &:before {\r\n                        left: -3px;\r\n                    }\r\n                }\r\n            }\r\n\r\n            .carousel-inner {\r\n                width: 270%;\r\n                left: -90%;\r\n\r\n                &.testimonial-round-images {\r\n                    width: 300%;\r\n                    left: -100%;\r\n                }\r\n            }\r\n\r\n            .testimonial-arrows {\r\n                width: 90%;\r\n                left: 15px;\r\n\r\n                &.testimonial-arrows-round-images {\r\n                    width: 100%;\r\n                    left: 15px;\r\n                }\r\n            }\r\n\r\n            .item__third {\r\n\r\n                .testimonial-row {\r\n                    height: 600px;\r\n\r\n                    .testimonial-image {\r\n                        height: 100%;\r\n                    }\r\n\r\n                    .testimonial-text-wrap {\r\n                        max-height: 480px;\r\n\r\n                        .testimonial-text {\r\n                            max-width: 600px;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n\r\n        @include media-breakpoint-down(md) {\r\n            .carousel-item .carousel-item-image-area, .carousel-item .hero-settings {\r\n                height: 65vw;\r\n                max-height: 450px;\r\n            }\r\n\r\n            .carousel-control-prev,\r\n            .carousel-control-next {\r\n                height: 58px;\r\n                width: 58px;\r\n            }\r\n\r\n            .carousel-control-prev div.carousel-prev-arrow::before, .carousel-control-next div.carousel-next-arrow::before {\r\n                border-width: 2px 2px 0 0;\r\n                height: 14px;\r\n                width: 14px;\r\n                top: 22px;\r\n            }\r\n\r\n            .carousel-control-prev {\r\n                border-right: none;\r\n                left: 87px;\r\n                top: -100px;\r\n\r\n                div.carousel-prev-arrow {\r\n                    width: 58px;\r\n                    height: 58px;\r\n                    border-radius: 50%;\r\n                    right: -23px;\r\n\r\n                    &:before {\r\n                        left: 1px;\r\n                    }\r\n                }\r\n            }\r\n\r\n            .carousel-control-next {\r\n                border-left: none;\r\n                left: 237px;\r\n                top: -100px;\r\n\r\n                div.carousel-next-arrow {\r\n                    width: 58px;\r\n                    height: 58px;\r\n                    border-radius: 50%;\r\n                    left: -23px;\r\n\r\n                    &:before {\r\n                        left: -1px;\r\n                    }\r\n                }\r\n            }\r\n\r\n            .item__third {\r\n\r\n                .testimonial-row {\r\n                    height: auto;\r\n                    padding-bottom: 130px;\r\n\r\n                    .testimonial-image {\r\n                        height: 52vw;\r\n\r\n                        &.testimonial-image-empty {\r\n                            height: 0;\r\n                        }\r\n                    }\r\n\r\n                    .testimonial-text-wrap {\r\n                        max-height: unset;\r\n                        padding-top: 45px;\r\n                        padding-left: 0 !important;\r\n                        max-width: calc(100vw - 184px);\r\n                        margin: 0 auto;\r\n\r\n                        .testimonial-text {\r\n                            max-width: unset;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n\r\n            .carousel-inner {\r\n                width: 310%;\r\n                left: -103%;\r\n\r\n                &.testimonial-round-images {\r\n                    .testimonial-image {\r\n                        height: 170px;\r\n\r\n                        .testimonial-image-round {\r\n                            right: unset;\r\n                            left: 114px;\r\n                        }\r\n\r\n                        &.testimonial-image-empty {\r\n                            height: 0;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n\r\n            .testimonial-arrows {\r\n                width: 103%;\r\n                left: 0;\r\n            }\r\n        }\r\n\r\n        @include media-breakpoint-down(sm) {\r\n\r\n            .carousel-control-prev {\r\n                left: 41px;\r\n                top: -100px;\r\n            }\r\n\r\n            .carousel-control-next {\r\n                left: 191px;\r\n                top: -100px;\r\n            }\r\n\r\n            .item__third {\r\n\r\n                .testimonial-row {\r\n                    height: auto;\r\n\r\n                    .testimonial-image {\r\n                        height: 68vw;\r\n                    }\r\n\r\n                    .testimonial-text-wrap {\r\n                        max-height: unset;\r\n                        padding-top: 45px;\r\n                        padding-left: 0 !important;\r\n                        max-width: calc(100vw - 100px);\r\n                        margin: 0 auto;\r\n\r\n                        .testimonial-text {\r\n                            max-width: unset;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n\r\n\r\n            .carousel-inner {\r\n\r\n                &.testimonial-round-images {\r\n                    .testimonial-image {\r\n                        height: 160px;\r\n\r\n                        .testimonial-image-round {\r\n                            right: unset;\r\n                            left: 68px;\r\n                        }\r\n\r\n                        &.testimonial-image-empty {\r\n                            height: 0;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        .carousel-item-next:not(.carousel-item-left),\r\n        .carousel-item-right.active {\r\n            -webkit-transform: translate3d(33%, 0, 0);\r\n            transform: translate3d(33%, 0, 0);\r\n        }\r\n\r\n        .carousel-item-prev:not(.carousel-item-right),\r\n        .carousel-item-left.active {\r\n            -webkit-transform: translate3d(-33%, 0, 0);\r\n            transform: translate3d(-33%, 0, 0);\r\n        }\r\n    }\r\n}\r\n\r\n.testimonial-results {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    flex-direction: column;\r\n    border-top: 1px solid #000;\r\n    padding-top: 12px;\r\n    margin-top: 10px;\r\n    height: 90px;\r\n    width: fit-content;\r\n\r\n    .testimonial-results-content {\r\n        width: fit-content;\r\n        padding-right: 10px;\r\n        line-height: 30px;\r\n\r\n        span {\r\n            line-height: 30px;\r\n        }\r\n    }\r\n}\r\n\r\n.flex-break {\r\n    flex-basis: 100%;\r\n    width: 0;\r\n}\r\n","﻿.textblock p {\r\n    margin-top: 1em;\r\n    margin-bottom: 1em;\r\n    font-size: 1rem;\r\n}\r\n\r\n.textblock-readmore {\r\n    position: relative;\r\n    overflow: hidden;\r\n}\r\n\r\n.textblock-readmore .textblock-readmore-fade {\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    max-width: 100%;\r\n    margin: 0;\r\n    padding: 60px 0 13px;\r\n    /* \"transparent\" only works here because == rgba(0,0,0,0) */\r\n    background-image: linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,1));\r\n}\r\n.textblock-readmore-button {\r\n    margin: 0;\r\n    text-transform: uppercase;\r\n}\r\n\r\n.textblock-readmore-button-white a.animated-link {\r\n    color: #fff;\r\n\r\n    &:before {\r\n        background: #fff;\r\n    }\r\n\r\n    &:after {\r\n        background: #caaeff;\r\n    }\r\n}\r\n\r\n","﻿$fixed-background-card-height: 710px;\r\n$fixed-background-card-width: 650px;\r\n$fixed-background-modal-height: calc(#{$fixed-background-card-height} + 40px);\r\n$fixed-background-modal-width: calc(#{$fixed-background-card-width} + 40px);\r\n\r\n.fixed-background-card-properties {\r\n    max-width: $fixed-background-card-width;\r\n    min-height: $fixed-background-card-height;\r\n    border-radius: 10px;\r\n    padding: 1.5rem 1.5rem;\r\n\r\n    @include media-breakpoint-up(md) {\r\n        padding: 2rem 3rem;\r\n    }\r\n\r\n    @include media-breakpoint-up(lg) {\r\n        padding: 3rem 3rem;\r\n    }\r\n\r\n    @media (max-width: 575px) {\r\n        max-width: calc(100vw - 20px);\r\n        min-height: calc(100vh - 110px);\r\n    }\r\n}\r\n.fixed-background-card .modal {\r\n    -ms-overflow-style: none; /* Internet Explorer 10+ */\r\n    scrollbar-width: none; /* Firefox */\r\n    overflow: -moz-scrollbars-none;\r\n}\r\n\r\n.fixed-background-card .modal::-webkit-scrollbar {\r\n    display: none; /* Safari and Chrome */\r\n}\r\n\r\n.e-with-fixed-bg {\r\n    width: 100%;\r\n    min-height: calc(100vh - 100px);\r\n    /* Important */\r\n    position: relative;\r\n}\r\n\r\n.bg-wrap {\r\n    clip: rect(0, auto, auto, 0);\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.bgb {\r\n    position: fixed;\r\n    display: block;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100vh;\r\n    background-size: cover;\r\n    background-position: center center;\r\n    transform: translateZ(0);\r\n    will-change: transform;\r\n}\r\n\r\n.e-container {\r\n    z-index: 1;\r\n}\r\n\r\n.fixed-background-container {\r\n    min-height: calc(100vh - 100px);\r\n    text-align: center;\r\n\r\n    h2 {\r\n        font-weight: 600;\r\n        font-size: 24px;\r\n        line-height: 36px;\r\n    }\r\n\r\n    @include media-breakpoint-up(md) {\r\n        h2 {\r\n            font-size: 28px;\r\n            line-height: 42px;\r\n        }\r\n    }\r\n\r\n    @include media-breakpoint-up(lg) {\r\n        h2 {\r\n            font-size: 32px;\r\n            line-height: 48px;\r\n        }\r\n    }\r\n\r\n    .fixed-background-card {\r\n        @extend .fixed-background-card-properties;\r\n        background-repeat: no-repeat;\r\n        background-position: center center;\r\n        background-size: cover;\r\n        background-color: #fff;\r\n        margin: 50px auto;\r\n        position: relative;\r\n        &-no-bg-image {\r\n            padding: 0;\r\n            min-height: initial;\r\n\r\n            .order-1 {\r\n                padding-top: 1.5rem;\r\n            }\r\n\r\n            .order-2 {\r\n                padding-top: 1rem !important;\r\n                padding-bottom: 1rem !important;\r\n            }\r\n\r\n            .order-3 {\r\n                padding-bottom: 1.5rem;\r\n            }\r\n\r\n            @include media-breakpoint-up(md) {\r\n                .order-1 {\r\n                    padding-top: 2rem;\r\n                }\r\n\r\n                .order-2 {\r\n                    padding-top: 1.5rem !important;\r\n                    padding-bottom: 1.5rem !important;\r\n                }\r\n\r\n                .order-3 {\r\n                    padding-bottom: 2rem;\r\n                }\r\n            }\r\n\r\n            @include media-breakpoint-up(lg) {\r\n                .order-1 {\r\n                    padding-top: 3rem;\r\n                }\r\n\r\n                .order-2 {\r\n                    padding-top: 2rem !important;\r\n                    padding-bottom: 2rem !important;\r\n                }\r\n\r\n                .order-3 {\r\n                    padding-bottom: 3rem;\r\n                }\r\n            }\r\n\r\n            .fixed-background-card-image.order-1.p-0 img {\r\n                border-top-left-radius: 10px;\r\n                border-top-right-radius: 10px;\r\n            }\r\n\r\n            .fixed-background-card-image.order-3.p-0 img {\r\n                border-bottom-left-radius: 10px;\r\n                border-bottom-right-radius: 10px;\r\n            }\r\n        }\r\n\r\n        button {\r\n\r\n            &::before {\r\n                content: \"\\F0415\";\r\n                font-family: 'Material Design Icons';\r\n                margin-right: 0.5rem;\r\n                font-size: 1.5rem;\r\n                line-height: .1;\r\n                position: relative;\r\n                top: 4px;\r\n                font-weight: 400;\r\n            }\r\n        }\r\n\r\n        .modal {\r\n            opacity: 0.95;\r\n            position: fixed;\r\n            padding-right: 0 !important;\r\n            text-align: left;\r\n\r\n            .modal-dialog {\r\n                max-width: 100vw;\r\n                margin: 0;\r\n\r\n                .modal-content {\r\n                    min-height: 100vh;\r\n                    border-radius: 0;\r\n\r\n                    @media (max-width: 575px) {\r\n                        .modal-header {\r\n                            position: fixed;\r\n                            top: 0;\r\n                            left: 0;\r\n                            padding: 7px;\r\n                            z-index: 1025;\r\n                        }\r\n                    }\r\n\r\n                    .btn-close::after {\r\n                        content: \"\\F0156\";\r\n                        font-family: 'Material Design Icons';\r\n                        font-size: 35px;\r\n                        color: $primary;\r\n                        cursor: pointer;\r\n                        line-height: 1;\r\n                    }\r\n                }\r\n            }\r\n\r\n            .modal-header {\r\n                border-bottom: none;\r\n                justify-content: end;\r\n            }\r\n\r\n            .modal-body {\r\n                padding: 45px;\r\n            }\r\n\r\n            @media (min-width: 576px) {\r\n\r\n                .modal-dialog {\r\n                    max-width: $fixed-background-modal-width;\r\n                    margin: calc(50vh - #{$fixed-background-modal-height} / 2) auto;\r\n\r\n                    .modal-content {\r\n                        min-height: $fixed-background-modal-height;\r\n                        border-radius: 10px;\r\n                    }\r\n                }\r\n\r\n                .modal-body {\r\n                    padding: 0px 60px 60px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n","﻿.category__figure {\r\n    flex: 0 0 200px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.category__img {\r\n    max-height: 180px;\r\n    width: auto;\r\n}\r\n\r\n.category {\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin-right: 50px;\r\n}\r\n\r\n.category-heading {\r\n    font-size: 18px;\r\n}\r\n\r\n.category__children {\r\n    flex: 1;\r\n    list-style: none;\r\n    padding: 0;\r\n    line-height: 1.7;\r\n}\r\n\r\n.category__name {\r\n    font-weight: 500;\r\n}","﻿h1.errorpage {\r\n    margin: 100px auto 0 auto;\r\n    color: var(--stroke-color);\r\n    font-family: 'Encode Sans Semi Condensed', Verdana, sans-serif;\r\n    font-size: 10rem;\r\n    line-height: 10rem;\r\n    font-weight: 200;\r\n    text-align: center;\r\n}\r\n\r\nh2.errorpage {\r\n    margin: 20px auto 30px auto;\r\n    font-family: 'Encode Sans Semi Condensed', Verdana, sans-serif;\r\n    font-size: 1.5rem;\r\n    font-weight: 200;\r\n    text-align: center;\r\n}\r\n\r\nh1.errorpage, h2.errorpage {\r\n    -webkit-transition: opacity 0.5s linear, margin-top 0.5s linear; /* Safari */\r\n    transition: opacity 0.5s linear, margin-top 0.5s linear;\r\n}\r\n\r\n.error-header {\r\n    background-color: rgb(236, 233, 242);\r\n\r\n    .container {\r\n        padding: 32px 0;\r\n\r\n        .error-header-logo {\r\n            margin: 0 auto;\r\n            display: block;\r\n        }\r\n    }\r\n}\r\n\r\n.cd-main-content:has(.error-header) {\r\n    padding-top: 0;\r\n}","﻿.video-file {\r\n    width: 100%;\r\n    height: 100%;\r\n    position: relative;\r\n\r\n    &__frame {\r\n        width: 100%;\r\n        height: auto;\r\n        object-fit: cover;\r\n    }\r\n\r\n    &__copyright {\r\n        position: absolute;\r\n        z-index: 10;\r\n        right: 1%;\r\n        top: 1%;\r\n        color: white;\r\n        font-style: italic;\r\n        font-size: 1.5vw;\r\n        user-select: none;\r\n        margin: 0;\r\n    }\r\n}\r\n","﻿.person-filter-block {\r\n    margin: 40px 0px 100px 0px;\r\n\r\n    .button-transparent-black {\r\n        padding: 8px 30px;\r\n        width: 100%;\r\n    }\r\n\r\n    div {\r\n        padding-left: 0px;\r\n    }\r\n\r\n    button-transparent-black {\r\n        padding: 8px 10px;\r\n    }\r\n\r\n    .easy-autocomplete-container ul {\r\n        display: none;\r\n    }\r\n}\r\n\r\n.person_image {\r\n    max-height: 200px;\r\n}\r\n\r\n.person_heading {\r\n    margin-top: 2rem;\r\n    text-align: center;\r\n    font-size: 3.85714rem;\r\n    margin: 28px 0 14px 0;\r\n    text-align: left;\r\n}\r\n\r\n.person-list-block {\r\n    margin-bottom: 40px;\r\n\r\n    .category-page__facets {\r\n        margin-top: 60px;\r\n    }\r\n\r\n    .product-tile-grid {\r\n        padding-bottom: 0px;\r\n        height: 50%;\r\n    }\r\n\r\n    .detail-info {\r\n        padding: 20px 0px 0px 10px;\r\n\r\n        a {\r\n            overflow-wrap: break-word;\r\n            color: black;\r\n        }\r\n    }\r\n\r\n    .h-50 {\r\n        margin-bottom: 40px;\r\n    }\r\n}\r\n\r\n.contact {\r\n    margin-top: 40px;\r\n\r\n    .detail-contact {\r\n        padding: 25px;\r\n\r\n        h2, p {\r\n            margin-bottom: 25px;\r\n        }\r\n\r\n        a {\r\n            color: black;\r\n        }\r\n    }\r\n\r\n    .product-tile-grid {\r\n        margin-bottom: 0px;\r\n    }\r\n\r\n    .product-tile-grid img {\r\n        height: auto;\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n.staff-block {\r\n    line-height: 22px;\r\n    h4 {\r\n        font-weight: normal;\r\n        font-size: 24px;\r\n        line-height: 36px;\r\n        margin-bottom: 0;\r\n    }\r\n\r\n    .staff-title {\r\n        font-weight: 600;\r\n        font-size: 18px;\r\n        line-height: 24px;\r\n        margin-bottom: 35px;\r\n    }\r\n}\r\n",".sticky-nav-tabs {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    position: relative;\r\n    padding: 0 2em;\r\n\r\n    .screen-width-block {\r\n        width: 100vw;\r\n        position: relative;\r\n        left: 50%;\r\n        right: 50%;\r\n        margin-left: -50vw;\r\n        margin-right: -50vw;\r\n    }\r\n\r\n    @include media-breakpoint-down(sm) {\r\n        .screen-width-block {\r\n            width: 100vw;\r\n            position: relative;\r\n            left: 50%;\r\n            right: 50%;\r\n            margin-left: -50vw;\r\n            margin-right: -50vw;\r\n        }\r\n    }\r\n}\r\n\r\n.sticky-nav-mobile-header {\r\n    height: 54px;\r\n    background-color: $light-purple;\r\n    color: #fff;\r\n    font-size: 20px;\r\n    line-height: 32px;\r\n    display: block;\r\n    padding: 11px 0;\r\n    cursor: pointer;\r\n}\r\n.sticky-nav-mobile-header:hover {\r\n    color: #fff;\r\n}\r\n\r\n.investors-arrowLinkWrapper {\r\n    width: 22px;\r\n    height: 22px;\r\n    position: absolute;\r\n    right: 12px;\r\n    top: 5px;\r\n}\r\n\r\n.investors-link-showHide {\r\n    border: solid #fff;\r\n    border-width: 0 2px 2px 0;\r\n    display: inline-block;\r\n    position: absolute;\r\n    padding: 4px;\r\n    top: 10px;\r\n    left: 5px;\r\n    line-height: 17px;\r\n    -webkit-transition: -webkit-transform linear 0.7s;\r\n    -moz-transition: -moz-transform 0.7s;\r\n    transition: transform 0.7s;\r\n    transform: rotate(-135deg);\r\n    -moz-transform: rotate(-135deg);\r\n    -webkit-transform: rotate(-135deg);\r\n    top: 14px;\r\n}\r\n\r\n.investors-link-down {\r\n    transform: rotate(45deg);\r\n    -moz-transform: rotate(45deg);\r\n    -webkit-transform: rotate(45deg);\r\n}\r\n\r\n.sticky-nav-tabs h1, .investors-slide h1 {\r\n    font-size: 48px;\r\n    margin: 0;\r\n    letter-spacing: 0.02em;\r\n}\r\n\r\n.sticky-nav-tabs h3, .investors-slide h3 {\r\n    font-weight: 600;\r\n    font-size: 32px;\r\n    line-height: 48px;\r\n    letter-spacing: 0.02em;\r\n    color: $color-black;\r\n\r\n    &.color-light {\r\n        color: #fff;\r\n    }\r\n}\r\n\r\n.sticky-nav-tabs-container {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n    -ms-flex-direction: row;\r\n    flex-direction: row;\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 54px;\r\n    background: $color-lighter-purple;\r\n    z-index: 2;\r\n    -webkit-transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);\r\n    transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);\r\n    padding: 0;\r\n}\r\n\r\n.inside-sticky {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-orient: horizontal;\r\n    -webkit-box-direction: normal;\r\n    -ms-flex-direction: row;\r\n    flex-direction: row;\r\n    height: 54px;\r\n}\r\n\r\n.sticky-nav-tabs-container--top-first {\r\n    position: fixed;\r\n    top: 100px;\r\n    left: 0;\r\n    -webkit-transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);\r\n    transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);\r\n}\r\n\r\n.sticky-nav-tabs-container--top-second {\r\n    position: fixed;\r\n    top: 100px;\r\n    left: 0;\r\n}\r\n\r\n.sticky-nav-tabs-container-wrap {\r\n    height: 54px;\r\n}\r\n@include media-breakpoint-down(md) {\r\n\r\n    .sticky-nav-tabs-container-wrap {\r\n        height: auto;\r\n    }\r\n\r\n    .sticky-nav-tabs-container, .sticky-nav-tabs-container-wrap {\r\n        background-color: $light-purple;\r\n    }\r\n\r\n    .inside-sticky {\r\n        display: block;\r\n        height: auto;\r\n        background-color: $color-lighter-purple;\r\n        padding: 0;\r\n\r\n        .sticky-nav-tab, .sticky-nav-link, .sticky-nav-external-quick-link {\r\n            height: 63px;\r\n            justify-content: left;\r\n            padding: 0 15px;\r\n        }\r\n    }\r\n}\r\n\r\n@media(max-width: 1169px) {\r\n\r\n    .sticky-nav-tabs-container--top-first {\r\n        top: 90px;\r\n    }\r\n\r\n    .sticky-nav-tabs-container--top-second {\r\n        top: 90px;\r\n    } \r\n}\r\n\r\n.sticky-nav-tab, .sticky-nav-link, .sticky-nav-external-quick-link {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n    -ms-flex-pack: center;\r\n    justify-content: center;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    -webkit-box-flex: 1;\r\n    -ms-flex: auto;\r\n    flex: auto;\r\n    color: $color-black;\r\n    -webkit-transition: all 0.5s ease;\r\n    transition: all 0.5s ease;\r\n    font-size: 16px;\r\n\r\n    @include media-breakpoint-down(lg) {\r\n        font-size: 14px;\r\n    }\r\n}\r\n\r\n.sticky-nav-tab:hover, .sticky-nav-tab.active, .sticky-nav-external-quick-link:hover, .sticky-nav-external-quick-link.active, .sticky-nav-link.active, .sticky-nav-link:hover {\r\n    color: white;\r\n    background-color: $light-purple;\r\n    -webkit-transition: all 0.5s ease;\r\n    transition: all 0.5s ease;\r\n    text-decoration: none;\r\n}\r\n.sticky-nav-link {\r\n    background-color: #C4B1CF;\r\n\r\n    &:after {\r\n        content: \"\\F0142\";\r\n        font-family: 'Material Design Icons';\r\n        margin-left: 0.5rem;\r\n        font-size: 20px;\r\n        margin-top: 3px;        \r\n    }\r\n}\r\n\r\n.person-filter-block {\r\n    margin: 40px 0px 100px 0px;\r\n\r\n    .button-transparent-black {\r\n        padding: 8px 30px;\r\n        width: 100%;\r\n    }\r\n\r\n    div {\r\n        padding-left: 0px;\r\n    }\r\n\r\n    button-transparent-black {\r\n        padding: 8px 10px;\r\n    }\r\n\r\n    .easy-autocomplete-container ul {\r\n        display: none;\r\n    }\r\n}\r\n\r\n.person_image {\r\n    max-height: 200px;\r\n}\r\n\r\n.person_heading {\r\n    margin-top: 2rem;\r\n    text-align: center;\r\n    font-size: 3.85714rem;\r\n    margin: 28px 0 14px 0;\r\n    text-align: left;\r\n}\r\n\r\n.person-list-block {\r\n    margin-bottom: 40px;\r\n\r\n    .category-page__facets {\r\n        margin-top: 60px;\r\n    }\r\n\r\n    .product-tile-grid {\r\n        padding-bottom: 0px;\r\n        height: 50%;\r\n    }\r\n\r\n    .detail-info {\r\n        padding: 20px 0px 0px 10px;\r\n\r\n        a {\r\n            overflow-wrap: break-word;\r\n            color: black;\r\n        }\r\n    }\r\n\r\n    .h-50 {\r\n        margin-bottom: 40px;\r\n    }\r\n}\r\n\r\n.contact {\r\n    margin-top: 40px;\r\n\r\n    .detail-contact {\r\n        padding: 25px;\r\n\r\n        h2, p {\r\n            margin-bottom: 25px;\r\n        }\r\n\r\n        a {\r\n            color: black;\r\n        }\r\n    }\r\n\r\n    .product-tile-grid {\r\n        margin-bottom: 0px;\r\n    }\r\n\r\n    .product-tile-grid img {\r\n        height: auto;\r\n        width: 100%;\r\n    }\r\n}\r\n.reports-row .collapse {\r\n    -webkit-transition: all .5s ease;\r\n    transition: all .5s ease;\r\n    opacity: 0;\r\n}\r\n.reports-row .collapsing.show, .reports-row .collapse.show {\r\n    opacity: 1;\r\n}\r\n\r\n@include media-breakpoint-up(md) {\r\n    .reports-row .col-md-6:nth-child(odd) {\r\n        border-right: 1px solid #9EA699;\r\n        padding-right: 115px;\r\n    }\r\n\r\n    .reports-row .col-md-6:nth-child(even) {\r\n        padding-left: 115px;\r\n    }\r\n}\r\n@include media-breakpoint-down(sm) {\r\n    .reports-row {\r\n        max-width: 310px;\r\n        margin: 0 auto;\r\n    }\r\n}\r\n\r\n.financial-calendar {\r\n    background-color: #0C6175;\r\n    color: #fff;\r\n\r\n    .detail-info {\r\n        border-bottom: 1px solid #09AFAB;\r\n        padding-top: 30px;\r\n        p {\r\n            font-weight: 600;\r\n            font-size: 20px;\r\n            line-height: 32px;\r\n        }\r\n    }\r\n\r\n    h3 {\r\n        color: #fff;\r\n    }\r\n}\r\n.financial-reports {\r\n    background-color: #EEEFEE;\r\n\r\n    .detail-info {\r\n        h4 {\r\n            font-weight: 600;\r\n            font-size: 20px;\r\n            line-height: 32px;\r\n        }\r\n\r\n        a {\r\n            color: $color-black;\r\n            font-weight: 600;\r\n            font-size: 16px;\r\n\r\n            &:hover {\r\n                &::after, &::before {\r\n                    color: $light-purple;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.press-releases {\r\n    background-color: #E5E5E5;\r\n\r\n    .detail-info {\r\n        h4 {\r\n            font-weight: 600;\r\n            font-size: 20px;\r\n            line-height: 32px;\r\n        }\r\n\r\n        a {\r\n            color: $color-black;\r\n            font-weight: 600;\r\n            font-size: 16px;\r\n\r\n            &:hover {\r\n                &::after, &::before {\r\n                    color: $light-purple;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.staff-round-image{\r\n    background-size: cover;\r\n    width: 180px;\r\n    height: 180px;\r\n    border-radius: 50%;\r\n}\r\n\r\n.graph-ticker {\r\n    position: relative;\r\n    width: 100%;\r\n    height: 0;\r\n    padding-bottom: 550px;\r\n}\r\n.share-info-toggle{\r\n    font-weight: 600;\r\n    text-decoration: underline;\r\n}\r\n@include media-breakpoint-up(lg) {\r\n    .graph-ticker {\r\n        padding-bottom: 270px;\r\n    }\r\n}\r\n\r\n.press-release-keyword {\r\n    display: inline-block;\r\n    padding: 7px 15px;\r\n    border-radius: 18px;\r\n    background-color: #f0f3f5;\r\n    white-space: nowrap;\r\n    margin-bottom: 5px;\r\n}","$news-list-image-height: 300px;\r\n\r\n.breadcrumbs {\r\n    color: #242829;\r\n    font-size: 12px;\r\n    line-height: 25px;\r\n    display: flex;\r\n    padding: 10px 0;\r\n    position: fixed;\r\n    z-index: 2;\r\n    background-color: #fff;\r\n\r\n    a {\r\n        padding: 0 4px;\r\n        line-height: 25px;\r\n        font-weight: 600;\r\n        letter-spacing: 0.2px;\r\n        text-decoration-line: underline;\r\n        color: #242829;\r\n\r\n        &:hover {\r\n            color: #000;\r\n        }\r\n    }\r\n\r\n    div.breadcrubms-current-page {\r\n        padding: 0 4px;\r\n        display: inline-block;\r\n        max-width: 100px;\r\n        font-style: italic;\r\n        white-space: nowrap;\r\n    }\r\n}\r\n.news-sticky-nav-tabs {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    position: relative;\r\n    padding: 0 2em;\r\n\r\n    .screen-width-block {\r\n        width: 100vw;\r\n        position: relative;\r\n        left: 50%;\r\n        right: 50%;\r\n        margin-left: -50vw;\r\n        margin-right: -50vw;\r\n    }\r\n\r\n    @include media-breakpoint-down(sm) {\r\n        .screen-width-block {\r\n            width: 100vw;\r\n            position: relative;\r\n            left: 50%;\r\n            right: 50%;\r\n            margin-left: -50vw;\r\n            margin-right: -50vw;\r\n        }\r\n    }\r\n\r\n    .news-sticky-nav-mobile-header {\r\n        height: 54px;\r\n        background-color: $light-purple;\r\n        color: #fff;\r\n        font-size: 20px;\r\n        line-height: 32px;\r\n        display: block;\r\n        padding: 11px 0;\r\n        cursor: pointer;\r\n    }\r\n\r\n    .news-sticky-nav-mobile-header:hover {\r\n        color: #fff;\r\n    }\r\n\r\n    .news-room-arrowLinkWrapper {\r\n        width: 22px;\r\n        height: 22px;\r\n        position: absolute;\r\n        right: 12px;\r\n        top: 5px;\r\n    }\r\n\r\n    .news-room-link-showHide {\r\n        border: solid #fff;\r\n        border-width: 0 2px 2px 0;\r\n        display: inline-block;\r\n        position: absolute;\r\n        padding: 4px;\r\n        top: 10px;\r\n        left: 5px;\r\n        line-height: 17px;\r\n        -webkit-transition: -webkit-transform linear 0.7s;\r\n        -moz-transition: -moz-transform 0.7s;\r\n        transition: transform 0.7s;\r\n        transform: rotate(-135deg);\r\n        -moz-transform: rotate(-135deg);\r\n        -webkit-transform: rotate(-135deg);\r\n        top: 14px;\r\n    }\r\n\r\n    .news-room-link-down {\r\n        transform: rotate(45deg);\r\n        -moz-transform: rotate(45deg);\r\n        -webkit-transform: rotate(45deg);\r\n    }\r\n\r\n    h1 {\r\n        font-size: 48px;\r\n        margin: 0;\r\n        letter-spacing: 0.02em;\r\n    }\r\n\r\n    h3 {\r\n        font-weight: 600;\r\n        font-size: 32px;\r\n        line-height: 48px;\r\n        letter-spacing: 0.02em;\r\n        color: $color-black;\r\n\r\n        &.color-light {\r\n            color: #fff;\r\n        }\r\n    }\r\n\r\n    .news-sticky-nav-tabs-container {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        -webkit-box-orient: horizontal;\r\n        -webkit-box-direction: normal;\r\n        -ms-flex-direction: row;\r\n        flex-direction: row;\r\n        position: absolute;\r\n        bottom: 0;\r\n        left: 0;\r\n        width: 100%;\r\n        height: 54px;\r\n        background: $color-lighter-purple;\r\n        z-index: 2;\r\n        -webkit-transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);\r\n        transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);\r\n        padding: 0;\r\n    }\r\n\r\n    .news-inside-sticky {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        -webkit-box-orient: horizontal;\r\n        -webkit-box-direction: normal;\r\n        -ms-flex-direction: row;\r\n        flex-direction: row;\r\n        height: 54px;\r\n    }\r\n\r\n    .news-sticky-nav-tabs-container--top-first {\r\n        position: fixed;\r\n        top: 100px;\r\n        left: 0;\r\n        -webkit-transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);\r\n        transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);\r\n    }\r\n\r\n    .news-sticky-nav-tabs-container--top-second {\r\n        position: fixed;\r\n        top: 100px;\r\n        left: 0;\r\n    }\r\n\r\n    .news-sticky-nav-tabs-container-wrap {\r\n        height: 54px;\r\n    }\r\n\r\n    @include media-breakpoint-down(md) {\r\n\r\n        .news-sticky-nav-tabs-container-wrap {\r\n            height: auto;\r\n        }\r\n\r\n        .news-sticky-nav-tabs-container, .news-sticky-nav-tabs-container-wrap {\r\n            background-color: $light-purple;\r\n        }\r\n\r\n        .news-inside-sticky {\r\n            display: block;\r\n            height: auto;\r\n            background-color: $color-lighter-purple;\r\n            padding: 0;\r\n\r\n            .news-sticky-nav-tab, .news-sticky-nav-link, .news-sticky-nav-external-quick-link {\r\n                height: 63px;\r\n                justify-content: left;\r\n                padding: 0 15px;\r\n            }\r\n        }\r\n    }\r\n\r\n    @media(max-width: 1169px) {\r\n\r\n        .news-sticky-nav-tabs-container--top-first {\r\n            top: 90px;\r\n        }\r\n\r\n        .news-sticky-nav-tabs-container--top-second {\r\n            top: 90px;\r\n        }\r\n    }\r\n\r\n    .news-sticky-nav-tab, .news-sticky-nav-link, .news-sticky-nav-external-quick-link {\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n        justify-content: center;\r\n        -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n        align-items: center;\r\n        -webkit-box-flex: 1;\r\n        -ms-flex: auto;\r\n        flex: auto;\r\n        color: $color-black;\r\n        -webkit-transition: all 0.5s ease;\r\n        transition: all 0.5s ease;\r\n        font-size: 16px;\r\n\r\n        @include media-breakpoint-down(lg) {\r\n            font-size: 14px;\r\n        }\r\n    }\r\n\r\n    .news-sticky-nav-tab:hover, .news-sticky-nav-tab.active, .news-sticky-nav-external-quick-link:hover, .news-sticky-nav-external-quick-link.active, .news-sticky-nav-link.active, .news-sticky-nav-link:hover {\r\n        color: white;\r\n        background-color: $light-purple;\r\n        -webkit-transition: all 0.5s ease;\r\n        transition: all 0.5s ease;\r\n        text-decoration: none;\r\n    }\r\n\r\n    .news-sticky-nav-link {\r\n        background-color: #C4B1CF;\r\n\r\n        &:after {\r\n            content: \"\\F0142\";\r\n            font-family: 'Material Design Icons';\r\n            margin-left: 0.5rem;\r\n            font-size: 20px;\r\n            margin-top: 3px;\r\n        }\r\n    }\r\n}\r\n\r\n.news-room-list-wrapper {\r\n    padding-top: 20px;\r\n}\r\n\r\n.news-list-wrapper {\r\n    border-radius: 8px;\r\n    height: 100%;\r\n    cursor: pointer;\r\n    background-color: #fff;\r\n    -webkit-transition: all 0.25s ease;\r\n    transition: all 0.25s ease;\r\n\r\n    &:hover {\r\n        -webkit-box-shadow: 0px 24px 40px -16px rgba(29, 35, 36, 0.24);\r\n        box-shadow: 0px 24px 40px -16px rgba(29, 35, 36, 0.24);\r\n    }\r\n}\r\n\r\n.news-list-item-image {\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n    background-position: center center;\r\n    height: $news-list-image-height;\r\n    border-top-right-radius: 8px;\r\n    border-top-left-radius: 8px;\r\n}\r\n\r\n.news-list-item {\r\n    padding: 20px 30px 30px;\r\n    transition: all .2s;\r\n    height: calc(100% - #{$news-list-image-height});\r\n\r\n    .row.align-content-between {\r\n        height: 100%;\r\n    }\r\n\r\n    .news-category-date {\r\n        color: #555;\r\n        font-size: 14px;\r\n    }\r\n}\r\n\r\n@media(max-width: 575px){\r\n    .more-news.row {\r\n        margin-left: -30px;\r\n        margin-right: -30px;\r\n\r\n        .news-list-wrapper {\r\n            padding: 15px;\r\n            border-radius: 0;\r\n            display: flex;\r\n            flex-wrap: wrap;\r\n            margin-right: -15px;\r\n            margin-left: -15px;\r\n        }\r\n\r\n        .news-list-item-image {\r\n            background-size: cover;\r\n            background-repeat: no-repeat;\r\n            background-position: center center;\r\n            height: 120px;\r\n            border-radius: 8px;\r\n            flex: 0 0 33.33333%;\r\n            max-width: 33.33333%;\r\n            position: relative;\r\n            width: 100%;\r\n            padding-right: 15px;\r\n            padding-left: 15px;\r\n        }\r\n\r\n        .news-list-item {\r\n            height: 100%;\r\n            transition: all .2s;\r\n            flex: 0 0 66.66667%;\r\n            max-width: 66.66667%;\r\n            position: relative;\r\n            width: 100%;\r\n            padding: 0 0 0 15px;\r\n\r\n            h6 {\r\n                font-size: 14px;\r\n                line-height: 24px;\r\n                font-weight: 400;\r\n            }\r\n\r\n\r\n            .row.align-content-between {\r\n                height: calc(100% - #{$news-list-image-height});\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media(min-width: 576px){\r\n    .more-news.row {\r\n        font-size: 15px;\r\n        color: #404748;\r\n\r\n        .news-list-wrapper {\r\n            h6 {\r\n                font-size: 15px;\r\n                line-height: 1.3rem;\r\n                font-weight: 400;\r\n                letter-spacing: .025em;\r\n                color: #000;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media(min-width: 992px){\r\n    .news-list-main-item {\r\n        background-image: none !important;\r\n        min-height: 500px;\r\n        padding: 25px 40px 25px 60%;\r\n        height: 100%;\r\n\r\n        .row.align-content-between {\r\n            height: 100%;\r\n        }\r\n\r\n        .news-list-main-item-image {\r\n            background-size: cover;\r\n            background-position: center center;\r\n            border-bottom-left-radius: 8px;\r\n            border-top-left-radius: 8px;\r\n            width: calc(60% - 55px);\r\n            height: calc(100%);\r\n            position: absolute;\r\n            left: 0;\r\n            top: 0;\r\n            margin-left: 15px;\r\n        }\r\n    }\r\n}\r\n\r\n.news-category-header {\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    line-height: 24px;\r\n    color: #595F56;\r\n    text-transform: uppercase;\r\n    letter-spacing: .02em;\r\n}\r\n\r\n\r\n.news-detail {\r\n    h1 {\r\n        font-weight: 400;\r\n        font-size: 48px;\r\n        line-height: 64px;\r\n        letter-spacing: 0.02em;\r\n        color: #242829;\r\n\r\n        @include media-breakpoint-down(md) {\r\n            font-size: 2.25em;\r\n            line-height: 1.2;\r\n        }\r\n    }\r\n\r\n    h2 {\r\n        font-weight: 500;\r\n        font-size: 1.5rem;\r\n        line-height: 36px;\r\n        letter-spacing: 0.02em;\r\n        color: #242829;\r\n\r\n        @include media-breakpoint-down(md) {\r\n            font-size: calc(1.275rem + 0.3vw);\r\n            line-height: 1.4;\r\n        }\r\n    }\r\n\r\n    h3 {\r\n        font-weight: 600;\r\n        font-size: 1.25rem;\r\n        line-height: 32px;\r\n        letter-spacing: 0.02em;\r\n        color: #242829;\r\n\r\n        @include media-breakpoint-down(md) {\r\n            font-size: 1.2em;\r\n            line-height: 1.4;\r\n        }\r\n    }\r\n\r\n    h4 {\r\n        font-weight: 600;\r\n        font-size: 1.125rem;\r\n        line-height: 36px;\r\n        letter-spacing: 0.02em;\r\n        color: #242829;\r\n\r\n        @include media-breakpoint-down(md) {\r\n            font-size: 1.2em;\r\n            line-height: 1.4;\r\n        }\r\n    }\r\n\r\n    p {\r\n        margin-bottom: 1.8rem;\r\n    }\r\n\r\n    img {\r\n        height: auto;\r\n    }\r\n\r\n    sup {\r\n        cursor: pointer;\r\n\r\n        &:after {\r\n            content: \"\";\r\n            padding: 10px;\r\n            position: absolute;\r\n            left: -7px;\r\n            top: -5px;\r\n            border-radius: 10px;\r\n            -webkit-transition: all .20s ease-in-out;\r\n            -moz-transition: all .20s ease-in-out;\r\n            -ms-transition: all .20s ease-in-out;\r\n            -o-transition: all .20s ease-in-out;\r\n            transition: all .20s ease-in-out;\r\n        }\r\n\r\n        &:hover::after {\r\n            padding: 14px;\r\n            left: -9px;\r\n            top: -7px;\r\n            border-radius: 14px;\r\n            background-color: rgba(136, 172, 39, 0.4);\r\n        }\r\n    }\r\n\r\n    .blog-article-preheader {\r\n        font-weight: 600;\r\n        font-size: 14px;\r\n        line-height: 24px;\r\n        letter-spacing: 0.02em;\r\n        color: #595F56;\r\n        margin: 20px 0 10px;\r\n    }\r\n\r\n    .blog-article-writer {\r\n        margin-top: 20px;\r\n        font-weight: 400;\r\n        font-size: 16px;\r\n        line-height: 25px;\r\n        letter-spacing: 0.2px;\r\n        color: #242829;\r\n    }\r\n\r\n    .shop-link-wrapper {\r\n        h6 {\r\n            font-weight: 400;\r\n            font-size: 20px;\r\n            line-height: 27px;\r\n            color: #000000;\r\n        }\r\n    }\r\n\r\n    .related-products {\r\n        h2 {\r\n            font-weight: 600;\r\n            font-size: 32px;\r\n            line-height: 44px;\r\n            letter-spacing: 0.02em;\r\n            color: #242829;\r\n        }\r\n    }\r\n}\r\n\r\n#searchterm {\r\n    width: 100%;\r\n    border: none;\r\n    border-radius: 0;\r\n    border-bottom: 1px solid #777;\r\n    background-color: transparent;\r\n    max-width: 355px;\r\n\r\n    &:focus {\r\n        box-shadow: none;\r\n    }\r\n\r\n    &::blur {\r\n        #auto-complete-results {\r\n            display: none;\r\n        }\r\n    }\r\n}\r\n\r\n#search-area {\r\n    max-width: 355px;\r\n}\r\n\r\n.search-term-button {\r\n    background: transparent;\r\n    border: none;\r\n    cursor: pointer;\r\n    display: inline-block;\r\n    font-size: 20px;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    padding: 10px 15px 8px 15px;\r\n\r\n    &:focus{\r\n        outline: none;\r\n    }\r\n}\r\n\r\n.news-search-header {\r\n    background-color: #8859C5;\r\n    height: 146px;\r\n    margin-right: -15px;\r\n    margin-left: -15px;\r\n\r\n    @include media-breakpoint-up(lg) {\r\n        height: 81px;\r\n    }\r\n\r\n    .news-back-button a {\r\n        font-weight: 400;\r\n        font-size: 12px;\r\n        line-height: 20px;\r\n        letter-spacing: 0.01em;\r\n        color: #fff;\r\n    }\r\n\r\n    .news-search-headline {\r\n        text-align: center;\r\n\r\n        h1 {\r\n            font-weight: 300;\r\n            font-size: 32px;\r\n            line-height: 48px;\r\n            text-align: center;\r\n            letter-spacing: 0.02em;\r\n            color: #FFFFFF;\r\n        }\r\n    }\r\n}\r\n\r\n#auto-complete-results {\r\n    -webkit-box-shadow: 0px 4px 10px 0px rgba(0,0,0,0.14);\r\n    box-shadow: 0px 4px 10px 0px rgba(0,0,0,0.14);\r\n    width: calc(100% - 30px);\r\n    background-color: rgba(255, 255, 255, .95);\r\n    position: absolute;\r\n    z-index: 3;\r\n}\r\n\r\n.autocomplete-search-result {\r\n    width: 100%;\r\n    border: 1px solid #ddd;\r\n    border-radius: 3px;\r\n\r\n    .search-result-row {\r\n        height: 55px;\r\n        cursor: pointer;\r\n        margin: 0;\r\n        transition: background-color linear .2s;\r\n        overflow: hidden;\r\n\r\n        a.mdi-chevron-right {\r\n            color: #8859C5;\r\n            &::before {\r\n                margin-top: 15px;\r\n                font-size: 22px;\r\n            }\r\n        }\r\n\r\n        &:hover {\r\n            background-color: #eee;\r\n\r\n            .news-list-button a {\r\n                background-color: #440099;\r\n            }\r\n        }\r\n\r\n        .search-result-small-image {\r\n            background-size: cover;\r\n            background-position: center center;\r\n            background-repeat: no-repeat;\r\n            width: 100%;\r\n            height: 37px;\r\n            margin: 9px 0;\r\n        }\r\n\r\n        .search-result-headline {\r\n            font-weight: 400;\r\n            font-size: 12px;\r\n            line-height: 18px;\r\n            display: flex;\r\n            align-items: center;\r\n            color: #242829;\r\n        }\r\n    }\r\n\r\n    .news-list-button {\r\n        height: 60px;\r\n        width: 100%;\r\n        position: absolute;\r\n        bottom: 0;\r\n        left: 0;\r\n        top: 10px;\r\n        padding: 10px 35px 20px;\r\n\r\n        a {\r\n            float: right;\r\n            background-color: #000;\r\n            color: #fff;\r\n            width: 26px;\r\n            height: 26px;\r\n            border-radius: 13px;\r\n\r\n            &:hover {\r\n                background-color: #440099;\r\n            }\r\n\r\n            &::before {\r\n                position: relative;\r\n                vertical-align: top;\r\n                font-size: 15px;\r\n                top: 1px;\r\n                left: 6px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.newsroom-hero-block {\r\n    position: relative;\r\n    overflow: hidden;\r\n    background-size: cover;\r\n    background-position: center center;\r\n}\r\n\r\n.newsroomheroblock {\r\n    height: 420px;\r\n\r\n    @include media-breakpoint-up(lg) {\r\n        height: 374px;\r\n    }\r\n\r\n    .newsroom-hero-block-content {\r\n        position: relative;\r\n        margin: 0 auto;\r\n        width: 1004px;\r\n        max-width: 100%;\r\n        padding-top: 116px;\r\n\r\n        h1 {\r\n            color: #242829;\r\n            margin-bottom: 10px;\r\n            line-height: 58px;\r\n            max-width: unset;\r\n        }\r\n\r\n        .newsroom-hero-block-info {\r\n            background-color: #fff;\r\n            border-top-left-radius: 10px;\r\n            border-top-right-radius: 10px;\r\n            height: 260px;\r\n            width: 1004px;\r\n            max-width: 90%;\r\n            margin: 0 auto;\r\n            font-size: 16px;   \r\n            padding-bottom: 30px;\r\n        }\r\n\r\n        @include media-breakpoint-down(md) {\r\n            position: absolute;\r\n            width: 1004px;\r\n            padding-top: 0;\r\n            bottom: 54px;\r\n\r\n            h1 {\r\n                font-size: 32px;\r\n                line-height: 40px;\r\n                font-weight: 400;\r\n                text-align: left;\r\n            }\r\n\r\n            .newsroom-hero-block-info {\r\n                background-color: #fff;\r\n                border-top-left-radius: 10px;\r\n                border-top-right-radius: 10px;\r\n                height: auto;\r\n                width: 1004px;\r\n                max-width: 90%;\r\n                margin: 0 auto;\r\n                font-size: 16px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.footnotes-container {\r\n    @include media-breakpoint-down(sm) {\r\n        padding: 0;\r\n    }\r\n}\r\n\r\n.footnotes {\r\n    max-width: 800px;\r\n    margin: 0 auto 125px;\r\n\r\n    @include media-breakpoint-down(xs) {\r\n        margin: 0 auto 75px;\r\n    }\r\n\r\n    #footnoteHeader {\r\n        background-color: #F3EEEB;\r\n        border-radius: 5px;\r\n\r\n        .footnote-arrowLinkWrapper {\r\n            width: 22px;\r\n            height: 22px;\r\n            position: absolute;\r\n            right: 25px;\r\n        }\r\n\r\n        .footnote-link-showHide {\r\n            border: solid #242829;\r\n            border-width: 0 2px 2px 0;\r\n            display: inline-block;\r\n            position: absolute;\r\n            padding: 4px;\r\n            top: 10px;\r\n            left: 5px;\r\n            line-height: 17px;\r\n            -webkit-transition: -webkit-transform linear 0.7s;\r\n            -moz-transition: -moz-transform 0.7s;\r\n            transition: transform 0.7s;\r\n        }\r\n\r\n        .footnote-link-showHide {\r\n            transform: rotate(-135deg);\r\n            -moz-transform: rotate(-135deg);\r\n            -webkit-transform: rotate(-135deg);\r\n        }\r\n\r\n        .collapsed .footnote-link-showHide {\r\n            transform: rotate(45deg);\r\n            -moz-transform: rotate(45deg);\r\n            -webkit-transform: rotate(45deg);\r\n        }\r\n    }\r\n\r\n    #footnotes-expander {\r\n        padding: 0.625rem 0;\r\n        font-weight: 600;\r\n        font-size: 18px;\r\n        line-height: 32px;\r\n\r\n        &:focus {\r\n            box-shadow: none;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n",".preview {\r\n    margin-bottom: 20px\r\n}\r\n\r\n.preview_supported {\r\n    margin-bottom: 25px\r\n}","﻿\r\n.heroblock {\r\n    .support-hero-settings {\r\n        height: 70vw;\r\n\r\n        @media(min-width: 576px) {\r\n            height: 300px;\r\n        }\r\n\r\n        @media(min-width: 768px) {\r\n            height: 425px;\r\n        }\r\n\r\n        @media(min-width: 992px) {\r\n            height: 475px;\r\n        }\r\n\r\n        .container, .row {\r\n            height: 100%;\r\n        }\r\n    }\r\n\r\n    .support-callout {\r\n        background-color: #EDF6F6;\r\n        padding: 50px;\r\n\r\n        p {\r\n            font-size: 18px;\r\n            line-height: 32px;\r\n        }\r\n\r\n        img {\r\n            max-width: 70px;\r\n            height: auto;\r\n        }\r\n\r\n        h2 {\r\n            font-weight: 600;\r\n            font-size: 32px;\r\n            line-height: 48px;\r\n        }\r\n    }\r\n\r\n    .support-callout-mobile {\r\n        background-color: #EDF6F6;\r\n        padding: 25px;\r\n\r\n        p {\r\n            font-size: 16px;\r\n            line-height: 26px;\r\n        }\r\n\r\n        img {\r\n            max-width: 45px;\r\n            height: auto;\r\n        }\r\n\r\n        h2 {\r\n            font-weight: 600;\r\n            font-size: 24px;\r\n            line-height: 32px;\r\n        }\r\n    }\r\n}\r\n","﻿// -----------------------------------------------------------------------------\r\n// When having several themes, this file contains everything related to the\r\n// default one.\r\n// -----------------------------------------------------------------------------\r\n\r\n.home-page.no-gutters{\r\n    max-width: 2560px;\r\n    margin: 0 auto;\r\n}\r\n\r\nheader {\r\n    height: auto;\r\n}\r\n\r\n.nav-pills .nav-link {\r\n    color: $color-primary;\r\n    background-color: $color-white;\r\n}\r\n\r\n.nav-pills .nav-link.active, .nav-pills .nav-link:hover {\r\n    color: $color-white;\r\n    background-color: $color-primary;\r\n}\r\n\r\n.field-validation-error {\r\n    position: relative;\r\n    padding: 0.25rem 1rem;\r\n    margin-bottom: 1rem;\r\n    border: 1px solid transparent;\r\n    border-radius: 0.25rem;\r\n    color: $color-darkred;\r\n    background-color: $color-pink;\r\n    border-color: $color-darkpink;\r\n}\r\n\r\n.btn.mdi:before {\r\n    font-size: 1.5rem;\r\n    line-height: .1;\r\n    position: relative;\r\n    top: 4px;\r\n}\r\n\r\nimg {\r\n    max-width: 100%;\r\n}\r\n\r\n@include media-breakpoint-up(sm) {\r\n    .screen-width-block {\r\n        &.footer-bottom {\r\n            width: 100vw;\r\n            position: relative;\r\n            left: 50%;\r\n            right: 50%;\r\n            margin-left: -50vw;\r\n            margin-right: -50vw;\r\n        }\r\n\r\n        .screen-width-wrapper {\r\n            @include media-breakpoint-up(xl) {\r\n                max-width: 1440px;\r\n            }\r\n\r\n            width: 100%;\r\n            padding-right: 15px;\r\n            padding-left: 15px;\r\n            margin-right: auto;\r\n            margin-left: auto;\r\n        }\r\n\r\n        .screen-width-container {\r\n            @include media-breakpoint-up(xl) {\r\n                max-width: 1440px;\r\n            }\r\n\r\n            width: 100%;\r\n            margin-right: auto;\r\n            margin-left: auto;\r\n        }\r\n    }\r\n}\r\n\r\n.standard-block-padding {\r\n    padding: 40px 0;\r\n\r\n    @include media-breakpoint-up(md) {\r\n        padding: 55px 0;\r\n    }\r\n\r\n    @include media-breakpoint-up(lg) {\r\n        padding: 65px 0;\r\n    }\r\n\r\n    @include media-breakpoint-up(xl) {\r\n        padding: 75px 0;\r\n    }\r\n}\r\n\r\n.btn-primary, #CartPreview .btn-primary {\r\n    background-color: $color-black !important;\r\n    border-color: $color-black !important;\r\n    color: #fff !important;\r\n\r\n    &:hover {\r\n        background-color: $light-purple;\r\n        border-color: $light-purple;\r\n    }\r\n\r\n    &:active, &.active {\r\n        background-color: #440099;\r\n        border-color: #440099;\r\n        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2);\r\n    }\r\n\r\n    &.disabled, &:disabled {\r\n        background-color: #B0B4B3;\r\n        border-color: #B0B4B3;\r\n    }\r\n\r\n    &:not(:disabled):not(.disabled):active, &:not(:disabled):not(.disabled).active,\r\n    .show > .btn-primary.dropdown-toggle {\r\n        background-color: $color-black;\r\n        border-color: $color-black;\r\n    }\r\n\r\n    &:not(:disabled):not(.disabled):active:focus, &:not(:disabled):not(.disabled).active:focus,\r\n    .show > &.dropdown-toggle:focus {\r\n        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2);\r\n    }\r\n}\r\n\r\n.btn-outline-primary {\r\n    color: $color-black;\r\n    border-color: $color-black;\r\n\r\n    &:hover {\r\n        color: #fff;\r\n        background-color: $color-black;\r\n        border-color: $color-black;\r\n    }\r\n\r\n    &:active, &.active {\r\n        color: #fff;\r\n        background-color: $color-black;\r\n        border-color: $color-black;\r\n    }\r\n\r\n    &.disabled, &:disabled {\r\n        color: #fff;\r\n        background-color: #B0B4B3;\r\n        border-color: #B0B4B3;\r\n    }\r\n\r\n    &:not(:disabled):not(.disabled):active, &:not(:disabled):not(.disabled).active,\r\n    .show > &.dropdown-toggle {\r\n        background-color: $color-black;\r\n        border-color: $color-black;\r\n    }\r\n\r\n    &:not(:disabled):not(.disabled):active:focus, &:not(:disabled):not(.disabled).active:focus,\r\n    .show > &.dropdown-toggle:focus {\r\n        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5);\r\n    }\r\n}\r\n\r\n.block, .news-detail {\r\n    p, h1, h2, h3, h4, h5, h6, .imagetextblock .buttonblock, .shortinfoitemblock .buttonblock, ol, ul {\r\n        max-width: 800px;\r\n        margin-right: auto;\r\n        margin-left: auto;\r\n        padding: 0;\r\n\r\n        li {\r\n            margin-left: 34px;\r\n        }\r\n    }\r\n}\r\na.zzPreHeaderCart i.mdi-cart::before {\r\n    color: #242829;\r\n}\r\n.hero-block__callout-content, .allow-full-width, .faqcontainerblock {\r\n    p, h1, h2, h3, h4, h5, h6, .imagetextblock .buttonblock, .shortinfoitemblock .buttonblock {\r\n        max-width: initial;\r\n        margin-right: initial;\r\n        margin-left: initial;\r\n    }\r\n}\r\n\r\n.fade-scale {\r\n    transform: scale(0.8);\r\n    opacity: 0;\r\n    -webkit-transition: all .25s linear;\r\n    -o-transition: all .25s linear;\r\n    transition: all .26s linear;\r\n}\r\n\r\n.fade-scale.show {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n}\r\n\r\na:hover {\r\n    text-decoration: none;\r\n}\r\n\r\n.block, .zzPreHeader {\r\n    a[target=_blank] {\r\n        &:not(.mdi-book-open-outline):not(.social-share-link):not(.footer-bottom a):not(a.animated-link) {\r\n            color: $color-black;\r\n            letter-spacing: 0.08em;\r\n\r\n            &::before {\r\n                position: relative;\r\n                content: \"\\F03CC\";\r\n                font-family: 'Material Design Icons';\r\n                margin-right: 0.5rem;\r\n                color: $light-purple;\r\n                top: .05em;\r\n            }\r\n\r\n            &:hover::before {\r\n                color: $color-black;\r\n            }\r\n        }\r\n    }\r\n\r\n    a[href$=\".pdf\"]:not(.btn):not(.footer-bottom a):not(a.animated-link) {\r\n        color: $color-black;\r\n\r\n        &::before {\r\n            color: #440099;\r\n            content: \"\\F01DA\";\r\n            font-family: 'Material Design Icons';\r\n            margin-right: 0.5rem;\r\n            color: $light-purple;\r\n        }\r\n\r\n        &:hover::before {\r\n            color: $color-black;\r\n        }\r\n\r\n        &::after {\r\n            content: \"\";\r\n        }\r\n    }\r\n}\r\n\r\n\r\nh1, .h1 {\r\n    line-height: $font-size-base * 3.5;\r\n    letter-spacing: 0.02em;\r\n}\r\n\r\nh2, .h2 {\r\n    line-height: $font-size-base * 3;\r\n    letter-spacing: 0.02em;\r\n}\r\n\r\nh3, .h3 {\r\n    line-height: $font-size-base * 2.25;\r\n    letter-spacing: 0.02em;\r\n}\r\n\r\nh4, .h4 {\r\n    line-height: $font-size-base * 2.25;\r\n    letter-spacing: 0.01em;\r\n}\r\n\r\nh5, .h5 {\r\n    line-height: $font-size-base * 2;\r\n}\r\n\r\nh6, .h6 {\r\n    line-height: $font-size-base * 2;\r\n    letter-spacing: 0.02em;\r\n}\r\n\r\n.display-1 {\r\n    line-height: $font-size-base * 4;\r\n    letter-spacing: 0.02em;\r\n}\r\n\r\n.display-2 {\r\n    line-height: $font-size-base * 3;\r\n    letter-spacing: 0.02em;\r\n}\r\n\r\n.display-3 {\r\n    line-height: $font-size-base * 2.25;\r\n    letter-spacing: 0.02em;\r\n}\r\n\r\n@include media-breakpoint-down(sm) {\r\n    h1, .h1 {\r\n        line-height: $font-size-base * 2.5;\r\n    }\r\n\r\n    h2, .h2 {\r\n        line-height: $font-size-base * 2.25;\r\n    }\r\n\r\n    h3, .h3 {\r\n        line-height: $font-size-base * 2;\r\n    }\r\n\r\n    h4, .h4 {\r\n        line-height: $font-size-base * 2;\r\n    }\r\n\r\n    h5, .h5 {\r\n        line-height: $font-size-base * 1.75;\r\n    }\r\n\r\n    h6, .h6 {\r\n        line-height: $font-size-base * 1.375;\r\n    }\r\n\r\n    .display-1 {\r\n        line-height: 1.4;\r\n    }\r\n\r\n    .display-2 {\r\n        line-height: 1.4;\r\n    }\r\n\r\n    .display-3 {\r\n        line-height: 1.4;\r\n    }\r\n}\r\n\r\n.social-sharing {\r\n    position: fixed;\r\n    right: 20px;\r\n    top: 120px;\r\n    z-index: 10;\r\n    background-color: rgba(251,250,252,0.7);\r\n    width: 46px;\r\n    height: 46px;\r\n    border-radius: 23px;\r\n    box-shadow: 0 3px 6px rgba(0,0,0,0.25);\r\n    cursor: pointer;\r\n    transform: scale(1);\r\n    transition: right 300ms ease-out, transform 200ms linear, box-shadow 100ms linear;\r\n\r\n    &::after {\r\n        position: absolute;\r\n        content: \"\\F0497\";\r\n        font-family: 'Material Design Icons';\r\n        text-decoration: none;\r\n        color: #6200FF;\r\n        top: .42em;\r\n        left: .4em;\r\n        font-size: 24px;\r\n    }\r\n\r\n    &:hover {\r\n        transform: scale(1.1) translateY(-3px);\r\n        box-shadow: 0px 4px 25px rgba(0, 0, 0, 0.25);\r\n\r\n        &::after {\r\n            color: #000;\r\n        }\r\n    }\r\n\r\n    &.active {\r\n        top: 120px;\r\n        right: 170px;\r\n        height: 46px;\r\n        background-color: rgba(251,250,252,1);\r\n\r\n        &::after {\r\n            content: \"\\F1398\";\r\n            left: .62em;\r\n            top: .5em;\r\n            font-size: 21px;\r\n            color: #6200FF;\r\n        }\r\n    }\r\n\r\n    svg {\r\n        max-width: 45%;\r\n        height: auto;\r\n        margin: 24%;\r\n    }\r\n}\r\n\r\n@include media-breakpoint-down(md) {\r\n    .social-sharing {\r\n        position: fixed;\r\n        right: 150px;\r\n        top: 1px;\r\n        z-index: 10;\r\n        background-color: transparent;\r\n        width: 46px;\r\n        height: 17px;\r\n        box-shadow: none;\r\n        cursor: pointer;\r\n        transform: scale(1);\r\n        transition: right 300ms ease-out, transform 200ms linear, box-shadow 100ms linear;\r\n\r\n        &::after {\r\n            position: absolute;\r\n            content: \"\\F0497\";\r\n            font-family: 'Material Design Icons';\r\n            text-decoration: none;\r\n            color: #ffffff;\r\n            top: 2px;\r\n            left: .4em;\r\n            font-size: 16px;\r\n        }\r\n\r\n        &:hover {\r\n            transform: scale(1) translateY(0);\r\n            box-shadow: none;\r\n\r\n            &::after {\r\n                color: #fff;\r\n            }\r\n        }\r\n\r\n        &.active:hover {\r\n\r\n            &::after {\r\n                color: #000;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.social-media-share-panel {\r\n    background-color: inherit;\r\n    padding: 10px 0;\r\n\r\n    #social-share-button {\r\n        padding: 0;\r\n        width: 80px;\r\n        height: 80px;\r\n        border-radius: 50%;\r\n        background-color: #8859C5;\r\n        color: #fff;\r\n        text-align: center;\r\n        font-size: 14px;\r\n        letter-spacing: 0.04em;\r\n        line-height: 22px;\r\n        text-transform: uppercase;\r\n        font-weight: normal;\r\n        margin: 20px auto 0;\r\n        display: block;\r\n        position: relative;\r\n        margin-bottom: -30px;\r\n        z-index: 1;\r\n\r\n        &.overflow-text {\r\n            font-size: 11px;\r\n            letter-spacing: 0;\r\n            line-height: 18px;\r\n        }\r\n\r\n        &:hover {\r\n            border-color: #545b62;\r\n            box-shadow: 0 0 0 0.2rem rgba(136, 89, 1197, 0.5);\r\n        }\r\n\r\n        span {\r\n            font-size: 18px;\r\n        }\r\n    }\r\n}\r\n\r\n#social-share-modal, .social-share-video-modal {\r\n    .modal-dialog {\r\n        max-width: 475px;\r\n    }\r\n\r\n    .modal-content {\r\n        background-color: #fbfafc;\r\n\r\n        h4 {\r\n            font-weight: normal;\r\n            font-size: 25px;\r\n            line-height: 34px;\r\n        }\r\n\r\n        h6 {\r\n            font-weight: 600;\r\n            font-size: 14px;\r\n            line-height: 150%;\r\n            color: #242E4C;\r\n        }\r\n    }\r\n\r\n    .modal-body {\r\n        padding: 30px;\r\n\r\n        .url-textarea textarea, #url-textarea textarea {\r\n            height: 48px;\r\n            width: 100%;\r\n            border: 1px solid #EBEBF2;\r\n            background-color: #fff;\r\n            font-size: 14px;\r\n            line-height: 18px;\r\n            color: #242E4C;\r\n            overflow: hidden;\r\n            resize: none;\r\n        }\r\n    }\r\n\r\n    .social-icon-wrapper {\r\n        margin-top: 11px;\r\n        float: left;\r\n        width: 50px;\r\n        height: 50px;\r\n        margin-right: 11px;\r\n        border-radius: 50%;\r\n        background-color: #fff;\r\n        border: 1px solid #EBEBF2;\r\n        padding: 12px;\r\n        cursor: pointer;\r\n        transition: all 150ms ease-out;\r\n        transform: scale(1);\r\n\r\n        &:hover {\r\n            transform: scale(1.3);\r\n        }\r\n    }\r\n\r\n    .mdi:not(.mdi-check) {\r\n        font-size: 24px;\r\n    }\r\n\r\n    #copy-share-link {\r\n        text-transform: uppercase;\r\n        margin-top: 10px;\r\n        padding: 0.625rem 2.5rem;\r\n        font-size: 0.875rem;\r\n        font-weight: 600;\r\n        letter-spacing: 0.04em;\r\n    }\r\n\r\n    .social-share-link .mdi {\r\n        line-height: 26px;\r\n        color: #440099;\r\n    }\r\n}\r\n\r\n\r\n.shortinfolinkblock {\r\n\r\n    .hover-bg {\r\n        transition: all 350ms ease-out;\r\n    }\r\n\r\n    .short-info-link-text {\r\n        position: relative;\r\n        text-decoration: none;\r\n        display: inline-block;\r\n        color: #242829;\r\n        letter-spacing: 0.08em;\r\n        font-weight: 600;\r\n\r\n        &:before {\r\n            width: 0;\r\n            background: #000;\r\n            transition: width 250ms ease-in;\r\n            z-index: 2;\r\n            content: \"\";\r\n            height: 2px;\r\n            display: block;\r\n            position: absolute;\r\n            left: 0;\r\n            bottom: -3px;\r\n        }\r\n\r\n        &:after {\r\n            width: 100%;\r\n            background: $light-purple;\r\n            content: \"\";\r\n            height: 2px;\r\n            display: block;\r\n            position: absolute;\r\n            left: 0;\r\n            bottom: -3px;\r\n        }\r\n    }\r\n\r\n    &:hover {\r\n        .short-info-link-text {\r\n            &:before {\r\n                width: 100%;\r\n            }\r\n        }\r\n    }\r\n\r\n    & .hover-bg:hover {\r\n        background-color: #ededed;\r\n    }\r\n}\r\n\r\n\r\na.animated-link {\r\n    position: relative;\r\n    text-decoration: none;\r\n    display: inline-block;\r\n    color: #242829;\r\n    letter-spacing: 0.08em;\r\n    font-weight: 600;\r\n\r\n    &:before {\r\n        width: 0;\r\n        background: #000;\r\n        transition: width 250ms ease-in;\r\n        z-index: 2;\r\n        content: \"\";\r\n        height: 2px;\r\n        display: block;\r\n        position: absolute;\r\n        left: 0;\r\n        bottom: -3px;\r\n    }\r\n\r\n    &:after {\r\n        width: 100%;\r\n        background: $light-purple;\r\n        content: \"\";\r\n        height: 2px;\r\n        display: block;\r\n        position: absolute;\r\n        left: 0;\r\n        bottom: -3px;\r\n    }\r\n\r\n    &:hover {\r\n        &:before {\r\n            width: 100%;\r\n        }\r\n    }\r\n}\r\n\r\n.block {\r\n    a:not(.btn):not(.btn-close):not(.carousel-control-prev):not(.carousel-control-next):not([target=_blank]):not([href$=\".pdf\"]):not(.short-info-link-block):not(.animated-link):not(.nav-link):not(.event-nav-tab) {\r\n        text-decoration: underline;\r\n        color: inherit;\r\n        font-weight: bold;\r\n\r\n        &:hover {\r\n            color: $light-purple;\r\n        }\r\n    }\r\n\r\n    .light-color-text:hover {\r\n        a:not(.btn):not(.btn-close):not(.carousel-control-prev):not(.carousel-control-next):not([target=_blank]):not([href$=\".pdf\"]):not(.short-info-link-block):not(.animated-link):not(.nav-link):not(.event-nav-tab) {\r\n            &:hover {\r\n                opacity: 0.9;\r\n                color: inherit;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\nul {\r\n    margin-left: 0;\r\n    padding-left: 20px;\r\n}\r\n\r\ndiv.animation-test {\r\n    width: 500px;\r\n    height: 580px;\r\n    background: url(https://zinzinowebstorage.blob.core.windows.net/images/png-animation-test5.png) left top;\r\n    transition: background .26s steps(7, end);\r\n}\r\n\r\ndiv.animation-test:hover {\r\n    background-position: -3500px top;\r\n}\r\n\r\n\r\n.trustpilot-widget iframe .tp-widget-wrapper {\r\n    margin: 0;\r\n}\r\n\r\n.form-control-lg {\r\n    padding: 0.5rem 1rem;\r\n}\r\n\r\n.selectdiv {\r\n    position: relative;\r\n}\r\n\r\n.selectdiv select {\r\n    -webkit-appearance: none;\r\n    -moz-appearance: none;\r\n    appearance: none;\r\n}\r\n\r\n.selectdiv:after {\r\n    right: 25px;\r\n    content: ' ';\r\n    font-size: 10px;\r\n    border: solid #440099;\r\n    border-width: 0 1px 1px 0;\r\n    display: inline-block;\r\n    width: 8px;\r\n    height: 8px;\r\n    -webkit-transform: scale(0.9, 0.9) rotate(45deg);\r\n    -moz-transform: scale(0.9, 0.9) rotate(45deg);\r\n    -ms-transform: scale(0.9, 0.9) rotate(45deg);\r\n    transform: scale(0.9, 0.9) rotate(45deg);\r\n    top: calc(50% - 5px);\r\n    position: absolute;\r\n    pointer-events: none;\r\n}\r\n\r\n.cd-main-header {\r\n    .csr-class {\r\n        background-color: red;\r\n        color: #fff;\r\n    }\r\n}\r\n\r\nhtml, body {\r\n    overflow-x: hidden;\r\n}\r\n\r\nbody {\r\n    max-width: 100% !important;\r\n}\r\n\r\n.pt-serif {\r\n    font-family: 'PT Serif', serif;\r\n}","﻿@media print {\r\n  .cd-primary-nav {\r\n    display: none !important;\r\n  }\r\n  #onetrust-banner-sdk {\r\n    display: none !important;\r\n  }\r\n}\r\n\r\n "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
